
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire61fd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire61fd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("gQiaw", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c42f9894639d75b8$var$nodeBelongs;

var $1yiQH = parcelRequire("1yiQH");

var $iaL5f = parcelRequire("iaL5f");
/**
 * Checks whether the given node (target) belongs to the container.
 * The function is similar to nodeContains but also accounts for dropdowns with expandToViewport=true.
 *
 * @param container Container node
 * @param target Node that is checked to be a descendant of the container
 */ function $c42f9894639d75b8$var$nodeBelongs(container, target) {
    var _a;
    if (!(0, $iaL5f.isNode)(target)) return false;
    const portal = (0, $1yiQH.findUpUntil)(target, (node)=>node === container || (0, $iaL5f.isHTMLElement)(node) && !!node.dataset.awsuiReferrerId);
    if (portal && portal === container) // We found the container as a direct ancestor without a portal
    return true;
    const referrer = (0, $iaL5f.isHTMLElement)(portal) ? document.getElementById((_a = portal.dataset.awsuiReferrerId) !== null && _a !== void 0 ? _a : '') : null;
    return referrer ? (0, $1yiQH.nodeContains)(container, referrer) : (0, $1yiQH.nodeContains)(container, target);
}

});
parcelRegister("1yiQH", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nodeBelongs = module.exports.nodeContains = module.exports.findUpUntil = void 0;

var $7WQrb = parcelRequire("7WQrb");

var $fFjzA = parcelRequire("fFjzA");
Object.defineProperty(module.exports, "findUpUntil", {
    enumerable: true,
    get: function() {
        return $7WQrb.__importDefault($fFjzA).default;
    }
});

var $f2mhY = parcelRequire("f2mhY");
Object.defineProperty(module.exports, "nodeContains", {
    enumerable: true,
    get: function() {
        return $7WQrb.__importDefault($f2mhY).default;
    }
});

var $gQiaw = parcelRequire("gQiaw");
Object.defineProperty(module.exports, "nodeBelongs", {
    enumerable: true,
    get: function() {
        return $7WQrb.__importDefault($gQiaw).default;
    }
});

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
$parcel$export(module.exports, "__importStar", () => $5c96a02c592fcff1$export$c21735bcef00d192);
$parcel$export(module.exports, "__importDefault", () => $5c96a02c592fcff1$export$da59b14a69baef04);
$parcel$export(module.exports, "__classPrivateFieldGet", () => $5c96a02c592fcff1$export$d5dcaf168c640c35);
$parcel$export(module.exports, "__classPrivateFieldSet", () => $5c96a02c592fcff1$export$d40a35129aaff81f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("fFjzA", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b679de281b3ba268$var$findUpUntil;

var $iaL5f = parcelRequire("iaL5f");
/**
 * Checks if the current element or any of its parent is matched with `test` function.
 *
 * @example
 * Check if there is an ancestor with a CSS class matching regex
 * ```
 * const matchContext = (element) => element.className.match(/my-context-([\w-]+)/)
 * const contextElement = findUpUntil(currentElement, matchContext)
 * ```
 *
 * @param from Element to search from
 * @param test Returns `true` if the given element satisfies the search criteria
 * @returns First matched element or `null`
 */ function $b679de281b3ba268$var$findUpUntil(from, test) {
    let current = from;
    while(current && !test(current)){
        current = current.parentElement;
        // If a component is used within an svg (i.e. as foreignObject), then it will
        // have some ancestor nodes that are SVGElement. We want to skip those,
        // as they have very different properties to HTMLElements.
        while(current && !(0, $iaL5f.isHTMLElement)(current))current = current.parentElement;
    }
    return current;
}

});
parcelRegister("iaL5f", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNode = $d3adaf01b292f658$var$isNode;
module.exports.isHTMLElement = $d3adaf01b292f658$var$isHTMLElement;
module.exports.isSVGElement = $d3adaf01b292f658$var$isSVGElement;
// The instanceof Node/HTMLElement/SVGElement checks can fail if the target element
// belongs to a different window than the respective type.
function $d3adaf01b292f658$var$isNode(target) {
    return target instanceof Node || target !== null && typeof target === 'object' && 'nodeType' in target && typeof target.nodeType === 'number' && 'nodeName' in target && typeof target.nodeName === 'string' && 'parentNode' in target && typeof target.parentNode === 'object';
}
function $d3adaf01b292f658$var$isHTMLElement(target) {
    return target instanceof HTMLElement || $d3adaf01b292f658$var$isNode(target) && target.nodeType === Node.ELEMENT_NODE && 'style' in target && typeof target.style === 'object' && typeof target.ownerDocument === 'object' && !$d3adaf01b292f658$var$isSVGElement(target);
}
function $d3adaf01b292f658$var$isSVGElement(target) {
    return target instanceof SVGElement || $d3adaf01b292f658$var$isNode(target) && target.nodeType === Node.ELEMENT_NODE && 'ownerSVGElement' in target && typeof target.ownerSVGElement === 'object';
}

});


parcelRegister("f2mhY", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af285507a4cbfe46$var$nodeContains;

var $iaL5f = parcelRequire("iaL5f");
/**
 * Checks whether the given node is a parent of the other descendant node.
 * @param parent Parent node
 * @param descendant Node that is checked to be a descendant of the parent node
 */ function $af285507a4cbfe46$var$nodeContains(parent, descendant) {
    if (!parent || !descendant || !(0, $iaL5f.isNode)(descendant)) return false;
    return parent.contains(descendant);
}

});



parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6b3372b60d35b33f$export$998bcd577473dd93, (v) => $6b3372b60d35b33f$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6b3372b60d35b33f$export$3d6c20d97e46b957, (v) => $6b3372b60d35b33f$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$998bcd577473dd93;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$3d6c20d97e46b957;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = Symbol.for("react.element"), $6b3372b60d35b33f$var$c = Symbol.for("react.portal"), $6b3372b60d35b33f$var$d = Symbol.for("react.fragment"), $6b3372b60d35b33f$var$e = Symbol.for("react.strict_mode"), $6b3372b60d35b33f$var$f = Symbol.for("react.profiler"), $6b3372b60d35b33f$var$g = Symbol.for("react.provider"), $6b3372b60d35b33f$var$h = Symbol.for("react.context"), $6b3372b60d35b33f$var$k = Symbol.for("react.server_context"), $6b3372b60d35b33f$var$l = Symbol.for("react.forward_ref"), $6b3372b60d35b33f$var$m = Symbol.for("react.suspense"), $6b3372b60d35b33f$var$n = Symbol.for("react.suspense_list"), $6b3372b60d35b33f$var$p = Symbol.for("react.memo"), $6b3372b60d35b33f$var$q = Symbol.for("react.lazy"), $6b3372b60d35b33f$var$t = Symbol.for("react.offscreen"), $6b3372b60d35b33f$var$u;
$6b3372b60d35b33f$var$u = Symbol.for("react.module.reference");
function $6b3372b60d35b33f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$l:
                            case $6b3372b60d35b33f$var$q:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return r;
        }
    }
}
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$b;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$q;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$998bcd577473dd93 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$q;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$m;
};
$6b3372b60d35b33f$export$3d6c20d97e46b957 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$n || a === $6b3372b60d35b33f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$q || a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$l || a.$$typeof === $6b3372b60d35b33f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$v;

});

parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
var $013a2451794a45c0$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($013a2451794a45c0$exports, "__esModule", {
    value: true
});
$013a2451794a45c0$exports.SelectionTree = $013a2451794a45c0$exports.getTrackableValue = $013a2451794a45c0$exports.validateProps = $013a2451794a45c0$exports.useUniqueId = $013a2451794a45c0$exports.useRandomId = $013a2451794a45c0$exports.useMergeRefs = $013a2451794a45c0$exports.Portal = $013a2451794a45c0$exports.circleIndex = $013a2451794a45c0$exports.handleKey = $013a2451794a45c0$exports.getLastFocusable = $013a2451794a45c0$exports.getFirstFocusable = $013a2451794a45c0$exports.getAllFocusables = $013a2451794a45c0$exports.isFocusable = $013a2451794a45c0$exports.useSingleTabStopNavigation = $013a2451794a45c0$exports.SingleTabStopNavigationReset = $013a2451794a45c0$exports.SingleTabStopNavigationProvider = $013a2451794a45c0$exports.getGlobalFlag = $013a2451794a45c0$exports.isModifierKey = $013a2451794a45c0$exports.KeyCode = $013a2451794a45c0$exports.useFocusVisible = $013a2451794a45c0$exports.getLogicalPageX = $013a2451794a45c0$exports.getLogicalBoundingClientRect = $013a2451794a45c0$exports.getLogicalClientX = $013a2451794a45c0$exports.getScrollInlineStart = $013a2451794a45c0$exports.getOffsetInlineStart = $013a2451794a45c0$exports.getIsRtl = $013a2451794a45c0$exports.clearMessageCache = $013a2451794a45c0$exports.warnOnce = $013a2451794a45c0$exports.isDevelopment = $013a2451794a45c0$exports.useRuntimeVisualRefresh = $013a2451794a45c0$exports.useReducedMotion = $013a2451794a45c0$exports.useDensityMode = $013a2451794a45c0$exports.useCurrentMode = $013a2451794a45c0$exports.isMotionDisabled = $013a2451794a45c0$exports.useStableCallback = $013a2451794a45c0$exports.createSingletonState = $013a2451794a45c0$exports.createSingletonHandler = $013a2451794a45c0$exports.Metrics = $013a2451794a45c0$exports.useResizeObserver = $013a2451794a45c0$exports.initAwsUiVersions = $013a2451794a45c0$exports.useComponentMetrics = $013a2451794a45c0$exports.COMPONENT_METADATA_KEY = $013a2451794a45c0$exports.useComponentMetadata = void 0;

var $7WQrb = parcelRequire("7WQrb");
var $ccdf93292345e76e$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($ccdf93292345e76e$exports, "__esModule", {
    value: true
});
$ccdf93292345e76e$exports.COMPONENT_METADATA_KEY = void 0;
$ccdf93292345e76e$exports.useComponentMetadata = $ccdf93292345e76e$var$useComponentMetadata;

var $acw62 = parcelRequire("acw62");
$ccdf93292345e76e$exports.COMPONENT_METADATA_KEY = '__awsuiMetadata__';
function $ccdf93292345e76e$var$useComponentMetadata(componentName, packageMetadata, analyticsMetadata) {
    const elementRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (elementRef.current) {
            const pkgMetadata = typeof packageMetadata === 'string' ? {
                version: packageMetadata
            } : packageMetadata;
            const node = elementRef.current;
            const metadata = {
                ...pkgMetadata,
                name: componentName
            };
            // Only add analytics property to metadata if analytics property is non-empty
            if (analyticsMetadata && Object.keys(analyticsMetadata).length > 0) metadata.analytics = analyticsMetadata;
            Object.freeze(metadata);
            Object.defineProperty(node, $ccdf93292345e76e$exports.COMPONENT_METADATA_KEY, {
                value: metadata,
                writable: false,
                configurable: true
            });
        }
    });
    return elementRef;
}


Object.defineProperty($013a2451794a45c0$exports, "useComponentMetadata", {
    enumerable: true,
    get: function() {
        return $ccdf93292345e76e$exports.useComponentMetadata;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "COMPONENT_METADATA_KEY", {
    enumerable: true,
    get: function() {
        return $ccdf93292345e76e$exports.COMPONENT_METADATA_KEY;
    }
});
var $927d1efec68c45ed$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($927d1efec68c45ed$exports, "__esModule", {
    value: true
});
$927d1efec68c45ed$exports.useComponentMetrics = $927d1efec68c45ed$var$useComponentMetrics;

var $acw62 = parcelRequire("acw62");
var $27492222c394d7f3$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($27492222c394d7f3$exports, "__esModule", {
    value: true
});
$27492222c394d7f3$exports.Metrics = void 0;
$27492222c394d7f3$exports.clearOneTimeMetricsCache = $27492222c394d7f3$var$clearOneTimeMetricsCache;
var $1ffeda400a26e1c2$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($1ffeda400a26e1c2$exports, "__esModule", {
    value: true
});
$1ffeda400a26e1c2$exports.PanoramaClient = $1ffeda400a26e1c2$exports.CLogClient = void 0;
const $1ffeda400a26e1c2$var$AWSUI_EVENT = 'awsui';
function $1ffeda400a26e1c2$var$validateLength(value, maxLength) {
    return !value || value.length <= maxLength;
}
/**
 * Console Platform's client logging JS API client.
 */ class $1ffeda400a26e1c2$var$CLogClient {
    /**
     * Sends metric but only if Console Platform client logging JS API is present in the page.
     */ sendMetric(metricName, value, detail) {
        if (!metricName || !/^[a-zA-Z0-9_-]+$/.test(metricName)) {
            console.error(`Invalid metric name: ${metricName}`);
            return;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(metricName, 1000)) {
            console.error(`Metric name ${metricName} is too long`);
            return;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(detail, 4000)) {
            console.error(`Detail for metric ${metricName} is too long: ${detail}`);
            return;
        }
        const wasSent = new $1ffeda400a26e1c2$var$PanoramaClient().sendMetric({
            eventContext: metricName,
            eventDetail: detail,
            eventValue: `${value}`,
            timestamp: Date.now()
        });
        if (wasSent) return;
        const AWSC = this.findAWSC(window);
        if (typeof AWSC === 'object' && typeof AWSC.Clog === 'object' && typeof AWSC.Clog.log === 'function') AWSC.Clog.log(metricName, value, detail);
    }
    findAWSC(currentWindow) {
        try {
            if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC) === 'object') return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC;
            if (!currentWindow || currentWindow.parent === currentWindow) // When the window has no more parents, it references itself
            return undefined;
            return this.findAWSC(currentWindow.parent);
        } catch  {
            // Most likely a cross-origin access error
            return undefined;
        }
    }
}
$1ffeda400a26e1c2$exports.CLogClient = $1ffeda400a26e1c2$var$CLogClient;
/**
 * Console Platform's client v2 logging JS API client.
 */ class $1ffeda400a26e1c2$var$PanoramaClient {
    /**
     * Sends metric but only if Console Platform client v2 logging JS API is present in the page.
     */ sendMetric(metric) {
        const panorama = this.findPanorama(window);
        if (!panorama) return false;
        const payload = {
            eventType: $1ffeda400a26e1c2$var$AWSUI_EVENT,
            timestamp: Date.now(),
            ...metric,
            eventDetail: typeof metric.eventDetail === 'object' ? JSON.stringify(metric.eventDetail) : metric.eventDetail,
            eventValue: typeof metric.eventValue === 'object' ? JSON.stringify(metric.eventValue) : metric.eventValue
        };
        if (!$1ffeda400a26e1c2$var$validateLength(payload.eventDetail, 4000)) {
            this.onMetricError(`Event detail for metric is too long: ${payload.eventDetail}`);
            return true;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(payload.eventValue, 4000)) {
            this.onMetricError(`Event value for metric is too long: ${payload.eventValue}`);
            return true;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(payload.eventContext, 4000)) {
            this.onMetricError(`Event context for metric is too long: ${payload.eventContext}`);
            return true;
        }
        panorama('trackCustomEvent', payload);
        return true;
    }
    onMetricError(message) {
        console.error(message);
        const panorama = this.findPanorama(window);
        if (panorama) panorama('trackCustomEvent', {
            eventType: $1ffeda400a26e1c2$var$AWSUI_EVENT,
            eventContext: 'awsui-metric-error',
            eventDetail: message.slice(0, 4000),
            timestamp: Date.now()
        });
    }
    findPanorama(currentWindow) {
        try {
            if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama) === 'function') return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama;
            const panoramaSymbol = Symbol.for('panorama');
            const symbolProperty = currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow[panoramaSymbol];
            if (typeof symbolProperty === 'function') return symbolProperty;
            if (!currentWindow || currentWindow.parent === currentWindow) // When the window has no more parents, it references itself
            return undefined;
            return this.findPanorama(currentWindow.parent);
        } catch  {
            // Most likely a cross-origin access error
            return undefined;
        }
    }
}
$1ffeda400a26e1c2$exports.PanoramaClient = $1ffeda400a26e1c2$var$PanoramaClient;


var $f34830c0df2b3501$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($f34830c0df2b3501$exports, "__esModule", {
    value: true
});
$f34830c0df2b3501$exports.buildMetricDetail = $f34830c0df2b3501$var$buildMetricDetail;
$f34830c0df2b3501$exports.buildComponentMetricDetail = $f34830c0df2b3501$var$buildComponentMetricDetail;
$f34830c0df2b3501$exports.getMajorVersion = $f34830c0df2b3501$var$getMajorVersion;
function $f34830c0df2b3501$var$buildMetricDetail(detail, context) {
    const metricOrigin = typeof AWSUI_METRIC_ORIGIN !== 'undefined' ? AWSUI_METRIC_ORIGIN : 'main';
    const detailObject = {
        o: metricOrigin,
        t: context.theme,
        // React is the only framework we're using.
        f: 'react',
        // Remove spaces from the version string for compactness
        v: context.packageVersion.replace(/\s/g, ''),
        ...detail
    };
    return $f34830c0df2b3501$var$jsonStringify(detailObject);
}
function $f34830c0df2b3501$var$buildComponentMetricDetail({ componentName: componentName, action: action, configuration: configuration, packageSource: packageSource }, context) {
    return $f34830c0df2b3501$var$buildMetricDetail({
        a: action,
        s: componentName,
        p: packageSource,
        c: configuration
    }, context);
}
function $f34830c0df2b3501$var$jsonStringify(detailObject) {
    return JSON.stringify(detailObject, $f34830c0df2b3501$var$detailSerializer);
}
function $f34830c0df2b3501$var$detailSerializer(key, value) {
    // Report NaN and Infinity as strings instead of `null` (default behavior)
    if (typeof value === 'number' && !Number.isFinite(value)) return `${value}`;
    return value;
}
function $f34830c0df2b3501$var$getMajorVersion(versionString) {
    const majorVersionMatch = versionString.match(/^(\d+\.\d+)/);
    return majorVersionMatch ? majorVersionMatch[1].replace('.', '') : '';
}


const $27492222c394d7f3$var$oneTimeMetrics = new Set();
class $27492222c394d7f3$var$Metrics {
    constructor(...args){
        this.clog = new $1ffeda400a26e1c2$exports.CLogClient();
        this.panorama = new $1ffeda400a26e1c2$exports.PanoramaClient();
        if (args.length === 1) this.context = args[0];
        else {
            const [packageSource, packageVersion] = args;
            this.context = {
                packageSource: packageSource,
                packageVersion: packageVersion,
                theme: 'unknown'
            };
        }
    }
    sendComponentMetric(metric) {
        this.sendMetricOnce(`awsui_${metric.componentName}_${this.context.theme.charAt(0)}${(0, $f34830c0df2b3501$exports.getMajorVersion)(this.context.packageVersion)}`, 1, (0, $f34830c0df2b3501$exports.buildComponentMetricDetail)(metric, this.context));
    }
    /*
     * Calls Console Platform's client logging only the first time the provided metricName is used.
     * Subsequent calls with the same metricName are ignored.
     */ sendMetricOnce(metricName, value, detail) {
        const key = [
            metricName + value + detail
        ].join('|');
        if (!$27492222c394d7f3$var$oneTimeMetrics.has(key)) {
            this.clog.sendMetric(metricName, value, detail);
            $27492222c394d7f3$var$oneTimeMetrics.add(key);
        }
    }
    /**
     * Calls Console Platform's client v2 logging JS API with provided metric name and detail.
     * Does nothing if Console Platform client logging JS is not present in page.
     */ sendPanoramaMetric(metric) {
        this.panorama.sendMetric(metric);
    }
    sendOpsMetricObject(metricName, detail) {
        this.sendMetricOnce(metricName, 1, (0, $f34830c0df2b3501$exports.buildMetricDetail)(detail, this.context));
    }
    sendOpsMetricValue(metricName, value) {
        this.sendMetricOnce(metricName, value);
    }
    /*
     * Reports a metric value 1 to Console Platform's client logging service to indicate that the
     * component was loaded. The component load event will only be reported as used to client logging
     * service once per page view.
     */ logComponentsLoaded() {
        this.sendComponentMetric({
            componentName: this.context.packageSource,
            action: 'loaded'
        });
    }
    /*
     * Reports a metric value 1 to Console Platform's client logging service to indicate that the
     * component was used in the page.  A component will only be reported as used to client logging
     * service once per page view.
     */ logComponentUsed(componentName, configuration) {
        this.sendComponentMetric({
            action: 'used',
            componentName: componentName,
            configuration: configuration,
            packageSource: this.context.packageSource
        });
    }
}
$27492222c394d7f3$exports.Metrics = $27492222c394d7f3$var$Metrics;
function $27492222c394d7f3$var$clearOneTimeMetricsCache() {
    $27492222c394d7f3$var$oneTimeMetrics.clear();
}


function $927d1efec68c45ed$var$useComponentMetrics(componentName, settings, configuration = {
    props: {}
}) {
    (0, $acw62.useEffect)(()=>{
        const metrics = new $27492222c394d7f3$exports.Metrics(settings);
        if (typeof window !== 'undefined') {
            metrics.sendOpsMetricValue('awsui-viewport-width', window.innerWidth || 0);
            metrics.sendOpsMetricValue('awsui-viewport-height', window.innerHeight || 0);
        }
        metrics.logComponentsLoaded();
        metrics.logComponentUsed(componentName.toLowerCase(), configuration);
    // Components do not change the name dynamically. Explicit empty array to prevent accidental double metrics
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}


Object.defineProperty($013a2451794a45c0$exports, "useComponentMetrics", {
    enumerable: true,
    get: function() {
        return $927d1efec68c45ed$exports.useComponentMetrics;
    }
});
var $c9df79a03158a684$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($c9df79a03158a684$exports, "__esModule", {
    value: true
});
$c9df79a03158a684$exports.initAwsUiVersions = $c9df79a03158a684$var$initAwsUiVersions;
// expose version info, so it can be checked using the browser devtools
function $c9df79a03158a684$var$initAwsUiVersions(source, packageVersion) {
    if (typeof window !== 'undefined') {
        if (!window.awsuiVersions) window.awsuiVersions = {};
        if (!window.awsuiVersions[source]) window.awsuiVersions[source] = [];
        window.awsuiVersions[source].push(packageVersion);
    }
}


Object.defineProperty($013a2451794a45c0$exports, "initAwsUiVersions", {
    enumerable: true,
    get: function() {
        return $c9df79a03158a684$exports.initAwsUiVersions;
    }
});
var $444535e54951fdea$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($444535e54951fdea$exports, "__esModule", {
    value: true
});
$444535e54951fdea$exports.useResizeObserver = $444535e54951fdea$var$useResizeObserver;


var $acw62 = parcelRequire("acw62");
var $3bf45ec0c2b54dd9$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($3bf45ec0c2b54dd9$exports, "__esModule", {
    value: true
});
$3bf45ec0c2b54dd9$exports.useStableCallback = $3bf45ec0c2b54dd9$var$useStableCallback;

var $acw62 = parcelRequire("acw62");
/**
 * A callback that stays stable between renders even as the dependencies change.
 * Not a recommended React pattern, so it should be used sparingly and only if
 * the callback is used asynchronously (i.e. not used during rendering) and causing
 * clear performance issues.
 *
 * @remarks
 *
 * The implementation ensures the callback cannot be called synchronously. All synchronous calls
 * (during rendering) are ignored.
 *
 * @example
 * Use stable onMouseMove handler
 * ```
 * function Demo({ args }) {
 *   const stableOnMouseMove = useStableCallback((event) => makeAction(event, args))
 *   return <Container onMouseMove={stableOnMouseMove} />
 * }
 * ```
 *
 * @see https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
 *
 * @typeParam Callback The callback to be made stable
 * @returns Stable callback
 */ function $3bf45ec0c2b54dd9$var$useStableCallback(fn) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = fn;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
    }, []);
}


/**
 * Attaches resize-observer to the referenced element.
 *
 * @remarks
 *
 * The hook has no control over the referenced element. It is up to the consumer to ensure
 * the element lifecycle and notify the hook by updating the `elementRef`.
 *
 * @example
 * With React reference
 * ```
 * const ref = useRef(null)
 * useResizeObserver(ref, (entry) => setState(getWidth(entry)))
 * ```
 *
 * @example
 * With ID reference
 * ```
 * const getElement = useCallback(() => document.getElementById(id), [id])
 * useResizeObserver(getElement, (entry) => setState(getWidth(entry)))
 * ```
 *
 * @param elementRef React reference or memoized getter for the target element
 * @param onObserve Function to fire when observation occurs
 */ function $444535e54951fdea$var$useResizeObserver(elementRef, onObserve) {
    const stableOnObserve = (0, $3bf45ec0c2b54dd9$exports.useStableCallback)(onObserve);
    // This effect provides a synchronous update required to prevent flakiness when initial state and first observed state are different.
    // Can potentially conflict with React concurrent mode: https://17.reactjs.org/docs/concurrent-mode-intro.html.
    // TODO: A possible solution would be to make consumers not render any content until the first (asynchronous) observation is available.
    (0, $acw62.useLayoutEffect)(()=>{
        const element = typeof elementRef === 'function' ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element) {
            const rect = element.getBoundingClientRect();
            onObserve($444535e54951fdea$var$convertElementToEntry(element, rect));
        }
    }, // This effect is only needed for the first render to provide a synchronous update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $acw62.useEffect)(()=>{
        const element = typeof elementRef === 'function' ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element && typeof ResizeObserver !== 'undefined') {
            let connected = true;
            const observer = new ResizeObserver((entries)=>{
                // Prevent observe notifications on already unmounted component.
                if (connected) (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    stableOnObserve($444535e54951fdea$var$convertResizeObserverEntry(entries[0]));
                });
            });
            observer.observe(element, {
                box: 'border-box'
            });
            return ()=>{
                connected = false;
                observer.disconnect();
            };
        }
    }, [
        elementRef,
        stableOnObserve
    ]);
}
function $444535e54951fdea$var$convertResizeObserverEntry(entry) {
    return {
        target: entry.target,
        contentBoxWidth: entry.contentBoxSize[0].inlineSize,
        contentBoxHeight: entry.contentBoxSize[0].blockSize,
        borderBoxWidth: entry.borderBoxSize[0].inlineSize,
        borderBoxHeight: entry.borderBoxSize[0].blockSize
    };
}
function $444535e54951fdea$var$convertElementToEntry(element, rect) {
    const computedStyle = window.getComputedStyle(element);
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
    const borderLeft = parseFloat(computedStyle.borderLeftWidth) || 0;
    const borderRight = parseFloat(computedStyle.borderRightWidth) || 0;
    const borderTop = parseFloat(computedStyle.borderTopWidth) || 0;
    const borderBottom = parseFloat(computedStyle.borderBottomWidth) || 0;
    return {
        target: element,
        contentBoxWidth: rect.width - paddingLeft - paddingRight - borderLeft - borderRight,
        contentBoxHeight: rect.height - paddingTop - paddingBottom - borderTop - borderBottom,
        borderBoxWidth: rect.width,
        borderBoxHeight: rect.height
    };
}


Object.defineProperty($013a2451794a45c0$exports, "useResizeObserver", {
    enumerable: true,
    get: function() {
        return $444535e54951fdea$exports.useResizeObserver;
    }
});
var $3b8abc3d09b9a048$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($3b8abc3d09b9a048$exports, "__esModule", {
    value: true
});
$3b8abc3d09b9a048$exports.Metrics = void 0;

Object.defineProperty($3b8abc3d09b9a048$exports, "Metrics", {
    enumerable: true,
    get: function() {
        return $27492222c394d7f3$exports.Metrics;
    }
});


Object.defineProperty($013a2451794a45c0$exports, "Metrics", {
    enumerable: true,
    get: function() {
        return $3b8abc3d09b9a048$exports.Metrics;
    }
});
var $0eab7c44803f46fb$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($0eab7c44803f46fb$exports, "__esModule", {
    value: true
});
$0eab7c44803f46fb$exports.createSingletonHandler = $0eab7c44803f46fb$var$createSingletonHandler;
$0eab7c44803f46fb$exports.createSingletonState = $0eab7c44803f46fb$var$createSingletonState;

var $acw62 = parcelRequire("acw62");

function $0eab7c44803f46fb$var$createSingletonHandler(factory) {
    // Using Set for O(1) add/delete operations instead of Array's O(n) indexOf + splice.
    // Sets maintain insertion order (ES2015+), preserving iteration consistency.
    const listeners = new Set();
    const callback = (value)=>{
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            for (const listener of listeners)listener(value);
        });
    };
    let cleanup;
    return function useSingleton(listener) {
        (0, $acw62.useEffect)(()=>{
            if (listeners.size === 0) cleanup = factory(callback);
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
                if (listeners.size === 0) {
                    cleanup();
                    cleanup = undefined;
                }
            };
        // register handlers only on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    };
}
function $0eab7c44803f46fb$var$createSingletonState({ factory: factory, initialState: initialState }) {
    const useSingleton = $0eab7c44803f46fb$var$createSingletonHandler(factory);
    return function useSingletonState() {
        const [state, setState] = (0, $acw62.useState)(initialState);
        useSingleton(setState);
        return state;
    };
}


Object.defineProperty($013a2451794a45c0$exports, "createSingletonHandler", {
    enumerable: true,
    get: function() {
        return $0eab7c44803f46fb$exports.createSingletonHandler;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "createSingletonState", {
    enumerable: true,
    get: function() {
        return $0eab7c44803f46fb$exports.createSingletonState;
    }
});

Object.defineProperty($013a2451794a45c0$exports, "useStableCallback", {
    enumerable: true,
    get: function() {
        return $3bf45ec0c2b54dd9$exports.useStableCallback;
    }
});
var $020c722843a7a503$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($020c722843a7a503$exports, "__esModule", {
    value: true
});
$020c722843a7a503$exports.isMotionDisabled = $020c722843a7a503$var$isMotionDisabled;
$020c722843a7a503$exports.useCurrentMode = $020c722843a7a503$var$useCurrentMode;
$020c722843a7a503$exports.useDensityMode = $020c722843a7a503$var$useDensityMode;
$020c722843a7a503$exports.useReducedMotion = $020c722843a7a503$var$useReducedMotion;
$020c722843a7a503$exports.clearVisualRefreshState = $020c722843a7a503$var$clearVisualRefreshState;
$020c722843a7a503$exports.useRuntimeVisualRefresh = $020c722843a7a503$var$useRuntimeVisualRefresh;

var $acw62 = parcelRequire("acw62");

var $1yiQH = parcelRequire("1yiQH");


var $ea769919060d7f5c$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($ea769919060d7f5c$exports, "__esModule", {
    value: true
});
$ea769919060d7f5c$exports.isDevelopment = void 0;
/**
 * Whether the bundle is a development bundle.
 * Only use this in an if condition and on its own! This will help bundlers find
 * and remove the conditional statement for production bundles.
 */ $ea769919060d7f5c$exports.isDevelopment = false;


var $dd646455762bc7b9$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($dd646455762bc7b9$exports, "__esModule", {
    value: true
});
$dd646455762bc7b9$exports.warnOnce = $dd646455762bc7b9$var$warnOnce;
$dd646455762bc7b9$exports.clearMessageCache = $dd646455762bc7b9$var$clearMessageCache;

const $dd646455762bc7b9$var$messageCache = new Set();
function $dd646455762bc7b9$var$warnOnce(component, message) {
    if ($ea769919060d7f5c$exports.isDevelopment) {
        const warning = `[AwsUi] [${component}] ${message}`;
        if (!$dd646455762bc7b9$var$messageCache.has(warning)) {
            $dd646455762bc7b9$var$messageCache.add(warning);
            console.warn(warning);
        }
    }
}
function $dd646455762bc7b9$var$clearMessageCache() {
    $dd646455762bc7b9$var$messageCache.clear();
}


var $127791eee0e6430c$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($127791eee0e6430c$exports, "__esModule", {
    value: true
});
$127791eee0e6430c$exports.setGlobalFlag = $127791eee0e6430c$exports.getGlobalFlag = $127791eee0e6430c$exports.getTopWindow = $127791eee0e6430c$exports.awsuiGlobalFlagsSymbol = $127791eee0e6430c$exports.awsuiVisualRefreshFlag = void 0;
$127791eee0e6430c$exports.getGlobal = $127791eee0e6430c$var$getGlobal;
$127791eee0e6430c$exports.awsuiVisualRefreshFlag = Symbol.for('awsui-visual-refresh-flag');
$127791eee0e6430c$exports.awsuiGlobalFlagsSymbol = Symbol.for('awsui-global-flags');
const $127791eee0e6430c$var$getTopWindow = ()=>{
    return window.top;
};
$127791eee0e6430c$exports.getTopWindow = $127791eee0e6430c$var$getTopWindow;
function $127791eee0e6430c$var$getGlobal() {
    return typeof window !== 'undefined' ? window : globalThis;
}
function $127791eee0e6430c$var$readFlag(holder, flagName) {
    var _a;
    return (_a = holder === null || holder === void 0 ? void 0 : holder[$127791eee0e6430c$exports.awsuiGlobalFlagsSymbol]) === null || _a === void 0 ? void 0 : _a[flagName];
}
const $127791eee0e6430c$var$getGlobalFlag = (flagName)=>{
    try {
        const ownFlag = $127791eee0e6430c$var$readFlag($127791eee0e6430c$var$getGlobal(), flagName);
        if (ownFlag !== undefined) return ownFlag;
        return $127791eee0e6430c$var$readFlag((0, $127791eee0e6430c$exports.getTopWindow)(), flagName);
    } catch  {
        return undefined;
    }
};
$127791eee0e6430c$exports.getGlobalFlag = $127791eee0e6430c$var$getGlobalFlag;
const $127791eee0e6430c$var$setGlobalFlag = (flagName, value)=>{
    const holder = $127791eee0e6430c$var$getGlobal();
    if (value === undefined) {
        const currentValue = $127791eee0e6430c$var$readFlag(holder, flagName);
        if (currentValue !== undefined) delete holder[$127791eee0e6430c$exports.awsuiGlobalFlagsSymbol][flagName];
    } else {
        holder[$127791eee0e6430c$exports.awsuiGlobalFlagsSymbol] = holder[$127791eee0e6430c$exports.awsuiGlobalFlagsSymbol] || {};
        holder[$127791eee0e6430c$exports.awsuiGlobalFlagsSymbol][flagName] = value;
    }
};
$127791eee0e6430c$exports.setGlobalFlag = $127791eee0e6430c$var$setGlobalFlag;


var $bbc4dc34e638d63d$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($bbc4dc34e638d63d$exports, "__esModule", {
    value: true
});
$bbc4dc34e638d63d$exports.safeMatchMedia = $bbc4dc34e638d63d$var$safeMatchMedia;
function $bbc4dc34e638d63d$var$safeMatchMedia(element, query) {
    var _a, _b, _c, _d;
    try {
        const targetWindow = (_b = (_a = element.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) !== null && _b !== void 0 ? _b : window;
        return (_d = (_c = targetWindow.matchMedia) === null || _c === void 0 ? void 0 : _c.call(targetWindow, query).matches) !== null && _d !== void 0 ? _d : false;
    } catch (error) {
        console.warn(error);
        return false;
    }
}


function $020c722843a7a503$var$isMotionDisabled(element) {
    return !!(0, $1yiQH.findUpUntil)(element, (node)=>node.classList.contains('awsui-motion-disabled')) || (0, $bbc4dc34e638d63d$exports.safeMatchMedia)(element, '(prefers-reduced-motion: reduce)');
}
// Generic hook for detecting mode changes via DOM mutation observation.
// Prevents unnecessary re-renders by only updating state when the value actually changes.
function $020c722843a7a503$var$useModeDetector(elementRef, detector, initialValue) {
    const [value, setValue] = (0, $acw62.useState)(initialValue);
    $020c722843a7a503$var$useMutationObserver(elementRef, (node)=>{
        const newValue = detector(node);
        /**
         * React has a behavior that triggers a re-render even if the same value is provided in the setState, while it does not
         * commit any changes to the DOM (commit phase) the function rerenders. This causes a false react act warnings in testing
         * and any component using the Transition component which in return uses this hook will possibly have false react warnings.
         *
         * To fix this, we manually stop setting the state ourselves if we see the same value.
         * References:  https://www.reddit.com/r/reactjs/comments/1ej505e/why_does_it_rerender_even_when_state_is_same/#:~:text=If%20the%20new%20value%20you,shouldn't%20affect%20your%20code
         */ if (newValue !== value) setValue(newValue);
    });
    return value;
}
function $020c722843a7a503$var$detectCurrentMode(node) {
    const darkModeParent = (0, $1yiQH.findUpUntil)(node, (node)=>node.classList.contains('awsui-polaris-dark-mode') || node.classList.contains('awsui-dark-mode'));
    return darkModeParent ? 'dark' : 'light';
}
function $020c722843a7a503$var$detectDensityMode(node) {
    const compactModeParent = (0, $1yiQH.findUpUntil)(node, (node)=>node.classList.contains('awsui-polaris-compact-mode') || node.classList.contains('awsui-compact-mode'));
    return compactModeParent ? 'compact' : 'comfortable';
}
// Note that this hook doesn't take into consideration @media print (unlike the dark mode CSS),
// due to challenges with cross-browser implementations of media/print state change listeners.
// This means that components using this hook will render in dark mode even when printing.
function $020c722843a7a503$var$useCurrentMode(elementRef) {
    return $020c722843a7a503$var$useModeDetector(elementRef, $020c722843a7a503$var$detectCurrentMode, 'light');
}
function $020c722843a7a503$var$useDensityMode(elementRef) {
    return $020c722843a7a503$var$useModeDetector(elementRef, $020c722843a7a503$var$detectDensityMode, 'comfortable');
}
function $020c722843a7a503$var$useReducedMotion(elementRef) {
    return $020c722843a7a503$var$useModeDetector(elementRef, $020c722843a7a503$var$isMotionDisabled, false);
}
const $020c722843a7a503$var$useMutationSingleton = (0, $0eab7c44803f46fb$exports.createSingletonHandler)((handler)=>{
    const observer = new MutationObserver(()=>handler());
    observer.observe(document.body, {
        attributes: true,
        subtree: true
    });
    return ()=>observer.disconnect();
});
function $020c722843a7a503$var$useMutationObserver(elementRef, onChange) {
    const handler = (0, $3bf45ec0c2b54dd9$exports.useStableCallback)(()=>{
        if (elementRef.current) onChange(elementRef.current);
    });
    $020c722843a7a503$var$useMutationSingleton(handler);
    (0, $acw62.useEffect)(()=>{
        handler();
    }, [
        handler
    ]);
}
// We expect VR is to be set only once and before the application is rendered.
let $020c722843a7a503$var$visualRefreshState = undefined;
// for testing
function $020c722843a7a503$var$clearVisualRefreshState() {
    $020c722843a7a503$var$visualRefreshState = undefined;
    if (typeof document !== 'undefined') document.body.classList.remove('awsui-visual-refresh');
}
function $020c722843a7a503$var$detectVisualRefreshClassName() {
    return typeof document !== 'undefined' && !!document.querySelector('.awsui-visual-refresh');
}
function $020c722843a7a503$var$detectVisualRefreshFlag() {
    var _a, _b;
    const global = (0, $127791eee0e6430c$exports.getGlobal)();
    return (_b = (_a = global === null || global === void 0 ? void 0 : global[$127791eee0e6430c$exports.awsuiVisualRefreshFlag]) === null || _a === void 0 ? void 0 : _a.call(global)) !== null && _b !== void 0 ? _b : false;
}
function $020c722843a7a503$var$useRuntimeVisualRefresh() {
    if ($020c722843a7a503$var$visualRefreshState === undefined) {
        $020c722843a7a503$var$visualRefreshState = $020c722843a7a503$var$detectVisualRefreshClassName();
        if (!$020c722843a7a503$var$visualRefreshState) {
            if ($020c722843a7a503$var$detectVisualRefreshFlag()) {
                $020c722843a7a503$var$visualRefreshState = true;
                if (typeof document !== 'undefined') document.body.classList.add('awsui-visual-refresh');
            }
        }
    }
    if ($ea769919060d7f5c$exports.isDevelopment) {
        const newVisualRefreshState = $020c722843a7a503$var$detectVisualRefreshClassName() || $020c722843a7a503$var$detectVisualRefreshFlag();
        if (newVisualRefreshState !== $020c722843a7a503$var$visualRefreshState) (0, $dd646455762bc7b9$exports.warnOnce)('Visual Refresh', "Dynamic visual refresh change detected. This is not supported. Make sure `awsui-visual-refresh` is attached to the `<body>` element before initial React render");
    }
    return $020c722843a7a503$var$visualRefreshState;
}


Object.defineProperty($013a2451794a45c0$exports, "isMotionDisabled", {
    enumerable: true,
    get: function() {
        return $020c722843a7a503$exports.isMotionDisabled;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "useCurrentMode", {
    enumerable: true,
    get: function() {
        return $020c722843a7a503$exports.useCurrentMode;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "useDensityMode", {
    enumerable: true,
    get: function() {
        return $020c722843a7a503$exports.useDensityMode;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "useReducedMotion", {
    enumerable: true,
    get: function() {
        return $020c722843a7a503$exports.useReducedMotion;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "useRuntimeVisualRefresh", {
    enumerable: true,
    get: function() {
        return $020c722843a7a503$exports.useRuntimeVisualRefresh;
    }
});

Object.defineProperty($013a2451794a45c0$exports, "isDevelopment", {
    enumerable: true,
    get: function() {
        return $ea769919060d7f5c$exports.isDevelopment;
    }
});

Object.defineProperty($013a2451794a45c0$exports, "warnOnce", {
    enumerable: true,
    get: function() {
        return $dd646455762bc7b9$exports.warnOnce;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "clearMessageCache", {
    enumerable: true,
    get: function() {
        return $dd646455762bc7b9$exports.clearMessageCache;
    }
});
var $558545a5feadf817$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($558545a5feadf817$exports, "__esModule", {
    value: true
});
$558545a5feadf817$exports.getIsRtl = $558545a5feadf817$var$getIsRtl;
$558545a5feadf817$exports.getOffsetInlineStart = $558545a5feadf817$var$getOffsetInlineStart;
$558545a5feadf817$exports.getScrollInlineStart = $558545a5feadf817$var$getScrollInlineStart;
$558545a5feadf817$exports.getLogicalClientX = $558545a5feadf817$var$getLogicalClientX;
$558545a5feadf817$exports.getLogicalBoundingClientRect = $558545a5feadf817$var$getLogicalBoundingClientRect;
$558545a5feadf817$exports.getLogicalPageX = $558545a5feadf817$var$getLogicalPageX;
function $558545a5feadf817$var$getIsRtl(element) {
    if (!element) return false;
    return getComputedStyle(element).direction === 'rtl';
}
/**
 * The offsetLeft property is relative to the left of the offsetParent
 * regardless of the document direction. This function returns the
 * offsetLeft value or computes the Rtl equivalent of this value
 * from the right of the offsetParent.
 */ function $558545a5feadf817$var$getOffsetInlineStart(element) {
    var _a, _b;
    const offsetParentWidth = (_b = (_a = element.offsetParent) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
    return $558545a5feadf817$var$getIsRtl(element) ? offsetParentWidth - element.offsetWidth - element.offsetLeft : element.offsetLeft;
}
/**
 * The scrollLeft value returned by the browser will be a negative number
 * if the direction is RTL. This function returns a positive value for direction
 * independent of scroll computations. Additionally, the scrollLeft value can be
 * a decimal value on systems using display scaling requiring the floor and ceiling calls.
 */ function $558545a5feadf817$var$getScrollInlineStart(element) {
    return $558545a5feadf817$var$getIsRtl(element) ? Math.floor(element.scrollLeft) * -1 : Math.ceil(element.scrollLeft);
}
/**
 * The clientX value is computed from the top left corner of the document regardless
 * of the document diretion. This function returns the clientX value or computes the
 * Rtl equivalent relative to the top right corner of the document in order for
 * computations to yield the same result in both element directions.
 */ function $558545a5feadf817$var$getLogicalClientX(event, IsRtl) {
    return IsRtl ? document.documentElement.clientWidth - event.clientX : event.clientX;
}
/**
 * The getBoundingClientRect() function returns values relative to the top left
 * corner of the document regardless of document direction. The left/right position
 * will be transformed to insetInlineStart based on element direction in order to
 * support direction agnostic position computation.
 */ function $558545a5feadf817$var$getLogicalBoundingClientRect(element) {
    const boundingClientRect = element.getBoundingClientRect();
    const blockSize = boundingClientRect.height;
    const inlineSize = boundingClientRect.width;
    const insetBlockStart = boundingClientRect.top;
    const insetBlockEnd = boundingClientRect.bottom;
    const insetInlineStart = $558545a5feadf817$var$getIsRtl(element) ? document.documentElement.clientWidth - boundingClientRect.right : boundingClientRect.left;
    const insetInlineEnd = insetInlineStart + inlineSize;
    return {
        blockSize: blockSize,
        inlineSize: inlineSize,
        insetBlockStart: insetBlockStart,
        insetBlockEnd: insetBlockEnd,
        insetInlineStart: insetInlineStart,
        insetInlineEnd: insetInlineEnd
    };
}
/**
 * The pageX position needs to be converted so it is relative to the right of
 * the document in order for computations to yield the same result in both
 * element directions.
 */ function $558545a5feadf817$var$getLogicalPageX(event) {
    return event.target instanceof HTMLElement && $558545a5feadf817$var$getIsRtl(event.target) ? document.documentElement.clientWidth - event.pageX : event.pageX;
}


Object.defineProperty($013a2451794a45c0$exports, "getIsRtl", {
    enumerable: true,
    get: function() {
        return $558545a5feadf817$exports.getIsRtl;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getOffsetInlineStart", {
    enumerable: true,
    get: function() {
        return $558545a5feadf817$exports.getOffsetInlineStart;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getScrollInlineStart", {
    enumerable: true,
    get: function() {
        return $558545a5feadf817$exports.getScrollInlineStart;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getLogicalClientX", {
    enumerable: true,
    get: function() {
        return $558545a5feadf817$exports.getLogicalClientX;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getLogicalBoundingClientRect", {
    enumerable: true,
    get: function() {
        return $558545a5feadf817$exports.getLogicalBoundingClientRect;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getLogicalPageX", {
    enumerable: true,
    get: function() {
        return $558545a5feadf817$exports.getLogicalPageX;
    }
});
var $07cc8ef4b4d5d146$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($07cc8ef4b4d5d146$exports, "__esModule", {
    value: true
});
$07cc8ef4b4d5d146$exports.useFocusVisible = $07cc8ef4b4d5d146$var$useFocusVisible;

var $acw62 = parcelRequire("acw62");
var $9c48dcf56f2dc374$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($9c48dcf56f2dc374$exports, "__esModule", {
    value: true
});
$9c48dcf56f2dc374$exports.KeyCode = void 0;
$9c48dcf56f2dc374$exports.isModifierKey = $9c48dcf56f2dc374$var$isModifierKey;
var $9c48dcf56f2dc374$var$KeyCode;
(function(KeyCode) {
    KeyCode[KeyCode["pageUp"] = 33] = "pageUp";
    KeyCode[KeyCode["pageDown"] = 34] = "pageDown";
    KeyCode[KeyCode["end"] = 35] = "end";
    KeyCode[KeyCode["home"] = 36] = "home";
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["down"] = 40] = "down";
    KeyCode[KeyCode["left"] = 37] = "left";
    KeyCode[KeyCode["right"] = 39] = "right";
    KeyCode[KeyCode["up"] = 38] = "up";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["tab"] = 9] = "tab";
    KeyCode[KeyCode["shift"] = 16] = "shift";
    KeyCode[KeyCode["control"] = 17] = "control";
    KeyCode[KeyCode["alt"] = 18] = "alt";
    KeyCode[KeyCode["meta"] = 91] = "meta";
})($9c48dcf56f2dc374$var$KeyCode || ($9c48dcf56f2dc374$exports.KeyCode = $9c48dcf56f2dc374$var$KeyCode = {}));
function $9c48dcf56f2dc374$var$isModifierKey(event) {
    // we do not want to highlight focused element
    // when special keys are pressed
    return [
        $9c48dcf56f2dc374$var$KeyCode.shift,
        $9c48dcf56f2dc374$var$KeyCode.alt,
        $9c48dcf56f2dc374$var$KeyCode.control,
        $9c48dcf56f2dc374$var$KeyCode.meta
    ].includes(event.keyCode);
}


const $07cc8ef4b4d5d146$var$frames = new Map();
function $07cc8ef4b4d5d146$var$setIsKeyboard(active) {
    if (active) for (const currentDocument of $07cc8ef4b4d5d146$var$frames.keys())currentDocument.body.setAttribute('data-awsui-focus-visible', 'true');
    else for (const currentDocument of $07cc8ef4b4d5d146$var$frames.keys())currentDocument.body.removeAttribute('data-awsui-focus-visible');
}
function $07cc8ef4b4d5d146$var$handleMousedown() {
    $07cc8ef4b4d5d146$var$setIsKeyboard(false);
}
function $07cc8ef4b4d5d146$var$handleKeydown(event) {
    if (!(0, $9c48dcf56f2dc374$exports.isModifierKey)(event)) $07cc8ef4b4d5d146$var$setIsKeyboard(true);
}
function $07cc8ef4b4d5d146$var$addListeners(currentDocument) {
    const abortController = new AbortController();
    currentDocument.addEventListener('mousedown', $07cc8ef4b4d5d146$var$handleMousedown, {
        signal: abortController.signal
    });
    currentDocument.addEventListener('keydown', $07cc8ef4b4d5d146$var$handleKeydown, {
        signal: abortController.signal
    });
    return abortController;
}
function $07cc8ef4b4d5d146$var$useFocusVisible(componentRef) {
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        const currentDocument = (_b = (_a = componentRef === null || componentRef === void 0 ? void 0 : componentRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : document;
        let frame = $07cc8ef4b4d5d146$var$frames.get(currentDocument);
        if (frame) frame.componentsCount++;
        else {
            const abortController = $07cc8ef4b4d5d146$var$addListeners(currentDocument);
            frame = {
                componentsCount: 1,
                abortController: abortController
            };
            $07cc8ef4b4d5d146$var$frames.set(currentDocument, frame);
        }
        return ()=>{
            frame.componentsCount--;
            if (frame.componentsCount === 0) {
                frame.abortController.abort();
                $07cc8ef4b4d5d146$var$frames.delete(currentDocument);
            }
        };
    }, [
        componentRef
    ]);
}


Object.defineProperty($013a2451794a45c0$exports, "useFocusVisible", {
    enumerable: true,
    get: function() {
        return $07cc8ef4b4d5d146$exports.useFocusVisible;
    }
});

Object.defineProperty($013a2451794a45c0$exports, "KeyCode", {
    enumerable: true,
    get: function() {
        return $9c48dcf56f2dc374$exports.KeyCode;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "isModifierKey", {
    enumerable: true,
    get: function() {
        return $9c48dcf56f2dc374$exports.isModifierKey;
    }
});

Object.defineProperty($013a2451794a45c0$exports, "getGlobalFlag", {
    enumerable: true,
    get: function() {
        return $127791eee0e6430c$exports.getGlobalFlag;
    }
});
var $efc3c6ecab8a5c7f$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($efc3c6ecab8a5c7f$exports, "__esModule", {
    value: true
});
$efc3c6ecab8a5c7f$exports.SingleTabStopNavigationProvider = $efc3c6ecab8a5c7f$exports.SingleTabStopNavigationContext = void 0;
$efc3c6ecab8a5c7f$exports.useSingleTabStopNavigation = $efc3c6ecab8a5c7f$var$useSingleTabStopNavigation;
$efc3c6ecab8a5c7f$exports.SingleTabStopNavigationReset = $efc3c6ecab8a5c7f$var$SingleTabStopNavigationReset;

var $7WQrb = parcelRequire("7WQrb");

const $efc3c6ecab8a5c7f$var$react_1 = $7WQrb.__importStar((parcelRequire("acw62")));
var $d12c395c458f4a4a$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($d12c395c458f4a4a$exports, "__esModule", {
    value: true
});
$d12c395c458f4a4a$exports.useEffectOnUpdate = $d12c395c458f4a4a$var$useEffectOnUpdate;

var $acw62 = parcelRequire("acw62");
// useEffect, which skips the initial render
function $d12c395c458f4a4a$var$useEffectOnUpdate(callback, deps) {
    const isFirstRender = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else return callback();
    // This is a useEffect extension, will be validated at the call site
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}



const $efc3c6ecab8a5c7f$var$node_belongs_js_1 = $7WQrb.__importDefault((parcelRequire("gQiaw")));
const $efc3c6ecab8a5c7f$var$defaultValue = {
    navigationActive: false,
    registerFocusable: ()=>()=>{},
    resetFocusTarget: ()=>{}
};
/**
 * Single tab stop navigation context is used together with keyboard navigation that requires a single tab stop.
 * It instructs interactive elements to override tab indices for just a single one to remain user-focusable.
 */ $efc3c6ecab8a5c7f$exports.SingleTabStopNavigationContext = (0, $efc3c6ecab8a5c7f$var$react_1.createContext)($efc3c6ecab8a5c7f$var$defaultValue);
function $efc3c6ecab8a5c7f$var$useSingleTabStopNavigation(focusable, options) {
    var _a;
    const { navigationActive: contextNavigationActive, registerFocusable: registerFocusable } = (0, $efc3c6ecab8a5c7f$var$react_1.useContext)($efc3c6ecab8a5c7f$exports.SingleTabStopNavigationContext);
    const [focusTargetActive, setFocusTargetActive] = (0, $efc3c6ecab8a5c7f$var$react_1.useState)(false);
    const navigationDisabled = (options === null || options === void 0 ? void 0 : options.tabIndex) && (options === null || options === void 0 ? void 0 : options.tabIndex) < 0;
    const navigationActive = contextNavigationActive && !navigationDisabled;
    (0, $efc3c6ecab8a5c7f$var$react_1.useLayoutEffect)(()=>{
        if (navigationActive && focusable && focusable.current) {
            const unregister = registerFocusable(focusable.current, (isFocusable)=>setFocusTargetActive(isFocusable));
            return ()=>unregister();
        }
    });
    let tabIndex = options === null || options === void 0 ? void 0 : options.tabIndex;
    if (navigationActive) tabIndex = !focusTargetActive ? -1 : (_a = options === null || options === void 0 ? void 0 : options.tabIndex) !== null && _a !== void 0 ? _a : 0;
    return {
        navigationActive: navigationActive,
        tabIndex: tabIndex
    };
}
function $efc3c6ecab8a5c7f$var$SingleTabStopNavigationReset({ children: children }) {
    return $efc3c6ecab8a5c7f$var$react_1.default.createElement($efc3c6ecab8a5c7f$exports.SingleTabStopNavigationContext.Provider, {
        value: $efc3c6ecab8a5c7f$var$defaultValue
    }, children);
}
$efc3c6ecab8a5c7f$exports.SingleTabStopNavigationProvider = (0, $efc3c6ecab8a5c7f$var$react_1.forwardRef)(({ navigationActive: navigationActive, children: children, getNextFocusTarget: getNextFocusTarget, isElementSuppressed: isElementSuppressed, onRegisterFocusable: onRegisterFocusable, onUnregisterActive: onUnregisterActive }, ref)=>{
    // A set of registered focusable elements that can use keyboard navigation.
    const focusables = (0, $efc3c6ecab8a5c7f$var$react_1.useRef)(new Set());
    // A map of registered focusable element handlers to update the respective tab indices.
    const focusHandlers = (0, $efc3c6ecab8a5c7f$var$react_1.useRef)(new Map());
    // A map of focusable element states to avoid issuing unnecessary updates to registered elements.
    const focusablesState = (0, $efc3c6ecab8a5c7f$var$react_1.useRef)(new WeakMap());
    // A reference to the currently focused element.
    const focusTarget = (0, $efc3c6ecab8a5c7f$var$react_1.useRef)(null);
    function onUnregisterFocusable(focusableElement) {
        const isUnregisteringFocusedNode = (0, $efc3c6ecab8a5c7f$var$node_belongs_js_1.default)(focusableElement, document.activeElement);
        if (isUnregisteringFocusedNode) // Wait for unmounted node to get removed from the DOM.
        setTimeout(()=>onUnregisterActive === null || onUnregisterActive === void 0 ? void 0 : onUnregisterActive(focusableElement), 0);
    }
    // Register a focusable element to allow navigating into it.
    // The focusable element tabIndex is only set to 0 if the element matches the focus target.
    function registerFocusable(focusableElement, changeHandler) {
        // In case the contexts are nested, we must that the components register to all of them,
        // so that switching between contexts dynamically is possible.
        const parentUnregister = parentContext.registerFocusable(focusableElement, changeHandler);
        focusables.current.add(focusableElement);
        focusHandlers.current.set(focusableElement, changeHandler);
        const isFocusable = !!focusablesState.current.get(focusableElement);
        const newIsFocusable = focusTarget.current === focusableElement || !!(isElementSuppressed === null || isElementSuppressed === void 0 ? void 0 : isElementSuppressed(focusableElement));
        if (newIsFocusable !== isFocusable) {
            focusablesState.current.set(focusableElement, newIsFocusable);
            changeHandler(newIsFocusable);
        }
        onRegisterFocusable === null || onRegisterFocusable === void 0 || onRegisterFocusable(focusableElement);
        return ()=>{
            parentUnregister();
            unregisterFocusable(focusableElement);
        };
    }
    function unregisterFocusable(focusableElement) {
        focusables.current.delete(focusableElement);
        focusHandlers.current.delete(focusableElement);
        onUnregisterFocusable === null || onUnregisterFocusable === void 0 || onUnregisterFocusable(focusableElement);
    }
    // Update focus target with next single focusable element and notify all registered focusables of a change.
    function updateFocusTarget(forceUpdate = false) {
        var _a;
        focusTarget.current = getNextFocusTarget();
        for (const focusableElement of focusables.current){
            const isFocusable = (_a = focusablesState.current.get(focusableElement)) !== null && _a !== void 0 ? _a : false;
            const newIsFocusable = focusTarget.current === focusableElement || !!(isElementSuppressed === null || isElementSuppressed === void 0 ? void 0 : isElementSuppressed(focusableElement));
            if (newIsFocusable !== isFocusable || forceUpdate) {
                focusablesState.current.set(focusableElement, newIsFocusable);
                focusHandlers.current.get(focusableElement)(newIsFocusable);
            }
        }
    }
    function resetFocusTarget() {
        updateFocusTarget(true);
    }
    function getFocusTarget() {
        return focusTarget.current;
    }
    function isRegistered(element) {
        return focusables.current.has(element);
    }
    (0, $efc3c6ecab8a5c7f$var$react_1.useImperativeHandle)(ref, ()=>({
            updateFocusTarget: updateFocusTarget,
            getFocusTarget: getFocusTarget,
            isRegistered: isRegistered
        }));
    // Only one STSN context should be active at a time.
    // The outer context is preferred over the inners. The components using STSN
    // must either work with either outer or inner context, or an explicit switch mechanism
    // needs to be implemented (that turns the outer context on and off based on user interaction).
    const parentContext = (0, $efc3c6ecab8a5c7f$var$react_1.useContext)($efc3c6ecab8a5c7f$exports.SingleTabStopNavigationContext);
    const value = parentContext.navigationActive ? parentContext : {
        navigationReset: false,
        navigationActive: navigationActive,
        registerFocusable: registerFocusable,
        updateFocusTarget: updateFocusTarget,
        resetFocusTarget: resetFocusTarget
    };
    // When contexts switching occurs, it is essential that the now-active one updates the focus target
    // to ensure the tab indices are correctly set.
    (0, $d12c395c458f4a4a$exports.useEffectOnUpdate)(()=>{
        if (parentContext.navigationActive) parentContext.resetFocusTarget();
        else resetFocusTarget();
    // The updateFocusTarget and its dependencies must be pure.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        parentContext.navigationActive
    ]);
    return $efc3c6ecab8a5c7f$var$react_1.default.createElement($efc3c6ecab8a5c7f$exports.SingleTabStopNavigationContext.Provider, {
        value: value
    }, children);
});


Object.defineProperty($013a2451794a45c0$exports, "SingleTabStopNavigationProvider", {
    enumerable: true,
    get: function() {
        return $efc3c6ecab8a5c7f$exports.SingleTabStopNavigationProvider;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "SingleTabStopNavigationReset", {
    enumerable: true,
    get: function() {
        return $efc3c6ecab8a5c7f$exports.SingleTabStopNavigationReset;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "useSingleTabStopNavigation", {
    enumerable: true,
    get: function() {
        return $efc3c6ecab8a5c7f$exports.useSingleTabStopNavigation;
    }
});
var $ad7b8669339712ff$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($ad7b8669339712ff$exports, "__esModule", {
    value: true
});
$ad7b8669339712ff$exports.isFocusable = $ad7b8669339712ff$var$isFocusable;
$ad7b8669339712ff$exports.getAllFocusables = $ad7b8669339712ff$var$getAllFocusables;
$ad7b8669339712ff$exports.getFirstFocusable = $ad7b8669339712ff$var$getFirstFocusable;
$ad7b8669339712ff$exports.getLastFocusable = $ad7b8669339712ff$var$getLastFocusable;
// Credits to
// https://github.com/theKashey/focus-lock/blob/33f8b4bd9675d2605b15e2e4015b77fe35fbd6d0/src/utils/tabbables.ts
const $ad7b8669339712ff$var$tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
].join(',');
function $ad7b8669339712ff$var$isFocusable(element) {
    return element.matches($ad7b8669339712ff$var$tabbables);
}
function $ad7b8669339712ff$var$getAllFocusables(container) {
    return [
        ...container.querySelectorAll($ad7b8669339712ff$var$tabbables)
    ];
}
function $ad7b8669339712ff$var$getFocusables(container) {
    return $ad7b8669339712ff$var$getAllFocusables(container).filter((element)=>element.tabIndex !== -1);
}
function $ad7b8669339712ff$var$getFirstFocusable(container) {
    var _a;
    const focusables = $ad7b8669339712ff$var$getFocusables(container);
    return (_a = focusables[0]) !== null && _a !== void 0 ? _a : null;
}
function $ad7b8669339712ff$var$getLastFocusable(container) {
    var _a;
    const focusables = $ad7b8669339712ff$var$getFocusables(container);
    return (_a = focusables[focusables.length - 1]) !== null && _a !== void 0 ? _a : null;
}


Object.defineProperty($013a2451794a45c0$exports, "isFocusable", {
    enumerable: true,
    get: function() {
        return $ad7b8669339712ff$exports.isFocusable;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getAllFocusables", {
    enumerable: true,
    get: function() {
        return $ad7b8669339712ff$exports.getAllFocusables;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getFirstFocusable", {
    enumerable: true,
    get: function() {
        return $ad7b8669339712ff$exports.getFirstFocusable;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "getLastFocusable", {
    enumerable: true,
    get: function() {
        return $ad7b8669339712ff$exports.getLastFocusable;
    }
});
var $9254ce8e27e541ce$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($9254ce8e27e541ce$exports, "__esModule", {
    value: true
});
$9254ce8e27e541ce$exports.isEventLike = $9254ce8e27e541ce$var$isEventLike;
$9254ce8e27e541ce$exports.default = $9254ce8e27e541ce$var$handleKey;



var $iaL5f = parcelRequire("iaL5f");
function $9254ce8e27e541ce$var$isEventLike(event) {
    return (0, $iaL5f.isHTMLElement)(event.currentTarget) || (0, $iaL5f.isSVGElement)(event.currentTarget);
}
function $9254ce8e27e541ce$var$handleKey(event, { onActivate: onActivate, onBlockEnd: onBlockEnd, onBlockStart: onBlockStart, onDefault: onDefault, onEnd: onEnd, onEscape: onEscape, onHome: onHome, onInlineEnd: onInlineEnd, onInlineStart: onInlineStart, onPageDown: onPageDown, onPageUp: onPageUp }) {
    switch(event.keyCode){
        case $9c48dcf56f2dc374$exports.KeyCode.down:
            onBlockEnd === null || onBlockEnd === void 0 || onBlockEnd();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.end:
            onEnd === null || onEnd === void 0 || onEnd();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.enter:
        case $9c48dcf56f2dc374$exports.KeyCode.space:
            onActivate === null || onActivate === void 0 || onActivate();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.escape:
            onEscape === null || onEscape === void 0 || onEscape();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.home:
            onHome === null || onHome === void 0 || onHome();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.left:
            (0, $558545a5feadf817$exports.getIsRtl)(event.currentTarget) ? onInlineEnd === null || onInlineEnd === void 0 || onInlineEnd() : onInlineStart === null || onInlineStart === void 0 || onInlineStart();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.pageDown:
            onPageDown === null || onPageDown === void 0 || onPageDown();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.pageUp:
            onPageUp === null || onPageUp === void 0 || onPageUp();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.right:
            (0, $558545a5feadf817$exports.getIsRtl)(event.currentTarget) ? onInlineStart === null || onInlineStart === void 0 || onInlineStart() : onInlineEnd === null || onInlineEnd === void 0 || onInlineEnd();
            break;
        case $9c48dcf56f2dc374$exports.KeyCode.up:
            onBlockStart === null || onBlockStart === void 0 || onBlockStart();
            break;
        default:
            onDefault === null || onDefault === void 0 || onDefault();
            break;
    }
}


Object.defineProperty($013a2451794a45c0$exports, "handleKey", {
    enumerable: true,
    get: function() {
        return $7WQrb.__importDefault($9254ce8e27e541ce$exports).default;
    }
});
var $98e5f5ca70994a7a$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($98e5f5ca70994a7a$exports, "__esModule", {
    value: true
});
$98e5f5ca70994a7a$exports.default = $98e5f5ca70994a7a$var$circleIndex;
// Returns given index if it is in range or the opposite range boundary otherwise.
function $98e5f5ca70994a7a$var$circleIndex(index, [from, to]) {
    if (index < from) return to;
    if (index > to) return from;
    return index;
}


Object.defineProperty($013a2451794a45c0$exports, "circleIndex", {
    enumerable: true,
    get: function() {
        return $7WQrb.__importDefault($98e5f5ca70994a7a$exports).default;
    }
});
var $021a4e94785c4829$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($021a4e94785c4829$exports, "__esModule", {
    value: true
});
$021a4e94785c4829$exports.default = $021a4e94785c4829$var$Portal;

var $acw62 = parcelRequire("acw62");



function $021a4e94785c4829$var$manageDefaultContainer(setState) {
    const newContainer = document.createElement('div');
    document.body.appendChild(newContainer);
    setState(newContainer);
    return ()=>{
        document.body.removeChild(newContainer);
    };
}
function $021a4e94785c4829$var$manageAsyncContainer(getContainer, removeContainer, setState) {
    let newContainer = null;
    const abortController = new AbortController();
    getContainer({
        abortSignal: abortController.signal
    }).then((container)=>{
        if (abortController.signal.aborted) return;
        newContainer = container;
        setState(container);
    }, (error)=>{
        console.warn('[AwsUi] [portal]: failed to load portal root', error);
    });
    return ()=>{
        abortController.abort();
        removeContainer(newContainer);
    };
}
/**
 * A safe react portal component that renders to a provided node.
 * If a node isn't provided, it creates one under document.body.
 */ function $021a4e94785c4829$var$Portal({ container: container, getContainer: getContainer, removeContainer: removeContainer, children: children }) {
    const [activeContainer, setActiveContainer] = (0, $acw62.useState)(container !== null && container !== void 0 ? container : null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (container) {
            setActiveContainer(container);
            return;
        }
        if ($ea769919060d7f5c$exports.isDevelopment) {
            if (getContainer && !removeContainer) (0, $dd646455762bc7b9$exports.warnOnce)('portal', '`removeContainer` is required when `getContainer` is provided');
            if (!getContainer && removeContainer) (0, $dd646455762bc7b9$exports.warnOnce)('portal', '`getContainer` is required when `removeContainer` is provided');
        }
        if (getContainer && removeContainer) return $021a4e94785c4829$var$manageAsyncContainer(getContainer, removeContainer, setActiveContainer);
        return $021a4e94785c4829$var$manageDefaultContainer(setActiveContainer);
    }, [
        container,
        getContainer,
        removeContainer
    ]);
    return activeContainer && (0, $11492dca620dcaa5$exports.createPortal)(children, activeContainer);
}


Object.defineProperty($013a2451794a45c0$exports, "Portal", {
    enumerable: true,
    get: function() {
        return $7WQrb.__importDefault($021a4e94785c4829$exports).default;
    }
});
var $0dca7fea98e14b4f$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($0dca7fea98e14b4f$exports, "__esModule", {
    value: true
});
$0dca7fea98e14b4f$exports.useMergeRefs = $0dca7fea98e14b4f$var$useMergeRefs;

var $acw62 = parcelRequire("acw62");
/**
 * useMergeRefs merges multiple refs into single ref callback.
 *
 * For example
 *  const mergedRef = useMergeRefs(ref1, ref2, ref3)
 *  <div ref={refs}>...</div>
 */ function $0dca7fea98e14b4f$var$useMergeRefs(...refs) {
    return (0, $acw62.useMemo)(()=>{
        if (refs.every((ref)=>ref === null || ref === undefined)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref !== null && ref !== undefined) ref.current = value;
            });
        };
    // ESLint expects an array literal which we can not provide here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


Object.defineProperty($013a2451794a45c0$exports, "useMergeRefs", {
    enumerable: true,
    get: function() {
        return $0dca7fea98e14b4f$exports.useMergeRefs;
    }
});
var $e9ee36f923ffe49f$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e9ee36f923ffe49f$var$_a;
Object.defineProperty($e9ee36f923ffe49f$exports, "__esModule", {
    value: true
});
$e9ee36f923ffe49f$exports.useRandomId = void 0;
$e9ee36f923ffe49f$exports.useUniqueId = $e9ee36f923ffe49f$var$useUniqueId;

var $7WQrb = parcelRequire("7WQrb");

const $e9ee36f923ffe49f$var$react_1 = $7WQrb.__importStar((parcelRequire("acw62")));
let $e9ee36f923ffe49f$var$counter = 0;
const $e9ee36f923ffe49f$var$useRandomId = ()=>{
    const idRef = (0, $e9ee36f923ffe49f$var$react_1.useRef)(null);
    if (!idRef.current) idRef.current = `${$e9ee36f923ffe49f$var$counter++}-${Date.now()}-${Math.round(Math.random() * 10000)}`;
    return idRef.current;
};
$e9ee36f923ffe49f$exports.useRandomId = $e9ee36f923ffe49f$var$useRandomId;
const $e9ee36f923ffe49f$var$useId = ($e9ee36f923ffe49f$var$_a = $e9ee36f923ffe49f$var$react_1.default.useId) !== null && $e9ee36f923ffe49f$var$_a !== void 0 ? $e9ee36f923ffe49f$var$_a : $e9ee36f923ffe49f$exports.useRandomId;
function $e9ee36f923ffe49f$var$useUniqueId(prefix) {
    return `${prefix ? prefix : ''}` + $e9ee36f923ffe49f$var$useId();
}


Object.defineProperty($013a2451794a45c0$exports, "useRandomId", {
    enumerable: true,
    get: function() {
        return $e9ee36f923ffe49f$exports.useRandomId;
    }
});
Object.defineProperty($013a2451794a45c0$exports, "useUniqueId", {
    enumerable: true,
    get: function() {
        return $e9ee36f923ffe49f$exports.useUniqueId;
    }
});
var $332c3ebb597eae63$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($332c3ebb597eae63$exports, "__esModule", {
    value: true
});
$332c3ebb597eae63$exports.validateProps = $332c3ebb597eae63$var$validateProps;

function $332c3ebb597eae63$var$validateProps(componentName, props, excludedProps, allowedEnums, systemName) {
    if (!$ea769919060d7f5c$exports.isDevelopment) return;
    for (const [prop, value] of Object.entries(props)){
        if (excludedProps.includes(prop)) throw new Error(`${componentName} does not support "${prop}" property when used in ${systemName} system`);
        if (value && allowedEnums[prop] && !allowedEnums[prop].includes(value)) throw new Error(`${componentName} does not support "${prop}" with value "${value}" when used in ${systemName} system`);
    }
}


Object.defineProperty($013a2451794a45c0$exports, "validateProps", {
    enumerable: true,
    get: function() {
        return $332c3ebb597eae63$exports.validateProps;
    }
});
var $44229fada2152a44$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($44229fada2152a44$exports, "__esModule", {
    value: true
});
$44229fada2152a44$exports.getTrackableValue = void 0;
const $44229fada2152a44$var$getTrackableValue = (trackBy, item)=>{
    if (!trackBy) return item;
    if (typeof trackBy === 'function') return trackBy(item);
    return item[trackBy];
};
$44229fada2152a44$exports.getTrackableValue = $44229fada2152a44$var$getTrackableValue;


Object.defineProperty($013a2451794a45c0$exports, "getTrackableValue", {
    enumerable: true,
    get: function() {
        return $44229fada2152a44$exports.getTrackableValue;
    }
});
var $195f36918596d40d$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($195f36918596d40d$exports, "__esModule", {
    value: true
});
$195f36918596d40d$exports.SelectionTree = void 0;

const $195f36918596d40d$var$ROOT_KEY = Symbol('selection-tree-root');
class $195f36918596d40d$var$SelectionTree {
    constructor(roots, treeProps, state){
        this.itemKeyToItem = new Map();
        this.itemToggleState = new Set();
        this.itemProjectedSelectionState = new Set();
        this.itemProjectedParentSelectionState = new Set();
        this.itemProjectedIndeterminateState = new Set();
        this.itemKeyToSelectedCount = new Map();
        this.selectedItems = new Array();
        this.isItemSelected = (item)=>this.itemProjectedSelectionState.has(this.getKey(item));
        this.isItemIndeterminate = (item)=>this.itemProjectedIndeterminateState.has(this.getKey(item));
        this.isAllItemsSelected = ()=>this.itemProjectedSelectionState.has($195f36918596d40d$var$ROOT_KEY) && !this.itemProjectedIndeterminateState.has($195f36918596d40d$var$ROOT_KEY);
        this.isAllItemsIndeterminate = ()=>this.itemProjectedIndeterminateState.has($195f36918596d40d$var$ROOT_KEY);
        this.getSelectedItemsCount = (item)=>{
            var _a;
            return (_a = this.itemKeyToSelectedCount.get(this.getKey(item))) !== null && _a !== void 0 ? _a : 0;
        };
        this.getSelectedItems = ()=>this.selectedItems;
        this.getState = ()=>{
            const inverted = this.itemToggleState.has($195f36918596d40d$var$ROOT_KEY);
            const toggledItems = [];
            for (const itemKey of Array.from(this.itemToggleState)){
                const item = this.getItemForKey(itemKey);
                if (item) toggledItems.push(item);
            }
            return {
                inverted: inverted,
                toggledItems: toggledItems
            };
        };
        this.toggleAll = ()=>{
            return this.isAllItemsSelected() ? new $195f36918596d40d$var$SelectionTree(this.roots, this.treeProps, {
                inverted: false,
                toggledItems: []
            }) : new $195f36918596d40d$var$SelectionTree(this.roots, this.treeProps, {
                inverted: true,
                toggledItems: []
            });
        };
        this.toggleSome = (requestedItems)=>{
            const clone = this.clone();
            const lastItemKey = clone.getKey(requestedItems[requestedItems.length - 1]);
            const isParentSelected = clone.itemProjectedParentSelectionState.has(lastItemKey);
            const isSelected = clone.itemProjectedSelectionState.has(lastItemKey);
            const isIndeterminate = clone.itemProjectedIndeterminateState.has(lastItemKey);
            const nextIsSelected = !(isSelected && !isIndeterminate);
            const nextIsSelfSelected = isParentSelected && !nextIsSelected || !isParentSelected && nextIsSelected;
            for (const requested of requestedItems){
                clone.unselectDeep(requested);
                if (nextIsSelfSelected) clone.itemToggleState.add(this.getKey(requested));
            }
            clone.computeState();
            return clone;
        };
        this.invertAll = ()=>{
            const clone = this.clone();
            clone.toggleKey($195f36918596d40d$var$ROOT_KEY);
            clone.roots.forEach((item)=>clone.toggleKey(clone.getKey(item)));
            clone.computeState();
            return clone;
        };
        this.invertOne = (item)=>{
            const clone = this.clone();
            clone.toggleKey(clone.getKey(item));
            clone.treeProps.getChildren(item).forEach((child)=>clone.toggleKey(clone.getKey(child)));
            clone.computeState();
            return clone;
        };
        this.toggleKey = (key)=>{
            if (this.itemToggleState.has(key)) this.itemToggleState.delete(key);
            else this.itemToggleState.add(key);
        };
        this.unselectDeep = (item)=>{
            this.itemToggleState.delete(this.getKey(item));
            this.treeProps.getChildren(item).forEach((child)=>this.unselectDeep(child));
        };
        this.roots = roots;
        this.treeProps = treeProps;
        // Translate initial state into internal representation.
        if (state.inverted) this.itemToggleState.add($195f36918596d40d$var$ROOT_KEY);
        for (const item of state.toggledItems)this.itemToggleState.add(this.getKey(item));
        // Populate item key to item mapping.
        const traverse = (item)=>{
            this.itemKeyToItem.set(this.getKey(item), item);
            treeProps.getChildren(item).forEach(traverse);
        };
        roots.forEach(traverse);
        this.computeState();
    }
    computeState() {
        var _a, _b;
        this.itemProjectedSelectionState = new Set();
        this.itemProjectedIndeterminateState = new Set();
        this.itemProjectedParentSelectionState = new Set();
        this.itemKeyToSelectedCount = new Map();
        this.selectedItems = [];
        // Transform input items tree to selection buckets.
        // Selection buckets are organized in a map by level.
        // Each bucket has a parent element (index=0) and might have children elements (index>=1).
        const selectionBuckets = new Map();
        const createSelectionBuckets = (item, level)=>{
            var _a;
            const itemKey = this.getKey(item);
            const levelBuckets = (_a = selectionBuckets.get(level)) !== null && _a !== void 0 ? _a : [];
            const children = this.treeProps.getChildren(item);
            const bucket = [
                itemKey
            ];
            for (const child of children){
                bucket.push(this.getKey(child));
                createSelectionBuckets(child, level + 1);
            }
            levelBuckets.push(bucket);
            selectionBuckets.set(level, levelBuckets);
        };
        // On level=0 there is a root bucket to hold the selection-inverted state.
        // On level>0 there are buckets that represent selection for every item.
        const rootBucket = [
            $195f36918596d40d$var$ROOT_KEY
        ];
        for (const item of this.roots){
            rootBucket.push(this.getKey(item));
            createSelectionBuckets(item, 1);
        }
        selectionBuckets.set(0, [
            rootBucket
        ]);
        // Transform buckets map to an array of buckets where those with bigger levels come first.
        const selectionBucketEntries = Array.from(selectionBuckets.entries()).sort(([a], [b])=>b - a).flatMap(([, v])=>v);
        // Normalize selection state.
        for (const bucket of selectionBucketEntries){
            // Cannot normalize 1-element buckets.
            if (bucket.length === 1) continue;
            let selectedCount = 0;
            for(let i = bucket.length - 1; i >= 0; i--){
                if (this.itemToggleState.has(bucket[i])) selectedCount++;
                else break;
            }
            // Cannot normalize incomplete buckets.
            if (((_b = (_a = this.treeProps).isComplete) === null || _b === void 0 ? void 0 : _b.call(_a, this.getItemForKey(bucket[0]))) === false) continue;
            // Normalize selection state when all children are selected but the parent is not.
            if (selectedCount === bucket.length - 1 && !this.itemToggleState.has(bucket[0])) {
                bucket.forEach((itemKey)=>this.itemToggleState.delete(itemKey));
                this.itemToggleState.add(bucket[0]);
            }
            // Normalize selection state when all children and the parent are selected.
            if (selectedCount === bucket.length) bucket.forEach((itemKey)=>this.itemToggleState.delete(itemKey));
        }
        // Compute projected selected state.
        // An item is selected either when it is present in selection state but its parent is not selected,
        // or when it is not present in selection state but its parent is selected.
        // An item can be selected and indeterminate at the same time.
        const setItemProjectedSelection = (item, inheritedSelected)=>{
            const itemKey = this.getKey(item);
            const isSelfSelected = this.itemToggleState.has(itemKey);
            const isSelected = isSelfSelected && !inheritedSelected || !isSelfSelected && inheritedSelected;
            if (isSelected) this.itemProjectedSelectionState.add(itemKey);
            if (inheritedSelected) this.itemProjectedParentSelectionState.add(itemKey);
            this.treeProps.getChildren(item).forEach((child)=>setItemProjectedSelection(child, isSelected));
        };
        // The projected selection computation starts from the root pseudo-item (selection inverted state).
        this.roots.forEach((item)=>{
            const isRootSelected = this.itemToggleState.has($195f36918596d40d$var$ROOT_KEY);
            if (isRootSelected) this.itemProjectedSelectionState.add($195f36918596d40d$var$ROOT_KEY);
            setItemProjectedSelection(item, isRootSelected);
        });
        // Compute projected indeterminate state.
        // The parent (bucket[0]) is indeterminate when any of its children (bucket[1+]) is selected or indeterminate.
        for (const bucket of selectionBucketEntries){
            let indeterminate = false;
            for(let i = 1; i < bucket.length; i++)if (this.itemToggleState.has(bucket[i]) || this.itemProjectedIndeterminateState.has(bucket[i])) {
                indeterminate = true;
                break;
            }
            if (indeterminate) this.itemProjectedIndeterminateState.add(bucket[0]);
        }
        // Compute selected children count per item.
        const computeCounts = (item)=>{
            const children = this.treeProps.getChildren(item);
            const selfCount = !this.isGroup(item) && this.isItemSelected(item) ? 1 : 0;
            const count = selfCount + children.reduce((acc, child)=>acc + computeCounts(child), 0);
            if (selfCount) this.selectedItems.push(item);
            this.itemKeyToSelectedCount.set(this.getKey(item), count);
            return count;
        };
        for (const item of this.roots)computeCounts(item);
    }
    // Presently, the implementation treats all nodes with children as groups. Groups do not
    // contribute to the counters and are not returned as selected items - only the non-group nodes do.
    // This can be made configurable by exposing the isGroup as property.
    isGroup(item) {
        return this.treeProps.getChildren(item).length > 0;
    }
    getKey(item) {
        return (0, $44229fada2152a44$exports.getTrackableValue)(this.treeProps.trackBy, item);
    }
    getItemForKey(itemKey) {
        if (itemKey === $195f36918596d40d$var$ROOT_KEY) return null;
        return this.itemKeyToItem.get(itemKey);
    }
    clone() {
        return new $195f36918596d40d$var$SelectionTree(this.roots, this.treeProps, this.getState());
    }
}
$195f36918596d40d$exports.SelectionTree = $195f36918596d40d$var$SelectionTree;


Object.defineProperty($013a2451794a45c0$exports, "SelectionTree", {
    enumerable: true,
    get: function() {
        return $195f36918596d40d$exports.SelectionTree;
    }
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// default delay for components defined by UX
const $3f63db4ba00e1128$export$d1a6d9ea0ea6ab23 = 200;
function $3f63db4ba00e1128$export$2e2bcd8739ae039(func, delay = $3f63db4ba00e1128$export$d1a6d9ea0ea6ab23) {
    let timeout;
    return function(...args) {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(()=>{
            timeout = null;
            func(...args);
        }, delay);
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f9a0c98d405a6b2e$export$c3e9367b9aa13a23(items) {
    return items.slice().sort((a, b)=>{
        var _a, _b;
        if (b.orderPriority !== a.orderPriority) return Math.sign(((_a = b.orderPriority) !== null && _a !== void 0 ? _a : 0) - ((_b = a.orderPriority) !== null && _b !== void 0 ? _b : 0));
        return b.id < a.id ? 1 : -1;
    });
}


class $669e12e768f7d5b7$export$d181f35107806ecc {
    constructor(){
        this.listeners = [];
        this.actions = [];
        this.scheduleUpdate = (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            this.listeners.forEach((listener)=>listener(this.actions));
        }, 0);
        this.registerAction = (action)=>{
            this.actions.push(action);
            this.actions = (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(this.actions);
            this.scheduleUpdate();
        };
        this.clearRegisteredActionsForTesting = ()=>{
            this.actions = [];
        };
        this.onActionRegistered = (listener)=>{
            this.listeners.push(listener);
            this.scheduleUpdate();
            return ()=>{
                this.listeners = this.listeners.filter((item)=>item !== listener);
            };
        };
    }
    installPublic(api = {}) {
        var _a, _b;
        (_a = api.registerAction) !== null && _a !== void 0 ? _a : api.registerAction = this.registerAction;
        (_b = api.clearRegisteredActionsForTesting) !== null && _b !== void 0 ? _b : api.clearRegisteredActionsForTesting = this.clearRegisteredActionsForTesting;
        return api;
    }
    installInternal(internalApi = {}) {
        var _a;
        (_a = internalApi.onActionRegistered) !== null && _a !== void 0 ? _a : internalApi.onActionRegistered = this.onActionRegistered;
        return internalApi;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $7WQrb = parcelRequire("7WQrb");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $93d122f201f7d1ff$export$e264257b4e6b5774 = "components";
var $93d122f201f7d1ff$export$4a03ffab3315ee34 = "3.0.0 (52a4127e)";
var $93d122f201f7d1ff$export$de001b401bf3761b = "52a4127e";
var $93d122f201f7d1ff$export$5714e40777c1bcc2 = "open-source-visual-refresh";
var $93d122f201f7d1ff$export$52653a075d3f70dc = "core";
var $93d122f201f7d1ff$export$6d52b47269698ace = true;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


const $0248ab5e20bc8888$export$b0c5c2fac8144e54 = new (0, $3b8abc3d09b9a048$exports.Metrics)({
    packageSource: (0, $93d122f201f7d1ff$export$e264257b4e6b5774),
    packageVersion: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34),
    theme: (0, $93d122f201f7d1ff$export$5714e40777c1bcc2)
});


function $c6f40142f532d98e$export$2d60c6d900199da9() {
    (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendPanoramaMetric({
        eventContext: 'awsui-runtime-api-loaded',
        eventDetail: {
            version: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34)
        }
    });
}
function $c6f40142f532d98e$export$740bffb7416ae276(component, message) {
    console.warn('[AwsUi]', `[${component}]`, message);
    (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendPanoramaMetric({
        eventContext: 'awsui-runtime-api-warning',
        eventDetail: {
            version: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34),
            component: component,
            message: message
        }
    });
}


var $08ee3f2b2782aaae$var$_AlertFlashContentController_listeners, $08ee3f2b2782aaae$var$_AlertFlashContentController_cleanups, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, $08ee3f2b2782aaae$var$_AlertFlashContentController_scheduleUpdate;
class $08ee3f2b2782aaae$export$74ed514b9db75e0b {
    constructor(){
        $08ee3f2b2782aaae$var$_AlertFlashContentController_listeners.set(this, []);
        $08ee3f2b2782aaae$var$_AlertFlashContentController_cleanups.set(this, new Map());
        $08ee3f2b2782aaae$var$_AlertFlashContentController_provider.set(this, void 0);
        $08ee3f2b2782aaae$var$_AlertFlashContentController_scheduleUpdate.set(this, (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>(0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_listeners, "f").forEach((listener)=>{
                if ((0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f")) {
                    const cleanup = listener((0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f"));
                    (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_cleanups, "f").set(listener, cleanup);
                }
            }), 0));
        this.registerContentReplacer = (content)=>{
            if ((0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f")) {
                (0, $c6f40142f532d98e$export$740bffb7416ae276)('alert-flash-content', `Cannot call \`registerContentReplacer\` with new provider: provider with id "${(0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f").id}" already registered.`);
                return;
            }
            (0, $7WQrb.__classPrivateFieldSet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, content, "f");
            // Notify existing components if registration happens after the components are rendered.
            (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_scheduleUpdate, "f").call(this);
        };
        this.clearRegisteredReplacerForTesting = ()=>{
            (0, $7WQrb.__classPrivateFieldSet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, undefined, "f");
        };
        this.initialCheck = (context)=>{
            var _a;
            if ((_a = (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f")) === null || _a === void 0 ? void 0 : _a.initialCheck) return (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f").initialCheck(context);
            return false;
        };
        this.onContentRegistered = (listener)=>{
            if ((0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f")) {
                const cleanup = listener((0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_provider, "f"));
                (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_listeners, "f").push(listener);
                (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_cleanups, "f").set(listener, cleanup);
            } else (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_listeners, "f").push(listener);
            return ()=>{
                var _a;
                (_a = (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_cleanups, "f").get(listener)) === null || _a === void 0 || _a();
                (0, $7WQrb.__classPrivateFieldSet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_listeners, (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_listeners, "f").filter((item)=>item !== listener), "f");
                (0, $7WQrb.__classPrivateFieldGet)(this, $08ee3f2b2782aaae$var$_AlertFlashContentController_cleanups, "f").delete(listener);
            };
        };
    }
    installPublic(api = {}) {
        var _a, _b;
        (_a = api.registerContentReplacer) !== null && _a !== void 0 ? _a : api.registerContentReplacer = this.registerContentReplacer;
        (_b = api.clearRegisteredReplacerForTesting) !== null && _b !== void 0 ? _b : api.clearRegisteredReplacerForTesting = this.clearRegisteredReplacerForTesting;
        return api;
    }
    installInternal(internalApi = {}) {
        var _a, _b;
        (_a = internalApi.onContentRegistered) !== null && _a !== void 0 ? _a : internalApi.onContentRegistered = this.onContentRegistered;
        (_b = internalApi.initialCheck) !== null && _b !== void 0 ? _b : internalApi.initialCheck = this.initialCheck;
        return internalApi;
    }
}
$08ee3f2b2782aaae$var$_AlertFlashContentController_listeners = new WeakMap(), $08ee3f2b2782aaae$var$_AlertFlashContentController_cleanups = new WeakMap(), $08ee3f2b2782aaae$var$_AlertFlashContentController_provider = new WeakMap(), $08ee3f2b2782aaae$var$_AlertFlashContentController_scheduleUpdate = new WeakMap();



var $7WQrb = parcelRequire("7WQrb");

var $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, $6857f6c4d1af0235$var$_AppLayoutWidgetController_findPrimary, $6857f6c4d1af0235$var$_AppLayoutWidgetController_update, $6857f6c4d1af0235$var$_AppLayoutWidgetController_scheduleUpdate;
class $6857f6c4d1af0235$export$4e39b8512dcb1787 {
    constructor(){
        $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations.set(this, []);
        $6857f6c4d1af0235$var$_AppLayoutWidgetController_findPrimary.set(this, ()=>{
            const forcedPrimary = (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f").find((registration)=>registration.forceType === 'primary');
            if (forcedPrimary) return forcedPrimary;
            for (const registration of (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f").slice()){
                if (registration.forceType !== 'secondary') return registration;
            }
            return undefined;
        });
        $6857f6c4d1af0235$var$_AppLayoutWidgetController_update.set(this, ()=>{
            const primary = (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_findPrimary, "f").call(this);
            const discoveredProps = (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f").filter((registration)=>registration !== primary).map((registration)=>registration.props);
            for (const registration of (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f"))if (registration === primary) registration.onChange({
                type: 'primary',
                discoveredProps: discoveredProps
            });
            else registration.onChange(registration.secondaryInstance);
        });
        $6857f6c4d1af0235$var$_AppLayoutWidgetController_scheduleUpdate.set(this, (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>(0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_update, "f").call(this), 0));
        this.register = (forceType, onRegistrationChange)=>{
            const hasForcedPrimary = (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f").some((instance)=>instance.forceType === 'primary');
            if (forceType === 'primary' && hasForcedPrimary) throw new Error('Double primary registration attempt');
            const registration = {
                forceType: forceType,
                onChange: onRegistrationChange,
                props: {},
                secondaryInstance: {
                    type: 'secondary',
                    update: (props)=>{
                        registration.props = props;
                        (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_scheduleUpdate, "f").call(this);
                    }
                }
            };
            (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f").push(registration);
            (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_update, "f").call(this);
            return ()=>{
                (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f").splice((0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f").indexOf(registration), 1);
                (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_scheduleUpdate, "f").call(this);
            };
        };
        this.getStateForTesting = ()=>{
            return {
                registrations: (0, $7WQrb.__classPrivateFieldGet)(this, $6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations, "f")
            };
        };
        this.installInternal = (internalApi = {})=>{
            var _a, _b;
            (_a = internalApi.register) !== null && _a !== void 0 ? _a : internalApi.register = this.register;
            (_b = internalApi.getStateForTesting) !== null && _b !== void 0 ? _b : internalApi.getStateForTesting = this.getStateForTesting;
            return internalApi;
        };
    }
}
$6857f6c4d1af0235$var$_AppLayoutWidgetController_registrations = new WeakMap(), $6857f6c4d1af0235$var$_AppLayoutWidgetController_findPrimary = new WeakMap(), $6857f6c4d1af0235$var$_AppLayoutWidgetController_update = new WeakMap(), $6857f6c4d1af0235$var$_AppLayoutWidgetController_scheduleUpdate = new WeakMap();



var $7WQrb = parcelRequire("7WQrb");

var $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs;
class $0e3fcb4f5802ba31$export$a601395342951fe2 {
    constructor(){
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback.set(this, null);
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances.set(this, []);
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations.set(this, []);
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout.set(this, (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            var _a;
            if (!(0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f")) return;
            const latestBreadcrumb = (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f")[(0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").length - 1];
            (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f").call(this, (_a = latestBreadcrumb === null || latestBreadcrumb === void 0 ? void 0 : latestBreadcrumb.props) !== null && _a !== void 0 ? _a : null);
        }, 0));
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs.set(this, (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").forEach((listener)=>listener(!!(0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f")));
        }, 0));
        this.registerAppLayout = (changeCallback)=>{
            if ((0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f")) return;
            (0, $7WQrb.__classPrivateFieldSet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, changeCallback, "f");
            (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
            return ()=>{
                (0, $7WQrb.__classPrivateFieldSet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, null, "f");
                (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
            };
        };
        this.registerBreadcrumbs = (props, onRegistered)=>{
            const instance = {
                props: props
            };
            (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").push(instance);
            (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").push(onRegistered);
            (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
            (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, "f").call(this);
            return {
                update: (props)=>{
                    instance.props = props;
                    (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, "f").call(this);
                },
                cleanup: ()=>{
                    (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").splice((0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").indexOf(instance), 1);
                    (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").splice((0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").indexOf(onRegistered), 1);
                    (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, "f").call(this);
                }
            };
        };
        this.getStateForTesting = ()=>{
            return {
                appLayoutUpdateCallback: (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f"),
                breadcrumbInstances: (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f"),
                breadcrumbRegistrations: (0, $7WQrb.__classPrivateFieldGet)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f")
            };
        };
    }
    installInternal(internalApi = {}) {
        var _a, _b, _c;
        (_a = internalApi.registerBreadcrumbs) !== null && _a !== void 0 ? _a : internalApi.registerBreadcrumbs = this.registerBreadcrumbs;
        (_b = internalApi.registerAppLayout) !== null && _b !== void 0 ? _b : internalApi.registerAppLayout = this.registerAppLayout;
        (_c = internalApi.getStateForTesting) !== null && _c !== void 0 ? _c : internalApi.getStateForTesting = this.getStateForTesting;
        return internalApi;
    }
}
$0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs = new WeakMap();




const $bafc331e35e8ca5f$var$updatableProperties = [
    'badge',
    'resizable',
    'defaultSize',
    'orderPriority',
    'defaultActive',
    'onResize'
];
class $bafc331e35e8ca5f$export$f0d3882597ab64cd {
    constructor(){
        this.drawers = [];
        this.drawersRegistrationListener = null;
        this.drawerOpenedListener = null;
        this.drawerClosedListener = null;
        this.drawersUpdateListeners = [];
        this.drawerResizeListener = null;
        this.scheduleUpdate = (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            var _a;
            (_a = this.drawersRegistrationListener) === null || _a === void 0 || _a.call(this, this.drawers);
            this.drawersUpdateListeners.forEach((drawersUpdateListeners)=>{
                drawersUpdateListeners === null || drawersUpdateListeners === void 0 || drawersUpdateListeners(this.drawers);
            });
        }, 0);
        this.registerDrawer = (config)=>{
            if (this.drawers.find((drawer)=>drawer.id === config.id)) (0, $c6f40142f532d98e$export$740bffb7416ae276)('app-layout-drawers', `drawer with id "${config.id}" is already registered`);
            this.drawers = this.drawers.concat(config);
            this.scheduleUpdate();
        };
        this.updateDrawer = ({ id: drawerId, ...rest })=>{
            var _a;
            const drawerIndex = this.drawers.findIndex(({ id: id })=>id === drawerId);
            const oldDrawerConfig = (_a = this.drawers) === null || _a === void 0 ? void 0 : _a[drawerIndex];
            if (!oldDrawerConfig) throw new Error(`[AwsUi] [runtime drawers] drawer with id ${drawerId} not found`);
            const drawers = this.drawers.slice();
            const updatedDrawer = {
                ...oldDrawerConfig
            };
            for (const key of $bafc331e35e8ca5f$var$updatableProperties)if (key in rest) updatedDrawer[key] = rest[key];
            drawers[drawerIndex] = updatedDrawer;
            this.drawers = drawers;
            this.scheduleUpdate();
        };
        this.onDrawersRegistered = (listener)=>{
            if (this.drawersRegistrationListener !== null) (0, $c6f40142f532d98e$export$740bffb7416ae276)('app-layout-drawers', 'multiple app layout instances detected when calling onDrawersRegistered');
            this.drawersRegistrationListener = listener;
            this.scheduleUpdate();
            return ()=>{
                this.drawersRegistrationListener = null;
                this.drawersUpdateListeners = [];
            };
        };
        this.clearRegisteredDrawersForTesting = ()=>{
            this.drawers = [];
        };
        this.onDrawerOpened = (listener)=>{
            if (this.drawerOpenedListener !== null) (0, $c6f40142f532d98e$export$740bffb7416ae276)('app-layout-drawers', 'multiple app layout instances detected when calling onDrawerOpened');
            this.drawerOpenedListener = listener;
            return ()=>{
                this.drawerOpenedListener = null;
            };
        };
        this.onDrawerClosed = (listener)=>{
            if (this.drawerClosedListener !== null) (0, $c6f40142f532d98e$export$740bffb7416ae276)('app-layout-drawers', 'multiple app layout instances detected when calling onDrawerClosed');
            this.drawerClosedListener = listener;
            return ()=>{
                this.drawerClosedListener = null;
            };
        };
        this.openDrawer = (drawerId, params)=>{
            var _a;
            (_a = this.drawerOpenedListener) === null || _a === void 0 || _a.call(this, drawerId, params);
        };
        this.closeDrawer = (drawerId, params)=>{
            var _a;
            (_a = this.drawerClosedListener) === null || _a === void 0 || _a.call(this, drawerId, params);
        };
        this.onDrawersUpdated = (listener)=>{
            this.drawersUpdateListeners.push(listener);
            return ()=>{
                this.drawersUpdateListeners = this.drawersUpdateListeners.filter((item)=>item !== listener);
            };
        };
        this.onDrawerResize = (listener)=>{
            if (this.drawerResizeListener !== null) (0, $c6f40142f532d98e$export$740bffb7416ae276)('app-layout-drawers', 'multiple app layout instances detected when calling onDrawerResize');
            this.drawerResizeListener = listener;
            return ()=>{
                this.drawerResizeListener = null;
            };
        };
        this.resizeDrawer = (drawerId, size)=>{
            var _a;
            (_a = this.drawerResizeListener) === null || _a === void 0 || _a.call(this, drawerId, size);
        };
        this.getDrawersState = ()=>{
            return this.drawers;
        };
    }
    installPublic(api = {}) {
        var _a, _b, _c, _d, _e, _f;
        (_a = api.registerDrawer) !== null && _a !== void 0 ? _a : api.registerDrawer = this.registerDrawer;
        (_b = api.updateDrawer) !== null && _b !== void 0 ? _b : api.updateDrawer = this.updateDrawer;
        (_c = api.openDrawer) !== null && _c !== void 0 ? _c : api.openDrawer = this.openDrawer;
        (_d = api.closeDrawer) !== null && _d !== void 0 ? _d : api.closeDrawer = this.closeDrawer;
        (_e = api.resizeDrawer) !== null && _e !== void 0 ? _e : api.resizeDrawer = this.resizeDrawer;
        (_f = api.clearRegisteredDrawersForTesting) !== null && _f !== void 0 ? _f : api.clearRegisteredDrawersForTesting = this.clearRegisteredDrawersForTesting;
        return api;
    }
    installInternal(internalApi = {}) {
        var _a, _b, _c, _d, _e, _f;
        (_a = internalApi.onDrawersRegistered) !== null && _a !== void 0 ? _a : internalApi.onDrawersRegistered = this.onDrawersRegistered;
        (_b = internalApi.onDrawerOpened) !== null && _b !== void 0 ? _b : internalApi.onDrawerOpened = this.onDrawerOpened;
        (_c = internalApi.onDrawerClosed) !== null && _c !== void 0 ? _c : internalApi.onDrawerClosed = this.onDrawerClosed;
        (_d = internalApi.onDrawerResize) !== null && _d !== void 0 ? _d : internalApi.onDrawerResize = this.onDrawerResize;
        (_e = internalApi.onDrawersUpdated) !== null && _e !== void 0 ? _e : internalApi.onDrawersUpdated = this.onDrawersUpdated;
        (_f = internalApi.getDrawersState) !== null && _f !== void 0 ? _f : internalApi.getDrawersState = this.getDrawersState;
        return internalApi;
    }
}



var $7WQrb = parcelRequire("7WQrb");
var $d8560e678cbd4f4c$var$_SharedReactContexts_registeredContexts;
class $d8560e678cbd4f4c$export$583f9c983bd41fe8 {
    constructor(){
        $d8560e678cbd4f4c$var$_SharedReactContexts_registeredContexts.set(this, new WeakMap());
        this.createContext = (ReactInstance, contextName)=>{
            let contexts = (0, $7WQrb.__classPrivateFieldGet)(this, $d8560e678cbd4f4c$var$_SharedReactContexts_registeredContexts, "f").get(ReactInstance);
            if (!contexts) {
                contexts = new Map();
                (0, $7WQrb.__classPrivateFieldGet)(this, $d8560e678cbd4f4c$var$_SharedReactContexts_registeredContexts, "f").set(ReactInstance, contexts);
            }
            let cachedContext = contexts.get(contextName);
            if (!cachedContext) {
                // We cannot put a default value here, because it will be shared between versions.
                // Consumers of this API must apply default value on their end.
                cachedContext = ReactInstance.createContext(undefined);
                contexts.set(contextName, cachedContext);
            }
            return cachedContext;
        };
    }
    installInternal(internalApi = {}) {
        var _a;
        (_a = internalApi.createContext) !== null && _a !== void 0 ? _a : internalApi.createContext = this.createContext;
        return internalApi;
    }
}
$d8560e678cbd4f4c$var$_SharedReactContexts_registeredContexts = new WeakMap();



const $2ec6e52915a41fcf$var$storageKey = Symbol.for('awsui-plugin-api');
function $2ec6e52915a41fcf$var$findUpApi(currentWindow) {
    try {
        if (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow[$2ec6e52915a41fcf$var$storageKey]) return currentWindow[$2ec6e52915a41fcf$var$storageKey];
        if (!currentWindow || currentWindow.parent === currentWindow) // When the window has no more parents, it references itself
        return undefined;
        return $2ec6e52915a41fcf$var$findUpApi(currentWindow.parent);
    } catch  {
        // Most likely a cross-origin access error
        return undefined;
    }
}
function $2ec6e52915a41fcf$export$1fed1876a7d5b3d0() {
    if (typeof window === 'undefined') return $2ec6e52915a41fcf$var$installApi({});
    const win = window;
    const existingApi = $2ec6e52915a41fcf$var$findUpApi(win);
    if (!existingApi) (0, $c6f40142f532d98e$export$2d60c6d900199da9)();
    win[$2ec6e52915a41fcf$var$storageKey] = $2ec6e52915a41fcf$var$installApi(existingApi !== null && existingApi !== void 0 ? existingApi : {});
    return win[$2ec6e52915a41fcf$var$storageKey];
}
const { awsuiPlugins: $2ec6e52915a41fcf$export$3e1465788a9d72b0, awsuiPluginsInternal: $2ec6e52915a41fcf$export$90753eb139627d74 } = $2ec6e52915a41fcf$export$1fed1876a7d5b3d0();
function $2ec6e52915a41fcf$var$installApi(api) {
    var _a, _b;
    (_a = api.awsuiPlugins) !== null && _a !== void 0 ? _a : api.awsuiPlugins = {};
    (_b = api.awsuiPluginsInternal) !== null && _b !== void 0 ? _b : api.awsuiPluginsInternal = {};
    const appLayoutDrawers = new (0, $bafc331e35e8ca5f$export$f0d3882597ab64cd)();
    api.awsuiPlugins.appLayout = appLayoutDrawers.installPublic(api.awsuiPlugins.appLayout);
    api.awsuiPluginsInternal.appLayout = appLayoutDrawers.installInternal(api.awsuiPluginsInternal.appLayout);
    const appLayoutController = new (0, $6857f6c4d1af0235$export$4e39b8512dcb1787)();
    api.awsuiPluginsInternal.appLayoutWidget = appLayoutController.installInternal(api.awsuiPluginsInternal.appLayoutWidget);
    const alertActions = new (0, $669e12e768f7d5b7$export$d181f35107806ecc)();
    api.awsuiPlugins.alert = alertActions.installPublic(api.awsuiPlugins.alert);
    api.awsuiPluginsInternal.alert = alertActions.installInternal(api.awsuiPluginsInternal.alert);
    const alertContent = new (0, $08ee3f2b2782aaae$export$74ed514b9db75e0b)();
    api.awsuiPlugins.alertContent = alertContent.installPublic(api.awsuiPlugins.alertContent);
    api.awsuiPluginsInternal.alertContent = alertContent.installInternal(api.awsuiPluginsInternal.alertContent);
    const flashContent = new (0, $08ee3f2b2782aaae$export$74ed514b9db75e0b)();
    api.awsuiPlugins.flashContent = flashContent.installPublic(api.awsuiPlugins.flashContent);
    api.awsuiPluginsInternal.flashContent = flashContent.installInternal(api.awsuiPluginsInternal.flashContent);
    const flashbarActions = new (0, $669e12e768f7d5b7$export$d181f35107806ecc)();
    api.awsuiPlugins.flashbar = flashbarActions.installPublic(api.awsuiPlugins.flashbar);
    api.awsuiPluginsInternal.flashbar = flashbarActions.installInternal(api.awsuiPluginsInternal.flashbar);
    const breadcrumbs = new (0, $0e3fcb4f5802ba31$export$a601395342951fe2)();
    api.awsuiPluginsInternal.breadcrumbs = breadcrumbs.installInternal(api.awsuiPluginsInternal.breadcrumbs);
    const sharedReactContexts = new (0, $d8560e678cbd4f4c$export$583f9c983bd41fe8)();
    api.awsuiPluginsInternal.sharedReactContexts = sharedReactContexts.installInternal(api.awsuiPluginsInternal.sharedReactContexts);
    return api;
}


const $4d65e7166b5544ac$export$76a88f7de6507443 = 'cloudscape-design-components';
const $4d65e7166b5544ac$var$defaultContextValue = {
    locale: null,
    format: (_namespace, _component, _key, provided)=>provided
};
const $4d65e7166b5544ac$export$59475d4ceaadaaa9 = (0, $2ec6e52915a41fcf$export$90753eb139627d74).sharedReactContexts.createContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), 'InternalI18nContext');
function $4d65e7166b5544ac$export$43bb16f9c6d9e3f7() {
    var _a;
    return ((_a = (0, $acw62.useContext)($4d65e7166b5544ac$export$59475d4ceaadaaa9)) !== null && _a !== void 0 ? _a : $4d65e7166b5544ac$var$defaultContextValue).locale;
}
function $4d65e7166b5544ac$export$35d4b88fdfc54b46(componentName) {
    var _a;
    const { format: format } = (_a = (0, $acw62.useContext)($4d65e7166b5544ac$export$59475d4ceaadaaa9)) !== null && _a !== void 0 ? _a : $4d65e7166b5544ac$var$defaultContextValue;
    return (key, provided, customHandler)=>{
        return format($4d65e7166b5544ac$export$76a88f7de6507443, componentName, key, provided, customHandler);
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $90a8cbcc33afaf65$export$2e2bcd8739ae039 = {};


(0, $013a2451794a45c0$exports.initAwsUiVersions)((0, $93d122f201f7d1ff$export$e264257b4e6b5774), (0, $93d122f201f7d1ff$export$4a03ffab3315ee34));
function $75a0355e989dd450$export$a7ec8144096537e7(props) {
    const baseProps = {};
    Object.keys(props).forEach((prop)=>{
        if (prop === 'id' || prop === 'className' || prop.match(/^data-/)) baseProps[prop] = props[prop];
    });
    return baseProps;
}
function $75a0355e989dd450$export$dba32c398c4b8fa1(props) {
    return {
        ...props === null || props === void 0 ? void 0 : props.analyticsMetadata,
        ...props === null || props === void 0 ? void 0 : props.__analyticsMetadata
    };
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6f7f009630e0e88c$export$ca05951c6da1d883 = (theme, isVR)=>{
    if (theme === 'polaris' && isVR) return 'vr';
    return theme;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


const $1306e73bd1cbbb9a$export$976bb239ea6ecef8 = (0, $93d122f201f7d1ff$export$6d52b47269698ace) ? ()=>true : (0, $013a2451794a45c0$exports.useRuntimeVisualRefresh);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $7d3d13d62b925c07$var$checkMissingStyles(ownerDocument) {
    if (!ownerDocument.defaultView) // skip the check if this iframe is detached
    return;
    const result = getComputedStyle(ownerDocument.body).getPropertyValue(`--awsui-version-info-${(0, $93d122f201f7d1ff$export$de001b401bf3761b)}`);
    if (!result) {
        console.error(`Missing AWS-UI CSS for theme "${(0, $93d122f201f7d1ff$export$5714e40777c1bcc2)}", version "${(0, $93d122f201f7d1ff$export$4a03ffab3315ee34)}", and git sha "${(0, $93d122f201f7d1ff$export$de001b401bf3761b)}".`);
        (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendOpsMetricObject('awsui-missing-css-asset', {});
    }
}
function $7d3d13d62b925c07$var$documentReady(document1, callback) {
    var _a;
    if (document1.readyState === 'complete') callback();
    else (_a = document1.defaultView) === null || _a === void 0 || _a.addEventListener('load', ()=>callback(), {
        once: true
    });
}
async function $7d3d13d62b925c07$var$documentReadyAndIdle(document1, signal) {
    await new Promise((resolve, reject)=>{
        signal.addEventListener('abort', ()=>reject(new DOMException('Aborted', 'AbortError')));
        $7d3d13d62b925c07$var$documentReady(document1, ()=>{
            setTimeout(()=>requestIdleCallback(()=>resolve()), 1000);
        });
    });
    const stylesheets = Array.from(document1.querySelectorAll('link[rel="stylesheet"]'));
    await Promise.all(stylesheets.map((link)=>{
        // already loaded
        if (link.sheet) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            function cleanup(done) {
                link.removeEventListener('load', onLoad);
                link.removeEventListener('error', onError);
                signal.removeEventListener('abort', onAbort);
                done();
            }
            const onLoad = ()=>cleanup(resolve);
            const onError = ()=>cleanup(resolve);
            const onAbort = ()=>cleanup(()=>reject(new DOMException('Aborted', 'AbortError')));
            link.addEventListener('load', onLoad);
            link.addEventListener('error', onError);
            signal.addEventListener('abort', onAbort);
        });
    }));
}
let $7d3d13d62b925c07$var$checkedDocs = new WeakMap();
const $7d3d13d62b925c07$var$checkMissingStylesOnce = (document1)=>{
    const checked = $7d3d13d62b925c07$var$checkedDocs.get(document1);
    if (!checked) {
        $7d3d13d62b925c07$var$checkMissingStyles(document1);
        $7d3d13d62b925c07$var$checkedDocs.set(document1, true);
    }
};
const $7d3d13d62b925c07$export$6b08ff299f8ace08 = ()=>$7d3d13d62b925c07$var$checkedDocs = new WeakMap();
function $7d3d13d62b925c07$export$97aa78da7dd6f6ee(elementRef) {
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        // if idle callbacks not supported, we simply do not collect the metric
        if (typeof requestIdleCallback !== 'function') return;
        const ownerDocument = (_b = (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : document;
        const abortController = new AbortController();
        $7d3d13d62b925c07$var$documentReadyAndIdle(ownerDocument, abortController.signal).then(()=>$7d3d13d62b925c07$var$checkMissingStylesOnce(ownerDocument), (error)=>{
            // istanbul ignore next
            if (error.name !== 'AbortError') throw error;
        });
        return ()=>abortController.abort();
    }, [
        elementRef
    ]);
}


function $970c67f83063979b$export$2e2bcd8739ae039(componentName, config, analyticsMetadata) {
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const theme = (0, $6f7f009630e0e88c$export$ca05951c6da1d883)((0, $93d122f201f7d1ff$export$5714e40777c1bcc2), isVisualRefresh);
    (0, $013a2451794a45c0$exports.useComponentMetrics)(componentName, {
        packageSource: (0, $93d122f201f7d1ff$export$e264257b4e6b5774),
        packageVersion: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34),
        theme: theme
    }, config);
    const elementRef = (0, $013a2451794a45c0$exports.useComponentMetadata)(componentName, {
        packageName: (0, $93d122f201f7d1ff$export$e264257b4e6b5774),
        version: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34),
        theme: theme
    }, analyticsMetadata);
    (0, $7d3d13d62b925c07$export$97aa78da7dd6f6ee)(elementRef);
    (0, $013a2451794a45c0$exports.useFocusVisible)(elementRef);
    return {
        __internalRootRef: elementRef
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Whether the bundle is a development bundle.
 * Only use this in an if condition and on its own! This will help bundlers find
 * and remove the conditional statement for production bundles.
 */ const $bf737c197e11d40f$export$df77466336fe5355 = false;


function $7c41f87eb31b9657$export$454217e89aea72b(controlledValue, handler, defaultValue, { componentName: componentName, changeHandler: changeHandler, controlledProp: controlledProp }) {
    // The decision whether a component is controlled or uncontrolled is made on its first render and cannot be changed afterwards.
    const isControlled = $acw62.useState(controlledValue !== undefined)[0];
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        // Print a warning if the component switches between controlled and uncontrolled mode.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useEffect(()=>{
            if (isControlled && handler === undefined) (0, $013a2451794a45c0$exports.warnOnce)(componentName, `You provided a \`${controlledProp}\` prop without an \`${changeHandler}\` handler. This will render a non-interactive component.`);
        }, [
            handler,
            isControlled,
            componentName,
            changeHandler,
            controlledProp
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useEffect(()=>{
            const isControlledNow = controlledValue !== undefined;
            if (isControlled !== isControlledNow) {
                const initialMode = isControlled ? 'controlled' : 'uncontrolled';
                const modeNow = isControlledNow ? 'controlled' : 'uncontrolled';
                (0, $013a2451794a45c0$exports.warnOnce)(componentName, `A component tried to change ${initialMode} '${controlledProp}' property to be ${modeNow}. ` + `This is not supported. Properties should not switch from ${initialMode} to ${modeNow} (or vice versa). ` + `Decide between using a controlled or uncontrolled mode for the lifetime of the component. ` + `More info: https://fb.me/react-controlled-components`);
            }
        }, [
            isControlled,
            controlledProp,
            componentName,
            controlledValue
        ]);
    }
    // This is the value that is used if the component is uncontrolled.
    const [valueState, setValue] = $acw62.useState(defaultValue);
    const [valueHasBeenSet, setValueHasBeenSet] = $acw62.useState(false);
    // We track changes to the defaultValue
    const currentUncontrolledValue = valueHasBeenSet ? valueState : defaultValue;
    const setUncontrolledValue = $acw62.useCallback((newValue)=>{
        setValue(newValue);
        setValueHasBeenSet(true);
    }, [
        setValue,
        setValueHasBeenSet
    ]);
    if (isControlled) return [
        controlledValue,
        $7c41f87eb31b9657$var$defaultCallback
    ];
    else return [
        currentUncontrolledValue,
        setUncontrolledValue
    ];
}
function $7c41f87eb31b9657$var$defaultCallback() {
    return void 0;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $1be283cfa47851a8$var$BREAKPOINT_MAPPING = [
    [
        'xl',
        1840
    ],
    [
        'l',
        1320
    ],
    [
        'm',
        1120
    ],
    [
        's',
        912
    ],
    [
        'xs',
        688
    ],
    [
        'xxs',
        465
    ],
    [
        'default',
        -1
    ]
];
const $1be283cfa47851a8$export$2e65b7c7134e01f0 = $1be283cfa47851a8$var$BREAKPOINT_MAPPING.filter((b)=>b[0] === 'xs')[0][1];
const $1be283cfa47851a8$var$BREAKPOINTS_DESCENDING = $1be283cfa47851a8$var$BREAKPOINT_MAPPING.map(([bp])=>bp);
function $1be283cfa47851a8$export$1decca26c2f3798f(subset, actual) {
    const qualifyingBreakpoints = $1be283cfa47851a8$var$BREAKPOINT_MAPPING.slice($1be283cfa47851a8$var$BREAKPOINTS_DESCENDING.indexOf(actual));
    for (const [breakpoint] of qualifyingBreakpoints){
        const breakpointValue = subset[breakpoint];
        if (breakpointValue !== undefined) return breakpointValue;
    }
    return null;
}
function $1be283cfa47851a8$export$21bc4262e291071d(width, breakpointFilter) {
    for (const [breakpoint, breakpointWidth] of $1be283cfa47851a8$var$BREAKPOINT_MAPPING){
        if (width > breakpointWidth && (!breakpointFilter || breakpointFilter.indexOf(breakpoint) !== -1)) return breakpoint;
    }
    return 'default';
}
function $1be283cfa47851a8$export$4adb988360925c51(breakpoint) {
    return $1be283cfa47851a8$var$BREAKPOINT_MAPPING.find((bp)=>bp[0] === breakpoint)[1];
}


const $60d79f8943c0bbd8$export$49eec8a97910c75c = Symbol.for('awsui-force-mobile-mode');
function $60d79f8943c0bbd8$var$getIsMobile() {
    var _a;
    // allow overriding the mobile mode in tests
    // any is needed because of this https://github.com/microsoft/TypeScript/issues/36813
    const forceMobileMode = globalThis[$60d79f8943c0bbd8$export$49eec8a97910c75c];
    if (typeof forceMobileMode !== 'undefined') return forceMobileMode;
    if (typeof window === 'undefined') // assume desktop in server-rendering
    return false;
    if (window.matchMedia) /**
         * Some browsers include the scrollbar width in their media query calculations, but
         * some browsers don't. Thus we can't use `window.innerWidth` or
         * `document.documentElement.clientWidth` to get a very accurate result (since we
         * wouldn't know which one of them to use).
         * Instead, we use the media query here in JS too.
         */ /* istanbul ignore next: matchMedia is not available in jsdom. */ return (_a = window.matchMedia(`(max-width: ${(0, $1be283cfa47851a8$export$2e65b7c7134e01f0)}px)`)) === null || _a === void 0 ? void 0 : _a.matches;
    return (0, $1be283cfa47851a8$export$21bc4262e291071d)(window.innerWidth, [
        'xs'
    ]) !== 'xs';
}
const $60d79f8943c0bbd8$export$d7da5fa076846028 = (0, $013a2451794a45c0$exports.createSingletonState)({
    initialState: ()=>$60d79f8943c0bbd8$var$getIsMobile(),
    factory: (handler)=>{
        const listener = ()=>handler($60d79f8943c0bbd8$var$getIsMobile());
        window.addEventListener('resize', listener);
        return ()=>{
            window.removeEventListener('resize', listener);
        };
    }
});




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $bc3b0639056cd743$export$12dc22cc47108d02(component, displayName) {
    component.displayName = displayName;
}


const $bfbfeb434025eacd$var$defaultContentTypeState = {
    navigationOpen: true,
    minContentWidth: 280,
    maxContentWidth: undefined
};
const $bfbfeb434025eacd$var$defaults = {
    default: {
        ...$bfbfeb434025eacd$var$defaultContentTypeState
    },
    dashboard: {
        ...$bfbfeb434025eacd$var$defaultContentTypeState
    },
    cards: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: undefined
    },
    form: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 800
    },
    table: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: undefined
    },
    wizard: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 1080
    }
};
function $bfbfeb434025eacd$export$981532776ab2217e(contentType, stateFromProps, isRefresh) {
    var _a, _b, _c;
    const contentTypeDefaults = isRefresh ? {
        ...$bfbfeb434025eacd$var$defaults[contentType],
        maxContentWidth: undefined
    } : $bfbfeb434025eacd$var$defaults[contentType];
    return {
        maxContentWidth: (_a = stateFromProps.maxContentWidth) !== null && _a !== void 0 ? _a : contentTypeDefaults.maxContentWidth,
        minContentWidth: (_b = stateFromProps.minContentWidth) !== null && _b !== void 0 ? _b : contentTypeDefaults.minContentWidth,
        navigationOpen: (_c = stateFromProps.navigationOpen) !== null && _c !== void 0 ? _c : contentTypeDefaults.navigationOpen
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $8b8e109c964d1d48$export$1a8b1350915fe2e0(fn) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = fn;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
    }, []);
}


function $90ce00a619b7a027$export$683480f191c0e3ea(elementRef, onObserve) {
    const stableOnObserve = (0, $8b8e109c964d1d48$export$1a8b1350915fe2e0)(onObserve);
    // This effect provides a synchronous update required to prevent flakiness when initial state and first observed state are different.
    // Can potentially conflict with React concurrent mode: https://17.reactjs.org/docs/concurrent-mode-intro.html.
    // TODO: A possible solution would be to make consumers not render any content until the first (asynchronous) observation is available.
    (0, $acw62.useLayoutEffect)(()=>{
        const element = typeof elementRef === 'function' ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element) {
            const rect = element.getBoundingClientRect();
            onObserve($90ce00a619b7a027$var$convertElementToEntry(element, rect));
        }
    }, // This effect is only needed for the first render to provide a synchronous update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $acw62.useEffect)(()=>{
        const element = typeof elementRef === 'function' ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element && typeof ResizeObserver !== 'undefined') {
            let connected = true;
            const observer = new ResizeObserver((entries)=>{
                // Prevent observe notifications on already unmounted component.
                if (connected) (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    stableOnObserve($90ce00a619b7a027$var$convertResizeObserverEntry(entries[0]));
                });
            });
            observer.observe(element, {
                box: 'border-box'
            });
            return ()=>{
                connected = false;
                observer.disconnect();
            };
        }
    }, [
        elementRef,
        stableOnObserve
    ]);
}
function $90ce00a619b7a027$var$convertResizeObserverEntry(entry) {
    return {
        target: entry.target,
        contentBoxWidth: entry.contentBoxSize[0].inlineSize,
        contentBoxHeight: entry.contentBoxSize[0].blockSize,
        borderBoxWidth: entry.borderBoxSize[0].inlineSize,
        borderBoxHeight: entry.borderBoxSize[0].blockSize
    };
}
function $90ce00a619b7a027$var$convertElementToEntry(element, rect) {
    const computedStyle = window.getComputedStyle(element);
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
    const borderLeft = parseFloat(computedStyle.borderLeftWidth) || 0;
    const borderRight = parseFloat(computedStyle.borderRightWidth) || 0;
    const borderTop = parseFloat(computedStyle.borderTopWidth) || 0;
    const borderBottom = parseFloat(computedStyle.borderBottomWidth) || 0;
    return {
        target: element,
        contentBoxWidth: rect.width - paddingLeft - paddingRight - borderLeft - borderRight,
        contentBoxHeight: rect.height - paddingTop - paddingBottom - borderTop - borderBottom,
        borderBoxWidth: rect.width,
        borderBoxHeight: rect.height
    };
}


function $ecd46a6f96034059$export$2e2bcd8739ae039(mapFn, deps = []) {
    const elementRef = (0, $acw62.useRef)(null);
    const [state, setState] = (0, $acw62.useState)(null);
    // Update getElement when deps change to trigger new observation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getElement = (0, $acw62.useCallback)(()=>elementRef.current, deps);
    (0, $90ce00a619b7a027$export$683480f191c0e3ea)(getElement, (entry)=>setState((prevState)=>mapFn(entry, prevState)));
    return [
        state,
        elementRef
    ];
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Whether the bundle is a development bundle.
 * Only use this in an if condition and on its own! This will help bundlers find
 * and remove the conditional statement for production bundles.
 */ const $2e9298b235f3f53e$export$df77466336fe5355 = false;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $ec35196c211e93c5$var$messageCache = new Set();
function $ec35196c211e93c5$export$5b28268982f175ba(component, message) {
    if (0, $2e9298b235f3f53e$export$df77466336fe5355) {
        const warning = `[AwsUi] [${component}] ${message}`;
        if (!$ec35196c211e93c5$var$messageCache.has(warning)) {
            $ec35196c211e93c5$var$messageCache.add(warning);
            console.warn(warning);
        }
    }
}
function $ec35196c211e93c5$export$897447febe1f8d38() {
    $ec35196c211e93c5$var$messageCache.clear();
}


function $35a58da6f090ad15$export$2e2bcd8739ae039(controlledValue, changeHandler, defaultValue, propertyDescriptions, fireEvent = (value, handler)=>handler(value)) {
    const { componentName: componentName, changeHandlerName: changeHandlerName, propertyName: propertyName } = propertyDescriptions;
    // The decision whether a component is controlled or uncontrolled is made on
    // its first render and cannot be changed afterwards.
    const [isControlled] = (0, $acw62.useState)(controlledValue !== undefined);
    // Most build tools will just strip this block from production builds, so we can
    // skip the conditional hook lint error.
    if (0, $2e9298b235f3f53e$export$df77466336fe5355) {
        // Print a warning if a controlled property was passed in without a change handler.
        // This may fire every render if the change handler isn't memoized, but warnOnce
        // will dedupe the error messages.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $acw62.useEffect)(()=>{
            if (isControlled && changeHandler === undefined) (0, $ec35196c211e93c5$export$5b28268982f175ba)(componentName, `You provided a \`${propertyName}\` prop without an \`${changeHandlerName}\` handler. This will render a non-interactive component.`);
        }, [
            changeHandler,
            isControlled,
            componentName,
            changeHandlerName,
            propertyName
        ]);
        // Print a warning if the component switches between controlled and uncontrolled mode.
        const isControlledValueProvided = controlledValue !== undefined;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $acw62.useEffect)(()=>{
            if (isControlled !== isControlledValueProvided) {
                const initialMode = isControlled ? 'controlled' : 'uncontrolled';
                const modeNow = isControlledValueProvided ? 'controlled' : 'uncontrolled';
                (0, $ec35196c211e93c5$export$5b28268982f175ba)(componentName, `A component tried to change ${initialMode} '${propertyName}' property to be ${modeNow}. ` + `This is not supported. Properties should not switch from ${initialMode} to ${modeNow} (or vice versa). ` + `Decide between using a controlled or uncontrolled mode for the lifetime of the component. ` + `More info: https://fb.me/react-controlled-components`);
            }
        }, [
            isControlled,
            isControlledValueProvided,
            propertyName,
            componentName
        ]);
    }
    // This is the value that is used if the component is uncontrolled.
    const [valueState, setValue] = (0, $acw62.useState)(defaultValue);
    const [isUncontrolledValueSet, setIsUncontrolledValueSet] = (0, $acw62.useState)(false);
    const stableFireEvent = (0, $8b8e109c964d1d48$export$1a8b1350915fe2e0)((value, handler)=>fireEvent(value, handler));
    const setControlledValue = (0, $acw62.useCallback)((value)=>{
        if (changeHandler) stableFireEvent(value, changeHandler);
    }, [
        changeHandler,
        stableFireEvent
    ]);
    // We allow changes to the defaultValue prop to be reflected until the component
    // starts controlling it internally.
    const currentUncontrolledValue = isUncontrolledValueSet ? valueState : defaultValue;
    const setUncontrolledValue = (0, $acw62.useCallback)((newValue)=>{
        setValue(newValue);
        setIsUncontrolledValueSet(true);
    }, []);
    return isControlled ? [
        controlledValue,
        setControlledValue
    ] : [
        currentUncontrolledValue,
        setUncontrolledValue
    ];
}





var $1yiQH = parcelRequire("1yiQH");

class $fc537b925f715587$var$CustomEventStub {
    constructor(cancelable = false, detail = null){
        this.cancelable = cancelable;
        this.detail = detail;
        this.defaultPrevented = false;
        this.cancelBubble = false;
    }
    preventDefault() {
        this.defaultPrevented = true;
    }
    stopPropagation() {
        this.cancelBubble = true;
    }
}
function $fc537b925f715587$export$1dfc1997f02563ab({ cancelable: cancelable, detail: detail }) {
    return new $fc537b925f715587$var$CustomEventStub(cancelable, detail);
}
function $fc537b925f715587$export$e36a47fa496fb0d2(handler, detail) {
    if (!handler) return;
    const event = $fc537b925f715587$export$1dfc1997f02563ab({
        cancelable: false,
        detail: detail
    });
    handler(event);
}
function $fc537b925f715587$export$d7e1721720edbb03(handler, detail, sourceEvent) {
    if (!handler) return false;
    const event = $fc537b925f715587$export$1dfc1997f02563ab({
        cancelable: true,
        detail: detail
    });
    handler(event);
    if (event.defaultPrevented && sourceEvent) sourceEvent.preventDefault();
    if (event.cancelBubble && sourceEvent) sourceEvent.stopPropagation();
    return event.defaultPrevented;
}
function $fc537b925f715587$export$d23d807e6c464ee0(handler, reactEvent) {
    return $fc537b925f715587$export$d7e1721720edbb03(handler, {
        keyCode: reactEvent.keyCode,
        key: reactEvent.key,
        ctrlKey: reactEvent.ctrlKey,
        shiftKey: reactEvent.shiftKey,
        altKey: reactEvent.altKey,
        metaKey: reactEvent.metaKey,
        isComposing: reactEvent.nativeEvent.isComposing
    }, reactEvent);
}
const $fc537b925f715587$var$isMouseEvent = (e)=>{
    return e.button !== undefined;
};
function $fc537b925f715587$export$17ddd23cbcfe5784(event) {
    return event.ctrlKey || event.altKey || event.shiftKey || event.metaKey;
}
function $fc537b925f715587$export$aaf9a36dd84c3909(event) {
    return event && (!$fc537b925f715587$var$isMouseEvent(event) || event.button === 0) && !$fc537b925f715587$export$17ddd23cbcfe5784(event);
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The page height where the page is considered constrained.
 */ const $582c00c3ff10d4e2$export$221784c3b0ae64c0 = 400;
const $582c00c3ff10d4e2$export$bed14608432f307e = 250;
const $582c00c3ff10d4e2$export$99ee445a84ec4a0d = 40;
function $582c00c3ff10d4e2$export$9d9d5fcac617b082(position) {
    if (typeof document === 'undefined') return 0; // render the split panel in its minimum possible size
    return position === 'side' ? document.documentElement.clientWidth / 3 : document.documentElement.clientHeight / 2;
}
function $582c00c3ff10d4e2$export$2e85165fee4e4eeb(min, value, max) {
    if (min > max) return min;
    if (value < min) return min;
    if (value > max) return max;
    return value;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $6b9279bdd85bd752$export$2e2bcd8739ae039 = {
    "content-wrapper": "awsui_content-wrapper_zycdx_mfqbj_153",
    "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_mfqbj_157",
    "content-type-dashboard": "awsui_content-type-dashboard_zycdx_mfqbj_162"
};


const $22602bc147daf734$var$ContentWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, style: style, contentType: contentType, children: children, toolsPadding: toolsPadding, disablePaddings: disablePaddings, navigationPadding: navigationPadding, isMobile: isMobile, contentWidthStyles: contentWidthStyles }, ref)=>{
    if (disablePaddings) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        ref: ref,
        style: style
    }, children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6b9279bdd85bd752$export$2e2bcd8739ae039)['content-wrapper'], !navigationPadding && (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)['content-wrapper-no-navigation-padding'], !toolsPadding && (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)['content-wrapper-no-tools-padding'], isMobile && (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)['content-wrapper-mobile']),
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: contentWidthStyles,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)[`content-type-${contentType}`])
    }, children));
});
var $22602bc147daf734$export$2e2bcd8739ae039 = $22602bc147daf734$var$ContentWrapper;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $1yiQH = parcelRequire("1yiQH");
const $8856d0c7df08fd8d$var$contextMatch = /awsui-context-([\w-]+)/;
function $8856d0c7df08fd8d$export$c894375248ea16f2(elementRef) {
    const [value, setValue] = (0, $acw62.useState)('');
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        if (elementRef.current) {
            const contextParent = (0, $1yiQH.findUpUntil)(elementRef.current, (node)=>!!node.className.match($8856d0c7df08fd8d$var$contextMatch));
            setValue((_a = contextParent === null || contextParent === void 0 ? void 0 : contextParent.className.match($8856d0c7df08fd8d$var$contextMatch)[1]) !== null && _a !== void 0 ? _a : '');
        }
    }, [
        elementRef
    ]);
    return value;
}
function $8856d0c7df08fd8d$export$6c7ba3d6c6708d3(contextName) {
    return `awsui-context-${contextName}`;
}
function $8856d0c7df08fd8d$export$2e2bcd8739ae039({ contextName: contextName, className: className, children: children }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)($8856d0c7df08fd8d$export$6c7ba3d6c6708d3(contextName), className)
    }, children);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $ee5290ed0efb3c57$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($ee5290ed0efb3c57$exports, "__esModule", {
    value: true
});
$ee5290ed0efb3c57$exports.activateAnalyticsMetadata = $ee5290ed0efb3c57$exports.getAnalyticsLabelAttribute = $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute = $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute = void 0;
var $8191a32a301ce73d$exports = {};
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($8191a32a301ce73d$exports, "__esModule", {
    value: true
});
$8191a32a301ce73d$exports.getAnalyticsLabelAttribute = $8191a32a301ce73d$exports.copyAnalyticsMetadataAttribute = $8191a32a301ce73d$exports.getAnalyticsMetadataAttribute = $8191a32a301ce73d$exports.activateAnalyticsMetadata = $8191a32a301ce73d$exports.REFERRER_ATTRIBUTE = $8191a32a301ce73d$exports.REFERRER_DATA_ATTRIBUTE = $8191a32a301ce73d$exports.LABEL_DATA_ATTRIBUTE = $8191a32a301ce73d$exports.METADATA_ATTRIBUTE = $8191a32a301ce73d$exports.METADATA_DATA_ATTRIBUTE = void 0;

$8191a32a301ce73d$exports.METADATA_DATA_ATTRIBUTE = 'awsuiAnalytics';
$8191a32a301ce73d$exports.METADATA_ATTRIBUTE = 'data-awsui-analytics';
$8191a32a301ce73d$exports.LABEL_DATA_ATTRIBUTE = 'awsuiAnalyticsLabel';
$8191a32a301ce73d$exports.REFERRER_DATA_ATTRIBUTE = 'awsuiReferrerId';
$8191a32a301ce73d$exports.REFERRER_ATTRIBUTE = 'data-awsui-referrer-id';
const $8191a32a301ce73d$var$LABEL_ATTRIBUTE = 'data-awsui-analytics-label';
let $8191a32a301ce73d$var$activated = (0, $127791eee0e6430c$exports.getGlobalFlag)('analyticsMetadata');
const $8191a32a301ce73d$var$activateAnalyticsMetadata = (active)=>{
    $8191a32a301ce73d$var$activated = active;
};
$8191a32a301ce73d$exports.activateAnalyticsMetadata = $8191a32a301ce73d$var$activateAnalyticsMetadata;
const $8191a32a301ce73d$var$getAnalyticsMetadataAttribute = (metadata)=>$8191a32a301ce73d$var$activated ? {
        [$8191a32a301ce73d$exports.METADATA_ATTRIBUTE]: JSON.stringify(metadata)
    } : {};
$8191a32a301ce73d$exports.getAnalyticsMetadataAttribute = $8191a32a301ce73d$var$getAnalyticsMetadataAttribute;
const $8191a32a301ce73d$var$copyAnalyticsMetadataAttribute = (props)=>$8191a32a301ce73d$var$activated ? {
        [$8191a32a301ce73d$exports.METADATA_ATTRIBUTE]: props[$8191a32a301ce73d$exports.METADATA_ATTRIBUTE]
    } : {};
$8191a32a301ce73d$exports.copyAnalyticsMetadataAttribute = $8191a32a301ce73d$var$copyAnalyticsMetadataAttribute;
const $8191a32a301ce73d$var$getAnalyticsLabelAttribute = (labelIdentifierString)=>$8191a32a301ce73d$var$activated ? {
        [$8191a32a301ce73d$var$LABEL_ATTRIBUTE]: labelIdentifierString
    } : {};
$8191a32a301ce73d$exports.getAnalyticsLabelAttribute = $8191a32a301ce73d$var$getAnalyticsLabelAttribute;


Object.defineProperty($ee5290ed0efb3c57$exports, "getAnalyticsMetadataAttribute", {
    enumerable: true,
    get: function() {
        return $8191a32a301ce73d$exports.getAnalyticsMetadataAttribute;
    }
});
Object.defineProperty($ee5290ed0efb3c57$exports, "copyAnalyticsMetadataAttribute", {
    enumerable: true,
    get: function() {
        return $8191a32a301ce73d$exports.copyAnalyticsMetadataAttribute;
    }
});
Object.defineProperty($ee5290ed0efb3c57$exports, "getAnalyticsLabelAttribute", {
    enumerable: true,
    get: function() {
        return $8191a32a301ce73d$exports.getAnalyticsLabelAttribute;
    }
});
Object.defineProperty($ee5290ed0efb3c57$exports, "activateAnalyticsMetadata", {
    enumerable: true,
    get: function() {
        return $8191a32a301ce73d$exports.activateAnalyticsMetadata;
    }
});



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $8d972b37456b0691$var$icons = {
    "add-plus": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2.01 8h12M8 14l.01-12"
    })),
    "anchor-link": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 8h6M7 12H5c-2.21 0-4-1.79-4-4s1.79-4 4-4h2M9 12h2c2.21 0 4-1.79 4-4s-1.79-4-4-4H9",
        className: "stroke-linejoin-round"
    })),
    "angle-down": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m2 5 6 6 6-6",
        className: "stroke-linejoin-round"
    })),
    "angle-left-double": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 2 2 8l6 6",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 2 7 8l6 6",
        className: "stroke-linejoin-round"
    })),
    "angle-left": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 2 5 8l6 6",
        className: "stroke-linejoin-round"
    })),
    "angle-right-double": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 2 6 6-6 6",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m3 2 6 6-6 6",
        className: "stroke-linejoin-round"
    })),
    "angle-right": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m5 2 6 6-6 6",
        className: "stroke-linejoin-round"
    })),
    "angle-up": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m2 11 6-6 6 6",
        className: "stroke-linejoin-round"
    })),
    "arrow-down": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m3 9 5 5 5-5M8 14V1",
        className: "stroke-linejoin-round"
    })),
    "arrow-left": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 3 2 8l5 5M2 8h13",
        className: "stroke-linejoin-round"
    })),
    "arrow-right": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m9 3 5 5-5 5M14 8H1",
        className: "stroke-linejoin-round"
    })),
    "arrow-up": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 7 8 2 3 7M8 2v13",
        className: "stroke-linejoin-round"
    })),
    "at-symbol": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9.5 13.75c-1.992.734-6.434 1.013-7.5-3.25-1-4 1.927-6.904 3.697-7.848 1.841-.982 5.523-1.48 7.34.944 1.888 2.516.63 6.29-.628 6.92-1.259.628-1.95.25-2.202 0a.902.902 0 0 1-.145-.191c-.258-.45-.12-1.01-.022-1.52l.678-3.518",
        className: "stroke-linecap-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.718 6.643c-.315-.42-1.254-1.357-2.26-1.357-1.258 0-2.654 1.14-2.969 3.027-.314 1.888.63 2.643 1.573 2.643s2.202-.44 2.83-1.384"
    })),
    "audio-full": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6.47 13.707 4 10.997H1v-6h3l2.47-2.71c.54-.59 1.53-.21 1.53.59v10.23c0 .8-.99 1.19-1.53.59v.01Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 12.997c2.76 0 5-2.24 5-5s-2.24-5-5-5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 9.997c1.1 0 2-.9 2-2s-.9-2-2-2"
    })),
    "audio-half": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.47 13.41 5 10.7H2v-6h3l2.47-2.71C8.01 1.4 9 1.78 9 2.58v10.23c0 .8-.99 1.19-1.53.59v.01Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 9.71c1.1 0 2-.9 2-2s-.9-2-2-2"
    })),
    "audio-off": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6.47 13.41 4 10.7H1v-6h3l2.47-2.71C7.01 1.4 8 1.78 8 2.58v10.23c0 .8-.99 1.19-1.53.59v.01ZM11 5.71l3.99 4M15 5.71 11 9.7",
        className: "stroke-linejoin-round"
    })),
    "backward-10-seconds": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5.95 14.01h-.96c-.56 0-1.02-.46-1.02-1.02v-2.96c0-.56.45-1.01 1.01-1.02h.96c.56 0 1.02.45 1.02 1.02v2.96c0 .56-.46 1.02-1.02 1.02h.01Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 9v5",
        className: "stroke-linecap-square"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 0v5h5",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9.976 15A7.154 7.154 0 0 0 15 8.164C15 4.204 11.804 1 7.852 1A7.148 7.148 0 0 0 1.5 4.875",
        className: "stroke-linejoin-round"
    })),
    "bug": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 5.71a4 4 0 0 0-8 0v4a4 4 0 1 0 8 0v-4ZM15 8.71h-3M4 8.71H1M12 6H4M15 3.63l-3 2.08M15 13.78l-3-2.07M1 3.63l3 2.08M1 13.78l3-2.07"
    })),
    "calendar": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 2H2v12h12V2Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 6V4h2v2H4ZM7 6V4h2v2H7ZM10 6V4h2v2h-2ZM4 9V7h2v2H4ZM7 9V7h2v2H7ZM4 12v-2h2v2H4ZM7 12v-2h2v2H7ZM10 9V7h2v2h-2Z",
        className: "filled no-stroke"
    })),
    "call": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.99 7.083c0-2.76-2.24-5-5-5M11.07 10.002c-.6.58-1.55.61-2.14.02l-2.88-2.88a1.49 1.49 0 0 1 0-2.12c.52-.52.52-1.36 0-1.88l-.85-.85a.996.996 0 0 0-1.41 0l-.38.38a4.83 4.83 0 0 0 0 6.82l3.17 3.17a4.83 4.83 0 0 0 6.82 0l.38-.38a.996.996 0 0 0 0-1.41l-.85-.85c-.51-.51-1.34-.52-1.86-.02Z",
        className: "stroke-linejoin-round"
    })),
    "caret-down-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 11 4-6H4l4 6Z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-down": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 11 4-6H4l4 6Z",
        className: "stroke-linejoin-round"
    })),
    "caret-left-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m5 8 6 4V4L5 8Z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-right-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m11 8-6 4V4l6 4Z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-up-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 5 4 6H4l4-6Z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-up": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 5 4 6H4l4-6Z",
        className: "stroke-linejoin-round"
    })),
    "check": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 9 4 4L15 2",
        className: "stroke-linejoin-round"
    })),
    "close": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m2 1.71 12 12M2 13.71l12-12",
        className: "stroke-linejoin-round"
    })),
    "closed-caption-unavailable": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 1H1v14h14V1Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.51 10H5c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99h1.01M13 10h-2.51c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99H13M1 1l14 14",
        className: "stroke-linejoin-round"
    })),
    "closed-caption": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 1H1v14h14V1Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.51 10H5c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99h2.51M13 10h-2.51c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99H13",
        className: "stroke-linejoin-round"
    })),
    "command-prompt": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 1H1v14h14V1ZM12 11H9",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.71 11.3 8 8 4.71 4.71",
        className: "stroke-linejoin-round"
    })),
    "contact": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h4v3l4-3h4Z",
        className: "stroke-linejoin-round"
    })),
    "copy": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 5H5v10h10V5Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 1H1v11",
        className: "stroke-linejoin-round"
    })),
    "delete-marker": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 7V1h6l4 4v10h-3",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v5h5M2 15l6-6M2 9.01l6.01 6",
        className: "stroke-linejoin-round"
    })),
    "download": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 15h14M13 6l-5 5-5-5M8 10V1",
        className: "stroke-linejoin-round"
    })),
    "drag-indicator": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "5.5",
        cy: "2.5",
        r: "1.5",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "5.5",
        cy: "13.5",
        r: "1.5",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "5.5",
        cy: "8",
        r: "1.5",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "10.5",
        cy: "2.5",
        r: "1.5",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "10.5",
        cy: "13.5",
        r: "1.5",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "10.5",
        cy: "8",
        r: "1.5",
        className: "filled no-stroke"
    })),
    "edit-gen-ai": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m5.19 12.275-4.19.7.7-4.19 7.2-7.2c.78-.78 2.05-.78 2.83 0l.66.66c.78.78.78 2.05 0 2.83l-1.865 1.85M10.99 5.975l-3-3",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m13.888 12.329-2.296-.921-.924-2.303c-.056-.14-.28-.14-.336 0l-.924 2.303-2.296.921S7 12.427 7 12.496c0 .07.042.14.112.168l.07.028 2.226.893.924 2.303s.098.112.168.112.14-.042.168-.112l.924-2.303 2.296-.921s.112-.098.112-.168-.042-.14-.112-.167Z",
        className: "filled no-stroke"
    })),
    "edit": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m6.19 13.275-4.19.7.7-4.19 7.2-7.2c.78-.78 2.05-.78 2.83 0l.66.66c.78.78.78 2.05 0 2.83l-7.2 7.2ZM9 3.995l3 3",
        className: "stroke-linejoin-round"
    })),
    "ellipsis": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "2.5",
        r: "1.5",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "13.5",
        r: "1.5",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "1.5",
        className: "filled no-stroke"
    })),
    "envelope": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 3 7 6 7-6",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 3H1v10h14V3Z",
        className: "stroke-linejoin-round"
    })),
    "exit-full-screen": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 10.01h5V15M10 15v-5h5M6 1v5H1M15 6h-5V1",
        className: "stroke-linejoin-round"
    })),
    "expand": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 7V2H9M10 6l4-4M6.99 14H2V9M6 10l-4 4M9 14h5V9M10 10l4 4M2 6.99V2h5M6 6 2 2",
        className: "stroke-linejoin-round"
    })),
    "external": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 9.012v-6H7M13.02 3 7 9.01M3 5.012v8h8.01",
        className: "stroke-linejoin-round"
    })),
    "face-happy-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.995 1.103a6.887 6.887 0 0 0-6.892 6.892 6.887 6.887 0 0 0 6.892 6.892 6.887 6.887 0 0 0 6.892-6.892 6.887 6.887 0 0 0-6.892-6.892Zm-2.002 7.61A2.148 2.148 0 0 0 8 10.134c.914 0 1.706-.592 2.007-1.423l1.646.596c-.54 1.489-1.966 2.577-3.653 2.577-1.686 0-3.114-1.088-3.653-2.577l1.646-.596ZM7.148 6.03a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm3.95 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 .5A7.495 7.495 0 0 0 .5 8c0 4.146 3.354 7.5 7.5 7.5s7.5-3.354 7.5-7.5S12.146.5 8 .5Zm0 1.559c3.61 0 6.008 2.566 6.008 5.941 0 2.404-2.044 6.014-6.008 6.014-3.818 0-6.01-2.9-6.01-6.014 0-2.603 1.712-5.941 6.01-5.941Z",
        className: "filled no-stroke"
    })),
    "face-happy": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.01 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.83 9.01c-.42 1.16-1.53 2-2.83 2s-2.41-.84-2.83-2",
        className: "stroke-linejoin-round"
    })),
    "face-neutral-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.995 1.103a6.887 6.887 0 0 0-6.892 6.892 6.887 6.887 0 0 0 6.892 6.892 6.887 6.887 0 0 0 6.892-6.892 6.887 6.887 0 0 0-6.892-6.892ZM11 10.875H5v-1.75h6v1.75ZM7.148 6.03a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm3.95 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 .5A7.495 7.495 0 0 0 .5 8c0 4.146 3.354 7.5 7.5 7.5s7.5-3.354 7.5-7.5S12.146.5 8 .5Zm0 1.559c3.61 0 6.008 2.566 6.008 5.941 0 2.404-2.044 6.014-6.008 6.014-3.818 0-6.01-2.9-6.01-6.014 0-2.603 1.712-5.941 6.01-5.941Z",
        className: "filled no-stroke"
    })),
    "face-neutral": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.01 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 10h6",
        className: "stroke-linejoin-round"
    })),
    "face-sad-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.995 1.103a6.887 6.887 0 0 0-6.892 6.892 6.887 6.887 0 0 0 6.892 6.892 6.887 6.887 0 0 0 6.892-6.892 6.887 6.887 0 0 0-6.892-6.892Zm-3.648 9.6C4.887 9.212 6.314 8.124 8 8.124c1.687 0 3.114 1.088 3.653 2.577l-1.646.596A2.148 2.148 0 0 0 8 9.875c-.913 0-1.706.592-2.007 1.423l-1.646-.596ZM7.148 6.03a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm3.95 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 .5A7.495 7.495 0 0 0 .5 8c0 4.146 3.354 7.5 7.5 7.5s7.5-3.354 7.5-7.5S12.146.5 8 .5Zm0 1.559c3.61 0 6.008 2.566 6.008 5.941 0 2.404-2.044 6.014-6.008 6.014-3.818 0-6.01-2.9-6.01-6.014 0-2.603 1.712-5.941 6.01-5.941Z",
        className: "filled no-stroke"
    })),
    "face-sad": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.01 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.83 11C10.41 9.84 9.3 9 8 9s-2.41.84-2.83 2",
        className: "stroke-linejoin-round"
    })),
    "file-open": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 15H3V1h6l4 4v10Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v5h5M3 8l7 7",
        className: "stroke-linejoin-round"
    })),
    "file": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 15H3V1h6l4 4v10Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v5h5",
        className: "stroke-linejoin-round"
    })),
    "filter": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 3 5 5v7l4-2V8l5-5V1H1v2Z",
        className: "stroke-linejoin-round"
    })),
    "flag": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1.99 16V1M2 2.14c4 2.71 8-2.99 12-.28v7.28c-4-2.89-8 2.61-12-.28",
        className: "stroke-linejoin-round"
    })),
    "folder-open": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 14h8l-3-7H1l2 7h3Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 7V2h6l1 2h5c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1h-1",
        className: "stroke-linejoin-round"
    })),
    "folder": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 5v9H2V2h6l1 2h5c.55 0 1 .45 1 1Z",
        className: "stroke-linejoin-round"
    })),
    "forward-10-seconds": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.95 14.01h-.96c-.56 0-1.02-.46-1.02-1.02v-2.96c0-.56.45-1.01 1.01-1.02h.96c.56 0 1.02.45 1.02 1.02v2.96c0 .56-.46 1.02-1.02 1.02h.01Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 9v5",
        className: "stroke-linecap-square"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 0v5h-5",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6.024 15A7.154 7.154 0 0 1 1 8.164C1 4.204 4.196 1 8.148 1A7.148 7.148 0 0 1 14.5 4.875",
        className: "stroke-linejoin-round"
    })),
    "full-screen": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 15H1v-5M15 10v5h-5M1 6V1h5M10 1h5v5",
        className: "stroke-linejoin-round"
    })),
    "gen-ai": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6.15 10.365 8 15.005l1.86-4.64 4.64-1.86-4.64-1.85L8 2.005l-1.85 4.65-4.65 1.85 4.65 1.86Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2.38 4.915c.02.05.07.08.12.08.05 0 .12-.08.12-.08l.66-1.64 1.64-.66a.13.13 0 0 0 .08-.12c0-.05-.08-.12-.08-.12l-1.64-.66-.66-1.64c-.04-.1-.2-.1-.24 0l-.66 1.64-1.64.66a.13.13 0 0 0-.08.12c0 .05.08.12.08.12l1.64.66.66 1.64Z",
        className: "filled no-stroke"
    })),
    "globe": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 15c1.657 0 3-3.134 3-7S9.657 1 8 1 5 4.134 5 8s1.343 7 3 7ZM1 8h14",
        className: "stroke-linejoin-round"
    })),
    "grid-view": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 10H2v4h4v-4ZM14 10h-4v4h4v-4ZM6 2H2v4h4V2ZM14 2h-4v4h4V2Z",
        className: "stroke-linejoin-round"
    })),
    "group-active": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "7",
        r: "3",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "4.25",
        cy: "4.25",
        r: "2.75",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 14a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v2H6v-2Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.126 8H3a3 3 0 0 0-3 3v3h5a4 4 0 0 1 3.405-3.956A4 4 0 0 1 7.126 8Z",
        className: "filled no-stroke"
    })),
    "group": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 16v-2a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11.25",
        cy: "6.75",
        r: "2.25"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6.254 8.99H3a2.005 2.005 0 0 0-2.005 2.005v2h.01v-2C1.005 9.893 1.898 9 3 9h3.261a8.678 8.678 0 0 1-.007-.01Z",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "4.25",
        cy: "4.25",
        r: "2.25"
    })),
    "heart-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.49 3.546C12.124 2.31 10.312 2.689 9 4L8 5 7 4c-1.301-1.302-3.114-1.69-4.491-.454a3.409 3.409 0 0 0-.133 4.95L7.952 14s.067.028.086 0l5.576-5.505a3.409 3.409 0 0 0-.133-4.95h.01Z",
        className: "filled stroke-linejoin-round"
    })),
    "heart": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.752 2.873c-1.44-1.3-3.7-1.1-5.08.28l-.7.7-.7-.7c-1.37-1.37-3.63-1.58-5.08-.28a3.588 3.588 0 0 0-.14 5.21l5.87 5.87s.07.03.09 0l5.87-5.87a3.588 3.588 0 0 0-.14-5.21h.01Z",
        className: "stroke-linejoin-round"
    })),
    "history": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 0v5l5-.04",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 8c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7C5.21 1 2.8 2.63 1.67 5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 4v5H5",
        className: "stroke-linejoin-round"
    })),
    "insert-row": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 11H1V2h14v4M12 7v8M8 11h8",
        className: "stroke-linejoin-round"
    })),
    "key": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 1a5.002 5.002 0 0 0-4.6 6.96L1 12.36v2.65h4v-2h3v-2.42c.61.27 1.29.42 2 .42 2.76 0 5-2.24 5-5s-2.24-5-5-5V1Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
        className: "filled no-stroke"
    })),
    "keyboard": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 2H1v12h14V2ZM4 11h8M4 8h2M4 5h2M7 8h2M7 5h2M10 8h2M10 5h2"
    })),
    "list-view": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 3h10M5 8h10M5 13h10"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2.01 3.01H2V3h.01v.01ZM2.01 8.01H2V8h.01v.01ZM2.01 13.01H2V13h.01v.01Z",
        className: "filled"
    })),
    "location-pin": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12.01 9c.63-.83 1-1.87 1-3 0-2.76-2.24-5-5-5a5.002 5.002 0 0 0-4 8l4 6 4-6Z",
        className: "stroke-linejoin-round"
    })),
    "lock-private": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 7H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1ZM5 7V4c0-1.65 1.35-3 3-3s3 1.35 3 3v3",
        className: "stroke-linejoin-round"
    })),
    "map": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 12.8V2l3.61 1.21V14L2 12.8ZM10.4 12.8V2L14 3.05V14l-3.6-1.2ZM5.61 14l4.79-1.2M5.61 3.21 10.4 2",
        className: "stroke-linejoin-round"
    })),
    "menu": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 3H1M15 8H1M15 13H1",
        className: "stroke-linejoin-round"
    })),
    "microphone-off": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15.01h10M8 15v-3"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6.6 8.43c.36.36.86.59 1.41.59 1.1 0 2-.9 2-2v-2L6.6 8.43Z",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 7.01c0 2.76-2.24 5-5 5-1.28 0-2.45-.48-3.33-1.28M3 12.01l10-10"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8.01 1.01c-1.1 0-2 .9-2 2v1.67l3.23-3.23c-.34-.27-.77-.44-1.23-.44Z",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3.01 7.01c0 .482-.162 1.263.33 1.75"
    })),
    "microphone": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10M8 15v-3M10 3a2 2 0 1 0-4 0v4a2 2 0 1 0 4 0V3Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 7c0 2.76-2.24 5-5 5S3 9.76 3 7",
        className: "stroke-linejoin-round"
    })),
    "mini-player": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 10.01H8v4h6v-4Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 14H2V2h12v5",
        className: "stroke-linejoin-round"
    })),
    "multiscreen": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 5H5v7h10V5Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 3V1.01L1.01 1 1 8h1.998M10 12v3M7 15h6",
        className: "stroke-linejoin-round"
    })),
    "notification": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 12H2c-.39 0-.63-.44-.41-.76L4 8V5c0-2.21 1.79-4 4-4s4 1.79 4 4v3l2.41 3.24c.22.33-.02.76-.41.76ZM6 13c0 1.1.9 2 2 2s2-.9 2-2",
        className: "stroke-linejoin-round"
    })),
    "pause": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 2v12M11 2v12",
        className: "stroke-linejoin-round"
    })),
    "play": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m4 13.03 8-5-8-5v10Z",
        className: "stroke-linejoin-round filled"
    })),
    "redo": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m11 2 4 4-4 4",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 6H5.5C3.01 6 1 8.01 1 10.5S3.01 15 5.5 15H8",
        className: "stroke-linejoin-round"
    })),
    "refresh": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 0v5l-5-.04",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 8c0 3.87-3.13 7-7 7s-7-3.13-7-7 3.13-7 7-7c2.79 0 5.2 1.63 6.33 4"
    })),
    "remove": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 5h14M13 5l-1 10H4L3 5M5 5V2h6v3",
        className: "stroke-linejoin-round"
    })),
    "resize-area": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 4 4 14M10 14l4-4",
        className: "stroke-linejoin-round"
    })),
    "script": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 4 1 8l4 4M11 4l4 4-4 4",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 13 9 3"
    })),
    "search-gen-ai": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12.332 6.888c.028.07.098.112.168.112s.168-.112.168-.112l.924-2.298 2.296-.925A.182.182 0 0 0 16 3.497c0-.07-.112-.169-.112-.169l-2.296-.925-.924-2.298c-.056-.14-.28-.14-.336 0l-.924 2.298-2.296.925A.182.182 0 0 0 9 3.497c0 .07.112.168.112.168l2.296.925.924 2.298Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m11 11.005 4 4M11.9 8a5.002 5.002 0 1 1-8.36-4.605A4.996 4.996 0 0 1 8 2.105",
        className: "stroke-linejoin-round"
    })),
    "search": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m11 11 4 4M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10Z",
        className: "stroke-linejoin-round"
    })),
    "security": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1C6.29 2.53 4.13 3.32 2 3.48v3.48c0 2.05.76 3.88 1.71 5.14.92 1.22 2.32 2.21 4.29 2.9 1.97-.69 3.37-1.68 4.29-2.9A8.684 8.684 0 0 0 14 6.96V3.48C11.87 3.32 9.71 2.52 8 1Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 4v5M8 10v2"
    })),
    "send": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 1 14 6.92L1 15l3-7-3-7ZM4 8h11",
        className: "stroke-linejoin-round"
    })),
    "settings": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6.11 1.729c.07-.42.44-.729.86-.729h2.02c.43 0 .79.31.86.729l.17.999c.05.29.24.529.5.679.06.03.11.06.17.1.25.15.56.2.84.1l.95-.35c.4-.15.85 0 1.07.38l1.01 1.747c.21.37.13.839-.2 1.108l-.78.64c-.23.189-.34.479-.33.768v.2c0 .29.11.579.33.769l.78.639c.33.27.42.739.2 1.108l-1.01 1.748c-.21.37-.66.529-1.06.38l-.95-.35a.966.966 0 0 0-.84.1c-.06.03-.11.07-.17.1-.26.14-.45.389-.5.679l-.17.998A.878.878 0 0 1 9 15H6.98a.87.87 0 0 1-.86-.729l-.17-.998a.988.988 0 0 0-.5-.68c-.06-.03-.11-.06-.17-.1a.996.996 0 0 0-.84-.1l-.95.35c-.4.15-.85 0-1.06-.38l-1.01-1.747a.873.873 0 0 1 .2-1.108l.78-.64c.23-.189.34-.479.33-.768v-.2c0-.3-.11-.579-.33-.769l-.78-.639a.861.861 0 0 1-.2-1.108l1.01-1.748c.21-.37.66-.529 1.07-.38l.95.35c.28.1.58.06.84-.1.06-.03.11-.07.17-.1.26-.14.45-.379.5-.678l.15-1Z",
        className: "stroke-linecap-round stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 8c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z",
        className: "stroke-linecap-round stroke-linejoin-round"
    })),
    "share": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3.5 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM12.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM12.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM10.326 4.7 5.678 7.293M10.223 11.483l-4.448-1.96"
    })),
    "shrink": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 1v5h5M10.71 5.29 15 1M1 10h5v5M5.3 10.7 1 15",
        className: "stroke-linejoin-round"
    })),
    "slash": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m10 4.5-4 7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "1",
        y: "1",
        width: "14",
        height: "14",
        rx: "1"
    })),
    "star-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 1 2.16 4.38 4.84.71-3.5 3.41.83 4.81L8 12.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z",
        className: "filled stroke-linejoin-round"
    })),
    "star-half": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v11.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 1 2.16 4.38 4.84.71-3.5 3.41.83 4.81L8 12.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z",
        className: "stroke-linejoin-round"
    })),
    "star": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 1 2.16 4.38 4.84.71-3.5 3.41.83 4.81L8 12.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z",
        className: "stroke-linejoin-round"
    })),
    "status-in-progress": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 7H7v2h2V7ZM6 7H4v2h2V7ZM12 7h-2v2h2V7Z",
        className: "filled no-stroke"
    })),
    "status-info": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 12V7M8 6V4"
    })),
    "status-negative": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m5.5 5.5 5 5M10.5 5.5l-5 5"
    })),
    "status-not-started": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    })),
    "status-pending": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 4v5H4",
        className: "stroke-linejoin-round"
    })),
    "status-positive": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.5 7.5 7 10l4-5",
        className: "stroke-linejoin-round"
    })),
    "status-stopped": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 8h6"
    })),
    "status-warning": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 5v4M8 10v2M6.52 1.88l-5.33 9.76c-.13.23-.19.5-.19.76 0 .88.71 1.59 1.59 1.59H13.4c.88 0 1.59-.71 1.59-1.59 0-.27-.07-.53-.19-.76L9.48 1.88C9.18 1.34 8.62 1 8 1s-1.18.34-1.48.88Z",
        className: "stroke-linejoin-round"
    })),
    "stop-circle": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "5",
        y: "5",
        width: "6",
        height: "6",
        rx: ".5",
        className: "filled no-stroke"
    })),
    "subtract-minus": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 8h12",
        className: "stroke-linejoin-round"
    })),
    "suggestions-gen-ai": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m15.888 3.329-2.296-.921-.924-2.303c-.056-.14-.28-.14-.336 0l-.924 2.303-2.296.921S9 3.427 9 3.497s.042.14.112.167l.07.028 2.226.893.924 2.303S12.43 7 12.5 7s.14-.042.168-.112l.924-2.303 2.296-.921S16 3.566 16 3.497c0-.07-.042-.14-.112-.168Z",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12.348 8.45a5.09 5.09 0 0 1-1.358 1.53L10 15H6l-.99-5.02C3.8 9.07 3 7.63 3 6c0-2.76 2.24-5 5-5M10.5 12.005h-5",
        className: "stroke-linejoin-round"
    })),
    "suggestions": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8.12 15h-2l-.99-5.02C3.92 9.07 3.12 7.63 3.12 6c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.07-2.01 3.98L10.12 15h-2ZM11.12 12h-6",
        className: "stroke-linejoin-round"
    })),
    "support": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5.75 6.338c.13-1.178.811-2.339 2.37-2.339 1.472 0 2.435 1.312 2.042 2.468-.215.633-.916 1.132-1.385 1.578C8.162 8.631 8 9.2 8 10"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 12.01h.01V12H8v.01Z",
        className: "filled"
    })),
    "thumbs-down-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 1h2.01v9H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1Zm14.14 6.22-1.69-5.03C13.21 1.48 12.54 1 11.79 1H4.01v9l3.23 3.88c.6.72 1.77.29 1.77-.64V9h4.86c.92 0 1.57-.91 1.28-1.78h-.01Z",
        className: "filled no-stroke"
    })),
    "thumbs-down": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 13.13V9h4.12c.6 0 1.02-.59.83-1.16l-1.6-4.77A1.58 1.58 0 0 0 10.86 2H1v8h4l2.41 3.61c.48.72 1.59.38 1.59-.48ZM5 2v8",
        className: "stroke-linejoin-round"
    })),
    "thumbs-up-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15.001H1c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h2v9Zm10.86-8H9v-4.24c0-.93-1.17-1.36-1.77-.64L4 6.001v9h7.78c.75 0 1.42-.48 1.66-1.19l1.69-5.03c.29-.87-.36-1.78-1.28-1.78h.01Z",
        className: "filled no-stroke"
    })),
    "thumbs-up": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 2.871v4.13h4.12c.6 0 1.02.59.83 1.16l-1.6 4.77a1.58 1.58 0 0 1-1.49 1.07H1v-8h4l2.41-3.61c.48-.72 1.59-.38 1.59.48ZM5 14.001v-8",
        className: "stroke-linejoin-round"
    })),
    "ticket": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13 8c0-1.1.9-2 2-2V3H1v3c1.1 0 2 .9 2 2s-.9 2-2 2v3h14v-3c-1.1 0-2-.9-2-2Z",
        className: "stroke-linejoin-round"
    })),
    "transcript": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 1H1v14h14V1ZM9 10H4M12 6H4",
        className: "stroke-linejoin-round"
    })),
    "treeview-collapse": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 2H2v12h12V2ZM5 8h6",
        className: "stroke-linejoin-round"
    })),
    "treeview-expand": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 2H2v12h12V2ZM8 5v6M5 8h6",
        className: "stroke-linejoin-round"
    })),
    "undo": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 2 1 6l4 4",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 6h8.5c2.49 0 4.5 2.01 4.5 4.5S12.99 15 10.5 15H8",
        className: "stroke-linejoin-round"
    })),
    "unlocked": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 7H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1ZM9 7V4c0-1.65 1.35-3 3-3s3 1.35 3 3",
        className: "stroke-linejoin-round"
    })),
    "upload-download": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m7 7-3 3-3-3M4 9V1M15 9l-3-3-3 3M12 7v8M0 14h8M8 2h8",
        className: "stroke-linejoin-round"
    })),
    "upload": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 1h14M13 10 8 5l-5 5M8 6v9",
        className: "stroke-linejoin-round"
    })),
    "user-profile-active": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 6a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5ZM2 15.5v-3c0-1.66 1.34-3 3-3h6c1.66 0 3 1.34 3 3v3",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 15.5v-3c0-1.66 1.34-3 3-3h6c1.66 0 3 1.34 3 3v3",
        className: "stroke-linejoin-round"
    })),
    "user-profile": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 7c1.66 0 3-1.34 3-3S9.66 1 8 1 5 2.34 5 4s1.34 3 3 3Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 16v-3c0-1.66 1.34-3 3-3h6c1.66 0 3 1.34 3 3v3",
        className: "stroke-linejoin-round"
    })),
    "video-camera-off": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 6V3H1v9.97h10V9.98L15 13V3.04L11 6ZM4 6l4 4M8 6.01 4 10",
        className: "stroke-linejoin-round"
    })),
    "video-camera-on": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 6V3H1v9.97L11 13v-3l4 3V3.04L11 6Z",
        className: "stroke-linejoin-round"
    })),
    "video-camera-unavailable": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 5.99V3H1v9.97h10V9.98L15 13V3.04l-4 2.95ZM4 8h4",
        className: "stroke-linejoin-round"
    })),
    "video-off": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "7",
        r: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10M8 15v-3M6.01 5.01 10 9M10 5 6 9",
        className: "stroke-linejoin-round"
    })),
    "video-on": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "7",
        r: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "7",
        r: "2",
        className: "filled no-stroke"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10M8 15v-3"
    })),
    "video-unavailable": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "7",
        r: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10M6 7h4M8 15v-3"
    })),
    "view-full": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 1H1v14h14V1Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.5 4h-7a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z",
        className: "filled no-stroke"
    })),
    "view-horizontal": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 15V1H1v14h14Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.5 7h-7a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Z",
        className: "filled no-stroke"
    })),
    "view-vertical": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 1H1v14h14V1Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.5 4h-4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z",
        className: "filled no-stroke"
    })),
    "zoom-in": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "7",
        cy: "7",
        r: "6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m11 11 4 4M7 4v6M4 7l6 .01"
    })),
    "zoom-out": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m11 11 4 4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "7",
        cy: "7",
        r: "6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m4 7 6 .01"
    })),
    "zoom-to-fit": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 5H5v6h6V5ZM6 1H1v5M10 1h5v5M6 15H1v-5M10 15h5v-5",
        className: "stroke-linejoin-round"
    }))
};
var $8d972b37456b0691$export$2e2bcd8739ae039 = $8d972b37456b0691$var$icons;


const $1f45c04519109e02$export$243ba0f53027507e = (0, $acw62.createContext)((0, $8d972b37456b0691$export$2e2bcd8739ae039));




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $c4349d15e19ce67a$export$914c7e68e6e8031e(rest, nativeAttributes, componentName, skipWarnings) {
    return Object.entries(nativeAttributes || {}).reduce((acc, [key, value])=>{
        // concatenate className
        if (key === 'className') acc[key] = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(rest.className, value);
        else if (key === 'style') acc[key] = {
            ...rest.style,
            ...value
        };
        else if (key.match(/^on[A-Z]/) && typeof value === 'function' && key in rest) acc[key] = (event)=>{
            value(event);
            if (!event.defaultPrevented) rest[key](event);
        };
        else {
            if (key in rest && (!skipWarnings || skipWarnings !== true && !skipWarnings.includes(key))) (0, $013a2451794a45c0$exports.warnOnce)(componentName, `Overriding native attribute [${key}] which has a Cloudscape-provided value`);
            acc[key] = value;
        }
        return acc;
    }, {
        ...rest
    });
}
var $c4349d15e19ce67a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ tag: tag, nativeAttributes: nativeAttributes, children: children, skipWarnings: skipWarnings, componentName: componentName, ...rest }, ref)=>{
    const Tag = tag;
    const processedAttributes = $c4349d15e19ce67a$export$914c7e68e6e8031e(rest, nativeAttributes, componentName, skipWarnings);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ...processedAttributes,
        ref: ref
    }, children);
});



var $ac283450f3f763d1$export$2e2bcd8739ae039 = {
    "icon": "awsui_icon_h11ix_y1ugs_189",
    "icon-flex-height": "awsui_icon-flex-height_h11ix_y1ugs_197",
    "size-small": "awsui_size-small_h11ix_y1ugs_225",
    "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_y1ugs_229",
    "size-normal": "awsui_size-normal_h11ix_y1ugs_244",
    "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_y1ugs_248",
    "size-medium": "awsui_size-medium_h11ix_y1ugs_263",
    "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_y1ugs_267",
    "size-big": "awsui_size-big_h11ix_y1ugs_282",
    "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_y1ugs_286",
    "size-large": "awsui_size-large_h11ix_y1ugs_301",
    "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_y1ugs_305",
    "variant-normal": "awsui_variant-normal_h11ix_y1ugs_320",
    "variant-disabled": "awsui_variant-disabled_h11ix_y1ugs_323",
    "variant-inverted": "awsui_variant-inverted_h11ix_y1ugs_326",
    "variant-subtle": "awsui_variant-subtle_h11ix_y1ugs_329",
    "variant-warning": "awsui_variant-warning_h11ix_y1ugs_332",
    "variant-error": "awsui_variant-error_h11ix_y1ugs_335",
    "variant-success": "awsui_variant-success_h11ix_y1ugs_338",
    "variant-link": "awsui_variant-link_h11ix_y1ugs_341",
    "name-angle-left-double": "awsui_name-angle-left-double_h11ix_y1ugs_344",
    "name-angle-left": "awsui_name-angle-left_h11ix_y1ugs_344",
    "name-angle-right-double": "awsui_name-angle-right-double_h11ix_y1ugs_346",
    "name-angle-right": "awsui_name-angle-right_h11ix_y1ugs_346",
    "name-arrow-left": "awsui_name-arrow-left_h11ix_y1ugs_348",
    "name-arrow-right": "awsui_name-arrow-right_h11ix_y1ugs_349",
    "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_y1ugs_350",
    "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_y1ugs_351",
    "name-audio-full": "awsui_name-audio-full_h11ix_y1ugs_352",
    "name-audio-half": "awsui_name-audio-half_h11ix_y1ugs_353",
    "name-audio-off": "awsui_name-audio-off_h11ix_y1ugs_354",
    "name-external": "awsui_name-external_h11ix_y1ugs_355",
    "name-redo": "awsui_name-redo_h11ix_y1ugs_356",
    "name-resize-area": "awsui_name-resize-area_h11ix_y1ugs_357",
    "name-send": "awsui_name-send_h11ix_y1ugs_358",
    "name-shrink": "awsui_name-shrink_h11ix_y1ugs_359",
    "name-undo": "awsui_name-undo_h11ix_y1ugs_360",
    "name-view-vertical": "awsui_name-view-vertical_h11ix_y1ugs_361",
    "badge": "awsui_badge_h11ix_y1ugs_385"
};


function $4ede5ec7997eb329$var$iconSizeMap(height, fontSize) {
    if (height === null) // This is the best guess for the contextual height while server rendering.
    return 'normal';
    // Only display medium size icon when both line-height >= 24px AND font-size >= 20px
    // This prevents icons from becoming medium size inappropriately
    if (height >= 50) return 'large';
    else if (height >= 36) return 'big';
    else if (height >= 24 && !!fontSize && fontSize >= 20) return 'medium';
    else if (height <= 16) return 'small';
    else return 'normal';
}
const $4ede5ec7997eb329$var$InternalIcon = ({ name: name, size: size = 'normal', variant: variant = 'normal', url: url, alt: alt, ariaLabel: ariaLabel, svg: svg, badge: badge, nativeAttributes: nativeAttributes, __internalRootRef: __internalRootRef, ...props })=>{
    const icons = (0, $acw62.useContext)((0, $1f45c04519109e02$export$243ba0f53027507e));
    const iconRef = (0, $acw62.useRef)(null);
    // To ensure a re-render is triggered on visual mode changes
    (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const [parentHeight, setParentHeight] = (0, $acw62.useState)(null);
    const [parentFontSize, setParentFontSize] = (0, $acw62.useState)(null);
    const contextualSize = size === 'inherit';
    const iconSize = contextualSize ? $4ede5ec7997eb329$var$iconSizeMap(parentHeight, parentFontSize) : size;
    const inlineStyles = contextualSize && parentHeight !== null ? {
        height: `${parentHeight}px`
    } : {};
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    baseProps.className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $ac283450f3f763d1$export$2e2bcd8739ae039).icon, contextualSize && (0, $ac283450f3f763d1$export$2e2bcd8739ae039)['icon-flex-height'], badge && (0, $ac283450f3f763d1$export$2e2bcd8739ae039).badge, !contextualSize && (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`size-${iconSize}-mapped-height`], (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`size-${iconSize}`], (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`variant-${variant}`], (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`name-${name}`]);
    // Possible infinite loop is not a concern here because line
    // height should not change without an external state update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useLayoutEffect)(()=>{
        if (!contextualSize || !iconRef.current) return;
        const computedStyle = getComputedStyle(iconRef.current);
        const { lineHeight: lineHeight, fontSize: fontSize } = computedStyle;
        const newParentHeight = parseInt(lineHeight, 10);
        const newParentFontSize = parseInt(fontSize, 10);
        setParentHeight(newParentHeight);
        setParentFontSize(newParentFontSize);
    });
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(iconRef, __internalRootRef);
    const hasAriaLabel = typeof ariaLabel === 'string';
    const labelAttributes = hasAriaLabel ? {
        role: 'img',
        'aria-label': ariaLabel
    } : {};
    if (svg) {
        if (url) (0, $013a2451794a45c0$exports.warnOnce)('Icon', 'You have specified both `url` and `svg`. `svg` will take precedence and `url` will be ignored.');
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
            ...baseProps,
            ...labelAttributes,
            tag: "span",
            componentName: "Icon",
            nativeAttributes: nativeAttributes,
            ref: mergedRef,
            "aria-hidden": !hasAriaLabel,
            style: inlineStyles
        }, svg);
    }
    if (url) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...baseProps,
        tag: "span",
        componentName: "Icon",
        nativeAttributes: nativeAttributes,
        ref: mergedRef,
        style: inlineStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: url,
        alt: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : alt
    }));
    const validIcon = name && Object.prototype.hasOwnProperty.call(icons, name);
    function iconMap(name) {
        if (name === 'gen-ai' && iconSize === 'small') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            focusable: "false",
            "aria-hidden": "true",
            "data-testid": "gen-ai-filled"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "m8 4.4 1.018 2.582L11.6 8 9.018 9.018 8 11.6 6.982 9.018 4.4 8l2.582-1.018L8 4.4ZM2.405 2.41l.002-.003.003-.002-.003-.002-.002-.003-.002.003-.003.002.003.002.002.003Z",
            className: "filled"
        }));
        else return icons[name];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...baseProps,
        ...labelAttributes,
        tag: "span",
        componentName: "Icon",
        nativeAttributes: nativeAttributes,
        ref: mergedRef,
        style: inlineStyles
    }, validIcon ? iconMap(name) : undefined);
};
var $4ede5ec7997eb329$export$2e2bcd8739ae039 = $4ede5ec7997eb329$var$InternalIcon;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/* istanbul ignore file */ function $54d511b0978bc73c$export$ccbd7b3cec4e5298(funnelMetrics) {
    $54d511b0978bc73c$export$300ddd9f131af3a = funnelMetrics;
}
function $54d511b0978bc73c$export$91f5f1215e029975(performanceMetrics) {
    $54d511b0978bc73c$export$68015ba807c17f26 = performanceMetrics;
}
function $54d511b0978bc73c$export$cc9d00d06d461551(componentMetrics) {
    $54d511b0978bc73c$export$ac7489d0d2439141 = componentMetrics;
}
let $54d511b0978bc73c$export$300ddd9f131af3a = {
    funnelStart () {
        return '';
    },
    funnelError () {},
    funnelComplete () {},
    funnelSuccessful () {},
    funnelCancelled () {},
    funnelChange () {},
    funnelStepStart () {},
    funnelStepComplete () {},
    funnelStepNavigation () {},
    funnelStepError () {},
    funnelStepChange () {},
    funnelSubStepStart () {},
    funnelSubStepComplete () {},
    funnelSubStepError () {},
    helpPanelInteracted () {},
    externalLinkInteracted () {}
};
let $54d511b0978bc73c$export$68015ba807c17f26 = {
    tableInteraction () {},
    taskCompletionData () {},
    modalPerformanceData () {}
};
let $54d511b0978bc73c$export$ac7489d0d2439141 = {
    componentMounted () {
        return '';
    },
    componentUpdated () {}
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1yiQH = parcelRequire("1yiQH");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1yiQH = parcelRequire("1yiQH");
function $38f6480185c49d6f$export$d6c4e8150c35fed1(element) {
    var _a;
    const computedStyle = getComputedStyle(element);
    return !!computedStyle.transform && computedStyle.transform !== 'none' || !!computedStyle.perspective && computedStyle.perspective !== 'none' || ((_a = computedStyle.contain) === null || _a === void 0 ? void 0 : _a.split(' ').some((s)=>[
            'layout',
            'paint',
            'strict',
            'content'
        ].includes(s)));
}
function $38f6480185c49d6f$export$940d8225183e1404(startElement) {
    if (!startElement.parentElement) return null;
    return (0, $1yiQH.findUpUntil)(startElement.parentElement, $38f6480185c49d6f$export$d6c4e8150c35fed1);
}
function $38f6480185c49d6f$export$4d2bf79134de6c3({ startElement: startElement, tests: tests }) {
    const keys = Object.keys(tests);
    const elements = {};
    let current = startElement;
    while(current && Object.keys(elements).length < keys.length){
        current = current.parentElement;
        // If a component is used within an svg (i.e. as foreignObject), then it will
        // have some ancestor nodes that are SVGElement. We want to skip those,
        // as they have very different properties to HTMLElements.
        while(current && !$38f6480185c49d6f$export$1b3bfaa9684536aa(current))current = current.parentElement;
        for (const key of keys)if (!elements[key] && current && tests[key](current)) elements[key] = current;
    }
    return elements;
}
function $38f6480185c49d6f$export$8ee0fc9ee280b4ee(target) {
    return target instanceof Node || target !== null && typeof target === 'object' && 'nodeType' in target && typeof target.nodeType === 'number' && 'nodeName' in target && typeof target.nodeName === 'string' && 'parentNode' in target && typeof target.parentNode === 'object';
}
function $38f6480185c49d6f$export$1b3bfaa9684536aa(target) {
    return target instanceof HTMLElement || $38f6480185c49d6f$export$8ee0fc9ee280b4ee(target) && target.nodeType === Node.ELEMENT_NODE && 'style' in target && typeof target.style === 'object' && typeof target.ownerDocument === 'object' && !$38f6480185c49d6f$export$17eda790a720ec57(target);
}
function $38f6480185c49d6f$export$17eda790a720ec57(target) {
    return target instanceof SVGElement || $38f6480185c49d6f$export$8ee0fc9ee280b4ee(target) && target.nodeType === Node.ELEMENT_NODE && 'ownerSVGElement' in target && typeof target.ownerSVGElement === 'object';
}
function $38f6480185c49d6f$export$45a5e7f76e0caa8d(target) {
    return $38f6480185c49d6f$export$1b3bfaa9684536aa(target) || $38f6480185c49d6f$export$17eda790a720ec57(target);
}


function $4c778684f125e678$export$57d4cb221e1d1857(container, target) {
    var _a;
    if (!(0, $38f6480185c49d6f$export$8ee0fc9ee280b4ee)(target)) return false;
    const portal = (0, $1yiQH.findUpUntil)(target, (node)=>node === container || (0, $38f6480185c49d6f$export$1b3bfaa9684536aa)(node) && !!node.dataset.awsuiReferrerId);
    if (portal && portal === container) // We found the container as a direct ancestor without a portal
    return true;
    const referrer = (0, $38f6480185c49d6f$export$1b3bfaa9684536aa)(portal) ? document.getElementById((_a = portal.dataset.awsuiReferrerId) !== null && _a !== void 0 ? _a : '') : null;
    return referrer ? (0, $1yiQH.nodeContains)(container, referrer) : (0, $1yiQH.nodeContains)(container, target);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $285a09b860d2bebc$var$DATA_ATTR_FUNNEL = 'data-analytics-funnel';
const $285a09b860d2bebc$export$6f6189a197458f7a = `${$285a09b860d2bebc$var$DATA_ATTR_FUNNEL}-interaction-id`;
const $285a09b860d2bebc$export$22b484224f7ab69a = `${$285a09b860d2bebc$var$DATA_ATTR_FUNNEL}-key`;
const $285a09b860d2bebc$export$39e42cde97dfcad = `${$285a09b860d2bebc$var$DATA_ATTR_FUNNEL}-value`;
const $285a09b860d2bebc$export$35cc9e5d8841ad00 = `${$285a09b860d2bebc$var$DATA_ATTR_FUNNEL}-step`;
const $285a09b860d2bebc$export$e4865c712b63120 = `${$285a09b860d2bebc$var$DATA_ATTR_FUNNEL}-substep`;
const $285a09b860d2bebc$export$2d9588ca27729166 = `${$285a09b860d2bebc$var$DATA_ATTR_FUNNEL}-resource-type`;
const $285a09b860d2bebc$export$1b41fd4f1fd53ef2 = 'data-analytics-modal-id';
const $285a09b860d2bebc$export$7f7018c0ba6d811a = 'data-analytics-field-label';
const $285a09b860d2bebc$export$374a078abad6179f = 'data-analytics-field-error';
const $285a09b860d2bebc$export$886c79e627389031 = 'data-analytics-alert';
const $285a09b860d2bebc$export$5acc5b69fd3e0afc = 'data-analytics-flashbar';
const $285a09b860d2bebc$export$62aaf1f56e89d4dc = 'data-analytics-suppress-flow-events';
const $285a09b860d2bebc$export$f707bfc38f5d283 = 'funnel-name';
const $285a09b860d2bebc$export$5a2a1cf91319a1cd = 'step-name';
const $285a09b860d2bebc$export$7eef17de8ae91f78 = 'substep-name';
const $285a09b860d2bebc$export$3e712eeacbba81a0 = ()=>`[${$285a09b860d2bebc$export$22b484224f7ab69a}="${$285a09b860d2bebc$export$f707bfc38f5d283}"]`;
const $285a09b860d2bebc$export$984fbea25848566f = (key)=>`[${$285a09b860d2bebc$export$22b484224f7ab69a}="${key}"]`;
const $285a09b860d2bebc$export$c0773214960ddccc = (value)=>`[${$285a09b860d2bebc$export$39e42cde97dfcad}="${value}"]`;
const $285a09b860d2bebc$export$57dc544ae10998c7 = ()=>`[${$285a09b860d2bebc$export$e4865c712b63120}]`;
const $285a09b860d2bebc$export$ee83c691e298510a = (subStepId)=>`[${$285a09b860d2bebc$export$e4865c712b63120}="${subStepId}"]`;
const $285a09b860d2bebc$export$d82de5788b5a2d19 = (subStepId)=>[
        subStepId ? $285a09b860d2bebc$export$ee83c691e298510a(subStepId) : '',
        `[${$285a09b860d2bebc$export$22b484224f7ab69a}="${$285a09b860d2bebc$export$7eef17de8ae91f78}"]`
    ].join(' ');
const $285a09b860d2bebc$export$9b7aa6f73a756b51 = (id)=>id ? `[id="${id}"]` : undefined;
const $285a09b860d2bebc$export$e6ab0626c6ca0272 = (selector)=>{
    var _a, _b;
    return selector ? (_b = (_a = document.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim() : undefined;
};


const $2c7360a12f6b0b92$export$7a5dd0cfd3639f1b = (0, $acw62.createContext)({
    funnelInteractionId: undefined,
    funnelNameSelector: (0, $285a09b860d2bebc$export$3e712eeacbba81a0)(),
    setFunnelInteractionId: ()=>{},
    funnelType: 'single-page',
    optionalStepNumbers: [],
    totalFunnelSteps: 0,
    funnelSubmit: ()=>{},
    funnelCancel: ()=>{},
    submissionAttempt: 0,
    funnelNextOrSubmitAttempt: ()=>{},
    funnelState: {
        current: 'default'
    },
    errorCount: {
        current: 0
    },
    loadingButtonCount: {
        current: 0
    },
    latestFocusCleanupFunction: {
        current: undefined
    },
    isInFunnel: false,
    wizardCount: {
        current: 0
    }
});
const $2c7360a12f6b0b92$export$8b0d9233e68df2ee = (0, $acw62.createContext)({
    stepNameSelector: '',
    stepNumber: 0,
    subStepCount: {
        current: 0
    },
    isInStep: false,
    funnelInteractionId: undefined,
    onStepChange: ()=>{},
    subStepConfiguration: {
        current: new Map()
    }
});
const $2c7360a12f6b0b92$export$3030a14ef22dab15 = (0, $acw62.createContext)({
    subStepId: '',
    subStepSelector: '',
    subStepNameSelector: '',
    subStepRef: {
        current: null
    },
    isNestedSubStep: false,
    mousePressed: {
        current: false
    },
    isFocusedSubStep: {
        current: false
    },
    focusCleanupFunction: {
        current: undefined
    }
});
const $2c7360a12f6b0b92$export$6763bc96d4aa4bf8 = (0, $acw62.createContext)(undefined);



const $777318d005be2fce$export$eaa6680ad4907dec = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$3030a14ef22dab15));
    const { funnelInteractionId: funnelInteractionId, funnelIdentifier: funnelIdentifier, funnelState: funnelState, latestFocusCleanupFunction: latestFocusCleanupFunction } = $777318d005be2fce$export$88e1f0f171a7843e();
    const { stepNumber: stepNumber, stepIdentifier: stepIdentifier, stepNameSelector: stepNameSelector, subStepConfiguration: subStepConfiguration } = $777318d005be2fce$export$77e0136e4218bd7f();
    const { subStepIdentifier: subStepIdentifier, subStepId: subStepId, subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector, subStepRef: subStepRef, isNestedSubStep: isNestedSubStep, mousePressed: mousePressed, isFocusedSubStep: isFocusedSubStep, focusCleanupFunction: focusCleanupFunction } = context;
    if (isNestedSubStep) return context;
    const onFocus = async (event)=>{
        var _a, _b, _c, _d;
        const element = event.target;
        // Ignore spurious focus events, such as when the browser window is focused again.
        await new Promise((r)=>setTimeout(r, 1));
        if (document.activeElement !== element) return;
        if (isFocusedSubStep.current) return;
        isFocusedSubStep.current = true;
        if (funnelInteractionId && subStepId) {
            /*
              If the previously focused substep has provided a cleanup function, we
              call it here on behalf of the previously focused substep.
            */ (_a = latestFocusCleanupFunction.current) === null || _a === void 0 || _a.call(latestFocusCleanupFunction);
            const subStepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(subStepNameSelector);
            const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
            const subStepNumber = (_d = (_c = (_b = subStepConfiguration.current) === null || _b === void 0 ? void 0 : _b.get(stepNumber)) === null || _c === void 0 ? void 0 : _c.find((step)=>step.name === subStepName)) === null || _d === void 0 ? void 0 : _d.number;
            (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepStart({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                subStepIdentifier: subStepIdentifier,
                subStepSelector: subStepSelector,
                subStepNameSelector: subStepNameSelector,
                subStepName: subStepName,
                subStepNumber: subStepNumber,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
            });
            /*
              This cleanup function will be called when the user leaves this substep.
              The function might be called either:
      
                - by the next focused substep as `latestFocusCleanupFunction`
                  (through a separate instance of the function we're currently in), or
      
                - by the same substep as `focusCleanupFunction`
                  (through the `onMouseUp` handler or the `onBlur` handler).
            */ let cleanupFunctionHasBeenRun = false;
            focusCleanupFunction.current = ()=>{
                var _a, _b, _c;
                if (cleanupFunctionHasBeenRun) return;
                cleanupFunctionHasBeenRun = true;
                const subStepNumber = (_c = (_b = (_a = subStepConfiguration.current) === null || _a === void 0 ? void 0 : _a.get(stepNumber)) === null || _b === void 0 ? void 0 : _b.find((s)=>s.name === subStepName)) === null || _c === void 0 ? void 0 : _c.number;
                if (funnelState.current !== 'cancelled') (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepComplete({
                    funnelIdentifier: funnelIdentifier,
                    funnelInteractionId: funnelInteractionId,
                    subStepIdentifier: subStepIdentifier,
                    subStepSelector: subStepSelector,
                    subStepNameSelector: subStepNameSelector,
                    subStepName: subStepName,
                    subStepNumber: subStepNumber,
                    stepIdentifier: stepIdentifier,
                    stepNumber: stepNumber,
                    stepName: stepName,
                    stepNameSelector: stepNameSelector,
                    subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
                });
            };
            latestFocusCleanupFunction.current = focusCleanupFunction.current;
        }
    };
    const onBlur = (event)=>{
        var _a;
        if (mousePressed.current) /*
             Ignore blur events that are caused by mouse interaction, because these events don't
             always reflect user intention. For example, clicking the label of an interactive form
             element will briefly blur it.
             The mouse-caused events are handled in the global `onMouseUp` handler of the substep
             context instead.
             */ return;
        if (!subStepRef.current || !event.relatedTarget || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(subStepRef.current, event.relatedTarget)) {
            isFocusedSubStep.current = false;
            if (funnelInteractionId && subStepId && funnelState.current !== 'cancelled') /*
                 Run this substep's own focus cleanup function if another substep
                 hasn't already done it for us.
                 */ (_a = focusCleanupFunction.current) === null || _a === void 0 || _a.call(focusCleanupFunction);
        }
    };
    const funnelSubStepProps = funnelInteractionId ? {
        [(0, $285a09b860d2bebc$export$e4865c712b63120)]: subStepId,
        onFocus: onFocus,
        onBlur: onBlur
    } : {};
    return {
        funnelSubStepProps: funnelSubStepProps,
        ...context
    };
};
const $777318d005be2fce$export$77e0136e4218bd7f = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$8b0d9233e68df2ee));
    return context;
};
const $777318d005be2fce$export$987fbbaf76a9f8ac = ()=>{
    const funnelStep = $777318d005be2fce$export$77e0136e4218bd7f();
    const funnelStepRef = (0, $acw62.useRef)(funnelStep);
    funnelStepRef.current = funnelStep;
    return funnelStepRef;
};
const $777318d005be2fce$export$88e1f0f171a7843e = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$7a5dd0cfd3639f1b));
    const funnelProps = context.funnelInteractionId ? {
        [(0, $285a09b860d2bebc$export$6f6189a197458f7a)]: context.funnelInteractionId
    } : {};
    return {
        funnelProps: funnelProps,
        ...context
    };
};
const $777318d005be2fce$export$330d990b59bc48da = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$6763bc96d4aa4bf8));
    return context;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $edea5ac281b34b48$export$24d547caef80ccd1 = (0, $acw62.createContext)({
    onClick: ()=>{}
});
function $edea5ac281b34b48$export$d891409b33cf7746() {
    return (0, $acw62.useContext)($edea5ac281b34b48$export$24d547caef80ccd1);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $e72aa8d9fd756822$export$2e2bcd8739ae039(mainRef, controlRef) {
    (0, $acw62.useImperativeHandle)(mainRef, ()=>({
            focus (...args) {
                var _a;
                (_a = controlRef.current) === null || _a === void 0 || _a.focus(...args);
            }
        }), [
        controlRef
    ]);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $b36e5053a31bf154$export$2e2bcd8739ae039(description) {
    const id = (0, $013a2451794a45c0$exports.useUniqueId)();
    return {
        targetProps: {
            'aria-describedby': description ? id : undefined
        },
        descriptionEl: description ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            id: id,
            hidden: true
        }, description) : null,
        descriptionId: id
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $584c4a19f0ba0537$export$ab57792b9b6974a6 = (0, $acw62.createContext)({
    isInModal: false,
    componentLoadingCount: {
        current: 0
    },
    emitTimeToContentReadyInModal: ()=>{}
});
const $584c4a19f0ba0537$export$4cc1699d46f42cae = ()=>{
    const modalContext = (0, $acw62.useContext)($584c4a19f0ba0537$export$ab57792b9b6974a6);
    return modalContext;
};


const $bd3a651d3c4436d1$export$def8917b9f6e206 = (isPrimaryButton, loading)=>{
    const modalContext = (0, $584c4a19f0ba0537$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        if (!isPrimaryButton || !modalContext.isInModal) return;
        if (loading) {
            modalContext.componentLoadingCount.current++;
            return ()=>{
                modalContext.componentLoadingCount.current--;
                modalContext.emitTimeToContentReadyInModal(performance.now());
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading
    ]);
};
const $bd3a651d3c4436d1$export$b155a71460610994 = ()=>{
    const modalContext = (0, $584c4a19f0ba0537$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        if (!modalContext.isInModal) return;
        modalContext.componentLoadingCount.current++;
        return ()=>{
            modalContext.componentLoadingCount.current--;
            modalContext.emitTimeToContentReadyInModal(performance.now());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $9c1836ca8dd61d43$export$69a1650565b41024(elementRef, attributeName, value) {
    const attributeValueRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        var _a;
        // With this effect, we apply the attribute only on the client, to avoid hydration errors.
        attributeValueRef.current = value;
        (_a = elementRef.current) === null || _a === void 0 || _a.setAttribute(attributeName, value);
    }, [
        attributeName,
        value,
        elementRef
    ]);
    return {
        [attributeName]: attributeValueRef.current
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $5f60cc888539a35b$export$21dfe79102a9caab(callback, deps) {
    const previousDepsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const previousDeps = previousDepsRef.current;
        previousDepsRef.current = deps;
        // The initial render is ignored by design.
        if (previousDeps === null) return;
        // In React 18 strict mode the useEffect callback is executed twice. We prevent the
        // callback from firing in case the dependencies did not actually change.
        if ($5f60cc888539a35b$var$isDepsEqual(previousDeps, deps)) // This line is only reachable in React 18+ strict mode.
        // istanbul ignore next
        return;
        return callback();
    // This is a useEffect extension, will be validated at the call site
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
function $5f60cc888539a35b$var$isDepsEqual(prev, next) {
    for(let i = 0; i < Math.max(prev.length, next.length); i++){
        // This is how React compared dependencies, documented here: https://react.dev/reference/react/useEffect.
        if (!Object.is(prev[i], next[i])) return false;
    }
    // This line is only reachable in React 18+ strict mode.
    // istanbul ignore next
    return true;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $69d46333f6e63b62$var$map = new WeakMap();
const $69d46333f6e63b62$var$MANUAL_TRIGGER_DELAY = 150;
function $69d46333f6e63b62$export$157b27307c5a0381(element, callback) {
    let resolve = (value)=>{
        resolve = ()=>{}; // Prevent multiple execution
        callback(value);
    };
    $69d46333f6e63b62$var$map.set(element, (inViewport)=>resolve(inViewport));
    $69d46333f6e63b62$var$observer.observe(element);
    /*
       If the IntersectionObserver does not fire in reasonable time (for example
       in a background page in Chrome), we need to call the callback manually.
    
       See https://issues.chromium.org/issues/41383759
       */ const timeoutHandle = setTimeout(()=>resolve(false), $69d46333f6e63b62$var$MANUAL_TRIGGER_DELAY);
    // Cleanup
    return ()=>{
        clearTimeout(timeoutHandle);
        $69d46333f6e63b62$var$map.delete(element);
        $69d46333f6e63b62$var$observer.unobserve(element);
    };
}
function $69d46333f6e63b62$var$createIntersectionObserver(callback) {
    if (typeof IntersectionObserver === 'undefined') return {
        observe: ()=>{},
        unobserve: ()=>{}
    };
    return new IntersectionObserver(callback);
}
const $69d46333f6e63b62$var$observer = $69d46333f6e63b62$var$createIntersectionObserver(function isInViewportObserver(entries) {
    var _a;
    for (const entry of entries){
        $69d46333f6e63b62$var$observer.unobserve(entry.target); // We only want the first run of the observer for each element.
        (_a = $69d46333f6e63b62$var$map.get(entry.target)) === null || _a === void 0 || _a(entry.isIntersecting);
        $69d46333f6e63b62$var$map.delete(entry.target);
    }
});


const $d1a7bb38399fdadf$var$EVALUATE_COMPONENT_VISIBILITY_EVENT = 'awsui-evaluate-component-visibility';
/**
 * This hook manages a boolean state (`evaluateComponentVisibility`) that toggles
 * whenever a custom DOM event (`EVALUATE_COMPONENT_VISIBILITY_EVENT`) is triggered.
 *
 * @returns
 */ const $d1a7bb38399fdadf$var$useEvaluateComponentVisibility = ()=>{
    const [evaluateComponentVisibility, setEvaluateComponentVisibility] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const handleEvaluateComponentVisibility = ()=>{
            setEvaluateComponentVisibility((prev)=>!prev);
        };
        document.addEventListener($d1a7bb38399fdadf$var$EVALUATE_COMPONENT_VISIBILITY_EVENT, handleEvaluateComponentVisibility);
        return ()=>{
            document.removeEventListener($d1a7bb38399fdadf$var$EVALUATE_COMPONENT_VISIBILITY_EVENT, handleEvaluateComponentVisibility);
        };
    }, []);
    return evaluateComponentVisibility;
};
function $d1a7bb38399fdadf$export$2ea7ecdb51f088f5(name, enabled, elementRef, getDetails, dependencies) {
    const id = (0, $013a2451794a45c0$exports.useRandomId)();
    const { isInModal: isInModal } = (0, $584c4a19f0ba0537$export$4cc1699d46f42cae)();
    const attributes = (0, $9c1836ca8dd61d43$export$69a1650565b41024)(elementRef, 'data-analytics-performance-mark', id);
    const evaluateComponentVisibility = $d1a7bb38399fdadf$var$useEvaluateComponentVisibility();
    (0, $acw62.useEffect)(()=>{
        if (!enabled() || !elementRef.current || isInModal) return;
        const elementVisible = elementRef.current.offsetWidth > 0 && elementRef.current.offsetHeight > 0 && getComputedStyle(elementRef.current).visibility !== 'hidden';
        if (!elementVisible) return;
        const timestamp = performance.now();
        const cleanup = (0, $69d46333f6e63b62$export$157b27307c5a0381)(elementRef.current, (inViewport)=>{
            performance.mark(`${name}Rendered`, {
                startTime: timestamp,
                detail: {
                    source: 'awsui',
                    instanceIdentifier: id,
                    inViewport: inViewport,
                    ...getDetails()
                }
            });
        });
        return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5f60cc888539a35b$export$21dfe79102a9caab)(()=>{
        if (!enabled() || !elementRef.current || isInModal) return;
        const elementVisible = elementRef.current.offsetWidth > 0 && elementRef.current.offsetHeight > 0 && getComputedStyle(elementRef.current).visibility !== 'hidden';
        if (!elementVisible) return;
        const timestamp = performance.now();
        const cleanup = (0, $69d46333f6e63b62$export$157b27307c5a0381)(elementRef.current, (inViewport)=>{
            performance.mark(`${name}Updated`, {
                startTime: timestamp,
                detail: {
                    source: 'awsui',
                    instanceIdentifier: id,
                    inViewport: inViewport,
                    ...getDetails()
                }
            });
        });
        return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        evaluateComponentVisibility,
        ...dependencies
    ]);
    return attributes;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $3de0f29144bb4e85$var$allowedJavascriptUrls = [
    'javascript:void(0)',
    'javascript:void(0);',
    'javascript:;'
];
function $3de0f29144bb4e85$export$6661f6891a200a5f(component, url) {
    if (!url) return;
    if ($3de0f29144bb4e85$var$allowedJavascriptUrls.indexOf(url.toLowerCase()) !== -1) return;
    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch  {
        // If the URL cannot be parsed by the browser, it likely does not pose a security risk.
        return;
    }
    if (parsedUrl.protocol === 'javascript:') {
        (0, $013a2451794a45c0$exports.warnOnce)(component, `A javascript: URL was blocked as a security precaution. The URL was "${url}".`);
        // This mirrors the error message that React will use:
        // https://github.com/facebook/react/blob/a724a3b578dce77d427bef313102a4d0e978d9b4/packages/react-dom/src/shared/sanitizeURL.js#L30
        throw new Error(`A javascript: URL was blocked as a security precaution.`);
    }
    return;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $6101d505dc93c9ce$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1iee7_xy9l5_145",
    "announcer": "awsui_announcer_1iee7_xy9l5_153"
};



var $3a1fbb013f70636a$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1pc7b_1k8pp_5",
    "announcer": "awsui_announcer_1pc7b_1k8pp_9"
};


class $9c52236b8f4a9295$export$eb348fee3537e554 {
    constructor(politeness, delay = $9c52236b8f4a9295$export$eb348fee3537e554.defaultDelay){
        this.politeness = politeness;
        this.delay = delay;
        this._addedTerminalPeriod = false;
        this._nextAnnouncement = '';
        this._element = document.createElement('div');
        this._element.className = `${(0, $6101d505dc93c9ce$export$2e2bcd8739ae039).announcer} ${(0, $3a1fbb013f70636a$export$2e2bcd8739ae039).announcer}`;
        this._element.setAttribute('aria-live', this.politeness);
        this._element.setAttribute('aria-atomic', 'true');
        document.body.appendChild(this._element);
    }
    /**
     * Reset the state of the controller and clear any active announcements.
     */ destroy() {
        var _a;
        (_a = this._element) === null || _a === void 0 || _a.remove();
        if (this._timeoutId !== undefined) {
            clearTimeout(this._timeoutId);
            this._timeoutId = undefined;
        }
    }
    announce({ message: message, forceReannounce: forceReannounce = false }) {
        if (!message) return;
        this._nextAnnouncement = message.trim();
        if (this.delay === 0 || forceReannounce) // If the delay is 0, just skip the timeout shenanigans and update the
        // element synchronously. Great for tests.
        return this._updateElement(forceReannounce);
        if (this._timeoutId === undefined) this._timeoutId = setTimeout(()=>this._updateElement(false), this.delay * 1000);
    }
    _updateElement(forceReannounce) {
        if (this._nextAnnouncement !== this._lastAnnouncement) {
            // The aria-atomic does not work properly in Voice Over, causing
            // certain parts of the content to be ignored. To fix that,
            // we assign the source text content as a single node.
            this._element.textContent = this._nextAnnouncement;
            this._addedTerminalPeriod = false;
        } else if (forceReannounce) {
            // A (generally) safe way of forcing re-announcements is toggling the
            // terminal period. If we only keep adding periods, it's going to be
            // eventually interpreted as an ellipsis.
            this._element.textContent = this._nextAnnouncement + (this._addedTerminalPeriod ? '' : '.');
            this._addedTerminalPeriod = !this._addedTerminalPeriod;
        }
        // Track the announced text for deduplication.
        this._lastAnnouncement = this._nextAnnouncement;
        // Reset the state for the next announcement.
        this._timeoutId = undefined;
    }
}
/**
 * The default delay for announcements when no delay is explicitly provided.
 * During internal unit testing, you can import this and explicitly set it to
 * 0 to make the live region update the DOM without waiting for a timer.
 */ $9c52236b8f4a9295$export$eb348fee3537e554.defaultDelay = 2;




var $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function InternalLiveRegion({ assertive: assertive = false, hidden: hidden = false, tagName: TagName = 'div', delay: delay, sources: sources, children: children, __internalRootRef: __internalRootRef, className: className, ...restProps }, ref) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const childrenRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(childrenRef, __internalRootRef);
    (0, $acw62.useEffect)(()=>{
        // We have to do this because `inert` isn't properly supported until
        // React 19 and this seems much more maintainable than version detection.
        // `inert` is better than `hidden` because it also blocks pointer and
        // focus events as well as hiding the contents from screen readers.
        // https://github.com/facebook/react/issues/17157
        if (childrenRef.current) childrenRef.current.inert = hidden;
    }, [
        hidden
    ]);
    // Initialize the live region controller inside an effect. We have to do this
    // because the controller depends on DOM elements, which aren't available on the
    // server.
    const liveRegionControllerRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        const liveRegionController = new (0, $9c52236b8f4a9295$export$eb348fee3537e554)(assertive ? 'assertive' : 'polite');
        liveRegionControllerRef.current = liveRegionController;
        return ()=>{
            liveRegionController.destroy();
            liveRegionControllerRef.current = undefined;
        };
    }, [
        assertive
    ]);
    const getContent = ()=>{
        if (sources) return $ad7fb7d5e8b2fd49$var$getSourceContent(sources);
        if (childrenRef.current) return $ad7fb7d5e8b2fd49$export$cd43ff883ede1e5d(childrenRef.current);
    };
    // Call the controller on every render. The controller will deduplicate the
    // message against the previous announcement internally.
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = liveRegionControllerRef.current) === null || _a === void 0 || _a.announce({
            message: getContent(),
            delay: delay
        });
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            reannounce () {
                var _a;
                (_a = liveRegionControllerRef.current) === null || _a === void 0 || _a.announce({
                    message: getContent(),
                    delay: delay,
                    forceReannounce: true
                });
            }
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        ref: mergedRef,
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6101d505dc93c9ce$export$2e2bcd8739ae039).root, (0, $3a1fbb013f70636a$export$2e2bcd8739ae039).root, className),
        hidden: hidden
    }, children);
});
const $ad7fb7d5e8b2fd49$var$processNode = (childNode)=>{
    if (childNode.nodeType === Node.TEXT_NODE) return childNode.textContent || '';
    if (childNode.nodeType === Node.ELEMENT_NODE) return $ad7fb7d5e8b2fd49$export$cd43ff883ede1e5d(childNode);
    return '';
};
function $ad7fb7d5e8b2fd49$export$cd43ff883ede1e5d(node) {
    var _a;
    // We use the text content of the node as the announcement text.
    // This only extracts text content from the node including all its children which is enough for now.
    // To make it more powerful, it is possible to create a more sophisticated extractor with respect to
    // ARIA properties to ignore aria-hidden nodes and read ARIA labels from the live content.
    if (!node || !((_a = node === null || node === void 0 ? void 0 : node.childNodes) === null || _a === void 0 ? void 0 : _a.length)) return '';
    return Array.from(node.childNodes, $ad7fb7d5e8b2fd49$var$processNode).join(' ').replace(/\s+/g, ' ').trim();
}
function $ad7fb7d5e8b2fd49$var$getSourceContent(source) {
    return source.map((item)=>{
        if (!item || typeof item === 'string') return item;
        if (item.current) return $ad7fb7d5e8b2fd49$export$cd43ff883ede1e5d(item.current);
    }).filter(Boolean).join(' ');
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $c8c884735cae083e$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $ae9b8e2bcc2d9ece$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $5eeab8444420e62b$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $6d520d6858ebc9b9$export$bb38bb9a1161268 = 'unmounted';
var $6d520d6858ebc9b9$export$84cbff306f539230 = 'exited';
var $6d520d6858ebc9b9$export$df38205c966be359 = 'entering';
var $6d520d6858ebc9b9$export$78e9e6e3e014d60a = 'entered';
var $6d520d6858ebc9b9$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $6d520d6858ebc9b9$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $6d520d6858ebc9b9$export$84cbff306f539230;
                _this.appearStatus = $6d520d6858ebc9b9$export$df38205c966be359;
            } else initialStatus = $6d520d6858ebc9b9$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $6d520d6858ebc9b9$export$bb38bb9a1161268;
        else initialStatus = $6d520d6858ebc9b9$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $6d520d6858ebc9b9$export$bb38bb9a1161268) return {
            status: $6d520d6858ebc9b9$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $6d520d6858ebc9b9$export$df38205c966be359 && status !== $6d520d6858ebc9b9$export$78e9e6e3e014d60a) nextStatus = $6d520d6858ebc9b9$export$df38205c966be359;
            } else if (status === $6d520d6858ebc9b9$export$df38205c966be359 || status === $6d520d6858ebc9b9$export$78e9e6e3e014d60a) nextStatus = $6d520d6858ebc9b9$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $6d520d6858ebc9b9$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $5eeab8444420e62b$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $6d520d6858ebc9b9$export$84cbff306f539230) this.setState({
            status: $6d520d6858ebc9b9$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c8c884735cae083e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6d520d6858ebc9b9$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $6d520d6858ebc9b9$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $6d520d6858ebc9b9$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c8c884735cae083e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6d520d6858ebc9b9$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $6d520d6858ebc9b9$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $6d520d6858ebc9b9$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $6d520d6858ebc9b9$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae9b8e2bcc2d9ece$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$6d520d6858ebc9b9$var$Transition.contextType = (0, $ae9b8e2bcc2d9ece$export$2e2bcd8739ae039);
$6d520d6858ebc9b9$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $6d520d6858ebc9b9$var$noop() {}
$6d520d6858ebc9b9$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $6d520d6858ebc9b9$var$noop,
    onEntering: $6d520d6858ebc9b9$var$noop,
    onEntered: $6d520d6858ebc9b9$var$noop,
    onExit: $6d520d6858ebc9b9$var$noop,
    onExiting: $6d520d6858ebc9b9$var$noop,
    onExited: $6d520d6858ebc9b9$var$noop
};
$6d520d6858ebc9b9$var$Transition.UNMOUNTED = $6d520d6858ebc9b9$export$bb38bb9a1161268;
$6d520d6858ebc9b9$var$Transition.EXITED = $6d520d6858ebc9b9$export$84cbff306f539230;
$6d520d6858ebc9b9$var$Transition.ENTERING = $6d520d6858ebc9b9$export$df38205c966be359;
$6d520d6858ebc9b9$var$Transition.ENTERED = $6d520d6858ebc9b9$export$78e9e6e3e014d60a;
$6d520d6858ebc9b9$var$Transition.EXITING = $6d520d6858ebc9b9$export$4aacc83d4d59139f;
var $6d520d6858ebc9b9$export$2e2bcd8739ae039 = $6d520d6858ebc9b9$var$Transition;



function $29f6cc3f65ba768c$export$be58926105124dd4({ in: isIn, children: children, exit: exit = true, onStatusChange: onStatusChange = ()=>void 0, disabled: disabled = false, transitionChangeDelay: transitionChangeDelay, ...rest }) {
    const transitionRootElement = (0, $acw62.useRef)(null);
    // the initial state of the transition should be either 'exited' or 'entered' depending
    // on the `in` property, this mimicks how internally the Transition component works here:
    // https://github.com/reactjs/react-transition-group/blob/6cbd6aaedaf8e9472007640b429ddb48c6c24158/src/Transition.js#L121
    const [transitionState, setTransitionState] = (0, $acw62.useState)(isIn ? 'entered' : 'exited');
    const motionDisabled = (0, $013a2451794a45c0$exports.useReducedMotion)(transitionRootElement) || disabled;
    const addTransitionEndListener = (0, $acw62.useCallback)((done)=>{
        const node = transitionRootElement.current;
        if (node === null) return;
        const controller = new AbortController();
        const listener = (e)=>{
            if (e.target === node) {
                controller.abort();
                done();
            }
        };
        node.addEventListener('transitionend', listener, {
            signal: controller.signal
        });
        node.addEventListener('animationend', listener, {
            signal: controller.signal
        });
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), {
        addEndListener: addTransitionEndListener,
        timeout: motionDisabled ? 0 : undefined,
        in: isIn,
        nodeRef: transitionRootElement,
        exit: exit,
        onEnter: (isAppearing)=>{
            if (!isAppearing) {
                setTransitionState('enter');
                onStatusChange('enter');
            }
        },
        onEntering: (isAppearing)=>{
            var _a;
            if (!isAppearing) {
                // This line forces the browser to recalculate the layout because we want the starting state in the 'enter' style
                // to be applied before the animation starts.
                (_a = transitionRootElement.current) === null || _a === void 0 || _a.offsetHeight;
                if (transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering) setTimeout(()=>{
                    setTransitionState('entering');
                    onStatusChange('entering');
                }, transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering);
                else {
                    setTransitionState('entering');
                    onStatusChange('entering');
                }
            }
        },
        onEntered: (isAppearing)=>{
            if (!isAppearing) {
                setTransitionState('entered');
                onStatusChange('entered');
            }
        },
        onExit: ()=>{
            setTransitionState('exit');
            onStatusChange('exit');
        },
        onExiting: ()=>{
            setTransitionState('exiting');
            onStatusChange('exiting');
        },
        onExited: ()=>{
            setTransitionState('exited');
            onStatusChange('exited');
        },
        ...rest
    }, ()=>children(transitionState, transitionRootElement));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $350807ffd27dc31c$export$2e2bcd8739ae039 = {
    "arrow": "awsui_arrow_xjuzf_45l16_153",
    "arrow-outer": "awsui_arrow-outer_xjuzf_45l16_157",
    "arrow-inner": "awsui_arrow-inner_xjuzf_45l16_157",
    "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_45l16_199",
    "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_45l16_199",
    "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_45l16_202",
    "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_45l16_202",
    "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_45l16_205",
    "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_45l16_205",
    "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_45l16_205",
    "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_45l16_205",
    "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_45l16_208",
    "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_45l16_208",
    "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_45l16_208",
    "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_45l16_208",
    "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_45l16_212",
    "body": "awsui_body_xjuzf_45l16_227",
    "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_45l16_263",
    "body-variant-chart": "awsui_body-variant-chart_xjuzf_45l16_266",
    "has-dismiss": "awsui_has-dismiss_xjuzf_45l16_271",
    "dismiss": "awsui_dismiss_xjuzf_45l16_276",
    "dismiss-control": "awsui_dismiss-control_xjuzf_45l16_284",
    "header-row": "awsui_header-row_xjuzf_45l16_288",
    "header": "awsui_header_xjuzf_45l16_288",
    "content": "awsui_content_xjuzf_45l16_317",
    "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_45l16_326",
    "container": "awsui_container_xjuzf_45l16_338",
    "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_45l16_349",
    "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_45l16_349",
    "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_45l16_349",
    "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_45l16_354",
    "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_45l16_354",
    "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_45l16_354",
    "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_45l16_359",
    "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_45l16_359",
    "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_45l16_364",
    "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_45l16_364",
    "container-body": "awsui_container-body_xjuzf_45l16_370",
    "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_45l16_410",
    "container-body-size-small": "awsui_container-body-size-small_xjuzf_45l16_415",
    "fixed-width": "awsui_fixed-width_xjuzf_45l16_418",
    "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_45l16_422",
    "container-body-size-large": "awsui_container-body-size-large_xjuzf_45l16_429",
    "container-arrow": "awsui_container-arrow_xjuzf_45l16_349",
    "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_45l16_479",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_45l16_1",
    "refresh": "awsui_refresh_xjuzf_45l16_537",
    "root": "awsui_root_xjuzf_45l16_559",
    "no-wrap": "awsui_no-wrap_xjuzf_45l16_591",
    "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_45l16_594",
    "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_45l16_594",
    "trigger-type-text": "awsui_trigger-type-text_xjuzf_45l16_594",
    "root-filtering-token": "awsui_root-filtering-token_xjuzf_45l16_616",
    "trigger": "awsui_trigger_xjuzf_45l16_594",
    "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_45l16_703",
    "popover-inline-content": "awsui_popover-inline-content_xjuzf_45l16_707",
    "hover-area": "awsui_hover-area_xjuzf_45l16_711"
};


const $b971696cf22f0db1$var$Arrow = ({ position: position, variant: variant })=>{
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).arrow, (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`arrow-position-${position}`], (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`arrow-variant-${variant}`])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039)['arrow-outer']
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)['arrow-inner'], isVisualRefresh && (0, $350807ffd27dc31c$export$2e2bcd8739ae039).refresh)
    }));
};
var $b971696cf22f0db1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($b971696cf22f0db1$var$Arrow);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $693d63d2fb891c85$exports = {};

$parcel$defineInteropFlag($693d63d2fb891c85$exports);

$parcel$export($693d63d2fb891c85$exports, "default", () => $693d63d2fb891c85$export$2e2bcd8739ae039);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $7WQrb = parcelRequire("7WQrb");
//
// Main
//
function $8f38f7d77b1e84b6$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $8f38f7d77b1e84b6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $8f38f7d77b1e84b6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $8f38f7d77b1e84b6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $8f38f7d77b1e84b6$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $8f38f7d77b1e84b6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $8f38f7d77b1e84b6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $8f38f7d77b1e84b6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $8f38f7d77b1e84b6$var$monadic : $8f38f7d77b1e84b6$var$variadic;
    return $8f38f7d77b1e84b6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyVariadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$variadic, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyMonadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $8f38f7d77b1e84b6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $8f38f7d77b1e84b6$var$cacheDefault = {
    create: function create() {
        return new $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache();
    }
};
var $8f38f7d77b1e84b6$export$c5491a8691a23b9e = {
    variadic: $8f38f7d77b1e84b6$var$strategyVariadic,
    monadic: $8f38f7d77b1e84b6$var$strategyMonadic
};



var $7WQrb = parcelRequire("7WQrb");
var $4c7cc2bf81666647$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($4c7cc2bf81666647$export$896afd8541959ee5 || ($4c7cc2bf81666647$export$896afd8541959ee5 = {}));



var $7WQrb = parcelRequire("7WQrb");

var $e62d085b79ea4606$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e62d085b79ea4606$export$b87f371cbc396fcf || ($e62d085b79ea4606$export$b87f371cbc396fcf = {}));
var $e62d085b79ea4606$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e62d085b79ea4606$export$906452485466fa53 || ($e62d085b79ea4606$export$906452485466fa53 = {}));
function $e62d085b79ea4606$export$cfa10c5697238752(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.literal;
}
function $e62d085b79ea4606$export$4f55724281bdfaf9(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.argument;
}
function $e62d085b79ea4606$export$e11187b219e191e1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.number;
}
function $e62d085b79ea4606$export$32d811605da75f40(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.date;
}
function $e62d085b79ea4606$export$34ec46f596b1702f(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.time;
}
function $e62d085b79ea4606$export$dcfe1c11d168b5a1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.select;
}
function $e62d085b79ea4606$export$6c796d116f0a4fbc(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.plural;
}
function $e62d085b79ea4606$export$c0ece297bdd0c082(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.pound;
}
function $e62d085b79ea4606$export$5c83de34745812b(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.tag;
}
function $e62d085b79ea4606$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $e62d085b79ea4606$export$906452485466fa53.number);
}
function $e62d085b79ea4606$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $e62d085b79ea4606$export$906452485466fa53.dateTime);
}
function $e62d085b79ea4606$export$f0ac572c1121c662(value) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e62d085b79ea4606$export$425e864b0ba114f1(value, style) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $8a8e2dd39f8c2b53$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $8a8e2dd39f8c2b53$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $088961f6a5934025$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $088961f6a5934025$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($088961f6a5934025$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



var $7WQrb = parcelRequire("7WQrb");
// @generated from regex-gen.ts
var $38d7ef65502c3cf1$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $68833020532266e2$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $38d7ef65502c3cf1$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $68833020532266e2$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $68833020532266e2$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $68833020532266e2$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $68833020532266e2$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $68833020532266e2$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $68833020532266e2$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $68833020532266e2$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $68833020532266e2$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $68833020532266e2$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $68833020532266e2$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($68833020532266e2$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($68833020532266e2$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($68833020532266e2$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), $68833020532266e2$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), $68833020532266e2$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $68833020532266e2$var$parseSign(token.stem);
        if (signOpts) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $68833020532266e2$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $99659e106fc3b209$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $2207e049a5272320$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $99659e106fc3b209$export$a8c9209db4084317)[regionTag || ''] || (0, $99659e106fc3b209$export$a8c9209db4084317)[languageTag || ''] || (0, $99659e106fc3b209$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $99659e106fc3b209$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $60e6f3ba709db920$var$_a;
var $60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $8a8e2dd39f8c2b53$export$523451f94304dd6c).source, "*"));
var $60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $8a8e2dd39f8c2b53$export$523451f94304dd6c).source, "*$"));
function $60e6f3ba709db920$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $60e6f3ba709db920$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $60e6f3ba709db920$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $60e6f3ba709db920$var$hasNativeFromEntries = !!Object.fromEntries;
var $60e6f3ba709db920$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $60e6f3ba709db920$var$hasTrimStart = !!String.prototype.trimStart;
var $60e6f3ba709db920$var$hasTrimEnd = !!String.prototype.trimEnd;
var $60e6f3ba709db920$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $60e6f3ba709db920$var$isSafeInteger = $60e6f3ba709db920$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $60e6f3ba709db920$var$re = $60e6f3ba709db920$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = (($60e6f3ba709db920$var$_a = $60e6f3ba709db920$var$re.exec('a')) === null || $60e6f3ba709db920$var$_a === void 0 ? void 0 : $60e6f3ba709db920$var$_a[0]) === 'a';
} catch (_) {
    $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $60e6f3ba709db920$var$startsWith = $60e6f3ba709db920$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $60e6f3ba709db920$var$fromCodePoint = $60e6f3ba709db920$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $60e6f3ba709db920$var$fromEntries = // native
$60e6f3ba709db920$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $60e6f3ba709db920$var$codePointAt = $60e6f3ba709db920$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $60e6f3ba709db920$var$trimStart = $60e6f3ba709db920$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $60e6f3ba709db920$var$trimEnd = $60e6f3ba709db920$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $60e6f3ba709db920$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $60e6f3ba709db920$var$matchIdentifierAtIndex;
if ($60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1 = $60e6f3ba709db920$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $60e6f3ba709db920$var$codePointAt(s, index);
        if (c === undefined || $60e6f3ba709db920$var$_isWhiteSpace(c) || $60e6f3ba709db920$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, match);
};
var $60e6f3ba709db920$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).pound,
                    location: $60e6f3ba709db920$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $60e6f3ba709db920$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$60e6f3ba709db920$var$_isAlpha(this.char())) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNCLOSED_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $60e6f3ba709db920$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $60e6f3ba709db920$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$60e6f3ba709db920$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $60e6f3ba709db920$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EMPTY_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $60e6f3ba709db920$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $60e6f3ba709db920$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $60e6f3ba709db920$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $60e6f3ba709db920$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $60e6f3ba709db920$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $2207e049a5272320$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $e62d085b79ea4606$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $088961f6a5934025$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $e62d085b79ea4606$export$b87f371cbc396fcf).date : (0, $e62d085b79ea4606$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $e62d085b79ea4606$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $e62d085b79ea4606$export$b87f371cbc396fcf).date : (0, $e62d085b79ea4606$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $60e6f3ba709db920$var$createLocation(typeEndPosition_1, (0, $7WQrb.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $68833020532266e2$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $e62d085b79ea4606$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $68833020532266e2$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $4c7cc2bf81666647$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $4c7cc2bf81666647$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$60e6f3ba709db920$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $60e6f3ba709db920$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($60e6f3ba709db920$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $60e6f3ba709db920$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $60e6f3ba709db920$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $60e6f3ba709db920$var$_isAlphaOrSlash(codepoint) {
    return $60e6f3ba709db920$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $60e6f3ba709db920$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}




var $7WQrb = parcelRequire("7WQrb");

function $8f8b09366e2f11a5$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $7WQrb.__spreadArray)([], obj.map($8f8b09366e2f11a5$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $8f8b09366e2f11a5$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $8f8b09366e2f11a5$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $8f8b09366e2f11a5$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $8f8b09366e2f11a5$export$be5687ba8bbdf416((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $8f8b09366e2f11a5$var$isPluralOrSelectElement(el) {
    return (0, $e62d085b79ea4606$export$6c796d116f0a4fbc)(el) || (0, $e62d085b79ea4606$export$dcfe1c11d168b5a1)(el);
}
function $8f8b09366e2f11a5$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($8f8b09366e2f11a5$var$isPluralOrSelectElement(el)) return true;
        if ((0, $e62d085b79ea4606$export$5c83de34745812b)(el)) return $8f8b09366e2f11a5$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $8f8b09366e2f11a5$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($8f8b09366e2f11a5$var$isPluralOrSelectElement(el)) return [
            $8f8b09366e2f11a5$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $e62d085b79ea4606$export$5c83de34745812b)(el) && $8f8b09366e2f11a5$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $8f8b09366e2f11a5$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $e62d085b79ea4606$export$4f55724281bdfaf9)(el) || (0, $e62d085b79ea4606$export$32d811605da75f40)(el) || (0, $e62d085b79ea4606$export$34ec46f596b1702f)(el) || (0, $e62d085b79ea4606$export$e11187b219e191e1)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $e62d085b79ea4606$export$6c796d116f0a4fbc)(el) || (0, $e62d085b79ea4606$export$dcfe1c11d168b5a1)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $8f8b09366e2f11a5$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $e62d085b79ea4606$export$5c83de34745812b)(el)) {
            vars.set(el.value, el.type);
            $8f8b09366e2f11a5$var$collectVariables(el.children, vars);
        }
    });
}
function $8f8b09366e2f11a5$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $8f8b09366e2f11a5$var$collectVariables(a, aVars);
    $8f8b09366e2f11a5$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $e62d085b79ea4606$export$b87f371cbc396fcf)[type], " vs ").concat((0, $e62d085b79ea4606$export$b87f371cbc396fcf)[bType]))
        };
        return result;
    }, {
        success: true
    });
}


function $b673c42291cd7fb6$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $e62d085b79ea4606$export$dcfe1c11d168b5a1)(el) || (0, $e62d085b79ea4606$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $b673c42291cd7fb6$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $e62d085b79ea4606$export$e11187b219e191e1)(el) && (0, $e62d085b79ea4606$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $e62d085b79ea4606$export$32d811605da75f40)(el) || (0, $e62d085b79ea4606$export$34ec46f596b1702f)(el)) && (0, $e62d085b79ea4606$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $e62d085b79ea4606$export$5c83de34745812b)(el)) $b673c42291cd7fb6$var$pruneLocation(el.children);
    });
}
function $b673c42291cd7fb6$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $7WQrb.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $60e6f3ba709db920$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $4c7cc2bf81666647$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $b673c42291cd7fb6$var$pruneLocation(result.val);
    return result.val;
}
var $b673c42291cd7fb6$export$d3c1bfa0f7d806e9 = (0, $60e6f3ba709db920$export$7acfa6ed01010e37);




var $7WQrb = parcelRequire("7WQrb");
var $b2de32051be1701b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b2de32051be1701b$export$d4e71bc0b80dc0fb || ($b2de32051be1701b$export$d4e71bc0b80dc0fb = {}));
var $b2de32051be1701b$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b2de32051be1701b$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $b2de32051be1701b$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b2de32051be1701b$export$7369836851cc1329);


var $a7bf6eec6df43b65$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($a7bf6eec6df43b65$export$49694c2877b44c57 || ($a7bf6eec6df43b65$export$49694c2877b44c57 = {}));
function $a7bf6eec6df43b65$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal || part.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $a7bf6eec6df43b65$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $a7bf6eec6df43b65$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $e62d085b79ea4606$export$cfa10c5697238752)(els[0])) return [
        {
            type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $e62d085b79ea4606$export$cfa10c5697238752)(el)) {
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $e62d085b79ea4606$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $b2de32051be1701b$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $e62d085b79ea4606$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $e62d085b79ea4606$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $e62d085b79ea4606$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $e62d085b79ea4606$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $e62d085b79ea4606$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $e62d085b79ea4606$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $e62d085b79ea4606$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $e62d085b79ea4606$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$a7bf6eec6df43b65$export$df0c12a2d414a163(formatFn)) throw new (0, $b2de32051be1701b$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $a7bf6eec6df43b65$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $e62d085b79ea4606$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $b2de32051be1701b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $e62d085b79ea4606$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $b2de32051be1701b$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $b2de32051be1701b$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $b2de32051be1701b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $a7bf6eec6df43b65$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $65f19ee2190344e6$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $65f19ee2190344e6$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $65f19ee2190344e6$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $7WQrb.__assign)({}, defaultConfig));
}
function $65f19ee2190344e6$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $65f19ee2190344e6$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $8f38f7d77b1e84b6$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.number),
            strategy: (0, $8f38f7d77b1e84b6$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $8f38f7d77b1e84b6$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $8f38f7d77b1e84b6$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $8f38f7d77b1e84b6$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $8f38f7d77b1e84b6$export$c5491a8691a23b9e).variadic
        })
    };
}
var $65f19ee2190344e6$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $a7bf6eec6df43b65$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $a7bf6eec6df43b65$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $7WQrb.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $65f19ee2190344e6$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $65f19ee2190344e6$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $b673c42291cd7fb6$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $693d63d2fb891c85$export$2e2bcd8739ae039 = (0, $65f19ee2190344e6$export$d342343268debc40);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $9699df5a060a9c12$export$1a01ae0705bafd37 = {
    defaultVariant: 'secondary'
};
const $9699df5a060a9c12$export$366cdc6257b696ef = (0, $acw62.createContext)($9699df5a060a9c12$export$1a01ae0705bafd37);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/* istanbul ignore file */ /* eslint-disable require-await, @typescript-eslint/no-unused-vars */ function $dca857cabc5bb5b3$export$ddd1ead001892597(functions) {
    if (functions.persistFlashbarDismiss) $dca857cabc5bb5b3$export$a93c5fb33d27b888 = functions.persistFlashbarDismiss;
    if (functions.retrieveFlashbarDismiss) $dca857cabc5bb5b3$export$ee01cd86db6e8e2a = functions.retrieveFlashbarDismiss;
    if (functions.persistAlertDismiss) $dca857cabc5bb5b3$export$b9a3e1da90e31cc6 = functions.persistAlertDismiss;
    if (functions.retrieveAlertDismiss) $dca857cabc5bb5b3$export$60e02eaf45845295 = functions.retrieveAlertDismiss;
    if (functions.persistFeatureNotifications) $dca857cabc5bb5b3$export$48f54c965235548a = functions.persistFeatureNotifications;
    if (functions.retrieveFeatureNotifications) $dca857cabc5bb5b3$export$1137a287ea89c32e = functions.retrieveFeatureNotifications;
}
let $dca857cabc5bb5b3$export$a93c5fb33d27b888 = async function(persistenceConfig) {
    return Promise.resolve();
};
let $dca857cabc5bb5b3$export$ee01cd86db6e8e2a = async function(persistenceConfig) {
    return Promise.resolve(false);
};
let $dca857cabc5bb5b3$export$b9a3e1da90e31cc6 = async function(persistenceConfig) {
    return Promise.resolve();
};
let $dca857cabc5bb5b3$export$60e02eaf45845295 = async function(persistenceConfig) {
    return Promise.resolve(false);
};
let $dca857cabc5bb5b3$export$48f54c965235548a = async function(persistenceConfig, value) {
    return Promise.resolve();
};
let $dca857cabc5bb5b3$export$1137a287ea89c32e = async function(persistenceConfig) {
    return Promise.resolve({});
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $a773f3a2497f02b1$var$RuntimeActionWrapper({ mountContent: mountContent, updateContent: updateContent, unmountContent: unmountContent, context: context }) {
    const ref = (0, $acw62.useRef)(null);
    const mountedRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (mountedRef.current && ref.current) updateContent === null || updateContent === void 0 || updateContent(ref.current, context);
    });
    (0, $acw62.useEffect)(()=>{
        const container = ref.current;
        mountContent(container, context);
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
            unmountContent(container);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    });
}
function $a773f3a2497f02b1$export$43997369e47eb864(onActionRegistered) {
    return function useDiscoveredAction(type) {
        const [actionConfigs, setActionConfigs] = (0, $acw62.useState)([]);
        const headerRef = (0, $acw62.useRef)(null);
        const contentRef = (0, $acw62.useRef)(null);
        (0, $acw62.useEffect)(()=>{
            return onActionRegistered((actions)=>setActionConfigs(actions));
        }, [
            type
        ]);
        const discoveredActions = actionConfigs.map((action)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a773f3a2497f02b1$var$RuntimeActionWrapper, {
                key: action.id + '-' + type,
                context: {
                    type: type,
                    headerRef: headerRef,
                    contentRef: contentRef
                },
                mountContent: action.mountContent,
                updateContent: action.updateContent,
                unmountContent: action.unmountContent
            }));
        return {
            discoveredActions: discoveredActions,
            headerRef: headerRef,
            contentRef: contentRef
        };
    };
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $4d6f2485768b0179$export$108105bf404ba92b(componentName, controller) {
    return function useDiscoveredContent({ type: type, header: header, children: children }) {
        const instanceId = (0, $013a2451794a45c0$exports.useUniqueId)(`${componentName}-discovered-content`);
        const headerRef = (0, $acw62.useRef)(null);
        const contentRef = (0, $acw62.useRef)(null);
        const replacementHeaderRef = (0, $acw62.useRef)(null);
        const replacementContentRef = (0, $acw62.useRef)(null);
        const [initialHidden, setInitialHidden] = (0, $acw62.useState)(()=>controller.initialCheck({
                instanceId: instanceId,
                type: type,
                header: header,
                content: children
            }));
        const [headerReplacementType, setFoundHeaderReplacement] = (0, $acw62.useState)('original');
        const [contentReplacementType, setFoundContentReplacement] = (0, $acw62.useState)('original');
        const mountedProvider = (0, $acw62.useRef)();
        (0, $acw62.useEffect)(()=>{
            const context = {
                instanceId: instanceId,
                type: type,
                headerRef: headerRef,
                contentRef: contentRef
            };
            setInitialHidden(false);
            return controller.onContentRegistered((provider)=>{
                let mounted = true;
                function checkMounted(methodName) {
                    if (!mounted) {
                        (0, $c6f40142f532d98e$export$740bffb7416ae276)(`${componentName}-content-replacer`, `"${methodName}" called after component unmounted`);
                        return false;
                    }
                    return true;
                }
                mountedProvider.current = provider.runReplacer(context, {
                    hideHeader () {
                        if (checkMounted('hideHeader')) setFoundHeaderReplacement('remove');
                    },
                    restoreHeader () {
                        if (checkMounted('restoreHeader')) setFoundHeaderReplacement('original');
                    },
                    replaceHeader (replacer) {
                        if (checkMounted('replaceHeader')) {
                            replacer(replacementHeaderRef.current);
                            setFoundHeaderReplacement('replaced');
                        }
                    },
                    hideContent () {
                        if (checkMounted('hideContent')) setFoundContentReplacement('remove');
                    },
                    restoreContent () {
                        if (checkMounted('restoreContent')) setFoundContentReplacement('original');
                    },
                    replaceContent (replacer) {
                        if (checkMounted('replaceContent')) {
                            replacer(replacementContentRef.current);
                            setFoundContentReplacement('replaced');
                        }
                    }
                });
                return ()=>{
                    var _a;
                    (_a = mountedProvider.current) === null || _a === void 0 || _a.unmount({
                        replacementHeaderContainer: replacementHeaderRef.current,
                        replacementContentContainer: replacementContentRef.current
                    });
                    mounted = false;
                };
            });
        }, [
            instanceId,
            type
        ]);
        (0, $acw62.useEffect)(()=>{
            var _a;
            (_a = mountedProvider.current) === null || _a === void 0 || _a.update();
        }, [
            type,
            header,
            children
        ]);
        return {
            initialHidden: initialHidden,
            headerReplacementType: headerReplacementType,
            contentReplacementType: contentReplacementType,
            headerRef: headerRef,
            replacementHeaderRef: replacementHeaderRef,
            contentRef: contentRef,
            replacementContentRef: replacementContentRef
        };
    };
}



function $28e2f0577fc47761$export$2e2bcd8739ae039(defaultValue = 0, threshold = 1) {
    const [width, ref] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect, prev)=>{
        if (prev === null) return rect.contentBoxWidth;
        return Math.abs(prev - rect.contentBoxWidth) >= threshold ? rect.contentBoxWidth : prev;
    });
    return [
        width !== null && width !== void 0 ? width : defaultValue,
        ref
    ];
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $0856f1407cdf9bef$export$2e2bcd8739ae039 = {
    "root": "awsui_root_37gf8_1udtb_9"
};


function $d276899a8d82cf05$var$createActionButton(testUtilClasses, action, buttonText, onButtonClick) {
    if (!action && buttonText) action = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: 'buttonClick'
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        className: testUtilClasses.actionButton,
        onClick: onButtonClick,
        formAction: "none"
    }, buttonText));
    return action ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: testUtilClasses.actionSlot
    }, action) : null;
}
const $d276899a8d82cf05$export$c8223871eecc8f3a = ({ className: className, testUtilClasses: testUtilClasses, action: action, discoveredActions: discoveredActions, buttonText: buttonText, wrappedClass: wrappedClass, containerWidth: containerWidth, onButtonClick: onButtonClick })=>{
    const [wrapped, setWrapped] = (0, $acw62.useState)(false);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!ref.current || !containerWidth || !wrappedClass) return;
        function check() {
            const isRtl = (0, $013a2451794a45c0$exports.getIsRtl)(ref.current);
            const { offsetWidth: offsetWidth, offsetLeft: offsetLeft } = ref.current;
            const start = isRtl ? containerWidth - offsetWidth - offsetLeft : offsetLeft;
            // if the action slot is towards the left (right in RTL) of its container
            setWrapped(start < 100);
        }
        // Discovered actions are rendered by their plugin, so don't cause a
        // re-render of our React tree. So we observe for changes.
        const observer = new MutationObserver(check);
        observer.observe(ref.current, {
            attributes: false,
            childList: true,
            subtree: true
        });
        check();
        return ()=>observer.disconnect();
    });
    const actionButton = $d276899a8d82cf05$var$createActionButton(testUtilClasses, action, buttonText, onButtonClick);
    if (!actionButton && discoveredActions.length === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0856f1407cdf9bef$export$2e2bcd8739ae039).root, className, wrapped && wrappedClass)
    }, actionButton, discoveredActions);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $7c3a34cd41432ad1$var$customCSSPropertiesMap = {
    "maxContentWidth": "--awsui-max-content-width-n6lfw8",
    "minContentWidth": "--awsui-min-content-width-n6lfw8",
    "breadcrumbsGap": "--awsui-breadcrumbs-gap-n6lfw8",
    "contentGapLeft": "--awsui-content-gap-left-n6lfw8",
    "contentGapRight": "--awsui-content-gap-right-n6lfw8",
    "contentHeight": "--awsui-content-height-n6lfw8",
    "contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-n6lfw8",
    "contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-n6lfw8",
    "contentLayoutMainGap": "--awsui-content-layout-main-gap-n6lfw8",
    "defaultMaxContentWidth": "--awsui-default-max-content-width-n6lfw8",
    "defaultMinContentWidth": "--awsui-default-min-content-width-n6lfw8",
    "drawerSize": "--awsui-drawer-size-n6lfw8",
    "drawerMinSize": "--awsui-drawer-min-size-n6lfw8",
    "bottomDrawerSize": "--awsui-bottom-drawer-size-n6lfw8",
    "footerHeight": "--awsui-footer-height-n6lfw8",
    "headerGap": "--awsui-header-gap-n6lfw8",
    "headerHeight": "--awsui-header-height-n6lfw8",
    "layoutWidth": "--awsui-layout-width-n6lfw8",
    "mainGap": "--awsui-main-gap-n6lfw8",
    "mainOffsetLeft": "--awsui-main-offset-left-n6lfw8",
    "mainTemplateRows": "--awsui-main-template-rows-n6lfw8",
    "mobileBarHeight": "--awsui-mobile-bar-height-n6lfw8",
    "notificationsHeight": "--awsui-notifications-height-n6lfw8",
    "offsetTop": "--awsui-offset-top-n6lfw8",
    "overlapHeight": "--awsui-overlap-height-n6lfw8",
    "navigationWidth": "--awsui-navigation-width-n6lfw8",
    "splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-n6lfw8",
    "splitPanelReportedSize": "--awsui-split-panel-reported-size-n6lfw8",
    "splitPanelHeight": "--awsui-split-panel-height-n6lfw8",
    "splitPanelMinWidth": "--awsui-split-panel-min-width-n6lfw8",
    "splitPanelMaxWidth": "--awsui-split-panel-max-width-n6lfw8",
    "toolsMaxWidth": "--awsui-tools-max-width-n6lfw8",
    "toolsWidth": "--awsui-tools-width-n6lfw8",
    "toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-n6lfw8",
    "contentScrollMargin": "--awsui-content-scroll-margin-n6lfw8",
    "flashbarStackDepth": "--awsui-flashbar-stack-depth-n6lfw8",
    "flashbarStackIndex": "--awsui-flashbar-stack-index-n6lfw8",
    "flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-n6lfw8",
    "stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-n6lfw8",
    "stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-n6lfw8",
    "dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-n6lfw8",
    "dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-n6lfw8",
    "modalCustomWidth": "--awsui-modal-custom-width-n6lfw8",
    "modalCustomHeight": "--awsui-modal-custom-height-n6lfw8",
    "spinnerRotatorFrom": "--awsui-spinner-rotator-from-n6lfw8",
    "spinnerRotatorTo": "--awsui-spinner-rotator-to-n6lfw8",
    "spinnerLineLeftFrom": "--awsui-spinner-line-left-from-n6lfw8",
    "spinnerLineLeftTo": "--awsui-spinner-line-left-to-n6lfw8",
    "spinnerLineRightFrom": "--awsui-spinner-line-right-from-n6lfw8",
    "spinnerLineRightTo": "--awsui-spinner-line-right-to-n6lfw8",
    "sliderLabelCount": "--awsui-slider-label-count-n6lfw8",
    "sliderTickCount": "--awsui-slider-tick-count-n6lfw8",
    "sliderReferenceColumn": "--awsui-slider-reference-column-n6lfw8",
    "sliderNextReferenceColumn": "--awsui-slider-next-reference-column-n6lfw8",
    "sliderMaxStart": "--awsui-slider-max-start-n6lfw8",
    "sliderMinEnd": "--awsui-slider-min-end-n6lfw8",
    "sliderRangeInlineSize": "--awsui-slider-range-inline-size-n6lfw8",
    "sliderTooltipPosition": "--awsui-slider-tooltip-position-n6lfw8",
    "togglesLeftWidth": "--awsui-toggles-left-width-n6lfw8",
    "togglesRightWidth": "--awsui-toggles-right-width-n6lfw8",
    "promptInputMaxRows": "--awsui-prompt-input-max-rows-n6lfw8",
    "promptInputScrollHeight": "--awsui-prompt-input-scroll-height-n6lfw8",
    "dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-n6lfw8",
    "dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-n6lfw8",
    "styleBackgroundActive": "--awsui-style-background-active-n6lfw8",
    "styleBackgroundDefault": "--awsui-style-background-default-n6lfw8",
    "styleBackgroundDisabled": "--awsui-style-background-disabled-n6lfw8",
    "styleBackgroundHover": "--awsui-style-background-hover-n6lfw8",
    "styleBorderColorActive": "--awsui-style-border-color-active-n6lfw8",
    "styleBorderColorDefault": "--awsui-style-border-color-default-n6lfw8",
    "styleBorderColorDisabled": "--awsui-style-border-color-disabled-n6lfw8",
    "styleBorderColorHover": "--awsui-style-border-color-hover-n6lfw8",
    "styleColorActive": "--awsui-style-color-active-n6lfw8",
    "styleColorDefault": "--awsui-style-color-default-n6lfw8",
    "styleColorDisabled": "--awsui-style-color-disabled-n6lfw8",
    "styleColorHover": "--awsui-style-color-hover-n6lfw8",
    "styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-n6lfw8",
    "styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-n6lfw8",
    "styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-n6lfw8",
    "styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-n6lfw8",
    "styleBoxShadowActive": "--awsui-style-box-shadow-active-n6lfw8",
    "styleBoxShadowDefault": "--awsui-style-box-shadow-default-n6lfw8",
    "styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-n6lfw8",
    "styleBoxShadowHover": "--awsui-style-box-shadow-hover-n6lfw8",
    "styleBackgroundReadonly": "--awsui-style-background-readonly-n6lfw8",
    "styleBorderColorReadonly": "--awsui-style-border-color-readonly-n6lfw8",
    "styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-n6lfw8",
    "styleColorReadonly": "--awsui-style-color-readonly-n6lfw8",
    "styleBackgroundFocus": "--awsui-style-background-focus-n6lfw8",
    "styleBorderColorFocus": "--awsui-style-border-color-focus-n6lfw8",
    "styleBoxShadowFocus": "--awsui-style-box-shadow-focus-n6lfw8",
    "styleColorFocus": "--awsui-style-color-focus-n6lfw8",
    "stylePlaceholderColor": "--awsui-style-placeholder-color-n6lfw8",
    "stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-n6lfw8",
    "stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-n6lfw8",
    "stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-n6lfw8",
    "styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-n6lfw8",
    "styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-n6lfw8",
    "styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-n6lfw8",
    "styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-n6lfw8",
    "styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-n6lfw8",
    "alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-n6lfw8",
    "alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-n6lfw8",
    "alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-n6lfw8",
    "alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-n6lfw8",
    "alertIconColor": "--awsui-alert-icon-color-n6lfw8",
    "promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-n6lfw8",
    "promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-n6lfw8",
    "promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-n6lfw8",
    "promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-n6lfw8",
    "promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-n6lfw8",
    "promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-n6lfw8",
    "promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-n6lfw8",
    "promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-n6lfw8",
    "promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-n6lfw8",
    "promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-n6lfw8",
    "promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-n6lfw8",
    "promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-n6lfw8",
    "promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-n6lfw8",
    "promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-n6lfw8",
    "promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-n6lfw8",
    "promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-n6lfw8",
    "promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-n6lfw8",
    "promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-n6lfw8",
    "promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-n6lfw8",
    "promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-n6lfw8",
    "promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-n6lfw8",
    "promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-n6lfw8",
    "promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-n6lfw8",
    "promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-n6lfw8",
    "progressBarBackgroundColor": "--awsui-progress-bar-background-color-n6lfw8",
    "progressBarBorderRadius": "--awsui-progress-bar-border-radius-n6lfw8",
    "progressBarHeight": "--awsui-progress-bar-height-n6lfw8",
    "progressValueBackgroundColor": "--awsui-progress-value-background-color-n6lfw8",
    "styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-n6lfw8",
    "styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-n6lfw8",
    "styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-n6lfw8",
    "styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-n6lfw8",
    "styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-n6lfw8",
    "styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-n6lfw8",
    "styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-n6lfw8"
};
var $7c3a34cd41432ad1$export$2e2bcd8739ae039 = $7c3a34cd41432ad1$var$customCSSPropertiesMap;


function $1b69964d7240f58c$export$4c7e967240c093d7(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !(style === null || style === void 0 ? void 0 : style.root)) return undefined;
    return {
        background: (_a = style.root) === null || _a === void 0 ? void 0 : _a.background,
        borderColor: (_b = style.root) === null || _b === void 0 ? void 0 : _b.borderColor,
        borderRadius: (_c = style.root) === null || _c === void 0 ? void 0 : _c.borderRadius,
        borderWidth: (_d = style.root) === null || _d === void 0 ? void 0 : _d.borderWidth,
        color: (_e = style.root) === null || _e === void 0 ? void 0 : _e.color,
        ...((_f = style.root) === null || _f === void 0 ? void 0 : _f.focusRing) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).alertFocusRingBorderColor]: (_g = style.root.focusRing) === null || _g === void 0 ? void 0 : _g.borderColor,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).alertFocusRingBorderRadius]: (_h = style.root.focusRing) === null || _h === void 0 ? void 0 : _h.borderRadius,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).alertFocusRingBorderWidth]: (_j = style.root.focusRing) === null || _j === void 0 ? void 0 : _j.borderWidth
        }
    };
}
function $1b69964d7240f58c$export$85b8da3d52ee4014(style) {
    var _a;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !((_a = style === null || style === void 0 ? void 0 : style.icon) === null || _a === void 0 ? void 0 : _a.color)) return undefined;
    return {
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).alertIconColor]: style.icon.color
    };
}
function $1b69964d7240f58c$export$fde468abe546d4b9(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !(style === null || style === void 0 ? void 0 : style.dismissButton)) return undefined;
    return {
        root: {
            color: {
                active: (_b = (_a = style.dismissButton) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.active,
                default: (_d = (_c = style.dismissButton) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.default,
                hover: (_f = (_e = style.dismissButton) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.hover
            },
            focusRing: {
                borderColor: (_h = (_g = style.dismissButton) === null || _g === void 0 ? void 0 : _g.focusRing) === null || _h === void 0 ? void 0 : _h.borderColor,
                borderRadius: (_k = (_j = style.dismissButton) === null || _j === void 0 ? void 0 : _j.focusRing) === null || _k === void 0 ? void 0 : _k.borderRadius,
                borderWidth: (_m = (_l = style.dismissButton) === null || _l === void 0 ? void 0 : _l.focusRing) === null || _m === void 0 ? void 0 : _m.borderWidth
            }
        }
    };
}



var $8b77acac91dd393c$export$2e2bcd8739ae039 = {
    "header": "awsui_header_17427_1ns0c_5"
};



var $6c011c101cc9f6f9$export$2e2bcd8739ae039 = {
    "alert": "awsui_alert_mx3cw_1l75r_193",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1l75r_1",
    "root": "awsui_root_mx3cw_1l75r_215",
    "hidden": "awsui_hidden_mx3cw_1l75r_250",
    "alert-wrapper": "awsui_alert-wrapper_mx3cw_1l75r_299",
    "initial-hidden": "awsui_initial-hidden_mx3cw_1l75r_311",
    "header": "awsui_header_mx3cw_1l75r_316",
    "header-replacement": "awsui_header-replacement_mx3cw_1l75r_317",
    "action": "awsui_action_mx3cw_1l75r_321",
    "action-slot": "awsui_action-slot_mx3cw_1l75r_325",
    "action-button": "awsui_action-button_mx3cw_1l75r_326",
    "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1l75r_330",
    "text": "awsui_text_mx3cw_1l75r_361",
    "icon": "awsui_icon_mx3cw_1l75r_368",
    "message": "awsui_message_mx3cw_1l75r_371",
    "action-wrapped": "awsui_action-wrapped_mx3cw_1l75r_375",
    "icon-size-medium": "awsui_icon-size-medium_mx3cw_1l75r_379",
    "icon-size-big": "awsui_icon-size-big_mx3cw_1l75r_383",
    "icon-size-normal": "awsui_icon-size-normal_mx3cw_1l75r_387",
    "content": "awsui_content_mx3cw_1l75r_391",
    "content-replacement": "awsui_content-replacement_mx3cw_1l75r_392",
    "dismiss": "awsui_dismiss_mx3cw_1l75r_396",
    "dismiss-button": "awsui_dismiss-button_mx3cw_1l75r_401",
    "type-error": "awsui_type-error_mx3cw_1l75r_405",
    "type-warning": "awsui_type-warning_mx3cw_1l75r_413",
    "type-success": "awsui_type-success_mx3cw_1l75r_421",
    "type-info": "awsui_type-info_mx3cw_1l75r_429"
};


const $0572c3fe95cef167$var$typeToIcon = {
    error: 'status-negative',
    warning: 'status-warning',
    success: 'status-positive',
    info: 'status-info'
};
const $0572c3fe95cef167$var$useDiscoveredAction = (0, $a773f3a2497f02b1$export$43997369e47eb864)((0, $2ec6e52915a41fcf$export$90753eb139627d74).alert.onActionRegistered);
const $0572c3fe95cef167$var$useDiscoveredContent = (0, $4d6f2485768b0179$export$108105bf404ba92b)('alert', (0, $2ec6e52915a41fcf$export$90753eb139627d74).alertContent);
const $0572c3fe95cef167$var$InternalAlert = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ type: type, i18nStrings: i18nStrings, visible: visible = true, dismissible: dismissible, children: children, header: header, buttonText: buttonText, action: action, onDismiss: onDismiss, onButtonClick: onButtonClick, __internalRootRef: __internalRootRef, statusIconAriaLabel: deprecatedStatusIconAriaLabel, dismissAriaLabel: deprecatedDismissAriaLabel, messageSlotId: messageSlotId, style: style, persistenceConfig: persistenceConfig, ...rest }, ref)=>{
    var _a, _b;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('alert');
    const focusRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus: ()=>{
                if (focusRef.current) {
                    focusRef.current.tabIndex = -1;
                    focusRef.current.focus();
                }
            }
        }));
    const handleBlur = ()=>{
        if (focusRef.current) focusRef.current.removeAttribute('tabindex');
    };
    const { discoveredActions: discoveredActions, headerRef: headerRefAction, contentRef: contentRefAction } = $0572c3fe95cef167$var$useDiscoveredAction(type);
    const { initialHidden: initialHidden, headerReplacementType: headerReplacementType, contentReplacementType: contentReplacementType, headerRef: headerRefContent, contentRef: contentRefContent, replacementHeaderRef: replacementHeaderRef, replacementContentRef: replacementContentRef } = $0572c3fe95cef167$var$useDiscoveredContent({
        type: type,
        header: header,
        children: children
    });
    const [containerWidth, containerMeasureRef] = (0, $28e2f0577fc47761$export$2e2bcd8739ae039)();
    const containerRef = (0, $013a2451794a45c0$exports.useMergeRefs)(containerMeasureRef, __internalRootRef);
    const headerRef = (0, $013a2451794a45c0$exports.useMergeRefs)(headerRefAction, headerRefContent);
    const contentRef = (0, $013a2451794a45c0$exports.useMergeRefs)(contentRefAction, contentRefContent);
    const [isPersistentlyDismissed, setIsPersistentlyDismissed] = (0, $acw62.useState)(!!(persistenceConfig && persistenceConfig.uniqueKey));
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const size = isRefresh ? 'normal' : headerReplacementType !== 'remove' && header && contentReplacementType !== 'remove' && children ? 'big' : 'normal';
    const hasAction = Boolean(action || buttonText || discoveredActions.length);
    const analyticsAttributes = {
        [(0, $285a09b860d2bebc$export$886c79e627389031)]: type
    };
    const statusIconAriaLabel = i18n(`i18nStrings.${type}IconAriaLabel`, (_a = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings[`${type}IconAriaLabel`]) !== null && _a !== void 0 ? _a : deprecatedStatusIconAriaLabel);
    const dismissAriaLabel = i18n('i18nStrings.dismissAriaLabel', (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dismissAriaLabel) !== null && _b !== void 0 ? _b : i18n('dismissAriaLabel', deprecatedDismissAriaLabel));
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        if (persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.uniqueKey) (0, $dca857cabc5bb5b3$export$60e02eaf45845295)(persistenceConfig).then((dismissed)=>{
            if (isMounted) setIsPersistentlyDismissed(!!dismissed);
        }).catch(()=>{
            if (isMounted) setIsPersistentlyDismissed(false);
        });
        return ()=>{
            isMounted = false;
        };
    // Only track specific properties to avoid re-running when persistenceConfig object reference changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.uniqueKey,
        persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.crossServicePersistence
    ]);
    const dismiss = ()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss);
        if (persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.uniqueKey) (0, $dca857cabc5bb5b3$export$b9a3e1da90e31cc6)(persistenceConfig);
    };
    if (isPersistentlyDismissed) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ...analyticsAttributes,
        "aria-hidden": !visible,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).root, {
            [(0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).hidden]: !visible,
            [(0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['initial-hidden']]: initialHidden
        }, baseProps.className),
        ref: containerRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9699df5a060a9c12$export$366cdc6257b696ef).Provider, {
        value: {
            defaultVariant: 'primary'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8856d0c7df08fd8d$export$2e2bcd8739ae039), {
        contextName: "alert"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).alert, (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)[`type-${type}`], (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)[`icon-size-${size}`], hasAction && (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['with-action'], dismissible && (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['with-dismiss']),
        style: (0, $1b69964d7240f58c$export$4c7e967240c093d7)(style)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['alert-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['alert-focus-wrapper'],
        ref: focusRef,
        role: "group",
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).icon, (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).text),
        style: (0, $1b69964d7240f58c$export$85b8da3d52ee4014)(style)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: $0572c3fe95cef167$var$typeToIcon[type],
        size: size,
        ariaLabel: statusIconAriaLabel
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).message, (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).text),
        id: messageSlotId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(header && (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).header, headerReplacementType !== 'original' ? (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).hidden : (0, $8b77acac91dd393c$export$2e2bcd8739ae039).header),
        ref: headerRef
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['header-replacement'], headerReplacementType !== 'replaced' ? (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).hidden : (0, $8b77acac91dd393c$export$2e2bcd8739ae039).header),
        ref: replacementHeaderRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).content, contentReplacementType !== 'original' && (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).hidden),
        ref: contentRef
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['content-replacement'], contentReplacementType !== 'replaced' && (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).hidden),
        ref: replacementContentRef
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d276899a8d82cf05$export$c8223871eecc8f3a), {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).action,
        testUtilClasses: {
            actionSlot: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['action-slot'],
            actionButton: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['action-button']
        },
        action: action,
        discoveredActions: discoveredActions,
        buttonText: buttonText,
        onButtonClick: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onButtonClick),
        containerWidth: containerWidth,
        wrappedClass: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['action-wrapped']
    })), dismissible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).dismiss,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: 'dismiss'
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)['dismiss-button'],
        variant: "icon",
        iconName: "close",
        formAction: "none",
        ariaLabel: dismissAriaLabel,
        onClick: dismiss,
        style: (0, $1b69964d7240f58c$export$fde468abe546d4b9)(style)
    }))))));
});
var $0572c3fe95cef167$export$2e2bcd8739ae039 = $0572c3fe95cef167$var$InternalAlert;





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// The default refresh action reloads the top window to avoid iframe lifecycle getting out of sync with the parent page.
// This is not possible from cross-origin iframes, in which case the default refresh action must be hidden.
function $9e22e384b00acf1d$export$c93f0f69085868df() {
    try {
        // In cross-origin iframes, accessing top.location can throw a SecurityError.
        $9e22e384b00acf1d$var$getTopWindow().location.href;
        return true;
    } catch  {
        return false;
    }
}
function $9e22e384b00acf1d$export$c8f9b9f45948a74c() {
    try {
        $9e22e384b00acf1d$var$getTopWindow().location.reload();
    } catch  {
    // noop
    }
}
// In browsers, window.top is always defined, but it is treated as optional by our current DOM types.
function $9e22e384b00acf1d$var$getTopWindow() {
    var _a;
    return (_a = window.top) !== null && _a !== void 0 ? _a : window;
}



var $880fc00bff0539b7$export$2e2bcd8739ae039 = {
    "error-boundary": "awsui_error-boundary_9pwoq_r5exj_5",
    "header": "awsui_header_9pwoq_r5exj_6",
    "description": "awsui_description_9pwoq_r5exj_7",
    "action": "awsui_action_9pwoq_r5exj_8"
};



var $e44df854188bc919$export$2e2bcd8739ae039 = {
    "fallback": "awsui_fallback_11u4a_1e43p_5",
    "feedback-action": "awsui_feedback-action_11u4a_1e43p_6",
    "refresh-action": "awsui_refresh-action_11u4a_1e43p_7",
    "header": "awsui_header_11u4a_1e43p_8",
    "description": "awsui_description_11u4a_1e43p_9",
    "action": "awsui_action_11u4a_1e43p_10"
};


function $fc251c26f75d93fa$export$8a28b7e38e4685dd({ i18nStrings: i18nStrings = {}, renderFallback: renderFallback, ...props }) {
    var _a;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const defaultSlots = {
        header: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $880fc00bff0539b7$export$2e2bcd8739ae039).header, (0, $e44df854188bc919$export$2e2bcd8739ae039).header)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fc251c26f75d93fa$var$DefaultHeaderContent, {
            i18nStrings: i18nStrings
        })),
        description: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $880fc00bff0539b7$export$2e2bcd8739ae039).description, (0, $e44df854188bc919$export$2e2bcd8739ae039).description)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fc251c26f75d93fa$var$DefaultDescriptionContent, {
            i18nStrings: i18nStrings
        })),
        action: (0, $9e22e384b00acf1d$export$c93f0f69085868df)() ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $880fc00bff0539b7$export$2e2bcd8739ae039).action, (0, $e44df854188bc919$export$2e2bcd8739ae039).action)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fc251c26f75d93fa$var$DefaultActionContent, {
            i18nStrings: i18nStrings
        })) : null
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $e44df854188bc919$export$2e2bcd8739ae039).fallback)
    }, (_a = renderFallback === null || renderFallback === void 0 ? void 0 : renderFallback(defaultSlots)) !== null && _a !== void 0 ? _a : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0572c3fe95cef167$export$2e2bcd8739ae039), {
        type: "error",
        header: defaultSlots.header,
        action: defaultSlots.action
    }, defaultSlots.description));
}
function $fc251c26f75d93fa$var$DefaultHeaderContent({ i18nStrings: i18nStrings }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('error-boundary');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, i18n('i18nStrings.headerText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.headerText));
}
function $fc251c26f75d93fa$var$DefaultDescriptionContent({ i18nStrings: { descriptionText: descriptionText, components: { Feedback: Feedback } = {} } = {} }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('error-boundary');
    // Dependencies for the intl-format function, where the pseudo-tags are declared as functions from parsed chunks.
    const formatArgs = Feedback ? {
        hasFeedback: true,
        Feedback: (chunks)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $e44df854188bc919$export$2e2bcd8739ae039)['feedback-action']
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Feedback, null, (_a = chunks[0]) !== null && _a !== void 0 ? _a : ''));
        }
    } : {
        hasFeedback: false,
        Feedback: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null)
    };
    // This ensures that the description string provided via i18nStrings also supports the <Feedback> injection,
    // because the i18n() helper propagates the second argument as is, without applying intl-format to it.
    // We wrap the format with try-catch to avoid intl errors caused by incorrectly referenced components.
    function safeFormat(descriptionText) {
        try {
            return descriptionText ? new (0, $693d63d2fb891c85$export$2e2bcd8739ae039)(descriptionText).format(formatArgs) : undefined;
        } catch  {
            return descriptionText;
        }
    }
    const message = i18n('i18nStrings.descriptionText', safeFormat(descriptionText), (format)=>format(formatArgs));
    // When the description includes <Feedback>, then the translated message is represented as an array of strings and
    // React elements that require keys when rendering to avoid React warnings.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Array.isArray(message) ? message.map((chunk, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, chunk)) : message);
}
function $fc251c26f75d93fa$var$DefaultActionContent({ i18nStrings: i18nStrings }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('error-boundary');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        iconName: "refresh",
        onClick: (0, $9e22e384b00acf1d$export$c8f9b9f45948a74c),
        className: (0, $e44df854188bc919$export$2e2bcd8739ae039)['refresh-action']
    }, i18n('i18nStrings.refreshActionText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.refreshActionText));
}



const $576a9d659fe56e52$var$RootSuppressed = Symbol();
const $576a9d659fe56e52$var$ErrorBoundariesContext = (0, $acw62.createContext)({
    onError: ()=>{},
    suppressed: $576a9d659fe56e52$var$RootSuppressed
});
function $576a9d659fe56e52$export$21015b20e314a601({ children: children, suppressNested: suppressNested, suppressible: suppressible, __internalRootRef: __internalRootRef, ...props }) {
    const context = (0, $acw62.useContext)($576a9d659fe56e52$var$ErrorBoundariesContext);
    const thisSuppressed = context.suppressed === true && suppressible;
    const nextSuppressed = suppressNested || thisSuppressed;
    const [forcedError, setForcedError] = (0, $acw62.useState)(false);
    const setElement = (node)=>{
        if (node) {
            if (!node.__awsui__) node.__awsui__ = {};
            node.__awsui__.forceError = ()=>setForcedError(true);
            node.__awsui__.clearForcedError = ()=>setForcedError(false);
        }
    };
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(setElement, __internalRootRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: mergedRef,
        className: (0, $880fc00bff0539b7$export$2e2bcd8739ae039)['error-boundary'],
        "data-awsui-boundary-id": props.errorBoundaryId
    }, !thisSuppressed ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($576a9d659fe56e52$var$ErrorBoundaryImpl, {
        ...props,
        forcedError: forcedError
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($576a9d659fe56e52$var$ErrorBoundariesContext.Provider, {
        value: {
            ...props,
            suppressed: nextSuppressed
        }
    }, children)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children));
}
function $576a9d659fe56e52$export$757d89c03059dd35({ wrapper: wrapper, suppressNested: suppressNested = false, children: children }) {
    const context = (0, $acw62.useContext)($576a9d659fe56e52$var$ErrorBoundariesContext);
    const thisSuppressed = context.suppressed === true || context.suppressed === $576a9d659fe56e52$var$RootSuppressed;
    const nextSuppressed = suppressNested || thisSuppressed;
    return !thisSuppressed ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($576a9d659fe56e52$var$ErrorBoundaryImpl, {
        ...context,
        wrapper: wrapper
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($576a9d659fe56e52$var$ErrorBoundariesContext.Provider, {
        value: {
            ...context,
            suppressed: nextSuppressed
        }
    }, children)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
}
class $576a9d659fe56e52$var$ErrorBoundaryImpl extends (0, $acw62.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        var _a, _b;
        (_b = (_a = this.props).onError) === null || _b === void 0 || _b.call(_a, {
            error: error,
            errorInfo: errorInfo,
            errorBoundaryId: this.props.errorBoundaryId
        });
    }
    render() {
        var _a, _b, _c;
        if (this.state.hasError || this.props.forcedError) {
            const fallback = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc251c26f75d93fa$export$8a28b7e38e4685dd), {
                ...this.props
            });
            return (_c = (_b = (_a = this.props).wrapper) === null || _b === void 0 ? void 0 : _b.call(_a, fallback)) !== null && _c !== void 0 ? _c : fallback;
        }
        return this.props.children;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $e2ccc16116876f8a$export$2e2bcd8739ae039 = {
    "root": "awsui_root_oip5a_160mh_5"
};


function $de7ebe5c886b994d$export$2e2bcd8739ae039({ focusNextCallback: focusNextCallback, disabled: disabled = false }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $e2ccc16116876f8a$export$2e2bcd8739ae039).root,
        tabIndex: disabled ? -1 : 0,
        onFocus: focusNextCallback
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Credits to
// https://github.com/theKashey/focus-lock/blob/33f8b4bd9675d2605b15e2e4015b77fe35fbd6d0/src/utils/tabbables.ts
const $eaddf2de854ee801$var$tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
].join(',');
/** Whether the element or any of its ancestors are not hidden. */ function $eaddf2de854ee801$var$isVisible(element) {
    if (!('checkVisibility' in element)) // checkVisibility isn't defined in JSDOM. It's safer to assume everything is visible.
    return true;
    // checkVisibility is only defined on element in Typescript 5+
    // See https://github.com/puppeteer/puppeteer/issues/11059
    return element.checkVisibility({
        visibilityProperty: true
    });
}
function $eaddf2de854ee801$export$4c063cf1350e6fed(element) {
    return element.matches($eaddf2de854ee801$var$tabbables) && $eaddf2de854ee801$var$isVisible(element);
}
function $eaddf2de854ee801$export$3fcce23e1e72b35b(container) {
    return Array.from(container.querySelectorAll($eaddf2de854ee801$var$tabbables)).filter($eaddf2de854ee801$var$isVisible);
}
/** Get all focusable elements that can be reached with the keyboard. */ function $eaddf2de854ee801$var$getAllTabbables(container) {
    return $eaddf2de854ee801$export$3fcce23e1e72b35b(container).filter((element)=>element.tabIndex !== -1);
}
function $eaddf2de854ee801$export$748138f04a69bf21(container) {
    var _a;
    const tabbables = $eaddf2de854ee801$var$getAllTabbables(container);
    return (_a = tabbables[0]) !== null && _a !== void 0 ? _a : null;
}
function $eaddf2de854ee801$export$73e81fa65335a75b(container) {
    var _a;
    const tabbables = $eaddf2de854ee801$var$getAllTabbables(container);
    return (_a = tabbables[tabbables.length - 1]) !== null && _a !== void 0 ? _a : null;
}


function $48646398710f9406$var$FocusLock({ className: className, disabled: disabled, autoFocus: autoFocus, restoreFocus: restoreFocus, children: children }, ref) {
    const restoreFocusTargetRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $acw62.useRef)(null);
    const focusFirst = ()=>{
        var _a;
        if (containerRef.current) (_a = (0, $eaddf2de854ee801$export$748138f04a69bf21)(containerRef.current)) === null || _a === void 0 || _a.focus();
    };
    const focusLast = ()=>{
        var _a;
        if (containerRef.current) (_a = (0, $eaddf2de854ee801$export$73e81fa65335a75b)(containerRef.current)) === null || _a === void 0 || _a.focus();
    };
    // Captures focus when `autoFocus` is set, and the component is mounted or
    // `disabled` changes from true to false.
    (0, $acw62.useEffect)(()=>{
        const assignRestoreFocusTarget = ()=>{
            var _a;
            if (document.activeElement && !((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))) restoreFocusTargetRef.current = document.activeElement;
        };
        if (autoFocus && !disabled) {
            assignRestoreFocusTarget();
            focusFirst();
        }
    }, [
        autoFocus,
        disabled
    ]);
    // Restore focus if `restoreFocus` is set, and `disabled` changes from false to true.
    const [previouslyDisabled, setPreviouslyDisabled] = (0, $acw62.useState)(!!disabled);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (previouslyDisabled !== !!disabled) {
            setPreviouslyDisabled(!!disabled);
            if (restoreFocus && disabled) {
                (_a = restoreFocusTargetRef.current) === null || _a === void 0 || _a.focus();
                restoreFocusTargetRef.current = null;
            }
        }
    }, [
        previouslyDisabled,
        disabled,
        restoreFocus
    ]);
    // Restore focus if `restoreFocus` is set and the component is unmounted.
    // Using a callback ref for this is safer than using useEffect cleanups.
    const restoreFocusHandler = (0, $acw62.useCallback)((elem)=>{
        var _a;
        if (elem === null && restoreFocus) {
            (_a = restoreFocusTargetRef.current) === null || _a === void 0 || _a.focus();
            restoreFocusTargetRef.current = null;
        }
    }, [
        restoreFocus
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focusFirst: focusFirst
        }));
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(containerRef, restoreFocusHandler);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
        disabled: disabled,
        focusNextCallback: focusLast
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        ref: mergedRef
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
        disabled: disabled,
        focusNextCallback: focusFirst
    }));
}
var $48646398710f9406$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($48646398710f9406$var$FocusLock);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// When updating the list of key codes, don't forget
// to modify corresponding list in test-utils
// to avoid failing unit tests
var $bb11bd44b752b968$export$e9e0d96f49f57c33;
(function(KeyCode) {
    KeyCode[KeyCode["pageUp"] = 33] = "pageUp";
    KeyCode[KeyCode["pageDown"] = 34] = "pageDown";
    KeyCode[KeyCode["end"] = 35] = "end";
    KeyCode[KeyCode["home"] = 36] = "home";
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["down"] = 40] = "down";
    KeyCode[KeyCode["left"] = 37] = "left";
    KeyCode[KeyCode["right"] = 39] = "right";
    KeyCode[KeyCode["up"] = 38] = "up";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["tab"] = 9] = "tab";
})($bb11bd44b752b968$export$e9e0d96f49f57c33 || ($bb11bd44b752b968$export$e9e0d96f49f57c33 = {}));



const $763097fcb7ec031e$var$PopoverBody = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ dismissButton: showDismissButton, dismissAriaLabel: dismissAriaLabel, header: header, children: children, onDismiss: onDismiss, onBlur: onBlur, variant: variant, overflowVisible: overflowVisible, className: className, ariaLabelledby: ariaLabelledby, closeAnalyticsAction: closeAnalyticsAction }, ref)=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('popover');
    const labelledById = (0, $013a2451794a45c0$exports.useUniqueId)('awsui-popover-');
    const dismissButtonFocused = (0, $acw62.useRef)(false);
    const dismissButtonRef = (0, $acw62.useRef)(null);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape) {
            event.stopPropagation();
            onDismiss === null || onDismiss === void 0 || onDismiss('escape');
        }
    }, [
        onDismiss
    ]);
    // Implement our own auto-focus rather than using FocusLock's,
    // because we also want to focus the dismiss button when it
    // is added dynamically (e.g. in chart popovers)
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (showDismissButton && !dismissButtonFocused.current) (_a = dismissButtonRef.current) === null || _a === void 0 || _a.focus({
            preventScroll: true
        });
        dismissButtonFocused.current = showDismissButton;
    }, [
        showDismissButton
    ]);
    const dismissButton = (showDismissButton !== null && showDismissButton !== void 0 ? showDismissButton : null) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039).dismiss,
        ...closeAnalyticsAction ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: closeAnalyticsAction
        }) : {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        variant: "icon",
        formAction: "none",
        iconName: "close",
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039)['dismiss-control'],
        ariaLabel: i18n('dismissAriaLabel', dismissAriaLabel),
        onClick: ()=>onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss('close-button'),
        ref: dismissButtonRef
    }));
    const isDialog = showDismissButton;
    const shouldTrapFocus = showDismissButton && variant !== 'annotation';
    const dialogProps = isDialog ? {
        role: 'dialog',
        'aria-labelledby': ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : header ? labelledById : undefined
    } : {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).body, (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`body-variant-${variant}`], className, {
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)['body-overflow-visible']]: overflowVisible === 'both'
        }),
        onKeyDown: onKeyDown,
        ref: ref,
        onBlur: onBlur,
        ...dialogProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        disabled: !shouldTrapFocus,
        autoFocus: false
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)['header-row'], showDismissButton && (0, $350807ffd27dc31c$export$2e2bcd8739ae039)['has-dismiss'])
    }, dismissButton, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039).header,
        id: labelledById
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", null, header))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: !header && showDismissButton ? (0, $350807ffd27dc31c$export$2e2bcd8739ae039)['has-dismiss'] : undefined
    }, !header && dismissButton, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).content, {
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)['content-overflow-visible']]: !!overflowVisible
        })
    }, children)))));
});
var $763097fcb7ec031e$export$2e2bcd8739ae039 = $763097fcb7ec031e$var$PopoverBody;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $1yiQH = parcelRequire("1yiQH");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1yiQH = parcelRequire("1yiQH");
const $24d40242cc6554ee$export$f32edd573b1049e6 = (element)=>{
    const parents = [];
    let node = element;
    while((node = node.parentElement) && node !== element.ownerDocument.body)if (getComputedStyle(node).overflow !== 'visible') parents.push(node);
    return parents;
};
const $24d40242cc6554ee$export$788cd595d1360cb2 = ({ element: element, excludeClosestParent: excludeClosestParent = false, expandToViewport: expandToViewport = false, canExpandOutsideViewport: canExpandOutsideViewport = false })=>{
    var _a, _b, _c, _d, _e;
    const parents = expandToViewport ? [] : $24d40242cc6554ee$export$f32edd573b1049e6(element).map((el)=>{
        const { height: height, width: width, top: top, left: left } = el.getBoundingClientRect();
        return {
            // Treat the whole scrollable area as the available height
            // if we're allowed to expand past the viewport.
            blockSize: canExpandOutsideViewport ? el.scrollHeight : height,
            inlineSize: width,
            insetBlockStart: top,
            insetInlineStart: left
        };
    });
    if (canExpandOutsideViewport && !expandToViewport) {
        const document = element.ownerDocument;
        const documentDimensions = document.documentElement.getBoundingClientRect();
        parents.push({
            inlineSize: Math.max(documentDimensions.width, document.documentElement.clientWidth),
            blockSize: Math.max(documentDimensions.height, document.documentElement.clientHeight),
            insetBlockStart: documentDimensions.top,
            insetInlineStart: documentDimensions.left
        });
    } else {
        const owningWindow = (_a = element.ownerDocument.defaultView) !== null && _a !== void 0 ? _a : window;
        parents.push({
            blockSize: (_c = (_b = owningWindow.visualViewport) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : owningWindow.innerHeight,
            inlineSize: (_e = (_d = owningWindow.visualViewport) === null || _d === void 0 ? void 0 : _d.width) !== null && _e !== void 0 ? _e : owningWindow.innerWidth,
            insetBlockStart: 0,
            insetInlineStart: 0
        });
    }
    if (excludeClosestParent && !expandToViewport) parents.shift();
    return parents;
};
function $24d40242cc6554ee$export$a904af9c1628c179(element, options = {
    block: 'nearest',
    inline: 'nearest'
}) {
    var _a;
    (_a = element === null || element === void 0 ? void 0 : element.scrollIntoView) === null || _a === void 0 || _a.call(element, options);
}
function $24d40242cc6554ee$export$9f07ffdb65d93a3a({ insetBlockStart: insetBlockStart, blockSize: blockSize }) {
    if (insetBlockStart < 0) return insetBlockStart;
    else if (insetBlockStart + blockSize > window.innerHeight) {
        if (blockSize > window.innerHeight) return insetBlockStart;
        else return insetBlockStart + blockSize - window.innerHeight;
    }
    return 0;
}
function $24d40242cc6554ee$export$daa0070c3a783245(box, scrollableParent) {
    const scrollAmount = $24d40242cc6554ee$export$9f07ffdb65d93a3a(box);
    if (scrollAmount) (scrollableParent || window).scrollBy(0, scrollAmount);
}
function $24d40242cc6554ee$export$421df48f39898a3d(element) {
    return (0, $1yiQH.findUpUntil)(element, (el)=>{
        const overflows = el.scrollHeight > el.clientHeight;
        return overflows && [
            'scroll',
            'auto'
        ].includes(getComputedStyle(el).overflowY);
    }) || undefined;
}


const $6bb895fb37385d1b$var$ARROW_OFFSET = 12;
const $6bb895fb37385d1b$export$75ff5b418e887e52 = {
    top: [
        'top-center',
        'top-right',
        'top-left',
        'bottom-center',
        'bottom-right',
        'bottom-left',
        'right-top',
        'right-bottom',
        'left-top',
        'left-bottom'
    ],
    bottom: [
        'bottom-center',
        'bottom-right',
        'bottom-left',
        'top-center',
        'top-right',
        'top-left',
        'right-top',
        'right-bottom',
        'left-top',
        'left-bottom'
    ],
    left: [
        'left-top',
        'left-bottom',
        'right-top',
        'right-bottom',
        'bottom-center',
        'top-center',
        'bottom-left',
        'top-left',
        'bottom-right',
        'top-right'
    ],
    right: [
        'right-top',
        'right-bottom',
        'left-top',
        'left-bottom',
        'bottom-center',
        'top-center',
        'bottom-right',
        'top-right',
        'bottom-left',
        'top-left'
    ]
};
const $6bb895fb37385d1b$var$RECTANGLE_CALCULATIONS = {
    'top-center': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - body.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'top-right': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'top-left': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.inlineSize / 2 - body.inlineSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'bottom-center': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - body.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'bottom-right': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'bottom-left': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.inlineSize / 2 - body.inlineSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'right-top': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize + arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'right-bottom': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - body.blockSize + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize + arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'left-top': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart - body.inlineSize - arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    'left-bottom': ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - body.blockSize + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart - body.inlineSize - arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    }
};
function $6bb895fb37385d1b$var$fitIntoContainer(inner, outer) {
    let { insetInlineStart: insetInlineStart, inlineSize: inlineSize, insetBlockStart: insetBlockStart, blockSize: blockSize } = inner;
    // Adjust left boundary.
    if (insetInlineStart < outer.insetInlineStart) {
        inlineSize = insetInlineStart + inlineSize - outer.insetInlineStart;
        insetInlineStart = outer.insetInlineStart;
    } else if (insetInlineStart + inlineSize > outer.insetInlineStart + outer.inlineSize) inlineSize = outer.insetInlineStart + outer.inlineSize - insetInlineStart;
    // Adjust top boundary.
    if (insetBlockStart < outer.insetBlockStart) {
        blockSize = insetBlockStart + blockSize - outer.insetBlockStart;
        insetBlockStart = outer.insetBlockStart;
    } else if (insetBlockStart + blockSize > outer.insetBlockStart + outer.blockSize) blockSize = outer.insetBlockStart + outer.blockSize - insetBlockStart;
    return {
        insetInlineStart: insetInlineStart,
        inlineSize: inlineSize,
        insetBlockStart: insetBlockStart,
        blockSize: blockSize
    };
}
function $6bb895fb37385d1b$var$getTallestRect(rect1, rect2) {
    return rect1.blockSize >= rect2.blockSize ? rect1 : rect2;
}
function $6bb895fb37385d1b$var$getIntersection(rectangles) {
    let boundingBox = null;
    for (const currentRect of rectangles){
        if (!boundingBox) {
            boundingBox = currentRect;
            continue;
        }
        const insetInlineStart = Math.max(boundingBox.insetInlineStart, currentRect.insetInlineStart);
        const insetBlockStart = Math.max(boundingBox.insetBlockStart, currentRect.insetBlockStart);
        const insetInlineEnd = Math.min(boundingBox.insetInlineStart + boundingBox.inlineSize, currentRect.insetInlineStart + currentRect.inlineSize);
        const insetBlockEnd = Math.min(boundingBox.insetBlockStart + boundingBox.blockSize, currentRect.insetBlockStart + currentRect.blockSize);
        if (insetInlineEnd < insetInlineStart || insetBlockEnd < insetBlockStart) return null;
        boundingBox = {
            insetInlineStart: insetInlineStart,
            insetBlockStart: insetBlockStart,
            inlineSize: insetInlineEnd - insetInlineStart,
            blockSize: insetBlockEnd - insetBlockStart
        };
    }
    return boundingBox;
}
function $6bb895fb37385d1b$export$3c843d0917c4676c(rectangles) {
    const boundingBox = $6bb895fb37385d1b$var$getIntersection(rectangles);
    return boundingBox && boundingBox.blockSize * boundingBox.inlineSize;
}
function $6bb895fb37385d1b$export$b3ceb0cbf1056d98({ preferredPosition: preferredPosition, fixedInternalPosition: fixedInternalPosition, trigger: trigger, arrow: arrow, body: body, container: container, viewport: viewport, renderWithPortal: // the popover is only bound by the viewport if it is rendered in a portal
renderWithPortal, allowVerticalOverflow: allowVerticalOverflow, minVisibleBlockSize: minVisibleBlockSize }) {
    let bestOption = null;
    // If a fixed internal position is passed, only consider this one.
    const preferredInternalPositions = fixedInternalPosition ? [
        fixedInternalPosition
    ] : $6bb895fb37385d1b$export$75ff5b418e887e52[preferredPosition];
    // Attempt to position the popover based on the priority list for this position.
    for (const internalPosition of preferredInternalPositions){
        const rect = $6bb895fb37385d1b$var$RECTANGLE_CALCULATIONS[internalPosition]({
            body: body,
            trigger: trigger,
            arrow: arrow
        });
        const visibleArea = renderWithPortal ? $6bb895fb37385d1b$var$getIntersection([
            rect,
            viewport
        ]) : $6bb895fb37385d1b$var$getIntersection([
            rect,
            viewport,
            container
        ]);
        // When min visible block size is set, the popover is considered fitting the container if the available space
        // is the same or larger than min allowed, even if it means the scrollbar is needed.
        const fitsBlockSize = minVisibleBlockSize === undefined ? visibleArea && visibleArea.blockSize === body.blockSize : visibleArea && visibleArea.blockSize >= Math.min(body.blockSize, minVisibleBlockSize);
        const fitsInlineSize = visibleArea && visibleArea.inlineSize === body.inlineSize;
        if (fitsBlockSize && fitsInlineSize) {
            const scrollable = visibleArea && visibleArea.blockSize < body.blockSize;
            return {
                internalPosition: internalPosition,
                rect: scrollable ? $6bb895fb37385d1b$var$fitIntoContainer(rect, viewport) : rect,
                scrollable: scrollable
            };
        }
        const newOption = {
            rect: rect,
            internalPosition: internalPosition,
            visibleArea: visibleArea
        };
        bestOption = $6bb895fb37385d1b$var$getBestOption(newOption, bestOption);
    }
    // Use best possible placement.
    const internalPosition = (bestOption === null || bestOption === void 0 ? void 0 : bestOption.internalPosition) || 'right-top';
    // Get default rect for that placement.
    const rect = $6bb895fb37385d1b$var$RECTANGLE_CALCULATIONS[internalPosition]({
        body: body,
        trigger: trigger,
        arrow: arrow
    });
    // Get largest possible rect that fits into the viewport or container.
    // We allow the popover to overflow the viewport if allowVerticalOverflow is true _and_ the popover will be anchored to the top or the bottom.
    // If it is anchored to the right or left, we consider that it should have enough vertical space so that applying scroll to it is a better option.
    const tallestBoundingContainer = $6bb895fb37385d1b$var$getTallestRect(viewport, container);
    const boundingContainer = allowVerticalOverflow && $6bb895fb37385d1b$var$isTopOrBottom(internalPosition) ? {
        insetBlockStart: tallestBoundingContainer.insetBlockStart,
        blockSize: tallestBoundingContainer.blockSize,
        insetInlineStart: viewport.insetInlineStart,
        inlineSize: viewport.inlineSize
    } : viewport;
    const optimizedRect = $6bb895fb37385d1b$var$fitIntoContainer(rect, boundingContainer);
    // If largest possible rect is shorter than original - set body scroll.
    const scrollable = optimizedRect.blockSize < rect.blockSize;
    return {
        internalPosition: internalPosition,
        rect: optimizedRect,
        scrollable: scrollable
    };
}
function $6bb895fb37385d1b$var$getBestOption(option1, option2) {
    // Within calculatePosition, the only case where option2 will not be defined will be in the first call.
    // The only case where the visibleArea of an option will be null is when the popover is totally outside of the viewport.
    if (!(option2 === null || option2 === void 0 ? void 0 : option2.visibleArea)) return option1;
    if (!option1.visibleArea) return option2;
    // Only if none of the two options overflows horizontally, choose the best based on the visible height.
    if (option1.visibleArea.inlineSize === option2.visibleArea.inlineSize) return option1.visibleArea.blockSize > option2.visibleArea.blockSize ? option1 : option2;
    // Otherwise, choose the option that is less cut off horizontally.
    return option1.visibleArea.inlineSize > option2.visibleArea.inlineSize ? option1 : option2;
}
function $6bb895fb37385d1b$export$41aa892fb2ec05ef(element) {
    return {
        offsetHeight: element.offsetHeight,
        offsetWidth: element.offsetWidth
    };
}
function $6bb895fb37385d1b$export$d1aa971bf69c7e87(element) {
    const computedStyle = getComputedStyle(element);
    return {
        inlineSize: parseFloat(computedStyle.inlineSize),
        blockSize: parseFloat(computedStyle.blockSize)
    };
}
function $6bb895fb37385d1b$var$isTopOrBottom(internalPosition) {
    return [
        'top',
        'bottom'
    ].includes(internalPosition.split('-')[0]);
}
function $6bb895fb37385d1b$export$e310744ff62333b8(child, parent) {
    const childCenter = child.insetBlockStart + child.blockSize / 2;
    const overflowsBlockStart = childCenter < parent.insetBlockStart;
    const overflowsBlockEnd = childCenter > parent.insetBlockEnd;
    return overflowsBlockStart || overflowsBlockEnd;
}


function $45ec260cea817966$export$2e2bcd8739ae039({ popoverRef: popoverRef, bodyRef: bodyRef, arrowRef: arrowRef, getTrack: getTrack, contentRef: contentRef, allowScrollToFit: allowScrollToFit, allowVerticalOverflow: allowVerticalOverflow, preferredPosition: preferredPosition, renderWithPortal: renderWithPortal, keepPosition: keepPosition, hideOnOverscroll: hideOnOverscroll, minVisibleBlockSize: minVisibleBlockSize }) {
    const previousInternalPositionRef = (0, $acw62.useRef)(null);
    const [popoverStyle, setPopoverStyle] = (0, $acw62.useState)({});
    const [internalPosition, setInternalPosition] = (0, $acw62.useState)(null);
    const [isOverscrolling, setIsOverscrolling] = (0, $acw62.useState)(false);
    // Store the handler in a ref so that it can still be replaced from outside of the listener closure.
    const positionHandlerRef = (0, $acw62.useRef)(()=>{});
    const scrollableContainerRectRef = (0, $acw62.useRef)(null);
    const updatePositionHandler = (0, $acw62.useCallback)((onContentResize = false)=>{
        var _a;
        const track = getTrack();
        if (!track || !popoverRef.current || !bodyRef.current || !contentRef.current || !arrowRef.current) return;
        // Get important elements
        const popover = popoverRef.current;
        const body = bodyRef.current;
        const arrow = arrowRef.current;
        const document = popover.ownerDocument;
        // If the popover body isn't being rendered for whatever reason (e.g. "display: none" or JSDOM),
        // or track does not belong to the document - bail on calculating dimensions.
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = (0, $6bb895fb37385d1b$export$41aa892fb2ec05ef)(popover);
        if (offsetWidth === 0 || offsetHeight === 0 || !(0, $1yiQH.nodeContains)(document.body, track)) return;
        // Imperatively move body off-screen to give it room to expand.
        // Not doing this in React because this recalculation should happen
        // in the span of a single frame without rerendering anything.
        const prevInsetBlockStart = popover.style.insetBlockStart;
        const prevInsetInlineStart = popover.style.insetInlineStart;
        popover.style.insetBlockStart = '0';
        popover.style.insetInlineStart = '0';
        // Imperatively remove body styles that can remain from the previous computation.
        body.style.maxBlockSize = '';
        body.style.overflowX = '';
        body.style.overflowY = '';
        // Get rects representing key elements
        // Use getComputedStyle for arrowRect to avoid modifications made by transform
        const viewportRect = $45ec260cea817966$var$getViewportRect(document.defaultView);
        const trackRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(track);
        const arrowRect = (0, $6bb895fb37385d1b$export$d1aa971bf69c7e87)(arrow);
        const { containingBlock: containingBlock, boundary: boundary } = (0, $38f6480185c49d6f$export$4d2bf79134de6c3)({
            startElement: popover,
            tests: {
                containingBlock: (0, $38f6480185c49d6f$export$d6c4e8150c35fed1),
                boundary: (element)=>(0, $38f6480185c49d6f$export$d6c4e8150c35fed1)(element) || $45ec260cea817966$var$isBoundary(element)
            }
        });
        // Rectangle for the containing block, which provides the reference frame for the popover coordinates.
        const containingBlockRect = containingBlock ? (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(containingBlock) : viewportRect;
        // Rectangle outside of which the popover should not be positioned, because it would be clipped.
        const boundaryRect = boundary ? (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(boundary) : $45ec260cea817966$var$getDocumentRect(document);
        const bodyBorderWidth = $45ec260cea817966$var$getBorderWidth(body);
        const contentRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(contentRef.current);
        const contentBoundingBox = {
            inlineSize: contentRect.inlineSize + 2 * bodyBorderWidth,
            blockSize: contentRect.blockSize + 2 * bodyBorderWidth
        };
        // When keepPosition is true and the recalculation was triggered by a resize of the popover content,
        // we maintain the previously defined internal position,
        // but we still call calculatePosition to know if the popover should be scrollable.
        const shouldKeepPosition = keepPosition && onContentResize && !!previousInternalPositionRef.current;
        const fixedInternalPosition = (_a = shouldKeepPosition && previousInternalPositionRef.current) !== null && _a !== void 0 ? _a : undefined;
        // Calculate the arrow direction and viewport-relative position of the popover.
        const { scrollable: scrollable, internalPosition: newInternalPosition, rect: rect } = (0, $6bb895fb37385d1b$export$b3ceb0cbf1056d98)({
            preferredPosition: preferredPosition,
            fixedInternalPosition: fixedInternalPosition,
            trigger: trackRect,
            arrow: arrowRect,
            body: contentBoundingBox,
            container: boundaryRect,
            viewport: viewportRect,
            renderWithPortal: renderWithPortal,
            allowVerticalOverflow: allowVerticalOverflow,
            minVisibleBlockSize: minVisibleBlockSize
        });
        // Get the position of the popover relative to the containing block.
        const popoverOffset = $45ec260cea817966$var$toRelativePosition(rect, containingBlockRect);
        // Cache the distance between the trigger and the popover (which stays the same as you scroll),
        // and use that to recalculate the new popover position.
        const trackRelativeOffset = $45ec260cea817966$var$toRelativePosition(popoverOffset, $45ec260cea817966$var$toRelativePosition(trackRect, containingBlockRect));
        // Bring back the container to its original position to prevent any flashing.
        popover.style.insetBlockStart = prevInsetBlockStart;
        popover.style.insetInlineStart = prevInsetInlineStart;
        // Allow popover body to scroll if can't fit the popover into the container/viewport otherwise.
        if (scrollable) {
            body.style.maxBlockSize = rect.blockSize + 'px';
            body.style.overflowX = 'hidden';
            body.style.overflowY = 'auto';
        }
        // Remember the internal position in case we want to keep it later.
        previousInternalPositionRef.current = newInternalPosition;
        setInternalPosition(newInternalPosition);
        const shouldScroll = allowScrollToFit && !shouldKeepPosition;
        // Position the popover
        const insetBlockStart = shouldScroll ? popoverOffset.insetBlockStart + (0, $24d40242cc6554ee$export$9f07ffdb65d93a3a)(rect) : popoverOffset.insetBlockStart;
        setPopoverStyle({
            insetBlockStart: insetBlockStart,
            insetInlineStart: popoverOffset.insetInlineStart
        });
        // Scroll if necessary
        if (shouldScroll) {
            const scrollableParent = (0, $24d40242cc6554ee$export$421df48f39898a3d)(popover);
            (0, $24d40242cc6554ee$export$daa0070c3a783245)(rect, scrollableParent);
        }
        if (hideOnOverscroll && track instanceof HTMLElement) {
            const scrollableContainer = (0, $24d40242cc6554ee$export$421df48f39898a3d)(track);
            if (scrollableContainer) scrollableContainerRectRef.current = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(scrollableContainer);
        }
        positionHandlerRef.current = ()=>{
            const track = getTrack();
            if (!track) return;
            const trackRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(track);
            const newTrackOffset = $45ec260cea817966$var$toRelativePosition(trackRect, containingBlock ? (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(containingBlock) : viewportRect);
            setPopoverStyle({
                insetBlockStart: newTrackOffset.insetBlockStart + trackRelativeOffset.insetBlockStart,
                insetInlineStart: newTrackOffset.insetInlineStart + trackRelativeOffset.insetInlineStart
            });
            if (hideOnOverscroll && scrollableContainerRectRef.current) // Assuming the arrow tip is at the vertical center of the popover trigger.
            // This is good enough for disabled reason tooltip in select and multiselect.
            // Can be further refined to take the exact arrow position into account if hideOnOverscroll is to be used in other cases.
            setIsOverscrolling((0, $6bb895fb37385d1b$export$e310744ff62333b8)(trackRect, scrollableContainerRectRef.current));
        };
    }, [
        getTrack,
        popoverRef,
        bodyRef,
        contentRef,
        arrowRef,
        keepPosition,
        preferredPosition,
        renderWithPortal,
        allowVerticalOverflow,
        allowScrollToFit,
        hideOnOverscroll,
        minVisibleBlockSize
    ]);
    return {
        updatePositionHandler: updatePositionHandler,
        popoverStyle: popoverStyle,
        internalPosition: internalPosition,
        positionHandlerRef: positionHandlerRef,
        isOverscrolling: isOverscrolling
    };
}
function $45ec260cea817966$var$getBorderWidth(element) {
    return parseInt(getComputedStyle(element).borderWidth) || 0;
}
/**
 * Convert a viewport-relative offset to an element-relative offset.
 */ function $45ec260cea817966$var$toRelativePosition(element, parent) {
    return {
        insetBlockStart: element.insetBlockStart - parent.insetBlockStart,
        insetInlineStart: element.insetInlineStart - parent.insetInlineStart
    };
}
/**
 * Get a BoundingBox that represents the visible viewport.
 */ function $45ec260cea817966$var$getViewportRect(window) {
    var _a, _b, _c, _d;
    return {
        insetBlockStart: 0,
        insetInlineStart: 0,
        inlineSize: (_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : window.innerWidth,
        blockSize: (_d = (_c = window.visualViewport) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : window.innerHeight
    };
}
function $45ec260cea817966$var$getDocumentRect(document) {
    const { insetBlockStart: insetBlockStart, insetInlineStart: insetInlineStart } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(document.documentElement);
    return {
        insetBlockStart: insetBlockStart,
        insetInlineStart: insetInlineStart,
        inlineSize: document.documentElement.scrollWidth,
        blockSize: document.documentElement.scrollHeight
    };
}
function $45ec260cea817966$var$isBoundary(element) {
    const computedStyle = getComputedStyle(element);
    return !!computedStyle.clipPath && computedStyle.clipPath !== 'none';
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/* istanbul ignore file - Tested with integration tests */ 
var $acw62 = parcelRequire("acw62");

function $d4dd2bb668ac24ae$export$2e2bcd8739ae039(getTrack, trackKey, callback) {
    const stableCallback = (0, $013a2451794a45c0$exports.useStableCallback)(callback);
    (0, $acw62.useEffect)(()=>{
        const track = getTrack();
        if (!track) return;
        let lastTrackKey = trackKey;
        let lastPosition = {
            x: track.getBoundingClientRect().x,
            y: track.getBoundingClientRect().y
        };
        const observer = new MutationObserver(()=>{
            const track = getTrack();
            if (!track) return;
            const { x: x, y: y } = track.getBoundingClientRect();
            // Only trigger the callback when the position changes or the track key changes
            if (x !== lastPosition.x || y !== lastPosition.y || trackKey !== lastTrackKey) {
                lastTrackKey = trackKey;
                lastPosition = {
                    x: x,
                    y: y
                };
                stableCallback();
            }
        });
        // Observe the entire ownerDocument for DOM changes
        observer.observe(track.ownerDocument, {
            attributes: true,
            subtree: true,
            childList: true
        });
        return ()=>observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getTrack,
        stableCallback
    ]); // trackKey excluded to avoid the observer being recreated everytime the value changes, causing rendering issues for Tooltip
}



function $129a117414eb7922$export$2e2bcd8739ae039({ position: position, trackRef: trackRef, getTrack: externalGetTrack, trackKey: trackKey, minVisibleBlockSize: minVisibleBlockSize, arrow: arrow, children: children, zIndex: zIndex, renderWithPortal: renderWithPortal, size: size, fixedWidth: fixedWidth, variant: variant, keepPosition: keepPosition, allowScrollToFit: allowScrollToFit, allowVerticalOverflow: allowVerticalOverflow, hideOnOverscroll: hideOnOverscroll, hoverArea: hoverArea, className: className }) {
    const bodyRef = (0, $acw62.useRef)(null);
    const contentRef = (0, $acw62.useRef)(null);
    const popoverRef = (0, $acw62.useRef)(null);
    const arrowRef = (0, $acw62.useRef)(null);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const getTrack = (0, $acw62.useRef)(()=>{
        if (trackRef) return trackRef.current;
        if (externalGetTrack) return externalGetTrack();
        throw new Error('Invariant violation: must provide either trackRef or getTrack.');
    });
    // Updates the position handler.
    const { updatePositionHandler: updatePositionHandler, popoverStyle: popoverStyle, internalPosition: internalPosition, positionHandlerRef: positionHandlerRef, isOverscrolling: isOverscrolling } = (0, $45ec260cea817966$export$2e2bcd8739ae039)({
        popoverRef: popoverRef,
        bodyRef: bodyRef,
        arrowRef: arrowRef,
        getTrack: getTrack.current,
        contentRef: contentRef,
        allowScrollToFit: allowScrollToFit,
        allowVerticalOverflow: allowVerticalOverflow,
        preferredPosition: position,
        renderWithPortal: renderWithPortal,
        keepPosition: keepPosition,
        hideOnOverscroll: hideOnOverscroll,
        minVisibleBlockSize: minVisibleBlockSize
    });
    // Recalculate position when properties change.
    (0, $acw62.useLayoutEffect)(()=>{
        updatePositionHandler();
    }, [
        updatePositionHandler,
        trackKey
    ]);
    // Recalculate position when content size changes.
    (0, $013a2451794a45c0$exports.useResizeObserver)(contentRef, ()=>{
        updatePositionHandler(true);
    });
    // Recalculate position when the DOM changes.
    // istanbul ignore next - tested via integration tests
    (0, $d4dd2bb668ac24ae$export$2e2bcd8739ae039)(getTrack.current, trackKey, ()=>{
        // Do not update position if popover moved offscreen
        const popoverOffset = popoverRef.current && (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(popoverRef.current);
        if (!popoverOffset || popoverOffset.insetBlockStart < 0 || popoverOffset.insetBlockEnd > window.innerHeight) return;
        positionHandlerRef.current();
    });
    // Recalculate position on resize or scroll events.
    (0, $acw62.useLayoutEffect)(()=>{
        const controller = new AbortController();
        const updatePositionOnResize = ()=>requestAnimationFrame(()=>updatePositionHandler(true));
        const refreshPosition = ()=>requestAnimationFrame(()=>positionHandlerRef.current());
        window.addEventListener('resize', updatePositionOnResize, {
            signal: controller.signal
        });
        window.addEventListener('scroll', refreshPosition, {
            capture: true,
            signal: controller.signal
        });
        return ()=>{
            controller.abort();
        };
    }, [
        hideOnOverscroll,
        keepPosition,
        positionHandlerRef,
        trackRef,
        updatePositionHandler
    ]);
    return isOverscrolling ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popoverRef,
        style: {
            ...popoverStyle,
            zIndex: zIndex
        },
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).container, isRefresh && (0, $350807ffd27dc31c$export$2e2bcd8739ae039).refresh, className)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: arrowRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-arrow`], (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-arrow-position-${internalPosition}`]),
        "aria-hidden": true
    }, arrow(internalPosition)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: bodyRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)['container-body'], (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-body-size-${size}`], {
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)['fixed-width']]: fixedWidth,
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-body-variant-${variant}`]]: variant
        })
    }, hoverArea ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039)['hover-area']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: contentRef
    }, children)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: contentRef
    }, children)));
}



var $9fbff412cdcfb53a$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1u26h_im8v7_5"
};


function $2c45f0c9feef90f6$export$2e2bcd8739ae039({ content: content, getTrack: getTrack, className: className, position: position = 'top', onEscape: onEscape, __internalRootRef: __internalRootRef, ...restProps }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const trackRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Update the ref with the current tracked element
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const element = getTrack();
        trackRef.current = element;
    }, [
        getTrack
    ]);
    (0, $acw62.useEffect)(()=>{
        const controller = new AbortController();
        window.addEventListener('keydown', (event)=>{
            if (event.key === 'Escape') {
                // Prevent any surrounding modals or dialogs from acting on this Esc.
                event.stopPropagation();
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onEscape);
            }
        }, {
            // The tooltip is often activated on mouseover, which means the focus can
            // be anywhere else on the page. Capture also means that this gets called
            // before any wrapper modals or dialogs can detect it and act on it.
            capture: true,
            signal: controller.signal
        });
        return ()=>{
            controller.abort();
        };
    }, [
        onEscape
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $9fbff412cdcfb53a$export$2e2bcd8739ae039).root, baseProps.className),
        ref: __internalRootRef,
        role: "tooltip"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: true
    }, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
            getTrack: getTrack,
            size: "medium",
            fixedWidth: false,
            position: position,
            zIndex: 7000,
            arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b971696cf22f0db1$export$2e2bcd8739ae039), {
                    position: position
                }),
            hideOnOverscroll: true,
            className: className
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
            dismissButton: false,
            dismissAriaLabel: undefined,
            onDismiss: undefined,
            header: undefined
        }, content)))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $7a3ef8fc211697e7$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1612d_g094d_183",
    "spinner-rotator": "awsui_spinner-rotator_1612d_g094d_1",
    "size-normal": "awsui_size-normal_1612d_g094d_198",
    "size-big": "awsui_size-big_1612d_g094d_206",
    "size-large": "awsui_size-large_1612d_g094d_214",
    "variant-normal": "awsui_variant-normal_1612d_g094d_222",
    "variant-disabled": "awsui_variant-disabled_1612d_g094d_225",
    "variant-inverted": "awsui_variant-inverted_1612d_g094d_228",
    "circle": "awsui_circle_1612d_g094d_240",
    "circle-left": "awsui_circle-left_1612d_g094d_268",
    "spinner-line-left": "awsui_spinner-line-left_1612d_g094d_1",
    "circle-right": "awsui_circle-right_1612d_g094d_273",
    "spinner-line-right": "awsui_spinner-line-right_1612d_g094d_1"
};


function $1101525b84777b8e$export$2e2bcd8739ae039({ size: size = 'normal', variant: variant = 'normal', nativeAttributes: nativeAttributes, __internalRootRef: __internalRootRef, ...props }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    (0, $bd3a651d3c4436d1$export$b155a71460610994)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...baseProps,
        tag: "span",
        componentName: "Spinner",
        nativeAttributes: nativeAttributes,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039).root, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)[`size-${size}`], (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)[`variant-${variant}`]),
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7a3ef8fc211697e7$export$2e2bcd8739ae039).circle, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)['circle-left'])
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7a3ef8fc211697e7$export$2e2bcd8739ae039).circle, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)['circle-right'])
    }));
}



var $e49660893c408df4$export$2e2bcd8739ae039 = {
    "content": "awsui_content_vjswe_19xwk_153",
    "button": "awsui_button_vjswe_19xwk_157",
    "variant-normal": "awsui_variant-normal_vjswe_19xwk_206",
    "disabled": "awsui_disabled_vjswe_19xwk_227",
    "variant-primary": "awsui_variant-primary_vjswe_19xwk_235",
    "variant-link": "awsui_variant-link_vjswe_19xwk_264",
    "variant-icon": "awsui_variant-icon_vjswe_19xwk_293",
    "variant-inline-icon": "awsui_variant-inline-icon_vjswe_19xwk_322",
    "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_19xwk_351",
    "variant-inline-link": "awsui_variant-inline-link_vjswe_19xwk_380",
    "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_19xwk_413",
    "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_19xwk_442",
    "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_19xwk_471",
    "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_19xwk_505",
    "button-no-text": "awsui_button-no-text_vjswe_19xwk_601",
    "button-no-wrap": "awsui_button-no-wrap_vjswe_19xwk_605",
    "full-width": "awsui_full-width_vjswe_19xwk_608",
    "icon-left": "awsui_icon-left_vjswe_19xwk_630",
    "icon-right": "awsui_icon-right_vjswe_19xwk_635",
    "icon": "awsui_icon_vjswe_19xwk_630",
    "link": "awsui_link_vjswe_19xwk_654",
    "disabled-with-reason": "awsui_disabled-with-reason_vjswe_19xwk_654"
};


function $c055d7846609c581$var$getIconAlign(props) {
    const standalone = props.variant === 'icon' || props.variant === 'inline-icon';
    return standalone ? 'left' : props.iconAlign;
}
function $c055d7846609c581$var$IconWrapper({ iconName: iconName, iconUrl: iconUrl, iconAlt: iconAlt, iconSvg: iconSvg, iconSize: iconSize, badge: badge, ...props }) {
    if (!iconName && !iconUrl && !iconSvg) return null;
    return $acw62.createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e49660893c408df4$export$2e2bcd8739ae039).icon, (0, $e49660893c408df4$export$2e2bcd8739ae039)[`icon-${$c055d7846609c581$var$getIconAlign(props)}`], props.iconClass),
        name: iconName,
        url: iconUrl,
        svg: iconSvg,
        alt: iconAlt,
        size: iconSize,
        badge: badge
    });
}
function $c055d7846609c581$export$c5a3a065f2cddabb(props) {
    if (props.loading) return $acw62.createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e49660893c408df4$export$2e2bcd8739ae039).icon, (0, $e49660893c408df4$export$2e2bcd8739ae039)['icon-left'])
    });
    else if ($c055d7846609c581$var$getIconAlign(props) === 'left') return $acw62.createElement($c055d7846609c581$var$IconWrapper, {
        ...props
    });
    return null;
}
function $c055d7846609c581$export$990119d7b3385d31(props) {
    if ($c055d7846609c581$var$getIconAlign(props) === 'right') return $acw62.createElement($c055d7846609c581$var$IconWrapper, {
        ...props
    });
    return null;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $fa7e5337e1d1a222$export$f98ea88a275be66c(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !(style === null || style === void 0 ? void 0 : style.root)) return undefined;
    return {
        borderRadius: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.borderRadius,
        borderWidth: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderWidth,
        paddingBlock: (_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.paddingBlock,
        paddingInline: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.paddingInline,
        ...((_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.background) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundActive]: (_f = style.root.background) === null || _f === void 0 ? void 0 : _f.active,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundDefault]: (_g = style.root.background) === null || _g === void 0 ? void 0 : _g.default,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundDisabled]: (_h = style.root.background) === null || _h === void 0 ? void 0 : _h.disabled,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundHover]: (_j = style.root.background) === null || _j === void 0 ? void 0 : _j.hover
        },
        ...((_k = style === null || style === void 0 ? void 0 : style.root) === null || _k === void 0 ? void 0 : _k.borderColor) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorActive]: (_l = style.root.borderColor) === null || _l === void 0 ? void 0 : _l.active,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorDefault]: (_m = style.root.borderColor) === null || _m === void 0 ? void 0 : _m.default,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorDisabled]: (_o = style.root.borderColor) === null || _o === void 0 ? void 0 : _o.disabled,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorHover]: (_p = style.root.borderColor) === null || _p === void 0 ? void 0 : _p.hover
        },
        ...((_q = style === null || style === void 0 ? void 0 : style.root) === null || _q === void 0 ? void 0 : _q.boxShadow) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowActive]: (_r = style.root.boxShadow) === null || _r === void 0 ? void 0 : _r.active,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowDefault]: (_s = style.root.boxShadow) === null || _s === void 0 ? void 0 : _s.default,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowDisabled]: (_t = style.root.boxShadow) === null || _t === void 0 ? void 0 : _t.disabled,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowHover]: (_u = style.root.boxShadow) === null || _u === void 0 ? void 0 : _u.hover
        },
        ...((_v = style === null || style === void 0 ? void 0 : style.root) === null || _v === void 0 ? void 0 : _v.color) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorActive]: (_w = style.root.color) === null || _w === void 0 ? void 0 : _w.active,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDefault]: (_x = style.root.color) === null || _x === void 0 ? void 0 : _x.default,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDisabled]: (_y = style.root.color) === null || _y === void 0 ? void 0 : _y.disabled,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorHover]: (_z = style.root.color) === null || _z === void 0 ? void 0 : _z.hover
        },
        ...((_0 = style === null || style === void 0 ? void 0 : style.root) === null || _0 === void 0 ? void 0 : _0.focusRing) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: (_1 = style.root.focusRing) === null || _1 === void 0 ? void 0 : _1.borderColor,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_2 = style.root.focusRing) === null || _2 === void 0 ? void 0 : _2.borderRadius,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_3 = style.root.focusRing) === null || _3 === void 0 ? void 0 : _3.borderWidth
        },
        ...((_5 = (_4 = style === null || style === void 0 ? void 0 : style.root) === null || _4 === void 0 ? void 0 : _4.focusRing) === null || _5 === void 0 ? void 0 : _5.borderRadius) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: style.root.focusRing.borderRadius
        }
    };
}



var $870ae2d4bade3fde$export$2e2bcd8739ae039 = {
    "label": "awsui_label_1f1d4_ocied_5"
};




var $226dc03e7e835ea6$export$2e2bcd8739ae039 = {
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_1ueyk_ca6yt_5",
    "external-icon": "awsui_external-icon_1ueyk_ca6yt_9"
};


const $3aceff6b46a02363$export$6e98354c7167985b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, iconName: iconName, __iconClass: __iconClass, onClick: onClick, onFollow: onFollow, iconAlign: iconAlign = 'left', iconUrl: iconUrl, iconSvg: iconSvg, iconAlt: iconAlt, variant: variant = 'normal', loading: loading = false, loadingText: loadingText, disabled: disabled = false, disabledReason: disabledReason, wrapText: wrapText = true, href: href, external: external, target: targetOverride, rel: rel, download: download, formAction: formAction = 'submit', ariaLabel: ariaLabel, ariaDescribedby: ariaDescribedby, ariaExpanded: ariaExpanded, ariaControls: ariaControls, fullWidth: fullWidth, badge: badge, i18nStrings: i18nStrings, style: style, nativeButtonAttributes: nativeButtonAttributes, nativeAnchorAttributes: nativeAnchorAttributes, __internalRootRef: __internalRootRef, __focusable: __focusable = false, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata = false, __title: __title, __emitPerformanceMarks: __emitPerformanceMarks = true, __skipNativeAttributesWarnings: __skipNativeAttributesWarnings, analyticsAction: analyticsAction = 'click', ...props }, ref)=>{
    var _a;
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('Button', href);
    const isAnchor = Boolean(href);
    const target = targetOverride !== null && targetOverride !== void 0 ? targetOverride : external ? '_blank' : undefined;
    const isNotInteractive = loading || disabled;
    const isDisabledWithReason = (variant === 'normal' || variant === 'primary' || variant === 'icon') && !!disabledReason && disabled;
    const hasAriaDisabled = loading && !disabled || disabled && __focusable || isDisabledWithReason;
    const shouldHaveContent = children && [
        'icon',
        'inline-icon',
        'flashbar-icon',
        'modal-dismiss',
        'inline-icon-pointer-target'
    ].indexOf(variant) === -1;
    if ((iconName || iconUrl || iconSvg) && iconAlign === 'right' && external) (0, $013a2451794a45c0$exports.warnOnce)('Button', 'A right-aligned icon should not be combined with an external icon.');
    const buttonRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, buttonRef);
    const buttonContext = (0, $edea5ac281b34b48$export$d891409b33cf7746)();
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('button');
    const uniqueId = (0, $013a2451794a45c0$exports.useUniqueId)('button');
    const { funnelInteractionId: funnelInteractionId } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const performanceMarkAttributes = (0, $d1a7bb38399fdadf$export$2ea7ecdb51f088f5)('primaryButton', ()=>variant === 'primary' && __emitPerformanceMarks && !loading && !disabled, buttonRef, ()=>{
        var _a;
        return {
            loading: loading,
            disabled: disabled,
            text: (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.innerText
        };
    }, [
        loading,
        disabled
    ]);
    (0, $bd3a651d3c4436d1$export$def8917b9f6e206)(variant === 'primary', loading);
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    const handleClick = (event)=>{
        if (isNotInteractive) return event.preventDefault();
        if (isAnchor && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) {
            (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, {
                href: href,
                target: target
            }, event);
            if ((iconName === 'external' || target === '_blank') && funnelInteractionId) {
                const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
                const subStepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(subStepNameSelector);
                (0, $54d511b0978bc73c$export$300ddd9f131af3a).externalLinkInteracted({
                    funnelInteractionId: funnelInteractionId,
                    stepNumber: stepNumber,
                    stepName: stepName,
                    stepNameSelector: stepNameSelector,
                    subStepSelector: subStepSelector,
                    subStepName: subStepName,
                    subStepNameSelector: subStepNameSelector,
                    elementSelector: (0, $285a09b860d2bebc$export$c0773214960ddccc)(uniqueId),
                    subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
                });
            }
        }
        const { altKey: altKey, button: button, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, {
            altKey: altKey,
            button: button,
            ctrlKey: ctrlKey,
            metaKey: metaKey,
            shiftKey: shiftKey
        }, event);
        buttonContext.onClick({
            variant: variant
        });
    };
    const buttonClass = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(props.className, (0, $e49660893c408df4$export$2e2bcd8739ae039).button, (0, $e49660893c408df4$export$2e2bcd8739ae039)[`variant-${variant}`], {
        [(0, $e49660893c408df4$export$2e2bcd8739ae039).disabled]: isNotInteractive,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039)['disabled-with-reason']]: isDisabledWithReason,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039)['button-no-wrap']]: !wrapText,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039)['button-no-text']]: !shouldHaveContent,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039)['full-width']]: shouldHaveContent && fullWidth,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039).link]: isAnchor
    });
    const explicitTabIndex = (_a = nativeButtonAttributes === null || nativeButtonAttributes === void 0 ? void 0 : nativeButtonAttributes.tabIndex) !== null && _a !== void 0 ? _a : nativeAnchorAttributes === null || nativeAnchorAttributes === void 0 ? void 0 : nativeAnchorAttributes.tabIndex;
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(buttonRef, {
        tabIndex: isAnchor && isNotInteractive && !isDisabledWithReason ? -1 : explicitTabIndex
    });
    const analyticsMetadata = disabled ? {} : {
        action: analyticsAction,
        detail: {
            label: {
                root: 'self'
            }
        }
    };
    if (__injectAnalyticsComponentMetadata) analyticsMetadata.component = {
        name: 'awsui.Button',
        label: {
            root: 'self'
        },
        properties: {
            variant: variant,
            disabled: `${disabled}`
        }
    };
    const buttonProps = {
        ...props,
        ...performanceMarkAttributes,
        tabIndex: tabIndex,
        // https://github.com/microsoft/TypeScript/issues/36659
        ref: (0, $013a2451794a45c0$exports.useMergeRefs)(buttonRef, __internalRootRef),
        'aria-label': ariaLabel,
        'aria-describedby': ariaDescribedby,
        'aria-expanded': ariaExpanded,
        'aria-controls': ariaControls,
        // add ariaLabel as `title` as visible hint text
        title: __title !== null && __title !== void 0 ? __title : ariaLabel,
        className: buttonClass,
        onClick: handleClick,
        [(0, $285a09b860d2bebc$export$39e42cde97dfcad)]: uniqueId,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata),
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsLabelAttribute)(shouldHaveContent ? `.${(0, $870ae2d4bade3fde$export$2e2bcd8739ae039).label}` : '')
    };
    const iconProps = {
        loading: loading,
        iconName: iconName,
        iconAlign: iconAlign,
        iconUrl: iconUrl,
        iconSvg: iconSvg,
        iconAlt: iconAlt,
        variant: variant,
        badge: badge,
        iconClass: __iconClass,
        iconSize: variant === 'modal-dismiss' ? 'medium' : 'normal'
    };
    const buttonContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c055d7846609c581$export$c5a3a065f2cddabb), {
        ...iconProps
    }), shouldHaveContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e49660893c408df4$export$2e2bcd8739ae039).content, (0, $870ae2d4bade3fde$export$2e2bcd8739ae039).label)
    }, children), external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, "\u00A0", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "external",
        className: (0, $226dc03e7e835ea6$export$2e2bcd8739ae039)['external-icon'],
        ariaLabel: i18n('i18nStrings.externalIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.externalIconAriaLabel)
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c055d7846609c581$export$990119d7b3385d31), {
        ...iconProps
    }));
    const { loadingButtonCount: loadingButtonCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    (0, $acw62.useEffect)(()=>{
        if (loading) {
            loadingButtonCount.current++;
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                loadingButtonCount.current--;
            };
        }
    }, [
        loading,
        loadingButtonCount
    ]);
    const disabledReasonProps = {
        onFocus: isDisabledWithReason ? ()=>setShowTooltip(true) : undefined,
        onBlur: isDisabledWithReason ? ()=>setShowTooltip(false) : undefined,
        onMouseEnter: isDisabledWithReason ? ()=>setShowTooltip(true) : undefined,
        onMouseLeave: isDisabledWithReason ? ()=>setShowTooltip(false) : undefined,
        ...isDisabledWithReason ? targetProps : {}
    };
    const disabledReasonContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $226dc03e7e835ea6$export$2e2bcd8739ae039)['disabled-reason-tooltip'],
        getTrack: ()=>buttonRef.current,
        content: disabledReason,
        onEscape: ()=>setShowTooltip(false)
    }));
    const stylePropertiesAndVariables = (0, $fa7e5337e1d1a222$export$f98ea88a275be66c)(style);
    if (isAnchor) {
        const getAnchorTabIndex = ()=>{
            if (isNotInteractive) // If disabled with a reason, make it focusable so users can access the tooltip
            // Otherwise, resolve to the default button props tabIndex.
            return isDisabledWithReason ? 0 : buttonProps.tabIndex;
            return buttonProps.tabIndex;
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
            ...buttonProps,
            ...disabledReasonProps,
            tag: "a",
            componentName: "Button",
            nativeAttributes: nativeAnchorAttributes,
            skipWarnings: __skipNativeAttributesWarnings,
            href: isNotInteractive ? undefined : href,
            role: isNotInteractive ? 'link' : undefined,
            tabIndex: getAnchorTabIndex(),
            target: target,
            // security recommendation: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target
            rel: rel !== null && rel !== void 0 ? rel : target === '_blank' ? 'noopener noreferrer' : undefined,
            "aria-disabled": isNotInteractive ? true : undefined,
            download: download,
            style: stylePropertiesAndVariables
        }, buttonContent, isDisabledWithReason && disabledReasonContent), loading && loadingText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
            tagName: "span",
            hidden: true
        }, loadingText));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...buttonProps,
        ...disabledReasonProps,
        tag: "button",
        componentName: "Button",
        nativeAttributes: nativeButtonAttributes,
        skipWarnings: __skipNativeAttributesWarnings,
        type: formAction === 'none' ? 'button' : 'submit',
        disabled: disabled && !__focusable && !isDisabledWithReason,
        "aria-disabled": hasAriaDisabled ? true : undefined,
        style: stylePropertiesAndVariables
    }, buttonContent, isDisabledWithReason && disabledReasonContent), loading && loadingText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span",
        hidden: true
    }, loadingText));
});
var $3aceff6b46a02363$export$2e2bcd8739ae039 = $3aceff6b46a02363$export$6e98354c7167985b;




var $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1fj9k_q6akd_5",
    "navigation": "awsui_navigation_1fj9k_q6akd_6",
    "navigation-toggle": "awsui_navigation-toggle_1fj9k_q6akd_7",
    "navigation-close": "awsui_navigation-close_1fj9k_q6akd_8",
    "content": "awsui_content_1fj9k_q6akd_9",
    "notifications": "awsui_notifications_1fj9k_q6akd_10",
    "breadcrumbs": "awsui_breadcrumbs_1fj9k_q6akd_11",
    "tools": "awsui_tools_1fj9k_q6akd_12",
    "tools-close": "awsui_tools-close_1fj9k_q6akd_13",
    "tools-toggle": "awsui_tools-toggle_1fj9k_q6akd_14",
    "drawer-closed": "awsui_drawer-closed_1fj9k_q6akd_15",
    "mobile-bar": "awsui_mobile-bar_1fj9k_q6akd_16",
    "disable-body-scroll-root": "awsui_disable-body-scroll-root_1fj9k_q6akd_17",
    "drawers-trigger": "awsui_drawers-trigger_1fj9k_q6akd_18",
    "drawers-trigger-global": "awsui_drawers-trigger-global_1fj9k_q6akd_19",
    "drawers-trigger-with-badge": "awsui_drawers-trigger-with-badge_1fj9k_q6akd_20",
    "active-drawer": "awsui_active-drawer_1fj9k_q6akd_21",
    "active-drawer-close-button": "awsui_active-drawer-close-button_1fj9k_q6akd_22",
    "overflow-menu": "awsui_overflow-menu_1fj9k_q6akd_23",
    "drawers-slider": "awsui_drawers-slider_1fj9k_q6akd_24",
    "toolbar": "awsui_toolbar_1fj9k_q6akd_25",
    "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_1fj9k_q6akd_26",
    "trigger-tooltip": "awsui_trigger-tooltip_1fj9k_q6akd_27",
    "active-drawer-expanded-mode-button": "awsui_active-drawer-expanded-mode-button_1fj9k_q6akd_28",
    "ai-drawer-toggle": "awsui_ai-drawer-toggle_1fj9k_q6akd_29",
    "active-ai-drawer-leave-expanded-mode-custom-button": "awsui_active-ai-drawer-leave-expanded-mode-custom-button_1fj9k_q6akd_30"
};



var $287069b5043d9ece$export$2e2bcd8739ae039 = {
    "toggle-button": "awsui_toggle-button_16w0h_1dfmp_185",
    "close-button": "awsui_close-button_16w0h_1dfmp_220"
};


const $917b74cb04fa7906$export$e0ae33479bcb926a = {
    navigation: {
        TagName: 'nav',
        iconName: 'menu',
        getLabels: (labels = {})=>({
                mainLabel: labels.navigation,
                openLabel: labels.navigationToggle,
                closeLabel: labels.navigationClose
            })
    },
    tools: {
        TagName: 'aside',
        iconName: 'status-info',
        getLabels: (labels = {})=>({
                mainLabel: labels.tools,
                openLabel: labels.toolsToggle,
                closeLabel: labels.toolsClose
            })
    }
};
const $917b74cb04fa7906$export$d2b052e7b4be1756 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaControls: ariaControls, iconName: iconName, iconSvg: iconSvg, disabled: disabled, testId: testId, onClick: onClick, badge: badge }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $287069b5043d9ece$export$2e2bcd8739ae039)['toggle-button'], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger-with-badge']]: badge
        }),
        "aria-label": ariaLabel,
        type: "button",
        onClick: onClick,
        disabled: disabled,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaExpanded ? undefined : true,
        "aria-controls": ariaControls,
        "data-testid": testId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        svg: iconSvg,
        name: iconName,
        badge: badge
    }));
});
const $917b74cb04fa7906$export$de65de8213222d10 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ariaLabel: ariaLabel, onClick: onClick }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $287069b5043d9ece$export$2e2bcd8739ae039)['close-button']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: ref,
        className: className,
        ariaLabel: ariaLabel,
        variant: "icon",
        formAction: "none",
        iconName: "close",
        onClick: onClick
    }));
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $bf410ac4539db587$export$adc986c053591633 = (0, $acw62.createContext)([]);



var $52e05cea689066aa$export$2e2bcd8739ae039 = {
    "runtime-content-wrapper": "awsui_runtime-content-wrapper_14m8x_spfr5_5",
    "runtime-header-wrapper": "awsui_runtime-header-wrapper_14m8x_spfr5_9"
};


function $43224bb3d30365a9$var$RuntimeDrawerWrapper({ mountContent: mountContent, unmountContent: unmountContent, id: id }) {
    const ref = (0, $acw62.useRef)(null);
    const visibilityChangeCallback = (0, $acw62.useRef)(null);
    const activeDrawersIds = (0, $acw62.useContext)((0, $bf410ac4539db587$export$adc986c053591633));
    const isVisible = !!id && activeDrawersIds.includes(id);
    (0, $acw62.useEffect)(()=>{
        const container = ref.current;
        mountContent(container, {
            onVisibilityChange: (cb)=>{
                visibilityChangeCallback.current = cb;
            }
        });
        return ()=>{
            unmountContent(container);
            visibilityChangeCallback.current = null;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = visibilityChangeCallback.current) === null || _a === void 0 || _a.call(visibilityChangeCallback, isVisible);
    }, [
        isVisible
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $52e05cea689066aa$export$2e2bcd8739ae039)['runtime-content-wrapper'],
        "data-awsui-runtime-drawer-root-id": id
    });
}
function $43224bb3d30365a9$var$RuntimeDrawerHeader({ mountHeader: mountHeader, unmountHeader: unmountHeader }) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const container = ref.current;
        mountHeader === null || mountHeader === void 0 || mountHeader(container);
        return ()=>{
            unmountHeader === null || unmountHeader === void 0 || unmountHeader(container);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $52e05cea689066aa$export$2e2bcd8739ae039)['runtime-header-wrapper'],
        ref: ref
    });
}
function $43224bb3d30365a9$var$mapRuntimeHeaderActionsToHeaderActions(runtimeHeaderActions) {
    return runtimeHeaderActions.map((runtimeHeaderAction)=>{
        return {
            ...runtimeHeaderAction,
            ...'iconSvg' in runtimeHeaderAction && runtimeHeaderAction.iconSvg && {
                iconSvg: $43224bb3d30365a9$var$convertRuntimeTriggerToReactNode(runtimeHeaderAction.iconSvg)
            },
            ...'pressedIconSvg' in runtimeHeaderAction && runtimeHeaderAction.pressedIconSvg && {
                iconSvg: $43224bb3d30365a9$var$convertRuntimeTriggerToReactNode(runtimeHeaderAction.pressedIconSvg)
            }
        };
    });
}
const $43224bb3d30365a9$var$convertRuntimeTriggerToReactNode = (runtimeTrigger)=>{
    if (!runtimeTrigger) return undefined;
    // eslint-disable-next-line react/no-danger
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            lineHeight: 0
        },
        dangerouslySetInnerHTML: {
            __html: runtimeTrigger
        }
    });
};
const $43224bb3d30365a9$export$880ba34165785d5f = (runtimeConfig)=>{
    var _a;
    const { mountContent: mountContent, unmountContent: unmountContent, trigger: trigger, ...runtimeDrawer } = runtimeConfig;
    return {
        ...runtimeDrawer,
        ariaLabels: {
            drawerName: (_a = runtimeDrawer.ariaLabels.content) !== null && _a !== void 0 ? _a : '',
            ...runtimeDrawer.ariaLabels
        },
        trigger: trigger ? {
            ...trigger.iconSvg && {
                iconSvg: $43224bb3d30365a9$var$convertRuntimeTriggerToReactNode(trigger.iconSvg)
            }
        } : undefined,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($43224bb3d30365a9$var$RuntimeDrawerWrapper, {
            key: runtimeDrawer.id,
            mountContent: mountContent,
            unmountContent: unmountContent,
            id: runtimeDrawer.id
        }),
        onResize: (event)=>{
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(runtimeDrawer.onResize, {
                size: event.detail.size,
                id: runtimeDrawer.id
            });
        },
        headerActions: runtimeDrawer.headerActions ? $43224bb3d30365a9$var$mapRuntimeHeaderActionsToHeaderActions(runtimeDrawer.headerActions) : undefined
    };
};
const $43224bb3d30365a9$export$aa60b7f985ef6954 = (runtimeConfig)=>{
    var _a;
    const { mountContent: mountContent, unmountContent: unmountContent, trigger: trigger, exitExpandedModeTrigger: exitExpandedModeTrigger, ...runtimeDrawer } = runtimeConfig;
    return {
        ...runtimeDrawer,
        ariaLabels: {
            drawerName: (_a = runtimeDrawer.ariaLabels.content) !== null && _a !== void 0 ? _a : '',
            ...runtimeDrawer.ariaLabels
        },
        ...trigger && {
            trigger: {
                customIcon: $43224bb3d30365a9$var$convertRuntimeTriggerToReactNode(trigger === null || trigger === void 0 ? void 0 : trigger.customIcon),
                iconSvg: $43224bb3d30365a9$var$convertRuntimeTriggerToReactNode(trigger === null || trigger === void 0 ? void 0 : trigger.iconSvg)
            }
        },
        exitExpandedModeTrigger: exitExpandedModeTrigger ? {
            customIcon: $43224bb3d30365a9$var$convertRuntimeTriggerToReactNode(exitExpandedModeTrigger === null || exitExpandedModeTrigger === void 0 ? void 0 : exitExpandedModeTrigger.customIcon)
        } : undefined,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($43224bb3d30365a9$var$RuntimeDrawerWrapper, {
            key: runtimeDrawer.id,
            mountContent: mountContent,
            unmountContent: unmountContent,
            id: runtimeDrawer.id
        }),
        ...runtimeDrawer.mountHeader && {
            header: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($43224bb3d30365a9$var$RuntimeDrawerHeader, {
                mountHeader: runtimeDrawer.mountHeader,
                unmountHeader: runtimeDrawer.unmountHeader
            })
        },
        onResize: (event)=>{
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(runtimeDrawer.onResize, {
                size: event.detail.size,
                id: runtimeDrawer.id
            });
        },
        headerActions: runtimeDrawer.headerActions ? $43224bb3d30365a9$var$mapRuntimeHeaderActionsToHeaderActions(runtimeDrawer.headerActions) : undefined
    };
};
function $43224bb3d30365a9$export$230994d0fa2896d5(localDrawers, globalDrawers) {
    const converted = localDrawers.map($43224bb3d30365a9$export$880ba34165785d5f);
    const sorted = (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(converted);
    return {
        global: (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(globalDrawers.map($43224bb3d30365a9$export$880ba34165785d5f)),
        localBefore: sorted.filter((item)=>{
            var _a;
            return ((_a = item.orderPriority) !== null && _a !== void 0 ? _a : 0) > 0;
        }),
        localAfter: sorted.filter((item)=>{
            var _a;
            return ((_a = item.orderPriority) !== null && _a !== void 0 ? _a : 0) <= 0;
        })
    };
}



const $892ef2b582c4882d$export$329f249760e831ae = 'awsui-internal-tools';
function $892ef2b582c4882d$var$getToolsDrawerItem(props) {
    if (props.toolsHide) return null;
    const { iconName: iconName, getLabels: getLabels } = (0, $917b74cb04fa7906$export$e0ae33479bcb926a).tools;
    const { mainLabel: mainLabel, closeLabel: closeLabel, openLabel: openLabel } = getLabels(props.ariaLabels);
    return {
        id: $892ef2b582c4882d$export$329f249760e831ae,
        content: props.tools,
        resizable: false,
        ariaLabels: {
            triggerButton: openLabel,
            closeButton: closeLabel,
            drawerName: mainLabel !== null && mainLabel !== void 0 ? mainLabel : ''
        },
        trigger: {
            iconName: iconName
        }
    };
}
const $892ef2b582c4882d$var$DRAWERS_LIMIT = 2;
const $892ef2b582c4882d$var$DEFAULT_ON_CHANGE_PARAMS = {
    initiatedByUserAction: true
};
function $892ef2b582c4882d$var$useRuntimeDrawers(disableRuntimeDrawers, activeDrawerId, onActiveDrawerChange, activeGlobalDrawersIds, onActiveGlobalDrawersChange) {
    const [runtimeDrawers, setRuntimeDrawers] = (0, $acw62.useState)({
        localBefore: [],
        localAfter: [],
        global: []
    });
    const onLocalDrawerChangeStable = (0, $013a2451794a45c0$exports.useStableCallback)(onActiveDrawerChange);
    const onGlobalDrawersChangeStable = (0, $013a2451794a45c0$exports.useStableCallback)(onActiveGlobalDrawersChange);
    const localDrawerWasOpenRef = (0, $acw62.useRef)(false);
    localDrawerWasOpenRef.current = localDrawerWasOpenRef.current || !!activeDrawerId;
    const activeGlobalDrawersIdsRef = (0, $acw62.useRef)([]);
    activeGlobalDrawersIdsRef.current = activeGlobalDrawersIds;
    (0, $acw62.useEffect)(()=>{
        if (disableRuntimeDrawers) return;
        const unsubscribe = (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayout.onDrawersRegistered((drawers)=>{
            const localDrawers = drawers.filter((drawer)=>drawer.type !== 'global');
            const globalDrawers = drawers.filter((drawer)=>drawer.type === 'global');
            setRuntimeDrawers((0, $43224bb3d30365a9$export$230994d0fa2896d5)(localDrawers, globalDrawers));
            if (!localDrawerWasOpenRef.current) {
                const defaultActiveLocalDrawer = (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(localDrawers).find((drawer)=>drawer.defaultActive);
                if (defaultActiveLocalDrawer) onLocalDrawerChangeStable(defaultActiveLocalDrawer.id, {
                    initiatedByUserAction: false
                });
            }
            const drawersNotActiveByDefault = globalDrawers.filter((drawer)=>!drawer.defaultActive);
            const hasDrawersOpenByUserAction = drawersNotActiveByDefault.find((drawer)=>activeGlobalDrawersIdsRef.current.includes(drawer.id));
            if (hasDrawersOpenByUserAction || activeGlobalDrawersIdsRef.current.length === $892ef2b582c4882d$var$DRAWERS_LIMIT) return;
            const defaultActiveGlobalDrawers = (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(globalDrawers).filter((drawer)=>!activeGlobalDrawersIdsRef.current.includes(drawer.id) && drawer.defaultActive);
            defaultActiveGlobalDrawers.forEach((drawer)=>{
                onGlobalDrawersChangeStable(drawer.id, {
                    initiatedByUserAction: false
                });
            });
        });
        return ()=>{
            unsubscribe();
            setRuntimeDrawers({
                localBefore: [],
                localAfter: [],
                global: []
            });
        };
    }, [
        disableRuntimeDrawers,
        onGlobalDrawersChangeStable,
        onLocalDrawerChangeStable
    ]);
    return runtimeDrawers;
}
function $892ef2b582c4882d$var$useDrawerRuntimeOpenClose(disableRuntimeDrawers, localDrawers, globalDrawers, activeDrawerId, onActiveDrawerChange, activeGlobalDrawersIds, onActiveGlobalDrawersChange) {
    const onDrawerOpened = (0, $013a2451794a45c0$exports.useStableCallback)((drawerId, params = $892ef2b582c4882d$var$DEFAULT_ON_CHANGE_PARAMS)=>{
        const localDrawer = localDrawers === null || localDrawers === void 0 ? void 0 : localDrawers.find((drawer)=>drawer.id === drawerId);
        const globalDrawer = globalDrawers.find((drawer)=>drawer.id === drawerId);
        if (localDrawer && activeDrawerId !== drawerId) onActiveDrawerChange(drawerId, params);
        if (globalDrawer && !activeGlobalDrawersIds.includes(drawerId)) onActiveGlobalDrawersChange(drawerId, params);
    });
    const onDrawerClosed = (0, $013a2451794a45c0$exports.useStableCallback)((drawerId, params = $892ef2b582c4882d$var$DEFAULT_ON_CHANGE_PARAMS)=>{
        const localDrawer = localDrawers === null || localDrawers === void 0 ? void 0 : localDrawers.find((drawer)=>drawer.id === drawerId);
        const globalDrawer = globalDrawers.find((drawer)=>drawer.id === drawerId);
        if (localDrawer && activeDrawerId === drawerId) onActiveDrawerChange(null, params);
        if (globalDrawer && activeGlobalDrawersIds.includes(drawerId)) onActiveGlobalDrawersChange(drawerId, params);
    });
    (0, $acw62.useEffect)(()=>{
        if (disableRuntimeDrawers) return;
        return (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayout.onDrawerOpened(onDrawerOpened);
    }, [
        disableRuntimeDrawers,
        onDrawerOpened
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disableRuntimeDrawers) return;
        return (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayout.onDrawerClosed(onDrawerClosed);
    }, [
        disableRuntimeDrawers,
        onDrawerClosed
    ]);
}
function $892ef2b582c4882d$var$useDrawerRuntimeResize(disableRuntimeDrawers, onActiveDrawerResize) {
    const onRuntimeDrawerResize = (0, $013a2451794a45c0$exports.useStableCallback)((drawerId, size)=>{
        onActiveDrawerResize({
            id: drawerId,
            size: size
        });
    });
    (0, $acw62.useEffect)(()=>{
        if (disableRuntimeDrawers) return;
        return (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayout.onDrawerResize(onRuntimeDrawerResize);
    }, [
        disableRuntimeDrawers,
        onRuntimeDrawerResize
    ]);
}
function $892ef2b582c4882d$var$applyToolsDrawer(toolsProps, runtimeDrawers) {
    const drawers = [
        ...runtimeDrawers.localBefore,
        ...runtimeDrawers.localAfter
    ];
    if (drawers.length === 0 && toolsProps.disableDrawersMerge) return null;
    const toolsItem = $892ef2b582c4882d$var$getToolsDrawerItem(toolsProps);
    if (toolsItem) drawers.unshift(toolsItem);
    return drawers;
}
const $892ef2b582c4882d$export$4a7e63d7f017c5fc = 290;
function $892ef2b582c4882d$export$468f52f962f49bf5({ drawers: drawers, externalLocalRuntimeDrawers: externalLocalRuntimeDrawers, activeDrawerId: controlledActiveDrawerId, onDrawerChange: onDrawerChange, onGlobalDrawerFocus: onGlobalDrawerFocus, onAddNewActiveDrawer: onAddNewActiveDrawer, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, __disableRuntimeDrawers: disableRuntimeDrawers }, ariaLabels, toolsProps) {
    var _a, _b, _c, _d;
    const [activeDrawerId = null, setActiveDrawerId] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledActiveDrawerId, onDrawerChange, null, {
        componentName: 'AppLayout',
        controlledProp: 'activeDrawerId',
        changeHandler: 'onChange'
    });
    const [activeGlobalDrawersIds, setActiveGlobalDrawersIds] = (0, $acw62.useState)([]);
    const [drawerSizes, setDrawerSizes] = (0, $acw62.useState)({});
    // FIFO queue that keeps track of open drawers, where the first element is the most recently opened drawer
    const drawersOpenQueue = (0, $acw62.useRef)([]);
    function onActiveDrawerResize({ id: id, size: size }) {
        setDrawerSizes((oldSizes)=>({
                ...oldSizes,
                [id]: size
            }));
        if ((activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) === id) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.onResize, {
            id: id,
            size: size
        });
        const activeGlobalDrawer = runtimeGlobalDrawers.find((drawer)=>drawer.id === id);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.onResize, {
            id: id,
            size: size
        });
    }
    function onActiveDrawerChange(newDrawerId, { initiatedByUserAction: initiatedByUserAction } = $892ef2b582c4882d$var$DEFAULT_ON_CHANGE_PARAMS) {
        var _a, _b;
        setActiveDrawerId(newDrawerId);
        if (newDrawerId) onAddNewActiveDrawer === null || onAddNewActiveDrawer === void 0 || onAddNewActiveDrawer(newDrawerId);
        if (hasOwnDrawers) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDrawerChange, {
            activeDrawerId: newDrawerId
        });
        else if (!toolsProps.toolsHide) toolsProps.onToolsToggle(newDrawerId === $892ef2b582c4882d$export$329f249760e831ae);
        if (newDrawerId) {
            drawersOpenQueue.current = [
                newDrawerId,
                ...drawersOpenQueue.current
            ];
            const newDrawer = (_a = [
                ...runtimeDrawers.localBefore,
                ...runtimeDrawers.localAfter
            ], _a === void 0) ? void 0 : _a.find((drawer)=>drawer.id === newDrawerId);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(newDrawer === null || newDrawer === void 0 ? void 0 : newDrawer.onToggle, {
                isOpen: true,
                initiatedByUserAction: initiatedByUserAction
            });
        }
        if (activeDrawerId) {
            drawersOpenQueue.current = drawersOpenQueue.current.filter((id)=>id !== activeDrawerId);
            const activeDrawer = (_b = [
                ...runtimeDrawers.localBefore,
                ...runtimeDrawers.localAfter
            ], _b === void 0) ? void 0 : _b.find((drawer)=>drawer.id === activeDrawerId);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.onToggle, {
                isOpen: false,
                initiatedByUserAction: initiatedByUserAction
            });
        }
    }
    function onActiveGlobalDrawersChange(drawerId, { initiatedByUserAction: initiatedByUserAction } = $892ef2b582c4882d$var$DEFAULT_ON_CHANGE_PARAMS) {
        const drawer = runtimeGlobalDrawers.find((drawer)=>drawer.id === drawerId);
        if (activeGlobalDrawersIds.includes(drawerId)) {
            setActiveGlobalDrawersIds((currentState)=>currentState.filter((id)=>id !== drawerId));
            onGlobalDrawerFocus === null || onGlobalDrawerFocus === void 0 || onGlobalDrawerFocus(drawerId, false);
            drawersOpenQueue.current = drawersOpenQueue.current.filter((id)=>id !== drawerId);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(drawer === null || drawer === void 0 ? void 0 : drawer.onToggle, {
                isOpen: false,
                initiatedByUserAction: initiatedByUserAction
            });
            if (drawerId === expandedDrawerId) setExpandedDrawerId === null || setExpandedDrawerId === void 0 || setExpandedDrawerId(null);
        } else if (drawerId) {
            onAddNewActiveDrawer === null || onAddNewActiveDrawer === void 0 || onAddNewActiveDrawer(drawerId);
            setActiveGlobalDrawersIds((currentState)=>[
                    drawerId,
                    ...currentState
                ].slice(0, $892ef2b582c4882d$var$DRAWERS_LIMIT));
            onGlobalDrawerFocus === null || onGlobalDrawerFocus === void 0 || onGlobalDrawerFocus(drawerId, true);
            drawersOpenQueue.current = [
                drawerId,
                ...drawersOpenQueue.current
            ];
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(drawer === null || drawer === void 0 ? void 0 : drawer.onToggle, {
                isOpen: true,
                initiatedByUserAction: initiatedByUserAction
            });
        }
    }
    const hasOwnDrawers = !!drawers;
    // support toolsOpen in runtime-drawers-only mode
    let activeDrawerIdResolved = (toolsProps === null || toolsProps === void 0 ? void 0 : toolsProps.toolsOpen) && !hasOwnDrawers ? $892ef2b582c4882d$export$329f249760e831ae : activeDrawerId !== $892ef2b582c4882d$export$329f249760e831ae ? activeDrawerId : null;
    let runtimeDrawers = $892ef2b582c4882d$var$useRuntimeDrawers(disableRuntimeDrawers, activeDrawerIdResolved, onActiveDrawerChange, activeGlobalDrawersIds, onActiveGlobalDrawersChange);
    if (externalLocalRuntimeDrawers) runtimeDrawers = {
        ...runtimeDrawers,
        localBefore: [
            ...externalLocalRuntimeDrawers,
            ...runtimeDrawers.localBefore
        ]
    };
    const { localBefore: localBefore, localAfter: localAfter, global: runtimeGlobalDrawers } = runtimeDrawers;
    const combinedLocalDrawers = drawers ? [
        ...localBefore,
        ...drawers,
        ...localAfter
    ] : $892ef2b582c4882d$var$applyToolsDrawer(toolsProps, runtimeDrawers);
    const activeDrawer = combinedLocalDrawers === null || combinedLocalDrawers === void 0 ? void 0 : combinedLocalDrawers.find((drawer)=>drawer.id === activeDrawerIdResolved);
    // ensure that id is only defined when the drawer exists
    activeDrawerIdResolved = (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== null && _a !== void 0 ? _a : null;
    const activeGlobalDrawers = runtimeGlobalDrawers.filter((drawer)=>activeGlobalDrawersIds.includes(drawer.id));
    $892ef2b582c4882d$var$useDrawerRuntimeOpenClose(disableRuntimeDrawers, combinedLocalDrawers, runtimeGlobalDrawers, activeDrawerId, onActiveDrawerChange, activeGlobalDrawersIds, onActiveGlobalDrawersChange);
    $892ef2b582c4882d$var$useDrawerRuntimeResize(disableRuntimeDrawers, onActiveDrawerResize);
    const activeDrawerSize = activeDrawerIdResolved ? (_c = (_b = drawerSizes[activeDrawerIdResolved]) !== null && _b !== void 0 ? _b : activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.defaultSize) !== null && _c !== void 0 ? _c : toolsProps.toolsWidth : toolsProps.toolsWidth;
    const activeGlobalDrawersSizes = activeGlobalDrawersIds.reduce((acc, currentGlobalDrawerId)=>{
        var _a, _b;
        const currentGlobalDrawer = runtimeGlobalDrawers.find((drawer)=>drawer.id === currentGlobalDrawerId);
        return {
            ...acc,
            [currentGlobalDrawerId]: (_b = (_a = drawerSizes[currentGlobalDrawerId]) !== null && _a !== void 0 ? _a : currentGlobalDrawer === null || currentGlobalDrawer === void 0 ? void 0 : currentGlobalDrawer.defaultSize) !== null && _b !== void 0 ? _b : $892ef2b582c4882d$export$4a7e63d7f017c5fc
        };
    }, {});
    const minGlobalDrawersSizes = runtimeGlobalDrawers.reduce((acc, globalDrawer)=>{
        var _a;
        return {
            ...acc,
            [globalDrawer.id]: Math.min((_a = globalDrawer.defaultSize) !== null && _a !== void 0 ? _a : $892ef2b582c4882d$export$4a7e63d7f017c5fc, $892ef2b582c4882d$export$4a7e63d7f017c5fc)
        };
    }, {});
    const minDrawerSize = Math.min((toolsProps === null || toolsProps === void 0 ? void 0 : toolsProps.toolsOpen) ? toolsProps.toolsWidth : (_d = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.defaultSize) !== null && _d !== void 0 ? _d : $892ef2b582c4882d$export$4a7e63d7f017c5fc, $892ef2b582c4882d$export$4a7e63d7f017c5fc);
    return {
        ariaLabelsWithDrawers: ariaLabels,
        drawers: combinedLocalDrawers || undefined,
        activeDrawer: activeDrawer,
        activeDrawerId: activeDrawerIdResolved,
        globalDrawers: runtimeGlobalDrawers,
        activeGlobalDrawers: activeGlobalDrawers,
        activeGlobalDrawersIds: activeGlobalDrawersIds,
        activeGlobalDrawersSizes: activeGlobalDrawersSizes,
        activeDrawerSize: activeDrawerSize,
        minDrawerSize: minDrawerSize,
        minGlobalDrawersSizes: minGlobalDrawersSizes,
        drawerSizes: drawerSizes,
        drawersOpenQueue: drawersOpenQueue,
        onActiveDrawerChange: onActiveDrawerChange,
        onActiveDrawerResize: onActiveDrawerResize,
        onActiveGlobalDrawersChange: onActiveGlobalDrawersChange
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $cd10a1d6e571a030$export$855cafbbae95d7a8(maybeItems, splitIndex, activeId) {
    const items = maybeItems !== null && maybeItems !== void 0 ? maybeItems : [];
    const visibleItems = items.slice(0, splitIndex);
    const overflowItems = items.slice(splitIndex);
    if (overflowItems.length === 1) return {
        visibleItems: items,
        overflowItems: []
    };
    if (activeId && overflowItems.length > 0 && visibleItems.length > 0) {
        const activeInOverflow = overflowItems.find((item)=>item.id === activeId);
        if (activeInOverflow) {
            overflowItems.splice(overflowItems.indexOf(activeInOverflow), 1);
            overflowItems.unshift(visibleItems.pop());
            visibleItems.push(activeInOverflow);
        }
    }
    return {
        visibleItems: visibleItems,
        overflowItems: overflowItems
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $a3bb2b713f638a5c$export$2e2bcd8739ae039 = {
    "box": "awsui_box_18wu0_ayvp9_172",
    "p-variant": "awsui_p-variant_18wu0_ayvp9_172",
    "color-default": "awsui_color-default_18wu0_ayvp9_172",
    "b-variant": "awsui_b-variant_18wu0_ayvp9_172",
    "strong-variant": "awsui_strong-variant_18wu0_ayvp9_172",
    "code-variant": "awsui_code-variant_18wu0_ayvp9_172",
    "pre-variant": "awsui_pre-variant_18wu0_ayvp9_172",
    "samp-variant": "awsui_samp-variant_18wu0_ayvp9_172",
    "h1-variant": "awsui_h1-variant_18wu0_ayvp9_176",
    "h2-variant": "awsui_h2-variant_18wu0_ayvp9_176",
    "h3-variant": "awsui_h3-variant_18wu0_ayvp9_176",
    "h4-variant": "awsui_h4-variant_18wu0_ayvp9_176",
    "h5-variant": "awsui_h5-variant_18wu0_ayvp9_176",
    "small-variant": "awsui_small-variant_18wu0_ayvp9_180",
    "a-variant": "awsui_a-variant_18wu0_ayvp9_184",
    "font-size-default": "awsui_font-size-default_18wu0_ayvp9_188",
    "font-weight-default": "awsui_font-weight-default_18wu0_ayvp9_229",
    "key-label-variant": "awsui_key-label-variant_18wu0_ayvp9_271",
    "gen-ai-label-variant": "awsui_gen-ai-label-variant_18wu0_ayvp9_278",
    "value-large-variant": "awsui_value-large-variant_18wu0_ayvp9_285",
    "inline-code-variant": "awsui_inline-code-variant_18wu0_ayvp9_292",
    "font-weight-heavy": "awsui_font-weight-heavy_18wu0_ayvp9_306",
    "color-inverted": "awsui_color-inverted_18wu0_ayvp9_311",
    "color-text-label": "awsui_color-text-label_18wu0_ayvp9_314",
    "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_ayvp9_317",
    "color-text-status-error": "awsui_color-text-status-error_18wu0_ayvp9_320",
    "color-text-status-success": "awsui_color-text-status-success_18wu0_ayvp9_323",
    "color-text-status-info": "awsui_color-text-status-info_18wu0_ayvp9_326",
    "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_ayvp9_329",
    "color-text-status-warning": "awsui_color-text-status-warning_18wu0_ayvp9_332",
    "color-inherit": "awsui_color-inherit_18wu0_ayvp9_335",
    "font-size-body-s": "awsui_font-size-body-s_18wu0_ayvp9_338",
    "font-size-body-m": "awsui_font-size-body-m_18wu0_ayvp9_343",
    "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_ayvp9_347",
    "font-size-heading-s": "awsui_font-size-heading-s_18wu0_ayvp9_352",
    "font-size-heading-m": "awsui_font-size-heading-m_18wu0_ayvp9_357",
    "font-size-heading-l": "awsui_font-size-heading-l_18wu0_ayvp9_362",
    "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_ayvp9_367",
    "font-size-display-l": "awsui_font-size-display-l_18wu0_ayvp9_372",
    "font-weight-light": "awsui_font-weight-light_18wu0_ayvp9_377",
    "font-weight-normal": "awsui_font-weight-normal_18wu0_ayvp9_380",
    "font-weight-bold": "awsui_font-weight-bold_18wu0_ayvp9_383",
    "t-left": "awsui_t-left_18wu0_ayvp9_390",
    "t-right": "awsui_t-right_18wu0_ayvp9_394",
    "t-center": "awsui_t-center_18wu0_ayvp9_398",
    "p-n": "awsui_p-n_18wu0_ayvp9_415",
    "p-top-n": "awsui_p-top-n_18wu0_ayvp9_420",
    "p-vertical-n": "awsui_p-vertical-n_18wu0_ayvp9_421",
    "p-right-n": "awsui_p-right-n_18wu0_ayvp9_425",
    "p-horizontal-n": "awsui_p-horizontal-n_18wu0_ayvp9_426",
    "p-bottom-n": "awsui_p-bottom-n_18wu0_ayvp9_430",
    "p-left-n": "awsui_p-left-n_18wu0_ayvp9_435",
    "p-xxxs": "awsui_p-xxxs_18wu0_ayvp9_440",
    "p-top-xxxs": "awsui_p-top-xxxs_18wu0_ayvp9_445",
    "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_ayvp9_446",
    "p-right-xxxs": "awsui_p-right-xxxs_18wu0_ayvp9_450",
    "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_ayvp9_451",
    "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_ayvp9_455",
    "p-left-xxxs": "awsui_p-left-xxxs_18wu0_ayvp9_460",
    "p-xxs": "awsui_p-xxs_18wu0_ayvp9_465",
    "p-top-xxs": "awsui_p-top-xxs_18wu0_ayvp9_470",
    "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_ayvp9_471",
    "p-right-xxs": "awsui_p-right-xxs_18wu0_ayvp9_475",
    "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_ayvp9_476",
    "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_ayvp9_480",
    "p-left-xxs": "awsui_p-left-xxs_18wu0_ayvp9_485",
    "p-xs": "awsui_p-xs_18wu0_ayvp9_490",
    "p-top-xs": "awsui_p-top-xs_18wu0_ayvp9_495",
    "p-vertical-xs": "awsui_p-vertical-xs_18wu0_ayvp9_496",
    "p-right-xs": "awsui_p-right-xs_18wu0_ayvp9_500",
    "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_ayvp9_501",
    "p-bottom-xs": "awsui_p-bottom-xs_18wu0_ayvp9_505",
    "p-left-xs": "awsui_p-left-xs_18wu0_ayvp9_510",
    "p-s": "awsui_p-s_18wu0_ayvp9_515",
    "p-top-s": "awsui_p-top-s_18wu0_ayvp9_520",
    "p-vertical-s": "awsui_p-vertical-s_18wu0_ayvp9_521",
    "p-right-s": "awsui_p-right-s_18wu0_ayvp9_525",
    "p-horizontal-s": "awsui_p-horizontal-s_18wu0_ayvp9_526",
    "p-bottom-s": "awsui_p-bottom-s_18wu0_ayvp9_530",
    "p-left-s": "awsui_p-left-s_18wu0_ayvp9_535",
    "p-m": "awsui_p-m_18wu0_ayvp9_540",
    "p-top-m": "awsui_p-top-m_18wu0_ayvp9_545",
    "p-vertical-m": "awsui_p-vertical-m_18wu0_ayvp9_546",
    "p-right-m": "awsui_p-right-m_18wu0_ayvp9_550",
    "p-horizontal-m": "awsui_p-horizontal-m_18wu0_ayvp9_551",
    "p-bottom-m": "awsui_p-bottom-m_18wu0_ayvp9_555",
    "p-left-m": "awsui_p-left-m_18wu0_ayvp9_560",
    "p-l": "awsui_p-l_18wu0_ayvp9_435",
    "p-top-l": "awsui_p-top-l_18wu0_ayvp9_570",
    "p-vertical-l": "awsui_p-vertical-l_18wu0_ayvp9_571",
    "p-right-l": "awsui_p-right-l_18wu0_ayvp9_575",
    "p-horizontal-l": "awsui_p-horizontal-l_18wu0_ayvp9_576",
    "p-bottom-l": "awsui_p-bottom-l_18wu0_ayvp9_580",
    "p-left-l": "awsui_p-left-l_18wu0_ayvp9_585",
    "p-xl": "awsui_p-xl_18wu0_ayvp9_590",
    "p-top-xl": "awsui_p-top-xl_18wu0_ayvp9_595",
    "p-vertical-xl": "awsui_p-vertical-xl_18wu0_ayvp9_596",
    "p-right-xl": "awsui_p-right-xl_18wu0_ayvp9_600",
    "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_ayvp9_601",
    "p-bottom-xl": "awsui_p-bottom-xl_18wu0_ayvp9_605",
    "p-left-xl": "awsui_p-left-xl_18wu0_ayvp9_610",
    "p-xxl": "awsui_p-xxl_18wu0_ayvp9_615",
    "p-top-xxl": "awsui_p-top-xxl_18wu0_ayvp9_620",
    "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_ayvp9_621",
    "p-right-xxl": "awsui_p-right-xxl_18wu0_ayvp9_625",
    "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_ayvp9_626",
    "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_ayvp9_630",
    "p-left-xxl": "awsui_p-left-xxl_18wu0_ayvp9_635",
    "p-xxxl": "awsui_p-xxxl_18wu0_ayvp9_640",
    "p-top-xxxl": "awsui_p-top-xxxl_18wu0_ayvp9_645",
    "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_ayvp9_646",
    "p-right-xxxl": "awsui_p-right-xxxl_18wu0_ayvp9_650",
    "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_ayvp9_651",
    "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_ayvp9_655",
    "p-left-xxxl": "awsui_p-left-xxxl_18wu0_ayvp9_660",
    "m-n": "awsui_m-n_18wu0_ayvp9_665",
    "m-top-n": "awsui_m-top-n_18wu0_ayvp9_670",
    "m-vertical-n": "awsui_m-vertical-n_18wu0_ayvp9_671",
    "m-right-n": "awsui_m-right-n_18wu0_ayvp9_675",
    "m-horizontal-n": "awsui_m-horizontal-n_18wu0_ayvp9_676",
    "m-bottom-n": "awsui_m-bottom-n_18wu0_ayvp9_680",
    "m-left-n": "awsui_m-left-n_18wu0_ayvp9_685",
    "m-xxxs": "awsui_m-xxxs_18wu0_ayvp9_690",
    "m-top-xxxs": "awsui_m-top-xxxs_18wu0_ayvp9_695",
    "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_ayvp9_696",
    "m-right-xxxs": "awsui_m-right-xxxs_18wu0_ayvp9_700",
    "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_ayvp9_701",
    "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_ayvp9_705",
    "m-left-xxxs": "awsui_m-left-xxxs_18wu0_ayvp9_710",
    "m-xxs": "awsui_m-xxs_18wu0_ayvp9_715",
    "m-top-xxs": "awsui_m-top-xxs_18wu0_ayvp9_720",
    "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_ayvp9_721",
    "m-right-xxs": "awsui_m-right-xxs_18wu0_ayvp9_725",
    "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_ayvp9_726",
    "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_ayvp9_730",
    "m-left-xxs": "awsui_m-left-xxs_18wu0_ayvp9_735",
    "m-xs": "awsui_m-xs_18wu0_ayvp9_740",
    "m-top-xs": "awsui_m-top-xs_18wu0_ayvp9_745",
    "m-vertical-xs": "awsui_m-vertical-xs_18wu0_ayvp9_746",
    "m-right-xs": "awsui_m-right-xs_18wu0_ayvp9_750",
    "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_ayvp9_751",
    "m-bottom-xs": "awsui_m-bottom-xs_18wu0_ayvp9_755",
    "m-left-xs": "awsui_m-left-xs_18wu0_ayvp9_760",
    "m-s": "awsui_m-s_18wu0_ayvp9_765",
    "m-top-s": "awsui_m-top-s_18wu0_ayvp9_770",
    "m-vertical-s": "awsui_m-vertical-s_18wu0_ayvp9_771",
    "m-right-s": "awsui_m-right-s_18wu0_ayvp9_775",
    "m-horizontal-s": "awsui_m-horizontal-s_18wu0_ayvp9_776",
    "m-bottom-s": "awsui_m-bottom-s_18wu0_ayvp9_780",
    "m-left-s": "awsui_m-left-s_18wu0_ayvp9_785",
    "m-m": "awsui_m-m_18wu0_ayvp9_790",
    "m-top-m": "awsui_m-top-m_18wu0_ayvp9_795",
    "m-vertical-m": "awsui_m-vertical-m_18wu0_ayvp9_796",
    "m-right-m": "awsui_m-right-m_18wu0_ayvp9_800",
    "m-horizontal-m": "awsui_m-horizontal-m_18wu0_ayvp9_801",
    "m-bottom-m": "awsui_m-bottom-m_18wu0_ayvp9_805",
    "m-left-m": "awsui_m-left-m_18wu0_ayvp9_810",
    "m-l": "awsui_m-l_18wu0_ayvp9_685",
    "m-top-l": "awsui_m-top-l_18wu0_ayvp9_820",
    "m-vertical-l": "awsui_m-vertical-l_18wu0_ayvp9_821",
    "m-right-l": "awsui_m-right-l_18wu0_ayvp9_825",
    "m-horizontal-l": "awsui_m-horizontal-l_18wu0_ayvp9_826",
    "m-bottom-l": "awsui_m-bottom-l_18wu0_ayvp9_830",
    "m-left-l": "awsui_m-left-l_18wu0_ayvp9_835",
    "m-xl": "awsui_m-xl_18wu0_ayvp9_840",
    "m-top-xl": "awsui_m-top-xl_18wu0_ayvp9_845",
    "m-vertical-xl": "awsui_m-vertical-xl_18wu0_ayvp9_846",
    "m-right-xl": "awsui_m-right-xl_18wu0_ayvp9_850",
    "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_ayvp9_851",
    "m-bottom-xl": "awsui_m-bottom-xl_18wu0_ayvp9_855",
    "m-left-xl": "awsui_m-left-xl_18wu0_ayvp9_860",
    "m-xxl": "awsui_m-xxl_18wu0_ayvp9_865",
    "m-top-xxl": "awsui_m-top-xxl_18wu0_ayvp9_870",
    "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_ayvp9_871",
    "m-right-xxl": "awsui_m-right-xxl_18wu0_ayvp9_875",
    "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_ayvp9_876",
    "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_ayvp9_880",
    "m-left-xxl": "awsui_m-left-xxl_18wu0_ayvp9_885",
    "m-xxxl": "awsui_m-xxxl_18wu0_ayvp9_890",
    "m-top-xxxl": "awsui_m-top-xxxl_18wu0_ayvp9_895",
    "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_ayvp9_896",
    "m-right-xxxl": "awsui_m-right-xxxl_18wu0_ayvp9_900",
    "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_ayvp9_901",
    "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_ayvp9_905",
    "m-left-xxxl": "awsui_m-left-xxxl_18wu0_ayvp9_910",
    "d-block": "awsui_d-block_18wu0_ayvp9_915",
    "d-inline": "awsui_d-inline_18wu0_ayvp9_918",
    "d-inline-block": "awsui_d-inline-block_18wu0_ayvp9_921",
    "d-none": "awsui_d-none_18wu0_ayvp9_924",
    "f-left": "awsui_f-left_18wu0_ayvp9_928",
    "f-right": "awsui_f-right_18wu0_ayvp9_932",
    "root": "awsui_root_18wu0_ayvp9_936"
};


function $897e30f655d0e79f$export$2e2bcd8739ae039({ variant: variant = 'div', tagOverride: tagOverride, margin: margin = {}, padding: padding = {}, display: display, textAlign: textAlign, float: float, fontSize: fontSize, fontWeight: fontWeight, color: color, children: children, nativeAttributes: nativeAttributes, __internalRootRef: __internalRootRef, ...props }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const marginsClassNamesSuffices = $897e30f655d0e79f$var$getClassNamesSuffixes(margin);
    const paddingsClassNamesSuffices = $897e30f655d0e79f$var$getClassNamesSuffixes(padding);
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039).root, (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039).box, (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`${variant.replace(/^awsui-/, '')}-variant`], marginsClassNamesSuffices.map((suffix)=>(0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`m-${suffix}`]), paddingsClassNamesSuffices.map((suffix)=>(0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`p-${suffix}`]), (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`d-${display}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`f-${float}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`color-${color || 'default'}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`font-size-${fontSize || 'default'}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`font-weight-${fontWeight || 'default'}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`t-${textAlign}`]);
    // allow auto-focusing of h1 boxes from flashbar
    const tabindex = variant === 'h1' ? -1 : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...baseProps,
        tag: $897e30f655d0e79f$var$getTag(variant, tagOverride),
        componentName: "Box",
        tabIndex: tabindex,
        nativeAttributes: nativeAttributes,
        className: className,
        ref: __internalRootRef
    }, children);
}
const $897e30f655d0e79f$var$getClassNamesSuffixes = (value)=>{
    if (typeof value === 'string') return [
        value
    ];
    const sides = [
        'top',
        'right',
        'bottom',
        'left',
        'horizontal',
        'vertical'
    ];
    return sides.filter((side)=>!!value[side]).map((side)=>`${side}-${value[side]}`);
};
const $897e30f655d0e79f$var$getTag = (variant, tagOverride)=>{
    if (tagOverride) return tagOverride;
    if (variant === 'awsui-value-large') return 'span';
    if (variant === 'awsui-key-label' || variant === 'awsui-gen-ai-label') return 'div';
    if (variant === 'awsui-inline-code') return 'code';
    return variant;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");











function $f509ecfba65f3bd6$export$464b090d8a567e1e(ref, options) {
    const colorMode = (0, $013a2451794a45c0$exports.useCurrentMode)(ref);
    const densityMode = (0, $013a2451794a45c0$exports.useDensityMode)(ref);
    const context = (0, $8856d0c7df08fd8d$export$c894375248ea16f2)(ref);
    const visualRefreshWithClass = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)() && !(0, $93d122f201f7d1ff$export$6d52b47269698ace);
    return (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        'awsui-polaris-dark-mode awsui-dark-mode': colorMode === 'dark',
        'awsui-polaris-compact-mode awsui-compact-mode': densityMode === 'compact',
        'awsui-visual-refresh': visualRefreshWithClass,
        [`awsui-context-${context}`]: context && !(options === null || options === void 0 ? void 0 : options.resetVisualContext)
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $6dba20b13890af88$var$DropdownContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    position: 'bottom-right'
});
function $6dba20b13890af88$export$22388a4cee803578({ children: children, position: position = 'bottom-right' }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6dba20b13890af88$var$DropdownContext.Provider, {
        value: {
            position: position
        }
    }, children);
}
function $6dba20b13890af88$export$28c3a9869c2838c2() {
    return (0, $acw62.useContext)($6dba20b13890af88$var$DropdownContext);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $1ddb2649063bc7db$export$2e2bcd8739ae039 = {
    "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_dpzx6_153",
    "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_dpzx6_1",
    "refresh": "awsui_refresh_qwoo0_dpzx6_174",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_dpzx6_1",
    "root": "awsui_root_qwoo0_dpzx6_199",
    "interior": "awsui_interior_qwoo0_dpzx6_232",
    "dropdown": "awsui_dropdown_qwoo0_dpzx6_153",
    "use-portal": "awsui_use-portal_qwoo0_dpzx6_242",
    "is-empty": "awsui_is-empty_qwoo0_dpzx6_318",
    "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_dpzx6_325",
    "with-limited-width": "awsui_with-limited-width_qwoo0_dpzx6_329",
    "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_dpzx6_332",
    "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_dpzx6_335",
    "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_dpzx6_338",
    "use-flexible-width": "awsui_use-flexible-width_qwoo0_dpzx6_341",
    "hide-block-border": "awsui_hide-block-border_qwoo0_dpzx6_349",
    "open": "awsui_open_qwoo0_dpzx6_358",
    "nowrap": "awsui_nowrap_qwoo0_dpzx6_367",
    "dropdown-content": "awsui_dropdown-content_qwoo0_dpzx6_153",
    "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_dpzx6_378"
};


const $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT = 50;
const $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL = 19; // 50 - 31
const $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL = 20;
const $a1c35d16322b3b4d$var$getClosestParentDimensions = (element)=>{
    const parents = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(element).map((element)=>{
        const { blockSize: blockSize, inlineSize: inlineSize, insetBlockStart: insetBlockStart, insetInlineStart: insetInlineStart } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(element);
        return {
            blockSize: blockSize,
            inlineSize: inlineSize,
            insetBlockStart: insetBlockStart,
            insetInlineStart: insetInlineStart
        };
    });
    return parents.shift();
};
const $a1c35d16322b3b4d$var$getAvailableSpace = ({ trigger: trigger, overflowParents: overflowParents, stretchWidth: stretchWidth = false, stretchHeight: stretchHeight = false, isMobile: isMobile })=>{
    const availableSpaceReserveVertical = stretchHeight ? 0 : isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const availableSpaceReserveHorizontal = stretchWidth ? 0 : isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const { insetBlockEnd: triggerBlockEnd, insetInlineStart: triggerInlineStart, insetInlineEnd: triggerInlineEnd } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(trigger);
    return overflowParents.reduce(({ blockStart: blockStart, blockEnd: blockEnd, inlineStart: inlineStart, inlineEnd: inlineEnd }, overflowParent)=>{
        const offsetTop = triggerBlockEnd - overflowParent.insetBlockStart;
        const currentBlockStart = offsetTop - trigger.offsetHeight - availableSpaceReserveVertical;
        const currentBlockEnd = overflowParent.blockSize - offsetTop - availableSpaceReserveVertical;
        const currentInlineStart = triggerInlineEnd - overflowParent.insetInlineStart - availableSpaceReserveHorizontal;
        const currentInlineEnd = overflowParent.insetInlineStart + overflowParent.inlineSize - triggerInlineStart - availableSpaceReserveHorizontal;
        return {
            blockStart: Math.min(blockStart, currentBlockStart),
            blockEnd: Math.min(blockEnd, currentBlockEnd),
            inlineStart: Math.min(inlineStart, currentInlineStart),
            inlineEnd: Math.min(inlineEnd, currentInlineEnd)
        };
    }, {
        blockStart: Number.MAX_VALUE,
        blockEnd: Number.MAX_VALUE,
        inlineStart: Number.MAX_VALUE,
        inlineEnd: Number.MAX_VALUE
    });
};
const $a1c35d16322b3b4d$var$getInteriorAvailableSpace = ({ trigger: trigger, overflowParents: overflowParents, isMobile: isMobile })=>{
    const AVAILABLE_SPACE_RESERVE_VERTICAL = isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const AVAILABLE_SPACE_RESERVE_HORIZONTAL = isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const { insetBlockEnd: triggerBlockEnd, insetBlockStart: triggerBlockStart, insetInlineStart: triggerInlineStart, insetInlineEnd: triggerInlineEnd } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(trigger);
    return overflowParents.reduce(({ blockStart: blockStart, blockEnd: blockEnd, inlineStart: inlineStart, inlineEnd: inlineEnd }, overflowParent)=>{
        const currentBlockStart = triggerBlockEnd - overflowParent.insetBlockStart - AVAILABLE_SPACE_RESERVE_VERTICAL;
        const currentBlockEnd = overflowParent.blockSize - triggerBlockStart + overflowParent.insetBlockStart - AVAILABLE_SPACE_RESERVE_VERTICAL;
        const currentInlineStart = triggerInlineStart - overflowParent.insetInlineStart - AVAILABLE_SPACE_RESERVE_HORIZONTAL;
        const currentInlineEnd = overflowParent.insetInlineStart + overflowParent.inlineSize - triggerInlineEnd - AVAILABLE_SPACE_RESERVE_HORIZONTAL;
        return {
            blockStart: Math.min(blockStart, currentBlockStart),
            blockEnd: Math.min(blockEnd, currentBlockEnd),
            inlineStart: Math.min(inlineStart, currentInlineStart),
            inlineEnd: Math.min(inlineEnd, currentInlineEnd)
        };
    }, {
        blockStart: Number.MAX_VALUE,
        blockEnd: Number.MAX_VALUE,
        inlineStart: Number.MAX_VALUE,
        inlineEnd: Number.MAX_VALUE
    });
};
const $a1c35d16322b3b4d$var$resolveWidthConstraint = (constraint, triggerWidth, fallback)=>{
    if (constraint === 'trigger') return triggerWidth;
    if (typeof constraint === 'number') return constraint;
    return fallback;
};
const $a1c35d16322b3b4d$var$getWidths = ({ triggerElement: triggerElement, dropdownElement: dropdownElement, minWidthConstraint: minWidthConstraint, maxWidthConstraint: maxWidthConstraint })=>{
    const { inlineSize: triggerInlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(triggerElement);
    const { inlineSize: requiredWidth } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(dropdownElement);
    const minWidth = $a1c35d16322b3b4d$var$resolveWidthConstraint(minWidthConstraint, triggerInlineSize, 0);
    const maxWidth = $a1c35d16322b3b4d$var$resolveWidthConstraint(maxWidthConstraint, triggerInlineSize, Number.MAX_VALUE);
    const idealWidth = Math.min(Math.max(requiredWidth, minWidth), maxWidth);
    return {
        idealWidth: idealWidth,
        minWidth: minWidth,
        triggerInlineSize: triggerInlineSize
    };
};
const $a1c35d16322b3b4d$export$70cf0ab8e9670856 = ({ triggerElement: triggerElement, dropdownElement: dropdownElement, minWidthConstraint: minWidthConstraint, maxWidthConstraint: maxWidthConstraint, expandToViewport: expandToViewport, stretchHeight: stretchHeight, isMobile: isMobile })=>{
    const overflowParents = (0, $24d40242cc6554ee$export$788cd595d1360cb2)({
        element: dropdownElement,
        excludeClosestParent: false,
        expandToViewport: expandToViewport,
        canExpandOutsideViewport: stretchHeight
    });
    const { idealWidth: idealWidth } = $a1c35d16322b3b4d$var$getWidths({
        triggerElement: triggerElement,
        dropdownElement: dropdownElement,
        minWidthConstraint: minWidthConstraint,
        maxWidthConstraint: maxWidthConstraint
    });
    const availableSpace = $a1c35d16322b3b4d$var$getAvailableSpace({
        trigger: triggerElement,
        overflowParents: overflowParents,
        stretchHeight: stretchHeight,
        isMobile: isMobile
    });
    return idealWidth <= availableSpace.inlineStart || idealWidth <= availableSpace.inlineEnd;
};
const $a1c35d16322b3b4d$export$7b2b760a2a5bbf54 = ({ triggerElement: triggerElement, dropdownElement: dropdownElement, overflowParents: overflowParents, minWidth: minWidthConstraint, maxWidth: maxWidthConstraint, preferCenter: preferCenter = false, matchTriggerWidth: matchTriggerWidth = false, stretchHeight: stretchHeight = false, isMobile: isMobile = false })=>{
    // Determine the space available around the dropdown that it can grow in
    const availableSpace = $a1c35d16322b3b4d$var$getAvailableSpace({
        trigger: triggerElement,
        overflowParents: overflowParents,
        stretchWidth: matchTriggerWidth,
        stretchHeight: stretchHeight,
        isMobile: isMobile
    });
    const { idealWidth: idealWidth, minWidth: minWidth, triggerInlineSize: triggerInlineSize } = $a1c35d16322b3b4d$var$getWidths({
        triggerElement: triggerElement,
        dropdownElement: dropdownElement,
        minWidthConstraint: minWidthConstraint,
        maxWidthConstraint: maxWidthConstraint
    });
    let dropInlineStart;
    let insetInlineStart = null;
    let inlineSize = idealWidth;
    //1. Can it be positioned with ideal width to the right?
    if (idealWidth <= availableSpace.inlineEnd) dropInlineStart = false;
    else if (idealWidth <= availableSpace.inlineStart) dropInlineStart = true;
    else {
        dropInlineStart = availableSpace.inlineStart > availableSpace.inlineEnd;
        inlineSize = Math.max(availableSpace.inlineStart, availableSpace.inlineEnd, minWidth);
    }
    if (preferCenter) {
        const spillOver = (idealWidth - triggerInlineSize) / 2;
        // availableSpace always includes the trigger width, but we want to exclude that
        const availableOutsideLeft = availableSpace.inlineStart - triggerInlineSize;
        const availableOutsideRight = availableSpace.inlineEnd - triggerInlineSize;
        const fitsInCenter = availableOutsideLeft >= spillOver && availableOutsideRight >= spillOver;
        if (fitsInCenter) insetInlineStart = -spillOver;
    }
    const dropBlockStart = availableSpace.blockEnd < dropdownElement.offsetHeight && availableSpace.blockStart > availableSpace.blockEnd;
    const availableHeight = dropBlockStart ? availableSpace.blockStart : availableSpace.blockEnd;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    const croppedHeight = Math.max(stretchHeight ? availableHeight : Math.floor(availableHeight / 31) * 31 + 16, 15);
    return {
        dropBlockStart: dropBlockStart,
        dropInlineStart: dropInlineStart,
        insetInlineStart: insetInlineStart === null ? 'auto' : `${insetInlineStart}px`,
        blockSize: `${croppedHeight}px`,
        inlineSize: `${inlineSize}px`
    };
};
const $a1c35d16322b3b4d$var$getInteriorDropdownPosition = (trigger, dropdown, overflowParents, isMobile)=>{
    const availableSpace = $a1c35d16322b3b4d$var$getInteriorAvailableSpace({
        trigger: trigger,
        overflowParents: overflowParents,
        isMobile: isMobile
    });
    const { insetBlockEnd: triggerBlockEnd, insetBlockStart: triggerBlockStart, inlineSize: triggerInlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(trigger);
    const { insetBlockStart: parentDropdownBlockStart, blockSize: parentDropdownHeight } = $a1c35d16322b3b4d$var$getClosestParentDimensions(trigger);
    let dropInlineStart;
    let { inlineSize: inlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(dropdown);
    const insetBlockStart = triggerBlockStart - parentDropdownBlockStart;
    if (inlineSize <= availableSpace.inlineEnd) dropInlineStart = false;
    else if (inlineSize <= availableSpace.inlineStart) dropInlineStart = true;
    else {
        dropInlineStart = availableSpace.inlineStart > availableSpace.inlineEnd;
        inlineSize = Math.max(availableSpace.inlineStart, availableSpace.inlineEnd);
    }
    const insetInlineStart = dropInlineStart ? 0 - inlineSize : triggerInlineSize;
    const dropBlockStart = availableSpace.blockEnd < dropdown.offsetHeight && availableSpace.blockStart > availableSpace.blockEnd;
    const insetBlockEnd = dropBlockStart ? parentDropdownBlockStart + parentDropdownHeight - triggerBlockEnd : 0;
    const availableHeight = dropBlockStart ? availableSpace.blockStart : availableSpace.blockEnd;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    const croppedHeight = Math.floor(availableHeight / 31) * 31 + 16;
    return {
        dropBlockStart: dropBlockStart,
        dropInlineStart: dropInlineStart,
        blockSize: `${croppedHeight}px`,
        inlineSize: `${inlineSize}px`,
        insetBlockStart: `${insetBlockStart}px`,
        insetBlockEnd: `${insetBlockEnd}px`,
        insetInlineStart: `${insetInlineStart}px`
    };
};
const $a1c35d16322b3b4d$export$b3ceb0cbf1056d98 = (dropdownElement, triggerElement, verticalContainerElement, interior, expandToViewport, preferCenter, matchTriggerWidth, stretchHeight, isMobile, minWidth, maxWidth)=>{
    // cleaning previously assigned values,
    // so that they are not reused in case of screen resize and similar events
    verticalContainerElement.style.maxBlockSize = '';
    dropdownElement.style.inlineSize = '';
    dropdownElement.style.insetBlockStart = '';
    dropdownElement.style.insetBlockEnd = '';
    dropdownElement.style.insetInlineStart = '';
    dropdownElement.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-drop-left']);
    dropdownElement.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-drop-right']);
    dropdownElement.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-drop-up']);
    const overflowParents = (0, $24d40242cc6554ee$export$788cd595d1360cb2)({
        element: dropdownElement,
        excludeClosestParent: interior,
        expandToViewport: expandToViewport,
        canExpandOutsideViewport: stretchHeight
    });
    const position = interior ? $a1c35d16322b3b4d$var$getInteriorDropdownPosition(triggerElement, dropdownElement, overflowParents, isMobile) : $a1c35d16322b3b4d$export$7b2b760a2a5bbf54({
        triggerElement: triggerElement,
        dropdownElement: dropdownElement,
        overflowParents: overflowParents,
        minWidth: minWidth,
        maxWidth: maxWidth,
        preferCenter: preferCenter,
        matchTriggerWidth: matchTriggerWidth,
        stretchHeight: stretchHeight,
        isMobile: isMobile
    });
    const triggerBox = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(triggerElement);
    return [
        position,
        triggerBox
    ];
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Applies its position to the dropdown element when expandToViewport is set to true.
function $b4b3e9c6b4ec8b29$export$3f19ef3440dd31b5({ position: position, dropdownElement: dropdownElement, triggerRect: triggerRect, isMobile: isMobile }) {
    // Fixed positions are not respected in iOS when the virtual keyboard is being displayed.
    // For this reason we use absolute positioning in mobile.
    const useAbsolutePositioning = isMobile;
    // Since when using expandToViewport=true the dropdown is attached to the root of the body,
    // the same coordinates can be used for fixed or absolute position,
    // except when using absolute position we need to take into account the scroll position of the body itself.
    const verticalScrollOffset = useAbsolutePositioning ? document.documentElement.scrollTop : 0;
    const horizontalScrollOffset = useAbsolutePositioning ? document.documentElement.scrollLeft : 0;
    dropdownElement.style.position = useAbsolutePositioning ? 'absolute' : 'fixed';
    if (position.dropBlockStart) dropdownElement.style.insetBlockEnd = `calc(100% - ${verticalScrollOffset + triggerRect.insetBlockStart}px)`;
    else dropdownElement.style.insetBlockStart = `${verticalScrollOffset + triggerRect.insetBlockEnd}px`;
    if (position.dropInlineStart) {
        // For right-aligned dropdowns, use the actual rendered width when flexible width is enabled
        // to ensure proper alignment even when CSS constraints differ from calculated inlineSize
        const actualWidth = dropdownElement.getBoundingClientRect().width;
        dropdownElement.style.insetInlineStart = `calc(${horizontalScrollOffset + triggerRect.insetInlineEnd}px - ${actualWidth}px)`;
    } else dropdownElement.style.insetInlineStart = `${horizontalScrollOffset + triggerRect.insetInlineStart}px`;
}



const $1fd689c8894b21bd$var$DropdownContainer = ({ triggerRef: triggerRef, children: children, renderWithPortal: renderWithPortal, id: id, referrerId: referrerId, open: open })=>{
    var _a, _b;
    if (!renderWithPortal) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    if (!open) return null;
    const currentDocument = (_b = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : document;
    return (0, $11492dca620dcaa5$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        "data-awsui-referrer-id": referrerId
    }, children), currentDocument.body);
};
const $1fd689c8894b21bd$var$TransitionContent = ({ state: state, transitionRef: transitionRef, dropdownClasses: dropdownClasses, matchTriggerWidth: matchTriggerWidth, hideBlockBorder: hideBlockBorder, interior: interior, isRefresh: isRefresh, dropdownRef: dropdownRef, verticalContainerRef: verticalContainerRef, expandToViewport: expandToViewport, minWidth: minWidth, maxWidth: maxWidth, header: header, content: content, footer: footer, position: position, open: open, onMouseDown: onMouseDown, onFocusEnter: onFocusEnter, onFocusLeave: onFocusLeave, id: id, ariaRole: ariaRole, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby })=>{
    const contentRef = (0, $013a2451794a45c0$exports.useMergeRefs)(dropdownRef, transitionRef);
    const dropdownStyles = {};
    if (minWidth) dropdownStyles[(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).dropdownDefaultMinWidth] = minWidth;
    if (maxWidth) dropdownStyles[(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).dropdownDefaultMaxWidth] = maxWidth;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).dropdown, dropdownClasses, {
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039).open]: open,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['with-limited-width']]: !matchTriggerWidth,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['hide-block-border']]: hideBlockBorder,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039).interior]: interior,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039).refresh]: isRefresh,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['use-portal']]: expandToViewport && !interior,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['use-flexible-width']]: !matchTriggerWidth && !interior
        }),
        ref: contentRef,
        id: id,
        role: ariaRole,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "data-open": open,
        "data-animating": state !== 'exited',
        "aria-hidden": !open,
        style: dropdownStyles,
        onMouseDown: onMouseDown,
        onFocus: onFocusEnter,
        onBlur: onFocusLeave
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-content-wrapper'], !header && !content && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['is-empty'], isRefresh && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039).refresh)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: verticalContainerRef,
        className: (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-content']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6dba20b13890af88$export$22388a4cee803578), {
        position: position
    }, header, content, footer))));
};
const $1fd689c8894b21bd$var$Dropdown = ({ content: content, trigger: trigger, open: open, onOutsideClick: onOutsideClick, onMouseDown: onMouseDown, header: header, footer: footer, dropdownId: dropdownId, stretchTriggerHeight: stretchTriggerHeight = false, stretchHeight: stretchHeight = false, minWidth: minWidth, maxWidth: maxWidth, hideBlockBorder: hideBlockBorder = true, expandToViewport: expandToViewport = false, preferredAlignment: preferredAlignment = 'start', interior: interior = false, scrollable: scrollable = true, loopFocus: loopFocus = expandToViewport, onFocus: onFocus, onBlur: onBlur, onFocusEnter: onFocusEnter, onFocusLeave: onFocusLeave, onEscape: onEscape, contentKey: contentKey, dropdownContentId: dropdownContentId, ariaRole: ariaRole, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby })=>{
    const wrapperRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const dropdownRef = (0, $acw62.useRef)(null);
    const dropdownContainerRef = (0, $acw62.useRef)(null);
    const verticalContainerRef = (0, $acw62.useRef)(null);
    // To keep track of the initial position (drop up/down) which is kept the same during fixed repositioning
    const fixedPosition = (0, $acw62.useRef)(null);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const dropdownClasses = (0, $f509ecfba65f3bd6$export$464b090d8a567e1e)(triggerRef);
    const [position, setPosition] = (0, $acw62.useState)('bottom-right');
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    // Derive if dropdown should match trigger width exactly
    // This happens when both minWidth and maxWidth are explicitly set to 'trigger'
    const matchTriggerWidth = minWidth === 'trigger' && maxWidth === 'trigger';
    // Convert preferredAlignment to boolean for internal positioning logic
    const preferCenter = preferredAlignment === 'center';
    const setDropdownPosition = (position, triggerBox, target, verticalContainer)=>{
        verticalContainer.style.maxBlockSize = position.blockSize;
        // Only apply occupy-entire-width when matching trigger width exactly and not in portal mode
        if (!interior && matchTriggerWidth && !expandToViewport) target.classList.add((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['occupy-entire-width']);
        else target.style.inlineSize = position.inlineSize;
        // Using styles for main dropdown to adjust its position as preferred alternative
        if (position.dropBlockStart && !interior) {
            target.classList.add((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-drop-up']);
            if (!expandToViewport) target.style.insetBlockEnd = '100%';
        } else target.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-drop-up']);
        target.classList.add(position.dropInlineStart ? (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-drop-left'] : (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['dropdown-drop-right']);
        if (position.insetInlineStart && position.insetInlineStart !== 'auto') target.style.insetInlineStart = position.insetInlineStart;
        // Position normal overflow dropdowns with fixed positioning relative to viewport
        if (expandToViewport && !interior) {
            (0, $b4b3e9c6b4ec8b29$export$3f19ef3440dd31b5)({
                position: position,
                dropdownElement: target,
                triggerRect: triggerBox,
                isMobile: isMobile
            });
            // Keep track of the initial dropdown position and direction.
            // Dropdown direction doesn't need to change as the user scrolls, just needs to stay attached to the trigger.
            fixedPosition.current = position;
            return;
        }
        // For an interior dropdown (the fly out) we need exact values for positioning
        // and classes are not enough
        // usage of relative position is impossible due to overwrite of overflow-x
        if (interior && $1fd689c8894b21bd$var$isInteriorPosition(position)) {
            if (position.dropBlockStart) target.style.insetBlockEnd = position.insetBlockEnd;
            else target.style.insetBlockStart = position.insetBlockStart;
            target.style.insetInlineStart = position.insetInlineStart;
        }
        if (position.dropBlockStart && position.dropInlineStart) setPosition('top-left');
        else if (position.dropBlockStart) setPosition('top-right');
        else if (position.dropInlineStart) setPosition('bottom-left');
        else setPosition('bottom-right');
    };
    const isOutsideDropdown = (element)=>(!wrapperRef.current || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(wrapperRef.current, element)) && (!dropdownContainerRef.current || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(dropdownContainerRef.current, element));
    const focusHandler = (event)=>{
        if (!event.relatedTarget || isOutsideDropdown(event.relatedTarget)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus, event);
    };
    const blurHandler = (event)=>{
        if (!event.relatedTarget || isOutsideDropdown(event.relatedTarget)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur, event);
    };
    const isOutsideDropdownContent = (element)=>!dropdownRef.current || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(dropdownRef.current, element);
    const focusEnterHandler = (event)=>{
        if (!event.relatedTarget || isOutsideDropdownContent(event.relatedTarget)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocusEnter, event);
    };
    const focusLeaveHandler = (event)=>{
        if (!event.relatedTarget || isOutsideDropdownContent(event.relatedTarget)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocusLeave, event);
    };
    // Check if the dropdown has enough space to fit with its desired width constraints
    // If not, remove the class that allows flexible width sizing
    const fixStretching = ()=>{
        const classNameToRemove = (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['use-flexible-width'];
        if (open && dropdownRef.current && triggerRef.current && dropdownRef.current.classList.contains(classNameToRemove) && !(0, $a1c35d16322b3b4d$export$70cf0ab8e9670856)({
            triggerElement: triggerRef.current,
            dropdownElement: dropdownRef.current,
            minWidthConstraint: minWidth,
            maxWidthConstraint: maxWidth,
            expandToViewport: expandToViewport,
            stretchHeight: stretchHeight,
            isMobile: isMobile
        })) dropdownRef.current.classList.remove(classNameToRemove);
    };
    (0, $013a2451794a45c0$exports.useResizeObserver)(()=>dropdownRef.current, fixStretching);
    (0, $acw62.useLayoutEffect)(()=>{
        const onDropdownOpen = ()=>{
            if (open && dropdownRef.current && triggerRef.current && verticalContainerRef.current) {
                if (scrollable) dropdownRef.current.classList.add((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).nowrap);
                setDropdownPosition(...(0, $a1c35d16322b3b4d$export$b3ceb0cbf1056d98)(dropdownRef.current, triggerRef.current, verticalContainerRef.current, interior, expandToViewport, preferCenter, matchTriggerWidth, stretchHeight, isMobile, minWidth, maxWidth), dropdownRef.current, verticalContainerRef.current);
                if (scrollable) dropdownRef.current.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).nowrap);
            }
        };
        onDropdownOpen();
        if (open) {
            // window may scroll when dropdown opens, for example when soft keyboard shows up
            window.addEventListener('scroll', onDropdownOpen);
            // only listen to window scroll within very short time after the dropdown opens
            // do not want to interfere dropdown position on scroll afterwards
            const timeoutId = setTimeout(()=>{
                window.removeEventListener('scroll', onDropdownOpen);
            }, 500);
            return ()=>{
                clearTimeout(timeoutId);
                window.removeEventListener('scroll', onDropdownOpen);
            };
        }
    // See AWSUI-13040
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        dropdownRef,
        triggerRef,
        verticalContainerRef,
        interior,
        matchTriggerWidth,
        isMobile,
        contentKey
    ]);
    // subscribe to outside click
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const clickListener = (event)=>{
            // Since the listener is registered on the window, `event.target` will incorrectly point at the
            // shadow root if the component is rendered inside shadow DOM.
            const target = event.composedPath ? event.composedPath()[0] : event.target;
            if (!(0, $4c778684f125e678$export$57d4cb221e1d1857)(dropdownRef.current, target) && !(0, $4c778684f125e678$export$57d4cb221e1d1857)(triggerRef.current, target)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onOutsideClick);
        };
        window.addEventListener('click', clickListener, true);
        return ()=>{
            window.removeEventListener('click', clickListener, true);
        };
    }, [
        open,
        onOutsideClick
    ]);
    // subscribe to Escape key press
    (0, $acw62.useEffect)(()=>{
        // Only add the listener if onEscape callback is provided
        if (!open || !onEscape) return;
        const keydownListener = (event)=>{
            if (event.key === 'Escape') {
                // Prevent any surrounding modals or dialogs from acting on this Escape key
                event.stopPropagation();
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onEscape);
            }
        };
        window.addEventListener('keydown', keydownListener, true);
        return ()=>{
            window.removeEventListener('keydown', keydownListener, true);
        };
    }, [
        open,
        onEscape
    ]);
    // sync dropdown position on scroll and resize
    (0, $acw62.useLayoutEffect)(()=>{
        if (!expandToViewport || !open) return;
        const updateDropdownPosition = ()=>{
            if (triggerRef.current && dropdownRef.current && verticalContainerRef.current && fixedPosition.current) (0, $b4b3e9c6b4ec8b29$export$3f19ef3440dd31b5)({
                position: fixedPosition.current,
                dropdownElement: dropdownRef.current,
                triggerRect: (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(triggerRef.current),
                isMobile: isMobile
            });
        };
        updateDropdownPosition();
        const controller = new AbortController();
        window.addEventListener('scroll', updateDropdownPosition, {
            capture: true,
            signal: controller.signal
        });
        window.addEventListener('resize', updateDropdownPosition, {
            capture: true,
            signal: controller.signal
        });
        return ()=>{
            controller.abort();
        };
    }, [
        open,
        expandToViewport,
        isMobile
    ]);
    const referrerId = (0, $013a2451794a45c0$exports.useUniqueId)();
    // Compute CSS variable values for min/max width
    // These will be used by the use-flexible-width CSS class
    const getMinWidthCssValue = ()=>{
        if (minWidth === undefined) return undefined;
        if (typeof minWidth === 'number') return `${minWidth}px`;
        // 'trigger' maps to 100% (relative to parent)
        return '100%';
    };
    const getMaxWidthCssValue = ()=>{
        if (maxWidth === undefined) return 'none';
        if (typeof maxWidth === 'number') return `${maxWidth}px`;
        // 'trigger' maps to 100% (relative to parent)
        return '100%';
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).root, interior && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039).interior, stretchTriggerHeight && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['stretch-trigger-height']),
        ref: wrapperRef,
        onFocus: focusHandler,
        onBlur: blurHandler
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: referrerId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(stretchTriggerHeight && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)['stretch-trigger-height']),
        ref: triggerRef
    }, trigger), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
        focusNextCallback: ()=>{
            var _a;
            return dropdownRef.current && ((_a = (0, $eaddf2de854ee801$export$748138f04a69bf21)(dropdownRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
        },
        disabled: !open || !loopFocus
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1fd689c8894b21bd$var$DropdownContainer, {
        triggerRef: triggerRef,
        renderWithPortal: expandToViewport && !interior,
        id: dropdownId,
        referrerId: referrerId,
        open: open
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: open !== null && open !== void 0 ? open : false,
        exit: false
    }, (state, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: dropdownContainerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
            focusNextCallback: ()=>{
                var _a;
                return triggerRef.current && ((_a = (0, $eaddf2de854ee801$export$73e81fa65335a75b)(triggerRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
            },
            disabled: !open || !loopFocus
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1fd689c8894b21bd$var$TransitionContent, {
            state: state,
            transitionRef: ref,
            dropdownClasses: dropdownClasses,
            open: open,
            matchTriggerWidth: matchTriggerWidth,
            hideBlockBorder: hideBlockBorder,
            interior: interior,
            header: header,
            content: content,
            expandToViewport: expandToViewport,
            minWidth: getMinWidthCssValue(),
            maxWidth: getMaxWidthCssValue(),
            footer: footer,
            onMouseDown: onMouseDown,
            onFocusEnter: focusEnterHandler,
            onFocusLeave: focusLeaveHandler,
            isRefresh: isRefresh,
            dropdownRef: dropdownRef,
            verticalContainerRef: verticalContainerRef,
            position: position,
            id: dropdownContentId,
            ariaRole: ariaRole,
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            ariaDescribedby: ariaDescribedby
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
            focusNextCallback: ()=>{
                var _a;
                return triggerRef.current && ((_a = (0, $eaddf2de854ee801$export$748138f04a69bf21)(triggerRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
            },
            disabled: !open || !loopFocus
        })))));
};
const $1fd689c8894b21bd$var$isInteriorPosition = (position)=>position.insetBlockEnd !== undefined;
var $1fd689c8894b21bd$export$2e2bcd8739ae039 = $1fd689c8894b21bd$var$Dropdown;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $1yiQH = parcelRequire("1yiQH");




var $89495c474e85c0d6$export$2e2bcd8739ae039 = {
    "options-list": "awsui_options-list_19gcf_11x8t_145",
    "options-list-embedded": "awsui_options-list-embedded_19gcf_11x8t_192",
    "decrease-block-margin": "awsui_decrease-block-margin_19gcf_11x8t_199"
};


const $4b0a4cb0aaef194c$var$BOTTOM_TRIGGER_OFFSET = 80;
const $4b0a4cb0aaef194c$var$getItemIndex = (containerRef, event)=>{
    const target = (0, $1yiQH.findUpUntil)(event.target, (element)=>element === containerRef.current || !!element.dataset.mouseTarget);
    const mouseTarget = target === null || target === void 0 ? void 0 : target.dataset.mouseTarget;
    return mouseTarget ? parseInt(mouseTarget) : -1;
};
const $4b0a4cb0aaef194c$var$OptionsList = ({ open: open, statusType: statusType, children: children, nativeAttributes: nativeAttributes = {}, onKeyDown: onKeyDown, onBlur: onBlur, onFocus: onFocus, onLoadMore: onLoadMore, onMouseUp: onMouseUp, onMouseMove: onMouseMove, position: position = 'relative', role: role = 'listbox', tagOverride: Tag = 'div', decreaseBlockMargin: decreaseBlockMargin = false, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, embedded: embedded, stickyItemBlockSize: stickyItemBlockSize, isMultiSelect: isMultiSelect, ...restProps }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const menuRef = (0, $acw62.useRef)(null);
    const handleScroll = (0, $013a2451794a45c0$exports.useStableCallback)(()=>{
        const scrollContainer = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current;
        if (scrollContainer) {
            const bottomEdgePosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
            const remainingScrollHeight = scrollContainer.scrollHeight - bottomEdgePosition;
            if (remainingScrollHeight < $4b0a4cb0aaef194c$var$BOTTOM_TRIGGER_OFFSET) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadMore);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (open && statusType === 'pending') handleScroll();
    }, [
        open,
        statusType,
        handleScroll
    ]);
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89495c474e85c0d6$export$2e2bcd8739ae039)['options-list'], {
        [(0, $89495c474e85c0d6$export$2e2bcd8739ae039)['decrease-block-margin']]: decreaseBlockMargin,
        [(0, $89495c474e85c0d6$export$2e2bcd8739ae039)['options-list-embedded']]: embedded
    });
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(ref, menuRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ...baseProps,
        ...nativeAttributes,
        className: className,
        ref: mergedRef,
        style: {
            position: position,
            scrollPaddingBlockStart: stickyItemBlockSize !== null && stickyItemBlockSize !== void 0 ? stickyItemBlockSize : undefined
        },
        role: role,
        onScroll: handleScroll,
        onKeyDown: (event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event),
        onMouseMove: (event)=>onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove($4b0a4cb0aaef194c$var$getItemIndex(menuRef, event)),
        onMouseUp: (event)=>onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp($4b0a4cb0aaef194c$var$getItemIndex(menuRef, event)),
        onBlur: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur, {
                relatedTarget: event.relatedTarget
            }),
        onFocus: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus),
        tabIndex: embedded ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-multiselectable": role === 'listbox' && isMultiSelect ? true : undefined
    }, open && children);
};
var $4b0a4cb0aaef194c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($4b0a4cb0aaef194c$var$OptionsList);





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $17bc88d78d27c4da$export$7cd733a6d16526b = (styles, className, open)=>(0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(styles[className], open && styles[`${className}-open`]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $faef8237080e4d9e$export$2e2bcd8739ae039 = {
    "header": "awsui_header_16mm3_1ethj_145",
    "disabled": "awsui_disabled_16mm3_1ethj_161",
    "no-content-styling": "awsui_no-content-styling_16mm3_1ethj_165",
    "expandable-header": "awsui_expandable-header_16mm3_1ethj_171",
    "rolled-down": "awsui_rolled-down_16mm3_1ethj_182",
    "highlighted": "awsui_highlighted_16mm3_1ethj_185",
    "is-focused": "awsui_is-focused_16mm3_1ethj_208",
    "visual-refresh": "awsui_visual-refresh_16mm3_1ethj_211",
    "category": "awsui_category_16mm3_1ethj_215",
    "expandable": "awsui_expandable_16mm3_1ethj_171",
    "variant-navigation": "awsui_variant-navigation_16mm3_1ethj_230",
    "expand-icon": "awsui_expand-icon_16mm3_1ethj_237",
    "expand-icon-up": "awsui_expand-icon-up_16mm3_1ethj_255",
    "expand-icon-right": "awsui_expand-icon-right_16mm3_1ethj_258",
    "items-list-container": "awsui_items-list-container_16mm3_1ethj_266",
    "in-dropdown": "awsui_in-dropdown_16mm3_1ethj_275",
    "icon-wrapper": "awsui_icon-wrapper_16mm3_1ethj_279",
    "header-content": "awsui_header-content_16mm3_1ethj_283"
};


const $d17284c265bc2b95$var$CategoryElement = ({ item: item, index: index, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, disabled: disabled, variant: variant, position: position, renderItem: renderItem })=>{
    var _a;
    const highlighted = isHighlighted(item);
    const groupProps = {
        type: 'group',
        index: index !== null && index !== void 0 ? index : 0,
        option: item,
        disabled: !!disabled,
        highlighted: !!highlighted,
        expanded: true,
        expandDirection: 'vertical'
    };
    const renderResult = (_a = renderItem === null || renderItem === void 0 ? void 0 : renderItem({
        item: groupProps
    })) !== null && _a !== void 0 ? _a : null;
    // Hide the category title element from screen readers because it will be
    // provided as an ARIA label.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).category, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], disabled && (0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled),
        role: "presentation"
    }, item.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).header, {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['no-content-styling']]: !!renderResult
        }),
        "aria-hidden": "true"
    }, renderResult ? renderResult : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['header-content']
    }, (item.iconName || item.iconUrl || item.iconSvg) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['icon-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: item.iconName,
        url: item.iconUrl,
        svg: item.iconSvg,
        alt: item.iconAlt
    })), item.text)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['items-list-container'],
        role: "group",
        "aria-label": item.text,
        "aria-disabled": disabled
    }, item.items && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
        items: item.items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        lastInDropdown: lastInDropdown,
        highlightItem: highlightItem,
        categoryDisabled: disabled,
        hasCategoryHeader: !!item.text,
        variant: variant,
        position: position,
        renderItem: renderItem,
        parentProps: groupProps
    })));
};
var $d17284c265bc2b95$export$2e2bcd8739ae039 = $d17284c265bc2b95$var$CategoryElement;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





const $b3bc414964f00db1$var$DEFAULT_OPEN_TIMEOUT_IN_MS = 120;
function $b3bc414964f00db1$export$2e2bcd8739ae039({ children: children, content: content, position: position = 'right', className: className }) {
    const ref = (0, $acw62.useRef)(null);
    const isReducedMotion = (0, $013a2451794a45c0$exports.useReducedMotion)(ref);
    const { open: open, triggerProps: triggerProps } = $b3bc414964f00db1$var$useTooltipOpen(isReducedMotion ? 0 : $b3bc414964f00db1$var$DEFAULT_OPEN_TIMEOUT_IN_MS);
    const portalClasses = (0, $f509ecfba65f3bd6$export$464b090d8a567e1e)(ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        ...triggerProps,
        className: className
    }, children, open && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: portalClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
        size: "small",
        fixedWidth: false,
        position: position,
        trackRef: ref,
        arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b971696cf22f0db1$export$2e2bcd8739ae039), {
                position: position
            }),
        renderWithPortal: true,
        zIndex: 7000
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
        dismissButton: false,
        dismissAriaLabel: undefined,
        header: null,
        onDismiss: ()=>{},
        overflowVisible: "both"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "button-dropdown-disabled-reason",
        role: "tooltip"
    }, content))))));
}
function $b3bc414964f00db1$var$useTooltipOpen(timeout) {
    const handle = (0, $acw62.useRef)();
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const close = ()=>{
        clearTimeout(handle.current);
        setIsOpen(false);
    };
    const open = ()=>setIsOpen(true);
    const openDelayed = ()=>{
        handle.current = setTimeout(open, timeout);
    };
    const onKeyDown = (e)=>{
        if (isOpen && $b3bc414964f00db1$var$isEscape(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            close();
        }
    };
    const onFocus = openDelayed;
    const onBlur = close;
    return {
        open: isOpen,
        triggerProps: {
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown
        }
    };
}
const $b3bc414964f00db1$var$isEscape = (key)=>key === 'Escape' || key === 'Esc';


/**
 * @returns attributes for a menuitem widget given parameters
 */ const $961ccbb638b2620b$export$9163b7ae6a25ed9 = ({ disabled: disabled, parent: parent, expanded: expanded })=>({
        role: 'menuitem',
        'aria-disabled': disabled ? 'true' : undefined,
        'aria-haspopup': parent ? 'true' : undefined,
        'aria-expanded': expanded ? 'true' : parent ? 'false' : undefined
    });
const $961ccbb638b2620b$export$26300457f4d17b16 = ({ disabled: disabled, checked: checked })=>({
        role: 'menuitemcheckbox',
        'aria-disabled': disabled ? 'true' : undefined,
        'aria-checked': checked ? 'true' : 'false'
    });



const $2363ad66200e58be$var$ExpandableCategoryElement = ({ index: index, item: item, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, disabled: disabled, expandToViewport: expandToViewport, variant: variant, position: position, renderItem: renderItem })=>{
    var _a;
    const highlighted = isHighlighted(item);
    const expanded = isExpanded(item);
    const isKeyboardHighlighted = isKeyboardHighlight(item);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (triggerRef.current && highlighted && !expanded) triggerRef.current.focus();
    }, [
        expanded,
        highlighted
    ]);
    const onClick = (event)=>{
        var _a;
        if (!disabled) {
            event.preventDefault();
            onGroupToggle(item, event);
            (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
        }
    };
    const onHover = ()=>{
        highlightItem(item);
    };
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const isDisabledWithReason = !!item.disabledReason && item.disabled;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(item.disabledReason);
    const groupProps = {
        index: index !== null && index !== void 0 ? index : 0,
        type: 'group',
        option: item,
        disabled: !!disabled,
        highlighted: !!highlighted,
        expanded: expanded,
        expandDirection: 'horizontal'
    };
    const renderResult = (_a = renderItem === null || renderItem === void 0 ? void 0 : renderItem({
        item: groupProps
    })) !== null && _a !== void 0 ? _a : null;
    const trigger = item.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).header, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['expandable-header'], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['no-content-styling']]: !!renderResult,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['is-focused']]: isKeyboardHighlighted,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['visual-refresh']]: isVisualRefresh
        }),
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1,
        ref: triggerRef,
        ...(0, $961ccbb638b2620b$export$9163b7ae6a25ed9)({
            parent: true,
            expanded: expanded,
            disabled: disabled
        }),
        ...isDisabledWithReason ? targetProps : {},
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(disabled ? {} : {
            action: !expanded ? 'expand' : 'collapse',
            detail: {
                position: position || '0',
                label: {
                    root: 'self'
                },
                id: item.id || ''
            }
        })
    }, renderResult ? renderResult : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (item.iconName || item.iconUrl || item.iconSvg) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['icon-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: item.iconName,
        url: item.iconUrl,
        svg: item.iconSvg,
        alt: item.iconAlt
    })), item.text, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039)['expand-icon'], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['expand-icon-right'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled"
    }))));
    let content;
    // If the category element is disabled, we do not render a dropdown.
    // Screenreaders are confused by additional sections
    if (isDisabledWithReason) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3bc414964f00db1$export$2e2bcd8739ae039), {
        content: item.disabledReason
    }, trigger, descriptionEl);
    else if (disabled) content = trigger;
    else content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        open: expanded,
        interior: true,
        hideBlockBorder: false,
        expandToViewport: expandToViewport,
        trigger: trigger,
        content: item.items && expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            role: "menu",
            "aria-label": item.text,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039)['items-list-container'], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['in-dropdown'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
            items: item.items,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: lastInDropdown,
            highlightItem: highlightItem,
            variant: variant,
            position: position,
            renderItem: renderItem,
            parentProps: groupProps
        })) : undefined
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).category, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], (0, $faef8237080e4d9e$export$2e2bcd8739ae039).expandable, {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).expanded]: expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted
        }),
        role: "presentation",
        "data-testid": item.id,
        ref: ref,
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover
    }, content);
};
var $2363ad66200e58be$export$2e2bcd8739ae039 = $2363ad66200e58be$var$ExpandableCategoryElement;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $cbe5d6461765a476$export$2e2bcd8739ae039 = {
    "root": "awsui_root_14cnr_39y7l_145",
    "trigger": "awsui_trigger_14cnr_39y7l_179",
    "dropdown": "awsui_dropdown_14cnr_39y7l_182",
    "nowrap": "awsui_nowrap_14cnr_39y7l_193",
    "open": "awsui_open_14cnr_39y7l_196"
};


const $a22e606bd520344e$var$MobileExpandableGroup = ({ children: children, trigger: trigger, open: open })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $cbe5d6461765a476$export$2e2bcd8739ae039).root
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $cbe5d6461765a476$export$2e2bcd8739ae039).trigger
    }, trigger), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $cbe5d6461765a476$export$2e2bcd8739ae039).dropdown, {
            [(0, $cbe5d6461765a476$export$2e2bcd8739ae039).open]: open
        }),
        "data-open": open
    }, children));
};
var $a22e606bd520344e$export$2e2bcd8739ae039 = $a22e606bd520344e$var$MobileExpandableGroup;





const $93350c5f4fe1e921$var$MobileExpandableCategoryElement = ({ index: index, item: item, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, disabled: disabled, variant: variant, position: position, renderItem: renderItem })=>{
    var _a;
    const highlighted = isHighlighted(item);
    const expanded = isExpanded(item);
    const isKeyboardHighlighted = isKeyboardHighlight(item);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useEffect)(()=>{
        if (triggerRef.current && highlighted && !expanded) triggerRef.current.focus();
    }, [
        expanded,
        highlighted
    ]);
    const onClick = (e)=>{
        if (!disabled) {
            e.preventDefault();
            onGroupToggle(item, e);
        }
    };
    const onHover = ()=>{
        highlightItem(item);
    };
    const isDisabledWithReason = !!item.disabledReason && item.disabled;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(item.disabledReason);
    const groupProps = {
        index: index !== null && index !== void 0 ? index : 0,
        type: 'group',
        option: item,
        disabled: !!disabled,
        highlighted: !!highlighted,
        expanded: expanded,
        expandDirection: 'vertical'
    };
    const renderResult = (_a = renderItem === null || renderItem === void 0 ? void 0 : renderItem({
        item: groupProps
    })) !== null && _a !== void 0 ? _a : null;
    const trigger = item.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).header, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['expandable-header'], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['rolled-down']]: expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['no-content-styling']]: !!renderResult,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['is-focused']]: isKeyboardHighlighted
        }),
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1,
        ref: triggerRef,
        ...(0, $961ccbb638b2620b$export$9163b7ae6a25ed9)({
            parent: true,
            disabled: disabled,
            expanded: expanded
        }),
        ...isDisabledWithReason ? targetProps : {},
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(disabled ? {} : {
            action: 'expand',
            detail: {
                position: position || '0',
                label: {
                    root: 'self'
                },
                id: item.id || '',
                expanded: `${!expanded}`
            }
        })
    }, renderResult ? renderResult : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (item.iconName || item.iconUrl || item.iconSvg) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['icon-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: item.iconName,
        url: item.iconUrl,
        svg: item.iconSvg,
        alt: item.iconAlt
    })), item.text, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039)['expand-icon'], {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)['expand-icon-up']]: expanded
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled"
    }))));
    let content;
    if (isDisabledWithReason) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3bc414964f00db1$export$2e2bcd8739ae039), {
        content: item.disabledReason
    }, trigger));
    else if (disabled) content = trigger;
    else content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a22e606bd520344e$export$2e2bcd8739ae039), {
        open: expanded,
        trigger: trigger
    }, item.items && expanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        role: "menu",
        "aria-label": item.text,
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)['items-list-container']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
        items: item.items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        lastInDropdown: lastInDropdown,
        highlightItem: highlightItem,
        hasCategoryHeader: true,
        variant: variant,
        position: position,
        renderItem: renderItem,
        parentProps: groupProps
    })));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).category, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], (0, $faef8237080e4d9e$export$2e2bcd8739ae039).expandable, {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).expanded]: expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted || expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).expandable]: true
        }),
        role: "presentation",
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover,
        "data-testid": item.id
    }, content);
};
var $93350c5f4fe1e921$export$2e2bcd8739ae039 = $93350c5f4fe1e921$var$MobileExpandableCategoryElement;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $ee8887597787bbef$export$e5ac556b1404ae1e(dataAttributes, excludeKeys = []) {
    if (!dataAttributes) return {};
    return Object.entries(dataAttributes).reduce((acc, [key, value])=>{
        if (excludeKeys.includes(key) || excludeKeys.includes(`data-${key}`)) {
            (0, $013a2451794a45c0$exports.warnOnce)('getDataAttributes', `"${key}" key is reserved and cannot be overridden via dataAttributes`);
            return acc;
        }
        if (value === undefined) return acc;
        const attrKey = key.startsWith('data-') ? key : `data-${key}`;
        acc[attrKey] = value;
        return acc;
    }, {});
}





function $e58a724b895c53bc$export$2e2bcd8739ae039(items) {
    const itemToIndex = new Map();
    const indexToItem = new Map();
    const flatIndices = [];
    $e58a724b895c53bc$export$219e7a8d0539f56b(items, (item, index)=>{
        const indexKey = $e58a724b895c53bc$var$stringifyIndex(index);
        itemToIndex.set(item, indexKey);
        indexToItem.set(indexKey, item);
        flatIndices.push(indexKey);
    });
    return {
        getItem: (index)=>{
            const indexKey = $e58a724b895c53bc$var$stringifyIndex(index);
            return indexToItem.get(indexKey) || null;
        },
        getItemIndex: (item)=>{
            const indexKey = itemToIndex.get(item);
            if (!indexKey) throw new Error('Invariant violation: item is not found.');
            return $e58a724b895c53bc$var$parseIndex(indexKey);
        },
        getSequentialIndex: (index, direction, loop = false)=>{
            const indexKey = $e58a724b895c53bc$var$stringifyIndex(index);
            const position = flatIndices.indexOf(indexKey);
            let nextIndex = position + direction;
            if (loop) {
                if (nextIndex < 0) nextIndex = flatIndices.length - 1;
                else if (nextIndex >= flatIndices.length) nextIndex = 0;
            }
            const nextIndexKey = flatIndices[nextIndex];
            if (!nextIndexKey) return null;
            return $e58a724b895c53bc$var$parseIndex(nextIndexKey);
        },
        getParentIndex: (item)=>{
            const indexKey = itemToIndex.get(item);
            if (!indexKey) throw new Error('Invariant violation: item is not found.');
            const index = $e58a724b895c53bc$var$parseIndex(indexKey);
            // No parent
            if (index.length === 1) return null;
            return index.slice(0, index.length - 1);
        }
    };
}
function $e58a724b895c53bc$export$219e7a8d0539f56b(items, act, parentIndex = []) {
    items.forEach((item, index)=>{
        const itemIndex = [
            ...parentIndex,
            index
        ];
        act(item, itemIndex);
        if ((0, $36113732f360ff28$export$15306afaeadd4bdb)(item)) $e58a724b895c53bc$export$219e7a8d0539f56b(item.items, act, itemIndex);
    });
}
function $e58a724b895c53bc$var$stringifyIndex(index) {
    return index.join('-');
}
function $e58a724b895c53bc$var$parseIndex(index) {
    return index.split('-').map((it)=>parseInt(it));
}


const $36113732f360ff28$export$15306afaeadd4bdb = (item)=>item && item.items !== undefined;
const $36113732f360ff28$export$211c15450d7814f3 = (item)=>item && item.href !== undefined;
const $36113732f360ff28$export$15d7d26473d9c458 = (item)=>item && item.itemType === 'checkbox';
const $36113732f360ff28$export$9d8ee2045b99eb06 = (item)=>item.external ? '_blank' : undefined;
function $36113732f360ff28$export$76dd2cf5deab69c6(source, target) {
    for(let index = 0; index < source.length; index++){
        if (source[index] !== target[index]) return false;
    }
    return true;
}
function $36113732f360ff28$export$22fe9d5ba1e722ce(left, right) {
    if (left.length !== right.length) return false;
    for(let index = 0; index < left.length; index++){
        if (left[index] !== right[index]) return false;
    }
    return true;
}
function $36113732f360ff28$export$31764348ecae41a2(items) {
    let hasCheckboxItems = false;
    (0, $e58a724b895c53bc$export$219e7a8d0539f56b)(items, (item)=>{
        if (item.itemType === 'checkbox') hasCheckboxItems = true;
    });
    return hasCheckboxItems;
}
function $36113732f360ff28$export$3cd60116dc0b63fc(items) {
    let hasDisabledReasons = false;
    (0, $e58a724b895c53bc$export$219e7a8d0539f56b)(items, (item)=>{
        if (item.disabledReason) hasDisabledReasons = true;
    });
    return hasDisabledReasons;
}



var $db405acf5a3665b5$export$2e2bcd8739ae039 = {
    "trigger-label": "awsui_trigger-label_q2oen_w271r_5",
    "menu-item": "awsui_menu-item_q2oen_w271r_6",
    "main-action-label": "awsui_main-action-label_q2oen_w271r_7"
};



var $05774784c67f3e3d$export$2e2bcd8739ae039 = {
    "item-element": "awsui_item-element_93a1u_1en7d_145",
    "no-content-styling": "awsui_no-content-styling_93a1u_1en7d_157",
    "disabled": "awsui_disabled_93a1u_1en7d_162",
    "show-divider": "awsui_show-divider_93a1u_1en7d_169",
    "highlighted": "awsui_highlighted_93a1u_1en7d_172",
    "is-focused": "awsui_is-focused_93a1u_1en7d_187",
    "visual-refresh": "awsui_visual-refresh_93a1u_1en7d_190",
    "menu-item": "awsui_menu-item_93a1u_1en7d_194",
    "link-style": "awsui_link-style_93a1u_1en7d_211",
    "current-breadcrumb": "awsui_current-breadcrumb_93a1u_1en7d_247",
    "link-style-highlighted": "awsui_link-style-highlighted_93a1u_1en7d_255",
    "has-category-header": "awsui_has-category-header_93a1u_1en7d_261",
    "item-tooltip-wrapper": "awsui_item-tooltip-wrapper_93a1u_1en7d_261",
    "has-checkmark": "awsui_has-checkmark_93a1u_1en7d_261",
    "icon": "awsui_icon_93a1u_1en7d_268",
    "checkmark": "awsui_checkmark_93a1u_1en7d_272",
    "external-icon": "awsui_external-icon_93a1u_1en7d_279",
    "content-wrapper": "awsui_content-wrapper_93a1u_1en7d_283",
    "main-row": "awsui_main-row_93a1u_1en7d_289",
    "label-tag": "awsui_label-tag_93a1u_1en7d_296",
    "secondary-text": "awsui_secondary-text_93a1u_1en7d_303"
};


const $a34fe9b438b4d7bf$var$ItemElement = ({ position: position = '1', index: index, item: item, disabled: disabled, onItemActivate: onItemActivate, highlighted: highlighted, highlightItem: highlightItem, showDivider: showDivider, hasCategoryHeader: hasCategoryHeader, isKeyboardHighlighted: isKeyboardHighlighted = false, analyticsMetadataTransformer: analyticsMetadataTransformer = (metadata)=>metadata, variant: variant = 'normal', linkStyle: linkStyle, renderItem: renderItem, parentProps: parentProps })=>{
    const isLink = (0, $36113732f360ff28$export$211c15450d7814f3)(item);
    const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
    const onClick = (event)=>{
        // Stop propagation to parent node and handle event exclusively in here. This ensures
        // that no group will interfere with the default behavior of links
        event.stopPropagation();
        if (!isLink) event.preventDefault();
        if (!disabled) onItemActivate(item, event);
    };
    const onHover = ()=>{
        highlightItem(item);
    };
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $05774784c67f3e3d$export$2e2bcd8739ae039)['item-element'], (0, $05774784c67f3e3d$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039).highlighted]: highlighted,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)['has-category-header']]: hasCategoryHeader,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)['has-checkmark']]: isCheckbox,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)['show-divider']]: showDivider,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)['is-focused']]: isKeyboardHighlighted,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)['visual-refresh']]: isVisualRefresh
        }),
        role: "presentation",
        "data-testid": item.id,
        "data-description": item.description,
        ...(0, $ee8887597787bbef$export$e5ac556b1404ae1e)(item.dataAttributes, [
            'testid'
        ]),
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(disabled ? {} : analyticsMetadataTransformer({
            action: 'click',
            detail: {
                position: position,
                id: item.id,
                label: `.${(0, $db405acf5a3665b5$export$2e2bcd8739ae039)['menu-item']}`,
                href: item.href || ''
            }
        }))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItem, {
        index: index,
        item: item,
        disabled: disabled,
        highlighted: highlighted,
        linkStyle: linkStyle,
        renderItem: renderItem,
        parentProps: parentProps
    }));
};
function $a34fe9b438b4d7bf$var$MenuItem({ index: index, item: item, disabled: disabled, highlighted: highlighted, linkStyle: linkStyle, renderItem: renderItem, parentProps: parentProps }) {
    var _a;
    const menuItemRef = (0, $acw62.useRef)(null);
    const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
    const isCurrentBreadcrumb = !isCheckbox && item.isCurrentBreadcrumb;
    (0, $acw62.useEffect)(()=>{
        if (highlighted && menuItemRef.current) menuItemRef.current.focus();
    }, [
        highlighted
    ]);
    let itemProps;
    if (isCheckbox) itemProps = {
        item: {
            index: index !== null && index !== void 0 ? index : 0,
            type: 'checkbox',
            option: item,
            disabled: disabled,
            highlighted: highlighted,
            checked: item.checked,
            parent: parentProps !== null && parentProps !== void 0 ? parentProps : null
        }
    };
    else itemProps = {
        item: {
            index: index !== null && index !== void 0 ? index : 0,
            type: 'action',
            option: item,
            disabled: disabled,
            highlighted: highlighted,
            parent: parentProps !== null && parentProps !== void 0 ? parentProps : null
        }
    };
    const renderResult = (_a = renderItem === null || renderItem === void 0 ? void 0 : renderItem(itemProps)) !== null && _a !== void 0 ? _a : null;
    const isDisabledWithReason = disabled && item.disabledReason;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(item.disabledReason);
    const menuItemProps = {
        'aria-label': item.ariaLabel,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $05774784c67f3e3d$export$2e2bcd8739ae039)['menu-item'], !!renderResult && (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['no-content-styling'], (0, $db405acf5a3665b5$export$2e2bcd8739ae039)['menu-item'], linkStyle && (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['link-style'], linkStyle && highlighted && (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['link-style-highlighted'], isCurrentBreadcrumb && (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['current-breadcrumb']),
        'aria-current': isCurrentBreadcrumb,
        lang: item.lang,
        ref: menuItemRef,
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1,
        ...isCheckbox ? (0, $961ccbb638b2620b$export$26300457f4d17b16)({
            disabled: disabled,
            checked: item.checked
        }) : (0, $961ccbb638b2620b$export$9163b7ae6a25ed9)({
            disabled: disabled
        }),
        ...isDisabledWithReason ? targetProps : {}
    };
    const menuItem = (0, $36113732f360ff28$export$211c15450d7814f3)(item) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...menuItemProps,
        href: !disabled ? item.href : undefined,
        download: !disabled && item.download ? item.download : undefined,
        target: (0, $36113732f360ff28$export$9d8ee2045b99eb06)(item),
        rel: item.external ? 'noopener noreferrer' : undefined
    }, renderResult ? renderResult : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemContent, {
        item: item,
        disabled: disabled,
        highlighted: highlighted
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...menuItemProps
    }, renderResult ? renderResult : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemContent, {
        item: item,
        disabled: disabled,
        highlighted: highlighted
    }));
    const { position: position } = (0, $6dba20b13890af88$export$28c3a9869c2838c2)();
    const tooltipPosition = position === 'bottom-left' || position === 'top-left' ? 'left' : 'right';
    return isDisabledWithReason ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3bc414964f00db1$export$2e2bcd8739ae039), {
        content: item.disabledReason,
        position: tooltipPosition,
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['item-tooltip-wrapper']
    }, menuItem, descriptionEl) : menuItem;
}
const $a34fe9b438b4d7bf$var$MenuItemContent = ({ item: item, disabled: disabled, highlighted: highlighted })=>{
    const hasIcon = !!(item.iconName || item.iconUrl || item.iconSvg);
    const hasExternal = (0, $36113732f360ff28$export$211c15450d7814f3)(item) && item.external;
    const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isCheckbox && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemCheckmark, {
        checked: item.checked,
        disabled: disabled
    }), hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemIcon, {
        name: item.iconName,
        url: item.iconUrl,
        svg: item.iconSvg,
        alt: item.iconAlt,
        badge: item.badge
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['content-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['main-row']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, item.text, hasExternal && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$ExternalIcon, {
        disabled: disabled,
        ariaLabel: item.externalIconAriaLabel
    })), item.labelTag && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $05774784c67f3e3d$export$2e2bcd8739ae039)['label-tag'], disabled && (0, $05774784c67f3e3d$export$2e2bcd8739ae039).disabled)
    }, item.labelTag)), item.secondaryText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $05774784c67f3e3d$export$2e2bcd8739ae039)['secondary-text'], highlighted && (0, $05774784c67f3e3d$export$2e2bcd8739ae039).highlighted, disabled && (0, $05774784c67f3e3d$export$2e2bcd8739ae039).disabled)
    }, item.secondaryText)));
};
const $a34fe9b438b4d7bf$var$MenuItemIcon = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039).icon
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        ...props
    }));
// Toggle has aria-hidden set because it's just used as a graphical element,
// a11y attributes for the checkmark are communicated through the role and aria-checked state
// of the menu element item.
const $a34fe9b438b4d7bf$var$MenuItemCheckmark = ({ disabled: disabled, checked: checked })=>{
    const checkmark = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        variant: disabled ? 'disabled' : 'normal',
        name: "check"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $05774784c67f3e3d$export$2e2bcd8739ae039).icon, (0, $05774784c67f3e3d$export$2e2bcd8739ae039).checkmark, {
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039).disabled]: disabled
        }),
        "aria-hidden": "true",
        style: {
            visibility: checked ? 'visible' : 'hidden'
        }
    }, checkmark);
};
const $a34fe9b438b4d7bf$var$ExternalIcon = ({ disabled: disabled, ariaLabel: ariaLabel })=>{
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        variant: disabled ? 'disabled' : 'normal',
        name: "external"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039)['external-icon'],
        role: ariaLabel ? 'img' : undefined,
        "aria-label": ariaLabel
    }, icon);
};
var $a34fe9b438b4d7bf$export$2e2bcd8739ae039 = $a34fe9b438b4d7bf$var$ItemElement;



function $95690548a868d7d0$export$2e2bcd8739ae039({ items: items, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, categoryDisabled: categoryDisabled = false, hasExpandableGroups: hasExpandableGroups = false, hasCategoryHeader: hasCategoryHeader = false, expandToViewport: expandToViewport = false, variant: variant = 'normal', analyticsMetadataTransformer: analyticsMetadataTransformer, position: position, linkStyle: linkStyle, renderItem: renderItem, parentProps: parentProps }) {
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const elements = items.map((item, index)=>{
        var _a, _b, _c, _d;
        if (!(0, $36113732f360ff28$export$15306afaeadd4bdb)(item)) {
            const showDivider = index === items.length - 1 && !lastInDropdown || (0, $36113732f360ff28$export$15306afaeadd4bdb)(items[index + 1]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a34fe9b438b4d7bf$export$2e2bcd8739ae039), {
                key: index,
                index: index,
                item: item,
                onItemActivate: onItemActivate,
                disabled: (_a = item.disabled) !== null && _a !== void 0 ? _a : categoryDisabled,
                highlighted: isHighlighted(item),
                isKeyboardHighlighted: isKeyboardHighlight(item),
                highlightItem: highlightItem,
                showDivider: showDivider,
                hasCategoryHeader: hasCategoryHeader,
                variant: variant,
                position: `${position ? `${position},` : ''}${index + 1}`,
                analyticsMetadataTransformer: analyticsMetadataTransformer,
                linkStyle: linkStyle,
                renderItem: renderItem,
                parentProps: parentProps
            });
        }
        if (hasExpandableGroups) return item.text ? isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93350c5f4fe1e921$export$2e2bcd8739ae039), {
            key: index,
            index: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: lastInDropdown && index === items.length - 1,
            highlightItem: highlightItem,
            disabled: (_b = item.disabled) !== null && _b !== void 0 ? _b : false,
            variant: variant,
            position: `${position ? `${position},` : ''}${index + 1}`,
            renderItem: renderItem
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2363ad66200e58be$export$2e2bcd8739ae039), {
            key: index,
            index: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: true,
            highlightItem: highlightItem,
            disabled: (_c = item.disabled) !== null && _c !== void 0 ? _c : false,
            expandToViewport: expandToViewport,
            variant: variant,
            position: `${position ? `${position},` : ''}${index + 1}`,
            renderItem: renderItem
        }) : null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d17284c265bc2b95$export$2e2bcd8739ae039), {
            key: index,
            index: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: lastInDropdown && index === items.length - 1,
            highlightItem: highlightItem,
            disabled: (_d = item.disabled) !== null && _d !== void 0 ? _d : false,
            variant: variant,
            position: `${position ? `${position},` : ''}${index + 1}`,
            renderItem: renderItem
        });
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, elements);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $aff605ad4173beb7$export$7d3a09d5141ab1f4 = ({ onOpen: onOpen, onClose: onClose, defaultOpen: defaultOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(defaultOpen);
    const [openedWithKeyboard, setOpenedWithKeyboard] = (0, $acw62.useState)(false);
    const openDropdown = (isKeyboard)=>{
        if (!isOpen) {
            setIsOpen(true);
            setOpenedWithKeyboard(!!isKeyboard);
            onOpen === null || onOpen === void 0 || onOpen();
        }
    };
    const closeDropdown = ()=>{
        if (isOpen) {
            setIsOpen(false);
            onClose === null || onClose === void 0 || onClose();
        }
    };
    const toggleDropdown = ()=>{
        if (isOpen) closeDropdown();
        else openDropdown(false);
    };
    return {
        isOpen: isOpen,
        openDropdown: openDropdown,
        closeDropdown: closeDropdown,
        toggleDropdown: toggleDropdown,
        openedWithKeyboard: openedWithKeyboard
    };
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $6ece526d45739594$export$2e2bcd8739ae039({ startIndex: startIndex, expandedIndex: expandedIndex, getNext: getNext, hasExpandableGroups: hasExpandableGroups, isInRestrictedView: isInRestrictedView }) {
    const tryMove = (currentIndex)=>{
        var _a;
        const next = getNext(currentIndex);
        if (!next) return null;
        // Prevents stepping into disabled expandable groups. However,
        // it's possible to navigate nested groups.
        if (((_a = next.parent) === null || _a === void 0 ? void 0 : _a.disabled) && hasExpandableGroups) return tryMove(next.index);
        // it is not allowed to highlight groups when non-expandable
        if ((0, $36113732f360ff28$export$15306afaeadd4bdb)(next.item) && !hasExpandableGroups) return tryMove(next.index);
        // can only move within same parent unless is in restricted view
        if (hasExpandableGroups && !isInRestrictedView && !$6ece526d45739594$var$isSameParent(startIndex, next.index)) return tryMove(next.index);
        // in restricted view can only navigate to children if group is expanded
        if (hasExpandableGroups && isInRestrictedView && !$6ece526d45739594$var$isSameLevel(next.index, expandedIndex) && !$6ece526d45739594$var$isIncluded(expandedIndex, next.index)) return tryMove(next.index);
        return next.index;
    };
    return tryMove(startIndex);
}
function $6ece526d45739594$var$isSameParent(left, right) {
    return (0, $36113732f360ff28$export$22fe9d5ba1e722ce)(left.slice(0, -1), right.slice(0, -1));
}
function $6ece526d45739594$var$isSameLevel(left, right) {
    return left.length === right.length;
}
function $6ece526d45739594$var$isIncluded(parent, child) {
    return (0, $36113732f360ff28$export$22fe9d5ba1e722ce)(parent, child.slice(0, -1));
}



function $a4b3e8c6b24a6e84$export$2e2bcd8739ae039({ items: items, hasExpandableGroups: hasExpandableGroups, isInRestrictedView: isInRestrictedView = false }) {
    const [targetIndex, setTargetIndex] = (0, $acw62.useState)([]);
    const [expandedIndex, setExpandedIndex] = (0, $acw62.useState)([]);
    const [isUsingMouse, setIsUsingMouse] = (0, $acw62.useState)(true);
    const { getItem: getItem, getItemIndex: getItemIndex, getSequentialIndex: getSequentialIndex, getParentIndex: getParentIndex } = (0, $acw62.useMemo)(()=>(0, $e58a724b895c53bc$export$2e2bcd8739ae039)(items), [
        items
    ]);
    const targetItem = (0, $acw62.useMemo)(()=>getItem(targetIndex), [
        targetIndex,
        getItem
    ]);
    const isHighlighted = (0, $acw62.useCallback)((item)=>{
        const index = getItemIndex(item);
        return (0, $36113732f360ff28$export$76dd2cf5deab69c6)(index, targetIndex);
    }, [
        targetIndex,
        getItemIndex
    ]);
    // check if keyboard focus is on the element
    const isKeyboardHighlight = (0, $acw62.useCallback)((item)=>{
        const index = getItemIndex(item);
        return !isUsingMouse && (0, $36113732f360ff28$export$22fe9d5ba1e722ce)(index, targetIndex);
    }, [
        targetIndex,
        getItemIndex,
        isUsingMouse
    ]);
    const isExpanded = (0, $acw62.useCallback)((group)=>{
        const index = getItemIndex(group);
        return (0, $36113732f360ff28$export$76dd2cf5deab69c6)(index, expandedIndex);
    }, [
        expandedIndex,
        getItemIndex
    ]);
    const moveHighlight = (0, $acw62.useCallback)((direction, loop)=>{
        const getNext = (index)=>{
            const nextIndex = getSequentialIndex(index, direction, loop);
            const item = getItem(nextIndex || [
                -1
            ]);
            if (!nextIndex || !item) return null;
            const parentIndex = getParentIndex(item);
            const parentItem = parentIndex && getItem(parentIndex);
            return {
                index: nextIndex,
                item: item,
                parent: parentItem || undefined
            };
        };
        const nextIndex = (0, $6ece526d45739594$export$2e2bcd8739ae039)({
            startIndex: targetIndex,
            expandedIndex: expandedIndex,
            getNext: getNext,
            hasExpandableGroups: hasExpandableGroups,
            isInRestrictedView: isInRestrictedView
        });
        if (nextIndex) setTargetIndex(nextIndex);
    }, [
        targetIndex,
        expandedIndex,
        getItem,
        getSequentialIndex,
        getParentIndex,
        hasExpandableGroups,
        isInRestrictedView
    ]);
    const highlightItem = (0, $acw62.useCallback)((item)=>{
        setTargetIndex(getItemIndex(item));
    }, [
        getItemIndex
    ]);
    const expandGroup = (0, $acw62.useCallback)((group)=>{
        const groupIndex = group ? getItemIndex(group) : targetIndex;
        const firstChildIndex = [
            ...groupIndex,
            0
        ];
        // move to the first child item unless in restricted mode
        setTargetIndex(isInRestrictedView ? groupIndex : firstChildIndex);
        setExpandedIndex(groupIndex);
    }, [
        targetIndex,
        getItemIndex,
        isInRestrictedView
    ]);
    const collapseGroup = (0, $acw62.useCallback)(()=>{
        if (expandedIndex.length > 0) {
            setTargetIndex(expandedIndex);
            setExpandedIndex(expandedIndex.slice(0, -1));
        }
    }, [
        expandedIndex
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setTargetIndex([]);
        setExpandedIndex([]);
    }, []);
    return {
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        moveHighlight: moveHighlight,
        highlightItem: highlightItem,
        expandGroup: expandGroup,
        collapseGroup: collapseGroup,
        reset: reset,
        setIsUsingMouse: setIsUsingMouse
    };
}



function $671527e64731e5aa$export$9df7c146789633dd({ items: items, onItemClick: onItemClick, onItemFollow: onItemFollow, onReturnFocus: onReturnFocus, hasExpandableGroups: hasExpandableGroups, isInRestrictedView: isInRestrictedView = false, expandToViewport: expandToViewport = false }) {
    const { targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, highlightItem: highlightItem, moveHighlight: moveHighlight, expandGroup: expandGroup, collapseGroup: collapseGroup, reset: reset, setIsUsingMouse: setIsUsingMouse } = (0, $a4b3e8c6b24a6e84$export$2e2bcd8739ae039)({
        items: items,
        hasExpandableGroups: hasExpandableGroups,
        isInRestrictedView: isInRestrictedView
    });
    const { isOpen: isOpen, closeDropdown: closeDropdown, ...openStateProps } = (0, $aff605ad4173beb7$export$7d3a09d5141ab1f4)({
        onClose: reset
    });
    const toggleDropdown = (options = {})=>{
        var _a;
        const moveHighlightOnOpen = (_a = options.moveHighlightOnOpen) !== null && _a !== void 0 ? _a : true;
        if (!isOpen && moveHighlightOnOpen) moveHighlight(1);
        openStateProps.toggleDropdown();
    };
    const onGroupToggle = (item)=>!isExpanded(item) ? expandGroup(item) : collapseGroup();
    const onItemActivate = (item, event)=>{
        const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
        const isLink = (0, $36113732f360ff28$export$211c15450d7814f3)(item);
        const details = {
            id: item.id || 'undefined',
            href: isLink ? item.href : undefined,
            external: isLink ? item.external : undefined,
            target: isLink ? (0, $36113732f360ff28$export$9d8ee2045b99eb06)(item) : undefined,
            checked: isCheckbox ? !item.checked : undefined
        };
        onReturnFocus();
        if (onItemFollow && isLink && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(onItemFollow, details, event);
        if (onItemClick) (0, $fc537b925f715587$export$d7e1721720edbb03)(onItemClick, details, event);
        closeDropdown();
    };
    const openAndSelectFirst = (event)=>{
        toggleDropdown();
        event.preventDefault();
    };
    const actOnParentDropdown = (event)=>{
        // if there is no highlighted item we act on the trigger by opening or closing dropdown
        if (!targetItem) {
            if (isOpen && !isInRestrictedView) toggleDropdown();
            else openAndSelectFirst(event);
        } else if ((0, $36113732f360ff28$export$15306afaeadd4bdb)(targetItem)) onGroupToggle(targetItem, event);
        else onItemActivate(targetItem, event);
    };
    const activate = (event, isEnter)=>{
        setIsUsingMouse(false);
        // if item is a link we rely on default behavior of an anchor, no need to prevent
        if (targetItem && (0, $36113732f360ff28$export$211c15450d7814f3)(targetItem) && isEnter) return;
        event.preventDefault();
        actOnParentDropdown(event);
    };
    const onKeyDown = (event)=>{
        setIsUsingMouse(false);
        switch(event.keyCode){
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
                if (!isOpen) {
                    toggleDropdown();
                    moveHighlight(1, true);
                } else moveHighlight(1);
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
                if (!isOpen) {
                    toggleDropdown();
                    moveHighlight(-1, true);
                } else moveHighlight(-1);
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
                // Prevent scrolling the list of items and highlighting the trigger
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
                if (!(targetItem === null || targetItem === void 0 ? void 0 : targetItem.disabled)) activate(event, true);
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left:
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right:
                if (targetItem && !targetItem.disabled && (0, $36113732f360ff28$export$15306afaeadd4bdb)(targetItem) && !isExpanded(targetItem)) expandGroup();
                else if (hasExpandableGroups) collapseGroup();
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape:
                onReturnFocus();
                closeDropdown();
                event.preventDefault();
                if (isOpen) event.stopPropagation();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).tab:
                // When expanded to viewport the focus can't move naturally to the next element.
                // Returning the focus to the trigger instead.
                if (expandToViewport) onReturnFocus();
                closeDropdown();
                break;
        }
    };
    const onKeyUp = (event)=>{
        // We need to handle activating items with Space separately because there is a bug
        // in Firefox where changing the focus during a Space keydown event it will trigger
        // unexpected click events on the new element: https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space && !(targetItem === null || targetItem === void 0 ? void 0 : targetItem.disabled)) activate(event);
    };
    return {
        isOpen: isOpen,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        highlightItem: highlightItem,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        toggleDropdown: toggleDropdown,
        closeDropdown: closeDropdown,
        setIsUsingMouse: setIsUsingMouse
    };
}





var $ad928a6240f442f3$export$2e2bcd8739ae039 = {
    "button-dropdown": "awsui_button-dropdown_sne0l_ncm5v_145",
    "full-width": "awsui_full-width_sne0l_ncm5v_148",
    "items-list-container": "awsui_items-list-container_sne0l_ncm5v_153",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_ncm5v_1",
    "rotate": "awsui_rotate_sne0l_ncm5v_172",
    "rotate-open": "awsui_rotate-open_sne0l_ncm5v_186",
    "header": "awsui_header_sne0l_ncm5v_190",
    "title": "awsui_title_sne0l_ncm5v_201",
    "description": "awsui_description_sne0l_ncm5v_202",
    "trigger-button": "awsui_trigger-button_sne0l_ncm5v_206",
    "loading": "awsui_loading_sne0l_ncm5v_210",
    "split-trigger-wrapper": "awsui_split-trigger-wrapper_sne0l_ncm5v_214",
    "trigger-item": "awsui_trigger-item_sne0l_ncm5v_217",
    "has-no-text": "awsui_has-no-text_sne0l_ncm5v_226",
    "visual-refresh": "awsui_visual-refresh_sne0l_ncm5v_229",
    "variant-normal": "awsui_variant-normal_sne0l_ncm5v_240",
    "split-trigger": "awsui_split-trigger_sne0l_ncm5v_214",
    "dropdown-trigger": "awsui_dropdown-trigger_sne0l_ncm5v_251",
    "main-action-full-width": "awsui_main-action-full-width_sne0l_ncm5v_255",
    "main-action-trigger-full-width": "awsui_main-action-trigger-full-width_sne0l_ncm5v_259",
    "test-utils-button-trigger": "awsui_test-utils-button-trigger_sne0l_ncm5v_263"
};


const $eed8d7153e9df678$var$InternalButtonDropdown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ items: items, variant: variant = 'normal', loading: loading = false, loadingText: loadingText, disabled: disabled = false, disabledReason: disabledReason, expandableGroups: expandableGroups = false, children: children, onItemClick: onItemClick, onItemFollow: onItemFollow, customTriggerBuilder: customTriggerBuilder, expandToViewport: expandToViewport, ariaLabel: ariaLabel, title: title, description: description, preferCenter: preferCenter, mainAction: mainAction, showMainActionOnly: showMainActionOnly, __internalRootRef: __internalRootRef, analyticsMetadataTransformer: analyticsMetadataTransformer, linkStyle: linkStyle, fullWidth: fullWidth, position: position, nativeMainActionAttributes: nativeMainActionAttributes, nativeTriggerAttributes: nativeTriggerAttributes, renderItem: renderItem, ...props }, ref)=>{
    var _a;
    const isInRestrictedView = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const dropdownId = (0, $013a2451794a45c0$exports.useUniqueId)('dropdown');
    for (const item of items)if ((0, $36113732f360ff28$export$211c15450d7814f3)(item)) (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('ButtonDropdown', item.href);
    if (mainAction) (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('ButtonDropdown', mainAction.href);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (mainAction && variant !== 'primary' && variant !== 'normal') (0, $013a2451794a45c0$exports.warnOnce)('ButtonDropdown', 'Main action is only supported for "primary" and "normal" component variant.');
    }
    const hasMainAction = mainAction && (variant === 'primary' || variant === 'normal');
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const { isOpen: isOpen, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, highlightItem: highlightItem, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, toggleDropdown: toggleDropdown, closeDropdown: closeDropdown, setIsUsingMouse: setIsUsingMouse } = (0, $671527e64731e5aa$export$9df7c146789633dd)({
        items: items,
        onItemClick: onItemClick,
        onItemFollow: onItemFollow,
        // Scroll is unnecessary when moving focus back to the dropdown trigger.
        onReturnFocus: ()=>{
            var _a;
            return (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus({
                preventScroll: true
            });
        },
        expandToViewport: expandToViewport,
        hasExpandableGroups: expandableGroups,
        isInRestrictedView: isInRestrictedView
    });
    const handleMouseEvent = ()=>{
        setIsUsingMouse(true);
    };
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const mainActionRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus (...args) {
                var _a;
                (_a = (hasMainAction ? mainActionRef : triggerRef).current) === null || _a === void 0 || _a.focus(...args);
            },
            focusDropdownTrigger (...args) {
                var _a;
                (_a = triggerRef.current) === null || _a === void 0 || _a.focus(...args);
            }
        }), [
        mainActionRef,
        triggerRef,
        hasMainAction
    ]);
    const clickHandler = ()=>{
        if (!loading && !disabled) // Prevent moving highlight on mobiles to avoid disabled state reason popup if defined.
        toggleDropdown({
            moveHighlightOnOpen: !isInRestrictedView
        });
    };
    const canBeOpened = !loading && !disabled;
    const canBeFullWidth = !!fullWidth && (variant === 'primary' || variant === 'normal');
    const triggerVariant = variant === 'navigation' ? undefined : variant === 'inline-icon' ? 'inline-icon' : variant;
    const iconProps = variant === 'icon' || variant === 'inline-icon' ? {
        iconName: 'ellipsis'
    } : {
        iconName: 'caret-down-filled',
        iconAlign: 'right',
        __iconClass: (0, $17bc88d78d27c4da$export$7cd733a6d16526b)((0, $ad928a6240f442f3$export$2e2bcd8739ae039), 'rotate', canBeOpened && isOpen)
    };
    const baseTriggerProps = {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)['trigger-button'], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['test-utils-button-trigger'], (0, $db405acf5a3665b5$export$2e2bcd8739ae039)['trigger-label']),
        ...iconProps,
        variant: triggerVariant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        disabledReason: disabledReason,
        onClick: (event)=>{
            event.preventDefault();
            clickHandler();
        },
        ariaLabel: ariaLabel,
        ariaExpanded: canBeOpened && isOpen,
        formAction: 'none',
        nativeButtonAttributes: {
            'aria-haspopup': true,
            ...nativeTriggerAttributes
        }
    };
    const triggerId = (0, $013a2451794a45c0$exports.useUniqueId)('awsui-button-dropdown__trigger');
    const triggerHasBadge = ()=>{
        const flatItems = items.flatMap((item)=>{
            if ('items' in item) return item.items;
            return item;
        });
        return variant === 'icon' && !!(flatItems === null || flatItems === void 0 ? void 0 : flatItems.find((item)=>{
            if ('badge' in item) return item.badge;
        }));
    };
    let trigger = null;
    const analyticsMetadata = disabled ? {} : {
        action: !isOpen ? 'expand' : 'collapse',
        detail: {
            label: `.${(0, $db405acf5a3665b5$export$2e2bcd8739ae039)['trigger-label']}`
        }
    };
    if (customTriggerBuilder) trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['dropdown-trigger'],
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    }, customTriggerBuilder({
        testUtilsClass: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['test-utils-button-trigger'],
        ariaExpanded: canBeOpened && isOpen,
        onClick: clickHandler,
        triggerRef: triggerRef,
        ariaLabel: ariaLabel,
        disabled: disabled,
        disabledReason: disabledReason,
        isOpen: isOpen
    }));
    else if (hasMainAction) {
        const { text: text, iconName: iconName, iconAlt: iconAlt, iconSvg: iconSvg, iconUrl: iconUrl, external: external, externalIconAriaLabel: externalIconAriaLabel, ...mainActionProps } = mainAction;
        const mainActionIconProps = external ? {
            iconName: 'external',
            iconAlign: 'right',
            target: '_blank',
            rel: 'noopener noreferrer'
        } : {
            iconName: iconName,
            iconAlt: iconAlt,
            iconSvg: iconSvg,
            iconUrl: iconUrl
        };
        const mainActionAriaLabel = externalIconAriaLabel ? `${(_a = mainAction.ariaLabel) !== null && _a !== void 0 ? _a : mainAction.text} ${mainAction.externalIconAriaLabel}` : mainAction.ariaLabel;
        const hasNoText = !text;
        const mainActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ref: mainActionRef,
            ...mainActionProps,
            ...mainActionIconProps,
            fullWidth: canBeFullWidth,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)['trigger-button'], hasNoText && (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['has-no-text'], isVisualRefresh && (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['visual-refresh'], canBeFullWidth && (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['main-action-full-width']),
            variant: variant,
            ariaLabel: mainActionAriaLabel,
            formAction: "none",
            nativeAnchorAttributes: nativeMainActionAttributes === null || nativeMainActionAttributes === void 0 ? void 0 : nativeMainActionAttributes.anchor,
            nativeButtonAttributes: nativeMainActionAttributes === null || nativeMainActionAttributes === void 0 ? void 0 : nativeMainActionAttributes.button
        }, text);
        trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "group",
            "aria-label": ariaLabel,
            className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['split-trigger-wrapper']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)['trigger-item'], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['split-trigger'], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)[`variant-${variant}`], mainActionProps.loading && (0, $ad928a6240f442f3$export$2e2bcd8739ae039).loading),
            // Close dropdown upon main action click unless event is cancelled.
            onClick: closeDropdown,
            // Prevent keyboard events from propagation to the button dropdown handler.
            onKeyDown: (e)=>e.stopPropagation(),
            onKeyUp: (e)=>e.stopPropagation(),
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
                action: 'click',
                detail: {
                    label: `.${(0, $db405acf5a3665b5$export$2e2bcd8739ae039)['main-action-label']}`
                }
            })
        }, mainActionButton), !showMainActionOnly && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)['trigger-item'], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['dropdown-trigger'], isVisualRefresh && (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['visual-refresh'], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)[`variant-${variant}`], baseTriggerProps.loading && (0, $ad928a6240f442f3$export$2e2bcd8739ae039).loading),
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ref: triggerRef,
            ...baseTriggerProps,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseTriggerProps.className, {
                [(0, $ad928a6240f442f3$export$2e2bcd8739ae039)['main-action-trigger-full-width']]: canBeFullWidth
            }),
            __emitPerformanceMarks: false
        }, children)));
    } else trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['dropdown-trigger'],
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: triggerRef,
        id: triggerId,
        ...baseTriggerProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseTriggerProps.className, {
            [(0, $ad928a6240f442f3$export$2e2bcd8739ae039)['full-width']]: canBeFullWidth,
            [(0, $ad928a6240f442f3$export$2e2bcd8739ae039).loading]: canBeFullWidth && !!loading
        }),
        badge: triggerHasBadge(),
        fullWidth: fullWidth
    }, children));
    const hasHeader = title || description;
    const headerId = (0, $013a2451794a45c0$exports.useUniqueId)('awsui-button-dropdown__header');
    const shouldLabelWithTrigger = !ariaLabel && !mainAction && variant !== 'icon' && variant !== 'inline-icon';
    const { loadingButtonCount: loadingButtonCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    (0, $acw62.useEffect)(()=>{
        if (loading) {
            loadingButtonCount.current++;
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                loadingButtonCount.current--;
            };
        }
    }, [
        loading,
        loadingButtonCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: handleMouseEvent,
        onMouseMove: handleMouseEvent,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)['button-dropdown'], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)[`variant-${variant}`], canBeFullWidth && (0, $ad928a6240f442f3$export$2e2bcd8739ae039)['full-width'], baseProps.className),
        "aria-owns": expandToViewport && isOpen ? dropdownId : undefined,
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        open: canBeOpened && isOpen,
        stretchTriggerHeight: variant === 'navigation',
        minWidth: expandToViewport ? undefined : 'trigger',
        hideBlockBorder: false,
        expandToViewport: expandToViewport,
        preferredAlignment: preferCenter ? 'center' : 'start',
        onOutsideClick: ()=>toggleDropdown(),
        trigger: trigger,
        dropdownId: dropdownId,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, hasHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039).header,
            id: headerId
        }, title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039).title
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
            fontSize: "heading-s",
            fontWeight: "bold",
            color: "inherit",
            tagOverride: "h2",
            margin: {
                vertical: 'n',
                horizontal: 'n'
            }
        }, title)), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
            fontSize: "body-s"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039).description
        }, description))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), {
            open: canBeOpened && isOpen,
            position: "static",
            role: "menu",
            tagOverride: "ul",
            decreaseBlockMargin: true,
            ariaLabel: ariaLabel,
            ariaLabelledby: hasHeader ? headerId : shouldLabelWithTrigger ? triggerId : undefined,
            statusType: "finished"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
            items: items,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            hasExpandableGroups: expandableGroups,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: true,
            highlightItem: highlightItem,
            expandToViewport: expandToViewport,
            variant: variant,
            analyticsMetadataTransformer: analyticsMetadataTransformer,
            linkStyle: linkStyle,
            position: position,
            renderItem: renderItem
        })))
    }));
});
var $eed8d7153e9df678$export$2e2bcd8739ae039 = $eed8d7153e9df678$var$InternalButtonDropdown;



const $68640640380c1033$var$mapDrawerToItem = (drawer, isTypeCheckbox)=>({
        id: drawer.id,
        text: drawer.ariaLabels.drawerName,
        iconName: drawer.trigger.iconName,
        iconSvg: drawer.trigger.iconSvg,
        badge: drawer.badge,
        itemType: isTypeCheckbox ? 'checkbox' : undefined,
        checked: drawer.active
    });
function $68640640380c1033$export$2e2bcd8739ae039({ items: drawers, onItemClick: onItemClick, customTriggerBuilder: customTriggerBuilder, ariaLabel: ariaLabel, globalDrawersStartIndex: globalDrawersStartIndex }) {
    const hasGlobalDrawers = globalDrawersStartIndex !== undefined;
    const itemsFlatList = drawers.map((item, index)=>$68640640380c1033$var$mapDrawerToItem(item, hasGlobalDrawers && index >= globalDrawersStartIndex));
    let items;
    if (hasGlobalDrawers) items = [
        {
            items: itemsFlatList.slice(0, globalDrawersStartIndex)
        },
        {
            items: itemsFlatList.slice(globalDrawersStartIndex)
        }
    ];
    else items = itemsFlatList;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), {
        items: items,
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['overflow-menu'],
        onItemClick: onItemClick,
        ariaLabel: ariaLabel,
        variant: "icon",
        customTriggerBuilder: customTriggerBuilder,
        expandToViewport: true
    });
}




var $3b5852da42b0f2f1$export$2e2bcd8739ae039 = {
    "toggle": "awsui_toggle_1uo6m_o2dyh_193",
    "drawer-triggers": "awsui_drawer-triggers_1uo6m_o2dyh_199",
    "drawer": "awsui_drawer_1uo6m_o2dyh_199",
    "drawer-mobile": "awsui_drawer-mobile_1uo6m_o2dyh_209",
    "drawer-closed": "awsui_drawer-closed_1uo6m_o2dyh_212",
    "drawer-content": "awsui_drawer-content_1uo6m_o2dyh_219",
    "drawer-content-clickable": "awsui_drawer-content-clickable_1uo6m_o2dyh_233",
    "drawer-resize-content": "awsui_drawer-resize-content_1uo6m_o2dyh_243",
    "drawer-content-wrapper": "awsui_drawer-content-wrapper_1uo6m_o2dyh_248",
    "drawer-triggers-wrapper": "awsui_drawer-triggers-wrapper_1uo6m_o2dyh_252",
    "drawer-trigger": "awsui_drawer-trigger_1uo6m_o2dyh_199",
    "drawer-trigger-active": "awsui_drawer-trigger-active_1uo6m_o2dyh_271",
    "resize-handle-wrapper": "awsui_resize-handle-wrapper_1uo6m_o2dyh_279",
    "hide": "awsui_hide_1uo6m_o2dyh_289"
};


const $dedc90907529521f$export$4071300121a182f5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ id: id, contentClassName: contentClassName, toggleClassName: toggleClassName, closeClassName: closeClassName, width: width, type: type, toggleRefs: toggleRefs, topOffset: topOffset, bottomOffset: bottomOffset, ariaLabels: ariaLabels, children: children, hideOpenButton: hideOpenButton, isOpen: isOpen, isHidden: isHidden, isMobile: isMobile, onToggle: onToggle, onClick: onClick, onLoseFocus: onLoseFocus, resizeHandle: resizeHandle }, ref)=>{
    const openButtonWrapperRef = (0, $acw62.useRef)(null);
    const { TagName: TagName, iconName: iconName } = (0, $917b74cb04fa7906$export$e0ae33479bcb926a)[type];
    const { mainLabel: mainLabel, closeLabel: closeLabel, openLabel: openLabel } = ariaLabels;
    const drawerContentWidthOpen = isMobile ? undefined : width;
    const drawerContentWidth = isOpen ? drawerContentWidthOpen : undefined;
    const regularOpenButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        ref: openButtonWrapperRef,
        "aria-label": mainLabel,
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).toggle,
        "aria-hidden": isOpen
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
        ref: toggleRefs.toggle,
        className: toggleClassName,
        iconName: iconName,
        ariaLabel: openLabel,
        onClick: ()=>onToggle(true),
        ariaExpanded: isOpen ? undefined : false
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).drawer, {
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).hide]: isHidden,
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-closed']]: !isOpen,
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-mobile']]: isMobile
        }),
        style: {
            width: drawerContentWidth
        },
        onBlur: onLoseFocus ? (e)=>{
            if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) onLoseFocus(e);
        } : undefined,
        onClick: (event)=>{
            var _a;
            if (onClick) onClick(event);
            if (!isOpen) // to prevent calling onToggle from the drawer when it's called from the toggle button
            {
                if (openButtonWrapperRef.current === event.target || !((_a = openButtonWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) onToggle(true);
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: {
            width: drawerContentWidth,
            top: topOffset,
            bottom: bottomOffset
        },
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-content'], (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-content-clickable'], contentClassName, {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !isOpen
        })
    }, !isMobile && !hideOpenButton && regularOpenButton, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(resizeHandle && (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-resize-content'], (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-content-wrapper']),
        "aria-label": mainLabel,
        "aria-hidden": !isOpen,
        style: {
            blockSize: `calc(100vh - ${(topOffset || 0) + (bottomOffset || 0)}px)`
        }
    }, !isMobile && isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['resize-handle-wrapper']
    }, resizeHandle), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$de65de8213222d10), {
        ref: toggleRefs.close,
        className: closeClassName,
        ariaLabel: closeLabel,
        onClick: ()=>{
            onToggle(false);
        }
    }), children)));
});
const $dedc90907529521f$var$DrawerTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ testUtilsClassName: testUtilsClassName, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaControls: ariaControls, badge: badge, itemId: itemId, isActive: isActive, trigger: trigger, onClick: onClick }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-trigger'], isActive && (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-trigger-active'], isActive && (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)('app-layout-tools-drawer-trigger')),
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
        ref: ref,
        className: testUtilsClassName,
        iconName: trigger.iconName,
        iconSvg: trigger.iconSvg,
        ariaLabel: ariaLabel,
        ariaExpanded: ariaExpanded,
        ariaControls: ariaControls,
        badge: badge,
        testId: itemId && `awsui-app-layout-trigger-${itemId}`
    })));
const $dedc90907529521f$export$30e27a27f04aa467 = ({ isMobile: isMobile, topOffset: topOffset, bottomOffset: bottomOffset, activeDrawerId: activeDrawerId, ariaLabels: ariaLabels, drawers: drawers, drawerRefs: drawerRefs, onDrawerChange: onDrawerChange })=>{
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const previousActiveDrawerId = (0, $acw62.useRef)(activeDrawerId);
    const [containerHeight, triggersContainerRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    const isCompactMode = (0, $013a2451794a45c0$exports.useDensityMode)(containerRef) === 'compact';
    if (activeDrawerId) previousActiveDrawerId.current = activeDrawerId;
    const getIndexOfOverflowItem = ()=>{
        if (containerHeight) {
            const ITEM_HEIGHT = isCompactMode ? 34 : 38;
            const overflowSpot = containerHeight / 1.5;
            const index = Math.floor(overflowSpot / ITEM_HEIGHT);
            return index;
        }
        return 0;
    };
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers, getIndexOfOverflowItem(), activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).drawer, (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-closed'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed'], {
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-mobile']]: isMobile,
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).hide]: drawers.length === 1 && !!activeDrawerId
        }),
        ref: containerRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: triggersContainerRef,
        style: {
            top: topOffset,
            bottom: bottomOffset
        },
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-content'], {
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-content-clickable']]: drawers.length === 1
        }),
        onClick: drawers.length === 1 ? ()=>onDrawerChange(drawers[0].id !== activeDrawerId ? drawers[0].id : null) : undefined
    }, !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-triggers-wrapper'],
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        role: "toolbar",
        "aria-orientation": "vertical"
    }, visibleItems.map((item, index)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dedc90907529521f$var$DrawerTrigger, {
            key: index,
            testUtilsClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle']),
            ariaExpanded: activeDrawerId === item.id,
            ref: item.id === previousActiveDrawerId.current ? drawerRefs.toggle : undefined,
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaControls: activeDrawerId === item.id ? item.id : undefined,
            trigger: item.trigger,
            badge: item.badge,
            itemId: item.id,
            isActive: activeDrawerId === item.id,
            onClick: drawers.length !== 1 ? ()=>onDrawerChange(item.id !== activeDrawerId ? item.id : null) : undefined
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)['drawer-trigger']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        ariaLabel: overflowMenuHasBadge ? ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflowWithBadge : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflow,
        items: overflowItems,
        onItemClick: ({ detail: detail })=>onDrawerChange(detail.id)
    }))))));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $1yiQH = parcelRequire("1yiQH");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







var $0c2548ea1dbf37f8$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1qprf_160mh_5"
};


function $76f4c84fd1bac364$export$2e2bcd8739ae039({ value: value, trackRef: trackRef, trackKey: trackKey, className: className, contentAttributes: contentAttributes = {}, position: position = 'top', size: size = 'small', hideOnOverscroll: hideOnOverscroll, onDismiss: onDismiss }) {
    if (!trackKey && (typeof value === 'string' || typeof value === 'number')) trackKey = value;
    (0, $acw62.useEffect)(()=>{
        const controller = new AbortController();
        window.addEventListener('keydown', (event)=>{
            if (event.key === 'Escape') {
                // Prevent any surrounding modals or dialogs from acting on this Esc.
                event.stopPropagation();
                onDismiss === null || onDismiss === void 0 || onDismiss();
            }
        }, {
            // The tooltip is often activated on mouseover, which means the focus can
            // be anywhere else on the page. Capture also means that this gets called
            // before any wrapper modals or dialogs can detect it and act on it.
            capture: true,
            signal: controller.signal
        });
        return ()=>{
            controller.abort();
        };
    }, [
        onDismiss
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${(0, $0c2548ea1dbf37f8$export$2e2bcd8739ae039).root} ${(0, $9fbff412cdcfb53a$export$2e2bcd8739ae039).root}`,
        ...contentAttributes,
        "data-testid": trackKey
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: true
    }, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
            trackRef: trackRef,
            trackKey: trackKey,
            size: size,
            fixedWidth: false,
            position: position,
            zIndex: 7000,
            arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b971696cf22f0db1$export$2e2bcd8739ae039), {
                    position: position
                }),
            hideOnOverscroll: hideOnOverscroll,
            className: className
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
            dismissButton: false,
            dismissAriaLabel: undefined,
            onDismiss: undefined,
            header: undefined
        }, value)))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $83858cfb94150c5b$export$2e2bcd8739ae039 = {
    "direction-button-wrapper": "awsui_direction-button-wrapper_155yk_1eux7_169",
    "direction-button-wrapper-motion-enter": "awsui_direction-button-wrapper-motion-enter_155yk_1eux7_189",
    "direction-button-wrapper-motion-entering": "awsui_direction-button-wrapper-motion-entering_155yk_1eux7_189",
    "direction-button-wrapper-motion-exit": "awsui_direction-button-wrapper-motion-exit_155yk_1eux7_189",
    "direction-button-wrapper-motion-exiting": "awsui_direction-button-wrapper-motion-exiting_155yk_1eux7_189",
    "drag-handle-entry": "awsui_drag-handle-entry_155yk_1eux7_1",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_155yk_1eux7_1",
    "drag-handle-exit": "awsui_drag-handle-exit_155yk_1eux7_1",
    "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_155yk_1eux7_1",
    "direction-button-wrapper-block-start": "awsui_direction-button-wrapper-block-start_155yk_1eux7_229",
    "direction-button-wrapper-block-end": "awsui_direction-button-wrapper-block-end_155yk_1eux7_233",
    "direction-button-wrapper-inline-start": "awsui_direction-button-wrapper-inline-start_155yk_1eux7_237",
    "direction-button-wrapper-inline-end": "awsui_direction-button-wrapper-inline-end_155yk_1eux7_248",
    "contents": "awsui_contents_155yk_1eux7_259",
    "portal-overlay": "awsui_portal-overlay_155yk_1eux7_263",
    "portal-overlay-disabled": "awsui_portal-overlay-disabled_155yk_1eux7_271",
    "portal-overlay-contents": "awsui_portal-overlay-contents_155yk_1eux7_275",
    "drag-handle": "awsui_drag-handle_155yk_1eux7_279",
    "direction-button-wrapper-hidden": "awsui_direction-button-wrapper-hidden_155yk_1eux7_292",
    "direction-button-wrapper-forced": "awsui_direction-button-wrapper-forced_155yk_1eux7_316",
    "direction-button-wrapper-forced-top-0": "awsui_direction-button-wrapper-forced-top-0_155yk_1eux7_320",
    "direction-button-wrapper-forced-top-1": "awsui_direction-button-wrapper-forced-top-1_155yk_1eux7_324",
    "direction-button-wrapper-forced-top-2": "awsui_direction-button-wrapper-forced-top-2_155yk_1eux7_328",
    "direction-button-wrapper-forced-top-3": "awsui_direction-button-wrapper-forced-top-3_155yk_1eux7_332",
    "direction-button-wrapper-forced-bottom-0": "awsui_direction-button-wrapper-forced-bottom-0_155yk_1eux7_336",
    "direction-button-wrapper-forced-bottom-1": "awsui_direction-button-wrapper-forced-bottom-1_155yk_1eux7_340",
    "direction-button-wrapper-forced-bottom-2": "awsui_direction-button-wrapper-forced-bottom-2_155yk_1eux7_344",
    "direction-button-wrapper-forced-bottom-3": "awsui_direction-button-wrapper-forced-bottom-3_155yk_1eux7_348",
    "direction-button": "awsui_direction-button_155yk_1eux7_169",
    "direction-button-disabled": "awsui_direction-button-disabled_155yk_1eux7_371"
};



var $628cbd768a664b7e$export$2e2bcd8739ae039 = {
    "root": "awsui_root_8k1rt_1i1h9_5",
    "direction-button": "awsui_direction-button_8k1rt_1i1h9_9",
    "direction-button-visible": "awsui_direction-button-visible_8k1rt_1i1h9_13",
    "direction-button-block-start": "awsui_direction-button-block-start_8k1rt_1i1h9_17",
    "direction-button-block-end": "awsui_direction-button-block-end_8k1rt_1i1h9_21",
    "direction-button-inline-start": "awsui_direction-button-inline-start_8k1rt_1i1h9_25",
    "direction-button-inline-end": "awsui_direction-button-inline-end_8k1rt_1i1h9_29"
};


// Mapping from CSS logical property direction to icon name. The icon component
// already flips the left/right icons automatically based on RTL, so we don't
// need to do anything special.
const $88e5069ce0196d7b$var$ICON_LOGICAL_PROPERTY_MAP = {
    'block-start': 'arrow-up',
    'block-end': 'arrow-down',
    'inline-start': 'arrow-left',
    'inline-end': 'arrow-right'
};
function $88e5069ce0196d7b$export$2e2bcd8739ae039({ direction: direction, state: state, show: show, onClick: onClick, forcedPosition: forcedPosition, forcedIndex: forcedIndex }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: show
    }, (transitionState, ref)=>// The wrapper exists to provide a padding around each direction button that
        // prevents any accidental presses around the button from propagating to any
        // interactive elements behind the button.
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            ref: ref,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $83858cfb94150c5b$export$2e2bcd8739ae039)['direction-button-wrapper'], !forcedPosition && (0, $83858cfb94150c5b$export$2e2bcd8739ae039)[`direction-button-wrapper-${direction}`], forcedPosition && (0, $83858cfb94150c5b$export$2e2bcd8739ae039)['direction-button-wrapper-forced'], forcedPosition && (0, $83858cfb94150c5b$export$2e2bcd8739ae039)[`direction-button-wrapper-forced-${forcedPosition}-${forcedIndex}`], transitionState === 'exited' && (0, $83858cfb94150c5b$export$2e2bcd8739ae039)['direction-button-wrapper-hidden'], (0, $83858cfb94150c5b$export$2e2bcd8739ae039)[`direction-button-wrapper-motion-${transitionState}`])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $83858cfb94150c5b$export$2e2bcd8739ae039)['direction-button'], state === 'disabled' && (0, $83858cfb94150c5b$export$2e2bcd8739ae039)['direction-button-disabled'], (0, $628cbd768a664b7e$export$2e2bcd8739ae039)[`direction-button-${direction}`], ![
                'exiting',
                'exited'
            ].includes(transitionState) && (0, $628cbd768a664b7e$export$2e2bcd8739ae039)['direction-button-visible']),
            onClick: state !== 'disabled' ? onClick : undefined,
            // This prevents focus from being lost to `document.body` on
            // mouse/pointer press. This allows us to listen to onClick while
            // keeping this button pointer-accessible only.
            onPointerDown: (event)=>event.preventDefault()
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: $88e5069ce0196d7b$var$ICON_LOGICAL_PROPERTY_MAP[direction],
            size: "small"
        }))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



function $0f2d4e39c3e21dba$export$2e2bcd8739ae039({ track: track, isDisabled: isDisabled, children: children }) {
    const ref = (0, $acw62.useRef)(null);
    const [container, setContainer] = (0, $acw62.useState)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (track.current) {
            const newContainer = track.current.ownerDocument.createElement('div');
            track.current.ownerDocument.body.appendChild(newContainer);
            setContainer(newContainer);
            return ()=>newContainer.remove();
        }
    }, [
        track
    ]);
    (0, $acw62.useEffect)(()=>{
        if (track.current === null || isDisabled) return;
        let cleanedUp = false;
        let lastX;
        let lastY;
        let lastInlineSize;
        let lastBlockSize;
        const updateElement = ()=>{
            // It could be that the portal hasn't been attached to the DOM yet - ensure the ref exists and is attached DOM tree.
            if (track.current && ref.current && document.body.contains(ref.current)) {
                const isRtl = (0, $013a2451794a45c0$exports.getIsRtl)(ref.current);
                const { insetInlineStart: insetInlineStart, insetBlockStart: insetBlockStart, inlineSize: inlineSize, blockSize: blockSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(track.current);
                // For simplicity, we just make all our calculations independent of
                // the browser's scrolling edge. When it comes to applying the changes,
                // translate is independent of writing direction, so we need to invert
                // the X coordinate ourselves just before applying the values.
                const newX = (insetInlineStart + (0, $013a2451794a45c0$exports.getScrollInlineStart)(document.documentElement)) * (isRtl ? -1 : 1);
                const newY = insetBlockStart + document.documentElement.scrollTop;
                if (lastX !== newX || lastY !== newY) {
                    ref.current.style.translate = `${newX}px ${newY}px`;
                    lastX = newX;
                    lastY = newY;
                }
                if (lastInlineSize !== inlineSize || lastBlockSize !== blockSize) {
                    ref.current.style.width = `${inlineSize}px`;
                    ref.current.style.height = `${blockSize}px`;
                    lastInlineSize = inlineSize;
                    lastBlockSize = blockSize;
                }
            }
            if (!cleanedUp) requestAnimationFrame(updateElement);
        };
        updateElement();
        return ()=>{
            cleanedUp = true;
        };
    }, [
        isDisabled,
        track
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), {
        container: container
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $83858cfb94150c5b$export$2e2bcd8739ae039)['portal-overlay'], isDisabled && (0, $83858cfb94150c5b$export$2e2bcd8739ae039)['portal-overlay-disabled'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $83858cfb94150c5b$export$2e2bcd8739ae039)['portal-overlay-contents']
    }, children)));
}




// The UAP buttons are forced to top/bottom position if the handle is close to the screen edge.
const $676a06802ce5bea2$var$FORCED_POSITION_PROXIMITY_PX = 50;
// Approximate UAP button size with margins to decide forced direction.
const $676a06802ce5bea2$var$UAP_BUTTON_SIZE_PX = 40;
const $676a06802ce5bea2$var$DIRECTIONS_ORDER = [
    'block-end',
    'block-start',
    'inline-end',
    'inline-start'
];
function $676a06802ce5bea2$export$2e2bcd8739ae039({ directions: directions, tooltipText: tooltipText, children: children, onDirectionClick: onDirectionClick, triggerMode: triggerMode = 'focus', initialShowButtons: initialShowButtons = false, controlledShowButtons: controlledShowButtons = false, wrapperClassName: wrapperClassName, hideButtonsOnDrag: hideButtonsOnDrag, clickDragThreshold: clickDragThreshold }) {
    const wrapperRef = (0, $acw62.useRef)(null);
    const dragHandleRef = (0, $acw62.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const [uncontrolledShowButtons, setUncontrolledShowButtons] = (0, $acw62.useState)(initialShowButtons);
    const isPointerDown = (0, $acw62.useRef)(false);
    const initialPointerPosition = (0, $acw62.useRef)();
    const didPointerDrag = (0, $acw62.useRef)(false);
    // The tooltip ("Drag or select to move/resize") shouldn't show if clicking
    // on the handle wouldn't do anything.
    const isDisabled = !directions['block-start'] && !directions['block-end'] && !directions['inline-start'] && !directions['inline-end'];
    const onWrapperFocusIn = (event)=>{
        // The drag handle is focused when it's either tabbed to, or the pointer
        // is pressed on it. We exclude handling the pointer press in this handler,
        // since it could be the start of a drag event - the pointer stuff is
        // handled in the "pointerup" listener instead. In cases where focus is moved
        // to the button (by manually calling `.focus()`), the buttons should only appear
        // if the action that triggered the focus move was the result of a keypress.
        if (document.body.dataset.awsuiFocusVisible && !(0, $1yiQH.nodeContains)(wrapperRef.current, event.relatedTarget)) {
            setShowTooltip(false);
            if (triggerMode === 'focus') setUncontrolledShowButtons(true);
        }
    };
    const onWrapperFocusOut = (event)=>{
        // Close the directional buttons when the focus leaves the drag handle.
        // "focusout" is also triggered when the user switches to another tab, but
        // since it'll be returned when they switch back anyway, we exclude that
        // case by checking for `document.hasFocus()`.
        if (document.hasFocus() && !(0, $1yiQH.nodeContains)(wrapperRef.current, event.relatedTarget)) setUncontrolledShowButtons(false);
    };
    (0, $acw62.useEffect)(()=>{
        const controller = new AbortController();
        // We need to differentiate between a "click" and a "drag" action.
        // We can say a "click" happens when a "pointerdown" is followed by
        // a "pointerup" with no "pointermove" between the two.
        // However, it would be a poor usability experience if a "click" isn't
        // registered because, while pressing my mouse, I moved it by just one
        // pixel, making it a "drag" instead. So we allow the pointer to move by
        // `clickDragThreshold` pixels before setting `didPointerDrag` to true.
        document.addEventListener('pointermove', (event)=>{
            if (isPointerDown.current && initialPointerPosition.current && (event.clientX > initialPointerPosition.current.x + clickDragThreshold || event.clientX < initialPointerPosition.current.x - clickDragThreshold || event.clientY > initialPointerPosition.current.y + clickDragThreshold || event.clientY < initialPointerPosition.current.y - clickDragThreshold)) {
                didPointerDrag.current = true;
                if (hideButtonsOnDrag) setUncontrolledShowButtons(false);
            }
        }, {
            signal: controller.signal
        });
        // Shared behavior when a "pointerdown" state ends. This is shared so it
        // can be called for both "pointercancel" and "pointerup" events.
        const resetPointerDownState = ()=>{
            isPointerDown.current = false;
            initialPointerPosition.current = undefined;
        };
        document.addEventListener('pointercancel', ()=>{
            resetPointerDownState();
        }, {
            signal: controller.signal
        });
        document.addEventListener('pointerup', ()=>{
            if (isPointerDown.current && !didPointerDrag.current) // The cursor didn't move much between "pointerdown" and "pointerup".
            // Handle this as a "click" instead of a "drag".
            setUncontrolledShowButtons(true);
            resetPointerDownState();
        }, {
            signal: controller.signal
        });
        return ()=>controller.abort();
    }, [
        clickDragThreshold,
        hideButtonsOnDrag
    ]);
    const onHandlePointerDown = (event)=>{
        // Tooltip behavior: the tooltip should appear on hover, but disappear when
        // the pointer starts dragging (having the tooltip get in the way while
        // you're trying to drag upwards is annoying). Additionally, the tooltip
        // shouldn't reappear when dragging ends, but only when the pointer leaves
        // the drag handle and comes back.
        isPointerDown.current = true;
        didPointerDrag.current = false;
        initialPointerPosition.current = {
            x: event.clientX,
            y: event.clientY
        };
        setShowTooltip(false);
    };
    // Tooltip behavior: the tooltip should stay open when the cursor moves
    // from the drag handle into the tooltip content itself. This is why the
    // handler is set on the wrapper for both the drag handle and the tooltip.
    const onTooltipGroupPointerEnter = ()=>{
        if (!isPointerDown.current) setShowTooltip(true);
    };
    const onTooltipGroupPointerLeave = ()=>{
        setShowTooltip(false);
    };
    const onDragHandleKeyDown = (event)=>{
        // For accessibility reasons, pressing escape should always close the floating controls.
        if (event.key === 'Escape') setUncontrolledShowButtons(false);
        else if (triggerMode === 'keyboard-activate' && (event.key === 'Enter' || event.key === ' ')) // toggle buttons when Enter or space is pressed in 'keyboard-activate' triggerMode
        setUncontrolledShowButtons((prevShowButtons)=>!prevShowButtons);
        else if (event.key !== 'Alt' && event.key !== 'Control' && event.key !== 'Meta' && event.key !== 'Shift' && triggerMode === 'focus') // Pressing any other key will display the focus-visible ring around the
        // drag handle if it's in focus, so we should also show the buttons now.
        setUncontrolledShowButtons(true);
    };
    const showButtons = triggerMode === 'controlled' ? controlledShowButtons : uncontrolledShowButtons;
    const [forcedPosition, setForcedPosition] = (0, $acw62.useState)(null);
    const directionsOrder = forcedPosition === 'bottom' ? [
        ...$676a06802ce5bea2$var$DIRECTIONS_ORDER
    ].reverse() : $676a06802ce5bea2$var$DIRECTIONS_ORDER;
    const visibleDirections = directionsOrder.filter((dir)=>directions[dir]);
    // Continuously monitor position while buttons are shown to handle CSS transitions/animations.
    // The position needs to be recalculated as the element may animate into its final position.
    (0, $acw62.useEffect)(()=>{
        if (!showButtons || !dragHandleRef.current) {
            setForcedPosition(null);
            return;
        }
        let frameId;
        const checkPosition = ()=>{
            if (!dragHandleRef.current) return;
            const rect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(dragHandleRef.current);
            const conflicts = {
                'block-start': rect.insetBlockStart < $676a06802ce5bea2$var$FORCED_POSITION_PROXIMITY_PX,
                'block-end': window.innerHeight - rect.insetBlockEnd < $676a06802ce5bea2$var$FORCED_POSITION_PROXIMITY_PX,
                'inline-start': rect.insetInlineStart < $676a06802ce5bea2$var$FORCED_POSITION_PROXIMITY_PX,
                'inline-end': window.innerWidth - rect.insetInlineEnd < $676a06802ce5bea2$var$FORCED_POSITION_PROXIMITY_PX
            };
            if (visibleDirections.some((direction)=>conflicts[direction])) {
                const hasEnoughSpaceAbove = rect.insetBlockStart > visibleDirections.length * $676a06802ce5bea2$var$UAP_BUTTON_SIZE_PX;
                setForcedPosition(hasEnoughSpaceAbove ? 'top' : 'bottom');
            } else setForcedPosition(null);
            frameId = requestAnimationFrame(checkPosition);
        };
        frameId = requestAnimationFrame(checkPosition);
        return ()=>{
            cancelAnimationFrame(frameId);
        };
    }, [
        showButtons,
        visibleDirections
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $628cbd768a664b7e$export$2e2bcd8739ae039).root, (0, $83858cfb94150c5b$export$2e2bcd8739ae039).contents),
        ref: wrapperRef,
        onFocus: onWrapperFocusIn,
        onBlur: onWrapperFocusOut
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $83858cfb94150c5b$export$2e2bcd8739ae039).contents,
        onPointerEnter: onTooltipGroupPointerEnter,
        onPointerLeave: onTooltipGroupPointerLeave
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $83858cfb94150c5b$export$2e2bcd8739ae039)['drag-handle'], wrapperClassName),
        ref: dragHandleRef,
        onPointerDown: onHandlePointerDown,
        onKeyDown: onDragHandleKeyDown
    }, children), !isDisabled && !showButtons && showTooltip && tooltipText && // Rendered in a portal but pointerenter/pointerleave events still propagate
    // up the React DOM tree, which is why it's placed in this nested context.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76f4c84fd1bac364$export$2e2bcd8739ae039), {
        trackRef: dragHandleRef,
        value: tooltipText,
        onDismiss: ()=>setShowTooltip(false)
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0f2d4e39c3e21dba$export$2e2bcd8739ae039), {
        track: dragHandleRef,
        isDisabled: !showButtons
    }, visibleDirections.map((direction, index)=>directions[direction] && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $88e5069ce0196d7b$export$2e2bcd8739ae039), {
            key: direction,
            show: !isDisabled && showButtons,
            direction: direction,
            state: directions[direction],
            onClick: ()=>onDirectionClick === null || onDirectionClick === void 0 ? void 0 : onDirectionClick(direction),
            forcedPosition: forcedPosition,
            forcedIndex: index
        }))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $b8ce152421b53bab$export$2e2bcd8739ae039 = {
    "handle": "awsui_handle_sdha6_45ome_145",
    "handle-size-normal": "awsui_handle-size-normal_sdha6_45ome_153",
    "handle-size-small": "awsui_handle-size-small_sdha6_45ome_157",
    "handle-drag-indicator": "awsui_handle-drag-indicator_sdha6_45ome_160",
    "handle-disabled": "awsui_handle-disabled_sdha6_45ome_160",
    "active": "awsui_active_sdha6_45ome_163",
    "handle-resize-area": "awsui_handle-resize-area_sdha6_45ome_166",
    "handle-resize-horizontal": "awsui_handle-resize-horizontal_sdha6_45ome_173",
    "handle-resize-vertical": "awsui_handle-resize-vertical_sdha6_45ome_176",
    "hide-focus": "awsui_hide-focus_sdha6_45ome_186",
    "resize-icon": "awsui_resize-icon_sdha6_45ome_208",
    "resize-icon-vertical": "awsui_resize-icon-vertical_sdha6_45ome_214",
    "resize-icon-horizontal": "awsui_resize-icon-horizontal_sdha6_45ome_218",
    "prevent-pointer": "awsui_prevent-pointer_sdha6_45ome_222"
};


function $865bc8099132e35e$export$8a1e762806b47a07({ variant: variant }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        focusable: "false",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b8ce152421b53bab$export$2e2bcd8739ae039)['resize-icon'], (0, $b8ce152421b53bab$export$2e2bcd8739ae039)[`resize-icon-${variant}`]),
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        "aria-hidden": true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 8H14",
        strokeWidth: "2",
        strokeLinecap: "round"
    }));
}




var $b3c0c86a715ad982$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1om0h_im8v7_5"
};


const $767762f09102f13f$var$DragHandleButton = (0, $acw62.forwardRef)(({ variant: variant = 'drag-indicator', size: size = 'normal', active: active = false, className: className, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, ariaDescribedby: ariaDescribedby, ariaValue: ariaValue, disabled: disabled, onPointerDown: onPointerDown, onClick: onClick, onKeyDown: onKeyDown }, ref)=>{
    const dragHandleRefObject = (0, $acw62.useRef)(null);
    const iconProps = (()=>{
        const shared = {
            variant: disabled ? 'disabled' : undefined,
            size: size
        };
        switch(variant){
            case 'drag-indicator':
                return {
                    ...shared,
                    name: 'drag-indicator'
                };
            case 'resize-area':
                return {
                    ...shared,
                    name: 'resize-area'
                };
            case 'resize-horizontal':
                return {
                    ...shared,
                    svg: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $865bc8099132e35e$export$8a1e762806b47a07), {
                        variant: "horizontal"
                    })
                };
            case 'resize-vertical':
                return {
                    ...shared,
                    svg: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $865bc8099132e35e$export$8a1e762806b47a07), {
                        variant: "vertical"
                    })
                };
        }
    })();
    return(// We need to use a div with button role instead of a button
    // so that Safari will focus on it when clicking it.
    // (See https://bugs.webkit.org/show_bug.cgi?id=22261)
    // Otherwise, we can't reliably catch keyboard events coming from the handle
    // when it is being dragged.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: (0, $013a2451794a45c0$exports.useMergeRefs)(ref, dragHandleRefObject),
        role: ariaValue ? 'slider' : 'application',
        tabIndex: 0,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $b8ce152421b53bab$export$2e2bcd8739ae039).handle, (0, $b3c0c86a715ad982$export$2e2bcd8739ae039).root, (0, $b8ce152421b53bab$export$2e2bcd8739ae039)[`handle-${variant}`], (0, $b8ce152421b53bab$export$2e2bcd8739ae039)[`handle-size-${size}`], disabled && (0, $b8ce152421b53bab$export$2e2bcd8739ae039)['handle-disabled'], active && (0, $b8ce152421b53bab$export$2e2bcd8739ae039).active),
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": disabled,
        "aria-valuemax": ariaValue === null || ariaValue === void 0 ? void 0 : ariaValue.valueMax,
        "aria-valuemin": ariaValue === null || ariaValue === void 0 ? void 0 : ariaValue.valueMin,
        "aria-valuenow": ariaValue === null || ariaValue === void 0 ? void 0 : ariaValue.valueNow,
        onPointerDown: onPointerDown,
        onClick: onClick,
        onKeyDown: onKeyDown
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b8ce152421b53bab$export$2e2bcd8739ae039)['prevent-pointer']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        ...iconProps
    }))));
});
var $767762f09102f13f$export$2e2bcd8739ae039 = $767762f09102f13f$var$DragHandleButton;


const $02800872363c99e3$var$InternalDragHandle = (0, $acw62.forwardRef)(({ variant: variant, size: size, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, ariaDescribedby: ariaDescribedby, tooltipText: tooltipText, ariaValue: ariaValue, disabled: disabled, directions: directions = {}, onPointerDown: onPointerDown, onClick: onClick, onKeyDown: onKeyDown, onDirectionClick: onDirectionClick, triggerMode: triggerMode, initialShowButtons: initialShowButtons, controlledShowButtons: controlledShowButtons, hideButtonsOnDrag: hideButtonsOnDrag = false, clickDragThreshold: clickDragThreshold = 3, active: active, ...rest }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $676a06802ce5bea2$export$2e2bcd8739ae039), {
        directions: !disabled ? directions : {},
        tooltipText: tooltipText,
        onDirectionClick: onDirectionClick,
        triggerMode: triggerMode,
        initialShowButtons: initialShowButtons,
        controlledShowButtons: controlledShowButtons,
        hideButtonsOnDrag: hideButtonsOnDrag,
        clickDragThreshold: clickDragThreshold
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $767762f09102f13f$export$2e2bcd8739ae039), {
        ref: ref,
        className: baseProps.className,
        variant: variant,
        size: size,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        ariaDescribedby: ariaDescribedby,
        ariaValue: ariaValue,
        disabled: disabled,
        active: active,
        onPointerDown: onPointerDown,
        onClick: onClick,
        onKeyDown: onKeyDown
    }));
});
var $02800872363c99e3$export$2e2bcd8739ae039 = $02800872363c99e3$var$InternalDragHandle;



var $6b3dd944ba6cee6d$export$2e2bcd8739ae039 = {
    "slider": "awsui_slider_cqzlk_pwkoj_145",
    "slider-side": "awsui_slider-side_cqzlk_pwkoj_179",
    "slider-side-start": "awsui_slider-side-start_cqzlk_pwkoj_180"
};


var $df0c014177452109$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function PanelResizeHandle({ className: className, ariaLabel: ariaLabel, tooltipText: tooltipText, ariaValuenow: ariaValuenow, position: position, onDirectionClick: onDirectionClick, onKeyDown: onKeyDown, onPointerDown: onPointerDown, disabled: disabled }, ref) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('panel-resize-handle');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02800872363c99e3$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $6b3dd944ba6cee6d$export$2e2bcd8739ae039).slider, (0, $6b3dd944ba6cee6d$export$2e2bcd8739ae039)[`slider-${position}`]),
        ariaLabel: i18n('i18nStrings.resizeHandleAriaLabel', ariaLabel),
        tooltipText: i18n('i18nStrings.resizeHandleTooltipText', tooltipText),
        ariaValue: {
            valueMin: 0,
            valueMax: 100,
            valueNow: ariaValuenow !== null && ariaValuenow !== void 0 ? ariaValuenow : 0
        },
        variant: [
            'side',
            'side-start'
        ].includes(position) ? 'resize-horizontal' : 'resize-vertical',
        directions: disabled ? {
            'inline-start': 'disabled',
            'inline-end': 'disabled'
        } : position === 'side' ? {
            'inline-end': ariaValuenow === 0 ? 'disabled' : 'active',
            'inline-start': ariaValuenow === 100 ? 'disabled' : 'active'
        } : position === 'side-start' ? {
            'inline-end': ariaValuenow === 100 ? 'disabled' : 'active',
            'inline-start': ariaValuenow === 0 ? 'disabled' : 'active'
        } : {
            'block-end': ariaValuenow === 0 ? 'disabled' : 'active',
            'block-start': ariaValuenow === 100 ? 'disabled' : 'active'
        },
        onDirectionClick: onDirectionClick,
        onKeyDown: onKeyDown,
        onPointerDown: onPointerDown,
        ref: ref
    });
});




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function $d790fc2d8f354fdb$export$f11fd8c04cad088d(event) {
    return (0, $38f6480185c49d6f$export$1b3bfaa9684536aa)(event.currentTarget) || (0, $38f6480185c49d6f$export$17eda790a720ec57)(event.currentTarget);
}
function $d790fc2d8f354fdb$export$2e2bcd8739ae039(event, { onActivate: onActivate, onBlockEnd: onBlockEnd, onBlockStart: onBlockStart, onDefault: onDefault, onEnd: onEnd, onEscape: onEscape, onHome: onHome, onInlineEnd: onInlineEnd, onInlineStart: onInlineStart, onPageDown: onPageDown, onPageUp: onPageUp }) {
    switch(event.keyCode){
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
            onBlockEnd === null || onBlockEnd === void 0 || onBlockEnd();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end:
            onEnd === null || onEnd === void 0 || onEnd();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
            onActivate === null || onActivate === void 0 || onActivate();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape:
            onEscape === null || onEscape === void 0 || onEscape();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home:
            onHome === null || onHome === void 0 || onHome();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left:
            (0, $013a2451794a45c0$exports.getIsRtl)(event.currentTarget) ? onInlineEnd === null || onInlineEnd === void 0 || onInlineEnd() : onInlineStart === null || onInlineStart === void 0 || onInlineStart();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageDown:
            onPageDown === null || onPageDown === void 0 || onPageDown();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageUp:
            onPageUp === null || onPageUp === void 0 || onPageUp();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right:
            (0, $013a2451794a45c0$exports.getIsRtl)(event.currentTarget) ? onInlineStart === null || onInlineStart === void 0 || onInlineStart() : onInlineEnd === null || onInlineEnd === void 0 || onInlineEnd();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
            onBlockStart === null || onBlockStart === void 0 || onBlockStart();
            break;
        default:
            onDefault === null || onDefault === void 0 || onDefault();
            break;
    }
}


const $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE = 10;
const $f3562f2817c11205$var$KEYBOARD_MULTIPLE_STEPS_SIZE = 60;
const $f3562f2817c11205$var$getCurrentSize = (panelRef)=>{
    if (!panelRef || !panelRef.current) return {
        panelHeight: 0,
        panelWidth: 0
    };
    return {
        panelHeight: panelRef.current.clientHeight,
        panelWidth: panelRef.current.clientWidth
    };
};
const $f3562f2817c11205$export$2ba6c1a0edf6483a = ({ position: position, onResize: onResize, panelRef: panelRef })=>{
    return {
        onDirectionClick: (direction)=>{
            let currentSize;
            const { panelHeight: panelHeight, panelWidth: panelWidth } = $f3562f2817c11205$var$getCurrentSize(panelRef);
            if ([
                'side',
                'side-start'
            ].includes(position)) currentSize = panelWidth;
            else currentSize = panelHeight;
            const singleStepUp = ()=>onResize(currentSize + $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE);
            const singleStepDown = ()=>onResize(currentSize - $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE);
            switch(direction){
                case 'block-start':
                case 'inline-start':
                    position === 'side-start' ? singleStepDown() : singleStepUp();
                    break;
                case 'block-end':
                case 'inline-end':
                    position === 'side-start' ? singleStepUp() : singleStepDown();
                    break;
            }
        },
        onKeyDown: (event)=>{
            let currentSize;
            let maxSize;
            const { panelHeight: panelHeight, panelWidth: panelWidth } = $f3562f2817c11205$var$getCurrentSize(panelRef);
            if ([
                'side',
                'side-start'
            ].includes(position)) {
                currentSize = panelWidth;
                // don't need the exact max size as it's constrained in the set size function
                maxSize = window.innerWidth;
            } else {
                currentSize = panelHeight;
                // don't need the exact max size as it's constrained in the set size function
                maxSize = window.innerHeight;
            }
            let isEventHandled = true;
            const singleStepUp = ()=>onResize(currentSize + $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE);
            const singleStepDown = ()=>onResize(currentSize - $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE);
            const multipleStepUp = ()=>onResize(currentSize + $f3562f2817c11205$var$KEYBOARD_MULTIPLE_STEPS_SIZE);
            const multipleStepDown = ()=>onResize(currentSize - $f3562f2817c11205$var$KEYBOARD_MULTIPLE_STEPS_SIZE);
            (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
                onBlockStart: ()=>{
                    [
                        'bottom',
                        'side-start'
                    ].includes(position) ? singleStepUp() : singleStepDown();
                },
                onBlockEnd: ()=>{
                    [
                        'bottom',
                        'side-start'
                    ].includes(position) ? singleStepDown() : singleStepUp();
                },
                onInlineEnd: ()=>{
                    [
                        'bottom',
                        'side-start'
                    ].includes(position) ? singleStepUp() : singleStepDown();
                },
                onInlineStart: ()=>{
                    [
                        'bottom',
                        'side-start'
                    ].includes(position) ? singleStepDown() : singleStepUp();
                },
                onPageDown: ()=>multipleStepDown(),
                onPageUp: ()=>multipleStepUp(),
                onHome: ()=>onResize(maxSize),
                onEnd: ()=>onResize(0),
                onDefault: ()=>isEventHandled = false
            });
            if (isEventHandled) event.preventDefault();
        }
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $4e3b8edb758a09c5$export$2e2bcd8739ae039 = {
    "with-motion-vertical": "awsui_with-motion-vertical_b18tp_kcmcc_146",
    "with-motion-horizontal": "awsui_with-motion-horizontal_b18tp_kcmcc_165",
    "resize-active": "awsui_resize-active_b18tp_kcmcc_184",
    "resize-side": "awsui_resize-side_b18tp_kcmcc_195",
    "resize-bottom": "awsui_resize-bottom_b18tp_kcmcc_198"
};


const $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69 = ({ position: position, panelRef: panelRef, handleRef: handleRef, onResize: onResize })=>{
    const onDocumentPointerMove = (0, $acw62.useCallback)((event)=>{
        if (!panelRef || !panelRef.current || !handleRef || !handleRef.current) return;
        if (position === 'side') {
            const mouseClientX = (0, $013a2451794a45c0$exports.getLogicalClientX)(event, (0, $013a2451794a45c0$exports.getIsRtl)(panelRef.current)) || 0;
            // The handle offset aligns the cursor with the middle of the resize handle.
            const handleOffset = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(handleRef.current).inlineSize / 2;
            const width = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(panelRef.current).insetInlineEnd - mouseClientX + handleOffset;
            onResize(width);
        } else if (position === 'side-start') {
            const mouseClientX = (0, $013a2451794a45c0$exports.getLogicalClientX)(event, (0, $013a2451794a45c0$exports.getIsRtl)(panelRef.current)) || 0;
            // The handle offset aligns the cursor with the middle of the resize handle.
            const handleOffset = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(handleRef.current).inlineSize / 2;
            const panelBoundingClientRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(panelRef.current);
            const width = mouseClientX + handleOffset - panelBoundingClientRect.insetInlineStart;
            onResize(width);
        } else {
            const mouseClientY = event.clientY || 0;
            // The handle offset aligns the cursor with the middle of the resize handle.
            const handleOffset = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(handleRef.current).blockSize / 2;
            const height = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(panelRef.current).insetBlockEnd - mouseClientY + handleOffset;
            onResize(height);
        }
    }, [
        position,
        panelRef,
        handleRef,
        onResize
    ]);
    const onDocumentPointerUp = (0, $acw62.useCallback)(()=>{
        const panelElement = panelRef === null || panelRef === void 0 ? void 0 : panelRef.current;
        /* istanbul ignore if  */ if (!panelElement) return;
        const currentDocument = panelElement.ownerDocument;
        currentDocument.body.classList.remove((0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['resize-active']);
        currentDocument.body.classList.remove((0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)[`resize-${position}`]);
        currentDocument.removeEventListener('pointerup', onDocumentPointerUp);
        currentDocument.removeEventListener('pointermove', onDocumentPointerMove);
    }, [
        panelRef,
        onDocumentPointerMove,
        position
    ]);
    const onSliderPointerDown = (0, $acw62.useCallback)(()=>{
        const panelElement = panelRef === null || panelRef === void 0 ? void 0 : panelRef.current;
        /* istanbul ignore if  */ if (!panelElement) return;
        const currentDocument = panelElement.ownerDocument;
        currentDocument.body.classList.add((0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['resize-active']);
        currentDocument.body.classList.add((0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)[`resize-${position}`]);
        currentDocument.addEventListener('pointerup', onDocumentPointerUp);
        currentDocument.addEventListener('pointermove', onDocumentPointerMove);
    }, [
        panelRef,
        onDocumentPointerMove,
        onDocumentPointerUp,
        position
    ]);
    return onSliderPointerDown;
};





const $fbbfc7e7be429ab7$export$c2945a2d20d1b49a = ({ onResize: onResize, maxWidth: maxWidth, minWidth: minWidth, refs: refs, activeDrawer: activeDrawer, toolsContent: toolsContent, ...props })=>{
    var _a, _b, _c, _d, _e;
    const { isOpen: isOpen, children: children, width: width, isMobile: isMobile } = props;
    const clampedWidth = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, width, maxWidth);
    const relativeSize = (clampedWidth - minWidth) / (maxWidth - minWidth) * 100;
    const setSidePanelWidth = (newWidth)=>{
        const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, newWidth, maxWidth);
        const id = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id;
        if (isOpen && id && maxWidth >= minWidth) onResize({
            size: size,
            id: id
        });
    };
    const drawerRefObject = (0, $acw62.useRef)(null);
    const sizeControlProps = {
        position: 'side',
        panelRef: drawerRefObject,
        handleRef: refs.slider,
        onResize: setSidePanelWidth
    };
    const onSliderPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const { onKeyDown: onKeyDown, onDirectionClick: onDirectionClick } = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$4071300121a182f5), {
        ...props,
        id: activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id,
        width: clampedWidth,
        ref: drawerRefObject,
        isHidden: !activeDrawer,
        resizeHandle: !isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.resizable) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
            ref: refs.slider,
            position: "side",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-slider'],
            ariaLabel: (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.resizeHandle,
            tooltipText: (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.resizeHandleTooltipText,
            ariaValuenow: relativeSize,
            onKeyDown: onKeyDown,
            onDirectionClick: onDirectionClick,
            onPointerDown: onSliderPointerDown
        }),
        ariaLabels: {
            openLabel: (_c = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.triggerButton,
            mainLabel: (_d = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _d === void 0 ? void 0 : _d.drawerName,
            closeLabel: (_e = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _e === void 0 ? void 0 : _e.closeButton
        }
    }, toolsContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).hide)
    }, toolsContent), (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== (0, $892ef2b582c4882d$export$329f249760e831ae) ? children : null);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $1e16b5b5cece95db$export$2e2bcd8739ae039 = {
    "root": "awsui_root_lm6vo_j45og_153",
    "root-no-scroll": "awsui_root-no-scroll_lm6vo_j45og_160",
    "layout": "awsui_layout_lm6vo_j45og_165",
    "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_j45og_171",
    "layout-main": "awsui_layout-main_lm6vo_j45og_175",
    "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_j45og_181",
    "unfocusable": "awsui_unfocusable_lm6vo_j45og_186",
    "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_j45og_190",
    "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_j45og_195",
    "content-wrapper": "awsui_content-wrapper_lm6vo_j45og_199",
    "content-overlapped": "awsui_content-overlapped_lm6vo_j45og_203",
    "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_j45og_207"
};




var $8f2f8f8a4015f30b$export$2e2bcd8739ae039 = {
    "block-body-scroll": "awsui_block-body-scroll_19d8l_ug653_153",
    "mobile-bar": "awsui_mobile-bar_19d8l_ug653_157",
    "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_ug653_170",
    "mobile-toggle": "awsui_mobile-toggle_19d8l_ug653_177",
    "mobile-toggle-type-navigation": "awsui_mobile-toggle-type-navigation_19d8l_ug653_186",
    "mobile-toggle-type-tools": "awsui_mobile-toggle-type-tools_19d8l_ug653_189",
    "mobile-toggle-type-drawer": "awsui_mobile-toggle-type-drawer_19d8l_ug653_189",
    "drawers-container": "awsui_drawers-container_19d8l_ug653_196"
};


const $61eeb350f8678116$var$MobileToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ariaLabels: ariaLabels, type: type, disabled: disabled, onClick: onClick }, ref)=>{
    const { TagName: TagName, iconName: iconName, getLabels: getLabels } = (0, $917b74cb04fa7906$export$e0ae33479bcb926a)[type];
    const { mainLabel: mainLabel, openLabel: openLabel } = getLabels(ariaLabels);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['mobile-toggle'], (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)[`mobile-toggle-type-${type}`]),
        "aria-hidden": disabled,
        "aria-label": mainLabel,
        onClick: (e)=>e.target === e.currentTarget && onClick()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
        ref: ref,
        className: className,
        iconName: iconName,
        onClick: onClick,
        ariaLabel: openLabel,
        disabled: disabled,
        ariaExpanded: disabled
    }));
});
function $61eeb350f8678116$export$ad5e3cc87670c145({ ariaLabels: ariaLabels, toggleRefs: toggleRefs, topOffset: topOffset, navigationHide: navigationHide, toolsHide: toolsHide, anyPanelOpen: anyPanelOpen, unfocusable: unfocusable, drawers: drawers, activeDrawerId: activeDrawerId, children: children, onNavigationOpen: onNavigationOpen, onToolsOpen: onToolsOpen, onDrawerChange: onDrawerChange, mobileBarRef: mobileBarRef }) {
    (0, $acw62.useEffect)(()=>{
        if (anyPanelOpen) {
            document.body.classList.add((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['block-body-scroll']);
            return ()=>{
                document.body.classList.remove((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['block-body-scroll']);
            };
        } else document.body.classList.remove((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['block-body-scroll']);
    }, [
        anyPanelOpen
    ]);
    const { overflowItems: overflowItems, visibleItems: visibleItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers, 2, activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: mobileBarRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['mobile-bar'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['mobile-bar'], unfocusable && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039).unfocusable),
        style: {
            top: topOffset
        }
    }, !navigationHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($61eeb350f8678116$var$MobileToggle, {
        ref: toggleRefs.navigation,
        type: "navigation",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-toggle'],
        ariaLabels: ariaLabels,
        disabled: anyPanelOpen,
        onClick: onNavigationOpen
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['mobile-bar-breadcrumbs']
    }, children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs
    }, children)), !toolsHide && !drawers && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($61eeb350f8678116$var$MobileToggle, {
        ref: toggleRefs.tools,
        type: "tools",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle'],
        ariaLabels: ariaLabels,
        disabled: anyPanelOpen,
        onClick: onToolsOpen
    }), drawers && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['drawers-container'],
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        role: "toolbar",
        "aria-orientation": "horizontal"
    }, visibleItems.map((item, index)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['mobile-toggle'], (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['mobile-toggle-type-drawer']),
            key: index,
            onClick: ()=>onDrawerChange(item.id)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle']),
            iconName: item.trigger.iconName,
            iconSvg: item.trigger.iconSvg,
            badge: item.badge,
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaExpanded: activeDrawerId === item.id,
            testId: `awsui-app-layout-trigger-${item.id}`
        }));
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['mobile-toggle'], (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)['mobile-toggle-type-drawer'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        ariaLabel: overflowMenuHasBadge ? ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflowWithBadge : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflow,
        items: overflowItems,
        onItemClick: ({ detail: detail })=>onDrawerChange(detail.id)
    })))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $6cdf4c073ae3a9ed$export$2e2bcd8739ae039 = {
    "notifications": "awsui_notifications_1hmm4_1wtbg_9",
    "notifications-sticky": "awsui_notifications-sticky_1hmm4_1wtbg_10",
    "no-content-paddings": "awsui_no-content-paddings_1hmm4_1wtbg_25"
};


const $6787200e64d912d4$export$36ba2f559d49a8f6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ sticky: sticky, disableContentPaddings: disableContentPaddings, ...props }, ref)=>{
    var _a, _b;
    return sticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039)['notifications-sticky'],
        style: {
            top: props.topOffset
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "region",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(props.testUtilsClassName, disableContentPaddings && (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039)['no-content-paddings']),
        "aria-label": (_a = props.labels) === null || _a === void 0 ? void 0 : _a.notifications
    }, props.children)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "region",
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(props.testUtilsClassName, (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039).notifications, disableContentPaddings && (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039)['no-content-paddings']),
        "aria-label": (_b = props.labels) === null || _b === void 0 ? void 0 : _b.notifications
    }, props.children);
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $0b5fa47dfe2910a6$var$AppLayoutWidgetSplitPanelContext = (0, $2ec6e52915a41fcf$export$90753eb139627d74).sharedReactContexts.createContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), 'AppLayoutWidgetSplitPanelContext');
const $0b5fa47dfe2910a6$export$135e17255f989a61 = $0b5fa47dfe2910a6$var$AppLayoutWidgetSplitPanelContext.Provider;
function $0b5fa47dfe2910a6$export$5a37a347a11159b8() {
    const ctx = (0, $acw62.useContext)($0b5fa47dfe2910a6$var$AppLayoutWidgetSplitPanelContext);
    if (!ctx) throw new Error('Split panel can only be used inside app layout');
    return ctx;
}



var $b863a32023c65e65$export$2e2bcd8739ae039 = {
    "drawer-displayed": "awsui_drawer-displayed_1lh3u_16xqy_149",
    "drawer-content": "awsui_drawer-content_1lh3u_16xqy_153"
};


function $b5261664e6ade23b$export$5bff16c6294339ae({ displayed: displayed, children: children }) {
    const { isOpen: isOpen, size: size, topOffset: topOffset, bottomOffset: bottomOffset } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const width = isOpen && children ? size : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(displayed && (0, $b863a32023c65e65$export$2e2bcd8739ae039)['drawer-displayed']),
        style: {
            width: width
        },
        "data-testid": "side-split-panel-drawer"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b863a32023c65e65$export$2e2bcd8739ae039)['drawer-content'],
        style: {
            width: width,
            top: topOffset,
            bottom: bottomOffset
        }
    }, children));
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $346c1f4e54c7d4ae$export$f9c7cae0dbc726b2 = 160;
const $346c1f4e54c7d4ae$export$c1bd455843613e23 = 280;


function $846ec670e2f21dff$export$fe6de1726a5559a({ children: children, size: size, getMaxHeight: getMaxHeight, maxWidth: maxWidth, reportSize: reportSize, onResize: onResize, ...rest }) {
    const { position: position, isOpen: isOpen } = rest;
    const [maxHeight, setMaxHeight] = (0, $acw62.useState)(size);
    const minSize = position === 'bottom' ? (0, $346c1f4e54c7d4ae$export$f9c7cae0dbc726b2) : (0, $346c1f4e54c7d4ae$export$c1bd455843613e23);
    const maxSize = position === 'bottom' ? maxHeight : maxWidth;
    const cappedSize = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minSize, size, maxSize);
    const relativeSize = (size - minSize) / (maxSize - minSize) * 100;
    const onResizeWithValidation = (newSize)=>{
        const maxSize = position === 'side' ? maxWidth : getMaxHeight();
        const isResizeValid = position === 'side' ? maxSize >= (0, $346c1f4e54c7d4ae$export$c1bd455843613e23) : maxSize >= (0, $346c1f4e54c7d4ae$export$f9c7cae0dbc726b2);
        if (isOpen && isResizeValid) onResize((0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minSize, newSize, maxSize));
    };
    (0, $acw62.useEffect)(()=>{
        if (position !== 'bottom') return;
        // effects are called inside out in the components tree
        // wait one frame to allow app-layout to complete its calculations
        const handle = requestAnimationFrame(()=>setMaxHeight(getMaxHeight()));
        return ()=>cancelAnimationFrame(handle);
    }, [
        size,
        minSize,
        position,
        getMaxHeight
    ]);
    (0, $acw62.useEffect)(()=>{
        reportSize(cappedSize);
    }, [
        reportSize,
        cappedSize
    ]);
    (0, $acw62.useEffect)(()=>{
        if (position !== 'bottom') return;
        const handler = ()=>setMaxHeight(getMaxHeight());
        window.addEventListener('resize', handler);
        return ()=>window.removeEventListener('resize', handler);
    }, [
        position,
        getMaxHeight
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0b5fa47dfe2910a6$export$135e17255f989a61), {
        value: {
            ...rest,
            size: cappedSize,
            relativeSize: relativeSize,
            onResize: onResizeWithValidation
        }
    }, children);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * ** Detect scrollbar width (blog post); version N/A -- https://davidwalsh.name/detect-scrollbar-width
 *
 * MIT License
 *
 * Copyright (c) 2007-2021 David Walsh
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /* eslint-disable header/header */ // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7ba862503e02b551$export$9d90a68566e6aa6f(callback) {
    let result = undefined;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $7b99d3a86137a2e2$export$bbb9ce125c89ccb4 = (0, $7ba862503e02b551$export$9d90a68566e6aa6f)(()=>{
    if (typeof document === 'undefined') return {
        width: 0,
        height: 0
    };
    const scrollDiv = document.createElement('div');
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.height = '100px';
    scrollDiv.style.width = '100px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.left = '-9999px';
    document.body.appendChild(scrollDiv);
    const width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    const height = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    return {
        width: width,
        height: height
    };
});



/**
 * Even if the Split Panel is set to be displayed on the side, it will be forced to the bottom
 * if the available space is less than 280px.
 *
 * We also have to account for the fact that after the split panel changes its position
 * from bottom to side or vice versa, there is a chance that the content  a scrollbar appears or disappears from the page,
 * which changes the available space again. This could potentially lead to an infinite loop.
 * To prevent that, we give the split panel some "resistance" to change from bottom to side
 * (but not from side to bottom), requiring in this case some extra space on top of the "nominal" 280px.
 */ function $1349679bbe0bb971$var$checkBasedOnPreviousPosition() {
    let isForced = false; // Remember position for the next render
    return (availableWidthForSplitPanel)=>{
        const minWidth = isForced ? (0, $346c1f4e54c7d4ae$export$c1bd455843613e23) + (0, $7b99d3a86137a2e2$export$bbb9ce125c89ccb4)().width : (0, $346c1f4e54c7d4ae$export$c1bd455843613e23);
        isForced = availableWidthForSplitPanel < minWidth;
        return isForced;
    };
}
const $1349679bbe0bb971$var$checkForcedPosition = $1349679bbe0bb971$var$checkBasedOnPreviousPosition();
function $1349679bbe0bb971$export$aef5e4755971001b({ isMobile: isMobile, availableWidthForSplitPanel: availableWidthForSplitPanel }) {
    if (isMobile) return true;
    return $1349679bbe0bb971$var$checkForcedPosition(availableWidthForSplitPanel);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $822db745899a2b07$var$globalVars = {
    stickyVerticalTopOffset: '--awsui-sticky-vertical-top-offset',
    stickyVerticalBottomOffset: '--awsui-sticky-vertical-bottom-offset'
};
var $822db745899a2b07$export$2e2bcd8739ae039 = $822db745899a2b07$var$globalVars;


function $218e10bc7e8580c0$export$7f13b984303df6e1(headerHeight, footerHeight, stickyNotificationsHeight, mobileToolbarHeight, disableBodyScroll, isMobile) {
    return {
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset]: `calc(${!disableBodyScroll ? headerHeight : 0}px + ${isMobile ? mobileToolbarHeight : stickyNotificationsHeight})`,
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset]: `${!disableBodyScroll ? footerHeight : 0}px`
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $84d3a2bbe2557e44$export$4fdf1d085a596a08(restoreFocus, activeDrawersIds) {
    const refs = (0, $acw62.useRef)({});
    activeDrawersIds.forEach((drawerId)=>{
        if (!refs.current[drawerId]) refs.current[drawerId] = {
            toggle: (0, $acw62.createRef)(),
            close: (0, $acw62.createRef)(),
            slider: (0, $acw62.createRef)()
        };
    });
    const doFocus = (0, $acw62.useCallback)((drawerId, open = true)=>{
        var _a, _b, _c, _d, _e, _f;
        const ref = refs.current[drawerId];
        if (open) {
            previousFocusedElement.current = document.activeElement !== document.body ? document.activeElement : undefined;
            if ((_a = ref === null || ref === void 0 ? void 0 : ref.slider) === null || _a === void 0 ? void 0 : _a.current) (_b = ref.slider.current) === null || _b === void 0 || _b.focus();
            else (_d = (_c = ref === null || ref === void 0 ? void 0 : ref.close) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        } else if (restoreFocus && previousFocusedElement.current && document.contains(previousFocusedElement.current)) {
            previousFocusedElement.current.focus();
            previousFocusedElement.current = undefined;
        } else (_f = (_e = ref === null || ref === void 0 ? void 0 : ref.toggle) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 || _f.focus();
    }, [
        refs,
        restoreFocus
    ]);
    const setFocus = (params)=>{
        const { force: force = false, drawerId: drawerId = null, open: open = true } = params || {};
        if (force && (!drawerId || activeDrawersIds.includes(drawerId))) doFocus(drawerId, open);
        else shouldFocus.current = true;
    };
    const loseFocus = (0, $acw62.useCallback)(()=>{
        previousFocusedElement.current = undefined;
    }, []);
    const previousFocusedElement = (0, $acw62.useRef)();
    const shouldFocus = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const drawerId = activeDrawersIds[0];
        if (shouldFocus.current) Promise.resolve().then(()=>{
            doFocus(drawerId);
            shouldFocus.current = false;
        });
    }, [
        activeDrawersIds,
        doFocus
    ]);
    return {
        refs: refs.current,
        setFocus: setFocus,
        loseFocus: loseFocus
    };
}
function $84d3a2bbe2557e44$export$817e5b4536f33d83(isOpen, restoreFocus = false, activeDrawerId) {
    const refs = {
        toggle: (0, $acw62.useRef)(null),
        close: (0, $acw62.useRef)(null),
        slider: (0, $acw62.useRef)(null)
    };
    const previousFocusedElement = (0, $acw62.useRef)();
    const shouldFocus = (0, $acw62.useRef)(false);
    const doFocus = ()=>{
        var _a, _b, _c;
        if (!shouldFocus.current) return;
        if (isOpen) {
            previousFocusedElement.current = document.activeElement !== document.body ? document.activeElement : undefined;
            if (refs.slider.current) (_a = refs.slider.current) === null || _a === void 0 || _a.focus();
            else (_b = refs.close.current) === null || _b === void 0 || _b.focus();
        } else if (restoreFocus && previousFocusedElement.current && document.contains(previousFocusedElement.current)) {
            previousFocusedElement.current.focus();
            previousFocusedElement.current = undefined;
        } else (_c = refs.toggle.current) === null || _c === void 0 || _c.focus();
        shouldFocus.current = false;
    };
    const setFocus = ({ force: force, autoFocus: autoFocus = true } = {
        force: false
    })=>{
        if (force && isOpen) {
            shouldFocus.current = true;
            doFocus();
        } else if (autoFocus) shouldFocus.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(doFocus, [
        isOpen,
        activeDrawerId
    ]);
    const loseFocus = (0, $acw62.useCallback)(()=>{
        previousFocusedElement.current = undefined;
    }, []);
    return {
        refs: refs,
        setFocus: setFocus,
        loseFocus: loseFocus
    };
}
function $84d3a2bbe2557e44$export$4f731f600e75308c(isOpen, restoreFocus = false, activeDrawerId) {
    const refs = {
        toggle: (0, $acw62.useRef)(null),
        close: (0, $acw62.useRef)(null),
        slider: (0, $acw62.useRef)(null)
    };
    const previousFocusedElement = (0, $acw62.useRef)();
    const shouldFocus = (0, $acw62.useRef)(false);
    const doFocus = ()=>{
        var _a, _b, _c;
        if (isOpen) {
            previousFocusedElement.current = document.activeElement !== document.body ? document.activeElement : undefined;
            if (refs.slider.current) (_a = refs.slider.current) === null || _a === void 0 || _a.focus();
            else (_b = refs.close.current) === null || _b === void 0 || _b.focus();
        } else if (restoreFocus && previousFocusedElement.current && document.contains(previousFocusedElement.current)) {
            previousFocusedElement.current.focus();
            previousFocusedElement.current = undefined;
        } else (_c = refs.toggle.current) === null || _c === void 0 || _c.focus();
    };
    const setFocus = ({ force: force, autoFocus: autoFocus = true } = {
        force: false
    })=>{
        if (force && isOpen) doFocus();
        else if (autoFocus) shouldFocus.current = true;
    };
    (0, $acw62.useEffect)(()=>{
        if (shouldFocus.current) Promise.resolve().then(()=>{
            doFocus();
            shouldFocus.current = false;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        activeDrawerId
    ]);
    const loseFocus = (0, $acw62.useCallback)(()=>{
        previousFocusedElement.current = undefined;
    }, []);
    return {
        refs: refs,
        setFocus: setFocus,
        loseFocus: loseFocus
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $d19d77c31ea1086e$export$ba7387b5ce3f72be(dependencies) {
    const refs = {
        toggle: (0, $acw62.useRef)(null),
        slider: (0, $acw62.useRef)(null),
        preferences: (0, $acw62.useRef)(null)
    };
    const lastInteraction = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        Promise.resolve().then(()=>{
            var _a, _b, _c, _d;
            switch((_a = lastInteraction.current) === null || _a === void 0 ? void 0 : _a.type){
                case 'open':
                    (_b = refs.slider.current) === null || _b === void 0 || _b.focus();
                    break;
                case 'close':
                    (_c = refs.toggle.current) === null || _c === void 0 || _c.focus();
                    break;
                case 'position':
                    (_d = refs.preferences.current) === null || _d === void 0 || _d.focus();
                    break;
            }
            lastInteraction.current = null;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
    return {
        refs: refs,
        setLastInteraction: (interaction)=>lastInteraction.current = interaction
    };
}




const $6ad7a06c5c5b5cb1$var$ClassicAppLayout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ navigation: navigation, navigationWidth: navigationWidth, navigationHide: navigationHide, navigationOpen: navigationOpen, tools: tools, toolsWidth: toolsWidth, toolsHide: toolsHide, toolsOpen: controlledToolsOpen, breadcrumbs: breadcrumbs, notifications: notifications, stickyNotifications: stickyNotifications, contentHeader: contentHeader, disableContentHeaderOverlap: disableContentHeaderOverlap, content: content, contentType: contentType, disableContentPaddings: disableContentPaddings, disableBodyScroll: disableBodyScroll, maxContentWidth: maxContentWidth, minContentWidth: minContentWidth, placement: placement, ariaLabels: ariaLabels, splitPanel: splitPanel, splitPanelSize: controlledSplitPanelSize, splitPanelOpen: controlledSplitPanelOpen, splitPanelPreferences: controlledSplitPanelPreferences, onSplitPanelPreferencesChange: onSplitPanelPreferencesChange, onSplitPanelResize: onSplitPanelResize, onSplitPanelToggle: onSplitPanelToggle, onNavigationChange: onNavigationChange, onToolsChange: onToolsChange, drawers: controlledDrawers, onDrawerChange: onDrawerChange, activeDrawerId: controlledActiveDrawerId, ...rest }, ref)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    // Private API for embedded view mode
    const __embeddedViewMode = Boolean(rest.__embeddedViewMode);
    const rootRef = (0, $acw62.useRef)(null);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const [toolsOpen = false, setToolsOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledToolsOpen, onToolsChange, false, {
        componentName: 'AppLayout',
        controlledProp: 'toolsOpen',
        changeHandler: 'onToolsChange'
    });
    const onToolsToggle = (open)=>{
        setToolsOpen(open);
        if (hasDrawers) focusDrawersButtons();
        else focusToolsButtons();
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onToolsChange, {
            open: open
        });
    };
    const { drawers: drawers, activeDrawer: activeDrawer, minDrawerSize: minDrawerSize, activeDrawerSize: activeDrawerSize, activeDrawerId: activeDrawerId, ariaLabelsWithDrawers: ariaLabelsWithDrawers, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize } = (0, $892ef2b582c4882d$export$468f52f962f49bf5)({
        drawers: controlledDrawers,
        onDrawerChange: onDrawerChange,
        activeDrawerId: controlledActiveDrawerId,
        ...rest
    }, ariaLabels, {
        disableDrawersMerge: true,
        ariaLabels: ariaLabels,
        tools: tools,
        toolsOpen: toolsOpen,
        toolsHide: toolsHide,
        toolsWidth: toolsWidth,
        onToolsToggle: onToolsToggle
    });
    ariaLabels = ariaLabelsWithDrawers;
    const hasDrawers = !!drawers;
    const { refs: navigationRefs, setFocus: focusNavButtons } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(navigationOpen);
    const { refs: toolsRefs, setFocus: focusToolsButtons, loseFocus: loseToolsFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(toolsOpen || activeDrawer !== undefined, true);
    const { refs: drawerRefs, setFocus: focusDrawersButtons, loseFocus: loseDrawersFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(!!activeDrawerId, true, activeDrawerId);
    const onNavigationToggle = (0, $013a2451794a45c0$exports.useStableCallback)(({ isOpen: isOpen, autoFocus: autoFocus })=>{
        focusNavButtons({
            force: false,
            autoFocus: autoFocus
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onNavigationChange, {
            open: isOpen
        });
    });
    const onNavigationClick = (event)=>{
        const hasLink = (0, $1yiQH.findUpUntil)(event.target, (node)=>node.tagName === 'A' && !!node.href);
        if (hasLink) onNavigationToggle({
            isOpen: false,
            autoFocus: true
        });
    };
    (0, $acw62.useEffect)(()=>{
        // Close navigation drawer on mobile so that the main content is visible
        if (isMobile) onNavigationToggle({
            isOpen: false,
            autoFocus: false
        });
    }, [
        isMobile,
        onNavigationToggle
    ]);
    const navigationVisible = !navigationHide && navigationOpen;
    const toolsVisible = !toolsHide && toolsOpen;
    const [headerFooterHeight, setHeaderFooterHeight] = (0, $acw62.useState)(0);
    // Delay applying changes in header/footer height, as applying them immediately can cause
    // ResizeOberver warnings due to the algorithm thinking that the change might have side-effects
    // further up the tree, therefore blocking notifications to prevent loops
    (0, $acw62.useEffect)(()=>{
        const id = requestAnimationFrame(()=>setHeaderFooterHeight(placement.insetBlockStart + placement.insetBlockEnd));
        return ()=>cancelAnimationFrame(id);
    }, [
        placement.insetBlockStart,
        placement.insetBlockEnd
    ]);
    const contentHeightStyle = {
        [disableBodyScroll ? 'blockSize' : 'minBlockSize']: `calc(100vh - ${headerFooterHeight}px)`
    };
    const [notificationsHeight, notificationsRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    const anyPanelOpen = navigationVisible || toolsVisible || !!activeDrawer;
    const hasRenderedNotifications = notificationsHeight ? notificationsHeight > 0 : false;
    const stickyNotificationsHeight = stickyNotifications ? notificationsHeight !== null && notificationsHeight !== void 0 ? notificationsHeight : 0 : 0;
    const [splitPanelPreferences, setSplitPanelPreferences] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelPreferences, onSplitPanelPreferencesChange, undefined, {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelPreferences',
        changeHandler: 'onSplitPanelPreferencesChange'
    });
    const [splitPanelOpen = false, setSplitPanelOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelOpen, onSplitPanelToggle, false, {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelOpen',
        changeHandler: 'onSplitPanelToggle'
    });
    const splitPanelPosition = (splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) || 'bottom';
    const [splitPanelReportedToggle, setSplitPanelReportedToggle] = (0, $acw62.useState)({
        displayed: false,
        ariaLabel: undefined
    });
    const splitPanelDisplayed = !!(splitPanel && (splitPanelReportedToggle.displayed || splitPanelOpen));
    const closedDrawerWidth = 40;
    const effectiveNavigationWidth = navigationHide ? 0 : navigationOpen ? navigationWidth : closedDrawerWidth;
    const defaultSplitPanelSize = (0, $582c00c3ff10d4e2$export$9d9d5fcac617b082)(splitPanelPosition);
    const [splitPanelSize = defaultSplitPanelSize, setSplitPanelSize] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelSize, onSplitPanelResize, defaultSplitPanelSize, {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelSize',
        changeHandler: 'onSplitPanelResize'
    });
    const mainContentRef = (0, $acw62.useRef)(null);
    const legacyScrollRootRef = (0, $acw62.useRef)(null);
    const { refs: splitPanelRefs, setLastInteraction: setSplitPanelLastInteraction } = (0, $d19d77c31ea1086e$export$ba7387b5ce3f72be)([
        splitPanelPreferences,
        splitPanelOpen
    ]);
    const onSplitPanelPreferencesSet = (0, $acw62.useCallback)((detail)=>{
        setSplitPanelPreferences(detail);
        setSplitPanelLastInteraction({
            type: 'position'
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelPreferencesChange, detail);
    }, [
        setSplitPanelPreferences,
        onSplitPanelPreferencesChange,
        setSplitPanelLastInteraction
    ]);
    const onSplitPanelSizeSet = (0, $acw62.useCallback)((newSize)=>{
        setSplitPanelSize(newSize);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelResize, {
            size: newSize
        });
    }, [
        setSplitPanelSize,
        onSplitPanelResize
    ]);
    const onSplitPanelToggleHandler = (0, $acw62.useCallback)(()=>{
        setSplitPanelOpen(!splitPanelOpen);
        setSplitPanelLastInteraction({
            type: splitPanelOpen ? 'close' : 'open'
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelToggle, {
            open: !splitPanelOpen
        });
    }, [
        setSplitPanelOpen,
        splitPanelOpen,
        onSplitPanelToggle,
        setSplitPanelLastInteraction
    ]);
    const getSplitPanelMaxHeight = (0, $013a2451794a45c0$exports.useStableCallback)(()=>{
        if (typeof document === 'undefined') return 0; // render the split panel in its minimum possible size
        else if (disableBodyScroll && legacyScrollRootRef.current) {
            const availableHeight = legacyScrollRootRef.current.clientHeight;
            return availableHeight < (0, $582c00c3ff10d4e2$export$221784c3b0ae64c0) ? availableHeight : availableHeight - (0, $582c00c3ff10d4e2$export$bed14608432f307e);
        } else {
            const availableHeight = document.documentElement.clientHeight - placement.insetBlockStart - placement.insetBlockEnd;
            return availableHeight < (0, $582c00c3ff10d4e2$export$221784c3b0ae64c0) ? availableHeight - (0, $582c00c3ff10d4e2$export$99ee445a84ec4a0d) : availableHeight - (0, $582c00c3ff10d4e2$export$bed14608432f307e);
        }
    });
    const rightDrawerBarWidth = drawers ? drawers.length > 1 ? closedDrawerWidth : 0 : 0;
    const contentPadding = 80;
    // all content except split-panel + drawers/tools area
    const resizableSpaceAvailable = Math.max(0, placement.inlineSize - effectiveNavigationWidth - minContentWidth - contentPadding - rightDrawerBarWidth);
    const getEffectiveToolsWidth = ()=>{
        if (activeDrawerSize && activeDrawer) return Math.min(resizableSpaceAvailable, activeDrawerSize);
        if (toolsHide || drawers) return 0;
        if (toolsOpen) return toolsWidth;
        return closedDrawerWidth;
    };
    const effectiveToolsWidth = getEffectiveToolsWidth();
    const availableWidthForSplitPanel = resizableSpaceAvailable - effectiveToolsWidth;
    const isSplitPanelForcedPosition = (0, $1349679bbe0bb971$export$aef5e4755971001b)({
        isMobile: isMobile,
        availableWidthForSplitPanel: availableWidthForSplitPanel
    });
    const finalSplitPanePosition = isSplitPanelForcedPosition ? 'bottom' : splitPanelPosition;
    const splitPaneAvailableOnTheSide = splitPanelDisplayed && finalSplitPanePosition === 'side';
    const sideSplitPanelSize = splitPaneAvailableOnTheSide ? splitPanelOpen ? splitPanelSize : closedDrawerWidth : 0;
    const sideSplitPanelMaxWidth = Math.max(0, resizableSpaceAvailable - effectiveToolsWidth);
    const drawerMaxSize = Math.max(0, resizableSpaceAvailable - sideSplitPanelSize);
    const navigationClosedWidth = navigationHide || isMobile ? 0 : closedDrawerWidth;
    const contentMaxWidthStyle = !isMobile ? {
        maxWidth: maxContentWidth
    } : undefined;
    const [splitPanelReportedSize, setSplitPanelReportedSize] = (0, $acw62.useState)(0);
    const [splitPanelReportedHeaderHeight, setSplitPanelReportedHeaderHeight] = (0, $acw62.useState)(0);
    const splitPanelContextProps = {
        topOffset: placement.insetBlockStart + (finalSplitPanePosition === 'bottom' ? stickyNotificationsHeight : 0),
        bottomOffset: placement.insetBlockEnd,
        leftOffset: placement.insetInlineStart + (isMobile ? 0 : !navigationHide && navigationOpen ? navigationWidth : navigationClosedWidth),
        rightOffset: isMobile ? 0 : placement.insetInlineEnd + effectiveToolsWidth + rightDrawerBarWidth,
        position: finalSplitPanePosition,
        size: splitPanelSize,
        maxWidth: sideSplitPanelMaxWidth,
        getMaxHeight: getSplitPanelMaxHeight,
        disableContentPaddings: disableContentPaddings,
        contentWidthStyles: contentMaxWidthStyle,
        isOpen: splitPanelOpen,
        isForcedPosition: isSplitPanelForcedPosition,
        onResize: onSplitPanelSizeSet,
        onToggle: onSplitPanelToggleHandler,
        onPreferencesChange: onSplitPanelPreferencesSet,
        setSplitPanelToggle: setSplitPanelReportedToggle,
        reportSize: setSplitPanelReportedSize,
        reportHeaderHeight: setSplitPanelReportedHeaderHeight,
        refs: splitPanelRefs
    };
    const splitPanelWrapped = splitPanel && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), {
        ...splitPanelContextProps
    }, finalSplitPanePosition === 'side' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5261664e6ade23b$export$5bff16c6294339ae), {
        displayed: splitPanelDisplayed
    }, splitPanel) : splitPanel);
    const contentWrapperProps = {
        contentType: contentType,
        navigationPadding: navigationHide || !!navigationOpen,
        contentWidthStyles: !isMobile ? {
            minWidth: minContentWidth,
            maxWidth: maxContentWidth
        } : undefined,
        toolsPadding: // tools padding is displayed in one of the three cases
        // 1. Nothing on the that screen edge (no tools panel and no split panel)
        toolsHide || hasDrawers && !activeDrawer && (!splitPanelDisplayed || finalSplitPanePosition !== 'side') || // 2. Tools panel is present and open
        toolsVisible || // 3. Split panel is open in side position
        splitPaneAvailableOnTheSide && splitPanelOpen,
        isMobile: isMobile
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            openTools: ()=>onToolsToggle(true),
            closeNavigationIfNecessary: ()=>{
                if (isMobile) onNavigationToggle({
                    isOpen: false,
                    autoFocus: true
                });
            },
            focusToolsClose: ()=>{
                if (hasDrawers) focusDrawersButtons({
                    force: true
                });
                else focusToolsButtons({
                    force: true
                });
            },
            focusActiveDrawer: ()=>focusDrawersButtons({
                    force: true
                }),
            focusSplitPanel: ()=>{
                var _a;
                return (_a = splitPanelRefs.slider.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }));
    const splitPanelBottomOffset = (_a = !splitPanelDisplayed || finalSplitPanePosition !== 'bottom' ? undefined : splitPanelOpen ? splitPanelReportedSize : splitPanelReportedHeaderHeight) !== null && _a !== void 0 ? _a : undefined;
    const [mobileBarHeight, mobileBarRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039).root, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).root, disableBodyScroll && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['root-no-scroll']),
        ref: rootRef,
        style: contentHeightStyle
    }, isMobile && !__embeddedViewMode && (!toolsHide || !navigationHide || breadcrumbs) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $61eeb350f8678116$export$ad5e3cc87670c145), {
        anyPanelOpen: anyPanelOpen,
        toggleRefs: {
            navigation: navigationRefs.toggle,
            tools: toolsRefs.toggle
        },
        topOffset: placement.insetBlockStart,
        ariaLabels: ariaLabels,
        navigationHide: navigationHide,
        toolsHide: toolsHide,
        onNavigationOpen: ()=>onNavigationToggle({
                isOpen: true,
                autoFocus: true
            }),
        onToolsOpen: ()=>onToolsToggle(true),
        unfocusable: anyPanelOpen,
        mobileBarRef: mobileBarRef,
        drawers: drawers === null || drawers === void 0 ? void 0 : drawers.filter((drawer)=>drawer.trigger),
        activeDrawerId: activeDrawerId,
        onDrawerChange: (newDrawerId)=>{
            onActiveDrawerChange(newDrawerId, {
                initiatedByUserAction: true
            });
            if (newDrawerId !== activeDrawerId) {
                focusToolsButtons();
                focusDrawersButtons();
            }
        }
    }, breadcrumbs), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039).layout, disableBodyScroll && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['layout-no-scroll'])
    }, !navigationHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$4071300121a182f5), {
        contentClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).navigation,
        toggleClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-toggle'],
        closeClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-close'],
        ariaLabels: (0, $917b74cb04fa7906$export$e0ae33479bcb926a).navigation.getLabels(ariaLabels),
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        isOpen: navigationOpen,
        onClick: isMobile ? onNavigationClick : undefined,
        onToggle: (isOpen)=>onNavigationToggle({
                isOpen: isOpen,
                autoFocus: true
            }),
        toggleRefs: navigationRefs,
        type: "navigation",
        width: navigationWidth
    }, navigation), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        ref: legacyScrollRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['layout-main'], {
            [(0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['layout-main-scrollable']]: disableBodyScroll,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['disable-body-scroll-root']]: disableBodyScroll,
            [(0, $1e16b5b5cece95db$export$2e2bcd8739ae039).unfocusable]: isMobile && anyPanelOpen
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: splitPanelBottomOffset
        }
    }, notifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6787200e64d912d4$export$36ba2f559d49a8f6), {
        disableContentPaddings: disableContentPaddings,
        testUtilsClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).notifications,
        labels: ariaLabels,
        topOffset: disableBodyScroll ? 0 : placement.insetBlockStart,
        sticky: !isMobile && stickyNotifications,
        ref: notificationsRef
    }, notifications), (!isMobile && breadcrumbs || contentHeader) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22602bc147daf734$export$2e2bcd8739ae039), {
        ...contentWrapperProps
    }, !isMobile && breadcrumbs && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs, (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['breadcrumbs-desktop'])
    }, breadcrumbs), contentHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-header-wrapper'], !hasRenderedNotifications && (isMobile || !breadcrumbs) && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-extra-top-padding'], !hasRenderedNotifications && !breadcrumbs && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-header-wrapper-first-child'], !disableContentHeaderOverlap && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-header-wrapper-overlapped'])
    }, contentHeader)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22602bc147daf734$export$2e2bcd8739ae039), {
        ...contentWrapperProps,
        ref: mainContentRef,
        disablePaddings: disableContentPaddings,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(!disableContentPaddings && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-wrapper'], !disableContentPaddings && (isMobile || !breadcrumbs) && !contentHeader && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-extra-top-padding'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).content, !disableContentHeaderOverlap && contentHeader && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-overlapped'], !hasRenderedNotifications && !breadcrumbs && !isMobile && !contentHeader && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)['content-wrapper-first-child']),
        style: (0, $218e10bc7e8580c0$export$7f13b984303df6e1)(placement.insetBlockStart, placement.insetBlockEnd + (splitPanelBottomOffset || 0), `${stickyNotificationsHeight}px`, mobileBarHeight && !disableBodyScroll ? `${mobileBarHeight}px` : '0px', !!disableBodyScroll, isMobile)
    }, content)), finalSplitPanePosition === 'bottom' && splitPanelWrapped), finalSplitPanePosition === 'side' && splitPanelWrapped, hasDrawers ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fbbfc7e7be429ab7$export$c2945a2d20d1b49a), {
        contentClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(activeDrawerId && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer'], activeDrawerId === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools),
        toggleClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle'],
        closeClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer-close-button'], activeDrawerId === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-close']),
        ariaLabels: {
            openLabel: (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.triggerButton,
            closeLabel: (_c = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.closeButton,
            mainLabel: (_d = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _d === void 0 ? void 0 : _d.drawerName,
            resizeHandle: (_e = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _e === void 0 ? void 0 : _e.resizeHandle,
            resizeHandleTooltipText: (_f = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _f === void 0 ? void 0 : _f.resizeHandleTooltipText
        },
        minWidth: minDrawerSize,
        maxWidth: drawerMaxSize,
        width: activeDrawerSize,
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        onToggle: (isOpen)=>{
            if (!isOpen) {
                focusToolsButtons();
                focusDrawersButtons();
                onActiveDrawerChange(null, {
                    initiatedByUserAction: true
                });
            }
        },
        isOpen: true,
        hideOpenButton: true,
        toggleRefs: drawerRefs,
        type: "tools",
        onLoseFocus: loseDrawersFocus,
        activeDrawer: activeDrawer,
        onResize: (changeDetail)=>onActiveDrawerResize(changeDetail),
        refs: drawerRefs,
        toolsContent: (_g = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === (0, $892ef2b582c4882d$export$329f249760e831ae))) === null || _g === void 0 ? void 0 : _g.content
    }, activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.content) : !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$4071300121a182f5), {
        contentClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools,
        toggleClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle'],
        closeClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-close'],
        ariaLabels: (0, $917b74cb04fa7906$export$e0ae33479bcb926a).tools.getLabels(ariaLabels),
        width: toolsWidth,
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        onToggle: onToolsToggle,
        isOpen: toolsOpen,
        toggleRefs: toolsRefs,
        type: "tools",
        onLoseFocus: loseToolsFocus
    }, tools), hasDrawers && drawers.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$30e27a27f04aa467), {
        drawerRefs: drawerRefs,
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        drawers: drawers.filter((drawer)=>drawer.trigger),
        activeDrawerId: activeDrawerId,
        onDrawerChange: (newDrawerId)=>{
            if (activeDrawerId !== newDrawerId) {
                focusToolsButtons();
                focusDrawersButtons();
            }
            onActiveDrawerChange(newDrawerId, {
                initiatedByUserAction: true
            });
        },
        ariaLabels: ariaLabels
    })));
});
var $6ad7a06c5c5b5cb1$export$2e2bcd8739ae039 = $6ad7a06c5c5b5cb1$var$ClassicAppLayout;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $5475c68ef3288dd6$export$f37757d67c29fcf7 = (0, $2ec6e52915a41fcf$export$90753eb139627d74).sharedReactContexts.createContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), 'BreadcrumbsSlotContext');
const $5475c68ef3288dd6$export$e0610513fcff76c1 = (0, $2ec6e52915a41fcf$export$90753eb139627d74).sharedReactContexts.createContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), 'AppLayoutVisibilityContext');
const $5475c68ef3288dd6$export$d63bf30415b1e704 = (0, $2ec6e52915a41fcf$export$90753eb139627d74).sharedReactContexts.createContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), 'AppLayoutToolbarPublicContext');


const $73078c4512771f18$export$140d325aa1fff478 = ()=>{
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return isRefresh && ((0, $013a2451794a45c0$exports.getGlobalFlag)('appLayoutWidget') || (0, $013a2451794a45c0$exports.getGlobalFlag)('appLayoutToolbar'));
};
const $73078c4512771f18$export$d38f11a69207eec8 = ()=>{
    var _a;
    const isToolbarPrivate = $73078c4512771f18$export$140d325aa1fff478();
    const isToolbarPublic = (_a = (0, $acw62.useContext)((0, $5475c68ef3288dd6$export$d63bf30415b1e704))) !== null && _a !== void 0 ? _a : false;
    return isToolbarPublic || isToolbarPrivate;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9c98cc94ae829c40$export$ebd33a9e3a891abd = 'awsui-context-content-header';


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $011bca9bf46093da$export$70fcc38162d125af = (0, $acw62.createContext)(()=>{});










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $022a29f861c64d70$var$useResize(drawerRefObject, { activeDrawer: activeDrawer, activeDrawerSize: activeDrawerSize, onActiveDrawerResize: onActiveDrawerResize, drawersRefs: drawersRefs, isToolsOpen: isToolsOpen, drawersMinWidth: drawersMinWidth, drawersMaxWidth: drawersMaxWidth }) {
    var _a, _b;
    const [relativeSize, setRelativeSize] = (0, $acw62.useState)(0);
    const drawerSize = !activeDrawer && !isToolsOpen ? 0 : activeDrawerSize;
    (0, $acw62.useEffect)(()=>{
        // effects are called inside out in the components tree
        // wait one frame to allow app-layout to complete its calculations
        const handle = requestAnimationFrame(()=>{
            const maxSize = drawersMaxWidth;
            setRelativeSize((drawerSize - drawersMinWidth) / (maxSize - drawersMinWidth) * 100);
        });
        return ()=>cancelAnimationFrame(handle);
    }, [
        drawerSize,
        drawersMaxWidth,
        drawersMinWidth
    ]);
    const setSidePanelWidth = (width)=>{
        const maxWidth = drawersMaxWidth;
        const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(drawersMinWidth, width, maxWidth);
        const id = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id;
        if (id && maxWidth >= drawersMinWidth) onActiveDrawerResize({
            size: size,
            id: id
        });
    };
    const sizeControlProps = {
        position: 'side',
        panelRef: drawerRefObject,
        handleRef: drawersRefs.slider,
        onResize: setSidePanelWidth
    };
    const onSliderPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const { onKeyDown: onKeyDown, onDirectionClick: onDirectionClick } = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    const resizeHandle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
        ref: drawersRefs.slider,
        position: "side",
        ariaLabel: (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.resizeHandle,
        tooltipText: (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.resizeHandleTooltipText,
        ariaValuenow: relativeSize,
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-slider'],
        onKeyDown: onKeyDown,
        onDirectionClick: onDirectionClick,
        onPointerDown: onSliderPointerDown
    });
    return {
        resizeHandle: resizeHandle,
        drawerSize: drawerSize
    };
}
var $022a29f861c64d70$export$2e2bcd8739ae039 = $022a29f861c64d70$var$useResize;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $7419c94a5186c7f4$export$2e2bcd8739ae039 = {
    "background": "awsui_background_hyvsj_v6t9d_149",
    "scrolling-background": "awsui_scrolling-background_hyvsj_v6t9d_152",
    "breadcrumbs": "awsui_breadcrumbs_hyvsj_v6t9d_163",
    "drawers-container": "awsui_drawers-container_hyvsj_v6t9d_176",
    "has-open-drawer": "awsui_has-open-drawer_hyvsj_v6t9d_187",
    "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_v6t9d_208",
    "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_v6t9d_213",
    "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_v6t9d_251",
    "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_v6t9d_261",
    "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_v6t9d_266",
    "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_v6t9d_280",
    "drawers-trigger": "awsui_drawers-trigger_hyvsj_v6t9d_266",
    "drawer": "awsui_drawer_hyvsj_v6t9d_176",
    "drawer-content-container": "awsui_drawer-content-container_hyvsj_v6t9d_311",
    "drawer-close-button": "awsui_drawer-close-button_hyvsj_v6t9d_320",
    "drawer-content": "awsui_drawer-content_hyvsj_v6t9d_311",
    "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_v6t9d_329",
    "drawer-slider": "awsui_drawer-slider_hyvsj_v6t9d_332",
    "is-drawer-open": "awsui_is-drawer-open_hyvsj_v6t9d_340",
    "content": "awsui_content_hyvsj_v6t9d_366",
    "layout": "awsui_layout_hyvsj_v6t9d_391",
    "has-max-content-width": "awsui_has-max-content-width_hyvsj_v6t9d_463",
    "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_v6t9d_478",
    "content-type-table": "awsui_content-type-table_hyvsj_v6t9d_492",
    "content-type-cards": "awsui_content-type-cards_hyvsj_v6t9d_492",
    "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_v6t9d_498",
    "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_v6t9d_501",
    "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_v6t9d_515",
    "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_v6t9d_518",
    "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_v6t9d_528",
    "content-first-child-header": "awsui_content-first-child-header_hyvsj_v6t9d_531",
    "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_v6t9d_531",
    "has-header": "awsui_has-header_hyvsj_v6t9d_531",
    "content-first-child-main": "awsui_content-first-child-main_hyvsj_v6t9d_546",
    "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_v6t9d_546",
    "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_v6t9d_566",
    "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_v6t9d_569",
    "has-split-panel": "awsui_has-split-panel_hyvsj_v6t9d_589",
    "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_v6t9d_589",
    "block-body-scroll": "awsui_block-body-scroll_hyvsj_v6t9d_597",
    "unfocusable": "awsui_unfocusable_hyvsj_v6t9d_602",
    "container": "awsui_container_hyvsj_v6t9d_612",
    "is-navigation-open": "awsui_is-navigation-open_hyvsj_v6t9d_638",
    "is-tools-open": "awsui_is-tools-open_hyvsj_v6t9d_641",
    "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_v6t9d_641",
    "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_v6t9d_641",
    "has-active-drawer": "awsui_has-active-drawer_hyvsj_v6t9d_641",
    "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_v6t9d_654",
    "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_v6t9d_671",
    "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_v6t9d_675",
    "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_v6t9d_679",
    "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_v6t9d_683",
    "navigation-container": "awsui_navigation-container_hyvsj_v6t9d_692",
    "show-navigation": "awsui_show-navigation_hyvsj_v6t9d_730",
    "animating": "awsui_animating_hyvsj_v6t9d_753",
    "showButtons": "awsui_showButtons_hyvsj_v6t9d_1",
    "navigation": "awsui_navigation_hyvsj_v6t9d_692",
    "openNavigation": "awsui_openNavigation_hyvsj_v6t9d_1",
    "animated-content": "awsui_animated-content_hyvsj_v6t9d_817",
    "content-container": "awsui_content-container_hyvsj_v6t9d_820",
    "hide-navigation": "awsui_hide-navigation_hyvsj_v6t9d_829",
    "notifications": "awsui_notifications_hyvsj_v6t9d_839",
    "has-notification-content": "awsui_has-notification-content_hyvsj_v6t9d_844",
    "sticky-notifications": "awsui_sticky-notifications_hyvsj_v6t9d_848",
    "high-contrast": "awsui_high-contrast_hyvsj_v6t9d_853",
    "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_v6t9d_871",
    "position-bottom": "awsui_position-bottom_hyvsj_v6t9d_918",
    "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_v6t9d_1",
    "split-panel-side": "awsui_split-panel-side_hyvsj_v6t9d_947",
    "position-side": "awsui_position-side_hyvsj_v6t9d_960",
    "tools-container": "awsui_tools-container_hyvsj_v6t9d_982",
    "tools": "awsui_tools_hyvsj_v6t9d_982",
    "openTools": "awsui_openTools_hyvsj_v6t9d_1",
    "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_v6t9d_1071",
    "hide-tools": "awsui_hide-tools_hyvsj_v6t9d_1081",
    "show-tools": "awsui_show-tools_hyvsj_v6t9d_1093",
    "has-tools-form": "awsui_has-tools-form_hyvsj_v6t9d_1071",
    "trigger-button-styles": "awsui_trigger-button-styles_hyvsj_v6t9d_1173",
    "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_v6t9d_1189",
    "trigger": "awsui_trigger_hyvsj_v6t9d_1173",
    "selected": "awsui_selected_hyvsj_v6t9d_1241",
    "badge": "awsui_badge_hyvsj_v6t9d_1261",
    "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_v6t9d_1265",
    "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_hyvsj_v6t9d_1276",
    "dot": "awsui_dot_hyvsj_v6t9d_1280",
    "trigger-tooltip": "awsui_trigger-tooltip_hyvsj_v6t9d_1293"
};


/**
 * If there is no Split Panel in the AppLayout context then the SplitPanel
 * will pass through the AppLayout children without the context.
 */ function $eda04021d4548892$var$SplitPanel({ children: children }) {
    const { footerHeight: footerHeight, handleSplitPanelClick: handleSplitPanelClick, handleSplitPanelPreferencesChange: handleSplitPanelPreferencesChange, handleSplitPanelResize: handleSplitPanelResize, headerHeight: headerHeight, isSplitPanelForcedPosition: isSplitPanelForcedPosition, isSplitPanelOpen: isSplitPanelOpen, setSplitPanelReportedSize: setSplitPanelReportedSize, setSplitPanelReportedHeaderHeight: setSplitPanelReportedHeaderHeight, setSplitPanelToggle: setSplitPanelToggle, splitPanelPosition: splitPanelPosition, splitPanelRefs: splitPanelRefs, splitPanelSize: splitPanelSize } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const props = {
        bottomOffset: 0,
        getMaxHeight: ()=>{
            const availableHeight = document.documentElement.clientHeight - headerHeight - footerHeight;
            // If the page is likely zoomed in at 200%, allow the split panel to fill the content area.
            return availableHeight < 400 ? availableHeight - 40 : availableHeight - 250;
        },
        maxWidth: typeof document !== 'undefined' ? document.documentElement.clientWidth : Number.POSITIVE_INFINITY,
        isForcedPosition: isSplitPanelForcedPosition,
        isOpen: isSplitPanelOpen,
        leftOffset: 0,
        onPreferencesChange: handleSplitPanelPreferencesChange,
        onResize: handleSplitPanelResize,
        onToggle: handleSplitPanelClick,
        position: splitPanelPosition,
        reportSize: setSplitPanelReportedSize,
        reportHeaderHeight: setSplitPanelReportedHeaderHeight,
        rightOffset: 0,
        size: splitPanelSize || 0,
        topOffset: 0,
        setSplitPanelToggle: setSplitPanelToggle,
        refs: splitPanelRefs
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), {
        ...props
    }, children);
}
/**
 * This is the render function for the SplitPanel when it is in bottom position.
 * The Split Panel container will be another row entry in the grid definition in
 * the Layout component. The start and finish columns will be variable based
 * on the presence and state of the Navigation and Tools components.
 */ function $eda04021d4548892$var$SplitPanelBottom() {
    const { disableBodyScroll: disableBodyScroll, hasOpenDrawer: hasOpenDrawer, navigationOpen: navigationOpen, isSplitPanelOpen: isSplitPanelOpen, splitPanel: splitPanel, splitPanelPosition: splitPanelPosition, splitPanelReportedSize: splitPanelReportedSize, splitPanelReportedHeaderHeight: splitPanelReportedHeaderHeight } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!splitPanel) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: isSplitPanelOpen !== null && isSplitPanelOpen !== void 0 ? isSplitPanelOpen : false,
        exit: false
    }, (state, transitionEventsRef)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['split-panel-bottom'], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`position-${splitPanelPosition}`], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === 'entering',
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['disable-body-scroll']]: disableBodyScroll,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-open-drawer']]: hasOpenDrawer,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-navigation-open']]: navigationOpen,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-split-panel-open']]: isSplitPanelOpen
            }),
            ref: transitionEventsRef,
            style: {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelReportedSize]: `${splitPanelReportedSize}px`,
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelReportedHeaderSize]: `${splitPanelReportedHeaderHeight}px`
            }
        }, splitPanelPosition === 'bottom' && splitPanel));
}
/**
 * This is the render function for the SplitPanel when it is side position.
 * The Split Panel will not be within the grid defined in the Layout component
 * but instead a direct child of the Tools component. The width constraints
 * for this position are computed in the Tools component.
 */ /**
 * This component has no opening animations because it causes lots of rerenders that makes the component lag. *
 */ function $eda04021d4548892$var$SplitPanelSide() {
    const { isSplitPanelOpen: isSplitPanelOpen, splitPanel: splitPanel, splitPanelPosition: splitPanelPosition, splitPanelMaxWidth: splitPanelMaxWidth, splitPanelControlId: splitPanelControlId, isToolsOpen: isToolsOpen, activeDrawerId: activeDrawerId } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!splitPanel) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        id: splitPanelControlId,
        "aria-hidden": !isSplitPanelOpen || splitPanelPosition === 'bottom' ? true : false,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['split-panel-side'], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`position-${splitPanelPosition}`], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-split-panel-open']]: isSplitPanelOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-open-drawer']]: !!activeDrawerId || isToolsOpen
        }),
        style: {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelMaxWidth]: `${splitPanelMaxWidth}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelMinWidth]: `${(0, $346c1f4e54c7d4ae$export$c1bd455843613e23)}px`
        }
    }, splitPanelPosition === 'side' && splitPanel);
}
function $eda04021d4548892$export$5582f2db528b4683(isSplitPanelForcedPosition, splitPanelPreferences) {
    let splitPanelPosition = 'bottom';
    if (!isSplitPanelForcedPosition && (splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) === 'side') splitPanelPosition = 'side';
    return splitPanelPosition;
}
$eda04021d4548892$var$SplitPanel.Bottom = $eda04021d4548892$var$SplitPanelBottom;
$eda04021d4548892$var$SplitPanel.Side = $eda04021d4548892$var$SplitPanelSide;
var $eda04021d4548892$export$2e2bcd8739ae039 = $eda04021d4548892$var$SplitPanel;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $78ac35921a119528$export$2e2bcd8739ae039({ contentHeader: contentHeader, disableContentHeaderOverlap: disableContentHeaderOverlap, layoutElement: layoutElement }) {
    const hasContentHeader = !!contentHeader;
    const [hasBackgroundOverlap, setHasBackgroundOverlap] = (0, $acw62.useState)(hasContentHeader);
    const updateBackgroundOverlapHeight = (0, $acw62.useCallback)((height)=>{
        const hasOverlap = hasContentHeader || height > 0;
        setHasBackgroundOverlap(hasOverlap);
        /**
         * React 18 will trigger a paint before the state is correctly updated
         * (see https://github.com/facebook/react/issues/24331).
         * To work around this, we bypass React state updates and imperatively update the custom property on the DOM.
         * An alternative would be to use `queueMicrotask` and `flushSync` in the ResizeObserver callback,
         * but that would have some performance impact as it would delay the render.
         */ // Layout component uses RefObject, we don't expect a RefCallback
        const element = typeof layoutElement !== 'function' && (layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.current);
        if (!element) return;
        if (disableContentHeaderOverlap || !hasOverlap || height <= 0) element.style.removeProperty((0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).overlapHeight);
        else element.style.setProperty((0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).overlapHeight, `${height}px`);
    }, [
        hasContentHeader,
        layoutElement,
        disableContentHeaderOverlap
    ]);
    return {
        hasBackgroundOverlap: hasBackgroundOverlap,
        updateBackgroundOverlapHeight: updateBackgroundOverlapHeight
    };
}



/**
 * The default values are destructured in the context instantiation to
 * prevent downstream Typescript errors. This could likely be replaced
 * by a context interface definition that extends the AppLayout interface.
 */ const $6e9ace527e915055$var$AppLayoutInternalsContext = (0, $acw62.createContext)(null);
function $6e9ace527e915055$export$8790094283eeada6() {
    const ctx = (0, $acw62.useContext)($6e9ace527e915055$var$AppLayoutInternalsContext);
    if (!ctx) throw new Error('Invariant violation: this context is only available inside app layout');
    return ctx;
}
const $6e9ace527e915055$export$56942bf202ca3905 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardRef)=>{
    var _a, _b, _c, _d, _e;
    const { toolsHide: toolsHide, toolsOpen: controlledToolsOpen, navigationHide: navigationHide, navigationOpen: navigationOpen, contentType: contentType, placement: placement, children: children, splitPanel: splitPanel } = props;
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    // Private API for embedded view mode
    const __embeddedViewMode = Boolean(props.__embeddedViewMode);
    /**
     * Set the default values for minimum and maximum content width.
     */ const geckoMaxCssLength = (1073741824 - 1) / 60;
    const halfGeckoMaxCssLength = geckoMaxCssLength / 2;
    // CSS lengths in Gecko are limited to at most (1<<30)-1 app units (Gecko uses 60 as app unit).
    // Limit the maxContentWidth to the half of the upper boundary (≈4230^2) to be on the safe side.
    const maxContentWidth = props.maxContentWidth && props.maxContentWidth > halfGeckoMaxCssLength ? halfGeckoMaxCssLength : (_a = props.maxContentWidth) !== null && _a !== void 0 ? _a : 0;
    const minContentWidth = (_b = props.minContentWidth) !== null && _b !== void 0 ? _b : 280;
    const { refs: navigationRefs, setFocus: focusNavButtons } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(navigationOpen);
    const handleNavigationClick = (0, $013a2451794a45c0$exports.useStableCallback)(({ isOpen: isOpen, autoFocus: autoFocus })=>{
        focusNavButtons({
            force: false,
            autoFocus: autoFocus
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onNavigationChange, {
            open: isOpen
        });
    });
    (0, $acw62.useEffect)(()=>{
        // Close navigation drawer on mobile so that the main content is visible
        if (isMobile) handleNavigationClick({
            isOpen: false,
            autoFocus: false
        });
    }, [
        isMobile,
        handleNavigationClick
    ]);
    const toolsWidth = props.toolsWidth;
    const [isToolsOpen = false, setIsToolsOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledToolsOpen, props.onToolsChange, false, {
        componentName: 'AppLayout',
        controlledProp: 'toolsOpen',
        changeHandler: 'onToolsChange'
    });
    const { refs: toolsRefs, setFocus: focusToolsButtons, loseFocus: loseToolsFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(isToolsOpen, true);
    const handleToolsClick = (0, $acw62.useCallback)(function handleToolsChange(isOpen, skipFocusControl) {
        setIsToolsOpen(isOpen);
        if (!skipFocusControl) focusToolsButtons({
            force: false
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onToolsChange, {
            open: isOpen
        });
    }, [
        props.onToolsChange,
        setIsToolsOpen,
        focusToolsButtons
    ]);
    /**
     * Set the default values for the minimum and maximum Split Panel width when it is
     * in the side position. The useLayoutEffect will compute the available space in the
     * DOM for the Split Panel given the current state. The minimum and maximum
     * widths will potentially trigger a side effect that will put the Split Panel into
     * a forced position on the bottom.
     */ const [splitPanelMaxWidth, setSplitPanelMaxWidth] = (0, $acw62.useState)((0, $346c1f4e54c7d4ae$export$c1bd455843613e23));
    /**
     * The useControllable hook will set the default value and manage either
     * the controlled or uncontrolled state of the Split Panel. By default
     * the Split Panel should always be closed on page load.
     *
     * The callback that will be passed to the SplitPanel component
     * to handle the click events that will change the state of the SplitPanel
     * to open or closed given the current state. It will set the isSplitPanelOpen
     * controlled state and fire the onSplitPanelToggle event.
     */ const [isSplitPanelOpen, setIsSplitPanelOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(props.splitPanelOpen, props.onSplitPanelToggle, false, {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelOpen',
        changeHandler: 'onSplitPanelToggle'
    });
    /**
     * The useControllable hook will manage the controlled or uncontrolled
     * state of the splitPanelPreferences. By default the splitPanelPreferences
     * is undefined. When set the object shape should have a single key to indicate
     * either bottom or side position.
     *
     * The callback that will handle changes to the splitPanelPreferences
     * object that will determine if the SplitPanel is rendered either on the
     * bottom of the viewport or within the Tools container.
     */ const [splitPanelPreferences, setSplitPanelPreferences] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(props.splitPanelPreferences, props.onSplitPanelPreferencesChange, undefined, {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelPreferences',
        changeHandler: 'onSplitPanelPreferencesChange'
    });
    const { refs: splitPanelRefs, setLastInteraction: setSplitPanelLastInteraction } = (0, $d19d77c31ea1086e$export$ba7387b5ce3f72be)([
        splitPanelPreferences,
        isSplitPanelOpen
    ]);
    const handleSplitPanelClick = (0, $acw62.useCallback)(function handleSplitPanelChange() {
        setIsSplitPanelOpen(!isSplitPanelOpen);
        setSplitPanelLastInteraction({
            type: isSplitPanelOpen ? 'close' : 'open'
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onSplitPanelToggle, {
            open: !isSplitPanelOpen
        });
    }, [
        props.onSplitPanelToggle,
        isSplitPanelOpen,
        setIsSplitPanelOpen,
        setSplitPanelLastInteraction
    ]);
    const isSplitPanelForcedPosition = (0, $1349679bbe0bb971$export$aef5e4755971001b)({
        isMobile: isMobile,
        availableWidthForSplitPanel: splitPanelMaxWidth
    });
    const splitPanelPosition = (0, $eda04021d4548892$export$5582f2db528b4683)(isSplitPanelForcedPosition, splitPanelPreferences);
    /**
     * The useControllable hook will set the default size of the SplitPanel based
     * on the default position set in the splitPanelPreferences. The logic for the
     * default size is contained in the SplitPanel component. The splitPanelControlledSize
     * will be bound to the size property in the SplitPanel context for rendering.
     *
     * The callback that will be passed to the SplitPanel component
     * to handle the resize events that will change the size of the SplitPanel.
     * It will set the splitPanelControlledSize controlled state and fire the
     * onSplitPanelResize event.
     */ const [splitPanelReportedSize, setSplitPanelReportedSize] = (0, $acw62.useState)(0);
    const [splitPanelReportedHeaderHeight, setSplitPanelReportedHeaderHeight] = (0, $acw62.useState)(0);
    const [splitPanelToggle, setSplitPanelToggle] = (0, $acw62.useState)({
        displayed: false,
        ariaLabel: undefined
    });
    const splitPanelDisplayed = !!(splitPanelToggle.displayed || isSplitPanelOpen) && !!splitPanel;
    const splitPanelControlId = (0, $013a2451794a45c0$exports.useUniqueId)('split-panel-');
    const toolsControlId = (0, $013a2451794a45c0$exports.useUniqueId)('tools-');
    const [splitPanelSize, setSplitPanelSize] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(props.splitPanelSize, props.onSplitPanelResize, (0, $582c00c3ff10d4e2$export$9d9d5fcac617b082)(splitPanelPosition), {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelSize',
        changeHandler: 'onSplitPanelResize'
    });
    const handleSplitPanelResize = (0, $acw62.useCallback)((size)=>{
        setSplitPanelSize(size);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onSplitPanelResize, {
            size: size
        });
    }, [
        props.onSplitPanelResize,
        setSplitPanelSize
    ]);
    const handleSplitPanelPreferencesChange = (0, $acw62.useCallback)(function handleSplitPanelChange(detail) {
        setSplitPanelPreferences(detail);
        setSplitPanelLastInteraction({
            type: 'position'
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onSplitPanelPreferencesChange, detail);
    }, [
        props.onSplitPanelPreferencesChange,
        setSplitPanelPreferences,
        setSplitPanelLastInteraction
    ]);
    const { drawers: drawers, activeDrawer: activeDrawer, activeDrawerId: activeDrawerId, minDrawerSize: drawersMinWidth, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize, activeDrawerSize: activeDrawerSize, ...drawersProps } = (0, $892ef2b582c4882d$export$468f52f962f49bf5)(props, props.ariaLabels, {
        disableDrawersMerge: true,
        ariaLabels: props.ariaLabels,
        toolsHide: toolsHide,
        toolsOpen: isToolsOpen,
        tools: props.tools,
        toolsWidth: toolsWidth,
        onToolsToggle: handleToolsClick
    });
    const [drawersMaxWidth, setDrawersMaxWidth] = (0, $acw62.useState)(toolsWidth);
    const hasDrawers = !!drawers && drawers.length > 0;
    const { refs: drawersRefs, setFocus: focusDrawersButtons, loseFocus: loseDrawersFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(!!activeDrawerId, true, activeDrawerId);
    const drawerRef = (0, $acw62.useRef)(null);
    const { resizeHandle: resizeHandle, drawerSize: drawerSize } = (0, $022a29f861c64d70$export$2e2bcd8739ae039)(drawerRef, {
        onActiveDrawerResize: onActiveDrawerResize,
        activeDrawerSize: activeDrawerSize,
        activeDrawer: activeDrawer,
        drawersRefs: drawersRefs,
        isToolsOpen: isToolsOpen,
        drawersMaxWidth: drawersMaxWidth,
        drawersMinWidth: drawersMinWidth
    });
    const handleDrawersClick = (id, skipFocusControl)=>{
        const newActiveDrawerId = id !== activeDrawerId ? id : null;
        onActiveDrawerChange(newActiveDrawerId, {
            initiatedByUserAction: true
        });
        if (!skipFocusControl) focusDrawersButtons();
    };
    let drawersTriggerCount = drawers ? drawers.length : !toolsHide ? 1 : 0;
    if (splitPanelDisplayed && splitPanelPosition === 'side') drawersTriggerCount++;
    const hasOpenDrawer = !!activeDrawerId || !toolsHide && isToolsOpen || splitPanelDisplayed && splitPanelPosition === 'side' && isSplitPanelOpen;
    const hasDrawerViewportOverlay = isMobile && (!!activeDrawerId || !navigationHide && navigationOpen || !toolsHide && isToolsOpen);
    const layoutElement = (0, $acw62.useRef)(null);
    const mainElement = (0, $acw62.useRef)(null);
    const [mainOffsetLeft, setMainOffsetLeft] = (0, $acw62.useState)(0);
    const { hasBackgroundOverlap: hasBackgroundOverlap, updateBackgroundOverlapHeight: updateBackgroundOverlapHeight } = (0, $78ac35921a119528$export$2e2bcd8739ae039)({
        contentHeader: props.contentHeader,
        disableContentHeaderOverlap: props.disableContentHeaderOverlap,
        layoutElement: layoutElement
    });
    (0, $acw62.useLayoutEffect)(function handleMainOffsetLeft() {
        const offsetInlineStart = (mainElement === null || mainElement === void 0 ? void 0 : mainElement.current) ? (0, $013a2451794a45c0$exports.getOffsetInlineStart)(mainElement === null || mainElement === void 0 ? void 0 : mainElement.current) : 0;
        setMainOffsetLeft(offsetInlineStart);
    }, [
        placement.inlineSize,
        navigationOpen,
        isToolsOpen,
        splitPanelReportedSize
    ]);
    /**
     * On mobile viewports the navigation and tools drawers are adjusted to a fixed position
     * that consumes 100% of the viewport height and width. The body content could potentially
     * be scrollable underneath the drawer. In order to prevent this a CSS class needs to be
     * added to the document body that sets overflow to hidden.
     */ (0, $acw62.useEffect)(function handleBodyScroll() {
        if (isMobile && (navigationOpen || isToolsOpen || !!activeDrawer)) document.body.classList.add((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['block-body-scroll']);
        else document.body.classList.remove((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['block-body-scroll']);
        // Ensure the CSS class is removed from the body on side effect cleanup
        return function cleanup() {
            document.body.classList.remove((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['block-body-scroll']);
        };
    }, [
        isMobile,
        navigationOpen,
        isToolsOpen,
        activeDrawer
    ]);
    const [notificationsHeight, setNotificationsHeight] = (0, $acw62.useState)(0);
    const hasNotificationsContent = notificationsHeight > 0;
    /**
     * Determine the offsetBottom value based on the presence of a footer element and
     * the SplitPanel component. Ignore the SplitPanel if it is not in the bottom
     * position. Use the size property if it is open and the header height if it is closed.
     */ let offsetBottom = placement.insetBlockEnd;
    if (splitPanelDisplayed && splitPanelPosition === 'bottom') {
        if (isSplitPanelOpen) offsetBottom += splitPanelReportedSize;
        else offsetBottom += splitPanelReportedHeaderHeight;
    }
    /**
     * Warning! This is a hack! In order to accurately calculate if there is adequate
     * horizontal space for the Split Panel to be in the side position we need two values
     * that are not available in JavaScript.
     *
     * The first is the the content gap on the right which is stored in a design token
     * and applied in the Layout CSS:
     *
     * $contentGapRight: #{awsui.$space-layout-content-horizontal};
     *
     * The second is the width of the element that has the circular buttons for the
     * Tools and Split Panel. This could be suppressed given the state of the Tools
     * drawer returning a zero value. It would, however, be rendered if the Split Panel
     * were to move into the side position. This is calculated in the Tools CSS and
     * the Trigger button CSS with design tokens:
     *
     * padding: awsui.$space-scaled-s awsui.$space-layout-toggle-padding;
     * width: awsui.$space-layout-toggle-diameter;
     *
     * These values will be defined below as static integers that are rough approximations
     * of their computed width when rendered in the DOM, but doubled to ensure adequate
     * spacing for the Split Panel to be in side position.
     */ (0, $acw62.useLayoutEffect)(function handleSplitPanelMaxWidth() {
        const contentGapRight = 50; // Approximately 24px when rendered but doubled for safety
        const toolsFormOffsetWidth = 120; // Approximately 60px when rendered but doubled for safety
        const getPanelOffsetWidth = ()=>{
            if (drawers) return activeDrawerId ? drawerSize : 0;
            return isToolsOpen ? toolsWidth : 0;
        };
        setSplitPanelMaxWidth(placement.inlineSize - mainOffsetLeft - minContentWidth - contentGapRight - toolsFormOffsetWidth - getPanelOffsetWidth());
        setDrawersMaxWidth(placement.inlineSize - mainOffsetLeft - minContentWidth - contentGapRight - toolsFormOffsetWidth);
    }, [
        activeDrawerId,
        drawerSize,
        drawers,
        navigationOpen,
        isToolsOpen,
        placement.inlineSize,
        mainOffsetLeft,
        minContentWidth,
        toolsWidth
    ]);
    /**
     * The useImperativeHandle hook in conjunction with the forwardRef function
     * in the AppLayout component definition expose the following callable
     * functions to component consumers when they put a ref as a property on
     * their component implementation.
     */ (0, $acw62.useImperativeHandle)(forwardRef, function createImperativeHandle() {
        return {
            closeNavigationIfNecessary: function() {
                if (isMobile) handleNavigationClick({
                    isOpen: false,
                    autoFocus: true
                });
            },
            openTools: function() {
                handleToolsClick(true, hasDrawers);
                if (hasDrawers) focusDrawersButtons({
                    force: true
                });
            },
            focusToolsClose: ()=>{
                if (hasDrawers) focusDrawersButtons({
                    force: true
                });
                else focusToolsButtons({
                    force: true
                });
            },
            focusActiveDrawer: ()=>focusDrawersButtons({
                    force: true
                }),
            focusSplitPanel: ()=>{
                var _a;
                return (_a = splitPanelRefs.slider.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
    }, [
        isMobile,
        handleNavigationClick,
        handleToolsClick,
        focusToolsButtons,
        focusDrawersButtons,
        splitPanelRefs.slider,
        hasDrawers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6e9ace527e915055$var$AppLayoutInternalsContext.Provider, {
        value: {
            ...props,
            activeDrawerId: activeDrawerId,
            contentType: contentType,
            drawers: drawers,
            drawersAriaLabel: (_c = drawersProps.ariaLabelsWithDrawers) === null || _c === void 0 ? void 0 : _c.drawers,
            drawersOverflowAriaLabel: (_d = drawersProps.ariaLabelsWithDrawers) === null || _d === void 0 ? void 0 : _d.drawersOverflow,
            drawersOverflowWithBadgeAriaLabel: (_e = drawersProps.ariaLabelsWithDrawers) === null || _e === void 0 ? void 0 : _e.drawersOverflowWithBadge,
            drawersRefs: drawersRefs,
            drawersMinWidth: drawersMinWidth,
            drawersMaxWidth: drawersMaxWidth,
            drawerSize: drawerSize,
            drawerRef: drawerRef,
            resizeHandle: resizeHandle,
            drawersTriggerCount: drawersTriggerCount,
            headerHeight: placement.insetBlockStart,
            footerHeight: placement.insetBlockEnd,
            hasDrawerViewportOverlay: hasDrawerViewportOverlay,
            handleDrawersClick: handleDrawersClick,
            handleNavigationClick: (isOpen)=>handleNavigationClick({
                    isOpen: isOpen,
                    autoFocus: true
                }),
            handleSplitPanelClick: handleSplitPanelClick,
            handleSplitPanelPreferencesChange: handleSplitPanelPreferencesChange,
            handleSplitPanelResize: handleSplitPanelResize,
            handleToolsClick: handleToolsClick,
            hasBackgroundOverlap: hasBackgroundOverlap,
            hasNotificationsContent: hasNotificationsContent,
            hasOpenDrawer: hasOpenDrawer,
            isBackgroundOverlapDisabled: props.disableContentHeaderOverlap || !hasBackgroundOverlap,
            isMobile: isMobile,
            isSplitPanelForcedPosition: isSplitPanelForcedPosition,
            isSplitPanelOpen: isSplitPanelOpen,
            isToolsOpen: isToolsOpen,
            layoutElement: layoutElement,
            layoutWidth: placement.inlineSize,
            loseToolsFocus: loseToolsFocus,
            loseDrawersFocus: loseDrawersFocus,
            mainElement: mainElement,
            mainOffsetLeft: mainOffsetLeft,
            maxContentWidth: maxContentWidth,
            minContentWidth: minContentWidth,
            navigationHide: navigationHide,
            navigationRefs: navigationRefs,
            notificationsHeight: notificationsHeight,
            setNotificationsHeight: setNotificationsHeight,
            offsetBottom: offsetBottom,
            setSplitPanelReportedSize: setSplitPanelReportedSize,
            setSplitPanelReportedHeaderHeight: setSplitPanelReportedHeaderHeight,
            splitPanel: splitPanel,
            splitPanelControlId: splitPanelControlId,
            splitPanelDisplayed: splitPanelDisplayed,
            splitPanelMaxWidth: splitPanelMaxWidth,
            splitPanelPosition: splitPanelPosition,
            splitPanelPreferences: splitPanelPreferences,
            splitPanelReportedSize: splitPanelReportedSize,
            splitPanelReportedHeaderHeight: splitPanelReportedHeaderHeight,
            splitPanelSize: splitPanelSize,
            splitPanelToggle: splitPanelToggle,
            setSplitPanelToggle: setSplitPanelToggle,
            splitPanelRefs: splitPanelRefs,
            toolsControlId: toolsControlId,
            toolsHide: toolsHide,
            toolsOpen: isToolsOpen,
            toolsWidth: toolsWidth,
            toolsRefs: toolsRefs,
            __embeddedViewMode: __embeddedViewMode
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $011bca9bf46093da$export$70fcc38162d125af).Provider, {
        value: updateBackgroundOverlapHeight
    }, children));
});



function $e6b9304cc8ecd5f8$export$2e2bcd8739ae039() {
    const { breadcrumbs: breadcrumbs, hasBackgroundOverlap: hasBackgroundOverlap, hasNotificationsContent: hasNotificationsContent, isMobile: isMobile, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!hasNotificationsContent && (!breadcrumbs || isMobile) && !hasBackgroundOverlap) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).background, {
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === 'high-contrast'
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['scrolling-background']
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $870116fec74b536c$export$2e2bcd8739ae039() {
    const { breadcrumbs: breadcrumbs, isMobile: isMobile, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (isMobile || !breadcrumbs) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).breadcrumbs, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs, {
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === 'high-contrast'
        })
    }, breadcrumbs);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $6a3757dc95ec4d39$var$TriggerButton({ ariaLabel: ariaLabel, className: className, iconName: iconName, iconSvg: iconSvg, ariaExpanded: ariaExpanded, ariaControls: ariaControls, onClick: onClick, testId: testId, disabled: disabled = false, badge: badge, selected: selected = false, highContrastHeader: highContrastHeader }, ref) {
    const { isMobile: isMobile } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['trigger-wrapper'], !highContrastHeader && (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['remove-high-contrast-header'])
    }, isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaExpanded: ariaExpanded,
        ariaLabel: ariaLabel,
        ariaControls: ariaControls,
        className: className,
        disabled: disabled,
        ref: ref,
        formAction: "none",
        iconName: iconName,
        iconSvg: iconSvg,
        badge: badge,
        onClick: onClick,
        variant: "icon",
        nativeButtonAttributes: {
            'aria-haspopup': true,
            ...testId && {
                'data-testid': testId
            }
        }
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": true,
        "aria-label": ariaLabel,
        "aria-disabled": disabled,
        disabled: disabled,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).trigger, (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['trigger-button-styles'], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).selected]: selected,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).badge]: badge
        }, className),
        onClick: onClick,
        ref: ref,
        type: "button",
        "data-testid": testId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(badge && (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['trigger-badge-wrapper'], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['trigger-button-styles']))
    }, (iconName || iconSvg) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconName,
        svg: iconSvg
    }))), badge && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039).dot
    })));
}
var $6a3757dc95ec4d39$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($6a3757dc95ec4d39$var$TriggerButton);



var $e24acb969e7c7c7f$export$2e2bcd8739ae039 = {
    "root": "awsui_root_rjqu5_1kbym_5",
    "header-actions": "awsui_header-actions_rjqu5_1kbym_6",
    "header-before": "awsui_header-before_rjqu5_1kbym_7",
    "header-description": "awsui_header-description_rjqu5_1kbym_8",
    "header-info": "awsui_header-info_rjqu5_1kbym_9",
    "header-text": "awsui_header-text_rjqu5_1kbym_10",
    "open-button": "awsui_open-button_rjqu5_1kbym_11",
    "close-button": "awsui_close-button_rjqu5_1kbym_12",
    "preferences-button": "awsui_preferences-button_rjqu5_1kbym_13",
    "slider": "awsui_slider_rjqu5_1kbym_14",
    "open-position-bottom": "awsui_open-position-bottom_rjqu5_1kbym_15",
    "open-position-side": "awsui_open-position-side_rjqu5_1kbym_16"
};




/**
 * The VISIBLE_MOBILE_TOOLBAR_TRIGGERS_LIMIT is used to reduce the number
 * of triggers that are initially visible on the mobile toolbar, the rest
 * are then placed into an overflow menu
 *
 * Note if one of the triggers is for a split-panel, it would not count that
 */ const $80840cb1e803926f$var$VISIBLE_MOBILE_TOOLBAR_TRIGGERS_LIMIT = 2;
function $80840cb1e803926f$export$2e2bcd8739ae039() {
    const { disableBodyScroll: disableBodyScroll, drawers: drawers, drawersTriggerCount: drawersTriggerCount, hasDrawerViewportOverlay: hasDrawerViewportOverlay, hasOpenDrawer: hasOpenDrawer, navigationOpen: navigationOpen, navigationHide: navigationHide, isMobile: isMobile } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const isUnfocusable = hasDrawerViewportOverlay && navigationOpen && !navigationHide;
    if (!drawers || drawersTriggerCount === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-container'], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['disable-body-scroll']]: disableBodyScroll,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-open-drawer']]: hasOpenDrawer,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039).Side, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($80840cb1e803926f$var$ActiveDrawer, null), !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($80840cb1e803926f$var$DesktopTriggers, null));
}
function $80840cb1e803926f$var$ActiveDrawer() {
    var _a, _b, _c, _d;
    const { activeDrawerId: activeDrawerId, ariaLabels: ariaLabels, drawers: drawers, drawersRefs: drawersRefs, handleDrawersClick: handleDrawersClick, handleToolsClick: handleToolsClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, navigationOpen: navigationOpen, navigationHide: navigationHide, loseDrawersFocus: loseDrawersFocus, resizeHandle: resizeHandle, drawerSize: drawerSize, drawersMinWidth: drawersMinWidth, drawersMaxWidth: drawersMaxWidth, drawerRef: drawerRef } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const activeDrawer = (_a = drawers === null || drawers === void 0 ? void 0 : drawers.find((item)=>item.id === activeDrawerId)) !== null && _a !== void 0 ? _a : null;
    const computedAriaLabels = {
        closeButton: activeDrawerId ? (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.closeButton : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose,
        content: activeDrawerId ? (_c = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.drawerName : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools
    };
    const isHidden = !activeDrawerId;
    const isUnfocusable = isHidden || hasDrawerViewportOverlay && navigationOpen && !navigationHide;
    const isToolsDrawer = activeDrawerId === (0, $892ef2b582c4882d$export$329f249760e831ae);
    const toolsContent = (_d = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === (0, $892ef2b582c4882d$export$329f249760e831ae))) === null || _d === void 0 ? void 0 : _d.content;
    const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(drawersMinWidth, drawerSize, drawersMaxWidth);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        id: activeDrawerId !== null && activeDrawerId !== void 0 ? activeDrawerId : undefined,
        "aria-hidden": isHidden,
        "aria-label": computedAriaLabels.content,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).drawer, {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-drawer-open']]: activeDrawerId,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer']]: activeDrawerId,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools]: isToolsDrawer
        }),
        style: {
            ...!isMobile && drawerSize && {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).drawerSize]: `${size}px`
            }
        },
        ref: drawerRef,
        onBlur: (e)=>{
            if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) loseDrawersFocus();
        }
    }, !isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.resizable) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawer-slider']
    }, resizeHandle), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawer-content-container']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawer-close-button']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaLabel: computedAriaLabels.closeButton,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer-close-button']]: activeDrawerId,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-close']]: isToolsDrawer
        }),
        formAction: "none",
        iconName: isMobile ? 'close' : 'angle-right',
        onClick: ()=>{
            handleDrawersClick(activeDrawerId);
            handleToolsClick(false);
        },
        ref: drawersRefs.close,
        variant: "icon"
    })), toolsContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: (0, $892ef2b582c4882d$export$329f249760e831ae),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawer-content'], activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawer-content-hidden'])
    }, toolsContent), activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: activeDrawerId,
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawer-content']
    }, activeDrawerId && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.content))));
}
/**
 * The DesktopTriggers will render the trigger buttons for Tools, Drawers, and the
 * SplitPanel in non mobile viewports. Changes to the activeDrawerId need to be
 * tracked by the previousActiveDrawerId property in order to appropriately apply
 * the ref required to manage focus control.
 */ function $80840cb1e803926f$var$DesktopTriggers() {
    const { activeDrawerId: activeDrawerId, drawers: drawers, drawersAriaLabel: drawersAriaLabel, drawersOverflowAriaLabel: drawersOverflowAriaLabel, drawersOverflowWithBadgeAriaLabel: drawersOverflowWithBadgeAriaLabel, drawersRefs: drawersRefs, drawersTriggerCount: drawersTriggerCount, handleDrawersClick: handleDrawersClick, handleSplitPanelClick: handleSplitPanelClick, hasOpenDrawer: hasOpenDrawer, isSplitPanelOpen: isSplitPanelOpen, splitPanel: splitPanel, splitPanelControlId: splitPanelControlId, splitPanelDisplayed: splitPanelDisplayed, splitPanelPosition: splitPanelPosition, splitPanelRefs: splitPanelRefs, splitPanelToggle: splitPanelToggle, splitPanelReportedHeaderHeight: splitPanelReportedHeaderHeight, splitPanelReportedSize: splitPanelReportedSize, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const hasMultipleTriggers = drawersTriggerCount > 1;
    const hasSplitPanel = splitPanel && splitPanelDisplayed && splitPanelPosition === 'side';
    const previousActiveDrawerId = (0, $acw62.useRef)(activeDrawerId);
    const [containerHeight, triggersContainerRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    if (activeDrawerId) previousActiveDrawerId.current = activeDrawerId;
    const splitPanelHeight = isSplitPanelOpen && splitPanelPosition === 'bottom' ? splitPanelReportedSize : splitPanelReportedHeaderHeight;
    const getIndexOfOverflowItem = ()=>{
        if (containerHeight) {
            const ITEM_HEIGHT = 48;
            const overflowSpot = activeDrawerId && isSplitPanelOpen ? (containerHeight - splitPanelReportedHeaderHeight) / 1.5 : (containerHeight - splitPanelHeight) / 1.5;
            const index = Math.floor(overflowSpot / ITEM_HEIGHT);
            let splitPanelItem = 0;
            if (hasSplitPanel && splitPanelToggle.displayed) splitPanelItem = 1;
            return index - splitPanelItem;
        }
        return 0;
    };
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers !== null && drawers !== void 0 ? drawers : undefined, getIndexOfOverflowItem(), activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-desktop-triggers-container'], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-multiple-triggers']]: hasMultipleTriggers,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-open-drawer']]: hasOpenDrawer
        }),
        "aria-label": drawersAriaLabel,
        ref: triggersContainerRef,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-trigger-content'], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-multiple-triggers']]: hasMultipleTriggers,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-open-drawer']]: hasOpenDrawer
        }),
        "aria-label": drawersAriaLabel,
        role: "toolbar",
        "aria-orientation": "vertical"
    }, visibleItems.map((item)=>{
        var _a, _b, _c;
        const isForPreviousActiveDrawer = (previousActiveDrawerId === null || previousActiveDrawerId === void 0 ? void 0 : previousActiveDrawerId.current) === item.id;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaExpanded: item.id === activeDrawerId,
            ariaControls: activeDrawerId === item.id ? item.id : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], {
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger-with-badge']]: item.badge,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle']]: item.id === (0, $892ef2b582c4882d$export$329f249760e831ae)
            }),
            iconName: (_b = item === null || item === void 0 ? void 0 : item.trigger) === null || _b === void 0 ? void 0 : _b.iconName,
            iconSvg: (_c = item === null || item === void 0 ? void 0 : item.trigger) === null || _c === void 0 ? void 0 : _c.iconSvg,
            key: item.id,
            onClick: ()=>handleDrawersClick(item.id),
            ref: isForPreviousActiveDrawer ? drawersRefs.toggle : undefined,
            badge: item.badge,
            testId: `awsui-app-layout-trigger-${item.id}`,
            highContrastHeader: headerVariant === 'high-contrast',
            selected: item.id === activeDrawerId
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        items: overflowItems,
        ariaLabel: overflowMenuHasBadge ? drawersOverflowWithBadgeAriaLabel : drawersOverflowAriaLabel,
        customTriggerBuilder: ({ onClick: onClick, triggerRef: triggerRef, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, testUtilsClass: testUtilsClass })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
                ref: triggerRef,
                ariaLabel: ariaLabel,
                ariaExpanded: ariaExpanded,
                badge: overflowMenuHasBadge,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], testUtilsClass),
                iconName: "ellipsis",
                onClick: onClick,
                highContrastHeader: headerVariant === 'high-contrast'
            }),
        onItemClick: ({ detail: detail })=>{
            handleDrawersClick(detail.id);
        }
    }), hasSplitPanel && splitPanelToggle.displayed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
        ariaLabel: splitPanelToggle.ariaLabel,
        ariaControls: splitPanelControlId,
        ariaExpanded: !!isSplitPanelOpen,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-trigger'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['open-button']),
        iconName: "view-vertical",
        onClick: ()=>handleSplitPanelClick(),
        selected: hasSplitPanel && isSplitPanelOpen,
        ref: splitPanelRefs.toggle,
        highContrastHeader: headerVariant === 'high-contrast'
    })));
}
function $80840cb1e803926f$export$3327f5ebc2d6865() {
    const { activeDrawerId: activeDrawerId, drawers: drawers, drawersAriaLabel: drawersAriaLabel, drawersOverflowAriaLabel: drawersOverflowAriaLabel, drawersOverflowWithBadgeAriaLabel: drawersOverflowWithBadgeAriaLabel, drawersRefs: drawersRefs, handleDrawersClick: handleDrawersClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const previousActiveDrawerId = (0, $acw62.useRef)(activeDrawerId);
    if (!drawers) return null;
    if (activeDrawerId) previousActiveDrawerId.current = activeDrawerId;
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers, $80840cb1e803926f$var$VISIBLE_MOBILE_TOOLBAR_TRIGGERS_LIMIT, activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-hidden": hasDrawerViewportOverlay,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay
        }),
        "aria-label": drawersAriaLabel,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-mobile-triggers-container'],
        "aria-label": drawersAriaLabel,
        role: "toolbar",
        "aria-orientation": "horizontal"
    }, visibleItems.map((item)=>{
        var _a, _b, _c;
        const isForPreviousActiveDrawer = (previousActiveDrawerId === null || previousActiveDrawerId === void 0 ? void 0 : previousActiveDrawerId.current) === item.id;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaExpanded: item.id === activeDrawerId,
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaControls: activeDrawerId === item.id ? item.id : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], {
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger-with-badge']]: item.badge,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle']]: item.id === (0, $892ef2b582c4882d$export$329f249760e831ae)
            }),
            disabled: hasDrawerViewportOverlay,
            ref: isForPreviousActiveDrawer ? drawersRefs.toggle : undefined,
            iconName: (_b = item === null || item === void 0 ? void 0 : item.trigger) === null || _b === void 0 ? void 0 : _b.iconName,
            iconSvg: (_c = item === null || item === void 0 ? void 0 : item.trigger) === null || _c === void 0 ? void 0 : _c.iconSvg,
            badge: item.badge,
            key: item.id,
            onClick: ()=>handleDrawersClick(item.id),
            testId: `awsui-app-layout-trigger-${item.id}`,
            highContrastHeader: headerVariant === 'high-contrast',
            selected: item.id === activeDrawerId
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        items: overflowItems,
        ariaLabel: overflowMenuHasBadge ? drawersOverflowWithBadgeAriaLabel : drawersOverflowAriaLabel,
        onItemClick: ({ detail: detail })=>handleDrawersClick(detail.id)
    })));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




function $267aa9df9137ec77$export$2e2bcd8739ae039() {
    const { breadcrumbs: breadcrumbs, contentHeader: contentHeader, hasDrawerViewportOverlay: hasDrawerViewportOverlay, hasNotificationsContent: hasNotificationsContent, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!contentHeader) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).content, {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-breadcrumbs']]: breadcrumbs,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-notifications-content']]: hasNotificationsContent,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay,
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === 'high-contrast'
        })
    }, contentHeader);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $139ddc5f315dad51$export$517494a671c245e0(headerHeight) {
    (0, $acw62.useEffect)(()=>{
        const scrollingElement = document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) scrollingElement.style.scrollPaddingTop = `${headerHeight}px`;
    }, [
        headerHeight
    ]);
}





function $52c91a8fefd6ceb2$export$2e2bcd8739ae039({ children: children }) {
    const { breadcrumbs: breadcrumbs, contentHeader: contentHeader, contentType: contentType, disableBodyScroll: disableBodyScroll, disableContentPaddings: disableContentPaddings, drawersTriggerCount: drawersTriggerCount, footerHeight: footerHeight, hasNotificationsContent: hasNotificationsContent, hasOpenDrawer: hasOpenDrawer, headerHeight: headerHeight, isBackgroundOverlapDisabled: isBackgroundOverlapDisabled, isMobile: isMobile, navigationOpen: navigationOpen, layoutElement: layoutElement, layoutWidth: layoutWidth, mainOffsetLeft: mainOffsetLeft, maxContentWidth: maxContentWidth, minContentWidth: minContentWidth, navigationHide: navigationHide, notificationsHeight: notificationsHeight, __embeddedViewMode: __embeddedViewMode, splitPanelPosition: splitPanelPosition, splitPanelDisplayed: splitPanelDisplayed } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    (0, $139ddc5f315dad51$export$517494a671c245e0)(headerHeight);
    // Determine the first content child so the gap will vertically align with the trigger buttons
    const contentFirstChild = $52c91a8fefd6ceb2$var$getContentFirstChild(breadcrumbs, contentHeader, hasNotificationsContent, isMobile);
    // Content gaps on the left and right are used with the minmax function in the CSS grid column definition
    const hasContentGapLeft = navigationOpen || navigationHide;
    const hasContentGapRight = drawersTriggerCount === 0 || hasOpenDrawer;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).layout, (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`content-first-child-${contentFirstChild}`], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`content-type-${contentType}`], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`split-panel-position-${splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : 'bottom'}`], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['disable-body-scroll']]: disableBodyScroll,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['disable-body-scroll-root']]: disableBodyScroll,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['disable-content-paddings']]: disableContentPaddings,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-breadcrumbs']]: breadcrumbs && !isMobile,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-content-gap-left']]: hasContentGapLeft,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-content-gap-right']]: hasContentGapRight,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-header']]: contentHeader,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-max-content-width']]: maxContentWidth && maxContentWidth > 0,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-split-panel']]: splitPanelDisplayed,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-overlap-disabled']]: isBackgroundOverlapDisabled,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-hide-mobile-toolbar']]: __embeddedViewMode,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-left-toggles-gutter']]: !(isMobile || navigationHide || navigationOpen),
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-right-toggles-gutter']]: !isMobile && !hasContentGapRight
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).root),
        ref: layoutElement,
        style: {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).headerHeight]: `${headerHeight}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).footerHeight]: `${footerHeight}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).layoutWidth]: `${layoutWidth}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).mainOffsetLeft]: `${mainOffsetLeft}px`,
            ...maxContentWidth && {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).maxContentWidth]: `${maxContentWidth}px`
            },
            ...minContentWidth && {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).minContentWidth]: `${minContentWidth}px`
            },
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).notificationsHeight]: `${notificationsHeight}px`
        }
    }, children);
}
/*
The Notifications, Breadcrumbs, Header, and Main are all rendered in the center
column of the grid layout. Any of these could be the first child to render in the
content area if the previous siblings do not exist. The grid gap before the first
child will be different to ensure vertical alignment with the trigger buttons.
*/ function $52c91a8fefd6ceb2$var$getContentFirstChild(breadcrumbs, contentHeader, hasNotificationsContent, isMobile) {
    let contentFirstChild = 'main';
    if (hasNotificationsContent) contentFirstChild = 'notifications';
    else if (breadcrumbs && !isMobile) contentFirstChild = 'breadcrumbs';
    else if (contentHeader) contentFirstChild = 'header';
    return contentFirstChild;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $17a6dd8285442c36$export$406273d7c25fc294 = "var(--color-primary-50-1y05xv, #f0fbff)";
var $17a6dd8285442c36$export$7e7ecbb702a934e = "var(--color-primary-100-f62fz9, #d1f1ff)";
var $17a6dd8285442c36$export$5b19f18e20281396 = "var(--color-primary-200-vubr4w, #b8e7ff)";
var $17a6dd8285442c36$export$7d5e70c6943c252d = "var(--color-primary-300-5q65ox, #75cfff)";
var $17a6dd8285442c36$export$9ca83facccc708b0 = "var(--color-primary-400-n8h4bx, #42b4ff)";
var $17a6dd8285442c36$export$74874ac05f52df55 = "var(--color-primary-500-q9c16y, #0099ff)";
var $17a6dd8285442c36$export$3350db2a17de352e = "var(--color-primary-600-1lcy1k, #006ce0)";
var $17a6dd8285442c36$export$24bf37af47f89f83 = "var(--color-primary-700-n6k121, #004a9e)";
var $17a6dd8285442c36$export$e34dd6abfc24ed3e = "var(--color-primary-800-j9rj38, #003b8f)";
var $17a6dd8285442c36$export$aaa1624d39e80617 = "var(--color-primary-900-a5kqrr, #002b66)";
var $17a6dd8285442c36$export$9ce10b08a81e302d = "var(--color-primary-1000-7umopx, #001129)";
var $17a6dd8285442c36$export$481e6ccb9f5249c4 = "var(--color-neutral-50-pvu04n, #fcfcfd)";
var $17a6dd8285442c36$export$831fcbb79da59113 = "var(--color-neutral-100-gk3lvf, #f9f9fa)";
var $17a6dd8285442c36$export$a74bdd786ba0e500 = "var(--color-neutral-150-gezhen, #f6f6f9)";
var $17a6dd8285442c36$export$3aab7304804a70d5 = "var(--color-neutral-200-fqt4tz, #f3f3f7)";
var $17a6dd8285442c36$export$85476d474b1b04f9 = "var(--color-neutral-250-vs1is4, #ebebf0)";
var $17a6dd8285442c36$export$a2bc5a980bd0e62e = "var(--color-neutral-300-08wi6k, #dedee3)";
var $17a6dd8285442c36$export$c9b93767f0ce9614 = "var(--color-neutral-350-dq6kfr, #c6c6cd)";
var $17a6dd8285442c36$export$d9e6f1db3d0ac51a = "var(--color-neutral-400-wtst55, #b4b4bb)";
var $17a6dd8285442c36$export$286983bba63f8abd = "var(--color-neutral-450-kn0235, #a4a4ad)";
var $17a6dd8285442c36$export$53fe47c5c024ab9a = "var(--color-neutral-500-8van0b, #8c8c94)";
var $17a6dd8285442c36$export$d8a73b31b8c1d8a6 = "var(--color-neutral-550-z2a44u, #72747e)";
var $17a6dd8285442c36$export$ee6e4bb6b1f94854 = "var(--color-neutral-600-fln1ww, #656871)";
var $17a6dd8285442c36$export$455c81824e4c7118 = "var(--color-neutral-650-miik4f, #424650)";
var $17a6dd8285442c36$export$f4edfc1815099e40 = "var(--color-neutral-700-qw8ats, #333843)";
var $17a6dd8285442c36$export$49bd2dc93b337b02 = "var(--color-neutral-750-pi9qqd, #232b37)";
var $17a6dd8285442c36$export$db711c3033047c29 = "var(--color-neutral-800-t7j5ap, #1b232d)";
var $17a6dd8285442c36$export$cf8b47915bdf4ac9 = "var(--color-neutral-850-3f0gro, #161d26)";
var $17a6dd8285442c36$export$21ccfa1fe2cbd499 = "var(--color-neutral-900-v0mtoc, #131920)";
var $17a6dd8285442c36$export$f848e8d8b613f2a = "var(--color-neutral-950-lxybh8, #0f141a)";
var $17a6dd8285442c36$export$63fc38f544e28d8e = "var(--color-neutral-1000-7ovvlt, #06080a)";
var $17a6dd8285442c36$export$99d733fc9cd5549b = "var(--color-error-50-1upkvz, #fff5f5)";
var $17a6dd8285442c36$export$57e0b9c357c3fa86 = "var(--color-error-400-c0knb8, #ff7a7a)";
var $17a6dd8285442c36$export$c621d6da1c6e01fb = "var(--color-error-600-mdn3ng, #db0000)";
var $17a6dd8285442c36$export$7ca720b89737a85d = "var(--color-error-900-skonp1, #700000)";
var $17a6dd8285442c36$export$615be1ecffbe7fe4 = "var(--color-error-1000-ecmudm, #1f0000)";
var $17a6dd8285442c36$export$87c9d530338af661 = "var(--color-success-50-yow9uc, #effff1)";
var $17a6dd8285442c36$export$abbac6ec13526cb9 = "var(--color-success-500-hhxb4g, #2bb534)";
var $17a6dd8285442c36$export$83ec387e00f08e75 = "var(--color-success-600-g7hz2i, #00802f)";
var $17a6dd8285442c36$export$863ec5fea4e756d2 = "var(--color-success-1000-xy1gvq, #001401)";
var $17a6dd8285442c36$export$82e8b446dd656e30 = "var(--color-warning-50-uxheb8, #fffef0)";
var $17a6dd8285442c36$export$cbc093498c6c58c2 = "var(--color-warning-400-55puga, #ffe347)";
var $17a6dd8285442c36$export$270b30d6458c2479 = "var(--color-warning-500-zidhub, #fbd332)";
var $17a6dd8285442c36$export$2e40ac11cb8b50ac = "var(--color-warning-900-kpxt8c, #855900)";
var $17a6dd8285442c36$export$eca2ce4ac09028da = "var(--color-warning-1000-65l070, #191100)";
var $17a6dd8285442c36$export$8dfcb7b9f14ffdf6 = "var(--color-info-50-cdvtrs, #f0fbff)";
var $17a6dd8285442c36$export$bfe606cdd47311e9 = "var(--color-info-300-q9xd1l, #75cfff)";
var $17a6dd8285442c36$export$5982e32abb216781 = "var(--color-info-400-674xac, #42b4ff)";
var $17a6dd8285442c36$export$801e838da8b7f183 = "var(--color-info-600-un21zh, #006ce0)";
var $17a6dd8285442c36$export$9c3b97b67e01a262 = "var(--color-info-1000-s77ok9, #001129)";
var $17a6dd8285442c36$export$362e848e4d969b44 = "var(--color-grey-50-mhbfod, #fcfcfd)";
var $17a6dd8285442c36$export$ed24602dc14c91c5 = "var(--color-grey-100-2sczed, #f9f9fa)";
var $17a6dd8285442c36$export$2e7ba6fddd2b98ab = "var(--color-grey-150-znah9n, #f6f6f9)";
var $17a6dd8285442c36$export$4375f263d524d51f = "var(--color-grey-200-s986pt, #f3f3f7)";
var $17a6dd8285442c36$export$959cab8a36c2ad47 = "var(--color-grey-250-l5wm60, #ebebf0)";
var $17a6dd8285442c36$export$a9fc903c548ef330 = "var(--color-grey-300-tqmb21, #dedee3)";
var $17a6dd8285442c36$export$3fb402287eceb5b = "var(--color-grey-350-brqf9i, #c6c6cd)";
var $17a6dd8285442c36$export$328dff5851989f4b = "var(--color-grey-400-oueki4, #b4b4bb)";
var $17a6dd8285442c36$export$22ddb7428a7a5e5 = "var(--color-grey-450-6n5usg, #a4a4ad)";
var $17a6dd8285442c36$export$15859a9372987526 = "var(--color-grey-500-argwpz, #8c8c94)";
var $17a6dd8285442c36$export$4a237a9cbe6a88e4 = "var(--color-grey-600-qux9qr, #656871)";
var $17a6dd8285442c36$export$c00c2331279e6b21 = "var(--color-grey-650-5vpn76, #424650)";
var $17a6dd8285442c36$export$54cedc0291f613bd = "var(--color-grey-700-i9hww0, #333843)";
var $17a6dd8285442c36$export$99407f45e1bee0c5 = "var(--color-grey-750-3a32f4, #232b37)";
var $17a6dd8285442c36$export$c131d3600ffdc96b = "var(--color-grey-800-38aulk, #1b232d)";
var $17a6dd8285442c36$export$8fe70712f893923a = "var(--color-grey-850-fg4m0u, #161d26)";
var $17a6dd8285442c36$export$7487412d62dff607 = "var(--color-grey-900-2zzggd, #131920)";
var $17a6dd8285442c36$export$4039321750849e76 = "var(--color-grey-950-rpj9g8, #0f141a)";
var $17a6dd8285442c36$export$31ed7c7ebd002bcd = "var(--color-grey-1000-kdxctl, #06080a)";
var $17a6dd8285442c36$export$962750d845027c6b = "var(--color-blue-50-1qtweg, #f0fbff)";
var $17a6dd8285442c36$export$6493569267fe4240 = "var(--color-blue-100-a7atso, #d1f1ff)";
var $17a6dd8285442c36$export$837d9b91fe473c15 = "var(--color-blue-200-66lcr3, #b8e7ff)";
var $17a6dd8285442c36$export$edaccd67a5c07740 = "var(--color-blue-300-s2r2o0, #75cfff)";
var $17a6dd8285442c36$export$b565e8bde2360f78 = "var(--color-blue-400-h2lqfk, #42b4ff)";
var $17a6dd8285442c36$export$af452b73992c6c12 = "var(--color-blue-600-dkpfum, #006ce0)";
var $17a6dd8285442c36$export$3bd3abc1d9644182 = "var(--color-blue-700-lcgdon, #004a9e)";
var $17a6dd8285442c36$export$9fa395951dc7b30b = "var(--color-blue-900-k0czor, #002b66)";
var $17a6dd8285442c36$export$56846b6961531656 = "var(--color-blue-1000-fmz0jt, #001129)";
var $17a6dd8285442c36$export$93528e2189e925e2 = "var(--color-green-50-p1p8l4, #effff1)";
var $17a6dd8285442c36$export$8449751ffd2014ac = "var(--color-green-500-c2uzi6, #2bb534)";
var $17a6dd8285442c36$export$6d0c82261279840a = "var(--color-green-600-vdmico, #00802f)";
var $17a6dd8285442c36$export$83848bb208de5f2a = "var(--color-green-900-6aqp28, #00471e)";
var $17a6dd8285442c36$export$aed66cab268db126 = "var(--color-green-1000-tarlm7, #001401)";
var $17a6dd8285442c36$export$657d78faf8dd7363 = "var(--color-red-50-k823mj, #fff5f5)";
var $17a6dd8285442c36$export$3fc3701e6f03c401 = "var(--color-red-400-40ay29, #ff7a7a)";
var $17a6dd8285442c36$export$80230352264c6859 = "var(--color-red-600-lxm4n7, #db0000)";
var $17a6dd8285442c36$export$845ac4c3743159c7 = "var(--color-red-900-gj885t, #700000)";
var $17a6dd8285442c36$export$6236932d080d4f8a = "var(--color-red-1000-jtashw, #1f0000)";
var $17a6dd8285442c36$export$2778d70b88de5f30 = "var(--color-yellow-50-wk1vy0, #fffef0)";
var $17a6dd8285442c36$export$64a2238e022ece3b = "var(--color-yellow-400-q4m2pa, #ffe347)";
var $17a6dd8285442c36$export$9ff56f6ed56c13d4 = "var(--color-yellow-500-rj98kw, #fbd332)";
var $17a6dd8285442c36$export$62bb24a3ccba79fd = "var(--color-yellow-900-jipa9u, #855900)";
var $17a6dd8285442c36$export$138cbcb9d9b489a4 = "var(--color-yellow-1000-zo0nn2, #191100)";
var $17a6dd8285442c36$export$d235588518303c81 = "var(--color-purple-400-o7fr4k, #bf80ff)";
var $17a6dd8285442c36$export$b8d7aa8737f894d5 = "var(--color-purple-700-5hcbeu, #7300e5)";
var $17a6dd8285442c36$export$343df22b5019dd83 = "var(--color-amber-400-z6oddn, #ff9900)";
var $17a6dd8285442c36$export$569e29b7dd064197 = "var(--color-amber-500-rsho1x, #fa6f00)";
var $17a6dd8285442c36$export$235769fc99cea3e4 = "var(--color-aws-squid-ink-oxiega, #232f3e)";
var $17a6dd8285442c36$export$a719537fc32a0aa2 = "var(--color-transparent-i61gs1, transparent)";
var $17a6dd8285442c36$export$5a09d2027d7b4316 = "var(--color-black-cox1hy, #000000)";
var $17a6dd8285442c36$export$e440a56bff5718e8 = "var(--color-white-p1zlvy, #ffffff)";
var $17a6dd8285442c36$export$a9828e023a63e078 = "var(--color-charts-red-300-2k7eul, #ea7158)";
var $17a6dd8285442c36$export$3ddd14fcdaa95b53 = "var(--color-charts-red-400-ssrf2o, #dc5032)";
var $17a6dd8285442c36$export$1a306ed4b826934c = "var(--color-charts-red-500-m14kmu, #d13313)";
var $17a6dd8285442c36$export$79a6d94ebedfd01 = "var(--color-charts-red-600-938v3h, #ba2e0f)";
var $17a6dd8285442c36$export$d960014a824484b0 = "var(--color-charts-red-700-f6sq8t, #a82a0c)";
var $17a6dd8285442c36$export$631d21ddd5abb1d7 = "var(--color-charts-red-800-tzkaad, #972709)";
var $17a6dd8285442c36$export$c400b33753785114 = "var(--color-charts-red-900-fhg0lh, #892407)";
var $17a6dd8285442c36$export$fb765c63f729809b = "var(--color-charts-red-1000-9iigzo, #7d2105)";
var $17a6dd8285442c36$export$273d3369fc6a4ee5 = "var(--color-charts-red-1100-4n7b3z, #721e03)";
var $17a6dd8285442c36$export$1eeb7b834075fe15 = "var(--color-charts-red-1200-ek3cuo, #671c00)";
var $17a6dd8285442c36$export$f25129d912299510 = "var(--color-charts-orange-300-hqhtmn, #e07941)";
var $17a6dd8285442c36$export$24b4dc9333132fb4 = "var(--color-charts-orange-400-g8c1fc, #cc5f21)";
var $17a6dd8285442c36$export$1525cd8d2b9a3aec = "var(--color-charts-orange-500-j3c2cu, #bc4d01)";
var $17a6dd8285442c36$export$88d8ea3f3895d62c = "var(--color-charts-orange-600-1ad7o4, #a84401)";
var $17a6dd8285442c36$export$c566e45c689e6204 = "var(--color-charts-orange-700-spsf2r, #983c02)";
var $17a6dd8285442c36$export$3288ddf390914f31 = "var(--color-charts-orange-800-244d7b, #8a3603)";
var $17a6dd8285442c36$export$85ed935da9e7515 = "var(--color-charts-orange-900-8omk92, #7e3103)";
var $17a6dd8285442c36$export$a73a38b81ac70eaa = "var(--color-charts-orange-1000-ezq5pz, #732c02)";
var $17a6dd8285442c36$export$e23af496e2f87b8f = "var(--color-charts-orange-1100-bhcmg5, #692801)";
var $17a6dd8285442c36$export$8baf5ef2e631b1cf = "var(--color-charts-orange-1200-exs6jj, #602400)";
var $17a6dd8285442c36$export$64da22293492db29 = "var(--color-charts-yellow-300-fpz8o0, #b2911c)";
var $17a6dd8285442c36$export$9bb0488a094d1e = "var(--color-charts-yellow-400-vxiqrf, #9c7b0b)";
var $17a6dd8285442c36$export$de4dbac299bcf140 = "var(--color-charts-yellow-500-1qgrtj, #8a6b05)";
var $17a6dd8285442c36$export$9ef13172cddad464 = "var(--color-charts-yellow-600-aweqy2, #7b5f04)";
var $17a6dd8285442c36$export$1506a692c1076c86 = "var(--color-charts-yellow-700-xh0lj9, #6f5504)";
var $17a6dd8285442c36$export$1067e4388f339352 = "var(--color-charts-yellow-800-gp4422, #654d03)";
var $17a6dd8285442c36$export$fe738ab100d4646e = "var(--color-charts-yellow-900-r6gx3k, #5d4503)";
var $17a6dd8285442c36$export$cf2e7654cbb19eef = "var(--color-charts-yellow-1000-6dnac6, #553f03)";
var $17a6dd8285442c36$export$ba5a4bc5d4f36844 = "var(--color-charts-yellow-1100-fqp4sw, #4d3901)";
var $17a6dd8285442c36$export$190b6c7610b5600b = "var(--color-charts-yellow-1200-k7kf4w, #483300)";
var $17a6dd8285442c36$export$a46e743d6cf8dc40 = "var(--color-charts-green-300-6766ev, #67a353)";
var $17a6dd8285442c36$export$885b99bde512dad6 = "var(--color-charts-green-400-gd41ay, #41902c)";
var $17a6dd8285442c36$export$7fc39ea62df7ea0 = "var(--color-charts-green-500-yr18n3, #1f8104)";
var $17a6dd8285442c36$export$873500ed0bd4cc47 = "var(--color-charts-green-600-b1gmr0, #1a7302)";
var $17a6dd8285442c36$export$baac9fc999a67937 = "var(--color-charts-green-700-305sle, #176702)";
var $17a6dd8285442c36$export$51c1b24e63fe0d1a = "var(--color-charts-green-800-rh42zr, #145d02)";
var $17a6dd8285442c36$export$3acc6c7e05c5758c = "var(--color-charts-green-900-2x5smm, #125502)";
var $17a6dd8285442c36$export$5036b53c310b7202 = "var(--color-charts-green-1000-opphoq, #104d01)";
var $17a6dd8285442c36$export$421453d2cb20f600 = "var(--color-charts-green-1100-o67uzm, #0f4601)";
var $17a6dd8285442c36$export$dbe41ef0261311ef = "var(--color-charts-green-1200-sw46fc, #0d4000)";
var $17a6dd8285442c36$export$30c9b2e10b0c1bf9 = "var(--color-charts-teal-300-2qlyrg, #2ea597)";
var $17a6dd8285442c36$export$8058b6032adcb032 = "var(--color-charts-teal-400-s8pa77, #1c8e81)";
var $17a6dd8285442c36$export$32f62b57e6e0a934 = "var(--color-charts-teal-500-8d830b, #0d7d70)";
var $17a6dd8285442c36$export$78d8816af4cf79a4 = "var(--color-charts-teal-600-772n9t, #096f64)";
var $17a6dd8285442c36$export$36314ab851f5924f = "var(--color-charts-teal-700-29mnwm, #06645a)";
var $17a6dd8285442c36$export$d690b383d2895ed4 = "var(--color-charts-teal-800-vp41t6, #045b52)";
var $17a6dd8285442c36$export$74ea4a4121522142 = "var(--color-charts-teal-900-k020ya, #03524a)";
var $17a6dd8285442c36$export$17088dc74eaf0a1f = "var(--color-charts-teal-1000-fhpqt3, #014b44)";
var $17a6dd8285442c36$export$bed6713920bf05f2 = "var(--color-charts-teal-1100-6w598w, #01443e)";
var $17a6dd8285442c36$export$12f8fb954448f141 = "var(--color-charts-teal-1200-0u78my, #003e38)";
var $17a6dd8285442c36$export$fa79a04a9a906132 = "var(--color-charts-blue-1-300-pdza0q, #529ccb)";
var $17a6dd8285442c36$export$48c509c34f957d0d = "var(--color-charts-blue-1-400-ajl038, #3184c2)";
var $17a6dd8285442c36$export$7c96a8085bc16a8f = "var(--color-charts-blue-1-500-9s8gor, #0273bb)";
var $17a6dd8285442c36$export$56c10107965bf615 = "var(--color-charts-blue-1-600-7ymb7g, #0166ab)";
var $17a6dd8285442c36$export$33d56a52826fc658 = "var(--color-charts-blue-1-700-5qzras, #015b9d)";
var $17a6dd8285442c36$export$371cb8863fa18e6a = "var(--color-charts-blue-1-800-awczh4, #015292)";
var $17a6dd8285442c36$export$6eee3d6351916f94 = "var(--color-charts-blue-1-900-6wxwzk, #014a87)";
var $17a6dd8285442c36$export$a60489d676ad76d8 = "var(--color-charts-blue-1-1000-00005b, #01437d)";
var $17a6dd8285442c36$export$deb9678842096613 = "var(--color-charts-blue-1-1100-8nwfwf, #003c75)";
var $17a6dd8285442c36$export$7f85fdbf5bd9af7 = "var(--color-charts-blue-1-1200-v60p8b, #00366d)";
var $17a6dd8285442c36$export$f48eb8499824d5a = "var(--color-charts-blue-2-300-g72slq, #688ae8)";
var $17a6dd8285442c36$export$e2be5cd8c0068595 = "var(--color-charts-blue-2-400-he538m, #5978e3)";
var $17a6dd8285442c36$export$a8c4d6f1fe5a2686 = "var(--color-charts-blue-2-500-quctxu, #4066df)";
var $17a6dd8285442c36$export$48f86d39aae0f8a1 = "var(--color-charts-blue-2-600-6qav3j, #3759ce)";
var $17a6dd8285442c36$export$71338f5286602841 = "var(--color-charts-blue-2-700-sp7t4m, #314fbf)";
var $17a6dd8285442c36$export$3163e1f30c8ec91c = "var(--color-charts-blue-2-800-q01umt, #2c46b1)";
var $17a6dd8285442c36$export$198212de992173ed = "var(--color-charts-blue-2-900-gog7z2, #273ea5)";
var $17a6dd8285442c36$export$5242cd4d7ebdc0ca = "var(--color-charts-blue-2-1000-c13nf8, #23379b)";
var $17a6dd8285442c36$export$a0a3f0d95c78cb24 = "var(--color-charts-blue-2-1100-ddk6eo, #1f3191)";
var $17a6dd8285442c36$export$fab6ea3a2ef9b143 = "var(--color-charts-blue-2-1200-gt550t, #1b2b88)";
var $17a6dd8285442c36$export$c0e6120be009810e = "var(--color-charts-purple-300-85q036, #a783e1)";
var $17a6dd8285442c36$export$2f2588c4abedb3ce = "var(--color-charts-purple-400-9axh6r, #9469d6)";
var $17a6dd8285442c36$export$63648664c68ba17f = "var(--color-charts-purple-500-rn2jbl, #8456ce)";
var $17a6dd8285442c36$export$6b451975572ae71b = "var(--color-charts-purple-600-26s4rg, #7749bf)";
var $17a6dd8285442c36$export$883cb1d43efde767 = "var(--color-charts-purple-700-tv8cvg, #6b40b2)";
var $17a6dd8285442c36$export$2415a2a0d767fc27 = "var(--color-charts-purple-800-h61qlx, #6237a7)";
var $17a6dd8285442c36$export$4f35d0b4f4b582b = "var(--color-charts-purple-900-am452b, #59309d)";
var $17a6dd8285442c36$export$4fcf8a1b8d9efba6 = "var(--color-charts-purple-1000-uarqpb, #512994)";
var $17a6dd8285442c36$export$b60e0d30572d54bb = "var(--color-charts-purple-1100-y8ctnd, #4a238b)";
var $17a6dd8285442c36$export$645aaa5557dc849d = "var(--color-charts-purple-1200-hr9f40, #431d84)";
var $17a6dd8285442c36$export$3c36e75e4dd6dd52 = "var(--color-charts-pink-300-ewnht7, #da7596)";
var $17a6dd8285442c36$export$e0fab26f937fb578 = "var(--color-charts-pink-400-smjdat, #ce567c)";
var $17a6dd8285442c36$export$2653997ab7b13509 = "var(--color-charts-pink-500-bw864b, #c33d69)";
var $17a6dd8285442c36$export$cc83a77bc22ca0ea = "var(--color-charts-pink-600-2ro14y, #b1325c)";
var $17a6dd8285442c36$export$1ccd30d400c559 = "var(--color-charts-pink-700-ryxvua, #a32952)";
var $17a6dd8285442c36$export$ec4ed67240ac961 = "var(--color-charts-pink-800-tcusf8, #962249)";
var $17a6dd8285442c36$export$d708622ae799c02f = "var(--color-charts-pink-900-kpyne4, #8b1b42)";
var $17a6dd8285442c36$export$d3cf77ffa2701f78 = "var(--color-charts-pink-1000-1soluc, #81143b)";
var $17a6dd8285442c36$export$181adccaa4683619 = "var(--color-charts-pink-1100-ff6g93, #780d35)";
var $17a6dd8285442c36$export$44143009802fb029 = "var(--color-charts-pink-1200-w9585d, #6f062f)";
var $17a6dd8285442c36$export$bfcc9a367dce467c = "var(--color-charts-status-critical-c6brdu, #7d2105)";
var $17a6dd8285442c36$export$63afa5b22146e506 = "var(--color-charts-status-high-18fhg5, #ba2e0f)";
var $17a6dd8285442c36$export$45986c6080dcdc0 = "var(--color-charts-status-medium-3trmy3, #cc5f21)";
var $17a6dd8285442c36$export$1d67a95b254591df = "var(--color-charts-status-low-br6wv0, #b2911c)";
var $17a6dd8285442c36$export$7d29b8df987fbf1a = "var(--color-charts-status-positive-md7eqa, #67a353)";
var $17a6dd8285442c36$export$479c6aff2f5a8046 = "var(--color-charts-status-info-yds4x2, #3184c2)";
var $17a6dd8285442c36$export$d3ba4fc130aa8209 = "var(--color-charts-status-neutral-k2p33t, #8c8c94)";
var $17a6dd8285442c36$export$847e6d8938982101 = "var(--color-charts-threshold-negative-aad26m, #db0000)";
var $17a6dd8285442c36$export$88ffb411b14150aa = "var(--color-charts-threshold-positive-mk2804, #00802f)";
var $17a6dd8285442c36$export$d376339af37b4fc8 = "var(--color-charts-threshold-info-ijuzzj, #006ce0)";
var $17a6dd8285442c36$export$8b8189d069458cd7 = "var(--color-charts-threshold-neutral-pd7kh4, #656871)";
var $17a6dd8285442c36$export$1e98244f4770dbab = "var(--color-charts-line-grid-kjxf3m, #dedee3)";
var $17a6dd8285442c36$export$fbb1afcfcdd7999f = "var(--color-charts-line-tick-xmcbvk, #dedee3)";
var $17a6dd8285442c36$export$cceeb5c018206c7 = "var(--color-charts-line-axis-b95ncf, #dedee3)";
var $17a6dd8285442c36$export$387e810215b93949 = "var(--color-charts-palette-categorical-1-xu0deg, #688ae8)";
var $17a6dd8285442c36$export$6b36f8ebdaeda401 = "var(--color-charts-palette-categorical-2-ktit09, #c33d69)";
var $17a6dd8285442c36$export$aa40dc30e0465617 = "var(--color-charts-palette-categorical-3-g0srj0, #2ea597)";
var $17a6dd8285442c36$export$985cbe030db91279 = "var(--color-charts-palette-categorical-4-5vauwp, #8456ce)";
var $17a6dd8285442c36$export$1cfcf138c0b430ef = "var(--color-charts-palette-categorical-5-3v8ery, #e07941)";
var $17a6dd8285442c36$export$f7cd0f2448817d94 = "var(--color-charts-palette-categorical-6-ztdd8d, #3759ce)";
var $17a6dd8285442c36$export$f00671b06e030449 = "var(--color-charts-palette-categorical-7-3j5o6w, #962249)";
var $17a6dd8285442c36$export$39d802f927087260 = "var(--color-charts-palette-categorical-8-c5r39m, #096f64)";
var $17a6dd8285442c36$export$f6f2c1390544458a = "var(--color-charts-palette-categorical-9-8n6iuv, #6237a7)";
var $17a6dd8285442c36$export$e1d059d390446292 = "var(--color-charts-palette-categorical-10-opta0w, #a84401)";
var $17a6dd8285442c36$export$cd54ac9f9496eab8 = "var(--color-charts-palette-categorical-11-b2r7jc, #273ea5)";
var $17a6dd8285442c36$export$283ff2a8517cf212 = "var(--color-charts-palette-categorical-12-b5drtm, #780d35)";
var $17a6dd8285442c36$export$f9d2aa43ebf6ccbf = "var(--color-charts-palette-categorical-13-c69xg9, #03524a)";
var $17a6dd8285442c36$export$63d2a3dc1009d04d = "var(--color-charts-palette-categorical-14-db19x8, #4a238b)";
var $17a6dd8285442c36$export$f36e7e14362eb76b = "var(--color-charts-palette-categorical-15-8z8vjw, #7e3103)";
var $17a6dd8285442c36$export$8fcf4bdb057ad1ef = "var(--color-charts-palette-categorical-16-549jkl, #1b2b88)";
var $17a6dd8285442c36$export$941a557cef6aef8 = "var(--color-charts-palette-categorical-17-nrio7t, #ce567c)";
var $17a6dd8285442c36$export$29753c2eb4750135 = "var(--color-charts-palette-categorical-18-tm902v, #003e38)";
var $17a6dd8285442c36$export$9477505cf3b71a85 = "var(--color-charts-palette-categorical-19-ujcr86, #9469d6)";
var $17a6dd8285442c36$export$b9cc240a469d1703 = "var(--color-charts-palette-categorical-20-h55e4g, #602400)";
var $17a6dd8285442c36$export$50648c0e1fe04995 = "var(--color-charts-palette-categorical-21-vs0u8l, #4066df)";
var $17a6dd8285442c36$export$ed03176497684e82 = "var(--color-charts-palette-categorical-22-6klt3l, #a32952)";
var $17a6dd8285442c36$export$98e3384f0b29784e = "var(--color-charts-palette-categorical-23-3zpkdt, #0d7d70)";
var $17a6dd8285442c36$export$894969d8a39baa17 = "var(--color-charts-palette-categorical-24-z9a4uk, #6b40b2)";
var $17a6dd8285442c36$export$4732b6b1b9140474 = "var(--color-charts-palette-categorical-25-tgdsk2, #bc4d01)";
var $17a6dd8285442c36$export$9059896a901b59e2 = "var(--color-charts-palette-categorical-26-lo8zn9, #2c46b1)";
var $17a6dd8285442c36$export$eeecb22a0367ff8c = "var(--color-charts-palette-categorical-27-bruhsa, #81143b)";
var $17a6dd8285442c36$export$c92f5bb324988073 = "var(--color-charts-palette-categorical-28-6b00fb, #045b52)";
var $17a6dd8285442c36$export$dd63dbbdfd71c80 = "var(--color-charts-palette-categorical-29-aurmid, #512994)";
var $17a6dd8285442c36$export$a532446888646b04 = "var(--color-charts-palette-categorical-30-fjnmd7, #8a3603)";
var $17a6dd8285442c36$export$643a76d5577063d5 = "var(--color-charts-palette-categorical-31-7zcct5, #1f3191)";
var $17a6dd8285442c36$export$7ca4d0fd1c5b00c2 = "var(--color-charts-palette-categorical-32-rrda6y, #da7596)";
var $17a6dd8285442c36$export$5d841c22b33103a7 = "var(--color-charts-palette-categorical-33-2v0mzv, #01443e)";
var $17a6dd8285442c36$export$a1da779d6b047036 = "var(--color-charts-palette-categorical-34-g9a9q3, #a783e1)";
var $17a6dd8285442c36$export$747cbb87e687e631 = "var(--color-charts-palette-categorical-35-u0w821, #692801)";
var $17a6dd8285442c36$export$e72d5d73aa047a48 = "var(--color-charts-palette-categorical-36-tthuf8, #5978e3)";
var $17a6dd8285442c36$export$8a5e1bcf65ef875b = "var(--color-charts-palette-categorical-37-y588bl, #b1325c)";
var $17a6dd8285442c36$export$a976a97095cdd9ad = "var(--color-charts-palette-categorical-38-qdh97u, #1c8e81)";
var $17a6dd8285442c36$export$65fff8610bdb3e4e = "var(--color-charts-palette-categorical-39-yisq6l, #7749bf)";
var $17a6dd8285442c36$export$34c5e846b011c6d = "var(--color-charts-palette-categorical-40-yeer1v, #cc5f21)";
var $17a6dd8285442c36$export$6f00bd99fa761c32 = "var(--color-charts-palette-categorical-41-tu9dxw, #314fbf)";
var $17a6dd8285442c36$export$2d603d581b5acb78 = "var(--color-charts-palette-categorical-42-q410kp, #8b1b42)";
var $17a6dd8285442c36$export$30e404c1b8690bed = "var(--color-charts-palette-categorical-43-dwew7q, #06645a)";
var $17a6dd8285442c36$export$5b808d0a2f45a41f = "var(--color-charts-palette-categorical-44-2thp96, #59309d)";
var $17a6dd8285442c36$export$604289a782503a0a = "var(--color-charts-palette-categorical-45-6kinj6, #983c02)";
var $17a6dd8285442c36$export$ad68fdf838355a7c = "var(--color-charts-palette-categorical-46-iefxfq, #23379b)";
var $17a6dd8285442c36$export$dc3a491108121404 = "var(--color-charts-palette-categorical-47-9l9wl2, #6f062f)";
var $17a6dd8285442c36$export$a692b0645cf6a893 = "var(--color-charts-palette-categorical-48-5s2n0r, #014b44)";
var $17a6dd8285442c36$export$3d613fc4079e0097 = "var(--color-charts-palette-categorical-49-bub0l1, #431d84)";
var $17a6dd8285442c36$export$522d2a779702d9b9 = "var(--color-charts-palette-categorical-50-utrpu5, #732c02)";
var $17a6dd8285442c36$export$f2aae732f9988776 = "var(--color-charts-error-bar-marker-r10jgv, #131920)";
var $17a6dd8285442c36$export$e236fe1ad3947586 = "var(--color-severity-dark-red-j8bmoc, #870303)";
var $17a6dd8285442c36$export$3fe6f39f50c13a0f = "var(--color-severity-red-wf5w2d, #ce3311)";
var $17a6dd8285442c36$export$31bb3fbd0d1277ad = "var(--color-severity-orange-rpbcus, #f89256)";
var $17a6dd8285442c36$export$140f9507c51c267 = "var(--color-severity-yellow-4er6zq, #f2cd54)";
var $17a6dd8285442c36$export$fa5b14c3dd833741 = "var(--color-severity-grey-sp7qo8, #656871)";
var $17a6dd8285442c36$export$19fd215efb5c50e7 = "var(--color-background-notification-severity-critical-0xl8pp, #870303)";
var $17a6dd8285442c36$export$e362c608cc753cd6 = "var(--color-background-notification-severity-high-8nbgdi, #ce3311)";
var $17a6dd8285442c36$export$91d39224777a3aa7 = "var(--color-background-notification-severity-medium-lbljs2, #f89256)";
var $17a6dd8285442c36$export$7f5326cff522c1b6 = "var(--color-background-notification-severity-low-giz8b6, #f2cd54)";
var $17a6dd8285442c36$export$c0fd705f6baea1ec = "var(--color-background-notification-severity-neutral-hnhgmv, #656871)";
var $17a6dd8285442c36$export$3f5d956a375e5880 = "var(--color-text-notification-severity-critical-tv4vw4, #f9f9fa)";
var $17a6dd8285442c36$export$7326e174b9a098c8 = "var(--color-text-notification-severity-high-t4suvu, #f9f9fa)";
var $17a6dd8285442c36$export$ee9ff63134d19909 = "var(--color-text-notification-severity-medium-8f60kb, #0f141a)";
var $17a6dd8285442c36$export$75a9279516f2aa8f = "var(--color-text-notification-severity-low-gvojhi, #0f141a)";
var $17a6dd8285442c36$export$9f868ff303f06d3d = "var(--color-text-notification-severity-neutral-ynm2wl, #f9f9fa)";
var $17a6dd8285442c36$export$2c56ea4af118527e = "var(--color-grey-opaque-10-vwfmts, rgba(0, 0, 0, 0.1))";
var $17a6dd8285442c36$export$11a94f9ea82ee978 = "var(--color-grey-opaque-25-cjy3al, rgba(255, 255, 255, 0.25))";
var $17a6dd8285442c36$export$7680f79f88ee05cd = "var(--color-grey-opaque-40-yj2cvz, rgba(0, 0, 0, 0.4))";
var $17a6dd8285442c36$export$2d5ad0d73aaa1f9 = "var(--color-grey-opaque-50-dlm5ly, rgba(0, 0, 0, 0.5))";
var $17a6dd8285442c36$export$5ff2af5f32b6f5d1 = "var(--color-grey-opaque-70-p0svy7, rgba(35, 43, 55, 0.7))";
var $17a6dd8285442c36$export$eaa8720fef73a91d = "var(--color-grey-opaque-80-1wrh9m, rgba(22, 25, 31, 0.8))";
var $17a6dd8285442c36$export$611e40961361c982 = "var(--color-grey-opaque-90-te8til, rgba(242, 243, 243, 0.9))";
var $17a6dd8285442c36$export$5d90c30a91722174 = "var(--color-grey-transparent-g4kcvh, rgba(15, 20, 26, 0.12))";
var $17a6dd8285442c36$export$6dc26d060817f5fc = "var(--color-grey-transparent-heavy-bu3q4i, rgba(15, 20, 26, 0.12))";
var $17a6dd8285442c36$export$729e6073df6a8851 = "var(--color-grey-transparent-light-mwvx49, rgba(15, 20, 26, 0.12))";
var $17a6dd8285442c36$export$560b534b5441d146 = "var(--color-background-badge-icon-jyxnxa, #db0000)";
var $17a6dd8285442c36$export$a3e968957b9b7d91 = "var(--color-background-button-link-active-5oi2dp, #d1f1ff)";
var $17a6dd8285442c36$export$1aec95d5b8e6cf26 = "var(--color-background-button-link-hover-lhrs2u, #f0fbff)";
var $17a6dd8285442c36$export$851ddd51fe884fa0 = "var(--color-background-button-normal-active-5imwxd, #d1f1ff)";
var $17a6dd8285442c36$export$7d3b14c589268c67 = "var(--color-background-button-normal-default-7f99mv, #ffffff)";
var $17a6dd8285442c36$export$6fceb2c87c97025d = "var(--color-background-button-normal-disabled-hl039l, #ffffff)";
var $17a6dd8285442c36$export$f5b8c697e46541c3 = "var(--color-background-button-normal-hover-53op9s, #f0fbff)";
var $17a6dd8285442c36$export$ea9c221f1e9e780d = "var(--color-background-toggle-button-normal-pressed-4khex7, #d1f1ff)";
var $17a6dd8285442c36$export$be40f60c52121476 = "var(--color-background-button-primary-active-5cqoqt, #002b66)";
var $17a6dd8285442c36$export$cfb4680cc8fc3bd2 = "var(--color-background-button-primary-default-vdt0fu, #006ce0)";
var $17a6dd8285442c36$export$6989cb41d9003aa4 = "var(--color-background-button-primary-disabled-sgo4zo, #ebebf0)";
var $17a6dd8285442c36$export$5c450568da4333da = "var(--color-background-button-primary-hover-mo85i6, #002b66)";
var $17a6dd8285442c36$export$3be83ac8b450d84d = "var(--color-background-direction-button-active-lvo0dy, #232b37)";
var $17a6dd8285442c36$export$220f2f1581dcc014 = "var(--color-background-direction-button-default-bvhbsn, #424650)";
var $17a6dd8285442c36$export$bd07734cec5a17fa = "var(--color-background-direction-button-disabled-s9x4zq, #ebebf0)";
var $17a6dd8285442c36$export$66880d346b63f2e0 = "var(--color-background-direction-button-hover-74n5o1, #333843)";
var $17a6dd8285442c36$export$34ad64213e983fdd = "var(--color-text-direction-button-default-p88lvb, #ffffff)";
var $17a6dd8285442c36$export$d8009316d7d6fc7b = "var(--color-text-direction-button-disabled-2jds36, #b4b4bb)";
var $17a6dd8285442c36$export$8380385764d8dd5c = "var(--color-background-calendar-current-date-sk0f6i, #f3f3f7)";
var $17a6dd8285442c36$export$238e24eb9c4c802 = "var(--color-background-cell-shaded-v7o6so, #f6f6f9)";
var $17a6dd8285442c36$export$b0250cb39ec1b995 = "var(--color-background-code-editor-gutter-active-line-default-51v1pv, #656871)";
var $17a6dd8285442c36$export$f292145a4ddf89f3 = "var(--color-background-code-editor-gutter-active-line-error-ro2qo1, #db0000)";
var $17a6dd8285442c36$export$be559e903087d458 = "var(--color-background-code-editor-gutter-default-15qdwh, #f3f3f7)";
var $17a6dd8285442c36$export$e42fc948412cf2b9 = "var(--color-background-code-editor-loading-6nwpin, #f9f9fa)";
var $17a6dd8285442c36$export$c05caaa8fe8b8712 = "var(--color-background-code-editor-pane-item-hover-z6k9mr, #ebebf0)";
var $17a6dd8285442c36$export$c356bef1ab71912f = "var(--color-background-code-editor-status-bar-yjtxod, #f3f3f7)";
var $17a6dd8285442c36$export$296d47a2f46b1742 = "var(--color-background-container-content-6u8rvp, #ffffff)";
var $17a6dd8285442c36$export$7c771e775c7524b4 = "var(--color-background-container-header-gs3mbe, #ffffff)";
var $17a6dd8285442c36$export$99a13a6ce59539ae = "var(--color-background-control-checked-ka7kc2, #006ce0)";
var $17a6dd8285442c36$export$d80a4e111a0f80e5 = "var(--color-background-control-default-4jb21l, #ffffff)";
var $17a6dd8285442c36$export$b62f5d074e74b81b = "var(--color-background-control-disabled-1f3718, #dedee3)";
var $17a6dd8285442c36$export$3dca3358588fc615 = "var(--color-background-dropdown-item-default-qmc033, #ffffff)";
var $17a6dd8285442c36$export$f1f135154edccf74 = "var(--color-background-dropdown-item-dimmed-dhho03, transparent)";
var $17a6dd8285442c36$export$d917fb8174a4da69 = "var(--color-background-dropdown-item-filter-match-49b5vt, #f0fbff)";
var $17a6dd8285442c36$export$1a8607b2d00c3400 = "var(--color-background-dropdown-item-hover-yunepc, #f3f3f7)";
var $17a6dd8285442c36$export$cc370251354814af = "var(--color-background-dropdown-item-selected-f3v6te, #f0fbff)";
var $17a6dd8285442c36$export$fd449b4efba1c256 = "var(--color-background-home-header-4c9jt4, #0f141a)";
var $17a6dd8285442c36$export$786e62fc120fae85 = "var(--color-background-inline-code-un8udy, rgba(0, 0, 0, 0.1))";
var $17a6dd8285442c36$export$5dbf2b85241be89c = "var(--color-background-input-default-ifz5bb, #ffffff)";
var $17a6dd8285442c36$export$77d0dd56aff4474b = "var(--color-background-input-disabled-dihaja, #ebebf0)";
var $17a6dd8285442c36$export$c09220b4798cd0fb = "var(--color-background-item-selected-9gppru, #f0fbff)";
var $17a6dd8285442c36$export$ecf310dc9384002a = "var(--color-background-layout-main-5ilwcb, #ffffff)";
var $17a6dd8285442c36$export$17fa709cee464516 = "var(--color-background-layout-mobile-panel-ed0ava, #0f141a)";
var $17a6dd8285442c36$export$bf959fe6f411f963 = "var(--color-background-layout-panel-content-xto15e, #ffffff)";
var $17a6dd8285442c36$export$8f53ce0ce04b7367 = "var(--color-background-layout-panel-hover-tguulw, #ebebf0)";
var $17a6dd8285442c36$export$4c32a80d3bd2febf = "var(--color-background-layout-toggle-active-ap91vm, #424650)";
var $17a6dd8285442c36$export$9cfe95af5ad0a88c = "var(--color-background-layout-toggle-default-2hgjdu, #424650)";
var $17a6dd8285442c36$export$e5eb190094d5ac48 = "var(--color-background-layout-toggle-hover-0cpm7g, #656871)";
var $17a6dd8285442c36$export$b85f55144ddbaf31 = "var(--color-background-layout-toggle-selected-active-zcl8w3, #006ce0)";
var $17a6dd8285442c36$export$6437ca8e29afbb60 = "var(--color-background-layout-toggle-selected-default-izfana, #006ce0)";
var $17a6dd8285442c36$export$3438cce4b8f16349 = "var(--color-background-layout-toggle-selected-hover-7953u1, #004a9e)";
var $17a6dd8285442c36$export$cb44c8b96306859a = "var(--color-background-modal-overlay-d7uby0, rgba(35, 43, 55, 0.7))";
var $17a6dd8285442c36$export$8ed753c2fc92a99f = "var(--color-background-notification-blue-4vnob8, #006ce0)";
var $17a6dd8285442c36$export$f5d9948982cf2dbd = "var(--color-background-notification-green-2rkyvu, #00802f)";
var $17a6dd8285442c36$export$c2e092073bc1d66 = "var(--color-background-notification-grey-x3vul6, #424650)";
var $17a6dd8285442c36$export$c134581152c00795 = "var(--color-background-notification-red-0487ea, #db0000)";
var $17a6dd8285442c36$export$389fd72e07e2625d = "var(--color-background-notification-yellow-y6us5r, #ffe347)";
var $17a6dd8285442c36$export$f3f567e353056c5d = "var(--color-background-notification-stack-bar-qe5n4w, #232b37)";
var $17a6dd8285442c36$export$929131bbb43fa587 = "var(--color-background-notification-stack-bar-active-a4h9r8, #232b37)";
var $17a6dd8285442c36$export$a3b7cb72e45aaba5 = "var(--color-background-notification-stack-bar-hover-jh82oo, #424650)";
var $17a6dd8285442c36$export$58604a7291b2ee8a = "var(--color-background-popover-e20fy8, #ffffff)";
var $17a6dd8285442c36$export$a8d1b0e9265a39a9 = "var(--color-background-progress-bar-value-default-69ydqg, #006ce0)";
var $17a6dd8285442c36$export$5ea2b80f2a5019e7 = "var(--color-background-progress-bar-default-j8kyxd, #ebebf0)";
var $17a6dd8285442c36$export$1e4b82141f2b1495 = "var(--color-background-segment-active-1u2ldl, #006ce0)";
var $17a6dd8285442c36$export$22d451f21f527ebb = "var(--color-background-segment-default-b0r494, #ffffff)";
var $17a6dd8285442c36$export$10f7455e64466bb = "var(--color-background-segment-disabled-m2a5t7, #ffffff)";
var $17a6dd8285442c36$export$1791628190961638 = "var(--color-background-segment-hover-800sl4, #f0fbff)";
var $17a6dd8285442c36$export$e39d729b60ed7faa = "var(--color-background-segment-wrapper-5tudmm, #ffffff)";
var $17a6dd8285442c36$export$664a1158e5d76b8c = "var(--color-background-slider-range-default-3ljdu4, #006ce0)";
var $17a6dd8285442c36$export$4996c24557e5cc7d = "var(--color-background-slider-range-active-vu3lky, #004a9e)";
var $17a6dd8285442c36$export$9796a91ad8016e6a = "var(--color-background-slider-handle-default-lp5ntg, #006ce0)";
var $17a6dd8285442c36$export$870b95565f97fc9b = "var(--color-background-slider-handle-active-50ubqb, #004a9e)";
var $17a6dd8285442c36$export$ae3c6b4f3e942aeb = "var(--color-background-slider-track-default-vk2c9o, #8c8c94)";
var $17a6dd8285442c36$export$9e44ac155cb1221c = "var(--color-background-slider-handle-ring-9sfenj, #ffffff)";
var $17a6dd8285442c36$export$d8f1eae3bc9a2288 = "var(--color-background-slider-handle-error-default-411tqq, #db0000)";
var $17a6dd8285442c36$export$59a4eb755e5d18c2 = "var(--color-background-slider-handle-error-active-x65pfh, #db0000)";
var $17a6dd8285442c36$export$38a733b29a1832a8 = "var(--color-background-slider-handle-warning-default-or76ej, #855900)";
var $17a6dd8285442c36$export$c1213b070602446e = "var(--color-background-slider-handle-warning-active-7o84zp, #855900)";
var $17a6dd8285442c36$export$18713b2b25c34c72 = "var(--color-background-slider-range-error-default-b519qn, #db0000)";
var $17a6dd8285442c36$export$900362a6d5e4344b = "var(--color-background-slider-range-error-active-6bo8an, #db0000)";
var $17a6dd8285442c36$export$4564d328eb855c7c = "var(--color-background-slider-range-warning-default-6isqvo, #855900)";
var $17a6dd8285442c36$export$b1476f59fe934dea = "var(--color-background-slider-range-warning-active-dm2pha, #855900)";
var $17a6dd8285442c36$export$96da102a897ab4bf = "var(--color-background-status-error-mu3lcw, #fff5f5)";
var $17a6dd8285442c36$export$f932e11b6b47e95e = "var(--color-background-status-info-sfobba, #f0fbff)";
var $17a6dd8285442c36$export$4e9e7dac13e5d995 = "var(--color-background-dialog-2fj3uu, #f0fbff)";
var $17a6dd8285442c36$export$19a27966008aaa29 = "var(--color-background-status-success-h6b8bh, #effff1)";
var $17a6dd8285442c36$export$3e42e679dbf98aa4 = "var(--color-background-status-warning-cv83up, #fffef0)";
var $17a6dd8285442c36$export$418d588cd1fd4f9 = "var(--color-background-table-header-hdjxos, #ffffff)";
var $17a6dd8285442c36$export$c18e6c272dd9dc7a = "var(--color-background-tiles-disabled-4ynms7, #ebebf0)";
var $17a6dd8285442c36$export$381775e80eb95c8c = "var(--color-background-toggle-checked-disabled-amxc0a, #b8e7ff)";
var $17a6dd8285442c36$export$7f6c6e0e80fbab8c = "var(--color-background-toggle-default-kjlhv0, #424650)";
var $17a6dd8285442c36$export$6814c0e0de242e7d = "var(--color-background-avatar-gen-ai-oxp2v6, radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%))";
var $17a6dd8285442c36$export$b3bb607884158857 = "var(--color-background-avatar-default-t427xm, #424650)";
var $17a6dd8285442c36$export$ed831b962e883834 = "var(--color-text-avatar-kuhkoa, #ffffff)";
var $17a6dd8285442c36$export$f04a8d03d93ee845 = "var(--color-background-loading-bar-gen-ai-tey70i, linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%))";
var $17a6dd8285442c36$export$14c565eaa0494b0f = "var(--color-background-chat-bubble-outgoing-ay6nj3, transparent)";
var $17a6dd8285442c36$export$3af47f7a1a727ecc = "var(--color-background-chat-bubble-incoming-j38cew, #f6f6f9)";
var $17a6dd8285442c36$export$a86cfe4fc3a5af82 = "var(--color-text-chat-bubble-outgoing-f3r63s, #0f141a)";
var $17a6dd8285442c36$export$405e200b77b46a5d = "var(--color-text-chat-bubble-incoming-od0yh8, #0f141a)";
var $17a6dd8285442c36$export$e3e7feb75e4133c1 = "var(--color-border-button-normal-active-ru7yhb, #002b66)";
var $17a6dd8285442c36$export$fb6983d30261bfaa = "var(--color-border-button-normal-default-glqfp1, #006ce0)";
var $17a6dd8285442c36$export$5bd1e48cb28c0a59 = "var(--color-border-toggle-button-normal-pressed-tq8o41, #006ce0)";
var $17a6dd8285442c36$export$4a460fb6c3800af9 = "var(--color-border-button-normal-disabled-pkhetz, #b4b4bb)";
var $17a6dd8285442c36$export$85f61c65019db4a0 = "var(--color-text-button-normal-disabled-05p74s, #8c8c94)";
var $17a6dd8285442c36$export$21bbd00e71e50aab = "var(--color-border-button-normal-hover-6a2tdq, #002b66)";
var $17a6dd8285442c36$export$a5ffe75f8a6ac64f = "var(--color-text-button-icon-disabled-nnofkn, #8c8c94)";
var $17a6dd8285442c36$export$82b3aa5f391b7647 = "var(--color-border-button-primary-disabled-b5p1ji, #ebebf0)";
var $17a6dd8285442c36$export$8b56c15e5a260ee7 = "var(--color-text-button-primary-disabled-q79gms, #8c8c94)";
var $17a6dd8285442c36$export$87fd8ff23e6e91a0 = "var(--color-item-selected-72rnwy, #006ce0)";
var $17a6dd8285442c36$export$85d894dd0ecb1e5a = "var(--color-border-calendar-grid-67r4w4, transparent)";
var $17a6dd8285442c36$export$7834474c559e3cfb = "var(--color-border-calendar-grid-selected-focus-ring-jk1fb0, #f9f9fa)";
var $17a6dd8285442c36$export$27b51584af0d27bc = "var(--color-border-cell-shaded-0ipazf, #dedee3)";
var $17a6dd8285442c36$export$4aab3eadca401d6 = "var(--color-border-code-editor-ace-active-line-light-theme-q6hsvt, #dedee3)";
var $17a6dd8285442c36$export$8142da277bc2ea05 = "var(--color-border-code-editor-ace-active-line-dark-theme-v09eti, #656871)";
var $17a6dd8285442c36$export$51ebf8e6c56e574c = "var(--color-border-code-editor-default-2bfcfq, #dedee3)";
var $17a6dd8285442c36$export$cf9140936855564d = "var(--color-border-code-editor-pane-item-hover-wvblek, #8c8c94)";
var $17a6dd8285442c36$export$9aad68da3fc64587 = "var(--color-border-container-divider-9huz1a, transparent)";
var $17a6dd8285442c36$export$fa1e43b885bf45ea = "var(--color-border-container-top-k3vmoz, transparent)";
var $17a6dd8285442c36$export$d093672d17c0de96 = "var(--color-border-control-checked-bdv28l, #006ce0)";
var $17a6dd8285442c36$export$e8c5d615f15f5e76 = "var(--color-border-control-default-sh3548, #8c8c94)";
var $17a6dd8285442c36$export$9cfb54df372559c7 = "var(--color-border-control-disabled-uj7t08, #dedee3)";
var $17a6dd8285442c36$export$e44173cef7897bf = "var(--color-border-divider-active-biq3j4, #0f141a)";
var $17a6dd8285442c36$export$13f70a45b59d5f8b = "var(--color-border-divider-default-nr68jt, #c6c6cd)";
var $17a6dd8285442c36$export$a44b693dc5993f76 = "var(--color-border-divider-panel-bottom-bruvuz, #c6c6cd)";
var $17a6dd8285442c36$export$fc16e8dc7d404c5b = "var(--color-border-divider-panel-side-an0w07, #c6c6cd)";
var $17a6dd8285442c36$export$ac43eeb57f91d764 = "var(--color-border-divider-secondary-qoitch, #ebebf0)";
var $17a6dd8285442c36$export$69bef49d54f5dd71 = "var(--color-border-dropdown-container-cmthq7, #b4b4bb)";
var $17a6dd8285442c36$export$1f6651cf07fc241b = "var(--color-border-dropdown-group-ylcnh8, #c6c6cd)";
var $17a6dd8285442c36$export$741a8ce3d247b977 = "var(--color-border-dropdown-item-default-kape37, #c6c6cd)";
var $17a6dd8285442c36$export$50f59cdad678c0dd = "var(--color-border-dropdown-item-hover-aqfuxq, #8c8c94)";
var $17a6dd8285442c36$export$c4d27d83094bd624 = "var(--color-border-dropdown-item-dimmed-hover-ga9sch, #8c8c94)";
var $17a6dd8285442c36$export$7fc52b80c956560f = "var(--color-border-dropdown-item-selected-dl2ezh, #006ce0)";
var $17a6dd8285442c36$export$3baa383d112607d = "var(--color-border-dropdown-item-top-gp2d1p, transparent)";
var $17a6dd8285442c36$export$62adfa6b7b328cf8 = "var(--color-border-editable-cell-hover-2hmo55, #8c8c94)";
var $17a6dd8285442c36$export$21afa3ade758638c = "var(--color-border-input-default-317xk5, #8c8c94)";
var $17a6dd8285442c36$export$ec8bd66c0156738c = "var(--color-border-input-disabled-zgnzvk, #ebebf0)";
var $17a6dd8285442c36$export$ec963abecb04d303 = "var(--color-border-input-focused-4z0pgn, #006ce0)";
var $17a6dd8285442c36$export$861654f1938d1f98 = "var(--color-border-item-focused-uk47pl, #006ce0)";
var $17a6dd8285442c36$export$3f1ce4cc66f844e1 = "var(--color-border-dropdown-item-focused-zacqlp, #424650)";
var $17a6dd8285442c36$export$22ae6baddbc6e3c9 = "var(--color-border-item-placeholder-x8kbjp, #006ce0)";
var $17a6dd8285442c36$export$aafa50fcd0bf473e = "var(--color-border-item-selected-wl5ttm, #006ce0)";
var $17a6dd8285442c36$export$e3904b4916291c65 = "var(--color-border-layout-ayg8vb, #c6c6cd)";
var $17a6dd8285442c36$export$7fef254eb1b70093 = "var(--color-border-notification-stack-bar-aszsse, #232b37)";
var $17a6dd8285442c36$export$cfcb693971ed251a = "var(--color-border-panel-header-ygztvl, #c6c6cd)";
var $17a6dd8285442c36$export$693c156e69be0284 = "var(--color-border-popover-1ye6tz, #b4b4bb)";
var $17a6dd8285442c36$export$293770c391b8bbd7 = "var(--color-border-segment-active-ls9t4n, #424650)";
var $17a6dd8285442c36$export$e24ad1b781f47c8f = "var(--color-border-segment-default-6ig2mo, #424650)";
var $17a6dd8285442c36$export$e12f0f1ebf9eb9d4 = "var(--color-border-segment-disabled-fcrbcl, #424650)";
var $17a6dd8285442c36$export$6ce770691b3e0927 = "var(--color-border-segment-hover-0o9ey3, #424650)";
var $17a6dd8285442c36$export$cbc24658d2fb9487 = "var(--color-border-status-error-j8acpp, #db0000)";
var $17a6dd8285442c36$export$f3c43f03ab377031 = "var(--color-border-status-info-qf6jok, #006ce0)";
var $17a6dd8285442c36$export$b93f266d442a4415 = "var(--color-border-status-success-8z5f8u, #00802f)";
var $17a6dd8285442c36$export$7e4932b8a8f6c584 = "var(--color-border-status-warning-j40pg7, #855900)";
var $17a6dd8285442c36$export$4d9f7bff9d4b5d1a = "var(--color-border-dialog-0rjwug, #006ce0)";
var $17a6dd8285442c36$export$78bfd3b23208a4e0 = "var(--color-border-divider-interactive-default-r928dz, #8c8c94)";
var $17a6dd8285442c36$export$9591885b4360f487 = "var(--color-border-tabs-divider-f5t9va, #c6c6cd)";
var $17a6dd8285442c36$export$423a7f6153e1b641 = "var(--color-border-tabs-shadow-ugyo07, rgba(15, 20, 26, 0.12))";
var $17a6dd8285442c36$export$28dbd52c273d4b7 = "var(--color-border-tabs-underline-gudemr, #006ce0)";
var $17a6dd8285442c36$export$d058d361ba133ca1 = "var(--color-border-tiles-disabled-19olbu, #ebebf0)";
var $17a6dd8285442c36$export$4ef42a9d5871f18 = "var(--color-border-tutorial-zggi80, #dedee3)";
var $17a6dd8285442c36$export$5846f2c78fe18c7f = "var(--color-foreground-control-default-eto4wy, #ffffff)";
var $17a6dd8285442c36$export$7bc49731426c5ff9 = "var(--color-foreground-control-disabled-txi6cf, #ffffff)";
var $17a6dd8285442c36$export$23f341fc399c3d71 = "var(--color-foreground-control-read-only-7ydvuj, #656871)";
var $17a6dd8285442c36$export$311a9f2d28f07e7c = "var(--color-shadow-default-o7dmmm, rgba(15, 20, 26, 0.12))";
var $17a6dd8285442c36$export$805fa7d3cf10a9f6 = "var(--color-shadow-medium-x7of55, rgba(15, 20, 26, 0.12))";
var $17a6dd8285442c36$export$5641087cd2c643f7 = "var(--color-shadow-side-rtsbda, rgba(15, 20, 26, 0.12))";
var $17a6dd8285442c36$export$adfb5d6d7405f089 = "var(--color-stroke-chart-line-3nsnk6, #8c8c94)";
var $17a6dd8285442c36$export$b178e95dfaec580f = "var(--color-stroke-code-editor-gutter-active-line-default-5hrdmu, #dedee3)";
var $17a6dd8285442c36$export$27b0788b70e0957e = "var(--color-stroke-code-editor-gutter-active-line-hover-vqrb6s, #f9f9fa)";
var $17a6dd8285442c36$export$42d86111d6f9cac1 = "var(--color-text-accent-n1kmht, #006ce0)";
var $17a6dd8285442c36$export$99fafe6b96819d06 = "var(--color-text-body-default-vvtq8u, #0f141a)";
var $17a6dd8285442c36$export$7ed8f2bb2f12e659 = "var(--color-text-body-secondary-yna5sb, #424650)";
var $17a6dd8285442c36$export$24880e6990a0adb2 = "var(--color-text-breadcrumb-current-2mqnkk, #656871)";
var $17a6dd8285442c36$export$2ceebbdc1000cfb4 = "var(--color-text-breadcrumb-icon-9j48ot, #8c8c94)";
var $17a6dd8285442c36$export$922335eb1ef6a73 = "var(--color-text-button-inline-icon-default-sm4ql6, #006ce0)";
var $17a6dd8285442c36$export$98fcc14a4823bf86 = "var(--color-text-button-inline-icon-disabled-82hho0, #b4b4bb)";
var $17a6dd8285442c36$export$9cc92cfa1634ca = "var(--color-text-button-inline-icon-hover-rbyzfc, #002b66)";
var $17a6dd8285442c36$export$63e7d68a830c9ae2 = "var(--color-text-button-normal-active-vihsxh, #002b66)";
var $17a6dd8285442c36$export$2cb3935909f75a87 = "var(--color-text-toggle-button-normal-pressed-wnx2zl, #002b66)";
var $17a6dd8285442c36$export$97f2d9ae0dc6d73e = "var(--color-text-button-normal-default-nzalii, #006ce0)";
var $17a6dd8285442c36$export$cd3f5c4941958390 = "var(--color-text-button-normal-hover-gusgyv, #002b66)";
var $17a6dd8285442c36$export$be42745d99acf7c2 = "var(--color-text-link-button-normal-default-srprth, #006ce0)";
var $17a6dd8285442c36$export$83589dd4e57b517e = "var(--color-text-link-button-normal-hover-jrnyw3, #002b66)";
var $17a6dd8285442c36$export$cb3f53ac38870aaa = "var(--color-text-link-button-normal-active-js9ryu, #002b66)";
var $17a6dd8285442c36$export$49a08c3d4865a6b5 = "var(--color-text-button-primary-active-refmba, #ffffff)";
var $17a6dd8285442c36$export$4b9f38ba4c3a17 = "var(--color-text-button-primary-default-mwl31m, #ffffff)";
var $17a6dd8285442c36$export$8d1cd4b4de370118 = "var(--color-text-button-primary-hover-pw12ep, #ffffff)";
var $17a6dd8285442c36$export$fa17c6da10611502 = "var(--color-text-calendar-date-hover-3fcriv, #0f141a)";
var $17a6dd8285442c36$export$7b67940acd4285c7 = "var(--color-text-calendar-month-ea0e93, #656871)";
var $17a6dd8285442c36$export$cdb37e98b35f1870 = "var(--color-text-code-editor-gutter-active-line-2addhd, #ffffff)";
var $17a6dd8285442c36$export$e3c59ff3d97a7e4e = "var(--color-text-code-editor-gutter-default-nlshs8, #0f141a)";
var $17a6dd8285442c36$export$5c8a158dea93561b = "var(--color-text-code-editor-status-bar-disabled-xxmtlc, #8c8c94)";
var $17a6dd8285442c36$export$dfe05a14127d6c2a = "var(--color-text-code-editor-tab-button-error-avwh01, #ffffff)";
var $17a6dd8285442c36$export$c438f00c0302b457 = "var(--color-text-column-header-e6urd1, #424650)";
var $17a6dd8285442c36$export$c52aae78f22065ee = "var(--color-text-column-sorting-icon-fngn77, #424650)";
var $17a6dd8285442c36$export$edab525602307245 = "var(--color-text-control-disabled-upk9lz, #b4b4bb)";
var $17a6dd8285442c36$export$18f2dc4137d83cf7 = "var(--color-text-counter-bywf75, #656871)";
var $17a6dd8285442c36$export$857c200a76b814d0 = "var(--color-text-disabled-rox5hg, #b4b4bb)";
var $17a6dd8285442c36$export$e1c203ec8aff3c13 = "var(--color-text-disabled-inline-edit-1cbiz8, #424650)";
var $17a6dd8285442c36$export$54d684990ca4aaea = "var(--color-text-dropdown-footer-umcot2, #656871)";
var $17a6dd8285442c36$export$6e6dd0370f5223d6 = "var(--color-text-dropdown-group-label-2tmyik, #424650)";
var $17a6dd8285442c36$export$e25a4b7952ed9fb1 = "var(--color-text-dropdown-item-default-f1jr9u, #0f141a)";
var $17a6dd8285442c36$export$e4ca2e371ee4d531 = "var(--color-text-dropdown-item-dimmed-tq8vh3, #b4b4bb)";
var $17a6dd8285442c36$export$4f904e7f556bf04e = "var(--color-text-dropdown-item-disabled-8m65hf, #b4b4bb)";
var $17a6dd8285442c36$export$bd72e46ce6e21dd6 = "var(--color-text-dropdown-item-filter-match-ebhvct, #006ce0)";
var $17a6dd8285442c36$export$56a5d6c04184dd38 = "var(--color-text-dropdown-item-highlighted-yr1px8, #0f141a)";
var $17a6dd8285442c36$export$9591a8460cdde3a7 = "var(--color-text-dropdown-item-secondary-v12lfh, #656871)";
var $17a6dd8285442c36$export$9efa36f8cfd415f6 = "var(--color-text-dropdown-item-secondary-hover-de15wb, #656871)";
var $17a6dd8285442c36$export$aa35dbb3aad6a65b = "var(--color-text-empty-tlohug, #656871)";
var $17a6dd8285442c36$export$d75e83bfc8c0be57 = "var(--color-text-expandable-section-default-ynw8my, #0f141a)";
var $17a6dd8285442c36$export$1b4c65d205376275 = "var(--color-text-expandable-section-hover-ojzwhd, #006ce0)";
var $17a6dd8285442c36$export$74009e11f21bb45c = "var(--color-text-expandable-section-navigation-icon-default-mklu1s, #424650)";
var $17a6dd8285442c36$export$7d1dc906b1b805c3 = "var(--color-text-form-default-47mtz6, #0f141a)";
var $17a6dd8285442c36$export$4e05f8acfec5c66c = "var(--color-text-form-label-6sbm75, #0f141a)";
var $17a6dd8285442c36$export$8ff2878df57d760d = "var(--color-text-form-secondary-1nm780, #656871)";
var $17a6dd8285442c36$export$192033fa7a73efac = "var(--color-text-group-label-a2qc05, #424650)";
var $17a6dd8285442c36$export$86bbad4e14c6062 = "var(--color-text-label-gen-ai-a2n3od, #7300e5)";
var $17a6dd8285442c36$export$8fe365f5a6ae70aa = "var(--color-text-heading-default-izpp46, #0f141a)";
var $17a6dd8285442c36$export$2ace79b7e81a7323 = "var(--color-text-heading-secondary-iwtvf6, #424650)";
var $17a6dd8285442c36$export$3b21a9010b3111e5 = "var(--color-text-home-header-default-morg6i, #ebebf0)";
var $17a6dd8285442c36$export$fc21ae35df42867b = "var(--color-text-home-header-secondary-i4jhp7, #c6c6cd)";
var $17a6dd8285442c36$export$d6227c677f296693 = "var(--color-text-icon-caret-9mqubk, #8c8c94)";
var $17a6dd8285442c36$export$e553b8131808490c = "var(--color-text-icon-subtle-3sgxlr, #656871)";
var $17a6dd8285442c36$export$257858c4198e525 = "var(--color-text-input-disabled-wh1f3y, #b4b4bb)";
var $17a6dd8285442c36$export$1b5853a0f4e17e5 = "var(--color-text-input-placeholder-dclg8u, #656871)";
var $17a6dd8285442c36$export$ef5bdf9e3981f664 = "var(--color-text-input-placeholder-disabled-wg87og, #b4b4bb)";
var $17a6dd8285442c36$export$27973045a319f5d1 = "var(--color-text-interactive-active-uoe6zi, #0f141a)";
var $17a6dd8285442c36$export$917409e24b36a327 = "var(--color-text-interactive-default-ugh9wp, #424650)";
var $17a6dd8285442c36$export$2544926b6b965541 = "var(--color-text-interactive-disabled-1bqmrl, #b4b4bb)";
var $17a6dd8285442c36$export$56be1b21083f2ecc = "var(--color-text-interactive-hover-6naf7i, #0f141a)";
var $17a6dd8285442c36$export$56cfbdd2bda3e0b7 = "var(--color-text-toggle-button-icon-pressed-detfkz, #0f141a)";
var $17a6dd8285442c36$export$1ace3632b151abd0 = "var(--color-text-interactive-inverted-default-xlc0d5, #dedee3)";
var $17a6dd8285442c36$export$586fbfdef511d74f = "var(--color-text-interactive-inverted-hover-65rnp7, #f9f9fa)";
var $17a6dd8285442c36$export$1da3dbae9b70c2e = "var(--color-text-inverted-4v4dmq, #ffffff)";
var $17a6dd8285442c36$export$4d79623668a3004f = "var(--color-text-label-28gfmc, #0f141a)";
var $17a6dd8285442c36$export$60752a0ef4f0a222 = "var(--color-text-layout-toggle-1a15s3, #ffffff)";
var $17a6dd8285442c36$export$8a9b3ed37003767f = "var(--color-text-layout-toggle-active-ifu7qp, #ffffff)";
var $17a6dd8285442c36$export$6a6284cae6fe86a2 = "var(--color-text-layout-toggle-hover-9jwdce, #006ce0)";
var $17a6dd8285442c36$export$4a375d38c14027cc = "var(--color-text-layout-toggle-selected-xpximc, #ffffff)";
var $17a6dd8285442c36$export$87fd46c2adb0565a = "var(--color-text-link-default-hude44, #006ce0)";
var $17a6dd8285442c36$export$b9118f081e6adc14 = "var(--color-text-link-hover-2hfec2, #002b66)";
var $17a6dd8285442c36$export$760c1828e1d1b351 = "var(--color-text-link-inverted-hover-ocd3u3, #ffffff)";
var $17a6dd8285442c36$export$67db7ec9a0bc21f9 = "var(--color-text-link-button-underline-z4wjnv, transparent)";
var $17a6dd8285442c36$export$ddf6b0c6528b3df8 = "var(--color-text-link-button-underline-hover-cn3mqh, transparent)";
var $17a6dd8285442c36$export$3f8a1f629cf02acc = "var(--color-text-notification-default-1iey72, #f9f9fa)";
var $17a6dd8285442c36$export$46dd282a0b58a932 = "var(--color-text-notification-stack-bar-tjj0ek, #ffffff)";
var $17a6dd8285442c36$export$21252f62bbad2125 = "var(--color-text-notification-yellow-vjtdxk, #0f141a)";
var $17a6dd8285442c36$export$4730513fe3b1f162 = "var(--color-text-pagination-page-number-active-disabled-gfl43p, #b4b4bb)";
var $17a6dd8285442c36$export$6b6720412e870e83 = "var(--color-text-pagination-page-number-default-74j15c, #424650)";
var $17a6dd8285442c36$export$6d37a0482ee6fd89 = "var(--color-text-segment-active-hlorbe, #ffffff)";
var $17a6dd8285442c36$export$ba8d3cb8859b9cda = "var(--color-text-segment-default-vi2vn9, #424650)";
var $17a6dd8285442c36$export$4ffd0943b22f4363 = "var(--color-text-segment-hover-65a2x8, #002b66)";
var $17a6dd8285442c36$export$c9e859a315128530 = "var(--color-text-small-m1tr70, #656871)";
var $17a6dd8285442c36$export$2daf8207ed230a8a = "var(--color-text-status-error-ksqavh, #db0000)";
var $17a6dd8285442c36$export$fca183cf8dc818d1 = "var(--color-text-status-inactive-gy7337, #656871)";
var $17a6dd8285442c36$export$af992c7c57616b19 = "var(--color-text-status-info-ue8bd2, #006ce0)";
var $17a6dd8285442c36$export$a5cc488071f3db86 = "var(--color-text-status-success-ybmii8, #00802f)";
var $17a6dd8285442c36$export$b0a9d296733744f4 = "var(--color-text-status-warning-6meo06, #855900)";
var $17a6dd8285442c36$export$789dbe3ee06794db = "var(--color-text-top-navigation-title-en0v40, #0f141a)";
var $17a6dd8285442c36$export$e9e64a48eac7ea3a = "var(--color-text-tutorial-hotspot-default-xfv3ow, #006ce0)";
var $17a6dd8285442c36$export$6ec7507914ffd5f9 = "var(--color-text-tutorial-hotspot-hover-92pxog, #002b66)";
var $17a6dd8285442c36$export$4ce75865f8956095 = "var(--color-board-placeholder-active-x6yfem, #ebebf0)";
var $17a6dd8285442c36$export$d5dc59ad54217992 = "var(--color-board-placeholder-hover-5nov9c, #d1f1ff)";
var $17a6dd8285442c36$export$eb6c4c2099c875f8 = "var(--color-drag-placeholder-active-ea1sgp, #ebebf0)";
var $17a6dd8285442c36$export$1f89d9e32f8d6b9e = "var(--color-drag-placeholder-hover-qwadna, #d1f1ff)";
var $17a6dd8285442c36$export$199172c0c894dfc1 = "var(--color-dropzone-background-default-7efhmb, #ffffff)";
var $17a6dd8285442c36$export$b4aab8b16da3aa95 = "var(--color-dropzone-background-hover-mi8rlm, #f0fbff)";
var $17a6dd8285442c36$export$bd1979c01e588e76 = "var(--color-dropzone-text-default-djdnme, #424650)";
var $17a6dd8285442c36$export$73d7d5da118148f7 = "var(--color-dropzone-text-hover-asw3rt, #424650)";
var $17a6dd8285442c36$export$d1644b2219e193b1 = "var(--color-dropzone-border-default-k648ha, #8c8c94)";
var $17a6dd8285442c36$export$3f9742b2f9ab12b1 = "var(--color-dropzone-border-hover-otpag5, #002b66)";
var $17a6dd8285442c36$export$e6e221dd976800f7 = "var(--color-gap-global-drawer-nh699a, #ebebf0)";
var $17a6dd8285442c36$export$c01450ee8f5ddb80 = "var(--color-tree-view-connector-line-1usxvn, #8c8c94)";
var $17a6dd8285442c36$export$5a5d81c9ba8db0dc = "var(--font-box-value-large-weight-wr00sw, 700)";
var $17a6dd8285442c36$export$6cea02332282f81c = "var(--font-button-letter-spacing-ufowe3, 0.005em)";
var $17a6dd8285442c36$export$97c97058d95ef0c = "var(--font-chart-detail-size-9qr25q, 12px)";
var $17a6dd8285442c36$export$a26c7707d8b80ef2 = "var(--font-display-label-weight-zavpeo, 700)";
var $17a6dd8285442c36$export$947ebdf5d486852d = "var(--font-expandable-heading-size-0uk059, 16px)";
var $17a6dd8285442c36$export$d6d0beee51714e68 = "var(--font-family-base-gmnpzl, 'Open Sans', 'Helvetica Neue', Roboto, Arial, sans-serif)";
var $17a6dd8285442c36$export$30db30f32770aeef = "var(--font-family-heading-ugphat, 'Open Sans', 'Helvetica Neue', Roboto, Arial, sans-serif)";
var $17a6dd8285442c36$export$f0a6663ff0bec29b = "var(--font-family-monospace-q47m7k, Monaco, Menlo, Consolas, 'Courier Prime', Courier, 'Courier New', monospace)";
var $17a6dd8285442c36$export$5dd33e724c44736 = "var(--font-header-h2-description-line-height-ts2s6o, 20px)";
var $17a6dd8285442c36$export$fa61d38260e1aa7f = "var(--font-header-h2-description-size-g2wws3, 14px)";
var $17a6dd8285442c36$export$899038b1221ac378 = "var(--font-link-button-letter-spacing-imtxwq, 0.005em)";
var $17a6dd8285442c36$export$78395bf113ea0316 = "var(--font-link-button-weight-vslyg9, 700)";
var $17a6dd8285442c36$export$a98c4a0b02ae57aa = "var(--font-panel-header-line-height-8xb2qj, 22px)";
var $17a6dd8285442c36$export$82533652d6b4f903 = "var(--font-panel-header-size-33h9j8, 18px)";
var $17a6dd8285442c36$export$de81818e89f6d1c = "var(--font-size-body-m-a7nh2n, 14px)";
var $17a6dd8285442c36$export$dff12ce2697b4214 = "var(--font-size-body-s-smc8cv, 12px)";
var $17a6dd8285442c36$export$802031699d2e324 = "var(--font-size-display-l-wa6woo, 42px)";
var $17a6dd8285442c36$export$78893ab79410136f = "var(--font-size-heading-xl-wvkbur, 24px)";
var $17a6dd8285442c36$export$8855834baaf16ab9 = "var(--font-size-heading-l-vnacx6, 20px)";
var $17a6dd8285442c36$export$b747afecae25382c = "var(--font-size-heading-m-170yiy, 18px)";
var $17a6dd8285442c36$export$e57a6c9ad7e1cf4a = "var(--font-size-heading-s-zp08en, 16px)";
var $17a6dd8285442c36$export$b41f1e4e3d64cfa6 = "var(--font-size-heading-xs-j8yzxv, 14px)";
var $17a6dd8285442c36$export$ea4831bdeb80d215 = "var(--font-smoothing-moz-osx-hbm0aq, grayscale)";
var $17a6dd8285442c36$export$584c04b0ccacae2a = "var(--font-smoothing-webkit-oemolo, antialiased)";
var $17a6dd8285442c36$export$f26159ce525e15ef = "var(--font-tabs-disabled-weight-e3lt4d, 700)";
var $17a6dd8285442c36$export$c040d70e16297339 = "var(--font-tabs-line-height-5g6n1v, 20px)";
var $17a6dd8285442c36$export$d2e204a7313b6b1f = "var(--font-tabs-size-18irgl, 16px)";
var $17a6dd8285442c36$export$57d5578d1c0dd031 = "var(--font-wayfinding-link-active-weight-ny4hup, 700)";
var $17a6dd8285442c36$export$79271bf2bb4db003 = "var(--font-weight-button-0eg20c, 700)";
var $17a6dd8285442c36$export$72d6edb9be191d20 = "var(--font-weight-heading-xl-u3m4we, 700)";
var $17a6dd8285442c36$export$463f7297c66c5659 = "var(--font-weight-heading-l-0t6dwc, 700)";
var $17a6dd8285442c36$export$9f0bb5f0d2fad1a7 = "var(--font-weight-heading-m-zf82dr, 700)";
var $17a6dd8285442c36$export$f32c723296820b10 = "var(--font-weight-heading-s-lcx0ai, 700)";
var $17a6dd8285442c36$export$7260e7109913629b = "var(--font-weight-heading-xs-wqqpne, 700)";
var $17a6dd8285442c36$export$db2388352ecb5150 = "var(--font-weight-heavy-6yh4un, 700)";
var $17a6dd8285442c36$export$264349a9e414770f = "var(--letter-spacing-body-s-gq78ok, 0.005em)";
var $17a6dd8285442c36$export$5b77f6808836ac1b = "var(--letter-spacing-display-l-elyyxk, -0.03em)";
var $17a6dd8285442c36$export$abf0281c74f07dbf = "var(--letter-spacing-heading-xl-ckkb6u, -0.02em)";
var $17a6dd8285442c36$export$833d03d6446bc9a8 = "var(--letter-spacing-heading-l-5v6ibv, -0.015em)";
var $17a6dd8285442c36$export$e563f57566f5a16c = "var(--letter-spacing-heading-m-29ewnk, -0.010em)";
var $17a6dd8285442c36$export$dcf2b798cdae05fe = "var(--letter-spacing-heading-s-4st9ep, -0.005em)";
var $17a6dd8285442c36$export$dae5535410493a20 = "var(--letter-spacing-heading-xs-fgog7a, normal)";
var $17a6dd8285442c36$export$960c67453f7bf2c4 = "var(--line-height-body-m-2mh3ke, 20px)";
var $17a6dd8285442c36$export$dfe0e027c81f3fb4 = "var(--line-height-body-s-nu5hx1, 16px)";
var $17a6dd8285442c36$export$a2ccddd9c8b22337 = "var(--line-height-display-l-vwanzp, 48px)";
var $17a6dd8285442c36$export$8252c71e3e8f47ad = "var(--line-height-heading-xl-hko6p0, 30px)";
var $17a6dd8285442c36$export$4a1a8478677e8661 = "var(--line-height-heading-l-mg5bx6, 24px)";
var $17a6dd8285442c36$export$eccc5884669941d3 = "var(--line-height-heading-m-uoaqdh, 22px)";
var $17a6dd8285442c36$export$ab1c754ed3ed46cf = "var(--line-height-heading-s-hmi4vc, 20px)";
var $17a6dd8285442c36$export$be5dafb62c47ddb3 = "var(--line-height-heading-xs-q9j004, 18px)";
var $17a6dd8285442c36$export$2254d56a2db9aaa4 = "var(--border-active-width-axzm24, 4px)";
var $17a6dd8285442c36$export$b857bd6df1943933 = "var(--border-code-editor-status-divider-width-4we6jf, 1px)";
var $17a6dd8285442c36$export$df9fd67728cbecdd = "var(--border-container-sticky-width-nri0ix, 0px)";
var $17a6dd8285442c36$export$af181704b6845b8f = "var(--border-container-top-width-n1eke6, 0px)";
var $17a6dd8285442c36$export$24ea37ef9c8f8fd9 = "var(--border-control-focus-ring-shadow-spread-9mjajk, 1px)";
var $17a6dd8285442c36$export$85ffa7850802bbcf = "var(--border-control-invalid-focus-ring-shadow-spread-9jjf96, 2px)";
var $17a6dd8285442c36$export$dbc87f9a80f6e622 = "var(--border-divider-list-width-tdfx1x, 1px)";
var $17a6dd8285442c36$export$b5bc0a4da20f31fe = "var(--border-divider-section-width-uwo8my, 1px)";
var $17a6dd8285442c36$export$dd22823a0a352bcf = "var(--border-dropdown-virtual-offset-width-3wp954, 2px)";
var $17a6dd8285442c36$export$32aca878b5c7fdb3 = "var(--border-invalid-width-3xd6e1, 8px)";
var $17a6dd8285442c36$export$16bb82810c487486 = "var(--border-item-width-miijiw, 2px)";
var $17a6dd8285442c36$export$e48f263823f3a26b = "var(--border-line-chart-dash-array-desefi, 3 5)";
var $17a6dd8285442c36$export$ffe30aa9ee1bf93 = "var(--border-line-chart-line-join-aslwou, round)";
var $17a6dd8285442c36$export$45491abb80b1b00d = "var(--border-line-chart-width-tesor1, 2px)";
var $17a6dd8285442c36$export$1840171bbd801836 = "var(--border-panel-header-width-t1iq1m, 1px)";
var $17a6dd8285442c36$export$a76a9c28849b8bd4 = "var(--border-panel-top-width-10990j, 1px)";
var $17a6dd8285442c36$export$935c733d90884a1e = "var(--border-radius-alert-syagf6, 12px)";
var $17a6dd8285442c36$export$5fecae2e6866e59b = "var(--border-radius-badge-exolfb, 4px)";
var $17a6dd8285442c36$export$cc74298e2de4c08a = "var(--border-radius-button-7bgkcs, 20px)";
var $17a6dd8285442c36$export$619970e6a624b9e4 = "var(--border-radius-calendar-day-focus-ring-xvvbuc, 3px)";
var $17a6dd8285442c36$export$78364b6834dce34f = "var(--border-radius-code-editor-5palck, 8px)";
var $17a6dd8285442c36$export$889ee0b119aa6cec = "var(--border-radius-container-nsfwmm, 16px)";
var $17a6dd8285442c36$export$5853edbe7ce5fc1a = "var(--border-radius-control-circular-focus-ring-yjhscw, 4px)";
var $17a6dd8285442c36$export$873f4d472370aae2 = "var(--border-radius-control-default-focus-ring-1uabki, 4px)";
var $17a6dd8285442c36$export$856fe769595fe7bd = "var(--border-radius-dropdown-fgc2a1, 8px)";
var $17a6dd8285442c36$export$4dc1eacc5288b1ff = "var(--border-radius-dropzone-eklq14, 12px)";
var $17a6dd8285442c36$export$289362cd463e61c = "var(--border-radius-flashbar-pp1ptu, 12px)";
var $17a6dd8285442c36$export$366d043df26e3678 = "var(--border-radius-item-iwaia5, 8px)";
var $17a6dd8285442c36$export$966ead158ef9e27f = "var(--border-radius-input-7q0str, 8px)";
var $17a6dd8285442c36$export$e53441319a919031 = "var(--border-radius-popover-6fqb5w, 8px)";
var $17a6dd8285442c36$export$74e50aa3cc90a49c = "var(--border-radius-tabs-focus-ring-o4qku1, 20px)";
var $17a6dd8285442c36$export$8bc7996a7815312b = "var(--border-radius-tiles-wm1vgw, 8px)";
var $17a6dd8285442c36$export$1bbac3b61fc38ae7 = "var(--border-radius-token-ycnemh, 8px)";
var $17a6dd8285442c36$export$e7f992d7e7458057 = "var(--border-radius-chat-bubble-haafsg, 8px)";
var $17a6dd8285442c36$export$4d5854d57d002eda = "var(--border-radius-tutorial-panel-item-ojaqxg, 8px)";
var $17a6dd8285442c36$export$eae4af9286e447e4 = "var(--border-table-sticky-width-ai31mi, 1px)";
var $17a6dd8285442c36$export$b676aea5f4dfd626 = "var(--border-link-focus-ring-outline-1p0hnu, 0)";
var $17a6dd8285442c36$export$f709f75889a62293 = "var(--border-link-focus-ring-shadow-spread-39uvxr, 2px)";
var $17a6dd8285442c36$export$44153c3243173c42 = "var(--border-width-alert-tuifgy, 2px)";
var $17a6dd8285442c36$export$8bf6f7616c1abcc4 = "var(--border-width-button-jm0qg7, 2px)";
var $17a6dd8285442c36$export$ac7f63b656725dd9 = "var(--border-width-dropdown-youcay, 2px)";
var $17a6dd8285442c36$export$3ca3e9a263300213 = "var(--border-width-field-2xc78x, 1px)";
var $17a6dd8285442c36$export$b4a23c2ce178222d = "var(--border-width-popover-nflirh, 2px)";
var $17a6dd8285442c36$export$c4a5d36a5ecec0fe = "var(--border-width-token-2ukdpu, 2px)";
var $17a6dd8285442c36$export$1ae51b62128f22a9 = "var(--border-width-icon-small-z55i5t, 2px)";
var $17a6dd8285442c36$export$8d6d3f1c21f241b9 = "var(--border-width-icon-normal-9h7vj7, 2px)";
var $17a6dd8285442c36$export$4a33e4c035e7d8f5 = "var(--border-width-icon-medium-b7icqv, 2px)";
var $17a6dd8285442c36$export$d9f5c7a6055d6d1a = "var(--border-width-icon-big-ymgy42, 3px)";
var $17a6dd8285442c36$export$bc36ce83eafb1570 = "var(--border-width-icon-large-u645rg, 4px)";
var $17a6dd8285442c36$export$90f113ab45c40d26 = "var(--motion-duration-extra-fast-l4w48j, 45ms)";
var $17a6dd8285442c36$export$c53bdc46c518ce23 = "var(--motion-duration-extra-slow-29bqym, 270ms)";
var $17a6dd8285442c36$export$b194457277388a75 = "var(--motion-duration-fast-unntf6, 90ms)";
var $17a6dd8285442c36$export$8248960b4daa03ef = "var(--motion-duration-moderate-c9utmg, 135ms)";
var $17a6dd8285442c36$export$13c749b0e529d502 = "var(--motion-duration-refresh-only-ambient-sxpcba, 2000ms)";
var $17a6dd8285442c36$export$fb284f102e23f210 = "var(--motion-duration-refresh-only-fast-zfibh6, 115ms)";
var $17a6dd8285442c36$export$b79895462792a7d = "var(--motion-duration-refresh-only-medium-5rbn3k, 165ms)";
var $17a6dd8285442c36$export$7c2d105804d5f376 = "var(--motion-duration-refresh-only-slow-ugjy90, 250ms)";
var $17a6dd8285442c36$export$9152560867a17034 = "var(--motion-duration-avatar-gen-ai-gradient-84si5n, 3600ms)";
var $17a6dd8285442c36$export$8a39eae61e1a77dc = "var(--motion-duration-avatar-loading-dots-1xxvis, 1200ms)";
var $17a6dd8285442c36$export$7780a7af350c4e0e = "var(--motion-duration-rotate-180-cxi9g7, 135ms)";
var $17a6dd8285442c36$export$733fae6fd0e54b99 = "var(--motion-duration-rotate-90-lyzb0k, 135ms)";
var $17a6dd8285442c36$export$2f0f38baa3369786 = "var(--motion-duration-show-paced-otsjh8, 180ms)";
var $17a6dd8285442c36$export$9210a1855b2e6614 = "var(--motion-duration-show-quick-tyvnyw, 135ms)";
var $17a6dd8285442c36$export$7f72f8e57fea3727 = "var(--motion-duration-slow-zji5vl, 180ms)";
var $17a6dd8285442c36$export$f9d740b165e1915c = "var(--motion-duration-transition-quick-mcm2y0, 90ms)";
var $17a6dd8285442c36$export$761a964467a31f8e = "var(--motion-duration-transition-show-paced-t8d1os, 180ms)";
var $17a6dd8285442c36$export$7ae9f4804b80bb45 = "var(--motion-duration-transition-show-quick-5jnnjz, 90ms)";
var $17a6dd8285442c36$export$6039388d85198df4 = "var(--motion-easing-ease-out-quart-p9axhm, cubic-bezier(0.165, 0.84, 0.44, 1))";
var $17a6dd8285442c36$export$8ac551728ae781f3 = "var(--motion-easing-refresh-only-a-ccyqaz, cubic-bezier(0, 0, 0, 1))";
var $17a6dd8285442c36$export$db463fd1dbae14e = "var(--motion-easing-refresh-only-b-44kz4o, cubic-bezier(1, 0, 0.83, 1))";
var $17a6dd8285442c36$export$a18224124e18d33c = "var(--motion-easing-refresh-only-c-cxy2sk, cubic-bezier(0.84, 0, 0.16, 1))";
var $17a6dd8285442c36$export$6c97e2d04d00ba3c = "var(--motion-easing-refresh-only-d-syj3g1, cubic-bezier(0.33, 0, 0.67, 1))";
var $17a6dd8285442c36$export$b34c36cd9a8ca9a0 = "var(--motion-easing-avatar-gen-ai-gradient-9fwaak, cubic-bezier(0.7, 0, 0.3, 1))";
var $17a6dd8285442c36$export$3a3d6668700e9350 = "var(--motion-easing-rotate-180-7a58rc, cubic-bezier(0.165, 0.84, 0.44, 1))";
var $17a6dd8285442c36$export$3080d41267244626 = "var(--motion-easing-rotate-90-jhbqg9, cubic-bezier(0.165, 0.84, 0.44, 1))";
var $17a6dd8285442c36$export$5fa8477512f355b8 = "var(--motion-easing-show-paced-ym6eyn, ease-out)";
var $17a6dd8285442c36$export$7253578fe3cd30ce = "var(--motion-easing-show-quick-9hlj8q, ease-out)";
var $17a6dd8285442c36$export$4b21a4ae15d6b590 = "var(--motion-easing-transition-quick-qxak3i, linear)";
var $17a6dd8285442c36$export$ae5affb845de4c95 = "var(--motion-easing-transition-show-paced-x2k7uh, ease-out)";
var $17a6dd8285442c36$export$c4796655c1feb618 = "var(--motion-easing-transition-show-quick-jz3lia, linear)";
var $17a6dd8285442c36$export$3272749b8942e8ae = "var(--motion-easing-responsive-hjj3ai, cubic-bezier(0, 0, 0, 1))";
var $17a6dd8285442c36$export$9224677e2fccea55 = "var(--motion-easing-sticky-tn072u, cubic-bezier(1, 0, 0.83, 1))";
var $17a6dd8285442c36$export$5e3e9ef096fde57f = "var(--motion-easing-expressive-o5jqzg, cubic-bezier(0.84, 0, 0.16, 1))";
var $17a6dd8285442c36$export$aafbf48949c0f053 = "var(--motion-duration-responsive-mehora, 115ms)";
var $17a6dd8285442c36$export$84ea3327d390cf38 = "var(--motion-duration-expressive-cbdcwy, 165ms)";
var $17a6dd8285442c36$export$bde394b5d5d9b56c = "var(--motion-duration-complex-tbdo30, 250ms)";
var $17a6dd8285442c36$export$3a3408fdb1e29b3b = "var(--motion-keyframes-fade-in-0r842q, awsui-fade-in-35003c)";
var $17a6dd8285442c36$export$8699c08b470406ee = "var(--motion-keyframes-fade-out-g7fgdu, awsui-fade-out-35003c)";
var $17a6dd8285442c36$export$b9d46f4676b7d1c = "var(--motion-keyframes-status-icon-error-wkou39, awsui-status-icon-error-35003c)";
var $17a6dd8285442c36$export$545dc454e500e431 = "var(--motion-keyframes-scale-popup-9iqcu0, awsui-scale-popup-35003c)";
var $17a6dd8285442c36$export$13e718164e7a069a = "var(--size-calendar-grid-width-hv3136, 238px)";
var $17a6dd8285442c36$export$6095f90852178a3d = "var(--size-control-adm93y, 16px)";
var $17a6dd8285442c36$export$23fa4976b85f2056 = "var(--size-icon-big-7pq9l3, 32px)";
var $17a6dd8285442c36$export$d04b8b9f637b72ff = "var(--size-icon-large-mb6y6y, 48px)";
var $17a6dd8285442c36$export$3bdd084b4bcfa640 = "var(--size-icon-medium-uv8xcz, 20px)";
var $17a6dd8285442c36$export$d69d712f9e825571 = "var(--size-icon-normal-levt08, 16px)";
var $17a6dd8285442c36$export$fc160442471465b9 = "var(--size-table-selection-horizontal-qqiajd, 40px)";
var $17a6dd8285442c36$export$e8026a7b8005ab0f = "var(--size-vertical-input-p1d7xx, 32px)";
var $17a6dd8285442c36$export$c8014675e924201b = "var(--size-vertical-panel-icon-offset-z959cw, 15px)";
var $17a6dd8285442c36$export$8caf7f29e9746daa = "var(--space-alert-action-left-4s8zo5, 12px)";
var $17a6dd8285442c36$export$114e3f7518b96412 = "var(--space-alert-horizontal-ul364s, 16px)";
var $17a6dd8285442c36$export$765c1a481904b843 = "var(--space-alert-message-right-mrjbnn, 4px)";
var $17a6dd8285442c36$export$555392da743e7396 = "var(--space-alert-vertical-dlp5wr, 8px)";
var $17a6dd8285442c36$export$358b02745b4237f4 = "var(--space-button-focus-outline-gutter-jj138g, 4px)";
var $17a6dd8285442c36$export$c6e0e857492b34a1 = "var(--space-button-horizontal-k0c786, 20px)";
var $17a6dd8285442c36$export$cc526c0c1526fabd = "var(--space-button-icon-focus-outline-gutter-vertical-r44mtq, 0px)";
var $17a6dd8285442c36$export$c55e243d1528a8aa = "var(--space-button-icon-only-horizontal-i85hxi, 6px)";
var $17a6dd8285442c36$export$f30fb22b2a0ea0fb = "var(--space-button-inline-icon-focus-outline-gutter-zbfgku, 0px)";
var $17a6dd8285442c36$export$7d0c4752ccfb7c0a = "var(--space-button-modal-dismiss-vertical-vqfxjd, 2px)";
var $17a6dd8285442c36$export$c5a3f263971e4328 = "var(--space-calendar-grid-focus-outline-gutter-vvh43m, -5px)";
var $17a6dd8285442c36$export$b9ba69ae8f61b35e = "var(--space-calendar-grid-selected-focus-outline-gutter-dy6gf8, -5px)";
var $17a6dd8285442c36$export$60e20fd0235c1eb0 = "var(--space-calendar-grid-gutter-zojo6r, 6px)";
var $17a6dd8285442c36$export$cbd6ab7cbe6ae4d6 = "var(--space-card-horizontal-8o8t31, 20px)";
var $17a6dd8285442c36$export$3f58f5d9a17104fa = "var(--space-card-vertical-uad0cc, 16px)";
var $17a6dd8285442c36$export$1df636762f9ea9d7 = "var(--space-code-editor-status-focus-outline-gutter-o87hra, -7px)";
var $17a6dd8285442c36$export$621ac375178a4ee2 = "var(--space-container-content-top-1wtqrc, 4px)";
var $17a6dd8285442c36$export$8b8ab07c79f75307 = "var(--space-container-header-top-am4vzw, 12px)";
var $17a6dd8285442c36$export$3ec430ae25cd3010 = "var(--space-container-header-bottom-2taq8v, 8px)";
var $17a6dd8285442c36$export$c98bf9221ed3cbcf = "var(--space-container-horizontal-nqrzyh, 20px)";
var $17a6dd8285442c36$export$77d777204ec7c3e0 = "var(--space-content-header-padding-bottom-rvy5xz, 16px)";
var $17a6dd8285442c36$export$9074ad80b2b98886 = "var(--space-dark-header-overlap-distance-ld45ap, 36px)";
var $17a6dd8285442c36$export$26a90042aea6bee3 = "var(--space-expandable-section-icon-offset-top-cntyn8, 4px)";
var $17a6dd8285442c36$export$b1d68397db4b962b = "var(--space-field-horizontal-0aq2ch, 12px)";
var $17a6dd8285442c36$export$dabd99aa1c88a1f2 = "var(--space-field-icon-offset-ikwzwx, 36px)";
var $17a6dd8285442c36$export$58060bd8e9494153 = "var(--space-filtering-token-dismiss-button-focus-outline-gutter-1iumy3, -5px)";
var $17a6dd8285442c36$export$97fe88d007d6d032 = "var(--space-filtering-token-operation-select-focus-outline-gutter-jacx1t, -5px)";
var $17a6dd8285442c36$export$6270ed8509018f35 = "var(--space-flashbar-action-left-rqk3ap, 12px)";
var $17a6dd8285442c36$export$b4401cfb5ae161f6 = "var(--space-flashbar-dismiss-right-ckhj91, 0px)";
var $17a6dd8285442c36$export$48379331462cb7b7 = "var(--space-flashbar-horizontal-l63501, 16px)";
var $17a6dd8285442c36$export$87f679ac6ba98515 = "var(--space-flashbar-vertical-th71op, 8px)";
var $17a6dd8285442c36$export$cf5f99ac262e6d42 = "var(--space-grid-gutter-whc3jp, 20px)";
var $17a6dd8285442c36$export$3875e03ade049d4c = "var(--space-key-value-gap-9glmqc, 0px)";
var $17a6dd8285442c36$export$37e7ffb8e4b64c96 = "var(--space-layout-content-bottom-zeb1g9, 40px)";
var $17a6dd8285442c36$export$36a9b22e1cfcaf2e = "var(--space-layout-content-horizontal-buc0zz, 24px)";
var $17a6dd8285442c36$export$3c52453e523fed6e = "var(--space-layout-toggle-diameter-j2qffw, 36px)";
var $17a6dd8285442c36$export$42dd034b87086400 = "var(--space-layout-toggle-padding-chwlhz, 12px)";
var $17a6dd8285442c36$export$88a492a594185c11 = "var(--space-modal-content-bottom-nl6ceq, 16px)";
var $17a6dd8285442c36$export$8094d629742a169c = "var(--space-modal-horizontal-y5hnwp, 20px)";
var $17a6dd8285442c36$export$e1367fa4dc864245 = "var(--space-panel-content-bottom-24c6lu, 40px)";
var $17a6dd8285442c36$export$d4713302d7c26e6b = "var(--space-panel-content-top-qvd1dr, 20px)";
var $17a6dd8285442c36$export$c0afa28f51a226ec = "var(--space-panel-divider-margin-horizontal-yw31p0, 8px)";
var $17a6dd8285442c36$export$8908b689c362bccd = "var(--space-panel-header-vertical-ckfgmy, 20px)";
var $17a6dd8285442c36$export$c92939981b1f1050 = "var(--space-panel-nav-left-wn0n7h, 28px)";
var $17a6dd8285442c36$export$584f6b4cb681baaf = "var(--space-panel-side-left-u1m3s9, 28px)";
var $17a6dd8285442c36$export$4fd59b8d0b4e83e = "var(--space-panel-side-right-8wwirc, 24px)";
var $17a6dd8285442c36$export$101d157c05609dd2 = "var(--space-panel-split-top-3u4vky, 20px)";
var $17a6dd8285442c36$export$e6fcc00599618311 = "var(--space-panel-split-bottom-ir16d7, 20px)";
var $17a6dd8285442c36$export$bf95ce2b0aa5e6b8 = "var(--space-segmented-control-focus-outline-gutter-x1ywqb, 6px)";
var $17a6dd8285442c36$export$8e46cb5ff7790e7 = "var(--space-tabs-content-top-ju6qox, 12px)";
var $17a6dd8285442c36$export$88c0b22bb51273e5 = "var(--space-tabs-focus-outline-gutter-eerrg4, -8px)";
var $17a6dd8285442c36$export$219b36a1d1f10241 = "var(--space-table-content-bottom-tlfqmq, 4px)";
var $17a6dd8285442c36$export$5ebf2bf42680f3a6 = "var(--space-table-embedded-header-top-twu628, 0px)";
var $17a6dd8285442c36$export$981faddf39ea8f3 = "var(--space-table-footer-horizontal-l5g495, 0px)";
var $17a6dd8285442c36$export$108d9c4210ddc555 = "var(--space-table-header-focus-outline-gutter-ymwujm, 0px)";
var $17a6dd8285442c36$export$ac872ce2d2ad6167 = "var(--space-table-header-horizontal-kb5ww2, 0px)";
var $17a6dd8285442c36$export$8a53ff70d0c3ab23 = "var(--space-table-header-tools-bottom-d9u5kf, 0px)";
var $17a6dd8285442c36$export$b7e9cde6d5f652fa = "var(--space-table-header-tools-full-page-bottom-9m47g6, 4px)";
var $17a6dd8285442c36$export$ec8a6ce7fae01cc3 = "var(--space-table-horizontal-suurzj, 20px)";
var $17a6dd8285442c36$export$8863d4a33f89b0b1 = "var(--space-tree-view-indentation-xh9kis, 24px)";
var $17a6dd8285442c36$export$7a85c21d97a7bedb = "var(--space-tile-gutter-bi2bdv, 24px)";
var $17a6dd8285442c36$export$1d72b68ed36d0565 = "var(--space-scaled-2x-none-987dp7, 0px)";
var $17a6dd8285442c36$export$8c49418839301222 = "var(--space-scaled-2x-xxxs-reumxj, 2px)";
var $17a6dd8285442c36$export$9d8d727fe595d20b = "var(--space-scaled-2x-xxs-e79hr1, 4px)";
var $17a6dd8285442c36$export$b06c1318950ec513 = "var(--space-scaled-2x-xs-bcbsqo, 8px)";
var $17a6dd8285442c36$export$910646e1df5f63cb = "var(--space-scaled-2x-s-yr27d5, 12px)";
var $17a6dd8285442c36$export$eb3b309217380584 = "var(--space-scaled-2x-m-4euqsk, 16px)";
var $17a6dd8285442c36$export$ab735f4edff2823c = "var(--space-scaled-2x-l-u5ida5, 20px)";
var $17a6dd8285442c36$export$2f7ce83aac952c4f = "var(--space-scaled-2x-xl-he48nr, 24px)";
var $17a6dd8285442c36$export$73095c83cff228f1 = "var(--space-scaled-2x-xxl-sul5ey, 32px)";
var $17a6dd8285442c36$export$10ac8e9e5f1cd8bd = "var(--space-scaled-2x-xxxl-bxyvwl, 40px)";
var $17a6dd8285442c36$export$8c1a206b8e2cd2b0 = "var(--space-scaled-none-nfyouv, 0px)";
var $17a6dd8285442c36$export$8d806ce0c65dbdd9 = "var(--space-scaled-xxxs-oo06c7, 2px)";
var $17a6dd8285442c36$export$5da13f39cac5ae10 = "var(--space-scaled-xxs-pfm1nx, 4px)";
var $17a6dd8285442c36$export$76d2c885680712dd = "var(--space-scaled-xs-xwoogq, 8px)";
var $17a6dd8285442c36$export$3af9271f55a32e1a = "var(--space-scaled-s-8ozaad, 12px)";
var $17a6dd8285442c36$export$fafa295c751d307c = "var(--space-scaled-m-m892r9, 16px)";
var $17a6dd8285442c36$export$5f54ec147ef18962 = "var(--space-scaled-l-sej05l, 20px)";
var $17a6dd8285442c36$export$7c6da9d513d46a3b = "var(--space-scaled-xl-dunxp5, 24px)";
var $17a6dd8285442c36$export$2a66e8119d8ca862 = "var(--space-scaled-xxl-6wgq96, 32px)";
var $17a6dd8285442c36$export$e3665984e119e598 = "var(--space-scaled-xxxl-hwoy7j, 40px)";
var $17a6dd8285442c36$export$b50e0e5009ac1ea = "var(--space-static-xxxs-yidks1, 2px)";
var $17a6dd8285442c36$export$555e78b2d9228651 = "var(--space-static-xxs-ns94dp, 4px)";
var $17a6dd8285442c36$export$974c039c1f9f4a58 = "var(--space-static-xs-gnm0mz, 8px)";
var $17a6dd8285442c36$export$10f5b0fba44658b8 = "var(--space-static-s-t763lu, 12px)";
var $17a6dd8285442c36$export$4adbb95e68b43364 = "var(--space-static-m-m6qboo, 16px)";
var $17a6dd8285442c36$export$a8c78948aabff143 = "var(--space-static-l-n53k41, 20px)";
var $17a6dd8285442c36$export$acce525ed75272e2 = "var(--space-static-xl-4tedi6, 24px)";
var $17a6dd8285442c36$export$3306f40812e234ae = "var(--space-static-xxl-ifa9j8, 32px)";
var $17a6dd8285442c36$export$294dff5030234a12 = "var(--space-static-xxxl-tngnnz, 40px)";
var $17a6dd8285442c36$export$246544137bdbab = "var(--space-none-xk6qzf, 0px)";
var $17a6dd8285442c36$export$82f2c4c06e9eaf08 = "var(--space-xxxs-pajhad, 2px)";
var $17a6dd8285442c36$export$8153dca95b50fd18 = "var(--space-xxs-hwfkai, 4px)";
var $17a6dd8285442c36$export$a60788ae5e849781 = "var(--space-xs-ymlm0b, 8px)";
var $17a6dd8285442c36$export$c491c1b55afe1022 = "var(--space-s-tvghoh, 12px)";
var $17a6dd8285442c36$export$4491a3f8ef608cd8 = "var(--space-m-dsumyt, 16px)";
var $17a6dd8285442c36$export$c24c82b22872b30a = "var(--space-l-2ud1p3, 20px)";
var $17a6dd8285442c36$export$58c2f5ffaa69b3d9 = "var(--space-xl-jfy3x4, 24px)";
var $17a6dd8285442c36$export$9a48af44bea2a2d8 = "var(--space-xxl-32srm4, 32px)";
var $17a6dd8285442c36$export$232473c916f8d19c = "var(--space-xxxl-aut1u7, 40px)";
var $17a6dd8285442c36$export$9aac36b601df0b58 = "var(--shadow-container-53ltfv, 0px 0px 1px 1px #e9ebed, 0px 1px 8px 2px rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$8c87d891ebc198e = "var(--shadow-container-active-ypjjoc, 0px 1px 1px 1px #e9ebed, 0px 6px 36px #0007161a)";
var $17a6dd8285442c36$export$6fcd3ad9fd10d9ab = "var(--shadow-dropdown-isf0w4, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$560134d5bcf74749 = "var(--shadow-dropup-2r02r5, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$afe074a2ceafee28 = "var(--shadow-flash-collapsed-b68ip6, 0px 4px 4px rgba(0, 0, 0, 0.25))";
var $17a6dd8285442c36$export$3116eac1bcb7e0a2 = "var(--shadow-flash-sticky-k69vye, 0px 4px 8px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$1067ab98941c6613 = "var(--shadow-modal-kwgqht, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$c8e4d733a7a682ea = "var(--shadow-panel-vk7iea, 0px 0px 0px 1px #b6bec9)";
var $17a6dd8285442c36$export$cd151389984aa898 = "var(--shadow-panel-toggle-qddz27, 0px 6px 12px 1px rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$1c6a2e702215849a = "var(--shadow-popover-pkane9, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$9ea96948d635fa85 = "var(--shadow-split-bottom-vlyulf, 0px -36px 36px -36px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$8894fc2c6a098f7 = "var(--shadow-split-side-nyajix, -1px 0px 1px 0px #e9ebed, -36px 6px 36px -36px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$508ae22026e4a8ec = "var(--shadow-sticky-lolw8j, 0px 4px 8px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$ecaf9a88594aea82 = "var(--shadow-sticky-embedded-jmny8n, 0px 2px 0px 0px #e9ebed, 0px 16px 16px -12px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$7f330c5d92588e86 = "var(--shadow-sticky-column-first-trcd2o, 4px 0px 8px 1px rgba(0, 7, 22, 0.1))";
var $17a6dd8285442c36$export$694e992736d5d212 = "var(--shadow-sticky-column-last-qgh697, -4px 0 8px 1px rgba(0, 28, 36, 0.1))";






function $face838852c85adc$export$2e2bcd8739ae039() {
    const { content: content, disableBodyScroll: disableBodyScroll, disableContentPaddings: disableContentPaddings, footerHeight: footerHeight, hasDrawerViewportOverlay: hasDrawerViewportOverlay, navigationOpen: navigationOpen, placement: placement, isMobile: isMobile, isSplitPanelOpen: isSplitPanelOpen, isToolsOpen: isToolsOpen, mainElement: mainElement, notificationsHeight: notificationsHeight, stickyNotifications: stickyNotifications, offsetBottom: offsetBottom, splitPanelDisplayed: splitPanelDisplayed, splitPanelPosition: splitPanelPosition, activeDrawerId: activeDrawerId } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const splitPanelHeight = offsetBottom - footerHeight;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).container, (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`split-panel-position-${splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : 'bottom'}`], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['disable-content-paddings']]: disableContentPaddings,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-split-panel']]: splitPanelDisplayed,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-navigation-open']]: navigationOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-tools-open']]: isToolsOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-active-drawer']]: !!activeDrawerId,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-split-panel-open']]: isSplitPanelOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).content),
        ref: mainElement,
        style: {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelHeight]: `${splitPanelHeight}px`,
            ...(0, $218e10bc7e8580c0$export$7f13b984303df6e1)(placement.insetBlockStart, offsetBottom, stickyNotifications && notificationsHeight > 0 ? `${$17a6dd8285442c36$export$a60788ae5e849781} + ${notificationsHeight}px` : '0px', `var(${(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).mobileBarHeight})`, !!disableBodyScroll, isMobile)
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), null, content));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







function $a4506ba612c715bc$export$2e2bcd8739ae039() {
    var _a, _b, _c, _d;
    const { ariaLabels: ariaLabels, breadcrumbs: breadcrumbs, drawers: drawers, handleNavigationClick: handleNavigationClick, handleToolsClick: handleToolsClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, navigationOpen: navigationOpen, __embeddedViewMode: __embeddedViewMode, isToolsOpen: isToolsOpen, navigationHide: navigationHide, navigationRefs: navigationRefs, toolsHide: toolsHide, toolsRefs: toolsRefs, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!isMobile || __embeddedViewMode || navigationHide && !breadcrumbs && toolsHide && (!drawers || drawers.length === 0)) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['mobile-toolbar'], [
            (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['mobile-bar']
        ], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-breadcrumbs']]: breadcrumbs,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay,
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === 'high-contrast'
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['mobile-bar'], headerVariant !== 'high-contrast' && (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['remove-high-contrast-header'])
    }, !navigationHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-hidden": navigationOpen,
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _a !== void 0 ? _a : undefined,
        "aria-orientation": "horizontal",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['mobile-toolbar-nav'], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !navigationOpen
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaLabel: (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle) !== null && _b !== void 0 ? _b : undefined,
        ariaExpanded: navigationOpen ? undefined : false,
        iconName: "menu",
        formAction: "none",
        onClick: ()=>handleNavigationClick(true),
        variant: "icon",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-toggle'],
        ref: navigationRefs.toggle,
        disabled: hasDrawerViewportOverlay,
        nativeButtonAttributes: {
            'aria-haspopup': navigationOpen ? undefined : true
        }
    })), breadcrumbs && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['mobile-toolbar-breadcrumbs'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs)
    }, breadcrumbs), drawers ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80840cb1e803926f$export$3327f5ebc2d6865), null) : !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-hidden": isToolsOpen,
        "aria-label": (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _c !== void 0 ? _c : undefined,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['mobile-toolbar-tools'], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !isToolsOpen
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle'],
        ariaExpanded: isToolsOpen,
        disabled: hasDrawerViewportOverlay,
        ariaLabel: (_d = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsToggle) !== null && _d !== void 0 ? _d : undefined,
        iconName: "status-info",
        formAction: "none",
        onClick: ()=>handleToolsClick(true),
        variant: "icon",
        ref: toolsRefs.toggle,
        nativeButtonAttributes: {
            'aria-haspopup': true
        }
    })));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $1yiQH = parcelRequire("1yiQH");







function $949807764b15a199$export$2e2bcd8739ae039() {
    const { ariaLabels: ariaLabels, disableBodyScroll: disableBodyScroll, handleNavigationClick: handleNavigationClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, navigationOpen: navigationOpen, isToolsOpen: isToolsOpen, navigation: navigation, navigationHide: navigationHide, navigationRefs: navigationRefs, navigationWidth: navigationWidth, toolsHide: toolsHide, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (navigationHide) return null;
    // Close the Navigation drawer on mobile when a user clicks a link inside.
    const onNavigationClick = (event)=>{
        const hasLink = (0, $1yiQH.findUpUntil)(event.target, (node)=>node.tagName === 'A' && !!node.href);
        if (hasLink && isMobile) handleNavigationClick(false);
    };
    const isUnfocusable = hasDrawerViewportOverlay && (!navigationOpen || isToolsOpen && !toolsHide);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: navigationOpen
    }, (state, transitionEventsRef)=>{
        var _a, _b, _c;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['navigation-container'], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['disable-body-scroll']]: disableBodyScroll,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable
            }),
            style: {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).navigationWidth]: `${navigationWidth}px`
            }
        }, !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
            "aria-hidden": isMobile || navigationOpen,
            "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _a !== void 0 ? _a : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['show-navigation'], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === 'exiting',
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-navigation-open']]: navigationOpen
            }),
            ref: state === 'exiting' ? transitionEventsRef : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle,
            ariaExpanded: navigationOpen ? undefined : false,
            iconName: "menu",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-toggle'],
            onClick: ()=>handleNavigationClick(true),
            ref: navigationRefs.toggle,
            highContrastHeader: headerVariant === 'high-contrast'
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
            "aria-label": (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _b !== void 0 ? _b : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).navigation, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).navigation, {
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !navigationOpen,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === 'entering',
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-navigation-open']]: navigationOpen
            }),
            ref: state !== 'exiting' ? transitionEventsRef : undefined,
            "aria-hidden": !navigationOpen,
            onClick: onNavigationClick
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['content-container'], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['animated-content'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['hide-navigation']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaLabel: (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationClose) !== null && _c !== void 0 ? _c : undefined,
            iconName: isMobile ? 'close' : 'angle-left',
            onClick: ()=>handleNavigationClick(false),
            variant: "icon",
            formAction: "none",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-close'],
            ref: navigationRefs.close
        })), navigation)));
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






function $af1f8915f0887b4c$export$2e2bcd8739ae039() {
    const { notifications: notifications } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!notifications) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($af1f8915f0887b4c$var$NotificationsImplementation, null);
}
function $af1f8915f0887b4c$var$NotificationsImplementation() {
    var _a;
    const { ariaLabels: ariaLabels, hasDrawerViewportOverlay: hasDrawerViewportOverlay, notifications: notifications, setNotificationsHeight: setNotificationsHeight, stickyNotifications: stickyNotifications, headerVariant: headerVariant, hasNotificationsContent: hasNotificationsContent } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const ref = (0, $acw62.useRef)(null);
    (0, $013a2451794a45c0$exports.useResizeObserver)(ref, (entry)=>setNotificationsHeight(entry.contentBoxHeight));
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setNotificationsHeight(0);
        };
    // unmount effect only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
     * The notificationsElement ref is assigned to an inner div to prevent internal bottom margin
     * from affecting the calculated height, which is used for sticky elements below.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "region",
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.notifications) !== null && _a !== void 0 ? _a : undefined,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).notifications, {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['sticky-notifications']]: stickyNotifications,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-notification-content']]: hasNotificationsContent,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay,
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === 'high-contrast',
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['high-contrast']]: headerVariant === 'high-contrast'
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).notifications)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    }, notifications));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









function $139860afa4ff28b8$export$2e2bcd8739ae039({ children: children }) {
    const { ariaLabels: ariaLabels, disableBodyScroll: disableBodyScroll, drawers: drawers, handleSplitPanelClick: handleSplitPanelClick, handleToolsClick: handleToolsClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, isSplitPanelOpen: isSplitPanelOpen, isToolsOpen: isToolsOpen, loseToolsFocus: loseToolsFocus, splitPanel: splitPanel, splitPanelControlId: splitPanelControlId, splitPanelDisplayed: splitPanelDisplayed, splitPanelPosition: splitPanelPosition, splitPanelRefs: splitPanelRefs, splitPanelToggle: splitPanelToggle, tools: tools, toolsControlId: toolsControlId, toolsHide: toolsHide, toolsRefs: toolsRefs, toolsWidth: toolsWidth, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const hasSplitPanel = !!splitPanel && splitPanelPosition === 'side';
    const hasToolsForm = $139860afa4ff28b8$var$getToolsFormStatus(hasSplitPanel && splitPanelDisplayed, isMobile, isSplitPanelOpen, isToolsOpen, toolsHide);
    const hasToolsFormPersistence = $139860afa4ff28b8$var$getToolsFormPersistence(hasSplitPanel, isSplitPanelOpen, isToolsOpen, toolsHide);
    const isUnfocusable = hasDrawerViewportOverlay && !isToolsOpen;
    /**
     * If the drawers property is defined the SplitPanel will be mounted and rendered
     * by the Drawers component.
     */ if (toolsHide && !hasSplitPanel || drawers) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: isToolsOpen !== null && isToolsOpen !== void 0 ? isToolsOpen : false
    }, (state, transitionEventsRef)=>{
        var _a, _b, _c;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['tools-container'], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['disable-body-scroll']]: disableBodyScroll,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable
            }),
            style: {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).toolsAnimationStartingOpacity]: `${hasSplitPanel && isSplitPanelOpen ? 1 : 0}`,
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).toolsWidth]: `${toolsWidth}px`
            },
            onBlur: (e)=>{
                if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) loseToolsFocus();
            }
        }, children, !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
            id: toolsControlId,
            "aria-hidden": !isToolsOpen ? true : false,
            "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _a !== void 0 ? _a : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).tools, {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === 'entering',
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-tools-form-persistence']]: hasToolsFormPersistence,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['is-tools-open']]: isToolsOpen,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !isToolsOpen
            }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools),
            ref: state !== 'exiting' ? transitionEventsRef : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['animated-content']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['hide-tools']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaLabel: (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose) !== null && _b !== void 0 ? _b : undefined,
            iconName: isMobile ? 'close' : 'angle-right',
            onClick: ()=>handleToolsClick(false),
            variant: "icon",
            formAction: "none",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-close'],
            ref: toolsRefs.close
        })), tools)), !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
            "aria-hidden": !hasToolsForm ? true : false,
            "aria-label": (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _c !== void 0 ? _c : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['show-tools'], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === 'exiting',
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-tools-form']]: hasToolsForm,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)['has-tools-form-persistence']]: hasToolsFormPersistence
            }),
            ref: state === 'exiting' ? transitionEventsRef : undefined,
            "data-testid": "side-split-panel-drawer"
        }, !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsToggle,
            ariaControls: toolsControlId,
            ariaExpanded: isToolsOpen,
            iconName: "status-info",
            onClick: ()=>handleToolsClick(!isToolsOpen),
            selected: hasSplitPanel && isToolsOpen,
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle'],
            ref: toolsRefs.toggle,
            highContrastHeader: headerVariant === 'high-contrast'
        }), hasSplitPanel && splitPanelToggle.displayed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: splitPanelToggle.ariaLabel,
            ariaControls: splitPanelControlId,
            ariaExpanded: !!isSplitPanelOpen,
            iconName: "view-vertical",
            onClick: ()=>handleSplitPanelClick(),
            selected: hasSplitPanel && isSplitPanelOpen,
            className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['open-button'],
            ref: splitPanelRefs.toggle,
            highContrastHeader: headerVariant === 'high-contrast'
        })));
    });
}
/**
 * By default the Tools form is styled as display: none; This behavior should
 * be unchanged in mobile viewports where the Tools form is always suppressed.
 * In large viewports, however the Tools form and its corresponding buttons
 * should be present in the UI under the below circumstances.
 */ function $139860afa4ff28b8$var$getToolsFormStatus(hasSplitPanel, isMobile, isSplitPanelOpen, isToolsOpen, toolsHide) {
    let hasToolsForm = false;
    if (!isMobile) {
        // Both the Split Panel and Tools button are needed
        if (hasSplitPanel && !toolsHide) hasToolsForm = true;
        // The Split Panel button is needed
        if (hasSplitPanel && !isSplitPanelOpen && toolsHide) hasToolsForm = true;
        // The Tools button is needed
        if (!hasSplitPanel && !toolsHide && !isToolsOpen) hasToolsForm = true;
    }
    return hasToolsForm;
}
/**
 * Under two scenarios the Tools form that contains the triggers
 * for the Tools content and the Split Panel may be persistent
 * in the UI (as opposed to disappearing when one of the drawers
 * is open). This will also add a white background as opposed to the
 * default transparent background. The buttons will present and in a
 * selected / not selected state.
 */ function $139860afa4ff28b8$var$getToolsFormPersistence(hasSplitPanel, isSplitPanelOpen, isToolsOpen, toolsHide) {
    let hasToolsFormPersistence = false;
    // Both Tools and Split Panel exist and one or both is open
    if (hasSplitPanel && !toolsHide && (isSplitPanelOpen || isToolsOpen)) hasToolsFormPersistence = true;
    return hasToolsFormPersistence;
}


const $18dc6142312830db$var$AppLayoutWithRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function AppLayout(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e9ace527e915055$export$56942bf202ca3905), {
        ...props,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $52c91a8fefd6ceb2$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6b9304cc8ecd5f8$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $949807764b15a199$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4506ba612c715bc$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af1f8915f0887b4c$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $870116fec74b536c$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $267aa9df9137ec77$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $face838852c85adc$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039).Bottom, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $139860afa4ff28b8$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039).Side, null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80840cb1e803926f$export$2e2bcd8739ae039), null))));
});
var $18dc6142312830db$export$2e2bcd8739ae039 = $18dc6142312830db$var$AppLayoutWithRef;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $710f0a879f8b63c2$export$2e2bcd8739ae039 = {
    "root": "awsui_root_xttbq_1rjuy_145"
};


function $b8469ab82402f2dd$export$2e2bcd8739ae039(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...props,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $710f0a879f8b63c2$export$2e2bcd8739ae039).root, props.className)
    });
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $293a071804cee86f$var$getCustomFlag = (flagName)=>{
    var _a;
    const flagHolder = typeof window !== 'undefined' ? window : globalThis;
    const awsuiCustomFlagsSymbol = Symbol.for('awsui-custom-flags');
    return (_a = flagHolder === null || flagHolder === void 0 ? void 0 : flagHolder[awsuiCustomFlagsSymbol]) === null || _a === void 0 ? void 0 : _a[flagName];
};
const $293a071804cee86f$var$isAppLayoutDelayedWidget = ()=>{
    return !!$293a071804cee86f$var$getCustomFlag('appLayoutDelayedWidget');
};
const $293a071804cee86f$var$enableDelayedComponents = $293a071804cee86f$var$isAppLayoutDelayedWidget();
let $293a071804cee86f$var$loadPromise;
function $293a071804cee86f$export$9b66a8b14f2768d9(Component) {
    if (!$293a071804cee86f$var$enableDelayedComponents) return;
    return (props)=>{
        const [mounted, setMounted] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            if (!$293a071804cee86f$var$loadPromise) $293a071804cee86f$var$loadPromise = new Promise((resolve)=>setTimeout(()=>resolve(), 1000));
            let mounted = true;
            $293a071804cee86f$var$loadPromise.then(()=>{
                if (mounted) setMounted(true);
            });
            return ()=>{
                mounted = false;
            };
        }, []);
        if (mounted) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ...props
        });
        // this prop is injected in `createWidgetizedComponent` and is not a part of the component signature
        const { Skeleton: Skeleton } = props;
        return Skeleton ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Skeleton, {
            ...props
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $2b25eacde88e3edd$export$61fae46ccdc4563e(Implementation, Skeleton) {
    return (Loader)=>{
        return (props)=>{
            const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
            if (isRefresh && (0, $013a2451794a45c0$exports.getGlobalFlag)('appLayoutWidget') && Loader) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Loader, {
                Skeleton: Skeleton,
                ...props
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Implementation, {
                ...props
            });
        };
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $902475055b64674b$var$checkAlreadyExists(value, propName) {
    if (value) {
        (0, $013a2451794a45c0$exports.warnOnce)('AppLayout', `Another app layout instance on this page already defines ${propName} property. This instance will be ignored.`);
        return true;
    }
    return false;
}
const $902475055b64674b$export$9d1611c77c2fe928 = (ownProps, additionalProps)=>{
    var _a;
    const toolbar = {};
    for (const props of [
        ownProps,
        ...additionalProps
    ]){
        toolbar.ariaLabels = {
            ...toolbar.ariaLabels,
            ...props.ariaLabels
        };
        if (props.drawers && props.drawers.some((drawer)=>drawer.trigger) && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.drawers, 'tools or drawers')) {
            toolbar.drawers = props.drawers;
            toolbar.activeDrawerId = props.activeDrawerId;
            toolbar.drawersFocusRef = props.drawersFocusRef;
            toolbar.onActiveDrawerChange = props.onActiveDrawerChange;
        }
        if (props.globalDrawers && props.globalDrawers.some((drawer)=>drawer.trigger) && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.globalDrawers, 'globalDrawers')) {
            toolbar.globalDrawersFocusControl = props.globalDrawersFocusControl;
            toolbar.globalDrawers = props.globalDrawers;
            toolbar.activeGlobalDrawersIds = props.activeGlobalDrawersIds;
            toolbar.onActiveGlobalDrawersChange = props.onActiveGlobalDrawersChange;
        }
        if (props.aiDrawer && props.aiDrawerFocusRef && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.aiDrawerFocusRef, 'aiDrawerFocusRef')) toolbar.aiDrawerFocusRef = props.aiDrawerFocusRef;
        if (props.bottomDrawers && props.bottomDrawers.some((drawer)=>drawer.trigger) && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.bottomDrawers, 'bottomDrawers')) {
            toolbar.bottomDrawers = props.bottomDrawers;
            toolbar.bottomDrawersFocusRef = props.bottomDrawersFocusRef;
            toolbar.activeGlobalBottomDrawerId = props.activeGlobalBottomDrawerId;
            toolbar.onActiveGlobalBottomDrawerChange = props.onActiveGlobalBottomDrawerChange;
        }
        if (props.navigation && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.hasNavigation, 'navigation')) {
            toolbar.hasNavigation = true;
            toolbar.navigationOpen = props.navigationOpen;
            toolbar.navigationFocusRef = props.navigationFocusRef;
            toolbar.onNavigationToggle = props.onNavigationToggle;
        }
        if (props.splitPanel && ((_a = props.splitPanelToggleProps) === null || _a === void 0 ? void 0 : _a.displayed) && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.hasSplitPanel, 'splitPanel')) {
            toolbar.hasSplitPanel = true;
            toolbar.splitPanelFocusRef = props.splitPanelFocusRef;
            toolbar.splitPanelToggleProps = props.splitPanelToggleProps;
            toolbar.onSplitPanelToggle = props.onSplitPanelToggle;
        }
        if (props.breadcrumbs && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.hasBreadcrumbsPortal, 'hasBreadcrumbsPortal')) toolbar.hasBreadcrumbsPortal = true;
        if (props.expandedDrawerId && !$902475055b64674b$var$checkAlreadyExists(!!toolbar.expandedDrawerId, 'expandedDrawerId')) {
            toolbar.expandedDrawerId = props.expandedDrawerId;
            toolbar.setExpandedDrawerId = props.setExpandedDrawerId;
        }
    }
    // do not render toolbar if no fields are defined, except ariaLabels, which are always there
    return Object.keys(toolbar).filter((key)=>key !== 'ariaLabels').length > 0 ? toolbar : null;
};
const $902475055b64674b$export$9fd8253f8e263aaf = (props, appLayoutState)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const state = appLayoutState.widgetizedState;
    return {
        breadcrumbs: props.breadcrumbs,
        ariaLabels: state ? state.ariaLabels : props.ariaLabels,
        navigation: !props.navigationTriggerHide && !props.navigationHide,
        navigationOpen: state ? state.navigationOpen : props.navigationOpen,
        onNavigationToggle: state === null || state === void 0 ? void 0 : state.onNavigationToggle,
        navigationFocusRef: state === null || state === void 0 ? void 0 : state.navigationFocusControl.refs.toggle,
        activeDrawerId: (_b = (_a = state === null || state === void 0 ? void 0 : state.activeDrawer) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
        // only pass it down if there are non-empty drawers or tools
        drawers: ((_c = state === null || state === void 0 ? void 0 : state.drawers) === null || _c === void 0 ? void 0 : _c.length) || !props.toolsHide ? state === null || state === void 0 ? void 0 : state.drawers : undefined,
        globalDrawersFocusControl: state === null || state === void 0 ? void 0 : state.globalDrawersFocusControl,
        globalDrawers: ((_d = state === null || state === void 0 ? void 0 : state.globalDrawers) === null || _d === void 0 ? void 0 : _d.length) ? state.globalDrawers : undefined,
        activeGlobalDrawersIds: state === null || state === void 0 ? void 0 : state.activeGlobalDrawersIds,
        onActiveGlobalDrawersChange: state === null || state === void 0 ? void 0 : state.onActiveGlobalDrawersChange,
        onActiveDrawerChange: state === null || state === void 0 ? void 0 : state.onActiveDrawerChange,
        bottomDrawers: state === null || state === void 0 ? void 0 : state.bottomDrawers,
        activeGlobalBottomDrawerId: state === null || state === void 0 ? void 0 : state.activeGlobalBottomDrawerId,
        onActiveGlobalBottomDrawerChange: state === null || state === void 0 ? void 0 : state.onActiveGlobalBottomDrawerChange,
        drawersFocusRef: state === null || state === void 0 ? void 0 : state.drawersFocusControl.refs.toggle,
        bottomDrawersFocusRef: state === null || state === void 0 ? void 0 : state.bottomDrawersFocusControl.refs.toggle,
        splitPanel: props.splitPanel,
        splitPanelToggleProps: (state === null || state === void 0 ? void 0 : state.splitPanelToggleConfig) && {
            ...state.splitPanelToggleConfig,
            active: state === null || state === void 0 ? void 0 : state.splitPanelOpen,
            controlId: state === null || state === void 0 ? void 0 : state.splitPanelControlId,
            position: state === null || state === void 0 ? void 0 : state.splitPanelPosition
        },
        splitPanelFocusRef: state === null || state === void 0 ? void 0 : state.splitPanelFocusControl.refs.toggle,
        onSplitPanelToggle: state === null || state === void 0 ? void 0 : state.onSplitPanelToggle,
        expandedDrawerId: state === null || state === void 0 ? void 0 : state.expandedDrawerId,
        setExpandedDrawerId: state === null || state === void 0 ? void 0 : state.setExpandedDrawerId,
        aiDrawer: (_e = state === null || state === void 0 ? void 0 : state.aiDrawer) !== null && _e !== void 0 ? _e : undefined,
        aiDrawerFocusRef: (_g = (_f = state === null || state === void 0 ? void 0 : state.aiDrawerFocusControl) === null || _f === void 0 ? void 0 : _f.refs) === null || _g === void 0 ? void 0 : _g.toggle
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $cff975c73fa800c5$export$a7395f9832c00176({ initialState: initialState = false } = {}) {
    const observerRef = (0, $acw62.useRef)(null);
    const [isIntersecting, setIsIntersecting] = (0, $acw62.useState)(initialState);
    const ref = (0, $acw62.useCallback)((targetElement)=>{
        if (typeof IntersectionObserver === 'undefined') // Do nothing in environments like JSDOM
        return;
        if (observerRef.current) // Dismiss previous observer because the target changed
        observerRef.current.disconnect();
        // Create a new observer with the target element
        if (targetElement) {
            // Fix for AWSUI-60898: In Firefox, IntersectionObserver instances inside an
            //   iframe context can't detect visibility changes caused by changes to elements
            //   outside the iframe (e.g. if an element wrapping the iframe is set to `display: none`).
            let TopLevelIntersectionObserver = IntersectionObserver;
            try {
                if (window.top) TopLevelIntersectionObserver = window.top.IntersectionObserver;
            } catch  {
            // Tried to access a cross-origin iframe. Fall back to current IntersectionObserver.
            }
            observerRef.current = new TopLevelIntersectionObserver((entries)=>{
                let latestEntry = entries[0];
                for (const entry of entries)if (entry.time > latestEntry.time) latestEntry = entry;
                setIsIntersecting(latestEntry.isIntersecting);
            });
            observerRef.current.observe(targetElement);
        }
    }, []);
    return {
        ref: ref,
        isIntersecting: isIntersecting
    };
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




function $e77086e9f518407b$var$useSetGlobalBreadcrumbsImplementation({ __disableGlobalization: __disableGlobalization, ...props }) {
    var _a, _b;
    const { isInToolbar: isInToolbar } = (_a = (0, $acw62.useContext)((0, $5475c68ef3288dd6$export$f37757d67c29fcf7))) !== null && _a !== void 0 ? _a : {};
    const isLayoutVisible = (_b = (0, $acw62.useContext)((0, $5475c68ef3288dd6$export$e0610513fcff76c1))) !== null && _b !== void 0 ? _b : true;
    const registrationRef = (0, $acw62.useRef)();
    const [registered, setRegistered] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (isInToolbar || __disableGlobalization || !isLayoutVisible) return;
        const registration = (0, $2ec6e52915a41fcf$export$90753eb139627d74).breadcrumbs.registerBreadcrumbs(props, (isRegistered)=>{
            setRegistered(isRegistered !== null && isRegistered !== void 0 ? isRegistered : true);
            if (isRegistered) {
                const breadcrumbs = props.items.map((item)=>item.text).join(' > ');
                (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendOpsMetricObject('awsui-global-breadcrumbs-used', {
                    breadcrumbs: breadcrumbs
                });
            }
        });
        registrationRef.current = registration;
        return ()=>{
            registration.cleanup();
        };
    // subsequent prop changes are handled by another effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInToolbar,
        __disableGlobalization,
        isLayoutVisible
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        (_a = registrationRef.current) === null || _a === void 0 || _a.update(props);
    });
    return registered;
}
function $e77086e9f518407b$export$f84a01a588f76472(props) {
    // avoid additional side effects when this feature is not active
    if (!(0, $73078c4512771f18$export$140d325aa1fff478)()) return false;
    // getGlobalFlag() value does not change without full page reload
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $e77086e9f518407b$var$useSetGlobalBreadcrumbsImplementation(props);
}
function $e77086e9f518407b$export$eaa9c9bd163bd73d(enabled) {
    const [discoveredBreadcrumbs, setDiscoveredBreadcrumbs] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        const unregisterAppLayout = (0, $2ec6e52915a41fcf$export$90753eb139627d74).breadcrumbs.registerAppLayout((breadcrumbs)=>{
            setDiscoveredBreadcrumbs(breadcrumbs);
        });
        return ()=>{
            unregisterAppLayout === null || unregisterAppLayout === void 0 || unregisterAppLayout();
            setDiscoveredBreadcrumbs(null);
        };
    }, [
        enabled
    ]);
    return discoveredBreadcrumbs;
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $ff079cc12921495d$export$6e84eb1dcf528852 = 48; // space-xl
function $ff079cc12921495d$export$847d464b8c579b64({ navigationOpen: navigationOpen, navigationWidth: navigationWidth, placement: placement, minContentWidth: minContentWidth, activeDrawerSize: activeDrawerSize, splitPanelOpen: splitPanelOpen, splitPanelPosition: splitPanelPosition, splitPanelSize: splitPanelSize, isMobile: isMobile, activeGlobalDrawersSizes: activeGlobalDrawersSizes, activeAiDrawerSize: activeAiDrawerSize }) {
    const activeNavigationWidth = navigationOpen ? navigationWidth : 0;
    let resizableSpaceAvailable = placement.inlineSize - minContentWidth - $ff079cc12921495d$export$6e84eb1dcf528852 - activeNavigationWidth - activeAiDrawerSize;
    const totalActiveGlobalDrawersSize = Object.values(activeGlobalDrawersSizes).reduce((acc, size)=>acc + size, 0);
    const availableWidthForSplitPanel = resizableSpaceAvailable - activeDrawerSize;
    const splitPanelForcedPosition = (0, $1349679bbe0bb971$export$aef5e4755971001b)({
        isMobile: isMobile,
        availableWidthForSplitPanel: availableWidthForSplitPanel
    });
    const resolvedSplitPanelPosition = splitPanelForcedPosition ? 'bottom' : splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : 'bottom';
    const sideSplitPanelSize = resolvedSplitPanelPosition === 'side' && splitPanelOpen ? splitPanelSize !== null && splitPanelSize !== void 0 ? splitPanelSize : 0 : 0;
    const maxSplitPanelSize = Math.max(resizableSpaceAvailable - totalActiveGlobalDrawersSize - activeDrawerSize, 0);
    resizableSpaceAvailable -= sideSplitPanelSize;
    const maxDrawerSize = resizableSpaceAvailable - totalActiveGlobalDrawersSize;
    const maxAiDrawerSize = resizableSpaceAvailable - totalActiveGlobalDrawersSize + activeAiDrawerSize;
    const maxGlobalDrawersSizes = Object.keys(activeGlobalDrawersSizes).reduce((acc, drawerId)=>{
        return {
            ...acc,
            [drawerId]: resizableSpaceAvailable - activeDrawerSize - totalActiveGlobalDrawersSize + activeGlobalDrawersSizes[drawerId]
        };
    }, {});
    return {
        splitPanelPosition: resolvedSplitPanelPosition,
        splitPanelForcedPosition: splitPanelForcedPosition,
        sideSplitPanelSize: sideSplitPanelSize,
        maxSplitPanelSize: maxSplitPanelSize,
        maxDrawerSize: maxDrawerSize,
        maxGlobalDrawersSizes: maxGlobalDrawersSizes,
        totalActiveGlobalDrawersSize: totalActiveGlobalDrawersSize,
        resizableSpaceAvailable: resizableSpaceAvailable,
        maxAiDrawerSize: maxAiDrawerSize
    };
}
function $ff079cc12921495d$export$88f2788934d642c4({ topOffset: topOffset, hasVisibleToolbar: hasVisibleToolbar, toolbarHeight: toolbarHeight, stickyNotifications: stickyNotifications, notificationsHeight: notificationsHeight }) {
    const toolbar = topOffset;
    let notifications = topOffset;
    let drawers = topOffset;
    if (hasVisibleToolbar) {
        notifications += toolbarHeight;
        drawers += toolbarHeight;
    }
    let header = notifications;
    if (stickyNotifications) header += notificationsHeight;
    return {
        toolbar: toolbar,
        notifications: notifications,
        header: header,
        drawers: drawers
    };
}
function $ff079cc12921495d$export$6bd7ab1bd03ec82c({ hasSplitPanel: hasSplitPanel, splitPanelPosition: splitPanelPosition, placement: placement, splitPanelOpen: splitPanelOpen, splitPanelFullHeight: splitPanelFullHeight, splitPanelHeaderHeight: splitPanelHeaderHeight }) {
    if (!hasSplitPanel || splitPanelPosition !== 'bottom') return {
        stickyVerticalBottomOffset: placement.insetBlockEnd,
        mainContentPaddingBlockEnd: undefined
    };
    const mainContentBottomOffset = splitPanelOpen ? splitPanelFullHeight : splitPanelHeaderHeight;
    return {
        stickyVerticalBottomOffset: mainContentBottomOffset + placement.insetBlockEnd,
        mainContentPaddingBlockEnd: mainContentBottomOffset
    };
}
function $ff079cc12921495d$export$d60a2a5f5d1f1f3d(verticalOffsets, isMobile, placement, activeGlobalBottomDrawerSize = 0) {
    var _a;
    const drawerTopOffset = isMobile ? verticalOffsets.toolbar : (_a = verticalOffsets.drawers) !== null && _a !== void 0 ? _a : placement.insetBlockStart;
    const drawerHeight = `calc(100vh - ${drawerTopOffset}px - ${placement.insetBlockEnd}px - ${activeGlobalBottomDrawerSize}px)`;
    return {
        drawerTopOffset: drawerTopOffset,
        drawerHeight: drawerHeight
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



const $5cb26ec4bd62507c$var$DEFAULT_ON_CHANGE_PARAMS = {
    initiatedByUserAction: true
};
const $5cb26ec4bd62507c$var$MIN_DRAWER_SIZE = 400;
function $5cb26ec4bd62507c$export$ddfe30cba6e4434({ onAiDrawerFocus: onAiDrawerFocus, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, getMaxAiDrawerSize: getMaxAiDrawerSize }) {
    var _a, _b;
    const [runtimeDrawer, setRuntimeDrawer] = (0, $acw62.useState)(null);
    const [activeAiDrawerId, setActiveAiDrawerId] = (0, $acw62.useState)(null);
    const [size, setSize] = (0, $acw62.useState)(null);
    const aiDrawerWasOpenRef = (0, $acw62.useRef)(false);
    aiDrawerWasOpenRef.current = aiDrawerWasOpenRef.current || !!activeAiDrawerId;
    function onActiveAiDrawerResize(size) {
        const limitedSize = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minAiDrawerSize, size, getMaxAiDrawerSize());
        setSize(limitedSize);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.onResize, {
            id: activeAiDrawerId,
            size: limitedSize
        });
    }
    function onActiveAiDrawerChange(newDrawerId, { initiatedByUserAction: initiatedByUserAction } = $5cb26ec4bd62507c$var$DEFAULT_ON_CHANGE_PARAMS) {
        setActiveAiDrawerId(newDrawerId);
        if (newDrawerId) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(runtimeDrawer === null || runtimeDrawer === void 0 ? void 0 : runtimeDrawer.onToggle, {
            isOpen: true,
            initiatedByUserAction: initiatedByUserAction
        });
        if (activeAiDrawerId) {
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(runtimeDrawer === null || runtimeDrawer === void 0 ? void 0 : runtimeDrawer.onToggle, {
                isOpen: false,
                initiatedByUserAction: initiatedByUserAction
            });
            if (activeAiDrawerId === expandedDrawerId) setExpandedDrawerId === null || setExpandedDrawerId === void 0 || setExpandedDrawerId(null);
        }
        onAiDrawerFocus === null || onAiDrawerFocus === void 0 || onAiDrawerFocus();
    }
    function aiDrawerMessageHandler(event) {
        if (event.type === 'registerLeftDrawer') {
            setRuntimeDrawer(event.payload);
            if (!aiDrawerWasOpenRef.current && event.payload.defaultActive) onActiveAiDrawerChange(event.payload.id, {
                initiatedByUserAction: false
            });
            return;
        }
        switch(event.type){
            case 'updateDrawerConfig':
                setRuntimeDrawer((current)=>current ? {
                        ...current,
                        ...event.payload
                    } : current);
                break;
            case 'openDrawer':
                onActiveAiDrawerChange(event.payload.id, {
                    initiatedByUserAction: false
                });
                break;
            case 'closeDrawer':
                onActiveAiDrawerChange(null, {
                    initiatedByUserAction: false
                });
                break;
            case 'resizeDrawer':
                onActiveAiDrawerResize(event.payload.size);
                break;
        }
    }
    const aiDrawer = runtimeDrawer && (0, $43224bb3d30365a9$export$aa60b7f985ef6954)(runtimeDrawer);
    const activeAiDrawer = activeAiDrawerId && activeAiDrawerId === (aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id) ? aiDrawer : null;
    const activeAiDrawerSize = activeAiDrawerId ? (_a = size !== null && size !== void 0 ? size : activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.defaultSize) !== null && _a !== void 0 ? _a : $5cb26ec4bd62507c$var$MIN_DRAWER_SIZE : 0;
    const minAiDrawerSize = Math.min((_b = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.defaultSize) !== null && _b !== void 0 ? _b : $5cb26ec4bd62507c$var$MIN_DRAWER_SIZE, $5cb26ec4bd62507c$var$MIN_DRAWER_SIZE);
    return {
        aiDrawer: aiDrawer,
        aiDrawerMessageHandler: aiDrawerMessageHandler,
        onActiveAiDrawerChange: onActiveAiDrawerChange,
        activeAiDrawer: activeAiDrawer,
        activeAiDrawerId: activeAiDrawerId,
        activeAiDrawerSize: activeAiDrawerSize,
        minAiDrawerSize: minAiDrawerSize,
        onActiveAiDrawerResize: onActiveAiDrawerResize
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $70c0e83ce261f6d3$var$DEFAULT_ON_CHANGE_PARAMS = {
    initiatedByUserAction: true
};
const $70c0e83ce261f6d3$var$MIN_DRAWER_SIZE = 400;
function $70c0e83ce261f6d3$export$cd45e44299c0c156({ onBottomDrawerFocus: onBottomDrawerFocus, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, drawersOpenQueue: drawersOpenQueue }) {
    var _a, _b, _c;
    const [activeBottomDrawerId, setActiveBottomDrawerId] = (0, $acw62.useState)(null);
    const [drawerSizes, setDrawerSizes] = (0, $acw62.useState)({});
    const [runtimeBottomDrawers, setRuntimeBottomDrawers] = (0, $acw62.useState)([]);
    const bottomDrawerWasOpenRef = (0, $acw62.useRef)(false);
    bottomDrawerWasOpenRef.current = bottomDrawerWasOpenRef.current || !!activeBottomDrawerId;
    const bottomDrawers = runtimeBottomDrawers.map((0, $43224bb3d30365a9$export$aa60b7f985ef6954));
    function onActiveBottomDrawerResize({ id: id, size: size }) {
        setDrawerSizes((oldSizes)=>({
                ...oldSizes,
                [id]: size
            }));
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(activeBottomDrawer === null || activeBottomDrawer === void 0 ? void 0 : activeBottomDrawer.onResize, {
            id: id,
            size: size
        });
    }
    function onActiveBottomDrawerChange(drawerId, { initiatedByUserAction: initiatedByUserAction } = $70c0e83ce261f6d3$var$DEFAULT_ON_CHANGE_PARAMS) {
        const drawer = bottomDrawers.find((drawer)=>drawer.id === (drawerId || activeBottomDrawerId));
        setActiveBottomDrawerId(drawerId);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(drawer === null || drawer === void 0 ? void 0 : drawer.onToggle, {
            isOpen: !!drawerId,
            initiatedByUserAction: initiatedByUserAction
        });
        if (activeBottomDrawerId === expandedDrawerId) setExpandedDrawerId(null);
        if (drawerId) drawersOpenQueue.current = [
            drawerId,
            ...drawersOpenQueue.current
        ];
        else drawersOpenQueue.current = drawersOpenQueue.current.filter((id)=>id !== activeBottomDrawerId);
        onBottomDrawerFocus === null || onBottomDrawerFocus === void 0 || onBottomDrawerFocus();
    }
    function bottomDrawersMessageHandler(event) {
        if (event.type === 'registerBottomDrawer') {
            if (bottomDrawers.find((drawer)=>drawer.id === event.payload.id)) return;
            setRuntimeBottomDrawers((existingBottomDrawers)=>[
                    ...existingBottomDrawers,
                    event.payload
                ]);
            if (!bottomDrawerWasOpenRef.current && event.payload.defaultActive) onActiveBottomDrawerChange(event.payload.id, {
                initiatedByUserAction: false
            });
            return;
        }
        switch(event.type){
            case 'updateDrawerConfig':
                setRuntimeBottomDrawers((existingBottomDrawers)=>{
                    return existingBottomDrawers.map((drawer)=>{
                        if (drawer.id === event.payload.id) return {
                            ...drawer,
                            ...event.payload
                        };
                        return drawer;
                    });
                });
                break;
            case 'openDrawer':
                onActiveBottomDrawerChange(event.payload.id, {
                    initiatedByUserAction: false
                });
                break;
            case 'closeDrawer':
                onActiveBottomDrawerChange(null, {
                    initiatedByUserAction: false
                });
                break;
            case 'resizeDrawer':
                onActiveBottomDrawerResize({
                    id: event.payload.id,
                    size: event.payload.size
                });
                break;
        }
    }
    const activeBottomDrawer = activeBottomDrawerId ? bottomDrawers.find((drawer)=>drawer.id === activeBottomDrawerId) : null;
    const activeBottomDrawerSize = activeBottomDrawerId ? (_b = (_a = drawerSizes[activeBottomDrawerId]) !== null && _a !== void 0 ? _a : activeBottomDrawer === null || activeBottomDrawer === void 0 ? void 0 : activeBottomDrawer.defaultSize) !== null && _b !== void 0 ? _b : $70c0e83ce261f6d3$var$MIN_DRAWER_SIZE : 0;
    const minBottomDrawerSize = Math.min((_c = activeBottomDrawer === null || activeBottomDrawer === void 0 ? void 0 : activeBottomDrawer.defaultSize) !== null && _c !== void 0 ? _c : $70c0e83ce261f6d3$var$MIN_DRAWER_SIZE, $70c0e83ce261f6d3$var$MIN_DRAWER_SIZE);
    return {
        bottomDrawers: bottomDrawers,
        activeBottomDrawer: activeBottomDrawer,
        onActiveBottomDrawerChange: onActiveBottomDrawerChange,
        activeBottomDrawerSize: activeBottomDrawerSize,
        minBottomDrawerSize: minBottomDrawerSize,
        onActiveBottomDrawerResize: onActiveBottomDrawerResize,
        bottomDrawersMessageHandler: bottomDrawersMessageHandler
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Method to filter out internal properties prefixed by "__"
 */ const $3833f34df478664f$export$21af416108db3048 = (props)=>{
    const externalPropNames = Object.keys(props).filter((propName)=>propName.indexOf('__') !== 0);
    return externalPropNames.reduce((acc, propName)=>{
        acc[propName] = props[propName];
        return acc;
    }, {});
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $7e52d1d829dbf9fa$export$85b6faccd4f04314 = (0, $acw62.createContext)({});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $4a30639b463663e4$export$8af1424ebe35bf26 = (0, $acw62.createContext)({});
function $4a30639b463663e4$var$applyDefault(fields, defaults, keys) {
    const result = {};
    keys.forEach((key)=>{
        result[key] = fields[key] === undefined ? defaults[key] : fields[key];
    });
    return result;
}
function $4a30639b463663e4$export$824c400da192ca1b(props) {
    const context = (0, $acw62.useContext)($4a30639b463663e4$export$8af1424ebe35bf26);
    return $4a30639b463663e4$var$applyDefault(props, context, [
        'invalid',
        'warning',
        'controlId',
        'ariaLabelledby',
        'ariaDescribedby'
    ]);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $edb6222f981e45e4$export$8ffd2daeac4a0391 = (0, $acw62.createContext)(undefined);



/*
 Use this context-resetter when creating a new modal-type context where typically the contents
 of the modal should not be affected by the surrounding components/DOM.
 */ const $08fba30ddb2cfd8a$var$ResetContextsForModal = ({ children: children })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edea5ac281b34b48$export$24d547caef80ccd1).Provider, {
        value: {
            onClick: ()=>{}
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314).Provider, {
        value: {
            assignId: ()=>{}
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a30639b463663e4$export$8af1424ebe35bf26).Provider, {
        value: {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edb6222f981e45e4$export$8ffd2daeac4a0391).Provider, {
        value: ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9699df5a060a9c12$export$366cdc6257b696ef).Provider, {
        value: (0, $9699df5a060a9c12$export$1a01ae0705bafd37)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.SingleTabStopNavigationReset), null, children))))));
var $08fba30ddb2cfd8a$export$2e2bcd8739ae039 = $08fba30ddb2cfd8a$var$ResetContextsForModal;





var $272216e49c0ac5bb$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1b522_im8v7_5"
};


function $e2cf882075041209$var$InternalFeaturePrompt({ onShow: onShow, onDismiss: onDismiss, header: header, content: content, i18nStrings: i18nStrings, size: size, position: position, getTrack: getTrack, trackKey: trackKey, __internalRootRef: __internalRootRef, ...restProps }, ref) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const [show, setShow] = (0, $acw62.useState)(false);
    const popoverBodyRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            dismiss: ()=>{
                setShow(false);
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss);
            },
            show: ()=>{
                setShow(true);
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onShow);
            }
        }));
    (0, $acw62.useEffect)(()=>{
        if (!show) return;
        const clickListener = (event)=>{
            // Since the listener is registered on the window, `event.target` will incorrectly point at the
            // shadow root if the component is rendered inside shadow DOM.
            const target = event.composedPath ? event.composedPath()[0] : event.target;
            if (!(0, $4c778684f125e678$export$57d4cb221e1d1857)(popoverBodyRef.current, target)) {
                setShow(false);
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
                    method: 'click-outside'
                });
            }
        };
        // Listen for blur events on the window to detect clicks in iframes
        const blurListener = ()=>{
            var _a;
            if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'IFRAME') {
                setShow(false);
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
                    method: 'click-outside'
                });
            }
        };
        const controller = new AbortController();
        window.addEventListener('click', clickListener, {
            signal: controller.signal,
            capture: true
        });
        window.addEventListener('blur', blurListener, {
            signal: controller.signal,
            capture: true
        });
        return ()=>{
            controller.abort();
        };
    }, [
        show,
        onDismiss
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...baseProps,
        className: (0, $272216e49c0ac5bb$export$2e2bcd8739ae039).root,
        ref: __internalRootRef
    }, show && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08fba30ddb2cfd8a$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
        size: size,
        fixedWidth: false,
        position: position,
        getTrack: getTrack,
        trackKey: trackKey,
        variant: "annotation",
        arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b971696cf22f0db1$export$2e2bcd8739ae039), {
                position: position,
                variant: "info"
            }),
        zIndex: 7000,
        renderWithPortal: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
        ref: popoverBodyRef,
        dismissButton: true,
        dismissAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dismissAriaLabel,
        header: header,
        onDismiss: (method)=>{
            setShow(false);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
                method: method
            });
        },
        onBlur: (event)=>{
            if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) {
                setShow(false);
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
                    method: 'blur'
                });
            }
        },
        variant: "feature-prompt",
        overflowVisible: "content"
    }, content)))));
}
var $e2cf882075041209$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($e2cf882075041209$var$InternalFeaturePrompt);


const $c5f122c383344aea$var$FeaturePrompt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ size: size = 'medium', position: position = 'top', ...rest }, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('FeaturePrompt', {
        props: {
            size: size,
            position: position
        }
    });
    const externalProps = (0, $3833f34df478664f$export$21af416108db3048)(rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2cf882075041209$export$2e2bcd8739ae039), {
        ref: ref,
        size: size,
        position: position,
        ...externalProps,
        ...baseComponentProps
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($c5f122c383344aea$var$FeaturePrompt, 'FeaturePrompt');
var $c5f122c383344aea$export$2e2bcd8739ae039 = $c5f122c383344aea$var$FeaturePrompt;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
class $b2a3a043bb8bc1ab$export$acf54e4006a88474 {
}
function $b2a3a043bb8bc1ab$export$9cddaee00efaebb2(promise) {
    let cancelled = false;
    const wrapped = promise.then((value)=>{
        if (cancelled) throw new $b2a3a043bb8bc1ab$export$acf54e4006a88474();
        return value;
    }, (err)=>{
        if (cancelled) throw new $b2a3a043bb8bc1ab$export$acf54e4006a88474();
        throw err;
    });
    return {
        promise: wrapped,
        cancel: ()=>{
            cancelled = true;
        },
        isCancelled: ()=>cancelled
    };
}
function $b2a3a043bb8bc1ab$export$785a3ae04659618d() {
    const promiseRef = (0, $acw62.useRef)();
    if (!promiseRef.current) {
        let resolve;
        const promise = new Promise((res)=>{
            resolve = res;
        });
        promiseRef.current = {
            promise: promise,
            resolve: resolve
        };
    }
    const ref = (0, $acw62.useCallback)((element)=>{
        if (element) promiseRef.current.resolve(element);
    }, []);
    return {
        ref: ref,
        promise: promiseRef.current.promise
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $1yiQH = parcelRequire("1yiQH");

const $abeb4b27c21f8915$export$a6b64d21ee114310 = ({ rootRef: rootRef })=>{
    const [drawerContext, setDrawerContext] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        // Determine if the hook is inside a runtime drawer.
        // There’s no other reliable way to check this, since runtime drawers are separate applications rendered into specific DOM nodes.
        if (!(rootRef === null || rootRef === void 0 ? void 0 : rootRef.current)) return;
        const runtimeDrawerWrapper = (0, $1yiQH.findUpUntil)(rootRef === null || rootRef === void 0 ? void 0 : rootRef.current, (node)=>{
            var _a;
            return !!((_a = node === null || node === void 0 ? void 0 : node.dataset) === null || _a === void 0 ? void 0 : _a.awsuiRuntimeDrawerRootId);
        });
        const drawerId = (_a = runtimeDrawerWrapper === null || runtimeDrawerWrapper === void 0 ? void 0 : runtimeDrawerWrapper.dataset) === null || _a === void 0 ? void 0 : _a.awsuiRuntimeDrawerRootId;
        if (!drawerId) return;
        const drawers = (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayout.getDrawersState();
        setDrawerContext((_b = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === drawerId)) !== null && _b !== void 0 ? _b : null);
        return (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayout.onDrawersUpdated((drawers)=>{
            var _a;
            setDrawerContext((_a = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === drawerId)) !== null && _a !== void 0 ? _a : null);
        });
    }, [
        rootRef
    ]);
    return drawerContext;
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $929891dc2e9a9ff2$export$2e2bcd8739ae039 = {
    "icon-shake": "awsui_icon-shake_1cbgc_rbfxz_153",
    "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_rbfxz_1",
    "container-fade-in": "awsui_container-fade-in_1cbgc_rbfxz_181",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_rbfxz_1",
    "root": "awsui_root_1cbgc_rbfxz_203",
    "status-error": "awsui_status-error_1cbgc_rbfxz_212",
    "status-warning": "awsui_status-warning_1cbgc_rbfxz_215",
    "status-success": "awsui_status-success_1cbgc_rbfxz_218",
    "status-info": "awsui_status-info_1cbgc_rbfxz_221",
    "status-stopped": "awsui_status-stopped_1cbgc_rbfxz_224",
    "status-pending": "awsui_status-pending_1cbgc_rbfxz_227",
    "status-in-progress": "awsui_status-in-progress_1cbgc_rbfxz_230",
    "status-loading": "awsui_status-loading_1cbgc_rbfxz_233",
    "status-not-started": "awsui_status-not-started_1cbgc_rbfxz_236",
    "color-override-red": "awsui_color-override-red_1cbgc_rbfxz_239",
    "color-override-grey": "awsui_color-override-grey_1cbgc_rbfxz_242",
    "color-override-blue": "awsui_color-override-blue_1cbgc_rbfxz_245",
    "color-override-green": "awsui_color-override-green_1cbgc_rbfxz_248",
    "color-override-yellow": "awsui_color-override-yellow_1cbgc_rbfxz_251",
    "container": "awsui_container_1cbgc_rbfxz_181",
    "display-inline": "awsui_display-inline_1cbgc_rbfxz_255",
    "icon": "awsui_icon_1cbgc_rbfxz_153",
    "display-inline-block": "awsui_display-inline-block_1cbgc_rbfxz_263",
    "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_rbfxz_272"
};


const $1ffdf6cc8746b93a$var$typeToIcon = (size)=>({
        error: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-negative",
            size: size
        }),
        warning: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-warning",
            size: size
        }),
        success: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-positive",
            size: size
        }),
        info: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-info",
            size: size
        }),
        stopped: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-stopped",
            size: size
        }),
        pending: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-pending",
            size: size
        }),
        'in-progress': (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-in-progress",
            size: size
        }),
        loading: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), null),
        'not-started': (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-not-started",
            size: size
        })
    });
function $1ffdf6cc8746b93a$export$f1956376d5e22017({ type: type, iconAriaLabel: iconAriaLabel, animate: animate, display: display, size: size = 'normal' }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $929891dc2e9a9ff2$export$2e2bcd8739ae039).icon, animate && (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)['icon-shake']),
        "aria-label": iconAriaLabel,
        role: iconAriaLabel ? 'img' : undefined
    }, $1ffdf6cc8746b93a$var$typeToIcon(size)[type], display === 'inline' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, "\u00A0"));
}
function $1ffdf6cc8746b93a$export$2e2bcd8739ae039({ type: type, children: children, iconAriaLabel: iconAriaLabel, colorOverride: colorOverride, wrapText: wrapText = true, nativeAttributes: nativeAttributes, __animate: __animate = false, __internalRootRef: __internalRootRef, __size: __size = 'normal', __display: __display = 'inline-block', ...rest }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...baseProps,
        tag: "span",
        componentName: "StatusIndicator",
        nativeAttributes: nativeAttributes,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $929891dc2e9a9ff2$export$2e2bcd8739ae039).root, (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)[`status-${type}`], {
            [(0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)[`color-override-${colorOverride}`]]: colorOverride
        }, baseProps.className),
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $929891dc2e9a9ff2$export$2e2bcd8739ae039).container, (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)[`display-${__display}`], wrapText === false && (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)['overflow-ellipsis'], __animate && (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)['container-fade-in'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ffdf6cc8746b93a$export$f1956376d5e22017, {
        type: type,
        iconAriaLabel: iconAriaLabel,
        animate: __animate,
        display: __display,
        size: __size
    }), children));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3d33451aaae58ddb$export$de363e709c412c8a(func, delay, { trailing: trailing = true } = {}) {
    let pending = null;
    let lastInvokeTime = null;
    let timerId = null;
    // Runs on every animation frame until timer stopped.
    function pendingFunc() {
        if (pending === null || lastInvokeTime === null) return;
        const invokeTime = Date.now();
        const shouldInvoke = invokeTime - lastInvokeTime >= delay;
        if (shouldInvoke) {
            func.apply(pending.this, pending.args);
            lastInvokeTime = invokeTime;
            pending = null;
            timerId = null;
        } else if (trailing) startTimer();
    }
    function startTimer() {
        if (timerId) cancelAnimationFrame(timerId);
        timerId = requestAnimationFrame(pendingFunc);
    }
    // Decorated client function with delay mechanism.
    function throttled(...args) {
        if (lastInvokeTime === null) {
            lastInvokeTime = Date.now();
            func.apply(this, args);
        } else {
            pending = {
                this: this,
                args: args
            };
            startTimer();
        }
    }
    // Prevents delayed function from execution when no longer needed.
    throttled.cancel = ()=>{
        if (timerId) cancelAnimationFrame(timerId);
        pending = null;
        lastInvokeTime = null;
        timerId = null;
    };
    return throttled;
}


const $e00a4a6a0e964ac0$export$421784913c73f821 = 148;
const $e00a4a6a0e964ac0$var$STICKY_STATE_CHECK_THROTTLE_DELAY = 100; // every tenth of a second
function $e00a4a6a0e964ac0$export$d252cd00b8daf1cd({ drawerRef: drawerRef, footerRef: footerRef }) {
    const [isSticky, setIsSticky] = (0, $acw62.useState)(true);
    const checkStickyState = (0, $3d33451aaae58ddb$export$de363e709c412c8a)((0, $acw62.useCallback)(()=>{
        if (!(drawerRef === null || drawerRef === void 0 ? void 0 : drawerRef.current) || !(footerRef === null || footerRef === void 0 ? void 0 : footerRef.current)) return;
        const parentElement = drawerRef.current.parentElement;
        const parentElementHeight = parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().height;
        const drawerHeight = drawerRef.current.getBoundingClientRect().height;
        const effectiveHeight = Math.min(parentElementHeight !== null && parentElementHeight !== void 0 ? parentElementHeight : drawerHeight, drawerHeight);
        // take minimum of drawer and parent height
        const footerHeight = footerRef.current.getBoundingClientRect().height;
        const scrollableHeight = effectiveHeight - footerHeight;
        const hasEnoughSpace = scrollableHeight >= $e00a4a6a0e964ac0$export$421784913c73f821;
        setIsSticky(hasEnoughSpace);
    }, [
        footerRef,
        drawerRef
    ]), $e00a4a6a0e964ac0$var$STICKY_STATE_CHECK_THROTTLE_DELAY);
    (0, $013a2451794a45c0$exports.useResizeObserver)(()=>{
        var _a, _b;
        return (_b = (_a = drawerRef === null || drawerRef === void 0 ? void 0 : drawerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) !== null && _b !== void 0 ? _b : null;
    }, checkStickyState);
    return {
        isSticky: isSticky
    };
}



var $058a2164b689fef0$export$2e2bcd8739ae039 = {
    "drawer": "awsui_drawer_1sxt8_1gt83_189",
    "with-footer": "awsui_with-footer_1sxt8_1gt83_221",
    "content": "awsui_content_1sxt8_1gt83_226",
    "header": "awsui_header_1sxt8_1gt83_230",
    "with-additional-action": "awsui_with-additional-action_1sxt8_1gt83_247",
    "with-runtime-context": "awsui_with-runtime-context_1sxt8_1gt83_255",
    "with-toolbar": "awsui_with-toolbar_1sxt8_1gt83_258",
    "header-actions": "awsui_header-actions_1sxt8_1gt83_277",
    "content-with-paddings": "awsui_content-with-paddings_1sxt8_1gt83_283",
    "footer": "awsui_footer_1sxt8_1gt83_290",
    "is-sticky": "awsui_is-sticky_1sxt8_1gt83_296",
    "test-utils-drawer-content": "awsui_test-utils-drawer-content_1sxt8_1gt83_304"
};


function $d3806a3ac91ef0cb$export$cb7da9c73ffd6fba({ header: header, footer: footer, children: children, loading: loading, i18nStrings: i18nStrings, disableContentPaddings: disableContentPaddings, __internalRootRef: __internalRootRef, headerActions: headerActions, ...restProps }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const isToolbar = (0, $73078c4512771f18$export$d38f11a69207eec8)();
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('drawer');
    const containerProps = {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $058a2164b689fef0$export$2e2bcd8739ae039).drawer, isToolbar && (0, $058a2164b689fef0$export$2e2bcd8739ae039)['with-toolbar'], !!footer && (0, $058a2164b689fef0$export$2e2bcd8739ae039)['with-footer'])
    };
    const footerRef = (0, $acw62.useRef)(null);
    const runtimeDrawerContext = (0, $abeb4b27c21f8915$export$a6b64d21ee114310)({
        rootRef: __internalRootRef
    });
    const hasAdditionalDrawerAction = !!(runtimeDrawerContext === null || runtimeDrawerContext === void 0 ? void 0 : runtimeDrawerContext.isExpandable);
    const { isSticky: isFooterSticky } = (0, $e00a4a6a0e964ac0$export$d252cd00b8daf1cd)({
        drawerRef: __internalRootRef,
        footerRef: footerRef
    });
    return loading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...containerProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(containerProps.className, (0, $058a2164b689fef0$export$2e2bcd8739ae039)['content-with-paddings']),
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ffdf6cc8746b93a$export$2e2bcd8739ae039), {
        type: "loading"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span"
    }, i18n('i18nStrings.loadingText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.loadingText)))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...containerProps,
        ref: __internalRootRef
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $058a2164b689fef0$export$2e2bcd8739ae039).header, runtimeDrawerContext && (0, $058a2164b689fef0$export$2e2bcd8739ae039)['with-runtime-context'], hasAdditionalDrawerAction && (0, $058a2164b689fef0$export$2e2bcd8739ae039)['with-additional-action'])
    }, header, headerActions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $058a2164b689fef0$export$2e2bcd8739ae039)['header-actions']
    }, headerActions)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $058a2164b689fef0$export$2e2bcd8739ae039)['test-utils-drawer-content'], (0, $058a2164b689fef0$export$2e2bcd8739ae039).content, !disableContentPaddings && (0, $058a2164b689fef0$export$2e2bcd8739ae039)['content-with-paddings'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), null, children)), footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: footerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $058a2164b689fef0$export$2e2bcd8739ae039).footer, {
            [(0, $058a2164b689fef0$export$2e2bcd8739ae039)['is-sticky']]: isFooterSticky
        })
    }, footer));
}
const $d3806a3ac91ef0cb$export$6dd60c2d53264eb7 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($d3806a3ac91ef0cb$export$cb7da9c73ffd6fba);


const $180d517b8d3982e1$export$9b864af7be484e92 = (0, $d3806a3ac91ef0cb$export$6dd60c2d53264eb7)();



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Prefixes given text with zeros until it reaches the target length.
 */ function $338478df0d3aeeab$export$2da9fd1f854a2a4b(text, length) {
    return text.padStart(length, '0');
}


function $b7857ad8c9833aee$export$3ae94a2503e890a1(value, granularity = 'day') {
    const year = value.getFullYear();
    const month = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getMonth() + 1}`, 2);
    if (granularity === 'month') return `${year}-${month}`;
    const date = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getDate()}`, 2);
    return `${year}-${month}-${date}`;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $3bf083e8e34095b6$export$566f4066c7caac18(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let properties = {};
    if ((style === null || style === void 0 ? void 0 : style.root) && (0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core') properties = {
        ...((_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.color) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorActive]: (_b = style.root.color) === null || _b === void 0 ? void 0 : _b.active,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDefault]: (_c = style.root.color) === null || _c === void 0 ? void 0 : _c.default,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorHover]: (_d = style.root.color) === null || _d === void 0 ? void 0 : _d.hover
        },
        ...((_e = style.root) === null || _e === void 0 ? void 0 : _e.focusRing) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: (_f = style.root.focusRing) === null || _f === void 0 ? void 0 : _f.borderColor,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_g = style.root.focusRing) === null || _g === void 0 ? void 0 : _g.borderRadius,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_h = style.root.focusRing) === null || _h === void 0 ? void 0 : _h.borderWidth
        }
    };
    return properties;
}



var $1f0dcdb6a7d564f1$export$2e2bcd8739ae039 = {
    "link": "awsui_link_4c84z_1icuo_145",
    "variant-secondary": "awsui_variant-secondary_4c84z_1icuo_212",
    "variant-primary": "awsui_variant-primary_4c84z_1icuo_247",
    "variant-info": "awsui_variant-info_4c84z_1icuo_280",
    "variant-value-large": "awsui_variant-value-large_4c84z_1icuo_315",
    "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1icuo_347",
    "variant-recovery": "awsui_variant-recovery_4c84z_1icuo_382",
    "button": "awsui_button_4c84z_1icuo_415",
    "color-inverted": "awsui_color-inverted_4c84z_1icuo_450",
    "font-size-body-s": "awsui_font-size-body-s_4c84z_1icuo_471",
    "font-size-body-m": "awsui_font-size-body-m_4c84z_1icuo_478",
    "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1icuo_484",
    "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1icuo_491",
    "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1icuo_498",
    "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1icuo_505",
    "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1icuo_512",
    "font-size-display-l": "awsui_font-size-display-l_4c84z_1icuo_519",
    "font-size-inherit": "awsui_font-size-inherit_4c84z_1icuo_526",
    "icon-wrapper": "awsui_icon-wrapper_4c84z_1icuo_534",
    "icon": "awsui_icon_4c84z_1icuo_534"
};


const $01503a290f20b804$var$InternalLink = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ variant: providedVariant, fontSize: fontSize = 'body-m', color: color = 'normal', external: external = false, target: target, href: href, rel: rel, ariaLabel: ariaLabel, externalIconAriaLabel: externalIconAriaLabel, onFollow: onFollow, onClick: onClick, children: children, nativeAttributes: nativeAttributes, __internalRootRef: __internalRootRef, style: style, ...props }, ref)=>{
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('Link', href);
    const isButton = !href;
    const { defaultVariant: defaultVariant } = (0, $acw62.useContext)((0, $9699df5a060a9c12$export$366cdc6257b696ef));
    const variant = providedVariant || defaultVariant;
    const specialStyles = [
        'top-navigation',
        'link',
        'recovery'
    ];
    const hasSpecialStyle = specialStyles.indexOf(variant) > -1;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('link');
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const anchorTarget = target !== null && target !== void 0 ? target : external ? '_blank' : undefined;
    const anchorRel = rel !== null && rel !== void 0 ? rel : anchorTarget === '_blank' ? 'noopener noreferrer' : undefined;
    const uniqueId = (0, $013a2451794a45c0$exports.useUniqueId)('link');
    const linkId = (0, $013a2451794a45c0$exports.useUniqueId)('link-self');
    const infoId = (0, $013a2451794a45c0$exports.useUniqueId)('link-info');
    const infoLinkLabelFromContext = (0, $acw62.useContext)((0, $edb6222f981e45e4$export$8ffd2daeac4a0391));
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepIdentifier: stepIdentifier, stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepIdentifier: subStepIdentifier, subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const fireFunnelEvent = (funnelInteractionId)=>{
        if (variant === 'info') {
            const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(subStepNameSelector);
            (0, $54d511b0978bc73c$export$300ddd9f131af3a).helpPanelInteracted({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                subStepIdentifier: subStepIdentifier,
                stepNameSelector: stepNameSelector,
                subStepSelector: subStepSelector,
                subStepName: subStepName,
                subStepNameSelector: subStepNameSelector,
                elementSelector: (0, $285a09b860d2bebc$export$c0773214960ddccc)(uniqueId),
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
            });
        } else if (external) {
            const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(subStepNameSelector);
            (0, $54d511b0978bc73c$export$300ddd9f131af3a).externalLinkInteracted({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                subStepIdentifier: subStepIdentifier,
                subStepSelector: subStepSelector,
                subStepName: subStepName,
                subStepNameSelector: subStepNameSelector,
                elementSelector: (0, $285a09b860d2bebc$export$c0773214960ddccc)(uniqueId),
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
            });
        }
    };
    const fireFollowEvent = (event)=>{
        if (funnelInteractionId) fireFunnelEvent(funnelInteractionId);
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, {
            href: href,
            external: external,
            target: anchorTarget
        }, event);
    };
    const fireClickEvent = (event)=>{
        const { altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
        const button = 'button' in event ? event.button : 0;
        // make onClick non-cancelable to prevent it from being used to block full page reload
        // for navigation use `onFollow` event instead
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onClick, {
            altKey: altKey,
            button: button,
            ctrlKey: ctrlKey,
            metaKey: metaKey,
            shiftKey: shiftKey
        });
    };
    const handleLinkClick = (event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) fireFollowEvent(event);
        fireClickEvent(event);
    };
    const handleButtonClick = (event)=>{
        fireFollowEvent(event);
        fireClickEvent(event);
    };
    const handleButtonKeyDown = (event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space || event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter) {
            event.preventDefault();
            fireFollowEvent(event);
            fireClickEvent(event);
        }
    };
    const linkRef = (0, $acw62.useRef)(null);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, linkRef);
    // Visual refresh should only add styles to buttons that don't already have unique styles (e.g. primary/secondary variants)
    const applyButtonStyles = isButton && isVisualRefresh && !hasSpecialStyle;
    const sharedProps = {
        id: linkId,
        ...baseProps,
        ref: (0, $013a2451794a45c0$exports.useMergeRefs)(linkRef, __internalRootRef),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039).link, baseProps.className, applyButtonStyles ? (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039).button : null, (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)[$01503a290f20b804$var$getVariantStyle(variant)], (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)[$01503a290f20b804$var$getFontSizeStyle(variant, fontSize)], (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)[$01503a290f20b804$var$getColorStyle(variant, color)]),
        style: (0, $3bf083e8e34095b6$export$566f4066c7caac18)(style),
        'aria-label': ariaLabel,
        'aria-labelledby': undefined,
        [(0, $285a09b860d2bebc$export$39e42cde97dfcad)]: uniqueId
    };
    if (variant === 'info' && infoLinkLabelFromContext && !ariaLabel) sharedProps['aria-labelledby'] = `${sharedProps.id} ${infoId} ${infoLinkLabelFromContext}`;
    const renderedExternalIconAriaLabel = i18n('externalIconAriaLabel', externalIconAriaLabel);
    const content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children, external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)['icon-wrapper']
    }, "\u00A0", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039).icon,
        "aria-label": renderedExternalIconAriaLabel,
        role: renderedExternalIconAriaLabel ? 'img' : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "external",
        size: "inherit"
    }))), variant === 'info' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        hidden: true,
        id: infoId
    }, ":"));
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(linkRef, {
        tabIndex: isButton ? 0 : undefined
    });
    if (isButton) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...sharedProps,
        tag: "a",
        componentName: "Link",
        nativeAttributes: nativeAttributes,
        role: "button",
        tabIndex: tabIndex,
        onKeyDown: handleButtonKeyDown,
        onClick: handleButtonClick
    }, content);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...sharedProps,
        tag: "a",
        componentName: "Link",
        nativeAttributes: nativeAttributes,
        tabIndex: tabIndex,
        target: anchorTarget,
        rel: anchorRel,
        href: href,
        onClick: handleLinkClick
    }, content);
});
function $01503a290f20b804$var$getVariantStyle(variant) {
    return `variant-${variant.replace(/^awsui-/, '')}`;
}
function $01503a290f20b804$var$getFontSizeStyle(variant, fontSize) {
    switch(variant){
        case 'info':
            return 'font-size-body-s';
        case 'awsui-value-large':
            return 'font-size-display-l';
        default:
            return `font-size-${fontSize}`;
    }
}
function $01503a290f20b804$var$getColorStyle(variant, color) {
    return `color-${variant === 'info' ? 'normal' : color}`;
}
var $01503a290f20b804$export$2e2bcd8739ae039 = $01503a290f20b804$var$InternalLink;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $0030bffa1359ca92$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $0030bffa1359ca92$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $0030bffa1359ca92$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $0030bffa1359ca92$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $0030bffa1359ca92$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $0030bffa1359ca92$export$62858bae88b53fd0(node) {
    const { Document: Document } = $0030bffa1359ca92$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $0030bffa1359ca92$export$1b3bfaa9684536aa(node) {
    if ($0030bffa1359ca92$export$5a096129d439f843(node)) return false;
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).HTMLElement;
}
function $0030bffa1359ca92$export$17eda790a720ec57(node) {
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).SVGElement;
}
function $0030bffa1359ca92$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target.document;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return document;
    if ($0030bffa1359ca92$export$62858bae88b53fd0(target)) return target;
    if ($0030bffa1359ca92$export$1b3bfaa9684536aa(target) || $0030bffa1359ca92$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $0030bffa1359ca92$export$700979bc83e7db82 = $0030bffa1359ca92$export$71594e8a50f746f4 ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $0030bffa1359ca92$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $acw62.useRef)(handler);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $0030bffa1359ca92$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $acw62.useRef)(null);
    const set = (0, $acw62.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $acw62.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $0030bffa1359ca92$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $acw62.useRef)(value);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $0030bffa1359ca92$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $acw62.useRef)();
    return (0, $acw62.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $0030bffa1359ca92$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $0030bffa1359ca92$export$90fc3a17d93f704c(onChange);
    const node = (0, $acw62.useRef)(null);
    const setNodeRef = (0, $acw62.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $0030bffa1359ca92$export$5cae361ad82dce8b(value) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $0030bffa1359ca92$var$ids = {};
function $0030bffa1359ca92$export$c485849f2e393253(prefix, value) {
    return (0, $acw62.useMemo)(()=>{
        if (value) return value;
        const id = $0030bffa1359ca92$var$ids[prefix] == null ? 0 : $0030bffa1359ca92$var$ids[prefix] + 1;
        $0030bffa1359ca92$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $0030bffa1359ca92$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $0030bffa1359ca92$export$e16d8520af44a096 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(1);
const $0030bffa1359ca92$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(-1);
function $0030bffa1359ca92$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $0030bffa1359ca92$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $0030bffa1359ca92$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $0030bffa1359ca92$export$36195c8aa1517e04(event) {
    if ($0030bffa1359ca92$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($0030bffa1359ca92$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $0030bffa1359ca92$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $0030bffa1359ca92$export$c4ffa16951855e28.Translate.toString(transform),
                $0030bffa1359ca92$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $0030bffa1359ca92$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $0030bffa1359ca92$export$44f71d798fd0a62b(element) {
    if (element.matches($0030bffa1359ca92$var$SELECTOR)) return element;
    return element.querySelector($0030bffa1359ca92$var$SELECTOR);
}



var $acw62 = parcelRequire("acw62");
const $768971a59ac63485$var$hiddenStyles = {
    display: 'none'
};
function $768971a59ac63485$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: $768971a59ac63485$var$hiddenStyles
    }, value);
}
function $768971a59ac63485$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $768971a59ac63485$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $acw62.useState)('');
    const announce = (0, $acw62.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $0bb7808e9486acbd$var$DndMonitorContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $0bb7808e9486acbd$export$1182af90218a7b81(listener) {
    const registerListener = (0, $acw62.useContext)($0bb7808e9486acbd$var$DndMonitorContext);
    (0, $acw62.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $0bb7808e9486acbd$var$useDndMonitorProvider() {
    const [listeners] = (0, $acw62.useState)(()=>new Set());
    const registerListener = (0, $acw62.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $acw62.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $0bb7808e9486acbd$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $0bb7808e9486acbd$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $0bb7808e9486acbd$var$Accessibility(_ref) {
    let { announcements: announcements = $0bb7808e9486acbd$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $0bb7808e9486acbd$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $768971a59ac63485$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
    }, []);
    $0bb7808e9486acbd$export$1182af90218a7b81((0, $acw62.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $11492dca620dcaa5$exports.createPortal)(markup, container) : markup;
}
var $0bb7808e9486acbd$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($0bb7808e9486acbd$var$Action || ($0bb7808e9486acbd$var$Action = {}));
function $0bb7808e9486acbd$var$noop() {}
function $0bb7808e9486acbd$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $acw62.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $0bb7808e9486acbd$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $0bb7808e9486acbd$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $0bb7808e9486acbd$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $0bb7808e9486acbd$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $0bb7808e9486acbd$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $0bb7808e9486acbd$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $0bb7808e9486acbd$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $0bb7808e9486acbd$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $0bb7808e9486acbd$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $0bb7808e9486acbd$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $0bb7808e9486acbd$var$distanceBetween($0bb7808e9486acbd$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $0bb7808e9486acbd$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $0bb7808e9486acbd$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $0bb7808e9486acbd$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $0bb7808e9486acbd$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $0bb7808e9486acbd$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $0bb7808e9486acbd$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $0bb7808e9486acbd$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $0bb7808e9486acbd$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
function $0bb7808e9486acbd$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $0bb7808e9486acbd$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $0bb7808e9486acbd$var$getAdjustedRect = /*#__PURE__*/ $0bb7808e9486acbd$var$createRectAdjustmentFn(1);
function $0bb7808e9486acbd$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $0bb7808e9486acbd$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $0bb7808e9486acbd$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $0bb7808e9486acbd$var$getTransformAgnosticClientRect(element) {
    return $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $0bb7808e9486acbd$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $0bb7808e9486acbd$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $0bb7808e9486acbd$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $0bb7808e9486acbd$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(node) || (0, $0030bffa1359ca92$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($0bb7808e9486acbd$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($0bb7808e9486acbd$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $0bb7808e9486acbd$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $0bb7808e9486acbd$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $0bb7808e9486acbd$var$getScrollableElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return null;
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element;
    if (!(0, $0030bffa1359ca92$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(element) || element === (0, $0030bffa1359ca92$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $0bb7808e9486acbd$var$getScrollXCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $0bb7808e9486acbd$var$getScrollYCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $0bb7808e9486acbd$var$getScrollCoordinates(element) {
    return {
        x: $0bb7808e9486acbd$var$getScrollXCoordinate(element),
        y: $0bb7808e9486acbd$var$getScrollYCoordinate(element)
    };
}
var $0bb7808e9486acbd$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($0bb7808e9486acbd$var$Direction || ($0bb7808e9486acbd$var$Direction = {}));
function $0bb7808e9486acbd$var$isDocumentScrollingElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $0bb7808e9486acbd$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $0bb7808e9486acbd$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $0bb7808e9486acbd$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $0bb7808e9486acbd$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $0bb7808e9486acbd$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $0bb7808e9486acbd$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $0bb7808e9486acbd$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $0bb7808e9486acbd$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $0bb7808e9486acbd$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, $0bb7808e9486acbd$var$getScrollCoordinates(node));
    }, $0bb7808e9486acbd$export$597cbd7bbd10deb4);
}
function $0bb7808e9486acbd$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollXCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollYCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $0bb7808e9486acbd$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $0bb7808e9486acbd$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $0bb7808e9486acbd$var$getScrollYOffset
    ]
];
class $0bb7808e9486acbd$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $0bb7808e9486acbd$export$e4864aa91b5ed091(element);
        const scrollOffsets = $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $0bb7808e9486acbd$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $0bb7808e9486acbd$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $0bb7808e9486acbd$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
}
function $0bb7808e9486acbd$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $0bb7808e9486acbd$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($0bb7808e9486acbd$var$EventName || ($0bb7808e9486acbd$var$EventName = {}));
function $0bb7808e9486acbd$var$preventDefault(event) {
    event.preventDefault();
}
function $0bb7808e9486acbd$var$stopPropagation(event) {
    event.stopPropagation();
}
var $0bb7808e9486acbd$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($0bb7808e9486acbd$export$a8b1916dba3ae88b || ($0bb7808e9486acbd$export$a8b1916dba3ae88b = {}));
const $0bb7808e9486acbd$var$defaultKeyboardCodes = {
    start: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Tab
    ]
};
const $0bb7808e9486acbd$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $0bb7808e9486acbd$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$b204af158042fbac)(target));
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(node);
        onStart($0bb7808e9486acbd$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $0030bffa1359ca92$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $0bb7808e9486acbd$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $0bb7808e9486acbd$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && !isRight || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && !isBottom || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $0030bffa1359ca92$export$e16d8520af44a096)((0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$0bb7808e9486acbd$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $0bb7808e9486acbd$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $0bb7808e9486acbd$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $0bb7808e9486acbd$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
        this.documentListeners = new $0bb7808e9486acbd$var$Listeners(this.document);
        this.listeners = new $0bb7808e9486acbd$var$Listeners(listenerTarget);
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.DragStart, $0bb7808e9486acbd$var$preventDefault);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.ContextMenu, $0bb7808e9486acbd$var$preventDefault);
        this.documentListeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.Click, $0bb7808e9486acbd$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        const delta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $0bb7808e9486acbd$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $0bb7808e9486acbd$export$b26af955418d6638 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $0030bffa1359ca92$export$b204af158042fbac)(event.target);
        super(props, $0bb7808e9486acbd$var$events, listenerTarget);
    }
}
$0bb7808e9486acbd$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $0bb7808e9486acbd$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($0bb7808e9486acbd$var$MouseButton || ($0bb7808e9486acbd$var$MouseButton = {}));
class $0bb7808e9486acbd$export$b28554b50bf7f273 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$1, (0, $0030bffa1359ca92$export$b204af158042fbac)(props.event.target));
    }
}
$0bb7808e9486acbd$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $0bb7808e9486acbd$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $0bb7808e9486acbd$export$19b41baf2e1bcdc0 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($0bb7808e9486acbd$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($0bb7808e9486acbd$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$0bb7808e9486acbd$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $0bb7808e9486acbd$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($0bb7808e9486acbd$export$eefe60e26f04c318 || ($0bb7808e9486acbd$export$eefe60e26f04c318 = {}));
var $0bb7808e9486acbd$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($0bb7808e9486acbd$export$f93aa492a37e1b0e || ($0bb7808e9486acbd$export$f93aa492a37e1b0e = {}));
function $0bb7808e9486acbd$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $0bb7808e9486acbd$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $0030bffa1359ca92$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $acw62.useMemo)(()=>{
        switch(activator){
            case $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $0bb7808e9486acbd$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $acw62.useRef)(null);
    const autoScroll = (0, $acw62.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $acw62.useMemo)(()=>order === $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $0bb7808e9486acbd$var$defaultScrollIntent = {
    x: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    },
    y: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    }
};
function $0bb7808e9486acbd$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(delta);
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $0bb7808e9486acbd$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Backward] || direction.x === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Backward] || direction.y === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $0bb7808e9486acbd$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $0bb7808e9486acbd$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $acw62.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $0bb7808e9486acbd$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($0bb7808e9486acbd$export$571c10ffffe014ab || ($0bb7808e9486acbd$export$571c10ffffe014ab = {}));
var $0bb7808e9486acbd$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($0bb7808e9486acbd$export$8e062c3160beefd5 || ($0bb7808e9486acbd$export$8e062c3160beefd5 = {}));
const $0bb7808e9486acbd$var$defaultValue = /*#__PURE__*/ new Map();
function $0bb7808e9486acbd$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $acw62.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $acw62.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $acw62.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $acw62.useRef)(null);
    const droppableRects = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $0bb7808e9486acbd$var$defaultValue;
        if (!previousValue || previousValue === $0bb7808e9486acbd$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $0bb7808e9486acbd$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $acw62.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $0bb7808e9486acbd$export$571c10ffffe014ab.Always:
                return false;
            case $0bb7808e9486acbd$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $0bb7808e9486acbd$var$useInitialValue(value, computeFn) {
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $0bb7808e9486acbd$var$useInitialRect(node, measure) {
    return $0bb7808e9486acbd$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $0bb7808e9486acbd$var$defaultMeasure(element) {
    return new $0bb7808e9486acbd$var$Rect($0bb7808e9486acbd$export$b6aa1f30c53d7454(element), element);
}
function $0bb7808e9486acbd$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $0bb7808e9486acbd$var$defaultMeasure;
    const [rect, setRect] = (0, $acw62.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $0bb7808e9486acbd$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRect
    });
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $0bb7808e9486acbd$var$useRectDelta(rect) {
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(rect);
    return $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
}
const $0bb7808e9486acbd$var$defaultValue$1 = [];
function $0bb7808e9486acbd$var$useScrollableAncestors(node) {
    const previousNode = (0, $acw62.useRef)(node);
    const ancestors = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $0bb7808e9486acbd$var$defaultValue$1;
        if (previousValue && previousValue !== $0bb7808e9486acbd$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $0bb7808e9486acbd$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $acw62.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $0bb7808e9486acbd$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $acw62.useState)(null);
    const prevElements = (0, $acw62.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $acw62.useCallback)((event)=>{
        const scrollingElement = $0bb7808e9486acbd$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $0bb7808e9486acbd$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $0bb7808e9486acbd$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $acw62.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, coordinates), $0bb7808e9486acbd$export$597cbd7bbd10deb4) : $0bb7808e9486acbd$var$getScrollOffsets(elements);
        return $0bb7808e9486acbd$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $acw62.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$useSensorSetup(sensors) {
    (0, $acw62.useEffect)(()=>{
        if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $0bb7808e9486acbd$var$useSyntheticListeners(listeners, id) {
    return (0, $acw62.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $0bb7808e9486acbd$var$useWindowRect(element) {
    return (0, $acw62.useMemo)(()=>element ? $0bb7808e9486acbd$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $0bb7808e9486acbd$var$defaultValue$2 = [];
function $0bb7808e9486acbd$var$useRects(elements, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(firstElement ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $acw62.useState)($0bb7808e9486acbd$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $0bb7808e9486acbd$var$defaultValue$2;
            return elements.map((element)=>$0bb7808e9486acbd$var$isDocumentScrollingElement(element) ? windowRect : new $0bb7808e9486acbd$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRects
    });
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $0bb7808e9486acbd$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $0bb7808e9486acbd$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $acw62.useState)(null);
    const handleResize = (0, $acw62.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $acw62.useCallback)((element)=>{
        const node = $0bb7808e9486acbd$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    return (0, $acw62.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $0bb7808e9486acbd$var$defaultSensors = [
    {
        sensor: $0bb7808e9486acbd$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $0bb7808e9486acbd$export$44d67f2a438aeba9,
        options: {}
    }
];
const $0bb7808e9486acbd$var$defaultData = {
    current: {}
};
const $0bb7808e9486acbd$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect,
        strategy: $0bb7808e9486acbd$export$571c10ffffe014ab.WhileDragging,
        frequency: $0bb7808e9486acbd$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $0bb7808e9486acbd$export$b6aa1f30c53d7454
    }
};
class $0bb7808e9486acbd$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $0bb7808e9486acbd$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $0bb7808e9486acbd$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $0bb7808e9486acbd$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $0bb7808e9486acbd$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $0bb7808e9486acbd$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $0bb7808e9486acbd$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop
};
const $0bb7808e9486acbd$var$InternalContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultInternalContext);
const $0bb7808e9486acbd$var$PublicContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultPublicContext);
function $0bb7808e9486acbd$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $0bb7808e9486acbd$var$DroppableContainersMap()
        }
    };
}
function $0bb7808e9486acbd$var$reducer(state, action) {
    switch(action.type){
        case $0bb7808e9486acbd$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $0bb7808e9486acbd$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.DragEnd:
        case $0bb7808e9486acbd$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $0bb7808e9486acbd$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previousActivatorEvent = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $0030bffa1359ca92$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $0030bffa1359ca92$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $0bb7808e9486acbd$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $0bb7808e9486acbd$var$useMeasuringConfiguration(config) {
    return (0, $acw62.useMemo)(()=>({
            draggable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $acw62.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $0bb7808e9486acbd$var$ActiveDraggableContext = /*#__PURE__*/ (0, $acw62.createContext)({
    ...$0bb7808e9486acbd$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $0bb7808e9486acbd$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($0bb7808e9486acbd$var$Status || ($0bb7808e9486acbd$var$Status = {}));
const $0bb7808e9486acbd$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $acw62.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $0bb7808e9486acbd$var$defaultSensors, collisionDetection: collisionDetection = $0bb7808e9486acbd$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $acw62.useReducer)($0bb7808e9486acbd$var$reducer, undefined, $0bb7808e9486acbd$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $0bb7808e9486acbd$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $acw62.useState)($0bb7808e9486acbd$var$Status.Uninitialized);
    const isInitialized = status === $0bb7808e9486acbd$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $acw62.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $acw62.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $0bb7808e9486acbd$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $acw62.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $acw62.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $acw62.useState)(null);
    const latestProps = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $acw62.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $0bb7808e9486acbd$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $0bb7808e9486acbd$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $0bb7808e9486acbd$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $acw62.useMemo)(()=>activatorEvent ? (0, $0030bffa1359ca92$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $0bb7808e9486acbd$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $0bb7808e9486acbd$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $0bb7808e9486acbd$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $acw62.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $0bb7808e9486acbd$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $0bb7808e9486acbd$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(draggingNode ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $0bb7808e9486acbd$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $0bb7808e9486acbd$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $0030bffa1359ca92$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $0bb7808e9486acbd$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $0bb7808e9486acbd$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $acw62.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $0bb7808e9486acbd$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $acw62.useRef)(null);
    const instantiateSensor = (0, $acw62.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($0bb7808e9486acbd$var$Status.Initializing);
                    dispatch({
                        type: $0bb7808e9486acbd$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $0bb7808e9486acbd$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($0bb7808e9486acbd$var$Action.DragEnd),
            onCancel: createHandler($0bb7808e9486acbd$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $0bb7808e9486acbd$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $0bb7808e9486acbd$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($0bb7808e9486acbd$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $0bb7808e9486acbd$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $acw62.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $0bb7808e9486acbd$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $0bb7808e9486acbd$var$useSensorSetup(sensors);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $0bb7808e9486acbd$var$Status.Initializing) setStatus($0bb7808e9486acbd$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $acw62.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $acw62.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $0bb7808e9486acbd$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $acw62.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $acw62.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $0bb7808e9486acbd$var$NullContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $0bb7808e9486acbd$var$defaultRole = 'button';
const $0bb7808e9486acbd$var$ID_PREFIX = 'Draggable';
function $0bb7808e9486acbd$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const { role: role = $0bb7808e9486acbd$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $acw62.useContext)(isDragging ? $0bb7808e9486acbd$var$ActiveDraggableContext : $0bb7808e9486acbd$var$NullContext);
    const [node, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const listeners = $0bb7808e9486acbd$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $acw62.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $0bb7808e9486acbd$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $0bb7808e9486acbd$export$4930f6bf413be70e() {
    return (0, $acw62.useContext)($0bb7808e9486acbd$var$PublicContext);
}
const $0bb7808e9486acbd$var$ID_PREFIX$1 = 'Droppable';
const $0bb7808e9486acbd$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $0bb7808e9486acbd$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previous = (0, $acw62.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $acw62.useRef)(false);
    const rect = (0, $acw62.useRef)(null);
    const callbackId = (0, $acw62.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$0bb7808e9486acbd$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $acw62.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $acw62.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $acw62.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch({
            type: $0bb7808e9486acbd$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $0bb7808e9486acbd$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $0bb7808e9486acbd$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $0bb7808e9486acbd$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $acw62.useState)(null);
    const [element, setElement] = (0, $acw62.useState)(null);
    const previousChildren = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children, clonedChildren ? (0, $acw62.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $0bb7808e9486acbd$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $0bb7808e9486acbd$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultTransform
    }, children));
}
const $0bb7808e9486acbd$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $0bb7808e9486acbd$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $0bb7808e9486acbd$var$PositionedOverlay = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $0bb7808e9486acbd$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$0bb7808e9486acbd$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $0bb7808e9486acbd$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $0bb7808e9486acbd$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $0bb7808e9486acbd$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $0bb7808e9486acbd$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $0bb7808e9486acbd$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $0bb7808e9486acbd$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $0bb7808e9486acbd$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $0030bffa1359ca92$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $0bb7808e9486acbd$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $0bb7808e9486acbd$var$createDefaultDropAnimation(config);
        $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $0bb7808e9486acbd$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$0bb7808e9486acbd$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $0bb7808e9486acbd$var$key = 0;
function $0bb7808e9486acbd$var$useKey(id) {
    return (0, $acw62.useMemo)(()=>{
        if (id == null) return;
        $0bb7808e9486acbd$var$key++;
        return $0bb7808e9486acbd$var$key;
    }, [
        id
    ]);
}
const $0bb7808e9486acbd$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $0bb7808e9486acbd$export$4930f6bf413be70e();
    const transform = (0, $acw62.useContext)($0bb7808e9486acbd$var$ActiveDraggableContext);
    const key = $0bb7808e9486acbd$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(activeNodeRect);
    const dropAnimation = $0bb7808e9486acbd$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $acw62 = parcelRequire("acw62");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $0332ec5baeac6793$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $0332ec5baeac6793$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $0332ec5baeac6793$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $0332ec5baeac6793$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $0332ec5baeac6793$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0332ec5baeac6793$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$0332ec5baeac6793$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
};
function $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $0332ec5baeac6793$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $0332ec5baeac6793$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $0332ec5baeac6793$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$0332ec5baeac6793$var$defaultScale$1
        };
    }
    const itemGap = $0332ec5baeac6793$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
};
function $0332ec5baeac6793$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $0332ec5baeac6793$var$ID_PREFIX = 'Sortable';
const $0332ec5baeac6793$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    activeIndex: -1,
    containerId: $0332ec5baeac6793$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $0332ec5baeac6793$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $0332ec5baeac6793$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $0332ec5baeac6793$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $0bb7808e9486acbd$export$4930f6bf413be70e)();
    const containerId = (0, $0030bffa1359ca92$export$c485849f2e393253)($0332ec5baeac6793$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $acw62.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $acw62.useRef)(items);
    const itemsHaveChanged = !$0332ec5baeac6793$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $0332ec5baeac6793$var$normalizeDisabled(disabledProp);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $acw62.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $0332ec5baeac6793$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0332ec5baeac6793$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $0332ec5baeac6793$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $0332ec5baeac6793$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $0332ec5baeac6793$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $0332ec5baeac6793$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $0332ec5baeac6793$var$transitionProperty = 'transform';
const $0332ec5baeac6793$var$disabledTransition = /*#__PURE__*/ (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
    property: $0332ec5baeac6793$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $0332ec5baeac6793$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $0332ec5baeac6793$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $acw62.useState)(null);
    const previousIndex = (0, $acw62.useRef)(index);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $0bb7808e9486acbd$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $acw62.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $0332ec5baeac6793$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $0332ec5baeac6793$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $0332ec5baeac6793$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $0332ec5baeac6793$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $acw62.useContext)($0332ec5baeac6793$var$Context);
    const disabled = $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $acw62.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $acw62.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $0bb7808e9486acbd$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $0bb7808e9486acbd$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$0332ec5baeac6793$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $0030bffa1359ca92$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $acw62.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $0332ec5baeac6793$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $acw62.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $acw62.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId && !previous.current.activeId) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $0332ec5baeac6793$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $0332ec5baeac6793$var$transitionProperty
        });
        return undefined;
    }
}
function $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $0332ec5baeac6793$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $0332ec5baeac6793$var$directions = [
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left
];
const $0332ec5baeac6793$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($0332ec5baeac6793$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $0bb7808e9486acbd$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $0bb7808e9486acbd$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $0bb7808e9486acbd$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $0332ec5baeac6793$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $0332ec5baeac6793$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $0332ec5baeac6793$var$isSameContainer(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $0332ec5baeac6793$var$isAfter(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    if (!$0332ec5baeac6793$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Joins strings with a whitespace, discarding empty strings. Useful to combine multiple aria-labels.
 */ function $49fa9e74c692ea64$export$b933cda3796739ed(...strings) {
    return strings.filter(Boolean).join(' ') || undefined;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $89ad4640bf55de42$export$8e49444f78fbbdb8;
(function(EventName) {
    EventName["Blur"] = "blur";
    EventName["Keydown"] = "keydown";
    EventName["Resize"] = "resize";
    EventName["VisibilityChange"] = "visibilitychange";
    EventName["CustomDown"] = "custom-movedown";
    EventName["CustomUp"] = "custom-moveup";
})($89ad4640bf55de42$export$8e49444f78fbbdb8 || ($89ad4640bf55de42$export$8e49444f78fbbdb8 = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $cf6378a5457d937f$export$f540d32a5bb3e030 = {
    start: [
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Space,
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Enter
    ],
    cancel: [
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Esc
    ],
    end: [
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Space,
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Enter
    ]
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $d38ddebdee6e0f81$export$3bcecaeba2732bae {
    constructor(target){
        this.target = target;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _a;
                return (_a = this.target) === null || _a === void 0 ? void 0 : _a.removeEventListener(...listener);
            });
        };
    }
    add(eventName, handler, options) {
        var _a;
        (_a = this.target) === null || _a === void 0 || _a.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $dc830c0a07b0efab$var$isDocumentScrollingElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $dc830c0a07b0efab$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $dc830c0a07b0efab$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
function $dc830c0a07b0efab$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $dc830c0a07b0efab$export$d9e2a939777fb2bd({ currentCoordinates: currentCoordinates, direction: direction, newCoordinates: newCoordinates, scrollableAncestors: scrollableAncestors }) {
    for (const scrollContainer of scrollableAncestors){
        const coordinatesDelta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
        const { isTop: isTop, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $dc830c0a07b0efab$var$getScrollPosition(scrollContainer);
        const scrollElementRect = $dc830c0a07b0efab$var$getScrollElementRect(scrollContainer);
        const clampedCoordinates = {
            y: Math.min(direction === 'down' ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === 'down' ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
        };
        const canScrollY = direction === 'down' && !isBottom || direction === 'up' && !isTop;
        if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
            const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
            const canScrollToNewCoordinates = direction === 'down' && newScrollCoordinates <= maxScroll.y || direction === 'up' && newScrollCoordinates >= minScroll.y;
            if (canScrollToNewCoordinates) {
                // We don't need to update coordinates, the scroll adjustment alone will trigger
                // logic to auto-detect the new container we are over
                scrollContainer.scrollTo({
                    top: newScrollCoordinates,
                    behavior: 'smooth'
                });
                return true;
            }
            break;
        }
    }
    return false;
}


class $38f306f43e19cecd$export$c2082cbbfc7d563f {
    constructor(props){
        this.props = props;
        this.autoScrollEnabled = false;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new (0, $d38ddebdee6e0f81$export$3bcecaeba2732bae)((0, $0030bffa1359ca92$export$b204af158042fbac)(target));
        this.windowListeners = new (0, $d38ddebdee6e0f81$export$3bcecaeba2732bae)((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCustomDirectionEvent = this.handleCustomDirectionEvent.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        var _a;
        this.handleStart();
        this.windowListeners.add((0, $89ad4640bf55de42$export$8e49444f78fbbdb8).Resize, this.handleCancel);
        this.windowListeners.add((0, $89ad4640bf55de42$export$8e49444f78fbbdb8).VisibilityChange, this.handleCancel);
        (_a = this.props.event.target) === null || _a === void 0 || _a.addEventListener((0, $89ad4640bf55de42$export$8e49444f78fbbdb8).Blur, this.handleEnd);
        setTimeout(()=>{
            this.listeners.add((0, $89ad4640bf55de42$export$8e49444f78fbbdb8).Keydown, this.handleKeyDown);
            this.listeners.add((0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomDown, this.handleCustomDirectionEvent);
            this.listeners.add((0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomUp, this.handleCustomDirectionEvent);
        });
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) (0, $24d40242cc6554ee$export$a904af9c1628c179)(node);
        onStart((0, $0bb7808e9486acbd$export$597cbd7bbd10deb4));
    }
    handleKeyDown(event) {
        if ((0, $0030bffa1359ca92$export$130b789831072f4c)(event)) {
            const { options: options } = this.props;
            const { keyboardCodes: keyboardCodes = (0, $cf6378a5457d937f$export$f540d32a5bb3e030) } = options;
            const { code: code } = event;
            if (keyboardCodes.end.indexOf(code) !== -1) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.indexOf(code) !== -1) {
                this.handleCancel(event);
                return;
            }
            switch(code){
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up:
                    this.handleDirectionalMove(event, 'up');
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down:
                    this.handleDirectionalMove(event, 'down');
                    break;
            }
        }
    }
    handleCustomDirectionEvent(event) {
        switch(event.type){
            case (0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomUp:
                this.handleDirectionalMove(event, 'up');
                break;
            case (0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomDown:
                this.handleDirectionalMove(event, 'down');
                break;
        }
    }
    handleDirectionalMove(event, direction) {
        const { active: active, context: context, options: options } = this.props;
        const { coordinateGetter: coordinateGetter } = options;
        const { collisionRect: collisionRect } = context.current;
        const currentCoordinates = collisionRect ? {
            x: collisionRect.left,
            y: collisionRect.top
        } : (0, $0bb7808e9486acbd$export$597cbd7bbd10deb4);
        if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
        const newCoordinates = coordinateGetter(event, {
            active: active,
            context: context.current,
            currentCoordinates: currentCoordinates
        });
        if (newCoordinates) {
            const { scrollableAncestors: scrollableAncestors } = context.current;
            const scrolled = (0, $dc830c0a07b0efab$export$d9e2a939777fb2bd)({
                currentCoordinates: currentCoordinates,
                direction: direction,
                newCoordinates: newCoordinates,
                scrollableAncestors: scrollableAncestors
            });
            if (!scrolled) this.handleMove(event, (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates));
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        if (event.type !== (0, $89ad4640bf55de42$export$8e49444f78fbbdb8).Blur) event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        var _a;
        (_a = this.props.event.target) === null || _a === void 0 || _a.removeEventListener((0, $89ad4640bf55de42$export$8e49444f78fbbdb8).Blur, this.handleCancel);
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$38f306f43e19cecd$export$c2082cbbfc7d563f.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, { keyboardCodes: keyboardCodes = (0, $cf6378a5457d937f$export$f540d32a5bb3e030), onActivation: onActivation }, { active: active })=>{
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.indexOf(code) !== -1) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation === null || onActivation === void 0 || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    },
    {
        eventName: 'onClick',
        handler: ({ nativeEvent: event }, { onActivation: onActivation })=>{
            if (event.button !== 0) return false;
            onActivation === null || onActivation === void 0 || onActivation({
                event: event
            });
            return true;
        }
    }
];



function $76483b883ee1c98d$export$2e2bcd8739ae039({ items: items, itemDefinition: itemDefinition }) {
    const isKeyboard = (0, $acw62.useRef)(false);
    const positionDelta = (0, $acw62.useRef)(0);
    const [activeItemId, setActiveItemId] = (0, $acw62.useState)(null);
    const setActiveItem = (id)=>{
        setActiveItemId(id);
        if (!id) {
            isKeyboard.current = false;
            positionDelta.current = 0;
        }
    };
    const handleKeyDown = (event)=>{
        if (isKeyboard.current && activeItemId) {
            const currentTargetIndex = items.findIndex((item)=>itemDefinition.id(item) === activeItemId) + positionDelta.current;
            if ((event.key === 'ArrowDown' || event.type === (0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomDown) && currentTargetIndex < items.length - 1) positionDelta.current += 1;
            else if ((event.key === 'ArrowUp' || event.type === (0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomUp) && currentTargetIndex > 0) positionDelta.current -= 1;
        }
        if (activeItemId && $76483b883ee1c98d$var$isEscape(event.key)) // Prevent modal from closing when pressing Esc to cancel the dragging action
        event.stopPropagation();
    };
    const getClosestId = (active)=>{
        if (positionDelta.current === 0) return active.id;
        const currentIndex = items.findIndex((item)=>itemDefinition.id(item) === active.id);
        const newIndex = Math.max(0, Math.min(items.length - 1, currentIndex + positionDelta.current));
        return itemDefinition.id(items[newIndex]);
    };
    const collisionDetection = ({ active: active, collisionRect: collisionRect, droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates })=>{
        if (isKeyboard.current) {
            // For keyboard interaction, determine the colliding container based on the movements made by the arrow keys,
            // via getClosestId
            const collidingContainer = $76483b883ee1c98d$var$getCollidingContainer({
                activeId: active.id,
                closestId: getClosestId(active),
                droppableContainers: droppableContainers
            });
            return collidingContainer ? [
                collidingContainer
            ] : [];
        } else // For mouse interaction, use the closest center algorithm
        return (0, $0bb7808e9486acbd$export$c8e785ae6b74bab8)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: droppableContainers,
            pointerCoordinates: pointerCoordinates
        });
    };
    const coordinateGetter = (event, { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } })=>{
        event.preventDefault();
        if (!active || !collisionRect) return;
        const closestId = getClosestId(active);
        if (closestId !== null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable === null || newDroppable === void 0 ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const isAfterActive = $76483b883ee1c98d$var$isAfter(activeDroppable, newDroppable);
                const offset = {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                return {
                    x: rectCoordinates.x - offset.x,
                    y: rectCoordinates.y - offset.y
                };
            }
        }
    };
    const sensors = (0, $0bb7808e9486acbd$export$19012f58216d597f)((0, $0bb7808e9486acbd$export$cc72dd71f4ec69eb)((0, $0bb7808e9486acbd$export$b26af955418d6638), {
        activationConstraint: {
            // allow KeyboardSensor (click to display UAP) to take priority
            // if handle is clicked without movement
            distance: 1
        }
    }), (0, $0bb7808e9486acbd$export$cc72dd71f4ec69eb)((0, $38f306f43e19cecd$export$c2082cbbfc7d563f), {
        coordinateGetter: coordinateGetter,
        onActivation: ()=>{
            isKeyboard.current = true;
        }
    }));
    return {
        activeItemId: activeItemId,
        setActiveItemId: setActiveItem,
        collisionDetection: collisionDetection,
        coordinateGetter: coordinateGetter,
        handleKeyDown: handleKeyDown,
        sensors: sensors,
        isKeyboard: isKeyboard
    };
}
function $76483b883ee1c98d$var$isAfter(a, b) {
    return (0, $0332ec5baeac6793$export$6424ec8a0d450b09)(a) && (0, $0332ec5baeac6793$export$6424ec8a0d450b09)(b) && a.data.current.sortable.index < b.data.current.sortable.index;
}
function $76483b883ee1c98d$var$getCollidingContainer({ activeId: activeId, closestId: closestId, droppableContainers: droppableContainers }) {
    if (closestId === activeId) return;
    const collidingContainer = droppableContainers.find(({ id: id })=>id === closestId);
    if (collidingContainer) return {
        id: collidingContainer.id,
        data: {
            droppableContainer: collidingContainer,
            value: 0
        }
    };
}
const $76483b883ee1c98d$var$isEscape = (key)=>key === 'Escape' || key === 'Esc';


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $3e8dbcd4f45d884d$export$c6a6b36ab85a3fbc = (format)=>(position, total)=>format({
            position: position,
            total: total
        });
const $3e8dbcd4f45d884d$export$1a85e9c4114850f5 = (format)=>(initialPosition, currentPosition, total)=>format({
            currentPosition: currentPosition,
            total: total,
            isInitialPosition: `${initialPosition === currentPosition}`
        });
const $3e8dbcd4f45d884d$export$944f43f20f281623 = (format)=>(initialPosition, finalPosition, total)=>format({
            initialPosition: initialPosition,
            finalPosition: finalPosition,
            total: total,
            isInitialPosition: `${initialPosition === finalPosition}`
        });
function $3e8dbcd4f45d884d$export$2e2bcd8739ae039({ items: items, itemDefinition: itemDefinition, isDragging: isDragging, liveAnnouncementDndStarted: liveAnnouncementDndStarted, liveAnnouncementDndItemReordered: liveAnnouncementDndItemReordered, liveAnnouncementDndItemCommitted: liveAnnouncementDndItemCommitted, liveAnnouncementDndDiscarded: liveAnnouncementDndDiscarded }) {
    const isFirstAnnouncement = (0, $acw62.useRef)(true);
    if (!isDragging) isFirstAnnouncement.current = true;
    return {
        onDragStart ({ active: active }) {
            if (active && liveAnnouncementDndStarted) {
                const index = items.findIndex((item)=>itemDefinition.id(item) === active.id);
                return liveAnnouncementDndStarted(index + 1, items.length);
            }
        },
        onDragOver ({ active: active, over: over }) {
            if (liveAnnouncementDndItemReordered) {
                // Don't announce on the first dragOver because it's redundant with onDragStart.
                if (isFirstAnnouncement.current) {
                    isFirstAnnouncement.current = false;
                    if (!over || over.id === active.id) return;
                }
                const initialIndex = items.findIndex((item)=>itemDefinition.id(item) === active.id);
                const currentIdex = over ? items.findIndex((item)=>itemDefinition.id(item) === over.id) : initialIndex;
                return liveAnnouncementDndItemReordered(initialIndex + 1, currentIdex + 1, items.length);
            }
        },
        onDragEnd ({ active: active, over: over }) {
            if (liveAnnouncementDndItemCommitted) {
                const initialIndex = items.findIndex((item)=>itemDefinition.id(item) === active.id);
                const finalIndex = over ? items.findIndex((item)=>itemDefinition.id(item) === over.id) : initialIndex;
                return liveAnnouncementDndItemCommitted(initialIndex + 1, finalIndex + 1, items.length);
            }
        },
        onDragCancel () {
            return liveAnnouncementDndDiscarded;
        }
    };
}



var $45d396daef5a942d$export$2e2bcd8739ae039 = {
    "drag-overlay": "awsui_drag-overlay_1ksmw_1wocz_145",
    "drag-overlay-item": "awsui_drag-overlay-item_1ksmw_1wocz_149",
    "drag-overlay-container": "awsui_drag-overlay-container_1ksmw_1wocz_174",
    "active": "awsui_active_1ksmw_1wocz_200",
    "placeholder": "awsui_placeholder_1ksmw_1wocz_210",
    "placeholder-item": "awsui_placeholder-item_1ksmw_1wocz_219",
    "placeholder-container": "awsui_placeholder-container_1ksmw_1wocz_225",
    "sorting": "awsui_sorting_1ksmw_1wocz_232"
};


function $7f16f0ed8e62b4fc$export$2e2bcd8739ae039({ items: items, itemDefinition: itemDefinition, renderItem: renderItem, onItemsChange: onItemsChange, disableReorder: disableReorder, i18nStrings: i18nStrings }) {
    var _a;
    const { activeItemId: activeItemId, setActiveItemId: setActiveItemId, collisionDetection: collisionDetection, handleKeyDown: handleKeyDown, sensors: sensors, isKeyboard: isKeyboard } = (0, $76483b883ee1c98d$export$2e2bcd8739ae039)({
        items: items,
        itemDefinition: itemDefinition
    });
    const activeItem = activeItemId ? items.find((item)=>itemDefinition.id(item) === activeItemId) : null;
    const isDragging = activeItemId !== null;
    const announcements = (0, $3e8dbcd4f45d884d$export$2e2bcd8739ae039)({
        items: items,
        itemDefinition: itemDefinition,
        isDragging: isDragging,
        ...i18nStrings
    });
    const portalContainer = $7f16f0ed8e62b4fc$var$usePortalContainer();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0bb7808e9486acbd$export$2d5c5ceac203fc1e), {
        sensors: sensors,
        collisionDetection: collisionDetection,
        accessibility: {
            announcements: announcements,
            restoreFocus: false,
            screenReaderInstructions: (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dragHandleAriaDescription) ? {
                draggable: i18nStrings.dragHandleAriaDescription
            } : undefined,
            container: portalContainer !== null && portalContainer !== void 0 ? portalContainer : undefined
        },
        onDragStart: ({ active: active })=>setActiveItemId(active.id),
        onDragEnd: (event)=>{
            setActiveItemId(null);
            const { active: active, over: over } = event;
            if (over && active.id !== over.id) {
                const movedItem = items.find((item)=>itemDefinition.id(item) === active.id);
                const oldIndex = items.findIndex((item)=>itemDefinition.id(item) === active.id);
                const newIndex = items.findIndex((item)=>itemDefinition.id(item) === over.id);
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onItemsChange, {
                    items: (0, $0332ec5baeac6793$export$5d49d615ad5ea2b0)([
                        ...items
                    ], oldIndex, newIndex),
                    movedItem: movedItem
                });
            }
        },
        onDragCancel: ()=>setActiveItemId(null)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
        disabled: disableReorder,
        items: items.map((item)=>itemDefinition.id(item)),
        strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e)
    }, items.map((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7f16f0ed8e62b4fc$var$DraggableItem, {
            key: itemDefinition.id(item),
            item: item,
            itemDefinition: itemDefinition,
            showDirectionButtons: item === activeItem && isKeyboard.current,
            renderItem: renderItem,
            onKeyDown: handleKeyDown,
            dragHandleAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dragHandleAriaLabel
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), {
        container: portalContainer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0bb7808e9486acbd$export$aca73479aa40659d), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $45d396daef5a942d$export$2e2bcd8739ae039)['drag-overlay'], (0, $45d396daef5a942d$export$2e2bcd8739ae039)[`drag-overlay-${$7f16f0ed8e62b4fc$export$338bd55eb7714bfe(itemDefinition)}`]),
        dropAnimation: null,
        style: {
            zIndex: 5000
        },
        transition: isKeyboard.current ? 'transform 250ms' : ''
    }, activeItem && renderItem({
        item: activeItem,
        id: activeItemId.toString(),
        style: {},
        className: (0, $45d396daef5a942d$export$2e2bcd8739ae039).active,
        isDropPlaceholder: true,
        isSortingActive: false,
        isDragGhost: true,
        dragHandleProps: {
            ariaLabel: (_a = (0, $49fa9e74c692ea64$export$b933cda3796739ed)(i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dragHandleAriaLabel, itemDefinition.label(activeItem))) !== null && _a !== void 0 ? _a : '',
            active: true,
            onKeyDown: handleKeyDown
        }
    }))));
}
function $7f16f0ed8e62b4fc$var$usePortalContainer() {
    const portalContainerRef = (0, $acw62.useRef)(typeof document !== 'undefined' ? document.createElement('div') : null);
    (0, $acw62.useEffect)(()=>{
        const container = portalContainerRef.current;
        if (container && !container.isConnected) document.body.appendChild(container);
        return ()=>{
            if (container && container.isConnected) document.body.removeChild(container);
        };
    }, []);
    return portalContainerRef.current;
}
function $7f16f0ed8e62b4fc$var$DraggableItem({ item: item, itemDefinition: itemDefinition, dragHandleAriaLabel: dragHandleAriaLabel, showDirectionButtons: showDirectionButtons, onKeyDown: onKeyDown, renderItem: renderItem }) {
    var _a;
    const id = itemDefinition.id(item);
    const { isDragging: isDragging, isSorting: isSorting, listeners: listeners, setNodeRef: setNodeRef, transform: transform, attributes: attributes } = (0, $0332ec5baeac6793$export$4ebcb6201122185a)({
        id: id
    });
    const style = {
        transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Translate.toString(transform)
    };
    const dragHandleListeners = attributes['aria-disabled'] ? {} : {
        ...listeners,
        onKeyDown: (event)=>{
            if (onKeyDown) onKeyDown(event);
            if (listeners === null || listeners === void 0 ? void 0 : listeners.onKeyDown) listeners.onKeyDown(event);
        }
    };
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(isDragging && (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $45d396daef5a942d$export$2e2bcd8739ae039).placeholder, (0, $45d396daef5a942d$export$2e2bcd8739ae039)[`placeholder-${$7f16f0ed8e62b4fc$export$338bd55eb7714bfe(itemDefinition)}`]), isSorting && (0, $45d396daef5a942d$export$2e2bcd8739ae039).sorting);
    const dragHandleRef = (0, $acw62.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderItem({
        item: item,
        id: id,
        ref: setNodeRef,
        style: style,
        className: className,
        isDropPlaceholder: isDragging,
        isSortingActive: isSorting,
        isDragGhost: false,
        dragHandleProps: {
            ...dragHandleListeners,
            ariaLabel: (_a = (0, $49fa9e74c692ea64$export$b933cda3796739ed)(dragHandleAriaLabel, itemDefinition.label(item))) !== null && _a !== void 0 ? _a : '',
            ariaDescribedby: attributes['aria-describedby'],
            disabled: attributes['aria-disabled'],
            triggerMode: 'controlled',
            controlledShowButtons: showDirectionButtons,
            ref: dragHandleRef,
            directions: showDirectionButtons ? {
                'block-start': 'active',
                'block-end': 'active'
            } : undefined,
            onDirectionClick: (direction)=>{
                var _a;
                const event = new Event(direction === 'block-start' ? (0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomUp : (0, $89ad4640bf55de42$export$8e49444f78fbbdb8).CustomDown, {
                    bubbles: true,
                    cancelable: true
                });
                onKeyDown(event);
                (_a = dragHandleRef.current) === null || _a === void 0 || _a.dispatchEvent(event);
            }
        }
    }));
}
function $7f16f0ed8e62b4fc$export$338bd55eb7714bfe(itemDefinition) {
    var _a;
    return (_a = itemDefinition.borderRadius) !== null && _a !== void 0 ? _a : 'item';
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $b980e557c26ffea8$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1ifko_1wryl_145",
    "disable-paddings": "awsui_disable-paddings_1ifko_1wryl_183",
    "main": "awsui_main_1ifko_1wryl_187",
    "content-wrap": "awsui_content-wrap_1ifko_1wryl_194",
    "wrap-actions": "awsui_wrap-actions_1ifko_1wryl_204",
    "content": "awsui_content_1ifko_1wryl_194",
    "actions": "awsui_actions_1ifko_1wryl_213"
};



var $7af313b12391c174$export$2e2bcd8739ae039 = {
    "content": "awsui_content_x6dl3_7yzrg_5",
    "icon": "awsui_icon_x6dl3_7yzrg_6",
    "actions": "awsui_actions_x6dl3_7yzrg_7",
    "secondary": "awsui_secondary_x6dl3_7yzrg_8"
};


function $7ca858140cb1d9d9$export$2e2bcd8739ae039({ content: content, icon: icon, actions: actions, secondaryContent: secondaryContent, disablePaddings: disablePaddings, wrapActions: wrapActions = true, className: className }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b980e557c26ffea8$export$2e2bcd8739ae039).root, (0, $7af313b12391c174$export$2e2bcd8739ae039).root, disablePaddings && (0, $b980e557c26ffea8$export$2e2bcd8739ae039)['disable-paddings'], className)
    }, icon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b980e557c26ffea8$export$2e2bcd8739ae039).icon, (0, $7af313b12391c174$export$2e2bcd8739ae039).icon)
    }, icon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b980e557c26ffea8$export$2e2bcd8739ae039).main)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b980e557c26ffea8$export$2e2bcd8739ae039)['content-wrap'], wrapActions && (0, $b980e557c26ffea8$export$2e2bcd8739ae039)['wrap-actions'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b980e557c26ffea8$export$2e2bcd8739ae039).content, (0, $7af313b12391c174$export$2e2bcd8739ae039).content)
    }, content), actions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b980e557c26ffea8$export$2e2bcd8739ae039).actions, (0, $7af313b12391c174$export$2e2bcd8739ae039).actions)
    }, actions)), secondaryContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b980e557c26ffea8$export$2e2bcd8739ae039).secondary, (0, $7af313b12391c174$export$2e2bcd8739ae039).secondary)
    }, secondaryContent)));
}




var $5328805fc7a99cef$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1axkx_1swaz_145",
    "item": "awsui_item_1axkx_1swaz_183",
    "disable-item-paddings": "awsui_disable-item-paddings_1axkx_1swaz_186",
    "disable-paddings": "awsui_disable-paddings_1axkx_1swaz_189",
    "sortable-item": "awsui_sortable-item_1axkx_1swaz_196"
};



var $6c76ca87aee0a4ce$export$2e2bcd8739ae039 = {
    "root": "awsui_root_rckk5_b9f2m_5",
    "item": "awsui_item_rckk5_b9f2m_6"
};


const $0399fe4d1a89f30e$var$extractValidStructuredItemProps = ({ content: content, secondaryContent: secondaryContent, icon: icon, actions: actions })=>({
        content: content,
        secondaryContent: secondaryContent,
        icon: icon,
        actions: actions
    });
function $0399fe4d1a89f30e$export$2e2bcd8739ae039({ items: items, renderItem: renderItem, sortable: sortable = false, sortDisabled: sortDisabled = false, tagOverride: Tag = sortable ? 'ol' : 'ul', ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, onSortingChange: onSortingChange, i18nStrings: i18nStrings, disablePaddings: disablePaddings, disableItemPaddings: disableItemPaddings, __internalRootRef: __internalRootRef, ...rest }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('list');
    let contents;
    if (sortable) contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f16f0ed8e62b4fc$export$2e2bcd8739ae039), {
        items: items,
        disableReorder: sortDisabled,
        itemDefinition: {
            id: (item)=>renderItem(item).id,
            label: (item)=>{
                var _a;
                const details = renderItem(item);
                return (_a = details.announcementLabel) !== null && _a !== void 0 ? _a : details.content;
            }
        },
        onItemsChange: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSortingChange, {
                items: event.detail.items
            }),
        i18nStrings: {
            liveAnnouncementDndStarted: i18n('liveAnnouncementDndStarted', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.liveAnnouncementDndStarted, (0, $3e8dbcd4f45d884d$export$c6a6b36ab85a3fbc)),
            liveAnnouncementDndItemReordered: i18n('liveAnnouncementDndItemReordered', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.liveAnnouncementDndItemReordered, (0, $3e8dbcd4f45d884d$export$1a85e9c4114850f5)),
            liveAnnouncementDndItemCommitted: i18n('liveAnnouncementDndItemCommitted', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.liveAnnouncementDndItemCommitted, (0, $3e8dbcd4f45d884d$export$944f43f20f281623)),
            liveAnnouncementDndDiscarded: i18n('liveAnnouncementDndDiscarded', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.liveAnnouncementDndDiscarded),
            dragHandleAriaLabel: i18n('dragHandleAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dragHandleAriaLabel),
            dragHandleAriaDescription: i18n('dragHandleAriaDescription', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dragHandleAriaDescription)
        },
        renderItem: ({ ref: ref, item: item, id: id, style: style, className: className, dragHandleProps: dragHandleProps, isDragGhost: isDragGhost })=>{
            const structuredItemProps = $0399fe4d1a89f30e$var$extractValidStructuredItemProps(renderItem(item));
            const itemClass = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $5328805fc7a99cef$export$2e2bcd8739ae039).item, (0, $6c76ca87aee0a4ce$export$2e2bcd8739ae039).item, disableItemPaddings && (0, $5328805fc7a99cef$export$2e2bcd8739ae039)['disable-item-paddings'], (0, $5328805fc7a99cef$export$2e2bcd8739ae039)['sortable-item'], className);
            const content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02800872363c99e3$export$2e2bcd8739ae039), {
                ...dragHandleProps
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ca858140cb1d9d9$export$2e2bcd8739ae039), {
                ...structuredItemProps,
                disablePaddings: disableItemPaddings
            }));
            if (isDragGhost) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: itemClass
            }, content);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                ref: ref,
                className: itemClass,
                style: style,
                "data-testid": id
            }, content);
        }
    });
    else contents = items === null || items === void 0 ? void 0 : items.map((item)=>{
        const { id: id, ...structuredItemProps } = renderItem(item);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: id,
            "data-testid": id,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $5328805fc7a99cef$export$2e2bcd8739ae039).item, (0, $6c76ca87aee0a4ce$export$2e2bcd8739ae039).item, disablePaddings && (0, $5328805fc7a99cef$export$2e2bcd8739ae039)['disable-paddings'], disableItemPaddings && (0, $5328805fc7a99cef$export$2e2bcd8739ae039)['disable-item-paddings'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ca858140cb1d9d9$export$2e2bcd8739ae039), {
            ...$0399fe4d1a89f30e$var$extractValidStructuredItemProps(structuredItemProps),
            disablePaddings: disableItemPaddings
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ref: __internalRootRef,
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $5328805fc7a99cef$export$2e2bcd8739ae039).root, (0, $6c76ca87aee0a4ce$export$2e2bcd8739ae039).root),
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby
    }, contents);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Vendored from react-keyed-flatten-children@3.2.0 (MIT License)
// Original source: https://github.com/grrowl/react-keyed-flatten-children

var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));



/* Returns React children into an array, flattening fragments. */ function $2cba335dbbac6d3a$var$isFragmentWithChildren(node) {
    return (0, $3251146683c5d714$exports.isFragment)(node);
}
function $2cba335dbbac6d3a$export$2e2bcd8739ae039(children, depth = 0, keys = [], componentName) {
    return (0, $acw62.Children).toArray(children).reduce((acc, node, nodeIndex)=>{
        if ($2cba335dbbac6d3a$var$isFragmentWithChildren(node)) {
            (0, $013a2451794a45c0$exports.warnOnce)(componentName, 'React.Fragment children are flattened in React 18 but not in React 19+. Use arrays instead of fragments for consistent behavior.');
            acc.push(...$2cba335dbbac6d3a$export$2e2bcd8739ae039(node.props.children, depth + 1, keys.concat(node.key || nodeIndex), componentName));
        } else if ((0, $acw62.isValidElement)(node)) acc.push((0, $acw62.cloneElement)(node, {
            key: keys.concat(String(node.key)).join('.')
        }));
        else if (typeof node === 'string' || typeof node === 'number') acc.push(node);
        return acc;
    }, []);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $068f50ec85b2a943$export$2d016a329b7f12c9() {
    var _a;
    const versionString = (_a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version) === null || _a === void 0 ? void 0 : _a.split('.')[0];
    return versionString ? parseInt(versionString, 10) : NaN;
}


function $ba51633932c6dcad$export$ad59fee0807e8d38(children, componentName) {
    const majorVersion = (0, $068f50ec85b2a943$export$2d016a329b7f12c9)();
    if (!Number.isNaN(majorVersion) && majorVersion < 19) return (0, $2cba335dbbac6d3a$export$2e2bcd8739ae039)(children, 0, [], componentName);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
}




var $c6c0a833d340e863$export$2e2bcd8739ae039 = {
    "root": "awsui_root_18582_1jqoe_145",
    "child": "awsui_child_18582_1jqoe_149",
    "horizontal": "awsui_horizontal_18582_1jqoe_160",
    "horizontal-xxxs": "awsui_horizontal-xxxs_18582_1jqoe_164",
    "horizontal-xxs": "awsui_horizontal-xxs_18582_1jqoe_167",
    "horizontal-xs": "awsui_horizontal-xs_18582_1jqoe_170",
    "horizontal-s": "awsui_horizontal-s_18582_1jqoe_173",
    "horizontal-m": "awsui_horizontal-m_18582_1jqoe_176",
    "horizontal-l": "awsui_horizontal-l_18582_1jqoe_179",
    "horizontal-xl": "awsui_horizontal-xl_18582_1jqoe_182",
    "horizontal-xxl": "awsui_horizontal-xxl_18582_1jqoe_185",
    "vertical": "awsui_vertical_18582_1jqoe_192",
    "vertical-xxxs": "awsui_vertical-xxxs_18582_1jqoe_195",
    "vertical-xxs": "awsui_vertical-xxs_18582_1jqoe_198",
    "vertical-xs": "awsui_vertical-xs_18582_1jqoe_201",
    "vertical-s": "awsui_vertical-s_18582_1jqoe_204",
    "vertical-m": "awsui_vertical-m_18582_1jqoe_207",
    "vertical-l": "awsui_vertical-l_18582_1jqoe_210",
    "vertical-xl": "awsui_vertical-xl_18582_1jqoe_213",
    "vertical-xxl": "awsui_vertical-xxl_18582_1jqoe_216",
    "align-center": "awsui_align-center_18582_1jqoe_220",
    "align-start": "awsui_align-start_18582_1jqoe_224",
    "align-end": "awsui_align-end_18582_1jqoe_228"
};


const $dbf1224d55e2b5c5$var$InternalSpaceBetween = (0, $acw62.forwardRef)(({ direction: direction = 'vertical', size: size, children: children, alignItems: alignItems, nativeAttributes: nativeAttributes, __internalRootRef: __internalRootRef, ...props }, ref)=>{
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(ref, __internalRootRef);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    /*
   Flattening the children allows us to "see through" React Fragments and nested arrays.
   */ const flattenedChildren = (0, $ba51633932c6dcad$export$ad59fee0807e8d38)(children, 'SpaceBetween');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...baseProps,
        tag: "div",
        componentName: "SpaceBetween",
        nativeAttributes: nativeAttributes,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $c6c0a833d340e863$export$2e2bcd8739ae039).root, (0, $c6c0a833d340e863$export$2e2bcd8739ae039)[direction], (0, $c6c0a833d340e863$export$2e2bcd8739ae039)[`${direction}-${size}`], alignItems && (0, $c6c0a833d340e863$export$2e2bcd8739ae039)[`align-${alignItems}`]),
        ref: mergedRef
    }, flattenedChildren.map((child)=>{
        // If this react child is a primitive value, the key will be undefined
        const key = child && typeof child === 'object' ? child.key : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ? String(key) : undefined,
            className: (0, $c6c0a833d340e863$export$2e2bcd8739ae039).child
        }, child);
    }));
});
var $dbf1224d55e2b5c5$export$2e2bcd8739ae039 = $dbf1224d55e2b5c5$var$InternalSpaceBetween;



var $ed46c0bdd69f76cb$export$2e2bcd8739ae039 = {
    "drawer": "awsui_drawer_12i0j_101qa_193",
    "with-expanded-motion": "awsui_with-expanded-motion_12i0j_101qa_207",
    "legacy": "awsui_legacy_12i0j_101qa_221",
    "ai-drawer": "awsui_ai-drawer_12i0j_101qa_221",
    "bottom-drawer": "awsui_bottom-drawer_12i0j_101qa_221",
    "last-opened": "awsui_last-opened_12i0j_101qa_229",
    "drawer-global": "awsui_drawer-global_12i0j_101qa_233",
    "drawer-expanded": "awsui_drawer-expanded_12i0j_101qa_242",
    "drawer-hidden": "awsui_drawer-hidden_12i0j_101qa_246",
    "has-next-siblings": "awsui_has-next-siblings_12i0j_101qa_256",
    "global-drawer-wrapper": "awsui_global-drawer-wrapper_12i0j_101qa_256",
    "drawer-content-container": "awsui_drawer-content-container_12i0j_101qa_270",
    "drawer-gap": "awsui_drawer-gap_12i0j_101qa_273",
    "drawer-close-button": "awsui_drawer-close-button_12i0j_101qa_291",
    "drawer-expanded-mode-button": "awsui_drawer-expanded-mode-button_12i0j_101qa_297",
    "drawer-content": "awsui_drawer-content_12i0j_101qa_270",
    "drawer-content-hidden": "awsui_drawer-content-hidden_12i0j_101qa_309",
    "drawer-slider": "awsui_drawer-slider_12i0j_101qa_312",
    "drawer-actions": "awsui_drawer-actions_12i0j_101qa_364",
    "ai-drawer-slider-handle": "awsui_ai-drawer-slider-handle_12i0j_101qa_421",
    "drawer-content-header": "awsui_drawer-content-header_12i0j_101qa_440",
    "drawer-content-header-content": "awsui_drawer-content-header-content_12i0j_101qa_453",
    "drawer-back-to-console-slot": "awsui_drawer-back-to-console-slot_12i0j_101qa_470",
    "drawer-back-to-console-button-wrapper": "awsui_drawer-back-to-console-button-wrapper_12i0j_101qa_509",
    "drawer-back-to-console-button": "awsui_drawer-back-to-console-button_12i0j_101qa_509",
    "drawer-back-to-console-custom-button": "awsui_drawer-back-to-console-custom-button_12i0j_101qa_582",
    "drawer-content-content": "awsui_drawer-content-content_12i0j_101qa_588",
    "bottom-drawer-content-header": "awsui_bottom-drawer-content-header_12i0j_101qa_646",
    "bottom-drawer-content-header-content": "awsui_bottom-drawer-content-header-content_12i0j_101qa_653",
    "bottom-drawer-actions": "awsui_bottom-drawer-actions_12i0j_101qa_661",
    "runtime-feature-notifications-drawer-content": "awsui_runtime-feature-notifications-drawer-content_12i0j_101qa_669",
    "runtime-feature-notifications-footer": "awsui_runtime-feature-notifications-footer_12i0j_101qa_673"
};


function $78b4c852d1af0c1a$export$b9c59dfba65c173({ content: content, mountContent: mountContent }) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!(mountContent && ref.current)) return;
        const container = ref.current;
        const destructor = mountContent(container, content);
        return ()=>{
            destructor === null || destructor === void 0 || destructor();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return mountContent ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, content);
}
function $78b4c852d1af0c1a$export$2e2bcd8739ae039({ features: features, mountItem: mountItem, featuresPageLink: featuresPageLink }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('features-notification-drawer');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $180d517b8d3982e1$export$9b864af7be484e92), {
        header: i18n('i18nStrings.title', undefined),
        disableContentPaddings: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['runtime-feature-notifications-drawer-content']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        padding: {
            top: 'm',
            left: 'xl',
            right: 'xl',
            bottom: 'm'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0399fe4d1a89f30e$export$2e2bcd8739ae039), {
        items: features,
        renderItem: (item)=>({
                id: item.id,
                content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
                    variant: "h3"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78b4c852d1af0c1a$export$b9c59dfba65c173, {
                    mountContent: mountItem,
                    content: item.header
                })),
                secondaryContent: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
                    size: "xs",
                    direction: "vertical"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
                    fontSize: "body-s",
                    color: "text-body-secondary"
                }, (0, $b7857ad8c9833aee$export$3ae94a2503e890a1)(item.releaseDate)), !!item.contentCategory && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78b4c852d1af0c1a$export$b9c59dfba65c173, {
                    mountContent: mountItem,
                    content: item.contentCategory
                })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78b4c852d1af0c1a$export$b9c59dfba65c173, {
                    mountContent: mountItem,
                    content: item.content
                })))
            })
    }), !!featuresPageLink && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("footer", {
        className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['runtime-feature-notifications-footer']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        padding: {
            top: 's'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01503a290f20b804$export$2e2bcd8739ae039), {
        href: featuresPageLink
    }, i18n('i18nStrings.viewAll', undefined)))))));
}


const $118f790bb239ec43$var$DEFAULT_PERSISTENCE_CONFIG = {
    uniqueKey: 'awsui-feature-notifications'
};
const $118f790bb239ec43$var$FEATURE_NOTIFICATIONS_RETENTION_DAYS = 180;
const $118f790bb239ec43$var$DEFAULT_FEATURE_FILTER_DAYS = 90;
function $118f790bb239ec43$var$subtractDaysFromDate(currentDate, daysToSubtract = 0) {
    const pastDate = new Date(currentDate);
    pastDate.setDate(pastDate.getDate() - daysToSubtract);
    return pastDate;
}
function $118f790bb239ec43$var$filterOutdatedFeatures(features) {
    const cutoffDate = $118f790bb239ec43$var$subtractDaysFromDate(new Date(), $118f790bb239ec43$var$FEATURE_NOTIFICATIONS_RETENTION_DAYS);
    return Object.keys(features).reduce((acc, key)=>{
        const featureDate = new Date(features[key]);
        if (featureDate && featureDate >= cutoffDate) return {
            ...acc,
            [key]: features[key]
        };
        return acc;
    }, {});
}
function $118f790bb239ec43$export$3742f45130d1cd85() {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('features-notification-drawer');
    const [featurePromptDismissed, setFeaturePromptDismissed] = (0, $acw62.useState)(false);
    const [featureNotificationsData, setFeatureNotificationsData] = (0, $acw62.useState)(null);
    const [seenFeatures, setSeenFeatures] = (0, $acw62.useState)({});
    const featurePromptRef = (0, $acw62.useRef)(null);
    const { ref: featurePromptMountRef, promise: featurePromptMountPromise } = (0, $b2a3a043bb8bc1ab$export$785a3ae04659618d)();
    const featurePromptMergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(featurePromptRef, featurePromptMountRef);
    const allNotificationsSeen = (0, $acw62.useMemo)(()=>{
        return featureNotificationsData === null || featureNotificationsData === void 0 ? void 0 : featureNotificationsData.features.every((feature)=>!!seenFeatures[feature.id]);
    }, [
        featureNotificationsData,
        seenFeatures
    ]);
    const defaultFeaturesFilter = (feature)=>{
        return feature.releaseDate >= $118f790bb239ec43$var$subtractDaysFromDate(new Date(), $118f790bb239ec43$var$DEFAULT_FEATURE_FILTER_DAYS);
    };
    const getFeaturesToDisplay = (payload)=>{
        return payload.features.slice().filter(payload.filterFeatures ? payload.filterFeatures : defaultFeaturesFilter).sort((a, b)=>b.releaseDate.getTime() - a.releaseDate.getTime());
    };
    const mapPayloadToDrawer = (payload)=>{
        var _a;
        return {
            id: payload.id,
            content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78b4c852d1af0c1a$export$2e2bcd8739ae039), {
                features: payload.features,
                featuresPageLink: payload.featuresPageLink,
                mountItem: payload.mountItem
            }),
            trigger: {
                iconName: 'suggestions'
            },
            ariaLabels: {
                closeButton: i18n('ariaLabels.closeButton', undefined),
                drawerName: (_a = i18n('ariaLabels.content', undefined)) !== null && _a !== void 0 ? _a : '',
                triggerButton: i18n('ariaLabels.triggerButton', undefined),
                resizeHandle: i18n('ariaLabels.resizeHandle', undefined)
            },
            resizable: true,
            defaultSize: 320,
            badge: payload.badge
        };
    };
    function featureNotificationsMessageHandler(event) {
        var _a, _b;
        if (event.type === 'registerFeatureNotifications') {
            const { payload: payload } = event;
            const features = getFeaturesToDisplay(payload);
            if (features.length === 0) return;
            setFeatureNotificationsData({
                ...payload,
                features: features
            });
            const persistenceConfig = (_a = payload.persistenceConfig) !== null && _a !== void 0 ? _a : $118f790bb239ec43$var$DEFAULT_PERSISTENCE_CONFIG;
            // Retrieve previously seen feature notifications from persistence to determine
            // which features the user has already viewed
            ((payload === null || payload === void 0 ? void 0 : payload.__retrieveFeatureNotifications) || (0, $dca857cabc5bb5b3$export$1137a287ea89c32e))(persistenceConfig).then((seenFeatureNotifications)=>{
                setSeenFeatures(seenFeatureNotifications);
                const hasUnseenFeatures = features.some((feature)=>!seenFeatureNotifications[feature.id]);
                if (hasUnseenFeatures) {
                    if (!payload.suppressFeaturePrompt && !featurePromptDismissed) featurePromptMountPromise.then(()=>{
                        var _a;
                        (_a = featurePromptRef.current) === null || _a === void 0 || _a.show();
                    });
                    setFeatureNotificationsData((data)=>data ? {
                            ...data,
                            badge: true
                        } : data);
                }
            });
            return;
        }
        if (event.type === 'showFeaturePromptIfPossible' && !allNotificationsSeen) {
            (_b = featurePromptRef.current) === null || _b === void 0 || _b.show();
            return;
        }
        if (event.type === 'clearFeatureNotifications') {
            setFeatureNotificationsData(null);
            return;
        }
    }
    function getLatestUnseenFeature() {
        var _a;
        return (_a = featureNotificationsData === null || featureNotificationsData === void 0 ? void 0 : featureNotificationsData.features.find((feature)=>!seenFeatures[feature.id])) !== null && _a !== void 0 ? _a : null;
    }
    function renderLatestFeaturePrompt({ triggerRef: triggerRef }) {
        const latestFeature = getLatestUnseenFeature();
        if (!triggerRef.current || !latestFeature) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c5f122c383344aea$export$2e2bcd8739ae039), {
            ref: featurePromptMergedRef,
            onShow: ()=>{
                triggerRef.current.dataset.awsuiSuppressTooltip = 'true';
            },
            onDismiss: (event)=>{
                var _a;
                if (((_a = event.detail) === null || _a === void 0 ? void 0 : _a.method) !== 'blur') triggerRef === null || triggerRef === void 0 || triggerRef.current.focus();
                setFeaturePromptDismissed(true);
                Promise.resolve().then(()=>{
                    var _a;
                    if ((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.dataset) triggerRef.current.dataset.awsuiSuppressTooltip = 'false';
                });
            },
            header: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78b4c852d1af0c1a$export$b9c59dfba65c173), {
                mountContent: featureNotificationsData === null || featureNotificationsData === void 0 ? void 0 : featureNotificationsData.mountItem,
                content: latestFeature.header
            }),
            content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78b4c852d1af0c1a$export$b9c59dfba65c173), {
                mountContent: featureNotificationsData === null || featureNotificationsData === void 0 ? void 0 : featureNotificationsData.mountItem,
                content: latestFeature.content
            }),
            trackKey: latestFeature.id,
            position: "left",
            getTrack: ()=>triggerRef.current
        });
    }
    const setFeaturesToSeenAndPersist = ()=>{
        var _a, _b;
        const persistenceConfig = (_a = featureNotificationsData === null || featureNotificationsData === void 0 ? void 0 : featureNotificationsData.persistenceConfig) !== null && _a !== void 0 ? _a : $118f790bb239ec43$var$DEFAULT_PERSISTENCE_CONFIG;
        const featuresMap = featureNotificationsData === null || featureNotificationsData === void 0 ? void 0 : featureNotificationsData.features.reduce((acc, feature)=>{
            return {
                ...acc,
                [feature.id]: feature.releaseDate
            };
        }, {});
        const filteredSeenFeaturesMap = $118f790bb239ec43$var$filterOutdatedFeatures(seenFeatures);
        const allFeaturesMap = {
            ...featuresMap,
            ...filteredSeenFeaturesMap
        };
        ((_b = featureNotificationsData === null || featureNotificationsData === void 0 ? void 0 : featureNotificationsData.__persistFeatureNotifications) !== null && _b !== void 0 ? _b : (0, $dca857cabc5bb5b3$export$48f54c965235548a))(persistenceConfig, allFeaturesMap).then(()=>{
            setSeenFeatures(allFeaturesMap);
            setFeatureNotificationsData((data)=>data ? {
                    ...data,
                    badge: false
                } : data);
        });
    };
    const onOpenFeatureNotificationsDrawer = ()=>{
        if (!featureNotificationsData || allNotificationsSeen) return;
        setFeaturesToSeenAndPersist();
    };
    const featureNotificationsProps = {
        renderLatestFeaturePrompt: renderLatestFeaturePrompt,
        drawer: featureNotificationsData && mapPayloadToDrawer(featureNotificationsData)
    };
    return {
        featureNotificationsProps: featureNotificationsProps,
        onOpenFeatureNotificationsDrawer: onOpenFeatureNotificationsDrawer,
        featureNotificationsMessageHandler: featureNotificationsMessageHandler
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $79fe2d2b38996dc7$var$storageKeyMessageHandler = Symbol.for('awsui-widget-api-message-handler');
const $79fe2d2b38996dc7$var$storageKeyInitialMessages = Symbol.for('awsui-widget-api-initial-messages');
const $79fe2d2b38996dc7$var$storageKeyReadyDeferCallbacks = Symbol.for('awsui-widget-api-ready-defer');
const $79fe2d2b38996dc7$var$oneTimeMessageTypes = [
    'emit-notification'
];
function $79fe2d2b38996dc7$var$getWindow() {
    return window;
}
function $79fe2d2b38996dc7$export$d572504cbc73933a() {
    const win = $79fe2d2b38996dc7$var$getWindow();
    return win[$79fe2d2b38996dc7$var$storageKeyMessageHandler];
}
function $79fe2d2b38996dc7$export$5cc2bbbc00e276a5() {
    var _a;
    const initialMessages = (_a = $79fe2d2b38996dc7$var$getWindow()[$79fe2d2b38996dc7$var$storageKeyInitialMessages]) !== null && _a !== void 0 ? _a : [];
    $79fe2d2b38996dc7$var$getWindow()[$79fe2d2b38996dc7$var$storageKeyInitialMessages] = initialMessages.filter((message)=>!$79fe2d2b38996dc7$var$oneTimeMessageTypes.includes(message.type));
    return initialMessages;
}
function $79fe2d2b38996dc7$export$85b3097fd1866260(message) {
    var _a;
    const win = $79fe2d2b38996dc7$var$getWindow();
    win[$79fe2d2b38996dc7$var$storageKeyInitialMessages] = (_a = win[$79fe2d2b38996dc7$var$storageKeyInitialMessages]) !== null && _a !== void 0 ? _a : [];
    win[$79fe2d2b38996dc7$var$storageKeyInitialMessages].push(message);
}
function $79fe2d2b38996dc7$export$ca924db515f77bab(handler) {
    var _a;
    const win = $79fe2d2b38996dc7$var$getWindow();
    if (win[$79fe2d2b38996dc7$var$storageKeyMessageHandler]) (0, $c6f40142f532d98e$export$740bffb7416ae276)('AppLayoutWidget', 'Double registration attempt, the old handler will be overridden');
    win[$79fe2d2b38996dc7$var$storageKeyMessageHandler] = handler;
    (_a = win[$79fe2d2b38996dc7$var$storageKeyReadyDeferCallbacks]) === null || _a === void 0 || _a.forEach((fn)=>fn());
    win[$79fe2d2b38996dc7$var$storageKeyReadyDeferCallbacks] = [];
    return ()=>{
        win[$79fe2d2b38996dc7$var$storageKeyMessageHandler] = undefined;
    };
}
function $79fe2d2b38996dc7$export$510b27a899cca9fc() {
    $79fe2d2b38996dc7$var$getWindow()[$79fe2d2b38996dc7$var$storageKeyInitialMessages] = undefined;
}
function $79fe2d2b38996dc7$export$9484fadedd110920() {
    return !!$79fe2d2b38996dc7$export$d572504cbc73933a();
}
function $79fe2d2b38996dc7$export$512f56fb6eeb2aa4() {
    var _a;
    if ($79fe2d2b38996dc7$export$9484fadedd110920()) return Promise.resolve();
    const win = $79fe2d2b38996dc7$var$getWindow();
    win[$79fe2d2b38996dc7$var$storageKeyReadyDeferCallbacks] = (_a = win[$79fe2d2b38996dc7$var$storageKeyReadyDeferCallbacks]) !== null && _a !== void 0 ? _a : [];
    return new Promise((resolve)=>{
        var _a;
        return (_a = win[$79fe2d2b38996dc7$var$storageKeyReadyDeferCallbacks]) === null || _a === void 0 ? void 0 : _a.push(resolve);
    });
}


function $05ecf70a04c320de$export$ed3f273c3e059c75(isEnabled, handler) {
    const appLayoutMessageHandler = (0, $013a2451794a45c0$exports.useStableCallback)(handler);
    (0, $acw62.useEffect)(()=>{
        if (!isEnabled) return;
        for (const message of (0, $79fe2d2b38996dc7$export$5cc2bbbc00e276a5)())appLayoutMessageHandler(message);
        return (0, $79fe2d2b38996dc7$export$ca924db515f77bab)(appLayoutMessageHandler);
    }, [
        isEnabled,
        appLayoutMessageHandler
    ]);
}


const $2fa81d949a5ff483$export$caf051616fa5c7fc = (hasToolbar, { ariaLabels: ariaLabels, navigationOpen: navigationOpen, navigationWidth: navigationWidth, navigation: navigation, navigationHide: navigationHide, onNavigationChange: onNavigationChange, tools: tools, toolsOpen: controlledToolsOpen, onToolsChange: onToolsChange, toolsHide: toolsHide, toolsWidth: toolsWidth, headerVariant: headerVariant, breadcrumbs: breadcrumbs, stickyNotifications: stickyNotifications, splitPanelPreferences: controlledSplitPanelPreferences, splitPanelOpen: controlledSplitPanelOpen, splitPanel: splitPanel, splitPanelSize: controlledSplitPanelSize, onSplitPanelToggle: onSplitPanelToggle, onSplitPanelResize: onSplitPanelResize, onSplitPanelPreferencesChange: onSplitPanelPreferencesChange, minContentWidth: minContentWidth, placement: placement, navigationTriggerHide: navigationTriggerHide, ...rest }, forwardRef)=>{
    var _a, _b, _c;
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const splitPanelControlId = (0, $013a2451794a45c0$exports.useUniqueId)('split-panel');
    const [toolbarState, setToolbarState] = (0, $acw62.useState)('show');
    const [toolbarHeight, setToolbarHeight] = (0, $acw62.useState)(0);
    const [notificationsHeight, setNotificationsHeight] = (0, $acw62.useState)(0);
    const [navigationAnimationDisabled, setNavigationAnimationDisabled] = (0, $acw62.useState)(true);
    const [splitPanelAnimationDisabled, setSplitPanelAnimationDisabled] = (0, $acw62.useState)(true);
    const [isNested, setIsNested] = (0, $acw62.useState)(false);
    const [expandedDrawerId, setInternalExpandedDrawerId] = (0, $acw62.useState)(null);
    const rootRefInternal = (0, $acw62.useRef)(null);
    // This workaround ensures the ref is defined before checking if the app layout is nested.
    // On initial render, the ref might be undefined because this component loads asynchronously via the widget API.
    const onMountRootRef = (0, $acw62.useCallback)((node)=>{
        setIsNested(getIsNestedInAppLayout(node));
    }, []);
    const [toolsOpen = false, setToolsOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledToolsOpen, onToolsChange, false, {
        componentName: 'AppLayout',
        controlledProp: 'toolsOpen',
        changeHandler: 'onToolsChange'
    });
    const onToolsToggle = (open)=>{
        setToolsOpen(open);
        drawersFocusControl.setFocus();
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onToolsChange, {
            open: open
        });
    };
    const setExpandedDrawerId = (value)=>{
        setInternalExpandedDrawerId(value);
        if ((aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.onToggleFocusMode) && (value === (aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id) || value === null)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(aiDrawer.onToggleFocusMode, {
            isExpanded: !!value
        });
    };
    const onGlobalDrawerFocus = (drawerId, open)=>{
        globalDrawersFocusControl.setFocus({
            force: true,
            drawerId: drawerId,
            open: open
        });
    };
    const onAddNewActiveDrawer = (drawerId)=>{
        var _a, _b;
        // If either a local drawer or a bottom drawer is already open, and we attempt to open a new one,
        // it will replace the existing one instead of opening an additional drawer,
        // since only one local drawer is supported. Therefore, layout calculations are not necessary.
        if (activeDrawer && (drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === drawerId)) || activeGlobalBottomDrawerId === drawerId) return;
        // get the size of drawerId. it could be either local or global drawer
        const combinedDrawers = [
            ...drawers || [],
            ...globalDrawers
        ];
        const newDrawer = combinedDrawers.find((drawer)=>drawer.id === drawerId);
        if (!newDrawer) return;
        const newDrawerSize = Math.min((_b = (_a = newDrawer.defaultSize) !== null && _a !== void 0 ? _a : drawerSizes[drawerId]) !== null && _b !== void 0 ? _b : (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc), (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc));
        //   check if the active drawers could be resized to fit the new drawers
        //   to do this, we need to take all active drawers, sum up their min sizes, truncate it from resizableSpaceAvailable
        //   and compare a given number with the new drawer id min size
        // the total size of all global drawers resized to their min size
        const availableSpaceForNewDrawer = resizableSpaceAvailable - totalActiveDrawersMinSize;
        if (availableSpaceForNewDrawer >= newDrawerSize) return;
        // now we made sure we cannot accommodate the new drawer with existing ones
        closeFirstDrawer();
    };
    const onGlobalBottomDrawerFocus = ()=>{
        bottomDrawersFocusControl.setFocus();
    };
    const { featureNotificationsProps: featureNotificationsProps, onOpenFeatureNotificationsDrawer: onOpenFeatureNotificationsDrawer, featureNotificationsMessageHandler: featureNotificationsMessageHandler } = (0, $118f790bb239ec43$export$3742f45130d1cd85)();
    const { drawers: drawers, activeDrawer: activeDrawer, minDrawerSize: minDrawerSize, minGlobalDrawersSizes: minGlobalDrawersSizes, activeDrawerSize: activeDrawerSize, ariaLabelsWithDrawers: ariaLabelsWithDrawers, globalDrawers: globalDrawers, activeGlobalDrawers: activeGlobalDrawers, activeGlobalDrawersIds: activeGlobalDrawersIds, activeGlobalDrawersSizes: activeGlobalDrawersSizes, drawerSizes: drawerSizes, drawersOpenQueue: drawersOpenQueue, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize, onActiveGlobalDrawersChange: onActiveGlobalDrawersChange } = (0, $892ef2b582c4882d$export$468f52f962f49bf5)({
        ...rest,
        externalLocalRuntimeDrawers: (featureNotificationsProps === null || featureNotificationsProps === void 0 ? void 0 : featureNotificationsProps.drawer) && [
            featureNotificationsProps === null || featureNotificationsProps === void 0 ? void 0 : featureNotificationsProps.drawer
        ],
        onGlobalDrawerFocus: onGlobalDrawerFocus,
        onAddNewActiveDrawer: onAddNewActiveDrawer,
        expandedDrawerId: expandedDrawerId,
        setExpandedDrawerId: setExpandedDrawerId
    }, ariaLabels, {
        ariaLabels: ariaLabels,
        toolsHide: toolsHide,
        toolsOpen: toolsOpen,
        tools: tools,
        toolsWidth: toolsWidth,
        onToolsToggle: onToolsToggle
    });
    const { aiDrawer: aiDrawer, aiDrawerMessageHandler: aiDrawerMessageHandler, onActiveAiDrawerChange: onActiveAiDrawerChange, activeAiDrawer: activeAiDrawer, activeAiDrawerId: activeAiDrawerId, activeAiDrawerSize: activeAiDrawerSize, minAiDrawerSize: minAiDrawerSize, onActiveAiDrawerResize: onActiveAiDrawerResize } = (0, $5cb26ec4bd62507c$export$ddfe30cba6e4434)({
        getMaxAiDrawerSize: ()=>maxAiDrawerSize,
        onAiDrawerFocus: ()=>aiDrawerFocusControl.setFocus(),
        expandedDrawerId: expandedDrawerId,
        setExpandedDrawerId: setExpandedDrawerId
    });
    const aiDrawerFocusControl = (0, $84d3a2bbe2557e44$export$4f731f600e75308c)(!!(activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.id), true, activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.id);
    const { bottomDrawers: bottomDrawers, activeBottomDrawer: activeBottomDrawer, onActiveBottomDrawerChange: onActiveGlobalBottomDrawerChange, activeBottomDrawerSize: activeGlobalBottomDrawerSize, minBottomDrawerSize: minGlobalBottomDrawerSize, onActiveBottomDrawerResize: onActiveBottomDrawerResize, bottomDrawersMessageHandler: bottomDrawersMessageHandler } = (0, $70c0e83ce261f6d3$export$cd45e44299c0c156)({
        onBottomDrawerFocus: onGlobalBottomDrawerFocus,
        expandedDrawerId: expandedDrawerId,
        setExpandedDrawerId: setExpandedDrawerId,
        drawersOpenQueue: drawersOpenQueue
    });
    const activeGlobalBottomDrawerId = (_a = activeBottomDrawer === null || activeBottomDrawer === void 0 ? void 0 : activeBottomDrawer.id) !== null && _a !== void 0 ? _a : null;
    const checkAIDrawerIdExists = (id)=>{
        return (aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id) === id;
    };
    const checkBottomDrawerIdExists = (id)=>{
        return !!bottomDrawers.find((drawer)=>drawer.id === id);
    };
    const checkDrawerIdExists = (id)=>{
        return checkAIDrawerIdExists(id) || checkBottomDrawerIdExists(id);
    };
    const drawerGenericMessageHandler = (message)=>{
        var _a;
        switch(message.type){
            case 'expandDrawer':
                if (!checkDrawerIdExists(message.payload.id)) (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendOpsMetricObject('awsui-widget-drawer-incorrect-id', {
                    id: message.payload.id,
                    type: message.type,
                    bottomDrawers: bottomDrawers.map((drawer)=>drawer.id).join(','),
                    aiDrawer: (_a = aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id) !== null && _a !== void 0 ? _a : ''
                });
                setExpandedDrawerId(message.payload.id);
                break;
            case 'exitExpandedMode':
                setExpandedDrawerId(null);
                break;
        }
    };
    (0, $05ecf70a04c320de$export$ed3f273c3e059c75)(hasToolbar, (message)=>{
        var _a, _b;
        if (message.type === 'expandDrawer' || message.type === 'exitExpandedMode') {
            drawerGenericMessageHandler(message);
            return;
        }
        if ([
            'registerFeatureNotifications',
            'showFeaturePromptIfPossible',
            'clearFeatureNotifications'
        ].includes(message.type)) {
            featureNotificationsMessageHandler(message);
            return;
        }
        if (!('payload' in message && 'id' in message.payload)) {
            (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendOpsMetricObject('awsui-widget-drawer-incorrect-payload', {
                type: message.type,
                bottomDrawers: bottomDrawers.map((drawer)=>drawer.id).join(','),
                aiDrawer: (_a = aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id) !== null && _a !== void 0 ? _a : ''
            });
            return;
        }
        const { id: id } = message.payload;
        if (checkAIDrawerIdExists(id) || message.type === 'registerLeftDrawer') {
            aiDrawerMessageHandler(message);
            return;
        }
        if (checkBottomDrawerIdExists(id) || message.type === 'registerBottomDrawer') {
            bottomDrawersMessageHandler(message);
            return;
        }
        (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendOpsMetricObject('awsui-widget-drawer-incorrect-id', {
            id: id,
            type: message.type,
            bottomDrawers: bottomDrawers.map((drawer)=>drawer.id).join(','),
            aiDrawer: (_b = aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id) !== null && _b !== void 0 ? _b : ''
        });
    });
    const onActiveDrawerChangeHandler = (drawerId, params = {
        initiatedByUserAction: true
    })=>{
        var _a, _b;
        onActiveDrawerChange(drawerId, params);
        drawersFocusControl.setFocus();
        if (((_a = featureNotificationsProps === null || featureNotificationsProps === void 0 ? void 0 : featureNotificationsProps.drawer) === null || _a === void 0 ? void 0 : _a.id) && ((_b = featureNotificationsProps === null || featureNotificationsProps === void 0 ? void 0 : featureNotificationsProps.drawer) === null || _b === void 0 ? void 0 : _b.id) === drawerId) onOpenFeatureNotificationsDrawer();
    };
    const [splitPanelOpen = false, setSplitPanelOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelOpen, onSplitPanelToggle, false, {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelOpen',
        changeHandler: 'onSplitPanelToggle'
    });
    const onSplitPanelToggleHandler = ()=>{
        setSplitPanelAnimationDisabled(false);
        setSplitPanelOpen(!splitPanelOpen);
        splitPanelFocusControl.setLastInteraction({
            type: splitPanelOpen ? 'close' : 'open'
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelToggle, {
            open: !splitPanelOpen
        });
    };
    const [splitPanelPreferences, setSplitPanelPreferences] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelPreferences, onSplitPanelPreferencesChange, undefined, {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelPreferences',
        changeHandler: 'onSplitPanelPreferencesChange'
    });
    const onSplitPanelPreferencesChangeHandler = (detail)=>{
        setSplitPanelPreferences(detail);
        splitPanelFocusControl.setLastInteraction({
            type: 'position'
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelPreferencesChange, detail);
    };
    const [splitPanelSize = 0, setSplitPanelSize] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelSize, onSplitPanelResize, (0, $582c00c3ff10d4e2$export$9d9d5fcac617b082)((_b = splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) !== null && _b !== void 0 ? _b : 'bottom'), {
        componentName: 'AppLayout',
        controlledProp: 'splitPanelSize',
        changeHandler: 'onSplitPanelResize'
    });
    const [splitPanelReportedSize, setSplitPanelReportedSize] = (0, $acw62.useState)(0);
    const [splitPanelHeaderBlockSize, setSplitPanelHeaderBlockSize] = (0, $acw62.useState)(0);
    const onSplitPanelResizeHandler = (size)=>{
        setSplitPanelSize(size);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelResize, {
            size: size
        });
    };
    const [splitPanelToggleConfig, setSplitPanelToggleConfig] = (0, $acw62.useState)({
        ariaLabel: undefined,
        displayed: false
    });
    const [bottomDrawerReportedSize, setBottomDrawerReportedSize] = (0, $acw62.useState)(0);
    const globalDrawersFocusControl = (0, $84d3a2bbe2557e44$export$4fdf1d085a596a08)(true, activeGlobalDrawersIds);
    const drawersFocusControl = (0, $84d3a2bbe2557e44$export$4f731f600e75308c)(!!(activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id), true, activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id);
    const bottomDrawersFocusControl = (0, $84d3a2bbe2557e44$export$4f731f600e75308c)(!!activeGlobalBottomDrawerId, true, activeGlobalBottomDrawerId);
    const navigationFocusControl = (0, $84d3a2bbe2557e44$export$4f731f600e75308c)(navigationOpen, navigationTriggerHide);
    const splitPanelFocusControl = (0, $d19d77c31ea1086e$export$ba7387b5ce3f72be)([
        splitPanelPreferences,
        splitPanelOpen
    ]);
    const onNavigationToggle = (0, $013a2451794a45c0$exports.useStableCallback)(({ isOpen: isOpen, autoFocus: autoFocus })=>{
        setNavigationAnimationDisabled(false);
        navigationFocusControl.setFocus({
            force: false,
            autoFocus: autoFocus
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onNavigationChange, {
            open: isOpen
        });
    });
    (0, $acw62.useImperativeHandle)(forwardRef, ()=>({
            closeNavigationIfNecessary: ()=>isMobile && onNavigationToggle({
                    isOpen: false,
                    autoFocus: true
                }),
            openTools: ()=>onToolsToggle(true),
            focusToolsClose: ()=>drawersFocusControl.setFocus({
                    force: true
                }),
            focusActiveDrawer: ()=>drawersFocusControl.setFocus({
                    force: true
                }),
            focusSplitPanel: ()=>splitPanelFocusControl.setLastInteraction({
                    type: 'open'
                }),
            focusNavigation: ()=>navigationFocusControl.setFocus({
                    force: true
                })
        }));
    const resolvedStickyNotifications = !!stickyNotifications && !isMobile;
    //navigation must be null if hidden so toolbar knows to hide the toggle button
    const resolvedNavigation = navigationHide ? null : navigation || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    //navigation must not be open if navigationHide is true
    const resolvedNavigationOpen = !!resolvedNavigation && navigationOpen;
    const { maxDrawerSize: maxDrawerSize, maxSplitPanelSize: maxSplitPanelSize, splitPanelForcedPosition: splitPanelForcedPosition, splitPanelPosition: splitPanelPosition, maxGlobalDrawersSizes: maxGlobalDrawersSizes, resizableSpaceAvailable: resizableSpaceAvailable, maxAiDrawerSize: maxAiDrawerSize } = (0, $ff079cc12921495d$export$847d464b8c579b64)({
        activeDrawerSize: activeDrawer ? activeDrawerSize : 0,
        splitPanelSize: splitPanelSize,
        minContentWidth: minContentWidth,
        navigationOpen: resolvedNavigationOpen,
        navigationWidth: navigationWidth,
        placement: placement,
        splitPanelOpen: splitPanelOpen,
        splitPanelPosition: splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position,
        isMobile: isMobile,
        activeGlobalDrawersSizes: activeGlobalDrawersSizes,
        activeAiDrawerSize: activeAiDrawerSize
    });
    const verticalOffsets = (0, $ff079cc12921495d$export$88f2788934d642c4)({
        topOffset: placement.insetBlockStart,
        hasVisibleToolbar: hasToolbar && toolbarState !== 'hide',
        notificationsHeight: notificationsHeight !== null && notificationsHeight !== void 0 ? notificationsHeight : 0,
        toolbarHeight: toolbarHeight !== null && toolbarHeight !== void 0 ? toolbarHeight : 0,
        stickyNotifications: resolvedStickyNotifications
    });
    const { ref: intersectionObserverRef, isIntersecting: isIntersecting } = (0, $cff975c73fa800c5$export$a7395f9832c00176)({
        initialState: true
    });
    const rootRef = (0, $013a2451794a45c0$exports.useMergeRefs)(rootRefInternal, intersectionObserverRef, onMountRootRef);
    const discoveredBreadcrumbs = (0, $e77086e9f518407b$export$eaa9c9bd163bd73d)(hasToolbar && !breadcrumbs);
    (0, $139ddc5f315dad51$export$517494a671c245e0)((_c = verticalOffsets.header) !== null && _c !== void 0 ? _c : 0);
    const getMaxGlobalBottomDrawerHeight = (0, $acw62.useCallback)(()=>{
        const splitPanelSize = splitPanelOpen && splitPanelPosition === 'bottom' ? splitPanelReportedSize : 0;
        const availableHeight = document.documentElement.clientHeight - placement.insetBlockStart - placement.insetBlockEnd - splitPanelSize;
        // skip reading sizes in JSDOM
        if (availableHeight === 0) return Infinity;
        // If the page is likely zoomed in at 200%, allow the split panel to fill the content area.
        return availableHeight < 400 ? availableHeight - 40 : availableHeight - 250;
    }, [
        splitPanelOpen,
        splitPanelPosition,
        splitPanelReportedSize,
        placement.insetBlockStart,
        placement.insetBlockEnd
    ]);
    const appLayoutInternals = {
        ariaLabels: ariaLabelsWithDrawers,
        headerVariant: headerVariant,
        isMobile: isMobile,
        breadcrumbs: breadcrumbs,
        discoveredBreadcrumbs: discoveredBreadcrumbs,
        stickyNotifications: resolvedStickyNotifications,
        navigationOpen: resolvedNavigationOpen,
        navigation: resolvedNavigation,
        navigationFocusControl: navigationFocusControl,
        activeDrawer: activeDrawer,
        activeDrawerSize: activeDrawerSize,
        minDrawerSize: minDrawerSize,
        maxDrawerSize: maxDrawerSize,
        minGlobalDrawersSizes: minGlobalDrawersSizes,
        maxGlobalDrawersSizes: maxGlobalDrawersSizes,
        drawers: drawers,
        globalDrawers: globalDrawers,
        activeGlobalDrawers: activeGlobalDrawers,
        activeGlobalDrawersIds: activeGlobalDrawersIds,
        activeGlobalDrawersSizes: activeGlobalDrawersSizes,
        onActiveGlobalDrawersChange: onActiveGlobalDrawersChange,
        drawersFocusControl: drawersFocusControl,
        globalDrawersFocusControl: globalDrawersFocusControl,
        splitPanelPosition: splitPanelPosition,
        splitPanelToggleConfig: splitPanelToggleConfig,
        splitPanelOpen: splitPanelOpen,
        splitPanelControlId: splitPanelControlId,
        splitPanelFocusControl: splitPanelFocusControl,
        placement: placement,
        toolbarState: toolbarState,
        setToolbarState: setToolbarState,
        verticalOffsets: verticalOffsets,
        drawersOpenQueue: drawersOpenQueue.current,
        setToolbarHeight: setToolbarHeight,
        setNotificationsHeight: setNotificationsHeight,
        onSplitPanelToggle: onSplitPanelToggleHandler,
        onNavigationToggle: (isOpen)=>onNavigationToggle({
                isOpen: isOpen,
                autoFocus: true
            }),
        onActiveDrawerChange: onActiveDrawerChangeHandler,
        onActiveDrawerResize: onActiveDrawerResize,
        splitPanelAnimationDisabled: splitPanelAnimationDisabled,
        expandedDrawerId: expandedDrawerId,
        setExpandedDrawerId: setExpandedDrawerId,
        aiDrawer: aiDrawer,
        onActiveAiDrawerChange: onActiveAiDrawerChange,
        activeAiDrawer: activeAiDrawer,
        activeAiDrawerId: activeAiDrawerId,
        activeAiDrawerSize: activeAiDrawerSize,
        minAiDrawerSize: minAiDrawerSize,
        maxAiDrawerSize: maxAiDrawerSize,
        aiDrawerFocusControl: aiDrawerFocusControl,
        onActiveAiDrawerResize: onActiveAiDrawerResize
    };
    const splitPanelInternals = {
        bottomOffset: 0,
        getMaxHeight: (0, $acw62.useCallback)(()=>{
            const bottomDrawerHeight = activeGlobalBottomDrawerId ? bottomDrawerReportedSize : 0;
            const availableHeight = document.documentElement.clientHeight - placement.insetBlockStart - placement.insetBlockEnd - bottomDrawerHeight;
            // If the page is likely zoomed in at 200%, allow the split panel to fill the content area.
            return availableHeight < 400 ? availableHeight - 40 : availableHeight - 250;
        }, [
            activeGlobalBottomDrawerId,
            bottomDrawerReportedSize,
            placement.insetBlockEnd,
            placement.insetBlockStart
        ]),
        maxWidth: maxSplitPanelSize,
        isForcedPosition: splitPanelForcedPosition,
        isOpen: splitPanelOpen,
        leftOffset: 0,
        onPreferencesChange: onSplitPanelPreferencesChangeHandler,
        onResize: onSplitPanelResizeHandler,
        onToggle: onSplitPanelToggleHandler,
        position: splitPanelPosition,
        reportSize: (0, $013a2451794a45c0$exports.useStableCallback)((size)=>setSplitPanelReportedSize(size)),
        reportHeaderHeight: (0, $013a2451794a45c0$exports.useStableCallback)((size)=>setSplitPanelHeaderBlockSize(size)),
        headerHeight: splitPanelHeaderBlockSize,
        rightOffset: 0,
        size: splitPanelSize,
        topOffset: 0,
        setSplitPanelToggle: setSplitPanelToggleConfig,
        refs: splitPanelFocusControl.refs
    };
    const closeFirstDrawer = (0, $013a2451794a45c0$exports.useStableCallback)(()=>{
        let drawerToClose = drawersOpenQueue.current[drawersOpenQueue.current.length - 1];
        if (drawerToClose === (activeBottomDrawer === null || activeBottomDrawer === void 0 ? void 0 : activeBottomDrawer.id)) drawerToClose = drawersOpenQueue.current[drawersOpenQueue.current.length - 2];
        if (activeDrawer && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) === drawerToClose) onActiveDrawerChange(null, {
            initiatedByUserAction: true
        });
        else if (activeGlobalDrawersIds.includes(drawerToClose)) onActiveGlobalDrawersChange(drawerToClose, {
            initiatedByUserAction: true
        });
    });
    (0, $acw62.useEffect)(()=>{
        // Close navigation drawer on mobile so that the main content is visible
        if (isMobile) onNavigationToggle({
            isOpen: false,
            autoFocus: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMobile
    ]);
    const getTotalActiveDrawersMinSize = ()=>{
        var _a, _b;
        const combinedDrawers = [
            ...drawers || [],
            ...globalDrawers
        ];
        let result = activeGlobalDrawersIds.map((activeDrawerId)=>{
            var _a, _b;
            return Math.min((_b = (_a = combinedDrawers.find((drawer)=>drawer.id === activeDrawerId)) === null || _a === void 0 ? void 0 : _a.defaultSize) !== null && _b !== void 0 ? _b : (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc), (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc));
        }).reduce((acc, curr)=>acc + curr, 0);
        if (activeDrawer) result += Math.min((_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.defaultSize) !== null && _a !== void 0 ? _a : (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc), (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc));
        if (activeAiDrawer) result += Math.min((_b = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.defaultSize) !== null && _b !== void 0 ? _b : (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc), (0, $892ef2b582c4882d$export$4a7e63d7f017c5fc));
        return result;
    };
    const totalActiveDrawersMinSize = getTotalActiveDrawersMinSize();
    (0, $acw62.useEffect)(()=>{
        if (isMobile) return;
        const activeNavigationWidth = !navigationHide && navigationOpen ? navigationWidth : 0;
        const scrollWidth = activeNavigationWidth + (0, $ff079cc12921495d$export$6e84eb1dcf528852) + totalActiveDrawersMinSize;
        const hasHorizontalScroll = scrollWidth > placement.inlineSize;
        if (hasHorizontalScroll) {
            if (!navigationHide && navigationOpen) {
                onNavigationToggle({
                    isOpen: false,
                    autoFocus: false
                });
                return;
            }
            closeFirstDrawer();
        }
    }, [
        totalActiveDrawersMinSize,
        closeFirstDrawer,
        isMobile,
        navigationHide,
        navigationOpen,
        navigationWidth,
        onNavigationToggle,
        placement.inlineSize
    ]);
    /**
     * Returns true if the AppLayout is nested
     * Does not apply to iframe
     */ const getIsNestedInAppLayout = (element)=>{
        var _a;
        let currentElement = (_a = element === null || element === void 0 ? void 0 : element.parentElement) !== null && _a !== void 0 ? _a : null;
        // this traverse is needed only for JSDOM
        // in real browsers the globalVar will be propagated to all descendants and this loops exits after initial iteration
        while(currentElement){
            if (getComputedStyle(currentElement).getPropertyValue((0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset)) return true;
            currentElement = currentElement.parentElement;
        }
        return false;
    };
    const splitPanelOffsets = (0, $ff079cc12921495d$export$6bd7ab1bd03ec82c)({
        placement: placement,
        hasSplitPanel: !!splitPanel,
        splitPanelOpen: splitPanelOpen,
        splitPanelPosition: splitPanelPosition,
        splitPanelFullHeight: splitPanelReportedSize,
        splitPanelHeaderHeight: splitPanelHeaderBlockSize
    });
    return {
        rootRef: rootRef,
        isIntersecting: isIntersecting,
        appLayoutInternals: appLayoutInternals,
        splitPanelInternals: splitPanelInternals,
        widgetizedState: {
            ...appLayoutInternals,
            aiDrawerExpandedMode: expandedDrawerId === (activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.id),
            isNested: isNested,
            navigationAnimationDisabled: navigationAnimationDisabled,
            verticalOffsets: verticalOffsets,
            splitPanelOffsets: splitPanelOffsets,
            activeGlobalBottomDrawerId: activeGlobalBottomDrawerId,
            onActiveGlobalBottomDrawerChange: onActiveGlobalBottomDrawerChange,
            activeGlobalBottomDrawerSize: activeGlobalBottomDrawerSize,
            bottomDrawerReportedSize: bottomDrawerReportedSize,
            minGlobalBottomDrawerSize: minGlobalBottomDrawerSize,
            getMaxGlobalBottomDrawerHeight: getMaxGlobalBottomDrawerHeight,
            reportBottomDrawerSize: (0, $013a2451794a45c0$exports.useStableCallback)((size)=>setBottomDrawerReportedSize(size)),
            onActiveBottomDrawerResize: onActiveBottomDrawerResize,
            bottomDrawers: bottomDrawers,
            bottomDrawersFocusControl: bottomDrawersFocusControl,
            featureNotificationsProps: featureNotificationsProps
        }
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






var $89ac1508ddb88f9a$export$2e2bcd8739ae039 = {
    "root": "awsui_root_7nfqu_cwk25_153",
    "has-adaptive-widths-default": "awsui_has-adaptive-widths-default_7nfqu_cwk25_197",
    "has-adaptive-widths-dashboard": "awsui_has-adaptive-widths-dashboard_7nfqu_cwk25_202",
    "drawer-expanded-mode": "awsui_drawer-expanded-mode_7nfqu_cwk25_217",
    "ai-drawer-expanded-mode": "awsui_ai-drawer-expanded-mode_7nfqu_cwk25_220",
    "bottom-drawer-expanded-mode": "awsui_bottom-drawer-expanded-mode_7nfqu_cwk25_223",
    "ai-drawer": "awsui_ai-drawer_7nfqu_cwk25_220",
    "navigation": "awsui_navigation_7nfqu_cwk25_230",
    "tools": "awsui_tools_7nfqu_cwk25_231",
    "global-tools": "awsui_global-tools_7nfqu_cwk25_232",
    "bottom-tool": "awsui_bottom-tool_7nfqu_cwk25_233",
    "tools-open": "awsui_tools-open_7nfqu_cwk25_290",
    "split-panel-side": "awsui_split-panel-side_7nfqu_cwk25_304",
    "split-panel-bottom": "awsui_split-panel-bottom_7nfqu_cwk25_311",
    "panel-hidden": "awsui_panel-hidden_7nfqu_cwk25_324",
    "toolbar-container": "awsui_toolbar-container_7nfqu_cwk25_334",
    "notifications-container": "awsui_notifications-container_7nfqu_cwk25_341",
    "notifications-background": "awsui_notifications-background_7nfqu_cwk25_345",
    "main-landmark": "awsui_main-landmark_7nfqu_cwk25_356",
    "main": "awsui_main_7nfqu_cwk25_356",
    "main-disable-paddings": "awsui_main-disable-paddings_7nfqu_cwk25_365",
    "content-header": "awsui_content-header_7nfqu_cwk25_375",
    "content": "awsui_content_7nfqu_cwk25_375",
    "unfocusable-mobile": "awsui_unfocusable-mobile_7nfqu_cwk25_385",
    "hidden": "awsui_hidden_7nfqu_cwk25_390",
    "breadcrumbs-own": "awsui_breadcrumbs-own_7nfqu_cwk25_394",
    "breadcrumbs-discovered": "awsui_breadcrumbs-discovered_7nfqu_cwk25_394"
};


const $85634026b9d58408$var$contentTypeCustomWidths = [
    'dashboard',
    'cards',
    'table'
];
const $85634026b9d58408$export$379a8e5e6261c9dd = (hasToolbar, appLayoutProps, appLayoutState)=>{
    var _a, _b, _c;
    const { isNested: isNested, activeDrawerSize: activeDrawerSize, navigationOpen: navigationOpen, verticalOffsets: verticalOffsets, splitPanelOffsets: splitPanelOffsets, activeDrawer: activeDrawer, expandedDrawerId: expandedDrawerId, activeAiDrawer: activeAiDrawer, activeGlobalBottomDrawerId: activeGlobalBottomDrawerId } = (_a = appLayoutState.widgetizedState) !== null && _a !== void 0 ? _a : {};
    const { contentType: contentType, placement: placement, maxContentWidth: maxContentWidth, navigationWidth: navigationWidth, minContentWidth: minContentWidth, disableContentPaddings: disableContentPaddings } = appLayoutProps;
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const toolsOpen = !!activeDrawer;
    const drawerExpandedMode = !!expandedDrawerId;
    const aiDrawerExpandedMode = expandedDrawerId === (activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.id);
    const bottomDrawerExpandedMode = expandedDrawerId === activeGlobalBottomDrawerId;
    const anyPanelOpen = navigationOpen || toolsOpen;
    const isMaxWidth = maxContentWidth === Number.MAX_VALUE || maxContentWidth === Number.MAX_SAFE_INTEGER;
    const wrapperElAttributes = {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).root, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).root, {
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['has-adaptive-widths-default']]: !$85634026b9d58408$var$contentTypeCustomWidths.includes(contentType),
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['has-adaptive-widths-dashboard']]: contentType === 'dashboard',
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['drawer-expanded-mode']]: drawerExpandedMode,
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['ai-drawer-expanded-mode']]: aiDrawerExpandedMode,
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['bottom-drawer-expanded-mode']]: bottomDrawerExpandedMode
        }),
        style: {
            minBlockSize: isNested ? '100%' : `calc(100vh - ${placement.insetBlockStart + placement.insetBlockEnd}px)`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).maxContentWidth]: isMaxWidth ? '100%' : maxContentWidth ? `${maxContentWidth}px` : '',
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).navigationWidth]: `${navigationWidth}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).toolsWidth]: `${activeDrawerSize}px`
        }
    };
    const mainElAttributes = {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['main-landmark'], isMobile && anyPanelOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['unfocusable-mobile'], drawerExpandedMode && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).hidden)
    };
    const contentWrapperElAttributes = {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).main, {
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['main-disable-paddings']]: disableContentPaddings
        }),
        style: {
            paddingBlockEnd: splitPanelOffsets === null || splitPanelOffsets === void 0 ? void 0 : splitPanelOffsets.mainContentPaddingBlockEnd,
            ...hasToolbar || !isNested ? {
                [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset]: `${(_b = verticalOffsets === null || verticalOffsets === void 0 ? void 0 : verticalOffsets.header) !== null && _b !== void 0 ? _b : 0}px`,
                [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset]: `${(_c = splitPanelOffsets === null || splitPanelOffsets === void 0 ? void 0 : splitPanelOffsets.stickyVerticalBottomOffset) !== null && _c !== void 0 ? _c : 0}px`
            } : {},
            ...!isMobile ? {
                minWidth: `${minContentWidth}px`
            } : {}
        }
    };
    const contentHeaderElAttributes = {
        className: (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['content-header']
    };
    const contentElAttributes = {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).content, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).content)
    };
    return {
        wrapperElAttributes: wrapperElAttributes,
        mainElAttributes: mainElAttributes,
        contentWrapperElAttributes: contentWrapperElAttributes,
        contentHeaderElAttributes: contentHeaderElAttributes,
        contentElAttributes: contentElAttributes
    };
};


const $16fc9c06fac4197f$export$72d3abb6f9e3e4dc = ({ appLayoutProps: appLayoutProps, stateManager: stateManager, forwardRef: forwardRef })=>{
    var _a;
    const [hasToolbar, setHasToolbar] = (0, $acw62.useState)((_a = stateManager.current.hasToolbar) !== null && _a !== void 0 ? _a : false);
    const appLayoutState = (0, $2fa81d949a5ff483$export$caf051616fa5c7fc)(hasToolbar, appLayoutProps, forwardRef);
    const skeletonSlotsAttributes = (0, $85634026b9d58408$export$379a8e5e6261c9dd)(hasToolbar, appLayoutProps, appLayoutState);
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        if (!((_a = stateManager.current) === null || _a === void 0 ? void 0 : _a.setState)) {
            console.warn('AppLayout state manager is not found');
            return;
        }
        stateManager.current.setState(appLayoutState, skeletonSlotsAttributes, (0, $902475055b64674b$export$9fd8253f8e263aaf)(appLayoutProps, appLayoutState), (0, $902475055b64674b$export$9d1611c77c2fe928));
    });
    (0, $acw62.useLayoutEffect)(()=>{
        stateManager.current.setToolbar = setHasToolbar;
    }, [
        stateManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
const $16fc9c06fac4197f$export$bf8c0c3640fa28b6 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($16fc9c06fac4197f$export$72d3abb6f9e3e4dc);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");











function $e7f76d3277b180ed$export$e8b771555dc4a003({ currentWidth: currentWidth, minWidth: minWidth, maxWidth: maxWidth, panelRef: panelRef, handleRef: handleRef, onResize: onResize, position: position }) {
    const onResizeHandler = (newWidth)=>{
        const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, newWidth, maxWidth);
        if (maxWidth >= minWidth) onResize(size);
    };
    const sizeControlProps = {
        position: position !== null && position !== void 0 ? position : 'side',
        panelRef: panelRef,
        handleRef: handleRef,
        onResize: onResizeHandler
    };
    const clampedWidth = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, currentWidth, maxWidth);
    const relativeSize = (clampedWidth - minWidth) / (maxWidth - minWidth) * 100;
    const onPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const { onKeyDown: onKeyDown, onDirectionClick: onDirectionClick } = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    return {
        onKeyDown: onKeyDown,
        onDirectionClick: onDirectionClick,
        onPointerDown: onPointerDown,
        relativeSize: relativeSize
    };
}





function $7ad280251af4a465$export$bf7efb8fc3f7ac58({ appLayoutInternals: appLayoutInternals, bottomDrawerReportedSize: bottomDrawerReportedSize }) {
    var _a, _b, _c;
    const { activeDrawer: activeDrawer, minDrawerSize: minDrawerSize, activeDrawerSize: activeDrawerSize, maxDrawerSize: maxDrawerSize, ariaLabels: ariaLabels, drawers: drawers, drawersFocusControl: drawersFocusControl, isMobile: isMobile, placement: placement, verticalOffsets: verticalOffsets, drawersOpenQueue: drawersOpenQueue, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize } = appLayoutInternals;
    const drawerRef = (0, $acw62.useRef)(null);
    const activeDrawerId = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id;
    const computedAriaLabels = {
        closeButton: activeDrawer ? (_a = activeDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.closeButton : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose,
        content: activeDrawer ? (_b = activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.drawerName : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools
    };
    const { drawerTopOffset: drawerTopOffset, drawerHeight: drawerHeight } = (0, $ff079cc12921495d$export$d60a2a5f5d1f1f3d)(verticalOffsets, isMobile, placement, isMobile ? 0 : bottomDrawerReportedSize !== null && bottomDrawerReportedSize !== void 0 ? bottomDrawerReportedSize : 0);
    const toolsOnlyMode = drawers.length === 1 && drawers[0].id === (0, $892ef2b582c4882d$export$329f249760e831ae);
    const isToolsDrawer = (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) === (0, $892ef2b582c4882d$export$329f249760e831ae) || toolsOnlyMode;
    const toolsContent = (_c = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === (0, $892ef2b582c4882d$export$329f249760e831ae))) === null || _c === void 0 ? void 0 : _c.content;
    const resizeProps = (0, $e7f76d3277b180ed$export$e8b771555dc4a003)({
        currentWidth: activeDrawerSize,
        minWidth: minDrawerSize,
        maxWidth: maxDrawerSize,
        panelRef: drawerRef,
        handleRef: drawersFocusControl.refs.slider,
        onResize: (size)=>onActiveDrawerResize({
                id: activeDrawerId,
                size: size
            })
    });
    // temporary handle a situation when app-layout is old, but this component come as a widget
    const isLegacyDrawer = drawersOpenQueue === undefined;
    const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minDrawerSize, activeDrawerSize, maxDrawerSize);
    const lastOpenedDrawerId = (drawersOpenQueue === null || drawersOpenQueue === void 0 ? void 0 : drawersOpenQueue.length) ? drawersOpenQueue[0] : activeDrawerId;
    const animationDisabled = (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.defaultActive) && !drawersOpenQueue.includes(activeDrawer.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), {
        nodeRef: drawerRef,
        in: !!activeDrawer,
        appear: true,
        timeout: 0
    }, (state)=>{
        var _a, _b;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
            id: activeDrawerId,
            "aria-hidden": !activeDrawer,
            "aria-label": computedAriaLabels.content,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039).drawer, {
                [(0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal']]: !animationDisabled,
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['last-opened']]: lastOpenedDrawerId === activeDrawerId,
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039).legacy]: isLegacyDrawer,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer']]: !toolsOnlyMode && activeDrawerId,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools]: isToolsDrawer,
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-hidden']]: !activeDrawer,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !activeDrawer
            }),
            ref: drawerRef,
            onBlur: (e)=>{
                if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) drawersFocusControl.loseFocus();
            },
            style: {
                blockSize: drawerHeight,
                insetBlockStart: drawerTopOffset,
                ...!isMobile && !isLegacyDrawer && {
                    [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).drawerSize]: `${[
                        'entering',
                        'entered'
                    ].includes(state) ? size : 0}px`
                }
            },
            "data-testid": activeDrawerId && `awsui-app-layout-drawer-${activeDrawerId}`
        }, !isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.resizable) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-slider']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
            ref: drawersFocusControl.refs.slider,
            position: "side",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-slider'],
            ariaLabel: (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.resizeHandle,
            tooltipText: (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.resizeHandleTooltipText,
            ariaValuenow: resizeProps.relativeSize,
            onKeyDown: resizeProps.onKeyDown,
            onPointerDown: resizeProps.onPointerDown,
            onDirectionClick: resizeProps.onDirectionClick
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-container'], (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-close-button'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaLabel: computedAriaLabels.closeButton,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer-close-button']]: !isToolsDrawer && activeDrawerId,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-close']]: isToolsDrawer
            }),
            formAction: "none",
            iconName: isMobile ? 'close' : 'angle-right',
            onClick: ()=>onActiveDrawerChange(null, {
                    initiatedByUserAction: true
                }),
            ref: drawersFocusControl.refs.close,
            variant: "icon",
            analyticsAction: "close"
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (0, $892ef2b582c4882d$export$329f249760e831ae),
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content'], activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-hidden']),
            style: {
                blockSize: drawerHeight
            }
        }, toolsContent), activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: activeDrawerId,
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content'],
            style: {
                blockSize: drawerHeight
            }
        }, activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.content)));
    });
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Returns given index if it is in range or the opposite range boundary otherwise.
function $9cebea7438e8886d$export$548e06c1946bc4e(index, [from, to]) {
    if (index < from) return to;
    if (index > to) return from;
    return index;
}




var $a7756a8f233fcbbe$export$2e2bcd8739ae039 = {
    "root": "awsui_root_ghvqw_1g0cx_5"
};



var $8a8daeeda7ed146c$export$2e2bcd8739ae039 = {
    "root": "awsui_root_efqlv_1qglu_5"
};


const $b29b9620a65adc52$var$InternalNavigableGroup = (0, $acw62.forwardRef)(({ children: children, getItemKey: getItemKey, navigationDirection: navigationDirection = 'horizontal', __internalRootRef: __internalRootRef, ...props }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const navigationAPI = (0, $acw62.useRef)(null);
    const containerObjectRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $013a2451794a45c0$exports.useMergeRefs)(containerObjectRef, __internalRootRef);
    const focusedIdRef = (0, $acw62.useRef)();
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus: ()=>{
                const target = getNextFocusTarget();
                if (target) target.focus();
            }
        }));
    function getNextFocusTarget() {
        var _a, _b;
        if (containerObjectRef.current) {
            const focusables = getFocusablesFrom(containerObjectRef.current);
            return (_b = (_a = focusables.find((el)=>getItemKey(el) === focusedIdRef.current)) !== null && _a !== void 0 ? _a : focusables[0]) !== null && _b !== void 0 ? _b : null;
        }
        return null;
    }
    function onUnregisterActive(focusableElement) {
        var _a;
        // Only refocus when the node is actually removed (no such element anymore).
        const target = (_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.getFocusTarget();
        if (target && getItemKey(target) !== getItemKey(focusableElement)) target.focus();
    }
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    });
    function onFocus(event) {
        var _a, _b;
        if (event.target instanceof HTMLElement && ((_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(event.target))) focusedIdRef.current = getItemKey(event.target);
        (_b = navigationAPI.current) === null || _b === void 0 || _b.updateFocusTarget();
    }
    function onBlur() {
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    }
    function onKeyDown(event) {
        var _a, _b;
        const focusTarget = (_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.getFocusTarget();
        let specialKeys = [];
        switch(navigationDirection){
            case 'horizontal':
                specialKeys = [
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left
                ];
                break;
            case 'vertical':
                specialKeys = [
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up
                ];
                break;
            case 'both':
                specialKeys = [
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up
                ];
                break;
        }
        specialKeys.push((0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end, (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home, (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageUp, (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageDown);
        if ((0, $fc537b925f715587$export$17ddd23cbcfe5784)(event) || specialKeys.indexOf(event.keyCode) === -1) return;
        if (!containerObjectRef.current || !focusTarget) return;
        // Ignore navigation when the focused element is not a registered focusable.
        if (document.activeElement && !((_b = navigationAPI.current) === null || _b === void 0 ? void 0 : _b.isRegistered(document.activeElement))) return;
        event.preventDefault();
        const focusables = getFocusablesFrom(containerObjectRef.current);
        const activeIndex = focusables.indexOf(focusTarget);
        const getNextIndex = (delta)=>{
            const newIndex = activeIndex + delta;
            return (0, $9cebea7438e8886d$export$548e06c1946bc4e)(newIndex, [
                0,
                focusables.length - 1
            ]);
        };
        (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
            onHome: ()=>focusElement(focusables[0]),
            onEnd: ()=>focusElement(focusables[focusables.length - 1]),
            onInlineStart: ()=>focusElement(focusables[getNextIndex(-1)]),
            onBlockStart: ()=>focusElement(focusables[getNextIndex(-1)]),
            onInlineEnd: ()=>focusElement(focusables[getNextIndex(1)]),
            onBlockEnd: ()=>focusElement(focusables[getNextIndex(1)])
        });
    }
    function focusElement(element) {
        element.focus();
    }
    // List all non-disabled and registered focusables: those are eligible for keyboard navigation.
    function getFocusablesFrom(target) {
        function isElementRegistered(element) {
            var _a, _b;
            return (_b = (_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(element)) !== null && _b !== void 0 ? _b : false;
        }
        function isElementDisabled(element) {
            if ('disabled' in element) return element.disabled;
            return false;
        }
        return (0, $eaddf2de854ee801$export$3fcce23e1e72b35b)(target).filter((el)=>isElementRegistered(el) && !isElementDisabled(el));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a7756a8f233fcbbe$export$2e2bcd8739ae039).root, (0, $8a8daeeda7ed146c$export$2e2bcd8739ae039).root, baseProps.className),
        ref: containerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.SingleTabStopNavigationProvider), {
        ref: navigationAPI,
        navigationActive: true,
        getNextFocusTarget: getNextFocusTarget,
        onUnregisterActive: onUnregisterActive
    }, children));
});
var $b29b9620a65adc52$export$2e2bcd8739ae039 = $b29b9620a65adc52$var$InternalNavigableGroup;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $6175122c42c548ad$export$2e2bcd8739ae039(componentName, propertyName, propertyValue, handlerName, handlerValue) {
    if (propertyValue !== undefined && handlerValue === undefined && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $013a2451794a45c0$exports.warnOnce)(componentName, `You provided \`${propertyName}\` prop without an \`${handlerName}\` handler. This will render a read-only component. If the component should be mutable, set an \`${handlerName}\` handler.`);
}





var $a14831985619a2f7$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1wp4s_1fn0v_185",
    "file-input": "awsui_file-input_1wp4s_1fn0v_189",
    "file-input-button": "awsui_file-input-button_1wp4s_1fn0v_204",
    "force-focus-outline-icon": "awsui_force-focus-outline-icon_1wp4s_1fn0v_204",
    "force-focus-outline-button": "awsui_force-focus-outline-button_1wp4s_1fn0v_225"
};


const $5bad98411ec3e571$var$InternalFileInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ accept: accept, ariaRequired: ariaRequired, ariaLabel: ariaLabel, multiple: multiple = false, value: value, onChange: onChange, variant: variant = 'button', children: children, __internalRootRef: __internalRootRef, __inputClassName: __inputClassName, __inputNativeAttributes: __inputNativeAttributes, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, ...restProps }, ref)=>{
    var _a;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const uploadInputRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(__internalRootRef, containerRef);
    const uploadButtonLabelId = (0, $013a2451794a45c0$exports.useUniqueId)('upload-button-label');
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const selfControlId = (0, $013a2451794a45c0$exports.useUniqueId)('upload-input');
    const controlId = (_a = formFieldContext.controlId) !== null && _a !== void 0 ? _a : selfControlId;
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, uploadInputRef);
    const [isFocused, setIsFocused] = (0, $acw62.useState)(false);
    const onUploadButtonClick = ()=>{
        var _a;
        return (_a = uploadInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const onUploadInputFocus = ()=>{
        setIsFocused(true);
    };
    const onUploadInputBlur = ()=>setIsFocused(false);
    const onUploadInputChange = ({ target: target })=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: target.files ? Array.from(target.files) : []
        });
    };
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)('FileInput', 'value', value, 'onChange', onChange);
    const nativeAttributes = {
        'aria-label': ariaLabel || children,
        'aria-labelledby': (0, $49fa9e74c692ea64$export$b933cda3796739ed)(formFieldContext.ariaLabelledby, uploadButtonLabelId),
        'aria-describedby': formFieldContext.ariaDescribedby,
        ...__inputNativeAttributes
    };
    if (formFieldContext.invalid) nativeAttributes['aria-invalid'] = true;
    if (ariaRequired) nativeAttributes['aria-required'] = true;
    if (variant === 'icon' && !ariaLabel) (0, $013a2451794a45c0$exports.warnOnce)('FileInput', 'Aria label is required with icon variant.');
    // Synchronizing component's value with the native file input state.
    (0, $acw62.useEffect)(()=>{
        /* istanbul ignore next: The DataTransfer is not available in jsdom. */ if (window.DataTransfer) {
            const dataTransfer = new DataTransfer();
            for (const file of value)dataTransfer.items.add(file);
            uploadInputRef.current.files = dataTransfer.files;
        }
        if (uploadInputRef.current) uploadInputRef.current.value = ''; // reset value to allow calling onChange when the same file is uploaded again
    }, [
        value
    ]);
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(uploadInputRef);
    const analyticsLabel = variant === 'button' && children ? 'button' : 'input';
    const componentAnalyticsMetadata = {
        name: 'awsui.FileInput',
        label: analyticsLabel
    };
    const analyticsMetadata = {
        detail: {
            label: analyticsLabel
        }
    };
    if (__injectAnalyticsComponentMetadata) analyticsMetadata.component = componentAnalyticsMetadata;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: mergedRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a14831985619a2f7$export$2e2bcd8739ae039).root),
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        ref: uploadInputRef,
        type: "file",
        hidden: false,
        multiple: multiple,
        accept: accept,
        onChange: onUploadInputChange,
        onFocus: onUploadInputFocus,
        onBlur: onUploadInputBlur,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a14831985619a2f7$export$2e2bcd8739ae039)['file-input'], (0, $a14831985619a2f7$export$2e2bcd8739ae039).hidden, __inputClassName),
        tabIndex: tabIndex,
        ...nativeAttributes
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        iconName: "upload",
        variant: variant === 'icon' ? 'icon' : undefined,
        formAction: "none",
        onClick: onUploadButtonClick,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a14831985619a2f7$export$2e2bcd8739ae039)['file-input-button'], {
            [(0, $a14831985619a2f7$export$2e2bcd8739ae039)['force-focus-outline-button']]: isFocused && variant === 'button',
            [(0, $a14831985619a2f7$export$2e2bcd8739ae039)['force-focus-outline-icon']]: isFocused && variant === 'icon'
        }),
        nativeButtonAttributes: {
            tabIndex: -1,
            'aria-hidden': true,
            // AWSUI-61771 Prevent focus on the decorative button to avoid aria-hidden focus warning
            onMouseDown: (event)=>event.preventDefault()
        },
        __skipNativeAttributesWarnings: true
    }, variant === 'button' && children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), {
        id: uploadButtonLabelId
    }, ariaLabel || children));
});
var $5bad98411ec3e571$export$2e2bcd8739ae039 = $5bad98411ec3e571$var$InternalFileInput;





var $01e0319057427be3$export$2e2bcd8739ae039 = {
    "button-group": "awsui_button-group_1v2mg_1s3dt_5",
    "button-group-item": "awsui_button-group-item_1v2mg_1s3dt_9",
    "button-group-tooltip": "awsui_button-group-tooltip_1v2mg_1s3dt_13",
    "item": "awsui_item_1v2mg_1s3dt_17",
    "tooltip": "awsui_tooltip_1v2mg_1s3dt_21"
};


const $698687f2692ae1a5$var$FileInputItem = (0, $acw62.forwardRef)(({ item: item, showTooltip: showTooltip, onTooltipDismiss: onTooltipDismiss, onFilesChange: onFilesChange }, ref)=>{
    const [files, setFiles] = (0, $acw62.useState)([]);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const canShowTooltip = Boolean(showTooltip);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bad98411ec3e571$export$2e2bcd8739ae039), {
        className: (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-item'],
        ref: ref,
        variant: "icon",
        ariaLabel: item.text,
        accept: item.accept,
        multiple: item.multiple,
        value: files,
        onChange: (event)=>{
            (0, $fc537b925f715587$export$d7e1721720edbb03)(onFilesChange, {
                id: item.id,
                files: event.detail.value
            });
            setFiles(event.detail.value);
        },
        "data-testid": item.id,
        __inputNativeAttributes: {
            'data-itemid': item.id
        },
        __inputClassName: (0, $01e0319057427be3$export$2e2bcd8739ae039).item
    }), canShowTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-tooltip'],
        getTrack: ()=>containerRef.current,
        content: item.text,
        onEscape: onTooltipDismiss
    }));
});
var $698687f2692ae1a5$export$2e2bcd8739ae039 = $698687f2692ae1a5$var$FileInputItem;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







const $bd6e6429625b5893$var$IconButtonItem = (0, $acw62.forwardRef)(({ item: item, showTooltip: showTooltip, showFeedback: showFeedback, onTooltipDismiss: onTooltipDismiss, onItemClick: onItemClick }, ref)=>{
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const hasIcon = item.iconName || item.iconUrl || item.iconSvg;
    if (!hasIcon) (0, $013a2451794a45c0$exports.warnOnce)('ButtonGroup', `Missing icon for item with id: ${item.id}`);
    const canShowTooltip = Boolean(showTooltip && !item.disabled && !item.loading);
    const canShowFeedback = Boolean(showTooltip && showFeedback && item.popoverFeedback);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        variant: "icon",
        loading: item.loading,
        loadingText: item.loadingText,
        disabled: item.disabled,
        disabledReason: showFeedback ? undefined : item.disabledReason,
        __focusable: canShowFeedback,
        iconName: hasIcon ? item.iconName : 'close',
        iconUrl: item.iconUrl,
        iconSvg: item.iconSvg,
        iconAlt: item.text,
        ariaLabel: item.text,
        onClick: (event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onItemClick, {
                id: item.id
            }, event),
        ref: ref,
        "data-testid": item.id,
        "data-itemid": item.id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $01e0319057427be3$export$2e2bcd8739ae039).item, (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-item']),
        analyticsAction: item.analyticsAction,
        __title: ""
    }, item.text), (canShowTooltip || canShowFeedback) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-tooltip'],
        getTrack: ()=>containerRef.current,
        content: showFeedback && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
            tagName: "span"
        }, item.popoverFeedback) || item.text,
        onEscape: onTooltipDismiss
    }));
});
var $bd6e6429625b5893$export$2e2bcd8739ae039 = $bd6e6429625b5893$var$IconButtonItem;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $45be9ab1859183ba$export$456263b47a25ca89(pressed, defaultIcon, pressedIcon) {
    if (pressed) return pressedIcon !== null && pressedIcon !== void 0 ? pressedIcon : defaultIcon;
    return defaultIcon;
}



var $afd5f52f905477d1$export$2e2bcd8739ae039 = {
    "variant-normal": "awsui_variant-normal_1a743_14khj_9",
    "pressed": "awsui_pressed_1a743_14khj_9",
    "variant-icon": "awsui_variant-icon_1a743_14khj_15"
};


const $06bcdb71ade47736$export$10cf38f073662d1a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ pressed: pressed, iconName: defaultIconName, pressedIconName: pressedIconName, iconSvg: defaultIconSvg, pressedIconSvg: pressedIconSvg, iconUrl: defaultIconUrl, pressedIconUrl: pressedIconUrl, variant: variant, nativeButtonAttributes: nativeButtonAttributes, onChange: onChange, className: className, analyticsAction: analyticsAction = 'click', ...rest }, ref)=>{
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (defaultIconName && !pressedIconName) (0, $013a2451794a45c0$exports.warnOnce)('ToggleButton', '`pressedIconName` must be provided for `pressed` state.');
        if (defaultIconSvg && !pressedIconSvg) (0, $013a2451794a45c0$exports.warnOnce)('ToggleButton', '`pressedIconSvg` must be provided for `pressed` state.');
        if (defaultIconUrl && !pressedIconUrl) (0, $013a2451794a45c0$exports.warnOnce)('ToggleButton', '`pressedIconUrl` must be provided for `pressed` state.');
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $afd5f52f905477d1$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $afd5f52f905477d1$export$2e2bcd8739ae039).pressed]: pressed
        }),
        variant: variant,
        formAction: "none",
        iconName: (0, $45be9ab1859183ba$export$456263b47a25ca89)(pressed, defaultIconName, pressedIconName),
        iconUrl: (0, $45be9ab1859183ba$export$456263b47a25ca89)(pressed, defaultIconUrl, pressedIconUrl),
        iconSvg: (0, $45be9ab1859183ba$export$456263b47a25ca89)(pressed, defaultIconSvg, pressedIconSvg),
        "aria-pressed": pressed,
        onClick: (event)=>{
            event.preventDefault();
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                pressed: !pressed
            });
        },
        ...rest,
        ref: ref,
        nativeButtonAttributes: nativeButtonAttributes,
        analyticsAction: analyticsAction
    });
});




const $8866dcbf774ab984$var$IconToggleButtonItem = (0, $acw62.forwardRef)(({ item: item, showTooltip: showTooltip, showFeedback: showFeedback, onTooltipDismiss: onTooltipDismiss, onItemClick: onItemClick }, ref)=>{
    var _a;
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const hasIcon = item.iconName || item.iconUrl || item.iconSvg;
    const hasPressedIcon = item.pressedIconName || item.pressedIconUrl || item.pressedIconSvg;
    if (!hasIcon) (0, $013a2451794a45c0$exports.warnOnce)('ButtonGroup', `Missing icon for item with id: ${item.id}`);
    if (!hasPressedIcon) (0, $013a2451794a45c0$exports.warnOnce)('ButtonGroup', `Missing pressed icon for item with id: ${item.id}`);
    const feedbackContent = item.pressed ? (_a = item.pressedPopoverFeedback) !== null && _a !== void 0 ? _a : item.popoverFeedback : item.popoverFeedback;
    const canShowTooltip = showTooltip && !item.disabled && !item.loading;
    const canShowFeedback = showTooltip && showFeedback && feedbackContent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06bcdb71ade47736$export$10cf38f073662d1a), {
        variant: "icon",
        pressed: item.pressed,
        loading: item.loading,
        loadingText: item.loadingText,
        disabled: item.disabled,
        disabledReason: showFeedback ? undefined : item.disabledReason,
        iconName: hasIcon ? item.iconName : 'close',
        iconUrl: item.iconUrl,
        iconSvg: item.iconSvg,
        pressedIconName: hasIcon ? item.pressedIconName : 'close',
        pressedIconUrl: item.pressedIconUrl,
        pressedIconSvg: item.pressedIconUrl,
        ariaLabel: item.text,
        onChange: (event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onItemClick, {
                id: item.id,
                pressed: event.detail.pressed
            }),
        ref: ref,
        "data-testid": item.id,
        "data-itemid": item.id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $01e0319057427be3$export$2e2bcd8739ae039).item, (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-item']),
        analyticsAction: item.analyticsAction,
        __title: ""
    }, item.text), (canShowTooltip || canShowFeedback) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-tooltip'],
        getTrack: ()=>containerRef.current,
        content: showFeedback && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
            tagName: "span"
        }, feedbackContent) || item.text,
        onEscape: onTooltipDismiss
    }));
});
var $8866dcbf774ab984$export$2e2bcd8739ae039 = $8866dcbf774ab984$var$IconToggleButtonItem;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







const $e0bc1d88002fc340$var$MenuDropdownItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ item: item, showTooltip: showTooltip, onItemClick: onItemClick, onTooltipDismiss: onTooltipDismiss, expandToViewport: expandToViewport, position: position }, ref)=>{
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const onClickHandler = (event)=>{
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onItemClick, {
            id: event.detail.id,
            checked: event.detail.checked
        }, event);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), {
        ref: ref,
        variant: "icon",
        items: item.items,
        onItemClick: onClickHandler,
        expandToViewport: expandToViewport,
        ariaLabel: item.text,
        className: (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-item'],
        position: position,
        "data-testid": item.id,
        disabled: item.disabled,
        customTriggerBuilder: ({ onClick: onClick, isOpen: isOpen, triggerRef: triggerRef, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, testUtilsClass: testUtilsClass })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                ref: containerRef,
                ...item.disabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
                    detail: {
                        position: position
                    }
                })
            }, !isOpen && showTooltip && !item.disabled && !item.loading && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
                className: (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group-tooltip'],
                getTrack: ()=>containerRef.current,
                content: item.text,
                onEscape: onTooltipDismiss
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
                ref: triggerRef,
                variant: "icon",
                ariaLabel: ariaLabel,
                "data-itemid": item.id,
                ariaExpanded: ariaExpanded,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $01e0319057427be3$export$2e2bcd8739ae039).item, testUtilsClass),
                iconName: "ellipsis",
                loading: item.loading,
                loadingText: item.loadingText,
                disabled: item.disabled,
                disabledReason: item.disabledReason,
                onClick: onClick,
                __title: ""
            }))
    });
});
var $e0bc1d88002fc340$export$2e2bcd8739ae039 = $e0bc1d88002fc340$var$MenuDropdownItem;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $9937e2870988caf2$export$ee43e763ceafeaf4(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !(style === null || style === void 0 ? void 0 : style.root)) return undefined;
    return {
        borderRadius: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.borderRadius,
        borderWidth: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderWidth,
        borderStyle: ((_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.borderWidth) ? 'solid' : undefined,
        boxShadow: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.boxShadow,
        paddingBlock: (_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.paddingBlock,
        paddingInline: (_f = style === null || style === void 0 ? void 0 : style.root) === null || _f === void 0 ? void 0 : _f.paddingInline,
        background: (_g = style === null || style === void 0 ? void 0 : style.root) === null || _g === void 0 ? void 0 : _g.background,
        borderColor: (_h = style === null || style === void 0 ? void 0 : style.root) === null || _h === void 0 ? void 0 : _h.borderColor,
        ...((_j = style === null || style === void 0 ? void 0 : style.root) === null || _j === void 0 ? void 0 : _j.focusRing) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: (_k = style.root.focusRing) === null || _k === void 0 ? void 0 : _k.borderColor,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_l = style.root.focusRing) === null || _l === void 0 ? void 0 : _l.borderRadius,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_m = style.root.focusRing) === null || _m === void 0 ? void 0 : _m.borderWidth
        }
    };
}
function $9937e2870988caf2$export$356696828c3b9055(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !(style === null || style === void 0 ? void 0 : style.item)) return undefined;
    return {
        ...((_a = style === null || style === void 0 ? void 0 : style.item) === null || _a === void 0 ? void 0 : _a.color) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorActive]: (_b = style.item.color) === null || _b === void 0 ? void 0 : _b.active,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDefault]: (_c = style.item.color) === null || _c === void 0 ? void 0 : _c.default,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDisabled]: (_d = style.item.color) === null || _d === void 0 ? void 0 : _d.disabled,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorHover]: (_e = style.item.color) === null || _e === void 0 ? void 0 : _e.hover
        },
        ...((_f = style === null || style === void 0 ? void 0 : style.item) === null || _f === void 0 ? void 0 : _f.boxShadow) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowActive]: (_g = style.item.boxShadow) === null || _g === void 0 ? void 0 : _g.active,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowDefault]: (_h = style.item.boxShadow) === null || _h === void 0 ? void 0 : _h.default,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowDisabled]: (_j = style.item.boxShadow) === null || _j === void 0 ? void 0 : _j.disabled,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowHover]: (_k = style.item.boxShadow) === null || _k === void 0 ? void 0 : _k.hover
        },
        ...((_l = style === null || style === void 0 ? void 0 : style.item) === null || _l === void 0 ? void 0 : _l.focusRing) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: (_m = style.item.focusRing) === null || _m === void 0 ? void 0 : _m.borderColor,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_o = style.item.focusRing) === null || _o === void 0 ? void 0 : _o.borderRadius,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_p = style.item.focusRing) === null || _p === void 0 ? void 0 : _p.borderWidth
        }
    };
}



var $7e3a3bb234044958$export$2e2bcd8739ae039 = {
    "root": "awsui_root_vdkpj_18dsz_181",
    "item-wrapper": "awsui_item-wrapper_vdkpj_18dsz_217",
    "group": "awsui_group_vdkpj_18dsz_221",
    "divider": "awsui_divider_vdkpj_18dsz_225"
};


const $afae460b206ddf41$var$ItemElement = (0, $acw62.forwardRef)(({ item: item, dropdownExpandToViewport: dropdownExpandToViewport, tooltip: tooltip, setTooltip: setTooltip, onItemClick: onItemClick, onFilesChange: onFilesChange, position: position, style: style }, ref)=>{
    const containerRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const fileInputRef = (0, $acw62.useRef)(null);
    const buttonDropdownRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus: ()=>{
                var _a, _b, _c;
                (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
                (_b = fileInputRef.current) === null || _b === void 0 || _b.focus();
                (_c = buttonDropdownRef.current) === null || _c === void 0 || _c.focus();
            }
        }));
    (0, $acw62.useEffect)(()=>{
        if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.item) !== item.id) return;
        const close = ()=>{
            setTooltip(null);
        };
        const handlePointerDownEvent = (event)=>{
            var _a;
            if (event.target && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) return;
            close();
        };
        const handleKeyDownEvent = (event)=>{
            if (event.key === 'Escape') close();
        };
        const controller = new AbortController();
        window.addEventListener('pointerdown', handlePointerDownEvent, {
            signal: controller.signal
        });
        window.addEventListener('keydown', handleKeyDownEvent, {
            signal: controller.signal
        });
        return ()=>{
            controller.abort();
        };
    }, [
        item.id,
        tooltip,
        setTooltip
    ]);
    const onShowTooltipSoft = (show)=>{
        if (!(tooltip === null || tooltip === void 0 ? void 0 : tooltip.feedback)) setTooltip(show ? {
            item: item.id,
            feedback: false
        } : null);
    };
    const onShowTooltipHard = (show)=>{
        if (!show && item.id !== (tooltip === null || tooltip === void 0 ? void 0 : tooltip.item)) return;
        setTooltip(show ? {
            item: item.id,
            feedback: false
        } : null);
    };
    const onClickHandler = (event)=>{
        const hasPopoverFeedback = 'popoverFeedback' in item && item.popoverFeedback;
        if (hasPopoverFeedback) setTooltip({
            item: item.id,
            feedback: true
        });
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onItemClick, event.detail, event);
    };
    const onFilesChangeHandler = (event)=>{
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onFilesChange, event.detail, event);
        setTooltip(null);
    };
    const itemStylePropertiesAndVariables = (0, $9937e2870988caf2$export$356696828c3b9055)(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: item.id,
        className: (0, $7e3a3bb234044958$export$2e2bcd8739ae039)['item-wrapper'],
        ref: containerRef,
        onPointerEnter: ()=>onShowTooltipSoft(true),
        onPointerLeave: ()=>onShowTooltipSoft(false),
        onFocus: (event)=>{
            // Showing no tooltip when the focus comes from inside the container.
            // This is needed to prevent the tooltip after a menu closes with item selection or Escape.
            if (event && event.relatedTarget && (0, $4c778684f125e678$export$57d4cb221e1d1857)(containerRef.current, event.relatedTarget)) return;
            onShowTooltipHard(true);
        },
        onBlur: ()=>onShowTooltipHard(false),
        style: itemStylePropertiesAndVariables,
        ...item.type === 'menu-dropdown' || item.disabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            detail: {
                position: position,
                id: item.id
            }
        })
    }, item.type === 'icon-button' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bd6e6429625b5893$export$2e2bcd8739ae039), {
        ref: buttonRef,
        item: item,
        onItemClick: onClickHandler,
        showTooltip: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.item) === item.id,
        showFeedback: !!(tooltip === null || tooltip === void 0 ? void 0 : tooltip.feedback),
        onTooltipDismiss: ()=>setTooltip(null)
    }), item.type === 'icon-toggle-button' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8866dcbf774ab984$export$2e2bcd8739ae039), {
        ref: buttonRef,
        item: item,
        onItemClick: onClickHandler,
        showTooltip: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.item) === item.id,
        showFeedback: !!(tooltip === null || tooltip === void 0 ? void 0 : tooltip.feedback),
        onTooltipDismiss: ()=>setTooltip(null)
    }), item.type === 'icon-file-input' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $698687f2692ae1a5$export$2e2bcd8739ae039), {
        ref: fileInputRef,
        item: item,
        onFilesChange: onFilesChangeHandler,
        showTooltip: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.item) === item.id,
        onTooltipDismiss: ()=>setTooltip(null)
    }), item.type === 'menu-dropdown' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e0bc1d88002fc340$export$2e2bcd8739ae039), {
        ref: buttonDropdownRef,
        item: item,
        showTooltip: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.item) === item.id,
        onItemClick: onClickHandler,
        expandToViewport: dropdownExpandToViewport,
        onTooltipDismiss: ()=>setTooltip(null),
        position: position
    }));
});
var $afae460b206ddf41$export$2e2bcd8739ae039 = $afae460b206ddf41$var$ItemElement;





const $ed198dba2f0fe830$var$InternalButtonGroup = (0, $acw62.forwardRef)(({ items: items = [], onItemClick: onItemClick, onFilesChange: onFilesChange, ariaLabel: ariaLabel, dropdownExpandToViewport: dropdownExpandToViewport, style: style, __internalRootRef: __internalRootRef, ...props }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const itemsRef = (0, $acw62.useRef)({});
    const [tooltip, setTooltip] = (0, $acw62.useState)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus: (id)=>{
                var _a;
                (_a = itemsRef.current[id]) === null || _a === void 0 || _a.focus();
            }
        }));
    const stylePropertiesAndVariables = (0, $9937e2870988caf2$export$ee43e763ceafeaf4)(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7e3a3bb234044958$export$2e2bcd8739ae039).root, (0, $01e0319057427be3$export$2e2bcd8739ae039)['button-group'], baseProps.className),
        role: "toolbar",
        "aria-label": ariaLabel,
        style: stylePropertiesAndVariables
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b29b9620a65adc52$export$2e2bcd8739ae039), {
        getItemKey: (item)=>item.dataset.itemid
    }, items.map((itemOrGroup, index)=>{
        var _a;
        const itemContent = (item, position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afae460b206ddf41$export$2e2bcd8739ae039), {
                key: item.id,
                item: item,
                dropdownExpandToViewport: dropdownExpandToViewport,
                tooltip: tooltip,
                setTooltip: setTooltip,
                onItemClick: onItemClick,
                onFilesChange: onFilesChange,
                ref: (element)=>itemsRef.current[item.id] = element,
                position: position,
                style: style
            });
        const isGroupBefore = ((_a = items[index - 1]) === null || _a === void 0 ? void 0 : _a.type) === 'group';
        const currentItem = items[index];
        const isGroupNow = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.type) === 'group';
        const shouldAddDivider = isGroupBefore || !isGroupBefore && isGroupNow && index !== 0;
        if (isGroupNow && currentItem.items.length === 0) (0, $013a2451794a45c0$exports.warnOnce)('ButtonGroup', 'Empty group detected. Empty groups are not allowed.');
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: itemOrGroup.type === 'group' ? index : itemOrGroup.id
        }, shouldAddDivider && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7e3a3bb234044958$export$2e2bcd8739ae039).divider
        }), itemOrGroup.type === 'group' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: index,
            role: "group",
            "aria-label": itemOrGroup.text,
            className: (0, $7e3a3bb234044958$export$2e2bcd8739ae039).group
        }, itemOrGroup.items.map((item, subIndex)=>itemContent(item, `${index + 1},${subIndex + 1}`))) : itemContent(itemOrGroup, `${index + 1}`));
    })));
});
var $ed198dba2f0fe830$export$2e2bcd8739ae039 = $ed198dba2f0fe830$var$InternalButtonGroup;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $adcc0ef515e81249$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};








function $94a17158ca078e4c$var$AppLayoutGlobalDrawerImplementation({ appLayoutInternals: appLayoutInternals, show: show, activeGlobalDrawer: activeGlobalDrawer }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { ariaLabels: ariaLabels, globalDrawersFocusControl: globalDrawersFocusControl, isMobile: isMobile, placement: placement, onActiveGlobalDrawersChange: onActiveGlobalDrawersChange, onActiveDrawerResize: onActiveDrawerResize, minGlobalDrawersSizes: minGlobalDrawersSizes, maxGlobalDrawersSizes: maxGlobalDrawersSizes, activeGlobalDrawersSizes: activeGlobalDrawersSizes, activeGlobalDrawers: activeGlobalDrawers, verticalOffsets: verticalOffsets, drawersOpenQueue: drawersOpenQueue, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, activeAiDrawer: activeAiDrawer } = appLayoutInternals;
    const drawerRef = (0, $acw62.useRef)(null);
    const activeDrawerId = (_a = activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.id) !== null && _a !== void 0 ? _a : '';
    const computedAriaLabels = {
        closeButton: activeGlobalDrawer ? (_b = activeGlobalDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.closeButton : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose,
        content: activeGlobalDrawer ? (_c = activeGlobalDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.drawerName : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools
    };
    const { drawerTopOffset: drawerTopOffset, drawerHeight: drawerHeight } = (0, $ff079cc12921495d$export$d60a2a5f5d1f1f3d)(verticalOffsets, isMobile, placement);
    const activeDrawerSize = (_d = activeDrawerId ? activeGlobalDrawersSizes[activeDrawerId] : 0) !== null && _d !== void 0 ? _d : 0;
    const minDrawerSize = (_e = activeDrawerId ? minGlobalDrawersSizes[activeDrawerId] : 0) !== null && _e !== void 0 ? _e : 0;
    const maxDrawerSize = (_f = activeDrawerId ? maxGlobalDrawersSizes[activeDrawerId] : 0) !== null && _f !== void 0 ? _f : 0;
    const refs = globalDrawersFocusControl.refs[activeDrawerId];
    const resizeProps = (0, $e7f76d3277b180ed$export$e8b771555dc4a003)({
        currentWidth: activeDrawerSize,
        minWidth: minDrawerSize,
        maxWidth: maxDrawerSize,
        panelRef: drawerRef,
        handleRef: refs === null || refs === void 0 ? void 0 : refs.slider,
        onResize: (size)=>onActiveDrawerResize({
                id: activeDrawerId,
                size: size
            })
    });
    const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minDrawerSize, activeDrawerSize, maxDrawerSize);
    const lastOpenedDrawerId = drawersOpenQueue.length ? drawersOpenQueue[0] : null;
    const hasTriggerButton = !!(activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.trigger);
    const isExpanded = (activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.isExpandable) && expandedDrawerId === activeDrawerId;
    const wasExpanded = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(isExpanded);
    const animationDisabled = (activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.defaultActive) && !drawersOpenQueue.includes(activeGlobalDrawer.id) || wasExpanded && !isExpanded;
    let drawerActions = [
        {
            type: 'icon-button',
            id: 'close',
            iconName: isMobile ? 'close' : 'angle-right',
            text: (_g = computedAriaLabels.closeButton) !== null && _g !== void 0 ? _g : '',
            analyticsAction: 'close'
        }
    ];
    if (!isMobile && (activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.isExpandable)) drawerActions = [
        {
            type: 'icon-button',
            id: 'expand',
            iconName: isExpanded ? 'shrink' : 'expand',
            text: (_j = (_h = activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.ariaLabels) === null || _h === void 0 ? void 0 : _h.expandedModeButton) !== null && _j !== void 0 ? _j : '',
            analyticsAction: isExpanded ? 'expand' : 'collapse'
        },
        ...drawerActions
    ];
    if (activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.headerActions) drawerActions = [
        {
            type: 'group',
            text: 'Actions',
            items: activeGlobalDrawer.headerActions
        },
        ...drawerActions
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), {
        nodeRef: drawerRef,
        in: show || isExpanded,
        appear: show || isExpanded,
        timeout: 0
    }, (state)=>{
        var _a, _b;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
            id: activeDrawerId,
            "aria-hidden": !show,
            "aria-label": computedAriaLabels.content,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039).drawer, (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-global'], (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)[state], !animationDisabled && (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal'], !animationDisabled && isExpanded && (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['with-expanded-motion'], {
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-hidden']]: !show,
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['last-opened']]: !activeAiDrawer && lastOpenedDrawerId === activeDrawerId || isExpanded,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer']]: show,
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-expanded']]: isExpanded,
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['has-next-siblings']]: activeGlobalDrawers.findIndex((drawer)=>drawer.id === activeDrawerId) + 1 < activeGlobalDrawers.length
            }),
            ref: drawerRef,
            onBlur: (e)=>{
                // Drawers with trigger buttons follow this restore focus logic:
                // If a previously focused element exists, restore focus on it; otherwise, focus on the associated trigger button.
                // This function resets the previously focused element.
                // If the drawer has no trigger button and loses focus on the previously focused element, it defaults to document.body,
                // which ideally should never happen.
                if (!hasTriggerButton) return;
                if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) globalDrawersFocusControl.loseFocus();
            },
            style: {
                blockSize: drawerHeight,
                insetBlockStart: drawerTopOffset,
                ...!isMobile && {
                    [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).drawerSize]: `${[
                        'entering',
                        'entered'
                    ].includes(state) ? isExpanded ? '100%' : size + 'px' : 0}`
                }
            },
            "data-testid": `awsui-app-layout-drawer-${activeDrawerId}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['global-drawer-wrapper'])
        }, !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-gap']
        }), !isMobile && (activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.resizable) && !isExpanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-slider']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
            ref: refs === null || refs === void 0 ? void 0 : refs.slider,
            position: "side",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-slider'],
            ariaLabel: (_a = activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.resizeHandle,
            tooltipText: (_b = activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.resizeHandleTooltipText,
            ariaValuenow: resizeProps.relativeSize,
            onKeyDown: resizeProps.onKeyDown,
            onDirectionClick: resizeProps.onDirectionClick,
            onPointerDown: resizeProps.onPointerDown
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-container'], (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal']),
            "data-testid": `awsui-app-layout-drawer-content-${activeDrawerId}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-actions']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed198dba2f0fe830$export$2e2bcd8739ae039), {
            dropdownExpandToViewport: false,
            variant: "icon",
            onItemClick: (event)=>{
                var _a;
                switch(event.detail.id){
                    case 'close':
                        onActiveGlobalDrawersChange(activeDrawerId, {
                            initiatedByUserAction: true
                        });
                        break;
                    case 'expand':
                        setExpandedDrawerId(isExpanded ? null : activeDrawerId);
                        break;
                    default:
                        (_a = activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.onHeaderActionClick) === null || _a === void 0 || _a.call(activeGlobalDrawer, event);
                }
            },
            ariaLabel: "Global panel actions",
            items: drawerActions,
            __internalRootRef: (root)=>{
                if (!root) return;
                refs.close = {
                    current: root.querySelector('[data-itemid="close"]')
                };
            }
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content'],
            style: {
                blockSize: drawerHeight
            }
        }, activeGlobalDrawer === null || activeGlobalDrawer === void 0 ? void 0 : activeGlobalDrawer.content))));
    });
}
var $94a17158ca078e4c$export$2e2bcd8739ae039 = $94a17158ca078e4c$var$AppLayoutGlobalDrawerImplementation;


function $fa58b54398feef3b$export$5fe44d52ba702782({ appLayoutInternals: appLayoutInternals }) {
    const { globalDrawers: globalDrawers, activeGlobalDrawersIds: activeGlobalDrawersIds, expandedDrawerId: expandedDrawerId } = appLayoutInternals;
    const openDrawersHistory = (0, $acw62.useRef)(new Set());
    if (!globalDrawers.length) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, globalDrawers.filter((drawer)=>drawer.position !== 'bottom' && activeGlobalDrawersIds.includes(drawer.id) || drawer.preserveInactiveContent && openDrawersHistory.current.has(drawer.id)).map((drawer)=>{
        openDrawersHistory.current.add(drawer.id);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $94a17158ca078e4c$export$2e2bcd8739ae039), {
            key: drawer.id,
            show: activeGlobalDrawersIds.includes(drawer.id) && (!expandedDrawerId || drawer.id === expandedDrawerId),
            activeGlobalDrawer: drawer,
            appLayoutInternals: appLayoutInternals
        });
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");












function $3574b830ff665c30$export$9bfd4bb22f91d1a3({ widgetizedState: widgetizedState }) {
    const { activeGlobalBottomDrawerId: activeGlobalBottomDrawerId, bottomDrawers: bottomDrawers } = widgetizedState;
    const openBottomDrawersHistory = (0, $acw62.useRef)(new Set());
    (0, $acw62.useEffect)(()=>{
        if (activeGlobalBottomDrawerId) openBottomDrawersHistory.current.add(activeGlobalBottomDrawerId);
    }, [
        activeGlobalBottomDrawerId
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, bottomDrawers.map((drawer)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3574b830ff665c30$var$AppLayoutGlobalBottomDrawerImplementation, {
            key: drawer.id,
            activeDrawer: activeGlobalBottomDrawerId === drawer.id || drawer.preserveInactiveContent && openBottomDrawersHistory.current.has(drawer.id) ? drawer : undefined,
            show: activeGlobalBottomDrawerId === drawer.id,
            widgetizedState: widgetizedState
        });
    }));
}
const $3574b830ff665c30$var$GAP_HEIGHT = 10;
const $3574b830ff665c30$var$RESIZE_HANDLER_HEIGHT = 18;
function $3574b830ff665c30$var$AppLayoutGlobalBottomDrawerImplementation({ widgetizedState: widgetizedState, show: show, activeDrawer: activeDrawer }) {
    var _a, _b, _c, _d, _e, _f;
    const { ariaLabels: ariaLabels, isMobile: isMobile, onActiveGlobalBottomDrawerChange: onActiveGlobalBottomDrawerChange, onActiveBottomDrawerResize: onActiveBottomDrawerResize, minGlobalBottomDrawerSize: minGlobalBottomDrawerSize, activeGlobalBottomDrawerSize: activeGlobalBottomDrawerSize, drawersOpenQueue: drawersOpenQueue, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, activeAiDrawer: activeAiDrawer, bottomDrawersFocusControl: bottomDrawersFocusControl, getMaxGlobalBottomDrawerHeight: getMaxGlobalBottomDrawerHeight, reportBottomDrawerSize: reportBottomDrawerSize, verticalOffsets: verticalOffsets, placement: placement } = widgetizedState;
    const drawerRef = (0, $acw62.useRef)(null);
    const headerRef = (0, $acw62.useRef)(null);
    const activeDrawerId = (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== null && _a !== void 0 ? _a : '';
    const computedAriaLabels = {
        closeButton: activeDrawer ? (_b = activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.closeButton : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose,
        content: activeDrawer ? (_c = activeDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.drawerName : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools
    };
    const { drawerTopOffset: mobileDrawerTopOffset, drawerHeight: drawerFullScreenHeight } = (0, $ff079cc12921495d$export$d60a2a5f5d1f1f3d)(verticalOffsets, isMobile, placement);
    const activeDrawerSize = activeGlobalBottomDrawerSize !== null && activeGlobalBottomDrawerSize !== void 0 ? activeGlobalBottomDrawerSize : 0;
    const minDrawerSize = minGlobalBottomDrawerSize !== null && minGlobalBottomDrawerSize !== void 0 ? minGlobalBottomDrawerSize : 0;
    const maxDrawerSize = getMaxGlobalBottomDrawerHeight();
    const refs = bottomDrawersFocusControl.refs;
    const resizeProps = (0, $e7f76d3277b180ed$export$e8b771555dc4a003)({
        currentWidth: activeDrawerSize,
        minWidth: minDrawerSize,
        maxWidth: maxDrawerSize,
        panelRef: drawerRef,
        handleRef: refs === null || refs === void 0 ? void 0 : refs.slider,
        onResize: (size)=>onActiveBottomDrawerResize({
                id: activeDrawerId,
                size: size
            }),
        position: 'bottom'
    });
    const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minDrawerSize, activeDrawerSize, maxDrawerSize);
    const lastOpenedDrawerId = drawersOpenQueue.length ? drawersOpenQueue[0] : null;
    const hasTriggerButton = !!(activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.trigger);
    const isExpanded = (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.isExpandable) && expandedDrawerId === activeDrawerId;
    const wasExpanded = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(isExpanded);
    const animationDisabled = (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.defaultActive) && !drawersOpenQueue.includes(activeDrawer.id) || wasExpanded && !isExpanded;
    // Prevent main content scroll when bottom drawer opens with animations
    (0, $acw62.useEffect)(()=>{
        if (show && drawerRef.current) {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const abortController = new AbortController();
            // Temporarily prevent scrolling during animation
            const preventScroll = ()=>{
                document.documentElement.scrollTop = scrollTop;
                document.body.scrollTop = scrollTop;
            };
            // Handle transition end to remove scroll prevention
            const handleTransitionEnd = (event)=>{
                // Only handle transitions on the drawer element itself
                if (event.target === drawerRef.current) abortController.abort();
            };
            // Add scroll prevention during animation
            document.addEventListener('scroll', preventScroll, {
                passive: false,
                signal: abortController.signal
            });
            drawerRef.current.addEventListener('transitionend', handleTransitionEnd, {
                signal: abortController.signal
            });
            return ()=>{
                abortController.abort();
            };
        }
    }, [
        show
    ]);
    let drawerActions = [
        {
            type: 'icon-button',
            id: 'close',
            iconName: isMobile ? 'close' : 'angle-down',
            text: (_d = computedAriaLabels.closeButton) !== null && _d !== void 0 ? _d : '',
            analyticsAction: 'close'
        }
    ];
    if (!isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.isExpandable)) drawerActions = [
        {
            type: 'icon-toggle-button',
            id: 'expand',
            iconName: isExpanded ? 'shrink' : 'expand',
            text: (_f = (_e = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _e === void 0 ? void 0 : _e.expandedModeButton) !== null && _f !== void 0 ? _f : '',
            pressed: !!isExpanded,
            analyticsAction: isExpanded ? 'expand' : 'collapse'
        },
        ...drawerActions
    ];
    if (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.headerActions) drawerActions = [
        {
            type: 'group',
            text: 'Actions',
            items: activeDrawer.headerActions
        },
        ...drawerActions
    ];
    (0, $acw62.useEffect)(()=>{
        reportBottomDrawerSize(size);
    }, [
        reportBottomDrawerSize,
        size
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), {
        nodeRef: drawerRef,
        in: show || isExpanded,
        appear: show || isExpanded,
        mountOnEnter: true,
        timeout: 250
    }, (state)=>{
        var _a, _b, _c, _d, _e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
            id: activeDrawerId,
            "aria-hidden": !show,
            "aria-label": computedAriaLabels.content,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039).drawer, (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['bottom-drawer'], (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)[state], !animationDisabled && (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-vertical'], !animationDisabled && isExpanded && (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['with-expanded-motion'], {
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-hidden']]: !show && state === 'exited',
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['last-opened']]: !activeAiDrawer && lastOpenedDrawerId === activeDrawerId || isExpanded,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer']]: show,
                [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-expanded']]: isExpanded
            }),
            ref: drawerRef,
            onBlur: (e)=>{
                // Drawers with trigger buttons follow this restore focus logic:
                // If a previously focused element exists, restore focus on it; otherwise, focus on the associated trigger button.
                // This function resets the previously focused element.
                // If the drawer has no trigger button and loses focus on the previously focused element, it defaults to document.body,
                // which ideally should never happen.
                if (!hasTriggerButton) return;
                if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) bottomDrawersFocusControl.loseFocus();
            },
            style: {
                ...isMobile && {
                    blockSize: drawerFullScreenHeight,
                    insetBlockStart: mobileDrawerTopOffset
                },
                ...!isMobile && {
                    [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).bottomDrawerSize]: `${[
                        'entering',
                        'entered'
                    ].includes(state) ? isExpanded ? drawerFullScreenHeight : size + 'px' : 0}`
                }
            },
            "data-testid": `awsui-app-layout-drawer-${activeDrawerId}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['global-drawer-wrapper'])
        }, !isMobile && !isExpanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-gap']
        }), !isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.resizable) && !isExpanded && // Prevents receiving focus in Firefox
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-slider'],
            tabIndex: -1
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
            ref: refs === null || refs === void 0 ? void 0 : refs.slider,
            position: "bottom",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-slider'],
            ariaLabel: (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.resizeHandle,
            tooltipText: (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.resizeHandleTooltipText,
            ariaValuenow: resizeProps.relativeSize,
            onKeyDown: resizeProps.onKeyDown,
            onDirectionClick: resizeProps.onDirectionClick,
            onPointerDown: resizeProps.onPointerDown
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['bottom-drawer-content-header'],
            ref: headerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['bottom-drawer-content-header-content']
        }, (_c = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.header) !== null && _c !== void 0 ? _c : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['bottom-drawer-actions']
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed198dba2f0fe830$export$2e2bcd8739ae039), {
            dropdownExpandToViewport: false,
            variant: "icon",
            onItemClick: (event)=>{
                var _a;
                switch(event.detail.id){
                    case 'close':
                        onActiveGlobalBottomDrawerChange(null, {
                            initiatedByUserAction: true
                        });
                        break;
                    case 'expand':
                        setExpandedDrawerId(isExpanded ? null : activeDrawerId);
                        break;
                    default:
                        (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.onHeaderActionClick) === null || _a === void 0 || _a.call(activeDrawer, event);
                }
            },
            ariaLabel: "Global panel actions",
            items: drawerActions,
            __internalRootRef: (root)=>{
                if (!root) return;
                refs.close = {
                    current: root.querySelector('[data-itemid="close"]')
                };
            }
        })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-container'], (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal']),
            "data-testid": `awsui-app-layout-drawer-content-${activeDrawerId}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content'],
            style: {
                blockSize: isMobile || isExpanded ? drawerFullScreenHeight : `${size - $3574b830ff665c30$var$GAP_HEIGHT - $3574b830ff665c30$var$RESIZE_HANDLER_HEIGHT - ((_e = (_d = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _d === void 0 ? void 0 : _d.clientHeight) !== null && _e !== void 0 ? _e : 0)}px`
            }
        }, activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.content))));
    });
}
var $3574b830ff665c30$export$2e2bcd8739ae039 = $3574b830ff665c30$var$AppLayoutGlobalBottomDrawerImplementation;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $d610b54fba123b07$export$2e2bcd8739ae039 = {
    "split-panel-side": "awsui_split-panel-side_j4v3w_1dcwh_145"
};


function $78b6bd93db866585$export$bf635d59bdc70f27({ children: children, appLayoutInternals: appLayoutInternals, splitPanelInternals: splitPanelInternals, bottomDrawerReportedSize: bottomDrawerReportedSize }) {
    const { splitPanelControlId: splitPanelControlId, placement: placement, verticalOffsets: verticalOffsets, isMobile: isMobile, splitPanelAnimationDisabled: splitPanelAnimationDisabled } = appLayoutInternals;
    const { drawerTopOffset: drawerTopOffset, drawerHeight: drawerHeight } = (0, $ff079cc12921495d$export$d60a2a5f5d1f1f3d)(verticalOffsets, isMobile, placement, isMobile ? 0 : bottomDrawerReportedSize !== null && bottomDrawerReportedSize !== void 0 ? bottomDrawerReportedSize : 0);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), {
        ...splitPanelInternals,
        animationDisabled: splitPanelAnimationDisabled
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        id: splitPanelControlId,
        className: (0, $d610b54fba123b07$export$2e2bcd8739ae039)['split-panel-side'],
        style: {
            blockSize: drawerHeight,
            insetBlockStart: drawerTopOffset
        }
    }, children));
}
function $78b6bd93db866585$export$16518e502b491282({ children: children, splitPanelInternals: splitPanelInternals, appLayoutInternals: appLayoutInternals }) {
    const { splitPanelControlId: splitPanelControlId, splitPanelAnimationDisabled: splitPanelAnimationDisabled } = appLayoutInternals;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), {
        ...splitPanelInternals,
        animationDisabled: splitPanelAnimationDisabled
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        id: splitPanelControlId
    }, children));
}


function $6574ac16ad1fbe57$export$54888fc7ce30d8c8(state) {
    return !!state.widgetizedState;
}




const $ec3fb68fb595309d$export$2099d7746a959a87 = ({ appLayoutState: appLayoutState, appLayoutProps: appLayoutProps })=>{
    if (!(0, $6574ac16ad1fbe57$export$54888fc7ce30d8c8)(appLayoutState)) return null;
    const { navigationOpen: navigationOpen, activeGlobalDrawersIds: activeGlobalDrawersIds, expandedDrawerId: expandedDrawerId, activeDrawer: activeDrawer, splitPanelOpen: splitPanelOpen, drawers: drawers, splitPanelPosition: splitPanelPosition, activeGlobalBottomDrawerId: activeGlobalBottomDrawerId, bottomDrawers: bottomDrawers, bottomDrawerReportedSize: bottomDrawerReportedSize } = appLayoutState.widgetizedState;
    const drawerExpandedMode = !!expandedDrawerId;
    const toolsOpen = !!activeDrawer;
    const globalToolsOpen = !!(activeGlobalDrawersIds === null || activeGlobalDrawersIds === void 0 ? void 0 : activeGlobalDrawersIds.length);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !!bottomDrawers.length && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['bottom-tool']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bf410ac4539db587$export$adc986c053591633).Provider, {
        value: activeGlobalBottomDrawerId ? [
            activeGlobalBottomDrawerId
        ] : []
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3574b830ff665c30$export$9bfd4bb22f91d1a3), {
        widgetizedState: appLayoutState.widgetizedState
    }))), splitPanelPosition === 'side' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['split-panel-side'], !splitPanelOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['panel-hidden'], drawerExpandedMode && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).hidden)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78b6bd93db866585$export$bf635d59bdc70f27), {
        appLayoutInternals: appLayoutState.appLayoutInternals,
        splitPanelInternals: appLayoutState.splitPanelInternals,
        bottomDrawerReportedSize: bottomDrawerReportedSize
    }, appLayoutProps.splitPanel)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).tools, !toolsOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['panel-hidden'], (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal'], navigationOpen && !toolsOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['unfocusable-mobile'], toolsOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['tools-open'], drawerExpandedMode && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).hidden)
    }, drawers && drawers.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ad280251af4a465$export$bf7efb8fc3f7ac58), {
        appLayoutInternals: appLayoutState.appLayoutInternals,
        bottomDrawerReportedSize: activeGlobalBottomDrawerId ? bottomDrawerReportedSize : 0
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['global-tools'], !globalToolsOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['panel-hidden'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bf410ac4539db587$export$adc986c053591633).Provider, {
        value: activeGlobalDrawersIds !== null && activeGlobalDrawersIds !== void 0 ? activeGlobalDrawersIds : []
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fa58b54398feef3b$export$5fe44d52ba702782), {
        appLayoutInternals: appLayoutState.appLayoutInternals
    }))));
};
const $ec3fb68fb595309d$export$3db9737c19e6e700 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($ec3fb68fb595309d$export$2099d7746a959a87);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");











function $eba55b24da75eb7d$export$ac0991eb1c14eb28({ appLayoutInternals: appLayoutInternals, show: show, activeAiDrawer: activeAiDrawer, aiDrawerProps: aiDrawerProps }) {
    var _a, _b, _c, _d;
    const { activeAiDrawerSize: activeAiDrawerSize, minAiDrawerSize: minAiDrawerSize, maxAiDrawerSize: maxAiDrawerSize, ariaLabels: ariaLabels, aiDrawerFocusControl: aiDrawerFocusControl, isMobile: isMobile, drawersOpenQueue: drawersOpenQueue, onActiveAiDrawerChange: onActiveAiDrawerChange, onActiveDrawerResize: onActiveDrawerResize, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId } = aiDrawerProps;
    const { verticalOffsets: verticalOffsets, placement: placement } = appLayoutInternals;
    const drawerRef = (0, $acw62.useRef)(null);
    const activeDrawerId = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.id;
    const computedAriaLabels = {
        closeButton: activeAiDrawer ? (_a = activeAiDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.closeButton : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose,
        content: activeAiDrawer ? (_b = activeAiDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.drawerName : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools
    };
    const resizeProps = (0, $e7f76d3277b180ed$export$e8b771555dc4a003)({
        currentWidth: activeAiDrawerSize,
        minWidth: minAiDrawerSize,
        maxWidth: maxAiDrawerSize,
        panelRef: drawerRef,
        handleRef: aiDrawerFocusControl.refs.slider,
        onResize: (size)=>{
            onActiveDrawerResize({
                id: activeDrawerId,
                size: size
            });
        },
        position: 'side-start'
    });
    const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minAiDrawerSize, activeAiDrawerSize, maxAiDrawerSize);
    const isExpanded = (activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.isExpandable) && expandedDrawerId === activeDrawerId;
    const wasExpanded = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(isExpanded);
    const animationDisabled = (activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.defaultActive) && !(drawersOpenQueue === null || drawersOpenQueue === void 0 ? void 0 : drawersOpenQueue.includes(activeAiDrawer.id)) || wasExpanded && !isExpanded;
    const drawerHeight = `calc(100vh - ${verticalOffsets.toolbar + placement.insetBlockEnd}px)`;
    // disable resizing when the drawer is at its minimum width in a "squeezed" state
    // (window is between mobile and desktop sizes). At this point, the drawer can't be
    // resized in either direction, so we disable the resize handler
    const isResizingDisabled = maxAiDrawerSize < activeAiDrawerSize;
    let drawerActions = [
        {
            type: 'icon-button',
            id: 'close',
            iconName: isMobile ? 'close' : 'angle-left',
            text: computedAriaLabels.closeButton,
            analyticsAction: 'close'
        }
    ];
    if (!isMobile && (activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.isExpandable)) drawerActions = [
        {
            type: 'icon-button',
            id: 'expand',
            iconName: isExpanded ? 'shrink' : 'expand',
            text: (_d = (_c = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.expandedModeButton) !== null && _d !== void 0 ? _d : '',
            analyticsAction: isExpanded ? 'expand' : 'collapse'
        },
        ...drawerActions
    ];
    if (activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.headerActions) drawerActions = [
        {
            type: 'group',
            text: 'Actions',
            items: activeAiDrawer.headerActions
        },
        ...drawerActions
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), {
        nodeRef: drawerRef,
        in: show,
        appear: show,
        mountOnEnter: true,
        timeout: 250
    }, (drawerTransitionState)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), {
            nodeRef: drawerRef,
            in: isExpanded,
            timeout: 250
        }, (expandedTransitionState)=>{
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
                id: activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.id,
                "aria-hidden": !activeAiDrawer,
                "aria-label": computedAriaLabels.content,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039).drawer, (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['ai-drawer'], !animationDisabled && isExpanded && (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['with-expanded-motion'], {
                    [(0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal']]: !animationDisabled,
                    [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-drawer']]: show,
                    [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-hidden']]: !show && drawerTransitionState === 'exited',
                    [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !activeAiDrawer,
                    [(0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-expanded']]: isExpanded
                }),
                ref: drawerRef,
                onBlur: (e)=>{
                    if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) aiDrawerFocusControl === null || aiDrawerFocusControl === void 0 || aiDrawerFocusControl.loseFocus();
                },
                style: {
                    blockSize: drawerHeight,
                    insetBlockStart: `${placement.insetBlockStart}px`,
                    ...!isMobile && {
                        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).drawerMinSize]: `${size}px`,
                        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).drawerSize]: `${[
                            'entering',
                            'entered'
                        ].includes(drawerTransitionState) ? size : 0}px`
                    }
                },
                "data-testid": activeDrawerId && `awsui-app-layout-drawer-${activeDrawerId}`
            }, !isMobile && (activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.resizable) && (!isExpanded || expandedTransitionState !== 'entered') && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-slider']
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
                ref: aiDrawerFocusControl === null || aiDrawerFocusControl === void 0 ? void 0 : aiDrawerFocusControl.refs.slider,
                position: "side-start",
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-slider'], (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['ai-drawer-slider-handle']),
                ariaLabel: (_a = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.resizeHandle,
                tooltipText: (_b = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.resizeHandleTooltipText,
                ariaValuenow: resizeProps.relativeSize,
                onKeyDown: resizeProps.onKeyDown,
                onPointerDown: resizeProps.onPointerDown,
                onDirectionClick: resizeProps.onDirectionClick,
                disabled: isResizingDisabled
            })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-container'], (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal'])
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content']
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-header']
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-header-content']
            }, (_c = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.header) !== null && _c !== void 0 ? _c : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-actions']
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed198dba2f0fe830$export$2e2bcd8739ae039), {
                dropdownExpandToViewport: false,
                variant: "icon",
                onItemClick: (event)=>{
                    var _a;
                    switch(event.detail.id){
                        case 'close':
                            onActiveAiDrawerChange === null || onActiveAiDrawerChange === void 0 || onActiveAiDrawerChange(null, {
                                initiatedByUserAction: true
                            });
                            break;
                        case 'expand':
                            setExpandedDrawerId(isExpanded ? null : activeDrawerId);
                            break;
                        default:
                            (_a = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.onHeaderActionClick) === null || _a === void 0 || _a.call(activeAiDrawer, event);
                    }
                },
                ariaLabel: "Left panel actions",
                items: drawerActions
            }))), !isMobile && isExpanded && ((_d = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.ariaLabels) === null || _d === void 0 ? void 0 : _d.exitExpandedModeButton) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-back-to-console-slot']
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-back-to-console-button-wrapper']
            }, ((_e = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.exitExpandedModeTrigger) === null || _e === void 0 ? void 0 : _e.customIcon) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-ai-drawer-leave-expanded-mode-custom-button'], (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-back-to-console-custom-button']),
                formAction: "none",
                onClick: ()=>setExpandedDrawerId(null),
                "aria-label": (_f = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.ariaLabels) === null || _f === void 0 ? void 0 : _f.exitExpandedModeButton
            }, (_g = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.exitExpandedModeTrigger) === null || _g === void 0 ? void 0 : _g.customIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['active-ai-drawer-leave-expanded-mode-custom-button'], (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-back-to-console-button']),
                formAction: "none",
                onClick: ()=>setExpandedDrawerId(null),
                "aria-label": (_h = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.ariaLabels) === null || _h === void 0 ? void 0 : _h.exitExpandedModeButton
            }, (_j = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.ariaLabels) === null || _j === void 0 ? void 0 : _j.exitExpandedModeButton)))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)['drawer-content-content']
            }, activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.content))));
        });
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $1yiQH = parcelRequire("1yiQH");





var $16819fd9ec850dac$export$2e2bcd8739ae039 = {
    "navigation-container": "awsui_navigation-container_2p2ab_o3mu9_153",
    "is-navigation-open": "awsui_is-navigation-open_2p2ab_o3mu9_164",
    "navigation": "awsui_navigation_2p2ab_o3mu9_153",
    "hide-navigation": "awsui_hide-navigation_2p2ab_o3mu9_184"
};


function $2aecf53b3be154f5$export$e315be948ceba4c9({ appLayoutInternals: appLayoutInternals, bottomDrawerReportedSize: bottomDrawerReportedSize }) {
    var _a, _b;
    const { ariaLabels: ariaLabels, onNavigationToggle: onNavigationToggle, isMobile: isMobile, navigationOpen: navigationOpen, navigation: navigation, navigationFocusControl: navigationFocusControl, placement: placement, verticalOffsets: verticalOffsets } = appLayoutInternals;
    const { drawerTopOffset: drawerTopOffset, drawerHeight: drawerHeight } = (0, $ff079cc12921495d$export$d60a2a5f5d1f1f3d)(verticalOffsets, isMobile, placement, isMobile ? 0 : bottomDrawerReportedSize !== null && bottomDrawerReportedSize !== void 0 ? bottomDrawerReportedSize : 0);
    // Close the Navigation drawer on mobile when a user clicks a link inside.
    const onNavigationClick = (event)=>{
        const hasLink = (0, $1yiQH.findUpUntil)(event.target, (node)=>node.tagName === 'A' && !!node.href);
        if (hasLink && isMobile) onNavigationToggle(false);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $16819fd9ec850dac$export$2e2bcd8739ae039)['navigation-container'], (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal'], {
            [(0, $16819fd9ec850dac$export$2e2bcd8739ae039)['is-navigation-open']]: navigationOpen
        }),
        style: {
            blockSize: drawerHeight,
            insetBlockStart: drawerTopOffset
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _a !== void 0 ? _a : undefined,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $16819fd9ec850dac$export$2e2bcd8739ae039).navigation, {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawer-closed']]: !navigationOpen
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).navigation),
        "aria-hidden": !navigationOpen,
        onClick: onNavigationClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $16819fd9ec850dac$export$2e2bcd8739ae039)['hide-navigation'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaLabel: (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationClose) !== null && _b !== void 0 ? _b : undefined,
        iconName: isMobile ? 'close' : 'angle-left',
        onClick: ()=>onNavigationToggle(false),
        variant: "icon",
        formAction: "none",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-close'],
        ref: navigationFocusControl.refs.close,
        analyticsAction: "close"
    })), navigation));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $72deb0d8205d26fb$export$2e2bcd8739ae039 = {
    "breadcrumb-group": "awsui_breadcrumb-group_d19fg_1h5ta_145",
    "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_1h5ta_180",
    "ghost": "awsui_ghost_d19fg_1h5ta_191",
    "item": "awsui_item_d19fg_1h5ta_196",
    "ghost-item": "awsui_ghost-item_d19fg_1h5ta_197",
    "ellipsis": "awsui_ellipsis_d19fg_1h5ta_198",
    "hide": "awsui_hide_d19fg_1h5ta_209",
    "visible": "awsui_visible_d19fg_1h5ta_215",
    "icon": "awsui_icon_d19fg_1h5ta_219",
    "breadcrumbs-skeleton": "awsui_breadcrumbs-skeleton_d19fg_1h5ta_225",
    "collapsed-button": "awsui_collapsed-button_d19fg_1h5ta_229",
    "button-icon": "awsui_button-icon_d19fg_1h5ta_311",
    "button-icon-open": "awsui_button-icon-open_d19fg_1h5ta_325",
    "hidden": "awsui_hidden_d19fg_1h5ta_329"
};


const $9aea34b11a7045b7$var$metadataTypeAttribute = {
    [(0, $285a09b860d2bebc$export$2d9588ca27729166)]: 'true'
};
const $9aea34b11a7045b7$export$f757d8f42a1e98b1 = ({ items: items, onItemClick: onItemClick, onItemFollow: onItemFollow })=>{
    var _a;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), {
        items: items.map((item, index)=>{
            const isCurrentBreadcrumb = index === items.length - 1;
            return {
                id: index.toString(),
                text: item.text,
                href: isCurrentBreadcrumb ? undefined : item.href,
                isCurrentBreadcrumb: isCurrentBreadcrumb
            };
        }),
        customTriggerBuilder: $9aea34b11a7045b7$var$getDropdownTrigger((_a = items[items.length - 1]) === null || _a === void 0 ? void 0 : _a.text),
        linkStyle: true,
        fullWidth: true,
        onItemClick: onItemClick,
        onItemFollow: onItemFollow,
        analyticsMetadataTransformer: (metadata)=>{
            var _a, _b;
            if ((_a = metadata.detail) === null || _a === void 0 ? void 0 : _a.id) delete metadata.detail.id;
            if ((_b = metadata.detail) === null || _b === void 0 ? void 0 : _b.position) metadata.detail.position = `${parseInt(metadata.detail.position, 10) + 1}`;
            return metadata;
        }
    }), items.length > 1 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).hidden,
        ...$9aea34b11a7045b7$var$metadataTypeAttribute
    }, items[1].text));
};
const $9aea34b11a7045b7$var$getDropdownTrigger = (currentPage)=>({ ariaLabel: ariaLabel, triggerRef: triggerRef, testUtilsClass: testUtilsClass, isOpen: isOpen, onClick: onClick })=>{
        const metadataAttributes = {
            [(0, $285a09b860d2bebc$export$22b484224f7ab69a)]: (0, $285a09b860d2bebc$export$f707bfc38f5d283)
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            ref: triggerRef,
            ...metadataAttributes,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $72deb0d8205d26fb$export$2e2bcd8739ae039)['collapsed-button'], testUtilsClass),
            onClick: (event)=>{
                event.preventDefault();
                onClick();
            },
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            "aria-label": ariaLabel,
            formAction: "none"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "caret-down-filled",
            className: (0, $17bc88d78d27c4da$export$7cd733a6d16526b)((0, $72deb0d8205d26fb$export$2e2bcd8739ae039), 'button-icon', isOpen)
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, currentPage));
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




const $021a19cabcc050c9$export$6b055ee0b245db25 = (item)=>({
        item: item,
        text: item.text,
        href: item.href
    });
const $021a19cabcc050c9$var$MIN_BREADCRUMB_WIDTH = 70;
const $021a19cabcc050c9$var$ELLIPSIS_WIDTH = 50;
const $021a19cabcc050c9$export$654f654a7357757e = (itemsWidths, navWidth)=>{
    const widthsWithFinalCollapsed = [
        ...itemsWidths
    ];
    widthsWithFinalCollapsed[itemsWidths.length - 1] = Math.min(itemsWidths[itemsWidths.length - 1], $021a19cabcc050c9$var$MIN_BREADCRUMB_WIDTH);
    return {
        collapsed: $021a19cabcc050c9$var$computeNumberOfCollapsedItems(widthsWithFinalCollapsed, navWidth)
    };
};
const $021a19cabcc050c9$var$computeNumberOfCollapsedItems = (itemWidths, navWidth)=>{
    if (typeof navWidth !== 'number') return 0;
    let usedWidth = itemWidths.reduce((acc, width)=>acc + width, 0);
    let collapsedItems = 0;
    while(collapsedItems < itemWidths.length - 1){
        if (usedWidth <= navWidth) break;
        collapsedItems += 1;
        usedWidth = usedWidth - itemWidths[collapsedItems];
        if (collapsedItems === 1) usedWidth += $021a19cabcc050c9$var$ELLIPSIS_WIDTH;
    }
    return collapsedItems;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $5f5f7763028e1f42$export$2e2bcd8739ae039 = {
    "breadcrumb-item": "awsui_breadcrumb-item_1c68o_b6unx_5"
};


const $7703d4e092fe9854$export$8a09f20323abaf01 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, text: text, itemIndex: itemIndex, totalCount: totalCount, disableAnalytics: disableAnalytics }, ref)=>{
    const funnelAttributes = {};
    if (!disableAnalytics) {
        if (itemIndex === totalCount - 1) funnelAttributes[0, $285a09b860d2bebc$export$22b484224f7ab69a] = (0, $285a09b860d2bebc$export$f707bfc38f5d283);
        if (itemIndex === 1) funnelAttributes[0, $285a09b860d2bebc$export$2d9588ca27729166] = 'true';
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...funnelAttributes,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, !disableAnalytics && (0, $5f5f7763028e1f42$export$2e2bcd8739ae039)['breadcrumb-item']),
        ref: ref
    }, text);
});



var $412480e10a479e0b$export$2e2bcd8739ae039 = {
    "link": "awsui_link_1kosq_cued1_145",
    "breadcrumb": "awsui_breadcrumb_1kosq_cued1_149",
    "ghost-breadcrumb": "awsui_ghost-breadcrumb_1kosq_cued1_150",
    "icon": "awsui_icon_1kosq_cued1_153",
    "anchor": "awsui_anchor_1kosq_cued1_159",
    "text": "awsui_text_1kosq_cued1_206",
    "last": "awsui_last_1kosq_cued1_225"
};


const $a94b06600eabeb7d$var$BreadcrumbItemWithPopover = ({ item: item, isLast: isLast, anchorAttributes: anchorAttributes, itemAttributes: itemAttributes, children: children })=>{
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const textRef = (0, $acw62.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a94b06600eabeb7d$var$Item, {
        ref: textRef,
        isLast: isLast,
        onFocus: ()=>{
            setShowTooltip(true);
        },
        onBlur: ()=>setShowTooltip(false),
        onMouseEnter: ()=>{
            setShowTooltip(true);
        },
        onMouseLeave: ()=>setShowTooltip(false),
        anchorAttributes: anchorAttributes,
        ...itemAttributes
    }, children, showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        getTrack: ()=>textRef.current,
        content: item.text,
        onEscape: ()=>setShowTooltip(false)
    }));
};
const $a94b06600eabeb7d$var$Item = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ anchorAttributes: anchorAttributes, children: children, isLast: isLast, ...itemAttributes }, ref)=>{
    return isLast ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: (0, $412480e10a479e0b$export$2e2bcd8739ae039).anchor,
        ...itemAttributes
    }, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ref: ref,
        className: (0, $412480e10a479e0b$export$2e2bcd8739ae039).anchor,
        ...itemAttributes,
        ...anchorAttributes
    }, children);
});
function $a94b06600eabeb7d$export$c13f210c706eb549({ item: item, itemIndex: itemIndex, totalCount: totalCount, onClick: onClick, onFollow: onFollow, isGhost: isGhost = false, isTruncated: isTruncated = false }) {
    const isLast = itemIndex === totalCount - 1;
    const preventDefault = (event)=>event.preventDefault();
    const onClickHandler = (event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(item), event);
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(item), event);
    };
    const anchorAttributes = {
        href: item.href || '#',
        onClick: isLast ? preventDefault : onClickHandler,
        tabIndex: 0
    };
    const itemAttributes = {};
    if (isGhost) anchorAttributes.tabIndex = -1;
    if (isLast && !isGhost) {
        itemAttributes['aria-current'] = 'page';
        itemAttributes['aria-disabled'] = true;
        itemAttributes.tabIndex = 0;
        itemAttributes.role = 'link';
    }
    const breadcrumbItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7703d4e092fe9854$export$8a09f20323abaf01), {
        className: (0, $412480e10a479e0b$export$2e2bcd8739ae039).text,
        itemIndex: itemIndex,
        totalCount: totalCount,
        text: item.text,
        disableAnalytics: isGhost
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(!isGhost && (0, $412480e10a479e0b$export$2e2bcd8739ae039).breadcrumb, isGhost && (0, $412480e10a479e0b$export$2e2bcd8739ae039)['ghost-breadcrumb'], isLast && (0, $412480e10a479e0b$export$2e2bcd8739ae039).last)
    }, isTruncated && !isGhost ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a94b06600eabeb7d$var$BreadcrumbItemWithPopover, {
        item: item,
        isLast: isLast,
        anchorAttributes: anchorAttributes,
        itemAttributes: itemAttributes
    }, breadcrumbItem) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a94b06600eabeb7d$var$Item, {
        isLast: isLast,
        anchorAttributes: anchorAttributes,
        ...itemAttributes
    }, breadcrumbItem), !isLast ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $412480e10a479e0b$export$2e2bcd8739ae039).icon
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-right"
    })) : null);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $1569b1285b59cb28$export$ef78e6a344db062f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ items: items }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039)['breadcrumbs-skeleton']
    }, items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7703d4e092fe9854$export$8a09f20323abaf01), {
            itemIndex: index,
            totalCount: items.length,
            text: item.text,
            key: index
        }))));





/**
 * Provided for backwards compatibility
 */ const $3a72f05b8b6b5b62$var$DEFAULT_EXPAND_ARIA_LABEL = 'Show path';
const $3a72f05b8b6b5b62$var$getEllipsisDropdownTrigger = ({ ariaLabel: ariaLabel, triggerRef: triggerRef, testUtilsClass: testUtilsClass, isOpen: isOpen, onClick: onClick })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: triggerRef,
        className: testUtilsClass,
        onClick: (event)=>{
            event.preventDefault();
            onClick();
        },
        ariaExpanded: isOpen,
        "aria-haspopup": true,
        ariaLabel: ariaLabel,
        variant: "breadcrumb-group",
        formAction: "none"
    }, "...");
};
const $3a72f05b8b6b5b62$var$EllipsisDropdown = ({ ariaLabel: ariaLabel, dropdownItems: dropdownItems, onDropdownItemClick: onDropdownItemClick, onDropdownItemFollow: onDropdownItemFollow, visible: visible })=>{
    var _a;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('breadcrumb-group');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $72deb0d8205d26fb$export$2e2bcd8739ae039).ellipsis, visible && (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).visible)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), {
        ariaLabel: (_a = i18n('expandAriaLabel', ariaLabel)) !== null && _a !== void 0 ? _a : $3a72f05b8b6b5b62$var$DEFAULT_EXPAND_ARIA_LABEL,
        items: dropdownItems,
        onItemClick: onDropdownItemClick,
        onItemFollow: onDropdownItemFollow,
        customTriggerBuilder: $3a72f05b8b6b5b62$var$getEllipsisDropdownTrigger,
        linkStyle: true,
        analyticsMetadataTransformer: (metadata)=>{
            var _a, _b;
            if ((_a = metadata.detail) === null || _a === void 0 ? void 0 : _a.id) delete metadata.detail.id;
            if ((_b = metadata.detail) === null || _b === void 0 ? void 0 : _b.position) metadata.detail.position = `${parseInt(metadata.detail.position, 10) + 1}`;
            return metadata;
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).icon
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-right"
    })));
};
const $3a72f05b8b6b5b62$var$areArrayEqual = (first, second)=>{
    if (first.length !== second.length) return false;
    return first.every((item, index)=>item === second[index]);
};
function $3a72f05b8b6b5b62$export$cc0e5b36fb9a70bc({ items: items = [], ariaLabel: ariaLabel, expandAriaLabel: expandAriaLabel, onClick: onClick, onFollow: onFollow, __internalRootRef: __internalRootRef, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, ...props }) {
    for (const item of items)(0, $3de0f29144bb4e85$export$6661f6891a200a5f)('BreadcrumbGroup', item.href);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const [navWidth, navRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.borderBoxWidth);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(navRef, __internalRootRef);
    const itemsRefs = (0, $acw62.useRef)({
        ghost: {},
        real: {}
    });
    const setBreadcrumb = (type, index, node)=>{
        if (node) itemsRefs.current[type][index] = node;
        else delete itemsRefs.current[type][index];
    };
    const [itemsWidths, setItemsWidths] = (0, $acw62.useState)({
        ghost: [],
        real: []
    });
    (0, $acw62.useEffect)(()=>{
        if (itemsRefs.current) {
            const newItemsWidths = {
                ghost: [],
                real: []
            };
            for (const node of Object.values(itemsRefs.current.ghost)){
                const width = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(node).inlineSize;
                newItemsWidths.ghost.push(width);
            }
            for (const node of Object.values(itemsRefs.current.real)){
                const width = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(node).inlineSize;
                newItemsWidths.real.push(width);
            }
            setItemsWidths((oldWidths)=>{
                if (!$3a72f05b8b6b5b62$var$areArrayEqual(newItemsWidths.ghost, oldWidths.ghost) || !$3a72f05b8b6b5b62$var$areArrayEqual(newItemsWidths.real, oldWidths.real)) return newItemsWidths;
                else return oldWidths;
            });
        }
    }, [
        items,
        navWidth
    ]);
    const { collapsed: collapsed } = (0, $021a19cabcc050c9$export$654f654a7357757e)(itemsWidths.ghost, navWidth);
    let breadcrumbItems = items.map((item, index)=>{
        const isLast = index === items.length - 1;
        const isDisplayed = index === 0 || index > collapsed;
        const clickAnalyticsMetadata = {
            action: 'click',
            detail: {
                position: `${index + 1}`,
                label: `.${(0, $5f5f7763028e1f42$export$2e2bcd8739ae039)['breadcrumb-item']}`,
                href: item.href || ''
            }
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $72deb0d8205d26fb$export$2e2bcd8739ae039).item, !isDisplayed && (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).hide),
            key: index,
            ...isLast ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(clickAnalyticsMetadata),
            ref: (node)=>setBreadcrumb('real', `${index}`, node)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a94b06600eabeb7d$export$c13f210c706eb549), {
            item: item,
            onClick: onClick,
            onFollow: onFollow,
            itemIndex: index,
            totalCount: items.length,
            isTruncated: itemsWidths.ghost[index] - itemsWidths.real[index] > 0
        }));
    });
    const hiddenBreadcrumbItems = items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039)['ghost-item'],
            key: index,
            ref: (node)=>setBreadcrumb('ghost', `${index}`, node)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a94b06600eabeb7d$export$c13f210c706eb549), {
            item: item,
            itemIndex: index,
            totalCount: items.length,
            isGhost: true
        })));
    const getEventItem = (e)=>{
        const { id: id } = e.detail;
        return items[parseInt(id)];
    };
    // Add ellipsis
    if (breadcrumbItems.length >= 2) {
        const dropdownItems = items.slice(1, 1 + collapsed).map((item, index)=>({
                id: (index + 1).toString(),
                text: item.text,
                href: item.href || '#'
            }));
        breadcrumbItems = [
            breadcrumbItems[0],
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a72f05b8b6b5b62$var$EllipsisDropdown, {
                key: 'ellipsis',
                visible: collapsed > 0,
                ariaLabel: expandAriaLabel,
                dropdownItems: dropdownItems,
                onDropdownItemClick: (e)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(getEventItem(e)), e),
                onDropdownItemFollow: (e)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(getEventItem(e)), e)
            }),
            ...breadcrumbItems.slice(1)
        ];
    }
    const componentAnalyticsMetadata = {
        name: 'awsui.BreadcrumbGroup',
        label: {
            root: 'self'
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $72deb0d8205d26fb$export$2e2bcd8739ae039)['breadcrumb-group'], baseProps.className),
        "aria-label": ariaLabel || undefined,
        ref: mergedRef,
        ...__injectAnalyticsComponentMetadata ? {
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
                component: componentAnalyticsMetadata
            })
        } : {}
    }, collapsed > 0 && collapsed === items.length - 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9aea34b11a7045b7$export$f757d8f42a1e98b1), {
        items: items,
        onItemClick: (e)=>e.detail.id !== (items.length - 1).toString() && (0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(getEventItem(e)), e),
        onItemFollow: (e)=>e.detail.id !== (items.length - 1).toString() && (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(getEventItem(e)), e)
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039)['breadcrumb-group-list']
    }, breadcrumbItems), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $72deb0d8205d26fb$export$2e2bcd8739ae039)['breadcrumb-group-list'], (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).ghost),
        "aria-hidden": true,
        tabIndex: -1
    }, hiddenBreadcrumbItems));
}
const $3a72f05b8b6b5b62$export$a040bee6da3a27ec = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($3a72f05b8b6b5b62$export$cc0e5b36fb9a70bc, (0, $1569b1285b59cb28$export$ef78e6a344db062f));





var $fac2a988aee55765$export$2e2bcd8739ae039 = {
    "universal-toolbar": "awsui_universal-toolbar_1kzri_iuh1s_153",
    "with-ai-drawer": "awsui_with-ai-drawer_1kzri_iuh1s_172",
    "universal-toolbar-ai-custom": "awsui_universal-toolbar-ai-custom_1kzri_iuh1s_172",
    "disable-body-scroll": "awsui_disable-body-scroll_1kzri_iuh1s_214",
    "toolbar-container": "awsui_toolbar-container_1kzri_iuh1s_267",
    "universal-toolbar-nav": "awsui_universal-toolbar-nav_1kzri_iuh1s_287",
    "universal-toolbar-breadcrumbs": "awsui_universal-toolbar-breadcrumbs_1kzri_iuh1s_292",
    "universal-toolbar-drawers": "awsui_universal-toolbar-drawers_1kzri_iuh1s_301",
    "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_1kzri_iuh1s_309",
    "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_1kzri_iuh1s_310",
    "drawers-trigger-content": "awsui_drawers-trigger-content_1kzri_iuh1s_352",
    "group-divider": "awsui_group-divider_1kzri_iuh1s_362",
    "drawers-trigger": "awsui_drawers-trigger_1kzri_iuh1s_352",
    "block-body-scroll": "awsui_block-body-scroll_1kzri_iuh1s_375"
};



const $201c6806d99725a1$export$69aed1e8e248d0c2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, style: style, children: children }, ref)=>{
    var _a;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['toolbar-container'], (0, $fac2a988aee55765$export$2e2bcd8739ae039)['universal-toolbar'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).toolbar, className),
        style: {
            insetBlockStart: (_a = style === null || style === void 0 ? void 0 : style.insetBlockStart) !== null && _a !== void 0 ? _a : 0,
            ...style
        }
    }, children);
});
const $201c6806d99725a1$export$afc7f76de8adf7d1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, style: style, children: children }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['notifications-container'], className),
        style: style
    }, children));
const $201c6806d99725a1$var$breadcrumbsSlotContextValue = {
    isInToolbar: true
};
function $201c6806d99725a1$export$2da44f0619419b07({ ownBreadcrumbs: ownBreadcrumbs, discoveredBreadcrumbs: discoveredBreadcrumbs }) {
    const isSSR = typeof window === 'undefined';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5475c68ef3288dd6$export$f37757d67c29fcf7).Provider, {
        value: $201c6806d99725a1$var$breadcrumbsSlotContextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['breadcrumbs-own']
    }, ownBreadcrumbs), discoveredBreadcrumbs && !isSSR && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['breadcrumbs-discovered']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a72f05b8b6b5b62$export$cc0e5b36fb9a70bc), {
        ...discoveredBreadcrumbs,
        "data-awsui-discovered-breadcrumbs": true,
        __injectAnalyticsComponentMetadata: true
    })));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




function $4a6da19502768a71$export$141c9d2033716579({ children: children, hasAiDrawer: hasAiDrawer }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['toolbar-container'], hasAiDrawer && (0, $fac2a988aee55765$export$2e2bcd8739ae039)['with-ai-drawer'])
    }, children);
}
function $4a6da19502768a71$export$cc08c3326b6308f0({ ownBreadcrumbs: ownBreadcrumbs, discoveredBreadcrumbs: discoveredBreadcrumbs, includeTestUtils: includeTestUtils = false }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['universal-toolbar-breadcrumbs'], includeTestUtils && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $201c6806d99725a1$export$2da44f0619419b07), {
        ownBreadcrumbs: ownBreadcrumbs,
        discoveredBreadcrumbs: discoveredBreadcrumbs
    }));
}
const $4a6da19502768a71$export$bd564832df8aa06d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ ownBreadcrumbs: ownBreadcrumbs, discoveredBreadcrumbs: discoveredBreadcrumbs }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $201c6806d99725a1$export$69aed1e8e248d0c2), {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4a6da19502768a71$export$141c9d2033716579, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4a6da19502768a71$export$cc08c3326b6308f0, {
        ownBreadcrumbs: ownBreadcrumbs,
        discoveredBreadcrumbs: discoveredBreadcrumbs,
        includeTestUtils: true
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $fac2a988aee55765$export$2e2bcd8739ae039)['universal-toolbar-drawers']
    }))));



const $673962bdbc7b42a3$export$c11019525960d012 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ toolbarProps: toolbarProps, appLayoutProps: appLayoutProps }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !!toolbarProps && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a6da19502768a71$export$bd564832df8aa06d), {
        ref: ref,
        ownBreadcrumbs: appLayoutProps.breadcrumbs
    }), (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.navigationOpen) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).navigation
    }));
});
const $673962bdbc7b42a3$export$5e29225d56ca7c7d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ appLayoutInternals: appLayoutInternals }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a6da19502768a71$export$bd564832df8aa06d), {
        ref: ref,
        ownBreadcrumbs: appLayoutInternals.breadcrumbs,
        discoveredBreadcrumbs: appLayoutInternals.discoveredBreadcrumbs
    }));
const $673962bdbc7b42a3$export$8c701afa7bf57aef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $201c6806d99725a1$export$afc7f76de8adf7d1), {
        ref: ref
    }));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $650283c079eee3f2$export$2e2bcd8739ae039 = {
    "trigger": "awsui_trigger_lpshu_10v1l_145",
    "custom": "awsui_custom_lpshu_10v1l_151",
    "trigger-with-badge": "awsui_trigger-with-badge_lpshu_10v1l_157",
    "circle": "awsui_circle_lpshu_10v1l_167",
    "selected": "awsui_selected_lpshu_10v1l_183",
    "trigger-wrapper": "awsui_trigger-wrapper_lpshu_10v1l_194",
    "dot": "awsui_dot_lpshu_10v1l_219"
};


function $ceee44cf910cdea1$var$TriggerButton({ ariaLabel: ariaLabel, className: className, iconName: iconName, iconSvg: iconSvg, customSvg: customSvg, ariaExpanded: ariaExpanded, ariaControls: ariaControls, onClick: onClick, testId: testId, disabled: disabled = false, badge: badge, selected: selected = false, hasTooltip: hasTooltip = false, tooltipText: tooltipText, hasOpenDrawer: hasOpenDrawer = false, isMobile: isMobile = false, isForPreviousActiveDrawer: isForPreviousActiveDrawer = false, isForSplitPanel: isForSplitPanel = false, variant: variant = 'circle' }, ref) {
    const containerRef = (0, $acw62.useRef)(null);
    const tooltipValue = tooltipText ? tooltipText : ariaLabel ? ariaLabel : '';
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const [suppressTooltip, setSupressTooltip] = (0, $acw62.useState)(false);
    const handleTriggerClick = (event)=>{
        event.stopPropagation(); // Stop the event from propagating to the badge icon
        setShowTooltip(false);
        setSupressTooltip(true);
        onClick(event);
    };
    const handleBlur = (keepSupressed = false)=>{
        setSupressTooltip(keepSupressed);
        setShowTooltip(false);
    };
    const handlePointerEnter = (event)=>{
        var _a, _b;
        const suppressedTooltip = ((_b = (_a = event.currentTarget.querySelector('button')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.awsuiSuppressTooltip) === 'true';
        if (suppressedTooltip) return;
        setSupressTooltip(false);
        setShowTooltip(true);
    };
    /**
     * Takes the drawer being closed and the data-shift-focus value from a close button on that drawer that persists
     * on the event relatedTarget to determine not to show the tooltip
     * @param event
     */ const handleOnFocus = (0, $acw62.useCallback)((event)=>{
        var _a, _b, _c;
        let shouldShowTooltip = false;
        const eventWithRelatedTarget = event;
        const relatedTarget = eventWithRelatedTarget === null || eventWithRelatedTarget === void 0 ? void 0 : eventWithRelatedTarget.relatedTarget;
        const isSuppressedOnTarget = ((_b = (_a = eventWithRelatedTarget === null || eventWithRelatedTarget === void 0 ? void 0 : eventWithRelatedTarget.target) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.awsuiSuppressTooltip) === 'true';
        const isFromAnotherTrigger = ((_c = relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.dataset) === null || _c === void 0 ? void 0 : _c.shiftFocus) === 'awsui-layout-drawer-trigger';
        if (isForSplitPanel && !!relatedTarget || // relatedTarget is null when split panel is closed
        !isForSplitPanel && (isFromAnotherTrigger || // for key navigation from another trigger button
        !isForPreviousActiveDrawer) // for when the drawer was not opened recently
        ) shouldShowTooltip = true;
        if (isSuppressedOnTarget) shouldShowTooltip = false;
        setSupressTooltip(!shouldShowTooltip);
        setShowTooltip(true);
    }, [
        // To assert reference equality check
        isForPreviousActiveDrawer,
        isForSplitPanel
    ]);
    const tooltipVisible = (0, $acw62.useMemo)(()=>{
        return hasTooltip && showTooltip && !suppressTooltip && !!(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && tooltipValue && !(isMobile && hasOpenDrawer);
    }, [
        hasTooltip,
        showTooltip,
        containerRef,
        tooltipValue,
        isMobile,
        hasOpenDrawer,
        suppressTooltip
    ]);
    (0, $acw62.useEffect)(()=>{
        if (hasTooltip && tooltipValue) {
            const close = ()=>{
                setShowTooltip(false);
                setSupressTooltip(false);
            };
            const shouldCloseTooltip = (event)=>{
                var _a;
                if (event.target && containerRef && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) return false;
                return true;
            };
            const handlePointerDownEvent = (event)=>{
                if (shouldCloseTooltip(event)) close();
            };
            const handleKeyDownEvent = (event)=>{
                if (event.key === 'Escape') close();
            };
            const wrapperDiv = containerRef.current;
            if (wrapperDiv) {
                const controller = new AbortController();
                wrapperDiv.addEventListener('pointerdown', handlePointerDownEvent, {
                    signal: controller.signal
                });
                wrapperDiv.addEventListener('keydown', handleKeyDownEvent, {
                    signal: controller.signal
                });
                return ()=>{
                    controller.abort();
                };
            }
        }
    }, [
        containerRef,
        hasTooltip,
        tooltipValue
    ]);
    const triggerEventMetadata = {
        action: selected ? 'close' : 'open',
        detail: {
            label: {
                root: 'self'
            }
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef,
        ...hasTooltip && {
            onPointerEnter: (event)=>handlePointerEnter(event),
            onPointerLeave: ()=>handleBlur(true),
            onFocus: (e)=>handleOnFocus(e),
            onBlur: ()=>handleBlur(true)
        },
        className: (0, $650283c079eee3f2$export$2e2bcd8739ae039)['trigger-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": true,
        "aria-label": ariaLabel,
        "aria-disabled": disabled,
        disabled: disabled,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $650283c079eee3f2$export$2e2bcd8739ae039).trigger, (0, $650283c079eee3f2$export$2e2bcd8739ae039)[variant], {
            [(0, $650283c079eee3f2$export$2e2bcd8739ae039).selected]: selected,
            [(0, $650283c079eee3f2$export$2e2bcd8739ae039)['trigger-with-badge']]: badge,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger-with-badge']]: badge
        }, className),
        onClick: handleTriggerClick,
        ref: ref,
        type: "button",
        "data-testid": testId,
        "data-shift-focus": "awsui-layout-drawer-trigger",
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(triggerEventMetadata)
    }, customSvg !== null && customSvg !== void 0 ? customSvg : (iconName || iconSvg) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconName,
        svg: iconSvg
    })), badge && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $650283c079eee3f2$export$2e2bcd8739ae039).dot
    }), tooltipVisible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        getTrack: ()=>containerRef.current,
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['trigger-tooltip'],
        content: tooltipValue,
        onEscape: ()=>{
            setShowTooltip(false);
            setSupressTooltip(false);
        }
    }));
}
var $ceee44cf910cdea1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($ceee44cf910cdea1$var$TriggerButton);





function $1f0a10ce5025b27d$export$f2a14c3cc682bac7({ ariaLabels: ariaLabels, activeDrawerId: activeDrawerId, drawers: drawers, drawersFocusRef: drawersFocusRef, onActiveDrawerChange: onActiveDrawerChange, splitPanelOpen: splitPanelOpen, splitPanelPosition: splitPanelPosition = 'bottom', splitPanelFocusRef: splitPanelFocusRef, splitPanelToggleProps: splitPanelToggleProps, onSplitPanelToggle: onSplitPanelToggle, disabled: disabled, activeGlobalDrawersIds: activeGlobalDrawersIds, globalDrawers: globalDrawers, globalDrawersFocusControl: globalDrawersFocusControl, onActiveGlobalDrawersChange: onActiveGlobalDrawersChange, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, activeGlobalBottomDrawerId: activeGlobalBottomDrawerId, onActiveGlobalBottomDrawerChange: onActiveGlobalBottomDrawerChange, bottomDrawersFocusRef: bottomDrawersFocusRef, bottomDrawers: bottomDrawers, featureNotificationsProps: featureNotificationsProps }) {
    var _a;
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const hasMultipleTriggers = drawers.length > 1;
    const previousActiveLocalDrawerId = (0, $acw62.useRef)(activeDrawerId);
    const previousActiveGlobalBottomDrawerId = (0, $acw62.useRef)(activeGlobalBottomDrawerId);
    const previousActiveGlobalDrawersIds = (0, $acw62.useRef)(activeGlobalDrawersIds);
    const [containerWidth, triggersContainerRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    const featureNotificationTriggerRef = (0, $acw62.useRef)(null);
    if (!drawers.length && !globalDrawers.length && !(bottomDrawers === null || bottomDrawers === void 0 ? void 0 : bottomDrawers.length) && !splitPanelToggleProps) return null;
    if (activeDrawerId) previousActiveLocalDrawerId.current = activeDrawerId;
    if (activeGlobalDrawersIds.length) previousActiveGlobalDrawersIds.current = activeGlobalDrawersIds;
    if (activeGlobalBottomDrawerId) previousActiveGlobalBottomDrawerId.current = activeGlobalBottomDrawerId;
    const getIndexOfOverflowItem = ()=>{
        if (isMobile) return 2;
        if (containerWidth) {
            const ITEM_WIDTH = 50; // Roughly 34px + padding = 42px but added extra for safety
            const overflowSpot = containerWidth;
            const index = Math.floor(overflowSpot / ITEM_WIDTH);
            let splitPanelItem = 0;
            if (splitPanelToggleProps) splitPanelItem = 1;
            return index - splitPanelItem;
        }
        return 0;
    };
    const indexOfOverflowItem = getIndexOfOverflowItem();
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)([
        ...drawers,
        ...globalDrawers,
        ...bottomDrawers || []
    ], indexOfOverflowItem, activeDrawerId !== null && activeDrawerId !== void 0 ? activeDrawerId : null);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    const toolsOnlyMode = drawers.length === 1 && drawers[0].id === (0, $892ef2b582c4882d$export$329f249760e831ae);
    const globalDrawersStartIndex = drawers.length;
    const hasOpenDrawer = !!activeDrawerId || splitPanelPosition === 'side' && splitPanelOpen;
    const splitPanelResolvedPosition = splitPanelToggleProps === null || splitPanelToggleProps === void 0 ? void 0 : splitPanelToggleProps.position;
    const exitExpandedMode = ()=>{
        if (setExpandedDrawerId) setExpandedDrawerId(null);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        className: (0, $fac2a988aee55765$export$2e2bcd8739ae039)[`drawers-${isMobile ? 'mobile' : 'desktop'}-triggers-container`],
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        ref: triggersContainerRef,
        role: "region"
    }, (_a = featureNotificationsProps === null || featureNotificationsProps === void 0 ? void 0 : featureNotificationsProps.renderLatestFeaturePrompt) === null || _a === void 0 ? void 0 : _a.call(featureNotificationsProps, {
        triggerRef: featureNotificationTriggerRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $fac2a988aee55765$export$2e2bcd8739ae039)['drawers-trigger-content'],
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        role: "toolbar",
        "aria-orientation": "horizontal"
    }, splitPanelToggleProps && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
        ariaLabel: splitPanelToggleProps.ariaLabel,
        ariaControls: splitPanelToggleProps.controlId,
        ariaExpanded: !expandedDrawerId && splitPanelToggleProps.active,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['open-button']),
        iconName: splitPanelResolvedPosition === 'side' ? 'view-vertical' : 'view-horizontal',
        onClick: ()=>{
            exitExpandedMode();
            if (!!expandedDrawerId && splitPanelToggleProps.active) return;
            onSplitPanelToggle === null || onSplitPanelToggle === void 0 || onSplitPanelToggle();
        },
        selected: !expandedDrawerId && splitPanelToggleProps.active,
        ref: splitPanelResolvedPosition === 'side' ? splitPanelFocusRef : undefined,
        hasTooltip: true,
        isMobile: isMobile,
        isForSplitPanel: true,
        disabled: disabled
    }), hasMultipleTriggers ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $fac2a988aee55765$export$2e2bcd8739ae039)['group-divider']
    }) : null), visibleItems.slice(0, globalDrawersStartIndex).map((item)=>{
        var _a, _b, _c;
        const isForPreviousActiveDrawer = (previousActiveLocalDrawerId === null || previousActiveLocalDrawerId === void 0 ? void 0 : previousActiveLocalDrawerId.current) === item.id;
        const selected = !expandedDrawerId && item.id === activeDrawerId;
        const isFeatureNotificationsDrawer = ((_a = featureNotificationsProps === null || featureNotificationsProps === void 0 ? void 0 : featureNotificationsProps.drawer) === null || _a === void 0 ? void 0 : _a.id) === item.id;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
            ariaLabel: (_b = item.ariaLabels) === null || _b === void 0 ? void 0 : _b.triggerButton,
            ariaExpanded: selected,
            ariaControls: activeDrawerId === item.id ? item.id : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['drawers-trigger'], !toolsOnlyMode && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['tools-toggle']),
            iconName: item.trigger.iconName,
            iconSvg: item.trigger.iconSvg,
            key: item.id,
            onClick: ()=>{
                exitExpandedMode();
                if (!!expandedDrawerId && activeDrawerId === item.id) return;
                onActiveDrawerChange === null || onActiveDrawerChange === void 0 || onActiveDrawerChange(activeDrawerId !== item.id ? item.id : null, {
                    initiatedByUserAction: true
                });
            },
            ref: item.id === previousActiveLocalDrawerId.current ? drawersFocusRef : isFeatureNotificationsDrawer ? featureNotificationTriggerRef : null,
            selected: selected,
            badge: item.badge,
            testId: `awsui-app-layout-trigger-${item.id}`,
            hasTooltip: true,
            hasOpenDrawer: hasOpenDrawer,
            tooltipText: (_c = item.ariaLabels) === null || _c === void 0 ? void 0 : _c.drawerName,
            isForPreviousActiveDrawer: isForPreviousActiveDrawer,
            isMobile: isMobile,
            disabled: disabled
        });
    }), globalDrawersStartIndex > 0 && visibleItems.length > globalDrawersStartIndex && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $fac2a988aee55765$export$2e2bcd8739ae039)['group-divider']
    }), visibleItems.slice(globalDrawersStartIndex).map((item)=>{
        var _a, _b, _c;
        let isForPreviousActiveDrawer = previousActiveGlobalDrawersIds === null || previousActiveGlobalDrawersIds === void 0 ? void 0 : previousActiveGlobalDrawersIds.current.includes(item.id);
        const isBottom = item.position === 'bottom';
        let selected = activeGlobalDrawersIds.includes(item.id) && (!expandedDrawerId || item.id === expandedDrawerId);
        if (isBottom) {
            selected = item.id === activeGlobalBottomDrawerId && (!expandedDrawerId || item.id === expandedDrawerId);
            isForPreviousActiveDrawer = previousActiveGlobalBottomDrawerId.current === item.id;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaExpanded: selected,
            ariaControls: selected ? item.id : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger-global']),
            iconName: item.trigger.iconName,
            iconSvg: item.trigger.iconSvg,
            key: item.id,
            onClick: ()=>{
                exitExpandedMode();
                if (!!expandedDrawerId && item.id !== expandedDrawerId && activeGlobalDrawersIds.includes(item.id)) return;
                if (isBottom) {
                    onActiveGlobalBottomDrawerChange === null || onActiveGlobalBottomDrawerChange === void 0 || onActiveGlobalBottomDrawerChange(selected ? null : item.id, {
                        initiatedByUserAction: true
                    });
                    return;
                }
                onActiveGlobalDrawersChange === null || onActiveGlobalDrawersChange === void 0 || onActiveGlobalDrawersChange(item.id, {
                    initiatedByUserAction: true
                });
            },
            ref: isBottom ? bottomDrawersFocusRef : (_b = globalDrawersFocusControl === null || globalDrawersFocusControl === void 0 ? void 0 : globalDrawersFocusControl.refs[item.id]) === null || _b === void 0 ? void 0 : _b.toggle,
            selected: selected,
            badge: item.badge,
            testId: `awsui-app-layout-trigger-${item.id}`,
            hasTooltip: true,
            hasOpenDrawer: hasOpenDrawer,
            tooltipText: (_c = item.ariaLabels) === null || _c === void 0 ? void 0 : _c.drawerName,
            isForPreviousActiveDrawer: isForPreviousActiveDrawer,
            isMobile: isMobile,
            disabled: disabled
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        items: overflowItems.map((item)=>{
            const isBottom = (item === null || item === void 0 ? void 0 : item.position) === 'bottom';
            let active = activeGlobalDrawersIds.includes(item.id) && (!expandedDrawerId || item.id === expandedDrawerId);
            if (isBottom) active = item.id === activeGlobalBottomDrawerId && (!expandedDrawerId || item.id === expandedDrawerId);
            return {
                ...item,
                active: active
            };
        }),
        ariaLabel: overflowMenuHasBadge ? ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflowWithBadge : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflow,
        customTriggerBuilder: ({ onClick: onClick, triggerRef: triggerRef, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, testUtilsClass: testUtilsClass })=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
                ref: triggerRef,
                ariaLabel: ariaLabel,
                ariaExpanded: ariaExpanded,
                badge: overflowMenuHasBadge,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger'], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['drawers-trigger-global'], testUtilsClass),
                iconName: "ellipsis",
                onClick: onClick,
                disabled: disabled
            });
        },
        onItemClick: (event)=>{
            const id = event.detail.id;
            exitExpandedMode();
            const item = overflowItems.find((item)=>item.id === id);
            const isBottom = (item === null || item === void 0 ? void 0 : item.position) === 'bottom';
            if (isBottom) {
                const selected = item.id === activeGlobalBottomDrawerId && (!expandedDrawerId || item.id === expandedDrawerId);
                onActiveGlobalBottomDrawerChange === null || onActiveGlobalBottomDrawerChange === void 0 || onActiveGlobalBottomDrawerChange(selected ? null : item.id, {
                    initiatedByUserAction: true
                });
                return;
            }
            if (globalDrawers.find((drawer)=>drawer.id === id)) {
                if (!!expandedDrawerId && id !== expandedDrawerId && activeGlobalDrawersIds.includes(id)) return;
                onActiveGlobalDrawersChange === null || onActiveGlobalDrawersChange === void 0 || onActiveGlobalDrawersChange(id, {
                    initiatedByUserAction: true
                });
            } else onActiveDrawerChange === null || onActiveDrawerChange === void 0 || onActiveDrawerChange(event.detail.id, {
                initiatedByUserAction: true
            });
        },
        globalDrawersStartIndex: globalDrawersStartIndex - indexOfOverflowItem
    })));
}






function $0a70221a38f0197f$export$a28be8b8dbc0fb74({ appLayoutInternals: appLayoutInternals, toolbarProps: // the value could be undefined if this component is loaded as a widget by a different app layout version
// not testable in a single-version setup
toolbarProps = {}, featureNotificationsProps: featureNotificationsProps }) {
    var _a, _b, _c;
    const { breadcrumbs: breadcrumbs, discoveredBreadcrumbs: discoveredBreadcrumbs, verticalOffsets: verticalOffsets, isMobile: isMobile, setToolbarHeight: setToolbarHeight, aiDrawer: aiDrawer, activeAiDrawer: activeAiDrawer, onActiveAiDrawerChange: onActiveAiDrawerChange } = appLayoutInternals;
    const { ariaLabels: ariaLabels, activeDrawerId: activeDrawerId, drawers: drawers, drawersFocusRef: drawersFocusRef, onActiveDrawerChange: onActiveDrawerChange, globalDrawersFocusControl: globalDrawersFocusControl, globalDrawers: globalDrawers, activeGlobalDrawersIds: activeGlobalDrawersIds, onActiveGlobalDrawersChange: onActiveGlobalDrawersChange, hasNavigation: hasNavigation, navigationOpen: navigationOpen, navigationFocusRef: navigationFocusRef, onNavigationToggle: onNavigationToggle, hasSplitPanel: hasSplitPanel, splitPanelFocusRef: splitPanelFocusRef, splitPanelToggleProps: splitPanelToggleProps, onSplitPanelToggle: onSplitPanelToggle, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, aiDrawerFocusRef: aiDrawerFocusRef, onActiveGlobalBottomDrawerChange: onActiveGlobalBottomDrawerChange, activeGlobalBottomDrawerId: activeGlobalBottomDrawerId, bottomDrawersFocusRef: bottomDrawersFocusRef, bottomDrawers: bottomDrawers } = toolbarProps;
    const drawerExpandedMode = !!expandedDrawerId;
    const ref = (0, $acw62.useRef)(null);
    const aiDrawerTransitionRef = (0, $acw62.useRef)(null);
    const activeAiDrawerId = activeAiDrawer === null || activeAiDrawer === void 0 ? void 0 : activeAiDrawer.id;
    (0, $013a2451794a45c0$exports.useResizeObserver)(ref, (entry)=>setToolbarHeight(entry.borderBoxHeight));
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setToolbarHeight(0);
        };
    // unmount effect only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const anyPanelOpenInMobile = !!isMobile && (!!activeDrawerId || !!(activeGlobalDrawersIds === null || activeGlobalDrawersIds === void 0 ? void 0 : activeGlobalDrawersIds.length) || !!activeAiDrawerId || !!activeGlobalBottomDrawerId || !!navigationOpen && !!hasNavigation);
    (0, $acw62.useEffect)(()=>{
        if (anyPanelOpenInMobile) document.body.classList.add((0, $fac2a988aee55765$export$2e2bcd8739ae039)['block-body-scroll']);
        else document.body.classList.remove((0, $fac2a988aee55765$export$2e2bcd8739ae039)['block-body-scroll']);
        return ()=>{
            document.body.classList.remove((0, $fac2a988aee55765$export$2e2bcd8739ae039)['block-body-scroll']);
        };
    }, [
        anyPanelOpenInMobile
    ]);
    const navLandmarkAttributes = navigationOpen ? {
        role: 'presentation'
    } : {
        role: 'navigation',
        'aria-label': ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $201c6806d99725a1$export$69aed1e8e248d0c2), {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(((aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.trigger) || !!activeAiDrawerId) && (0, $fac2a988aee55765$export$2e2bcd8739ae039)['with-ai-drawer'], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['mobile-bar']]: isMobile
        }),
        style: {
            insetBlockStart: verticalOffsets.toolbar
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), {
        in: !!((aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.trigger) && !activeAiDrawerId),
        timeout: {
            enter: 0,
            exit: 165
        },
        mountOnEnter: true,
        unmountOnExit: true,
        nodeRef: aiDrawerTransitionRef
    }, (state)=>{
        var _a, _b, _c;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(!!((_a = aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.trigger) === null || _a === void 0 ? void 0 : _a.customIcon) && (0, $fac2a988aee55765$export$2e2bcd8739ae039)['universal-toolbar-ai-custom'], [
                (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal']
            ]),
            style: {
                opacity: [
                    'entering',
                    'exiting'
                ].includes(state) ? 0 : 1
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
            ariaLabel: (_b = aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.triggerButton,
            ariaExpanded: !!activeAiDrawerId,
            iconName: aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.trigger.iconName,
            iconSvg: aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.trigger.iconSvg,
            customSvg: aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.trigger.customIcon,
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['ai-drawer-toggle'],
            onClick: ()=>{
                var _a;
                if (setExpandedDrawerId) setExpandedDrawerId(null);
                onActiveAiDrawerChange === null || onActiveAiDrawerChange === void 0 || onActiveAiDrawerChange((_a = aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id) !== null && _a !== void 0 ? _a : null, {
                    initiatedByUserAction: true
                });
            },
            ref: aiDrawerFocusRef,
            selected: !drawerExpandedMode && !!activeAiDrawerId,
            disabled: anyPanelOpenInMobile,
            variant: ((_c = aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.trigger) === null || _c === void 0 ? void 0 : _c.customIcon) ? 'custom' : 'circle',
            testId: `awsui-app-layout-trigger-${aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.id}`,
            isForPreviousActiveDrawer: true
        }));
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a6da19502768a71$export$141c9d2033716579), {
        hasAiDrawer: !!activeAiDrawerId
    }, hasNavigation && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ...navLandmarkAttributes,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['universal-toolbar-nav'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
        ariaLabel: (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle) !== null && _a !== void 0 ? _a : undefined,
        ariaExpanded: !drawerExpandedMode && navigationOpen,
        iconName: "menu",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)['navigation-toggle'],
        onClick: ()=>{
            if (setExpandedDrawerId) setExpandedDrawerId(null);
            if (navigationOpen && expandedDrawerId) return;
            onNavigationToggle === null || onNavigationToggle === void 0 || onNavigationToggle(!navigationOpen);
        },
        ref: navigationFocusRef,
        selected: !drawerExpandedMode && navigationOpen,
        disabled: anyPanelOpenInMobile
    })), (breadcrumbs || discoveredBreadcrumbs) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a6da19502768a71$export$cc08c3326b6308f0), {
        ownBreadcrumbs: appLayoutInternals.breadcrumbs,
        discoveredBreadcrumbs: appLayoutInternals.discoveredBreadcrumbs,
        includeTestUtils: true
    }), ((drawers === null || drawers === void 0 ? void 0 : drawers.length) || (globalDrawers === null || globalDrawers === void 0 ? void 0 : globalDrawers.length) || (bottomDrawers === null || bottomDrawers === void 0 ? void 0 : bottomDrawers.length) || hasSplitPanel && (splitPanelToggleProps === null || splitPanelToggleProps === void 0 ? void 0 : splitPanelToggleProps.displayed)) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)['universal-toolbar-drawers'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1f0a10ce5025b27d$export$f2a14c3cc682bac7), {
        ariaLabels: ariaLabels,
        activeDrawerId: activeDrawerId !== null && activeDrawerId !== void 0 ? activeDrawerId : null,
        drawers: (_b = drawers === null || drawers === void 0 ? void 0 : drawers.filter((item)=>!!item.trigger)) !== null && _b !== void 0 ? _b : [],
        drawersFocusRef: drawersFocusRef,
        onActiveDrawerChange: onActiveDrawerChange,
        splitPanelToggleProps: (splitPanelToggleProps === null || splitPanelToggleProps === void 0 ? void 0 : splitPanelToggleProps.displayed) ? splitPanelToggleProps : undefined,
        splitPanelFocusRef: splitPanelFocusRef,
        onSplitPanelToggle: onSplitPanelToggle,
        disabled: anyPanelOpenInMobile,
        globalDrawersFocusControl: globalDrawersFocusControl,
        bottomDrawersFocusRef: bottomDrawersFocusRef,
        globalDrawers: (_c = globalDrawers === null || globalDrawers === void 0 ? void 0 : globalDrawers.filter((item)=>!!item.trigger)) !== null && _c !== void 0 ? _c : [],
        activeGlobalDrawersIds: activeGlobalDrawersIds !== null && activeGlobalDrawersIds !== void 0 ? activeGlobalDrawersIds : [],
        onActiveGlobalDrawersChange: onActiveGlobalDrawersChange,
        expandedDrawerId: expandedDrawerId,
        setExpandedDrawerId: setExpandedDrawerId,
        bottomDrawers: bottomDrawers,
        onActiveGlobalBottomDrawerChange: onActiveGlobalBottomDrawerChange,
        activeGlobalBottomDrawerId: activeGlobalBottomDrawerId,
        featureNotificationsProps: featureNotificationsProps
    }))));
}
const $0a70221a38f0197f$export$3c92a11bdbcfb575 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($0a70221a38f0197f$export$a28be8b8dbc0fb74, (0, $673962bdbc7b42a3$export$5e29225d56ca7c7d));




const $237675db78187541$export$3c582ae2bb7d1ca3 = ({ toolbarProps: toolbarProps, appLayoutState: appLayoutState, appLayoutProps: appLayoutProps })=>{
    const wasAiDrawerOpenRef = (0, $acw62.useRef)(false);
    if (!(0, $6574ac16ad1fbe57$export$54888fc7ce30d8c8)(appLayoutState)) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $673962bdbc7b42a3$export$c11019525960d012), {
        toolbarProps: toolbarProps,
        appLayoutProps: appLayoutProps,
        appLayoutState: appLayoutState
    });
    const { activeDrawer: activeDrawer, navigationOpen: navigationOpen, navigation: navigation, expandedDrawerId: expandedDrawerId, setExpandedDrawerId: setExpandedDrawerId, navigationAnimationDisabled: navigationAnimationDisabled, activeAiDrawerId: activeAiDrawerId, aiDrawerExpandedMode: aiDrawerExpandedMode, aiDrawer: aiDrawer, activeAiDrawerSize: activeAiDrawerSize, minAiDrawerSize: minAiDrawerSize, maxAiDrawerSize: maxAiDrawerSize, onActiveAiDrawerResize: onActiveAiDrawerResize, aiDrawerFocusControl: aiDrawerFocusControl, ariaLabels: ariaLabels, isMobile: isMobile, drawersOpenQueue: drawersOpenQueue, onActiveAiDrawerChange: onActiveAiDrawerChange, activeAiDrawer: activeAiDrawer, bottomDrawerReportedSize: bottomDrawerReportedSize, featureNotificationsProps: featureNotificationsProps } = appLayoutState.widgetizedState;
    const drawerExpandedMode = !!expandedDrawerId;
    const toolsOpen = !!activeDrawer;
    // Must use `toolbarProps` because all layouts have to apply this mode, not just the one with toolbar
    const drawerExpandedModeInChildLayout = !!(toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.expandedDrawerId);
    const { __embeddedViewMode: embeddedViewMode } = appLayoutProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !!toolbarProps && !embeddedViewMode && !aiDrawerExpandedMode && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0a70221a38f0197f$export$a28be8b8dbc0fb74), {
        appLayoutInternals: appLayoutState.appLayoutInternals,
        toolbarProps: toolbarProps,
        featureNotificationsProps: featureNotificationsProps
    }), aiDrawer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['ai-drawer'], (drawerExpandedMode || drawerExpandedModeInChildLayout) && !aiDrawerExpandedMode && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).hidden)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bf410ac4539db587$export$adc986c053591633).Provider, {
        value: activeAiDrawer ? [
            activeAiDrawer.id
        ] : []
    }, (!!activeAiDrawerId || (aiDrawer === null || aiDrawer === void 0 ? void 0 : aiDrawer.preserveInactiveContent) && wasAiDrawerOpenRef.current) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, wasAiDrawerOpenRef.current = true, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eba55b24da75eb7d$export$ac0991eb1c14eb28), {
        show: !!activeAiDrawerId,
        activeAiDrawer: aiDrawer !== null && aiDrawer !== void 0 ? aiDrawer : null,
        appLayoutInternals: appLayoutState.appLayoutInternals,
        aiDrawerProps: {
            activeAiDrawerSize: activeAiDrawerSize,
            minAiDrawerSize: minAiDrawerSize,
            maxAiDrawerSize: maxAiDrawerSize,
            aiDrawer: aiDrawer,
            ariaLabels: ariaLabels,
            aiDrawerFocusControl: aiDrawerFocusControl,
            isMobile: isMobile,
            drawersOpenQueue: drawersOpenQueue,
            onActiveAiDrawerChange: onActiveAiDrawerChange,
            onActiveDrawerResize: ({ size: size })=>onActiveAiDrawerResize(size),
            expandedDrawerId: expandedDrawerId,
            setExpandedDrawerId: setExpandedDrawerId
        }
    })))), navigation && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).navigation, !navigationOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['panel-hidden'], toolsOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['unfocusable-mobile'], !navigationAnimationDisabled && (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal'], (drawerExpandedMode || drawerExpandedModeInChildLayout) && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).hidden)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2aecf53b3be154f5$export$e315be948ceba4c9), {
        appLayoutInternals: appLayoutState.appLayoutInternals,
        bottomDrawerReportedSize: bottomDrawerReportedSize
    })));
};
const $237675db78187541$export$c3914139613ca35 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($237675db78187541$export$3c582ae2bb7d1ca3, (0, $673962bdbc7b42a3$export$c11019525960d012));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






const $bcec66d2f73b31de$export$f87ab68b014e0096 = ({ appLayoutState: appLayoutState, appLayoutProps: appLayoutProps })=>{
    if (!(0, $6574ac16ad1fbe57$export$54888fc7ce30d8c8)(appLayoutState)) return null;
    const { splitPanelPosition: splitPanelPosition, placement: placement, activeGlobalBottomDrawerId: activeGlobalBottomDrawerId, bottomDrawerReportedSize: bottomDrawerReportedSize, isMobile: isMobile } = appLayoutState.widgetizedState;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, splitPanelPosition === 'bottom' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['split-panel-bottom'], (0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-vertical']),
        style: {
            insetBlockEnd: placement.insetBlockEnd + (activeGlobalBottomDrawerId && !isMobile ? bottomDrawerReportedSize : 0)
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78b6bd93db866585$export$16518e502b491282), {
        appLayoutInternals: appLayoutState.appLayoutInternals,
        splitPanelInternals: appLayoutState.splitPanelInternals
    }, appLayoutProps.splitPanel)));
};
const $bcec66d2f73b31de$export$ecb68490733db4a8 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($bcec66d2f73b31de$export$f87ab68b014e0096);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $7742510d1afc0efb$export$2e2bcd8739ae039 = {
    "sticky-notifications": "awsui_sticky-notifications_154bi_yk7p7_9",
    "sticky-notifications-with-background": "awsui_sticky-notifications-with-background_154bi_yk7p7_13",
    "has-notifications-content": "awsui_has-notifications-content_154bi_yk7p7_17"
};


function $2ea73f4bcc2e791e$export$14bceeeb14a3fc9a({ appLayoutInternals: appLayoutInternals, children: children }) {
    const { ariaLabels: ariaLabels, stickyNotifications: stickyNotifications, setNotificationsHeight: setNotificationsHeight, verticalOffsets: verticalOffsets } = appLayoutInternals;
    const [hasNotificationsContent, setHasNotificationsContent] = (0, $acw62.useState)(false);
    const rootRef = (0, $acw62.useRef)(null);
    (0, $013a2451794a45c0$exports.useResizeObserver)(rootRef, (entry)=>{
        const hasContent = entry.contentBoxHeight > 0;
        setNotificationsHeight(hasContent ? entry.borderBoxHeight : 0);
        setHasNotificationsContent(hasContent);
    });
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setNotificationsHeight(0);
        };
    // unmount effect only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $201c6806d99725a1$export$afc7f76de8adf7d1), {
        ref: rootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(appLayoutInternals.headerVariant === 'high-contrast' && (0, $9c98cc94ae829c40$export$ebd33a9e3a891abd), stickyNotifications && (0, $7742510d1afc0efb$export$2e2bcd8739ae039)['sticky-notifications'], hasNotificationsContent && (0, $7742510d1afc0efb$export$2e2bcd8739ae039)['has-notifications-content'], appLayoutInternals.headerVariant !== 'high-contrast' && (0, $7742510d1afc0efb$export$2e2bcd8739ae039)['sticky-notifications-with-background']),
        style: {
            insetBlockStart: stickyNotifications ? verticalOffsets.notifications : undefined
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).notifications,
        role: "region",
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.notifications
    }, children));
}




const $706818fe14c7389c$export$35be11449843eec7 = ({ appLayoutProps: appLayoutProps, appLayoutState: appLayoutState })=>{
    if (!(0, $6574ac16ad1fbe57$export$54888fc7ce30d8c8)(appLayoutState)) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, appLayoutProps.notifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['notifications-background'], appLayoutProps.headerVariant === 'high-contrast' && (0, $9c98cc94ae829c40$export$ebd33a9e3a891abd))
    }), appLayoutProps.notifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2ea73f4bcc2e791e$export$14bceeeb14a3fc9a), {
        appLayoutInternals: appLayoutState.appLayoutInternals
    }, appLayoutProps.notifications));
};
const $706818fe14c7389c$export$32580f3969d53232 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($706818fe14c7389c$export$35be11449843eec7);


const $4e005140358e61f0$export$87d6b6ad42cb4287 = (0, $237675db78187541$export$c3914139613ca35)((0, $293a071804cee86f$export$9b66a8b14f2768d9)((0, $237675db78187541$export$3c582ae2bb7d1ca3)));
const $4e005140358e61f0$export$966b7dc8e7da6436 = (0, $ec3fb68fb595309d$export$3db9737c19e6e700)((0, $293a071804cee86f$export$9b66a8b14f2768d9)((0, $ec3fb68fb595309d$export$2099d7746a959a87)));
const $4e005140358e61f0$export$f13c1beec34eb90d = (0, $706818fe14c7389c$export$32580f3969d53232)((0, $293a071804cee86f$export$9b66a8b14f2768d9)((0, $706818fe14c7389c$export$35be11449843eec7)));
const $4e005140358e61f0$export$1c25ca4972f5cf41 = (0, $bcec66d2f73b31de$export$ecb68490733db4a8)((0, $293a071804cee86f$export$9b66a8b14f2768d9)((0, $bcec66d2f73b31de$export$f87ab68b014e0096)));
const $4e005140358e61f0$export$1f5518373263c8af = (0, $16fc9c06fac4197f$export$bf8c0c3640fa28b6)((0, $293a071804cee86f$export$9b66a8b14f2768d9)((0, $16fc9c06fac4197f$export$72d3abb6f9e3e4dc)));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









const $032e239c9545babc$var$componentAnalyticsMetadata = {
    name: 'awsui.AppLayoutToolbar',
    label: {
        selector: 'h1',
        root: 'body'
    }
};
const $032e239c9545babc$export$af3ba02ef74c9bdf = ({ registered: registered, appLayoutProps: appLayoutProps, appLayoutState: appLayoutState, toolbarProps: toolbarProps, skeletonSlotsAttributes: skeletonSlotsAttributes })=>{
    var _a, _b, _c, _d, _e;
    const { contentHeader: contentHeader, content: content, navigationWidth: navigationWidth } = appLayoutProps;
    const mergedProps = {
        toolbarProps: toolbarProps,
        appLayoutProps: appLayoutProps,
        appLayoutState: appLayoutState
    };
    const { wrapperElAttributes: wrapperElAttributes, mainElAttributes: mainElAttributes, contentWrapperElAttributes: contentWrapperElAttributes, contentHeaderElAttributes: contentHeaderElAttributes, contentElAttributes: contentElAttributes } = skeletonSlotsAttributes;
    const isWidgetLoaded = (0, $6574ac16ad1fbe57$export$54888fc7ce30d8c8)(appLayoutState);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8856d0c7df08fd8d$export$2e2bcd8739ae039), {
        contextName: "app-layout-toolbar"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: $032e239c9545babc$var$componentAnalyticsMetadata
        }),
        ref: appLayoutState.rootRef,
        "data-awsui-app-layout-widget-loaded": isWidgetLoaded,
        ...wrapperElAttributes,
        className: (_a = wrapperElAttributes === null || wrapperElAttributes === void 0 ? void 0 : wrapperElAttributes.className) !== null && _a !== void 0 ? _a : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).root, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).root),
        style: (_b = wrapperElAttributes === null || wrapperElAttributes === void 0 ? void 0 : wrapperElAttributes.style) !== null && _b !== void 0 ? _b : {
            blockSize: `calc(100vh - ${appLayoutProps.placement.insetBlockStart + appLayoutProps.placement.insetBlockEnd}px)`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).navigationWidth]: `${navigationWidth}px`
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$87d6b6ad42cb4287), {
        ...mergedProps
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        ...mainElAttributes,
        className: (_c = mainElAttributes === null || mainElAttributes === void 0 ? void 0 : mainElAttributes.className) !== null && _c !== void 0 ? _c : (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['main-landmark']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$f13c1beec34eb90d), {
        ...mergedProps
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...contentWrapperElAttributes,
        className: (_d = contentWrapperElAttributes === null || contentWrapperElAttributes === void 0 ? void 0 : contentWrapperElAttributes.className) !== null && _d !== void 0 ? _d : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).main, {
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)['main-disable-paddings']]: appLayoutProps.disableContentPaddings
        })
    }, contentHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...contentHeaderElAttributes
    }, contentHeader), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...contentElAttributes,
        className: (_e = contentElAttributes === null || contentElAttributes === void 0 ? void 0 : contentElAttributes.className) !== null && _e !== void 0 ? _e : (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).content
    }, registered ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), null, content) : null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$1c25ca4972f5cf41), {
        ...mergedProps
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$966b7dc8e7da6436), {
        ...mergedProps
    })));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



function $7ac2028770f0421f$export$e58f5c42fb71154d(forceDeduplicationType, isEnabled, props, mergeProps) {
    const [registration, setRegistration] = (0, $acw62.useState)(null);
    const isToolbar = (0, $73078c4512771f18$export$140d325aa1fff478)();
    (0, $acw62.useLayoutEffect)(()=>{
        if (!isEnabled || forceDeduplicationType === 'suspended' || !isToolbar) return;
        if (forceDeduplicationType === 'off') {
            setRegistration({
                type: 'primary',
                discoveredProps: []
            });
            return;
        }
        const unregister = (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayoutWidget.register(forceDeduplicationType, (props)=>setRegistration(props));
        return ()=>{
            unregister();
            setRegistration({
                type: 'suspended'
            });
        };
    }, [
        forceDeduplicationType,
        isEnabled,
        isToolbar
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if ((registration === null || registration === void 0 ? void 0 : registration.type) === 'secondary') registration.update(props);
    });
    (0, $acw62.useEffect)(()=>{
        if (registration) $7ac2028770f0421f$var$reportMultiLayoutMetric(registration);
    }, [
        registration
    ]);
    if (!isToolbar) return {
        registered: true,
        // mergeProps is needed here because the toolbar's behavior depends on reconciliation logic
        // in this function. For example, navigation trigger visibility
        toolbarProps: mergeProps(props, [])
    };
    return {
        registered: !!(registration === null || registration === void 0 ? void 0 : registration.type),
        toolbarProps: (registration === null || registration === void 0 ? void 0 : registration.type) === 'primary' ? mergeProps(props, registration.discoveredProps) : null
    };
}
function $7ac2028770f0421f$var$reportMultiLayoutMetric(registration) {
    if (registration.type === 'primary' && registration.discoveredProps.length > 0) (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendOpsMetricObject('awsui-multi-layout-usage-primary', {
        // temporary workaround for missing typings
        // https://github.com/cloudscape-design/component-toolkit/pull/153
        instancesCount: registration.discoveredProps.length
    });
    else if (registration.type === 'suspended') (0, $0248ab5e20bc8888$export$b0c5c2fac8144e54).sendOpsMetricObject('awsui-multi-layout-usage-suspended', {});
}



const $1cb9e3746b46916d$var$AppLayoutStateProvider = ({ forceDeduplicationType: forceDeduplicationType, appLayoutProps: appLayoutProps, stateManager: stateManager, children: children })=>{
    const [appLayoutState, setAppLayoutState] = (0, $acw62.useState)({
        isIntersecting: true
    });
    const [skeletonAttributes, setSkeletonAttributes] = (0, $acw62.useState)({});
    // use { fn: } object wrapper to avoid confusion with callback form of setState
    const [deduplicator, setDeduplicator] = (0, $acw62.useState)({
        fn: (0, $902475055b64674b$export$9d1611c77c2fe928)
    });
    const [deduplicationProps, setDeduplicationProps] = (0, $acw62.useState)(undefined);
    const { registered: registered, toolbarProps: toolbarProps } = (0, $7ac2028770f0421f$export$e58f5c42fb71154d)(forceDeduplicationType, appLayoutState.isIntersecting, deduplicationProps !== null && deduplicationProps !== void 0 ? deduplicationProps : (0, $902475055b64674b$export$9fd8253f8e263aaf)(appLayoutProps, appLayoutState), deduplicator.fn);
    (0, $acw62.useLayoutEffect)(()=>{
        stateManager.current.setState = (appLayoutState, skeletonAttributes, deduplicationProps, mergeProps)=>{
            (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                setAppLayoutState(appLayoutState);
                setSkeletonAttributes(skeletonAttributes);
                setDeduplicationProps(deduplicationProps);
                setDeduplicator({
                    fn: mergeProps
                });
            });
        };
    }, [
        stateManager
    ]);
    const hasToolbar = !!toolbarProps;
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        stateManager.current.hasToolbar = hasToolbar;
        (_b = (_a = stateManager.current).setToolbar) === null || _b === void 0 || _b.call(_a, hasToolbar);
    }, [
        stateManager,
        hasToolbar
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(registered, appLayoutState, toolbarProps, skeletonAttributes));
};
const $1cb9e3746b46916d$var$AppLayoutVisualRefreshToolbar = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardRef)=>{
    const stateManager = (0, $acw62.useRef)({
        setState: undefined,
        hasToolbar: false,
        setToolbar: undefined
    });
    const { __forceDeduplicationType: forceDeduplicationType, __embeddedViewMode: embeddedViewMode } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1cb9e3746b46916d$var$AppLayoutStateProvider, {
        forceDeduplicationType: forceDeduplicationType,
        appLayoutProps: props,
        stateManager: stateManager
    }, (registered, appLayoutState, toolbarProps, skeletonAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5475c68ef3288dd6$export$e0610513fcff76c1).Provider, {
            value: appLayoutState.isIntersecting
        }, (embeddedViewMode || !toolbarProps) && props.breadcrumbs ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), null, props.breadcrumbs) : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $032e239c9545babc$export$af3ba02ef74c9bdf), {
            registered: registered,
            toolbarProps: toolbarProps,
            appLayoutProps: props,
            appLayoutState: appLayoutState,
            skeletonSlotsAttributes: skeletonAttributes
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$1f5518373263c8af), {
        forwardRef: forwardRef,
        appLayoutProps: props,
        stateManager: stateManager
    }));
});
var $1cb9e3746b46916d$export$2e2bcd8739ae039 = $1cb9e3746b46916d$var$AppLayoutVisualRefreshToolbar;


const $ea8590cb86272801$export$e7b09cbd23d3aff = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const isToolbar = (0, $73078c4512771f18$export$140d325aa1fff478)();
    if (isRefresh) {
        if (isToolbar) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1cb9e3746b46916d$export$2e2bcd8739ae039), {
            ref: ref,
            ...props
        });
        else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18dc6142312830db$export$2e2bcd8739ae039), {
            ref: ref,
            ...props
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ad7a06c5c5b5cb1$export$2e2bcd8739ae039), {
        ref: ref,
        ...props
    });
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $fe475dd0b21a124b$export$f22a61189702bd57(rootElementRef, selector) {
    const getElement = (0, $acw62.useCallback)(()=>{
        var _a, _b;
        const document = (_b = (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : window.document;
        return document.querySelector(selector);
    }, [
        rootElementRef,
        selector
    ]);
    const [height, setHeight] = (0, $acw62.useState)(0);
    (0, $013a2451794a45c0$exports.useResizeObserver)(getElement, (entry)=>setHeight(entry.borderBoxHeight));
    return height;
}


function $9bd7f949256e7f39$export$15e0126286aabec3(headerSelector, footerSelector) {
    const mainElementRef = (0, $acw62.useRef)(null);
    const headerHeight = (0, $fe475dd0b21a124b$export$f22a61189702bd57)(mainElementRef, headerSelector);
    const footerHeight = (0, $fe475dd0b21a124b$export$f22a61189702bd57)(mainElementRef, footerSelector);
    const [offsets, setOffsets] = (0, $acw62.useState)({
        insetInlineStart: 0,
        insetInlineEnd: 0,
        inlineSize: Number.POSITIVE_INFINITY
    });
    const updatePosition = (0, $acw62.useCallback)(()=>{
        if (!mainElementRef.current) return;
        const { insetInlineStart: insetInlineStart, insetInlineEnd: insetInlineEnd, inlineSize: inlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(mainElementRef.current);
        // skip reading sizes in JSDOM
        if (inlineSize === 0) return;
        setOffsets({
            insetInlineStart: insetInlineStart,
            insetInlineEnd: inlineSize - insetInlineEnd,
            inlineSize: inlineSize
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener('resize', updatePosition);
        return ()=>window.removeEventListener('resize', updatePosition);
    }, [
        updatePosition
    ]);
    (0, $013a2451794a45c0$exports.useResizeObserver)(mainElementRef, updatePosition);
    return [
        mainElementRef,
        {
            ...offsets,
            insetBlockStart: headerHeight,
            insetBlockEnd: footerHeight
        }
    ];
}


'use client';
const $12de04d549d06eb2$var$AppLayout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ contentType: contentType = 'default', headerSelector: headerSelector = '#b #h', footerSelector: footerSelector = '#b #f', navigationWidth: navigationWidth = 280, toolsWidth: toolsWidth = 290, maxContentWidth: maxContentWidth, minContentWidth: minContentWidth, navigationOpen: controlledNavigationOpen, onNavigationChange: controlledOnNavigationChange, analyticsMetadata: analyticsMetadata, ...rest }, ref)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (rest.toolsOpen && rest.toolsHide) (0, $013a2451794a45c0$exports.warnOnce)('AppLayout', `You have enabled both the \`toolsOpen\` prop and the \`toolsHide\` prop. This is not supported. Set \`toolsOpen\` to \`false\` when you set \`toolsHide\` to \`true\`.`);
    }
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)('AppLayout', {
        props: {
            contentType: contentType,
            disableContentPaddings: rest.disableContentPaddings,
            disableBodyScroll: rest.disableBodyScroll,
            navigationWidth: navigationWidth,
            navigationHide: rest.navigationHide,
            toolsHide: rest.toolsHide,
            toolsWidth: toolsWidth,
            maxContentWidth: maxContentWidth,
            minContentWidth: minContentWidth,
            stickyNotifications: rest.stickyNotifications,
            disableContentHeaderOverlap: rest.disableContentHeaderOverlap
        },
        metadata: {
            drawersCount: (_b = (_a = rest.drawers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : null,
            hasContentHeader: !!rest.contentHeader
        }
    }, analyticsMetadata);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('app-layout');
    const ariaLabels = {
        navigation: i18n('ariaLabels.navigation', (_c = rest.ariaLabels) === null || _c === void 0 ? void 0 : _c.navigation),
        navigationClose: i18n('ariaLabels.navigationClose', (_d = rest.ariaLabels) === null || _d === void 0 ? void 0 : _d.navigationClose),
        navigationToggle: i18n('ariaLabels.navigationToggle', (_e = rest.ariaLabels) === null || _e === void 0 ? void 0 : _e.navigationToggle),
        notifications: i18n('ariaLabels.notifications', (_f = rest.ariaLabels) === null || _f === void 0 ? void 0 : _f.notifications),
        tools: i18n('ariaLabels.tools', (_g = rest.ariaLabels) === null || _g === void 0 ? void 0 : _g.tools),
        toolsClose: i18n('ariaLabels.toolsClose', (_h = rest.ariaLabels) === null || _h === void 0 ? void 0 : _h.toolsClose),
        toolsToggle: i18n('ariaLabels.toolsToggle', (_j = rest.ariaLabels) === null || _j === void 0 ? void 0 : _j.toolsToggle),
        drawers: i18n('ariaLabels.drawers', (_k = rest.ariaLabels) === null || _k === void 0 ? void 0 : _k.drawers),
        drawersOverflow: i18n('ariaLabels.drawersOverflow', (_l = rest.ariaLabels) === null || _l === void 0 ? void 0 : _l.drawersOverflow),
        drawersOverflowWithBadge: i18n('ariaLabels.drawersOverflowWithBadge', (_m = rest.ariaLabels) === null || _m === void 0 ? void 0 : _m.drawersOverflowWithBadge)
    };
    const { navigationOpen: defaultNavigationOpen, ...restDefaults } = (0, $bfbfeb434025eacd$export$981532776ab2217e)(contentType, {
        maxContentWidth: maxContentWidth,
        minContentWidth: minContentWidth
    }, isRefresh);
    const [navigationOpen = false, setNavigationOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledNavigationOpen, controlledOnNavigationChange, isMobile ? false : defaultNavigationOpen, {
        componentName: 'AppLayout',
        controlledProp: 'navigationOpen',
        changeHandler: 'onNavigationChange'
    });
    const onNavigationChange = (event)=>{
        setNavigationOpen(event.detail.open);
        controlledOnNavigationChange === null || controlledOnNavigationChange === void 0 || controlledOnNavigationChange(event);
    };
    const [rootRef, placement] = (0, $9bd7f949256e7f39$export$15e0126286aabec3)(headerSelector, footerSelector);
    // This re-builds the props including the default values
    const props = {
        contentType: contentType,
        navigationWidth: navigationWidth,
        toolsWidth: toolsWidth,
        navigationOpen: navigationOpen,
        onNavigationChange: onNavigationChange,
        ...restDefaults,
        ...rest,
        ariaLabels: ariaLabels,
        placement: placement
    };
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: (0, $013a2451794a45c0$exports.useMergeRefs)(__internalRootRef, rootRef),
        ...baseProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ea8590cb86272801$export$e7b09cbd23d3aff), {
        ref: ref,
        ...props
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($12de04d549d06eb2$var$AppLayout, 'AppLayout');
var $12de04d549d06eb2$export$2e2bcd8739ae039 = $12de04d549d06eb2$var$AppLayout;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $a377204c24659ddf$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $a377204c24659ddf$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $a377204c24659ddf$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $a377204c24659ddf$export$fa71e2345c31d7a2(props, onExited) {
    return $a377204c24659ddf$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $a377204c24659ddf$var$getProp(child, 'appear', props),
            enter: $a377204c24659ddf$var$getProp(child, 'enter', props),
            exit: $a377204c24659ddf$var$getProp(child, 'exit', props)
        });
    });
}
function $a377204c24659ddf$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $a377204c24659ddf$export$bbc8a025727ea824(nextProps.children);
    var children = $a377204c24659ddf$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $a377204c24659ddf$var$getProp(child, 'exit', nextProps),
            enter: $a377204c24659ddf$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $a377204c24659ddf$var$getProp(child, 'exit', nextProps),
            enter: $a377204c24659ddf$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $6bd2d3fc5aa42c33$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $6bd2d3fc5aa42c33$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $6bd2d3fc5aa42c33$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $a377204c24659ddf$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $a377204c24659ddf$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $a377204c24659ddf$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $6bd2d3fc5aa42c33$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae9b8e2bcc2d9ece$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae9b8e2bcc2d9ece$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$6bd2d3fc5aa42c33$var$TransitionGroup.propTypes = {};
$6bd2d3fc5aa42c33$var$TransitionGroup.defaultProps = $6bd2d3fc5aa42c33$var$defaultProps;
var $6bd2d3fc5aa42c33$export$2e2bcd8739ae039 = $6bd2d3fc5aa42c33$var$TransitionGroup;




var $1yiQH = parcelRequire("1yiQH");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3598f7c3986914de$export$2c8afa89e423ed39(elements) {
    const rects = {};
    for(const id in elements){
        const element = elements[id];
        if (element) rects[id] = element.getBoundingClientRect();
    }
    return rects;
}
function $3598f7c3986914de$export$e3607ec2d7a891c4({ oldState: oldState, elements: elements, onTransitionsEnd: onTransitionsEnd, newElementInitialState: newElementInitialState }) {
    // First, apply the transform that will make the elements "look like" in the start position
    for(const id in elements){
        const element = elements[id];
        const oldRect = oldState[id];
        if (element) {
            const newRect = element.getBoundingClientRect();
            const noOpTransform = {
                scale: 1,
                x: 0,
                y: 0
            };
            // Calculate initial position.
            // If the element didn't exist previously, use the newElementInitialState function if provided.
            // If not, default to no transitions (scale: 1, y: 0)
            const calculatedInverseTransform = oldRect ? {
                scale: oldRect.width / newRect.width,
                x: (oldRect.left + oldRect.right) / 2 - (newRect.left + newRect.right) / 2,
                y: (oldRect.top + oldRect.bottom) / 2 - (newRect.top + newRect.bottom) / 2
            } : newElementInitialState ? newElementInitialState(newRect) : {};
            const inverseTransform = {
                ...noOpTransform,
                ...calculatedInverseTransform
            };
            // Apply this initial change, without animating
            element.style.transitionProperty = 'none';
            element.style.transform = `scale(${inverseTransform.scale}) translate(${inverseTransform.x}px, ${inverseTransform.y}px)`;
            if (!oldRect) // If the element didn't exist, then fade it in
            // (besides any other possibly defined transitions based on `newElementInitialState`)
            element.style.opacity = '0';
        }
    }
    // Animate from the initial state to the end state
    requestAnimationFrame(()=>{
        const ongoingAnimations = new Set();
        for(const id in elements){
            const element = elements[id];
            if (element) {
                const oldRect = oldState[id];
                if (oldRect) {
                    // Animate from here on
                    element.style.transitionProperty = `transform`;
                    // Unset inline CSS transforms so that the final state is applied
                    element.style.transform = '';
                } else {
                    // If the element didn't exist previously, fade in as well
                    element.style.transitionProperty = `transform, opacity`;
                    element.style.transform = '';
                    element.style.opacity = '';
                }
                const onTransitionStart = (event)=>{
                    if (event.target === element) {
                        ongoingAnimations.add(id);
                        element.removeEventListener('transitionstart', onTransitionStart);
                    }
                };
                const onTransitionEnd = (event)=>{
                    if (event.target === element) {
                        // Clean up remaining inline styles
                        element.style.transitionProperty = '';
                        element.removeEventListener('transitionend', onTransitionEnd);
                        if (onTransitionsEnd) {
                            ongoingAnimations.delete(id);
                            if (ongoingAnimations.size === 0) onTransitionsEnd();
                        }
                    }
                };
                element.addEventListener('transitionstart', onTransitionStart);
                element.addEventListener('transitionend', onTransitionEnd);
            }
        }
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $2f667510820517ed$export$40ae01be0011c1e6(callback, delay) {
    const callbackRef = (0, $acw62.useRef)();
    callbackRef.current = callback;
    // ESLint rule requires an inline function which we cannot provide here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)((0, $3f63db4ba00e1128$export$2e2bcd8739ae039)((...args)=>{
        if (callbackRef.current) callbackRef.current(...args);
    }, delay), []);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $5e5497af6e342378$export$43f0d02427e1c683(func, delay, deps) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useMemo)(()=>(0, $3d33451aaae58ddb$export$de363e709c412c8a)(func, delay), deps);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1a959aecdb7241ea$export$2e2bcd8739ae039 = {
    "flash-header": "awsui_flash-header_4c95g_vov7p_5"
};


const $7b53e52459b13a81$export$d337fc1999ef7dec = (itemsCount, stackItems, expanded)=>{
    const metadata = {
        component: {
            name: 'awsui.Flashbar',
            label: stackItems ? {
                root: 'self',
                selector: 'ul'
            } : {
                root: 'self'
            },
            properties: {
                itemsCount: `${itemsCount}`,
                stackItems: `${stackItems}`
            }
        }
    };
    if (expanded !== undefined) metadata.component.properties.expanded = `${expanded}`;
    return metadata;
};
const $7b53e52459b13a81$export$4e4df58d95018800 = (position, type, id)=>{
    const baseMetadata = {
        itemLabel: `.${(0, $1a959aecdb7241ea$export$2e2bcd8739ae039)['flash-header']}`,
        itemPosition: `${position}`,
        itemType: type
    };
    if (id) baseMetadata.itemId = id;
    return {
        component: {
            innerContext: baseMetadata
        }
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


const $f3ef1b762a556220$export$44c8f1d8dc8f2bac = 500;
const $f3ef1b762a556220$var$typesToColors = {
    error: 'red',
    info: 'blue',
    'in-progress': 'blue',
    success: 'green',
    warning: 'yellow'
};
function $f3ef1b762a556220$var$getColorFromType(type) {
    const defaultColor = 'blue';
    return type ? $f3ef1b762a556220$var$typesToColors[type] || defaultColor : defaultColor;
}
function $f3ef1b762a556220$export$28b75a4bedf6475d(item) {
    if (item.loading) return 'in-progress';
    else return item.type || 'info';
}
function $f3ef1b762a556220$export$5bbd879b67a2454e(item) {
    return $f3ef1b762a556220$var$getColorFromType($f3ef1b762a556220$export$28b75a4bedf6475d(item));
}
function $f3ef1b762a556220$export$46bbf6b048090d82(items, desiredLength) {
    // First `desiredLength` items in the original array,
    // together with `isColorRepeated` to tell if they can be subject to be replaced later on if necessary
    const itemsOnTop = [];
    // Items that fall outside `desiredIndexLength` but need to be "promoted" if possible
    // because they are of a different color which otherwise wouldn't be represented
    const itemsToPromote = [];
    const addedColors = new Set();
    const allPossibleColors = Object.keys($f3ef1b762a556220$var$typesToColors).length;
    const finalLength = Math.min(items.length, desiredLength);
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        const color = $f3ef1b762a556220$export$5bbd879b67a2454e(item);
        const isColorRepeated = addedColors.has(color);
        if (i < finalLength) itemsOnTop.push({
            item: {
                ...item,
                expandedIndex: i
            },
            isColorRepeated: isColorRepeated
        });
        else {
            if (addedColors.size === allPossibleColors) break;
            else if (!isColorRepeated) itemsToPromote.push({
                ...item,
                expandedIndex: i
            });
        }
        addedColors.add(color);
    }
    // Generate the new array with the selected items, by picking from both arrays.
    // First, from the non-repeated items within the desired length...
    // We loop `itemsOnTop` starting from the end because we prefer to preserve the first ones rather than the old ones
    const reversedInitialSelection = [];
    let slotsReservedForPromotions = 0;
    for(let j = itemsOnTop.length - 1; j >= 0; j--){
        const item = itemsOnTop[j];
        if (item.isColorRepeated && slotsReservedForPromotions < itemsToPromote.length) slotsReservedForPromotions += 1;
        else reversedInitialSelection.push(item.item);
    }
    const selectedItems = reversedInitialSelection.reverse();
    // ...and then complete the selection with as many promotable items as we can fit in the rest of the array
    for(let k = 0; selectedItems.length < desiredLength; k++)selectedItems.push(itemsToPromote[k]);
    return selectedItems;
}
function $f3ef1b762a556220$export$bc904e7e06b11e99(items) {
    const count = {
        error: 0,
        info: 0,
        'in-progress': 0,
        success: 0,
        warning: 0
    };
    for (const item of items){
        const type = $f3ef1b762a556220$export$28b75a4bedf6475d(item);
        count[type] += 1;
    }
    return count;
}
function $f3ef1b762a556220$export$a7ac283235aa9a32(type) {
    return type === 'in-progress' ? 'inProgress' : type;
}
const $f3ef1b762a556220$export$7256f2f4a100fd7 = [
    {
        type: 'error',
        labelName: 'errorIconAriaLabel',
        iconName: 'status-negative'
    },
    {
        type: 'warning',
        labelName: 'warningIconAriaLabel',
        iconName: 'status-warning'
    },
    {
        type: 'success',
        labelName: 'successIconAriaLabel',
        iconName: 'status-positive'
    },
    {
        type: 'info',
        labelName: 'infoIconAriaLabel',
        iconName: 'status-info'
    },
    {
        type: 'in-progress',
        labelName: 'inProgressIconAriaLabel',
        iconName: 'status-in-progress'
    }
];


function $13b0be2e1fb279db$export$725491c3104a6274(style, type = 'info') {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !style) return undefined;
    const styleKey = (0, $f3ef1b762a556220$export$a7ac283235aa9a32)(type);
    const background = ((_b = (_a = style === null || style === void 0 ? void 0 : style.item) === null || _a === void 0 ? void 0 : _a.root) === null || _b === void 0 ? void 0 : _b.background) && ((_d = (_c = style === null || style === void 0 ? void 0 : style.item) === null || _c === void 0 ? void 0 : _c.root) === null || _d === void 0 ? void 0 : _d.background[styleKey]);
    const borderColor = ((_f = (_e = style === null || style === void 0 ? void 0 : style.item) === null || _e === void 0 ? void 0 : _e.root) === null || _f === void 0 ? void 0 : _f.borderColor) && ((_h = (_g = style === null || style === void 0 ? void 0 : style.item) === null || _g === void 0 ? void 0 : _g.root) === null || _h === void 0 ? void 0 : _h.borderColor[styleKey]);
    const borderRadius = (_k = (_j = style === null || style === void 0 ? void 0 : style.item) === null || _j === void 0 ? void 0 : _j.root) === null || _k === void 0 ? void 0 : _k.borderRadius;
    const borderWidth = (_m = (_l = style === null || style === void 0 ? void 0 : style.item) === null || _l === void 0 ? void 0 : _l.root) === null || _m === void 0 ? void 0 : _m.borderWidth;
    const borderStyle = ((_p = (_o = style === null || style === void 0 ? void 0 : style.item) === null || _o === void 0 ? void 0 : _o.root) === null || _p === void 0 ? void 0 : _p.borderWidth) && 'solid';
    const color = ((_r = (_q = style === null || style === void 0 ? void 0 : style.item) === null || _q === void 0 ? void 0 : _q.root) === null || _r === void 0 ? void 0 : _r.color) && ((_t = (_s = style === null || style === void 0 ? void 0 : style.item) === null || _s === void 0 ? void 0 : _s.root) === null || _t === void 0 ? void 0 : _t.color[styleKey]);
    return {
        background: background,
        borderColor: borderColor,
        borderRadius: borderRadius,
        borderStyle: borderStyle,
        borderWidth: borderWidth,
        color: color
    };
}
function $13b0be2e1fb279db$export$d54ee177cd31913a(style, type = 'info') {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !style) return undefined;
    const focusRingBorderColor = ((_c = (_b = (_a = style === null || style === void 0 ? void 0 : style.item) === null || _a === void 0 ? void 0 : _a.root) === null || _b === void 0 ? void 0 : _b.focusRing) === null || _c === void 0 ? void 0 : _c.borderColor) && style.item.root.focusRing.borderColor[(0, $f3ef1b762a556220$export$a7ac283235aa9a32)(type)];
    return {
        ...$13b0be2e1fb279db$export$725491c3104a6274(style, type),
        ...((_e = (_d = style === null || style === void 0 ? void 0 : style.item) === null || _d === void 0 ? void 0 : _d.root) === null || _e === void 0 ? void 0 : _e.focusRing) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: focusRingBorderColor,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_f = style.item.root.focusRing) === null || _f === void 0 ? void 0 : _f.borderRadius,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_g = style.item.root.focusRing) === null || _g === void 0 ? void 0 : _g.borderWidth
        },
        ...((_k = (_j = (_h = style === null || style === void 0 ? void 0 : style.item) === null || _h === void 0 ? void 0 : _h.root) === null || _j === void 0 ? void 0 : _j.focusRing) === null || _k === void 0 ? void 0 : _k.borderRadius) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: style.item.root.focusRing.borderRadius
        }
    };
}
function $13b0be2e1fb279db$export$fde468abe546d4b9(style, type = 'info') {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !style) return undefined;
    const styleKey = (0, $f3ef1b762a556220$export$a7ac283235aa9a32)(type);
    const activeColor = ((_c = (_b = (_a = style === null || style === void 0 ? void 0 : style.item) === null || _a === void 0 ? void 0 : _a.dismissButton) === null || _b === void 0 ? void 0 : _b.color) === null || _c === void 0 ? void 0 : _c.active) && style.item.dismissButton.color.active[styleKey];
    const defaultColor = ((_f = (_e = (_d = style === null || style === void 0 ? void 0 : style.item) === null || _d === void 0 ? void 0 : _d.dismissButton) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.default) && style.item.dismissButton.color.default[styleKey];
    const hoverColor = ((_j = (_h = (_g = style === null || style === void 0 ? void 0 : style.item) === null || _g === void 0 ? void 0 : _g.dismissButton) === null || _h === void 0 ? void 0 : _h.color) === null || _j === void 0 ? void 0 : _j.hover) && style.item.dismissButton.color.hover[styleKey];
    const focusRingBorderColor = ((_m = (_l = (_k = style === null || style === void 0 ? void 0 : style.item) === null || _k === void 0 ? void 0 : _k.dismissButton) === null || _l === void 0 ? void 0 : _l.focusRing) === null || _m === void 0 ? void 0 : _m.borderColor) && style.item.dismissButton.focusRing.borderColor[styleKey];
    return {
        root: {
            color: {
                active: activeColor,
                default: defaultColor,
                hover: hoverColor
            },
            focusRing: {
                borderColor: focusRingBorderColor,
                borderRadius: (_q = (_p = (_o = style === null || style === void 0 ? void 0 : style.item) === null || _o === void 0 ? void 0 : _o.dismissButton) === null || _p === void 0 ? void 0 : _p.focusRing) === null || _q === void 0 ? void 0 : _q.borderRadius,
                borderWidth: (_t = (_s = (_r = style === null || style === void 0 ? void 0 : style.item) === null || _r === void 0 ? void 0 : _r.dismissButton) === null || _s === void 0 ? void 0 : _s.focusRing) === null || _t === void 0 ? void 0 : _t.borderWidth
            }
        }
    };
}
function $13b0be2e1fb279db$export$7505a75c3c76ded4(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core' || !style) return undefined;
    return {
        borderRadius: (_b = (_a = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _a === void 0 ? void 0 : _a.root) === null || _b === void 0 ? void 0 : _b.borderRadius,
        borderWidth: (_d = (_c = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _c === void 0 ? void 0 : _c.root) === null || _d === void 0 ? void 0 : _d.borderWidth,
        ...((_g = (_f = (_e = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _e === void 0 ? void 0 : _e.root) === null || _f === void 0 ? void 0 : _f.background) === null || _g === void 0 ? void 0 : _g.active) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundActive]: style.notificationBar.root.background.active
        },
        ...((_k = (_j = (_h = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _h === void 0 ? void 0 : _h.root) === null || _j === void 0 ? void 0 : _j.background) === null || _k === void 0 ? void 0 : _k.default) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundDefault]: style.notificationBar.root.background.default
        },
        ...((_o = (_m = (_l = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _l === void 0 ? void 0 : _l.root) === null || _m === void 0 ? void 0 : _m.background) === null || _o === void 0 ? void 0 : _o.hover) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundHover]: style.notificationBar.root.background.hover
        },
        ...((_r = (_q = (_p = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _p === void 0 ? void 0 : _p.root) === null || _q === void 0 ? void 0 : _q.borderColor) === null || _r === void 0 ? void 0 : _r.active) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorActive]: style.notificationBar.root.borderColor.active
        },
        ...((_u = (_t = (_s = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _s === void 0 ? void 0 : _s.root) === null || _t === void 0 ? void 0 : _t.borderColor) === null || _u === void 0 ? void 0 : _u.default) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorDefault]: style.notificationBar.root.borderColor.default
        },
        ...((_x = (_w = (_v = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _v === void 0 ? void 0 : _v.root) === null || _w === void 0 ? void 0 : _w.borderColor) === null || _x === void 0 ? void 0 : _x.hover) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorHover]: style.notificationBar.root.borderColor.hover
        },
        ...((_0 = (_z = (_y = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _y === void 0 ? void 0 : _y.root) === null || _z === void 0 ? void 0 : _z.color) === null || _0 === void 0 ? void 0 : _0.active) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorActive]: style.notificationBar.root.color.active
        },
        ...((_3 = (_2 = (_1 = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _1 === void 0 ? void 0 : _1.root) === null || _2 === void 0 ? void 0 : _2.color) === null || _3 === void 0 ? void 0 : _3.default) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDefault]: style.notificationBar.root.color.default
        },
        ...((_6 = (_5 = (_4 = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _4 === void 0 ? void 0 : _4.root) === null || _5 === void 0 ? void 0 : _5.color) === null || _6 === void 0 ? void 0 : _6.hover) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorHover]: style.notificationBar.root.color.hover
        },
        ...((_8 = (_7 = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _7 === void 0 ? void 0 : _7.expandButton) === null || _8 === void 0 ? void 0 : _8.focusRing) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: (_11 = (_10 = (_9 = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _9 === void 0 ? void 0 : _9.expandButton) === null || _10 === void 0 ? void 0 : _10.focusRing) === null || _11 === void 0 ? void 0 : _11.borderColor,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_14 = (_13 = (_12 = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _12 === void 0 ? void 0 : _12.expandButton) === null || _13 === void 0 ? void 0 : _13.focusRing) === null || _14 === void 0 ? void 0 : _14.borderRadius,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_17 = (_16 = (_15 = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _15 === void 0 ? void 0 : _15.expandButton) === null || _16 === void 0 ? void 0 : _16.focusRing) === null || _17 === void 0 ? void 0 : _17.borderWidth
        },
        ...((_20 = (_19 = (_18 = style === null || style === void 0 ? void 0 : style.notificationBar) === null || _18 === void 0 ? void 0 : _18.expandButton) === null || _19 === void 0 ? void 0 : _19.focusRing) === null || _20 === void 0 ? void 0 : _20.borderRadius) && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: style.notificationBar.expandButton.focusRing.borderRadius
        }
    };
}




var $22172a45fa7d5ae9$export$2e2bcd8739ae039 = {
    "flash-with-motion": "awsui_flash-with-motion_1q84n_283yi_157",
    "enter": "awsui_enter_1q84n_283yi_157",
    "flash-body": "awsui_flash-body_1q84n_283yi_171",
    "flash-message": "awsui_flash-message_1q84n_283yi_171",
    "flash-header": "awsui_flash-header_1q84n_283yi_171",
    "flash-content": "awsui_flash-content_1q84n_283yi_172",
    "action-button-wrapper": "awsui_action-button-wrapper_1q84n_283yi_173",
    "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_283yi_174",
    "flash-icon": "awsui_flash-icon_1q84n_283yi_197",
    "entering": "awsui_entering_1q84n_283yi_210",
    "entered": "awsui_entered_1q84n_283yi_231",
    "exiting": "awsui_exiting_1q84n_283yi_336",
    "stack": "awsui_stack_1q84n_283yi_370",
    "animation-running": "awsui_animation-running_1q84n_283yi_370",
    "item": "awsui_item_1q84n_283yi_370",
    "flash-list-item": "awsui_flash-list-item_1q84n_283yi_371",
    "notification-bar": "awsui_notification-bar_1q84n_283yi_372",
    "collapsed": "awsui_collapsed_1q84n_283yi_392",
    "animation-ready": "awsui_animation-ready_1q84n_283yi_392",
    "expanded-only": "awsui_expanded-only_1q84n_283yi_392",
    "expanded": "awsui_expanded_1q84n_283yi_392",
    "flash": "awsui_flash_1q84n_283yi_157",
    "collapsible": "awsui_collapsible_1q84n_283yi_448",
    "short-list": "awsui_short-list_1q84n_283yi_454",
    "visual-refresh": "awsui_visual-refresh_1q84n_283yi_454",
    "status": "awsui_status_1q84n_283yi_601",
    "header": "awsui_header_1q84n_283yi_601",
    "item-count": "awsui_item-count_1q84n_283yi_602",
    "button": "awsui_button_1q84n_283yi_603",
    "type-count": "awsui_type-count_1q84n_283yi_636",
    "count-number": "awsui_count-number_1q84n_283yi_636",
    "icon": "awsui_icon_1q84n_283yi_674",
    "floating": "awsui_floating_1q84n_283yi_715",
    "flashbar": "awsui_flashbar_1q84n_283yi_719",
    "initial-hidden": "awsui_initial-hidden_1q84n_283yi_778",
    "flash-list": "awsui_flash-list_1q84n_283yi_371",
    "flash-focus-container": "awsui_flash-focus-container_1q84n_283yi_802",
    "flash-text": "awsui_flash-text_1q84n_283yi_832",
    "hidden": "awsui_hidden_1q84n_283yi_851",
    "header-replacement": "awsui_header-replacement_1q84n_283yi_856",
    "content-replacement": "awsui_content-replacement_1q84n_283yi_861",
    "dismiss-button": "awsui_dismiss-button_1q84n_283yi_174",
    "action-wrapped": "awsui_action-wrapped_1q84n_283yi_879",
    "action-button": "awsui_action-button_1q84n_283yi_173",
    "action-slot": "awsui_action-slot_1q84n_283yi_886",
    "flash-type-success": "awsui_flash-type-success_1q84n_283yi_890",
    "flash-type-error": "awsui_flash-type-error_1q84n_283yi_894",
    "flash-type-info": "awsui_flash-type-info_1q84n_283yi_898",
    "flash-type-in-progress": "awsui_flash-type-in-progress_1q84n_283yi_899",
    "flash-type-warning": "awsui_flash-type-warning_1q84n_283yi_903"
};


const $7ea138ef7d1e02a7$var$ICON_TYPES = {
    success: 'status-positive',
    warning: 'status-warning',
    info: 'status-info',
    error: 'status-negative',
    'in-progress': 'status-in-progress'
};
const $7ea138ef7d1e02a7$var$useDiscoveredAction = (0, $a773f3a2497f02b1$export$43997369e47eb864)((0, $2ec6e52915a41fcf$export$90753eb139627d74).flashbar.onActionRegistered);
const $7ea138ef7d1e02a7$var$useDiscoveredContent = (0, $4d6f2485768b0179$export$108105bf404ba92b)('flash', (0, $2ec6e52915a41fcf$export$90753eb139627d74).flashContent);
function $7ea138ef7d1e02a7$var$dismissButton(dismissLabel, onDismiss, style, type, ref, id, onDismissed, persistenceConfig) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['dismiss-button-wrapper'],
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: 'dismiss'
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: ref,
        onClick: (event)=>{
            if (onDismiss) onDismiss(event);
            if (onDismissed) onDismissed(id, persistenceConfig);
        },
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['dismiss-button'],
        variant: "flashbar-icon",
        iconName: "close",
        formAction: "none",
        ariaLabel: dismissLabel,
        style: (0, $13b0be2e1fb279db$export$fde468abe546d4b9)(style, type)
    }));
}
const $7ea138ef7d1e02a7$export$2f30217b133cbab5 = (flash)=>{
    if (!flash) return;
    const dismissButton = flash.querySelector(`.${(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['dismiss-button']}`);
    const focusContainer = flash.querySelector(`.${(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-focus-container']}`);
    if (dismissButton) dismissButton.focus();
    else if (focusContainer) focusContainer.focus();
};
function $7ea138ef7d1e02a7$export$c30a2af81d342722(element, itemId) {
    if (!element) return;
    const flashElement = element.querySelector(`[data-itemid="${CSS.escape(itemId)}"]`);
    if (!flashElement) return;
    const focusContainer = flashElement.querySelector(`.${(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-focus-container']}`);
    focusContainer === null || focusContainer === void 0 || focusContainer.focus();
}
const $7ea138ef7d1e02a7$export$d02c4befa38bdff8 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ id: id, header: header, content: content, dismissible: dismissible, dismissLabel: dismissLabel, loading: loading, action: action, buttonText: buttonText, onButtonClick: onButtonClick, onDismiss: onDismiss, className: className, transitionState: transitionState, ariaRole: ariaRole, i18nStrings: i18nStrings, type: type = 'info', analyticsMetadata: analyticsMetadata, style: style, rootRef: rootRef, onDismissed: onDismissed, persistenceConfig: persistenceConfig, ...props }, ref)=>{
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (buttonText && !onButtonClick) (0, $013a2451794a45c0$exports.warnOnce)('Flashbar', `You provided a \`buttonText\` prop without an \`onButtonClick\` handler. This will render a non-interactive action button.`);
        if (dismissible && !onDismiss) (0, $013a2451794a45c0$exports.warnOnce)('Flashbar', `You have set the \`dismissible\` prop without an \`onDismiss\` handler. This will render a non-interactive dismiss button.`);
    }
    const [containerWidth, containerMeasureRef] = (0, $28e2f0577fc47761$export$2e2bcd8739ae039)();
    const elementRef = (0, $013a2451794a45c0$exports.useComponentMetadata)('Flash', (0, $93d122f201f7d1ff$export$4a03ffab3315ee34), analyticsMetadata);
    // Merge all refs including the rootRef if provided
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(ref, rootRef, elementRef, containerMeasureRef);
    const flashIconId = (0, $013a2451794a45c0$exports.useUniqueId)('flash-icon');
    const flashMessageId = (0, $013a2451794a45c0$exports.useUniqueId)('flash-message');
    const headerRefObject = (0, $acw62.useRef)(null);
    const contentRefObject = (0, $acw62.useRef)(null);
    const dismissButtonRefObject = (0, $acw62.useRef)(null);
    const { discoveredActions: discoveredActions, headerRef: headerRefAction, contentRef: contentRefAction } = $7ea138ef7d1e02a7$var$useDiscoveredAction(type);
    const { initialHidden: initialHidden, headerReplacementType: headerReplacementType, contentReplacementType: contentReplacementType, headerRef: headerRefContent, contentRef: contentRefContent, replacementHeaderRef: replacementHeaderRef, replacementContentRef: replacementContentRef } = $7ea138ef7d1e02a7$var$useDiscoveredContent({
        type: type,
        header: header,
        children: content
    });
    const headerRef = (0, $013a2451794a45c0$exports.useMergeRefs)(headerRefAction, headerRefContent, headerRefObject);
    const contentRef = (0, $013a2451794a45c0$exports.useMergeRefs)(contentRefAction, contentRefContent, contentRefObject);
    const statusIconAriaLabel = props.statusIconAriaLabel || (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings[`${loading || type === 'in-progress' ? 'inProgress' : type}IconAriaLabel`]);
    const iconType = $7ea138ef7d1e02a7$var$ICON_TYPES[type];
    const icon = loading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": statusIconAriaLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), null)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconType,
        ariaLabel: statusIconAriaLabel
    });
    const effectiveType = loading ? 'info' : type;
    const analyticsAttributes = {
        [(0, $285a09b860d2bebc$export$5acc5b69fd3e0afc)]: effectiveType
    };
    if (analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.suppressFlowMetricEvents) analyticsAttributes[0, $285a09b860d2bebc$export$62aaf1f56e89d4dc] = 'true';
    return(// We're not using "polite" or "assertive" here, just turning default behavior off.
    // eslint-disable-next-line @cloudscape-design/components/prefer-live-region
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: mergedRef,
        role: ariaRole,
        "aria-live": ariaRole ? 'off' : undefined,
        "data-itemid": id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flash, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)[`flash-type-${effectiveType}`], className, transitionState && {
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).enter]: transitionState === 'enter',
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).entering]: transitionState === 'entering',
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).entered]: transitionState === 'entered',
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).exit]: transitionState === 'exit',
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).exiting]: transitionState === 'exiting',
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).exited]: transitionState === 'exited'
        }, (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)(type === 'warning' && !loading ? 'flashbar-warning' : 'flashbar'), initialHidden && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['initial-hidden']),
        style: (0, $13b0be2e1fb279db$export$d54ee177cd31913a)(style, effectiveType),
        ...analyticsAttributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-body']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-focus-container'],
        tabIndex: -1,
        role: "group",
        "aria-labelledby": `${flashIconId} ${flashMessageId}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-icon'], (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-text']),
        id: flashIconId
    }, icon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-message'], (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-text']),
        id: flashMessageId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-header'], headerReplacementType !== 'original' ? (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).hidden : (0, $1a959aecdb7241ea$export$2e2bcd8739ae039)['flash-header']),
        ref: headerRef
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['header-replacement'], headerReplacementType !== 'replaced' && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).hidden),
        ref: replacementHeaderRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-content'], contentReplacementType !== 'original' ? (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).hidden : (0, $1a959aecdb7241ea$export$2e2bcd8739ae039)['flash-header']),
        ref: contentRef
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['content-replacement'], contentReplacementType !== 'replaced' && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).hidden),
        ref: replacementContentRef
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d276899a8d82cf05$export$c8223871eecc8f3a), {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['action-button-wrapper'],
        testUtilClasses: {
            actionSlot: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['action-slot'],
            actionButton: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['action-button']
        },
        action: action,
        discoveredActions: discoveredActions,
        buttonText: buttonText,
        onButtonClick: onButtonClick,
        containerWidth: containerWidth,
        wrappedClass: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['action-wrapped']
    })), dismissible && $7ea138ef7d1e02a7$var$dismissButton(dismissLabel, onDismiss, style, effectiveType, dismissButtonRefObject, id, onDismissed, persistenceConfig), ariaRole === 'status' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        sources: [
            statusIconAriaLabel,
            headerRefObject,
            contentRefObject
        ]
    })));
});




const $be55b1acbb6c5660$export$8adea4d3f455e263 = (dismissedId, items, refCurrent, flashRefsCurrent)=>{
    var _a;
    if (!items || !dismissedId || !refCurrent) return;
    const dismissedIndex = items.findIndex((item)=>{
        var _a;
        return ((_a = item.id) !== null && _a !== void 0 ? _a : '') === dismissedId;
    });
    if (dismissedIndex === -1) return;
    let nextItemIndex = dismissedIndex + 1;
    if (nextItemIndex >= items.length) nextItemIndex = dismissedIndex - 1;
    // If there's no next item, focus the first instance of the h1 element
    if (nextItemIndex < 0 || nextItemIndex >= items.length) {
        const h1Element = document.querySelector('h1');
        h1Element === null || h1Element === void 0 || h1Element.focus();
        return;
    }
    const nextItemId = (_a = items[nextItemIndex].id) !== null && _a !== void 0 ? _a : nextItemIndex;
    // Try to focus on the next item, but with a small delay to ensure the DOM is updated
    // This is especially important for collapsible flashbars where the next item might become visible
    const attemptFocus = ()=>{
        const nextFlashElement = flashRefsCurrent[nextItemId];
        if (!nextFlashElement) {
            // If the next flash element is not available, it might be because the flashbar is collapsed
            // In that case, try to focus on the notification bar button or the main element
            const notificationBarButton = refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.querySelector(`.${(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).button}`);
            if (notificationBarButton) {
                notificationBarButton.focus();
                return;
            }
            const h1Element = document.querySelector('h1');
            h1Element === null || h1Element === void 0 || h1Element.focus();
            return;
        }
        (0, $7ea138ef7d1e02a7$export$2f30217b133cbab5)(nextFlashElement);
    };
    setTimeout(attemptFocus, 0);
};
function $be55b1acbb6c5660$export$7552e9d189822810({ items: items, onItemsAdded: onItemsAdded, onItemsChanged: onItemsChanged, onItemsRemoved: onItemsRemoved, __internalRootRef: __internalRootRef, ...restProps }) {
    const allItemsHaveId = (0, $acw62.useMemo)(()=>items.every((item)=>'id' in item), [
        items
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const ref = (0, $acw62.useRef)(null);
    const flashRefs = (0, $acw62.useRef)({});
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(ref, __internalRootRef);
    const isReducedMotion = (0, $013a2451794a45c0$exports.useReducedMotion)(ref);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const [previousItems, setPreviousItems] = (0, $acw62.useState)(items);
    const [nextFocusId, setNextFocusId] = (0, $acw62.useState)(null);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (items === null || items === void 0 ? void 0 : items.some((item)=>item.ariaRole === 'alert' && !item.id)) (0, $013a2451794a45c0$exports.warnOnce)('Flashbar', `You provided \`ariaRole="alert"\` for a flashbar item without providing an \`id\`. Focus will not be moved to the newly added flash message.`);
    }
    // Track new or removed item IDs in state to only trigger focus changes for newly added items.
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    if (items) {
        const newItems = items.filter(({ id: id })=>id && !previousItems.some((item)=>item.id === id));
        const removedItems = previousItems.filter(({ id: id })=>id && !items.some((item)=>item.id === id));
        if (newItems.length > 0 || removedItems.length > 0) {
            setPreviousItems(items);
            onItemsAdded === null || onItemsAdded === void 0 || onItemsAdded(newItems);
            onItemsRemoved === null || onItemsRemoved === void 0 || onItemsRemoved(removedItems);
            onItemsChanged === null || onItemsChanged === void 0 || onItemsChanged({
                allItemsHaveId: allItemsHaveId,
                isReducedMotion: isReducedMotion
            });
            const newFocusItems = newItems.filter(({ ariaRole: ariaRole })=>ariaRole === 'alert');
            if (newFocusItems.length > 0) setNextFocusId(newFocusItems[0].id);
        }
    }
    const debouncedFocus = (0, $2f667510820517ed$export$40ae01be0011c1e6)((0, $7ea138ef7d1e02a7$export$c30a2af81d342722), (0, $f3ef1b762a556220$export$44c8f1d8dc8f2bac));
    (0, $acw62.useEffect)(()=>{
        if (nextFocusId) debouncedFocus(ref.current, nextFocusId);
    }, [
        debouncedFocus,
        nextFocusId,
        ref
    ]);
    const handleFlashDismissed = (dismissedId, persistenceConfig)=>{
        $be55b1acbb6c5660$export$8adea4d3f455e263(dismissedId, items, ref.current, flashRefs.current);
        if (persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.uniqueKey) (0, $dca857cabc5bb5b3$export$a93c5fb33d27b888)(persistenceConfig);
    };
    return {
        allItemsHaveId: allItemsHaveId,
        baseProps: baseProps,
        isReducedMotion: isReducedMotion,
        isVisualRefresh: isVisualRefresh,
        mergedRef: mergedRef,
        ref: ref,
        flashRefs: flashRefs,
        handleFlashDismissed: handleFlashDismissed
    };
}
function $be55b1acbb6c5660$export$e763494c23a0a38b(items) {
    const [checkedPersistenceKeys, setCheckedPersistenceKeys] = (0, $acw62.useState)(()=>new Set());
    const [persistentItemsVisibility, setPersistentItemsVisibility] = (0, $acw62.useState)(()=>new Map());
    const visibleItems = items.filter((item)=>{
        var _a;
        return !((_a = item.persistenceConfig) === null || _a === void 0 ? void 0 : _a.uniqueKey) || persistentItemsVisibility.get(item.persistenceConfig.uniqueKey) === true;
    });
    (0, $acw62.useEffect)(()=>{
        const newPersistentItems = items.filter((item)=>{
            var _a;
            return ((_a = item.persistenceConfig) === null || _a === void 0 ? void 0 : _a.uniqueKey) && !checkedPersistenceKeys.has(item.persistenceConfig.uniqueKey);
        });
        if (newPersistentItems.length === 0) return;
        let isMounted = true;
        const checkNewPersistentItems = async ()=>{
            try {
                const results = await Promise.all(newPersistentItems.map(async (item)=>{
                    try {
                        const isDismissed = await (0, $dca857cabc5bb5b3$export$ee01cd86db6e8e2a)(item.persistenceConfig);
                        return {
                            key: item.persistenceConfig.uniqueKey,
                            visible: !isDismissed
                        };
                    } catch  {
                        return {
                            key: item.persistenceConfig.uniqueKey,
                            visible: true
                        };
                    }
                }));
                if (!isMounted) return;
                setPersistentItemsVisibility((prev)=>{
                    const updated = new Map(prev);
                    results.forEach(({ key: key, visible: visible })=>updated.set(key, visible));
                    return updated;
                });
                setCheckedPersistenceKeys((prev)=>{
                    const updated = new Set(prev);
                    results.forEach(({ key: key })=>updated.add(key));
                    return updated;
                });
            } catch  {
                if (!isMounted) return;
                // Fallback if Promise.all itself fails, set all newPersistentItems to visible
                setPersistentItemsVisibility((prev)=>{
                    const updated = new Map(prev);
                    newPersistentItems.forEach((item)=>updated.set(item.persistenceConfig.uniqueKey, true));
                    return updated;
                });
            }
        };
        checkNewPersistentItems();
        return ()=>{
            isMounted = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items
    ]);
    return visibleItems;
}






// If the number of items is equal or less than this value,
// the toggle element will not be displayed and the Flashbar will look like a regular single-item Flashbar.
const $6c57dec6dcc18848$var$maxNonCollapsibleItems = 1;
const $6c57dec6dcc18848$var$resizeListenerThrottleDelay = 100;
function $6c57dec6dcc18848$export$2e2bcd8739ae039({ items: items, style: style, ...restProps }) {
    const visibleItems = (0, $be55b1acbb6c5660$export$e763494c23a0a38b)(items);
    const [enteringItems, setEnteringItems] = (0, $acw62.useState)([]);
    const [exitingItems, setExitingItems] = (0, $acw62.useState)([]);
    const [isFlashbarStackExpanded, setIsFlashbarStackExpanded] = (0, $acw62.useState)(false);
    const getElementsToAnimate = (0, $acw62.useCallback)(()=>{
        const flashElements = isFlashbarStackExpanded ? expandedItemRefs.current : collapsedItemRefs.current;
        return {
            ...flashElements,
            notificationBar: notificationBarRef.current
        };
    }, [
        isFlashbarStackExpanded
    ]);
    const prepareAnimations = (0, $acw62.useCallback)(()=>{
        const rects = (0, $3598f7c3986914de$export$2c8afa89e423ed39)(getElementsToAnimate());
        setInitialAnimationState(rects);
    }, [
        getElementsToAnimate
    ]);
    const collapsedItemRefs = (0, $acw62.useRef)({});
    const expandedItemRefs = (0, $acw62.useRef)({});
    const [initialAnimationState, setInitialAnimationState] = (0, $acw62.useState)(null);
    const listElementRef = (0, $acw62.useRef)(null);
    const notificationBarRef = (0, $acw62.useRef)(null);
    const [transitioning, setTransitioning] = (0, $acw62.useState)(false);
    const flashbarElementId = (0, $013a2451794a45c0$exports.useUniqueId)('flashbar');
    const itemCountElementId = (0, $013a2451794a45c0$exports.useUniqueId)('item-count');
    const { baseProps: baseProps, isReducedMotion: isReducedMotion, isVisualRefresh: isVisualRefresh, mergedRef: mergedRef, ref: ref, flashRefs: flashRefs, handleFlashDismissed: handleFlashDismissed } = (0, $be55b1acbb6c5660$export$7552e9d189822810)({
        items: visibleItems,
        ...restProps,
        onItemsAdded: (newItems)=>{
            setEnteringItems([
                ...enteringItems,
                ...newItems
            ]);
        },
        onItemsChanged: (options)=>{
            // If not all items have ID, we can still animate collapse/expand transitions
            // because we can rely on each item's index in the original array,
            // but we can't do that when elements are added or removed, since the index changes.
            if ((options === null || options === void 0 ? void 0 : options.allItemsHaveId) && !(options === null || options === void 0 ? void 0 : options.isReducedMotion)) prepareAnimations();
        },
        onItemsRemoved: (removedItems)=>{
            setExitingItems([
                ...exitingItems,
                ...removedItems
            ]);
        }
    });
    if (visibleItems.length <= $6c57dec6dcc18848$var$maxNonCollapsibleItems && isFlashbarStackExpanded) setIsFlashbarStackExpanded(false);
    const animateFlash = !isReducedMotion;
    function toggleCollapseExpand() {
        if (!isReducedMotion) prepareAnimations();
        setIsFlashbarStackExpanded((prev)=>!prev);
    }
    const debouncedFocus = (0, $2f667510820517ed$export$40ae01be0011c1e6)((0, $7ea138ef7d1e02a7$export$c30a2af81d342722), (0, $f3ef1b762a556220$export$44c8f1d8dc8f2bac));
    (0, $acw62.useLayoutEffect)(()=>{
        if (isFlashbarStackExpanded && (visibleItems === null || visibleItems === void 0 ? void 0 : visibleItems.length)) {
            const mostRecentItem = visibleItems[0];
            if (mostRecentItem.id !== undefined) debouncedFocus(ref.current, mostRecentItem.id);
        }
    // Run this after expanding, but not every time the items change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedFocus,
        isFlashbarStackExpanded
    ]);
    // When collapsing, scroll up if necessary to avoid losing track of the focused button
    (0, $5f60cc888539a35b$export$21dfe79102a9caab)(()=>{
        if (!isFlashbarStackExpanded && notificationBarRef.current) (0, $24d40242cc6554ee$export$a904af9c1628c179)(notificationBarRef.current);
    }, [
        isFlashbarStackExpanded
    ]);
    const updateBottomSpacing = (0, $5e5497af6e342378$export$43f0d02427e1c683)(()=>{
        // Allow vertical space between Flashbar and page bottom only when the Flashbar is reaching the end of the page,
        // otherwise avoid spacing with eventual sticky elements below.
        const listElement = listElementRef === null || listElementRef === void 0 ? void 0 : listElementRef.current;
        const flashbar = listElement === null || listElement === void 0 ? void 0 : listElement.parentElement;
        if (listElement && flashbar) {
            // Make sure the bottom padding is present when we make the calculations,
            // then we might decide to remove it or not.
            flashbar.classList.remove((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).floating);
            const windowHeight = window.innerHeight;
            // Take the parent region into account if using the App Layout, because it might have additional margins.
            // Otherwise we use the Flashbar component for this calculation.
            const outerElement = (0, $1yiQH.findUpUntil)(flashbar, (element)=>element.getAttribute('role') === 'region') || flashbar;
            const applySpacing = isFlashbarStackExpanded && Math.ceil(outerElement.getBoundingClientRect().bottom) >= windowHeight;
            if (!applySpacing) flashbar.classList.add((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).floating);
        }
    }, $6c57dec6dcc18848$var$resizeListenerThrottleDelay, [
        isFlashbarStackExpanded
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        window.addEventListener('resize', updateBottomSpacing);
        return ()=>{
            window.removeEventListener('resize', updateBottomSpacing);
            updateBottomSpacing.cancel();
        };
    }, [
        updateBottomSpacing
    ]);
    const { i18nStrings: i18nStrings } = restProps;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('flashbar');
    const ariaLabel = i18n('i18nStrings.ariaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.ariaLabel);
    const notificationBarText = i18n('i18nStrings.notificationBarText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.notificationBarText);
    const notificationBarAriaLabel = i18n('i18nStrings.notificationBarAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.notificationBarAriaLabel);
    const iconAriaLabels = {
        errorIconAriaLabel: i18n('i18nStrings.errorIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel),
        inProgressIconAriaLabel: i18n('i18nStrings.inProgressIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.inProgressIconAriaLabel),
        infoIconAriaLabel: i18n('i18nStrings.infoIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.infoIconAriaLabel),
        successIconAriaLabel: i18n('i18nStrings.successIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.successIconAriaLabel),
        warningIconAriaLabel: i18n('i18nStrings.warningIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel)
    };
    (0, $acw62.useLayoutEffect)(()=>{
        // When `useLayoutEffect` is called, the DOM is updated but has not been painted yet,
        // so it's a good moment to trigger animations that will make calculations based on old and new DOM state.
        // The old state is kept in `initialAnimationState`
        // and the new state can be retrieved from the current DOM elements.
        if (initialAnimationState) {
            updateBottomSpacing();
            (0, $3598f7c3986914de$export$e3607ec2d7a891c4)({
                elements: getElementsToAnimate(),
                oldState: initialAnimationState,
                newElementInitialState: ({ top: top })=>({
                        scale: 0.9,
                        y: -0.2 * top
                    }),
                onTransitionsEnd: ()=>setTransitioning(false)
            });
            setTransitioning(true);
            setInitialAnimationState(null);
        }
    }, [
        updateBottomSpacing,
        getElementsToAnimate,
        initialAnimationState,
        isFlashbarStackExpanded
    ]);
    const isCollapsible = visibleItems.length > $6c57dec6dcc18848$var$maxNonCollapsibleItems;
    const countByType = (0, $f3ef1b762a556220$export$bc904e7e06b11e99)(visibleItems);
    const numberOfColorsInStack = new Set(visibleItems.map((0, $f3ef1b762a556220$export$5bbd879b67a2454e))).size;
    const maxSlots = Math.max(numberOfColorsInStack, 3);
    const stackDepth = Math.min(maxSlots, visibleItems.length);
    const itemsToShow = isFlashbarStackExpanded ? visibleItems.map((item, index)=>({
            ...item,
            expandedIndex: index
        })) : (0, $f3ef1b762a556220$export$46bbf6b048090d82)(visibleItems, stackDepth).map((item, index)=>({
            ...item,
            collapsedIndex: index
        }));
    const getItemId = (item)=>{
        var _a, _b;
        return (_b = (_a = item.id) !== null && _a !== void 0 ? _a : item.expandedIndex) !== null && _b !== void 0 ? _b : 0;
    };
    // This check allows us to use the standard "enter" Transition only when the notification was not existing before.
    // If instead it was moved to the top of the stack but was already present in the array
    // (e.g, after dismissing another notification),
    // we need to use different, more custom and more controlled animations.
    const hasEntered = (item)=>enteringItems.some((_item)=>_item.id && _item.id === item.id);
    const hasLeft = (item)=>!('expandedIndex' in item);
    const hasEnteredOrLeft = (item)=>hasEntered(item) || hasLeft(item);
    const showInnerContent = (item)=>isFlashbarStackExpanded || hasLeft(item) || 'expandedIndex' in item && item.expandedIndex === 0;
    const shouldUseStandardAnimation = (item, index)=>index === 0 && hasEnteredOrLeft(item);
    const getAnimationElementId = (item)=>`flash-${getItemId(item)}`;
    const renderList = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            ref: listElementRef,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-list'], isFlashbarStackExpanded ? (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded : (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).collapsed, transitioning && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['animation-running'], initialAnimationState && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['animation-ready'], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['visual-refresh']),
            id: flashbarElementId,
            "aria-label": ariaLabel,
            "aria-describedby": isCollapsible ? itemCountElementId : undefined,
            style: !isFlashbarStackExpanded || transitioning ? {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).flashbarStackDepth]: stackDepth
            } : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6c57dec6dcc18848$var$ListWrapper, {
            withMotion: !isReducedMotion
        }, itemsToShow.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
                key: getItemId(item),
                in: !hasLeft(item),
                onStatusChange: (status)=>{
                    if (status === 'entered') setEnteringItems([]);
                    else if (status === 'exited') setExitingItems([]);
                }
            }, (state, transitionRootElement)=>{
                var _a, _b, _c;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    "aria-hidden": !showInnerContent(item),
                    className: showInnerContent(item) ? (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-list-item'], !isFlashbarStackExpanded && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).item, !collapsedItemRefs.current[getAnimationElementId(item)] && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['expanded-only']) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flash, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)[`flash-type-${(_a = item.type) !== null && _a !== void 0 ? _a : 'info'}`], (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).item),
                    ref: (element)=>{
                        if (isFlashbarStackExpanded) expandedItemRefs.current[getAnimationElementId(item)] = element;
                        else collapsedItemRefs.current[getAnimationElementId(item)] = element;
                    },
                    style: {
                        ...index > 0 && !isFlashbarStackExpanded && (0, $13b0be2e1fb279db$export$725491c3104a6274)(style, item.type),
                        ...(!isFlashbarStackExpanded || transitioning) && {
                            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).flashbarStackIndex]: (_c = (_b = item.collapsedIndex) !== null && _b !== void 0 ? _b : item.expandedIndex) !== null && _c !== void 0 ? _c : index
                        }
                    },
                    key: getItemId(item),
                    ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)((0, $7b53e52459b13a81$export$4e4df58d95018800)(index + 1, item.type || 'info', item.id))
                }, showInnerContent(item) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ea138ef7d1e02a7$export$d02c4befa38bdff8), {
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(animateFlash && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-with-motion'], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-refresh']),
                    key: getItemId(item),
                    ref: (el)=>{
                        // Store the Flash element reference for focus management
                        flashRefs.current[getItemId(item)] = el;
                        if (shouldUseStandardAnimation(item, index) && transitionRootElement) {
                            if (typeof transitionRootElement === 'function') transitionRootElement(el);
                            else if (transitionRootElement && typeof transitionRootElement === 'object' && 'current' in transitionRootElement) transitionRootElement.current = el;
                        }
                    },
                    transitionState: shouldUseStandardAnimation(item, index) ? state : undefined,
                    i18nStrings: iconAriaLabels,
                    style: style,
                    onDismissed: handleFlashDismissed,
                    ...item
                }));
            }))));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flashbar, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).stack, isCollapsible && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).collapsible, visibleItems.length === 2 && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['short-list'], isFlashbarStackExpanded && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded, isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['visual-refresh']),
        ref: mergedRef,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)((0, $7b53e52459b13a81$export$d337fc1999ef7dec)(visibleItems.length, true, isFlashbarStackExpanded))
    }, isFlashbarStackExpanded && renderList(), isCollapsible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['notification-bar'], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['visual-refresh'], isFlashbarStackExpanded ? (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded : (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).collapsed, transitioning && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['animation-running'], visibleItems.length === 2 && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['short-list'], (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)('flashbar') // Visual context is needed for focus ring to be white
        ),
        onClick: toggleCollapseExpand,
        ref: notificationBarRef,
        style: (0, $13b0be2e1fb279db$export$7505a75c3c76ded4)(style),
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: !isFlashbarStackExpanded ? 'expand' : 'collapse',
            detail: {
                label: 'h2'
            }
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).status,
        role: "status",
        id: itemCountElementId
    }, notificationBarText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).header
    }, notificationBarText), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['item-count']
    }, (0, $f3ef1b762a556220$export$7256f2f4a100fd7).map(({ type: type, labelName: labelName, iconName: iconName })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6c57dec6dcc18848$var$NotificationTypeCount, {
            key: type,
            iconName: iconName,
            label: iconAriaLabels[labelName],
            count: countByType[type]
        })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-controls": flashbarElementId,
        "aria-describedby": itemCountElementId,
        "aria-expanded": isFlashbarStackExpanded,
        "aria-label": notificationBarAriaLabel,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).button, isFlashbarStackExpanded && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).icon,
        size: "normal",
        name: "angle-down"
    }))), !isFlashbarStackExpanded && renderList());
}
const $6c57dec6dcc18848$var$NotificationTypeCount = ({ iconName: iconName, label: label, count: count })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['type-count']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: label
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconName,
        ariaLabel: label
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['count-number']
    }, count));
};
const $6c57dec6dcc18848$var$ListWrapper = ({ children: children, withMotion: withMotion })=>withMotion ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6bd2d3fc5aa42c33$export$2e2bcd8739ae039), {
        component: null
    }, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This is a delay that delays the `entering` transition state
 * for the flashbar to be executed, this is useful for:
 * - If a flashbar is exiting and another is entering at the same time we'd want to delay the entering to
 * prevent the jumping in the layout
 * The current animation time for the exiting can be found in motion.scss which is equivilant to 115ms,
 * if in the future this value is changed for the exiting animation we'll have to change this as well to match it
 */ const $5d1964865bfeee82$export$a1a178fbad7f15f6 = 115;




function $1928fa3d1e93457e$export$2e2bcd8739ae039({ items: items, i18nStrings: i18nStrings, style: style, ...restProps }) {
    const visibleItems = (0, $be55b1acbb6c5660$export$e763494c23a0a38b)(items);
    const { allItemsHaveId: allItemsHaveId, baseProps: baseProps, isReducedMotion: isReducedMotion, isVisualRefresh: isVisualRefresh, mergedRef: mergedRef, flashRefs: flashRefs, handleFlashDismissed: handleFlashDismissed } = (0, $be55b1acbb6c5660$export$7552e9d189822810)({
        items: visibleItems,
        ...restProps
    });
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('flashbar');
    const ariaLabel = i18n('i18nStrings.ariaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.ariaLabel);
    const iconAriaLabels = {
        errorIconAriaLabel: i18n('i18nStrings.errorIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel),
        inProgressIconAriaLabel: i18n('i18nStrings.inProgressIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.inProgressIconAriaLabel),
        infoIconAriaLabel: i18n('i18nStrings.infoIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.infoIconAriaLabel),
        successIconAriaLabel: i18n('i18nStrings.successIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.successIconAriaLabel),
        warningIconAriaLabel: i18n('i18nStrings.warningIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel)
    };
    /**
     * All the flash items should have ids so we can identify which DOM element is being
     * removed from the DOM to animate it. Motion will be disabled if any of the provided
     * flash messages does not contain an `id`.
     */ const motionDisabled = isReducedMotion || !isVisualRefresh || !allItemsHaveId;
    const animateFlash = !isReducedMotion && isVisualRefresh;
    /**
     * If the flashbar is flat and motion is `enabled` then the adding and removing of items
     * from the flashbar will render with visual transitions.
     */ function renderFlatItemsWithTransitions() {
        if (motionDisabled || !visibleItems) return;
        return(// This is a proxy for <ul>, so we're not applying a class to another actual component.
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6bd2d3fc5aa42c33$export$2e2bcd8739ae039), {
            component: "ul",
            className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-list'],
            "aria-label": ariaLabel
        }, visibleItems.map((item, index)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
                transitionChangeDelay: {
                    entering: (0, $5d1964865bfeee82$export$a1a178fbad7f15f6)
                },
                key: (_a = item.id) !== null && _a !== void 0 ? _a : index,
                in: true
            }, (state, transitionRootElement)=>{
                var _a;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-list-item']
                }, renderItem(item, (_a = item.id) !== null && _a !== void 0 ? _a : index, transitionRootElement, state));
            });
        })));
    }
    /**
     * If the flashbar is flat and motion is `disabled` then the adding and removing of items
     * from the flashbar will render without visual transitions.
     */ function renderFlatItemsWithoutTransitions() {
        if (!motionDisabled || !visibleItems) return;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-list'],
            "aria-label": ariaLabel,
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)((0, $7b53e52459b13a81$export$d337fc1999ef7dec)(visibleItems.length, false))
        }, visibleItems.map((item, index)=>{
            var _a, _b;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: (_a = item.id) !== null && _a !== void 0 ? _a : index,
                className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-list-item'],
                ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)((0, $7b53e52459b13a81$export$4e4df58d95018800)(index + 1, item.type || 'info', item.id))
            }, renderItem(item, (_b = item.id) !== null && _b !== void 0 ? _b : index));
        }));
    }
    /**
     * This is a shared render function for a single flashbar item to be used
     * by the stacking, motion, and non-motion item group render functions.
     */ function renderItem(item, key, transitionRootElement, transitionState) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ea138ef7d1e02a7$export$d02c4befa38bdff8), {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(animateFlash && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-with-motion'], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)['flash-refresh']),
            key: key,
            ref: (el)=>{
                flashRefs.current[key] = el;
                // If there's a transition root element ref, update it too
                if (transitionRootElement && typeof transitionRootElement === 'function') transitionRootElement(el);
                else if (transitionRootElement && typeof transitionRootElement === 'object' && 'current' in transitionRootElement) transitionRootElement.current = el;
            },
            transitionState: transitionState,
            i18nStrings: iconAriaLabels,
            style: style,
            onDismissed: handleFlashDismissed,
            ...item
        });
    }
    // The handleFlashDismissed function is now provided by the useFlashbar hook
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flashbar),
        ref: mergedRef
    }, renderFlatItemsWithTransitions(), renderFlatItemsWithoutTransitions());
}


function $1d901483503cffbd$export$a924d0037b2461fd(props) {
    if (props.stackItems) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6c57dec6dcc18848$export$2e2bcd8739ae039), {
        ...props
    });
    else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1928fa3d1e93457e$export$2e2bcd8739ae039), {
        ...props
    });
}
const $1d901483503cffbd$export$199b37530a8ceac7 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($1d901483503cffbd$export$a924d0037b2461fd);


const $5044463d48144792$export$21b6e08cad7a37a3 = (0, $1d901483503cffbd$export$199b37530a8ceac7)();


'use client';
function $295a537205c57cb7$export$2e2bcd8739ae039(props) {
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Flashbar', {
        props: {
            stackItems: props.stackItems
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5044463d48144792$export$21b6e08cad7a37a3), {
        __internalRootRef: __internalRootRef,
        ...props
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($295a537205c57cb7$export$2e2bcd8739ae039, 'Flashbar');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $acw62 = parcelRequire("acw62");



var $8eaf58dc26b3be4b$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(node, c);
    });
};
var $8eaf58dc26b3be4b$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $8eaf58dc26b3be4b$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $5eeab8444420e62b$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $8eaf58dc26b3be4b$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $8eaf58dc26b3be4b$var$removeClass(node, baseClassName);
        if (activeClassName) $8eaf58dc26b3be4b$var$removeClass(node, activeClassName);
        if (doneClassName) $8eaf58dc26b3be4b$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d520d6858ebc9b9$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$8eaf58dc26b3be4b$var$CSSTransition.defaultProps = {
    classNames: ''
};
$8eaf58dc26b3be4b$var$CSSTransition.propTypes = {};
var $8eaf58dc26b3be4b$export$2e2bcd8739ae039 = $8eaf58dc26b3be4b$var$CSSTransition;





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3f049698d9cc843b$export$7527db17211c2842 = 'awsui-screenreader-text';
function $3f049698d9cc843b$export$2e2bcd8739ae039(element) {
    const elementsWithText = Array.from(element.querySelectorAll(`.${$3f049698d9cc843b$export$7527db17211c2842}`));
    return elementsWithText.map((element)=>{
        var _a;
        if (element instanceof HTMLElement) return (_a = element.innerText) === null || _a === void 0 ? void 0 : _a.split('\n').map((s)=>s.trim()).join(' ').trim();
    }).filter(Boolean).join(', ');
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $ae03e50ad9979830$var$ContainerHeaderContext = (0, $acw62.createContext)({
    isInContainer: false
});
const $ae03e50ad9979830$export$6a1f6653605d906d = ({ children: children })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ae03e50ad9979830$var$ContainerHeaderContext.Provider, {
        value: {
            isInContainer: true
        }
    }, children);
};
const $ae03e50ad9979830$export$a1df13ec57f8d1e3 = ()=>{
    const { isInContainer: isInContainer } = (0, $acw62.useContext)($ae03e50ad9979830$var$ContainerHeaderContext);
    return isInContainer;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $27065251b9f952cf$export$7ad1eab6c2e3d0fe(style) {
    var _a, _b, _c, _d, _e;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return {};
    return {
        background: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.background,
        borderColor: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderColor,
        borderRadius: (_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.borderRadius,
        borderWidth: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.borderWidth,
        boxShadow: (_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.boxShadow
    };
}
function $27065251b9f952cf$export$14bc84780246832b(style) {
    var _a, _b;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return {};
    return {
        paddingBlock: (_a = style === null || style === void 0 ? void 0 : style.content) === null || _a === void 0 ? void 0 : _a.paddingBlock,
        paddingInline: (_b = style === null || style === void 0 ? void 0 : style.content) === null || _b === void 0 ? void 0 : _b.paddingInline
    };
}
function $27065251b9f952cf$export$787d20557dd87cd(style) {
    var _a, _b, _c, _d;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return {};
    return {
        ...((_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.background) && {
            background: 'transparent'
        },
        borderRadius: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderRadius,
        paddingBlock: (_c = style === null || style === void 0 ? void 0 : style.header) === null || _c === void 0 ? void 0 : _c.paddingBlock,
        paddingInline: (_d = style === null || style === void 0 ? void 0 : style.header) === null || _d === void 0 ? void 0 : _d.paddingInline
    };
}
function $27065251b9f952cf$export$cb72cd9798e915d8(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return {};
    return {
        borderColor: (_b = (_a = style === null || style === void 0 ? void 0 : style.footer) === null || _a === void 0 ? void 0 : _a.divider) === null || _b === void 0 ? void 0 : _b.borderColor,
        borderWidth: (_d = (_c = style === null || style === void 0 ? void 0 : style.footer) === null || _c === void 0 ? void 0 : _c.divider) === null || _d === void 0 ? void 0 : _d.borderWidth,
        paddingBlock: (_f = (_e = style === null || style === void 0 ? void 0 : style.footer) === null || _e === void 0 ? void 0 : _e.root) === null || _f === void 0 ? void 0 : _f.paddingBlock,
        paddingInline: (_h = (_g = style === null || style === void 0 ? void 0 : style.footer) === null || _g === void 0 ? void 0 : _g.root) === null || _h === void 0 ? void 0 : _h.paddingInline
    };
}
function $27065251b9f952cf$export$398c761b68cf7d00(mediaPosition, style) {
    var _a;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return {};
    return {
        borderRadius: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.borderRadius,
        ...mediaPosition === 'top' && {
            borderEndStartRadius: '0px',
            borderEndEndRadius: '0px'
        },
        ...mediaPosition === 'side' && {
            borderStartEndRadius: '0px',
            borderEndEndRadius: '0px'
        }
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $1yiQH = parcelRequire("1yiQH");




function $6ffd179a45e998fe$export$e9684832087ed7c6({ isMobile: isMobile, __stickyOffset: __stickyOffset, __mobileStickyOffset: __mobileStickyOffset, hasInnerOverflowParents: hasInnerOverflowParents, __additionalOffset: __additionalOffset }) {
    const localOffset = isMobile ? (__stickyOffset !== null && __stickyOffset !== void 0 ? __stickyOffset : 0) - (__mobileStickyOffset !== null && __mobileStickyOffset !== void 0 ? __mobileStickyOffset : 0) : __stickyOffset !== null && __stickyOffset !== void 0 ? __stickyOffset : 0;
    if (hasInnerOverflowParents || __stickyOffset !== undefined) return `${localOffset}px`;
    const globalOffset = `var(${(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset}, 0px)`;
    return `calc(${globalOffset} + ${localOffset}px + ${__additionalOffset ? $17a6dd8285442c36$export$3af9271f55a32e1a : '0px'})`;
}
const $6ffd179a45e998fe$export$277266c55937e104 = (0, $acw62.createContext)({
    isStuck: false,
    isStuckAtBottom: false
});
const $6ffd179a45e998fe$export$3a5ae2edeb8648ad = (rootRef, headerRef, __stickyHeader, __stickyOffset, __mobileStickyOffset, __disableMobile, __additionalOffset = false)=>{
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const disableSticky = isMobile && __disableMobile;
    const isSticky = !disableSticky && !!__stickyHeader;
    // If it has overflow parents inside the app layout, we shouldn't apply a sticky offset.
    const [hasInnerOverflowParents, setHasInnerOverflowParents] = (0, $acw62.useState)(false);
    const [isStuck, setIsStuck] = (0, $acw62.useState)(false);
    const [isStuckAtBottom, setIsStuckAtBottom] = (0, $acw62.useState)(false);
    (0, $acw62.useLayoutEffect)(()=>{
        if (rootRef.current) {
            const overflowParents = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(rootRef.current);
            const mainElement = (0, $1yiQH.findUpUntil)(rootRef.current, (elem)=>elem.tagName === 'MAIN');
            // In both versions of the app layout, the scrolling element for disableBodyScroll
            // is the <main>. If the closest overflow parent is also the closest <main> and we have
            // offset values, it's safe to assume that it's the app layout scroll root and we
            // should stop there.
            setHasInnerOverflowParents(overflowParents.length > 0 && overflowParents[0] !== mainElement);
        }
    }, [
        rootRef
    ]);
    const computedOffset = $6ffd179a45e998fe$export$e9684832087ed7c6({
        isMobile: isMobile,
        __stickyOffset: __stickyOffset,
        __mobileStickyOffset: __mobileStickyOffset,
        hasInnerOverflowParents: hasInnerOverflowParents,
        __additionalOffset: __additionalOffset
    });
    const stickyStyles = isSticky ? {
        style: {
            top: computedOffset
        }
    } : {};
    // "stuck" state, when the header has moved from its original posititon has a
    // box-shadow, applied here by a "header-stuck" className
    const checkIfStuck = (0, $acw62.useCallback)(({ isTrusted: isTrusted, target: target, type: type })=>{
        if (type === 'resize' && target === window && !isTrusted) // The window size didn't actually change, it was a synthetic event
        return;
        if (rootRef.current && headerRef.current) {
            const rootTopBorderWidth = parseFloat(getComputedStyle(rootRef.current).borderTopWidth) || 0;
            // Using Math.round to adjust for rounding errors in floating-point arithmetic and timing issues
            const rootTop = Math.round(rootRef.current.getBoundingClientRect().top + rootTopBorderWidth);
            const headerTop = Math.round(headerRef.current.getBoundingClientRect().top);
            if (rootTop < headerTop) setIsStuck(true);
            else setIsStuck(false);
            const rootBottom = Math.round(rootRef.current.getBoundingClientRect().bottom - rootTopBorderWidth);
            const headerBottom = Math.round(headerRef.current.getBoundingClientRect().bottom);
            if (rootBottom <= headerBottom) setIsStuckAtBottom(true);
            else setIsStuckAtBottom(false);
        }
    }, [
        rootRef,
        headerRef
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isSticky) {
            const controller = new AbortController();
            window.addEventListener('scroll', checkIfStuck, {
                capture: true,
                signal: controller.signal
            });
            window.addEventListener('resize', checkIfStuck, {
                signal: controller.signal
            });
            return ()=>{
                controller.abort();
            };
        }
    }, [
        isSticky,
        checkIfStuck
    ]);
    return {
        isSticky: isSticky,
        isStuck: isStuck,
        isStuckAtBottom: isStuckAtBottom,
        stickyStyles: stickyStyles
    };
};



var $5446dda083eafd32$export$2e2bcd8739ae039 = {
    "header": "awsui_header_164jl_1ns0c_5"
};



var $a1d2e03e856f50ac$export$2e2bcd8739ae039 = {
    "root": "awsui_root_14iqq_1vhb3_189",
    "fit-height": "awsui_fit-height_14iqq_1vhb3_222",
    "with-side-media": "awsui_with-side-media_14iqq_1vhb3_227",
    "variant-default": "awsui_variant-default_14iqq_1vhb3_230",
    "variant-stacked": "awsui_variant-stacked_14iqq_1vhb3_230",
    "refresh": "awsui_refresh_14iqq_1vhb3_238",
    "sticky-enabled": "awsui_sticky-enabled_14iqq_1vhb3_288",
    "with-stuck-sticky-header-at-bottom": "awsui_with-stuck-sticky-header-at-bottom_14iqq_1vhb3_294",
    "with-top-media": "awsui_with-top-media_14iqq_1vhb3_304",
    "content-wrapper": "awsui_content-wrapper_14iqq_1vhb3_309",
    "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_1vhb3_314",
    "media": "awsui_media_14iqq_1vhb3_321",
    "media-top": "awsui_media-top_14iqq_1vhb3_339",
    "media-side": "awsui_media-side_14iqq_1vhb3_344",
    "header": "awsui_header_14iqq_1vhb3_350",
    "header-full-page": "awsui_header-full-page_14iqq_1vhb3_355",
    "header-variant-embedded": "awsui_header-variant-embedded_14iqq_1vhb3_358",
    "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1vhb3_358",
    "header-with-media": "awsui_header-with-media_14iqq_1vhb3_361",
    "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1vhb3_367",
    "header-stuck": "awsui_header-stuck_14iqq_1vhb3_377",
    "header-variant-cards": "awsui_header-variant-cards_14iqq_1vhb3_387",
    "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1vhb3_390",
    "with-paddings": "awsui_with-paddings_14iqq_1vhb3_396",
    "with-hidden-content": "awsui_with-hidden-content_14iqq_1vhb3_405",
    "header-variant-full-page": "awsui_header-variant-full-page_14iqq_1vhb3_463",
    "header-cover": "awsui_header-cover_14iqq_1vhb3_466",
    "content": "awsui_content_14iqq_1vhb3_309",
    "content-fit-height": "awsui_content-fit-height_14iqq_1vhb3_494",
    "content-inner": "awsui_content-inner_14iqq_1vhb3_500",
    "with-header": "awsui_with-header_14iqq_1vhb3_507",
    "footer": "awsui_footer_14iqq_1vhb3_511",
    "with-divider": "awsui_with-divider_14iqq_1vhb3_515"
};



var $f115ae42aa2c9b21$export$2e2bcd8739ae039 = {
    "content-inner": "awsui_content-inner_1mwlm_oyjaq_5"
};


function $cc8a25d23ca8ebd0$export$79c16a58b85ba6af(props) {
    const { subStepRef: subStepRef, funnelSubStepProps: funnelSubStepProps } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const modalContext = (0, $584c4a19f0ba0537$export$4cc1699d46f42cae)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cc8a25d23ca8ebd0$export$2e2bcd8739ae039, {
        ...props,
        __subStepRef: (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isInModal) ? {
            current: null
        } : subStepRef,
        __funnelSubStepProps: (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isInModal) ? {} : funnelSubStepProps
    });
}
function $cc8a25d23ca8ebd0$export$2e2bcd8739ae039({ header: header, footer: footer, children: children, variant: variant = 'default', disableHeaderPaddings: disableHeaderPaddings = false, disableContentPaddings: disableContentPaddings = false, disableFooterPaddings: disableFooterPaddings = false, fitHeight: fitHeight, media: media, style: style, __stickyOffset: __stickyOffset, __mobileStickyOffset: __mobileStickyOffset, __stickyHeader: __stickyHeader = false, __internalRootRef: __internalRootRef, __disableFooterDivider: __disableFooterDivider = false, __hiddenContent: __hiddenContent = false, __headerRef: __headerRef, __fullPage: __fullPage = false, __disableStickyMobile: __disableStickyMobile = true, __funnelSubStepProps: __funnelSubStepProps, __subStepRef: __subStepRef, __contentKey: __contentKey, ...restProps }) {
    var _a;
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const rootRef = (0, $acw62.useRef)(null);
    const headerRef = (0, $acw62.useRef)(null);
    const { isSticky: isSticky, isStuck: isStuck, isStuckAtBottom: isStuckAtBottom, stickyStyles: stickyStyles } = (0, $6ffd179a45e998fe$export$3a5ae2edeb8648ad)(rootRef, headerRef, __stickyHeader, __stickyOffset, __mobileStickyOffset, __disableStickyMobile, __fullPage && isRefresh && !isMobile);
    const contentId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const hasDynamicHeight = isRefresh && variant === 'full-page';
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(rootRef, __internalRootRef);
    const headerMergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(headerRef, __headerRef);
    // The container is only sticky on mobile if it is the header for the table.
    // In this case we don't want the container to have sticky styles, as only the table header row will show as stuck on scroll.
    const shouldHaveStickyStyles = isSticky && !isMobile;
    const hasMedia = !!(media === null || media === void 0 ? void 0 : media.content);
    const mediaPosition = (_a = media === null || media === void 0 ? void 0 : media.position) !== null && _a !== void 0 ? _a : 'top';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ...__funnelSubStepProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).root, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)[`variant-${variant}`], fitHeight && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['fit-height'], hasMedia && (mediaPosition === 'side' ? (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-side-media'] : (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-top-media']), shouldHaveStickyStyles && [
            (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['sticky-enabled']
        ], shouldHaveStickyStyles && isStuck && isStuckAtBottom && [
            (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-stuck-sticky-header-at-bottom']
        ], isRefresh && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).refresh),
        ref: mergedRef,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsLabelAttribute)(`.${(0, $5446dda083eafd32$export$2e2bcd8739ae039).header} h1, .${(0, $5446dda083eafd32$export$2e2bcd8739ae039).header} h2, .${(0, $5446dda083eafd32$export$2e2bcd8739ae039).header} h3`),
        style: (0, $27065251b9f952cf$export$7ad1eab6c2e3d0fe)(style)
    }, hasMedia && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)[`media-${mediaPosition === 'side' ? 'side' : 'top'}`], (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).media),
        style: mediaPosition === 'top' ? {
            ...(0, $27065251b9f952cf$export$398c761b68cf7d00)(mediaPosition, style),
            height: (media === null || media === void 0 ? void 0 : media.height) || ''
        } : {
            ...(0, $27065251b9f952cf$export$398c761b68cf7d00)(mediaPosition, style),
            width: (media === null || media === void 0 ? void 0 : media.width) || ''
        }
    }, media.content), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: contentId,
        ref: __subStepRef,
        key: __contentKey,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['content-wrapper'], fitHeight && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['content-wrapper-fit-height'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), {
        wrapper: (content)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
                padding: "m"
            }, content)
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae03e50ad9979830$export$6a1f6653605d906d), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ffd179a45e998fe$export$277266c55937e104).Provider, {
        value: {
            isStuck: isStuck,
            isStuckAtBottom: isStuckAtBottom
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(isRefresh && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).refresh, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).header, (0, $5446dda083eafd32$export$2e2bcd8739ae039).header, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)[`header-variant-${variant}`], {
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['header-sticky-disabled']]: __stickyHeader && !isSticky,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['header-sticky-enabled']]: isSticky,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['header-dynamic-height']]: hasDynamicHeight,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['header-stuck']]: isStuck,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-paddings']]: !disableHeaderPaddings,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-hidden-content']]: !children || __hiddenContent,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['header-with-media']]: hasMedia,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['header-full-page']]: __fullPage && isRefresh
        }),
        ref: headerMergedRef,
        style: {
            ...stickyStyles.style,
            ...(0, $27065251b9f952cf$export$787d20557dd87cd)(style)
        }
    }, isStuck && !isMobile && isRefresh && __fullPage && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['header-cover']
    }), header))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).content, fitHeight && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['content-fit-height'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['content-inner'], (0, $f115ae42aa2c9b21$export$2e2bcd8739ae039)['content-inner'], {
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-paddings']]: !disableContentPaddings,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-header']]: !!header
        }),
        style: (0, $27065251b9f952cf$export$14bc84780246832b)(style)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), {
        wrapper: (content)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
                padding: disableContentPaddings ? 'm' : undefined
            }, content)
    }, children))), footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).footer, {
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-divider']]: !__disableFooterDivider,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)['with-paddings']]: !disableFooterPaddings
        }),
        style: (0, $27065251b9f952cf$export$cb72cd9798e915d8)(style)
    }, footer))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









const $515d52eb9df17853$var$FUNNEL_VERSION = '1.4';
const $515d52eb9df17853$export$467468afd0d320b9 = (props)=>{
    const { isInFunnel: isInFunnel } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    /*
     If the current funnel component is a Form (i.e. single-page funnel), it should
     defer its funnel-handling to a parent Form element, if present.
     Wizards (i.e. multi-page funnels) always take highest precedence for handling funnels,
     and do not defer to any other element.
    */ if (isInFunnel && props.funnelType === 'single-page') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($515d52eb9df17853$var$InnerAnalyticsFunnel, {
        ...props
    });
};
const $515d52eb9df17853$export$73b97833b52f451a = 'awsui-creation-edit-flow-done';
const $515d52eb9df17853$var$dispatchCreateEditFlowDoneEvent = ()=>{
    var _a;
    try {
        (_a = window.top) === null || _a === void 0 || _a.document.dispatchEvent(new Event($515d52eb9df17853$export$73b97833b52f451a));
    } catch  {
    // probably because of cross-origin error, then do not dispatch the event
    }
};
const $515d52eb9df17853$var$onFunnelCancelled = ({ funnelInteractionId: funnelInteractionId, funnelIdentifier: funnelIdentifier })=>{
    (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelCancelled({
        funnelInteractionId: funnelInteractionId,
        funnelIdentifier: funnelIdentifier
    });
};
const $515d52eb9df17853$var$onFunnelComplete = (taskCompletionDataProps)=>{
    (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelComplete({
        funnelInteractionId: taskCompletionDataProps.taskInteractionId,
        funnelIdentifier: taskCompletionDataProps.taskIdentifier
    });
    (0, $54d511b0978bc73c$export$68015ba807c17f26).taskCompletionData(taskCompletionDataProps);
    $515d52eb9df17853$var$dispatchCreateEditFlowDoneEvent();
};
function $515d52eb9df17853$var$evaluateSelectors(selectors, defaultSelector) {
    for (const selector of selectors){
        const element = document.querySelector(selector);
        if (element) return selector;
    }
    return defaultSelector;
}
const $515d52eb9df17853$var$InnerAnalyticsFunnel = ({ mounted: mounted = true, children: children, stepConfiguration: stepConfiguration, ...props })=>{
    const [funnelInteractionId, setFunnelInteractionId] = (0, $acw62.useState)('');
    const [submissionAttempt, setSubmissionAttempt] = (0, $acw62.useState)(0);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const funnelState = (0, $acw62.useRef)('default');
    const funnelNameSelector = (0, $acw62.useRef)((0, $285a09b860d2bebc$export$3e712eeacbba81a0)());
    const componentSelector = (0, $acw62.useRef)();
    const errorCount = (0, $acw62.useRef)(0);
    const loadingButtonCount = (0, $acw62.useRef)(0);
    const wizardCount = (0, $acw62.useRef)(0);
    const latestFocusCleanupFunction = (0, $acw62.useRef)(undefined);
    const formSubmitStartTime = (0, $acw62.useRef)(0);
    // This useEffect hook is run once on component mount to initiate the funnel analytics.
    // It first calls the 'funnelStart' method from FunnelMetrics, providing all necessary details
    // about the funnel, and receives a unique interaction id.
    // This unique interaction id is then stored in the state for further use.
    //
    // On component unmount, it checks whether the funnel was successfully completed.
    // Based on this, it either calls 'funnelComplete' or 'funnelCancelled' method from FunnelMetrics.
    //
    // The eslint-disable is required as we deliberately want this effect to run only once on mount and unmount,
    // hence we do not provide any dependencies.
    (0, $acw62.useEffect)(()=>{
        if (!mounted) return;
        /*
          We run this effect with a delay, in order to detect whether this funnel contains a Wizard.
          If it does contain a Wizard, that Wizard should take precedence for handling the funnel, and
          this current funnel component should do nothing.
        */ let funnelInteractionId;
        const handle = setTimeout(()=>{
            var _a, _b, _c;
            funnelNameSelector.current = $515d52eb9df17853$var$evaluateSelectors(((_a = props.funnelNameSelectors) === null || _a === void 0 ? void 0 : _a.call(props)) || [], (0, $285a09b860d2bebc$export$3e712eeacbba81a0)());
            componentSelector.current = $515d52eb9df17853$var$evaluateSelectors(((_b = props.componentSelectors) === null || _b === void 0 ? void 0 : _b.call(props)) || [], '');
            if (props.funnelType === 'single-page' && wizardCount.current > 0) return;
            // Reset the state, in case the component was re-mounted.
            funnelState.current = 'default';
            const funnelName = (_c = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(funnelNameSelector.current)) !== null && _c !== void 0 ? _c : '';
            const singleStepFlowStepConfiguration = [
                {
                    number: 1,
                    isOptional: false,
                    name: funnelName,
                    stepIdentifier: props.funnelIdentifier
                }
            ];
            let componentTheme = (0, $93d122f201f7d1ff$export$5714e40777c1bcc2);
            if ((0, $93d122f201f7d1ff$export$5714e40777c1bcc2) === 'polaris') // This is the only place we specify the theme as classic so we cannot reuse the getVisualTheme function :(
            componentTheme = isVisualRefresh ? 'vr' : 'classic';
            funnelInteractionId = (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStart({
                funnelName: funnelName,
                funnelIdentifier: props.funnelIdentifier,
                flowType: props.funnelFlowType,
                funnelNameSelector: funnelNameSelector.current,
                componentSelector: componentSelector.current,
                optionalStepNumbers: props.optionalStepNumbers,
                funnelType: props.funnelType,
                totalFunnelSteps: props.totalFunnelSteps,
                componentVersion: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34),
                componentTheme: componentTheme,
                funnelVersion: $515d52eb9df17853$var$FUNNEL_VERSION,
                stepConfiguration: stepConfiguration !== null && stepConfiguration !== void 0 ? stepConfiguration : singleStepFlowStepConfiguration,
                resourceType: props.funnelResourceType || (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(`[${(0, $285a09b860d2bebc$export$2d9588ca27729166)}]`)
            });
            setFunnelInteractionId(funnelInteractionId);
        }, 1);
        // A funnel counts as "successful" if it is unmounted after being "complete".
        /* eslint-disable react-hooks/exhaustive-deps */ return ()=>{
            clearTimeout(handle);
            // There is no need in cleanup if the funnel was not started.
            if (!funnelInteractionId) return;
            if (props.funnelType === 'single-page' && wizardCount.current > 0) return;
            if (funnelState.current === 'validating') {
                // Finish the validation phase early.
                const taskCompletionDataProps = {
                    taskIdentifier: props.funnelIdentifier,
                    taskType: props.funnelType,
                    timeToRespondAfterFormSubmit: performance.now() - formSubmitStartTime.current,
                    taskInteractionId: funnelInteractionId,
                    taskFlowType: props.funnelFlowType
                };
                $515d52eb9df17853$var$onFunnelComplete(taskCompletionDataProps);
                funnelState.current = 'complete';
            }
            if (funnelState.current === 'complete') (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSuccessful({
                funnelInteractionId: funnelInteractionId,
                funnelIdentifier: props.funnelIdentifier
            });
            else {
                funnelState.current = 'cancelled';
                $515d52eb9df17853$var$onFunnelCancelled({
                    funnelInteractionId: funnelInteractionId,
                    funnelIdentifier: props.funnelIdentifier
                });
            }
        };
    }, [
        mounted
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const funnelSubmit = ()=>{
        funnelState.current = 'validating';
        formSubmitStartTime.current = performance.now();
        /*
          When the user attempts to submit the form, we wait for 50 milliseconds before checking
          if any form validation errors are present. This value was chosen to give enough time
          for validation and rerendering to occur, but be low enough that the user will not
          be able to take further action in the meantime.
        */ const VALIDATION_WAIT_DELAY = 50;
        /*
         Loading is expected to take longer than validation, so we can keep the pressure on the CPU low.
         */ const LOADING_WAIT_DELAY = 100;
        const checkForCompleteness = ()=>{
            if (funnelState.current === 'complete') return;
            if (loadingButtonCount.current > 0) {
                setTimeout(checkForCompleteness, LOADING_WAIT_DELAY);
                return;
            }
            if (errorCount.current === 0) {
                /*
                  If no validation errors are rendered, we treat the funnel as complete.
                */ const taskCompletionDataProps = {
                    taskIdentifier: props.funnelIdentifier,
                    taskType: props.funnelType,
                    timeToRespondAfterFormSubmit: performance.now() - formSubmitStartTime.current,
                    taskInteractionId: funnelInteractionId,
                    taskFlowType: props.funnelFlowType
                };
                $515d52eb9df17853$var$onFunnelComplete(taskCompletionDataProps);
                funnelState.current = 'complete';
            } else funnelState.current = 'default';
        };
        setTimeout(checkForCompleteness, VALIDATION_WAIT_DELAY);
    };
    const funnelNextOrSubmitAttempt = ()=>setSubmissionAttempt((i)=>i + 1);
    const funnelCancel = ()=>{};
    const funnelContextValue = {
        funnelInteractionId: funnelInteractionId,
        funnelIdentifier: props.funnelIdentifier,
        funnelFlowType: props.funnelFlowType,
        funnelErrorContext: props.funnelErrorContext,
        setFunnelInteractionId: setFunnelInteractionId,
        funnelType: props.funnelType,
        optionalStepNumbers: props.optionalStepNumbers,
        totalFunnelSteps: props.totalFunnelSteps,
        funnelNameSelector: funnelNameSelector.current,
        funnelSubmit: funnelSubmit,
        funnelCancel: funnelCancel,
        submissionAttempt: submissionAttempt,
        funnelNextOrSubmitAttempt: funnelNextOrSubmitAttempt,
        funnelState: funnelState,
        errorCount: errorCount,
        loadingButtonCount: loadingButtonCount,
        latestFocusCleanupFunction: latestFocusCleanupFunction,
        isInFunnel: true,
        wizardCount: wizardCount
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$7a5dd0cfd3639f1b).Provider, {
        value: funnelContextValue
    }, children);
};
const $515d52eb9df17853$export$3fa82ebb4c38684d = (props)=>{
    /*
     This wrapper is used to apply a `key` property to the actual (inner) AnalyticsFunnelStep
     element. This allows us to keep the state and effects separate per step.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($515d52eb9df17853$var$InnerAnalyticsFunnelStep, {
        ...props,
        key: props.stepNumber
    });
};
function $515d52eb9df17853$var$getSubStepConfiguration() {
    const subSteps = Array.from(document.querySelectorAll((0, $285a09b860d2bebc$export$57dc544ae10998c7)()));
    const subStepConfiguration = subSteps.map((substep, index)=>{
        var _a, _b, _c, _d, _e;
        const subStepIdentifier = (_b = (_a = substep === null || substep === void 0 ? void 0 : substep.__awsuiMetadata__) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.instanceIdentifier;
        const name = (_e = (_d = (_c = substep.querySelector((0, $285a09b860d2bebc$export$d82de5788b5a2d19)())) === null || _c === void 0 ? void 0 : _c.innerText) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : '';
        return {
            name: name,
            number: index + 1,
            subStepIdentifier: subStepIdentifier
        };
    });
    return subStepConfiguration;
}
function $515d52eb9df17853$var$useStepChangeListener(stepNumber, handler) {
    const subStepConfiguration = (0, $acw62.useRef)(new Map());
    /*
     Chosen so that it's hopefully shorter than a user interaction, but gives enough time for the
     amount of containers to stabilise.
    */ const SUBSTEP_CHANGE_DEBOUNCE = 50;
    const listenForSubStepChanges = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        // We prevent emitting the event on the first render.
        const handle = setTimeout(()=>listenForSubStepChanges.current = true, SUBSTEP_CHANGE_DEBOUNCE);
        return ()=>{
            clearTimeout(handle);
            listenForSubStepChanges.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handle = setTimeout(()=>subStepConfiguration.current.set(stepNumber, $515d52eb9df17853$var$getSubStepConfiguration()), SUBSTEP_CHANGE_DEBOUNCE);
        return ()=>{
            clearTimeout(handle);
        };
    }, [
        stepNumber
    ]);
    /* We debounce this handler, so that multiple containers can change at once without causing
    too many events. */ const stepChangeCallback = (0, $2f667510820517ed$export$40ae01be0011c1e6)(()=>{
        // We don't want to emit the event after the component has been unmounted.
        if (!listenForSubStepChanges.current) return;
        subStepConfiguration.current.set(stepNumber, $515d52eb9df17853$var$getSubStepConfiguration());
        handler(subStepConfiguration.current.get(stepNumber));
    }, SUBSTEP_CHANGE_DEBOUNCE);
    return {
        onStepChange: stepChangeCallback,
        subStepConfiguration: subStepConfiguration
    };
}
const $515d52eb9df17853$var$InnerAnalyticsFunnelStep = ({ mounted: mounted = true, children: children, stepNumber: stepNumber, stepIdentifier: stepIdentifier, stepErrorContext: stepErrorContext, ...rest })=>{
    const { funnelInteractionId: funnelInteractionId, funnelIdentifier: funnelIdentifier, funnelNameSelector: funnelNameSelector, funnelState: funnelState, funnelType: funnelType } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const parentStep = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const parentStepExists = parentStep.isInStep;
    const parentStepFunnelInteractionId = parentStep.funnelInteractionId;
    const funnelStepProps = {
        [(0, $285a09b860d2bebc$export$35cc9e5d8841ad00)]: stepNumber
    };
    const subStepCount = (0, $acw62.useRef)(0);
    const stepNameSelector = rest.stepNameSelector || funnelNameSelector;
    const { onStepChange: onStepChange, subStepConfiguration: subStepConfiguration } = $515d52eb9df17853$var$useStepChangeListener(stepNumber, (subStepConfiguration)=>{
        if (!funnelInteractionId) return;
        (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepChange({
            stepIdentifier: stepIdentifier,
            funnelIdentifier: funnelIdentifier,
            funnelInteractionId: funnelInteractionId,
            stepNumber: stepNumber,
            stepNameSelector: stepNameSelector,
            subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
            totalSubSteps: subStepCount.current,
            subStepConfiguration: subStepConfiguration
        });
    });
    (0, $acw62.useEffect)(()=>{
        if (!funnelInteractionId) // This step is not inside an active funnel.
        return;
        if (mounted) return;
        const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
        const handler = setTimeout(()=>{
            if (funnelState.current !== 'cancelled') (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepComplete({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                totalSubSteps: subStepCount.current
            });
        }, 0);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        stepIdentifier,
        funnelIdentifier,
        funnelInteractionId,
        stepNumber,
        stepNameSelector,
        funnelState,
        parentStepExists,
        funnelType,
        parentStepFunnelInteractionId,
        mounted
    ]);
    // This useEffect hook is used to track the start and completion of interaction with the step.
    // On mount, if there is a valid funnel interaction id, it calls the 'funnelStepStart' method from FunnelMetrics
    // to record the beginning of the interaction with the current step.
    // On unmount, it does a similar thing but this time calling 'funnelStepComplete' to record the completion of the interaction.
    (0, $acw62.useEffect)(()=>{
        if (!funnelInteractionId) // This step is not inside an active funnel.
        return;
        if (parentStepExists && parentStepFunnelInteractionId) /*
             This step is inside another step, which already reports events as
             part of an active funnel (i.e. that step is not a parent of a Wizard).
             Thus, this current step does not need to report any events.
             */ return;
        const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
        if (funnelState.current === 'default') (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepStart({
            stepIdentifier: stepIdentifier,
            funnelIdentifier: funnelIdentifier,
            funnelInteractionId: funnelInteractionId,
            stepNumber: stepNumber,
            stepName: stepName,
            stepNameSelector: stepNameSelector,
            subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
            totalSubSteps: subStepCount.current,
            subStepConfiguration: $515d52eb9df17853$var$getSubStepConfiguration()
        });
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (funnelState.current !== 'cancelled') (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepComplete({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                // eslint-disable-next-line react-hooks/exhaustive-deps
                totalSubSteps: subStepCount.current
            });
        };
    }, [
        stepIdentifier,
        funnelIdentifier,
        funnelInteractionId,
        stepNumber,
        stepNameSelector,
        funnelState,
        parentStepExists,
        funnelType,
        parentStepFunnelInteractionId
    ]);
    const contextValue = {
        stepIdentifier: stepIdentifier,
        stepNumber: stepNumber,
        stepNameSelector: stepNameSelector,
        funnelStepProps: funnelStepProps,
        subStepCount: subStepCount,
        isInStep: true,
        funnelInteractionId: funnelInteractionId,
        onStepChange: onStepChange,
        subStepConfiguration: subStepConfiguration,
        stepErrorContext: stepErrorContext
    };
    /*
      If this step is inside another step which already reports events as part of an active
      funnel (i.e. that step is not a parent of a Wizard), the current step becomes invisible
      in the hierarchy by passing the context of its parent through.
    */ const effectiveContextValue = parentStepExists && parentStepFunnelInteractionId ? parentStep : contextValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$8b0d9233e68df2ee).Provider, {
        value: effectiveContextValue
    }, typeof children === 'function' ? children(effectiveContextValue) : children);
};
const $515d52eb9df17853$export$b1325661caf9fa0 = ({ children: children, subStepIdentifier: subStepIdentifier, subStepErrorContext: subStepErrorContext })=>{
    const subStepId = (0, $013a2451794a45c0$exports.useUniqueId)('substep');
    const subStepSelector = (0, $285a09b860d2bebc$export$ee83c691e298510a)(subStepId);
    const subStepNameSelector = (0, $285a09b860d2bebc$export$d82de5788b5a2d19)(subStepId);
    const subStepRef = (0, $acw62.useRef)(null);
    const { subStepCount: subStepCount, onStepChange: onStepChange } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const mousePressed = (0, $acw62.useRef)(false);
    const isFocusedSubStep = (0, $acw62.useRef)(false);
    const focusCleanupFunction = (0, $acw62.useRef)(undefined);
    const { funnelState: funnelState, funnelInteractionId: funnelInteractionId } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const newContext = {
        subStepIdentifier: subStepIdentifier,
        subStepErrorContext: subStepErrorContext,
        subStepSelector: subStepSelector,
        subStepNameSelector: subStepNameSelector,
        subStepId: subStepId,
        subStepRef: subStepRef,
        mousePressed: mousePressed,
        isFocusedSubStep: isFocusedSubStep,
        focusCleanupFunction: focusCleanupFunction,
        isNestedSubStep: false
    };
    const inheritedContext = {
        ...(0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$3030a14ef22dab15)),
        isNestedSubStep: true
    };
    const isNested = Boolean(inheritedContext.subStepId);
    (0, $acw62.useEffect)(()=>{
        if (!isNested) {
            subStepCount.current++;
            onStepChange();
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                subStepCount.current--;
                onStepChange();
            };
        }
    }, [
        isNested,
        subStepCount,
        onStepChange
    ]);
    const context = isNested ? inheritedContext : newContext;
    (0, $acw62.useEffect)(()=>{
        if (isNested || !subStepRef.current) return;
        const onMouseDown = ()=>mousePressed.current = true;
        const onMouseUp = async ()=>{
            var _a;
            mousePressed.current = false;
            if (!isFocusedSubStep.current) return;
            /*
              Some mouse events result in an element being focused. However,
              this happens only _after_ the onMouseUp event. We yield the
              event loop here, so that `document.activeElement` has the
              correct new value.
            */ await new Promise((r)=>setTimeout(r, 1));
            if (!subStepRef.current || !document.activeElement || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(subStepRef.current, document.activeElement)) {
                isFocusedSubStep.current = false;
                /*
                 Run this substep's own focus cleanup function if another substep
                 hasn't already done it for us.
                 */ (_a = focusCleanupFunction.current) === null || _a === void 0 || _a.call(focusCleanupFunction);
            }
        };
        const controller = new AbortController();
        window.addEventListener('mousedown', onMouseDown, {
            signal: controller.signal
        });
        window.addEventListener('mouseup', onMouseUp, {
            signal: controller.signal
        });
        return ()=>{
            controller.abort();
        };
    }, [
        funnelInteractionId,
        funnelState,
        stepNameSelector,
        stepNumber,
        subStepNameSelector,
        subStepSelector,
        focusCleanupFunction,
        isNested,
        subStepRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$3030a14ef22dab15).Provider, {
        value: context
    }, typeof children === 'function' ? children(context) : children);
};




var $9f0c0e878359cef4$export$2e2bcd8739ae039 = {
    "header-label": "awsui_header-label_4mvj3_1h74t_5",
    "root": "awsui_root_4mvj3_1h74t_6"
};


const $051fdcf4200bfadb$export$6a1cf8e8d6294858 = ({ className: className, children: children, header: header, variant: variant, expanded: expanded, disableContentPaddings: disableContentPaddings, __internalRootRef: __internalRootRef, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, ...rest })=>{
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(rest);
    const analyticsComponentMetadata = {
        name: 'awsui.ExpandableSection',
        label: {
            root: 'self'
        },
        properties: {
            variant: variant,
            expanded: `${!!expanded}`
        }
    };
    const metadataAttribute = __injectAnalyticsComponentMetadata ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
        component: analyticsComponentMetadata
    }) : {};
    if (variant === 'container' || variant === 'stacked') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$b1325661caf9fa0), {
        subStepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        subStepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$79c16a58b85ba6af), {
        ...rest,
        className: className,
        header: header,
        variant: variant === 'stacked' ? 'stacked' : 'default',
        disableContentPaddings: disableContentPaddings || !expanded,
        disableHeaderPaddings: true,
        __hiddenContent: !expanded,
        __internalRootRef: __internalRootRef,
        ...metadataAttribute
    }, children));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        ...rest,
        ref: __internalRootRef,
        ...metadataAttribute,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsLabelAttribute)(`.${(0, $9f0c0e878359cef4$export$2e2bcd8739ae039)['header-label']}`)
    }, header, children);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Extracts the count value from table header/filter text.
 *
 * Parses various counter string formats and extracts the relevant numeric value:
 * - "Items (100)" - Extracts 100 (first number found)
 * - "1/100" - Extracts 100 (denominator of fraction, representing total count)
 * - "100+" - Extracts 100 (first number found)
 */ const $fba7efa2f48a8453$export$61352b8152b6fbca = (countText)=>{
    if (!countText || typeof countText !== 'string') return undefined;
    const target = countText.includes('/') ? countText.split('/')[1] : countText;
    const match = target.match(/\d+/);
    return match ? parseInt(match[0], 10) : undefined;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $83cc797b0d9c18d5$var$TableComponentsContext = (0, $acw62.createContext)(null);
const $83cc797b0d9c18d5$export$9822b1dd239f3572 = $83cc797b0d9c18d5$var$TableComponentsContext.Provider;
const $83cc797b0d9c18d5$export$b4130bf0cd295245 = ()=>{
    const tableComponentContext = (0, $acw62.useContext)($83cc797b0d9c18d5$var$TableComponentsContext);
    return tableComponentContext;
};


const $c4a1f6669a725139$export$1f3015f6bbb3d1be = (countText)=>{
    const tableComponentContext = (0, $83cc797b0d9c18d5$export$b4130bf0cd295245)();
    const countValue = (0, $acw62.useMemo)(()=>{
        if (typeof countText === 'string') return (0, $fba7efa2f48a8453$export$61352b8152b6fbca)(countText);
        else return undefined;
    }, [
        countText
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (((_a = tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.headerRef) === null || _a === void 0 ? void 0 : _a.current) && countValue !== undefined) {
            tableComponentContext.headerRef.current.totalCount = countValue;
            return ()=>{
                var _a;
                (_a = tableComponentContext.headerRef.current) === null || _a === void 0 || delete _a.totalCount;
            };
        }
    }, [
        tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.headerRef,
        countValue
    ]);
};



var $d4c2d529cdd424cd$export$2e2bcd8739ae039 = {
    "heading-text": "awsui_heading-text_105ke_268sp_5"
};



var $962e3f40ddca05f8$export$2e2bcd8739ae039 = {
    "root": "awsui_root_2qdw9_m18q1_185",
    "refresh": "awsui_refresh_2qdw9_m18q1_221",
    "root-no-actions": "awsui_root-no-actions_2qdw9_m18q1_221",
    "root-variant-h2": "awsui_root-variant-h2_2qdw9_m18q1_224",
    "root-variant-h3": "awsui_root-variant-h3_2qdw9_m18q1_224",
    "root-has-description": "awsui_root-has-description_2qdw9_m18q1_224",
    "root-variant-h1": "awsui_root-variant-h1_2qdw9_m18q1_233",
    "main": "awsui_main_2qdw9_m18q1_243",
    "no-wrap": "awsui_no-wrap_2qdw9_m18q1_253",
    "main-variant-h1": "awsui_main-variant-h1_2qdw9_m18q1_259",
    "actions": "awsui_actions_2qdw9_m18q1_267",
    "actions-centered": "awsui_actions-centered_2qdw9_m18q1_272",
    "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_m18q1_275",
    "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_m18q1_279",
    "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_m18q1_283",
    "title": "awsui_title_2qdw9_m18q1_299",
    "title-variant-h1": "awsui_title-variant-h1_2qdw9_m18q1_304",
    "title-variant-h2": "awsui_title-variant-h2_2qdw9_m18q1_311",
    "title-variant-h3": "awsui_title-variant-h3_2qdw9_m18q1_317",
    "virtual-space": "awsui_virtual-space_2qdw9_m18q1_338",
    "info": "awsui_info_2qdw9_m18q1_344",
    "description": "awsui_description_2qdw9_m18q1_348",
    "description-variant-h1": "awsui_description-variant-h1_2qdw9_m18q1_355",
    "description-variant-h2": "awsui_description-variant-h2_2qdw9_m18q1_359",
    "description-variant-h3": "awsui_description-variant-h3_2qdw9_m18q1_366",
    "heading": "awsui_heading_2qdw9_m18q1_377",
    "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_m18q1_402",
    "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_m18q1_407",
    "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_m18q1_412",
    "heading-text": "awsui_heading-text_2qdw9_m18q1_418",
    "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_m18q1_421",
    "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_m18q1_430",
    "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_m18q1_439",
    "counter": "awsui_counter_2qdw9_m18q1_449"
};


function $a2f4d445a38721ba$export$2e2bcd8739ae039({ variant: variant, headingTagOverride: headingTagOverride, children: children, actions: actions, counter: counter, description: description, info: info, __internalRootRef: __internalRootRef, __disableActionsWrapping: __disableActionsWrapping, __headingTagRef: __headingTagRef, __headingTagTabIndex: __headingTagTabIndex, ...restProps }) {
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const HeadingTag = headingTagOverride !== null && headingTagOverride !== void 0 ? headingTagOverride : variant === 'awsui-h1-sticky' ? 'h1' : variant;
    const { isStuck: isStuck } = (0, $acw62.useContext)((0, $6ffd179a45e998fe$export$277266c55937e104));
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const assignHeaderId = (0, $acw62.useContext)((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314)).assignId;
    const isInContainer = (0, $ae03e50ad9979830$export$a1df13ec57f8d1e3)();
    const headingId = (0, $013a2451794a45c0$exports.useUniqueId)('heading');
    (0, $c4a1f6669a725139$export$1f3015f6bbb3d1be)(counter);
    if (assignHeaderId !== undefined) assignHeaderId(headingId);
    // If is mobile there is no need to have the dynamic variant because it's scrolled out of view
    const dynamicVariant = !isMobile && isStuck ? 'h2' : 'h1';
    const variantOverride = variant === 'awsui-h1-sticky' ? isRefresh ? dynamicVariant : 'h2' : variant;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).root, baseProps.className, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`root-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh, !actions && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`root-no-actions`]
        ], description && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`root-has-description`]
        ]),
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).main, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`main-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh, __disableActionsWrapping && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)['no-wrap']
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).title, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`title-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HeadingTag, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).heading, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`heading-variant-${variantOverride}`]),
        ref: __headingTagRef,
        tabIndex: __headingTagTabIndex,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsLabelAttribute)(`.${(0, $d4c2d529cdd424cd$export$2e2bcd8739ae039)['heading-text']}`)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...isInContainer ? {
            [(0, $285a09b860d2bebc$export$22b484224f7ab69a)]: (0, $285a09b860d2bebc$export$7eef17de8ae91f78)
        } : {},
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039)['heading-text'], (0, $d4c2d529cdd424cd$export$2e2bcd8739ae039)['heading-text'], (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`heading-text-variant-${variantOverride}`]),
        id: headingId
    }, children), counter !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).counter
    }, " ", counter)), info && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edb6222f981e45e4$export$8ffd2daeac4a0391).Provider, {
        value: headingId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)['virtual-space']
    }, " \u00A0"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).info
    }, info))), actions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).actions, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`actions-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh, !__disableActionsWrapping && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)['actions-centered']
        ])
    }, actions)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a2f4d445a38721ba$export$393edc798c47379d, {
        variantOverride: variantOverride
    }, description));
}
function $a2f4d445a38721ba$export$393edc798c47379d({ children: children, variantOverride: variantOverride }) {
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).description, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`description-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh)
    }, children) || null;
}




const $03e0cab07f1da727$var$variantIsOneOf = (variant, oneOf)=>oneOf.includes(variant);
function $03e0cab07f1da727$export$943a7be7ee5dd72e(variant) {
    return $03e0cab07f1da727$var$variantIsOneOf(variant, [
        'container',
        'default',
        'footer',
        'inline'
    ]);
}
function $03e0cab07f1da727$export$fd23164a6c2ae7c2(variant) {
    return $03e0cab07f1da727$var$variantIsOneOf(variant, [
        'container',
        'compact',
        'default',
        'inline'
    ]);
}
function $03e0cab07f1da727$export$e957d3e82fcb5a42(variant) {
    return $03e0cab07f1da727$var$variantIsOneOf(variant, [
        'container',
        'compact'
    ]);
}
function $03e0cab07f1da727$export$65281cc70a2487e2(variant) {
    return $03e0cab07f1da727$var$variantIsOneOf(variant, [
        'default',
        'inline'
    ]);
}




var $8ec66faffacc81ba$export$2e2bcd8739ae039 = {
    "content-enter": "awsui_content-enter_gwq0h_1pven_161",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_1pven_1",
    "trigger-expanded": "awsui_trigger-expanded_gwq0h_1pven_183",
    "icon": "awsui_icon_gwq0h_1pven_197",
    "root": "awsui_root_gwq0h_1pven_211",
    "expand-button": "awsui_expand-button_gwq0h_1pven_246",
    "expanded": "awsui_expanded_gwq0h_1pven_254",
    "icon-container": "awsui_icon-container_gwq0h_1pven_264",
    "icon-container-container": "awsui_icon-container-container_gwq0h_1pven_268",
    "wrapper": "awsui_wrapper_gwq0h_1pven_272",
    "wrapper-default": "awsui_wrapper-default_gwq0h_1pven_280",
    "wrapper-inline": "awsui_wrapper-inline_gwq0h_1pven_280",
    "wrapper-footer": "awsui_wrapper-footer_gwq0h_1pven_280",
    "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1pven_284",
    "wrapper-container": "awsui_wrapper-container_gwq0h_1pven_287",
    "wrapper-compact": "awsui_wrapper-compact_gwq0h_1pven_291",
    "header-deprecated": "awsui_header-deprecated_gwq0h_1pven_304",
    "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1pven_310",
    "wrapper-not-expanded-without-actions": "awsui_wrapper-not-expanded-without-actions_gwq0h_1pven_333",
    "header": "awsui_header_gwq0h_1pven_304",
    "header-wrapper": "awsui_header-wrapper_gwq0h_1pven_350",
    "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_1pven_362",
    "header-button": "awsui_header-button_gwq0h_1pven_368",
    "header-container-button": "awsui_header-container-button_gwq0h_1pven_368",
    "header-container": "awsui_header-container_gwq0h_1pven_368",
    "header-navigation": "awsui_header-navigation_gwq0h_1pven_403",
    "header-text": "awsui_header-text_gwq0h_1pven_440",
    "content": "awsui_content_gwq0h_1pven_161",
    "content-default": "awsui_content-default_gwq0h_1pven_453",
    "content-inline": "awsui_content-inline_gwq0h_1pven_453",
    "content-footer": "awsui_content-footer_gwq0h_1pven_457",
    "content-expanded": "awsui_content-expanded_gwq0h_1pven_461",
    "content-compact": "awsui_content-compact_gwq0h_1pven_464",
    "focusable": "awsui_focusable_gwq0h_1pven_468",
    "click-target": "awsui_click-target_gwq0h_1pven_483"
};


const $9264c5b706725159$var$componentName = 'ExpandableSection';
const $9264c5b706725159$var$getExpandActionAnalyticsMetadataAttribute = (expanded)=>{
    const metadata = {
        action: !expanded ? 'expand' : 'collapse',
        detail: {
            label: {
                rootSelector: `.${(0, $9f0c0e878359cef4$export$2e2bcd8739ae039).root}`
            }
        }
    };
    return (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(metadata);
};
const $9264c5b706725159$var$ExpandableDeprecatedHeader = ({ id: id, className: className, onClick: onClick, ariaLabel: ariaLabel, ariaControls: ariaControls, expanded: expanded, children: children, icon: icon, onKeyUp: onKeyUp, onKeyDown: onKeyDown, variant: variant })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        role: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['expand-button'], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['click-target'], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['header-deprecated'], (0, $9f0c0e878359cef4$export$2e2bcd8739ae039)['header-label']),
        tabIndex: 0,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": expanded,
        ...$9264c5b706725159$var$getExpandActionAnalyticsMetadataAttribute(expanded)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['icon-container'], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`icon-container-${variant}`])
    }, icon), children);
};
const $9264c5b706725159$var$ExpandableNavigationHeader = ({ id: id, className: className, onClick: onClick, ariaLabelledBy: ariaLabelledBy, ariaLabel: ariaLabel, ariaControls: ariaControls, expanded: expanded, children: children, icon: icon })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['click-target'], (0, $9f0c0e878359cef4$export$2e2bcd8739ae039)['header-label'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['icon-container'], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['expand-button']),
        "aria-labelledby": ariaLabelledBy,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": expanded,
        type: "button",
        onClick: onClick,
        ...$9264c5b706725159$var$getExpandActionAnalyticsMetadataAttribute(expanded)
    }, icon), children);
};
const $9264c5b706725159$var$ExpandableHeaderTextWrapper = ({ id: id, descriptionId: descriptionId, className: className, onClick: onClick, ariaLabel: ariaLabel, ariaControls: ariaControls, expanded: expanded, children: children, icon: icon, headerDescription: headerDescription, headerCounter: headerCounter, headerInfo: headerInfo, headerActions: headerActions, variant: variant, headingTagOverride: headingTagOverride, onKeyUp: onKeyUp, onKeyDown: onKeyDown })=>{
    const isContainer = variant === 'container';
    const HeadingTag = headingTagOverride || 'div';
    const supportsInteractiveElements = (0, $03e0cab07f1da727$export$fd23164a6c2ae7c2)(variant);
    const restrictClickableArea = supportsInteractiveElements && (headerInfo || headerActions);
    const actions = supportsInteractiveElements && headerActions;
    const description = (0, $03e0cab07f1da727$export$943a7be7ee5dd72e)(variant) && headerDescription && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descriptionId,
        className: (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`description-${variant}`]
    }, headerDescription);
    const listeners = {
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    // If interactive elements are present, constrain the clickable area to only the icon and the header text
    // to prevent nesting interactive elements.
    const headerButtonListeners = restrictClickableArea ? listeners : undefined;
    // For the default and footer variants with description,
    // include also the immediate wrapper around it to include the entire row for backwards compatibility,
    // but exclude the description.
    const headingTagListeners = !headerButtonListeners && !isContainer && description ? listeners : undefined;
    // For all other cases, make the entire header clickable for backwards compatibility.
    const wrapperListeners = !headerButtonListeners && !headingTagListeners ? listeners : undefined;
    const headerButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['expand-button'], isContainer ? (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['header-container-button'] : (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['header-button'], headerButtonListeners && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['click-target']),
        role: "button",
        tabIndex: 0,
        "aria-label": ariaLabel,
        "aria-labelledby": !ariaLabel && description ? id : undefined,
        "aria-describedby": description ? descriptionId : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": expanded,
        ...headerButtonListeners,
        ...headerButtonListeners ? $9264c5b706725159$var$getExpandActionAnalyticsMetadataAttribute(expanded) : {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['icon-container'], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`icon-container-${variant}`])
    }, icon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['header-text'], (0, $9f0c0e878359cef4$export$2e2bcd8739ae039)['header-label'])
    }, children));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperListeners && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['click-target']),
        ...wrapperListeners,
        ...wrapperListeners ? $9264c5b706725159$var$getExpandActionAnalyticsMetadataAttribute(expanded) : {}
    }, isContainer ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$2e2bcd8739ae039), {
        variant: "h2",
        description: description,
        counter: headerCounter,
        info: headerInfo,
        actions: actions,
        headingTagOverride: headingTagOverride
    }, headerButton) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(actions && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['header-actions-wrapper'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HeadingTag, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['header-wrapper'], headingTagListeners && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['click-target']),
        ...headingTagListeners,
        ...headingTagListeners ? $9264c5b706725159$var$getExpandActionAnalyticsMetadataAttribute(expanded) : {}
    }, headerButton), actions), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$393edc798c47379d), {
        variantOverride: "h3"
    }, description)));
};
const $9264c5b706725159$export$c7e168399ebe47d9 = ({ id: id, descriptionId: descriptionId, className: className, variant: variant, header: header, headerText: headerText, headerDescription: headerDescription, headerCounter: headerCounter, headerInfo: headerInfo, headerActions: headerActions, headingTagOverride: headingTagOverride, expanded: expanded, ariaControls: ariaControls, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, onKeyUp: onKeyUp, onKeyDown: onKeyDown, onClick: onClick })=>{
    const alwaysShowDivider = (0, $03e0cab07f1da727$export$65281cc70a2487e2)(variant) && headerActions;
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        size: variant === 'container' ? 'medium' : 'normal',
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).icon, expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).expanded),
        name: "caret-down-filled"
    });
    const defaultHeaderProps = {
        id: id,
        icon: icon,
        expanded: expanded,
        ariaControls: ariaControls,
        ariaLabel: ariaLabel,
        onClick: onClick,
        variant: variant
    };
    if ((headerCounter || headerInfo) && !(0, $03e0cab07f1da727$export$e957d3e82fcb5a42)(variant) && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $013a2451794a45c0$exports.warnOnce)($9264c5b706725159$var$componentName, 'The `headerCounter` and `headerInfo` props are only supported for the "container" variant.');
    if (headerActions && !(0, $03e0cab07f1da727$export$fd23164a6c2ae7c2)(variant) && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $013a2451794a45c0$exports.warnOnce)($9264c5b706725159$var$componentName, `The \`headerActions\` prop is only supported for the "container" and "default" variants.`);
    if (headerDescription && !(0, $03e0cab07f1da727$export$943a7be7ee5dd72e)(variant) && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $013a2451794a45c0$exports.warnOnce)($9264c5b706725159$var$componentName, `The \`headerDescription\` prop is not supported for the ${variant} variant.`);
    const wrapperClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).wrapper, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`wrapper-${variant}`], (expanded || alwaysShowDivider) && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['wrapper-expanded']);
    if (variant === 'navigation') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9264c5b706725159$var$ExpandableNavigationHeader, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperClassName),
        ariaLabelledBy: ariaLabelledBy,
        ...defaultHeaderProps
    }, headerText !== null && headerText !== void 0 ? headerText : header);
    if (headerText || variant === 'inline') {
        if (!headerText && header && variant === 'inline') (0, $013a2451794a45c0$exports.warnOnce)($9264c5b706725159$var$componentName, 'Only `headerText` instead of `header` is supported for `inline` variant.');
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9264c5b706725159$var$ExpandableHeaderTextWrapper, {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperClassName, expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).expanded, !expanded && (!headerActions || headerDescription) && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['wrapper-not-expanded-without-actions']),
            descriptionId: descriptionId,
            headerDescription: headerDescription,
            headerCounter: headerCounter,
            headerInfo: headerInfo,
            headerActions: headerActions,
            headingTagOverride: headingTagOverride,
            onKeyUp: onKeyUp,
            onKeyDown: onKeyDown,
            ...defaultHeaderProps
        }, headerText);
    }
    if (variant === 'container' && header && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $013a2451794a45c0$exports.warnOnce)($9264c5b706725159$var$componentName, 'Use `headerText` instead of `header` to provide the button within the heading for a11y.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9264c5b706725159$var$ExpandableDeprecatedHeader, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperClassName, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).focusable, expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).expanded),
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        ...defaultHeaderProps
    }, header);
};





function $558ed5ac4f872148$export$2e2bcd8739ae039({ expanded: controlledExpanded, defaultExpanded: defaultExpanded, onChange: onChange, variant: variant = 'default', children: children, header: header, headerText: headerText, headerCounter: headerCounter, headerDescription: headerDescription, headerInfo: headerInfo, headerActions: headerActions, headingTagOverride: headingTagOverride, disableContentPaddings: disableContentPaddings, headerAriaLabel: headerAriaLabel, __internalRootRef: __internalRootRef, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, ...props }) {
    const ref = (0, $acw62.useRef)(null);
    const controlId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const triggerControlId = `${controlId}-trigger`;
    const descriptionId = `${controlId}-description`;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const [expanded, setExpanded] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledExpanded, onChange, defaultExpanded, {
        componentName: 'ExpandableSection',
        controlledProp: 'expanded',
        changeHandler: 'onChange'
    });
    const onExpandChange = (0, $acw62.useCallback)((expanded)=>{
        setExpanded(expanded);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            expanded: expanded
        });
    }, [
        onChange,
        setExpanded
    ]);
    const onClick = (0, $acw62.useCallback)(()=>{
        onExpandChange(!expanded);
    }, [
        onExpandChange,
        expanded
    ]);
    const onKeyUp = (0, $acw62.useCallback)((event)=>{
        const interactionKeys = [
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space
        ];
        if (interactionKeys.indexOf(event.keyCode) !== -1) onExpandChange(!expanded);
    }, [
        onExpandChange,
        expanded
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space) // Prevent the page from scrolling when toggling the component with the space bar.
        event.preventDefault();
    }, []);
    const triggerProps = {
        ariaControls: controlId,
        ariaLabel: headerAriaLabel,
        ariaLabelledBy: headerAriaLabel ? undefined : triggerControlId,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onClick: onClick
    };
    // Map stacked variant to container to avoid code duplication
    const baseVariant = variant === 'stacked' ? 'container' : variant;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $051fdcf4200bfadb$export$6a1cf8e8d6294858), {
        ...props,
        expanded: expanded,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).root, (0, $9f0c0e878359cef4$export$2e2bcd8739ae039).root),
        variant: variant,
        disableContentPaddings: disableContentPaddings,
        __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata,
        header: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9264c5b706725159$export$c7e168399ebe47d9), {
            id: triggerControlId,
            descriptionId: descriptionId,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).header, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`header-${baseVariant}`], (0, $3f049698d9cc843b$export$7527db17211c2842)),
            variant: baseVariant,
            expanded: !!expanded,
            header: header,
            headerText: headerText,
            headerDescription: headerDescription,
            headerCounter: headerCounter,
            headerInfo: headerInfo,
            headerActions: headerActions,
            headingTagOverride: headingTagOverride,
            ...triggerProps
        }),
        __internalRootRef: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8eaf58dc26b3be4b$export$2e2bcd8739ae039), {
        in: expanded,
        timeout: 30,
        classNames: {
            enter: (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['content-enter']
        },
        nodeRef: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: controlId,
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).content, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`content-${baseVariant}`], expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)['content-expanded']),
        role: "group",
        "aria-label": triggerProps.ariaLabel,
        "aria-labelledby": triggerProps.ariaLabelledBy,
        "aria-describedby": (0, $03e0cab07f1da727$export$943a7be7ee5dd72e)(baseVariant) && headerDescription ? descriptionId : undefined
    }, children)));
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $e08d731147a73b24$export$35f2025888793fe1(items, activeHref) {
    for (const item of items){
        if ((item.type === 'link' || item.type === 'link-group' || item.type === 'expandable-link-group') && item.href === activeHref) return true;
        if ((item.type === 'section' || item.type === 'link-group' || item.type === 'expandable-link-group') && $e08d731147a73b24$export$35f2025888793fe1(item.items, activeHref)) return true;
    }
    return false;
}
function $e08d731147a73b24$export$9620f8797d1dcd73(items, mapping = new WeakMap(), expandableParents = []) {
    items.forEach((item)=>{
        const nextLevelParents = expandableParents.slice();
        if (item.type === 'section' || item.type === 'expandable-link-group') {
            mapping.set(item, expandableParents);
            nextLevelParents.unshift(item);
        }
        if (item.type === 'section' || item.type === 'link-group' || item.type === 'expandable-link-group') $e08d731147a73b24$export$9620f8797d1dcd73(item.items, mapping, nextLevelParents);
    });
    return mapping;
}
function $e08d731147a73b24$export$a9b81fc69bcc1c83(items) {
    const hrefs = new Set();
    const queue = items.slice();
    while(queue.length > 0){
        // We just checked that there's items in the queue.
        const item = queue.shift();
        // Check duplicated hrefs
        if ('href' in item) {
            if (hrefs.has(item.href)) (0, $013a2451794a45c0$exports.warnOnce)('SideNavigation', `duplicate href in "${item.text}": ${item.href}`);
            hrefs.add(item.href);
        }
        if ('items' in item) queue.push(...item.items);
    }
}



var $eb3eadff89de3109$export$2e2bcd8739ae039 = {
    "header-link-text": "awsui_header-link-text_eymn4_rug8v_5",
    "link-text": "awsui_link-text_eymn4_rug8v_6"
};



var $09faa395f06fdc03$export$2e2bcd8739ae039 = {
    "root": "awsui_root_l0dv0_1qeic_145",
    "header": "awsui_header_l0dv0_1qeic_179",
    "header-link": "awsui_header-link_l0dv0_1qeic_193",
    "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_1qeic_204",
    "header-link-text": "awsui_header-link-text_l0dv0_1qeic_204",
    "header-logo": "awsui_header-logo_l0dv0_1qeic_209",
    "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_1qeic_215",
    "items-control": "awsui_items-control_l0dv0_1qeic_220",
    "list-container": "awsui_list-container_l0dv0_1qeic_224",
    "with-toolbar": "awsui_with-toolbar_l0dv0_1qeic_232",
    "divider-header": "awsui_divider-header_l0dv0_1qeic_232",
    "list": "awsui_list_l0dv0_1qeic_224",
    "list-variant-root": "awsui_list-variant-root_l0dv0_1qeic_245",
    "list-variant-root--first": "awsui_list-variant-root--first_l0dv0_1qeic_252",
    "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_1qeic_256",
    "list-item": "awsui_list-item_l0dv0_1qeic_260",
    "section": "awsui_section_l0dv0_1qeic_271",
    "expandable-link-group": "awsui_expandable-link-group_l0dv0_1qeic_272",
    "section--no-ident": "awsui_section--no-ident_l0dv0_1qeic_275",
    "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_1qeic_276",
    "refresh": "awsui_refresh_l0dv0_1qeic_284",
    "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_1qeic_295",
    "section-group": "awsui_section-group_l0dv0_1qeic_302",
    "section-group-title": "awsui_section-group-title_l0dv0_1qeic_314",
    "link": "awsui_link_l0dv0_1qeic_318",
    "link-active": "awsui_link-active_l0dv0_1qeic_327",
    "info": "awsui_info_l0dv0_1qeic_364",
    "external-icon": "awsui_external-icon_l0dv0_1qeic_368",
    "divider": "awsui_divider_l0dv0_1qeic_232",
    "divider-default": "awsui_divider-default_l0dv0_1qeic_377"
};



var $dcc726d3d05e0791$export$2e2bcd8739ae039 = {
    "info": "awsui_info_1fhsi_6k3bb_5"
};


function $fbeadf0ec275905f$export$8b251419efc915eb({ definition: definition, activeHref: activeHref, fireFollow: fireFollow }) {
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('SideNavigation', definition.href);
    const onClick = (0, $acw62.useCallback)((event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) fireFollow(definition, event);
    }, [
        fireFollow,
        definition
    ]);
    const clickActionAnalyticsMetadata = {
        action: 'click',
        detail: {
            label: `.${(0, $eb3eadff89de3109$export$2e2bcd8739ae039)['header-link-text']}`,
            external: 'false',
            href: definition.href,
            position: 'header'
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039).header
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: definition.href,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039)['header-link'], {
            [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)['header-link--has-logo']]: !!definition.logo
        }),
        "aria-current": definition.href === activeHref ? 'page' : undefined,
        onClick: onClick,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(clickActionAnalyticsMetadata)
    }, definition.logo && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039)['header-logo'], {
            [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)['header-logo--stretched']]: !definition.text
        }),
        ...definition.logo
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039)['header-link-text'], (0, $eb3eadff89de3109$export$2e2bcd8739ae039)['header-link-text'])
    }, definition.text))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Divider, {
        isPresentational: true,
        variant: "header"
    }));
}
function $fbeadf0ec275905f$export$47e2c5415bb5aa12({ items: items, variant: variant, activeHref: activeHref, fireChange: fireChange, fireFollow: fireFollow, position: position = '' }) {
    const lists = [];
    let currentListIndex = 0;
    lists[currentListIndex] = {
        listVariant: variant,
        items: []
    };
    items.forEach((item, index)=>{
        var _a, _b, _c, _d, _e;
        const itemid = index + 1;
        const itemPosition = `${position ? `${position},` : ''}${itemid}`;
        switch(item.type){
            case 'divider':
                {
                    const dividerIndex = lists.length;
                    lists[dividerIndex] = {
                        element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            "data-itemid": `item-${itemid}`
                        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Divider, {
                            variant: "default"
                        }))
                    };
                    currentListIndex = lists.length;
                    lists[currentListIndex] = {
                        listVariant: variant,
                        items: []
                    };
                    return;
                }
            case 'link':
                (_a = lists[currentListIndex].items) === null || _a === void 0 || _a.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-item']
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Link, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow,
                        position: itemPosition
                    }))
                });
                return;
            case 'section':
                (_b = lists[currentListIndex].items) === null || _b === void 0 || _b.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-item']
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Section, {
                        definition: item,
                        activeHref: activeHref,
                        variant: variant,
                        fireChange: fireChange,
                        fireFollow: fireFollow,
                        position: itemPosition
                    }))
                });
                return;
            case 'section-group':
                (_c = lists[currentListIndex].items) === null || _c === void 0 || _c.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-item']
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$SectionGroup, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow,
                        position: itemPosition
                    }))
                });
                return;
            case 'link-group':
                (_d = lists[currentListIndex].items) === null || _d === void 0 || _d.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-item']
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$LinkGroup, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow,
                        position: itemPosition
                    }))
                });
                return;
            case 'expandable-link-group':
                (_e = lists[currentListIndex].items) === null || _e === void 0 || _e.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-item']
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$ExpandableLinkGroup, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow,
                        variant: variant,
                        position: itemPosition
                    }))
                });
                return;
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, lists.map((list, index)=>{
        if (!list.items || list.items.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `hr-${index}`,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).list, (0, $09faa395f06fdc03$export$2e2bcd8739ae039)[`list-variant-${variant}`], {
                [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-variant-root--first']]: list.listVariant === 'root' && index === 0
            })
        }, list.element);
        else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            key: `list-${index}`,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).list, (0, $09faa395f06fdc03$export$2e2bcd8739ae039)[`list-variant-${list.listVariant}`], {
                [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-variant-root--first']]: list.listVariant === 'root' && index === 0
            })
        }, list.items.map((item)=>item.element));
    }));
}
function $fbeadf0ec275905f$var$Divider({ variant: variant = 'default', isPresentational: isPresentational = false }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).divider, (0, $09faa395f06fdc03$export$2e2bcd8739ae039)[`divider-${variant}`]),
        role: isPresentational ? 'presentation' : undefined
    });
}
function $fbeadf0ec275905f$var$Link({ definition: definition, expanded: expanded, activeHref: activeHref, fireFollow: fireFollow, position: position }) {
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('SideNavigation', definition.href);
    const isActive = definition.href === activeHref;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('link');
    const onClick = (0, $acw62.useCallback)((event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) fireFollow(definition, event);
    }, [
        fireFollow,
        definition
    ]);
    const clickActionAnalyticsMetadata = {
        action: 'click',
        detail: {
            label: `.${(0, $eb3eadff89de3109$export$2e2bcd8739ae039)['link-text']}`,
            external: `${!!definition.external}`,
            href: definition.href,
            position: position
        }
    };
    const renderedExternalIconAriaLabel = i18n('externalIconAriaLabel', definition.externalIconAriaLabel);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: definition.href,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).link, {
            [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)['link-active']]: isActive
        }),
        target: definition.external ? '_blank' : undefined,
        rel: definition.external ? 'noopener noreferrer' : undefined,
        "aria-expanded": expanded,
        "aria-current": definition.href === activeHref ? 'page' : undefined,
        onClick: onClick,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(clickActionAnalyticsMetadata)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $eb3eadff89de3109$export$2e2bcd8739ae039)['link-text']
    }, definition.text), definition.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-label": renderedExternalIconAriaLabel,
        role: renderedExternalIconAriaLabel ? 'img' : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "external",
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['external-icon']
    }))), definition.info && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).info, (0, $dcc726d3d05e0791$export$2e2bcd8739ae039).info)
    }, definition.info));
}
function $fbeadf0ec275905f$var$Section({ definition: definition, activeHref: activeHref, fireFollow: fireFollow, fireChange: fireChange, variant: variant, position: position }) {
    var _a;
    const [expanded, setExpanded] = (0, $acw62.useState)((_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : true);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const onExpandedChange = (0, $acw62.useCallback)((e)=>{
        fireChange(definition, e.detail.expanded);
        setExpanded(e.detail.expanded);
    }, [
        definition,
        fireChange
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        setExpanded((_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : true);
    }, [
        definition
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $558ed5ac4f872148$export$2e2bcd8739ae039), {
        variant: "footer",
        expanded: expanded,
        onChange: onExpandedChange,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).section, variant === 'section-group' && (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['section--no-ident'], isVisualRefresh && (0, $09faa395f06fdc03$export$2e2bcd8739ae039).refresh),
        headerText: definition.text
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "section",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref,
        position: position
    }));
}
function $fbeadf0ec275905f$var$SectionGroup({ definition: definition, activeHref: activeHref, fireFollow: fireFollow, fireChange: fireChange, position: position }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['section-group']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['section-group-title'],
        variant: "h3"
    }, definition.title), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "section-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref,
        position: position
    }));
}
function $fbeadf0ec275905f$var$LinkGroup({ definition: definition, activeHref: activeHref, fireFollow: fireFollow, fireChange: fireChange, position: position }) {
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('SideNavigation', definition.href);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Link, {
        definition: {
            type: 'link',
            href: definition.href,
            text: definition.text,
            info: definition.info
        },
        fireFollow: (_, event)=>fireFollow(definition, event),
        fireChange: fireChange,
        activeHref: activeHref,
        position: position
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "link-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref,
        position: position
    }));
}
function $fbeadf0ec275905f$var$ExpandableLinkGroup({ definition: definition, fireFollow: fireFollow, fireChange: fireChange, activeHref: activeHref, variant: variant, position: position }) {
    // Check whether the definition contains an active link and memoize it to avoid
    // rechecking every time.
    const containsActiveLink = (0, $acw62.useMemo)(()=>{
        return activeHref ? (0, $e08d731147a73b24$export$35f2025888793fe1)(definition.items, activeHref) : false;
    }, [
        activeHref,
        definition.items
    ]);
    const [expanded, setExpanded] = (0, $acw62.useState)(()=>{
        var _a;
        return (_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : definition.href === activeHref || containsActiveLink;
    });
    const [userExpanded, setUserExpanded] = (0, $acw62.useState)();
    // Reset user expansion status when the items property is updated.
    (0, $acw62.useEffect)(()=>setUserExpanded(undefined), [
        definition
    ]);
    // By default, the expandable section is open when there's an active link inside.
    (0, $acw62.useEffect)(()=>{
        setExpanded(definition.href === activeHref || containsActiveLink);
    }, [
        definition.href,
        containsActiveLink,
        activeHref
    ]);
    // If the definition object itself is updated, reset the expansion state to default.
    (0, $acw62.useEffect)(()=>{
        if (definition.defaultExpanded !== undefined) setExpanded(definition.defaultExpanded);
    }, [
        definition
    ]);
    const onExpandedChange = (0, $acw62.useCallback)((e)=>{
        fireChange(definition, e.detail.expanded);
        setUserExpanded(e.detail.expanded);
    }, [
        definition,
        fireChange
    ]);
    const onHeaderFollow = (_, event)=>{
        fireFollow(definition, event);
        setUserExpanded(true);
        if (!expanded) fireChange(definition, true);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $558ed5ac4f872148$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039)['expandable-link-group'], variant === 'section-group' && (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['expandable-link-group--no-ident']),
        variant: "navigation",
        expanded: userExpanded !== null && userExpanded !== void 0 ? userExpanded : expanded,
        onChange: onExpandedChange,
        headerText: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Link, {
            definition: {
                type: 'link',
                href: definition.href,
                text: definition.text
            },
            expanded: userExpanded !== null && userExpanded !== void 0 ? userExpanded : expanded,
            fireFollow: onHeaderFollow,
            fireChange: fireChange,
            activeHref: activeHref,
            position: position
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "expandable-link-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref,
        position: position
    }));
}




function $97ca3a14b9e1fad1$export$5a83c1b4c43ae3e8({ header: header, itemsControl: itemsControl, activeHref: activeHref, items: items = [], onFollow: onFollow, onChange: onChange, __internalRootRef: __internalRootRef, ...props }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const isToolbar = (0, $73078c4512771f18$export$d38f11a69207eec8)();
    const parentMap = (0, $acw62.useMemo)(()=>(0, $e08d731147a73b24$export$9620f8797d1dcd73)(items), [
        items
    ]);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) // This code should be wiped in production anyway.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(()=>(0, $e08d731147a73b24$export$a9b81fc69bcc1c83)(items), [
        items
    ]);
    const onChangeHandler = (0, $acw62.useCallback)((item, expanded)=>{
        // generateExpandableItemsMapping walks through the entire tree, so we're certain about getting a value.
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            item: item,
            expanded: expanded,
            expandableParents: parentMap.get(item)
        });
    }, [
        onChange,
        parentMap
    ]);
    const onFollowHandler = (0, $acw62.useCallback)((item, sourceEvent)=>{
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, item, sourceEvent);
    }, [
        onFollow
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).root, baseProps.className, isToolbar && (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['with-toolbar']),
        ref: __internalRootRef
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fbeadf0ec275905f$export$8b251419efc915eb), {
        definition: header,
        activeHref: activeHref,
        fireChange: onChangeHandler,
        fireFollow: onFollowHandler
    }), itemsControl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['items-control']
    }, itemsControl), items && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)['list-container']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fbeadf0ec275905f$export$47e2c5415bb5aa12), {
        variant: "root",
        items: items,
        fireFollow: onFollowHandler,
        fireChange: onChangeHandler,
        activeHref: activeHref
    })));
}
const $97ca3a14b9e1fad1$export$19dbb901354d5f3b = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($97ca3a14b9e1fad1$export$5a83c1b4c43ae3e8);


const $8d070a3bd5b52efb$export$b5418ddf09afa424 = (0, $97ca3a14b9e1fad1$export$19dbb901354d5f3b)();



'use client';
function $ea79e02d828b2693$export$2e2bcd8739ae039({ items: items = [], ...props }) {
    const internalProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('SideNavigation');
    const componentAnalyticMetadata = {
        name: 'awsui.SideNavigation',
        label: `.${(0, $eb3eadff89de3109$export$2e2bcd8739ae039)['header-link-text']}`,
        properties: {
            activeHref: props.activeHref || ''
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8d070a3bd5b52efb$export$b5418ddf09afa424), {
        ...props,
        ...internalProps,
        items: items,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticMetadata
        })
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($ea79e02d828b2693$export$2e2bcd8739ae039, 'SideNavigation');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








var $e1c8c8de42f23af5$export$2e2bcd8739ae039 = {
    "button": "awsui_button_m5h9f_19alj_145",
    "expanded": "awsui_expanded_m5h9f_19alj_197",
    "offset-right-none": "awsui_offset-right-none_m5h9f_19alj_208",
    "offset-right-l": "awsui_offset-right-l_m5h9f_19alj_211",
    "offset-right-xxl": "awsui_offset-right-xxl_m5h9f_19alj_214",
    "text": "awsui_text_m5h9f_19alj_239",
    "icon": "awsui_icon_m5h9f_19alj_243"
};


const $f839ee348a1a366f$export$e0f8f8cab7ecda00 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ testUtilsClass: testUtilsClass, iconName: iconName, iconUrl: iconUrl, iconAlt: iconAlt, iconSvg: iconSvg, badge: badge, ariaLabel: ariaLabel, offsetRight: offsetRight, disabled: disabled, expanded: expanded, children: children, onClick: onClick }, ref)=>{
    const hasIcon = iconName || iconUrl || iconSvg;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        type: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).button, (0, $e1c8c8de42f23af5$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`], testUtilsClass, {
            [(0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).expanded]: expanded
        }),
        "aria-label": ariaLabel,
        "aria-expanded": !!expanded,
        "aria-haspopup": true,
        disabled: disabled,
        onClick: (event)=>{
            event.preventDefault();
            onClick === null || onClick === void 0 || onClick();
        }
    }, hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        className: (0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).icon,
        name: iconName,
        url: iconUrl,
        alt: iconAlt,
        svg: iconSvg,
        badge: badge
    }), children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).text
    }, children), children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled",
        className: (0, $17bc88d78d27c4da$export$7cd733a6d16526b)((0, $ad928a6240f442f3$export$2e2bcd8739ae039), 'rotate', !!expanded)
    }));
});
const $f839ee348a1a366f$var$MenuDropdown = ({ iconName: iconName, iconUrl: iconUrl, iconAlt: iconAlt, iconSvg: iconSvg, badge: badge, offsetRight: offsetRight, children: children, ...props })=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const dropdownTrigger = ({ triggerRef: triggerRef, ariaLabel: ariaLabel, isOpen: isOpen, testUtilsClass: testUtilsClass, disabled: disabled, onClick: onClick })=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f839ee348a1a366f$export$e0f8f8cab7ecda00, {
            testUtilsClass: testUtilsClass,
            ref: triggerRef,
            disabled: disabled,
            expanded: isOpen,
            iconName: iconName,
            iconUrl: iconUrl,
            iconAlt: iconAlt,
            iconSvg: iconSvg,
            badge: badge,
            ariaLabel: ariaLabel,
            offsetRight: offsetRight,
            onClick: onClick
        }, children);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), {
        ...baseProps,
        ...props,
        variant: "navigation",
        customTriggerBuilder: dropdownTrigger,
        preferCenter: true
    });
};
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($f839ee348a1a366f$var$MenuDropdown, 'MenuDropdown');
var $f839ee348a1a366f$export$2e2bcd8739ae039 = $f839ee348a1a366f$var$MenuDropdown;






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $d6887b82092c9af8$var$defaultCtx = {
    state: {
        view: 'utilities',
        data: null
    },
    setState: ()=>{}
};
const $d6887b82092c9af8$var$ViewContext = (0, $acw62.createContext)($d6887b82092c9af8$var$defaultCtx);
const $d6887b82092c9af8$export$9770f232ac06a008 = ()=>{
    const { setState: setState } = (0, $acw62.useContext)($d6887b82092c9af8$var$ViewContext);
    const navigate = (view, data)=>{
        setState({
            view: view,
            data: data
        });
    };
    return navigate;
};
const $d6887b82092c9af8$export$e7b0ac011bb776c6 = ({ view: view, element: element })=>{
    const { state: state } = (0, $acw62.useContext)($d6887b82092c9af8$var$ViewContext);
    if (view === state.view) {
        if (typeof element === 'function') return element(state.data);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, element);
    }
    return null;
};
const $d6887b82092c9af8$var$Router = ({ children: children })=>{
    const [state, setState] = (0, $acw62.useState)({
        view: 'utilities',
        data: null
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6887b82092c9af8$var$ViewContext.Provider, {
        value: {
            state: state,
            setState: setState
        }
    }, children);
};
var $d6887b82092c9af8$export$2e2bcd8739ae039 = $d6887b82092c9af8$var$Router;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $86c82fd4ab0a7351$export$2e2bcd8739ae039 = {
    "top-navigation": "awsui_top-navigation_k5dlb_vnjbq_145",
    "padding-box": "awsui_padding-box_k5dlb_vnjbq_178",
    "medium": "awsui_medium_k5dlb_vnjbq_188",
    "narrow": "awsui_narrow_k5dlb_vnjbq_188",
    "virtual": "awsui_virtual_k5dlb_vnjbq_199",
    "hidden": "awsui_hidden_k5dlb_vnjbq_203",
    "\t": "awsui_\t_k5dlb_vnjbq_1",
    "identity": "awsui_identity_k5dlb_vnjbq_215",
    "identity-link": "awsui_identity-link_k5dlb_vnjbq_218",
    "no-logo": "awsui_no-logo_k5dlb_vnjbq_238",
    "logo": "awsui_logo_k5dlb_vnjbq_242",
    "title": "awsui_title_k5dlb_vnjbq_254",
    "inputs": "awsui_inputs_k5dlb_vnjbq_270",
    "search": "awsui_search_k5dlb_vnjbq_278",
    "search-expanded": "awsui_search-expanded_k5dlb_vnjbq_282",
    "utilities": "awsui_utilities_k5dlb_vnjbq_286",
    "utility-wrapper": "awsui_utility-wrapper_k5dlb_vnjbq_297",
    "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_vnjbq_318",
    "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_vnjbq_323",
    "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_vnjbq_332",
    "utility-link-icon": "awsui_utility-link-icon_k5dlb_vnjbq_340",
    "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_vnjbq_344",
    "offset-right-none": "awsui_offset-right-none_k5dlb_vnjbq_348",
    "offset-right-l": "awsui_offset-right-l_k5dlb_vnjbq_352",
    "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_vnjbq_356",
    "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_vnjbq_361",
    "overflow-menu": "awsui_overflow-menu_k5dlb_vnjbq_361",
    "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_vnjbq_402",
    "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_vnjbq_410",
    "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_vnjbq_417",
    "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_vnjbq_426",
    "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_vnjbq_434",
    "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_vnjbq_438",
    "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_vnjbq_442",
    "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_vnjbq_480",
    "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_vnjbq_488",
    "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_vnjbq_491",
    "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_vnjbq_480",
    "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_vnjbq_527",
    "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_vnjbq_480",
    "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_vnjbq_536",
    "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_vnjbq_539",
    "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_vnjbq_548",
    "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_vnjbq_554",
    "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_vnjbq_558",
    "icon": "awsui_icon_k5dlb_vnjbq_563",
    "icon-open": "awsui_icon-open_k5dlb_vnjbq_577"
};


const $a1a7b8ef02d5746f$var$Header = ({ children: children, secondaryText: secondaryText, backIconAriaLabel: backIconAriaLabel, dismissIconAriaLabel: dismissIconAriaLabel, onBack: onBack, onClose: onClose })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-header']
    }, onBack && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        // Used for test-utils, which require the selectable element to have a classname.
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-back-button'],
        ariaLabel: backIconAriaLabel,
        iconName: "angle-left",
        variant: "icon",
        onClick: ()=>onBack()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-header-text']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-header-text--title']
    }, children), secondaryText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-header-text--secondary']
    }, secondaryText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-dismiss-button'],
        ariaLabel: dismissIconAriaLabel,
        iconName: "close",
        variant: "icon",
        onClick: ()=>onClose && onClose()
    }));
};
var $a1a7b8ef02d5746f$export$2e2bcd8739ae039 = $a1a7b8ef02d5746f$var$Header;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








const $ee8af3c74c2e73d8$var$ListItem = ({ children: children, startIcon: startIcon, endIcon: endIcon })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-list-item-icon']
    }, startIcon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-list-item-text']
    }, children), endIcon && endIcon);
};
const $ee8af3c74c2e73d8$var$LinkItem = (0, $acw62.forwardRef)(({ children: children, external: external, href: href, target: target, rel: rel, startIcon: startIcon, endIcon: endIcon, onClick: onClick, context: context, testId: testId }, ref)=>{
    const anchorTarget = target !== null && target !== void 0 ? target : external ? '_blank' : undefined;
    const anchorRel = rel !== null && rel !== void 0 ? rel : anchorTarget === '_blank' ? 'noopener noreferrer' : undefined;
    const role = !href ? 'button' : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ref: ref,
        onClick: onClick,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-control'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-control-link'], context && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-control-${context}`]),
        role: role,
        tabIndex: 0,
        href: href,
        target: anchorTarget,
        rel: anchorRel,
        ...testId ? {
            'data-testid': testId
        } : {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ListItem, {
        startIcon: startIcon,
        endIcon: endIcon
    }, children));
});
const $ee8af3c74c2e73d8$var$ButtonItem = (0, $acw62.forwardRef)(({ children: children, startIcon: startIcon, endIcon: endIcon, onClick: onClick, testId: testId }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-control'],
        onClick: onClick,
        ...typeof testId === 'string' ? {
            'data-testid': testId
        } : {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ListItem, {
        startIcon: startIcon,
        endIcon: endIcon
    }, children));
});
const $ee8af3c74c2e73d8$var$NavigationItem = (0, $acw62.forwardRef)(({ startIcon: startIcon, children: children, index: index, testId: testId, ...definition }, ref)=>{
    const navigate = (0, $d6887b82092c9af8$export$9770f232ac06a008)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ButtonItem, {
        ref: ref,
        startIcon: startIcon,
        endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "angle-right"
        }),
        testId: testId,
        onClick: ()=>navigate('dropdown-menu', {
                definition: definition,
                headerText: definition.text || definition.title,
                headerSecondaryText: definition.description,
                utilityIndex: index
            })
    }, children);
});
const $ee8af3c74c2e73d8$var$ExpandableItem = ({ children: children, onItemClick: onItemClick, ...definition })=>{
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const headerId = (0, $013a2451794a45c0$exports.useUniqueId)('overflow-menu-item');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-control'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-control-expandable-menu-trigger']),
        onClick: ()=>setExpanded((value)=>!value),
        "aria-expanded": expanded
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ListItem, {
        endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $17bc88d78d27c4da$export$7cd733a6d16526b)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039), 'icon', expanded)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "caret-down-filled"
        }))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headerId
    }, children))), expanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-list'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-list-submenu']),
        "aria-labelledby": headerId
    }, definition.items.map((item, index)=>{
        const isGroup = typeof item.items !== 'undefined';
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: index,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item`], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-dropdown-menu`])
        }, $ee8af3c74c2e73d8$var$dropdownComponentFactory(item, isGroup, onItemClick));
    })));
};
function $ee8af3c74c2e73d8$var$utilityComponentFactory(utility, index, ref) {
    const label = utility.text || utility.title;
    const hasIcon = !!utility.iconName || !!utility.iconUrl || !!utility.iconAlt || !!utility.iconSvg;
    const startIcon = hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: utility.iconName,
        url: utility.iconUrl,
        alt: utility.iconAlt,
        svg: utility.iconSvg
    });
    switch(utility.type){
        case 'button':
            {
                const handleClick = (event)=>{
                    var _a;
                    if (Boolean(utility.href) && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(utility.onFollow, {
                        href: utility.href,
                        target: utility.target
                    }, event);
                    (0, $fc537b925f715587$export$d7e1721720edbb03)(utility.onClick, {}, event);
                    (_a = utility.onClose) === null || _a === void 0 || _a.call(utility);
                };
                const content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, label, utility.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, ' ', (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    "aria-label": utility.externalIconAriaLabel,
                    role: utility.externalIconAriaLabel ? 'img' : undefined
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
                    name: "external",
                    size: "normal"
                }))));
                if (!utility.href) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ButtonItem, {
                    ref: ref,
                    startIcon: startIcon,
                    onClick: handleClick,
                    testId: `__${index}`
                }, content);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$LinkItem, {
                    ref: ref,
                    startIcon: startIcon,
                    href: utility.href,
                    external: utility.external,
                    target: utility.target,
                    rel: utility.rel,
                    testId: `__${index}`,
                    onClick: handleClick
                }, content);
            }
        case 'menu-dropdown':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$NavigationItem, {
                ref: ref,
                startIcon: startIcon,
                index: index,
                ...utility,
                testId: `__${index}`
            }, label);
    }
}
function $ee8af3c74c2e73d8$var$dropdownComponentFactory(item, expandable, onItemClick) {
    const label = item.text;
    const hasIcon = !!item.iconName || !!item.iconUrl || !!item.iconAlt || !!item.iconSvg;
    const isLink = (0, $36113732f360ff28$export$211c15450d7814f3)(item);
    const startIcon = hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: item.iconName,
        url: item.iconUrl,
        alt: item.iconAlt,
        svg: item.iconSvg
    });
    if (expandable) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ExpandableItem, {
        ...item,
        onItemClick: onItemClick
    }, label);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$LinkItem, {
        startIcon: startIcon,
        href: isLink ? item.href : undefined,
        external: isLink ? item.external : undefined,
        context: "dropdown-menu",
        testId: item.id,
        onClick: (event)=>onItemClick(event, item)
    }, label, isLink && item.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, ' ', (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-label": item.externalIconAriaLabel,
        role: item.externalIconAriaLabel ? 'img' : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "external",
        size: "normal"
    }))));
}
const $ee8af3c74c2e73d8$export$654fec7a6e91b021 = (0, $acw62.forwardRef)(({ index: index, ...props }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item`], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-utility`])
    }, $ee8af3c74c2e73d8$var$utilityComponentFactory(props, index, ref));
});
const $ee8af3c74c2e73d8$export$9bfb1e302b1192e9 = (props)=>{
    const expandable = typeof props.items !== 'undefined';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item`], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-submenu`], expandable && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-expandable`])
    }, $ee8af3c74c2e73d8$var$dropdownComponentFactory(props, expandable, props.onClick));
};




const $631f73cba7eaef88$var$SubmenuView = ({ onClose: onClose, utilityIndex: utilityIndex, headerText: headerText, headerSecondaryText: headerSecondaryText, dismissIconAriaLabel: dismissIconAriaLabel, backIconAriaLabel: backIconAriaLabel, definition: definition })=>{
    const navigate = (0, $d6887b82092c9af8$export$9770f232ac06a008)();
    const headerId = (0, $013a2451794a45c0$exports.useUniqueId)('overflow-menu-header');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        autoFocus: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1a7b8ef02d5746f$export$2e2bcd8739ae039), {
        secondaryText: headerSecondaryText,
        dismissIconAriaLabel: dismissIconAriaLabel,
        backIconAriaLabel: backIconAriaLabel,
        onClose: onClose,
        onBack: ()=>navigate('utilities', {
                utilityIndex: utilityIndex
            })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headerId
    }, headerText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-list'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-list-submenu']),
        "aria-labelledby": headerId
    }, definition.items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ee8af3c74c2e73d8$export$9bfb1e302b1192e9), {
            key: index,
            ...item,
            onClick: (event, item)=>{
                if (item.href && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onItemFollow, {
                    id: item.id,
                    href: item.href,
                    external: item.external
                }, event);
                (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onItemClick, {
                    id: item.id,
                    href: item.href,
                    external: item.external
                }, event);
                onClose === null || onClose === void 0 || onClose();
            }
        }))));
};
var $631f73cba7eaef88$export$2e2bcd8739ae039 = $631f73cba7eaef88$var$SubmenuView;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





const $a78e2c3b6dd21636$var$UtilitiesView = ({ headerText: headerText, dismissIconAriaLabel: dismissIconAriaLabel, onClose: onClose, items: items = [], focusIndex: focusIndex })=>{
    const headerId = (0, $013a2451794a45c0$exports.useUniqueId)('overflow-menu-header');
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _a;
        // A focus index is used to set the focus back to the submenu trigger
        // returning from a submenu.
        if (typeof focusIndex === 'number') (_a = ref.current) === null || _a === void 0 || _a.focus();
    }, [
        focusIndex
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        autoFocus: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1a7b8ef02d5746f$export$2e2bcd8739ae039), {
        dismissIconAriaLabel: dismissIconAriaLabel,
        onClose: onClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headerId
    }, headerText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-list'],
        "aria-labelledby": headerId
    }, items.map((utility, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ee8af3c74c2e73d8$export$654fec7a6e91b021), {
            key: index,
            index: index,
            ref: index === focusIndex ? ref : undefined,
            onClose: onClose,
            ...utility
        }))));
};
var $a78e2c3b6dd21636$export$2e2bcd8739ae039 = $a78e2c3b6dd21636$var$UtilitiesView;



const $d12922b6dc43cbfb$var$OverflowMenu = ({ headerText: headerText, dismissIconAriaLabel: dismissIconAriaLabel, backIconAriaLabel: backIconAriaLabel, items: items = [], onClose: onClose })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('top-navigation');
    const renderedDismissIconAriaLabel = i18n('i18nStrings.overflowMenuDismissIconAriaLabel', dismissIconAriaLabel);
    const renderedBackIconAriaLabel = i18n('i18nStrings.overflowMenuBackIconAriaLabel', backIconAriaLabel);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu'],
        onKeyUp: (event)=>{
            if (event.key === 'Escape') onClose === null || onClose === void 0 || onClose();
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6887b82092c9af8$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6887b82092c9af8$export$e7b0ac011bb776c6), {
        view: "utilities",
        element: (data)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78e2c3b6dd21636$export$2e2bcd8739ae039), {
                headerText: i18n('i18nStrings.overflowMenuTitleText', headerText),
                items: items,
                focusIndex: data === null || data === void 0 ? void 0 : data.utilityIndex,
                dismissIconAriaLabel: renderedDismissIconAriaLabel,
                backIconAriaLabel: renderedBackIconAriaLabel,
                onClose: onClose
            })
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6887b82092c9af8$export$e7b0ac011bb776c6), {
        view: "dropdown-menu",
        element: (data)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $631f73cba7eaef88$export$2e2bcd8739ae039), {
                headerText: data === null || data === void 0 ? void 0 : data.headerText,
                headerSecondaryText: data === null || data === void 0 ? void 0 : data.headerSecondaryText,
                dismissIconAriaLabel: renderedDismissIconAriaLabel,
                backIconAriaLabel: renderedBackIconAriaLabel,
                definition: data === null || data === void 0 ? void 0 : data.definition,
                utilityIndex: data === null || data === void 0 ? void 0 : data.utilityIndex,
                onClose: onClose
            })
    })));
};
var $d12922b6dc43cbfb$export$2e2bcd8739ae039 = $d12922b6dc43cbfb$var$OverflowMenu;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");










function $4c089e0b33219dfd$export$2e2bcd8739ae039({ hideText: hideText, definition: definition, offsetRight: offsetRight }) {
    var _a;
    const hasIcon = !!definition.iconName || !!definition.iconUrl || !!definition.iconAlt || !!definition.iconSvg;
    const shouldHideText = hideText && !definition.disableTextCollapse && hasIcon;
    let ariaLabel = (_a = definition.ariaLabel) !== null && _a !== void 0 ? _a : definition.text;
    if (definition.type === 'button') {
        ariaLabel = definition.ariaLabel ? definition.ariaLabel : (0, $49fa9e74c692ea64$export$b933cda3796739ed)(definition.text, definition.externalIconAriaLabel);
        (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('TopNavigation', definition.href);
        if (definition.variant === 'primary-button') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            variant: "primary",
            href: definition.href,
            target: definition.external ? '_blank' : undefined,
            onClick: definition.onClick,
            onFollow: definition.onFollow,
            ariaLabel: ariaLabel,
            iconName: definition.iconName,
            iconUrl: definition.iconUrl,
            iconAlt: definition.iconAlt,
            iconSvg: definition.iconSvg
        }, shouldHideText ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, definition.text, definition.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, ' ', (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-button-external-icon'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`]),
            "aria-label": definition.externalIconAriaLabel,
            role: definition.externalIconAriaLabel ? 'img' : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "external"
        }))))));
        else // Link
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01503a290f20b804$export$2e2bcd8739ae039), {
            variant: "top-navigation",
            href: definition.href,
            target: definition.target,
            rel: definition.rel,
            external: definition.external,
            onFollow: (evt)=>{
                (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onFollow, {
                    href: definition.href,
                    target: definition.target,
                    external: definition.external
                }, evt);
                (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onClick, {
                    href: definition.href,
                    target: definition.target,
                    external: definition.external
                }, evt);
            },
            ariaLabel: ariaLabel
        }, hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: definition.iconName,
            url: definition.iconUrl,
            alt: definition.iconAlt,
            svg: definition.iconSvg,
            badge: definition.badge
        }), !shouldHideText && definition.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: hasIcon ? (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-link-icon'] : undefined
        }, definition.text)));
    } else if (definition.type === 'menu-dropdown') {
        const title = definition.title || definition.text;
        const shouldShowTitle = shouldHideText || !definition.text;
        $4c089e0b33219dfd$var$checkSafeUrlRecursively(definition.items);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f839ee348a1a366f$export$2e2bcd8739ae039), {
            ...definition,
            title: shouldShowTitle ? title : '',
            ariaLabel: ariaLabel,
            offsetRight: offsetRight
        }, !shouldHideText && definition.text);
    }
    return null;
}
function $4c089e0b33219dfd$var$checkSafeUrlRecursively(itemOrGroup) {
    for (const item of itemOrGroup){
        if ((0, $36113732f360ff28$export$211c15450d7814f3)(item)) (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('TopNavigation', item.href);
        if ('items' in item) $4c089e0b33219dfd$var$checkSafeUrlRecursively(item.items);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




function $921c3f4037759790$export$2aa1887afbd6d218(triggers) {
    // triggers.join() gives us a stable value to use for the dependencies argument
    const triggersDep = triggers === null || triggers === void 0 ? void 0 : triggers.join();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>(0, $1be283cfa47851a8$export$21bc4262e291071d)(rect.contentBoxWidth, triggers), [
        triggersDep
    ]);
}



// A small buffer to make calculations more lenient against browser lag or padding adjustments.
const $08ca12ced8309980$var$RESPONSIVENESS_BUFFER = 20;
function $08ca12ced8309980$export$1452fd78386de60a({ identity: identity, search: search, utilities: utilities }) {
    // Refs and breakpoints
    const mainRef = (0, $acw62.useRef)(null);
    const virtualRef = (0, $acw62.useRef)(null);
    const [breakpoint, breakpointRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        'xxs',
        's'
    ]);
    // Responsiveness state
    // The component works by calculating the possible resize states that it can
    // be in, and having a state variable to track which state we're currently in.
    const hasSearch = !!search;
    const hasTitleWithLogo = identity && !!identity.logo && !!identity.title;
    const responsiveStates = (0, $acw62.useMemo)(()=>{
        return $08ca12ced8309980$export$ebce2383234760ce(utilities, hasSearch, hasTitleWithLogo);
    }, [
        utilities,
        hasSearch,
        hasTitleWithLogo
    ]);
    // To hide/show elements dynamically, we need to know how much space they take up,
    // even if they're not being rendered. The top navigation elements are hidden/resized
    // based on the available size or if a search bar is open, and they need to be available
    // for calculations so we know where to toggle them. So we render a second, more stable
    // top-nav off screen to do these calculations against.
    //
    // We can't "affix" these values to pixels because they can depend on spacing tokens.
    // It's easier to render all of these utilities separately rather than figuring out
    // spacing token values, icon sizes, text widths, etc.
    const [responsiveState, setResponsiveState] = (0, $acw62.useState)();
    const recalculateFit = (0, $acw62.useCallback)(()=>{
        var _a, _b, _c, _d;
        if (!(mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) || !virtualRef.current) {
            setResponsiveState(responsiveStates[0]);
            return;
        }
        // Get available width from the visible top navigation.
        const availableWidth = $08ca12ced8309980$var$getContentBoxWidth(mainRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['padding-box']}`));
        if (availableWidth === 0) {
            // Likely in an SSR or Jest situation.
            setResponsiveState(responsiveStates[0]);
            return;
        }
        const sizeConfiguration = {
            hasSearch: hasSearch,
            availableWidth: availableWidth,
            // Get widths from the hidden top navigation
            fullIdentityWidth: virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).identity}`).getBoundingClientRect().width,
            titleWidth: (_b = (_a = virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).title}`)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0,
            searchSlotWidth: (_d = (_c = virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).search}`)) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width) !== null && _d !== void 0 ? _d : 0,
            searchUtilityWidth: virtualRef.current.querySelector('[data-utility-special="search"]').getBoundingClientRect().width,
            utilitiesLeftPadding: parseFloat(getComputedStyle(virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).utilities}`)).paddingLeft || '0px'),
            utilityWithLabelWidths: Array.prototype.slice.call(virtualRef.current.querySelectorAll(`[data-utility-hide="false"]`)).map((element)=>element.getBoundingClientRect().width),
            utilityWithoutLabelWidths: Array.prototype.slice.call(virtualRef.current.querySelectorAll(`[data-utility-hide="true"]`)).map((element)=>element.getBoundingClientRect().width),
            menuTriggerUtilityWidth: virtualRef.current.querySelector('[data-utility-special="menu-trigger"]').getBoundingClientRect().width
        };
        setResponsiveState($08ca12ced8309980$export$4d42314861d0d60c(responsiveStates, sizeConfiguration));
    }, [
        responsiveStates,
        hasSearch
    ]);
    const [, containerQueryRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)(()=>{
        recalculateFit();
    }, [
        recalculateFit
    ]);
    // Due to being rendered in a portal, the virtual navigation isn't rendered
    // at the same time as the main one.
    const onVirtualMount = (0, $acw62.useCallback)((element)=>{
        virtualRef.current = element;
        recalculateFit();
    }, [
        recalculateFit
    ]);
    // Search slot expansion on small screens
    const [isSearchMinimized, setSearchMinimized] = (0, $acw62.useState)(true);
    const isSearchExpanded = !isSearchMinimized && hasSearch && (responsiveState === null || responsiveState === void 0 ? void 0 : responsiveState.hideSearch);
    // If the search was expanded, and then the screen resized so that the
    // expansion is no longer necessary. So we implicitly minimize it.
    (0, $acw62.useEffect)(()=>{
        if (!(responsiveState === null || responsiveState === void 0 ? void 0 : responsiveState.hideSearch)) setSearchMinimized(true);
    }, [
        responsiveState
    ]);
    // If the search is expanded after clicking on the search utility, move
    // the focus to the input. Since this is a user-controlled slot, we're just
    // assuming that it contains an input, though it's a pretty safe guess.
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        if (isSearchExpanded) (_b = (_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).search} input`)) === null || _b === void 0 || _b.focus();
    }, [
        isSearchExpanded,
        mainRef
    ]);
    const mergedMainRef = (0, $013a2451794a45c0$exports.useMergeRefs)(mainRef, containerQueryRef, breakpointRef);
    return {
        mainRef: mergedMainRef,
        virtualRef: onVirtualMount,
        responsiveState: responsiveState !== null && responsiveState !== void 0 ? responsiveState : responsiveStates[0],
        breakpoint: breakpoint !== null && breakpoint !== void 0 ? breakpoint : 'default',
        isSearchExpanded: !!isSearchExpanded,
        onSearchUtilityClick: ()=>setSearchMinimized((isSearchMinimized)=>!isSearchMinimized)
    };
}
/**
 * Get the width of the content box (assuming the element's box-sizing is border-box).
 */ function $08ca12ced8309980$var$getContentBoxWidth(element) {
    const style = getComputedStyle(element);
    return parseFloat(style.width || '0px') - parseFloat(style.paddingLeft || '0px') - parseFloat(style.paddingRight || '0px');
}
function $08ca12ced8309980$export$ebce2383234760ce(utilities, canHideSearch, canHideTitle) {
    const states = [
        {}
    ];
    if (utilities.some((utility)=>utility.text)) states.push({
        hideUtilityText: true
    });
    if (canHideSearch) states.push({
        hideUtilityText: true,
        hideSearch: true
    });
    const hiddenUtilties = [];
    for(let i = 0; i < utilities.length; i++)if (!utilities[i].disableUtilityCollapse) {
        hiddenUtilties.push(i);
        states.push({
            hideUtilityText: true,
            hideSearch: canHideSearch || undefined,
            hideUtilities: hiddenUtilties.length > 0 ? hiddenUtilties.slice() : undefined
        });
    }
    if (canHideTitle) states.push({
        hideUtilityText: true,
        hideSearch: canHideSearch || undefined,
        hideUtilities: hiddenUtilties.length > 0 ? hiddenUtilties.slice() : undefined,
        hideTitle: true
    });
    return states;
}
function $08ca12ced8309980$export$4d42314861d0d60c(possibleStates, sizes) {
    const { hasSearch: hasSearch, availableWidth: availableWidth, utilitiesLeftPadding: utilitiesLeftPadding, fullIdentityWidth: fullIdentityWidth, titleWidth: titleWidth, searchSlotWidth: searchSlotWidth, searchUtilityWidth: searchUtilityWidth, utilityWithLabelWidths: utilityWithLabelWidths, utilityWithoutLabelWidths: utilityWithoutLabelWidths, menuTriggerUtilityWidth: menuTriggerUtilityWidth } = sizes;
    // Iterate through each state and calculate its expected required width.
    for (const state of possibleStates){
        const searchWidth = hasSearch ? state.hideSearch ? searchUtilityWidth : searchSlotWidth : 0;
        const utilitiesWidth = (state.hideUtilityText ? utilityWithoutLabelWidths : utilityWithLabelWidths).filter((_width, i)=>!state.hideUtilities || state.hideUtilities.indexOf(i) === -1).reduce((sum, width)=>sum + width, 0);
        const menuTriggerWidth = state.hideUtilities ? menuTriggerUtilityWidth : 0;
        const identityWidth = state.hideTitle ? fullIdentityWidth - titleWidth : fullIdentityWidth;
        const expectedInnerWidth = identityWidth + searchWidth + utilitiesLeftPadding + utilitiesWidth + menuTriggerWidth;
        if (expectedInnerWidth <= availableWidth - $08ca12ced8309980$var$RESPONSIVENESS_BUFFER) return state;
    }
    // If nothing matches, pick the smallest possible state.
    return possibleStates[possibleStates.length - 1];
}



function $3a7cb2c90d1e72da$export$2e2bcd8739ae039({ __internalRootRef: __internalRootRef, identity: identity, i18nStrings: i18nStrings, utilities: utilities, search: search, ...restProps }) {
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)('TopNavigation', identity.href);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const { mainRef: mainRef, virtualRef: virtualRef, breakpoint: breakpoint, responsiveState: responsiveState, isSearchExpanded: isSearchExpanded, onSearchUtilityClick: onSearchUtilityClick } = (0, $08ca12ced8309980$export$1452fd78386de60a)({
        identity: identity,
        search: search,
        utilities: utilities
    });
    const [overflowMenuOpen, setOverflowMenuOpen] = (0, $acw62.useState)(false);
    const overflowMenuTriggerRef = (0, $acw62.useRef)(null);
    const isNarrowViewport = breakpoint === 'default';
    const isMediumViewport = breakpoint === 'xxs';
    const isLargeViewport = breakpoint === 's';
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('top-navigation');
    const onIdentityClick = (event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(identity.onFollow, {}, event);
    };
    const toggleOverflowMenu = ()=>{
        setOverflowMenuOpen((overflowMenuOpen)=>!overflowMenuOpen);
    };
    const menuTriggerVisible = !isSearchExpanded && responsiveState.hideUtilities;
    (0, $acw62.useEffect)(()=>{
        setOverflowMenuOpen(false);
    }, [
        menuTriggerVisible
    ]);
    (0, $5f60cc888539a35b$export$21dfe79102a9caab)(()=>{
        var _a;
        if (!overflowMenuOpen) (_a = overflowMenuTriggerRef.current) === null || _a === void 0 || _a.focus();
    }, [
        overflowMenuOpen
    ]);
    // Render the top nav twice; once as the top nav that users can see, and another
    // "virtual" top nav used just for calculations. The virtual top nav doesn't react to
    // layout changes and renders two sets of utilities: one with labels and one without.
    const content = (isVirtual)=>{
        var _a, _b;
        const Wrapper = isVirtual ? 'div' : 'header';
        const showIdentity = isVirtual || !isSearchExpanded;
        const showTitle = isVirtual || !responsiveState.hideTitle;
        const showSearchSlot = search && (isVirtual || !responsiveState.hideSearch || isSearchExpanded);
        const showSearchUtility = isVirtual || search && responsiveState.hideSearch;
        const showUtilities = isVirtual || !isSearchExpanded;
        const showMenuTrigger = isVirtual || menuTriggerVisible;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, {
            ref: isVirtual ? virtualRef : mainRef,
            "aria-hidden": isVirtual ? true : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['top-navigation'], {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).virtual]: isVirtual,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).hidden]: isVirtual,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['padding-box']
        }, showIdentity && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).identity, !identity.logo && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['no-logo'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['identity-link'],
            href: identity.href,
            onClick: onIdentityClick
        }, identity.logo && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            role: "img",
            src: (_a = identity.logo) === null || _a === void 0 ? void 0 : _a.src,
            alt: (_b = identity.logo) === null || _b === void 0 ? void 0 : _b.alt,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).logo, {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport
            })
        }), showTitle && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).title
        }, identity.title))), showSearchSlot && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).inputs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).search, !isVirtual && isSearchExpanded && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['search-expanded'])
        }, search)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).utilities
        }, showSearchUtility && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-wrapper'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-type-button'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-type-button-link'], {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
            }),
            "data-utility-special": "search"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c089e0b33219dfd$export$2e2bcd8739ae039), {
            hideText: true,
            definition: {
                type: 'button',
                iconName: isSearchExpanded ? 'close' : 'search',
                ariaLabel: isSearchExpanded ? i18n('i18nStrings.searchDismissIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.searchDismissIconAriaLabel) : i18n('i18nStrings.searchIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.searchIconAriaLabel),
                onClick: onSearchUtilityClick
            }
        })), showUtilities && utilities.filter((_utility, i)=>isVirtual || !responsiveState.hideUtilities || responsiveState.hideUtilities.indexOf(i) === -1).map((utility, i)=>{
            var _a;
            const hideText = !!responsiveState.hideUtilityText;
            const isLast = (isVirtual || !showMenuTrigger) && i === utilities.length - 1;
            const offsetRight = isLast && isLargeViewport ? 'xxl' : isLast ? 'l' : undefined;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: i,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-wrapper'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-${utility.type}`], utility.type === 'button' && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-button-${(_a = utility.variant) !== null && _a !== void 0 ? _a : 'link'}`], {
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
                }),
                "data-utility-index": i,
                "data-utility-hide": `${hideText}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c089e0b33219dfd$export$2e2bcd8739ae039), {
                hideText: hideText,
                definition: utility,
                offsetRight: offsetRight
            }));
        }), isVirtual && utilities.map((utility, i)=>{
            var _a;
            const hideText = !responsiveState.hideUtilityText;
            const isLast = !showMenuTrigger && i === utilities.length - 1;
            const offsetRight = isLast && isLargeViewport ? 'xxl' : isLast ? 'l' : undefined;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: i,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-wrapper'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-${utility.type}`], utility.type === 'button' && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-button-${(_a = utility.variant) !== null && _a !== void 0 ? _a : 'link'}`], {
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
                }),
                "data-utility-index": i,
                "data-utility-hide": `${hideText}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c089e0b33219dfd$export$2e2bcd8739ae039), {
                hideText: hideText,
                definition: utility,
                offsetRight: offsetRight
            }));
        }), showMenuTrigger && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-wrapper'], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['utility-type-menu-dropdown'], {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
            }),
            "data-utility-special": "menu-trigger"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f839ee348a1a366f$export$e0f8f8cab7ecda00), {
            expanded: overflowMenuOpen,
            onClick: toggleOverflowMenu,
            offsetRight: "l",
            ref: !isVirtual ? overflowMenuTriggerRef : undefined
        }, i18n('i18nStrings.overflowMenuTriggerText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuTriggerText))))));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8856d0c7df08fd8d$export$2e2bcd8739ae039), {
        contextName: "top-navigation"
    }, content(true), content(false), menuTriggerVisible && overflowMenuOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)['overflow-menu-drawer']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d12922b6dc43cbfb$export$2e2bcd8739ae039), {
        headerText: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuTitleText,
        dismissIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuDismissIconAriaLabel,
        backIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuBackIconAriaLabel,
        items: utilities.filter((utility, i)=>(!responsiveState.hideUtilities || responsiveState.hideUtilities.indexOf(i) !== -1) && !utility.disableUtilityCollapse),
        onClose: toggleOverflowMenu
    }))));
}


'use client';
function $a6eb6096d647f226$export$2e2bcd8739ae039({ utilities: utilities = [], ...restProps }) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('TopNavigation');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a7cb2c90d1e72da$export$2e2bcd8739ae039), {
        ...baseComponentProps,
        utilities: utilities,
        ...restProps
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($a6eb6096d647f226$export$2e2bcd8739ae039, 'TopNavigation');



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $d8475b95fcbdc3b7$export$24a86ef7798177e4 = "v1";
const $d8475b95fcbdc3b7$var$scheme = window.location.protocol;
let $d8475b95fcbdc3b7$var$_url = $d8475b95fcbdc3b7$var$scheme + "//" + window.location.host + window.location.pathname;
if (!$d8475b95fcbdc3b7$var$_url.endsWith("/")) $d8475b95fcbdc3b7$var$_url += "/";
const $d8475b95fcbdc3b7$export$ca6dda5263526f75 = $d8475b95fcbdc3b7$var$_url;
const $d8475b95fcbdc3b7$export$923ea8233b386e99 = `${$d8475b95fcbdc3b7$var$_url}api/${$d8475b95fcbdc3b7$export$24a86ef7798177e4}/`;


// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$O = Object;
var $5f9e38360d79f95a$var$getPrototypeOf = $5f9e38360d79f95a$var$O.getPrototypeOf;
var $5f9e38360d79f95a$var$CONSTRUCTOR = "constructor";
var $5f9e38360d79f95a$var$PROTOTYPE = "prototype";
var $5f9e38360d79f95a$var$CONFIGURABLE = "configurable";
var $5f9e38360d79f95a$var$ENUMERABLE = "enumerable";
var $5f9e38360d79f95a$var$WRITABLE = "writable";
var $5f9e38360d79f95a$var$VALUE = "value";
var $5f9e38360d79f95a$export$541ac630993a4c84 = (value)=>!!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || $5f9e38360d79f95a$var$isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value[$5f9e38360d79f95a$var$CONSTRUCTOR]) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE][$5f9e38360d79f95a$var$CONSTRUCTOR].toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || !$5f9e38360d79f95a$var$isObjectish(value)) return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null || proto === $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE]) return true;
    const Ctor = $5f9e38360d79f95a$var$O.hasOwnProperty.call(proto, $5f9e38360d79f95a$var$CONSTRUCTOR) && proto[$5f9e38360d79f95a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$5f9e38360d79f95a$var$isFunction(Ctor)) return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $5f9e38360d79f95a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : $5f9e38360d79f95a$var$isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $5f9e38360d79f95a$var$has = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $5f9e38360d79f95a$var$get = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $5f9e38360d79f95a$var$set = (thing, propOrOldValue, value, type = $5f9e38360d79f95a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $5f9e38360d79f95a$var$isArray = Array.isArray;
var $5f9e38360d79f95a$var$isMap = (target)=>target instanceof Map;
var $5f9e38360d79f95a$var$isSet = (target)=>target instanceof Set;
var $5f9e38360d79f95a$var$isObjectish = (target)=>typeof target === "object";
var $5f9e38360d79f95a$var$isFunction = (target)=>typeof target === "function";
var $5f9e38360d79f95a$var$isBoolean = (target)=>typeof target === "boolean";
function $5f9e38360d79f95a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $5f9e38360d79f95a$var$getProxyDraft = (value)=>{
    if (!$5f9e38360d79f95a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$5f9e38360d79f95a$var$DRAFT_STATE];
};
var $5f9e38360d79f95a$var$latest = (state)=>state.copy_ || state.base_;
var $5f9e38360d79f95a$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $5f9e38360d79f95a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if ($5f9e38360d79f95a$var$isArray(base)) return Array[$5f9e38360d79f95a$var$PROTOTYPE].slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $5f9e38360d79f95a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$5f9e38360d79f95a$var$WRITABLE] === false) {
                desc[$5f9e38360d79f95a$var$WRITABLE] = true;
                desc[$5f9e38360d79f95a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$5f9e38360d79f95a$var$CONFIGURABLE]: true,
                [$5f9e38360d79f95a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
                [$5f9e38360d79f95a$var$VALUE]: base[key]
            };
        }
        return $5f9e38360d79f95a$var$O.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = $5f9e38360d79f95a$var$O.create(proto);
        return $5f9e38360d79f95a$var$O.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) $5f9e38360d79f95a$var$O.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    $5f9e38360d79f95a$var$O.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>{
        $5f9e38360d79f95a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    [$5f9e38360d79f95a$var$VALUE]: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || !$5f9e38360d79f95a$var$isObjectish(obj)) return true;
    return $5f9e38360d79f95a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$PluginMapSet = "MapSet";
var $5f9e38360d79f95a$var$PluginPatches = "Patches";
var $5f9e38360d79f95a$var$PluginArrayMethods = "ArrayMethods";
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
var $5f9e38360d79f95a$var$isPluginLoaded = (pluginKey)=>!!$5f9e38360d79f95a$var$plugins[pluginKey];
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$getCurrentScope = ()=>$5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginMapSet) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginArrayMethods) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginArrayMethods) : void 0
    });
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
var $5f9e38360d79f95a$var$enterScope = (immer2)=>$5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) result = $5f9e38360d79f95a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft);
    $5f9e38360d79f95a$var$maybeFreeze(scope, result, true);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $5f9e38360d79f95a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
function $5f9e38360d79f95a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $5f9e38360d79f95a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT = [];
function $5f9e38360d79f95a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $5f9e38360d79f95a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $5f9e38360d79f95a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $5f9e38360d79f95a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $5f9e38360d79f95a$var$each(parentCopy, (key, value)=>{
            if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$5f9e38360d79f95a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
        $5f9e38360d79f95a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $5f9e38360d79f95a$var$markStateFinalized(state);
    }
}
function $5f9e38360d79f95a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
        const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
        if ($5f9e38360d79f95a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $5f9e38360d79f95a$var$prepareCopy(target);
            const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
            $5f9e38360d79f95a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $5f9e38360d79f95a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $5f9e38360d79f95a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($5f9e38360d79f95a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $5f9e38360d79f95a$var$handleValue($5f9e38360d79f95a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $5f9e38360d79f95a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(target) || handledSet.has(target) || !$5f9e38360d79f95a$export$16e3aed3edb85946(target) || $5f9e38360d79f95a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $5f9e38360d79f95a$var$each(target, (key, value)=>{
        if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
            const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
            if ($5f9e38360d79f95a$var$isSameScope(state, rootScope)) {
                const updatedValue = $5f9e38360d79f95a$var$getFinalValue(state);
                $5f9e38360d79f95a$var$set(target, key, updatedValue, target.type_);
                $5f9e38360d79f95a$var$markStateFinalized(state);
            }
        } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) $5f9e38360d79f95a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const baseIsArray = $5f9e38360d79f95a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop, state.type_)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $5f9e38360d79f95a$var$isArrayIndex(prop)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop, state.type_))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $5f9e38360d79f95a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $5f9e38360d79f95a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$5f9e38360d79f95a$var$WRITABLE]: true,
            [$5f9e38360d79f95a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
            [$5f9e38360d79f95a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
for(let key in $5f9e38360d79f95a$var$objectTraps){
    let fn = $5f9e38360d79f95a$var$objectTraps[key];
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? $5f9e38360d79f95a$var$VALUE in desc ? desc[$5f9e38360d79f95a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($5f9e38360d79f95a$var$isFunction(base) && !$5f9e38360d79f95a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$5f9e38360d79f95a$var$isFunction(recipe)) $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && !$5f9e38360d79f95a$var$isFunction(patchListener)) $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || !$5f9e38360d79f95a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($5f9e38360d79f95a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft($5f9e38360d79f95a$var$get(parentCopy, state.key_));
            const valueAtKey = $5f9e38360d79f95a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $5f9e38360d79f95a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $5f9e38360d79f95a$var$get(current2, key);
            if (!$5f9e38360d79f95a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$5f9e38360d79f95a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key, type_);
            const value = $5f9e38360d79f95a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $5f9e38360d79f95a$var$CONSTRUCTOR)) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if ($5f9e38360d79f95a$var$isFunction(base) && p === $5f9e38360d79f95a$var$PROTOTYPE) $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (!$5f9e38360d79f95a$var$isObjectish(base)) $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if ($5f9e38360d79f95a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $5f9e38360d79f95a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
                $5f9e38360d79f95a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($5f9e38360d79f95a$var$getValue(value));
            });
        }
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $5f9e38360d79f95a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        const result = operation();
        $5f9e38360d79f95a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $5f9e38360d79f95a$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c05b21e3257751e5 = (value)=>value;
var $5f9e38360d79f95a$export$20f911b3f8cf0b74 = (value)=>value;


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$emptyObject = {};
var $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    var uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


// Define the initial state using that type
const $e94319ab67c021b4$var$initialState = {
    messages: []
};
const $e94319ab67c021b4$export$77bb0165c25c314f = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "error",
    initialState: // `createSlice` will infer the state type from the `initialState` argument
    $e94319ab67c021b4$var$initialState,
    reducers: {
        addMessage: (state, action)=>{
            const id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
            const newPayload = {
                ...action.payload,
                id: id,
                dismissible: true,
                dismissLabel: "Dismiss message"
            };
            state.messages = [
                ...state.messages,
                newPayload
            ];
        },
        removeMessage: (state, action)=>{
            state.messages = state.messages.filter((message)=>message.id !== action.payload);
        }
    }
});
const { addMessage: $e94319ab67c021b4$export$16fdb433d434f08, removeMessage: $e94319ab67c021b4$export$f9a3c275d8ffdac0 } = $e94319ab67c021b4$export$77bb0165c25c314f.actions;
const $e94319ab67c021b4$export$31ff3874607c5ef8 = (state)=>state.messages;
var $e94319ab67c021b4$export$2e2bcd8739ae039 = $e94319ab67c021b4$export$77bb0165c25c314f.reducer;




const $b38651f901ccdd09$export$6f57813fe9f31bf9 = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: {
        messages: (0, $e94319ab67c021b4$export$2e2bcd8739ae039)
    }
});




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");










'use client';
const $d3c6170f3936b68b$var$Alert = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ type: type = 'info', visible: visible = true, style: style, ...props }, ref)=>{
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Alert', {
        props: {
            type: type,
            visible: visible,
            dismissible: props.dismissible
        }
    }, analyticsMetadata);
    const rootRef = (0, $acw62.useRef)(null);
    const __internalRootRef = (0, $013a2451794a45c0$exports.useMergeRefs)(rootRef, baseComponentProps.__internalRootRef);
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId, funnelErrorContext: funnelErrorContext, submissionAttempt: submissionAttempt, funnelState: funnelState, errorCount: errorCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepNumber: stepNumber, stepNameSelector: stepNameSelector, stepIdentifier: stepIdentifier, subStepCount: subStepCount, stepErrorContext: stepErrorContext, subStepConfiguration: subStepConfiguration } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector, subStepIdentifier: subStepIdentifier, subStepErrorContext: subStepErrorContext } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const messageSlotId = (0, $013a2451794a45c0$exports.useUniqueId)('alert-');
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c, _d, _e;
        if (funnelInteractionId && visible && type === 'error' && funnelState.current !== 'complete') {
            const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(subStepNameSelector);
            errorCount.current++;
            // We don't want to report an error if it is hidden, e.g. inside an Expandable Section.
            const errorIsVisible = ((_c = (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0) > 0;
            if (errorIsVisible) {
                if (subStepSelector) (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepError({
                    funnelInteractionId: funnelInteractionId,
                    funnelIdentifier: funnelIdentifier,
                    stepIdentifier: stepIdentifier,
                    subStepSelector: subStepSelector,
                    subStepName: subStepName,
                    subStepNameSelector: subStepNameSelector,
                    stepNumber: stepNumber,
                    stepName: stepName,
                    stepNameSelector: stepNameSelector,
                    subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                    subStepIdentifier: subStepIdentifier,
                    errorContext: analyticsMetadata.errorContext || subStepErrorContext
                });
                else if (stepNameSelector) (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepError({
                    funnelInteractionId: funnelInteractionId,
                    stepNumber: stepNumber,
                    stepNameSelector: stepNameSelector,
                    stepName: stepName,
                    stepIdentifier: stepIdentifier,
                    currentDocument: (_d = rootRef.current) === null || _d === void 0 ? void 0 : _d.ownerDocument,
                    totalSubSteps: subStepCount.current,
                    funnelIdentifier: funnelIdentifier,
                    subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                    errorContext: analyticsMetadata.errorContext || stepErrorContext,
                    subStepConfiguration: (_e = subStepConfiguration.current) === null || _e === void 0 ? void 0 : _e.get(stepNumber),
                    stepErrorSelector: '#' + messageSlotId
                });
                else (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelError({
                    funnelIdentifier: funnelIdentifier,
                    funnelInteractionId: funnelInteractionId,
                    errorContext: analyticsMetadata.errorContext || funnelErrorContext
                });
            }
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                errorCount.current--;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        funnelInteractionId,
        visible,
        submissionAttempt,
        errorCount
    ]);
    const componentAnalyticsMetadata = {
        name: 'awsui.Alert',
        label: `.${(0, $8b77acac91dd393c$export$2e2bcd8739ae039).header}`,
        properties: {
            type: type
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0572c3fe95cef167$export$2e2bcd8739ae039), {
        type: type,
        visible: visible,
        ...props,
        ...baseComponentProps,
        __internalRootRef: __internalRootRef,
        ref: ref,
        messageSlotId: messageSlotId,
        style: style,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticsMetadata
        })
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($d3c6170f3936b68b$var$Alert, 'Alert');
var $d3c6170f3936b68b$export$2e2bcd8739ae039 = $d3c6170f3936b68b$var$Alert;




const $1a8b0110371552e0$var$Alert = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    (0, $013a2451794a45c0$exports.validateProps)('Alert', props, [
        "persistenceConfig"
    ], {}, 'core');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d3c6170f3936b68b$export$2e2bcd8739ae039), {
        ref: ref,
        ...props
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($1a8b0110371552e0$var$Alert, 'Alert');
var $1a8b0110371552e0$export$2e2bcd8739ae039 = $1a8b0110371552e0$var$Alert;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




'use client';
const $9cee4eab59be790b$var$Button = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, iconName: iconName, iconAlign: iconAlign = 'left', iconUrl: iconUrl, iconSvg: iconSvg, iconAlt: iconAlt, variant: variant = 'normal', loading: loading = false, loadingText: loadingText, disabled: disabled = false, disabledReason: disabledReason, wrapText: wrapText = true, href: href, target: target, rel: rel, external: external = false, download: download, formAction: formAction = 'submit', ariaLabel: ariaLabel, ariaDescribedby: ariaDescribedby, onClick: onClick, onFollow: onFollow, ariaExpanded: ariaExpanded, ariaControls: ariaControls, fullWidth: fullWidth, form: form, i18nStrings: i18nStrings, style: style, nativeButtonAttributes: nativeButtonAttributes, nativeAnchorAttributes: nativeAnchorAttributes, ...props }, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Button', {
        props: {
            formAction: formAction,
            fullWidth: fullWidth,
            iconAlign: iconAlign,
            iconName: iconName,
            rel: rel,
            target: target,
            external: external,
            variant: variant,
            wrapText: wrapText
        },
        metadata: {
            hasDisabledReason: Boolean(disabledReason)
        }
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ...baseProps,
        ...baseComponentProps,
        ref: ref,
        iconName: iconName,
        iconAlign: iconAlign,
        iconUrl: iconUrl,
        iconSvg: iconSvg,
        iconAlt: iconAlt,
        variant: variant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        disabledReason: disabledReason,
        wrapText: wrapText,
        href: href,
        target: target,
        rel: rel,
        external: external,
        download: download,
        formAction: formAction,
        ariaLabel: ariaLabel,
        ariaDescribedby: ariaDescribedby,
        onClick: onClick,
        onFollow: onFollow,
        ariaExpanded: ariaExpanded,
        ariaControls: ariaControls,
        fullWidth: fullWidth,
        form: form,
        i18nStrings: i18nStrings,
        style: style,
        nativeButtonAttributes: nativeButtonAttributes,
        nativeAnchorAttributes: nativeAnchorAttributes,
        __injectAnalyticsComponentMetadata: true
    }, children);
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($9cee4eab59be790b$var$Button, 'Button');
var $9cee4eab59be790b$export$2e2bcd8739ae039 = $9cee4eab59be790b$var$Button;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







'use client';
function $60822fbe2c08caa5$export$2e2bcd8739ae039({ variant: variant = 'default', disableHeaderPaddings: disableHeaderPaddings = false, disableContentPaddings: disableContentPaddings = false, fitHeight: fitHeight = false, ...props }) {
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Container', {
        props: {
            disableContentPaddings: disableContentPaddings,
            disableHeaderPaddings: disableHeaderPaddings,
            fitHeight: fitHeight,
            variant: variant
        },
        metadata: {
            hasInstanceIdentifier: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier)
        }
    }, analyticsMetadata);
    const externalProps = (0, $3833f34df478664f$export$21af416108db3048)(props);
    const analyticsComponentMetadata = {
        name: 'awsui.Container',
        label: {
            root: 'self'
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$b1325661caf9fa0), {
        subStepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        subStepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$79c16a58b85ba6af), {
        variant: variant,
        disableContentPaddings: disableContentPaddings,
        disableHeaderPaddings: disableHeaderPaddings,
        fitHeight: fitHeight,
        ...props,
        ...externalProps,
        ...baseComponentProps,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: analyticsComponentMetadata
        })
    }));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($60822fbe2c08caa5$export$2e2bcd8739ae039, 'Container');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








var $fd157c50f7b7577d$export$2e2bcd8739ae039 = {
    "grid": "awsui_grid_14yj0_y2kz6_145",
    "no-gutters": "awsui_no-gutters_14yj0_y2kz6_181",
    "grid-column": "awsui_grid-column_14yj0_y2kz6_186",
    "colspan-1": "awsui_colspan-1_14yj0_y2kz6_197",
    "push-1": "awsui_push-1_14yj0_y2kz6_201",
    "pull-1": "awsui_pull-1_14yj0_y2kz6_204",
    "colspan-2": "awsui_colspan-2_14yj0_y2kz6_207",
    "push-2": "awsui_push-2_14yj0_y2kz6_211",
    "pull-2": "awsui_pull-2_14yj0_y2kz6_214",
    "colspan-3": "awsui_colspan-3_14yj0_y2kz6_217",
    "push-3": "awsui_push-3_14yj0_y2kz6_221",
    "pull-3": "awsui_pull-3_14yj0_y2kz6_224",
    "colspan-4": "awsui_colspan-4_14yj0_y2kz6_227",
    "push-4": "awsui_push-4_14yj0_y2kz6_231",
    "pull-4": "awsui_pull-4_14yj0_y2kz6_234",
    "colspan-5": "awsui_colspan-5_14yj0_y2kz6_237",
    "push-5": "awsui_push-5_14yj0_y2kz6_241",
    "pull-5": "awsui_pull-5_14yj0_y2kz6_244",
    "colspan-6": "awsui_colspan-6_14yj0_y2kz6_247",
    "push-6": "awsui_push-6_14yj0_y2kz6_251",
    "pull-6": "awsui_pull-6_14yj0_y2kz6_254",
    "colspan-7": "awsui_colspan-7_14yj0_y2kz6_257",
    "push-7": "awsui_push-7_14yj0_y2kz6_261",
    "pull-7": "awsui_pull-7_14yj0_y2kz6_264",
    "colspan-8": "awsui_colspan-8_14yj0_y2kz6_267",
    "push-8": "awsui_push-8_14yj0_y2kz6_271",
    "pull-8": "awsui_pull-8_14yj0_y2kz6_274",
    "colspan-9": "awsui_colspan-9_14yj0_y2kz6_277",
    "push-9": "awsui_push-9_14yj0_y2kz6_281",
    "pull-9": "awsui_pull-9_14yj0_y2kz6_284",
    "colspan-10": "awsui_colspan-10_14yj0_y2kz6_287",
    "push-10": "awsui_push-10_14yj0_y2kz6_291",
    "pull-10": "awsui_pull-10_14yj0_y2kz6_294",
    "colspan-11": "awsui_colspan-11_14yj0_y2kz6_297",
    "push-11": "awsui_push-11_14yj0_y2kz6_301",
    "pull-11": "awsui_pull-11_14yj0_y2kz6_304",
    "colspan-12": "awsui_colspan-12_14yj0_y2kz6_307",
    "push-12": "awsui_push-12_14yj0_y2kz6_311",
    "pull-12": "awsui_pull-12_14yj0_y2kz6_314",
    "push-0": "awsui_push-0_14yj0_y2kz6_317",
    "pull-0": "awsui_pull-0_14yj0_y2kz6_320",
    "offset-1": "awsui_offset-1_14yj0_y2kz6_323",
    "offset-2": "awsui_offset-2_14yj0_y2kz6_326",
    "offset-3": "awsui_offset-3_14yj0_y2kz6_329",
    "offset-4": "awsui_offset-4_14yj0_y2kz6_332",
    "offset-5": "awsui_offset-5_14yj0_y2kz6_335",
    "offset-6": "awsui_offset-6_14yj0_y2kz6_338",
    "offset-7": "awsui_offset-7_14yj0_y2kz6_341",
    "offset-8": "awsui_offset-8_14yj0_y2kz6_344",
    "offset-9": "awsui_offset-9_14yj0_y2kz6_347",
    "offset-10": "awsui_offset-10_14yj0_y2kz6_350",
    "offset-11": "awsui_offset-11_14yj0_y2kz6_353",
    "restore-pointer-events": "awsui_restore-pointer-events_14yj0_y2kz6_357"
};


const $533fd63a0264232f$var$InternalGrid = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ __breakpoint: __breakpoint, gridDefinition: gridDefinition = [], disableGutters: disableGutters = false, children: children, __tagOverride: __tagOverride, __responsiveClassName: __responsiveClassName, __internalRootRef: __internalRootRef, ...restProps }, ref)=>{
    let [defaultBreakpoint, defaultRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)(undefined);
    if (__breakpoint !== undefined) {
        defaultBreakpoint = __breakpoint;
        defaultRef = ref;
    }
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    /*
   Flattening the children allows us to "see through" React Fragments and nested arrays.
   */ const flattenedChildren = (0, $ba51633932c6dcad$export$ad59fee0807e8d38)(children, 'Grid');
    const Tag = __tagOverride !== null && __tagOverride !== void 0 ? __tagOverride : 'div';
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        const columnCount = gridDefinition.length;
        const childCount = flattenedChildren.length;
        if (columnCount !== childCount) (0, $013a2451794a45c0$exports.warnOnce)('Grid', `The number of children (${childCount}) does not match the number of columns defined (${columnCount}).`);
    }
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(defaultRef, __internalRootRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fd157c50f7b7577d$export$2e2bcd8739ae039).grid, baseProps.className, {
            [(0, $fd157c50f7b7577d$export$2e2bcd8739ae039)['no-gutters']]: disableGutters
        }, __responsiveClassName ? __responsiveClassName(defaultBreakpoint) : null),
        ref: mergedRef
    }, flattenedChildren.map((child, i)=>{
        var _a, _b, _c, _d;
        // If this react child is a primitive value, the key will be undefined
        const key = child && typeof child === 'object' ? child.key : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ? String(key) : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fd157c50f7b7577d$export$2e2bcd8739ae039)['grid-column'], $533fd63a0264232f$var$getColumnClassNames('colspan', (_a = gridDefinition[i]) === null || _a === void 0 ? void 0 : _a.colspan, defaultBreakpoint), $533fd63a0264232f$var$getColumnClassNames('offset', (_b = gridDefinition[i]) === null || _b === void 0 ? void 0 : _b.offset, defaultBreakpoint), $533fd63a0264232f$var$getColumnClassNames('pull', (_c = gridDefinition[i]) === null || _c === void 0 ? void 0 : _c.pull, defaultBreakpoint), $533fd63a0264232f$var$getColumnClassNames('push', (_d = gridDefinition[i]) === null || _d === void 0 ? void 0 : _d.push, defaultBreakpoint))
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $fd157c50f7b7577d$export$2e2bcd8739ae039)['restore-pointer-events']
        }, child));
    }));
});
function $533fd63a0264232f$var$getColumnClassNames(prop, mapping, breakpoint) {
    if (typeof mapping === 'number') return (0, $fd157c50f7b7577d$export$2e2bcd8739ae039)[`${prop}-${mapping}`];
    if (breakpoint === null || mapping === undefined) return null;
    return (0, $fd157c50f7b7577d$export$2e2bcd8739ae039)[`${prop}-${(0, $1be283cfa47851a8$export$1decca26c2f3798f)(mapping, breakpoint)}`];
}
var $533fd63a0264232f$export$2e2bcd8739ae039 = $533fd63a0264232f$var$InternalGrid;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $26604b8e35e1a00b$export$fd4f28634267f02(props) {
    var _a;
    const disabled = (_a = props === null || props === void 0 ? void 0 : props.disabled) !== null && _a !== void 0 ? _a : false;
    const setDynamicOverlapHeight = (0, $acw62.useContext)((0, $011bca9bf46093da$export$70fcc38162d125af));
    const overlapElementRef = (0, $acw62.useRef)(null);
    const getElement = (0, $acw62.useCallback)(()=>overlapElementRef.current, [
        overlapElementRef
    ]);
    const updateState = (0, $acw62.useCallback)((entry)=>{
        if (!disabled) setDynamicOverlapHeight(entry.contentBoxHeight);
    }, [
        disabled,
        setDynamicOverlapHeight
    ]);
    (0, $013a2451794a45c0$exports.useResizeObserver)(getElement, updateState);
    (0, $acw62.useLayoutEffect)(function handleDynamicOverlapHeight() {
        // Set overlap height back to 0 when unmounting
        return ()=>{
            if (!disabled) setDynamicOverlapHeight(0);
        };
    }, [
        disabled,
        setDynamicOverlapHeight
    ]);
    return overlapElementRef;
}





var $f6419952c58a2c60$export$2e2bcd8739ae039 = {
    "layout": "awsui_layout_5gtk3_1xlyi_145",
    "background": "awsui_background_5gtk3_1xlyi_159",
    "is-overlap-disabled": "awsui_is-overlap-disabled_5gtk3_1xlyi_164",
    "header-background": "awsui_header-background_5gtk3_1xlyi_167",
    "notifications": "awsui_notifications_5gtk3_1xlyi_171",
    "breadcrumbs": "awsui_breadcrumbs_5gtk3_1xlyi_176",
    "default-padding": "awsui_default-padding_5gtk3_1xlyi_181",
    "header-wrapper": "awsui_header-wrapper_5gtk3_1xlyi_185",
    "with-divider": "awsui_with-divider_5gtk3_1xlyi_190",
    "content": "awsui_content_5gtk3_1xlyi_193",
    "has-header": "awsui_has-header_5gtk3_1xlyi_197",
    "is-visual-refresh": "awsui_is-visual-refresh_5gtk3_1xlyi_204",
    "has-default-background": "awsui_has-default-background_5gtk3_1xlyi_204",
    "has-notifications": "awsui_has-notifications_5gtk3_1xlyi_208"
};



var $998cfd68a29f6d17$export$2e2bcd8739ae039 = {
    "header": "awsui_header_64tge_1scxg_5",
    "secondary-header": "awsui_secondary-header_64tge_1scxg_9",
    "notifications": "awsui_notifications_64tge_1scxg_13",
    "breadcrumbs": "awsui_breadcrumbs_64tge_1scxg_17"
};


const $64e035e8b8dcf6cb$var$halfGeckoMaxCssLength = (1073741824 - 1) / 120;
function $64e035e8b8dcf6cb$export$2e2bcd8739ae039({ children: children, disableOverlap: disableOverlap, header: header, headerVariant: headerVariant = 'default', headerBackgroundStyle: headerBackgroundStyle, __internalRootRef: __internalRootRef, maxContentWidth: maxContentWidth = Number.MAX_VALUE, breadcrumbs: breadcrumbs, notifications: notifications, defaultPadding: defaultPadding, secondaryHeader: secondaryHeader, ...rest }) {
    const mainRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(mainRef, __internalRootRef);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const mode = (0, $013a2451794a45c0$exports.useCurrentMode)(mainRef);
    const overlapElement = (0, $26604b8e35e1a00b$export$fd4f28634267f02)();
    const isOverlapDisabled = !children || disableOverlap;
    const contentHeaderClassName = headerVariant === 'high-contrast' && isVisualRefresh ? (0, $9c98cc94ae829c40$export$ebd33a9e3a891abd) : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $f6419952c58a2c60$export$2e2bcd8739ae039).layout, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['is-overlap-disabled']]: isOverlapDisabled,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['is-visual-refresh']]: isVisualRefresh,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['has-header']]: !!header,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['default-padding']]: !!defaultPadding,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['has-notifications']]: !!notifications
        }),
        style: {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).contentLayoutMaxContentWidth]: maxContentWidth < Number.MAX_VALUE ? `${maxContentWidth}px` : `${$64e035e8b8dcf6cb$var$halfGeckoMaxCssLength}px`
        },
        ref: mergedRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).background, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['has-default-background']]: !headerBackgroundStyle
        }, contentHeaderClassName),
        ref: overlapElement
    }, headerBackgroundStyle && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f6419952c58a2c60$export$2e2bcd8739ae039)['header-background'],
        style: {
            background: typeof headerBackgroundStyle === 'function' ? headerBackgroundStyle(mode) : headerBackgroundStyle
        }
    })), notifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).notifications, (0, $998cfd68a29f6d17$export$2e2bcd8739ae039).notifications, contentHeaderClassName)
    }, notifications), breadcrumbs && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).breadcrumbs, (0, $998cfd68a29f6d17$export$2e2bcd8739ae039).breadcrumbs, contentHeaderClassName)
    }, breadcrumbs), header && !secondaryHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039)['header-wrapper'], (0, $998cfd68a29f6d17$export$2e2bcd8739ae039).header, contentHeaderClassName, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['with-divider']]: headerVariant === 'divider'
        })
    }, header), header && secondaryHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039)['header-wrapper'], {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['with-divider']]: headerVariant === 'divider'
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), {
        gridDefinition: [
            {
                colspan: {
                    default: 12,
                    xs: 9
                }
            },
            {
                colspan: {
                    default: 12,
                    xs: 3
                }
            }
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $998cfd68a29f6d17$export$2e2bcd8739ae039).header, contentHeaderClassName)
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $998cfd68a29f6d17$export$2e2bcd8739ae039)['secondary-header']
    }, secondaryHeader))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).content, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)['with-divider']]: headerVariant === 'divider'
        })
    }, children));
}


'use client';
function $1c3c7a1fd2ca4107$export$2e2bcd8739ae039(props) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('ContentLayout', {
        props: {
            disableOverlap: props.disableOverlap
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $64e035e8b8dcf6cb$export$2e2bcd8739ae039), {
        ...props,
        ...baseComponentProps
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($1c3c7a1fd2ca4107$export$2e2bcd8739ae039, 'ContentLayout');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









var $d59174f9693a9a56$export$2e2bcd8739ae039 = {
    "root": "awsui_root_6xiez_bfzb6_5",
    "header": "awsui_header_6xiez_bfzb6_6"
};



var $a8ac619624564433$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1i0s3_sdppn_145",
    "header": "awsui_header_1i0s3_sdppn_177",
    "content": "awsui_content_1i0s3_sdppn_181",
    "error": "awsui_error_1i0s3_sdppn_185",
    "footer": "awsui_footer_1i0s3_sdppn_189",
    "actions-section": "awsui_actions-section_1i0s3_sdppn_193",
    "secondary-actions": "awsui_secondary-actions_1i0s3_sdppn_202",
    "actions": "awsui_actions_1i0s3_sdppn_193"
};


function $a0d286337a97b9da$export$2e2bcd8739ae039({ children: children, header: header, errorText: errorText, errorIconAriaLabel: errorIconAriaLabelOverride, actions: actions, secondaryActions: secondaryActions, __internalRootRef: __internalRootRef, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, __errorSlotId: __errorSlotId, ...props }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('form');
    const errorIconAriaLabel = i18n('errorIconAriaLabel', errorIconAriaLabelOverride);
    const analyticsComponentMetadata = {
        component: {
            name: 'awsui.Form',
            label: {
                selector: [
                    'h1',
                    'h2',
                    'h3'
                ].map((heading)=>`.${(0, $d59174f9693a9a56$export$2e2bcd8739ae039).header} ${heading}`)
            }
        }
    };
    return(// We suppress nested error boundaries so that if there is an unexpected error inside the form - the entire form
    // will be replaced with a fallback message. That is to ensure that no part of the form can crash without the user
    // noticing that, as then a part of the form data might not get submitted.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), {
        suppressNested: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a8ac619624564433$export$2e2bcd8739ae039).root, (0, $d59174f9693a9a56$export$2e2bcd8739ae039).root, baseProps.className),
        ...__injectAnalyticsComponentMetadata ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsComponentMetadata) : {}
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a8ac619624564433$export$2e2bcd8739ae039).header, (0, $d59174f9693a9a56$export$2e2bcd8739ae039).header)
    }, header), children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).content
    }, children), errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        margin: {
            top: 'l'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0572c3fe95cef167$export$2e2bcd8739ae039), {
        type: "error",
        statusIconAriaLabel: errorIconAriaLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).error,
        id: __errorSlotId
    }, errorText))), (actions || secondaryActions) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).footer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039)['actions-section']
    }, actions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).actions
    }, actions), secondaryActions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039)['secondary-actions']
    }, secondaryActions))), errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        hidden: true,
        tagName: "span",
        assertive: true
    }, errorIconAriaLabel, ", ", errorText))));
}




'use client';
const $3128a80b6a88093c$var$FormWithAnalytics = ({ variant: variant = 'full-page', actions: actions, errorText: errorText, __internalRootRef: __internalRootRef, ...props })=>{
    const rootRef = (0, $acw62.useRef)(null);
    const ref = (0, $013a2451794a45c0$exports.useMergeRefs)(rootRef, __internalRootRef);
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId, funnelProps: funnelProps, funnelSubmit: funnelSubmit, funnelNextOrSubmitAttempt: funnelNextOrSubmitAttempt, errorCount: errorCount, submissionAttempt: submissionAttempt, funnelErrorContext: funnelErrorContext } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const funnelStepInfo = (0, $777318d005be2fce$export$987fbbaf76a9f8ac)();
    const handleActionButtonClick = ({ variant: variant })=>{
        if (variant === 'primary') {
            funnelNextOrSubmitAttempt();
            funnelSubmit();
        }
    };
    const errorSlotId = (0, $013a2451794a45c0$exports.useUniqueId)('form-error-');
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        if (funnelInteractionId && errorText) {
            errorCount.current++;
            const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(funnelStepInfo.current.stepNameSelector);
            (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepError({
                funnelInteractionId: funnelInteractionId,
                stepNumber: funnelStepInfo.current.stepNumber,
                stepNameSelector: funnelStepInfo.current.stepNameSelector,
                stepName: stepName,
                stepIdentifier: funnelStepInfo.current.stepIdentifier,
                currentDocument: (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument,
                totalSubSteps: funnelStepInfo.current.subStepCount.current,
                funnelIdentifier: funnelIdentifier,
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                errorContext: funnelStepInfo.current.stepErrorContext,
                subStepConfiguration: (_b = funnelStepInfo.current.subStepConfiguration.current) === null || _b === void 0 ? void 0 : _b.get(funnelStepInfo.current.stepNumber),
                stepErrorSelector: '#' + errorSlotId
            });
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                errorCount.current--;
            };
        }
    }, [
        funnelInteractionId,
        funnelIdentifier,
        errorText,
        submissionAttempt,
        errorCount,
        funnelErrorContext,
        errorSlotId,
        funnelStepInfo
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edea5ac281b34b48$export$24d547caef80ccd1).Provider, {
        value: {
            onClick: handleActionButtonClick
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0d286337a97b9da$export$2e2bcd8739ae039), {
        variant: variant,
        actions: actions,
        errorText: errorText,
        __errorSlotId: errorSlotId,
        ...props,
        ...funnelProps,
        ...funnelStepInfo.current.funnelStepProps,
        __internalRootRef: ref,
        __injectAnalyticsComponentMetadata: true
    }));
};
function $3128a80b6a88093c$export$2e2bcd8739ae039({ variant: variant = 'full-page', ...props }) {
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Form', {
        props: {
            variant: variant,
            flowType: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.flowType
        },
        metadata: {
            hasResourceType: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.resourceType),
            hasInstanceIdentifier: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier)
        }
    }, analyticsMetadata);
    const inheritedFunnelNameSelector = (0, $777318d005be2fce$export$330d990b59bc48da)();
    const funnelNameSelector = inheritedFunnelNameSelector || `.${(0, $d59174f9693a9a56$export$2e2bcd8739ae039).header} .${(0, $962e3f40ddca05f8$export$2e2bcd8739ae039)['heading-text']}`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$467468afd0d320b9), {
        funnelIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        funnelFlowType: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.flowType,
        funnelErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext,
        funnelResourceType: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.resourceType,
        funnelType: "single-page",
        optionalStepNumbers: [],
        totalFunnelSteps: 1,
        funnelNameSelectors: ()=>[
                funnelNameSelector,
                `.${(0, $d59174f9693a9a56$export$2e2bcd8739ae039).header}`
            ],
        componentSelectors: ()=>[
                `.${(0, $d59174f9693a9a56$export$2e2bcd8739ae039).root}`
            ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$3fa82ebb4c38684d), {
        stepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        stepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext,
        stepNumber: 1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3128a80b6a88093c$var$FormWithAnalytics, {
        variant: variant,
        ...props,
        ...baseComponentProps
    })));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($3128a80b6a88093c$export$2e2bcd8739ae039, 'Form');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");















function $31fd7deea6fab642$var$makeSlotId(prop, formFieldId, propName) {
    if (!prop) return undefined;
    return `${formFieldId}-${propName}`;
}
function $31fd7deea6fab642$export$c24c1edd02a696d0(formFieldId, label, description, constraintText, errorText, warningText) {
    const ids = {
        label: $31fd7deea6fab642$var$makeSlotId(label, formFieldId, 'label'),
        description: $31fd7deea6fab642$var$makeSlotId(description, formFieldId, 'description'),
        constraint: $31fd7deea6fab642$var$makeSlotId(constraintText, formFieldId, 'constraint'),
        error: $31fd7deea6fab642$var$makeSlotId(errorText, formFieldId, 'error'),
        warning: $31fd7deea6fab642$var$makeSlotId(warningText, formFieldId, 'warning')
    };
    return ids;
}
function $31fd7deea6fab642$export$65ef0a02533e7bf7({ error: error, warning: warning, description: description, constraint: constraint }) {
    const describedByAttributes = [
        error,
        warning,
        description,
        constraint
    ].filter((e)=>!!e);
    const describedBy = describedByAttributes.length ? describedByAttributes.join(' ') : undefined;
    return describedBy;
}
function $31fd7deea6fab642$export$8192ce047e6259ae(stretch, secondaryControlPresent, isRefresh) {
    let columns;
    if (stretch) columns = [
        {
            colspan: 12
        },
        {
            colspan: 12
        }
    ];
    else if (isRefresh) columns = [
        {
            colspan: {
                default: 12,
                xs: 8
            }
        },
        {
            colspan: {
                default: 12,
                xs: 4
            }
        }
    ];
    else columns = [
        {
            colspan: {
                default: 12,
                xs: 9
            }
        },
        {
            colspan: {
                default: 12,
                xs: 3
            }
        }
    ];
    if (!secondaryControlPresent) return [
        columns[0]
    ];
    return columns;
}



var $9f04880c7d790163$export$2e2bcd8739ae039 = {
    "label": "awsui_label_aqu00_ocied_5"
};



var $a106f54d44afb8cf$export$2e2bcd8739ae039 = {
    "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_fzxwy_153",
    "warning-icon-shake-wrapper": "awsui_warning-icon-shake-wrapper_14mhv_fzxwy_154",
    "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_fzxwy_1",
    "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_fzxwy_184",
    "warning-icon-scale-wrapper": "awsui_warning-icon-scale-wrapper_14mhv_fzxwy_185",
    "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_fzxwy_1",
    "warning": "awsui_warning_14mhv_fzxwy_154",
    "error": "awsui_error_14mhv_fzxwy_153",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_fzxwy_1",
    "root": "awsui_root_14mhv_fzxwy_236",
    "label": "awsui_label_14mhv_fzxwy_269",
    "info": "awsui_info_14mhv_fzxwy_285",
    "description": "awsui_description_14mhv_fzxwy_291",
    "constraint": "awsui_constraint_14mhv_fzxwy_292",
    "hints": "awsui_hints_14mhv_fzxwy_299",
    "constraint-has-validation-text": "awsui_constraint-has-validation-text_14mhv_fzxwy_300",
    "secondary-control": "awsui_secondary-control_14mhv_fzxwy_304",
    "controls": "awsui_controls_14mhv_fzxwy_308",
    "label-hidden": "awsui_label-hidden_14mhv_fzxwy_308",
    "label-wrapper": "awsui_label-wrapper_14mhv_fzxwy_311",
    "control": "awsui_control_14mhv_fzxwy_308",
    "error__message": "awsui_error__message_14mhv_fzxwy_338",
    "warning__message": "awsui_warning__message_14mhv_fzxwy_339",
    "visually-hidden": "awsui_visually-hidden_14mhv_fzxwy_343"
};


function $7e58f0606af63724$export$4852ecce5ecf6bcb({ id: id, children: children, errorIconAriaLabel: errorIconAriaLabel }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('form-field');
    const contentRef = (0, $acw62.useRef)(null);
    const i18nErrorIconAriaLabel = i18n('i18nStrings.errorIconAriaLabel', errorIconAriaLabel);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).error
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['error-icon-shake-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['error-icon-scale-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "status-negative",
        size: "small",
        ariaLabel: i18nErrorIconAriaLabel
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).error__message,
        ref: contentRef
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        assertive: true,
        tagName: "span",
        sources: [
            i18nErrorIconAriaLabel,
            contentRef
        ]
    }));
}
function $7e58f0606af63724$export$7f93a80d0cfdba0c({ id: id, children: children, warningIconAriaLabel: warningIconAriaLabel }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('form-field');
    const contentRef = (0, $acw62.useRef)(null);
    const i18nWarningIconAriaLabel = i18n('i18nStrings.warningIconAriaLabel', warningIconAriaLabel);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).warning
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['warning-icon-shake-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['warning-icon-scale-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "status-warning",
        size: "small",
        ariaLabel: i18nWarningIconAriaLabel
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).warning__message,
        ref: contentRef
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        assertive: true,
        tagName: "span",
        sources: [
            i18nWarningIconAriaLabel,
            contentRef
        ]
    }));
}
function $7e58f0606af63724$export$d907c2d8d9ae85b4({ id: id, hasValidationText: hasValidationText, children: children }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a106f54d44afb8cf$export$2e2bcd8739ae039).constraint, hasValidationText && (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['constraint-has-validation-text'])
    }, children);
}
function $7e58f0606af63724$export$2e2bcd8739ae039({ controlId: controlId, stretch: stretch = false, label: label, info: info, i18nStrings: i18nStrings, children: children, secondaryControl: secondaryControl, description: description, constraintText: constraintText, errorText: errorText, warningText: warningText, __hideLabel: __hideLabel, __internalRootRef: __internalRootRef, __disableGutters: __disableGutters = false, __analyticsMetadata: __analyticsMetadata, __style: __style = {}, ...rest }) {
    const rootRef = (0, $acw62.useRef)();
    const ref = (0, $013a2451794a45c0$exports.useMergeRefs)(rootRef, __internalRootRef);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const instanceUniqueId = (0, $013a2451794a45c0$exports.useUniqueId)('formField');
    const generatedControlId = controlId || instanceUniqueId;
    const formFieldId = controlId || generatedControlId;
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId, submissionAttempt: submissionAttempt, funnelState: funnelState, errorCount: errorCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepIdentifier: stepIdentifier, stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepIdentifier: subStepIdentifier, subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const showWarning = warningText && !errorText;
    if (warningText && errorText) (0, $013a2451794a45c0$exports.warnOnce)('FileUpload', 'Both `errorText` and `warningText` exist. `warningText` will not be shown.');
    const slotIds = (0, $31fd7deea6fab642$export$c24c1edd02a696d0)(formFieldId, label, description, constraintText, errorText, showWarning ? warningText : undefined);
    const ariaDescribedBy = (0, $31fd7deea6fab642$export$65ef0a02533e7bf7)(slotIds);
    const gridDefinition = (0, $31fd7deea6fab642$export$8192ce047e6259ae)(stretch, !!secondaryControl, isRefresh);
    const { ariaLabelledby: parentAriaLabelledby, ariaDescribedby: parentAriaDescribedby, invalid: parentInvalid, warning: parentWarning } = (0, $4a30639b463663e4$export$824c400da192ca1b)({});
    const contextValuesWithoutControlId = {
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(parentAriaLabelledby, slotIds.label) || undefined,
        ariaDescribedby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(parentAriaDescribedby, ariaDescribedBy) || undefined,
        invalid: !!errorText || !!parentInvalid,
        warning: !!warningText && !errorText || !!parentWarning && !parentInvalid
    };
    const analyticsAttributes = {
        [(0, $285a09b860d2bebc$export$7f7018c0ba6d811a)]: slotIds.label ? (0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.label) : undefined,
        [(0, $285a09b860d2bebc$export$374a078abad6179f)]: slotIds.error ? (0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.error) : undefined
    };
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c;
        if (funnelInteractionId && errorText && funnelState.current !== 'complete') {
            const stepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$e6ab0626c6ca0272)(subStepNameSelector);
            errorCount.current++;
            // We don't want to report an error if it is hidden, e.g. inside an Expandable Section.
            const errorIsVisible = ((_c = (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0) > 0;
            if (errorIsVisible) (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepError({
                funnelInteractionId: funnelInteractionId,
                funnelIdentifier: funnelIdentifier,
                subStepSelector: subStepSelector,
                subStepName: subStepName,
                subStepNameSelector: subStepNameSelector,
                subStepIdentifier: subStepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                stepIdentifier: stepIdentifier,
                fieldErrorSelector: `${(0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.error)} .${(0, $a106f54d44afb8cf$export$2e2bcd8739ae039).error__message}`,
                fieldLabelSelector: (0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.label),
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                fieldIdentifier: __analyticsMetadata === null || __analyticsMetadata === void 0 ? void 0 : __analyticsMetadata.instanceIdentifier,
                errorContext: __analyticsMetadata === null || __analyticsMetadata === void 0 ? void 0 : __analyticsMetadata.errorContext
            });
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                errorCount.current--;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        funnelInteractionId,
        errorText,
        submissionAttempt,
        errorCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).root),
        style: __style,
        ref: ref,
        ...analyticsAttributes,
        ...(0, $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute)(rest)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['label-wrapper'], __hideLabel && (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['visually-hidden'])
    }, label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a106f54d44afb8cf$export$2e2bcd8739ae039).label, (0, $9f04880c7d790163$export$2e2bcd8739ae039).label),
        id: slotIds.label,
        htmlFor: generatedControlId
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edb6222f981e45e4$export$8ffd2daeac4a0391).Provider, {
        value: slotIds.label
    }, !__hideLabel && info && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).info
    }, info))), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).description,
        id: slotIds.description
    }, description), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a106f54d44afb8cf$export$2e2bcd8739ae039).controls, __hideLabel && (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['label-hidden'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), {
        gridDefinition: gridDefinition,
        disableGutters: __disableGutters
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a30639b463663e4$export$8af1424ebe35bf26).Provider, {
        value: {
            controlId: generatedControlId,
            ...contextValuesWithoutControlId
        }
    }, children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).control
    }, children)), secondaryControl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a30639b463663e4$export$8af1424ebe35bf26).Provider, {
        value: contextValuesWithoutControlId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)['secondary-control']
    }, secondaryControl)))), (constraintText || errorText || warningText) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).hints
    }, errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e58f0606af63724$export$4852ecce5ecf6bcb, {
        id: slotIds.error,
        errorIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel
    }, errorText), showWarning && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e58f0606af63724$export$7f93a80d0cfdba0c, {
        id: slotIds.warning,
        warningIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel
    }, warningText), constraintText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e58f0606af63724$export$d907c2d8d9ae85b4, {
        id: slotIds.constraint,
        hasValidationText: !!errorText || !!warningText
    }, constraintText)));
}



'use client';
function $d07d035b542ec3e4$export$2e2bcd8739ae039({ stretch: stretch = false, ...props }) {
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('FormField', {
        props: {
            stretch: stretch
        },
        metadata: {
            hasInstanceIdentifier: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier),
            hasErrorContext: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext)
        }
    }, analyticsMetadata);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        stretch: stretch,
        ...props,
        __hideLabel: false,
        __analyticsMetadata: analyticsMetadata,
        ...baseComponentProps,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: {
                name: 'awsui.FormField',
                label: `.${(0, $9f04880c7d790163$export$2e2bcd8739ae039).label}`
            }
        })
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($d07d035b542ec3e4$export$2e2bcd8739ae039, 'FormField');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



'use client';
function $417cbce8ab3dcc04$export$2e2bcd8739ae039({ variant: variant = 'h2', ...props }) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Header', {
        props: {
            headingTagOverride: props.headingTagOverride,
            variant: variant
        }
    });
    /**
     * We are adding a special tabindex -1 for heading variant h1 to allow the focus behavior of flashbars
     * when closed to programmatically focus the h1 after the last item is closed.
     */ const tabIndex = variant === 'h1' ? -1 : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$2e2bcd8739ae039), {
        __headingTagTabIndex: tabIndex,
        variant: variant,
        ...props,
        ...baseComponentProps
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($417cbce8ab3dcc04$export$2e2bcd8739ae039, 'Header');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $33e7e05d308de989$export$42752b7c8e044245(style, requireRoot = false) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return undefined;
    if (requireRoot && !(style === null || style === void 0 ? void 0 : style.root)) return undefined;
    return {
        borderRadius: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.borderRadius,
        borderWidth: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderWidth,
        fontSize: (_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.fontSize,
        fontWeight: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.fontWeight,
        paddingBlock: (_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.paddingBlock,
        paddingInline: (_f = style === null || style === void 0 ? void 0 : style.root) === null || _f === void 0 ? void 0 : _f.paddingInline,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundDefault]: (_h = (_g = style === null || style === void 0 ? void 0 : style.root) === null || _g === void 0 ? void 0 : _g.backgroundColor) === null || _h === void 0 ? void 0 : _h.default,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundDisabled]: (_k = (_j = style === null || style === void 0 ? void 0 : style.root) === null || _j === void 0 ? void 0 : _j.backgroundColor) === null || _k === void 0 ? void 0 : _k.disabled,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundHover]: (_m = (_l = style === null || style === void 0 ? void 0 : style.root) === null || _l === void 0 ? void 0 : _l.backgroundColor) === null || _m === void 0 ? void 0 : _m.hover,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundFocus]: (_p = (_o = style === null || style === void 0 ? void 0 : style.root) === null || _o === void 0 ? void 0 : _o.backgroundColor) === null || _p === void 0 ? void 0 : _p.focus,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundReadonly]: (_r = (_q = style === null || style === void 0 ? void 0 : style.root) === null || _q === void 0 ? void 0 : _q.backgroundColor) === null || _r === void 0 ? void 0 : _r.readonly,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorDefault]: (_t = (_s = style === null || style === void 0 ? void 0 : style.root) === null || _s === void 0 ? void 0 : _s.borderColor) === null || _t === void 0 ? void 0 : _t.default,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorDisabled]: (_v = (_u = style === null || style === void 0 ? void 0 : style.root) === null || _u === void 0 ? void 0 : _u.borderColor) === null || _v === void 0 ? void 0 : _v.disabled,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorHover]: (_x = (_w = style === null || style === void 0 ? void 0 : style.root) === null || _w === void 0 ? void 0 : _w.borderColor) === null || _x === void 0 ? void 0 : _x.hover,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorFocus]: (_z = (_y = style === null || style === void 0 ? void 0 : style.root) === null || _y === void 0 ? void 0 : _y.borderColor) === null || _z === void 0 ? void 0 : _z.focus,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorReadonly]: (_1 = (_0 = style === null || style === void 0 ? void 0 : style.root) === null || _0 === void 0 ? void 0 : _0.borderColor) === null || _1 === void 0 ? void 0 : _1.readonly,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowDefault]: (_3 = (_2 = style === null || style === void 0 ? void 0 : style.root) === null || _2 === void 0 ? void 0 : _2.boxShadow) === null || _3 === void 0 ? void 0 : _3.default,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowDisabled]: (_5 = (_4 = style === null || style === void 0 ? void 0 : style.root) === null || _4 === void 0 ? void 0 : _4.boxShadow) === null || _5 === void 0 ? void 0 : _5.disabled,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowHover]: (_7 = (_6 = style === null || style === void 0 ? void 0 : style.root) === null || _6 === void 0 ? void 0 : _6.boxShadow) === null || _7 === void 0 ? void 0 : _7.hover,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowFocus]: (_9 = (_8 = style === null || style === void 0 ? void 0 : style.root) === null || _8 === void 0 ? void 0 : _8.boxShadow) === null || _9 === void 0 ? void 0 : _9.focus,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBoxShadowReadonly]: (_11 = (_10 = style === null || style === void 0 ? void 0 : style.root) === null || _10 === void 0 ? void 0 : _10.boxShadow) === null || _11 === void 0 ? void 0 : _11.readonly,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDefault]: (_13 = (_12 = style === null || style === void 0 ? void 0 : style.root) === null || _12 === void 0 ? void 0 : _12.color) === null || _13 === void 0 ? void 0 : _13.default,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDisabled]: (_15 = (_14 = style === null || style === void 0 ? void 0 : style.root) === null || _14 === void 0 ? void 0 : _14.color) === null || _15 === void 0 ? void 0 : _15.disabled,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorHover]: (_17 = (_16 = style === null || style === void 0 ? void 0 : style.root) === null || _16 === void 0 ? void 0 : _16.color) === null || _17 === void 0 ? void 0 : _17.hover,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorFocus]: (_19 = (_18 = style === null || style === void 0 ? void 0 : style.root) === null || _18 === void 0 ? void 0 : _18.color) === null || _19 === void 0 ? void 0 : _19.focus,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorReadonly]: (_21 = (_20 = style === null || style === void 0 ? void 0 : style.root) === null || _20 === void 0 ? void 0 : _20.color) === null || _21 === void 0 ? void 0 : _21.readonly,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).stylePlaceholderColor]: (_22 = style === null || style === void 0 ? void 0 : style.placeholder) === null || _22 === void 0 ? void 0 : _22.color,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).stylePlaceholderFontSize]: (_23 = style === null || style === void 0 ? void 0 : style.placeholder) === null || _23 === void 0 ? void 0 : _23.fontSize,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).stylePlaceholderFontWeight]: (_24 = style === null || style === void 0 ? void 0 : style.placeholder) === null || _24 === void 0 ? void 0 : _24.fontWeight,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).stylePlaceholderFontStyle]: (_25 = style === null || style === void 0 ? void 0 : style.placeholder) === null || _25 === void 0 ? void 0 : _25.fontStyle
    };
}


function $a1eebeb6ffe5dcf8$export$c440a9ba630ba69(style) {
    return (0, $33e7e05d308de989$export$42752b7c8e044245)(style);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $b4592d5eb2ab5ee3$export$f3b00687d1185fd5 = (type, disabled, readOnly, value, inputRef, onChange)=>{
    const searchProps = {};
    const handleIconClick = (0, $acw62.useCallback)(()=>{
        var _a;
        (_a = inputRef.current) === null || _a === void 0 || _a.focus();
        onChange('');
    }, [
        inputRef,
        onChange
    ]);
    if (type === 'search' || type === 'visualSearch') {
        searchProps.__leftIcon = 'search';
        if (!disabled && !readOnly && value) {
            searchProps.__rightIcon = 'close';
            searchProps.__onRightIconClick = handleIconClick;
        }
    }
    return searchProps;
};
const $b4592d5eb2ab5ee3$export$d0b21904efc6680a = (propertyValue = false)=>{
    if (propertyValue === true) return 'on';
    return propertyValue || 'off';
};



var $3b18faa9c4faa28d$export$2e2bcd8739ae039 = {
    "root": "awsui_root_2rhyz_1affo_145",
    "input": "awsui_input_2rhyz_1affo_149",
    "input-readonly": "awsui_input-readonly_2rhyz_1affo_203",
    "input-invalid": "awsui_input-invalid_2rhyz_1affo_266",
    "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_1affo_275",
    "input-warning": "awsui_input-warning_2rhyz_1affo_278",
    "input-type-search": "awsui_input-type-search_2rhyz_1affo_290",
    "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_1affo_303",
    "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1affo_306",
    "input-container": "awsui_input-container_2rhyz_1affo_313",
    "input-icon-left": "awsui_input-icon-left_2rhyz_1affo_318",
    "input-icon-right": "awsui_input-icon-right_2rhyz_1affo_325",
    "input-button-right": "awsui_input-button-right_2rhyz_1affo_331"
};


function $fadf349311229145$var$InternalInput({ type: type = 'text', step: step, inputMode: inputMode, autoComplete: autoComplete = true, ariaLabel: ariaLabel, clearAriaLabel: clearAriaLabelOverride, name: name, value: value, placeholder: placeholder, autoFocus: autoFocus, disabled: disabled, readOnly: readOnly, disableBrowserAutocorrect: disableBrowserAutocorrect, spellcheck: spellcheck, __noBorderRadius: __noBorderRadius, __leftIcon: __leftIcon, __leftIconVariant: __leftIconVariant = 'subtle', __onLeftIconClick: __onLeftIconClick, ariaRequired: ariaRequired, __rightIcon: __rightIcon, __onRightIconClick: __onRightIconClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onChange: onChange, __onDelayedInput: __onDelayedInput, __onBlurWithDetail: __onBlurWithDetail, onBlur: onBlur, onFocus: onFocus, nativeInputAttributes: nativeInputAttributes, __internalRootRef: __internalRootRef, __inheritFormFieldProps: __inheritFormFieldProps, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, __skipNativeAttributesWarnings: __skipNativeAttributesWarnings, style: style, ...rest }, ref) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('input');
    const fireDelayedInput = (0, $2f667510820517ed$export$40ae01be0011c1e6)((value)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(__onDelayedInput, {
            value: value
        }));
    const handleChange = (value)=>{
        fireDelayedInput(value);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: value
        });
    };
    const inputRef = (0, $acw62.useRef)(null);
    const searchProps = (0, $b4592d5eb2ab5ee3$export$f3b00687d1185fd5)(type, disabled, readOnly, value, inputRef, handleChange);
    __leftIcon = __leftIcon !== null && __leftIcon !== void 0 ? __leftIcon : searchProps.__leftIcon;
    __rightIcon = __rightIcon !== null && __rightIcon !== void 0 ? __rightIcon : searchProps.__rightIcon;
    __onRightIconClick = __onRightIconClick !== null && __onRightIconClick !== void 0 ? __onRightIconClick : searchProps.__onRightIconClick;
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const { ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, controlId: controlId, invalid: invalid, warning: warning } = __inheritFormFieldProps ? formFieldContext : rest;
    const attributes = {
        'aria-label': ariaLabel,
        // aria-labelledby has precedence over aria-label in accessible name calculation.
        // When aria-label is provided for Input, it should override aria-labelledBy from form-field context.
        // If both aria-label and aria-labelledby come from Input props, aria-labelledby will be used in accessible name
        'aria-labelledby': ariaLabel && !rest.ariaLabelledby ? undefined : ariaLabelledby,
        'aria-describedby': ariaDescribedby,
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        id: controlId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b18faa9c4faa28d$export$2e2bcd8739ae039).input, type && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)[`input-type-${type}`], __rightIcon && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-has-icon-right'], __leftIcon && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-has-icon-left'], __noBorderRadius && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-has-no-border-radius'], {
            [(0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-readonly']]: readOnly,
            [(0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-invalid']]: invalid,
            [(0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-warning']]: warning && !invalid
        }),
        autoComplete: (0, $b4592d5eb2ab5ee3$export$d0b21904efc6680a)(autoComplete),
        disabled: disabled,
        readOnly: readOnly,
        type: type,
        step: step,
        inputMode: inputMode,
        spellCheck: spellcheck,
        onKeyDown: onKeyDown && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event)),
        onKeyUp: onKeyUp && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyUp, event)),
        // We set a default value on the component in order to force it into the controlled mode.
        value: value !== null && value !== void 0 ? value : '',
        onChange: onChange && ((event)=>handleChange(event.target.value)),
        onBlur: (e)=>{
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(__onBlurWithDetail, {
                relatedTarget: e.relatedTarget
            });
        },
        onFocus: onFocus && (()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus))
    };
    if (type === 'number') // Chrome and Safari have a weird built-in behavior of letting focused
    // number inputs be controlled by scrolling on them. However, they don't
    // lock the browser's scroll, so it's very easy to accidentally increment
    // the input while scrolling down the page.
    attributes.onWheel = (event)=>event.currentTarget.blur();
    if (disableBrowserAutocorrect) {
        attributes.autoCorrect = 'off';
        attributes.autoCapitalize = 'off';
    }
    // ensure aria properties are string literal "true"
    if (ariaRequired) attributes['aria-required'] = 'true';
    if (invalid) attributes['aria-invalid'] = 'true';
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(ref, inputRef);
    // type = "visualSearch" renders a type="text' input
    if (attributes.type === 'visualSearch') attributes.type = 'text';
    const componentAnalyticsMetadata = {
        name: 'awsui.Input',
        label: 'input',
        properties: {
            value: value || ''
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-container']),
        ref: __internalRootRef,
        dir: type === 'email' ? 'ltr' : undefined,
        ...__injectAnalyticsComponentMetadata ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticsMetadata
        }) : (0, $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute)(rest)
    }, __leftIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        onClick: __onLeftIconClick,
        className: (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-icon-left']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: __leftIcon,
        variant: disabled || readOnly ? 'disabled' : __leftIconVariant
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...attributes,
        tag: "input",
        componentName: "Input",
        nativeAttributes: nativeInputAttributes,
        skipWarnings: __skipNativeAttributesWarnings,
        ref: mergedRef,
        style: (0, $a1eebeb6ffe5dcf8$export$c440a9ba630ba69)(style)
    }), __rightIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-icon-right'],
        ...__rightIcon === 'close' ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: 'clearInput'
        }) : {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        // Used for test utils
        className: (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)['input-button-right'],
        variant: "inline-icon-pointer-target",
        formAction: "none",
        iconName: __rightIcon,
        onClick: __onRightIconClick,
        ariaLabel: i18n('clearAriaLabel', clearAriaLabelOverride),
        disabled: disabled
    })));
}
var $fadf349311229145$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($fadf349311229145$var$InternalInput);



'use client';
const $cc0ce5a84f6f2813$var$Input = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, type: type = 'text', step: step, inputMode: inputMode, autoComplete: autoComplete = true, spellcheck: spellcheck, disabled: disabled, readOnly: readOnly, disableBrowserAutocorrect: disableBrowserAutocorrect, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onChange: onChange, onBlur: onBlur, onFocus: onFocus, ariaRequired: ariaRequired, name: name, placeholder: placeholder, autoFocus: autoFocus, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, invalid: invalid, warning: warning, controlId: controlId, clearAriaLabel: clearAriaLabel, nativeInputAttributes: nativeInputAttributes, style: style, ...rest }, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Input', {
        props: {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            disableBrowserAutocorrect: disableBrowserAutocorrect,
            inputMode: inputMode,
            readOnly: readOnly,
            spellcheck: spellcheck,
            type: type
        }
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus (...args) {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 || _a.focus(...args);
            },
            select () {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 || _a.select();
            }
        }), [
        inputRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), {
        ref: inputRef,
        ...baseProps,
        ...baseComponentProps,
        autoComplete: autoComplete,
        ariaLabel: ariaLabel,
        ariaRequired: ariaRequired,
        autoFocus: autoFocus,
        disabled: disabled,
        disableBrowserAutocorrect: disableBrowserAutocorrect,
        name: name,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        placeholder: placeholder,
        readOnly: readOnly,
        type: type,
        step: step,
        inputMode: inputMode,
        spellcheck: spellcheck,
        value: value,
        ariaDescribedby: ariaDescribedby,
        ariaLabelledby: ariaLabelledby,
        invalid: invalid,
        warning: warning,
        controlId: controlId,
        clearAriaLabel: clearAriaLabel,
        nativeInputAttributes: nativeInputAttributes,
        style: style,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b18faa9c4faa28d$export$2e2bcd8739ae039).root, baseProps.className),
        __inheritFormFieldProps: true,
        __injectAnalyticsComponentMetadata: true
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($cc0ce5a84f6f2813$var$Input, 'Input');
var $cc0ce5a84f6f2813$export$2e2bcd8739ae039 = $cc0ce5a84f6f2813$var$Input;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




'use client';
const $3baf384ab7fe8d32$var$Link = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ fontSize: fontSize = 'body-m', color: color = 'normal', external: external = false, style: style, ...props }, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Link', {
        props: {
            color: color,
            external: external,
            fontSize: fontSize,
            rel: props.rel,
            target: props.target,
            variant: props.variant
        }
    });
    const analyticsMetadata = {
        action: 'click',
        detail: {
            label: {
                root: 'self'
            },
            external: `${external}`
        },
        component: {
            name: 'awsui.Link',
            label: {
                root: 'self'
            },
            properties: {
                variant: props.variant || 'secondary'
            }
        }
    };
    if (props.href) analyticsMetadata.detail.href = props.href;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01503a290f20b804$export$2e2bcd8739ae039), {
        fontSize: fontSize,
        color: color,
        external: external,
        ...props,
        ...baseComponentProps,
        ref: ref,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata),
        style: style
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($3baf384ab7fe8d32$var$Link, 'Link');
var $3baf384ab7fe8d32$export$2e2bcd8739ae039 = $3baf384ab7fe8d32$var$Link;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



'use client';
function $74ee220a592e3066$export$2e2bcd8739ae039({ direction: direction = 'vertical', ...props }) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('SpaceBetween', {
        props: {
            alignItems: props.alignItems,
            direction: direction,
            size: props.size
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        direction: direction,
        ...props,
        ...baseComponentProps
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($74ee220a592e3066$export$2e2bcd8739ae039, 'SpaceBetween');



var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



'use client';
function $09d4a5bf5140299c$export$2e2bcd8739ae039({ variant: variant = 'div', margin: margin = {}, padding: padding = {}, ...props }) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Box', {
        props: {
            color: props.color,
            display: props.display,
            float: props.float,
            fontSize: props.fontSize,
            fontWeight: props.fontWeight,
            textAlign: props.textAlign,
            variant: variant
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        variant: variant,
        margin: margin,
        padding: padding,
        ...props,
        ...baseComponentProps
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($09d4a5bf5140299c$export$2e2bcd8739ae039, 'Box');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $914111a054c2e0da$export$2e2bcd8739ae039 = {
    "dialog": "awsui_dialog_1d2i7_1hq7h_169",
    "modal-slide-up": "awsui_modal-slide-up_1d2i7_1hq7h_1",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_1hq7h_1",
    "refresh": "awsui_refresh_1d2i7_1hq7h_192",
    "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_1hq7h_1",
    "root": "awsui_root_1d2i7_1hq7h_225",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_1hq7h_1",
    "hidden": "awsui_hidden_1d2i7_1hq7h_302",
    "focus-lock": "awsui_focus-lock_1d2i7_1hq7h_306",
    "position-top": "awsui_position-top_1d2i7_1hq7h_314",
    "position-center": "awsui_position-center_1d2i7_1hq7h_317",
    "small": "awsui_small_1d2i7_1hq7h_331",
    "medium": "awsui_medium_1d2i7_1hq7h_334",
    "large": "awsui_large_1d2i7_1hq7h_337",
    "x-large": "awsui_x-large_1d2i7_1hq7h_340",
    "xx-large": "awsui_xx-large_1d2i7_1hq7h_343",
    "custom-width": "awsui_custom-width_1d2i7_1hq7h_346",
    "max": "awsui_max_1d2i7_1hq7h_349",
    "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_1hq7h_349",
    "custom-height": "awsui_custom-height_1d2i7_1hq7h_354",
    "container": "awsui_container_1d2i7_1hq7h_359",
    "custom-height-container": "awsui_custom-height-container_1d2i7_1hq7h_399",
    "content": "awsui_content_1d2i7_1hq7h_405",
    "no-paddings": "awsui_no-paddings_1d2i7_1hq7h_410",
    "custom-height-content": "awsui_custom-height-content_1d2i7_1hq7h_414",
    "header": "awsui_header_1d2i7_1hq7h_419",
    "header--text": "awsui_header--text_1d2i7_1hq7h_431",
    "footer": "awsui_footer_1d2i7_1hq7h_435",
    "footer--rounded": "awsui_footer--rounded_1d2i7_1hq7h_444",
    "dismiss-control": "awsui_dismiss-control_1d2i7_1hq7h_456",
    "modal-open": "awsui_modal-open_1d2i7_1hq7h_460"
};


// Read this before making changes to the code below.
//
// When a modal is used from an iframe the body scrolling utils take no effect because they need to be applied to another document.
// The customers replicate this behavior by running the same code on the correct document instance, see AWSUI-41915.
// Hence, we should avoid making changes to the component that break the body scrolling logic in its current form.
let $16c9734086b05737$var$initialBodyPaddingRightStyle = undefined;
function $16c9734086b05737$export$b90142434781d71c() {
    $16c9734086b05737$var$setBodyScrollbarPadding();
    document.body.classList.add((0, $914111a054c2e0da$export$2e2bcd8739ae039)['modal-open']);
}
function $16c9734086b05737$export$28b514218137a105() {
    document.body.classList.remove((0, $914111a054c2e0da$export$2e2bcd8739ae039)['modal-open']);
    $16c9734086b05737$var$restoreBodyScrollbarPadding();
}
function $16c9734086b05737$var$setBodyScrollbarPadding() {
    if ($16c9734086b05737$var$bodyHasScrollbar()) {
        $16c9734086b05737$var$initialBodyPaddingRightStyle = document.body.style.paddingRight;
        const initialBodyPaddingRight = $16c9734086b05737$var$computedBodyPaddingRightPixels();
        const scrollbarWidth = (0, $7b99d3a86137a2e2$export$bbb9ce125c89ccb4)().width;
        const newBodyPaddingRight = initialBodyPaddingRight + scrollbarWidth;
        document.body.style.paddingRight = newBodyPaddingRight + 'px';
    }
}
function $16c9734086b05737$var$computedBodyPaddingRightPixels() {
    return parseInt(window.getComputedStyle(document.body).paddingRight, 10);
}
function $16c9734086b05737$var$restoreBodyScrollbarPadding() {
    if ($16c9734086b05737$var$initialBodyPaddingRightStyle) document.body.style.setProperty('padding-right', $16c9734086b05737$var$initialBodyPaddingRightStyle);
    else document.body.style.removeProperty('padding-right');
    $16c9734086b05737$var$initialBodyPaddingRightStyle = undefined;
}
function $16c9734086b05737$var$bodyHasScrollbar() {
    // Unfortunately this difference doesn't appear to match the scrollbar width during testing,
    // otherwise we could remove browserScrollbarSize().  Bootstrap also doesn't use this difference
    // directly.
    return document.body.clientWidth < window.innerWidth;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




const $a82ae7a319ea5af1$var$MIN_CONTENT_HEIGHT = 60;
const $a82ae7a319ea5af1$var$MIN_MODAL_WIDTH = 320;
function $a82ae7a319ea5af1$export$880f015ecfb3adc2({ height: height, width: width, hasFooter: hasFooter }) {
    const [footerHeight, footerRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.borderBoxHeight);
    const [headerHeight, headerRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.borderBoxHeight);
    const minModalHeight = (headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0) + (hasFooter ? footerHeight !== null && footerHeight !== void 0 ? footerHeight : 0 : 0) + $a82ae7a319ea5af1$var$MIN_CONTENT_HEIGHT;
    const constrainedHeight = Math.max(height !== null && height !== void 0 ? height : 0, minModalHeight);
    const constrainedWidth = Math.max(width !== null && width !== void 0 ? width : 0, $a82ae7a319ea5af1$var$MIN_MODAL_WIDTH);
    const hasCustomHeight = height !== undefined && !Number.isNaN(height);
    const hasCustomWidth = width !== undefined && !Number.isNaN(width);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (Number.isNaN(height)) (0, $013a2451794a45c0$exports.warnOnce)('Modal', 'Height is NaN and will not be set. This is likely a bug in your code.');
        else if (hasCustomHeight && constrainedHeight !== height) (0, $013a2451794a45c0$exports.warnOnce)('Modal', `Height (${height}px) is too small. Modal requires at least ${$a82ae7a319ea5af1$var$MIN_CONTENT_HEIGHT}px for content plus header/footer space (total: ${minModalHeight}px). Height will be adjusted to ${constrainedHeight}px.`);
        if (Number.isNaN(width)) (0, $013a2451794a45c0$exports.warnOnce)('Modal', 'Width is NaN and will not be set. This is likely a bug in your code.');
        else if (hasCustomWidth && constrainedWidth !== width) (0, $013a2451794a45c0$exports.warnOnce)('Modal', `Width (${width}px) is below minimum (${$a82ae7a319ea5af1$var$MIN_MODAL_WIDTH}px) and will be adjusted to ${constrainedWidth}px.`);
    }
    return {
        footerRef: footerRef,
        headerRef: headerRef,
        footerHeight: footerHeight,
        hasCustomHeight: hasCustomHeight,
        hasCustomWidth: hasCustomWidth,
        dialogCustomStyles: {
            ...hasCustomWidth && {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).modalCustomWidth]: `${constrainedWidth}px`
            },
            ...hasCustomHeight && {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).modalCustomHeight]: `${constrainedHeight}px`
            }
        }
    };
}



var $eb53ed8bd7d1cbf4$export$2e2bcd8739ae039 = {
    "header": "awsui_header_15dxs_1ns0c_5"
};



function $7a5bb8d240e2baab$export$9b43f61d6d324b4d(props) {
    const { funnelProps: funnelProps, funnelSubmit: funnelSubmit, funnelNextOrSubmitAttempt: funnelNextOrSubmitAttempt } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { funnelStepProps: funnelStepProps } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepRef: subStepRef, funnelSubStepProps: funnelSubStepProps } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const onButtonClick = ({ variant: variant })=>{
        if (variant === 'primary') {
            funnelNextOrSubmitAttempt();
            funnelSubmit();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a5bb8d240e2baab$export$2e2bcd8739ae039, {
        __funnelProps: funnelProps,
        __funnelStepProps: funnelStepProps,
        __subStepRef: subStepRef,
        __subStepFunnelProps: funnelSubStepProps,
        onButtonClick: onButtonClick,
        ...props
    });
}
function $7a5bb8d240e2baab$export$2e2bcd8739ae039({ modalRoot: modalRoot, getModalRoot: getModalRoot, removeModalRoot: removeModalRoot, ...rest }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), {
        container: modalRoot,
        getContainer: getModalRoot,
        removeContainer: removeModalRoot
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a5bb8d240e2baab$var$PortaledModal, {
        ...rest
    }));
}
// Separate component to prevent the Portal from getting in the way of refs, as it needs extra cycles to render the inner components.
// useContainerQuery needs its targeted element to exist on the first render in order to work properly.
function $7a5bb8d240e2baab$var$PortaledModal({ size: size, visible: visible, header: header, children: children, footer: footer, disableContentPaddings: disableContentPaddings, position: position = 'center', onButtonClick: onButtonClick = ()=>{}, onDismiss: onDismiss, width: width, height: height, __internalRootRef: __internalRootRef, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, __funnelProps: __funnelProps, __funnelStepProps: __funnelStepProps, __subStepRef: __subStepRef, __subStepFunnelProps: __subStepFunnelProps, referrerId: referrerId, ...rest }) {
    var _a;
    const instanceUniqueId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const headerId = `${rest.id || instanceUniqueId}-header`;
    const lastMouseDownElementRef = (0, $acw62.useRef)(null);
    const [breakpoint, breakpointsRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        'xs'
    ]);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('modal');
    const closeAriaLabel = i18n('closeAriaLabel', rest.closeAriaLabel);
    const refObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(breakpointsRef, refObject, __internalRootRef);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const analyticsComponentMetadata = {
        name: 'awsui.Modal',
        label: `.${(0, $eb53ed8bd7d1cbf4$export$2e2bcd8739ae039).header} h2`
    };
    const metadataAttribute = __injectAnalyticsComponentMetadata ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
        component: analyticsComponentMetadata
    }) : {};
    const loadStartTime = (0, $acw62.useRef)(0);
    const loadCompleteTime = (0, $acw62.useRef)(0);
    const componentLoadingCount = (0, $acw62.useRef)(0);
    const performanceMetricLogged = (0, $acw62.useRef)(false);
    // enable body scroll and restore focus if unmounting while visible
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            (0, $16c9734086b05737$export$28b514218137a105)();
        };
    }, []);
    const resetModalPerformanceData = ()=>{
        loadStartTime.current = performance.now();
        loadCompleteTime.current = 0;
        performanceMetricLogged.current = false;
    };
    const emitTimeToContentReadyInModal = (loadCompleteTime)=>{
        var _a;
        if (componentLoadingCount.current === 0 && loadStartTime.current && loadStartTime.current !== 0 && !performanceMetricLogged.current) {
            const timeToContentReadyInModal = loadCompleteTime - loadStartTime.current;
            (0, $54d511b0978bc73c$export$68015ba807c17f26).modalPerformanceData({
                timeToContentReadyInModal: timeToContentReadyInModal,
                instanceIdentifier: instanceUniqueId,
                componentIdentifier: ((_a = headerTextRef.current) === null || _a === void 0 ? void 0 : _a.textContent) || ''
            });
            performanceMetricLogged.current = true;
        }
    };
    const MODAL_READY_TIMEOUT = 100;
    /**
     * This useEffect is triggered when the visible attribute of modal changes.
     * When modal becomes visible, modal performance metrics are reset marking the beginning loading process.
     * To ensure that the modal component ready metric is always emitted, a setTimeout is implemented.
     * This setTimeout automatically emits the component ready metric after a specified duration.
     */ (0, $acw62.useEffect)(()=>{
        if (visible) {
            (0, $16c9734086b05737$export$b90142434781d71c)();
            resetModalPerformanceData();
            setTimeout(()=>{
                emitTimeToContentReadyInModal(loadStartTime.current);
            }, MODAL_READY_TIMEOUT);
        } else (0, $16c9734086b05737$export$28b514218137a105)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visible
    ]);
    // Because we hide the element with styles (and not actually detach it from DOM), we need to scroll to top
    (0, $acw62.useEffect)(()=>{
        if (visible && refObject.current) refObject.current.scrollTop = 0;
    }, [
        visible
    ]);
    const dismiss = (reason)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
            reason: reason
        });
    const onOverlayMouseDown = (event)=>{
        lastMouseDownElementRef.current = event.target;
    };
    const onOverlayClick = (event)=>{
        const overlay = refObject.current;
        const lastClicked = lastMouseDownElementRef.current;
        if (event.target === overlay && lastClicked === overlay) dismiss('overlay');
    };
    const onCloseButtonClick = ()=>dismiss('closeButton');
    const escKeyHandler = (event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape) dismiss('keyboard');
    };
    // We use an empty div element at the end of the content slot as a sentinel
    // to detect when the user has scrolled to the bottom.
    const { ref: stickySentinelRef, isIntersecting: footerStuck } = (0, $cff975c73fa800c5$export$a7395f9832c00176)();
    const headerTextRef = (0, $acw62.useRef)(null);
    const { subStepRef: subStepRef } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const { footerRef: footerRef, headerRef: headerRef, hasCustomHeight: hasCustomHeight, hasCustomWidth: hasCustomWidth, dialogCustomStyles: dialogCustomStyles, footerHeight: footerHeight } = (0, $a82ae7a319ea5af1$export$880f015ecfb3adc2)({
        height: height,
        width: width,
        hasFooter: !!footer
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$6763bc96d4aa4bf8).Provider, {
        value: `.${(0, $914111a054c2e0da$export$2e2bcd8739ae039)['header--text']}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08fba30ddb2cfd8a$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $584c4a19f0ba0537$export$ab57792b9b6974a6).Provider, {
        value: {
            isInModal: true,
            componentLoadingCount: componentLoadingCount,
            emitTimeToContentReadyInModal: emitTimeToContentReadyInModal
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ...__funnelProps,
        ...__funnelStepProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).root, {
            [(0, $914111a054c2e0da$export$2e2bcd8739ae039).hidden]: !visible
        }, baseProps.className, isRefresh && (0, $914111a054c2e0da$export$2e2bcd8739ae039).refresh),
        role: "dialog",
        "aria-labelledby": headerId,
        onMouseDown: onOverlayMouseDown,
        onClick: onOverlayClick,
        ref: mergedRef,
        style: footerHeight ? {
            scrollPaddingBottom: footerHeight
        } : undefined,
        "data-awsui-referrer-id": ((_a = subStepRef.current) === null || _a === void 0 ? void 0 : _a.id) || referrerId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        disabled: !visible,
        autoFocus: true,
        restoreFocus: true,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039)['focus-lock'], (0, $914111a054c2e0da$export$2e2bcd8739ae039)[`position-${position}`])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).dialog, !hasCustomWidth && (0, $914111a054c2e0da$export$2e2bcd8739ae039)[size], (0, $914111a054c2e0da$export$2e2bcd8739ae039)[`breakpoint-${breakpoint}`], isRefresh && (0, $914111a054c2e0da$export$2e2bcd8739ae039).refresh, hasCustomWidth && (0, $914111a054c2e0da$export$2e2bcd8739ae039)['custom-width'], hasCustomHeight && (0, $914111a054c2e0da$export$2e2bcd8739ae039)['custom-height']),
        style: dialogCustomStyles,
        onKeyDown: escKeyHandler,
        ...metadataAttribute
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).container, hasCustomHeight && (0, $914111a054c2e0da$export$2e2bcd8739ae039)['custom-height-container'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: headerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).header, (0, $eb53ed8bd7d1cbf4$export$2e2bcd8739ae039).header)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$2e2bcd8739ae039), {
        variant: "h2",
        __disableActionsWrapping: true,
        actions: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
                action: 'dismiss'
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaLabel: closeAriaLabel,
            className: (0, $914111a054c2e0da$export$2e2bcd8739ae039)['dismiss-control'],
            variant: "modal-dismiss",
            iconName: "close",
            formAction: "none",
            onClick: onCloseButtonClick
        }))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: headerTextRef,
        id: headerId,
        className: (0, $914111a054c2e0da$export$2e2bcd8739ae039)['header--text']
    }, header))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), {
        wrapper: (content)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
                padding: {
                    bottom: 'm',
                    horizontal: 'l'
                }
            }, content)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: __subStepRef,
        ...__subStepFunnelProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).content, {
            [(0, $914111a054c2e0da$export$2e2bcd8739ae039)['no-paddings']]: disableContentPaddings
        }, hasCustomHeight && (0, $914111a054c2e0da$export$2e2bcd8739ae039)['custom-height-content']),
        ...hasCustomHeight && {
            tabIndex: 0,
            role: 'region',
            'aria-labelledby': headerId
        }
    }, children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: stickySentinelRef
    })), footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edea5ac281b34b48$export$24d547caef80ccd1).Provider, {
        value: {
            onClick: onButtonClick
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: footerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).footer, (footerStuck || hasCustomHeight) && (0, $914111a054c2e0da$export$2e2bcd8739ae039)['footer--rounded'])
    }, footer))))))))));
}



'use client';
function $104eee66f5fcddce$var$ModalWithAnalyticsFunnel({ analyticsMetadata: analyticsMetadata, baseComponentProps: baseComponentProps, size: size = 'medium', ...props }) {
    const modalId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const dataAttributes = {
        [(0, $285a09b860d2bebc$export$1b41fd4f1fd53ef2)]: modalId
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$467468afd0d320b9), {
        mounted: props.visible,
        funnelIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        funnelFlowType: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.flowType,
        funnelErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext,
        funnelResourceType: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.resourceType,
        funnelType: "modal",
        optionalStepNumbers: [],
        totalFunnelSteps: 1,
        funnelNameSelectors: ()=>{
            var _a;
            return [
                `[${(0, $285a09b860d2bebc$export$1b41fd4f1fd53ef2)}="${(_a = window === null || window === void 0 ? void 0 : window.CSS) === null || _a === void 0 ? void 0 : _a.escape(modalId)}"] .${(0, $914111a054c2e0da$export$2e2bcd8739ae039)['header--text']}`
            ];
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$3fa82ebb4c38684d), {
        mounted: props.visible,
        stepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        stepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext,
        stepNumber: 1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$b1325661caf9fa0), {
        subStepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        subStepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a5bb8d240e2baab$export$9b43f61d6d324b4d), {
        size: size,
        ...props,
        ...baseComponentProps,
        ...dataAttributes,
        __injectAnalyticsComponentMetadata: true
    }))));
}
function $104eee66f5fcddce$export$2e2bcd8739ae039({ size: size = 'medium', position: position = 'center', width: width, height: height, ...props }) {
    const { isInFunnel: isInFunnel } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Modal', {
        props: {
            size: size,
            position: position,
            disableContentPaddings: props.disableContentPaddings,
            flowType: analyticsMetadata.flowType,
            width: width,
            height: height
        },
        metadata: {
            hasResourceType: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.resourceType),
            hasInstanceIdentifier: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier)
        }
    }, analyticsMetadata);
    if (!isInFunnel) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($104eee66f5fcddce$var$ModalWithAnalyticsFunnel, {
        analyticsMetadata: analyticsMetadata,
        baseComponentProps: baseComponentProps,
        size: size,
        position: position,
        width: width,
        height: height,
        ...props
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a5bb8d240e2baab$export$2e2bcd8739ae039), {
        size: size,
        position: position,
        width: width,
        height: height,
        ...props,
        ...baseComponentProps,
        __injectAnalyticsComponentMetadata: true
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($104eee66f5fcddce$export$2e2bcd8739ae039, 'Modal');



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $b40c3a08cec6a11c$exports = {};
"use strict";
var $b40c3a08cec6a11c$var$__create = Object.create;
var $b40c3a08cec6a11c$var$__defProp = Object.defineProperty;
var $b40c3a08cec6a11c$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $b40c3a08cec6a11c$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $b40c3a08cec6a11c$var$__getProtoOf = Object.getPrototypeOf;
var $b40c3a08cec6a11c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b40c3a08cec6a11c$var$__export = (target, all)=>{
    for(var name in all)$b40c3a08cec6a11c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $b40c3a08cec6a11c$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $b40c3a08cec6a11c$var$__getOwnPropNames(from))if (!$b40c3a08cec6a11c$var$__hasOwnProp.call(to, key) && key !== except) $b40c3a08cec6a11c$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $b40c3a08cec6a11c$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $b40c3a08cec6a11c$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $b40c3a08cec6a11c$var$__create($b40c3a08cec6a11c$var$__getProtoOf(mod)) : {}, $b40c3a08cec6a11c$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $b40c3a08cec6a11c$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $b40c3a08cec6a11c$var$__toCommonJS = (mod)=>$b40c3a08cec6a11c$var$__copyProps($b40c3a08cec6a11c$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $b40c3a08cec6a11c$var$index_exports = {};
$b40c3a08cec6a11c$var$__export($b40c3a08cec6a11c$var$index_exports, {
    AuthContext: ()=>$b40c3a08cec6a11c$var$AuthContext,
    AuthProvider: ()=>$b40c3a08cec6a11c$var$AuthProvider,
    hasAuthParams: ()=>$b40c3a08cec6a11c$var$hasAuthParams,
    useAuth: ()=>$b40c3a08cec6a11c$var$useAuth,
    useAutoSignin: ()=>$b40c3a08cec6a11c$var$useAutoSignin,
    withAuth: ()=>$b40c3a08cec6a11c$var$withAuth,
    withAuthenticationRequired: ()=>$b40c3a08cec6a11c$var$withAuthenticationRequired
});
$b40c3a08cec6a11c$exports = $b40c3a08cec6a11c$var$__toCommonJS($b40c3a08cec6a11c$var$index_exports);

// src/AuthContext.ts
var $b40c3a08cec6a11c$var$import_react = $b40c3a08cec6a11c$var$__toESM((parcelRequire("acw62")));
var $b40c3a08cec6a11c$var$AuthContext = $b40c3a08cec6a11c$var$import_react.default.createContext(void 0);
$b40c3a08cec6a11c$var$AuthContext.displayName = "AuthContext";
var $631c75f8a3fcffe9$exports = {};
"use strict";
var $631c75f8a3fcffe9$var$__defProp = Object.defineProperty;
var $631c75f8a3fcffe9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $631c75f8a3fcffe9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $631c75f8a3fcffe9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $631c75f8a3fcffe9$var$__export = (target, all)=>{
    for(var name in all)$631c75f8a3fcffe9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $631c75f8a3fcffe9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $631c75f8a3fcffe9$var$__getOwnPropNames(from))if (!$631c75f8a3fcffe9$var$__hasOwnProp.call(to, key) && key !== except) $631c75f8a3fcffe9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $631c75f8a3fcffe9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $631c75f8a3fcffe9$var$__toCommonJS = (mod)=>$631c75f8a3fcffe9$var$__copyProps($631c75f8a3fcffe9$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $631c75f8a3fcffe9$var$index_exports = {};
$631c75f8a3fcffe9$var$__export($631c75f8a3fcffe9$var$index_exports, {
    AccessTokenEvents: ()=>$631c75f8a3fcffe9$var$AccessTokenEvents,
    CheckSessionIFrame: ()=>$631c75f8a3fcffe9$var$CheckSessionIFrame,
    DPoPState: ()=>$631c75f8a3fcffe9$var$DPoPState,
    ErrorResponse: ()=>$631c75f8a3fcffe9$var$ErrorResponse,
    ErrorTimeout: ()=>$631c75f8a3fcffe9$var$ErrorTimeout,
    InMemoryWebStorage: ()=>$631c75f8a3fcffe9$var$InMemoryWebStorage,
    IndexedDbDPoPStore: ()=>$631c75f8a3fcffe9$var$IndexedDbDPoPStore,
    Log: ()=>$631c75f8a3fcffe9$var$Log,
    Logger: ()=>$631c75f8a3fcffe9$var$Logger,
    MetadataService: ()=>$631c75f8a3fcffe9$var$MetadataService,
    OidcClient: ()=>$631c75f8a3fcffe9$var$OidcClient,
    OidcClientSettingsStore: ()=>$631c75f8a3fcffe9$var$OidcClientSettingsStore,
    SessionMonitor: ()=>$631c75f8a3fcffe9$var$SessionMonitor,
    SigninResponse: ()=>$631c75f8a3fcffe9$var$SigninResponse,
    SigninState: ()=>$631c75f8a3fcffe9$var$SigninState,
    SignoutResponse: ()=>$631c75f8a3fcffe9$var$SignoutResponse,
    State: ()=>$631c75f8a3fcffe9$var$State,
    User: ()=>$631c75f8a3fcffe9$var$User,
    UserManager: ()=>$631c75f8a3fcffe9$var$UserManager,
    UserManagerSettingsStore: ()=>$631c75f8a3fcffe9$var$UserManagerSettingsStore,
    Version: ()=>$631c75f8a3fcffe9$var$Version,
    WebStorageStateStore: ()=>$631c75f8a3fcffe9$var$WebStorageStateStore
});
$631c75f8a3fcffe9$exports = $631c75f8a3fcffe9$var$__toCommonJS($631c75f8a3fcffe9$var$index_exports);
// src/utils/Logger.ts
var $631c75f8a3fcffe9$var$nopLogger = {
    debug: ()=>void 0,
    info: ()=>void 0,
    warn: ()=>void 0,
    error: ()=>void 0
};
var $631c75f8a3fcffe9$var$level;
var $631c75f8a3fcffe9$var$logger;
var $631c75f8a3fcffe9$var$Log = /* @__PURE__ */ ((Log2)=>{
    Log2[Log2["NONE"] = 0] = "NONE";
    Log2[Log2["ERROR"] = 1] = "ERROR";
    Log2[Log2["WARN"] = 2] = "WARN";
    Log2[Log2["INFO"] = 3] = "INFO";
    Log2[Log2["DEBUG"] = 4] = "DEBUG";
    return Log2;
})($631c75f8a3fcffe9$var$Log || {});
((Log2)=>{
    function reset() {
        $631c75f8a3fcffe9$var$level = 3 /* INFO */ ;
        $631c75f8a3fcffe9$var$logger = $631c75f8a3fcffe9$var$nopLogger;
    }
    Log2.reset = reset;
    function setLevel(value) {
        if (!(0 /* NONE */  <= value && value <= 4 /* DEBUG */ )) throw new Error("Invalid log level");
        $631c75f8a3fcffe9$var$level = value;
    }
    Log2.setLevel = setLevel;
    function setLogger(value) {
        $631c75f8a3fcffe9$var$logger = value;
    }
    Log2.setLogger = setLogger;
})($631c75f8a3fcffe9$var$Log || ($631c75f8a3fcffe9$var$Log = {}));
var $631c75f8a3fcffe9$var$Logger = class _Logger {
    constructor(_name){
        this._name = _name;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ debug(...args) {
        if ($631c75f8a3fcffe9$var$level >= 4 /* DEBUG */ ) $631c75f8a3fcffe9$var$logger.debug(_Logger._format(this._name, this._method), ...args);
    }
    info(...args) {
        if ($631c75f8a3fcffe9$var$level >= 3 /* INFO */ ) $631c75f8a3fcffe9$var$logger.info(_Logger._format(this._name, this._method), ...args);
    }
    warn(...args) {
        if ($631c75f8a3fcffe9$var$level >= 2 /* WARN */ ) $631c75f8a3fcffe9$var$logger.warn(_Logger._format(this._name, this._method), ...args);
    }
    error(...args) {
        if ($631c75f8a3fcffe9$var$level >= 1 /* ERROR */ ) $631c75f8a3fcffe9$var$logger.error(_Logger._format(this._name, this._method), ...args);
    }
    /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */ throw(err) {
        this.error(err);
        throw err;
    }
    create(method) {
        const methodLogger = Object.create(this);
        methodLogger._method = method;
        methodLogger.debug("begin");
        return methodLogger;
    }
    static createStatic(name, staticMethod) {
        const staticLogger = new _Logger(`${name}.${staticMethod}`);
        staticLogger.debug("begin");
        return staticLogger;
    }
    static _format(name, method) {
        const prefix = `[${name}]`;
        return method ? `${prefix} ${method}:` : prefix;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ // helpers for static class methods
    static debug(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 4 /* DEBUG */ ) $631c75f8a3fcffe9$var$logger.debug(_Logger._format(name), ...args);
    }
    static info(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 3 /* INFO */ ) $631c75f8a3fcffe9$var$logger.info(_Logger._format(name), ...args);
    }
    static warn(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 2 /* WARN */ ) $631c75f8a3fcffe9$var$logger.warn(_Logger._format(name), ...args);
    }
    static error(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 1 /* ERROR */ ) $631c75f8a3fcffe9$var$logger.error(_Logger._format(name), ...args);
    }
};
$631c75f8a3fcffe9$var$Log.reset();
class $968f28756c67bd23$export$b9721ef022f71a68 extends Error {
}
$968f28756c67bd23$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $968f28756c67bd23$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $968f28756c67bd23$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $968f28756c67bd23$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $968f28756c67bd23$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $968f28756c67bd23$var$base64UrlDecode(part);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


var $631c75f8a3fcffe9$var$JwtUtils = class {
    // IMPORTANT: doesn't validate the token
    static decode(token) {
        try {
            return (0, $968f28756c67bd23$export$fa1e2fb699b7861e)(token);
        } catch (err) {
            $631c75f8a3fcffe9$var$Logger.error("JwtUtils.decode", err);
            throw err;
        }
    }
    static async generateSignedJwt(header, payload, privateKey) {
        const encodedHeader = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign({
            name: "ECDSA",
            hash: {
                name: "SHA-256"
            }
        }, privateKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
    static async generateSignedJwtWithHmac(header, payload, secretKey) {
        const encodedHeader = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign("HMAC", secretKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
};
// src/utils/CryptoUtils.ts
var $631c75f8a3fcffe9$var$UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var $631c75f8a3fcffe9$var$toBase64 = (val)=>btoa([
        ...new Uint8Array(val)
    ].map((chr)=>String.fromCharCode(chr)).join(""));
var $631c75f8a3fcffe9$var$_CryptoUtils = class _CryptoUtils {
    static _randomWord() {
        const arr = new Uint32Array(1);
        crypto.getRandomValues(arr);
        return arr[0];
    }
    /**
   * Generates RFC4122 version 4 guid
   */ static generateUUIDv4() {
        const uuid = $631c75f8a3fcffe9$var$UUID_V4_TEMPLATE.replace(/[018]/g, (c)=>(+c ^ _CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
        return uuid.replace(/-/g, "");
    }
    /**
   * PKCE: Generate a code verifier
   */ static generateCodeVerifier() {
        return _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4();
    }
    /**
   * PKCE: Generate a code challenge
   */ static async generateCodeChallenge(code_verifier) {
        if (!crypto.subtle) throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(code_verifier);
            const hashed = await crypto.subtle.digest("SHA-256", data);
            return $631c75f8a3fcffe9$var$toBase64(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (err) {
            $631c75f8a3fcffe9$var$Logger.error("CryptoUtils.generateCodeChallenge", err);
            throw err;
        }
    }
    /**
   * Generates a base64-encoded string for a basic auth header
   */ static generateBasicAuth(client_id, client_secret) {
        const encoder = new TextEncoder();
        const data = encoder.encode([
            client_id,
            client_secret
        ].join(":"));
        return $631c75f8a3fcffe9$var$toBase64(data);
    }
    /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */ static async hash(alg, message) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest(alg, msgUint8);
        return new Uint8Array(hashBuffer);
    }
    /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */ static async customCalculateJwkThumbprint(jwk) {
        let jsonObject;
        switch(jwk.kty){
            case "RSA":
                jsonObject = {
                    "e": jwk.e,
                    "kty": jwk.kty,
                    "n": jwk.n
                };
                break;
            case "EC":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x,
                    "y": jwk.y
                };
                break;
            case "OKP":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x
                };
                break;
            case "oct":
                jsonObject = {
                    "crv": jwk.k,
                    "kty": jwk.kty
                };
                break;
            default:
                throw new Error("Unknown jwk type");
        }
        const utf8encodedAndHashed = await _CryptoUtils.hash("SHA-256", JSON.stringify(jsonObject));
        return _CryptoUtils.encodeBase64Url(utf8encodedAndHashed);
    }
    static async generateDPoPProof({ url: url, accessToken: accessToken, httpMethod: httpMethod, keyPair: keyPair, nonce: nonce }) {
        let hashedToken;
        let encodedHash;
        const payload = {
            "jti": window.crypto.randomUUID(),
            "htm": httpMethod != null ? httpMethod : "GET",
            "htu": url,
            "iat": Math.floor(Date.now() / 1e3)
        };
        if (accessToken) {
            hashedToken = await _CryptoUtils.hash("SHA-256", accessToken);
            encodedHash = _CryptoUtils.encodeBase64Url(hashedToken);
            payload.ath = encodedHash;
        }
        if (nonce) payload.nonce = nonce;
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            const header = {
                "alg": "ES256",
                "typ": "dpop+jwt",
                "jwk": {
                    "crv": publicJwk.crv,
                    "kty": publicJwk.kty,
                    "x": publicJwk.x,
                    "y": publicJwk.y
                }
            };
            return await $631c75f8a3fcffe9$var$JwtUtils.generateSignedJwt(header, payload, keyPair.privateKey);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Error exporting dpop public key: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPJkt(keyPair) {
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            return await _CryptoUtils.customCalculateJwkThumbprint(publicJwk);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Could not retrieve dpop keys from storage: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPKeys() {
        return await window.crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign",
            "verify"
        ]);
    }
    /**
   * Generates a client assertion JWT for client_secret_jwt authentication
   * @param client_id The client identifier
   * @param client_secret The client secret
   * @param audience The token endpoint URL (audience)
   * @param algorithm The HMAC algorithm to use (HS256, HS384, HS512). Defaults to HS256
   */ static async generateClientAssertionJwt(client_id, client_secret, audience, algorithm = "HS256") {
        const now = Math.floor(Date.now() / 1e3);
        const header = {
            "alg": algorithm,
            "typ": "JWT"
        };
        const payload = {
            "iss": client_id,
            "sub": client_id,
            "aud": audience,
            "jti": _CryptoUtils.generateUUIDv4(),
            "exp": now + 300,
            // 5 minutes
            "iat": now
        };
        const hashMap = {
            "HS256": "SHA-256",
            "HS384": "SHA-384",
            "HS512": "SHA-512"
        };
        const hashFunction = hashMap[algorithm];
        if (!hashFunction) throw new Error(`Unsupported algorithm: ${algorithm}. Supported algorithms are: HS256, HS384, HS512`);
        const encoder = new TextEncoder();
        const secretKey = await crypto.subtle.importKey("raw", encoder.encode(client_secret), {
            name: "HMAC",
            hash: hashFunction
        }, false, [
            "sign"
        ]);
        return await $631c75f8a3fcffe9$var$JwtUtils.generateSignedJwtWithHmac(header, payload, secretKey);
    }
};
/**
 * Generates a base64url encoded string
 */ $631c75f8a3fcffe9$var$_CryptoUtils.encodeBase64Url = (input)=>{
    return $631c75f8a3fcffe9$var$toBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var $631c75f8a3fcffe9$var$CryptoUtils = $631c75f8a3fcffe9$var$_CryptoUtils;
// src/utils/Event.ts
var $631c75f8a3fcffe9$var$Event = class {
    constructor(_name){
        this._name = _name;
        this._callbacks = [];
        this._logger = new $631c75f8a3fcffe9$var$Logger(`Event('${this._name}')`);
    }
    addHandler(cb) {
        this._callbacks.push(cb);
        return ()=>this.removeHandler(cb);
    }
    removeHandler(cb) {
        const idx = this._callbacks.lastIndexOf(cb);
        if (idx >= 0) this._callbacks.splice(idx, 1);
    }
    async raise(...ev) {
        this._logger.debug("raise:", ...ev);
        for (const cb of this._callbacks)await cb(...ev);
    }
};
// src/utils/PopupUtils.ts
var $631c75f8a3fcffe9$var$PopupUtils = class {
    /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */ static center({ ...features }) {
        var _a, _b, _c;
        if (features.width == null) features.width = (_a = [
            800,
            720,
            600,
            480
        ].find((width)=>width <= window.outerWidth / 1.618)) != null ? _a : 360;
        (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
        if (features.height != null) (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
        return features;
    }
    static serialize(features) {
        return Object.entries(features).filter(([, value])=>value != null).map(([key, value])=>`${key}=${typeof value !== "boolean" ? value : value ? "yes" : "no"}`).join(",");
    }
};
// src/utils/Timer.ts
var $631c75f8a3fcffe9$var$Timer = class _Timer extends $631c75f8a3fcffe9$var$Event {
    constructor(){
        super(...arguments);
        this._logger = new $631c75f8a3fcffe9$var$Logger(`Timer('${this._name}')`);
        this._timerHandle = null;
        this._expiration = 0;
        this._callback = ()=>{
            const diff = this._expiration - _Timer.getEpochTime();
            this._logger.debug("timer completes in", diff);
            if (this._expiration <= _Timer.getEpochTime()) {
                this.cancel();
                super.raise();
            }
        };
    }
    // get the time
    static getEpochTime() {
        return Math.floor(Date.now() / 1e3);
    }
    init(durationInSeconds) {
        const logger2 = this._logger.create("init");
        durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
        const expiration = _Timer.getEpochTime() + durationInSeconds;
        if (this.expiration === expiration && this._timerHandle) {
            logger2.debug("skipping since already initialized for expiration at", this.expiration);
            return;
        }
        this.cancel();
        logger2.debug("using duration", durationInSeconds);
        this._expiration = expiration;
        const timerDurationInSeconds = Math.min(durationInSeconds, 5);
        this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
    }
    get expiration() {
        return this._expiration;
    }
    cancel() {
        this._logger.create("cancel");
        if (this._timerHandle) {
            clearInterval(this._timerHandle);
            this._timerHandle = null;
        }
    }
};
// src/utils/UrlUtils.ts
var $631c75f8a3fcffe9$var$UrlUtils = class {
    static readParams(url, responseMode = "query") {
        if (!url) throw new TypeError("Invalid URL");
        const parsedUrl = new URL(url, "http://127.0.0.1");
        const params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
        return new URLSearchParams(params.slice(1));
    }
};
var $631c75f8a3fcffe9$var$URL_STATE_DELIMITER = ";";
// src/errors/ErrorResponse.ts
var $631c75f8a3fcffe9$var$ErrorResponse = class extends Error {
    constructor(args, form){
        var _a, _b, _c;
        super(args.error_description || args.error || "");
        this.form = form;
        /** Marker to detect class: "ErrorResponse" */ this.name = "ErrorResponse";
        if (!args.error) {
            $631c75f8a3fcffe9$var$Logger.error("ErrorResponse", "No error passed");
            throw new Error("No error passed");
        }
        this.error = args.error;
        this.error_description = (_a = args.error_description) != null ? _a : null;
        this.error_uri = (_b = args.error_uri) != null ? _b : null;
        this.state = args.userState;
        this.session_state = (_c = args.session_state) != null ? _c : null;
        this.url_state = args.url_state;
    }
};
// src/errors/ErrorTimeout.ts
var $631c75f8a3fcffe9$var$ErrorTimeout = class extends Error {
    constructor(message){
        super(message);
        /** Marker to detect class: "ErrorTimeout" */ this.name = "ErrorTimeout";
    }
};
// src/AccessTokenEvents.ts
var $631c75f8a3fcffe9$var$AccessTokenEvents = class {
    constructor(args){
        this._logger = new $631c75f8a3fcffe9$var$Logger("AccessTokenEvents");
        this._expiringTimer = new $631c75f8a3fcffe9$var$Timer("Access token expiring");
        this._expiredTimer = new $631c75f8a3fcffe9$var$Timer("Access token expired");
        this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
    }
    async load(container) {
        const logger2 = this._logger.create("load");
        if (container.access_token && container.expires_in !== void 0) {
            const duration = container.expires_in;
            logger2.debug("access token present, remaining duration:", duration);
            if (duration > 0) {
                let expiring = duration - this._expiringNotificationTimeInSeconds;
                if (expiring <= 0) expiring = 1;
                logger2.debug("registering expiring timer, raising in", expiring, "seconds");
                this._expiringTimer.init(expiring);
            } else {
                logger2.debug("canceling existing expiring timer because we're past expiration.");
                this._expiringTimer.cancel();
            }
            const expired = duration + 1;
            logger2.debug("registering expired timer, raising in", expired, "seconds");
            this._expiredTimer.init(expired);
        } else {
            this._expiringTimer.cancel();
            this._expiredTimer.cancel();
        }
    }
    async unload() {
        this._logger.debug("unload: canceling existing access token timers");
        this._expiringTimer.cancel();
        this._expiredTimer.cancel();
    }
    /**
   * Add callback: Raised prior to the access token expiring.
   */ addAccessTokenExpiring(cb) {
        return this._expiringTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised prior to the access token expiring.
   */ removeAccessTokenExpiring(cb) {
        this._expiringTimer.removeHandler(cb);
    }
    /**
   * Add callback: Raised after the access token has expired.
   */ addAccessTokenExpired(cb) {
        return this._expiredTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised after the access token has expired.
   */ removeAccessTokenExpired(cb) {
        this._expiredTimer.removeHandler(cb);
    }
};
// src/CheckSessionIFrame.ts
var $631c75f8a3fcffe9$var$CheckSessionIFrame = class {
    constructor(_callback, _client_id, url, _intervalInSeconds, _stopOnError){
        this._callback = _callback;
        this._client_id = _client_id;
        this._intervalInSeconds = _intervalInSeconds;
        this._stopOnError = _stopOnError;
        this._logger = new $631c75f8a3fcffe9$var$Logger("CheckSessionIFrame");
        this._timer = null;
        this._session_state = null;
        this._message = (e)=>{
            if (e.origin === this._frame_origin && e.source === this._frame.contentWindow) {
                if (e.data === "error") {
                    this._logger.error("error message from check session op iframe");
                    if (this._stopOnError) this.stop();
                } else if (e.data === "changed") {
                    this._logger.debug("changed message from check session op iframe");
                    this.stop();
                    this._callback();
                } else this._logger.debug(e.data + " message from check session op iframe");
            }
        };
        const parsedUrl = new URL(url);
        this._frame_origin = parsedUrl.origin;
        this._frame = window.document.createElement("iframe");
        this._frame.style.visibility = "hidden";
        this._frame.style.position = "fixed";
        this._frame.style.left = "-1000px";
        this._frame.style.top = "0";
        this._frame.width = "0";
        this._frame.height = "0";
        this._frame.src = parsedUrl.href;
    }
    load() {
        return new Promise((resolve)=>{
            this._frame.onload = ()=>{
                resolve();
            };
            window.document.body.appendChild(this._frame);
            window.addEventListener("message", this._message, false);
        });
    }
    start(session_state) {
        if (this._session_state === session_state) return;
        this._logger.create("start");
        this.stop();
        this._session_state = session_state;
        const send = ()=>{
            if (!this._frame.contentWindow || !this._session_state) return;
            this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
        };
        send();
        this._timer = setInterval(send, this._intervalInSeconds * 1e3);
    }
    stop() {
        this._logger.create("stop");
        this._session_state = null;
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }
};
// src/InMemoryWebStorage.ts
var $631c75f8a3fcffe9$var$InMemoryWebStorage = class {
    constructor(){
        this._logger = new $631c75f8a3fcffe9$var$Logger("InMemoryWebStorage");
        this._data = {};
    }
    clear() {
        this._logger.create("clear");
        this._data = {};
    }
    getItem(key) {
        this._logger.create(`getItem('${key}')`);
        return this._data[key];
    }
    setItem(key, value) {
        this._logger.create(`setItem('${key}')`);
        this._data[key] = value;
    }
    removeItem(key) {
        this._logger.create(`removeItem('${key}')`);
        delete this._data[key];
    }
    get length() {
        return Object.getOwnPropertyNames(this._data).length;
    }
    key(index) {
        return Object.getOwnPropertyNames(this._data)[index];
    }
};
// src/errors/ErrorDPoPNonce.ts
var $631c75f8a3fcffe9$var$ErrorDPoPNonce = class extends Error {
    constructor(nonce, message){
        super(message);
        /** Marker to detect class: "ErrorDPoPNonce" */ this.name = "ErrorDPoPNonce";
        this.nonce = nonce;
    }
};
// src/JsonService.ts
var $631c75f8a3fcffe9$var$JsonService = class {
    constructor(additionalContentTypes = [], _jwtHandler = null, _extraHeaders = {}){
        this._jwtHandler = _jwtHandler;
        this._extraHeaders = _extraHeaders;
        this._logger = new $631c75f8a3fcffe9$var$Logger("JsonService");
        this._contentTypes = [];
        this._contentTypes.push(...additionalContentTypes, "application/json");
        if (_jwtHandler) this._contentTypes.push("application/jwt");
    }
    async fetchWithTimeout(input, init = {}) {
        const { timeoutInSeconds: timeoutInSeconds, ...initFetch } = init;
        if (!timeoutInSeconds) return await fetch(input, initFetch);
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeoutInSeconds * 1e3);
        try {
            const response = await fetch(input, {
                ...init,
                signal: controller.signal
            });
            return response;
        } catch (err) {
            if (err instanceof DOMException && err.name === "AbortError") throw new $631c75f8a3fcffe9$var$ErrorTimeout("Network timed out");
            throw err;
        } finally{
            clearTimeout(timeoutId);
        }
    }
    async getJson(url, { token: token, credentials: credentials, timeoutInSeconds: timeoutInSeconds } = {}) {
        const logger2 = this._logger.create("getJson");
        const headers = {
            "Accept": this._contentTypes.join(", ")
        };
        if (token) {
            logger2.debug("token passed, setting Authorization header");
            headers["Authorization"] = "Bearer " + token;
        }
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "GET",
                headers: headers,
                timeoutInSeconds: timeoutInSeconds,
                credentials: credentials
            });
        } catch (err) {
            logger2.error("Network Error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) logger2.throw(new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`));
        if (response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt"))) return await this._jwtHandler(await response.text());
        let json;
        try {
            json = await response.json();
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (json.error) throw new $631c75f8a3fcffe9$var$ErrorResponse(json);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    async postForm(url, { body: body, basicAuth: basicAuth, timeoutInSeconds: timeoutInSeconds, initCredentials: initCredentials, extraHeaders: extraHeaders }) {
        const logger2 = this._logger.create("postForm");
        const headers = {
            "Accept": this._contentTypes.join(", "),
            "Content-Type": "application/x-www-form-urlencoded",
            ...extraHeaders
        };
        if (basicAuth !== void 0) headers["Authorization"] = "Basic " + basicAuth;
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: body,
                timeoutInSeconds: timeoutInSeconds,
                credentials: initCredentials
            });
        } catch (err) {
            logger2.error("Network error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) throw new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`);
        const responseText = await response.text();
        let json = {};
        if (responseText) try {
            json = JSON.parse(responseText);
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (response.headers.has("dpop-nonce")) {
                const nonce = response.headers.get("dpop-nonce");
                throw new $631c75f8a3fcffe9$var$ErrorDPoPNonce(nonce, `${JSON.stringify(json)}`);
            }
            if (json.error) throw new $631c75f8a3fcffe9$var$ErrorResponse(json, body);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    _appendExtraHeaders(headers) {
        const logger2 = this._logger.create("appendExtraHeaders");
        const customKeys = Object.keys(this._extraHeaders);
        const protectedHeaders = [
            "accept",
            "content-type"
        ];
        const preventOverride = [
            "authorization"
        ];
        if (customKeys.length === 0) return;
        customKeys.forEach((headerName)=>{
            if (protectedHeaders.includes(headerName.toLocaleLowerCase())) {
                logger2.warn("Protected header could not be set", headerName, protectedHeaders);
                return;
            }
            if (preventOverride.includes(headerName.toLocaleLowerCase()) && Object.keys(headers).includes(headerName)) {
                logger2.warn("Header could not be overridden", headerName, preventOverride);
                return;
            }
            const content = typeof this._extraHeaders[headerName] === "function" ? this._extraHeaders[headerName]() : this._extraHeaders[headerName];
            if (content && content !== "") headers[headerName] = content;
        });
    }
};
// src/MetadataService.ts
var $631c75f8a3fcffe9$var$MetadataService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("MetadataService");
        this._signingKeys = null;
        this._metadata = null;
        this._metadataUrl = this._settings.metadataUrl;
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService([
            "application/jwk-set+json"
        ], null, this._settings.extraHeaders);
        if (this._settings.signingKeys) {
            this._logger.debug("using signingKeys from settings");
            this._signingKeys = this._settings.signingKeys;
        }
        if (this._settings.metadata) {
            this._logger.debug("using metadata from settings");
            this._metadata = this._settings.metadata;
        }
        if (this._settings.fetchRequestCredentials) {
            this._logger.debug("using fetchRequestCredentials from settings");
            this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
        }
    }
    resetSigningKeys() {
        this._signingKeys = null;
    }
    async getMetadata() {
        const logger2 = this._logger.create("getMetadata");
        if (this._metadata) {
            logger2.debug("using cached values");
            return this._metadata;
        }
        if (!this._metadataUrl) {
            logger2.throw(new Error("No authority or metadataUrl configured on settings"));
            throw null;
        }
        logger2.debug("getting metadata from", this._metadataUrl);
        const metadata = await this._jsonService.getJson(this._metadataUrl, {
            credentials: this._fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("merging remote JSON with seed metadata");
        this._metadata = Object.assign({}, metadata, this._settings.metadataSeed);
        return this._metadata;
    }
    getIssuer() {
        return this._getMetadataProperty("issuer");
    }
    getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
    }
    getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
    }
    getTokenEndpoint(optional = true) {
        return this._getMetadataProperty("token_endpoint", optional);
    }
    getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", true);
    }
    getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", true);
    }
    getRevocationEndpoint(optional = true) {
        return this._getMetadataProperty("revocation_endpoint", optional);
    }
    getKeysEndpoint(optional = true) {
        return this._getMetadataProperty("jwks_uri", optional);
    }
    async _getMetadataProperty(name, optional = false) {
        const logger2 = this._logger.create(`_getMetadataProperty('${name}')`);
        const metadata = await this.getMetadata();
        logger2.debug("resolved");
        if (metadata[name] === void 0) {
            if (optional === true) {
                logger2.warn("Metadata does not contain optional property");
                return void 0;
            }
            logger2.throw(new Error("Metadata does not contain property " + name));
        }
        return metadata[name];
    }
    async getSigningKeys() {
        const logger2 = this._logger.create("getSigningKeys");
        if (this._signingKeys) {
            logger2.debug("returning signingKeys from cache");
            return this._signingKeys;
        }
        const jwks_uri = await this.getKeysEndpoint(false);
        logger2.debug("got jwks_uri", jwks_uri);
        const keySet = await this._jsonService.getJson(jwks_uri, {
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got key set", keySet);
        if (!Array.isArray(keySet.keys)) {
            logger2.throw(new Error("Missing keys on keyset"));
            throw null;
        }
        this._signingKeys = keySet.keys;
        return this._signingKeys;
    }
};
// src/WebStorageStateStore.ts
var $631c75f8a3fcffe9$var$WebStorageStateStore = class {
    constructor({ prefix: prefix = "oidc.", store: store = localStorage } = {}){
        this._logger = new $631c75f8a3fcffe9$var$Logger("WebStorageStateStore");
        this._store = store;
        this._prefix = prefix;
    }
    async set(key, value) {
        this._logger.create(`set('${key}')`);
        key = this._prefix + key;
        await this._store.setItem(key, value);
    }
    async get(key) {
        this._logger.create(`get('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        return item;
    }
    async remove(key) {
        this._logger.create(`remove('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        await this._store.removeItem(key);
        return item;
    }
    async getAllKeys() {
        this._logger.create("getAllKeys");
        const len = await this._store.length;
        const keys = [];
        for(let index = 0; index < len; index++){
            const key = await this._store.key(index);
            if (key && key.indexOf(this._prefix) === 0) keys.push(key.substr(this._prefix.length));
        }
        return keys;
    }
};
// src/OidcClientSettings.ts
var $631c75f8a3fcffe9$var$DefaultResponseType = "code";
var $631c75f8a3fcffe9$var$DefaultScope = "openid";
var $631c75f8a3fcffe9$var$DefaultClientAuthentication = "client_secret_post";
var $631c75f8a3fcffe9$var$DefaultStaleStateAgeInSeconds = 900;
var $631c75f8a3fcffe9$var$OidcClientSettingsStore = class {
    constructor({ authority: // metadata related
    authority, metadataUrl: metadataUrl, metadata: metadata, signingKeys: signingKeys, metadataSeed: metadataSeed, client_id: // client related
    client_id, client_secret: client_secret, response_type: response_type = $631c75f8a3fcffe9$var$DefaultResponseType, scope: scope = $631c75f8a3fcffe9$var$DefaultScope, redirect_uri: redirect_uri, post_logout_redirect_uri: post_logout_redirect_uri, client_authentication: client_authentication = $631c75f8a3fcffe9$var$DefaultClientAuthentication, token_endpoint_auth_signing_alg: token_endpoint_auth_signing_alg = "HS256", prompt: // optional protocol
    prompt, display: display, max_age: max_age, ui_locales: ui_locales, acr_values: acr_values, resource: resource, response_mode: response_mode, filterProtocolClaims: // behavior flags
    filterProtocolClaims = true, loadUserInfo: loadUserInfo = false, requestTimeoutInSeconds: requestTimeoutInSeconds, staleStateAgeInSeconds: staleStateAgeInSeconds = $631c75f8a3fcffe9$var$DefaultStaleStateAgeInSeconds, mergeClaimsStrategy: mergeClaimsStrategy = {
        array: "replace"
    }, disablePKCE: disablePKCE = false, stateStore: // other behavior
    stateStore, revokeTokenAdditionalContentTypes: revokeTokenAdditionalContentTypes, fetchRequestCredentials: fetchRequestCredentials, refreshTokenAllowedScope: refreshTokenAllowedScope, extraQueryParams: // extra
    extraQueryParams = {}, extraTokenParams: extraTokenParams = {}, extraHeaders: extraHeaders = {}, dpop: dpop, omitScopeWhenRequesting: omitScopeWhenRequesting = false }){
        var _a;
        this.authority = authority;
        if (metadataUrl) this.metadataUrl = metadataUrl;
        else {
            this.metadataUrl = authority;
            if (authority) {
                if (!this.metadataUrl.endsWith("/")) this.metadataUrl += "/";
                this.metadataUrl += ".well-known/openid-configuration";
            }
        }
        this.metadata = metadata;
        this.metadataSeed = metadataSeed;
        this.signingKeys = signingKeys;
        this.client_id = client_id;
        this.client_secret = client_secret;
        this.response_type = response_type;
        this.scope = scope;
        this.redirect_uri = redirect_uri;
        this.post_logout_redirect_uri = post_logout_redirect_uri;
        this.client_authentication = client_authentication;
        this.token_endpoint_auth_signing_alg = token_endpoint_auth_signing_alg;
        this.prompt = prompt;
        this.display = display;
        this.max_age = max_age;
        this.ui_locales = ui_locales;
        this.acr_values = acr_values;
        this.resource = resource;
        this.response_mode = response_mode;
        this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
        this.loadUserInfo = !!loadUserInfo;
        this.staleStateAgeInSeconds = staleStateAgeInSeconds;
        this.mergeClaimsStrategy = mergeClaimsStrategy;
        this.omitScopeWhenRequesting = omitScopeWhenRequesting;
        this.disablePKCE = !!disablePKCE;
        this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
        this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : "same-origin";
        this.requestTimeoutInSeconds = requestTimeoutInSeconds;
        if (stateStore) this.stateStore = stateStore;
        else {
            const store = typeof window !== "undefined" ? window.localStorage : new $631c75f8a3fcffe9$var$InMemoryWebStorage();
            this.stateStore = new $631c75f8a3fcffe9$var$WebStorageStateStore({
                store: store
            });
        }
        this.refreshTokenAllowedScope = refreshTokenAllowedScope;
        this.extraQueryParams = extraQueryParams;
        this.extraTokenParams = extraTokenParams;
        this.extraHeaders = extraHeaders;
        this.dpop = dpop;
        if (this.dpop && !((_a = this.dpop) == null ? void 0 : _a.store)) throw new Error("A DPoPStore is required when dpop is enabled");
    }
};
// src/UserInfoService.ts
var $631c75f8a3fcffe9$var$UserInfoService = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserInfoService");
        this._getClaimsFromJwt = async (responseText)=>{
            const logger2 = this._logger.create("_getClaimsFromJwt");
            try {
                const payload = $631c75f8a3fcffe9$var$JwtUtils.decode(responseText);
                logger2.debug("JWT decoding successful");
                return payload;
            } catch (err) {
                logger2.error("Error parsing JWT response");
                throw err;
            }
        };
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
    }
    async getClaims(token) {
        const logger2 = this._logger.create("getClaims");
        if (!token) this._logger.throw(new Error("No token passed"));
        const url = await this._metadataService.getUserInfoEndpoint();
        logger2.debug("got userinfo url", url);
        const claims = await this._jsonService.getJson(url, {
            token: token,
            credentials: this._settings.fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got claims", claims);
        return claims;
    }
};
// src/TokenClient.ts
var $631c75f8a3fcffe9$var$TokenClient = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("TokenClient");
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
    }
    /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */ async exchangeCode({ grant_type: grant_type = "authorization_code", redirect_uri: redirect_uri = this._settings.redirect_uri, client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeCode");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!redirect_uri) logger2.throw(new Error("A redirect_uri is required"));
        if (!args.code) logger2.throw(new Error("A code is required"));
        const params = new URLSearchParams({
            grant_type: grant_type,
            redirect_uri: redirect_uri
        });
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */ async exchangeCredentials({ grant_type: grant_type = "password", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, scope: scope = this._settings.scope, ...args }) {
        const logger2 = this._logger.create("exchangeCredentials");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        if (!this._settings.omitScopeWhenRequesting) params.set("scope", scope);
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */ async exchangeRefreshToken({ grant_type: grant_type = "refresh_token", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeRefreshToken");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!args.refresh_token) logger2.throw(new Error("A refresh_token is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        for (const [key, value] of Object.entries(args)){
            if (Array.isArray(value)) value.forEach((param)=>params.append(key, param));
            else if (value != null) params.set(key, value);
        }
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: timeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */ async revoke(args) {
        var _a;
        const logger2 = this._logger.create("revoke");
        if (!args.token) logger2.throw(new Error("A token is required"));
        const url = await this._metadataService.getRevocationEndpoint(false);
        logger2.debug(`got revocation endpoint, revoking ${(_a = args.token_type_hint) != null ? _a : "default token type"}`);
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        params.set("client_id", this._settings.client_id);
        if (this._settings.client_secret) params.set("client_secret", this._settings.client_secret);
        await this._jsonService.postForm(url, {
            body: params,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got response");
    }
};
// src/ResponseValidator.ts
var $631c75f8a3fcffe9$var$ResponseValidator = class {
    constructor(_settings, _metadataService, _claimsService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._claimsService = _claimsService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("ResponseValidator");
        this._userInfoService = new $631c75f8a3fcffe9$var$UserInfoService(this._settings, this._metadataService);
        this._tokenClient = new $631c75f8a3fcffe9$var$TokenClient(this._settings, this._metadataService);
    }
    async validateSigninResponse(response, state, extraHeaders) {
        const logger2 = this._logger.create("validateSigninResponse");
        this._processSigninState(response, state);
        logger2.debug("state processed");
        await this._processCode(response, state, extraHeaders);
        logger2.debug("code processed");
        if (response.isOpenId) this._validateIdTokenAttributes(response);
        logger2.debug("tokens validated");
        await this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
        logger2.debug("claims processed");
    }
    async validateCredentialsResponse(response, skipUserInfo) {
        const logger2 = this._logger.create("validateCredentialsResponse");
        const shouldValidateSubClaim = response.isOpenId && !!response.id_token;
        if (shouldValidateSubClaim) this._validateIdTokenAttributes(response);
        logger2.debug("tokens validated");
        await this._processClaims(response, skipUserInfo, shouldValidateSubClaim);
        logger2.debug("claims processed");
    }
    async validateRefreshResponse(response, state) {
        var _a, _b;
        const logger2 = this._logger.create("validateRefreshResponse");
        response.userState = state.data;
        (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
        (_b = response.scope) != null ? _b : response.scope = state.scope;
        if (response.isOpenId && !!response.id_token) {
            this._validateIdTokenAttributes(response, state.id_token);
            logger2.debug("ID Token validated");
        }
        if (!response.id_token) {
            response.id_token = state.id_token;
            response.profile = state.profile;
        }
        const hasIdToken = response.isOpenId && !!response.id_token;
        await this._processClaims(response, false, hasIdToken);
        logger2.debug("claims processed");
    }
    validateSignoutResponse(response, state) {
        const logger2 = this._logger.create("validateSignoutResponse");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        logger2.debug("state validated");
        response.userState = state.data;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
        }
    }
    _processSigninState(response, state) {
        var _a;
        const logger2 = this._logger.create("_processSigninState");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        if (!state.client_id) logger2.throw(new Error("No client_id on state"));
        if (!state.authority) logger2.throw(new Error("No authority on state"));
        if (this._settings.authority !== state.authority) logger2.throw(new Error("authority mismatch on settings vs. signin state"));
        if (this._settings.client_id && this._settings.client_id !== state.client_id) logger2.throw(new Error("client_id mismatch on settings vs. signin state"));
        logger2.debug("state validated");
        response.userState = state.data;
        response.url_state = state.url_state;
        (_a = response.scope) != null ? _a : response.scope = state.scope;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
        }
        if (state.code_verifier && !response.code) logger2.throw(new Error("Expected code in response"));
    }
    async _processClaims(response, skipUserInfo = false, validateSub = true) {
        const logger2 = this._logger.create("_processClaims");
        response.profile = this._claimsService.filterProtocolClaims(response.profile);
        if (skipUserInfo || !this._settings.loadUserInfo || !response.access_token) {
            logger2.debug("not loading user info");
            return;
        }
        logger2.debug("loading user info");
        const claims = await this._userInfoService.getClaims(response.access_token);
        logger2.debug("user info claims received from user info endpoint");
        if (validateSub && claims.sub !== response.profile.sub) logger2.throw(new Error("subject from UserInfo response does not match subject in ID Token"));
        response.profile = this._claimsService.mergeClaims(response.profile, this._claimsService.filterProtocolClaims(claims));
        logger2.debug("user info claims received, updated profile:", response.profile);
    }
    async _processCode(response, state, extraHeaders) {
        const logger2 = this._logger.create("_processCode");
        if (response.code) {
            logger2.debug("Validating code");
            const tokenResponse = await this._tokenClient.exchangeCode({
                client_id: state.client_id,
                client_secret: state.client_secret,
                code: response.code,
                redirect_uri: state.redirect_uri,
                code_verifier: state.code_verifier,
                extraHeaders: extraHeaders,
                ...state.extraTokenParams
            });
            Object.assign(response, tokenResponse);
        } else logger2.debug("No code to process");
    }
    _validateIdTokenAttributes(response, existingToken) {
        var _a;
        const logger2 = this._logger.create("_validateIdTokenAttributes");
        logger2.debug("decoding ID Token JWT");
        const incoming = $631c75f8a3fcffe9$var$JwtUtils.decode((_a = response.id_token) != null ? _a : "");
        if (!incoming.sub) logger2.throw(new Error("ID Token is missing a subject claim"));
        if (existingToken) {
            const existing = $631c75f8a3fcffe9$var$JwtUtils.decode(existingToken);
            if (incoming.sub !== existing.sub) logger2.throw(new Error("sub in id_token does not match current sub"));
            if (incoming.auth_time && incoming.auth_time !== existing.auth_time) logger2.throw(new Error("auth_time in id_token does not match original auth_time"));
            if (incoming.azp && incoming.azp !== existing.azp) logger2.throw(new Error("azp in id_token does not match original azp"));
            if (!incoming.azp && existing.azp) logger2.throw(new Error("azp not in id_token, but present in original id_token"));
        }
        response.profile = incoming;
    }
};
// src/State.ts
var $631c75f8a3fcffe9$var$State = class _State {
    constructor(args){
        this.id = args.id || $631c75f8a3fcffe9$var$CryptoUtils.generateUUIDv4();
        this.data = args.data;
        if (args.created && args.created > 0) this.created = args.created;
        else this.created = $631c75f8a3fcffe9$var$Timer.getEpochTime();
        this.request_type = args.request_type;
        this.url_state = args.url_state;
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("State").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("State", "fromStorageString");
        return Promise.resolve(new _State(JSON.parse(storageString)));
    }
    static async clearStaleState(storage, age) {
        const logger2 = $631c75f8a3fcffe9$var$Logger.createStatic("State", "clearStaleState");
        const cutoff = $631c75f8a3fcffe9$var$Timer.getEpochTime() - age;
        const keys = await storage.getAllKeys();
        logger2.debug("got keys", keys);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const item = await storage.get(key);
            let remove = false;
            if (item) try {
                const state = await _State.fromStorageString(item);
                logger2.debug("got item from key:", key, state.created);
                if (state.created <= cutoff) remove = true;
            } catch (err) {
                logger2.error("Error parsing state for key:", key, err);
                remove = true;
            }
            else {
                logger2.debug("no item in storage for key:", key);
                remove = true;
            }
            if (remove) {
                logger2.debug("removed item for key:", key);
                storage.remove(key);
            }
        }
    }
};
// src/SigninState.ts
var $631c75f8a3fcffe9$var$SigninState = class _SigninState extends $631c75f8a3fcffe9$var$State {
    constructor(args){
        super(args);
        this.code_verifier = args.code_verifier;
        this.code_challenge = args.code_challenge;
        this.authority = args.authority;
        this.client_id = args.client_id;
        this.redirect_uri = args.redirect_uri;
        this.scope = args.scope;
        this.client_secret = args.client_secret;
        this.extraTokenParams = args.extraTokenParams;
        this.response_mode = args.response_mode;
        this.skipUserInfo = args.skipUserInfo;
    }
    static async create(args) {
        const code_verifier = args.code_verifier === true ? $631c75f8a3fcffe9$var$CryptoUtils.generateCodeVerifier() : args.code_verifier || void 0;
        const code_challenge = code_verifier ? await $631c75f8a3fcffe9$var$CryptoUtils.generateCodeChallenge(code_verifier) : void 0;
        return new _SigninState({
            ...args,
            code_verifier: code_verifier,
            code_challenge: code_challenge
        });
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("SigninState").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state,
            code_verifier: this.code_verifier,
            authority: this.authority,
            client_id: this.client_id,
            redirect_uri: this.redirect_uri,
            scope: this.scope,
            client_secret: this.client_secret,
            extraTokenParams: this.extraTokenParams,
            response_mode: this.response_mode,
            skipUserInfo: this.skipUserInfo
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("SigninState", "fromStorageString");
        const data = JSON.parse(storageString);
        return _SigninState.create(data);
    }
};
// src/SigninRequest.ts
var $631c75f8a3fcffe9$var$_SigninRequest = class _SigninRequest {
    constructor(args){
        this.url = args.url;
        this.state = args.state;
    }
    static async create({ url: // mandatory
    url, authority: authority, client_id: client_id, redirect_uri: redirect_uri, response_type: response_type, scope: scope, state_data: // optional
    state_data, response_mode: response_mode, request_type: request_type, client_secret: client_secret, nonce: nonce, url_state: url_state, resource: resource, skipUserInfo: skipUserInfo, extraQueryParams: extraQueryParams, extraTokenParams: extraTokenParams, disablePKCE: disablePKCE, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting, ...optionalParams }) {
        if (!url) {
            this._logger.error("create: No url passed");
            throw new Error("url");
        }
        if (!client_id) {
            this._logger.error("create: No client_id passed");
            throw new Error("client_id");
        }
        if (!redirect_uri) {
            this._logger.error("create: No redirect_uri passed");
            throw new Error("redirect_uri");
        }
        if (!response_type) {
            this._logger.error("create: No response_type passed");
            throw new Error("response_type");
        }
        if (!scope) {
            this._logger.error("create: No scope passed");
            throw new Error("scope");
        }
        if (!authority) {
            this._logger.error("create: No authority passed");
            throw new Error("authority");
        }
        const state = await $631c75f8a3fcffe9$var$SigninState.create({
            data: state_data,
            request_type: request_type,
            url_state: url_state,
            code_verifier: !disablePKCE,
            client_id: client_id,
            authority: authority,
            redirect_uri: redirect_uri,
            response_mode: response_mode,
            client_secret: client_secret,
            scope: scope,
            extraTokenParams: extraTokenParams,
            skipUserInfo: skipUserInfo
        });
        const parsedUrl = new URL(url);
        parsedUrl.searchParams.append("client_id", client_id);
        parsedUrl.searchParams.append("redirect_uri", redirect_uri);
        parsedUrl.searchParams.append("response_type", response_type);
        if (!omitScopeWhenRequesting) parsedUrl.searchParams.append("scope", scope);
        if (nonce) parsedUrl.searchParams.append("nonce", nonce);
        if (dpopJkt) parsedUrl.searchParams.append("dpop_jkt", dpopJkt);
        let stateParam = state.id;
        if (url_state) stateParam = `${stateParam}${$631c75f8a3fcffe9$var$URL_STATE_DELIMITER}${url_state}`;
        parsedUrl.searchParams.append("state", stateParam);
        if (state.code_challenge) {
            parsedUrl.searchParams.append("code_challenge", state.code_challenge);
            parsedUrl.searchParams.append("code_challenge_method", "S256");
        }
        if (resource) {
            const resources = Array.isArray(resource) ? resource : [
                resource
            ];
            resources.forEach((r)=>parsedUrl.searchParams.append("resource", r));
        }
        for (const [key, value] of Object.entries({
            response_mode: response_mode,
            ...optionalParams,
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        return new _SigninRequest({
            url: parsedUrl.href,
            state: state
        });
    }
};
$631c75f8a3fcffe9$var$_SigninRequest._logger = new $631c75f8a3fcffe9$var$Logger("SigninRequest");
var $631c75f8a3fcffe9$var$SigninRequest = $631c75f8a3fcffe9$var$_SigninRequest;
// src/SigninResponse.ts
var $631c75f8a3fcffe9$var$OidcScope = "openid";
var $631c75f8a3fcffe9$var$SigninResponse = class {
    constructor(params){
        /** @see {@link User.access_token} */ this.access_token = "";
        /** @see {@link User.token_type} */ this.token_type = "";
        /** @see {@link User.profile} */ this.profile = {};
        this.state = params.get("state");
        this.session_state = params.get("session_state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
        this.code = params.get("code");
    }
    get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (typeof value === "string") value = Number(value);
        if (value !== void 0 && value >= 0) this.expires_at = Math.floor(value) + $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    get isOpenId() {
        var _a;
        return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes($631c75f8a3fcffe9$var$OidcScope)) || !!this.id_token;
    }
};
// src/SignoutRequest.ts
var $631c75f8a3fcffe9$var$SignoutRequest = class {
    constructor({ url: url, state_data: state_data, id_token_hint: id_token_hint, post_logout_redirect_uri: post_logout_redirect_uri, extraQueryParams: extraQueryParams, request_type: request_type, client_id: client_id, url_state: url_state }){
        this._logger = new $631c75f8a3fcffe9$var$Logger("SignoutRequest");
        if (!url) {
            this._logger.error("ctor: No url passed");
            throw new Error("url");
        }
        const parsedUrl = new URL(url);
        if (id_token_hint) parsedUrl.searchParams.append("id_token_hint", id_token_hint);
        if (client_id) parsedUrl.searchParams.append("client_id", client_id);
        if (post_logout_redirect_uri) {
            parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
            if (state_data || url_state) {
                this.state = new $631c75f8a3fcffe9$var$State({
                    data: state_data,
                    request_type: request_type,
                    url_state: url_state
                });
                let stateParam = this.state.id;
                if (url_state) stateParam = `${stateParam}${$631c75f8a3fcffe9$var$URL_STATE_DELIMITER}${url_state}`;
                parsedUrl.searchParams.append("state", stateParam);
            }
        }
        for (const [key, value] of Object.entries({
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        this.url = parsedUrl.href;
    }
};
// src/SignoutResponse.ts
var $631c75f8a3fcffe9$var$SignoutResponse = class {
    constructor(params){
        this.state = params.get("state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
    }
};
// src/ClaimsService.ts
var $631c75f8a3fcffe9$var$DefaultProtocolClaims = [
    "nbf",
    "jti",
    "auth_time",
    "nonce",
    "acr",
    "amr",
    "azp",
    "at_hash"
];
var $631c75f8a3fcffe9$var$InternalRequiredProtocolClaims = [
    "sub",
    "iss",
    "aud",
    "exp",
    "iat"
];
var $631c75f8a3fcffe9$var$ClaimsService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("ClaimsService");
    }
    filterProtocolClaims(claims) {
        const result = {
            ...claims
        };
        if (this._settings.filterProtocolClaims) {
            let protocolClaims;
            if (Array.isArray(this._settings.filterProtocolClaims)) protocolClaims = this._settings.filterProtocolClaims;
            else protocolClaims = $631c75f8a3fcffe9$var$DefaultProtocolClaims;
            for (const claim of protocolClaims)if (!$631c75f8a3fcffe9$var$InternalRequiredProtocolClaims.includes(claim)) delete result[claim];
        }
        return result;
    }
    mergeClaims(claims1, claims2) {
        const result = {
            ...claims1
        };
        for (const [claim, values] of Object.entries(claims2))if (result[claim] !== values) {
            if (Array.isArray(result[claim]) || Array.isArray(values)) {
                if (this._settings.mergeClaimsStrategy.array == "replace") result[claim] = values;
                else {
                    const mergedValues = Array.isArray(result[claim]) ? result[claim] : [
                        result[claim]
                    ];
                    for (const value of Array.isArray(values) ? values : [
                        values
                    ])if (!mergedValues.includes(value)) mergedValues.push(value);
                    result[claim] = mergedValues;
                }
            } else if (typeof result[claim] === "object" && typeof values === "object") result[claim] = this.mergeClaims(result[claim], values);
            else result[claim] = values;
        }
        return result;
    }
};
// src/DPoPStore.ts
var $631c75f8a3fcffe9$var$DPoPState = class {
    constructor(keys, nonce){
        this.keys = keys;
        this.nonce = nonce;
    }
};
// src/OidcClient.ts
var $631c75f8a3fcffe9$var$OidcClient = class {
    constructor(settings, metadataService){
        this._logger = new $631c75f8a3fcffe9$var$Logger("OidcClient");
        this.settings = settings instanceof $631c75f8a3fcffe9$var$OidcClientSettingsStore ? settings : new $631c75f8a3fcffe9$var$OidcClientSettingsStore(settings);
        this.metadataService = metadataService != null ? metadataService : new $631c75f8a3fcffe9$var$MetadataService(this.settings);
        this._claimsService = new $631c75f8a3fcffe9$var$ClaimsService(this.settings);
        this._validator = new $631c75f8a3fcffe9$var$ResponseValidator(this.settings, this.metadataService, this._claimsService);
        this._tokenClient = new $631c75f8a3fcffe9$var$TokenClient(this.settings, this.metadataService);
    }
    async createSigninRequest({ state: state, request: request, request_uri: request_uri, request_type: request_type, id_token_hint: id_token_hint, login_hint: login_hint, skipUserInfo: skipUserInfo, nonce: nonce, url_state: url_state, response_type: response_type = this.settings.response_type, scope: scope = this.settings.scope, redirect_uri: redirect_uri = this.settings.redirect_uri, prompt: prompt = this.settings.prompt, display: display = this.settings.display, max_age: max_age = this.settings.max_age, ui_locales: ui_locales = this.settings.ui_locales, acr_values: acr_values = this.settings.acr_values, resource: resource = this.settings.resource, response_mode: response_mode = this.settings.response_mode, extraQueryParams: extraQueryParams = this.settings.extraQueryParams, extraTokenParams: extraTokenParams = this.settings.extraTokenParams, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting = this.settings.omitScopeWhenRequesting }) {
        const logger2 = this._logger.create("createSigninRequest");
        if (response_type !== "code") throw new Error("Only the Authorization Code flow (with PKCE) is supported");
        const url = await this.metadataService.getAuthorizationEndpoint();
        logger2.debug("Received authorization endpoint", url);
        const signinRequest = await $631c75f8a3fcffe9$var$SigninRequest.create({
            url: url,
            authority: this.settings.authority,
            client_id: this.settings.client_id,
            redirect_uri: redirect_uri,
            response_type: response_type,
            scope: scope,
            state_data: state,
            url_state: url_state,
            prompt: prompt,
            display: display,
            max_age: max_age,
            ui_locales: ui_locales,
            id_token_hint: id_token_hint,
            login_hint: login_hint,
            acr_values: acr_values,
            dpopJkt: dpopJkt,
            resource: resource,
            request: request,
            request_uri: request_uri,
            extraQueryParams: extraQueryParams,
            extraTokenParams: extraTokenParams,
            request_type: request_type,
            response_mode: response_mode,
            client_secret: this.settings.client_secret,
            skipUserInfo: skipUserInfo,
            nonce: nonce,
            disablePKCE: this.settings.disablePKCE,
            omitScopeWhenRequesting: omitScopeWhenRequesting
        });
        await this.clearStaleState();
        const signinState = signinRequest.state;
        await this.settings.stateStore.set(signinState.id, signinState.toStorageString());
        return signinRequest;
    }
    async readSigninResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSigninResponseState");
        const response = new $631c75f8a3fcffe9$var$SigninResponse($631c75f8a3fcffe9$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.throw(new Error("No state in response"));
            throw null;
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $631c75f8a3fcffe9$var$SigninState.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSigninResponse(url, extraHeaders, removeState = true) {
        const logger2 = this._logger.create("processSigninResponse");
        const { state: state, response: response } = await this.readSigninResponseState(url, removeState);
        logger2.debug("received state from storage; validating response");
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        try {
            await this._validator.validateSigninResponse(response, state, extraHeaders);
        } catch (err) {
            if (err instanceof $631c75f8a3fcffe9$var$ErrorDPoPNonce && this.settings.dpop) {
                const dpopProof = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                extraHeaders["DPoP"] = dpopProof;
                await this._validator.validateSigninResponse(response, state, extraHeaders);
            } else throw err;
        }
        return response;
    }
    async getDpopProof(dpopStore, nonce) {
        let keyPair;
        let dpopState;
        if (!(await dpopStore.getAllKeys()).includes(this.settings.client_id)) {
            keyPair = await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $631c75f8a3fcffe9$var$DPoPState(keyPair, nonce);
            await dpopStore.set(this.settings.client_id, dpopState);
        } else {
            dpopState = await dpopStore.get(this.settings.client_id);
            if (dpopState.nonce !== nonce && nonce) {
                dpopState.nonce = nonce;
                await dpopStore.set(this.settings.client_id, dpopState);
            }
        }
        return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPProof({
            url: await this.metadataService.getTokenEndpoint(false),
            httpMethod: "POST",
            keyPair: dpopState.keys,
            nonce: dpopState.nonce
        });
    }
    async processResourceOwnerPasswordCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false, extraTokenParams: extraTokenParams = {} }) {
        const tokenResponse = await this._tokenClient.exchangeCredentials({
            username: username,
            password: password,
            ...extraTokenParams
        });
        const signinResponse = new $631c75f8a3fcffe9$var$SigninResponse(new URLSearchParams());
        Object.assign(signinResponse, tokenResponse);
        await this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
        return signinResponse;
    }
    async useRefreshToken({ state: state, redirect_uri: redirect_uri, resource: resource, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, extraTokenParams: extraTokenParams }) {
        var _a;
        const logger2 = this._logger.create("useRefreshToken");
        let scope;
        if (this.settings.refreshTokenAllowedScope === void 0) scope = state.scope;
        else {
            const allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
            const providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
            scope = providedScopes.filter((s)=>allowableScopes.includes(s)).join(" ");
        }
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        let result;
        try {
            result = await this._tokenClient.exchangeRefreshToken({
                refresh_token: state.refresh_token,
                scope: // provide the (possible filtered) scope list
                scope,
                redirect_uri: redirect_uri,
                resource: resource,
                timeoutInSeconds: timeoutInSeconds,
                extraHeaders: extraHeaders,
                ...extraTokenParams
            });
        } catch (err) {
            if (err instanceof $631c75f8a3fcffe9$var$ErrorDPoPNonce && this.settings.dpop) {
                extraHeaders["DPoP"] = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                result = await this._tokenClient.exchangeRefreshToken({
                    refresh_token: state.refresh_token,
                    scope: // provide the (possible filtered) scope list
                    scope,
                    redirect_uri: redirect_uri,
                    resource: resource,
                    timeoutInSeconds: timeoutInSeconds,
                    extraHeaders: extraHeaders,
                    ...extraTokenParams
                });
            } else throw err;
        }
        const response = new $631c75f8a3fcffe9$var$SigninResponse(new URLSearchParams());
        Object.assign(response, result);
        logger2.debug("validating response", response);
        await this._validator.validateRefreshResponse(response, {
            ...state,
            scope: // override the scope in the state handed over to the validator
            // so it can set the granted scope to the requested scope in case none is included in the response
            scope
        });
        return response;
    }
    async createSignoutRequest({ state: state, id_token_hint: id_token_hint, client_id: client_id, request_type: request_type, url_state: url_state, post_logout_redirect_uri: post_logout_redirect_uri = this.settings.post_logout_redirect_uri, extraQueryParams: extraQueryParams = this.settings.extraQueryParams } = {}) {
        const logger2 = this._logger.create("createSignoutRequest");
        const url = await this.metadataService.getEndSessionEndpoint();
        if (!url) {
            logger2.throw(new Error("No end session endpoint"));
            throw null;
        }
        logger2.debug("Received end session endpoint", url);
        if (!client_id && post_logout_redirect_uri && !id_token_hint) client_id = this.settings.client_id;
        const request = new $631c75f8a3fcffe9$var$SignoutRequest({
            url: url,
            id_token_hint: id_token_hint,
            client_id: client_id,
            post_logout_redirect_uri: post_logout_redirect_uri,
            state_data: state,
            extraQueryParams: extraQueryParams,
            request_type: request_type,
            url_state: url_state
        });
        await this.clearStaleState();
        const signoutState = request.state;
        if (signoutState) {
            logger2.debug("Signout request has state to persist");
            await this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
        }
        return request;
    }
    async readSignoutResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSignoutResponseState");
        const response = new $631c75f8a3fcffe9$var$SignoutResponse($631c75f8a3fcffe9$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.debug("No state in response");
            if (response.error) {
                logger2.warn("Response was error:", response.error);
                throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
            }
            return {
                state: void 0,
                response: response
            };
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $631c75f8a3fcffe9$var$State.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSignoutResponse(url) {
        const logger2 = this._logger.create("processSignoutResponse");
        const { state: state, response: response } = await this.readSignoutResponseState(url, true);
        if (state) {
            logger2.debug("Received state from storage; validating response");
            this._validator.validateSignoutResponse(response, state);
        } else logger2.debug("No state from storage; skipping response validation");
        return response;
    }
    clearStaleState() {
        this._logger.create("clearStaleState");
        return $631c75f8a3fcffe9$var$State.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
    }
    async revokeToken(token, type) {
        this._logger.create("revokeToken");
        return await this._tokenClient.revoke({
            token: token,
            token_type_hint: type
        });
    }
};
// src/SessionMonitor.ts
var $631c75f8a3fcffe9$var$SessionMonitor = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $631c75f8a3fcffe9$var$Logger("SessionMonitor");
        this._start = async (user)=>{
            const session_state = user.session_state;
            if (!session_state) return;
            const logger2 = this._logger.create("_start");
            if (user.profile) {
                this._sub = user.profile.sub;
                logger2.debug("session_state", session_state, ", sub", this._sub);
            } else {
                this._sub = void 0;
                logger2.debug("session_state", session_state, ", anonymous user");
            }
            if (this._checkSessionIFrame) {
                this._checkSessionIFrame.start(session_state);
                return;
            }
            try {
                const url = await this._userManager.metadataService.getCheckSessionIframe();
                if (url) {
                    logger2.debug("initializing check session iframe");
                    const client_id = this._userManager.settings.client_id;
                    const intervalInSeconds = this._userManager.settings.checkSessionIntervalInSeconds;
                    const stopOnError = this._userManager.settings.stopCheckSessionOnError;
                    const checkSessionIFrame = new $631c75f8a3fcffe9$var$CheckSessionIFrame(this._callback, client_id, url, intervalInSeconds, stopOnError);
                    await checkSessionIFrame.load();
                    this._checkSessionIFrame = checkSessionIFrame;
                    checkSessionIFrame.start(session_state);
                } else logger2.warn("no check session iframe found in the metadata");
            } catch (err) {
                logger2.error("Error from getCheckSessionIframe:", err instanceof Error ? err.message : err);
            }
        };
        this._stop = ()=>{
            const logger2 = this._logger.create("_stop");
            this._sub = void 0;
            if (this._checkSessionIFrame) this._checkSessionIFrame.stop();
            if (this._userManager.settings.monitorAnonymousSession) {
                const timerHandle = setInterval(async ()=>{
                    clearInterval(timerHandle);
                    try {
                        const session = await this._userManager.querySessionStatus();
                        if (session) {
                            const tmpUser = {
                                session_state: session.session_state,
                                profile: session.sub ? {
                                    sub: session.sub
                                } : null
                            };
                            this._start(tmpUser);
                        }
                    } catch (err) {
                        logger2.error("error from querySessionStatus", err instanceof Error ? err.message : err);
                    }
                }, 1e3);
            }
        };
        this._callback = async ()=>{
            const logger2 = this._logger.create("_callback");
            try {
                const session = await this._userManager.querySessionStatus();
                let raiseEvent = true;
                if (session && this._checkSessionIFrame) {
                    if (session.sub === this._sub) {
                        raiseEvent = false;
                        this._checkSessionIFrame.start(session.session_state);
                        logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
                        await this._userManager.events._raiseUserSessionChanged();
                    } else logger2.debug("different subject signed into OP", session.sub);
                } else logger2.debug("subject no longer signed into OP");
                if (raiseEvent) {
                    if (this._sub) await this._userManager.events._raiseUserSignedOut();
                    else await this._userManager.events._raiseUserSignedIn();
                } else logger2.debug("no change in session detected, no event to raise");
            } catch (err) {
                if (this._sub) {
                    logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", err);
                    await this._userManager.events._raiseUserSignedOut();
                }
            }
        };
        if (!_userManager) this._logger.throw(new Error("No user manager passed"));
        this._userManager.events.addUserLoaded(this._start);
        this._userManager.events.addUserUnloaded(this._stop);
        this._init().catch((err)=>{
            this._logger.error(err);
        });
    }
    async _init() {
        this._logger.create("_init");
        const user = await this._userManager.getUser();
        if (user) this._start(user);
        else if (this._userManager.settings.monitorAnonymousSession) {
            const session = await this._userManager.querySessionStatus();
            if (session) {
                const tmpUser = {
                    session_state: session.session_state,
                    profile: session.sub ? {
                        sub: session.sub
                    } : null
                };
                this._start(tmpUser);
            }
        }
    }
};
// src/User.ts
var $631c75f8a3fcffe9$var$User = class _User {
    constructor(args){
        var _a;
        this.id_token = args.id_token;
        this.session_state = (_a = args.session_state) != null ? _a : null;
        this.access_token = args.access_token;
        this.refresh_token = args.refresh_token;
        this.token_type = args.token_type;
        this.scope = args.scope;
        this.profile = args.profile;
        this.expires_at = args.expires_at;
        this.state = args.userState;
        this.url_state = args.url_state;
    }
    /** Computed number of seconds the access token has remaining. */ get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (value !== void 0) this.expires_at = Math.floor(value) + $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    /** Computed value indicating if the access token is expired. */ get expired() {
        const expires_in = this.expires_in;
        if (expires_in === void 0) return void 0;
        return expires_in <= 0;
    }
    /** Array representing the parsed values from the `scope`. */ get scopes() {
        var _a, _b;
        return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("User").create("toStorageString");
        return JSON.stringify({
            id_token: this.id_token,
            session_state: this.session_state,
            access_token: this.access_token,
            refresh_token: this.refresh_token,
            token_type: this.token_type,
            scope: this.scope,
            profile: this.profile,
            expires_at: this.expires_at
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("User", "fromStorageString");
        return new _User(JSON.parse(storageString));
    }
};
// src/navigators/AbstractChildWindow.ts
var $631c75f8a3fcffe9$var$messageSource = "oidc-client";
var $631c75f8a3fcffe9$var$AbstractChildWindow = class {
    constructor(){
        this._abort = new $631c75f8a3fcffe9$var$Event("Window navigation aborted");
        this._disposeHandlers = /* @__PURE__ */ new Set();
        this._window = null;
    }
    async navigate(params) {
        const logger2 = this._logger.create("navigate");
        if (!this._window) throw new Error("Attempted to navigate on a disposed window");
        logger2.debug("setting URL in window");
        this._window.location.replace(params.url);
        const { url: url, keepOpen: keepOpen } = await new Promise((resolve, reject)=>{
            const listener = (e)=>{
                var _a;
                const data = e.data;
                const origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
                if (e.origin !== origin || (data == null ? void 0 : data.source) !== $631c75f8a3fcffe9$var$messageSource) return;
                try {
                    const state = $631c75f8a3fcffe9$var$UrlUtils.readParams(data.url, params.response_mode).get("state");
                    if (!state) logger2.warn("no state found in response url");
                    if (e.source !== this._window && state !== params.state) return;
                } catch  {
                    this._dispose();
                    reject(new Error("Invalid response from window"));
                }
                resolve(data);
            };
            window.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>window.removeEventListener("message", listener, false));
            const channel = new BroadcastChannel(`oidc-client-popup-${params.state}`);
            channel.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>channel.close());
            this._disposeHandlers.add(this._abort.addHandler((reason)=>{
                this._dispose();
                reject(reason);
            }));
        });
        logger2.debug("got response from window");
        this._dispose();
        if (!keepOpen) this.close();
        return {
            url: url
        };
    }
    _dispose() {
        this._logger.create("_dispose");
        for (const dispose of this._disposeHandlers)dispose();
        this._disposeHandlers.clear();
    }
    static _notifyParent(parent, url, keepOpen = false, targetOrigin = window.location.origin) {
        const msgData = {
            source: $631c75f8a3fcffe9$var$messageSource,
            url: url,
            keepOpen: keepOpen
        };
        const logger2 = new $631c75f8a3fcffe9$var$Logger("_notifyParent");
        if (parent) {
            logger2.debug("With parent. Using parent.postMessage.");
            parent.postMessage(msgData, targetOrigin);
        } else {
            logger2.debug("No parent. Using BroadcastChannel.");
            const state = new URL(url).searchParams.get("state");
            if (!state) throw new Error("No parent and no state in URL. Can't complete notification.");
            const channel = new BroadcastChannel(`oidc-client-popup-${state}`);
            channel.postMessage(msgData);
            channel.close();
        }
    }
};
// src/UserManagerSettings.ts
var $631c75f8a3fcffe9$var$DefaultPopupWindowFeatures = {
    location: false,
    toolbar: false,
    height: 640,
    closePopupWindowAfterInSeconds: -1
};
var $631c75f8a3fcffe9$var$DefaultPopupTarget = "_blank";
var $631c75f8a3fcffe9$var$DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var $631c75f8a3fcffe9$var$DefaultCheckSessionIntervalInSeconds = 2;
var $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds = 10;
var $631c75f8a3fcffe9$var$UserManagerSettingsStore = class extends $631c75f8a3fcffe9$var$OidcClientSettingsStore {
    constructor(args){
        const { popup_redirect_uri: popup_redirect_uri = args.redirect_uri, popup_post_logout_redirect_uri: popup_post_logout_redirect_uri = args.post_logout_redirect_uri, popupWindowFeatures: popupWindowFeatures = $631c75f8a3fcffe9$var$DefaultPopupWindowFeatures, popupWindowTarget: popupWindowTarget = $631c75f8a3fcffe9$var$DefaultPopupTarget, redirectMethod: redirectMethod = "assign", redirectTarget: redirectTarget = "self", iframeNotifyParentOrigin: iframeNotifyParentOrigin = args.iframeNotifyParentOrigin, iframeScriptOrigin: iframeScriptOrigin = args.iframeScriptOrigin, requestTimeoutInSeconds: requestTimeoutInSeconds, silent_redirect_uri: silent_redirect_uri = args.redirect_uri, silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, automaticSilentRenew: automaticSilentRenew = true, validateSubOnSilentRenew: validateSubOnSilentRenew = true, includeIdTokenInSilentRenew: includeIdTokenInSilentRenew = false, monitorSession: monitorSession = false, monitorAnonymousSession: monitorAnonymousSession = false, checkSessionIntervalInSeconds: checkSessionIntervalInSeconds = $631c75f8a3fcffe9$var$DefaultCheckSessionIntervalInSeconds, query_status_response_type: query_status_response_type = "code", stopCheckSessionOnError: stopCheckSessionOnError = true, revokeTokenTypes: revokeTokenTypes = [
            "access_token",
            "refresh_token"
        ], revokeTokensOnSignout: revokeTokensOnSignout = false, includeIdTokenInSilentSignout: includeIdTokenInSilentSignout = false, accessTokenExpiringNotificationTimeInSeconds: accessTokenExpiringNotificationTimeInSeconds = $631c75f8a3fcffe9$var$DefaultAccessTokenExpiringNotificationTimeInSeconds, userStore: userStore } = args;
        super(args);
        this.popup_redirect_uri = popup_redirect_uri;
        this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
        this.popupWindowFeatures = popupWindowFeatures;
        this.popupWindowTarget = popupWindowTarget;
        this.redirectMethod = redirectMethod;
        this.redirectTarget = redirectTarget;
        this.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
        this.iframeScriptOrigin = iframeScriptOrigin;
        this.silent_redirect_uri = silent_redirect_uri;
        this.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds || requestTimeoutInSeconds || $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds;
        this.automaticSilentRenew = automaticSilentRenew;
        this.validateSubOnSilentRenew = validateSubOnSilentRenew;
        this.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
        this.monitorSession = monitorSession;
        this.monitorAnonymousSession = monitorAnonymousSession;
        this.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
        this.stopCheckSessionOnError = stopCheckSessionOnError;
        this.query_status_response_type = query_status_response_type;
        this.revokeTokenTypes = revokeTokenTypes;
        this.revokeTokensOnSignout = revokeTokensOnSignout;
        this.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
        this.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
        if (userStore) this.userStore = userStore;
        else {
            const store = typeof window !== "undefined" ? window.sessionStorage : new $631c75f8a3fcffe9$var$InMemoryWebStorage();
            this.userStore = new $631c75f8a3fcffe9$var$WebStorageStateStore({
                store: store
            });
        }
    }
};
// src/navigators/IFrameWindow.ts
var $631c75f8a3fcffe9$var$IFrameWindow = class _IFrameWindow extends $631c75f8a3fcffe9$var$AbstractChildWindow {
    constructor({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds }){
        super();
        this._logger = new $631c75f8a3fcffe9$var$Logger("IFrameWindow");
        this._timeoutInSeconds = silentRequestTimeoutInSeconds;
        this._frame = _IFrameWindow.createHiddenIframe();
        this._window = this._frame.contentWindow;
    }
    static createHiddenIframe() {
        const iframe = window.document.createElement("iframe");
        iframe.style.visibility = "hidden";
        iframe.style.position = "fixed";
        iframe.style.left = "-1000px";
        iframe.style.top = "0";
        iframe.width = "0";
        iframe.height = "0";
        window.document.body.appendChild(iframe);
        return iframe;
    }
    async navigate(params) {
        this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
        const timer = setTimeout(()=>void this._abort.raise(new $631c75f8a3fcffe9$var$ErrorTimeout("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
        this._disposeHandlers.add(()=>clearTimeout(timer));
        return await super.navigate(params);
    }
    close() {
        var _a;
        if (this._frame) {
            if (this._frame.parentNode) {
                this._frame.addEventListener("load", (ev)=>{
                    var _a2;
                    const frame = ev.target;
                    (_a2 = frame.parentNode) == null || _a2.removeChild(frame);
                    this._abort.raise(new Error("IFrame removed from DOM"));
                }, true);
                (_a = this._frame.contentWindow) == null || _a.location.replace("about:blank");
            }
            this._frame = null;
        }
        this._window = null;
    }
    static notifyParent(url, targetOrigin) {
        return super._notifyParent(window.parent, url, false, targetOrigin);
    }
};
// src/navigators/IFrameNavigator.ts
var $631c75f8a3fcffe9$var$IFrameNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("IFrameNavigator");
    }
    async prepare({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = this._settings.silentRequestTimeoutInSeconds }) {
        return new $631c75f8a3fcffe9$var$IFrameWindow({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
    }
    async callback(url) {
        this._logger.create("callback");
        $631c75f8a3fcffe9$var$IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
    }
};
// src/navigators/PopupWindow.ts
var $631c75f8a3fcffe9$var$checkForPopupClosedInterval = 500;
var $631c75f8a3fcffe9$var$second = 1e3;
var $631c75f8a3fcffe9$var$PopupWindow = class extends $631c75f8a3fcffe9$var$AbstractChildWindow {
    constructor({ popupWindowTarget: popupWindowTarget = $631c75f8a3fcffe9$var$DefaultPopupTarget, popupWindowFeatures: popupWindowFeatures = {}, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }){
        super();
        this._logger = new $631c75f8a3fcffe9$var$Logger("PopupWindow");
        const centeredPopup = $631c75f8a3fcffe9$var$PopupUtils.center({
            ...$631c75f8a3fcffe9$var$DefaultPopupWindowFeatures,
            ...popupWindowFeatures
        });
        this._window = window.open(void 0, popupWindowTarget, $631c75f8a3fcffe9$var$PopupUtils.serialize(centeredPopup));
        this.abortOnClose = Boolean(popupAbortOnClose);
        if (popupSignal) popupSignal.addEventListener("abort", ()=>{
            var _a;
            this._abort.raise(new Error((_a = popupSignal.reason) != null ? _a : "Popup aborted"));
        });
        if (popupWindowFeatures.closePopupWindowAfterInSeconds && popupWindowFeatures.closePopupWindowAfterInSeconds > 0) setTimeout(()=>{
            if (!this._window || typeof this._window.closed !== "boolean" || this._window.closed) {
                this._abort.raise(new Error("Popup blocked by user"));
                return;
            }
            this.close();
        }, popupWindowFeatures.closePopupWindowAfterInSeconds * $631c75f8a3fcffe9$var$second);
    }
    async navigate(params) {
        var _a;
        (_a = this._window) == null || _a.focus();
        const popupClosedInterval = setInterval(()=>{
            if (!this._window || this._window.closed) {
                this._logger.debug("Popup closed by user or isolated by redirect");
                clearPopupClosedInterval();
                this._disposeHandlers.delete(clearPopupClosedInterval);
                if (this.abortOnClose) this._abort.raise(new Error("Popup closed by user"));
            }
        }, $631c75f8a3fcffe9$var$checkForPopupClosedInterval);
        const clearPopupClosedInterval = ()=>clearInterval(popupClosedInterval);
        this._disposeHandlers.add(clearPopupClosedInterval);
        return await super.navigate(params);
    }
    close() {
        if (this._window) {
            if (!this._window.closed) {
                this._window.close();
                this._abort.raise(new Error("Popup closed"));
            }
        }
        this._window = null;
    }
    static notifyOpener(url, keepOpen) {
        super._notifyParent(window.opener, url, keepOpen);
        if (!keepOpen && !window.opener) window.close();
    }
};
// src/navigators/PopupNavigator.ts
var $631c75f8a3fcffe9$var$PopupNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("PopupNavigator");
    }
    async prepare({ popupWindowFeatures: popupWindowFeatures = this._settings.popupWindowFeatures, popupWindowTarget: popupWindowTarget = this._settings.popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }) {
        return new $631c75f8a3fcffe9$var$PopupWindow({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
    }
    async callback(url, { keepOpen: keepOpen = false }) {
        this._logger.create("callback");
        $631c75f8a3fcffe9$var$PopupWindow.notifyOpener(url, keepOpen);
    }
};
// src/navigators/RedirectNavigator.ts
var $631c75f8a3fcffe9$var$RedirectNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("RedirectNavigator");
    }
    async prepare({ redirectMethod: redirectMethod = this._settings.redirectMethod, redirectTarget: redirectTarget = this._settings.redirectTarget }) {
        var _a;
        this._logger.create("prepare");
        let targetWindow = window.self;
        if (redirectTarget === "top") targetWindow = (_a = window.top) != null ? _a : window.self;
        const redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
        let abort;
        return {
            navigate: async (params)=>{
                this._logger.create("navigate");
                const promise = new Promise((resolve, reject)=>{
                    abort = reject;
                    window.addEventListener("pageshow", ()=>resolve(window.location.href));
                    redirect(params.url);
                });
                return await promise;
            },
            close: ()=>{
                this._logger.create("close");
                abort == null || abort(new Error("Redirect aborted"));
                targetWindow.stop();
            }
        };
    }
    async callback() {
        return;
    }
};
// src/UserManagerEvents.ts
var $631c75f8a3fcffe9$var$UserManagerEvents = class extends $631c75f8a3fcffe9$var$AccessTokenEvents {
    constructor(settings){
        super({
            expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds
        });
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserManagerEvents");
        this._userLoaded = new $631c75f8a3fcffe9$var$Event("User loaded");
        this._userUnloaded = new $631c75f8a3fcffe9$var$Event("User unloaded");
        this._silentRenewError = new $631c75f8a3fcffe9$var$Event("Silent renew error");
        this._userSignedIn = new $631c75f8a3fcffe9$var$Event("User signed in");
        this._userSignedOut = new $631c75f8a3fcffe9$var$Event("User signed out");
        this._userSessionChanged = new $631c75f8a3fcffe9$var$Event("User session changed");
    }
    async load(user, raiseEvent = true) {
        await super.load(user);
        if (raiseEvent) await this._userLoaded.raise(user);
    }
    async unload() {
        await super.unload();
        await this._userUnloaded.raise();
    }
    /**
   * Add callback: Raised when a user session has been established (or re-established).
   */ addUserLoaded(cb) {
        return this._userLoaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */ removeUserLoaded(cb) {
        return this._userLoaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when a user session has been terminated.
   */ addUserUnloaded(cb) {
        return this._userUnloaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been terminated.
   */ removeUserUnloaded(cb) {
        return this._userUnloaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when the automatic silent renew has failed.
   */ addSilentRenewError(cb) {
        return this._silentRenewError.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */ removeSilentRenewError(cb) {
        return this._silentRenewError.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseSilentRenewError(e) {
        await this._silentRenewError.raise(e);
    }
    /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedIn(cb) {
        return this._userSignedIn.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */ removeUserSignedIn(cb) {
        this._userSignedIn.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedIn() {
        await this._userSignedIn.raise();
    }
    /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedOut(cb) {
        return this._userSignedOut.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */ removeUserSignedOut(cb) {
        this._userSignedOut.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedOut() {
        await this._userSignedOut.raise();
    }
    /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSessionChanged(cb) {
        return this._userSessionChanged.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */ removeUserSessionChanged(cb) {
        this._userSessionChanged.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSessionChanged() {
        await this._userSessionChanged.raise();
    }
};
// src/SilentRenewService.ts
var $631c75f8a3fcffe9$var$SilentRenewService = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $631c75f8a3fcffe9$var$Logger("SilentRenewService");
        this._isStarted = false;
        this._retryTimer = new $631c75f8a3fcffe9$var$Timer("Retry Silent Renew");
        this._tokenExpiring = async ()=>{
            const logger2 = this._logger.create("_tokenExpiring");
            try {
                await this._userManager.signinSilent();
                logger2.debug("silent token renewal successful");
            } catch (err) {
                if (err instanceof $631c75f8a3fcffe9$var$ErrorTimeout) {
                    logger2.warn("ErrorTimeout from signinSilent:", err, "retry in 5s");
                    this._retryTimer.init(5);
                    return;
                }
                logger2.error("Error from signinSilent:", err);
                await this._userManager.events._raiseSilentRenewError(err);
            }
        };
    }
    async start() {
        const logger2 = this._logger.create("start");
        if (!this._isStarted) {
            this._isStarted = true;
            this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
            this._retryTimer.addHandler(this._tokenExpiring);
            try {
                await this._userManager.getUser();
            } catch (err) {
                logger2.error("getUser error", err);
            }
        }
    }
    stop() {
        if (this._isStarted) {
            this._retryTimer.cancel();
            this._retryTimer.removeHandler(this._tokenExpiring);
            this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
            this._isStarted = false;
        }
    }
};
// src/RefreshState.ts
var $631c75f8a3fcffe9$var$RefreshState = class {
    constructor(args){
        this.refresh_token = args.refresh_token;
        this.id_token = args.id_token;
        this.session_state = args.session_state;
        this.scope = args.scope;
        this.profile = args.profile;
        this.data = args.state;
    }
};
// src/UserManager.ts
var $631c75f8a3fcffe9$var$UserManager = class {
    constructor(settings, redirectNavigator, popupNavigator, iframeNavigator){
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserManager");
        this.settings = new $631c75f8a3fcffe9$var$UserManagerSettingsStore(settings);
        this._client = new $631c75f8a3fcffe9$var$OidcClient(settings);
        this._redirectNavigator = redirectNavigator != null ? redirectNavigator : new $631c75f8a3fcffe9$var$RedirectNavigator(this.settings);
        this._popupNavigator = popupNavigator != null ? popupNavigator : new $631c75f8a3fcffe9$var$PopupNavigator(this.settings);
        this._iframeNavigator = iframeNavigator != null ? iframeNavigator : new $631c75f8a3fcffe9$var$IFrameNavigator(this.settings);
        this._events = new $631c75f8a3fcffe9$var$UserManagerEvents(this.settings);
        this._silentRenewService = new $631c75f8a3fcffe9$var$SilentRenewService(this);
        if (this.settings.automaticSilentRenew) this.startSilentRenew();
        this._sessionMonitor = null;
        if (this.settings.monitorSession) this._sessionMonitor = new $631c75f8a3fcffe9$var$SessionMonitor(this);
    }
    /**
   * Get object used to register for events raised by the `UserManager`.
   */ get events() {
        return this._events;
    }
    /**
   * Get object used to access the metadata configuration of the identity provider.
   */ get metadataService() {
        return this._client.metadataService;
    }
    /**
   * Load the `User` object for the currently authenticated user.
   *
   * @param raiseEvent - If `true`, the `UserLoaded` event will be raised. Defaults to false.
   * @returns A promise
   */ async getUser(raiseEvent = false) {
        const logger2 = this._logger.create("getUser");
        const user = await this._loadUser();
        if (user) {
            logger2.info("user loaded");
            await this._events.load(user, raiseEvent);
            return user;
        }
        logger2.info("user not found in storage");
        return null;
    }
    /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */ async removeUser() {
        const logger2 = this._logger.create("removeUser");
        await this.storeUser(null);
        logger2.info("user removed from storage");
        await this._events.unload();
    }
    /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */ async signinRedirect(args = {}) {
        var _a;
        this._logger.create("signinRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signinStart({
            request_type: "si:r",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
    }
    /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */ async signinRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinRedirectCallback");
        const user = await this._signinEnd(url);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */ async signinResourceOwnerCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false }) {
        const logger2 = this._logger.create("signinResourceOwnerCredential");
        const signinResponse = await this._client.processResourceOwnerPasswordCredentials({
            username: username,
            password: password,
            skipUserInfo: skipUserInfo,
            extraTokenParams: this.settings.extraTokenParams
        });
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */ async signinPopup(args = {}) {
        var _a;
        const logger2 = this._logger.create("signinPopup");
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose, ...requestArgs } = args;
        const url = this.settings.popup_redirect_uri;
        if (!url) logger2.throw(new Error("No popup_redirect_uri configured"));
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
        const user = await this._signin({
            request_type: "si:p",
            redirect_uri: url,
            display: "popup",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
        if (user) {
            if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signinPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */ async signinSilent(args = {}) {
        var _a, _b;
        const logger2 = this._logger.create("signinSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        let user = await this._loadUser();
        if (!args.forceIframeAuth && (user == null ? void 0 : user.refresh_token)) {
            logger2.debug("using refresh token");
            const state = new $631c75f8a3fcffe9$var$RefreshState(user);
            return await this._useRefreshToken({
                state: state,
                redirect_uri: requestArgs.redirect_uri,
                resource: requestArgs.resource,
                extraTokenParams: requestArgs.extraTokenParams,
                timeoutInSeconds: silentRequestTimeoutInSeconds
            });
        }
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        let verifySub;
        if (user && this.settings.validateSubOnSilentRenew) {
            logger2.debug("subject prior to silent renew:", user.profile.sub);
            verifySub = user.profile.sub;
        }
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        user = await this._signin({
            request_type: "si:s",
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle, verifySub);
        if (user) {
            if ((_b = user.profile) == null ? void 0 : _b.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    async _useRefreshToken(args) {
        const response = await this._client.useRefreshToken({
            timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds,
            ...args
        });
        const user = new $631c75f8a3fcffe9$var$User({
            ...args.state,
            ...response
        });
        await this.storeUser(user);
        await this._events.load(user);
        return user;
    }
    /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */ async signinCallback(url = window.location.href) {
        const { state: state } = await this._client.readSigninResponseState(url);
        switch(state.request_type){
            case "si:r":
                return await this.signinRedirectCallback(url);
            case "si:p":
                await this.signinPopupCallback(url);
                break;
            case "si:s":
                await this.signinSilentCallback(url);
                break;
            default:
                throw new Error("invalid response_type in state");
        }
        return void 0;
    }
    /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */ async signoutCallback(url = window.location.href, keepOpen = false) {
        const { state: state } = await this._client.readSignoutResponseState(url);
        if (!state) return void 0;
        switch(state.request_type){
            case "so:r":
                return await this.signoutRedirectCallback(url);
            case "so:p":
                await this.signoutPopupCallback(url, keepOpen);
                break;
            case "so:s":
                await this.signoutSilentCallback(url);
                break;
            default:
                throw new Error("invalid response_type in state");
        }
        return void 0;
    }
    /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */ async querySessionStatus(args = {}) {
        const logger2 = this._logger.create("querySessionStatus");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        const user = await this._loadUser();
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        const navResponse = await this._signinStart({
            request_type: "si:s",
            // this acts like a signin silent
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            response_type: this.settings.query_status_response_type,
            scope: "openid",
            skipUserInfo: true,
            ...requestArgs
        }, handle);
        try {
            const extraHeaders = {};
            const signinResponse = await this._client.processSigninResponse(navResponse.url, extraHeaders);
            logger2.debug("got signin response");
            if (signinResponse.session_state && signinResponse.profile.sub) {
                logger2.info("success for subject", signinResponse.profile.sub);
                return {
                    session_state: signinResponse.session_state,
                    sub: signinResponse.profile.sub
                };
            }
            logger2.info("success, user not authenticated");
            return null;
        } catch (err) {
            if (this.settings.monitorAnonymousSession && err instanceof $631c75f8a3fcffe9$var$ErrorResponse) switch(err.error){
                case "login_required":
                case "consent_required":
                case "interaction_required":
                case "account_selection_required":
                    logger2.info("success for anonymous user");
                    return {
                        session_state: err.session_state
                    };
            }
            throw err;
        }
    }
    async _signin(args, handle, verifySub) {
        const navResponse = await this._signinStart(args, handle);
        return await this._signinEnd(navResponse.url, verifySub);
    }
    async _signinStart(args, handle) {
        const logger2 = this._logger.create("_signinStart");
        try {
            const signinRequest = await this._client.createSigninRequest(args);
            logger2.debug("got signin request");
            return await handle.navigate({
                url: signinRequest.url,
                state: signinRequest.state.id,
                response_mode: signinRequest.state.response_mode,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signinEnd(url, verifySub) {
        const logger2 = this._logger.create("_signinEnd");
        const extraHeaders = {};
        const signinResponse = await this._client.processSigninResponse(url, extraHeaders);
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse, verifySub);
        return user;
    }
    async _buildUser(signinResponse, verifySub) {
        const logger2 = this._logger.create("_buildUser");
        const user = new $631c75f8a3fcffe9$var$User(signinResponse);
        if (verifySub) {
            if (verifySub !== user.profile.sub) {
                logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
                throw new $631c75f8a3fcffe9$var$ErrorResponse({
                    ...signinResponse,
                    error: "login_required"
                });
            }
            logger2.debug("current user matches user returned from signin");
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
        return user;
    }
    /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutRedirect(args = {}) {
        const logger2 = this._logger.create("signoutRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signoutStart({
            request_type: "so:r",
            post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutRedirectCallback");
        const response = await this._signoutEnd(url);
        logger2.info("success");
        return response;
    }
    /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutPopup(args = {}) {
        const logger2 = this._logger.create("signoutPopup");
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, ...requestArgs } = args;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal
        });
        await this._signout({
            request_type: "so:p",
            post_logout_redirect_uri: url,
            // we're putting a dummy entry in here because we
            // need a unique id from the state for notification
            // to the parent window, which is necessary if we
            // plan to return back to the client after signout
            // and so we can close the popup after signout
            state: url == null ? void 0 : {},
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signoutPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    async _signout(args, handle) {
        const navResponse = await this._signoutStart(args, handle);
        return await this._signoutEnd(navResponse.url);
    }
    async _signoutStart(args = {}, handle) {
        var _a;
        const logger2 = this._logger.create("_signoutStart");
        try {
            const user = await this._loadUser();
            logger2.debug("loaded current user from storage");
            if (this.settings.revokeTokensOnSignout) await this._revokeInternal(user);
            const id_token = args.id_token_hint || user && user.id_token;
            if (id_token) {
                logger2.debug("setting id_token_hint in signout request");
                args.id_token_hint = id_token;
            }
            await this.removeUser();
            logger2.debug("user removed, creating signout request");
            const signoutRequest = await this._client.createSignoutRequest(args);
            logger2.debug("got signout request");
            return await handle.navigate({
                url: signoutRequest.url,
                state: (_a = signoutRequest.state) == null ? void 0 : _a.id,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signoutEnd(url) {
        const logger2 = this._logger.create("_signoutEnd");
        const signoutResponse = await this._client.processSignoutResponse(url);
        logger2.debug("got signout response");
        return signoutResponse;
    }
    /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */ async signoutSilent(args = {}) {
        var _a;
        const logger2 = this._logger.create("signoutSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const id_token_hint = this.settings.includeIdTokenInSilentSignout ? (_a = await this._loadUser()) == null ? void 0 : _a.id_token : void 0;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        await this._signout({
            request_type: "so:s",
            post_logout_redirect_uri: url,
            id_token_hint: id_token_hint,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    async revokeTokens(types) {
        const user = await this._loadUser();
        await this._revokeInternal(user, types);
    }
    async _revokeInternal(user, types = this.settings.revokeTokenTypes) {
        const logger2 = this._logger.create("_revokeInternal");
        if (!user) return;
        const typesPresent = types.filter((type)=>typeof user[type] === "string");
        if (!typesPresent.length) {
            logger2.debug("no need to revoke due to no token(s)");
            return;
        }
        for (const type of typesPresent){
            await this._client.revokeToken(user[type], type);
            logger2.info(`${type} revoked successfully`);
            if (type !== "access_token") user[type] = null;
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
    }
    /**
   * Enables silent renew for the `UserManager`.
   */ startSilentRenew() {
        this._logger.create("startSilentRenew");
        this._silentRenewService.start();
    }
    /**
   * Disables silent renew for the `UserManager`.
   */ stopSilentRenew() {
        this._silentRenewService.stop();
    }
    get _userStoreKey() {
        return `user:${this.settings.authority}:${this.settings.client_id}`;
    }
    async _loadUser() {
        const logger2 = this._logger.create("_loadUser");
        const storageString = await this.settings.userStore.get(this._userStoreKey);
        if (storageString) {
            logger2.debug("user storageString loaded");
            return $631c75f8a3fcffe9$var$User.fromStorageString(storageString);
        }
        logger2.debug("no user storageString");
        return null;
    }
    async storeUser(user) {
        const logger2 = this._logger.create("storeUser");
        if (user) {
            logger2.debug("storing user");
            const storageString = user.toStorageString();
            await this.settings.userStore.set(this._userStoreKey, storageString);
        } else {
            this._logger.debug("removing user");
            await this.settings.userStore.remove(this._userStoreKey);
            if (this.settings.dpop) await this.settings.dpop.store.remove(this.settings.client_id);
        }
    }
    /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */ async clearStaleState() {
        await this._client.clearStaleState();
    }
    /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */ async dpopProof(url, user, httpMethod, nonce) {
        var _a, _b;
        const dpopState = await ((_b = (_a = this.settings.dpop) == null ? void 0 : _a.store) == null ? void 0 : _b.get(this.settings.client_id));
        if (dpopState) return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPProof({
            url: url,
            accessToken: user == null ? void 0 : user.access_token,
            httpMethod: httpMethod,
            keyPair: dpopState.keys,
            nonce: nonce
        });
        return void 0;
    }
    async generateDPoPJkt(dpopSettings) {
        let dpopState = await dpopSettings.store.get(this.settings.client_id);
        if (!dpopState) {
            const dpopKeys = await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $631c75f8a3fcffe9$var$DPoPState(dpopKeys);
            await dpopSettings.store.set(this.settings.client_id, dpopState);
        }
        return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPJkt(dpopState.keys);
    }
};
// package.json
var $631c75f8a3fcffe9$var$version = "3.4.1";
// src/Version.ts
var $631c75f8a3fcffe9$var$Version = $631c75f8a3fcffe9$var$version;
// src/IndexedDbDPoPStore.ts
var $631c75f8a3fcffe9$var$IndexedDbDPoPStore = class {
    constructor(){
        this._dbName = "oidc";
        this._storeName = "dpop";
    }
    async set(key, value) {
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            str.put(value, key);
            return this.promisifyRequest(str.transaction);
        });
    }
    async get(key) {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.get(key));
        });
    }
    async remove(key) {
        const item = await this.get(key);
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            return this.promisifyRequest(str.delete(key));
        });
        return item;
    }
    async getAllKeys() {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.getAllKeys());
        });
    }
    promisifyRequest(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    async createStore(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const db = await this.promisifyRequest(request);
        return async (txMode, callback)=>{
            const tx = db.transaction(storeName, txMode);
            const store = tx.objectStore(storeName);
            return await callback(store);
        };
    }
};



var $b40c3a08cec6a11c$var$import_react2 = $b40c3a08cec6a11c$var$__toESM((parcelRequire("acw62")));
// src/AuthState.ts
var $b40c3a08cec6a11c$var$initialAuthState = {
    isLoading: true,
    isAuthenticated: false
};
// src/reducer.ts
var $b40c3a08cec6a11c$var$reducer = (state, action)=>{
    switch(action.type){
        case "INITIALISED":
        case "USER_LOADED":
            return {
                ...state,
                user: action.user,
                isLoading: false,
                isAuthenticated: action.user ? !action.user.expired : false,
                error: void 0
            };
        case "USER_SIGNED_OUT":
        case "USER_UNLOADED":
            return {
                ...state,
                user: void 0,
                isAuthenticated: false
            };
        case "NAVIGATOR_INIT":
            return {
                ...state,
                isLoading: true,
                activeNavigator: action.method
            };
        case "NAVIGATOR_CLOSE":
            return {
                ...state,
                isLoading: false,
                activeNavigator: void 0
            };
        case "ERROR":
            {
                const error = action.error;
                error["toString"] = ()=>`${error.name}: ${error.message}`;
                return {
                    ...state,
                    isLoading: false,
                    error: error
                };
            }
        default:
            {
                const innerError = new TypeError(`unknown type ${action["type"]}`);
                const error = {
                    name: innerError.name,
                    message: innerError.message,
                    innerError: innerError,
                    stack: innerError.stack,
                    source: "unknown"
                };
                error["toString"] = ()=>`${error.name}: ${error.message}`;
                return {
                    ...state,
                    isLoading: false,
                    error: error
                };
            }
    }
};
// src/utils.ts
var $b40c3a08cec6a11c$var$hasAuthParams = (location = window.location)=>{
    let searchParams = new URLSearchParams(location.search);
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) return true;
    searchParams = new URLSearchParams(location.hash.replace("#", "?"));
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) return true;
    return false;
};
var $b40c3a08cec6a11c$var$signinError = $b40c3a08cec6a11c$var$normalizeErrorFn("signinCallback", "Sign-in failed");
var $b40c3a08cec6a11c$var$signoutError = $b40c3a08cec6a11c$var$normalizeErrorFn("signoutCallback", "Sign-out failed");
var $b40c3a08cec6a11c$var$renewSilentError = $b40c3a08cec6a11c$var$normalizeErrorFn("renewSilent", "Renew silent failed");
function $b40c3a08cec6a11c$var$normalizeError(error, fallbackMessage) {
    return {
        name: $b40c3a08cec6a11c$var$stringFieldOf(error, "name", ()=>"Error"),
        message: $b40c3a08cec6a11c$var$stringFieldOf(error, "message", ()=>fallbackMessage),
        stack: $b40c3a08cec6a11c$var$stringFieldOf(error, "stack", ()=>new Error().stack),
        innerError: error
    };
}
function $b40c3a08cec6a11c$var$normalizeErrorFn(source, fallbackMessage) {
    return (error)=>{
        return {
            ...$b40c3a08cec6a11c$var$normalizeError(error, fallbackMessage),
            source: source
        };
    };
}
function $b40c3a08cec6a11c$var$stringFieldOf(element, fieldName, or) {
    if (element && typeof element === "object") {
        const value = element[fieldName];
        if (typeof value === "string") return value;
    }
    return or();
}
// src/AuthProvider.tsx
var $b40c3a08cec6a11c$var$userManagerContextKeys = [
    "clearStaleState",
    "querySessionStatus",
    "revokeTokens",
    "startSilentRenew",
    "stopSilentRenew"
];
var $b40c3a08cec6a11c$var$navigatorKeys = [
    "signinPopup",
    "signinSilent",
    "signinRedirect",
    "signinResourceOwnerCredentials",
    "signoutPopup",
    "signoutRedirect",
    "signoutSilent"
];
var $b40c3a08cec6a11c$var$unsupportedEnvironment = (fnName)=>()=>{
        throw new Error(`UserManager#${fnName} was called from an unsupported context. If this is a server-rendered page, defer this call with useEffect() or pass a custom UserManager implementation.`);
    };
var $b40c3a08cec6a11c$var$UserManagerImpl = typeof window === "undefined" ? null : $631c75f8a3fcffe9$exports.UserManager;
var $b40c3a08cec6a11c$var$AuthProvider = (props)=>{
    const { children: children, onSigninCallback: onSigninCallback, skipSigninCallback: skipSigninCallback, matchSignoutCallback: matchSignoutCallback, onSignoutCallback: onSignoutCallback, onRemoveUser: onRemoveUser, userManager: userManagerProp = null, ...userManagerSettings } = props;
    const [userManager] = $b40c3a08cec6a11c$var$import_react2.default.useState(()=>{
        return userManagerProp != null ? userManagerProp : $b40c3a08cec6a11c$var$UserManagerImpl ? new $b40c3a08cec6a11c$var$UserManagerImpl(userManagerSettings) : {
            settings: userManagerSettings
        };
    });
    const [state, dispatch] = $b40c3a08cec6a11c$var$import_react2.default.useReducer($b40c3a08cec6a11c$var$reducer, $b40c3a08cec6a11c$var$initialAuthState);
    const userManagerContext = $b40c3a08cec6a11c$var$import_react2.default.useMemo(()=>Object.assign({
            settings: userManager.settings,
            events: userManager.events
        }, Object.fromEntries($b40c3a08cec6a11c$var$userManagerContextKeys.map((key)=>{
            var _a, _b;
            return [
                key,
                (_b = (_a = userManager[key]) == null ? void 0 : _a.bind(userManager)) != null ? _b : $b40c3a08cec6a11c$var$unsupportedEnvironment(key)
            ];
        })), Object.fromEntries($b40c3a08cec6a11c$var$navigatorKeys.map((key)=>[
                key,
                userManager[key] ? async (args)=>{
                    dispatch({
                        type: "NAVIGATOR_INIT",
                        method: key
                    });
                    try {
                        return await userManager[key](args);
                    } catch (error) {
                        dispatch({
                            type: "ERROR",
                            error: {
                                ...$b40c3a08cec6a11c$var$normalizeError(error, `Unknown error while executing ${key}(...).`),
                                source: key,
                                args: args
                            }
                        });
                        return null;
                    } finally{
                        dispatch({
                            type: "NAVIGATOR_CLOSE"
                        });
                    }
                } : $b40c3a08cec6a11c$var$unsupportedEnvironment(key)
            ]))), [
        userManager
    ]);
    const didInitialize = $b40c3a08cec6a11c$var$import_react2.default.useRef(false);
    $b40c3a08cec6a11c$var$import_react2.default.useEffect(()=>{
        if (!userManager || didInitialize.current) return;
        didInitialize.current = true;
        (async ()=>{
            try {
                let user = null;
                if ($b40c3a08cec6a11c$var$hasAuthParams() && !skipSigninCallback) {
                    user = await userManager.signinCallback();
                    if (onSigninCallback) await onSigninCallback(user);
                }
                user = !user ? await userManager.getUser() : user;
                dispatch({
                    type: "INITIALISED",
                    user: user
                });
            } catch (error) {
                dispatch({
                    type: "ERROR",
                    error: $b40c3a08cec6a11c$var$signinError(error)
                });
            }
            try {
                if (matchSignoutCallback && matchSignoutCallback(userManager.settings)) {
                    const resp = await userManager.signoutCallback();
                    if (onSignoutCallback) await onSignoutCallback(resp);
                }
            } catch (error) {
                dispatch({
                    type: "ERROR",
                    error: $b40c3a08cec6a11c$var$signoutError(error)
                });
            }
        })();
    }, [
        userManager,
        skipSigninCallback,
        onSigninCallback,
        onSignoutCallback,
        matchSignoutCallback
    ]);
    $b40c3a08cec6a11c$var$import_react2.default.useEffect(()=>{
        if (!userManager) return void 0;
        const handleUserLoaded = (user)=>{
            dispatch({
                type: "USER_LOADED",
                user: user
            });
        };
        userManager.events.addUserLoaded(handleUserLoaded);
        const handleUserUnloaded = ()=>{
            dispatch({
                type: "USER_UNLOADED"
            });
        };
        userManager.events.addUserUnloaded(handleUserUnloaded);
        const handleUserSignedOut = ()=>{
            dispatch({
                type: "USER_SIGNED_OUT"
            });
        };
        userManager.events.addUserSignedOut(handleUserSignedOut);
        const handleSilentRenewError = (error)=>{
            dispatch({
                type: "ERROR",
                error: $b40c3a08cec6a11c$var$renewSilentError(error)
            });
        };
        userManager.events.addSilentRenewError(handleSilentRenewError);
        return ()=>{
            userManager.events.removeUserLoaded(handleUserLoaded);
            userManager.events.removeUserUnloaded(handleUserUnloaded);
            userManager.events.removeUserSignedOut(handleUserSignedOut);
            userManager.events.removeSilentRenewError(handleSilentRenewError);
        };
    }, [
        userManager
    ]);
    const removeUser = $b40c3a08cec6a11c$var$import_react2.default.useCallback(async ()=>{
        if (!userManager) $b40c3a08cec6a11c$var$unsupportedEnvironment("removeUser");
        await userManager.removeUser();
        if (onRemoveUser) await onRemoveUser();
    }, [
        userManager,
        onRemoveUser
    ]);
    const contextValue = $b40c3a08cec6a11c$var$import_react2.default.useMemo(()=>{
        return {
            ...state,
            ...userManagerContext,
            removeUser: removeUser
        };
    }, [
        state,
        userManagerContext,
        removeUser
    ]);
    return /* @__PURE__ */ $b40c3a08cec6a11c$var$import_react2.default.createElement($b40c3a08cec6a11c$var$AuthContext.Provider, {
        value: contextValue
    }, children);
};

// src/useAuth.ts
var $b40c3a08cec6a11c$var$import_react3 = $b40c3a08cec6a11c$var$__toESM((parcelRequire("acw62")));
var $b40c3a08cec6a11c$var$useAuth = ()=>{
    const context = $b40c3a08cec6a11c$var$import_react3.default.useContext($b40c3a08cec6a11c$var$AuthContext);
    if (!context) console.warn("AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component.");
    return context;
};

// src/useAutoSignin.ts
var $b40c3a08cec6a11c$var$import_react4 = $b40c3a08cec6a11c$var$__toESM((parcelRequire("acw62")));
var $b40c3a08cec6a11c$var$useAutoSignin = ({ signinMethod: signinMethod = "signinRedirect" } = {})=>{
    const auth = $b40c3a08cec6a11c$var$useAuth();
    const [hasTriedSignin, setHasTriedSignin] = $b40c3a08cec6a11c$var$import_react4.default.useState(false);
    const shouldAttemptSignin = $b40c3a08cec6a11c$var$import_react4.default.useMemo(()=>!$b40c3a08cec6a11c$var$hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasTriedSignin, [
        auth.activeNavigator,
        auth.isAuthenticated,
        auth.isLoading,
        hasTriedSignin
    ]);
    $b40c3a08cec6a11c$var$import_react4.default.useEffect(()=>{
        if (shouldAttemptSignin) {
            switch(signinMethod){
                case "signinPopup":
                    auth.signinPopup();
                    break;
                case "signinRedirect":
                default:
                    auth.signinRedirect();
                    break;
            }
            setHasTriedSignin(true);
        }
    }, [
        auth,
        hasTriedSignin,
        shouldAttemptSignin,
        signinMethod
    ]);
    return {
        isLoading: auth.isLoading,
        isAuthenticated: auth.isAuthenticated,
        error: auth.error
    };
};

// src/withAuth.tsx
var $b40c3a08cec6a11c$var$import_react5 = $b40c3a08cec6a11c$var$__toESM((parcelRequire("acw62")));
function $b40c3a08cec6a11c$var$withAuth(Component) {
    const displayName = `withAuth(${Component.displayName || Component.name})`;
    const C = (props)=>{
        const auth = $b40c3a08cec6a11c$var$useAuth();
        return /* @__PURE__ */ $b40c3a08cec6a11c$var$import_react5.default.createElement(Component, {
            ...props,
            auth: auth
        });
    };
    C.displayName = displayName;
    return C;
}

// src/withAuthenticationRequired.tsx
var $b40c3a08cec6a11c$var$import_react6 = $b40c3a08cec6a11c$var$__toESM((parcelRequire("acw62")));
var $b40c3a08cec6a11c$var$withAuthenticationRequired = (Component, options = {})=>{
    const { OnRedirecting: OnRedirecting = ()=>/* @__PURE__ */ $b40c3a08cec6a11c$var$import_react6.default.createElement($b40c3a08cec6a11c$var$import_react6.default.Fragment, null), onBeforeSignin: onBeforeSignin, signinRedirectArgs: signinRedirectArgs } = options;
    const displayName = `withAuthenticationRequired(${Component.displayName || Component.name})`;
    const C = (props)=>{
        const auth = $b40c3a08cec6a11c$var$useAuth();
        $b40c3a08cec6a11c$var$import_react6.default.useEffect(()=>{
            if ($b40c3a08cec6a11c$var$hasAuthParams() || auth.isLoading || auth.activeNavigator || auth.isAuthenticated) return;
            (async ()=>{
                if (onBeforeSignin) await onBeforeSignin();
                await auth.signinRedirect(signinRedirectArgs);
            })();
        }, [
            auth.isLoading,
            auth.isAuthenticated,
            auth
        ]);
        return auth.isAuthenticated ? /* @__PURE__ */ $b40c3a08cec6a11c$var$import_react6.default.createElement(Component, {
            ...props
        }) : OnRedirecting();
    };
    C.displayName = displayName;
    return C;
};


const $fe9e7bfbce151564$var$AuthContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
let $fe9e7bfbce151564$var$accessToken = "";
let $fe9e7bfbce151564$var$refreshToken = "";
const $fe9e7bfbce151564$export$87091915187a1a85 = ({ children: children })=>{
    const [lastRefreshDate, setLastRefreshDate] = (0, $acw62.useState)(new Date());
    const [user, setUser] = (0, $acw62.useState)(null);
    const [isReady, setIsReady] = (0, $acw62.useState)(false);
    const [isAuthenticated, setIsAuthenticated] = (0, $acw62.useState)(false);
    const oidcAuth = (0, $b40c3a08cec6a11c$exports.useAuth)();
    const { appName: appName, authConfig: authConfig, appVersion: appVersion, isReady: mainAppIsReady, showComponent: showComponent } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    //const navigate = useNavigate();
    const getName = (name)=>{
        return appName + "_" + name;
    };
    (0, $acw62.useEffect)(()=>{
        if (mainAppIsReady === true) initializeAuth();
    }, [
        mainAppIsReady
    ]);
    (0, $acw62.useEffect)(()=>{
        if (authConfig?.AuthType == "Oidc" && mainAppIsReady === true && oidcAuth.isLoading === false) {
            if (oidcAuth.isAuthenticated === true) {
                window.history.replaceState({}, document.title, window.location.pathname);
                $fe9e7bfbce151564$var$accessToken = oidcAuth.user.access_token;
                localStorage.setItem(getName("accessToken"), $fe9e7bfbce151564$var$accessToken);
                onReadyFunction(false);
            } else oidcAuth.signinRedirect();
        }
    }, [
        oidcAuth.isAuthenticated,
        authConfig,
        mainAppIsReady,
        oidcAuth.isLoading
    ]);
    const getAccessToken = ()=>{
        return $fe9e7bfbce151564$var$accessToken;
    };
    const getRefreshToken = ()=>{
        return $fe9e7bfbce151564$var$refreshToken;
    };
    const performTokenRefresh = async ()=>{
        // const data = new FormData();
        // data.append("grant_type", "refresh_token");
        // data.append("refresh_token", refreshToken);
        // data.append("client_id", appName);
        const data = new URLSearchParams();
        data.append("grant_type", "refresh_token");
        data.append("refresh_token", $fe9e7bfbce151564$var$refreshToken);
        data.append("client_id", appName);
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}token?v=${appVersion}`;
        // make API call
        try {
            const fetchOptions = {
                method: "POST"
            };
            fetchOptions.body = data;
            const loginResponse = await fetch(urlToCall, fetchOptions);
            if (loginResponse.ok === true) {
                const json = await loginResponse.json();
                $fe9e7bfbce151564$var$accessToken = json.access_token;
                $fe9e7bfbce151564$var$refreshToken = json.refresh_token;
                setLastRefreshDate(new Date());
                localStorage.setItem(getName("accessToken"), json.access_token);
                localStorage.setItem(getName("refreshToken"), json.refresh_token);
                localStorage.setItem(getName("lastRefreshDate"), JSON.stringify(new Date()));
                setIsAuthenticated(true);
                return Promise.resolve();
            }
            return Promise.reject("could not update refresh token");
        } catch (err) {
            console.error(err);
        }
    };
    const validateRefreshToken = async ()=>{
        // check when last the refresh token was obtained
        const refreshDate = localStorage.getItem(getName("lastRefreshDate"));
        let lastRefreshDateString = refreshDate || "";
        if (lastRefreshDateString == null || lastRefreshDateString.length == 0) // this defaults it to right now, so it won't try and refresh the token
        // The next API call will fail with 401 and force the login dialog
        lastRefreshDateString = JSON.stringify(new Date());
        const savedLastRefreshDate = new Date(JSON.parse(lastRefreshDateString));
        setLastRefreshDate(savedLastRefreshDate);
        // see if refresh token needs to be refreshed again
        var today = new Date();
        if (savedLastRefreshDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
            try {
                await performTokenRefresh();
            } catch (err) {
                console.log("error performing token refresh");
                console.log(err);
            }
            setIsReady(true);
            onReadyFunction();
        } else {
            setIsReady(true);
            onReadyFunction();
        }
    };
    const initializeAuth = async ()=>{
        // get auth tokens from local storage
        $fe9e7bfbce151564$var$accessToken = localStorage.getItem(getName("accessToken"));
        $fe9e7bfbce151564$var$refreshToken = localStorage.getItem(getName("refreshToken"));
        //validateRefreshToken();
        if (authConfig.AuthType == "Qbic") {
            await onReadyFunction();
            setIsReady(true);
        } else authConfig.AuthType;
    };
    const performLogin = async (username, password)=>{
        const data = new URLSearchParams();
        data.append("grant_type", "password");
        data.append("username", username);
        data.append("password", password);
        data.append("client_id", appName);
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}token?v=${appVersion}`;
        // make API call
        try {
            const fetchOptions = {
                method: "POST"
            };
            fetchOptions.body = data;
            const loginResponse = await fetch(urlToCall, fetchOptions);
            if (loginResponse.ok === true) {
                const json = await loginResponse.json();
                localStorage.setItem(getName("accessToken"), json.access_token);
                localStorage.setItem(getName("refreshToken"), json.refresh_token);
                localStorage.setItem(getName("lastRefreshDate"), JSON.stringify(new Date()));
                setTimeout(()=>{
                    window.location.reload();
                }, 10); // make sure this happens after navigate !?!
                //navigate("/");
                showComponent({
                    menu: null,
                    type: "home"
                });
                return;
            }
            const responseText = await loginResponse.text();
            return Promise.reject(responseText);
        } catch (err) {
            console.log(err);
        }
    };
    const resetPassword = async (username)=>{
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}menu/RequestPasswordReset?v=${appVersion}`;
        // make API call
        try {
            const fetchOptions = {
                method: "POST",
                body: JSON.stringify({
                    usernameOrEmail: username
                })
            };
            const apiResponse = await fetch(urlToCall, fetchOptions);
            if (apiResponse.ok === true) return await apiResponse.text();
            const responseText = await apiResponse.text();
            return Promise.reject(responseText);
        } catch (err) {
            console.log(err);
        }
    };
    const doLogin = async (username, password)=>{
        await performLogin(username, password);
    };
    const handleLoggingIn = ()=>{
        if (authConfig?.AuthType == "Qbic") showComponent({
            menu: null,
            type: "login"
        });
        else if (authConfig?.AuthType == "Oidc") ;
        else console.warn("Unexpected auth config type: " + authConfig?.AuthType);
    };
    const logout = ()=>{
        localStorage.removeItem(getName("accessToken"));
        localStorage.removeItem(getName("refreshToken"));
        localStorage.removeItem(getName("lastRefreshDate"));
        setIsAuthenticated(false);
        if (authConfig?.AuthType == "Oidc") oidcAuth.signoutSilent();
        handleLoggingIn();
        // show home page
        showComponent({
            menu: null,
            type: "home"
        });
    };
    async function onReadyFunction(allow401 = true) {
        // call initialize (basically checks if user is authenticated, and returns user name and id)
        if (window.location.search.includes("anonAction")) return;
        // make API call
        try {
            const fetchOptions = {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + $fe9e7bfbce151564$var$accessToken
                }
            };
            const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}initialize?v=${appVersion}`;
            const apiResponse = await fetch(urlToCall, fetchOptions);
            if (apiResponse.ok === true) {
                const json = await apiResponse.json();
                const userInfo = json;
                setUser(userInfo);
                setIsAuthenticated(true);
            } else if (apiResponse.status == 401) {
                if (allow401) {
                    await performTokenRefresh();
                    await onReadyFunction(false);
                } else handleLoggingIn();
            }
        //return Promise.reject(responseText);
        } catch (err) {
            console.log("caught error trying to initialize");
            console.log(err);
            handleLoggingIn();
        }
    }
    const value = {
        getAccessToken: getAccessToken,
        performTokenRefresh: performTokenRefresh,
        isReady: isReady,
        doLogin: doLogin,
        logout: logout,
        isAuthenticated: isAuthenticated,
        setIsAuthenticated: setIsAuthenticated,
        resetPassword: resetPassword,
        user: user
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fe9e7bfbce151564$var$AuthContext.Provider, {
        value: value,
        children: children
    });
};
const $fe9e7bfbce151564$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $acw62.useContext)($fe9e7bfbce151564$var$AuthContext);
    if (!context) throw new Error("useAuth must be used within an AuthProvider");
    return context;
};


function $9004343119f79a76$var$validateField(field, value) {
    switch(field){
        case "username":
            return value ? null : "Username is required";
        default:
            return null;
    }
}
function $9004343119f79a76$var$validateFormData(data) {
    const fields = Object.keys(data);
    const errors = fields.reduce((errors, field)=>{
        const error = $9004343119f79a76$var$validateField(field, data[field]);
        if (error) errors[field] = error;
        return errors;
    }, {});
    return Object.keys(errors).length > 0 ? errors : undefined;
}
const $9004343119f79a76$var$initialValues = {
    username: ""
};
const $9004343119f79a76$export$b597ee422a3143dc = ({ visible: visible = false, onDismiss: onDismiss })=>{
    const [values, setValues] = (0, $acw62.useState)($9004343119f79a76$var$initialValues);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [successMessage, setSuccessMessage] = (0, $acw62.useState)("");
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const onChange = (field, value)=>{
        console.log("on change");
        setValues((prevValues)=>({
                ...prevValues,
                [field]: value
            }));
        const error = $9004343119f79a76$var$validateField(field, value);
        setErrors((prevErrors)=>({
                ...prevErrors,
                [field]: error
            }));
    };
    const submitForm = async ()=>{
        const errors = $9004343119f79a76$var$validateFormData(values);
        if (errors) setErrors(errors);
        else {
            // todo
            setLoading(true);
            const result = await auth.resetPassword(values.username);
            if (result.includes("No user")) setErrorMessage(result);
            else setSuccessMessage(result);
            setLoading(false);
        }
    };
    const dismissAndClear = ()=>{
        setErrorMessage("");
        setSuccessMessage("");
        setValues($9004343119f79a76$var$initialValues);
        onDismiss();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $104eee66f5fcddce$export$2e2bcd8739ae039), {
        header: "Forgot password",
        visible: visible,
        onDismiss: dismissAndClear,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
            float: "left",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                direction: "horizontal",
                size: "xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                        variant: "primary",
                        onClick: submitForm,
                        loading: loading,
                        loadingText: "Resetting password",
                        children: "Reset Password"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                        variant: "link",
                        onClick: dismissAndClear,
                        children: "Cancel"
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            direction: "vertical",
            size: "l",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                    label: "Username",
                    errorText: errors?.username,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                        onChange: ({ detail: { value: value } })=>onChange("username", value),
                        placeholder: "Enter username",
                        value: values.username
                    })
                }),
                errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a8b0110371552e0$export$2e2bcd8739ae039), {
                    statusIconAriaLabel: "Error",
                    type: "error",
                    header: `Error resetting password`,
                    dismissible: true,
                    onDismiss: ()=>setErrorMessage(""),
                    children: errorMessage
                }, "alert-item") : null,
                successMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a8b0110371552e0$export$2e2bcd8739ae039), {
                    statusIconAriaLabel: "Success",
                    type: "success",
                    header: `Success`,
                    dismissible: true,
                    onDismiss: ()=>setSuccessMessage(""),
                    children: successMessage
                }, "alert-item") : null
            ]
        })
    });
};




function $bed6b8339cc09029$var$validateField(field, value) {
    switch(field){
        case "username":
            return value ? null : "Username is required";
        case "password":
            return value ? null : "Password is required";
        default:
            return null;
    }
}
function $bed6b8339cc09029$var$validateFormData(data) {
    const fields = Object.keys(data);
    const errors = fields.reduce((errors, field)=>{
        const error = $bed6b8339cc09029$var$validateField(field, data[field]);
        if (error) errors[field] = error;
        return errors;
    }, {});
    return Object.keys(errors).length > 0 ? errors : undefined;
}
const $bed6b8339cc09029$export$21a94553ffa41578 = ()=>{
    const [values, setValues] = (0, $acw62.useState)({
        username: "",
        password: ""
    });
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [showForgotPassword, setShowForgotPassword] = (0, $acw62.useState)(false);
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const { showComponent: showComponent } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    (0, $acw62.useEffect)(()=>{
        if (auth.isAuthenticated == true) showComponent({
            menu: null,
            type: "home"
        });
    }, [
        auth.isAuthenticated
    ]);
    const onChange = (field, value)=>{
        setValues((prevValues)=>({
                ...prevValues,
                [field]: value
            }));
        const error = $bed6b8339cc09029$var$validateField(field, value);
        setErrors((prevErrors)=>({
                ...prevErrors,
                [field]: error
            }));
    };
    const submitForm = async (e)=>{
        e.preventDefault();
        const errors = $bed6b8339cc09029$var$validateFormData(values);
        if (errors) setErrors(errors);
        else {
            setLoading(true);
            try {
                await auth.doLogin(values.username, values.password);
            } catch (err) {
                setErrorMessage(err);
            } finally{
                setLoading(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c3c7a1fd2ca4107$export$2e2bcd8739ae039), {
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            size: "m",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
                variant: "h1"
            })
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9004343119f79a76$export$b597ee422a3143dc), {
                    visible: showForgotPassword,
                    onDismiss: ()=>setShowForgotPassword(false)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60822fbe2c08caa5$export$2e2bcd8739ae039), {
                    header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
                        variant: "h2",
                        children: "Login"
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                        onSubmit: submitForm,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3128a80b6a88093c$export$2e2bcd8739ae039), {
                            variant: "embedded",
                            actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                                alignItems: "center",
                                direction: "horizontal",
                                size: "xs",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    loading: loading,
                                    children: "Login"
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                                direction: "vertical",
                                size: "l",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                                        label: "Username",
                                        errorText: errors?.username,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                                            onChange: ({ detail: { value: value } })=>onChange("username", value),
                                            placeholder: "Enter username",
                                            value: values.username
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                                        label: "Password",
                                        errorText: errors?.password,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                                            type: "password",
                                            onChange: ({ detail: { value: value } })=>onChange("password", value),
                                            placeholder: "Enter password",
                                            value: values.password
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3baf384ab7fe8d32$export$2e2bcd8739ae039), {
                                            onFollow: ()=>setShowForgotPassword(true),
                                            children: "Forgot password?"
                                        })
                                    }),
                                    errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a8b0110371552e0$export$2e2bcd8739ae039), {
                                        statusIconAriaLabel: "Error",
                                        type: "error",
                                        header: `Unable to login`,
                                        dismissible: true,
                                        onDismiss: ()=>setErrorMessage(""),
                                        children: errorMessage
                                    }, "alert-item") : null
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $bdffb66bf00e09e1$export$2e2bcd8739ae039 = {
    "label": "awsui_label_13tpe_9w8pd_5",
    "native-input": "awsui_native-input_13tpe_9w8pd_6"
};



var $1e6aa07928915cff$export$2e2bcd8739ae039 = {
    "content": "awsui_content_1wepg_fp1bh_145",
    "description": "awsui_description_1wepg_fp1bh_146",
    "label": "awsui_label_1wepg_fp1bh_147",
    "outline": "awsui_outline_1wepg_fp1bh_155",
    "show-outline": "awsui_show-outline_1wepg_fp1bh_158",
    "native-input": "awsui_native-input_1wepg_fp1bh_162",
    "wrapper": "awsui_wrapper_1wepg_fp1bh_166",
    "label-wrapper": "awsui_label-wrapper_1wepg_fp1bh_172",
    "empty-content": "awsui_empty-content_1wepg_fp1bh_183",
    "description-bottom-padding": "awsui_description-bottom-padding_1wepg_fp1bh_193",
    "label-disabled": "awsui_label-disabled_1wepg_fp1bh_201",
    "description-disabled": "awsui_description-disabled_1wepg_fp1bh_202",
    "control": "awsui_control_1wepg_fp1bh_206"
};


function $f9358073d64ebb29$var$joinString(values) {
    return values.filter((value)=>!!value).join(' ');
}
function $f9358073d64ebb29$export$2e2bcd8739ae039({ controlId: controlId, controlClassName: controlClassName, outlineClassName: outlineClassName, showOutline: showOutline, disabled: disabled, readOnly: readOnly, nativeControl: nativeControl, styledControl: styledControl, label: label, description: description, descriptionBottomPadding: descriptionBottomPadding, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, ariaControls: ariaControls, onClick: onClick, style: style, __internalRootRef: __internalRootRef, ...rest }) {
    var _a, _b, _c, _d, _e, _f;
    const uniqueId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const id = controlId || uniqueId;
    const labelId = `${id}-label`;
    const descriptionId = `${id}-description`;
    const ariaLabelledByIds = [];
    if (label && !ariaLabel) ariaLabelledByIds.push(labelId);
    if (ariaLabelledby) ariaLabelledByIds.push(ariaLabelledby);
    const ariaDescriptions = [];
    if (ariaDescribedby) ariaDescriptions.push(ariaDescribedby);
    if (description) ariaDescriptions.push(descriptionId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...rest,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).wrapper, rest.className),
        ref: __internalRootRef,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsLabelAttribute)(label ? `.${(0, $bdffb66bf00e09e1$export$2e2bcd8739ae039).label}` : `.${(0, $bdffb66bf00e09e1$export$2e2bcd8739ae039)['native-input']}`)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $1e6aa07928915cff$export$2e2bcd8739ae039)['label-wrapper'],
        "aria-disabled": disabled ? 'true' : undefined,
        onClick: disabled || readOnly ? undefined : onClick,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(disabled || readOnly ? {} : {
            action: 'select',
            detail: {
                label: label ? `.${(0, $bdffb66bf00e09e1$export$2e2bcd8739ae039).label}` : `.${(0, $bdffb66bf00e09e1$export$2e2bcd8739ae039)['native-input']}`
            }
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).control, controlClassName),
        style: {
            background: (_a = style === null || style === void 0 ? void 0 : style.control) === null || _a === void 0 ? void 0 : _a.background,
            ...(style === null || style === void 0 ? void 0 : style.focusRing) && {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: (_b = style.focusRing) === null || _b === void 0 ? void 0 : _b.borderColor,
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_c = style.focusRing) === null || _c === void 0 ? void 0 : _c.borderRadius,
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_d = style.focusRing) === null || _d === void 0 ? void 0 : _d.borderWidth
            }
        }
    }, styledControl, nativeControl({
        id: id,
        disabled: disabled,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039)['native-input'], (0, $bdffb66bf00e09e1$export$2e2bcd8739ae039)['native-input']),
        'aria-describedby': ariaDescriptions.length ? $f9358073d64ebb29$var$joinString(ariaDescriptions) : undefined,
        'aria-labelledby': ariaLabelledByIds.length ? $f9358073d64ebb29$var$joinString(ariaLabelledByIds) : undefined,
        'aria-label': ariaLabel,
        'aria-controls': ariaControls
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).outline, outlineClassName, showOutline && (0, $1e6aa07928915cff$export$2e2bcd8739ae039)['show-outline'])
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).content, !label && !description && (0, $1e6aa07928915cff$export$2e2bcd8739ae039)['empty-content'])
    }, label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: labelId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).label, (0, $bdffb66bf00e09e1$export$2e2bcd8739ae039).label, {
            [(0, $1e6aa07928915cff$export$2e2bcd8739ae039)['label-disabled']]: disabled
        }),
        style: {
            color: (_e = style === null || style === void 0 ? void 0 : style.label) === null || _e === void 0 ? void 0 : _e.color
        }
    }, label), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descriptionId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).description, {
            [(0, $1e6aa07928915cff$export$2e2bcd8739ae039)['description-disabled']]: disabled,
            [(0, $1e6aa07928915cff$export$2e2bcd8739ae039)['description-bottom-padding']]: descriptionBottomPadding
        }),
        style: {
            color: (_f = style === null || style === void 0 ? void 0 : style.description) === null || _f === void 0 ? void 0 : _f.color
        }
    }, description))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $7e68b67ced01b463$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1fn7j_t5xe1_145",
    "styled-box": "awsui_styled-box_1fn7j_t5xe1_152",
    "styled-box-checked": "awsui_styled-box-checked_1fn7j_t5xe1_168",
    "styled-box-indeterminate": "awsui_styled-box-indeterminate_1fn7j_t5xe1_168",
    "styled-box-disabled": "awsui_styled-box-disabled_1fn7j_t5xe1_172",
    "styled-box-readonly": "awsui_styled-box-readonly_1fn7j_t5xe1_172",
    "styled-line": "awsui_styled-line_1fn7j_t5xe1_176",
    "styled-line-disabled": "awsui_styled-line-disabled_1fn7j_t5xe1_181",
    "styled-line-readonly": "awsui_styled-line-readonly_1fn7j_t5xe1_184"
};


// Can't use css variables for svg attributes
const $c90f2424593277d9$var$dimensionsByTheme = {
    default: {
        viewBox: '0 0 14 14',
        indeterminate: '2.5,7 11.5,7',
        checked: '2.5,7 6,10 11,3',
        xy: 0.5,
        r: 1.5,
        size: 13
    },
    refresh: {
        viewBox: '0 0 16 16',
        indeterminate: '3.5,8 12.5,8',
        checked: '3.5,8 7,11 12,4',
        xy: 0.5,
        r: 3,
        size: 15
    }
};
const $c90f2424593277d9$var$CheckboxIcon = ({ checked: checked, indeterminate: indeterminate, disabled: disabled = false, readOnly: readOnly = false, style: style, ...restProps })=>{
    var _a, _b, _c;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const theme = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)() ? 'refresh' : 'default';
    const dimensions = $c90f2424593277d9$var$dimensionsByTheme[theme];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        className: (0, $7e68b67ced01b463$export$2e2bcd8739ae039).root,
        viewBox: dimensions.viewBox,
        "aria-hidden": "true",
        focusable: "false",
        ...baseProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-box'], {
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-box-checked']]: checked,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-box-indeterminate']]: indeterminate,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-box-disabled']]: disabled,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-box-readonly']]: readOnly
        }),
        x: dimensions.xy,
        y: dimensions.xy,
        rx: dimensions.r,
        ry: dimensions.r,
        width: dimensions.size,
        height: dimensions.size,
        style: {
            fill: (_a = style === null || style === void 0 ? void 0 : style.box) === null || _a === void 0 ? void 0 : _a.fill,
            stroke: (_b = style === null || style === void 0 ? void 0 : style.box) === null || _b === void 0 ? void 0 : _b.stroke
        }
    }), checked || indeterminate ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-line'], {
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-line-disabled']]: disabled,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)['styled-line-readonly']]: readOnly
        }),
        points: indeterminate ? dimensions.indeterminate : dimensions.checked,
        style: {
            stroke: (_c = style === null || style === void 0 ? void 0 : style.line) === null || _c === void 0 ? void 0 : _c.stroke
        }
    }) : null);
};
var $c90f2424593277d9$export$2e2bcd8739ae039 = $c90f2424593277d9$var$CheckboxIcon;






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $a4ca11d6aa7fe07f$export$6444e33011b307a(checked, disabled, readOnly, indeterminate, defaultValue = 'default') {
    let computedState;
    if (disabled) computedState = 'disabled';
    else if (readOnly) computedState = 'readOnly';
    else if (indeterminate) computedState = 'indeterminate';
    else if (checked) computedState = 'checked';
    else computedState = defaultValue;
    return computedState;
}


function $29f91cc232c4f4bc$export$b401c5cdeddba627(style, checked, disabled, readOnly, indeterminate) {
    var _a, _b, _c, _d, _e, _f, _g;
    let properties = {};
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core' && ((style === null || style === void 0 ? void 0 : style.label) || (style === null || style === void 0 ? void 0 : style.input))) {
        const computedState = (0, $a4ca11d6aa7fe07f$export$6444e33011b307a)(checked, disabled, readOnly, indeterminate);
        properties = {
            label: {
                color: ((_a = style === null || style === void 0 ? void 0 : style.label) === null || _a === void 0 ? void 0 : _a.color) && style.label.color[computedState]
            },
            focusRing: {
                borderColor: (_c = (_b = style === null || style === void 0 ? void 0 : style.input) === null || _b === void 0 ? void 0 : _b.focusRing) === null || _c === void 0 ? void 0 : _c.borderColor,
                borderRadius: (_e = (_d = style === null || style === void 0 ? void 0 : style.input) === null || _d === void 0 ? void 0 : _d.focusRing) === null || _e === void 0 ? void 0 : _e.borderRadius,
                borderWidth: (_g = (_f = style === null || style === void 0 ? void 0 : style.input) === null || _f === void 0 ? void 0 : _f.focusRing) === null || _g === void 0 ? void 0 : _g.borderWidth
            }
        };
    }
    return properties;
}
function $29f91cc232c4f4bc$export$711e179a8771dc4d(style, checked, disabled, readOnly, indeterminate) {
    var _a, _b, _c, _d;
    let properties = {};
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core' && (style === null || style === void 0 ? void 0 : style.input)) {
        const computedState = (0, $a4ca11d6aa7fe07f$export$6444e33011b307a)(checked, disabled, readOnly, indeterminate);
        properties = {
            box: {
                fill: ((_a = style.input) === null || _a === void 0 ? void 0 : _a.fill) && style.input.fill[computedState],
                stroke: ((_b = style.input) === null || _b === void 0 ? void 0 : _b.stroke) && style.input.stroke[computedState]
            },
            line: {
                stroke: ((_d = (_c = style.input) === null || _c === void 0 ? void 0 : _c.check) === null || _d === void 0 ? void 0 : _d.stroke) && style.input.check.stroke[computedState]
            }
        };
    }
    return properties;
}



var $0fe4000c413c450b$export$2e2bcd8739ae039 = {
    "root": "awsui_root_k2y2q_107vk_145",
    "checkbox-control": "awsui_checkbox-control_k2y2q_107vk_178",
    "outline": "awsui_outline_k2y2q_107vk_186"
};


const $81def5553f1b8381$var$InternalCheckbox = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ controlId: controlId, name: name, checked: checked, disabled: disabled, readOnly: readOnly, ariaRequired: ariaRequired, indeterminate: indeterminate, children: children, description: description, ariaLabel: ariaLabel, onFocus: onFocus, onBlur: onBlur, onChange: onChange, tabIndex: explicitTabIndex, showOutline: showOutline, ariaControls: ariaControls, style: style, nativeInputAttributes: nativeInputAttributes, __internalRootRef: __internalRootRef, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata = false, ...rest }, ref)=>{
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const checkboxRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, checkboxRef);
    (0, $acw62.useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = Boolean(indeterminate);
    });
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(checkboxRef, {
        tabIndex: explicitTabIndex
    });
    const analyticsMetadata = {};
    const analyticsComponentMetadata = {
        name: 'awsui.Checkbox',
        label: {
            root: 'self'
        },
        properties: {
            checked: `${!!checked}`
        }
    };
    if (__injectAnalyticsComponentMetadata) analyticsMetadata.component = analyticsComponentMetadata;
    if (!disabled && !readOnly) analyticsMetadata.action = !checked ? 'select' : 'deselect';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9358073d64ebb29$export$2e2bcd8739ae039), {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0fe4000c413c450b$export$2e2bcd8739ae039).root, baseProps.className),
        controlClassName: (0, $0fe4000c413c450b$export$2e2bcd8739ae039)['checkbox-control'],
        outlineClassName: (0, $0fe4000c413c450b$export$2e2bcd8739ae039).outline,
        controlId: controlId,
        disabled: disabled,
        readOnly: readOnly,
        label: children,
        description: description,
        descriptionBottomPadding: true,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby,
        ariaControls: ariaControls,
        showOutline: showOutline,
        nativeControl: (nativeControlProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
                ...nativeControlProps,
                tag: "input",
                componentName: "Checkbox",
                nativeAttributes: nativeInputAttributes,
                ref: checkboxRef,
                type: "checkbox",
                checked: checked,
                name: name,
                "aria-required": ariaRequired ? 'true' : undefined,
                "aria-disabled": readOnly && !disabled ? 'true' : undefined,
                tabIndex: tabIndex,
                onFocus: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus),
                onBlur: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur),
                // empty handler to suppress React controllability warning
                onChange: ()=>{}
            }),
        onClick: ()=>{
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 || _a.focus();
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, // for deterministic transitions "indeterminate" -> "checked" -> "unchecked"
            indeterminate ? {
                checked: true,
                indeterminate: false
            } : {
                checked: !checked,
                indeterminate: false
            });
        },
        styledControl: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90f2424593277d9$export$2e2bcd8739ae039), {
            checked: checked,
            indeterminate: indeterminate,
            disabled: disabled,
            readOnly: readOnly,
            style: (0, $29f91cc232c4f4bc$export$711e179a8771dc4d)(style, checked, disabled, readOnly, indeterminate)
        }),
        style: (0, $29f91cc232c4f4bc$export$b401c5cdeddba627)(style, checked, disabled, readOnly, indeterminate),
        __internalRootRef: __internalRootRef,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    });
});
var $81def5553f1b8381$export$2e2bcd8739ae039 = $81def5553f1b8381$var$InternalCheckbox;


'use client';
const $f975e47fe9face4d$var$Checkbox = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ ...props }, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Checkbox', {
        props: {
            readOnly: props.readOnly
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        ...props,
        ...baseComponentProps,
        ref: ref,
        __injectAnalyticsComponentMetadata: true
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($f975e47fe9face4d$var$Checkbox, 'Checkbox');
var $f975e47fe9face4d$export$2e2bcd8739ae039 = $f975e47fe9face4d$var$Checkbox;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}


function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}




function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}



function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $8085a298e92e1718$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}



function $09f87854553a6255$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $341652d1a063d149$export$56ec8876a3c0f013() {
    const cacheRef = (0, $acw62.useRef)(new Map());
    return (date)=>{
        const current = cacheRef.current.get(date.getTime());
        if (current) return current;
        cacheRef.current.set(date.getTime(), date);
        return date;
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $baa585fc493d6e9d$export$6b862160d295c8e(value, strict = false) {
    const [yearString, monthString, dayString] = value.split('-');
    const year = Number(yearString);
    const month = Number(monthString);
    const day = Number(dayString);
    if (strict) {
        if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
    }
    return new Date(year, (month || 1) - 1, day || 1);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $1a5a86f8a8149138$export$f0064b1835777f8e(locale, fullLocale) {
    const isShort = locale.length === 2;
    if (isShort && fullLocale.indexOf(locale) === 0) return fullLocale;
    return locale;
}


function $d3f825eb41b88093$export$dca0327c9b9c6498(component, locale) {
    var _a;
    locale = $d3f825eb41b88093$var$checkLocale(component, locale);
    const browserLocale = $d3f825eb41b88093$var$getBrowserLocale();
    if (locale) return (0, $1a5a86f8a8149138$export$f0064b1835777f8e)(locale, browserLocale);
    const htmlLocale = $d3f825eb41b88093$var$checkLocale(component, (_a = $d3f825eb41b88093$var$getHtmlElement()) === null || _a === void 0 ? void 0 : _a.getAttribute('lang'));
    if (htmlLocale) return (0, $1a5a86f8a8149138$export$f0064b1835777f8e)(htmlLocale, browserLocale);
    return browserLocale;
}
function $d3f825eb41b88093$var$checkLocale(component, locale) {
    if (!locale || locale === '') return '';
    // Support underscore-delimited locales
    locale = locale && locale.replace(/^([a-z]{2})_/, '$1-');
    // Check that the value matches aa-BB pattern
    // TODO: support full BCP 47 spec?
    if (locale && !locale.match(/^[a-z]{2}(-[A-Z]{2})?$/)) {
        (0, $013a2451794a45c0$exports.warnOnce)(component, `Invalid locale provided: ${locale}. Falling back to default`);
        locale = '';
    }
    return locale;
}
function $d3f825eb41b88093$var$getHtmlElement() {
    return typeof document !== 'undefined' ? document.querySelector('html') : null;
}
function $d3f825eb41b88093$var$getBrowserLocale() {
    return new Intl.DateTimeFormat().resolvedOptions().locale;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








var $b10423781dc3537f$export$2e2bcd8739ae039 = {
    "calendar": "awsui_calendar_1ykar_1p0hg_153",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1ykar_1p0hg_1",
    "root": "awsui_root_1ykar_1p0hg_180",
    "calendar-inner": "awsui_calendar-inner_1ykar_1p0hg_218",
    "calendar-header": "awsui_calendar-header_1ykar_1p0hg_222",
    "calendar-header-title": "awsui_calendar-header-title_1ykar_1p0hg_227",
    "calendar-next-btn": "awsui_calendar-next-btn_1ykar_1p0hg_235",
    "calendar-prev-btn": "awsui_calendar-prev-btn_1ykar_1p0hg_238",
    "calendar-grid": "awsui_calendar-grid_1ykar_1p0hg_241",
    "calendar-grid-dense": "awsui_calendar-grid-dense_1ykar_1p0hg_245",
    "calendar-grid-cell": "awsui_calendar-grid-cell_1ykar_1p0hg_253",
    "calendar-date-header": "awsui_calendar-date-header_1ykar_1p0hg_258",
    "calendar-date": "awsui_calendar-date_1ykar_1p0hg_258",
    "calendar-date-enabled": "awsui_calendar-date-enabled_1ykar_1p0hg_278",
    "calendar-date-current-page": "awsui_calendar-date-current-page_1ykar_1p0hg_288",
    "calendar-date-selected": "awsui_calendar-date-selected_1ykar_1p0hg_299",
    "calendar-date-current": "awsui_calendar-date-current_1ykar_1p0hg_288",
    "calendar-date-dense": "awsui_calendar-date-dense_1ykar_1p0hg_320",
    "date-inner": "awsui_date-inner_1ykar_1p0hg_328",
    "calendar-row": "awsui_calendar-row_1ykar_1p0hg_403",
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_1ykar_1p0hg_407"
};


const $b0a3f0e4ff8ed2c9$var$GridCell = (0, $acw62.forwardRef)((props, focusedDateRef)=>{
    const { disabledReason: disabledReason, ...rest } = props;
    const isDisabledWithReason = !!disabledReason;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    const ref = (0, $acw62.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
        ref: (0, $013a2451794a45c0$exports.useMergeRefs)(focusedDateRef, ref),
        ...isDisabledWithReason ? targetProps : {},
        ...rest,
        onFocus: ()=>isDisabledWithReason ? setShowTooltip(true) : undefined,
        onBlur: ()=>isDisabledWithReason ? setShowTooltip(false) : undefined,
        onMouseEnter: ()=>isDisabledWithReason ? setShowTooltip(true) : undefined,
        onMouseLeave: ()=>isDisabledWithReason ? setShowTooltip(false) : undefined
    }, props.children, isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['disabled-reason-tooltip'],
        getTrack: ()=>ref.current,
        content: disabledReason,
        onEscape: ()=>setShowTooltip(false)
    })));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($b0a3f0e4ff8ed2c9$var$GridCell, 'GridCell');
function $b0a3f0e4ff8ed2c9$export$2e2bcd8739ae039({ isDateEnabled: isDateEnabled, dateDisabledReason: dateDisabledReason, focusedDate: focusedDate, focusableDate: focusableDate, onSelectDate: onSelectDate, selectedDate: selectedDate, ariaLabelledby: ariaLabelledby, header: header, rows: rows, isCurrentPage: isCurrentPage, renderDate: renderDate, renderDateAnnouncement: renderDateAnnouncement, isSameDate: isSameDate, onGridKeyDownHandler: onGridKeyDownHandler }) {
    const focusedDateRef = (0, $acw62.useRef)(null);
    // The focused date changes as a feedback to keyboard navigation in the grid.
    // Once changed, the corresponding date button needs to receive the actual focus.
    (0, $5f60cc888539a35b$export$21dfe79102a9caab)(()=>{
        if (focusedDate && focusedDateRef.current) focusedDateRef.current.focus();
    }, [
        focusedDate
    ]);
    const rowLength = rows[0].length;
    const denseGrid = rowLength > 3;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        role: "grid",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-grid'], denseGrid && (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-grid-dense']),
        "aria-labelledby": ariaLabelledby
    }, header, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", {
        onKeyDown: onGridKeyDownHandler
    }, rows.map((row, rowIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowIndex,
            className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-row']
        }, row.map((date, dateIndex)=>{
            const isFocusable = !!focusableDate && isSameDate(date, focusableDate);
            const isSelected = !!selectedDate && isSameDate(date, selectedDate);
            const isEnabled = !isDateEnabled || isDateEnabled(date);
            const disabledReason = dateDisabledReason(date);
            const isDisabledWithReason = !isEnabled && !!disabledReason;
            const isCurrentDate = isSameDate(date, new Date());
            // Can't be focused.
            let tabIndex = undefined;
            if (isFocusable && (isEnabled || isDisabledWithReason)) // Next focus target.
            tabIndex = 0;
            else if (isEnabled || isDisabledWithReason) // Can be focused programmatically.
            tabIndex = -1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b0a3f0e4ff8ed2c9$var$GridCell, {
                key: `${rowIndex}:${dateIndex}`,
                ref: tabIndex === 0 ? focusedDateRef : undefined,
                tabIndex: tabIndex,
                "aria-current": isCurrentDate ? 'date' : undefined,
                "aria-selected": isEnabled ? isSelected : undefined,
                "aria-disabled": !isEnabled,
                // Do not attach click event when the date is disabled, otherwise VO+safari announces clickable
                onClick: isEnabled ? ()=>onSelectDate(date) : undefined,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-grid-cell'], (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-date'], {
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-date-current-page']]: isCurrentPage(date),
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-date-enabled']]: isEnabled,
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-date-selected']]: isSelected,
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-date-current']]: isCurrentDate,
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-date-dense']]: denseGrid
                }),
                disabledReason: isDisabledWithReason ? disabledReason : undefined
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['date-inner'],
                "aria-hidden": "true"
            }, renderDate(date)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), null, renderDateAnnouncement(date, isCurrentDate)));
        })))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $a12d66404868ccd6$var$setDayIndex(date, dayIndex) {
    const diff = dayIndex - date.getDay();
    date.setDate(date.getDate() + diff);
}
function $a12d66404868ccd6$export$3383afc3cadfb678(locale, dayIndex, mode) {
    const tempDate = new Date();
    $a12d66404868ccd6$var$setDayIndex(tempDate, dayIndex);
    return tempDate.toLocaleDateString(locale, {
        weekday: mode
    });
}
function $a12d66404868ccd6$export$ac27097ce4a1899f(locale, baseDate) {
    const result = baseDate.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long'
    });
    return result;
}
function $a12d66404868ccd6$export$64ba10e8616b702f(locale, date) {
    return date.toLocaleDateString(locale, {
        year: 'numeric'
    });
}
const $a12d66404868ccd6$var$dayLabelCache = new Map();
function $a12d66404868ccd6$export$51d68b748655e933(locale, date, mode = 'full') {
    const cacheKey = locale + date.getTime() + mode;
    const cachedValue = $a12d66404868ccd6$var$dayLabelCache.get(cacheKey);
    if (cachedValue) return cachedValue;
    const value = date.toLocaleDateString(locale, {
        weekday: mode === 'full' ? 'long' : undefined,
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
    $a12d66404868ccd6$var$dayLabelCache.set(cacheKey, value);
    return value;
}
function $a12d66404868ccd6$export$450ec533fd4eb9e4(locale, date, format) {
    let options = {};
    if (format === 'hh') options = {
        hour: '2-digit'
    };
    if (format === 'hh:mm') options = {
        hour: '2-digit',
        minute: '2-digit'
    };
    const value = date.toLocaleTimeString(locale, options);
    return value;
}



function $a4f6cc9bbab9bd77$export$2e2bcd8739ae039({ locale: locale, rows: rows }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, rows[0].map((date)=>date.getDay()).map((dayIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: dayIndex,
            scope: "col",
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-grid-cell'], (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-date-header'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true"
        }, (0, $a12d66404868ccd6$export$3383afc3cadfb678)(locale, dayIndex, 'short')), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), null, (0, $a12d66404868ccd6$export$3383afc3cadfb678)(locale, dayIndex, 'long'))))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}




function $e66021df2494c23e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $8a0cd77776020c49$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}



function $3ff7ac235dc3be01$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $e66021df2494c23e$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}


function $7d9f33c1c1097d4d$export$752403752bc16d94(startDate, isDateFocusable) {
    return $7d9f33c1c1097d4d$export$a1e8dc5f82b3f37d(startDate, isDateFocusable, 1);
}
function $7d9f33c1c1097d4d$export$20e3431fd4d21d70(startDate, isDateFocusable) {
    return $7d9f33c1c1097d4d$export$a1e8dc5f82b3f37d(startDate, isDateFocusable, -1);
}
function $7d9f33c1c1097d4d$export$12e8132dee1e1cb5(startDate, isDateFocusable) {
    return $7d9f33c1c1097d4d$export$a1e8dc5f82b3f37d(startDate, isDateFocusable, 7);
}
function $7d9f33c1c1097d4d$export$d83a6ab9969f2147(startDate, isDateFocusable) {
    return $7d9f33c1c1097d4d$export$a1e8dc5f82b3f37d(startDate, isDateFocusable, -7);
}
function $7d9f33c1c1097d4d$export$1fa92dcbdf32fb44(date, isDateFocusable) {
    const startDate = (0, $41c3cc0836893904$export$2e2bcd8739ae039)(date);
    if (isDateFocusable(startDate)) return startDate;
    const firstEnabledDate = $7d9f33c1c1097d4d$export$a1e8dc5f82b3f37d(startDate, isDateFocusable, 1);
    return (0, $8085a298e92e1718$export$2e2bcd8739ae039)(startDate, firstEnabledDate) ? firstEnabledDate : startDate;
}
function $7d9f33c1c1097d4d$export$a1e8dc5f82b3f37d(startDate, isDateFocusable, step) {
    const limitYears = 1;
    let current = (0, $4f754377033842c6$export$2e2bcd8739ae039)(startDate, step);
    while(!isDateFocusable(current)){
        if (Math.abs((0, $3ff7ac235dc3be01$export$2e2bcd8739ae039)(startDate, current)) > limitYears) return startDate;
        current = (0, $4f754377033842c6$export$2e2bcd8739ae039)(current, step);
    }
    return current;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


function $d60a56c0ed82241c$export$b3c242a863a88095(startDate, isDateFocusable) {
    return $d60a56c0ed82241c$export$f17b1604efd57788(startDate, isDateFocusable, 1);
}
function $d60a56c0ed82241c$export$2940ccdf63d4cab1(startDate, isDateFocusable) {
    return $d60a56c0ed82241c$export$f17b1604efd57788(startDate, isDateFocusable, -1);
}
function $d60a56c0ed82241c$export$1f32bc6c1f421808(startDate, isDateFocusable) {
    return $d60a56c0ed82241c$export$f17b1604efd57788(startDate, isDateFocusable, 3);
}
function $d60a56c0ed82241c$export$10ac36d8097361a0(startDate, isDateFocusable) {
    return $d60a56c0ed82241c$export$f17b1604efd57788(startDate, isDateFocusable, -3);
}
function $d60a56c0ed82241c$export$126ba571a8444064(date, isDateFocusable) {
    const startDate = (0, $48a662f07bb27222$export$2e2bcd8739ae039)(date);
    if (isDateFocusable(startDate)) return startDate;
    const firstEnabledDate = $d60a56c0ed82241c$export$f17b1604efd57788(startDate, isDateFocusable, 1);
    return (0, $09f87854553a6255$export$2e2bcd8739ae039)(startDate, firstEnabledDate) ? firstEnabledDate : startDate;
}
function $d60a56c0ed82241c$export$f17b1604efd57788(startDate, isDateFocusable, step) {
    const limitYears = 10;
    let current = (0, $a8211859f65764ad$export$2e2bcd8739ae039)(startDate, step);
    while(!isDateFocusable(current)){
        if (Math.abs((0, $3ff7ac235dc3be01$export$2e2bcd8739ae039)(startDate, current)) > limitYears) return startDate;
        current = (0, $a8211859f65764ad$export$2e2bcd8739ae039)(current, step);
    }
    return current;
}


function $c9a1e01e2f915c47$export$2e2bcd8739ae039({ baseDate: baseDate, focusableDate: focusableDate, granularity: granularity, isDateEnabled: isDateEnabled, isDateFocusable: isDateFocusable, onChangePage: onChangePage, onFocusDate: onFocusDate, onSelectDate: onSelectDate }) {
    const isMonthPicker = granularity === 'month';
    const moveDown = isMonthPicker ? (0, $d60a56c0ed82241c$export$1f32bc6c1f421808) : (0, $7d9f33c1c1097d4d$export$12e8132dee1e1cb5);
    const moveLeft = isMonthPicker ? (0, $d60a56c0ed82241c$export$2940ccdf63d4cab1) : (0, $7d9f33c1c1097d4d$export$20e3431fd4d21d70);
    const moveRight = isMonthPicker ? (0, $d60a56c0ed82241c$export$b3c242a863a88095) : (0, $7d9f33c1c1097d4d$export$752403752bc16d94);
    const moveUp = isMonthPicker ? (0, $d60a56c0ed82241c$export$10ac36d8097361a0) : (0, $7d9f33c1c1097d4d$export$d83a6ab9969f2147);
    const isSamePage = isMonthPicker ? (0, $09f87854553a6255$export$2e2bcd8739ae039) : (0, $8085a298e92e1718$export$2e2bcd8739ae039);
    const onGridKeyDownHandler = (event)=>{
        let updatedFocusDate;
        const keys = [
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter
        ];
        if (focusableDate === null || keys.indexOf(event.keyCode) === -1) return;
        event.preventDefault();
        (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
            onActivate: ()=>{
                if (!isDateEnabled(focusableDate)) return;
                onFocusDate(null);
                onSelectDate(focusableDate);
            },
            onBlockEnd: ()=>updatedFocusDate = moveDown(focusableDate, isDateFocusable),
            onBlockStart: ()=>updatedFocusDate = moveUp(focusableDate, isDateFocusable),
            onInlineStart: ()=>updatedFocusDate = moveLeft(focusableDate, isDateFocusable),
            onInlineEnd: ()=>updatedFocusDate = moveRight(focusableDate, isDateFocusable)
        });
        if (!updatedFocusDate) return;
        if (!isSamePage(updatedFocusDate, baseDate)) onChangePage(updatedFocusDate);
        onFocusDate(updatedFocusDate);
    };
    return onGridKeyDownHandler;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $821d7431eba4c146$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



function $3a082e1cb0a32433$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $ffba10b3e12d8879$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $a0be1d3cff8ac270$export$dd412b56f1e4d8aa = function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};


var $d3721cd57b171c74$export$566174fa40823587 = function setDate(date, day) {
    var result = new Date(date);
    result.setDate(day);
    return result;
};


function $b70e16aabf990ae1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b70e16aabf990ae1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b70e16aabf990ae1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b70e16aabf990ae1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b70e16aabf990ae1$var$DAYS_IN_WEEK = 7;
var $b70e16aabf990ae1$export$8f3e2263a6d57311 = function getCalendarMonth(date, options) {
    var _firstDayOfWeek$optio = $b70e16aabf990ae1$var$_objectSpread({
        firstDayOfWeek: 1
    }, options), firstDayOfWeek = _firstDayOfWeek$optio.firstDayOfWeek;
    var firstDateOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDateOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    var firstWeekdayOfMonth = firstDateOfMonth.getDay();
    var lastWeekdayOfMonth = lastDateOfMonth.getDay();
    var daysInMonth = lastDateOfMonth.getDate();
    var daysToPrepend = (firstWeekdayOfMonth - firstDayOfWeek + $b70e16aabf990ae1$var$DAYS_IN_WEEK) % $b70e16aabf990ae1$var$DAYS_IN_WEEK;
    var daysToAppend = ($b70e16aabf990ae1$var$DAYS_IN_WEEK - 1 - lastWeekdayOfMonth + firstDayOfWeek) % $b70e16aabf990ae1$var$DAYS_IN_WEEK;
    var month = [];
    var week = [];
    for(var i = 1 - daysToPrepend; i <= daysInMonth + daysToAppend + 1; i++){
        if (i <= 0) week.push((0, $a0be1d3cff8ac270$export$dd412b56f1e4d8aa)(firstDateOfMonth, i - 1));
        else if (i > daysInMonth) week.push((0, $a0be1d3cff8ac270$export$dd412b56f1e4d8aa)(lastDateOfMonth, i - daysInMonth));
        else week.push((0, $d3721cd57b171c74$export$566174fa40823587)(date, i));
        if (week.length === 7) {
            month.push(week);
            week = [];
        }
    }
    return month;
};


function $d89aef5eb57c603c$export$e86dac089c0dcd37(date) {
    const year = date.getFullYear();
    return new Array(4).fill(0).map((_, i)=>new Array(3).fill(0).map((_, j)=>new Date(year, i * 3 + j)));
}
class $d89aef5eb57c603c$export$d7a7c85c0f5afc4a {
    constructor({ padDates: padDates, baseDate: baseDate, startOfWeek: startOfWeek, selection: selection }){
        this.padDates = padDates;
        this.weeks = [];
        this.range = [
            baseDate,
            baseDate
        ];
        const allCalendarDates = $d89aef5eb57c603c$export$3a9f029074dee897(baseDate, {
            startOfWeek: startOfWeek,
            padDates: padDates
        });
        this.weekdays = allCalendarDates[0].map((date)=>date.getDay());
        const isDateVisible = (weekIndex, dayIndex)=>{
            const week = allCalendarDates[weekIndex];
            const date = week === null || week === void 0 ? void 0 : week[dayIndex];
            if (!date) return false;
            switch(padDates){
                case 'before':
                    return (0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, baseDate) || (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(date, baseDate);
                case 'after':
                    return (0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, baseDate) || (0, $821d7431eba4c146$export$2e2bcd8739ae039)(date, baseDate);
            }
        };
        const isDateInRange = (weekIndex, dayIndex)=>{
            const week = allCalendarDates[weekIndex];
            const date = week === null || week === void 0 ? void 0 : week[dayIndex];
            return !!(date && selection && $d89aef5eb57c603c$var$checkDateIsInRange(date, selection[0], selection[1]));
        };
        // The test index is only set for weeks that have at least one day that belongs to the current month.
        // It starts from the first such week and counts from 1.
        const getWeekTestIndex = (weekIndex)=>{
            var _a;
            const week = allCalendarDates[weekIndex];
            if (!week) return undefined;
            if (!(0, $8085a298e92e1718$export$2e2bcd8739ae039)(week[0], baseDate) && !(0, $8085a298e92e1718$export$2e2bcd8739ae039)(week[week.length - 1], baseDate)) return undefined;
            return ((_a = getWeekTestIndex(weekIndex - 1)) !== null && _a !== void 0 ? _a : 0) + 1;
        };
        for(let weekIndex = 0; weekIndex < allCalendarDates.length; weekIndex++){
            const daysOfWeek = allCalendarDates[weekIndex];
            const week = {
                days: [],
                testIndex: getWeekTestIndex(weekIndex)
            };
            for(let dayIndex = 0; dayIndex < daysOfWeek.length; dayIndex++){
                const date = daysOfWeek[dayIndex];
                const isVisible = isDateVisible(weekIndex, dayIndex);
                const isSelected = !!(selection && ((0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039)(date, selection[0]) || (0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039)(date, selection[1])));
                const isInRange = isDateInRange(weekIndex, dayIndex);
                const isTop = isVisible && !isDateVisible(weekIndex - 1, dayIndex);
                const isBottom = isVisible && !isDateVisible(weekIndex + 1, dayIndex);
                const isLeft = isVisible && !isDateVisible(weekIndex, dayIndex - 1);
                const isRight = isVisible && !isDateVisible(weekIndex, dayIndex + 1);
                const isRangeTop = isInRange && !isDateInRange(weekIndex - 1, dayIndex);
                const isRangeBottom = isInRange && !isDateInRange(weekIndex + 1, dayIndex);
                const isRangeLeft = isInRange && !isDateInRange(weekIndex, dayIndex - 1);
                const isRangeRight = isInRange && !isDateInRange(weekIndex, dayIndex + 1);
                week.days.push({
                    date: date,
                    isVisible: isVisible,
                    isSelected: isSelected,
                    isInRange: isInRange,
                    isSelectionTop: isTop || isRangeTop,
                    isSelectionBottom: isBottom || isRangeBottom,
                    isSelectionLeft: isLeft || isRangeLeft,
                    isSelectionRight: isRight || isRangeRight
                });
            }
            this.weeks.push(week);
        }
    }
}
class $d89aef5eb57c603c$export$657f9200591b2b71 {
    constructor({ baseDate: baseDate, selection: selection }){
        this.quarters = [];
        this.range = [
            baseDate,
            baseDate
        ];
        const allCalendarMonths = $d89aef5eb57c603c$export$e86dac089c0dcd37(baseDate);
        const isMonthInRange = (quarterIndex, monthIndex)=>{
            const quarter = allCalendarMonths[quarterIndex];
            const month = quarter === null || quarter === void 0 ? void 0 : quarter[monthIndex];
            return !!(month && selection && $d89aef5eb57c603c$var$checkMonthIsInRange(month, selection[0], selection[1]));
        };
        const isMonthVisible = (quarterIndex, monthIndex)=>{
            const quarter = allCalendarMonths[quarterIndex];
            const month = quarter === null || quarter === void 0 ? void 0 : quarter[monthIndex];
            if (!month) return false;
            return (0, $09f87854553a6255$export$2e2bcd8739ae039)(month, baseDate);
        };
        for(let quarterIndex = 0; quarterIndex < allCalendarMonths.length; quarterIndex++){
            const monthsOfQuarter = allCalendarMonths[quarterIndex];
            const quarter = {
                months: []
            };
            for(let monthIndex = 0; monthIndex < monthsOfQuarter.length; monthIndex++){
                const month = monthsOfQuarter[monthIndex];
                const isVisible = isMonthVisible(quarterIndex, monthIndex);
                const isSelected = !!(selection && ((0, $8085a298e92e1718$export$2e2bcd8739ae039)(month, selection[0]) || (0, $8085a298e92e1718$export$2e2bcd8739ae039)(month, selection[1])));
                const isInRange = isMonthInRange(quarterIndex, monthIndex);
                const isTop = isVisible && !isMonthVisible(quarterIndex - 1, monthIndex);
                const isBottom = isVisible && !isMonthVisible(quarterIndex + 1, monthIndex);
                const isLeft = isVisible && !isMonthVisible(quarterIndex, monthIndex - 1);
                const isRight = isVisible && !isMonthVisible(quarterIndex, monthIndex + 1);
                const isRangeTop = isInRange && !isMonthInRange(quarterIndex - 1, monthIndex);
                const isRangeBottom = isInRange && !isMonthInRange(quarterIndex + 1, monthIndex);
                const isRangeLeft = isInRange && !isMonthInRange(quarterIndex, monthIndex - 1);
                const isRangeRight = isInRange && !isMonthInRange(quarterIndex, monthIndex + 1);
                quarter.months.push({
                    date: month,
                    isVisible: isVisible,
                    isSelected: isSelected,
                    isInRange: isInRange,
                    isSelectionTop: isTop || isRangeTop,
                    isSelectionBottom: isBottom || isRangeBottom,
                    isSelectionLeft: isLeft || isRangeLeft,
                    isSelectionRight: isRight || isRangeRight
                });
            }
            this.quarters.push(quarter);
        }
    }
}
function $d89aef5eb57c603c$export$3a9f029074dee897(date, { startOfWeek: startOfWeek, padDates: padDates }) {
    switch(padDates){
        case 'before':
            return [
                ...$d89aef5eb57c603c$export$e15d502648546b68(date, startOfWeek),
                ...$d89aef5eb57c603c$export$7562918837e8f6cc(date, startOfWeek)
            ].slice(-6);
        case 'after':
            return [
                ...$d89aef5eb57c603c$export$7562918837e8f6cc(date, startOfWeek),
                ...$d89aef5eb57c603c$export$fc40e2850257b7d1(date, startOfWeek)
            ].slice(0, 6);
    }
}
function $d89aef5eb57c603c$var$checkDateIsInRange(date, dateOne, dateTwo) {
    if (!dateOne || !dateTwo || (0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039)(dateOne, dateTwo)) return false;
    const inRange = (0, $821d7431eba4c146$export$2e2bcd8739ae039)(date, dateOne) && (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(date, dateTwo) || (0, $821d7431eba4c146$export$2e2bcd8739ae039)(date, dateTwo) && (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(date, dateOne);
    return inRange || (0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039)(date, dateOne) || (0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039)(date, dateTwo);
}
function $d89aef5eb57c603c$var$checkMonthIsInRange(date, dateOne, dateTwo) {
    if (!dateOne || !dateTwo || (0, $8085a298e92e1718$export$2e2bcd8739ae039)(dateOne, dateTwo)) return false;
    const inRange = (0, $821d7431eba4c146$export$2e2bcd8739ae039)(date, dateOne) && (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(date, dateTwo) || (0, $821d7431eba4c146$export$2e2bcd8739ae039)(date, dateTwo) && (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(date, dateOne);
    return inRange || (0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, dateOne) || (0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, dateTwo);
}
function $d89aef5eb57c603c$export$7562918837e8f6cc(date, firstDayOfWeek) {
    return (0, $b70e16aabf990ae1$export$8f3e2263a6d57311)(date, {
        firstDayOfWeek: firstDayOfWeek
    });
}
function $d89aef5eb57c603c$export$e15d502648546b68(date, firstDayOfWeek) {
    const rows = (0, $b70e16aabf990ae1$export$8f3e2263a6d57311)((0, $ffba10b3e12d8879$export$2e2bcd8739ae039)(date, 1), {
        firstDayOfWeek: firstDayOfWeek
    });
    const lastDay = rows[rows.length - 1][rows[rows.length - 1].length - 1];
    return !(0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, lastDay) ? rows : rows.slice(0, -1);
}
function $d89aef5eb57c603c$export$fc40e2850257b7d1(date, firstDayOfWeek) {
    const rows = (0, $b70e16aabf990ae1$export$8f3e2263a6d57311)((0, $a8211859f65764ad$export$2e2bcd8739ae039)(date, 1), {
        firstDayOfWeek: firstDayOfWeek
    });
    const firstDay = rows[0][0];
    return !(0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, firstDay) ? rows : rows.slice(1);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $ed2afbcacc9e5a85$export$31e6abbf76343621(regionCode, regionDayMap) {
    var code = regionDayMap[typeof regionCode === 'string' ? regionCode.toUpperCase() : regionCode];
    return typeof code === 'number' ? code : 1;
}
function $ed2afbcacc9e5a85$export$ea33a5988b1820a3(locale, langRegionMap, regionDayMap) {
    if (locale) {
        var data = locale.toLowerCase().split(/[-_]/);
        var language = data[0];
        var country;
        if (data[1] && data[1].length === 4) {
            language += "_" + data[1];
            country = data[2];
        } else country = data[1];
        if (!country) country = langRegionMap[language];
        if (country) return $ed2afbcacc9e5a85$export$31e6abbf76343621(country.match(/^\d+$/) ? Number(country) : country, regionDayMap);
    }
    return 1;
}


var $40d21ee6d3ef8dc5$var$langRegionMap = {
    en: 'US',
    zh: 'CN',
    zh_hans: 'CN',
    hans: 'CN',
    wuu: 'CN',
    hsn: 'CN',
    hak: 'CN',
    nan: 'CN',
    gan: 'CN',
    hi: 'IN',
    te: 'IN',
    mr: 'IN',
    ta: 'IN',
    gu: 'IN',
    kn: 'IN',
    or: 'IN',
    ml: 'IN',
    pa_guru: 'IN',
    bho: 'IN',
    awa: 'IN',
    as: 'IN',
    mwr: 'IN',
    mai: 'IN',
    mag: 'IN',
    bgc: 'IN',
    hne: 'IN',
    dcc: 'IN',
    dz: 'BT',
    tn: 'BW',
    am: 'ET',
    om: 'ET',
    quc: 'GT',
    id: 'ID',
    jv: 'ID',
    su: 'ID',
    mad: 'ID',
    ms_arab: 'ID',
    ga: 'IE',
    he: 'IL',
    jam: 'JM',
    ja: 'JP',
    km: 'KH',
    ko: 'KR',
    lo: 'LA',
    mh: 'MH',
    my: 'MM',
    mt: 'MT',
    ne: 'NP',
    fil: 'PH',
    ceb: 'PH',
    ilo: 'PH',
    ur: 'PK',
    pa: 'PK',
    pa_arab: 'PK',
    arab: 'PK',
    lah: 'PK',
    ps: 'PK',
    sd: 'PK',
    sd_arab: 'PK',
    skr: 'PK',
    gn: 'PY',
    th: 'TH',
    tts: 'TH',
    aeb: 'TN',
    zh_hant: 'TW',
    hant: 'TW',
    sm: 'WS',
    zu: 'ZA',
    sn: 'ZW',
    arq: 'DZ',
    ar: 'EG',
    arz: 'EG',
    fa: 'IR',
    az_arab: 'IR',
    ary: 'MA',
    bn: 'BD',
    rkt: 'BD',
    dv: 'MV'
};
var $40d21ee6d3ef8dc5$export$2e2bcd8739ae039 = $40d21ee6d3ef8dc5$var$langRegionMap;


var $3f551231987c5e40$var$regionDayMap = {
    AG: 0,
    ATG: 0,
    28: 0,
    AR: 0,
    ARG: 0,
    32: 0,
    AS: 0,
    ASM: 0,
    16: 0,
    AU: 0,
    AUS: 0,
    36: 0,
    BR: 0,
    BRA: 0,
    76: 0,
    BS: 0,
    BHS: 0,
    44: 0,
    BT: 0,
    BTN: 0,
    64: 0,
    BW: 0,
    BWA: 0,
    72: 0,
    BZ: 0,
    BLZ: 0,
    84: 0,
    CA: 0,
    CAN: 0,
    124: 0,
    CN: 0,
    CHN: 0,
    156: 0,
    CO: 0,
    COL: 0,
    170: 0,
    DM: 0,
    DMA: 0,
    212: 0,
    DO: 0,
    DOM: 0,
    214: 0,
    ET: 0,
    ETH: 0,
    231: 0,
    GT: 0,
    GTM: 0,
    320: 0,
    GU: 0,
    GUM: 0,
    316: 0,
    HK: 0,
    HKG: 0,
    344: 0,
    HN: 0,
    HND: 0,
    340: 0,
    ID: 0,
    IDN: 0,
    360: 0,
    IE: 0,
    IRL: 0,
    372: 0,
    IL: 0,
    ISR: 0,
    376: 0,
    IN: 0,
    IND: 0,
    356: 0,
    JM: 0,
    JAM: 0,
    388: 0,
    JP: 0,
    JPN: 0,
    392: 0,
    KE: 0,
    KEN: 0,
    404: 0,
    KH: 0,
    KHM: 0,
    116: 0,
    KR: 0,
    KOR: 0,
    410: 0,
    LA: 0,
    LA0: 0,
    418: 0,
    MH: 0,
    MHL: 0,
    584: 0,
    MM: 0,
    MMR: 0,
    104: 0,
    MO: 0,
    MAC: 0,
    446: 0,
    MT: 0,
    MLT: 0,
    470: 0,
    MX: 0,
    MEX: 0,
    484: 0,
    MZ: 0,
    MOZ: 0,
    508: 0,
    NI: 0,
    NIC: 0,
    558: 0,
    NP: 0,
    NPL: 0,
    524: 0,
    NZ: 0,
    NZL: 0,
    554: 0,
    PA: 0,
    PAN: 0,
    591: 0,
    PE: 0,
    PER: 0,
    604: 0,
    PH: 0,
    PHL: 0,
    608: 0,
    PK: 0,
    PAK: 0,
    586: 0,
    PR: 0,
    PRI: 0,
    630: 0,
    PY: 0,
    PRY: 0,
    600: 0,
    SA: 0,
    SAU: 0,
    682: 0,
    SG: 0,
    SGP: 0,
    702: 0,
    SV: 0,
    SLV: 0,
    222: 0,
    TH: 0,
    THA: 0,
    764: 0,
    TN: 0,
    TUN: 0,
    788: 0,
    TT: 0,
    TTO: 0,
    780: 0,
    TW: 0,
    TWN: 0,
    158: 0,
    UM: 0,
    UMI: 0,
    581: 0,
    US: 0,
    USA: 0,
    840: 0,
    VE: 0,
    VEN: 0,
    862: 0,
    VI: 0,
    VIR: 0,
    850: 0,
    WS: 0,
    WSM: 0,
    882: 0,
    YE: 0,
    YEM: 0,
    887: 0,
    ZA: 0,
    ZAF: 0,
    710: 0,
    ZW: 0,
    ZWE: 0,
    716: 0,
    AE: 6,
    ARE: 6,
    784: 6,
    AF: 6,
    AFG: 6,
    4: 6,
    BH: 6,
    BHR: 6,
    48: 6,
    DJ: 6,
    DJI: 6,
    262: 6,
    DZ: 6,
    DZA: 6,
    12: 6,
    EG: 6,
    EGY: 6,
    818: 6,
    IQ: 6,
    IRQ: 6,
    368: 6,
    IR: 6,
    IRN: 6,
    364: 6,
    JO: 6,
    JOR: 6,
    400: 6,
    KW: 6,
    KWT: 6,
    414: 6,
    LY: 6,
    LBY: 6,
    434: 6,
    MA: 6,
    MAR: 6,
    504: 6,
    OM: 6,
    OMN: 6,
    512: 6,
    QA: 6,
    QAT: 6,
    634: 6,
    SD: 6,
    SDN: 6,
    729: 6,
    SY: 6,
    SYR: 6,
    760: 6,
    BD: 5,
    BGD: 5,
    50: 5,
    MV: 5,
    MDV: 5,
    462: 5
};
var $3f551231987c5e40$export$2e2bcd8739ae039 = $3f551231987c5e40$var$regionDayMap;


function $f56c42fe50147334$export$31e6abbf76343621(regionCode) {
    return (0, $ed2afbcacc9e5a85$export$31e6abbf76343621)(regionCode, (0, $3f551231987c5e40$export$2e2bcd8739ae039));
}
function $f56c42fe50147334$export$ea33a5988b1820a3(locale) {
    return (0, $ed2afbcacc9e5a85$export$ea33a5988b1820a3)(locale, (0, $40d21ee6d3ef8dc5$export$2e2bcd8739ae039), (0, $3f551231987c5e40$export$2e2bcd8739ae039));
}


function $22a87fd332ba377b$export$7beb97a13d59670f(startOfWeek, locale) {
    return typeof startOfWeek === 'number' ? startOfWeek % 7 : (0, $f56c42fe50147334$export$ea33a5988b1820a3)(locale);
}


function $53e2d2a976979c1b$export$2e2bcd8739ae039({ baseDate: baseDate, granularity: granularity, locale: locale, startOfWeek: rawStartOfWeek }) {
    const isMonthPicker = granularity === 'month';
    const rows = (0, $acw62.useMemo)(()=>{
        if (isMonthPicker) return (0, $d89aef5eb57c603c$export$e86dac089c0dcd37)(baseDate);
        else {
            const startOfWeek = (0, $22a87fd332ba377b$export$7beb97a13d59670f)(rawStartOfWeek, locale);
            return (0, $d89aef5eb57c603c$export$3a9f029074dee897)(baseDate, {
                startOfWeek: startOfWeek,
                padDates: 'after'
            });
        }
    }, [
        baseDate,
        isMonthPicker,
        rawStartOfWeek,
        locale
    ]);
    return rows;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $b70eab54f49c2e79$export$4e2c663d01cf9786({ ariaLabel: ariaLabel, onChange: onChange }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        iconName: "angle-left",
        ariaLabel: ariaLabel,
        variant: "icon",
        onClick: ()=>onChange(-1),
        formAction: "none",
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-prev-btn']
    });
}
function $b70eab54f49c2e79$export$b62bfe3a46d1d8c8({ ariaLabel: ariaLabel, onChange: onChange }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        iconName: "angle-right",
        ariaLabel: ariaLabel,
        variant: "icon",
        onClick: ()=>onChange(1),
        formAction: "none",
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-next-btn']
    });
}



const $c58214b95df0f907$var$CalendarHeader = ({ formattedDate: formattedDate, onChange: onChange, previousLabel: previousLabel, nextLabel: nextLabel, headingId: headingId })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-header']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b70eab54f49c2e79$export$4e2c663d01cf9786), {
        ariaLabel: previousLabel,
        onChange: onChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-header-title'],
        id: headingId
    }, formattedDate), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b70eab54f49c2e79$export$b62bfe3a46d1d8c8), {
        ariaLabel: nextLabel,
        onChange: onChange
    }));
};
var $c58214b95df0f907$export$2e2bcd8739ae039 = $c58214b95df0f907$var$CalendarHeader;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $0c8f1e892bb01470$export$2e2bcd8739ae039({ granularity: granularity, locale: locale, i18nStrings: i18nStrings, previousMonthAriaLabel: previousMonthAriaLabel, nextMonthAriaLabel: nextMonthAriaLabel, todayAriaLabel: todayAriaLabel }) {
    var _a, _b, _c;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('calendar');
    const isMonthPicker = granularity === 'month';
    const previousButtonLabel = isMonthPicker ? i18n('i18nStrings.previousYearAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.previousYearAriaLabel) : i18n('previousMonthAriaLabel', (_a = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.previousMonthAriaLabel) !== null && _a !== void 0 ? _a : previousMonthAriaLabel);
    const nextButtonLabel = isMonthPicker ? i18n('i18nStrings.nextYearAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.nextYearAriaLabel) : i18n('nextMonthAriaLabel', (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.nextMonthAriaLabel) !== null && _b !== void 0 ? _b : nextMonthAriaLabel);
    const currentDateLabel = isMonthPicker ? i18n('i18nStrings.currentMonthAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.currentMonthAriaLabel) : i18n('todayAriaLabel', (_c = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.todayAriaLabel) !== null && _c !== void 0 ? _c : todayAriaLabel);
    const renderDate = (date)=>isMonthPicker ? date.toLocaleString(locale, {
            month: 'short'
        }) : date.getDate().toString();
    const renderDateAnnouncement = (date, isCurrentDate)=>{
        const formattedDate = isMonthPicker ? (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date) : (0, $a12d66404868ccd6$export$51d68b748655e933)(locale, date, 'short');
        if (isCurrentDate && currentDateLabel) return formattedDate + '. ' + currentDateLabel;
        return formattedDate;
    };
    const renderHeaderText = (date)=>isMonthPicker ? date.getFullYear().toString() : (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date);
    return {
        previousButtonLabel: previousButtonLabel,
        nextButtonLabel: nextButtonLabel,
        renderDate: renderDate,
        renderDateAnnouncement: renderDateAnnouncement,
        renderHeaderText: renderHeaderText
    };
}





function $e4c1f8123712086f$export$2e2bcd8739ae039({ value: value, locale: locale = '', startOfWeek: startOfWeek, isDateEnabled: isDateEnabled = ()=>true, dateDisabledReason: dateDisabledReason = ()=>'', ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, onChange: onChange, __internalRootRef: __internalRootRef, i18nStrings: i18nStrings, granularity: granularity = 'day', previousMonthAriaLabel: previousMonthAriaLabel, nextMonthAriaLabel: nextMonthAriaLabel, todayAriaLabel: todayAriaLabel, ...rest }) {
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)('Calendar', 'value', value, 'onChange', onChange);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const normalizedLocale = (0, $d3f825eb41b88093$export$dca0327c9b9c6498)('Calendar', locale);
    const gridWrapperRef = (0, $acw62.useRef)(null);
    const [focusedDate, setFocusedDate] = (0, $acw62.useState)(null);
    const valueDateCache = (0, $341652d1a063d149$export$56ec8876a3c0f013)();
    const focusedDateCache = (0, $341652d1a063d149$export$56ec8876a3c0f013)();
    // Set displayed date to value if defined or to current date otherwise.
    const parsedValue = value && value.length >= 4 ? (0, $baa585fc493d6e9d$export$6b862160d295c8e)(value) : null;
    const memoizedValue = parsedValue && !isNaN(parsedValue.getDate()) ? valueDateCache(parsedValue) : null;
    const defaultDisplayedDate = memoizedValue !== null && memoizedValue !== void 0 ? memoizedValue : new Date();
    const [displayedDate, setDisplayedDate] = (0, $acw62.useState)(defaultDisplayedDate);
    const headingId = (0, $013a2451794a45c0$exports.useUniqueId)('calendar-heading');
    const isMonthPicker = granularity === 'month';
    const isDateFocusable = (date)=>isDateEnabled(date) || !isDateEnabled(date) && !!dateDisabledReason(date);
    const baseDate = isMonthPicker ? (0, $d60a56c0ed82241c$export$126ba571a8444064)(displayedDate, isDateEnabled) : (0, $7d9f33c1c1097d4d$export$1fa92dcbdf32fb44)(displayedDate, isDateEnabled);
    const isSameDate = isMonthPicker ? (0, $8085a298e92e1718$export$2e2bcd8739ae039) : (0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039);
    const isSamePage = isMonthPicker ? (0, $09f87854553a6255$export$2e2bcd8739ae039) : (0, $8085a298e92e1718$export$2e2bcd8739ae039);
    const isCurrentPage = (date)=>isMonthPicker || (0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, baseDate);
    const { previousButtonLabel: previousButtonLabel, nextButtonLabel: nextButtonLabel, renderDate: renderDate, renderDateAnnouncement: renderDateAnnouncement, renderHeaderText: renderHeaderText } = (0, $0c8f1e892bb01470$export$2e2bcd8739ae039)({
        granularity: granularity,
        i18nStrings: i18nStrings,
        locale: normalizedLocale,
        previousMonthAriaLabel: previousMonthAriaLabel,
        nextMonthAriaLabel: nextMonthAriaLabel,
        todayAriaLabel: todayAriaLabel
    });
    const gridRows = (0, $53e2d2a976979c1b$export$2e2bcd8739ae039)({
        baseDate: baseDate,
        granularity: granularity,
        startOfWeek: startOfWeek,
        locale: normalizedLocale
    });
    // Update displayed date if value changes.
    (0, $acw62.useEffect)(()=>{
        if (memoizedValue) setDisplayedDate((prev)=>prev.getTime() !== memoizedValue.getTime() ? memoizedValue : prev);
    }, [
        memoizedValue
    ]);
    const selectFocusedDate = (selected, baseDate)=>{
        if (selected && isDateFocusable(selected) && isSamePage(selected, baseDate)) return selected;
        const today = new Date();
        if (isDateFocusable(today) && isSamePage(today, baseDate)) return today;
        if (isDateFocusable(baseDate)) return baseDate;
        return null;
    };
    const focusableDate = focusedDate || selectFocusedDate(memoizedValue, baseDate);
    const onHeaderChangePageHandler = (amount)=>{
        const movePage = isMonthPicker ? (0, $eb237db400049a40$export$2e2bcd8739ae039) : (0, $a8211859f65764ad$export$2e2bcd8739ae039);
        const newDate = movePage(baseDate, amount);
        onChangePageHandler(newDate);
    };
    const onChangePageHandler = (newDate)=>{
        setDisplayedDate(newDate);
        setFocusedDate(null);
    };
    const onGridFocusDateHandler = (date)=>{
        if (date) setFocusedDate(date ? focusedDateCache(date) : null);
    };
    const onGridSelectDateHandler = (date)=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: (0, $b7857ad8c9833aee$export$3ae94a2503e890a1)(date, granularity)
        });
        setFocusedDate(null);
    };
    const onGridBlur = (event)=>{
        var _a;
        const newFocusTargetIsInGrid = event.relatedTarget && ((_a = gridWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget));
        if (!newFocusTargetIsInGrid) setFocusedDate(null);
    };
    const onGridKeyDownHandler = (0, $c9a1e01e2f915c47$export$2e2bcd8739ae039)({
        baseDate: baseDate,
        focusableDate: focusableDate,
        granularity: granularity,
        isDateEnabled: isDateEnabled,
        isDateFocusable: isDateFocusable,
        onChangePage: onChangePageHandler,
        onFocusDate: onGridFocusDateHandler,
        onSelectDate: onGridSelectDateHandler
    });
    const headerText = renderHeaderText(baseDate);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: __internalRootRef,
        ...baseProps,
        role: "group",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039).root, (0, $b10423781dc3537f$export$2e2bcd8739ae039).calendar, baseProps.className)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)['calendar-inner']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c58214b95df0f907$export$2e2bcd8739ae039), {
        formattedDate: headerText,
        onChange: onHeaderChangePageHandler,
        previousLabel: previousButtonLabel,
        nextLabel: nextButtonLabel,
        headingId: headingId
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onBlur: onGridBlur,
        ref: gridWrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b0a3f0e4ff8ed2c9$export$2e2bcd8739ae039), {
        isDateEnabled: isDateEnabled,
        dateDisabledReason: dateDisabledReason,
        focusedDate: focusedDate,
        focusableDate: focusableDate,
        onSelectDate: onGridSelectDateHandler,
        onFocusDate: onGridFocusDateHandler,
        onChangePage: onChangePageHandler,
        selectedDate: memoizedValue,
        ariaLabelledby: headingId,
        header: isMonthPicker ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4f6cc9bbab9bd77$export$2e2bcd8739ae039), {
            locale: normalizedLocale,
            rows: gridRows
        }),
        rows: gridRows,
        isCurrentPage: isCurrentPage,
        renderDate: renderDate,
        renderDateAnnouncement: renderDateAnnouncement,
        isSameDate: isSameDate,
        onGridKeyDownHandler: onGridKeyDownHandler
    }))));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








/**
 * Handles character removal
 *
 * @param initialValue Current value of input
 * @param format MaskFormat object
 * @param selectionStart Starting index value of selection cursor
 * @param selectionEnd Ending Index value of selection cursor
 */ const $9bd94e88f6352be2$export$8245067361b70905 = (initialValue, format, selectionStart, selectionEnd)=>{
    const multiCharDelete = selectionStart !== selectionEnd;
    if (multiCharDelete) {
        const isCursorAtEnd = selectionEnd === initialValue.length;
        if (!isCursorAtEnd) return format.replaceDigitsWithZeroes(initialValue, selectionStart, selectionEnd);
        return {
            value: initialValue.slice(0, selectionStart),
            position: selectionStart
        };
    }
    const isSeparator = format.isSegmentStart(selectionStart);
    const atEnd = selectionStart === initialValue.length;
    if (!atEnd) {
        if (isSeparator) return format.deleteSeparator(initialValue, selectionStart);
        else return format.deleteDigit(initialValue, selectionStart);
    }
    if (isSeparator) return {
        value: initialValue.slice(0, selectionStart - 2),
        position: selectionStart - 2
    };
    return {
        value: initialValue.slice(0, selectionStart - 1),
        position: selectionStart - 1
    };
};
const $9bd94e88f6352be2$export$53be3f01be2e49ac = (initialValue, key, format, selectionStart, selectionEnd)=>{
    let value = initialValue;
    const position = selectionStart;
    // return if no more digits can be added at the end
    if (selectionStart === value.length && value.length === format.getMaxLength()) return {
        value: value,
        position: position
    };
    // if range is selected to the end, remove all of that selection first
    if (selectionStart !== value.length && selectionEnd === value.length) {
        const sliceEnd = format.isCursorAtSeparator(selectionStart) ? selectionStart + 1 : selectionStart;
        value = initialValue.slice(0, sliceEnd);
    }
    if (format.isCursorAtSeparator(position)) return {
        value: value,
        position: position + 1
    };
    return format.processKey(value, key, position);
};
const $9bd94e88f6352be2$export$606c1792086c85f2 = (value, format)=>{
    // Do not autocomplete if input is empty
    if (!value) return {
        value: '',
        position: 0
    };
    const autoCompletedValue = format.autoComplete(value);
    const position = autoCompletedValue.length;
    return {
        value: autoCompletedValue,
        position: position
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $d19e2b7d7c7cc806$var$isSpecialCommand = (keyCode)=>{
    return keyCode > 7 && keyCode < 47 && keyCode !== (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space;
};
const $d19e2b7d7c7cc806$var$isClipboardCommand = (ctrlKey, metaKey)=>ctrlKey || metaKey;
const $d19e2b7d7c7cc806$export$43de6be2c393a8bd = (keyCode, ctrlKey, metaKey)=>$d19e2b7d7c7cc806$var$isSpecialCommand(keyCode) || $d19e2b7d7c7cc806$var$isClipboardCommand(ctrlKey, metaKey);
const $d19e2b7d7c7cc806$export$727d9dbc4fbb948f = (char)=>!isNaN(parseInt(char, 10));


const $056b1715a7436e30$var$onAutoComplete = (value, onChange, maskFormat)=>{
    // Do not autocomplete if input is empty
    if (!value) return;
    const autoCompletedValue = maskFormat.autoComplete(value);
    if (autoCompletedValue !== value) onChange(autoCompletedValue);
};
const $056b1715a7436e30$var$preventDefault = (event, result)=>result && event.preventDefault();
const $056b1715a7436e30$var$useMask = ({ value: value = '', onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, format: format, inputRef: inputRef, autofix: autofix = false, disableAutocompleteOnBlur: disableAutocompleteOnBlur = false, setPosition: setPosition, showUnmaskedValue: showUnmaskedValue = false })=>{
    if (!format.isValid(value) && !showUnmaskedValue) (0, $013a2451794a45c0$exports.warnOnce)('useMask', `Invalid string "${value}" provided`);
    const onMaskChange = (updatedValue)=>{
        const autofixedUpdatedValue = autofix ? format.correctMinMaxValues(updatedValue) : updatedValue;
        if (autofixedUpdatedValue === value || !format.isValid(autofixedUpdatedValue)) return;
        onChange(autofixedUpdatedValue);
    };
    const initialValue = autofix ? format.correctMinMaxValues(value) : value;
    const maskedValue = format.getValidValue(initialValue);
    return {
        value: maskedValue,
        onKeyDown: (event)=>{
            var _a, _b;
            const selectionStart = ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0;
            const selectionEnd = ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.selectionEnd) || 0;
            let result;
            const { keyCode: keyCode, key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event.detail;
            if ((0, $d19e2b7d7c7cc806$export$727d9dbc4fbb948f)(key) || format.isSeparator(key)) {
                result = (0, $9bd94e88f6352be2$export$53be3f01be2e49ac)(maskedValue, key, format, selectionStart, selectionEnd);
                $056b1715a7436e30$var$preventDefault(event, result);
            } else if (keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).backspace) {
                result = (0, $9bd94e88f6352be2$export$8245067361b70905)(maskedValue, format, selectionStart, selectionEnd);
                $056b1715a7436e30$var$preventDefault(event, result);
            } else if (keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter) result = (0, $9bd94e88f6352be2$export$606c1792086c85f2)(maskedValue, format);
            else if (!(0, $d19e2b7d7c7cc806$export$43de6be2c393a8bd)(keyCode, ctrlKey, metaKey)) event.preventDefault();
            if (result) {
                const { value: value, position: position } = result;
                onMaskChange(value);
                setPosition(position);
            }
            // Proxy original event
            onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
        },
        onChange: ({ detail: detail })=>onMaskChange(detail.value),
        onBlur: ()=>{
            if (!disableAutocompleteOnBlur) $056b1715a7436e30$var$onAutoComplete(maskedValue, onChange, format);
            onBlur === null || onBlur === void 0 || onBlur();
        },
        onPaste: (event)=>{
            var _a, _b;
            if (event.clipboardData) {
                const text = event.clipboardData.getData('text');
                const selectionStart = ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0;
                const selectionEnd = ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.selectionEnd) || 0;
                const formattedText = format.formatPastedText(text, maskedValue, selectionStart, selectionEnd);
                onMaskChange(formattedText);
            }
        }
    };
};
var $056b1715a7436e30$export$2e2bcd8739ae039 = $056b1715a7436e30$var$useMask;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $96cd96a8ce7962d6$export$9f200c4466975173 = (text, toInsert, start, end = start)=>text.slice(0, start) + toInsert + text.slice(end);


class $1277ba0d73502361$var$MaskFormat {
    constructor({ separator: separator, inputSeparators: inputSeparators = [], segments: segments }){
        this.positionFormats = new Map();
        this.segments = [];
        this.separator = separator;
        this.inputSeparators = [
            ...inputSeparators,
            separator
        ];
        this.enrichSegmentDefinitions(segments);
    }
    tryAppendSeparator(value) {
        const withSeparator = `${value}${this.separator}`;
        return this.isValid(withSeparator) ? withSeparator : value;
    }
    isSeparator(key) {
        return this.inputSeparators.indexOf(key) !== -1;
    }
    isValid(value) {
        // No inputSeparators will be present as they are replaced with the separator prior.
        const inputSegments = value.split(this.separator);
        if (inputSegments.length > this.segments.length) return false;
        return inputSegments.every((segmentValue, i)=>{
            const segment = this.segments[i];
            // Disallow empty segments
            if (segmentValue === '') {
                // except empty last segment (e.g. trailing separator "12:").
                if (i === inputSegments.length - 1) return true;
                else return false;
            }
            // Only allow numerals.
            if (!segmentValue.match(/^\d+$/)) return false;
            // Disallow incomplete segments, except at end.
            if (segmentValue.length < segment.length && i !== inputSegments.length - 1) return false;
            // Limit numerical value.
            const intValue = parseInt(segmentValue, 10);
            // Handle values padded with 0s that are lost during parsing.
            if (segmentValue.length > segment.length) return false;
            if (intValue < segment.min || intValue > segment.max(value)) {
                // Allow incomplete segments in final position.
                if (i === inputSegments.length - 1 && segmentValue.length < segment.length) return true;
                return false;
            }
            return true;
        });
    }
    getValidValue(value) {
        let validValue = value;
        do {
            if (this.isValid(validValue)) return this.tryAppendSeparator(validValue);
            validValue = validValue.substring(0, validValue.length - 1);
        }while (validValue.length > 0);
        return '';
    }
    autoComplete(value) {
        const [lastSegmentValue, ...completeSegmentValues] = value.split(this.separator).reverse();
        const lastSegment = this.segments[completeSegmentValues.length];
        // If the last segment isn't complete, pad it with a preceding 0,
        // e.g. 10:1 -> 10:01.
        const paddedLastSegmentValue = this.padWithDefaultValue(lastSegmentValue, lastSegment);
        // Recombine, and pad with extra segments for the full format.
        const partial = [
            ...completeSegmentValues.reverse(),
            paddedLastSegmentValue
        ];
        while(partial.length < this.segments.length){
            const nextSegment = this.segments[partial.length];
            const segmentValue = this.padWithDefaultValue('', nextSegment);
            partial.push(segmentValue);
        }
        value = partial.join(this.separator);
        value = this.correctMinMaxValues(value);
        return value;
    }
    getSegmentValueWithAddition(position, value, enteredDigit) {
        const segment = this.positionFormats.get(position);
        const segmentValue = value.substr(segment.start, segment.length);
        const segmentPosition = position - segment.start;
        const newValue = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(segmentValue, enteredDigit, segmentPosition, segmentPosition + 1);
        return parseInt(newValue, 10);
    }
    replaceDigitsWithZeroes(value, cursorStart, cursorEnd) {
        const position = this.isCursorAtSeparator(cursorStart) ? cursorStart + 1 : cursorStart;
        // Move selection forwards if it starts with a separator.
        if (this.isCursorAtSeparator(cursorStart)) cursorStart++;
        // First, insert zeros in a partial segment at beginning of selection.
        if (!this.isSegmentStart(cursorStart)) {
            const segment = this.positionFormats.get(cursorStart);
            value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)('', segment.end - cursorStart), cursorStart, segment.end);
            cursorStart = segment.end + 1;
        }
        // Then, loop through remaining segments, filling with zeros.
        let currentSegment;
        while(cursorStart < cursorEnd && (currentSegment = this.positionFormats.get(cursorStart + 1))){
            const insertionEnd = Math.min(cursorEnd, currentSegment.end);
            value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)('', insertionEnd - currentSegment.start), currentSegment.start, insertionEnd);
            cursorStart = insertionEnd + 1;
        }
        value = this.correctMinMaxValues(value);
        return {
            value: value,
            position: position
        };
    }
    handleSeparatorInput(value, position) {
        if (position === value.length && !this.isSegmentStart(position)) {
            const segment = this.positionFormats.get(position);
            let segmentValue = value.substr(segment.start, segment.length);
            segmentValue = this.padWithDefaultValue(segmentValue, segment);
            value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentValue, segment.start, segment.end);
            value = this.correctMinMaxValues(value);
            return {
                value: value,
                position: value.length
            };
        }
    }
    isCursorAtSeparator(position) {
        return 0 < position && position < this.getMaxLength() && this.positionFormats.get(position) === undefined;
    }
    isSegmentStart(position) {
        return position === 0 || this.isCursorAtSeparator(position - 1);
    }
    getSegmentMaxValue(value, position) {
        return this.positionFormats.get(position).max(value);
    }
    getSegmentMinValue(value, position) {
        return this.positionFormats.get(position).min;
    }
    getMaxLength() {
        const last = this.segments[this.segments.length - 1];
        return last.start + last.length;
    }
    deleteSeparator(value, position) {
        value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, '0', position - 2, position - 1);
        return {
            value: this.correctMinMaxValues(value),
            position: position - 2
        };
    }
    deleteDigit(value, position) {
        value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, '0', position - 1, position);
        // 23:59|: => backspace => 23:5|
        const length = value.length;
        if (value.slice(length - 2) === '0:') value = value.slice(0, length - 2);
        return {
            value: this.correctMinMaxValues(value),
            position: position - 1
        };
    }
    correctMinMaxValues(value) {
        let segment = this.positionFormats.get(0);
        while(segment && value.length >= segment.end){
            const segmentValue = parseInt(value.substr(segment.start, segment.length), 10);
            const segmentMax = segment.max(value);
            if (segmentValue < segment.min) {
                let toInsert = segment.min.toFixed();
                toInsert = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(toInsert, segment.length);
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, toInsert, segment.start, segment.end);
            }
            if (segmentValue > segmentMax) value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMax.toFixed(), segment.start, segment.end);
            segment = this.positionFormats.get(segment.end + 1);
        }
        return value.substr(0, this.segments[this.segments.length - 1].end);
    }
    formatPastedText(text, value, cursorStart, cursorEnd) {
        const keyArr = text.trim().split('');
        let position = cursorStart;
        let formattedValue = value;
        // If a selection range captures the end of the current value,
        // we replace it with the value in buffer even if the value in buffer is shorter.
        if (cursorEnd > cursorStart && cursorEnd === value.length) formattedValue = value.slice(0, cursorStart);
        for (const key of keyArr){
            if (position >= this.getMaxLength()) break;
            const result = this.processKey(formattedValue, key, position);
            formattedValue = result.value;
            position = result.position;
        }
        return this.tryAppendSeparator(formattedValue);
    }
    processKey(initialValue, key, initialPosition) {
        let value = initialValue;
        let position = initialPosition;
        if (this.isSeparator(key)) {
            const result = this.handleSeparatorInput(value, position);
            if (result) {
                value = result.value;
                position = result.position;
            }
        } else {
            const isCursorAtEnd = position === value.length;
            const segmentValue = this.getSegmentValueWithAddition(position, value, key);
            const segmentMaxValue = this.getSegmentMaxValue(value, position);
            const segmentMinValue = this.getSegmentMinValue(value, position);
            const firstDigitGreater = parseInt(key, 10) > parseInt(segmentMaxValue.toFixed()[0], 10);
            const isValidPosition = isCursorAtEnd || segmentValue.toFixed().length === 1;
            const exceedsMaxAtSegmentStart = this.isSegmentStart(position) && isValidPosition && firstDigitGreater;
            if (exceedsMaxAtSegmentStart) {
                // 22:| => Enter '9' => 22:09|
                // |1 => Enter '9' => 09|
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, `0${key}`, position, position + 2);
                position += 2;
            } else if (segmentValue > segmentMaxValue && this.isSegmentStart(position)) {
                // 22:|22 => Enter '9' => 22:59|
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMaxValue.toFixed(), position, position + segmentMaxValue.toFixed().length);
                position += segmentMaxValue.toFixed().length;
            } else if (segmentValue > segmentMaxValue) {
                // 2|2:22 => Enter '9' => 23:|22
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMaxValue.toFixed(), position - 1, position + 1);
                position += 1;
            } else if (segmentValue < segmentMinValue && !this.isSegmentStart(position)) {
                // 0| => enter '0' => 01:
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMinValue.toFixed(), position, position + 1);
                position += 1;
            } else {
                // 22:| => Enter '5' => 23:5|
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, key, position, position + 1);
                position += 1;
            }
        }
        value = this.tryAppendSeparator(value);
        // Move cursor in front of separator if behind after overwriting a character.
        if (this.isCursorAtSeparator(position)) position++;
        return {
            value: value,
            position: position
        };
    }
    padWithDefaultValue(segmentValue, segment) {
        let defaultValue = (segment.default || segment.min).toFixed();
        defaultValue = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(defaultValue, segment.length);
        return (0, $96cd96a8ce7962d6$export$9f200c4466975173)(defaultValue, segmentValue, segment.length - segmentValue.length, segment.length);
    }
    enrichSegmentDefinitions(segments) {
        this.positionFormats = new Map();
        this.segments = [];
        let position = 0;
        for (const segment of segments){
            const max = segment.max;
            const fullSegment = {
                ...segment,
                max: typeof max === 'number' ? ()=>max : max,
                start: position,
                end: position + segment.length
            };
            this.segments.push(fullSegment);
            // Insert this format segment for every char in the max value.
            for(let j = 0; j < fullSegment.length; j++)this.positionFormats.set(position++, fullSegment);
            // Skip a position for separator.
            position++;
        }
    }
}
var $1277ba0d73502361$export$2e2bcd8739ae039 = $1277ba0d73502361$var$MaskFormat;


const $f7cca821612459be$var$MaskedInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, mask: mask, autofix: autofix = false, disableAutocompleteOnBlur: disableAutocompleteOnBlur = false, showUnmaskedValue: showUnmaskedValue = false, nativeInputAttributes: nativeInputAttributes, ...rest }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [cursorPosition, setCursorPosition] = (0, $acw62.useState)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        if (cursorPosition !== null) (_a = inputRef.current) === null || _a === void 0 || _a.setSelectionRange(cursorPosition, cursorPosition);
    }, [
        cursorPosition,
        inputRef
    ]);
    const { onPaste: onPaste, ...maskProps } = (0, $056b1715a7436e30$export$2e2bcd8739ae039)({
        format: new (0, $1277ba0d73502361$export$2e2bcd8739ae039)(mask),
        value: value,
        inputRef: inputRef,
        autofix: autofix,
        disableAutocompleteOnBlur: disableAutocompleteOnBlur,
        onChange: (value)=>!rest.readOnly && (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: value
            }),
        onKeyDown: (event)=>!rest.readOnly && onKeyDown && (0, $fc537b925f715587$export$d7e1721720edbb03)(onKeyDown, event.detail, event),
        onBlur: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur),
        setPosition: setCursorPosition,
        showUnmaskedValue: showUnmaskedValue
    });
    const inputProps = {
        ...rest,
        ...baseProps,
        ...formFieldContext,
        ...maskProps,
        value: showUnmaskedValue ? value : maskProps.value
    };
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(ref, inputRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), {
        ...inputProps,
        ref: mergedRef,
        nativeInputAttributes: (0, $c4349d15e19ce67a$export$914c7e68e6e8031e)({
            onPaste: onPaste
        }, nativeInputAttributes, 'MaskedInput')
    });
});
var $f7cca821612459be$export$2e2bcd8739ae039 = $f7cca821612459be$var$MaskedInput;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts ISO date to display format, e.g. 2020-01-01 -> 2020/01/01.
 */ function $d58710628af8846a$export$aa53871afc5b25e6(value) {
    return value.replace(/-/g, '/');
}
function $d58710628af8846a$export$763ac7e5df87a34a(value) {
    return value.replace(/\//g, '-');
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}





function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}





function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(date).getTime() - (0, $4e98b4d5a2488885$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}







var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}


function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options).getTime() - (0, $5b38b39a484f4993$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}



function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;


var $d91e238bf521c720$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $dbfee7256f9ba04c$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;


var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;


function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $b99de2b03d4f39be$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;


var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;


function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $9567ced935a3b497$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;


function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $56621c36efca199b$export$2e2bcd8739ae039)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: 'en-US',
    formatDistance: (0, $1c4e78b8ee7f66d8$export$2e2bcd8739ae039),
    formatLong: (0, $b99de2b03d4f39be$export$2e2bcd8739ae039),
    formatRelative: (0, $117705cf2af2348d$export$2e2bcd8739ae039),
    localize: (0, $9567ced935a3b497$export$2e2bcd8739ae039),
    match: (0, $219397ebd8b56b11$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;


var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $0ca880ce53ce49f9$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $98e3d5324cb7d94c$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $d91e238bf521c720$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a5375092e28b891e$export$c6cc36aa33304772)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4faa9cd956e257dc$export$dfd9b671c89acc8e = 7;
var $4faa9cd956e257dc$export$3913210603d8e9ae = 365.2425;
var $4faa9cd956e257dc$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4faa9cd956e257dc$export$91246f0b9bd9beff = 60000;
var $4faa9cd956e257dc$export$7f72910d6dfd237a = 3600000;
var $4faa9cd956e257dc$export$397c2d5776aa9055 = 1000;
var $4faa9cd956e257dc$export$4dec998e48f9c246 = -$4faa9cd956e257dc$export$81caae6e1cc7a622;
var $4faa9cd956e257dc$export$f2f5ae5a8e2d8f9f = 60;
var $4faa9cd956e257dc$export$3c58128db900d44e = 3;
var $4faa9cd956e257dc$export$80d7e435f744f319 = 12;
var $4faa9cd956e257dc$export$4db7641526e3241f = 4;
var $4faa9cd956e257dc$export$698aec755e92c695 = 3600;
var $4faa9cd956e257dc$export$a77c1a7ebebe2a5a = 60;
var $4faa9cd956e257dc$export$815a9362476d2fe3 = $4faa9cd956e257dc$export$698aec755e92c695 * 24;
var $4faa9cd956e257dc$export$34804a017b31e2fe = $4faa9cd956e257dc$export$815a9362476d2fe3 * 7;
var $4faa9cd956e257dc$export$7271e9e3478110d1 = $4faa9cd956e257dc$export$815a9362476d2fe3 * $4faa9cd956e257dc$export$3913210603d8e9ae;
var $4faa9cd956e257dc$export$8e6600bbdee7dabb = $4faa9cd956e257dc$export$7271e9e3478110d1 / 12;
var $4faa9cd956e257dc$export$be1dccf2de902d31 = $4faa9cd956e257dc$export$8e6600bbdee7dabb * 3;




function $9c2d1611e11d9224$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9c2d1611e11d9224$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9c2d1611e11d9224$var$parseYear(dateStrings.date, additionalDigits);
        date = $9c2d1611e11d9224$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9c2d1611e11d9224$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9c2d1611e11d9224$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9c2d1611e11d9224$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9c2d1611e11d9224$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9c2d1611e11d9224$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9c2d1611e11d9224$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9c2d1611e11d9224$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9c2d1611e11d9224$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9c2d1611e11d9224$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9c2d1611e11d9224$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9c2d1611e11d9224$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9c2d1611e11d9224$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9c2d1611e11d9224$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9c2d1611e11d9224$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9c2d1611e11d9224$var$parseDateUnit(captures[1]);
    var month = $9c2d1611e11d9224$var$parseDateUnit(captures[2]) - 1;
    var day = $9c2d1611e11d9224$var$parseDateUnit(captures[3]);
    var week = $9c2d1611e11d9224$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9c2d1611e11d9224$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9c2d1611e11d9224$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9c2d1611e11d9224$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9c2d1611e11d9224$var$validateDate(year, month, day) || !$9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9c2d1611e11d9224$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9c2d1611e11d9224$var$parseTime(timeString) {
    var captures = timeString.match($9c2d1611e11d9224$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9c2d1611e11d9224$var$parseTimeUnit(captures[1]);
    var minutes = $9c2d1611e11d9224$var$parseTimeUnit(captures[2]);
    var seconds = $9c2d1611e11d9224$var$parseTimeUnit(captures[3]);
    if (!$9c2d1611e11d9224$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $4faa9cd956e257dc$export$7f72910d6dfd237a) + minutes * (0, $4faa9cd956e257dc$export$91246f0b9bd9beff) + seconds * 1000;
}
function $9c2d1611e11d9224$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9c2d1611e11d9224$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9c2d1611e11d9224$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9c2d1611e11d9224$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $4faa9cd956e257dc$export$7f72910d6dfd237a) + minutes * (0, $4faa9cd956e257dc$export$91246f0b9bd9beff));
}
function $9c2d1611e11d9224$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9c2d1611e11d9224$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9c2d1611e11d9224$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9c2d1611e11d9224$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9c2d1611e11d9224$var$daysInMonths[month] || ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9c2d1611e11d9224$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9c2d1611e11d9224$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9c2d1611e11d9224$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $a91c18b43f51bd2f$export$2473c1b41d520c07(isoDate, offsetInMinutes) {
    offsetInMinutes = $a91c18b43f51bd2f$var$defaultToLocal(isoDate, offsetInMinutes);
    const { hours: hours, minutes: minutes } = $a91c18b43f51bd2f$var$getMinutesAndHours(offsetInMinutes);
    const sign = offsetInMinutes < 0 ? '-' : '+';
    const formattedOffset = `${sign}${$a91c18b43f51bd2f$var$formatISO2Digits(hours)}:${$a91c18b43f51bd2f$var$formatISO2Digits(minutes)}`;
    return formattedOffset;
}
function $a91c18b43f51bd2f$export$2db27ac5fed3c521(isoDate, offsetInMinutes) {
    offsetInMinutes = $a91c18b43f51bd2f$var$defaultToLocal(isoDate, offsetInMinutes);
    if (offsetInMinutes === 0) return 'Z';
    const { hours: hours, minutes: minutes } = $a91c18b43f51bd2f$var$getMinutesAndHours(offsetInMinutes);
    const sign = offsetInMinutes < 0 ? '-' : '+';
    const formattedOffset = `${sign}${$a91c18b43f51bd2f$var$formatISO2Digits(hours)}:${$a91c18b43f51bd2f$var$formatISO2Digits(minutes)}`;
    return formattedOffset;
}
function $a91c18b43f51bd2f$export$7d74c9337bd1b54b(isoDate, offsetInMinutes) {
    offsetInMinutes = $a91c18b43f51bd2f$var$defaultToLocal(isoDate, offsetInMinutes);
    if (offsetInMinutes === 0) return '(UTC)';
    const { hours: hours, minutes: minutes } = $a91c18b43f51bd2f$var$getMinutesAndHours(offsetInMinutes);
    const sign = offsetInMinutes < 0 ? '-' : '+';
    const formattedMinutes = minutes === 0 ? '' : `:${minutes}`;
    const formattedOffset = `(UTC${sign}${hours}${formattedMinutes})`;
    return formattedOffset;
}
function $a91c18b43f51bd2f$var$defaultToLocal(isoDate, offsetInMinutes) {
    return offsetInMinutes !== null && offsetInMinutes !== void 0 ? offsetInMinutes : 0 - new Date(isoDate).getTimezoneOffset();
}
function $a91c18b43f51bd2f$var$getMinutesAndHours(minutes) {
    return {
        hours: Math.floor(Math.abs(minutes) / 60),
        minutes: Math.abs(minutes % 60)
    };
}
function $a91c18b43f51bd2f$var$formatISO2Digits(n) {
    return (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(n.toFixed(0), 2);
}


function $6acaf4d815fbbaa4$export$2e2bcd8739ae039({ date: isoDate, hideTimeOffset: hideTimeOffset, isDateOnly: isDateOnly, timeOffset: timeOffset, isMonthOnly: isMonthOnly }) {
    const formattedOffset = hideTimeOffset || isDateOnly || isMonthOnly ? '' : (0, $a91c18b43f51bd2f$export$2db27ac5fed3c521)(isoDate, timeOffset);
    if (isMonthOnly) return (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)((0, $9c2d1611e11d9224$export$2e2bcd8739ae039)(isoDate), 'yyyy-MM');
    return isoDate + formattedOffset;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $0dad758c69228a4c$export$2e2bcd8739ae039({ date: isoDate, hideTimeOffset: hideTimeOffset, isDateOnly: isDateOnly, isMonthOnly: isMonthOnly, timeOffset: timeOffset, locale: locale }) {
    let date = (0, $9c2d1611e11d9224$export$2e2bcd8739ae039)(isoDate);
    // if the date is not ISO formatted, fallback to built-in date parsing
    if (!(0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(date)) date = new Date(isoDate);
    if (isMonthOnly) {
        const formattedMonthDate = new Intl.DateTimeFormat(locale, {
            month: 'long',
            year: 'numeric'
        }).format(date);
        return formattedMonthDate;
    }
    const formattedDate = new Intl.DateTimeFormat(locale, {
        month: 'long',
        year: 'numeric',
        day: 'numeric'
    }).format(date);
    if (isDateOnly) return formattedDate;
    const formattedTime = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        hourCycle: 'h23',
        minute: '2-digit',
        second: '2-digit'
    }).format(date);
    const formattedDateTime = formattedDate + $0dad758c69228a4c$var$getDateTimeSeparator(locale) + formattedTime;
    if (hideTimeOffset) return formattedDateTime;
    const formattedTimeOffset = (0, $a91c18b43f51bd2f$export$7d74c9337bd1b54b)(isoDate, timeOffset);
    return formattedDateTime + ' ' + formattedTimeOffset;
}
// Languages in which date and time are separated just with a space, without comma
const $0dad758c69228a4c$var$languagesWithoutDateTimeSeparator = [
    'ja',
    'zh-CN',
    'zh-TW'
];
function $0dad758c69228a4c$var$getDateTimeSeparator(locale) {
    return locale && $0dad758c69228a4c$var$languagesWithoutDateTimeSeparator.includes(locale) ? ' ' : ', ';
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $95706a37c0d7d1b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



const $82b347b9aae817e1$var$yearMask = {
    min: 0,
    max: 9999,
    default: 2000,
    length: 4
};
const $82b347b9aae817e1$var$monthMask = {
    min: 1,
    max: 12,
    length: 2
};
const $82b347b9aae817e1$var$dayMask = {
    min: 1,
    max: $82b347b9aae817e1$var$getMaxDaysForDate,
    length: 2
};
function $82b347b9aae817e1$var$getMaxDaysForDate(value) {
    // Forcing to first day in month to ensure the correct month is used in case the date is incorrect.
    // For example, the date '2018-02-30' is parsed as '2018-03-02' (because there is only 28 days in February 2018).
    const baseDate = (0, $d58710628af8846a$export$763ac7e5df87a34a)(value).substring(0, 7);
    return (0, $95706a37c0d7d1b0$export$2e2bcd8739ae039)((0, $baa585fc493d6e9d$export$6b862160d295c8e)(baseDate));
}
const $82b347b9aae817e1$export$423cbaf9034788b1 = ({ granularity: granularity = 'day', isIso: /**
 * There are only two options, 'iso' and 'slashed' which is our current default format. If more formats are entered
 * we should take the formatting type rather than the boolean when we make an update.
 */ isIso = false } = {})=>{
    return {
        separator: isIso ? '-' : '/',
        inputSeparators: isIso ? [
            '/',
            '.',
            ' '
        ] : [
            '-',
            '.',
            ' '
        ],
        segments: granularity === 'month' ? [
            $82b347b9aae817e1$var$yearMask,
            $82b347b9aae817e1$var$monthMask
        ] : [
            $82b347b9aae817e1$var$yearMask,
            $82b347b9aae817e1$var$monthMask,
            $82b347b9aae817e1$var$dayMask
        ]
    };
};
function $82b347b9aae817e1$export$9fb49b4897335d6c(dateString, granularity) {
    if (!dateString) return '';
    const match = dateString.match(/^(\d{4})(?:-(\d{1,2})?)?(?:-(\d{1,2})?)?$/);
    if (!match) return '';
    const [, year, month, day] = match;
    if (granularity === 'day' && (month === null || month === void 0 ? void 0 : month.length) === 2 && (day === null || day === void 0 ? void 0 : day.length) === 2) return `${year}-${month}-${day}`;
    if ((month === null || month === void 0 ? void 0 : month.length) === 2) return `${year}-${month}`;
    return year;
}



var $5f022994dab408bc$export$2e2bcd8739ae039 = {
    "root": "awsui_root_yodkx_im8v7_5"
};


const $5054cd724d97a7f8$var$InternalDateInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, onChange: onChange, onBlur: onBlur, onFocus: onFocus, granularity: granularity = 'day', locale: locale, format: format = 'slashed', inputFormat: inputFormat = 'slashed', __internalRootRef: __internalRootRef, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata = false, ...props }, ref)=>{
    const [isFocused, setIsFocused] = (0, $acw62.useState)(false);
    const inputRef = (0, $acw62.useRef)(null);
    const isIso = format === 'iso' || format === 'long-localized' && inputFormat === 'iso';
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, inputRef);
    const onInputFocus = (event)=>{
        setIsFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(event);
    };
    const onInputBlur = (event)=>{
        setIsFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(event);
    };
    const onInputChange = (event)=>{
        const isNonFocusedLongLocalized = format === 'long-localized' && !(isFocused || props.readOnly);
        if (!isNonFocusedLongLocalized) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: (0, $d58710628af8846a$export$763ac7e5df87a34a)(event.detail.value)
        });
    };
    const usesLongLocalizedValue = format === 'long-localized' && !(isFocused && !props.readOnly);
    const displayedValue = (0, $acw62.useMemo)(()=>{
        if (!value) return '';
        const isoValue = (0, $d58710628af8846a$export$763ac7e5df87a34a)(value);
        const formatProps = {
            hideTimeOffset: true,
            isDateOnly: true,
            isMonthOnly: granularity === 'month',
            locale: locale
        };
        const normalizedValue = (0, $82b347b9aae817e1$export$9fb49b4897335d6c)(isoValue, granularity);
        return usesLongLocalizedValue && normalizedValue ? (0, $0dad758c69228a4c$export$2e2bcd8739ae039)({
            date: normalizedValue,
            ...formatProps
        }) : isIso ? (0, $6acaf4d815fbbaa4$export$2e2bcd8739ae039)({
            date: isoValue,
            ...formatProps
        }) : (0, $d58710628af8846a$export$aa53871afc5b25e6)(isoValue);
    }, [
        value,
        isIso,
        granularity,
        locale,
        usesLongLocalizedValue
    ]);
    const componentAnalyticsMetadata = {
        name: 'awsui.DateInput',
        label: 'input',
        properties: {
            value: value || ''
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7cca821612459be$export$2e2bcd8739ae039), {
        ref: inputRef,
        ...props,
        value: displayedValue,
        onChange: onInputChange,
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $5f022994dab408bc$export$2e2bcd8739ae039).root, props.className),
        mask: (0, $82b347b9aae817e1$export$423cbaf9034788b1)({
            granularity: granularity,
            isIso: isIso
        }),
        autofix: !usesLongLocalizedValue,
        disableAutocompleteOnBlur: false,
        disableBrowserAutocorrect: true,
        showUnmaskedValue: usesLongLocalizedValue,
        autoComplete: false,
        __internalRootRef: __internalRootRef,
        ...__injectAnalyticsComponentMetadata ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticsMetadata
        }) : {}
    });
});
var $5054cd724d97a7f8$export$2e2bcd8739ae039 = $5054cd724d97a7f8$var$InternalDateInput;










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

class $fc4c3d7c11f51903$export$2e2bcd8739ae039 {
    constructor(node, { onFocusEnter: onFocusEnter, onFocusLeave: onFocusLeave }){
        this.node = node;
        this.currentlyFocused = false;
        this.focusInListener = (event)=>{
            const focusIsInside = (0, $4c778684f125e678$export$57d4cb221e1d1857)(this.node, event.target);
            if (!this.currentlyFocused && focusIsInside) this.triggerFocus();
        };
        this.focusOutListener = (event)=>{
            const nextFocused = event.relatedTarget;
            const isNextFocusedInParent = !(0, $4c778684f125e678$export$57d4cb221e1d1857)(this.node, nextFocused);
            if (this.currentlyFocused && (nextFocused === null || isNextFocusedInParent)) this.triggerBlur();
        };
        this.onFocusEnter = onFocusEnter;
        this.onFocusLeave = onFocusLeave;
        this.controller = new AbortController();
    }
    initialize() {
        this.currentlyFocused = (0, $4c778684f125e678$export$57d4cb221e1d1857)(this.node, document.activeElement);
        document.addEventListener('focusin', this.focusInListener, {
            signal: this.controller.signal
        });
        document.addEventListener('focusout', this.focusOutListener, {
            signal: this.controller.signal
        });
    }
    destroy() {
        this.controller.abort();
    }
    triggerBlur() {
        this.currentlyFocused = false;
        this.onFocusLeave();
    }
    triggerFocus() {
        this.currentlyFocused = true;
        this.onFocusEnter();
    }
}


const $51561f9ae227347c$export$3369c53c6e376592 = ({ rootRef: rootRef, onBlur: onBlur, onFocus: onFocus })=>{
    const focusTracker = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!rootRef.current) return;
        focusTracker.current = new (0, $fc4c3d7c11f51903$export$2e2bcd8739ae039)(rootRef.current, {
            onFocusLeave: ()=>{
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur);
            },
            onFocusEnter: ()=>{
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus);
            }
        });
        focusTracker.current.initialize();
        return ()=>{
            var _a;
            (_a = focusTracker.current) === null || _a === void 0 || _a.destroy();
        };
    }, [
        rootRef,
        onBlur,
        onFocus
    ]);
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $2a75c3368373dbfd$export$a02eb350a92cd69({ date: date, granularity: granularity }) {
    const regex = granularity === 'month' ? /^\d{4}-\d{2}(-\d{2})?$/ : /^\d{4}-\d{2}-\d{2}$/;
    return !!date.match(regex);
}
function $2a75c3368373dbfd$export$fbaf8bc37fede21({ date: date, granularity: granularity, locale: locale }) {
    return granularity === 'month' ? (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date) : (0, $a12d66404868ccd6$export$51d68b748655e933)(locale, date);
}
function $2a75c3368373dbfd$export$a3a70c8ff09af2eb({ date: date, granularity: granularity, locale: locale }) {
    return granularity === 'month' ? (0, $a12d66404868ccd6$export$64ba10e8616b702f)(locale, date) : (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date);
}



var $e439776d2d025878$export$2e2bcd8739ae039 = {
    "root": "awsui_root_145pa_1qi9j_145",
    "focus-lock": "awsui_focus-lock_145pa_1qi9j_177",
    "calendar": "awsui_calendar_145pa_1qi9j_181",
    "date-picker-container": "awsui_date-picker-container_145pa_1qi9j_197",
    "date-picker-trigger": "awsui_date-picker-trigger_145pa_1qi9j_202",
    "date-picker-input": "awsui_date-picker-input_145pa_1qi9j_206",
    "open-calendar-button": "awsui_open-calendar-button_145pa_1qi9j_211"
};


'use client';
const $0fddd550297817b9$var$DatePicker = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ locale: locale, startOfWeek: startOfWeek, isDateEnabled: isDateEnabled, dateDisabledReason: dateDisabledReason, nextMonthAriaLabel: nextMonthAriaLabel, previousMonthAriaLabel: previousMonthAriaLabel, todayAriaLabel: todayAriaLabel, i18nStrings: i18nStrings, placeholder: placeholder = '', value: value = '', readOnly: readOnly = false, disabled: disabled = false, onBlur: onBlur, autoFocus: autoFocus = false, onChange: onChange, onFocus: onFocus, name: name, ariaLabel: ariaLabel, ariaRequired: ariaRequired, controlId: controlId, invalid: invalid, warning: warning, openCalendarAriaLabel: openCalendarAriaLabel, expandToViewport: expandToViewport, granularity: granularity = 'day', format: format = 'slashed', inputFormat: inputFormat = 'slashed', ...restProps }, ref)=>{
    var _a, _b, _c, _d;
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)('DatePicker', {
        props: {
            autoFocus: autoFocus,
            expandToViewport: expandToViewport,
            granularity: granularity,
            readOnly: readOnly
        },
        metadata: {
            hasDisabledReasons: Boolean(dateDisabledReason)
        }
    });
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)('DatePicker', 'value', value, 'onChange', onChange);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('date-picker');
    const contextLocale = (0, $4d65e7166b5544ac$export$43bb16f9c6d9e3f7)();
    const normalizedLocale = (0, $d3f825eb41b88093$export$dca0327c9b9c6498)('DatePicker', locale || contextLocale);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const [isDropDownOpen, setIsDropDownOpen] = (0, $acw62.useState)(false);
    const { ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const internalInputRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, internalInputRef);
    const rootRef = (0, $acw62.useRef)(null);
    const dropdownId = (0, $013a2451794a45c0$exports.useUniqueId)('calender');
    const calendarDescriptionId = (0, $013a2451794a45c0$exports.useUniqueId)('calendar-description-');
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(rootRef, __internalRootRef);
    (0, $51561f9ae227347c$export$3369c53c6e376592)({
        rootRef: rootRef,
        onBlur: onBlur,
        onFocus: onFocus
    });
    const onDropdownCloseHandler = (0, $acw62.useCallback)(()=>setIsDropDownOpen(false), [
        setIsDropDownOpen
    ]);
    const onButtonClickHandler = ()=>{
        if (!isDropDownOpen) setIsDropDownOpen(true);
    };
    const onWrapperKeyDownHandler = (event)=>{
        var _a;
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape && isDropDownOpen) {
            event.stopPropagation();
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
            setIsDropDownOpen(false);
        }
    };
    const onInputChangeHandler = (event)=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: event.detail.value
        });
    };
    const onInputBlurHandler = ()=>{
        if (!isDropDownOpen) setIsDropDownOpen(false);
    };
    // Set displayed date to value if defined or to current date otherwise.
    const parsedValue = value && value.length >= 4 ? (0, $baa585fc493d6e9d$export$6b862160d295c8e)(value) : null;
    const baseDate = parsedValue || new Date();
    const hasFullValue = (0, $2a75c3368373dbfd$export$a02eb350a92cd69)({
        date: value,
        granularity: granularity
    });
    const defaultOpenCalendarAriaLabel = i18n('i18nStrings.openCalendarAriaLabel', (_a = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.openCalendarAriaLabel) !== null && _a !== void 0 ? _a : openCalendarAriaLabel, (format)=>(selectedDate)=>format({
                selectedDate: selectedDate !== null && selectedDate !== void 0 ? selectedDate : 'none'
            }));
    const buttonAriaLabel = defaultOpenCalendarAriaLabel === null || defaultOpenCalendarAriaLabel === void 0 ? void 0 : defaultOpenCalendarAriaLabel(hasFullValue && parsedValue ? (0, $2a75c3368373dbfd$export$fbaf8bc37fede21)({
        date: parsedValue,
        granularity: granularity,
        locale: normalizedLocale
    }) : null);
    const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039)['date-picker-trigger']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039)['date-picker-input']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5054cd724d97a7f8$export$2e2bcd8739ae039), {
        name: name,
        invalid: invalid,
        warning: warning,
        controlId: controlId,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby,
        ariaLabel: ariaLabel,
        ariaRequired: ariaRequired,
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onChange: onInputChangeHandler,
        onBlur: onInputBlurHandler,
        placeholder: placeholder,
        ref: internalInputRef,
        autoFocus: autoFocus,
        onFocus: onDropdownCloseHandler,
        granularity: granularity,
        locale: locale,
        format: format,
        inputFormat: inputFormat
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        iconName: "calendar",
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039)['open-calendar-button'],
        onClick: onButtonClickHandler,
        ref: buttonRef,
        ariaLabel: buttonAriaLabel,
        disabled: disabled || readOnly,
        formAction: "none"
    })));
    baseProps.className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $e439776d2d025878$export$2e2bcd8739ae039).root, (0, $e439776d2d025878$export$2e2bcd8739ae039)['date-picker-container']);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: mergedRef,
        onKeyDown: !disabled && !readOnly ? onWrapperKeyDownHandler : undefined
    }, disabled || readOnly ? trigger : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        minWidth: "trigger",
        maxWidth: "trigger",
        stretchHeight: true,
        open: isDropDownOpen,
        onOutsideClick: onDropdownCloseHandler,
        trigger: trigger,
        expandToViewport: expandToViewport,
        scrollable: false,
        dropdownId: dropdownId,
        content: isDropDownOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
            className: (0, $e439776d2d025878$export$2e2bcd8739ae039)['focus-lock'],
            autoFocus: true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            tabIndex: 0,
            className: (0, $e439776d2d025878$export$2e2bcd8739ae039).calendar,
            role: "dialog"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4c1f8123712086f$export$2e2bcd8739ae039), {
            value: value,
            onChange: (e)=>{
                var _a;
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, e.detail);
                (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 || _a.focus();
                setIsDropDownOpen(false);
            },
            locale: normalizedLocale,
            startOfWeek: startOfWeek,
            ariaDescribedby: calendarDescriptionId,
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            granularity: granularity,
            isDateEnabled: isDateEnabled,
            dateDisabledReason: dateDisabledReason,
            i18nStrings: {
                ...i18nStrings,
                todayAriaLabel: (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.todayAriaLabel) !== null && _b !== void 0 ? _b : todayAriaLabel,
                nextMonthAriaLabel: (_c = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.nextMonthAriaLabel) !== null && _c !== void 0 ? _c : nextMonthAriaLabel,
                previousMonthAriaLabel: (_d = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.previousMonthAriaLabel) !== null && _d !== void 0 ? _d : previousMonthAriaLabel
            }
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
            id: calendarDescriptionId,
            hidden: true,
            tagName: "span"
        }, (0, $2a75c3368373dbfd$export$a3a70c8ff09af2eb)({
            date: baseDate,
            granularity: granularity,
            locale: normalizedLocale
        })))) : undefined
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($0fddd550297817b9$var$DatePicker, 'DatePicker');
var $0fddd550297817b9$export$2e2bcd8739ae039 = $0fddd550297817b9$var$DatePicker;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $05d97dd7d2fbe73d$export$2e2bcd8739ae039 = {
    "root": "awsui_root_ptw8i_wv87u_181",
    "hovered": "awsui_hovered_ptw8i_wv87u_194",
    "content": "awsui_content_ptw8i_wv87u_201"
};


function $f244de4f6b4db138$export$2e2bcd8739ae039({ onChange: onChange, children: children, __internalRootRef: __internalRootRef, ...restProps }) {
    const [isDropzoneHovered, setDropzoneHovered] = (0, $acw62.useState)(false);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const onDragOver = (event)=>{
        event.preventDefault();
        if (event.dataTransfer) {
            setDropzoneHovered(true);
            event.dataTransfer.dropEffect = 'copy';
        }
    };
    const onDragLeave = (event)=>{
        event.preventDefault();
        setDropzoneHovered(false);
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
    };
    const onDrop = (event)=>{
        event.preventDefault();
        setDropzoneHovered(false);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: Array.from(event.dataTransfer.files)
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $05d97dd7d2fbe73d$export$2e2bcd8739ae039).root, {
            [(0, $05d97dd7d2fbe73d$export$2e2bcd8739ae039).hovered]: isDropzoneHovered
        }),
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDrop: onDrop
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $05d97dd7d2fbe73d$export$2e2bcd8739ae039).content
    }, children));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $8e72b22b9066cfc1$export$3e5acc18bff877d4() {
    const [areFilesDragging, setFilesDragging] = (0, $acw62.useState)(false);
    // Registering global drag events listeners.
    (0, $acw62.useEffect)(()=>{
        // The timer helps avoiding dropzone blinking.
        let dragTimer = null;
        // The file-upload dropzone is shown when the user drags files over to the browser.
        const onDocumentDragOver = (event)=>{
            var _a, _b;
            event.preventDefault();
            let files = 0;
            for(let item = 0; item < (((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.length) || 0); item++)if (((_b = event.dataTransfer) === null || _b === void 0 ? void 0 : _b.types[item]) === 'Files') files++;
            if (files > 0) {
                setFilesDragging(true);
                if (dragTimer) clearTimeout(dragTimer);
            }
        };
        // When the files are no longer dragged over the browser the state must be reset.
        const onDocumentDragLeave = (event)=>{
            event.preventDefault();
            dragTimer = setTimeout(()=>setFilesDragging(false), 25);
        };
        // If the files were dropped the state must be reset.
        const onDocumentDrop = (event)=>{
            event.preventDefault();
            dragTimer = setTimeout(()=>setFilesDragging(false), 25);
        };
        const controller = new AbortController();
        document.addEventListener('dragover', onDocumentDragOver, {
            signal: controller.signal
        });
        document.addEventListener('dragleave', onDocumentDragLeave, {
            signal: controller.signal
        });
        document.addEventListener('drop', onDocumentDrop, {
            signal: controller.signal
        });
        return ()=>{
            if (dragTimer) clearTimeout(dragTimer);
            controller.abort();
        };
    }, []);
    return {
        areFilesDragging: areFilesDragging
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $d2fb1ae7ca5a8786$export$2e2bcd8739ae039 = {
    "root": "awsui_root_gfwv3_dimvd_193",
    "horizontal": "awsui_horizontal_gfwv3_dimvd_196",
    "vertical": "awsui_vertical_gfwv3_dimvd_202",
    "list": "awsui_list_gfwv3_dimvd_207",
    "grid": "awsui_grid_gfwv3_dimvd_226",
    "list-item": "awsui_list-item_gfwv3_dimvd_238",
    "toggle-container-inline": "awsui_toggle-container-inline_gfwv3_dimvd_245",
    "toggle": "awsui_toggle_gfwv3_dimvd_245",
    "description": "awsui_description_gfwv3_dimvd_337",
    "separator": "awsui_separator_gfwv3_dimvd_341"
};


function $32c25cc8bcb71de1$export$2e2bcd8739ae039({ controlId: controlId, allHidden: allHidden, expanded: expanded, numberOfHiddenOptions: numberOfHiddenOptions, onClick: onClick, i18nStrings: i18nStrings = {}, limitShowFewerAriaLabel: limitShowFewerAriaLabel, limitShowMoreAriaLabel: limitShowMoreAriaLabel }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('token-group');
    const numberOfHiddenOptionLabel = allHidden ? numberOfHiddenOptions : `+${numberOfHiddenOptions}`;
    const description = expanded ? i18n('i18nStrings.limitShowFewer', i18nStrings.limitShowFewer) : `${i18n('i18nStrings.limitShowMore', i18nStrings.limitShowMore) || ''} (${numberOfHiddenOptionLabel})`;
    const ariaLabel = expanded ? limitShowFewerAriaLabel : limitShowMoreAriaLabel;
    const handleClick = (0, $acw62.useCallback)(()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onClick, null);
    }, [
        onClick
    ]);
    const analyticsMetadata = {
        action: !expanded ? 'showMore' : 'showLess',
        detail: {
            label: {
                root: 'self'
            }
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).toggle,
        onClick: handleClick,
        "aria-controls": controlId,
        "aria-expanded": expanded,
        "aria-label": ariaLabel,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: expanded ? 'treeview-collapse' : 'treeview-expand'
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).description
    }, description));
}



function $1e34c3ccd4808258$export$2e2bcd8739ae039({ items: items, alignment: alignment, renderItem: renderItem, limit: limit, after: after, i18nStrings: i18nStrings, limitShowFewerAriaLabel: limitShowFewerAriaLabel, limitShowMoreAriaLabel: limitShowMoreAriaLabel, onExpandedClick: onExpandedClick = ()=>undefined }) {
    const controlId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const hasItems = items.length > 0;
    const hasHiddenItems = hasItems && limit !== undefined && items.length > limit;
    const visibleItems = hasHiddenItems && !expanded ? items.slice(0, limit) : items;
    const hasVisibleItems = visibleItems.length > 0;
    const toggle = hasHiddenItems ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)[`toggle-container-${alignment}`]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32c25cc8bcb71de1$export$2e2bcd8739ae039), {
        controlId: hasVisibleItems ? controlId : undefined,
        allHidden: limit === 0,
        expanded: expanded,
        numberOfHiddenOptions: items.length - visibleItems.length,
        i18nStrings: i18nStrings,
        limitShowFewerAriaLabel: limitShowFewerAriaLabel,
        limitShowMoreAriaLabel: limitShowMoreAriaLabel,
        onClick: ()=>{
            const isExpanded = !expanded;
            setExpanded(isExpanded);
            onExpandedClick(isExpanded);
        }
    })) : null;
    if (alignment === 'inline') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).root, (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).horizontal)
    }, hasItems && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: controlId,
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).list
    }, visibleItems.map((item, itemIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: itemIndex,
            className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)['list-item'],
            "aria-setsize": items.length,
            "aria-posinset": itemIndex + 1
        }, renderItem(item, itemIndex)))), toggle, after && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).separator
    }), after);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).root, (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).vertical)
    }, hasVisibleItems && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: controlId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).list, {
            [(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).vertical]: alignment === 'vertical',
            [(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).horizontal]: alignment === 'horizontal',
            [(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).grid]: alignment === 'horizontal-grid'
        })
    }, visibleItems.map((item, itemIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: itemIndex,
            className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)['list-item'],
            "aria-setsize": items.length,
            "aria-posinset": itemIndex + 1
        }, renderItem(item, itemIndex)))), toggle, after);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $b53452f0d99d5bc4$export$62f3f0e010c1e172({ nextFocusIndex: nextFocusIndex, onFocusMoved: onFocusMoved, listItemSelector: listItemSelector, fallbackSelector: fallbackSelector, showMoreSelector: showMoreSelector }) {
    const tokenListRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (nextFocusIndex === undefined || nextFocusIndex === null || tokenListRef.current === null) return;
        const tokenElements = tokenListRef.current.querySelectorAll(listItemSelector);
        const fallbackElement = fallbackSelector ? $b53452f0d99d5bc4$var$selectElement(tokenListRef.current, fallbackSelector) : null;
        const toggleButton = showMoreSelector ? $b53452f0d99d5bc4$var$selectElement(tokenListRef.current, showMoreSelector) : null;
        let closestPrevIndex = Number.NEGATIVE_INFINITY;
        let closestNextIndex = Number.POSITIVE_INFINITY;
        for(let activeIndex = 0; activeIndex < tokenElements.length; activeIndex++)if (activeIndex < nextFocusIndex) closestPrevIndex = nextFocusIndex - activeIndex < nextFocusIndex - closestPrevIndex ? activeIndex : closestPrevIndex;
        else closestNextIndex = activeIndex - nextFocusIndex < closestNextIndex - nextFocusIndex ? activeIndex : closestNextIndex;
        const nextElement = tokenElements[closestNextIndex];
        const prevElement = tokenElements[closestPrevIndex];
        const focusTarget = $b53452f0d99d5bc4$var$getFirstEligible({
            id: 'next',
            element: nextElement
        }, {
            id: 'prev',
            element: prevElement
        }, {
            id: 'show-more',
            element: toggleButton
        }, {
            id: 'fallback',
            element: fallbackElement
        });
        if (focusTarget) onFocusMoved(focusTarget.element, focusTarget.id);
    // Expecting onFocusMoved to be pure
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        nextFocusIndex,
        listItemSelector,
        fallbackSelector,
        showMoreSelector
    ]);
    return tokenListRef;
}
function $b53452f0d99d5bc4$var$getFirstEligible(...elements) {
    for (const { id: id, element: element } of elements){
        const focusable = element ? $b53452f0d99d5bc4$var$getFocusableElement(element) : null;
        if (focusable) return {
            id: id,
            element: focusable
        };
    }
    return null;
}
function $b53452f0d99d5bc4$var$getFocusableElement(element) {
    if (!(element instanceof HTMLElement)) return null;
    if ((0, $eaddf2de854ee801$export$4c063cf1350e6fed)(element)) return element;
    return (0, $eaddf2de854ee801$export$748138f04a69bf21)(element);
}
function $b53452f0d99d5bc4$var$selectElement(container, selector) {
    if (container.matches(selector)) return container;
    return container.querySelector(selector);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $c8fe48aa6495c25f$export$2e2bcd8739ae039 = {
    "dismiss-button": "awsui_dismiss-button_dm8gx_1wq3k_145",
    "token": "awsui_token_dm8gx_1wq3k_146",
    "root": "awsui_root_dm8gx_1wq3k_150",
    "has-items": "awsui_has-items_dm8gx_1wq3k_181",
    "no-padding": "awsui_no-padding_dm8gx_1wq3k_181"
};



var $98573fdc0990a8b2$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1i2wg_18qq8_161",
    "dismiss-button": "awsui_dismiss-button_1i2wg_18qq8_193",
    "dismiss-button-inline": "awsui_dismiss-button-inline_1i2wg_18qq8_233",
    "icon": "awsui_icon_1i2wg_18qq8_240",
    "icon-inline": "awsui_icon-inline_1i2wg_18qq8_246",
    "token-normal": "awsui_token-normal_1i2wg_18qq8_251",
    "token-inline": "awsui_token-inline_1i2wg_18qq8_258",
    "token-option-inline": "awsui_token-option-inline_1i2wg_18qq8_284",
    "token-box": "awsui_token-box_1i2wg_18qq8_288",
    "token-box-without-dismiss": "awsui_token-box-without-dismiss_1i2wg_18qq8_307",
    "token-box-inline": "awsui_token-box-inline_1i2wg_18qq8_311",
    "disable-padding": "awsui_disable-padding_1i2wg_18qq8_331",
    "token-box-readonly": "awsui_token-box-readonly_1i2wg_18qq8_338",
    "token-box-disabled": "awsui_token-box-disabled_1i2wg_18qq8_339"
};



var $dcd504446b2d2d64$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1epxo_12cv0_5",
    "dismiss-button": "awsui_dismiss-button_1epxo_12cv0_6"
};


var $3197154d56686200$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($3197154d56686200$var$DismissButton);
function $3197154d56686200$var$DismissButton({ disabled: disabled, dismissLabel: dismissLabel, onDismiss: onDismiss, readOnly: readOnly, inline: inline }, ref) {
    const analyticsMetadata = {
        action: 'dismiss',
        detail: {
            label: {
                root: 'self'
            }
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        type: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['dismiss-button'], (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)['dismiss-button'], (0, $dcd504446b2d2d64$export$2e2bcd8739ae039)['dismiss-button'], inline && (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['dismiss-button-inline']),
        "aria-disabled": disabled || readOnly ? true : undefined,
        onClick: ()=>{
            if (disabled || readOnly || !onDismiss) return;
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss);
        },
        "aria-label": dismissLabel,
        ...disabled || readOnly ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "close"
    }));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $a09d76d059fef380$export$3203edd9e5edd663 = (value)=>{
    const hours = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getHours()}`, 2);
    const minutes = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getMinutes()}`, 2);
    const seconds = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getSeconds()}`, 2);
    return `${hours}:${minutes}:${seconds}`;
};


function $8c712b40a21c0439$export$8b492ed8828f789c(date) {
    return (0, $b7857ad8c9833aee$export$3ae94a2503e890a1)(date) + 'T' + (0, $a09d76d059fef380$export$3203edd9e5edd663)(date);
}


const $a9961f13c4f48afd$var$KB = 1000;
const $a9961f13c4f48afd$var$MB = 1000 ** 2;
const $a9961f13c4f48afd$var$GB = 1000 ** 3;
const $a9961f13c4f48afd$var$TB = 1000 ** 4;
function $a9961f13c4f48afd$export$a55dc7d9a051abe5(size) {
    if (size < $a9961f13c4f48afd$var$MB) return `${(size / $a9961f13c4f48afd$var$KB).toFixed(2)} KB`;
    if (size < $a9961f13c4f48afd$var$GB) return `${(size / $a9961f13c4f48afd$var$MB).toFixed(2)} MB`;
    if (size < $a9961f13c4f48afd$var$TB) return `${(size / $a9961f13c4f48afd$var$GB).toFixed(2)} GB`;
    return `${(size / $a9961f13c4f48afd$var$TB).toFixed(2)} TB`;
}
function $a9961f13c4f48afd$export$f20360301b72d45f(date) {
    return (0, $8c712b40a21c0439$export$8b492ed8828f789c)(date);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $144f260e470faaba$export$2e2bcd8739ae039 = {
    "root": "awsui_root_39ths_ivxwx_209",
    "file-loading-overlay": "awsui_file-loading-overlay_39ths_ivxwx_241",
    "file-loading-overlay-single-row": "awsui_file-loading-overlay-single-row_39ths_ivxwx_246",
    "file-name-container": "awsui_file-name-container_39ths_ivxwx_250",
    "file-option-name": "awsui_file-option-name_39ths_ivxwx_280",
    "file-option-size": "awsui_file-option-size_39ths_ivxwx_281",
    "file-option-last-modified": "awsui_file-option-last-modified_39ths_ivxwx_282",
    "file-option": "awsui_file-option_39ths_ivxwx_280",
    "file-option-thumbnail": "awsui_file-option-thumbnail_39ths_ivxwx_295",
    "file-option-thumbnail-image": "awsui_file-option-thumbnail-image_39ths_ivxwx_299",
    "file-option-metadata": "awsui_file-option-metadata_39ths_ivxwx_312",
    "with-image": "awsui_with-image_39ths_ivxwx_315",
    "single-row-loading": "awsui_single-row-loading_39ths_ivxwx_318",
    "token": "awsui_token_39ths_ivxwx_322",
    "token-grid": "awsui_token-grid_39ths_ivxwx_329",
    "token-contains-image": "awsui_token-contains-image_39ths_ivxwx_338",
    "token-box": "awsui_token-box_39ths_ivxwx_342",
    "horizontal": "awsui_horizontal_39ths_ivxwx_361",
    "error": "awsui_error_39ths_ivxwx_369",
    "dismiss-button": "awsui_dismiss-button_39ths_ivxwx_373",
    "warning": "awsui_warning_39ths_ivxwx_379",
    "read-only": "awsui_read-only_39ths_ivxwx_389",
    "loading": "awsui_loading_39ths_ivxwx_402"
};


function $ae86ce8ce294423e$export$d65da67560512fde({ file: file }) {
    const [imageSrc, setImageSrc] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        // The URL.createObjectURL is not available in jsdom.
        if (URL.createObjectURL) {
            const src = URL.createObjectURL(file);
            setImageSrc(src);
            return ()=>{
                URL.revokeObjectURL(src);
            };
        }
    }, [
        file
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $144f260e470faaba$export$2e2bcd8739ae039)['file-option-thumbnail'],
        "aria-hidden": true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: (0, $144f260e470faaba$export$2e2bcd8739ae039)['file-option-thumbnail-image'],
        alt: file.name,
        src: imageSrc
    }));
}




var $b06ea1a764f9bd6a$export$2e2bcd8739ae039 = {
    "root": "awsui_root_polq8_6ggi7_5",
    "file-option-thumbnail": "awsui_file-option-thumbnail_polq8_6ggi7_6",
    "file-option-name": "awsui_file-option-name_polq8_6ggi7_7",
    "file-option-size": "awsui_file-option-size_polq8_6ggi7_8",
    "file-option-last-modified": "awsui_file-option-last-modified_polq8_6ggi7_9",
    "ellipsis-active": "awsui_ellipsis-active_polq8_6ggi7_10"
};


function $34b42b229e579ad9$var$InternalFileToken({ file: file, showFileLastModified: showFileLastModified, showFileSize: showFileSize, showFileThumbnail: showFileThumbnail, i18nStrings: i18nStrings, onDismiss: onDismiss, errorText: errorText, warningText: warningText, readOnly: readOnly, loading: loading, alignment: alignment, groupContainsImage: groupContainsImage, isImage: isImage, index: index }) {
    var _a, _b;
    const formatFileSize = (_a = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.formatFileSize) !== null && _a !== void 0 ? _a : $a9961f13c4f48afd$export$a55dc7d9a051abe5;
    const formatFileLastModified = (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.formatFileLastModified) !== null && _b !== void 0 ? _b : $a9961f13c4f48afd$export$f20360301b72d45f;
    const errorId = (0, $013a2451794a45c0$exports.useUniqueId)('error');
    const warningId = (0, $013a2451794a45c0$exports.useUniqueId)('warning');
    const showWarning = warningText && !errorText;
    const containerRef = (0, $acw62.useRef)(null);
    const fileNameRef = (0, $acw62.useRef)(null);
    const fileNameContainerRef = (0, $acw62.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $acw62.useState)(false);
    const getDismissLabel = (fileIndex)=>{
        var _a;
        return (_a = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.removeFileAriaLabel) === null || _a === void 0 ? void 0 : _a.call(i18nStrings, fileIndex, file.name);
    };
    function isEllipsisActive() {
        const span = fileNameRef.current;
        const container = fileNameContainerRef.current;
        if (span && container) return span.offsetWidth >= container.offsetWidth;
        return false;
    }
    (0, $013a2451794a45c0$exports.useResizeObserver)(()=>fileNameContainerRef.current, ()=>setIsTruncated(isEllipsisActive()));
    const fileIsSingleRow = !showFileLastModified && !showFileSize && (!groupContainsImage || groupContainsImage && !showFileThumbnail);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $144f260e470faaba$export$2e2bcd8739ae039).token, {
            [(0, $144f260e470faaba$export$2e2bcd8739ae039)['token-grid']]: alignment === 'horizontal',
            [(0, $144f260e470faaba$export$2e2bcd8739ae039)['token-contains-image']]: groupContainsImage && showFileThumbnail
        }),
        role: "group",
        "aria-label": file.name,
        "aria-describedby": errorText ? errorId : warningText ? warningId : undefined,
        "aria-disabled": loading,
        "data-index": index
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $144f260e470faaba$export$2e2bcd8739ae039)['token-box'], {
            [(0, $144f260e470faaba$export$2e2bcd8739ae039).loading]: loading,
            [(0, $144f260e470faaba$export$2e2bcd8739ae039).error]: errorText,
            [(0, $144f260e470faaba$export$2e2bcd8739ae039).warning]: showWarning,
            [(0, $144f260e470faaba$export$2e2bcd8739ae039).horizontal]: alignment === 'horizontal',
            [(0, $144f260e470faaba$export$2e2bcd8739ae039)['read-only']]: readOnly
        })
    }, loading && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $144f260e470faaba$export$2e2bcd8739ae039)['file-loading-overlay'], {
            [(0, $144f260e470faaba$export$2e2bcd8739ae039)['file-loading-overlay-single-row']]: loading && fileIsSingleRow
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), {
        variant: "disabled",
        size: "normal"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        className: (0, $144f260e470faaba$export$2e2bcd8739ae039)['file-option']
    }, showFileThumbnail && isImage && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae86ce8ce294423e$export$d65da67560512fde), {
        file: file
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $144f260e470faaba$export$2e2bcd8739ae039)['file-option-metadata'], {
            [(0, $144f260e470faaba$export$2e2bcd8739ae039)['with-image']]: showFileThumbnail && isImage,
            [(0, $144f260e470faaba$export$2e2bcd8739ae039)['single-row-loading']]: loading && fileIsSingleRow
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        direction: "vertical",
        size: "xxxs"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $144f260e470faaba$export$2e2bcd8739ae039)['file-name-container'],
        onMouseOver: ()=>setShowTooltip(true),
        onMouseOut: ()=>setShowTooltip(false),
        onFocus: ()=>setShowTooltip(true),
        onBlur: ()=>setShowTooltip(false),
        role: isTruncated ? 'button' : undefined,
        "aria-expanded": isTruncated ? showTooltip : undefined,
        tabIndex: isTruncated ? 0 : -1,
        ref: fileNameContainerRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        fontWeight: "normal",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $144f260e470faaba$export$2e2bcd8739ae039)['file-option-name'], (0, $b06ea1a764f9bd6a$export$2e2bcd8739ae039)['file-option-name'], {
            [(0, $b06ea1a764f9bd6a$export$2e2bcd8739ae039)['ellipsis-active']]: isTruncated
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: fileNameRef
    }, file.name))), showFileSize && file.size ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        fontSize: "body-s",
        color: 'text-body-secondary',
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $144f260e470faaba$export$2e2bcd8739ae039)['file-option-size'], (0, $b06ea1a764f9bd6a$export$2e2bcd8739ae039)['file-option-size'])
    }, formatFileSize(file.size)) : null, showFileLastModified && file.lastModified ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        fontSize: "body-s",
        color: 'text-body-secondary',
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $144f260e470faaba$export$2e2bcd8739ae039)['file-option-last-modified'], (0, $b06ea1a764f9bd6a$export$2e2bcd8739ae039)['file-option-last-modified'])
    }, formatFileLastModified(new Date(file.lastModified))) : null))), onDismiss && !readOnly && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3197154d56686200$export$2e2bcd8739ae039), {
        dismissLabel: getDismissLabel(index),
        onDismiss: onDismiss
    })), errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$4852ecce5ecf6bcb), {
        id: errorId,
        errorIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel
    }, errorText), showWarning && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$7f93a80d0cfdba0c), {
        id: warningId,
        warningIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel
    }, warningText), showTooltip && isTruncated && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        getTrack: ()=>containerRef.current,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
            fontWeight: "normal"
        }, file.name),
        onEscape: ()=>setShowTooltip(false)
    }));
}
var $34b42b229e579ad9$export$2e2bcd8739ae039 = $34b42b229e579ad9$var$InternalFileToken;





function $4ee034ab300b6cfb$var$InternalFileTokenGroup({ items: items, showFileLastModified: showFileLastModified, showFileSize: showFileSize, showFileThumbnail: showFileThumbnail, i18nStrings: i18nStrings, onDismiss: onDismiss, limit: limit, readOnly: readOnly, alignment: alignment = 'vertical', __internalRootRef: __internalRootRef, ...restProps }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const [nextFocusIndex, setNextFocusIndex] = (0, $acw62.useState)(null);
    const tokenListRef = (0, $b53452f0d99d5bc4$export$62f3f0e010c1e172)({
        nextFocusIndex: nextFocusIndex,
        onFocusMoved: (target)=>{
            target.focus();
            setNextFocusIndex(null);
        },
        listItemSelector: `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)['list-item']}`,
        showMoreSelector: `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).toggle}`
    });
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(__internalRootRef, tokenListRef);
    const isImage = (file)=>file.type.startsWith('image/');
    const groupContainsImage = items.filter((item)=>isImage(item.file)).length > 0;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('file-token-group');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: mergedRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $144f260e470faaba$export$2e2bcd8739ae039).root, (0, $b06ea1a764f9bd6a$export$2e2bcd8739ae039).root)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e34c3ccd4808258$export$2e2bcd8739ae039), {
        alignment: alignment === 'horizontal' ? 'horizontal-grid' : alignment,
        items: items,
        renderItem: (file, fileIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34b42b229e579ad9$export$2e2bcd8739ae039), {
                file: file.file,
                showFileLastModified: showFileLastModified,
                showFileSize: showFileSize,
                showFileThumbnail: showFileThumbnail,
                onDismiss: ()=>{
                    (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
                        fileIndex: fileIndex
                    });
                    setNextFocusIndex(fileIndex);
                },
                errorText: file.errorText,
                warningText: file.warningText,
                i18nStrings: {
                    removeFileAriaLabel: i18n('i18nStrings.removeFileAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.removeFileAriaLabel, (format)=>(fileIndex, fileName)=>format({
                                fileIndex: fileIndex + 1,
                                fileName: fileName
                            })),
                    errorIconAriaLabel: i18n('i18nStrings.errorIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel),
                    warningIconAriaLabel: i18n('i18nStrings.warningIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel),
                    formatFileSize: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.formatFileSize,
                    formatFileLastModified: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.formatFileLastModified
                },
                loading: file.loading,
                readOnly: readOnly,
                alignment: alignment,
                groupContainsImage: groupContainsImage,
                isImage: isImage(file.file),
                index: fileIndex
            }),
        limit: limit,
        i18nStrings: {
            limitShowFewer: i18n('i18nStrings.limitShowFewer', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.limitShowFewer),
            limitShowMore: i18n('i18nStrings.limitShowMore', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.limitShowMore)
        }
    }));
}
var $4ee034ab300b6cfb$export$2e2bcd8739ae039 = $4ee034ab300b6cfb$var$InternalFileTokenGroup;













var $b9661ba9f59df7b7$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1ubbm_139m0_9",
    "hints": "awsui_hints_1ubbm_139m0_10"
};


var $8bc91695888761ff$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($8bc91695888761ff$var$InternalFileUpload);
function $8bc91695888761ff$var$InternalFileUpload({ accept: accept, ariaRequired: ariaRequired, multiple: multiple = false, onChange: onChange, value: value, tokenLimit: tokenLimit, showFileSize: showFileSize, showFileLastModified: showFileLastModified, showFileThumbnail: showFileThumbnail, i18nStrings: i18nStrings, __internalRootRef: __internalRootRef, constraintText: constraintText, errorText: errorText, warningText: warningText, fileErrors: fileErrors, fileWarnings: fileWarnings, fileTokenAlignment: fileTokenAlignment = 'vertical', ...restProps }, externalRef) {
    var _a, _b, _c;
    const [nextFocusIndex, setNextFocusIndex] = (0, $acw62.useState)(null);
    const tokenListRef = (0, $b53452f0d99d5bc4$export$62f3f0e010c1e172)({
        nextFocusIndex: nextFocusIndex,
        onFocusMoved: (target)=>{
            target.focus();
            setNextFocusIndex(null);
        },
        listItemSelector: `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)['list-item']}`,
        showMoreSelector: `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).toggle}`,
        fallbackSelector: `.${(0, $a14831985619a2f7$export$2e2bcd8739ae039)['file-input']}`
    });
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('file-upload');
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const metadata = {
        showFileSize: showFileSize,
        showFileLastModified: showFileLastModified,
        showFileThumbnail: showFileThumbnail
    };
    const errorId = (0, $013a2451794a45c0$exports.useUniqueId)('error-');
    const warningId = (0, $013a2451794a45c0$exports.useUniqueId)('warning-');
    const constraintTextId = (0, $013a2451794a45c0$exports.useUniqueId)('constraint-text-');
    const fileInputRef = (0, $acw62.useRef)(null);
    const ref = (0, $013a2451794a45c0$exports.useMergeRefs)(fileInputRef, externalRef);
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)('FileUpload', 'value', value, 'onChange', onChange);
    if (!multiple && value.length > 1) (0, $013a2451794a45c0$exports.warnOnce)('FileUpload', 'Value must be an array of size 0 or 1 when `multiple=false`.');
    const handleFilesChange = (newFiles)=>{
        const newValue = multiple ? [
            ...value,
            ...newFiles
        ] : newFiles[0] ? newFiles.slice(0, 1) : [
            ...value
        ];
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: newValue
        });
    };
    const onFileRemove = (removeFileIndex)=>{
        const newValue = value.filter((_, fileIndex)=>fileIndex !== removeFileIndex);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: newValue
        });
        setNextFocusIndex(removeFileIndex);
    };
    const { areFilesDragging: areFilesDragging } = (0, $8e72b22b9066cfc1$export$3e5acc18bff877d4)();
    const showWarning = warningText && !errorText;
    if (warningText && errorText) (0, $013a2451794a45c0$exports.warnOnce)('FileUpload', 'Both `errorText` and `warningText` exist. `warningText` will not be shown.');
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const ariaDescribedBy = (0, $49fa9e74c692ea64$export$b933cda3796739ed)((_a = restProps.ariaDescribedby) !== null && _a !== void 0 ? _a : formFieldContext.ariaDescribedby, errorText ? errorId : undefined, showWarning ? warningId : undefined, constraintText ? constraintTextId : undefined);
    const hasError = Boolean(errorText || (fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors.filter(Boolean).length));
    const invalid = restProps.invalid || formFieldContext.invalid || hasError;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        ...baseProps,
        size: "xs",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $b9661ba9f59df7b7$export$2e2bcd8739ae039).root),
        __internalRootRef: __internalRootRef,
        ref: tokenListRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), null, areFilesDragging ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f244de4f6b4db138$export$2e2bcd8739ae039), {
        onChange: (event)=>handleFilesChange(event.detail.value)
    }, i18n('i18nStrings.dropzoneText', (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dropzoneText) === null || _b === void 0 ? void 0 : _b.call(i18nStrings, multiple), (format)=>format({
            multiple: `${multiple}`
        }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bad98411ec3e571$export$2e2bcd8739ae039), {
        ref: ref,
        accept: accept,
        ariaRequired: ariaRequired,
        multiple: multiple,
        onChange: (event)=>handleFilesChange(event.detail.value),
        value: value,
        ariaLabelledby: restProps.ariaLabelledby,
        controlId: restProps.controlId,
        ariaDescribedby: ariaDescribedBy,
        invalid: invalid
    }, i18n('i18nStrings.uploadButtonText', (_c = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.uploadButtonText) === null || _c === void 0 ? void 0 : _c.call(i18nStrings, multiple), (format)=>format({
            multiple: `${multiple}`
        }))), (constraintText || errorText || warningText) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b9661ba9f59df7b7$export$2e2bcd8739ae039).hints
    }, errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$4852ecce5ecf6bcb), {
        id: errorId,
        errorIconAriaLabel: i18n('i18nStrings.errorIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel)
    }, errorText), showWarning && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$7f93a80d0cfdba0c), {
        id: warningId,
        warningIconAriaLabel: i18n('i18nStrings.warningIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel)
    }, warningText), constraintText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$d907c2d8d9ae85b4), {
        id: constraintTextId,
        hasValidationText: !!errorText || !!warningText
    }, constraintText))), value.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ee034ab300b6cfb$export$2e2bcd8739ae039), {
        limit: tokenLimit,
        alignment: fileTokenAlignment,
        items: value.map((file, fileIndex)=>({
                file: file,
                errorText: fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors[fileIndex],
                warningText: fileWarnings === null || fileWarnings === void 0 ? void 0 : fileWarnings[fileIndex]
            })),
        showFileLastModified: metadata.showFileLastModified,
        showFileSize: metadata.showFileSize,
        showFileThumbnail: metadata.showFileThumbnail,
        i18nStrings: {
            removeFileAriaLabel: i18n('i18nStrings.removeFileAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.removeFileAriaLabel, (format)=>(fileIndex, fileName)=>format({
                        fileIndex: fileIndex + 1,
                        fileName: fileName
                    })),
            limitShowFewer: i18n('i18nStrings.limitShowFewer', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.limitShowFewer),
            limitShowMore: i18n('i18nStrings.limitShowMore', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.limitShowMore),
            formatFileSize: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.formatFileSize,
            formatFileLastModified: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.formatFileLastModified,
            errorIconAriaLabel: i18n('i18nStrings.errorIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel),
            warningIconAriaLabel: i18n('i18nStrings.warningIconAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel)
        },
        onDismiss: (event)=>onFileRemove(event.detail.fileIndex)
    }) : null);
}


'use client';
const $0caa904d8e7106e8$var$FileUpload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ multiple: multiple, showFileSize: showFileSize, showFileLastModified: showFileLastModified, showFileThumbnail: showFileThumbnail, ...restProps }, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('FileUpload', {
        props: {
            multiple: multiple,
            showFileLastModified: showFileLastModified,
            showFileSize: showFileSize,
            showFileThumbnail: showFileThumbnail,
            tokenLimit: restProps.tokenLimit
        }
    });
    const externalProps = (0, $3833f34df478664f$export$21af416108db3048)(restProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8bc91695888761ff$export$2e2bcd8739ae039), {
        ref: ref,
        multiple: multiple,
        showFileSize: showFileSize,
        showFileLastModified: showFileLastModified,
        showFileThumbnail: showFileThumbnail,
        ...externalProps,
        ...baseComponentProps
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($0caa904d8e7106e8$var$FileUpload, 'FileUpload');
var $0caa904d8e7106e8$export$2e2bcd8739ae039 = $0caa904d8e7106e8$var$FileUpload;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $18244bc9191d76b9$export$2e2bcd8739ae039 = {
    "root": "awsui_root_vrgzu_11c7p_145",
    "recovery": "awsui_recovery_vrgzu_11c7p_180"
};


function $41901c188ad0f2ad$var$DropdownStatus({ children: children }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $18244bc9191d76b9$export$2e2bcd8739ae039).root
    }, children);
}
const $41901c188ad0f2ad$export$5467db17117c3a32 = ({ statusType: statusType, empty: empty, loadingText: loadingText, finishedText: finishedText, filteringResultsText: filteringResultsText, errorText: errorText, recoveryText: recoveryText, isEmpty: isEmpty, isNoMatch: isNoMatch, noMatch: noMatch, onRecoveryClick: onRecoveryClick, hasRecoveryCallback: hasRecoveryCallback = false, errorIconAriaLabel: errorIconAriaLabel })=>{
    const previousStatusType = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(statusType);
    const statusResult = {
        isSticky: true,
        content: null,
        hasRecoveryButton: false
    };
    if (statusType === 'loading') statusResult.content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ffdf6cc8746b93a$export$2e2bcd8739ae039), {
        type: 'loading'
    }, loadingText);
    else if (statusType === 'error') {
        statusResult.hasRecoveryButton = !!recoveryText && hasRecoveryCallback;
        statusResult.content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ffdf6cc8746b93a$export$2e2bcd8739ae039), {
            type: "error",
            __display: "inline",
            __animate: previousStatusType !== 'error',
            iconAriaLabel: errorIconAriaLabel
        }, errorText), ' ', statusResult.hasRecoveryButton && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01503a290f20b804$export$2e2bcd8739ae039), {
            onFollow: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onRecoveryClick),
            variant: "recovery",
            className: (0, $18244bc9191d76b9$export$2e2bcd8739ae039).recovery
        }, recoveryText));
    } else if (isEmpty && empty) statusResult.content = empty;
    else if (isNoMatch && noMatch) statusResult.content = noMatch;
    else if (filteringResultsText) statusResult.content = filteringResultsText;
    else if (statusType === 'finished' && finishedText) {
        statusResult.content = finishedText;
        statusResult.isSticky = false;
    }
    return statusResult;
};
var $41901c188ad0f2ad$export$2e2bcd8739ae039 = $41901c188ad0f2ad$var$DropdownStatus;



var $3b310b443add1678$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1afi9_1n6s2_145",
    "hidden": "awsui_hidden_1afi9_1n6s2_176",
    "no-items": "awsui_no-items_1afi9_1n6s2_179"
};


const $4d1a5dc327bab5f7$var$DropdownFooter = ({ content: content, id: id, hasItems: hasItems = true })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b310b443add1678$export$2e2bcd8739ae039).root, {
            [(0, $3b310b443add1678$export$2e2bcd8739ae039).hidden]: content === null,
            [(0, $3b310b443add1678$export$2e2bcd8739ae039)['no-items']]: !hasItems
        })
    }, content && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        id: id
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $41901c188ad0f2ad$export$2e2bcd8739ae039), null, content)));
var $4d1a5dc327bab5f7$export$2e2bcd8739ae039 = $4d1a5dc327bab5f7$var$DropdownFooter;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $002622222677c92c$export$729c6707a50a5721({ expandToViewport: expandToViewport, triggerWidth: triggerWidth, dropdownWidth: dropdownWidth }) {
    if (dropdownWidth) return dropdownWidth;
    if (!expandToViewport) return 'trigger';
    return triggerWidth !== null ? Math.min(triggerWidth, (0, $1be283cfa47851a8$export$4adb988360925c51)('xxs')) : undefined;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $598d44f77c0b7cbc$export$2e2bcd8739ae039 = {
    "placeholder": "awsui_placeholder_dwuol_r15lx_145",
    "item": "awsui_item_dwuol_r15lx_150",
    "checkbox": "awsui_checkbox_dwuol_r15lx_154",
    "option-group": "awsui_option-group_dwuol_r15lx_163",
    "filter": "awsui_filter_dwuol_r15lx_167",
    "trigger": "awsui_trigger_dwuol_r15lx_172",
    "layout-strut": "awsui_layout-strut_dwuol_r15lx_178",
    "list-bottom": "awsui_list-bottom_dwuol_r15lx_184",
    "selected-icon": "awsui_selected-icon_dwuol_r15lx_188",
    "show-label-tag": "awsui_show-label-tag_dwuol_r15lx_193",
    "inline-token-trigger": "awsui_inline-token-trigger_dwuol_r15lx_197",
    "inline-token-list": "awsui_inline-token-list_dwuol_r15lx_204",
    "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_r15lx_218",
    "inline-token-counter": "awsui_inline-token-counter_dwuol_r15lx_224",
    "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_dwuol_r15lx_228",
    "inline-label-wrapper": "awsui_inline-label-wrapper_dwuol_r15lx_232",
    "inline-label": "awsui_inline-label_dwuol_r15lx_228",
    "inline-label-disabled": "awsui_inline-label-disabled_dwuol_r15lx_257",
    "inline-label-inline-tokens": "awsui_inline-label-inline-tokens_dwuol_r15lx_261",
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_dwuol_r15lx_266"
};


const $3d59f5e64bb57d9d$var$Filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ filteringType: filteringType, ...filterProps }, ref)=>{
    if (filteringType === 'none') return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), {
        ref: ref,
        type: "visualSearch",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).filter,
        autoComplete: false,
        disableBrowserAutocorrect: true,
        invalid: false,
        __noBorderRadius: true,
        ...filterProps,
        nativeInputAttributes: {
            'aria-expanded': true,
            'aria-haspopup': 'listbox',
            role: 'combobox',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            ...filterProps.nativeInputAttributes
        },
        __skipNativeAttributesWarnings: true
    });
});
var $3d59f5e64bb57d9d$export$2e2bcd8739ae039 = $3d59f5e64bb57d9d$var$Filter;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $39828edae85cca10$export$1c15153076b74c08(options) {
    const nestedOptions = [];
    let currentParent;
    options.forEach((option, index)=>{
        var _a;
        if (option.type === 'parent') {
            const wrapped = {
                type: 'parent',
                option: option,
                index: index,
                children: []
            };
            currentParent = wrapped;
            nestedOptions.push(wrapped);
        } else if (option.type === 'child') ((_a = currentParent === null || currentParent === void 0 ? void 0 : currentParent.children) !== null && _a !== void 0 ? _a : nestedOptions).push({
            type: 'child',
            option: option,
            index: index
        });
        else {
            currentParent = undefined;
            nestedOptions.push({
                type: 'child',
                option: option,
                index: index
            });
        }
    });
    return nestedOptions;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $c352e6ab47e4b381$export$2e2bcd8739ae039 = {
    "option": "awsui_option_1p2cx_cbqrk_153",
    "disabled": "awsui_disabled_1p2cx_cbqrk_190",
    "parent": "awsui_parent_1p2cx_cbqrk_193",
    "highlighted": "awsui_highlighted_1p2cx_cbqrk_196",
    "content": "awsui_content_1p2cx_cbqrk_200",
    "label-content": "awsui_label-content_1p2cx_cbqrk_207",
    "label": "awsui_label_1p2cx_cbqrk_207",
    "tag": "awsui_tag_1p2cx_cbqrk_214",
    "label-tag": "awsui_label-tag_1p2cx_cbqrk_215",
    "label-prefix": "awsui_label-prefix_1p2cx_cbqrk_225",
    "tags": "awsui_tags_1p2cx_cbqrk_238",
    "description": "awsui_description_1p2cx_cbqrk_239",
    "selected": "awsui_selected_1p2cx_cbqrk_250",
    "icon": "awsui_icon_1p2cx_cbqrk_264",
    "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_cbqrk_271",
    "trigger-variant": "awsui_trigger-variant_1p2cx_cbqrk_286",
    "custom-content": "awsui_custom-content_1p2cx_cbqrk_292"
};


const $30b43541cf6c2d4d$var$splitOnFiltering = (str, highlightText)=>{
    // We match by creating a regex using user-provided strings, so we skip
    // highlighting if the generated regex would be too memory intensive.
    if (highlightText.length > 10000) return {
        noMatches: [
            str
        ],
        matches: null
    };
    // Filtering needs to be case insensitive
    const filteringPattern = highlightText.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
    const regexp = new RegExp(filteringPattern, 'gi');
    const noMatches = str.split(regexp);
    const matches = str.match(regexp);
    return {
        noMatches: noMatches,
        matches: matches
    };
};
function $30b43541cf6c2d4d$var$Highlight({ str: str, labelRef: labelRef }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("mark", {
        ref: labelRef,
        className: (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['filtering-match-highlight']
    }, str);
}
function $30b43541cf6c2d4d$export$2e2bcd8739ae039({ str: str, highlightText: highlightText, labelRef: labelRef }) {
    if (!str || !highlightText) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: labelRef
    }, str);
    if (str === highlightText) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($30b43541cf6c2d4d$var$Highlight, {
        labelRef: labelRef,
        str: str
    });
    const { noMatches: noMatches, matches: matches } = $30b43541cf6c2d4d$var$splitOnFiltering(str, highlightText);
    const highlighted = [];
    noMatches.forEach((noMatch, idx)=>{
        highlighted.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: `noMatch-${idx}`
        }, noMatch));
        if (matches && idx < matches.length) highlighted.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($30b43541cf6c2d4d$var$Highlight, {
            key: `match-${idx}`,
            str: matches[idx]
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: labelRef
    }, highlighted);
}



var $231b656bce9fc08e$export$2e2bcd8739ae039 = {
    "label": "awsui_label_1q5vz_ocied_5"
};



const $37c16ef5b2efceb2$export$b04be29aa201d4f5 = ({ labelContainerRef: labelContainerRef, labelRef: labelRef, labelId: labelId, label: label, prefix: prefix, highlightText: highlightText, triggerVariant: triggerVariant })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: labelId,
        ref: labelContainerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).label, (0, $231b656bce9fc08e$export$2e2bcd8739ae039).label, triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['trigger-variant'])
    }, prefix && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['label-prefix'], triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['trigger-variant'])
    }, prefix, " "), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
        labelRef: labelRef,
        str: label,
        highlightText: highlightText
    }));
};
const $37c16ef5b2efceb2$export$9dacaafb9baa8abc = ({ labelTag: labelTag, highlightText: highlightText, triggerVariant: triggerVariant })=>labelTag ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['label-tag'], triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['trigger-variant'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
        str: labelTag,
        highlightText: highlightText
    })) : null;
const $37c16ef5b2efceb2$export$393edc798c47379d = ({ description: description, highlightedOption: highlightedOption, highlightText: highlightText, selectedOption: selectedOption, triggerVariant: triggerVariant })=>description ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).description, {
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['trigger-variant']]: triggerVariant,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted]: highlightedOption,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).selected]: selectedOption
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
        str: description,
        highlightText: highlightText
    })) : null;
const $37c16ef5b2efceb2$export$b72686b556e29ca6 = ({ tags: tags, highlightedOption: highlightedOption, highlightText: highlightText, selectedOption: selectedOption, triggerVariant: triggerVariant })=>tags ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tags, {
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted]: highlightedOption,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).selected]: selectedOption
        })
    }, tags.map((tag, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: idx,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tag, triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['trigger-variant'])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
            str: tag,
            highlightText: highlightText
        })))) : null;
const $37c16ef5b2efceb2$export$cd6b1b7fd0ae97c9 = ({ filteringTags: filteringTags, highlightedOption: highlightedOption, highlightText: highlightText, selectedOption: selectedOption, triggerVariant: triggerVariant })=>{
    if (!highlightText || !filteringTags) return null;
    const searchElement = highlightText.toLowerCase();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tags, {
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted]: highlightedOption,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).selected]: selectedOption
        })
    }, filteringTags.map((filteringTag, key)=>{
        const match = filteringTag.toLowerCase().indexOf(searchElement) !== -1;
        if (match) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tag, triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['trigger-variant']),
            key: key
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
            str: filteringTag,
            highlightText: highlightText
        }));
        return null;
    }));
};
const $37c16ef5b2efceb2$export$cbe66ba5a24d87ce = (props)=>{
    if (!props.name && !props.url && !props.svg) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).icon
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        ...props
    }));
};




function $8c692c1c1c803c55$var$validateStringValue(value, propertyName) {
    if (typeof value !== 'undefined' && typeof value !== 'string') (0, $013a2451794a45c0$exports.warnOnce)('DropdownOption', `This component only supports string values, but "option.${propertyName}" has ${typeof value} type. The component may work incorrectly.`);
}
const $8c692c1c1c803c55$var$Option = ({ option: option, highlightText: highlightText, triggerVariant: triggerVariant = false, isGroupOption: isGroupOption = false, highlightedOption: highlightedOption = false, selectedOption: selectedOption = false, disableTitleTooltip: disableTitleTooltip = false, labelContainerRef: labelContainerRef, labelRef: labelRef, labelId: labelId, customContent: customContent, ...restProps })=>{
    var _a, _b, _c, _d;
    if (!option) return null;
    if (customContent) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-value": option.value,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).option)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['custom-content'])
    }, customContent));
    const { disabled: disabled } = option;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const SpanOrDivTag = option.labelContent ? 'div' : 'span';
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        $8c692c1c1c803c55$var$validateStringValue(option.label, 'label');
        $8c692c1c1c803c55$var$validateStringValue(option.description, 'description');
        $8c692c1c1c803c55$var$validateStringValue(option.labelTag, 'labelTag');
        (_a = option.tags) === null || _a === void 0 || _a.forEach((tag, index)=>{
            $8c692c1c1c803c55$var$validateStringValue(tag, `tags[${index}]`);
        });
        (_b = option.filteringTags) === null || _b === void 0 || _b.forEach((tag, index)=>{
            $8c692c1c1c803c55$var$validateStringValue(tag, `filteringTags[${index}]`);
        });
    }
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).option, disabled && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).disabled, isGroupOption && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).parent, highlightedOption && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted, baseProps.className);
    const icon = option.__customIcon || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$cbe66ba5a24d87ce), {
        name: option.iconName,
        url: option.iconUrl,
        svg: option.iconSvg,
        alt: option.iconAlt,
        ariaLabel: option.iconAriaLabel,
        size: "normal"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SpanOrDivTag, {
        ...baseProps,
        "data-value": option.value,
        className: className,
        lang: option.lang,
        title: !disableTitleTooltip ? (_c = option.label) !== null && _c !== void 0 ? _c : option.value : undefined
    }, icon, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SpanOrDivTag, {
        className: (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).content
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SpanOrDivTag, {
        className: (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)['label-content']
    }, option.labelContent ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SpanOrDivTag, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).label, (0, $231b656bce9fc08e$export$2e2bcd8739ae039).label)
    }, option.labelContent) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$b04be29aa201d4f5), {
        labelContainerRef: labelContainerRef,
        labelRef: labelRef,
        labelId: labelId,
        label: (_d = option.label) !== null && _d !== void 0 ? _d : option.value,
        prefix: option.__labelPrefix,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$9dacaafb9baa8abc), {
        labelTag: option.labelTag,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$393edc798c47379d), {
        description: option.description,
        highlightedOption: highlightedOption,
        selectedOption: selectedOption,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$b72686b556e29ca6), {
        tags: option.tags,
        highlightedOption: highlightedOption,
        selectedOption: selectedOption,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$cd6b1b7fd0ae97c9), {
        filteringTags: option.filteringTags,
        highlightedOption: highlightedOption,
        selectedOption: selectedOption,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    })));
};
var $8c692c1c1c803c55$export$2e2bcd8739ae039 = $8c692c1c1c803c55$var$Option;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $42202144cf456408$export$2e2bcd8739ae039 = {
    "parent": "awsui_parent_2dmmi_qu62t_5",
    "option-content": "awsui_option-content_2dmmi_qu62t_6"
};


const $a79cc6b55c309170$export$21c5fe65bde956fa = ({ isChild: isChild, value: value, ...restProps })=>{
    const dataAttributes = restProps;
    const analyticsMetadata = {
        action: 'select',
        detail: {
            label: {
                selector: [
                    `.${(0, $231b656bce9fc08e$export$2e2bcd8739ae039).label}`,
                    `.${(0, $42202144cf456408$export$2e2bcd8739ae039)['option-content']}`
                ]
            }
        }
    };
    let position = undefined;
    if (isChild && dataAttributes['data-group-index'] && dataAttributes['data-in-group-index'] || dataAttributes['data-child-index']) position = `${dataAttributes['data-group-index']},${dataAttributes['data-in-group-index'] || dataAttributes['data-child-index']}`;
    else if (dataAttributes['data-test-index']) position = `${dataAttributes['data-test-index']}`;
    if (position) analyticsMetadata.detail.position = position;
    if (value) analyticsMetadata.detail.value = value;
    if (isChild) analyticsMetadata.detail.groupLabel = {
        root: 'body',
        selector: `.${(0, $42202144cf456408$export$2e2bcd8739ae039).parent}[data-group-index="${dataAttributes['data-group-index']}"] .${(0, $42202144cf456408$export$2e2bcd8739ae039)['option-content']}`
    };
    return analyticsMetadata;
};




var $889a465928992b9e$export$2e2bcd8739ae039 = {
    "selectable-item": "awsui_selectable-item_15o6u_11e6r_145",
    "parent": "awsui_parent_15o6u_11e6r_164",
    "interactiveGroups": "awsui_interactiveGroups_15o6u_11e6r_164",
    "highlighted": "awsui_highlighted_15o6u_11e6r_164",
    "selected": "awsui_selected_15o6u_11e6r_164",
    "selectable-item-content": "awsui_selectable-item-content_15o6u_11e6r_167",
    "pad-bottom": "awsui_pad-bottom_15o6u_11e6r_171",
    "virtual": "awsui_virtual_15o6u_11e6r_178",
    "has-background": "awsui_has-background_15o6u_11e6r_181",
    "child": "awsui_child_15o6u_11e6r_184",
    "disabled": "awsui_disabled_15o6u_11e6r_190",
    "is-keyboard": "awsui_is-keyboard_15o6u_11e6r_205",
    "visual-refresh": "awsui_visual-refresh_15o6u_11e6r_215",
    "next-item-selected": "awsui_next-item-selected_15o6u_11e6r_229",
    "previous-item-selected": "awsui_previous-item-selected_15o6u_11e6r_239",
    "sticky": "awsui_sticky_15o6u_11e6r_271",
    "with-scrollbar": "awsui_with-scrollbar_15o6u_11e6r_290",
    "after-header": "awsui_after-header_15o6u_11e6r_293",
    "measure-strut": "awsui_measure-strut_15o6u_11e6r_322",
    "screenreader-content": "awsui_screenreader-content_15o6u_11e6r_334",
    "option-content": "awsui_option-content_15o6u_11e6r_340",
    "select-all": "awsui_select-all_15o6u_11e6r_344"
};


const $76c8d22f7e2aa462$var$SelectableItem = ({ children: content, ariaSelected: ariaSelected, ariaChecked: ariaChecked, selected: selected, highlighted: highlighted, disabled: disabled, hasBackground: hasBackground, isParent: isParent, isChild: isChild, isSelectAll: isSelectAll, virtualPosition: virtualPosition, padBottom: padBottom, disableContentStyling: disableContentStyling, isNextSelected: isNextSelected, isPreviousSelected: isPreviousSelected, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent, ariaPosinset: ariaPosinset, ariaSetsize: ariaSetsize, highlightType: highlightType, value: value, sticky: sticky, afterHeader: afterHeader, withScrollbar: withScrollbar, ...restProps }, ref)=>{
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const { className: className, ...rest } = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const classNames = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $889a465928992b9e$export$2e2bcd8739ae039)['selectable-item'], {
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).selected]: selected,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).highlighted]: highlighted,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['has-background']]: hasBackground,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).parent]: isParent,
        [(0, $42202144cf456408$export$2e2bcd8739ae039).parent]: isParent,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).child]: isChild,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['select-all']]: isSelectAll,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['is-keyboard']]: highlightType === 'keyboard',
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).disabled]: disabled,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).virtual]: virtualPosition !== undefined && !sticky,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['pad-bottom']]: padBottom,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['next-item-selected']]: isNextSelected,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['previous-item-selected']]: isPreviousSelected,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).interactiveGroups]: useInteractiveGroups,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).sticky]: sticky,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['after-header']]: !!afterHeader,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['with-scrollbar']]: withScrollbar,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['visual-refresh']]: isVisualRefresh
    });
    const contentClassNames = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $889a465928992b9e$export$2e2bcd8739ae039)['option-content'], (0, $42202144cf456408$export$2e2bcd8739ae039)['option-content'], {
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)['selectable-item-content']]: !disableContentStyling
    });
    const contentRef = (0, $acw62.useRef)(null);
    const screenReaderContentRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        // the state of aria-hidden and announcement is not set back because NVDA+Firefox would announce
        // the item which lost highlight
        // set aria-hidden true when there is announcement content, so that screen reader still announce
        // meaningful content when navigate with screen reader cursor
        // imperatively update to avoid announcement made multiple times when content updates
        if (highlighted && screenReaderContent) {
            if (contentRef.current) contentRef.current.setAttribute('aria-hidden', 'true');
            if (screenReaderContentRef.current) screenReaderContentRef.current.textContent = screenReaderContent;
        }
    }, [
        highlighted,
        screenReaderContent,
        contentRef,
        screenReaderContentRef
    ]);
    const style = virtualPosition !== undefined ? {
        transform: `translateY(${virtualPosition}px)`
    } : undefined;
    const a11yProperties = {};
    if (isParent && ariaChecked === undefined) a11yProperties.role = 'presentation';
    else {
        a11yProperties.role = 'option';
        a11yProperties['aria-disabled'] = disabled;
        if (ariaSelected !== undefined) a11yProperties['aria-selected'] = ariaSelected;
        // Safari+VO needs aria-checked for multi-selection. Otherwise it only announces selected option even though another option is highlighted.
        if (ariaChecked !== undefined) a11yProperties['aria-checked'] = ariaChecked;
        if (ariaPosinset && ariaSetsize) {
            a11yProperties['aria-posinset'] = ariaPosinset;
            a11yProperties['aria-setsize'] = ariaSetsize;
        }
        if (restProps.ariaDescribedby) a11yProperties['aria-describedby'] = restProps.ariaDescribedby;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classNames,
        style: style,
        ...a11yProperties,
        ...rest,
        ...isParent || disabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)((0, $a79cc6b55c309170$export$21c5fe65bde956fa)({
            isChild: isChild,
            value: value,
            ...restProps
        }))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: contentClassNames,
        ref: contentRef
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $889a465928992b9e$export$2e2bcd8739ae039)['measure-strut'],
        ref: ref
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $889a465928992b9e$export$2e2bcd8739ae039)['screenreader-content'],
        ref: screenReaderContentRef
    }));
};
var $76c8d22f7e2aa462$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($76c8d22f7e2aa462$var$SelectableItem);





const $41275999010a0acf$var$toSelectOptionGroupItem = (props)=>{
    var _a;
    return {
        type: 'group',
        index: (_a = props.virtualIndex) !== null && _a !== void 0 ? _a : props.index,
        option: props.option.option,
        disabled: props.disabled
    };
};
const $41275999010a0acf$var$toSelectOptionItem = (props)=>{
    var _a, _b, _c, _d;
    return {
        type: 'item',
        index: (_a = props.virtualIndex) !== null && _a !== void 0 ? _a : props.index,
        option: props.option.option,
        selected: props.selected,
        highlighted: props.highlighted,
        disabled: props.disabled,
        parent: props.parentProps ? $41275999010a0acf$var$toSelectOptionGroupItem({
            index: (_b = props.parentProps) === null || _b === void 0 ? void 0 : _b.index,
            virtualIndex: (_c = props.parentProps) === null || _c === void 0 ? void 0 : _c.virtualIndex,
            option: (_d = props.parentProps) === null || _d === void 0 ? void 0 : _d.option,
            disabled: props.disabled
        }) : null
    };
};
const $41275999010a0acf$var$Item = ({ index: index, virtualIndex: virtualIndex, option: option, highlighted: highlighted, selected: selected, filteringValue: filteringValue, hasCheckbox: hasCheckbox, virtualPosition: virtualPosition, padBottom: padBottom, isNextSelected: isNextSelected, isPreviousSelected: isPreviousSelected, screenReaderContent: screenReaderContent, ariaPosinset: ariaPosinset, ariaSetsize: ariaSetsize, highlightType: highlightType, withScrollbar: withScrollbar, sticky: sticky, renderOption: renderOption, parentProps: parentProps, ...restProps }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const isParent = option.type === 'parent';
    const isChild = option.type === 'child';
    const wrappedOption = option.option;
    const disabled = option.disabled || wrappedOption.disabled;
    const disabledReason = disabled && wrappedOption.disabledReason ? wrappedOption.disabledReason : '';
    const isDisabledWithReason = !!disabledReason;
    const internalRef = (0, $acw62.useRef)(null);
    const { descriptionEl: descriptionEl, descriptionId: descriptionId } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    const [canShowTooltip, setCanShowTooltip] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>setCanShowTooltip(true), [
        highlighted
    ]);
    const getSelectItemProps = (option)=>{
        if (option.type === 'parent') return $41275999010a0acf$var$toSelectOptionGroupItem({
            option: option,
            index: index,
            virtualIndex: virtualIndex,
            disabled: !!disabled
        });
        else return $41275999010a0acf$var$toSelectOptionItem({
            option: option,
            index: index,
            virtualIndex: virtualIndex,
            disabled: !!disabled,
            highlighted: !!highlighted,
            selected: !!selected,
            parentProps: parentProps
        });
    };
    const renderOptionWrapper = (option)=>{
        if (!renderOption) return null;
        return renderOption({
            item: getSelectItemProps(option),
            filterText: filteringValue
        });
    };
    const renderResult = renderOptionWrapper(option);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76c8d22f7e2aa462$export$2e2bcd8739ae039), {
        disableContentStyling: !!renderResult,
        ariaSelected: Boolean(selected),
        selected: selected,
        isNextSelected: isNextSelected,
        isPreviousSelected: isPreviousSelected,
        highlighted: highlighted,
        disabled: option.disabled,
        isParent: isParent,
        isChild: isChild,
        ref: (0, $013a2451794a45c0$exports.useMergeRefs)(ref, internalRef),
        virtualPosition: virtualPosition,
        padBottom: padBottom,
        screenReaderContent: screenReaderContent,
        ariaPosinset: ariaPosinset,
        ariaSetsize: ariaSetsize,
        highlightType: highlightType,
        ariaDescribedby: isDisabledWithReason ? descriptionId : '',
        value: option.option.value,
        withScrollbar: withScrollbar,
        sticky: sticky,
        ...baseProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).item, !isParent && wrappedOption.labelTag && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['show-label-tag'])
    }, !renderResult && hasCheckbox && !isParent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).checkbox
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90f2424593277d9$export$2e2bcd8739ae039), {
        checked: selected || false,
        disabled: option.disabled
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
        customContent: renderResult,
        option: {
            ...wrappedOption,
            disabled: disabled
        },
        highlightedOption: highlighted,
        selectedOption: selected,
        highlightText: filteringValue,
        isGroupOption: isParent
    }), !renderResult && !hasCheckbox && !isParent && selected && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['selected-icon']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "check"
    })), !renderResult && isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, highlighted && canShowTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['disabled-reason-tooltip'],
        getTrack: ()=>internalRef.current,
        content: disabledReason,
        position: "right",
        onEscape: ()=>setCanShowTooltip(false)
    }))));
};
var $41275999010a0acf$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($41275999010a0acf$var$Item));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








const $e079fe59697fd5d8$var$toMultiselectOptionGroupItem = (props)=>{
    var _a, _b;
    return {
        type: 'group',
        index: (_a = props.virtualIndex) !== null && _a !== void 0 ? _a : props.index,
        option: props.option.option,
        indeterminate: (_b = props.indeterminate) !== null && _b !== void 0 ? _b : false,
        selected: props.selected,
        highlighted: props.highlighted,
        disabled: props.disabled
    };
};
const $e079fe59697fd5d8$var$toMultiselectOptionItem = (props)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        type: 'item',
        index: (_a = props.virtualIndex) !== null && _a !== void 0 ? _a : props.index,
        option: props.option.option,
        selected: props.selected,
        highlighted: props.highlighted,
        disabled: props.disabled,
        parent: props.parentProps ? $e079fe59697fd5d8$var$toMultiselectOptionGroupItem({
            index: (_b = props.parentProps) === null || _b === void 0 ? void 0 : _b.index,
            virtualIndex: (_c = props.parentProps) === null || _c === void 0 ? void 0 : _c.virtualIndex,
            option: (_d = props.parentProps) === null || _d === void 0 ? void 0 : _d.option,
            disabled: props.disabled,
            highlighted: (_f = (_e = props.parentProps) === null || _e === void 0 ? void 0 : _e.highlighted) !== null && _f !== void 0 ? _f : false,
            indeterminate: (_h = (_g = props.parentProps) === null || _g === void 0 ? void 0 : _g.indeterminate) !== null && _h !== void 0 ? _h : false,
            selected: (_k = (_j = props.parentProps) === null || _j === void 0 ? void 0 : _j.selected) !== null && _k !== void 0 ? _k : false
        }) : null
    };
};
const $e079fe59697fd5d8$var$MultiSelectItem = ({ index: index, virtualIndex: virtualIndex, option: option, highlighted: highlighted, selected: selected, filteringValue: filteringValue, hasCheckbox: hasCheckbox, virtualPosition: virtualPosition, padBottom: padBottom, isNextSelected: isNextSelected, isPreviousSelected: isPreviousSelected, indeterminate: indeterminate, screenReaderContent: screenReaderContent, ariaPosinset: ariaPosinset, ariaSetsize: ariaSetsize, highlightType: highlightType, withScrollbar: withScrollbar, sticky: sticky, renderOption: renderOption, parentProps: parentProps, ...restProps }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const isParent = option.type === 'parent';
    const isChild = option.type === 'child';
    const isSelectAll = option.type === 'select-all';
    const wrappedOption = option.option;
    const disabled = option.disabled || wrappedOption.disabled;
    const disabledReason = disabled && (option.disabledReason || wrappedOption.disabledReason) ? option.disabledReason || wrappedOption.disabledReason : '';
    const isDisabledWithReason = !!disabledReason;
    const internalRef = (0, $acw62.useRef)(null);
    const className = (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).item;
    const { descriptionId: descriptionId, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    const [canShowTooltip, setCanShowTooltip] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>setCanShowTooltip(true), [
        highlighted
    ]);
    const getMultiselectItemProps = (option)=>{
        if (option.type === 'parent') return $e079fe59697fd5d8$var$toMultiselectOptionGroupItem({
            option: option,
            index: index,
            virtualIndex: virtualIndex,
            disabled: !!disabled,
            highlighted: !!highlighted,
            selected: !!selected,
            indeterminate: indeterminate !== null && indeterminate !== void 0 ? indeterminate : false
        });
        else if (option.type === 'select-all') return {
            type: 'select-all',
            option: option.option,
            indeterminate: indeterminate !== null && indeterminate !== void 0 ? indeterminate : false,
            selected: !!selected,
            highlighted: !!highlighted
        };
        else return $e079fe59697fd5d8$var$toMultiselectOptionItem({
            option: option,
            index: index,
            virtualIndex: virtualIndex,
            disabled: !!disabled,
            highlighted: !!highlighted,
            selected: !!selected,
            parentProps: parentProps
        });
    };
    const renderOptionWrapper = (option)=>{
        if (!renderOption) return null;
        return renderOption({
            item: getMultiselectItemProps(option),
            filterText: filteringValue
        });
    };
    const renderResult = renderOptionWrapper(option);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76c8d22f7e2aa462$export$2e2bcd8739ae039), {
        disableContentStyling: !!renderResult,
        ariaSelected: isParent && indeterminate ? undefined : Boolean(selected),
        ariaChecked: isParent && indeterminate ? 'mixed' : Boolean(selected),
        selected: selected,
        isNextSelected: isNextSelected,
        isPreviousSelected: isPreviousSelected,
        highlighted: highlighted,
        disabled: disabled,
        isParent: isParent,
        isChild: isChild,
        isSelectAll: isSelectAll,
        highlightType: highlightType,
        ref: (0, $013a2451794a45c0$exports.useMergeRefs)(ref, internalRef),
        virtualPosition: virtualPosition,
        padBottom: padBottom,
        useInteractiveGroups: true,
        screenReaderContent: screenReaderContent,
        ariaPosinset: ariaPosinset,
        ariaSetsize: ariaSetsize,
        ariaDescribedby: isDisabledWithReason ? descriptionId : '',
        value: option.option.value,
        afterHeader: option.afterHeader,
        withScrollbar: withScrollbar,
        sticky: sticky,
        ...baseProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className
    }, !renderResult && hasCheckbox && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).checkbox
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90f2424593277d9$export$2e2bcd8739ae039), {
        checked: selected,
        indeterminate: (isParent || isSelectAll) && indeterminate,
        disabled: disabled
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
        customContent: renderResult,
        option: {
            ...wrappedOption,
            disabled: disabled
        },
        highlightedOption: highlighted,
        selectedOption: selected,
        highlightText: filteringValue,
        isGroupOption: isParent
    })), !renderResult && isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, highlighted && canShowTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['disabled-reason-tooltip'],
        getTrack: ()=>internalRef.current,
        content: disabledReason,
        position: "right",
        onEscape: ()=>setCanShowTooltip(false)
    })));
};
var $e079fe59697fd5d8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($e079fe59697fd5d8$var$MultiSelectItem));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $5d21c6306de4d95d$export$2e2bcd8739ae039({ children: children, virtual: virtual, ariaLabelledby: ariaLabelledby, ariaDisabled: ariaDisabled }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['option-group'], virtual && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).virtual),
        "aria-labelledby": ariaLabelledby,
        "aria-disabled": ariaDisabled
    }, children);
}


const $319ac672533f1934$var$testIndexMap = new WeakMap();
const $319ac672533f1934$export$7a93927e4b42a61f = (item)=>$319ac672533f1934$var$testIndexMap.get(item);
const $319ac672533f1934$export$d803820991dee08 = (filteredItems, getParentGroup)=>{
    let throughIndex = 1;
    let groupIndex = 0;
    let inGroupIndex = 1;
    let currentGroup = null;
    filteredItems.forEach((item)=>{
        const isGroup = item.type === 'parent';
        const group = isGroup ? item : getParentGroup(item);
        if (group && group !== currentGroup) {
            currentGroup = group;
            groupIndex += 1;
            inGroupIndex = 1;
        }
        if (isGroup) $319ac672533f1934$var$testIndexMap.set(item, {
            groupIndex: groupIndex
        });
        else if (group && item.type === 'child') $319ac672533f1934$var$testIndexMap.set(item, {
            throughIndex: throughIndex++,
            groupIndex: groupIndex,
            inGroupIndex: inGroupIndex++
        });
        else if (item.type === 'child' || !item.type) $319ac672533f1934$var$testIndexMap.set(item, {
            throughIndex: throughIndex++
        });
    });
};


const $cbdf3adf00550b27$export$f075439baf9a4095 = ({ option: option, index: index, getOptionProps: getOptionProps, filteringValue: filteringValue, checkboxes: checkboxes = false })=>{
    const optionProps = getOptionProps(option, index);
    optionProps.filteringValue = filteringValue;
    const { inGroupIndex: inGroupIndex, groupIndex: groupIndex, throughIndex: throughIndex } = (0, $319ac672533f1934$export$7a93927e4b42a61f)(option) || {};
    return {
        ...optionProps,
        hasCheckbox: checkboxes,
        ['data-group-index']: groupIndex,
        ['data-child-index']: inGroupIndex,
        ['data-test-index']: throughIndex
    };
};


const $9b39d1324e4300f1$export$edde41d128e72035 = ({ options: options, getOptionProps: getOptionProps, filteringValue: filteringValue, highlightType: highlightType, idPrefix: idPrefix, checkboxes: checkboxes = false, hasDropdownStatus: hasDropdownStatus, virtualItems: virtualItems, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent, ariaSetsize: ariaSetsize, withScrollbar: withScrollbar, firstOptionSticky: firstOptionSticky, stickyOptionRef: stickyOptionRef, renderOption: renderOption })=>{
    const getNestedItemProps = ({ index: index, option: option })=>{
        const virtualItem = virtualItems && virtualItems[index];
        const globalIndex = virtualItem ? virtualItem.index : index;
        return (0, $cbdf3adf00550b27$export$f075439baf9a4095)({
            option: option,
            index: globalIndex,
            getOptionProps: getOptionProps,
            filteringValue: option.type === 'select-all' ? '' : filteringValue,
            checkboxes: checkboxes
        });
    };
    const renderListItem = (props, index, parentProps)=>{
        const virtualItem = virtualItems && virtualItems[index];
        const globalIndex = virtualItem ? virtualItem.index : index;
        const isLastItem = index === options.length - 1;
        const padBottom = !hasDropdownStatus && isLastItem;
        const ListItem = useInteractiveGroups ? (0, $e079fe59697fd5d8$export$2e2bcd8739ae039) : (0, $41275999010a0acf$export$2e2bcd8739ae039);
        const isSticky = firstOptionSticky && globalIndex === 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListItem, {
            index: index,
            virtualIndex: virtualItem ? virtualItem.index : undefined,
            key: globalIndex,
            ...props,
            virtualPosition: virtualItem === null || virtualItem === void 0 ? void 0 : virtualItem.start,
            ref: isSticky && stickyOptionRef ? stickyOptionRef : virtualItem && virtualItem.measureRef,
            padBottom: padBottom,
            screenReaderContent: screenReaderContent,
            ariaPosinset: globalIndex + 1,
            ariaSetsize: ariaSetsize,
            highlightType: highlightType.type,
            withScrollbar: withScrollbar,
            sticky: isSticky,
            renderOption: renderOption,
            parentProps: parentProps
        });
    };
    const unflattenedOptions = (0, $39828edae85cca10$export$1c15153076b74c08)(options);
    return unflattenedOptions.map((nestedDropdownOption)=>{
        var _a;
        const index = nestedDropdownOption.index;
        const props = getNestedItemProps(nestedDropdownOption);
        if (nestedDropdownOption.type === 'parent') {
            const { children: children } = nestedDropdownOption;
            const optionId = (_a = props.id) !== null && _a !== void 0 ? _a : `${idPrefix}-option-${index}`;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5d21c6306de4d95d$export$2e2bcd8739ae039), {
                key: `group-${index}`,
                virtual: (virtualItems === null || virtualItems === void 0 ? void 0 : virtualItems[index]) !== undefined,
                ariaLabelledby: optionId,
                ariaDisabled: props['aria-disabled']
            }, renderListItem(props, index), children.map((child)=>{
                var _a, _b, _c, _d, _e, _f;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    key: child.index
                }, renderListItem(getNestedItemProps(child), child.index, {
                    option: nestedDropdownOption.option,
                    disabled: (_a = nestedDropdownOption.option.disabled) !== null && _a !== void 0 ? _a : false,
                    index: index,
                    virtualIndex: (_c = (_b = virtualItems === null || virtualItems === void 0 ? void 0 : virtualItems[index]) === null || _b === void 0 ? void 0 : _b.index) !== null && _c !== void 0 ? _c : undefined,
                    highlighted: (_d = props.highlighted) !== null && _d !== void 0 ? _d : false,
                    selected: (_e = props.selected) !== null && _e !== void 0 ? _e : false,
                    indeterminate: (_f = props.indeterminate) !== null && _f !== void 0 ? _f : false
                }));
            }));
        }
        return renderListItem(props, index);
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $35b29d57f883e79f$export$2e2bcd8739ae039({ index: index, menuEl: menuEl }) {
    const item = menuEl.querySelector(`[data-mouse-target="${index}"]`);
    if (item) // In edge case dropdown can be very small, scrolling can cause side effect AWSUI-60318
    {
        if (menuEl.clientHeight !== undefined && menuEl.clientHeight > 15) {
            // We only want the menu element to scroll, as scrolling any further parent elements can
            // cause the screen to jump, resulting in a select item being "clicked" while opening the select.
            // Therefore, we scroll manually rather than using `scrollIntoView`.
            const menuRect = menuEl.getBoundingClientRect();
            const itemRect = item.getBoundingClientRect();
            const offset = parseInt(menuEl.style.scrollPaddingBlockStart) || 0;
            if (itemRect.top < menuRect.top + offset || itemRect.height > menuRect.height - offset) menuEl.scrollBy({
                top: itemRect.top - menuRect.top - offset
            });
            else if (itemRect.bottom > menuRect.bottom) menuEl.scrollBy({
                top: itemRect.bottom - menuRect.bottom
            });
        }
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1a73a942594fbff9$export$26569b4b78571e5d = 31;



const $e3f3b61849c4e04a$var$PlainList = ({ menuProps: menuProps, getOptionProps: getOptionProps, filteredOptions: filteredOptions, filteringValue: filteringValue, highlightType: highlightType, checkboxes: checkboxes, hasDropdownStatus: hasDropdownStatus, listBottom: listBottom, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent, firstOptionSticky: firstOptionSticky, isMultiSelect: isMultiSelect, renderOption: renderOption }, ref)=>{
    const idPrefix = (0, $013a2451794a45c0$exports.useUniqueId)('select-list-');
    const stickyOptionRef = (0, $acw62.useRef)(null);
    const [stickyOptionBlockSize, setStickyOptionBlockSize] = (0, $acw62.useState)(firstOptionSticky ? (0, $1a73a942594fbff9$export$26569b4b78571e5d) : 0);
    const [width, menuMeasureRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>{
        if (stickyOptionRef.current) // Cannot use container query on the sticky option individually because it is not rendered until the dropdown is open.
        // Not expecting the sticky option to change size without the dropdown also changing size.
        // The effects of using the sticky option block size to set the menu scroll padding are covered by integration tests.
        // istanbul ignore next
        setStickyOptionBlockSize(stickyOptionRef.current.clientHeight);
        return {
            inner: rect.contentBoxWidth,
            outer: rect.borderBoxWidth
        };
    });
    const menuRef = menuProps.ref;
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(menuMeasureRef, menuRef);
    (0, $acw62.useImperativeHandle)(ref, ()=>(index)=>{
            const isSticky = firstOptionSticky && index === 0;
            if (highlightType.moveFocus && menuRef.current && !isSticky) (0, $35b29d57f883e79f$export$2e2bcd8739ae039)({
                index: index,
                menuEl: menuRef.current
            });
        }, [
        firstOptionSticky,
        highlightType.moveFocus,
        menuRef
    ]);
    const withScrollbar = !!width && width.inner < width.outer;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), {
        ...menuProps,
        ref: mergedRef,
        stickyItemBlockSize: stickyOptionBlockSize,
        isMultiSelect: isMultiSelect
    }, (0, $9b39d1324e4300f1$export$edde41d128e72035)({
        renderOption: renderOption,
        options: filteredOptions,
        getOptionProps: getOptionProps,
        filteringValue: filteringValue,
        idPrefix: idPrefix,
        highlightType: highlightType,
        checkboxes: checkboxes,
        hasDropdownStatus: hasDropdownStatus,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: screenReaderContent,
        firstOptionSticky: firstOptionSticky,
        stickyOptionRef: stickyOptionRef,
        withScrollbar: withScrollbar
    }), listBottom ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "option",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['list-bottom']
    }, listBottom) : null);
};
var $e3f3b61849c4e04a$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($e3f3b61849c4e04a$var$PlainList);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $901609b99800953a$export$2e2bcd8739ae039 = {
    "button-trigger": "awsui_button-trigger_l32fn_xo3sj_5"
};



var $d46ca2f87d30af25$export$2e2bcd8739ae039 = {
    "button-trigger": "awsui_button-trigger_18eso_el76d_161",
    "arrow": "awsui_arrow_18eso_el76d_161",
    "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_el76d_221",
    "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_el76d_221",
    "has-caret": "awsui_has-caret_18eso_el76d_257",
    "placeholder": "awsui_placeholder_18eso_el76d_260",
    "pressed": "awsui_pressed_18eso_el76d_273",
    "disabled": "awsui_disabled_18eso_el76d_276",
    "in-filtering-token": "awsui_in-filtering-token_18eso_el76d_221",
    "readonly": "awsui_readonly_18eso_el76d_297",
    "invalid": "awsui_invalid_18eso_el76d_319",
    "warning": "awsui_warning_18eso_el76d_328",
    "custom-option": "awsui_custom-option_18eso_el76d_337",
    "inline-tokens": "awsui_inline-tokens_18eso_el76d_342"
};


const $35d168f0b5e99e77$var$ButtonTrigger = ({ children: children, pressed: pressed, hideCaret: hideCaret = false, disabled: disabled = false, readOnly: readOnly = false, invalid: invalid = false, warning: warning = false, inlineTokens: inlineTokens, inFilteringToken: inFilteringToken, ariaHasPopup: ariaHasPopup, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, ariaControls: ariaControls, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onClick: onClick, onFocus: onFocus, onBlur: onBlur, hasCustomContent: hasCustomContent = false, autoFocus: autoFocus, ...restProps }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    let attributes = {
        ...baseProps,
        type: 'button',
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d46ca2f87d30af25$export$2e2bcd8739ae039)['button-trigger'], (0, $901609b99800953a$export$2e2bcd8739ae039)['button-trigger'], baseProps.className, pressed && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).pressed, disabled && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).disabled, invalid && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).invalid, warning && !invalid && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).warning, !hideCaret && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)['has-caret'], readOnly && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).readonly, inFilteringToken && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)['in-filtering-token'], inFilteringToken && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)[`in-filtering-token-${inFilteringToken}`], inlineTokens && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)['inline-tokens'], !!hasCustomContent && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)['custom-option']),
        disabled: disabled,
        'aria-expanded': pressed,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby,
        'aria-describedby': ariaDescribedby,
        'aria-haspopup': ariaHasPopup !== null && ariaHasPopup !== void 0 ? ariaHasPopup : 'listbox',
        'aria-controls': ariaControls,
        'aria-disabled': readOnly && !disabled ? 'true' : undefined,
        autoFocus: autoFocus
    };
    if (!readOnly) attributes = {
        ...attributes,
        onKeyDown: onKeyDown && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event)),
        onKeyUp: onKeyUp && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyUp, event)),
        onMouseDown: onMouseDown && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onMouseDown, {}, event)),
        onClick: onClick && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, {}, event)),
        onFocus: onFocus && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onFocus, {}, event)),
        onBlur: onBlur && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onBlur, {
                relatedTarget: event.relatedTarget
            }, event))
    };
    if (invalid) attributes['aria-invalid'] = invalid;
    const analyticsMetadata = {
        action: !pressed ? 'expand' : 'collapse',
        detail: {
            label: {
                root: 'self'
            }
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        ...attributes,
        ...disabled || readOnly ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    }, children, !hideCaret && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).arrow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled",
        variant: disabled || readOnly ? 'disabled' : 'normal'
    })));
};
var $35d168f0b5e99e77$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($35d168f0b5e99e77$var$ButtonTrigger);





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









var $13c5031dfb5f5d1b$export$2e2bcd8739ae039 = {
    "token": "awsui_token_v05f6_c8hk2_5"
};




function $7a535bd9f95cc9dc$var$InternalToken({ label: // External
label, ariaLabel: ariaLabel, labelTag: labelTag, description: description, variant: variant = 'normal', disabled: disabled, readOnly: readOnly, icon: icon, tags: tags, dismissLabel: dismissLabel, onDismiss: onDismiss, tooltipContent: tooltipContent, role: // Internal
role, disableInnerPadding: disableInnerPadding, __internalRootRef: // Base
__internalRootRef, ...restProps }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const labelContainerRef = (0, $acw62.useRef)(null);
    const labelRef = (0, $acw62.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const [isEllipsisActive, setIsEllipsisActive] = (0, $acw62.useState)(false);
    const isInline = variant === 'inline';
    const ariaLabelledbyId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const isLabelOverflowing = ()=>{
        const labelContent = labelRef.current;
        const labelContainer = labelContainerRef.current;
        if (labelContent && labelContainer) return labelContent.offsetWidth > labelContainer.offsetWidth;
    };
    (0, $013a2451794a45c0$exports.useResizeObserver)(labelContainerRef, ()=>{
        var _a;
        if (isInline) setIsEllipsisActive((_a = isLabelOverflowing()) !== null && _a !== void 0 ? _a : false);
    });
    const buildOptionDefinition = ()=>{
        const isLabelStringOrNumber = typeof label === 'string' || typeof label === 'number';
        const labelObject = isLabelStringOrNumber ? {
            label: String(label)
        } : {
            labelContent: label
        };
        if (isInline) {
            if (!isLabelStringOrNumber) (0, $013a2451794a45c0$exports.warnOnce)('Label', `Only plain text (strings or numbers) are supported when variant="inline".`);
            return {
                ...labelObject,
                disabled: disabled,
                __customIcon: icon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $98573fdc0990a8b2$export$2e2bcd8739ae039).icon, (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['icon-inline'])
                }, icon)
            };
        } else return {
            ...labelObject,
            disabled: disabled,
            labelTag: labelTag,
            description: description,
            tags: tags,
            __customIcon: icon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $98573fdc0990a8b2$export$2e2bcd8739ae039).icon
            }, icon)
        };
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $98573fdc0990a8b2$export$2e2bcd8739ae039).root, (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039).token, (0, $dcd504446b2d2d64$export$2e2bcd8739ae039).root, !isInline ? (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-normal'] : (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-inline'], (0, $13c5031dfb5f5d1b$export$2e2bcd8739ae039).token, baseProps.className),
        "aria-label": ariaLabel,
        "aria-labelledby": !ariaLabel ? ariaLabelledbyId : undefined,
        "aria-disabled": !!disabled,
        role: role !== null && role !== void 0 ? role : 'group',
        onFocus: ()=>{
            setShowTooltip(true);
        },
        onBlur: ()=>{
            setShowTooltip(false);
        },
        onMouseEnter: ()=>{
            setShowTooltip(true);
        },
        onMouseLeave: ()=>{
            setShowTooltip(false);
        },
        tabIndex: !!tooltipContent && isInline && isEllipsisActive ? 0 : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(!isInline ? (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-box'] : (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-box-inline'], disabled && (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-box-disabled'], readOnly && (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-box-readonly'], !isInline && !onDismiss && (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-box-without-dismiss'], disableInnerPadding && (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['disable-padding'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(isInline && (0, $98573fdc0990a8b2$export$2e2bcd8739ae039)['token-option-inline']),
        triggerVariant: isInline,
        option: buildOptionDefinition(),
        disableTitleTooltip: !!tooltipContent,
        labelContainerRef: labelContainerRef,
        labelRef: labelRef,
        labelId: ariaLabelledbyId
    }), onDismiss && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3197154d56686200$export$2e2bcd8739ae039), {
        disabled: disabled,
        dismissLabel: dismissLabel,
        onDismiss: onDismiss,
        readOnly: readOnly,
        inline: isInline
    })), !!tooltipContent && isInline && isEllipsisActive && showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        "data-testid": "token-tooltip",
        getTrack: ()=>labelContainerRef.current,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "tooltip-live-region-content"
        }, tooltipContent)),
        onEscape: ()=>{
            setShowTooltip(false);
        }
    }));
}
var $7a535bd9f95cc9dc$export$2e2bcd8739ae039 = $7a535bd9f95cc9dc$var$InternalToken;



const $9c94b50b6f9902cf$var$Trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, controlId: controlId, invalid: invalid, inlineLabelText: inlineLabelText, warning: warning, triggerProps: triggerProps, selectedOption: selectedOption, selectedOptions: selectedOptions, triggerVariant: triggerVariant, inFilteringToken: inFilteringToken, isOpen: isOpen, placeholder: placeholder, disabled: disabled, readOnly: readOnly, renderOption: renderOption }, ref)=>{
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const generatedId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const id = controlId !== null && controlId !== void 0 ? controlId : generatedId;
    const triggerContentId = (0, $013a2451794a45c0$exports.useUniqueId)('trigger-content-');
    let ariaLabelledbyIds = (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabelledby, triggerContentId);
    let triggerContent = null;
    let hasCustomContent = false;
    if (triggerVariant === 'tokens') {
        if (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) {
            triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-token-trigger'], disabled && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-token-trigger--disabled'], isVisualRefresh && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['visual-refresh'])
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-token-list']
            }, selectedOptions.map(({ label: label }, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a535bd9f95cc9dc$export$2e2bcd8739ae039), {
                    key: i,
                    label: label,
                    variant: "inline",
                    disabled: disabled
                }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-token-counter'],
                id: triggerContentId
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-token-hidden-placeholder']
            }, placeholder), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "(", selectedOptions.length, ")")));
            ariaLabelledbyIds = ariaLabelledby;
        } else triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-disabled": "true",
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).placeholder, (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).trigger),
            id: triggerContentId
        }, placeholder);
    } else if (!selectedOption) triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-disabled": "true",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).placeholder, (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).trigger),
        id: triggerContentId
    }, placeholder);
    else if (triggerVariant === 'option') {
        const triggerCustomContent = renderOption === null || renderOption === void 0 ? void 0 : renderOption({
            filterText: undefined,
            item: {
                type: 'trigger',
                option: selectedOption
            }
        });
        if (triggerCustomContent) {
            hasCustomContent = true;
            triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
                customContent: triggerCustomContent,
                id: triggerContentId,
                option: {
                    ...selectedOption,
                    disabled: disabled
                },
                triggerVariant: true
            });
        } else triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
            id: triggerContentId,
            option: {
                ...selectedOption,
                disabled: disabled
            },
            triggerVariant: true
        });
    } else triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: triggerContentId,
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).trigger
    }, selectedOption.label || selectedOption.value);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(triggerProps.ref, ref);
    const triggerButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35d168f0b5e99e77$export$2e2bcd8739ae039), {
        ...triggerProps,
        id: id,
        ref: mergedRef,
        pressed: !!isOpen,
        disabled: disabled,
        readOnly: readOnly,
        invalid: invalid,
        warning: warning && !invalid,
        inFilteringToken: inFilteringToken,
        inlineTokens: triggerVariant === 'tokens',
        hasCustomContent: hasCustomContent,
        ariaDescribedby: ariaDescribedby,
        ariaLabelledby: ariaLabelledbyIds
    }, triggerContent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, inlineLabelText ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-label-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: controlId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-label'], disabled && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-label-disabled'], triggerVariant === 'tokens' && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-label-inline-tokens'])
    }, inlineLabelText), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['inline-label-trigger-wrapper']
    }, triggerButton)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, triggerButton));
});
var $9c94b50b6f9902cf$export$2e2bcd8739ae039 = $9c94b50b6f9902cf$var$Trigger;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
/**
 * Name: react-virtual
 * Version: 2.10.4
 * License: MIT
 * Private: false
 * Description: Hooks for virtualizing scrollable elements in React
 * Repository: undefined
 * Homepage: https://github.com/tannerlinsley/react-virtual#readme
 * Author: tannerlinsley
 * License Copyright:
 * ===
 *
 * MIT License
 *
 * Copyright (c) 2019 Tanner Linsley
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
var $acw62 = parcelRequire("acw62");
function $7944ff2e8f91c451$var$_extends() {
    $7944ff2e8f91c451$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7944ff2e8f91c451$var$_extends.apply(this, arguments);
}
function $7944ff2e8f91c451$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7944ff2e8f91c451$var$props = [
    'bottom',
    'height',
    'left',
    'right',
    'top',
    'width'
];
var $7944ff2e8f91c451$var$rectChanged = function rectChanged(a, b) {
    if (a === void 0) a = {};
    if (b === void 0) b = {};
    return $7944ff2e8f91c451$var$props.some(function(prop) {
        return a[prop] !== b[prop];
    });
};
var $7944ff2e8f91c451$var$observedNodes = /*#__PURE__*/ new Map();
var $7944ff2e8f91c451$var$rafId;
var $7944ff2e8f91c451$var$run = function run() {
    var changedStates = [];
    $7944ff2e8f91c451$var$observedNodes.forEach(function(state, node) {
        var newRect = node.getBoundingClientRect();
        if ($7944ff2e8f91c451$var$rectChanged(newRect, state.rect)) {
            state.rect = newRect;
            changedStates.push(state);
        }
    });
    changedStates.forEach(function(state) {
        state.callbacks.forEach(function(cb) {
            return cb(state.rect);
        });
    });
    $7944ff2e8f91c451$var$rafId = window.requestAnimationFrame(run);
};
function $7944ff2e8f91c451$var$observeRect(node, cb) {
    return {
        observe: function observe() {
            var wasEmpty = $7944ff2e8f91c451$var$observedNodes.size === 0;
            if ($7944ff2e8f91c451$var$observedNodes.has(node)) $7944ff2e8f91c451$var$observedNodes.get(node).callbacks.push(cb);
            else $7944ff2e8f91c451$var$observedNodes.set(node, {
                rect: undefined,
                hasRectChanged: false,
                callbacks: [
                    cb
                ]
            });
            if (wasEmpty) $7944ff2e8f91c451$var$run();
        },
        unobserve: function unobserve() {
            var state = $7944ff2e8f91c451$var$observedNodes.get(node);
            if (state) {
                // Remove the callback
                var index = state.callbacks.indexOf(cb);
                if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference
                if (!state.callbacks.length) $7944ff2e8f91c451$var$observedNodes["delete"](node); // Stop the loop
                if (!$7944ff2e8f91c451$var$observedNodes.size) cancelAnimationFrame($7944ff2e8f91c451$var$rafId);
            }
        }
    };
}
var $7944ff2e8f91c451$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect;
function $7944ff2e8f91c451$var$useRect(nodeRef, initialRect) {
    if (initialRect === void 0) initialRect = {
        width: 0,
        height: 0
    };
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(nodeRef.current), element = _React$useState[0], setElement = _React$useState[1];
    var _React$useReducer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer($7944ff2e8f91c451$var$rectReducer, initialRect), rect = _React$useReducer[0], dispatch = _React$useReducer[1];
    var initialRectSet = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (nodeRef.current !== element) setElement(nodeRef.current);
    });
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (element && !initialRectSet.current) {
            initialRectSet.current = true;
            var _rect = element.getBoundingClientRect();
            dispatch({
                rect: _rect
            });
        }
    }, [
        element
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!element) return;
        var observer = $7944ff2e8f91c451$var$observeRect(element, function(rect) {
            dispatch({
                rect: rect
            });
        });
        observer.observe();
        return function() {
            observer.unobserve();
        };
    }, [
        element
    ]);
    return rect;
}
function $7944ff2e8f91c451$var$rectReducer(state, action) {
    var rect = action.rect;
    if (state.height !== rect.height || state.width !== rect.width) return rect;
    return state;
}
var $7944ff2e8f91c451$var$defaultEstimateSize = function defaultEstimateSize() {
    return 50;
};
var $7944ff2e8f91c451$var$defaultKeyExtractor = function defaultKeyExtractor(index) {
    return index;
};
var $7944ff2e8f91c451$var$defaultMeasureSize = function defaultMeasureSize(el, horizontal) {
    var key = horizontal ? 'offsetWidth' : 'offsetHeight';
    return el[key];
};
var $7944ff2e8f91c451$export$7eb7cb13fd21e5e1 = function defaultRangeExtractor(range) {
    var start = Math.max(range.start - range.overscan, 0);
    var end = Math.min(range.end + range.overscan, range.size - 1);
    var arr = [];
    for(var i = start; i <= end; i++)arr.push(i);
    return arr;
};
function $7944ff2e8f91c451$export$ebc1863da693699a(_ref) {
    var _measurements;
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 0 : _ref$size, _ref$estimateSize = _ref.estimateSize, estimateSize = _ref$estimateSize === void 0 ? $7944ff2e8f91c451$var$defaultEstimateSize : _ref$estimateSize, _ref$overscan = _ref.overscan, overscan = _ref$overscan === void 0 ? 1 : _ref$overscan, _ref$paddingStart = _ref.paddingStart, paddingStart = _ref$paddingStart === void 0 ? 0 : _ref$paddingStart, _ref$paddingEnd = _ref.paddingEnd, paddingEnd = _ref$paddingEnd === void 0 ? 0 : _ref$paddingEnd, parentRef = _ref.parentRef, horizontal = _ref.horizontal, scrollToFn = _ref.scrollToFn, useObserver = _ref.useObserver, initialRect = _ref.initialRect, onScrollElement = _ref.onScrollElement, scrollOffsetFn = _ref.scrollOffsetFn, _ref$keyExtractor = _ref.keyExtractor, keyExtractor = _ref$keyExtractor === void 0 ? $7944ff2e8f91c451$var$defaultKeyExtractor : _ref$keyExtractor, _ref$measureSize = _ref.measureSize, measureSize = _ref$measureSize === void 0 ? $7944ff2e8f91c451$var$defaultMeasureSize : _ref$measureSize, _ref$rangeExtractor = _ref.rangeExtractor, rangeExtractor = _ref$rangeExtractor === void 0 ? $7944ff2e8f91c451$export$7eb7cb13fd21e5e1 : _ref$rangeExtractor;
    var sizeKey = horizontal ? 'width' : 'height';
    var scrollKey = horizontal ? 'scrollLeft' : 'scrollTop';
    var latestRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        scrollOffset: 0,
        measurements: []
    });
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), scrollOffset = _React$useState[0], setScrollOffset = _React$useState[1];
    latestRef.current.scrollOffset = scrollOffset;
    var useMeasureParent = useObserver || $7944ff2e8f91c451$var$useRect;
    var _useMeasureParent = useMeasureParent(parentRef, initialRect), outerSize = _useMeasureParent[sizeKey];
    latestRef.current.outerSize = outerSize;
    var defaultScrollToFn = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(offset) {
        if (parentRef.current) parentRef.current[scrollKey] = offset;
    }, [
        parentRef,
        scrollKey
    ]);
    var resolvedScrollToFn = scrollToFn || defaultScrollToFn;
    scrollToFn = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(offset) {
        resolvedScrollToFn(offset, defaultScrollToFn);
    }, [
        defaultScrollToFn,
        resolvedScrollToFn
    ]);
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({}), measuredCache = _React$useState2[0], setMeasuredCache = _React$useState2[1];
    var measure = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function() {
        return setMeasuredCache({});
    }, []);
    var pendingMeasuredCacheIndexesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    var measurements = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var min = pendingMeasuredCacheIndexesRef.current.length > 0 ? Math.min.apply(Math, pendingMeasuredCacheIndexesRef.current) : 0;
        pendingMeasuredCacheIndexesRef.current = [];
        var measurements = latestRef.current.measurements.slice(0, min);
        for(var i = min; i < size; i++){
            var key = keyExtractor(i);
            var measuredSize = measuredCache[key];
            var _start = measurements[i - 1] ? measurements[i - 1].end : paddingStart;
            var _size = typeof measuredSize === 'number' ? measuredSize : estimateSize(i);
            var _end = _start + _size;
            measurements[i] = {
                index: i,
                start: _start,
                size: _size,
                end: _end,
                key: key
            };
        }
        return measurements;
    }, [
        estimateSize,
        measuredCache,
        paddingStart,
        size,
        keyExtractor
    ]);
    var totalSize = (((_measurements = measurements[size - 1]) == null ? void 0 : _measurements.end) || paddingStart) + paddingEnd;
    latestRef.current.measurements = measurements;
    latestRef.current.totalSize = totalSize;
    var element = onScrollElement ? onScrollElement.current : parentRef.current;
    var scrollOffsetFnRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(scrollOffsetFn);
    scrollOffsetFnRef.current = scrollOffsetFn;
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (!element) {
            setScrollOffset(0);
            return;
        }
        var onScroll = function onScroll(event) {
            var offset = scrollOffsetFnRef.current ? scrollOffsetFnRef.current(event) : element[scrollKey];
            setScrollOffset(offset);
        };
        onScroll();
        element.addEventListener('scroll', onScroll, {
            capture: false,
            passive: true
        });
        return function() {
            element.removeEventListener('scroll', onScroll);
        };
    }, [
        element,
        scrollKey
    ]);
    var _calculateRange = $7944ff2e8f91c451$var$calculateRange(latestRef.current), start = _calculateRange.start, end = _calculateRange.end;
    var indexes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return rangeExtractor({
            start: start,
            end: end,
            overscan: overscan,
            size: measurements.length
        });
    }, [
        start,
        end,
        overscan,
        measurements.length,
        rangeExtractor
    ]);
    var measureSizeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(measureSize);
    measureSizeRef.current = measureSize;
    var virtualItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var virtualItems = [];
        var _loop = function _loop(k, len) {
            var i = indexes[k];
            var measurement = measurements[i];
            var item = $7944ff2e8f91c451$var$_extends($7944ff2e8f91c451$var$_extends({}, measurement), {}, {
                measureRef: function measureRef(el) {
                    if (el) {
                        var measuredSize = measureSizeRef.current(el, horizontal);
                        if (measuredSize !== item.size) {
                            var _scrollOffset = latestRef.current.scrollOffset;
                            if (item.start < _scrollOffset) defaultScrollToFn(_scrollOffset + (measuredSize - item.size));
                            pendingMeasuredCacheIndexesRef.current.push(i);
                            setMeasuredCache(function(old) {
                                var _extends2;
                                return $7944ff2e8f91c451$var$_extends($7944ff2e8f91c451$var$_extends({}, old), {}, (_extends2 = {}, _extends2[item.key] = measuredSize, _extends2));
                            });
                        }
                    }
                }
            });
            virtualItems.push(item);
        };
        for(var k = 0, len = indexes.length; k < len; k++)_loop(k);
        return virtualItems;
    }, [
        indexes,
        defaultScrollToFn,
        horizontal,
        measurements
    ]);
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (mountedRef.current) setMeasuredCache({});
        mountedRef.current = true;
    }, [
        estimateSize
    ]);
    var scrollToOffset = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(toOffset, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$align = _ref2.align, align = _ref2$align === void 0 ? 'start' : _ref2$align;
        var _latestRef$current = latestRef.current, scrollOffset = _latestRef$current.scrollOffset, outerSize = _latestRef$current.outerSize;
        if (align === 'auto') {
            if (toOffset <= scrollOffset) align = 'start';
            else if (toOffset >= scrollOffset + outerSize) align = 'end';
            else align = 'start';
        }
        if (align === 'start') scrollToFn(toOffset);
        else if (align === 'end') scrollToFn(toOffset - outerSize);
        else if (align === 'center') scrollToFn(toOffset - outerSize / 2);
    }, [
        scrollToFn
    ]);
    var tryScrollToIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(index, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$align = _ref3.align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, rest = $7944ff2e8f91c451$var$_objectWithoutPropertiesLoose(_ref3, [
            "align"
        ]);
        var _latestRef$current2 = latestRef.current, measurements = _latestRef$current2.measurements, scrollOffset = _latestRef$current2.scrollOffset, outerSize = _latestRef$current2.outerSize;
        var measurement = measurements[Math.max(0, Math.min(index, size - 1))];
        if (!measurement) return;
        if (align === 'auto') {
            if (measurement.end >= scrollOffset + outerSize) align = 'end';
            else if (measurement.start <= scrollOffset) align = 'start';
            else return;
        }
        var toOffset = align === 'center' ? measurement.start + measurement.size / 2 : align === 'end' ? measurement.end : measurement.start;
        scrollToOffset(toOffset, $7944ff2e8f91c451$var$_extends({
            align: align
        }, rest));
    }, [
        scrollToOffset,
        size
    ]);
    var scrollToIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // We do a double request here because of
        // dynamic sizes which can cause offset shift
        // and end up in the wrong spot. Unfortunately,
        // we can't know about those dynamic sizes until
        // we try and render them. So double down!
        tryScrollToIndex.apply(void 0, args);
        requestAnimationFrame(function() {
            tryScrollToIndex.apply(void 0, args);
        });
    }, [
        tryScrollToIndex
    ]);
    return {
        virtualItems: virtualItems,
        totalSize: totalSize,
        scrollToOffset: scrollToOffset,
        scrollToIndex: scrollToIndex,
        measure: measure
    };
}
var $7944ff2e8f91c451$var$findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
    while(low <= high){
        var middle = (low + high) / 2 | 0;
        var currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $7944ff2e8f91c451$var$calculateRange(_ref4) {
    var measurements = _ref4.measurements, outerSize = _ref4.outerSize, scrollOffset = _ref4.scrollOffset;
    var size = measurements.length - 1;
    var getOffset = function getOffset(index) {
        return measurements[index].start;
    };
    var start = $7944ff2e8f91c451$var$findNearestBinarySearch(0, size, getOffset, scrollOffset);
    var end = start;
    while(end < size && measurements[end].end < scrollOffset + outerSize)end++;
    return {
        start: start,
        end: end
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $ab9bcca4a89d8bd5$export$2e2bcd8739ae039(range) {
    const defaultRange = (0, $7944ff2e8f91c451$export$7eb7cb13fd21e5e1)(range);
    return defaultRange[0] === 0 ? defaultRange : [
        0,
        ...defaultRange
    ];
}


// Maximum allowed synchronous (nested) item mounts before forcing a bail-out.
// Mirrors React’s internal safeguard for nested updates: React throws
// "Maximum update depth exceeded" once >50 sync updates occur within a single commit.
// See: https://github.com/facebook/react/commit/d8c90fa48d3addefe4b805ec56a3c65e4ee39127
const $ff607ed83f96c87f$var$MAX_ITEM_MOUNTS = 49;
function $ff607ed83f96c87f$export$ebc1863da693699a({ items: items, parentRef: parentRef, estimateSize: estimateSize, firstItemSticky: firstItemSticky }) {
    var _a, _b;
    const rowVirtualizer = (0, $7944ff2e8f91c451$export$ebc1863da693699a)({
        size: items.length,
        parentRef: parentRef,
        estimateSize: estimateSize,
        overscan: 5,
        rangeExtractor: firstItemSticky ? (0, $ab9bcca4a89d8bd5$export$2e2bcd8739ae039) : undefined
    });
    // Cache virtual item mounts to limit the amount of mounts per item.
    const measuresCache = (0, $acw62.useRef)(new WeakMap());
    // Clear mounts cache every time indices, items, or size estimate change.
    const indicesKey = rowVirtualizer.virtualItems.map((item)=>`${item.index}`).join(':');
    (0, $acw62.useEffect)(()=>{
        measuresCache.current = new WeakMap();
    }, [
        indicesKey,
        items,
        estimateSize
    ]);
    const virtualItems = (0, $acw62.useMemo)(()=>rowVirtualizer.virtualItems.map((virtualItem)=>({
                ...virtualItem,
                start: virtualItem.start,
                measureRef: (node)=>{
                    var _a;
                    const mountedCount = (_a = measuresCache.current.get(items[virtualItem.index])) !== null && _a !== void 0 ? _a : 0;
                    if (mountedCount < $ff607ed83f96c87f$var$MAX_ITEM_MOUNTS) {
                        virtualItem.measureRef(node);
                        measuresCache.current.set(items[virtualItem.index], mountedCount + 1);
                    }
                }
            })), [
        items,
        rowVirtualizer.virtualItems
    ]);
    // If first item is sticky, substract that item's size from the total size
    const firstItemSize = (_b = (_a = virtualItems[0]) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 0;
    const adjustedTotalSize = firstItemSticky ? rowVirtualizer.totalSize - firstItemSize : rowVirtualizer.totalSize;
    return {
        virtualItems: virtualItems,
        totalSize: adjustedTotalSize,
        scrollToIndex: rowVirtualizer.scrollToIndex
    };
}






const $ef788f2229336596$var$VirtualList = (props, ref)=>{
    return props.menuProps.open ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ef788f2229336596$var$VirtualListOpen, {
        ...props,
        ref: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ef788f2229336596$var$VirtualListClosed, {
        ...props,
        ref: ref
    });
};
const $ef788f2229336596$var$VirtualListOpen = (0, $acw62.forwardRef)(({ menuProps: menuProps, getOptionProps: getOptionProps, filteredOptions: filteredOptions, filteringValue: filteringValue, highlightType: highlightType, checkboxes: checkboxes, hasDropdownStatus: hasDropdownStatus, listBottom: listBottom, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent, firstOptionSticky: firstOptionSticky, isMultiSelect: isMultiSelect, renderOption: renderOption }, ref)=>{
    // update component, when it gets wider or narrower to reposition items
    const [width, menuMeasureRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>({
            inner: rect.contentBoxWidth,
            outer: rect.borderBoxWidth
        }), []);
    const menuRefObject = (0, $acw62.useRef)(null);
    const menuRef = (0, $013a2451794a45c0$exports.useMergeRefs)(menuMeasureRef, menuRefObject, menuProps.ref);
    const previousHighlightedIndex = (0, $acw62.useRef)();
    const { virtualItems: virtualItems, totalSize: totalSize, scrollToIndex: scrollToIndex } = (0, $ff607ed83f96c87f$export$ebc1863da693699a)({
        items: filteredOptions,
        parentRef: menuRefObject,
        // estimateSize is a dependency of measurements memo. We update it to force full recalculation
        // when the height of any option could have changed:
        // 1: because the component got resized (width property got updated)
        // 2: because the option changed its content (filteringValue property controls the highlight and the visibility of hidden tags)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        estimateSize: (0, $acw62.useCallback)(()=>(0, $1a73a942594fbff9$export$26569b4b78571e5d), [
            width === null || width === void 0 ? void 0 : width.inner,
            filteringValue
        ]),
        firstItemSticky: firstOptionSticky
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>(index)=>{
            if (highlightType.moveFocus) {
                const movingUp = previousHighlightedIndex.current !== undefined && index < previousHighlightedIndex.current;
                if (firstOptionSticky && movingUp && index !== 0 && menuRefObject.current) // React-Virtual v2 does not offer a proper way to handle sticky elements when scrolling,
                // so until we upgrade to v3, use our own scroll implementation
                // to prevent newly highlighted element from being covered by the sticky element
                // when moving the highlight upwards in the list.
                // Scrolling behavior is covered by integration tests.
                // istanbul ignore next
                (0, $35b29d57f883e79f$export$2e2bcd8739ae039)({
                    index: index,
                    menuEl: menuRefObject === null || menuRefObject === void 0 ? void 0 : menuRefObject.current
                });
                else // Fix for AWSUI-61506. Defer scroll to next frame to ensure
                // virtual items are measured after re-render. When called from
                // parent's useEffect, measurements may not be ready yet.
                requestAnimationFrame(()=>scrollToIndex(index));
            }
            previousHighlightedIndex.current = index;
        }, [
        firstOptionSticky,
        highlightType.moveFocus,
        scrollToIndex
    ]);
    const stickySize = firstOptionSticky ? virtualItems[0].size : 0;
    const withScrollbar = !!width && width.inner < width.outer;
    const idPrefix = (0, $013a2451794a45c0$exports.useUniqueId)('select-list-');
    const finalOptions = (0, $9b39d1324e4300f1$export$edde41d128e72035)({
        options: virtualItems.map(({ index: index })=>filteredOptions[index]),
        renderOption: renderOption,
        getOptionProps: getOptionProps,
        filteringValue: filteringValue,
        highlightType: highlightType,
        idPrefix: idPrefix,
        checkboxes: checkboxes,
        hasDropdownStatus: hasDropdownStatus,
        virtualItems: virtualItems,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: screenReaderContent,
        firstOptionSticky: firstOptionSticky,
        withScrollbar: withScrollbar
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), {
        ...menuProps,
        stickyItemBlockSize: stickySize,
        ref: menuRef,
        isMultiSelect: isMultiSelect
    }, finalOptions, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        key: "total-size",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['layout-strut'],
        style: {
            height: totalSize
        }
    }), listBottom ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "option",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['list-bottom']
    }, listBottom) : null);
});
const $ef788f2229336596$var$VirtualListClosed = (0, $acw62.forwardRef)(({ menuProps: menuProps, listBottom: listBottom, isMultiSelect: isMultiSelect }, ref)=>{
    (0, $acw62.useImperativeHandle)(ref, ()=>()=>{}, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), {
        ...menuProps,
        ref: menuProps.ref,
        isMultiSelect: isMultiSelect
    }, listBottom ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "option",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)['list-bottom']
    }, listBottom) : null);
});
var $ef788f2229336596$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($ef788f2229336596$var$VirtualList);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");












function $8f8026664024aac9$export$2e2bcd8739ae039({ alignment: alignment, items: items, onDismiss: onDismiss, limit: limit, i18nStrings: i18nStrings, disableOuterPadding: disableOuterPadding, limitShowFewerAriaLabel: limitShowFewerAriaLabel, limitShowMoreAriaLabel: limitShowMoreAriaLabel, readOnly: readOnly, isItemReadOnly: isItemReadOnly, __internalRootRef: __internalRootRef, ...props }) {
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)('TokenGroup', 'items', items, 'onDismiss', onDismiss);
    const [nextFocusIndex, setNextFocusIndex] = (0, $acw62.useState)(null);
    const tokenListRef = (0, $b53452f0d99d5bc4$export$62f3f0e010c1e172)({
        nextFocusIndex: nextFocusIndex,
        onFocusMoved: (target)=>{
            target.focus();
            setNextFocusIndex(null);
        },
        listItemSelector: `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)['list-item']}`,
        showMoreSelector: `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).toggle}`
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const hasItems = items.length > 0;
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(__internalRootRef, tokenListRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039).root, hasItems && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)['has-items'], disableOuterPadding && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)['no-padding']),
        ref: mergedRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e34c3ccd4808258$export$2e2bcd8739ae039), {
        alignment: alignment,
        items: items,
        limit: limit,
        renderItem: (item, itemIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a535bd9f95cc9dc$export$2e2bcd8739ae039), {
                ...item,
                label: item.label,
                key: itemIndex,
                onDismiss: ()=>{
                    (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
                        itemIndex: itemIndex
                    });
                    setNextFocusIndex(itemIndex);
                },
                readOnly: readOnly || (isItemReadOnly === null || isItemReadOnly === void 0 ? void 0 : isItemReadOnly(item)),
                variant: 'normal',
                icon: item.iconName || item.iconUrl || item.iconSvg ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
                    name: item.iconName,
                    svg: item.iconSvg,
                    url: item.iconUrl,
                    ariaLabel: item.iconAlt,
                    size: 'normal'
                }) : undefined,
                ...item.disabled || readOnly ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
                    detail: {
                        position: `${itemIndex + 1}`
                    }
                })
            }),
        i18nStrings: i18nStrings,
        limitShowFewerAriaLabel: limitShowFewerAriaLabel,
        limitShowMoreAriaLabel: limitShowMoreAriaLabel,
        onExpandedClick: (isExpanded)=>{
            if (isExpanded && limit) setNextFocusIndex(limit);
            else setNextFocusIndex(null);
        }
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



const $a3e6bb5a1ebc1aee$var$searchableFields = [
    'value',
    'label',
    'description',
    'labelTag'
];
const $a3e6bb5a1ebc1aee$export$10ef3d2ac5f88595 = (value, searchText, strictMatching)=>{
    if (!value) return false;
    const index = value.toLowerCase().indexOf(searchText);
    return strictMatching ? index === 0 : index > -1;
};
const $a3e6bb5a1ebc1aee$var$matchesSingleOption = (dropdownOption, text, strictMatching)=>{
    const searchText = text.toLowerCase();
    const option = dropdownOption.option;
    const searchStrFields = (attr)=>$a3e6bb5a1ebc1aee$export$10ef3d2ac5f88595(option[attr], searchText, strictMatching);
    const searchTagsFields = (attr)=>{
        var _a;
        return (_a = option[attr]) === null || _a === void 0 ? void 0 : _a.some((value)=>$a3e6bb5a1ebc1aee$export$10ef3d2ac5f88595(value, searchText, strictMatching));
    };
    const searchableTagFields = [
        'tags'
    ];
    if (!strictMatching) searchableTagFields.push('filteringTags');
    return $a3e6bb5a1ebc1aee$var$searchableFields.some(searchStrFields) || searchableTagFields.some(searchTagsFields);
};
const $a3e6bb5a1ebc1aee$export$60d56ed3961c839c = (options, searchText, strictMatching = false)=>{
    if (searchText === '') return options;
    let currentGroup = null;
    let parentMatched = false;
    return options.reduce((acc, option)=>{
        if (option.type === 'parent') {
            parentMatched = false;
            currentGroup = option;
            if ($a3e6bb5a1ebc1aee$var$matchesSingleOption(option, searchText, strictMatching)) {
                parentMatched = true;
                acc.push(currentGroup);
            }
            return acc;
        }
        if (option.type !== 'child') {
            currentGroup = null;
            parentMatched = false;
        }
        if (parentMatched) acc.push(option);
        else if ($a3e6bb5a1ebc1aee$var$matchesSingleOption(option, searchText, strictMatching)) {
            if (currentGroup) {
                acc.push(currentGroup);
                currentGroup = null;
            }
            acc.push(option);
        }
        return acc;
    }, []);
};
const $a3e6bb5a1ebc1aee$export$6af67c5380a168e2 = (option)=>!!option && !option.disabled && option.type !== 'parent';
const $a3e6bb5a1ebc1aee$export$8269a10a0c239702 = (option)=>!!option && !option.disabled;
const $a3e6bb5a1ebc1aee$export$d7976824e9f55785 = (option)=>{
    const key = 'options';
    return !!option && key in option && !!option.options;
};





const $2c9d1cbc9ede1e89$export$7baa7c13b358b002 = (options)=>{
    const parentMap = new Map();
    const flatOptions = options.reduce((acc, option)=>{
        if ((0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(option)) {
            const { options: options, ...rest } = option;
            const parentDropdownOption = {
                type: 'parent',
                option: option
            };
            const allOptionsDisabled = options.every((option)=>option.disabled);
            if (option.disabled || allOptionsDisabled) parentDropdownOption.disabled = true;
            acc.push(parentDropdownOption);
            options.forEach((child)=>{
                const childDropdownOption = {
                    type: 'child',
                    option: child
                };
                if (rest.disabled || child.disabled) childDropdownOption.disabled = true;
                acc.push(childDropdownOption);
                parentMap.set(childDropdownOption, parentDropdownOption);
            });
        } else {
            const dropdownOption = {
                option: option
            };
            if (option.disabled) dropdownOption.disabled = true;
            acc.push(dropdownOption);
        }
        return acc;
    }, []);
    return {
        flatOptions: flatOptions,
        parentMap: parentMap
    };
};


function $842e88ad945f2818$export$3b43bf09494a926b(options, filteringType, filteringText) {
    const { flatOptions: flatOptions, parentMap: parentMap } = (0, $2c9d1cbc9ede1e89$export$7baa7c13b358b002)(options);
    const filteredOptions = filteringType !== 'auto' ? flatOptions : (0, $a3e6bb5a1ebc1aee$export$60d56ed3961c839c)(flatOptions, filteringText);
    (0, $319ac672533f1934$export$d803820991dee08)(filteredOptions, parentMap.get.bind(parentMap));
    return {
        flatOptions: flatOptions,
        filteredOptions: filteredOptions,
        parentMap: parentMap,
        totalCount: flatOptions.length,
        matchesCount: filteredOptions.length
    };
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $1f218afa2afb7e05$export$a967962c200ab07c(componentName, propertyName, propertyValue) {
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (!propertyValue) return;
        // The `in` checks below are intentional: `element` is `any` (loosely-typed external input),
        // so compile-time `keyof` validation is not possible. These checks validate runtime shape.
        const valuePropertyMissing = !propertyValue.every((element)=>{
            return 'options' in element || 'value' in element;
        });
        if (valuePropertyMissing) (0, $013a2451794a45c0$exports.warnOnce)(componentName, `You provided an \`${propertyName}\` prop where at least one non-group array element is missing the \`value\` field. This field is required for all options without sub-items.`);
    }
}


const $80c0308d36c0fca6$export$c85ed1874bcf2a02 = (options, selectedOptions)=>{
    return (selectedOptions || []).map((selectedOption)=>{
        for (const dropdownOption of options){
            if (dropdownOption.type !== 'parent' && dropdownOption.option.value === selectedOption.value) return dropdownOption;
        }
        return {
            option: selectedOption
        };
    });
};
const $80c0308d36c0fca6$export$333e23643ef496e4 = (options, option)=>{
    for(let index = 0; index < options.length; index++){
        const __option = options[index];
        if (__option === option || __option.value === option.value) return index;
    }
    return -1;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $46b116ae1da6db28$var$getMatchingFilteringTags(filteringTags, highlightText) {
    if (!highlightText || !filteringTags) return [];
    return filteringTags.filter((filteringTag)=>(0, $a3e6bb5a1ebc1aee$export$10ef3d2ac5f88595)(filteringTag, highlightText, false));
}
function $46b116ae1da6db28$var$defaultOptionDescription({ option: option, parentGroup: parentGroup, highlightText: highlightText }) {
    return [
        parentGroup && parentGroup.label,
        option.__labelPrefix,
        option.label || option.value,
        option.description,
        option.labelTag
    ].concat(option.tags).concat($46b116ae1da6db28$var$getMatchingFilteringTags(option.filteringTags, highlightText)).filter((el)=>!!el).join(' ');
}
var $46b116ae1da6db28$export$2e2bcd8739ae039 = $46b116ae1da6db28$var$defaultOptionDescription;


function $b7f1c9ed858d2e1a$export$97d78af8d95ca8bd({ highlightText: highlightText, announceSelected: announceSelected, highlightedOption: highlightedOption, getParent: getParent, selectedAriaLabel: selectedAriaLabel, renderHighlightedAriaLive: renderHighlightedAriaLive }) {
    const prevAnnouncedGroup = (0, $acw62.useRef)(undefined);
    // Record previously announced group with a delay to account for possible re-renders of the hook.
    (0, $acw62.useEffect)(()=>{
        if (highlightedOption) {
            const frameId = requestAnimationFrame(()=>{
                prevAnnouncedGroup.current = getParent(highlightedOption);
            });
            return ()=>cancelAnimationFrame(frameId);
        }
    });
    if (!highlightedOption) return '';
    const option = highlightedOption.option;
    const parent = getParent(highlightedOption);
    // Only announce parent group if it wasn't announced with previous option.
    const group = parent && parent !== prevAnnouncedGroup.current ? parent : undefined;
    // Use custom renderer if provided.
    if (renderHighlightedAriaLive) return renderHighlightedAriaLive(option, group);
    // Use default renderer with selected ARIA label if defined and relevant.
    // Note: We intentionally keep selectedAriaLabel in the live region announcement even though
    // we now use proper ARIA attributes (aria-selected, aria-checked, aria-multiselectable).
    // This is because NVDA and older versions of JAWS (e.g., 2022, still commonly used) have bugs
    // where they don't properly announce the selected state from ARIA attributes alone.
    // For newer screen readers (modern JAWS, VoiceOver), this results in redundant "Selected"
    // announcements, but this is preferable to the alternative where users hear "Selected"
    // followed by "Not Selected" due to missing ARIA attribute support.
    // See AWSUI-61639 for details.
    const selectedAnnouncement = announceSelected && selectedAriaLabel ? selectedAriaLabel : '';
    const defaultDescription = (0, $46b116ae1da6db28$export$2e2bcd8739ae039)({
        option: option,
        parentGroup: group,
        highlightText: highlightText
    });
    return [
        selectedAnnouncement,
        defaultDescription
    ].filter(Boolean).join(' ');
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $6e841f6ba081dbe4$export$36f5628e43bc3fcd = ({ onLoadItems: onLoadItems, options: options, statusType: statusType })=>{
    const prevFilteringText = (0, $acw62.useRef)(undefined);
    const fireLoadItems = (filteringText)=>{
        if (prevFilteringText.current === filteringText) return;
        prevFilteringText.current = filteringText;
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadItems, {
            filteringText: filteringText,
            firstPage: true,
            samePage: false
        });
    };
    const handleLoadMore = ()=>{
        const firstPage = options.length === 0;
        if (statusType === 'pending') (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadItems, {
            firstPage: firstPage,
            samePage: false,
            filteringText: prevFilteringText.current || ''
        });
    };
    const handleRecoveryClick = ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadItems, {
            firstPage: false,
            samePage: true,
            filteringText: prevFilteringText.current || ''
        });
    return {
        fireLoadItems: fireLoadItems,
        handleLoadMore: handleLoadMore,
        handleRecoveryClick: handleRecoveryClick
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $3e842f82042c98b4$var$isRepeatedChar = (str)=>str.split('').every((c)=>c === str[0]);
function $3e842f82042c98b4$var$findMatchingOption(options, searchText, currentHighlight, useInteractiveGroups) {
    const interactivityCheck = useInteractiveGroups ? (0, $a3e6bb5a1ebc1aee$export$8269a10a0c239702) : (0, $a3e6bb5a1ebc1aee$export$6af67c5380a168e2);
    const filter = (searchText)=>(0, $a3e6bb5a1ebc1aee$export$60d56ed3961c839c)(options, searchText, true).filter((option)=>interactivityCheck(option));
    const matchingOptions = filter(searchText);
    if (matchingOptions.length === 1) return matchingOptions[0];
    // Hit the same char over and over, we assume they want to cycle through
    if (currentHighlight && searchText.length > 1 && $3e842f82042c98b4$var$isRepeatedChar(searchText)) {
        const matchingOptions = filter(searchText[0]);
        if (matchingOptions.length > 0) {
            //handling OptionGroups when useInteractiveGroups is set
            let active = (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(currentHighlight) ? matchingOptions.map(({ option: option })=>option).indexOf(currentHighlight) : matchingOptions.map(({ option: option })=>option.value).indexOf(currentHighlight.value);
            // Pick the next thing (if something with this prefix wasn't selected
            // we'll end up with the first option)
            active += 1;
            active = active % matchingOptions.length;
            return matchingOptions[active];
        }
    }
    // We have multiple things that start with this prefix.  Based on the
    // behavior of native select, this is considered after the repeated case
    if (matchingOptions.length > 0) return matchingOptions[0];
    return null;
}
function $3e842f82042c98b4$export$1fd459f1bf9b474a({ isEnabled: isEnabled, options: options, highlightOption: highlightOption, highlightedOption: highlightedOption, useInteractiveGroups: useInteractiveGroups }) {
    const value = (0, $acw62.useRef)('');
    const delayedResetValue = (0, $2f667510820517ed$export$40ae01be0011c1e6)(()=>value.current = '', 500);
    return (event)=>{
        if (!isEnabled) return;
        const { key: key } = event;
        if (!key || key.length !== 1) return;
        delayedResetValue();
        const newValue = value.current + key;
        value.current = newValue;
        const nextHighlight = $3e842f82042c98b4$var$findMatchingOption(options, newValue, highlightedOption, useInteractiveGroups);
        if (nextHighlight) highlightOption(nextHighlight);
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
class $984ac970450c0ae3$export$7874144f5bc63567 {
    constructor(type, moveFocus = type === 'keyboard'){
        this.type = type;
        this.moveFocus = moveFocus;
    }
}
function $984ac970450c0ae3$export$160d4638fe61b58a({ options: options, isHighlightable: isHighlightable }) {
    const [highlightedIndex, setHighlightedIndexState] = (0, $acw62.useState)(-1);
    const [highlightType, setHighlightType] = (0, $acw62.useState)(new $984ac970450c0ae3$export$7874144f5bc63567('keyboard'));
    const setHighlightedIndex = (0, $acw62.useCallback)((index, newHighlightType)=>{
        setHighlightedIndexState(index);
        setHighlightType((oldHighlight)=>oldHighlight.type !== newHighlightType.type ? newHighlightType : oldHighlight);
    }, []);
    const highlightedOption = options[highlightedIndex] && isHighlightable(options[highlightedIndex]) ? options[highlightedIndex] : undefined;
    const moveHighlightFrom = (direction, startIndex = highlightedIndex, highlightType)=>{
        const fromBottomEnd = startIndex === -1 && direction === -1;
        let newIndex = fromBottomEnd ? options.length : startIndex;
        do newIndex += direction;
        while (options[newIndex] && !isHighlightable(options[newIndex]));
        if (options[newIndex]) setHighlightedIndex(newIndex, highlightType);
    };
    const moveHighlight = (direction, highlightType)=>moveHighlightFrom(direction, highlightedIndex, highlightType);
    const highlightOption = (0, $acw62.useCallback)((option, highlightType)=>{
        const index = options.indexOf(option);
        setHighlightedIndex(index, highlightType);
    }, [
        options,
        setHighlightedIndex
    ]);
    return [
        {
            highlightType: highlightType,
            highlightedIndex: highlightedIndex,
            highlightedOption: highlightedOption
        },
        {
            setHighlightedIndexWithMouse: (index, moveFocus = false)=>setHighlightedIndex(index, new $984ac970450c0ae3$export$7874144f5bc63567('mouse', moveFocus)),
            highlightFirstOptionWithMouse: ()=>moveHighlightFrom(1, -1, new $984ac970450c0ae3$export$7874144f5bc63567('mouse', true)),
            moveHighlightWithKeyboard: (direction)=>moveHighlight(direction, new $984ac970450c0ae3$export$7874144f5bc63567('keyboard')),
            highlightOptionWithKeyboard: (option)=>highlightOption(option, new $984ac970450c0ae3$export$7874144f5bc63567('keyboard')),
            resetHighlightWithKeyboard: ()=>setHighlightedIndex(-1, new $984ac970450c0ae3$export$7874144f5bc63567('keyboard')),
            goHomeWithKeyboard: ()=>moveHighlightFrom(1, -1, new $984ac970450c0ae3$export$7874144f5bc63567('keyboard')),
            goEndWithKeyboard: ()=>moveHighlightFrom(-1, options.length, new $984ac970450c0ae3$export$7874144f5bc63567('keyboard'))
        }
    ];
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $771626752877e74e$export$a53dab9d69563a9d = (menuId, index)=>{
    if (index < 0) return undefined;
    return `${menuId}-option-${index}`;
};



const $39379ec6775359b3$var$HOME = 36;
const $39379ec6775359b3$var$END = 35;
const $39379ec6775359b3$export$7994f81da2f6972c = ({ goUp: goUp, goDown: goDown, selectOption: selectOption, goHome: goHome, goEnd: goEnd, closeDropdown: closeDropdown, preventNativeSpace: preventNativeSpace = false })=>{
    return (event)=>{
        switch(event.detail.keyCode){
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
                event.preventDefault();
                goUp();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
                event.preventDefault();
                goDown();
                break;
            case $39379ec6775359b3$var$HOME:
                goHome();
                break;
            case $39379ec6775359b3$var$END:
                goEnd();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape:
                event.stopPropagation();
                closeDropdown();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
                event.preventDefault();
                selectOption();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
                if (preventNativeSpace) {
                    event.preventDefault();
                    selectOption();
                }
        }
    };
};
const $39379ec6775359b3$export$212c9ac9ac4f6242 = ({ openDropdown: openDropdown, goHome: goHome })=>{
    return (event)=>{
        switch(event.detail.keyCode){
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
                event.preventDefault();
                goHome();
                openDropdown();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
                event.preventDefault();
                openDropdown();
                break;
        }
    };
};







function $6b2e7bdae89bf6e1$export$e64b2f635402ca43({ selectedOptions: selectedOptions, updateSelectedOption: updateSelectedOption, options: options, filteringType: filteringType, onBlur: onBlur, onFocus: onFocus, externalRef: externalRef, keepOpen: keepOpen, embedded: embedded, fireLoadItems: fireLoadItems, setFilteringValue: setFilteringValue, useInteractiveGroups: useInteractiveGroups = false, statusType: statusType, isAllSelected: isAllSelected, isSomeSelected: isSomeSelected, toggleAll: toggleAll }) {
    const interactivityCheck = useInteractiveGroups ? (0, $a3e6bb5a1ebc1aee$export$8269a10a0c239702) : (0, $a3e6bb5a1ebc1aee$export$6af67c5380a168e2);
    const isHighlightable = (option)=>!!option && (useInteractiveGroups || option.type !== 'parent');
    const filterRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const hasFilter = filteringType !== 'none' && !embedded;
    const activeRef = hasFilter ? filterRef : menuRef;
    const __selectedOptions = (0, $80c0308d36c0fca6$export$c85ed1874bcf2a02)(options, selectedOptions);
    const __selectedValuesSet = selectedOptions.reduce((selectedValuesSet, item)=>{
        if (item.value) selectedValuesSet.add(item.value);
        return selectedValuesSet;
    }, new Set());
    const [{ highlightType: highlightType, highlightedOption: highlightedOption, highlightedIndex: highlightedIndex }, { moveHighlightWithKeyboard: moveHighlightWithKeyboard, resetHighlightWithKeyboard: resetHighlightWithKeyboard, setHighlightedIndexWithMouse: setHighlightedIndexWithMouse, highlightOptionWithKeyboard: highlightOptionWithKeyboard, highlightFirstOptionWithMouse: highlightFirstOptionWithMouse, goHomeWithKeyboard: goHomeWithKeyboard, goEndWithKeyboard: goEndWithKeyboard }] = (0, $984ac970450c0ae3$export$160d4638fe61b58a)({
        options: options,
        isHighlightable: isHighlightable
    });
    const { isOpen: isOpen, openDropdown: openDropdown, closeDropdown: closeDropdown, toggleDropdown: toggleDropdown, openedWithKeyboard: openedWithKeyboard } = (0, $aff605ad4173beb7$export$7d3a09d5141ab1f4)({
        defaultOpen: embedded,
        onOpen: ()=>fireLoadItems(''),
        onClose: ()=>{
            resetHighlightWithKeyboard();
            setFilteringValue === null || setFilteringValue === void 0 || setFilteringValue('');
        }
    });
    const handleFocus = ()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus, {});
    };
    const handleBlur = ()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur, {});
        closeDropdown();
    };
    const hasSelectedOption = __selectedOptions.length > 0;
    const menuId = (0, $013a2451794a45c0$exports.useUniqueId)('option-list');
    const dialogId = (0, $013a2451794a45c0$exports.useUniqueId)('dialog');
    const highlightedOptionId = (0, $771626752877e74e$export$a53dab9d69563a9d)(menuId, highlightedIndex);
    const closeDropdownIfNecessary = ()=>{
        var _a;
        if (!keepOpen) {
            (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
            closeDropdown();
        }
    };
    const selectOption = (option)=>{
        const optionToSelect = option || highlightedOption;
        if (!optionToSelect || !interactivityCheck(optionToSelect)) return;
        if (optionToSelect.type === 'select-all' && toggleAll) toggleAll();
        else updateSelectedOption(optionToSelect.option);
        closeDropdownIfNecessary();
    };
    const activeKeyDownHandler = (0, $39379ec6775359b3$export$7994f81da2f6972c)({
        goUp: ()=>{
            if (!useInteractiveGroups && (highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.type) === 'child' && highlightedIndex === 1 || highlightedIndex === 0) {
                goEndWithKeyboard();
                return;
            }
            moveHighlightWithKeyboard(-1);
        },
        goDown: ()=>{
            if (highlightedIndex === options.length - 1) {
                goHomeWithKeyboard();
                return;
            }
            moveHighlightWithKeyboard(1);
        },
        selectOption: selectOption,
        goHome: goHomeWithKeyboard,
        goEnd: goEndWithKeyboard,
        closeDropdown: ()=>{
            var _a;
            if (!embedded) {
                (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
                closeDropdown();
            }
        },
        preventNativeSpace: !hasFilter || highlightedOption && highlightType.type === 'keyboard'
    });
    const triggerKeyDownHandler = (0, $39379ec6775359b3$export$212c9ac9ac4f6242)({
        openDropdown: ()=>openDropdown(true),
        goHome: goHomeWithKeyboard
    });
    const getDropdownProps = ()=>({
            onFocus: handleFocus,
            onBlur: handleBlur,
            dropdownContentId: dialogId,
            ariaRole: hasFilter ? 'dialog' : undefined
        });
    const getTriggerProps = (disabled = false, autoFocus = false)=>{
        const triggerProps = {
            ref: triggerRef,
            onFocus: ()=>closeDropdown(),
            autoFocus: autoFocus,
            ariaHasPopup: hasFilter ? 'dialog' : 'listbox',
            ariaControls: isOpen ? hasFilter ? dialogId : menuId : undefined
        };
        if (!disabled) {
            triggerProps.onMouseDown = (event)=>{
                var _a;
                event.preventDefault(); // prevent current focus from blurring as it immediately closes the dropdown
                if (isOpen) (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
                toggleDropdown();
            };
            triggerProps.onKeyDown = triggerKeyDownHandler;
        }
        return triggerProps;
    };
    const getFilterProps = ()=>{
        if (!hasFilter || !setFilteringValue) return {};
        return {
            ref: filterRef,
            onKeyDown: activeKeyDownHandler,
            onChange: (event)=>{
                setFilteringValue(event.detail.value);
                resetHighlightWithKeyboard();
            },
            __onDelayedInput: (event)=>{
                fireLoadItems(event.detail.value);
            },
            nativeInputAttributes: {
                'aria-activedescendant': highlightedOptionId,
                ['aria-owns']: menuId,
                ['aria-controls']: menuId
            }
        };
    };
    const getMenuProps = ()=>{
        const menuProps = {
            id: menuId,
            ref: menuRef,
            open: isOpen,
            onMouseUp: (itemIndex)=>{
                if (itemIndex > -1) selectOption(options[itemIndex]);
            },
            onMouseMove: (itemIndex)=>{
                if (itemIndex > -1) setHighlightedIndexWithMouse(itemIndex);
            },
            statusType: statusType
        };
        if (!hasFilter) {
            menuProps.onKeyDown = activeKeyDownHandler;
            menuProps.nativeAttributes = {
                'aria-activedescendant': highlightedOptionId
            };
        }
        if (embedded) {
            menuProps.onFocus = ()=>{
                if (!highlightedOption) goHomeWithKeyboard();
            };
            menuProps.onBlur = ()=>{
                resetHighlightWithKeyboard();
            };
        }
        return menuProps;
    };
    const getGroupState = (option)=>{
        const totalSelected = option.options.filter((item)=>!!item.value && __selectedValuesSet.has(item.value)).length;
        const hasSelected = totalSelected > 0;
        const allSelected = totalSelected === option.options.length;
        return {
            selected: hasSelected && allSelected && useInteractiveGroups,
            indeterminate: hasSelected && !allSelected
        };
    };
    const getOptionProps = (option, index)=>{
        var _a, _b;
        const isSelectAll = option.type === 'select-all';
        const highlighted = option === highlightedOption;
        const groupState = (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(option.option) ? getGroupState(option.option) : undefined;
        const selected = isSelectAll ? isAllSelected : __selectedOptions.indexOf(option) > -1 || !!(groupState === null || groupState === void 0 ? void 0 : groupState.selected);
        const nextOption = (_a = options[index + 1]) === null || _a === void 0 ? void 0 : _a.option;
        const isNextSelected = !!nextOption && (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(nextOption) ? getGroupState(nextOption).selected : __selectedOptions.indexOf(options[index + 1]) > -1;
        const previousOption = (_b = options[index - 1]) === null || _b === void 0 ? void 0 : _b.option;
        const isPreviousSelected = !!previousOption && (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(previousOption) ? getGroupState(previousOption).selected : __selectedOptions.indexOf(options[index - 1]) > -1;
        const optionProps = {
            key: index,
            option: option,
            highlighted: highlighted,
            selected: selected,
            isNextSelected: isNextSelected,
            isPreviousSelected: isPreviousSelected,
            indeterminate: !!(groupState === null || groupState === void 0 ? void 0 : groupState.indeterminate) || isSelectAll && !isAllSelected && isSomeSelected,
            ['data-mouse-target']: isHighlightable(option) ? index : -1,
            id: (0, $771626752877e74e$export$a53dab9d69563a9d)(menuId, index)
        };
        return optionProps;
    };
    const prevOpen = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(isOpen);
    (0, $acw62.useEffect)(()=>{
        // highlight the first selected option, when opening the Select component without filter input
        // keep the focus in the filter input when opening, so that screenreader can recognize the combobox
        if (isOpen && !prevOpen && options.length > 0 && !hasFilter) {
            if (openedWithKeyboard) {
                if (__selectedOptions[0]) highlightOptionWithKeyboard(__selectedOptions[0]);
                else goHomeWithKeyboard();
            } else if (!__selectedOptions[0] || !options.includes(__selectedOptions[0])) highlightFirstOptionWithMouse();
            else {
                const highlightedIndex = options.indexOf(__selectedOptions[0]);
                setHighlightedIndexWithMouse(highlightedIndex, true);
            }
        }
    }, [
        isOpen,
        __selectedOptions,
        hasSelectedOption,
        setHighlightedIndexWithMouse,
        highlightOptionWithKeyboard,
        highlightFirstOptionWithMouse,
        goHomeWithKeyboard,
        openedWithKeyboard,
        options,
        prevOpen,
        hasFilter
    ]);
    const focusActiveRef = (0, $acw62.useCallback)(()=>{
        var _a;
        // dropdown-fit calculations ensure that the dropdown will fit inside the current
        // viewport, so prevent the browser from trying to scroll it into view (e.g. if
        // scroll-padding-top is set on a parent)
        (_a = activeRef.current) === null || _a === void 0 || _a.focus({
            preventScroll: true
        });
    }, [
        activeRef
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isOpen && !embedded) focusActiveRef();
    }, [
        isOpen,
        activeRef,
        embedded,
        focusActiveRef
    ]);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(externalRef, triggerRef);
    const highlightedGroupSelected = !!highlightedOption && (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(highlightedOption.option) && getGroupState(highlightedOption.option).selected;
    const announceSelected = !!highlightedOption && (__selectedOptions.indexOf(highlightedOption) > -1 || highlightedGroupSelected);
    return {
        isOpen: isOpen,
        highlightedOption: highlightedOption,
        highlightedIndex: highlightedIndex,
        highlightType: highlightType,
        getTriggerProps: getTriggerProps,
        getDropdownProps: getDropdownProps,
        getMenuProps: getMenuProps,
        getFilterProps: getFilterProps,
        getOptionProps: getOptionProps,
        highlightOption: highlightOptionWithKeyboard,
        selectOption: selectOption,
        announceSelected: announceSelected,
        dialogId: dialogId,
        focusActiveRef: focusActiveRef
    };
}


function $6c9bace3f7acb30f$export$eb0e345faa9ac46d({ options: options, filteringType: filteringType, filteringResultsText: filteringResultsText, disabled: disabled, statusType: statusType, empty: empty, loadingText: loadingText, finishedText: finishedText, errorText: errorText, noMatch: noMatch, renderHighlightedAriaLive: renderHighlightedAriaLive, selectedOptions: selectedOptions, deselectAriaLabel: deselectAriaLabel, keepOpen: keepOpen, onBlur: onBlur, onFocus: onFocus, onLoadItems: onLoadItems, onChange: onChange, controlId: controlId, ariaLabelId: ariaLabelId, footerId: footerId, filteringValue: filteringValue, setFilteringValue: setFilteringValue, externalRef: externalRef, embedded: embedded, enableSelectAll: enableSelectAll, i18nStrings: i18nStrings, ...restProps }) {
    (0, $1f218afa2afb7e05$export$a967962c200ab07c)('Multiselect', 'options', options);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('multiselect');
    const i18nCommon = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('select');
    const recoveryText = i18nCommon('recoveryText', restProps.recoveryText);
    const errorIconAriaLabel = i18nCommon('errorIconAriaLabel', restProps.errorIconAriaLabel);
    const selectedAriaLabel = i18nCommon('selectedAriaLabel', restProps.selectedAriaLabel);
    if (restProps.recoveryText && !onLoadItems) (0, $013a2451794a45c0$exports.warnOnce)('Multiselect', '`onLoadItems` must be provided for `recoveryText` to be displayed.');
    const { handleLoadMore: handleLoadMore, handleRecoveryClick: handleRecoveryClick, fireLoadItems: fireLoadItems } = (0, $6e841f6ba081dbe4$export$36f5628e43bc3fcd)({
        onLoadItems: onLoadItems,
        options: options,
        statusType: statusType
    });
    const useInteractiveGroups = true;
    const { flatOptions: flatOptions, filteredOptions: filteredOptions, parentMap: parentMap, totalCount: totalCount, matchesCount: matchesCount } = (0, $842e88ad945f2818$export$3b43bf09494a926b)(options, filteringType, filteringValue);
    const selectAllOption = {
        type: 'select-all',
        afterHeader: filteringType !== 'none',
        option: {
            label: i18n('i18nStrings.selectAllText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.selectAllText)
        }
    };
    const visibleOptions = enableSelectAll && filteredOptions.length ? [
        selectAllOption,
        ...filteredOptions
    ] : filteredOptions;
    // Includes visible and non-visible (filtered out) options
    const allNonParentOptions = flatOptions.filter((item)=>item.type !== 'parent').map((option)=>option.option);
    const filteredNonParentOptions = filteredOptions.filter((item)=>item.type !== 'parent').map((item)=>item.option);
    const selectedValues = (0, $acw62.useMemo)(()=>new Set(selectedOptions.map((option)=>option.value)), [
        selectedOptions
    ]);
    const isSomeSelected = selectedOptions.length > 0;
    const isAllVisibleSelectableSelected = isSomeSelected && filteredNonParentOptions.every((option)=>option.disabled || selectedValues.has(option.value));
    const isAllSelected = allNonParentOptions.every((option)=>selectedValues.has(option.value));
    const toggleAll = ()=>{
        const filteredNonParentOptionValues = new Set(filteredNonParentOptions.map((option)=>option.value));
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            selectedOptions: isAllVisibleSelectableSelected ? selectedOptions.filter((option)=>!filteredNonParentOptionValues.has(option.value)) : allNonParentOptions.filter(({ disabled: disabled, value: value })=>selectedValues.has(value) || !disabled && filteredNonParentOptionValues.has(value))
        });
    };
    const updateSelectedOption = (0, $acw62.useCallback)((option)=>{
        // switch between selection and deselection behavior, ignores disabled options to prevent
        // getting stuck on one behavior when an option is disabled and its state cannot be changed
        const isAllChildrenSelected = (optionsArray)=>optionsArray.every((item)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(selectedOptions, item) > -1 || item.disabled);
        const intersection = (visibleOptions, options)=>visibleOptions.filter((item)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(options, item) > -1 && !item.disabled);
        const union = (visibleOptions, options)=>visibleOptions.filter((item)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(options, item) === -1).concat(options);
        const select = (options, selectedOptions)=>{
            return union(selectedOptions, options);
        };
        const unselect = (options, selectedOptions)=>{
            return selectedOptions.filter((option)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(options, option) === -1);
        };
        let newSelectedOptions = [
            ...selectedOptions
        ];
        if ((0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(option)) {
            const visibleOptions = intersection([
                ...option.options
            ], filteredNonParentOptions);
            newSelectedOptions = isAllChildrenSelected(visibleOptions) ? unselect(visibleOptions, newSelectedOptions) : select(visibleOptions, newSelectedOptions);
        } else newSelectedOptions = isAllChildrenSelected([
            option
        ]) ? unselect([
            option
        ], newSelectedOptions) : select([
            option
        ], newSelectedOptions);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            selectedOptions: newSelectedOptions
        });
    }, [
        selectedOptions,
        onChange,
        filteredNonParentOptions
    ]);
    const scrollToIndex = (0, $acw62.useRef)(null);
    const { isOpen: isOpen, highlightType: highlightType, highlightedOption: highlightedOption, highlightedIndex: highlightedIndex, getTriggerProps: getTriggerProps, getDropdownProps: getDropdownProps, getFilterProps: getFilterProps, getMenuProps: getMenuProps, getOptionProps: getOptionProps, highlightOption: highlightOption, announceSelected: announceSelected, focusActiveRef: focusActiveRef } = (0, $6b2e7bdae89bf6e1$export$e64b2f635402ca43)({
        selectedOptions: selectedOptions,
        updateSelectedOption: updateSelectedOption,
        options: visibleOptions,
        filteringType: filteringType,
        onFocus: onFocus,
        onBlur: onBlur,
        externalRef: externalRef,
        keepOpen: keepOpen,
        fireLoadItems: fireLoadItems,
        setFilteringValue: setFilteringValue,
        useInteractiveGroups: useInteractiveGroups,
        statusType: statusType,
        embedded: embedded,
        isAllSelected: isAllSelected,
        isSomeSelected: isSomeSelected,
        toggleAll: toggleAll
    });
    const wrapperOnKeyDown = (0, $3e842f82042c98b4$export$1fd459f1bf9b474a)({
        isEnabled: filteringType === 'none' && isOpen,
        options: visibleOptions,
        highlightOption: highlightOption,
        highlightedOption: highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.option,
        useInteractiveGroups: useInteractiveGroups
    });
    const isEmpty = !options || options.length === 0;
    const isNoMatch = filteredOptions && filteredOptions.length === 0;
    const isFiltered = filteringType !== 'none' && filteringValue.length > 0 && filteredOptions && filteredOptions.length > 0;
    const filteredText = isFiltered ? filteringResultsText === null || filteringResultsText === void 0 ? void 0 : filteringResultsText(matchesCount, totalCount) : undefined;
    const dropdownStatus = (0, $41901c188ad0f2ad$export$5467db17117c3a32)({
        statusType: statusType,
        empty: empty,
        loadingText: loadingText,
        finishedText: finishedText,
        errorText: errorText,
        recoveryText: recoveryText,
        isEmpty: isEmpty,
        isNoMatch: isNoMatch,
        noMatch: noMatch,
        filteringResultsText: filteredText,
        onRecoveryClick: ()=>{
            handleRecoveryClick();
            focusActiveRef();
        },
        errorIconAriaLabel: errorIconAriaLabel,
        hasRecoveryCallback: !!onLoadItems
    });
    const announcement = (0, $b7f1c9ed858d2e1a$export$97d78af8d95ca8bd)({
        announceSelected: announceSelected,
        highlightedOption: highlightedOption,
        getParent: (option)=>{
            var _a;
            return (_a = parentMap.get(option)) === null || _a === void 0 ? void 0 : _a.option;
        },
        selectedAriaLabel: selectedAriaLabel,
        renderHighlightedAriaLive: renderHighlightedAriaLive
    });
    const tokens = selectedOptions.map((option)=>({
            label: option.label,
            disabled: disabled || option.disabled,
            labelTag: option.labelTag,
            description: option.description,
            iconAlt: option.iconAlt,
            iconName: option.iconName,
            iconUrl: option.iconUrl,
            iconSvg: option.iconSvg,
            tags: option.tags,
            dismissLabel: i18n('deselectAriaLabel', deselectAriaLabel === null || deselectAriaLabel === void 0 ? void 0 : deselectAriaLabel(option), (format)=>{
                var _a;
                return format({
                    option__label: (_a = option.label) !== null && _a !== void 0 ? _a : ''
                });
            })
        }));
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = scrollToIndex.current) === null || _a === void 0 || _a.call(scrollToIndex, highlightedIndex);
    }, [
        highlightedIndex
    ]);
    const dropdownOnMouseDown = (event)=>{
        const target = event.target;
        if (target !== document.activeElement) // prevent currently focused element from losing it
        event.preventDefault();
    };
    const tokenOnDismiss = ({ detail: detail })=>{
        const optionToDeselect = selectedOptions[detail.itemIndex];
        updateSelectedOption(optionToDeselect);
        const targetRef = getTriggerProps().ref;
        if (targetRef.current) targetRef.current.focus();
    };
    return {
        isOpen: isOpen,
        tokens: tokens,
        announcement: announcement,
        dropdownStatus: dropdownStatus,
        filteringValue: filteringValue,
        filteredOptions: visibleOptions,
        highlightType: highlightType,
        scrollToIndex: scrollToIndex,
        getFilterProps: getFilterProps,
        getTriggerProps: getTriggerProps,
        getMenuProps: ()=>({
                ...getMenuProps(),
                onLoadMore: handleLoadMore,
                ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabelId, controlId),
                ariaDescribedby: dropdownStatus.content ? footerId : undefined,
                embedded: embedded
            }),
        getOptionProps: getOptionProps,
        getTokenProps: ()=>({
                onDismiss: tokenOnDismiss
            }),
        getDropdownProps: ()=>({
                ...getDropdownProps(),
                onMouseDown: dropdownOnMouseDown
            }),
        getWrapperProps: ()=>({
                onKeyDown: wrapperOnKeyDown
            }),
        highlightedIndex: highlightedIndex
    };
}



var $f0f1f7c75b4089a9$export$2e2bcd8739ae039 = {
    "root": "awsui_root_f8g6q_anlz5_145",
    "embedded": "awsui_embedded_f8g6q_anlz5_177",
    "tokens": "awsui_tokens_f8g6q_anlz5_210"
};


const $274dd79cbacd4aac$var$InternalMultiselect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ options: options, filteringType: filteringType, filteringPlaceholder: filteringPlaceholder, filteringAriaLabel: filteringAriaLabel, filteringClearAriaLabel: filteringClearAriaLabel, ariaRequired: ariaRequired, placeholder: placeholder, disabled: disabled, readOnly: readOnly, ariaLabel: ariaLabel, inlineLabelText: inlineLabelText, selectedOptions: selectedOptions, deselectAriaLabel: deselectAriaLabel, tokenLimit: tokenLimit, i18nStrings: i18nStrings, virtualScroll: virtualScroll, inlineTokens: inlineTokens = false, hideTokens: hideTokens, expandToViewport: expandToViewport, tokenLimitShowFewerAriaLabel: tokenLimitShowFewerAriaLabel, tokenLimitShowMoreAriaLabel: tokenLimitShowMoreAriaLabel, __internalRootRef: __internalRootRef, autoFocus: autoFocus, enableSelectAll: enableSelectAll, renderOption: renderOption, ...restProps }, externalRef)=>{
    var _a;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('multiselect');
    const selfControlId = (0, $013a2451794a45c0$exports.useUniqueId)('trigger');
    const controlId = (_a = formFieldContext.controlId) !== null && _a !== void 0 ? _a : selfControlId;
    const ariaLabelId = (0, $013a2451794a45c0$exports.useUniqueId)('multiselect-ariaLabel-');
    const footerId = (0, $013a2451794a45c0$exports.useUniqueId)('multiselect-footer-');
    const [filteringValue, setFilteringValue] = (0, $acw62.useState)('');
    const multiselectProps = (0, $6c9bace3f7acb30f$export$eb0e345faa9ac46d)({
        options: options,
        selectedOptions: selectedOptions,
        filteringType: filteringType,
        disabled: disabled,
        deselectAriaLabel: deselectAriaLabel,
        controlId: controlId,
        ariaLabelId: ariaLabelId,
        footerId: footerId,
        filteringValue: filteringValue,
        setFilteringValue: setFilteringValue,
        externalRef: externalRef,
        enableSelectAll: enableSelectAll,
        i18nStrings: i18nStrings,
        ...restProps
    });
    const filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3d59f5e64bb57d9d$export$2e2bcd8739ae039), {
        clearAriaLabel: filteringClearAriaLabel,
        filteringType: filteringType,
        placeholder: filteringPlaceholder,
        ariaLabel: filteringAriaLabel,
        ariaRequired: ariaRequired,
        value: filteringValue,
        ...multiselectProps.getFilterProps()
    });
    const triggerRef = (0, $acw62.useRef)(null);
    const [triggerWidth, setTriggerWidth] = (0, $acw62.useState)(null);
    (0, $013a2451794a45c0$exports.useResizeObserver)(()=>triggerRef.current, (entry)=>entry.borderBoxWidth > 0 && setTriggerWidth(entry.borderBoxWidth));
    const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c94b50b6f9902cf$export$2e2bcd8739ae039), {
        ref: triggerRef,
        placeholder: placeholder,
        disabled: disabled,
        readOnly: readOnly,
        triggerProps: multiselectProps.getTriggerProps(disabled, autoFocus),
        selectedOption: null,
        selectedOptions: selectedOptions,
        triggerVariant: inlineTokens ? 'tokens' : 'placeholder',
        isOpen: multiselectProps.isOpen,
        inlineLabelText: inlineLabelText,
        ...formFieldContext,
        controlId: controlId,
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(formFieldContext.ariaLabelledby, ariaLabelId)
    });
    const tokens = selectedOptions.map((option)=>({
            label: option.label,
            disabled: disabled,
            labelTag: option.labelTag,
            description: option.description,
            iconAlt: option.iconAlt,
            iconName: option.iconName,
            iconUrl: option.iconUrl,
            iconSvg: option.iconSvg,
            tags: option.tags,
            dismissLabel: i18n('deselectAriaLabel', deselectAriaLabel === null || deselectAriaLabel === void 0 ? void 0 : deselectAriaLabel(option), (format)=>{
                var _a;
                return format({
                    option__label: (_a = option.label) !== null && _a !== void 0 ? _a : ''
                });
            }),
            _readOnly: !!option.disabled
        }));
    const ListComponent = virtualScroll ? (0, $ef788f2229336596$export$2e2bcd8739ae039) : (0, $e3f3b61849c4e04a$export$2e2bcd8739ae039);
    const showTokens = !hideTokens && !inlineTokens && tokens.length > 0;
    const tokenGroupI18nStrings = {
        limitShowFewer: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.tokenLimitShowFewer,
        limitShowMore: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.tokenLimitShowMore
    };
    const dropdownStatus = multiselectProps.dropdownStatus;
    const dropdownProps = multiselectProps.getDropdownProps();
    const hasFilteredOptions = multiselectProps.filteredOptions.length > 0;
    const hasOptions = (0, $acw62.useRef)(options.length > 0);
    hasOptions.current = hasOptions.current || options.length > 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f0f1f7c75b4089a9$export$2e2bcd8739ae039).root, baseProps.className),
        ...multiselectProps.getWrapperProps()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        ...dropdownProps,
        ariaLabelledby: dropdownProps.ariaRole ? (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabelId, controlId) : undefined,
        ariaDescribedby: dropdownProps.ariaRole ? dropdownStatus.content ? footerId : undefined : undefined,
        open: multiselectProps.isOpen,
        minWidth: (0, $002622222677c92c$export$729c6707a50a5721)({
            expandToViewport: expandToViewport,
            triggerWidth: triggerWidth
        }),
        maxWidth: (0, $1be283cfa47851a8$export$4adb988360925c51)('xxs'),
        trigger: trigger,
        header: filter,
        footer: dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
            content: multiselectProps.isOpen ? dropdownStatus.content : null,
            id: footerId
        }) : null,
        expandToViewport: expandToViewport,
        // Forces dropdown position recalculation when new options are loaded
        contentKey: hasOptions.current.toString(),
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListComponent, {
            renderOption: renderOption,
            listBottom: !dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
                content: multiselectProps.isOpen ? dropdownStatus.content : null,
                id: footerId
            }) : null,
            menuProps: multiselectProps.getMenuProps(),
            getOptionProps: multiselectProps.getOptionProps,
            filteredOptions: multiselectProps.filteredOptions,
            filteringValue: filteringValue,
            ref: multiselectProps.scrollToIndex,
            hasDropdownStatus: dropdownStatus.content !== null,
            checkboxes: true,
            useInteractiveGroups: true,
            screenReaderContent: multiselectProps.announcement,
            highlightType: multiselectProps.highlightType,
            firstOptionSticky: hasFilteredOptions && enableSelectAll,
            isMultiSelect: true
        })
    }), showTokens && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f8026664024aac9$export$2e2bcd8739ae039), {
        ...multiselectProps.getTokenProps(),
        className: (0, $f0f1f7c75b4089a9$export$2e2bcd8739ae039).tokens,
        alignment: "horizontal",
        limit: tokenLimit,
        items: tokens,
        i18nStrings: tokenGroupI18nStrings,
        limitShowMoreAriaLabel: tokenLimitShowMoreAriaLabel,
        limitShowFewerAriaLabel: tokenLimitShowFewerAriaLabel,
        disableOuterPadding: true,
        readOnly: readOnly,
        isItemReadOnly: (item)=>item._readOnly
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), {
        id: ariaLabelId
    }, ariaLabel || inlineLabelText));
});
var $274dd79cbacd4aac$export$2e2bcd8739ae039 = $274dd79cbacd4aac$var$InternalMultiselect;



'use client';
const $8bb34a8468c146d7$var$Multiselect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ options: options = [], filteringType: filteringType = 'none', statusType: statusType = 'finished', selectedOptions: selectedOptions = [], keepOpen: keepOpen = true, hideTokens: hideTokens = false, renderOption: renderOption, ...restProps }, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Multiselect', {
        props: {
            inlineTokens: restProps.inlineTokens,
            autoFocus: restProps.autoFocus,
            expandToViewport: restProps.expandToViewport,
            filteringType: filteringType,
            hideTokens: hideTokens,
            keepOpen: keepOpen,
            tokenLimit: restProps.tokenLimit,
            virtualScroll: restProps.virtualScroll,
            readOnly: restProps.readOnly,
            enableSelectAll: restProps.enableSelectAll
        },
        metadata: {
            hasInlineLabel: Boolean(restProps.inlineLabelText),
            hasDisabledReasons: options.some((option)=>Boolean(option.disabledReason))
        }
    });
    const componentAnalyticsMetadata = {
        name: 'awsui.Multiselect',
        label: `.${(0, $901609b99800953a$export$2e2bcd8739ae039)['button-trigger']}`,
        properties: {
            disabled: `${!!restProps.disabled}`,
            selectedOptionsCount: `${selectedOptions.length}`,
            selectedOptionsValues: selectedOptions.filter((option)=>option.value !== undefined).map((option)=>`${option.value}`),
            selectedOptions: selectedOptions.filter((option)=>option.value !== undefined)// fallback on value when label's undefined because in the dropdown if there's no label
            // the value will be shown.
            .map((option)=>{
                var _a;
                return `${(_a = option.label) !== null && _a !== void 0 ? _a : option.value}`;
            })
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $274dd79cbacd4aac$export$2e2bcd8739ae039), {
        renderOption: renderOption,
        options: options,
        filteringType: filteringType,
        statusType: statusType,
        selectedOptions: selectedOptions,
        keepOpen: keepOpen,
        hideTokens: hideTokens,
        ...restProps,
        ...baseComponentProps,
        ref: ref,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticsMetadata
        })
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($8bb34a8468c146d7$var$Multiselect, 'Multiselect');
var $8bb34a8468c146d7$export$2e2bcd8739ae039 = $8bb34a8468c146d7$var$Multiselect;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
























var $bee7b2eb9022be82$export$2e2bcd8739ae039 = {
    "root": "awsui_root_r2vco_1yzpb_145"
};


const $70c5949ccf01312a$var$InternalSelect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ options: options, filteringType: filteringType = 'none', filteringPlaceholder: filteringPlaceholder, filteringAriaLabel: filteringAriaLabel, filteringClearAriaLabel: filteringClearAriaLabel, filteringResultsText: filteringResultsText, inlineLabelText: inlineLabelText, ariaRequired: ariaRequired, placeholder: placeholder, disabled: disabled, readOnly: readOnly, ariaLabel: ariaLabel, statusType: statusType = 'finished', empty: empty, loadingText: loadingText, finishedText: finishedText, errorText: errorText, noMatch: noMatch, triggerVariant: triggerVariant = 'label', renderHighlightedAriaLive: renderHighlightedAriaLive, selectedOption: selectedOption, onBlur: onBlur, onFocus: onFocus, onLoadItems: onLoadItems, onChange: onChange, virtualScroll: virtualScroll, expandToViewport: expandToViewport, autoFocus: autoFocus, __inFilteringToken: __inFilteringToken, __internalRootRef: __internalRootRef, renderOption: renderOption, ...restProps }, externalRef)=>{
    var _a;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('select');
    const errorIconAriaLabel = i18n('errorIconAriaLabel', restProps.errorIconAriaLabel);
    const selectedAriaLabel = i18n('selectedAriaLabel', restProps.selectedAriaLabel);
    const recoveryText = i18n('recoveryText', restProps.recoveryText);
    if (restProps.recoveryText && !onLoadItems) (0, $013a2451794a45c0$exports.warnOnce)('Select', '`onLoadItems` must be provided for `recoveryText` to be displayed.');
    const { handleLoadMore: handleLoadMore, handleRecoveryClick: handleRecoveryClick, fireLoadItems: fireLoadItems } = (0, $6e841f6ba081dbe4$export$36f5628e43bc3fcd)({
        onLoadItems: onLoadItems,
        options: options,
        statusType: statusType
    });
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)('Select', 'selectedOption', selectedOption, 'onChange', onChange);
    (0, $1f218afa2afb7e05$export$a967962c200ab07c)('Select', 'options', options);
    const [filteringValue, setFilteringValue] = (0, $acw62.useState)('');
    const { filteredOptions: filteredOptions, parentMap: parentMap, totalCount: totalCount, matchesCount: matchesCount } = (0, $842e88ad945f2818$export$3b43bf09494a926b)(options, filteringType, filteringValue);
    const rootRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const [triggerWidth, setTriggerWidth] = (0, $acw62.useState)(null);
    (0, $013a2451794a45c0$exports.useResizeObserver)(()=>triggerRef.current, (entry)=>entry.borderBoxWidth > 0 && setTriggerWidth(entry.borderBoxWidth));
    const selfControlId = (0, $013a2451794a45c0$exports.useUniqueId)('trigger');
    const controlId = (_a = formFieldContext.controlId) !== null && _a !== void 0 ? _a : selfControlId;
    const scrollToIndex = (0, $acw62.useRef)(null);
    const { isOpen: isOpen, highlightType: highlightType, highlightedOption: highlightedOption, highlightedIndex: highlightedIndex, getTriggerProps: getTriggerProps, getDropdownProps: getDropdownProps, getFilterProps: getFilterProps, getMenuProps: getMenuProps, getOptionProps: getOptionProps, highlightOption: highlightOption, selectOption: selectOption, announceSelected: announceSelected, focusActiveRef: focusActiveRef } = (0, $6b2e7bdae89bf6e1$export$e64b2f635402ca43)({
        selectedOptions: selectedOption ? [
            selectedOption
        ] : [],
        updateSelectedOption: (option)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                selectedOption: option
            }),
        options: filteredOptions,
        filteringType: filteringType,
        onBlur: onBlur,
        onFocus: onFocus,
        externalRef: externalRef,
        fireLoadItems: fireLoadItems,
        setFilteringValue: setFilteringValue,
        statusType: statusType
    });
    const handleNativeSearch = (0, $3e842f82042c98b4$export$1fd459f1bf9b474a)({
        isEnabled: filteringType === 'none' && !readOnly,
        options: filteredOptions,
        highlightOption: !isOpen ? selectOption : highlightOption,
        highlightedOption: !isOpen ? selectedOption : highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.option
    });
    const selectAriaLabelId = (0, $013a2451794a45c0$exports.useUniqueId)('select-arialabel-');
    const footerId = (0, $013a2451794a45c0$exports.useUniqueId)('footer');
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = scrollToIndex.current) === null || _a === void 0 || _a.call(scrollToIndex, highlightedIndex);
    }, [
        highlightedIndex
    ]);
    const filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3d59f5e64bb57d9d$export$2e2bcd8739ae039), {
        clearAriaLabel: filteringClearAriaLabel,
        filteringType: filteringType,
        placeholder: filteringPlaceholder,
        ariaLabel: filteringAriaLabel,
        ariaRequired: ariaRequired,
        value: filteringValue,
        ...getFilterProps()
    });
    const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c94b50b6f9902cf$export$2e2bcd8739ae039), {
        renderOption: renderOption,
        ref: triggerRef,
        placeholder: placeholder,
        disabled: disabled,
        readOnly: readOnly,
        triggerVariant: triggerVariant,
        triggerProps: getTriggerProps(disabled, autoFocus),
        selectedOption: selectedOption,
        isOpen: isOpen,
        inFilteringToken: __inFilteringToken,
        inlineLabelText: inlineLabelText,
        ...formFieldContext,
        controlId: controlId,
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(formFieldContext.ariaLabelledby, selectAriaLabelId)
    });
    const isEmpty = !options || options.length === 0;
    const isNoMatch = filteredOptions && filteredOptions.length === 0;
    const isFiltered = filteringType !== 'none' && filteringValue.length > 0 && filteredOptions && filteredOptions.length > 0;
    const filteredText = isFiltered ? filteringResultsText === null || filteringResultsText === void 0 ? void 0 : filteringResultsText(matchesCount, totalCount) : undefined;
    const dropdownStatus = (0, $41901c188ad0f2ad$export$5467db17117c3a32)({
        statusType: statusType,
        empty: empty,
        loadingText: loadingText,
        finishedText: finishedText,
        errorText: errorText,
        recoveryText: recoveryText,
        isEmpty: isEmpty,
        isNoMatch: isNoMatch,
        noMatch: noMatch,
        filteringResultsText: filteredText,
        errorIconAriaLabel: errorIconAriaLabel,
        onRecoveryClick: ()=>{
            handleRecoveryClick();
            focusActiveRef();
        },
        hasRecoveryCallback: !!onLoadItems
    });
    const menuProps = {
        ...getMenuProps(),
        onLoadMore: handleLoadMore,
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(selectAriaLabelId, controlId),
        ariaDescribedby: dropdownStatus.content ? footerId : undefined
    };
    const announcement = (0, $b7f1c9ed858d2e1a$export$97d78af8d95ca8bd)({
        announceSelected: announceSelected,
        highlightedOption: highlightedOption,
        getParent: (option)=>{
            var _a;
            return (_a = parentMap.get(option)) === null || _a === void 0 ? void 0 : _a.option;
        },
        selectedAriaLabel: selectedAriaLabel,
        renderHighlightedAriaLive: renderHighlightedAriaLive
    });
    const ListComponent = virtualScroll ? (0, $ef788f2229336596$export$2e2bcd8739ae039) : (0, $e3f3b61849c4e04a$export$2e2bcd8739ae039);
    const handleMouseDown = (event)=>{
        const target = event.target;
        if (target !== document.activeElement) // prevent currently focused element from losing it
        event.preventDefault();
    };
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(rootRef, __internalRootRef);
    const dropdownProps = getDropdownProps();
    const hasOptions = (0, $acw62.useRef)(options.length > 0);
    hasOptions.current = hasOptions.current || options.length > 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        ref: mergedRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $bee7b2eb9022be82$export$2e2bcd8739ae039).root, baseProps.className),
        onKeyDown: handleNativeSearch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        ...dropdownProps,
        ariaLabelledby: dropdownProps.ariaRole ? (0, $49fa9e74c692ea64$export$b933cda3796739ed)(selectAriaLabelId, controlId) : undefined,
        ariaDescribedby: dropdownProps.ariaRole ? dropdownStatus.content ? footerId : undefined : undefined,
        open: isOpen,
        stretchTriggerHeight: !!__inFilteringToken,
        minWidth: (0, $002622222677c92c$export$729c6707a50a5721)({
            expandToViewport: expandToViewport,
            triggerWidth: triggerWidth
        }),
        maxWidth: (0, $1be283cfa47851a8$export$4adb988360925c51)('xxs'),
        trigger: trigger,
        header: filter,
        onMouseDown: handleMouseDown,
        footer: dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
            content: isOpen ? dropdownStatus.content : null,
            id: footerId
        }) : null,
        expandToViewport: expandToViewport,
        // Forces dropdown position recalculation when new options are loaded
        contentKey: hasOptions.current.toString(),
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListComponent, {
            listBottom: !dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
                content: isOpen ? dropdownStatus.content : null,
                id: footerId
            }) : null,
            renderOption: renderOption,
            menuProps: menuProps,
            getOptionProps: getOptionProps,
            filteredOptions: filteredOptions,
            filteringValue: filteringValue,
            ref: scrollToIndex,
            hasDropdownStatus: dropdownStatus.content !== null,
            screenReaderContent: announcement,
            highlightType: highlightType
        })
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        hidden: true,
        id: selectAriaLabelId
    }, ariaLabel || inlineLabelText));
});
var $70c5949ccf01312a$export$2e2bcd8739ae039 = $70c5949ccf01312a$var$InternalSelect;



'use client';
const $1a3c01a344cfcaf3$var$Select = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ options: options = [], filteringType: filteringType = 'none', statusType: statusType = 'finished', triggerVariant: triggerVariant = 'label', renderOption: renderOption, ...restProps }, ref)=>{
    var _a, _b, _c, _d;
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Select', {
        props: {
            autoFocus: restProps.autoFocus,
            expandToViewport: restProps.expandToViewport,
            filteringType: filteringType,
            triggerVariant: triggerVariant,
            virtualScroll: restProps.virtualScroll,
            readOnly: restProps.readOnly
        },
        metadata: {
            hasInlineLabel: Boolean(restProps.inlineLabelText),
            hasDisabledReasons: options.some((option)=>Boolean(option.disabledReason))
        }
    });
    const externalProps = (0, $3833f34df478664f$export$21af416108db3048)(restProps);
    const componentAnalyticsMetadata = {
        name: 'awsui.Select',
        label: `.${(0, $901609b99800953a$export$2e2bcd8739ae039)['button-trigger']}`,
        properties: {
            disabled: `${!!externalProps.disabled}`,
            selectedOptionValue: `${externalProps.selectedOption && externalProps.selectedOption.value ? externalProps.selectedOption.value : null}`,
            // Use label for display if available, fallback to value because that's what gets shown in dropdown when label is not provided
            selectedOption: `${(_d = (_b = (_a = externalProps.selectedOption) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : (_c = externalProps.selectedOption) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : null}`
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70c5949ccf01312a$export$2e2bcd8739ae039), {
        renderOption: renderOption,
        options: options,
        filteringType: filteringType,
        statusType: statusType,
        triggerVariant: triggerVariant,
        ...externalProps,
        ...baseComponentProps,
        ref: ref,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticsMetadata
        })
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($1a3c01a344cfcaf3$var$Select, 'Select');
var $1a3c01a344cfcaf3$export$2e2bcd8739ae039 = $1a3c01a344cfcaf3$var$Select;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// This function is in a separate file to allow for mocking in unit tests
function $c788c75c0d66b726$export$2e2bcd8739ae039() {
    return 'scrollBehavior' in document.documentElement.style;
}


// The scroll speed depends on the scrolling distance. The equation below is an interpolation of measurements in Chrome.
const $b34d710081dd5986$var$getScrollSpeed = (pixels)=>0.0015 * Math.abs(pixels) + 0.558;
const $b34d710081dd5986$var$getScrollTime = (pixels)=>Math.round(Math.abs(pixels) / $b34d710081dd5986$var$getScrollSpeed(pixels));
const $b34d710081dd5986$var$now = ()=>window.performance ? window.performance.now() : Date.now();
const $b34d710081dd5986$var$ease = (k)=>{
    return 0.5 * (1 - Math.cos(Math.PI * k));
};
const $b34d710081dd5986$var$step = (context)=>{
    const time = $b34d710081dd5986$var$now();
    const elapsed = Math.min((time - context.startTime) / context.scrollTime, 1);
    const value = $b34d710081dd5986$var$ease(elapsed);
    const currentX = context.startX + (context.endX - context.startX) * value;
    context.scrollable.scrollLeft = currentX;
    // scroll more if we have not reached our destination
    if (currentX !== context.endX) requestAnimationFrame(()=>$b34d710081dd5986$var$step(context));
};
const $b34d710081dd5986$var$simulateSmoothScroll = (element, endX)=>{
    const startX = element.scrollLeft;
    $b34d710081dd5986$var$step({
        scrollable: element,
        startX: startX,
        endX: endX,
        startTime: $b34d710081dd5986$var$now(),
        scrollTime: $b34d710081dd5986$var$getScrollTime(endX - startX)
    });
};
const $b34d710081dd5986$var$smoothScroll = (element, to)=>{
    if ((0, $013a2451794a45c0$exports.isMotionDisabled)(element)) {
        element.scrollLeft = to;
        return;
    }
    if ((0, $c788c75c0d66b726$export$2e2bcd8739ae039)() && element.scrollTo) {
        element.scrollTo({
            left: to,
            behavior: 'smooth'
        });
        return;
    }
    $b34d710081dd5986$var$simulateSmoothScroll(element, to);
};
var $b34d710081dd5986$export$2e2bcd8739ae039 = $b34d710081dd5986$var$smoothScroll;


const $ac20d4f6814ec953$export$e2980a73b22819de = (headerBarRef, direction)=>{
    if (!(headerBarRef === null || headerBarRef === void 0 ? void 0 : headerBarRef.current)) return;
    const element = headerBarRef.current;
    const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = element;
    // Scroll each paginated section by 75% of what is already visible
    const paginatedSectionSize = Math.ceil(element.clientWidth * 0.75);
    const scrollDistance = direction === 'forward' ? Math.min(Math.abs(scrollLeft) + paginatedSectionSize, scrollWidth - offsetWidth) : Math.max(Math.abs(scrollLeft) - paginatedSectionSize, 0);
    // scroll destination needs to be a negative number if the direction is RTL
    const scrollTo = (0, $013a2451794a45c0$exports.getIsRtl)(element) ? scrollDistance * -1 : scrollDistance;
    (0, $b34d710081dd5986$export$2e2bcd8739ae039)(element, scrollTo);
};
const $ac20d4f6814ec953$export$6593e8d7c1045101 = (headerBar, inlineStartOverflowButton)=>{
    const { offsetWidth: offsetWidth, scrollWidth: scrollWidth } = headerBar;
    // Need to account for pagination button width when deciding if there would be overflow without them
    const paginationButtonsWidth = inlineStartOverflowButton.current && 2 * inlineStartOverflowButton.current.offsetWidth;
    return paginationButtonsWidth ? scrollWidth > offsetWidth + paginationButtonsWidth : scrollWidth > offsetWidth;
};
const $ac20d4f6814ec953$export$f68d63f3e53e9a7f = (headerBar)=>{
    return (0, $013a2451794a45c0$exports.getScrollInlineStart)(headerBar) > 0;
};
const $ac20d4f6814ec953$export$a741e8cb1f4eb366 = (headerBar)=>{
    return Math.ceil((0, $013a2451794a45c0$exports.getScrollInlineStart)(headerBar)) < headerBar.scrollWidth - headerBar.offsetWidth;
};
const $ac20d4f6814ec953$export$53a0910f038337bd = (tabHeader, headerBar, smooth = true)=>{
    if (!tabHeader || !headerBar) return;
    // Extra left and right margin to always make the focus ring visible
    const margin = 2;
    let updatedLeftScroll = headerBar.scrollLeft;
    // Anchor tab to left of scroll parent
    updatedLeftScroll = Math.min(updatedLeftScroll, tabHeader.offsetLeft - margin);
    // Anchor tab to right of scroll parent
    updatedLeftScroll = Math.max(updatedLeftScroll, tabHeader.offsetLeft + tabHeader.offsetWidth / 2 - headerBar.offsetWidth / 2 + margin);
    if (smooth) (0, $b34d710081dd5986$export$2e2bcd8739ae039)(headerBar, updatedLeftScroll);
    else headerBar.scrollLeft = updatedLeftScroll;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $f9b0c79b605bce6c$export$916c8b0fccbb37d2(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return undefined;
    return {
        borderRadius: (_a = style === null || style === void 0 ? void 0 : style.tab) === null || _a === void 0 ? void 0 : _a.borderRadius,
        borderWidth: (_b = style === null || style === void 0 ? void 0 : style.tab) === null || _b === void 0 ? void 0 : _b.borderWidth,
        fontSize: (_c = style === null || style === void 0 ? void 0 : style.tab) === null || _c === void 0 ? void 0 : _c.fontSize,
        fontWeight: (_d = style === null || style === void 0 ? void 0 : style.tab) === null || _d === void 0 ? void 0 : _d.fontWeight,
        paddingBlock: (_e = style === null || style === void 0 ? void 0 : style.tab) === null || _e === void 0 ? void 0 : _e.paddingBlock,
        paddingInline: (_f = style === null || style === void 0 ? void 0 : style.tab) === null || _f === void 0 ? void 0 : _f.paddingInline,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundActive]: (_h = (_g = style === null || style === void 0 ? void 0 : style.tab) === null || _g === void 0 ? void 0 : _g.backgroundColor) === null || _h === void 0 ? void 0 : _h.active,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundDefault]: (_k = (_j = style === null || style === void 0 ? void 0 : style.tab) === null || _j === void 0 ? void 0 : _j.backgroundColor) === null || _k === void 0 ? void 0 : _k.default,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundDisabled]: (_m = (_l = style === null || style === void 0 ? void 0 : style.tab) === null || _l === void 0 ? void 0 : _l.backgroundColor) === null || _m === void 0 ? void 0 : _m.disabled,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBackgroundHover]: (_p = (_o = style === null || style === void 0 ? void 0 : style.tab) === null || _o === void 0 ? void 0 : _o.backgroundColor) === null || _p === void 0 ? void 0 : _p.hover,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorActive]: (_r = (_q = style === null || style === void 0 ? void 0 : style.tab) === null || _q === void 0 ? void 0 : _q.borderColor) === null || _r === void 0 ? void 0 : _r.active,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorDefault]: (_t = (_s = style === null || style === void 0 ? void 0 : style.tab) === null || _s === void 0 ? void 0 : _s.borderColor) === null || _t === void 0 ? void 0 : _t.default,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorDisabled]: (_v = (_u = style === null || style === void 0 ? void 0 : style.tab) === null || _u === void 0 ? void 0 : _u.borderColor) === null || _v === void 0 ? void 0 : _v.disabled,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleBorderColorHover]: (_x = (_w = style === null || style === void 0 ? void 0 : style.tab) === null || _w === void 0 ? void 0 : _w.borderColor) === null || _x === void 0 ? void 0 : _x.hover,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorActive]: (_z = (_y = style === null || style === void 0 ? void 0 : style.tab) === null || _y === void 0 ? void 0 : _y.color) === null || _z === void 0 ? void 0 : _z.active,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDefault]: (_1 = (_0 = style === null || style === void 0 ? void 0 : style.tab) === null || _0 === void 0 ? void 0 : _0.color) === null || _1 === void 0 ? void 0 : _1.default,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorDisabled]: (_3 = (_2 = style === null || style === void 0 ? void 0 : style.tab) === null || _2 === void 0 ? void 0 : _2.color) === null || _3 === void 0 ? void 0 : _3.disabled,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleColorHover]: (_5 = (_4 = style === null || style === void 0 ? void 0 : style.tab) === null || _4 === void 0 ? void 0 : _4.color) === null || _5 === void 0 ? void 0 : _5.hover,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderColor]: (_7 = (_6 = style === null || style === void 0 ? void 0 : style.tab) === null || _6 === void 0 ? void 0 : _6.focusRing) === null || _7 === void 0 ? void 0 : _7.borderColor,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderRadius]: (_9 = (_8 = style === null || style === void 0 ? void 0 : style.tab) === null || _8 === void 0 ? void 0 : _8.focusRing) === null || _9 === void 0 ? void 0 : _9.borderRadius,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleFocusRingBorderWidth]: (_11 = (_10 = style === null || style === void 0 ? void 0 : style.tab) === null || _10 === void 0 ? void 0 : _10.focusRing) === null || _11 === void 0 ? void 0 : _11.borderWidth
    };
}
function $f9b0c79b605bce6c$export$269d593d6e308d64(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) !== 'core') return undefined;
    return {
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleTabsActiveIndicatorColor]: (_b = (_a = style === null || style === void 0 ? void 0 : style.tab) === null || _a === void 0 ? void 0 : _a.activeIndicator) === null || _b === void 0 ? void 0 : _b.color,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleTabsActiveIndicatorWidth]: (_d = (_c = style === null || style === void 0 ? void 0 : style.tab) === null || _c === void 0 ? void 0 : _c.activeIndicator) === null || _d === void 0 ? void 0 : _d.width,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleTabsActiveIndicatorBorderRadius]: (_f = (_e = style === null || style === void 0 ? void 0 : style.tab) === null || _e === void 0 ? void 0 : _e.activeIndicator) === null || _f === void 0 ? void 0 : _f.borderRadius,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleTabsSeparatorColor]: (_g = style === null || style === void 0 ? void 0 : style.tabSeparator) === null || _g === void 0 ? void 0 : _g.color,
        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).styleTabsSeparatorWidth]: (_h = style === null || style === void 0 ? void 0 : style.tabSeparator) === null || _h === void 0 ? void 0 : _h.width
    };
}



var $47efe4393e872e0d$export$2e2bcd8739ae039 = {
    "tabs-header-list": "awsui_tabs-header-list_1acwa_dp0cl_5",
    "active-tab-header": "awsui_active-tab-header_1acwa_dp0cl_6",
    "tab-label": "awsui_tab-label_1acwa_dp0cl_7",
    "tab-dismiss-button": "awsui_tab-dismiss-button_1acwa_dp0cl_8"
};



var $b98c12bd88d60794$export$2e2bcd8739ae039 = {
    "tabs-header": "awsui_tabs-header_14rmt_nlsa1_154",
    "tab-header-scroll-container": "awsui_tab-header-scroll-container_14rmt_nlsa1_163",
    "tabs-header-list": "awsui_tabs-header-list_14rmt_nlsa1_169",
    "pagination-button": "awsui_pagination-button_14rmt_nlsa1_186",
    "pagination-button-left": "awsui_pagination-button-left_14rmt_nlsa1_193",
    "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_nlsa1_196",
    "pagination-button-right": "awsui_pagination-button-right_14rmt_nlsa1_200",
    "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_nlsa1_203",
    "actions-container": "awsui_actions-container_14rmt_nlsa1_208",
    "tabs-tab": "awsui_tabs-tab_14rmt_nlsa1_216",
    "tabs-tab-label": "awsui_tabs-tab-label_14rmt_nlsa1_226",
    "tabs-tab-header-container": "awsui_tabs-tab-header-container_14rmt_nlsa1_237",
    "tabs-tab-dismiss": "awsui_tabs-tab-dismiss_14rmt_nlsa1_245",
    "tabs-tab-action": "awsui_tabs-tab-action_14rmt_nlsa1_245",
    "refresh": "awsui_refresh_14rmt_nlsa1_250",
    "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_nlsa1_254",
    "tabs-tab-link": "awsui_tabs-tab-link_14rmt_nlsa1_296",
    "tabs-tab-active": "awsui_tabs-tab-active_14rmt_nlsa1_379",
    "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_nlsa1_388",
    "tabs-tab-focusable": "awsui_tabs-tab-focusable_14rmt_nlsa1_392",
    "root": "awsui_root_14rmt_nlsa1_396",
    "tabs": "awsui_tabs_14rmt_nlsa1_154",
    "tabs-content": "awsui_tabs-content_14rmt_nlsa1_434",
    "fit-height": "awsui_fit-height_14rmt_nlsa1_438",
    "tabs-content-active": "awsui_tabs-content-active_14rmt_nlsa1_444",
    "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_nlsa1_458",
    "with-paddings": "awsui_with-paddings_14rmt_nlsa1_458",
    "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_nlsa1_469",
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_14rmt_nlsa1_480",
    "tabs-tab-focused": "awsui_tabs-tab-focused_14rmt_nlsa1_484"
};



var $258c8583a174d7a9$export$2e2bcd8739ae039 = {
    "tab-dismiss-button": "awsui_tab-dismiss-button_1nq1i_1nd7r_5"
};


const $2bc37773cc3b7003$var$tabSelector = `.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-link']}`;
const $2bc37773cc3b7003$var$focusedTabSelector = `.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-focused']}`;
const $2bc37773cc3b7003$var$focusableTabSelector = `.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-focusable']}`;
function $2bc37773cc3b7003$var$dismissButton({ dismissLabel: dismissLabel, dismissDisabled: dismissDisabled, onDismiss: onDismiss, tabId: tabId }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        onClick: onDismiss,
        variant: "icon",
        iconName: "close",
        formAction: "none",
        ariaLabel: dismissLabel,
        disabled: dismissDisabled,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $258c8583a174d7a9$export$2e2bcd8739ae039)['tab-dismiss-button'], (0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tab-dismiss-button']),
        "data-testid": `awsui-tab-dismiss-button-${tabId}`
    });
}
function $2bc37773cc3b7003$export$54e7b1d47a1cf43a({ onChange: onChange, activeTabId: activeTabId, tabs: tabs, variant: variant, idNamespace: idNamespace, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, i18nStrings: i18nStrings, keyboardActivationMode: keyboardActivationMode, actions: actions, style: style }) {
    const headerBarRef = (0, $acw62.useRef)(null);
    const activeTabHeaderRef = (0, $acw62.useRef)(null);
    const inlineStartOverflowButton = (0, $acw62.useRef)(null);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('tabs');
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const containerObjectRef = (0, $acw62.useRef)(null);
    const documentRef = (0, $acw62.useRef)(typeof document !== 'undefined' ? document : null);
    const documentRefCallback = (node)=>{
        var _a;
        return documentRef.current = (_a = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _a !== void 0 ? _a : document;
    };
    const [widthChange, containerMeasureRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    const containerRef = (0, $013a2451794a45c0$exports.useMergeRefs)(containerObjectRef, containerMeasureRef, documentRefCallback);
    const tabRefs = (0, $acw62.useRef)(new Map());
    const [horizontalOverflow, setHorizontalOverflow] = (0, $acw62.useState)(false);
    const [inlineStartOverflow, setInlineStartOverflow] = (0, $acw62.useState)(false);
    const [inlineEndOverflow, setInlineEndOverflow] = (0, $acw62.useState)(false);
    const [focusedTabId, setFocusedTabId] = (0, $acw62.useState)(activeTabId);
    const [previousActiveTabId, setPreviousActiveTabId] = (0, $acw62.useState)(activeTabId);
    const hasActionOrDismissible = tabs.some((tab)=>tab.action || tab.dismissible);
    const hadActionOrDismissible = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(hasActionOrDismissible);
    const tabActionAttributes = hasActionOrDismissible ? {
        role: 'application',
        'aria-roledescription': i18n('i18nStrings.tabsWithActionsAriaRoleDescription', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.tabsWithActionsAriaRoleDescription)
    } : {
        role: 'tablist'
    };
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (hadActionOrDismissible && !hasActionOrDismissible) // when tabs becomes non-dismissible (e.g. when all dismissible tabs are removed),
        // the hasActionOrDismissible is changing which causing tabs to re-mount to the React tree,
        // which, in turn, causes losing their refs, and the nextActive.focus() function inside handleDismiss does not focus on the next tab
        // so this code does
        (_a = getNextFocusTarget()) === null || _a === void 0 || _a.focus();
    }, [
        hasActionOrDismissible,
        hadActionOrDismissible
    ]);
    (0, $acw62.useEffect)(()=>{
        if (headerBarRef.current) {
            setHorizontalOverflow((0, $ac20d4f6814ec953$export$6593e8d7c1045101)(headerBarRef.current, inlineStartOverflowButton));
            setInlineStartOverflow((0, $ac20d4f6814ec953$export$f68d63f3e53e9a7f)(headerBarRef.current));
            setInlineEndOverflow((0, $ac20d4f6814ec953$export$a741e8cb1f4eb366)(headerBarRef.current));
        }
    }, [
        widthChange,
        tabs
    ]);
    const scrollIntoViewIfPossible = (smooth)=>{
        if (!activeTabId) return;
        const activeTabRef = tabRefs.current.get(activeTabId);
        if (activeTabRef && headerBarRef.current) (0, $ac20d4f6814ec953$export$53a0910f038337bd)(activeTabRef, headerBarRef.current, smooth);
    };
    (0, $acw62.useEffect)(()=>{
        // Delay scrollIntoView as the position is depending on parent elements
        // (effects are called inside-out in the component tree).
        // Wait one frame to allow parents to complete it's calculation.
        requestAnimationFrame(()=>{
            scrollIntoViewIfPossible(false);
        });
    // Non-smooth scrolling should not be called upon activeId change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        horizontalOverflow,
        widthChange,
        tabs.length
    ]);
    (0, $acw62.useEffect)(()=>{
        scrollIntoViewIfPossible(true);
    // Smooth scrolling should only be called upon activeId change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeTabId
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        /*
         When the selected tab changes and we are currently already focused on a tab,
         move the focus to the newly selected tab.
        */ if (documentRef.current && ((_a = headerBarRef.current) === null || _a === void 0 ? void 0 : _a.contains(documentRef.current.activeElement))) {
            if (documentRef.current.activeElement !== activeTabHeaderRef.current) (_b = activeTabHeaderRef.current) === null || _b === void 0 || _b.focus({
                preventScroll: true
            });
        }
    }, [
        activeTabId
    ]);
    const onScroll = ()=>{
        if (headerBarRef.current) {
            setInlineStartOverflow((0, $ac20d4f6814ec953$export$f68d63f3e53e9a7f)(headerBarRef.current));
            setInlineEndOverflow((0, $ac20d4f6814ec953$export$a741e8cb1f4eb366)(headerBarRef.current));
        }
    };
    const classes = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-header']]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-header-with-divider']]: variant === 'default' || isVisualRefresh
    });
    const leftButtonClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['pagination-button']]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['pagination-button-left']]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['pagination-button-left-scrollable']]: inlineStartOverflow
    });
    const rightButtonClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['pagination-button']]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['pagination-button-right']]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['pagination-button-right-scrollable']]: inlineEndOverflow
    });
    const navigationAPI = (0, $acw62.useRef)(null);
    function getNextFocusTarget() {
        var _a, _b;
        if (!containerObjectRef.current) return null;
        const tabElements = Array.from(containerObjectRef.current.querySelectorAll($2bc37773cc3b7003$var$tabSelector));
        return (_b = (_a = tabElements.find((tab)=>tab.matches($2bc37773cc3b7003$var$focusedTabSelector))) !== null && _a !== void 0 ? _a : tabElements.find((tab)=>!tab.disabled)) !== null && _b !== void 0 ? _b : null;
    }
    function onUnregisterActive(focusableElement) {
        var _a;
        const isFocusableActionOrDismissible = !focusableElement.classList.contains((0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-link']);
        if (!isFocusableActionOrDismissible) {
            const nextFocusTarget = (_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.getFocusTarget();
            const tabLinkButton = nextFocusTarget === null || nextFocusTarget === void 0 ? void 0 : nextFocusTarget.querySelector(`.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-link']}`);
            tabLinkButton === null || tabLinkButton === void 0 || tabLinkButton.focus();
        }
    }
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    });
    function onFocus() {
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    }
    function onBlur() {
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    }
    function onKeyDown(event) {
        var _a, _b, _c;
        const focusTarget = (_a = documentRef.current) === null || _a === void 0 ? void 0 : _a.activeElement;
        const specialKeys = [
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageUp,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageDown,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space
        ];
        const isActionOpen = (_b = documentRef.current) === null || _b === void 0 ? void 0 : _b.querySelector(`.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-action']} [aria-expanded="true"]`);
        const isDismissOrActionFocused = !(focusTarget === null || focusTarget === void 0 ? void 0 : focusTarget.classList.contains((0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-link']));
        if (isActionOpen) return;
        if (event.key === 'Tab' && !event.shiftKey && isDismissOrActionFocused) {
            event.preventDefault();
            const panelId = `${idNamespace}-${activeTabId}-panel`;
            const panel = (_c = documentRef.current) === null || _c === void 0 ? void 0 : _c.getElementById(panelId);
            panel === null || panel === void 0 || panel.focus();
        }
        if ((0, $fc537b925f715587$export$17ddd23cbcfe5784)(event) || specialKeys.indexOf(event.keyCode) === -1) return;
        if (!containerObjectRef.current || !focusTarget) return;
        event.preventDefault();
        const focusables = getFocusablesFrom(containerObjectRef.current);
        const activeIndex = (0, $38f6480185c49d6f$export$1b3bfaa9684536aa)(focusTarget) ? focusables.indexOf(focusTarget) : -1;
        (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
            onHome: ()=>focusElement(focusables[0]),
            onEnd: ()=>focusElement(focusables[focusables.length - 1]),
            onInlineStart: ()=>focusElement(focusables[(0, $9cebea7438e8886d$export$548e06c1946bc4e)(activeIndex - 1, [
                    0,
                    focusables.length - 1
                ])]),
            onInlineEnd: ()=>focusElement(focusables[(0, $9cebea7438e8886d$export$548e06c1946bc4e)(activeIndex + 1, [
                    0,
                    focusables.length - 1
                ])]),
            onPageDown: ()=>inlineEndOverflow && (0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, 'forward'),
            onPageUp: ()=>inlineStartOverflow && (0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, 'backward'),
            onActivate: ()=>{
                var _a;
                return focusedTabId && focusedTabId !== activeTabId && onChange({
                    activeTabId: focusedTabId,
                    activeTabHref: (_a = tabs.find((tab)=>tab.id === focusedTabId)) === null || _a === void 0 ? void 0 : _a.href
                });
            }
        });
    }
    function focusElement(element) {
        var _a, _b;
        element.focus();
        // If focusable element is a tab - fire the onChange for it.
        const tabsById = tabs.reduce((map, tab)=>map.set(tab.id, tab), new Map());
        for (const [tabId, focusTargetTabTriggerElement] of tabRefs.current.entries()){
            const focusTargetTabLabelElement = focusTargetTabTriggerElement === null || focusTargetTabTriggerElement === void 0 ? void 0 : focusTargetTabTriggerElement.querySelector(`.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-link']}`);
            if (tabId !== activeTabId && focusTargetTabLabelElement === element) {
                setPreviousActiveTabId(tabId);
                setFocusedTabId(tabId);
                if (!((_a = tabsById.get(tabId)) === null || _a === void 0 ? void 0 : _a.disabled) && keyboardActivationMode === 'automatic') onChange({
                    activeTabId: tabId,
                    activeTabHref: (_b = tabsById.get(tabId)) === null || _b === void 0 ? void 0 : _b.href
                });
                break;
            }
        }
    }
    // List all non-disabled and registered focusables: those are eligible for keyboard navigation.
    function getFocusablesFrom(target) {
        function isElementRegistered(element) {
            var _a, _b;
            return (_b = (_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(element)) !== null && _b !== void 0 ? _b : false;
        }
        function isElementFocusable(element) {
            if (element instanceof HTMLButtonElement) return !element.disabled || element.closest($2bc37773cc3b7003$var$focusableTabSelector);
            return element.matches($2bc37773cc3b7003$var$focusableTabSelector);
        }
        return (0, $eaddf2de854ee801$export$3fcce23e1e72b35b)(target).filter((el)=>isElementRegistered(el) && isElementFocusable(el));
    }
    const TabList = hasActionOrDismissible ? 'div' : 'ul';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tab-header-scroll-container'],
        ref: containerRef
    }, horizontalOverflow && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: inlineStartOverflowButton,
        className: leftButtonClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        formAction: "none",
        variant: "icon",
        iconName: "angle-left",
        disabled: !inlineStartOverflow,
        __focusable: true,
        onClick: ()=>(0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, 'backward'),
        ariaLabel: i18n('i18nStrings.scrollLeftAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.scrollLeftAriaLabel)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.SingleTabStopNavigationProvider), {
        ref: navigationAPI,
        navigationActive: true,
        getNextFocusTarget: getNextFocusTarget,
        onUnregisterActive: onUnregisterActive
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TabList, {
        ...tabActionAttributes,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-header-list'], (0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tabs-header-list']),
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        ref: headerBarRef,
        onScroll: onScroll,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur
    }, tabs.map(renderTabHeader))), horizontalOverflow && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: rightButtonClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        formAction: "none",
        variant: "icon",
        iconName: "angle-right",
        disabled: !inlineEndOverflow,
        __focusable: true,
        onClick: ()=>(0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, 'forward'),
        ariaLabel: i18n('i18nStrings.scrollRightAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.scrollRightAriaLabel)
    }))), actions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)['actions-container']
    }, actions));
    function renderTabHeader(tab, index) {
        const { dismissible: dismissible, dismissLabel: dismissLabel, dismissDisabled: dismissDisabled, action: action, onDismiss: onDismiss } = tab;
        const isActive = activeTabId === tab.id && !tab.disabled;
        const clickTab = (event)=>{
            var _a;
            if (tab.disabled) {
                event.preventDefault();
                return;
            }
            // if the primary mouse button is clicked with a modifier key, the browser will handle opening a new tab
            const specialKey = !(0, $fc537b925f715587$export$aaf9a36dd84c3909)(event);
            if (specialKey && tab.href) return;
            event.preventDefault();
            // for browsers that do not focus buttons on button click
            if (!tab.href) {
                const clickedTabRef = tabRefs.current.get(tab.id);
                if (clickedTabRef) {
                    if (clickedTabRef && clickedTabRef !== ((_a = documentRef.current) === null || _a === void 0 ? void 0 : _a.activeElement)) clickedTabRef.focus({
                        preventScroll: true
                    });
                }
            }
            if (tab.id === activeTabId) return;
            setFocusedTabId(tab.id);
            setPreviousActiveTabId(tab.id);
            onChange({
                activeTabId: tab.id,
                activeTabHref: tab.href
            });
        };
        const classes = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-link']]: true,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039).refresh]: isVisualRefresh,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-active']]: activeTabId === tab.id && !tab.disabled,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-focused']]: focusedTabId === tab.id,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-active']]: isActive,
            [(0, $47efe4393e872e0d$export$2e2bcd8739ae039)['active-tab-header']]: isActive,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-disabled']]: tab.disabled,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-focusable']]: !tab.disabled || tab.disabled && !!tab.disabledReason
        });
        const tabHeaderContainerClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-header-container']]: true,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039).refresh]: isVisualRefresh,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-active']]: isActive,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-disabled']]: tab.disabled,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-focusable']]: !tab.disabled || tab.disabled && !!tab.disabledReason
        });
        const tabActionClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-action']]: true,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-active']]: isActive
        });
        const commonProps = {
            className: classes,
            'aria-controls': `${idNamespace}-${tab.id}-panel`,
            'data-testid': tab.id,
            id: $2bc37773cc3b7003$export$9697735e7c51a21({
                namespace: idNamespace,
                tabId: tab.id
            }),
            onClick: clickTab
        };
        const tabHeaderContainerAriaProps = hasActionOrDismissible ? {
            role: 'group',
            'aria-labelledby': commonProps.id
        } : {};
        if (!hasActionOrDismissible) {
            commonProps['aria-selected'] = activeTabId === tab.id;
            commonProps.role = 'tab';
        } else commonProps['aria-expanded'] = activeTabId === tab.id;
        if (tab.disabled) commonProps['aria-disabled'] = 'true';
        const setElement = (tabElement)=>{
            if (tab.id === activeTabId) activeTabHeaderRef.current = tabElement;
            tabRefs.current.set(tab.id, tabElement);
        };
        const handleDismiss = (event)=>{
            if (!containerObjectRef.current || !onDismiss) return;
            const tabElements = getFocusablesFrom(containerObjectRef.current).filter((el)=>el.classList.contains((0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-link']));
            const activeTabIndex = tabElements.findIndex((el)=>el.dataset.testid === tab.id);
            tabElements.splice(activeTabIndex, 1);
            let nextActive;
            if (previousActiveTabId && previousActiveTabId !== tab.id) nextActive = tabElements.find((el)=>el.dataset.testid === previousActiveTabId);
            else nextActive = tabElements[Math.min(tabElements.length - 1, activeTabIndex)];
            if (nextActive && nextActive.dataset.testid) {
                onChange({
                    activeTabId: nextActive.dataset.testid
                });
                setPreviousActiveTabId(nextActive.dataset.testid);
                nextActive.focus();
            }
            onDismiss(event);
        };
        const TabItem = hasActionOrDismissible ? 'div' : 'li';
        const analyticsDismissMetadata = {
            action: 'dismiss',
            detail: {
                id: tab.id,
                label: `.${(0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tab-dismiss-button']}`,
                position: `${index + 1}`
            }
        };
        const analyticsComponentMetadataInnerContext = {
            innerContext: {
                tabId: tab.id,
                tabLabel: `.${(0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tab-label']}`,
                tabPosition: `${index + 1}`
            }
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TabItem, {
            ref: (element)=>tabRefs.current.set(tab.id, element),
            className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab'],
            role: "presentation",
            key: tab.id
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: tabHeaderContainerClasses,
            ...tabHeaderContainerAriaProps,
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
                component: analyticsComponentMetadataInnerContext
            }),
            style: (0, $f9b0c79b605bce6c$export$269d593d6e308d64)(style)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2bc37773cc3b7003$var$TabTrigger, {
            ref: setElement,
            tab: tab,
            elementProps: commonProps,
            activeTabId: activeTabId,
            index: index,
            style: style
        }), action && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: tabActionClasses
        }, action), dismissible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-dismiss'],
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsDismissMetadata)
        }, $2bc37773cc3b7003$var$dismissButton({
            dismissLabel: dismissLabel,
            dismissDisabled: dismissDisabled,
            onDismiss: handleDismiss,
            tabId: tab.id
        }))));
    }
}
const $2bc37773cc3b7003$var$TabTrigger = (0, $acw62.forwardRef)(({ tab: tab, elementProps: elementProps, activeTabId: activeTabId, index: index, style: style }, ref)=>{
    const refObject = (0, $acw62.useRef)(null);
    const tabLabelRefObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(refObject, ref);
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(refObject);
    const isDisabledWithReason = tab.disabled && !!tab.disabledReason;
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(tab.disabledReason);
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-tab-label'], (0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tab-label']),
        ref: tabLabelRefObject
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, tab.label)), isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c45f0c9feef90f6$export$2e2bcd8739ae039), {
        className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)['disabled-reason-tooltip'],
        getTrack: ()=>tabLabelRefObject.current,
        content: tab.disabledReason,
        onEscape: ()=>setShowTooltip(false)
    })));
    const handlers = {
        onFocus: ()=>setShowTooltip(true),
        onBlur: ()=>setShowTooltip(false),
        onMouseEnter: ()=>setShowTooltip(true),
        onMouseLeave: ()=>setShowTooltip(false)
    };
    const analyticsSelectMetadata = {
        action: 'select',
        detail: {
            id: tab.id,
            label: `.${(0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tab-label']}`,
            position: `${index + 1}`,
            originTabId: activeTabId || ''
        }
    };
    const commonProps = {
        ...elementProps,
        ...isDisabledWithReason ? targetProps : {},
        ...isDisabledWithReason ? handlers : {},
        ref: mergedRef,
        tabIndex: tabIndex,
        style: {
            ...elementProps.style,
            ...(0, $f9b0c79b605bce6c$export$916c8b0fccbb37d2)(style)
        },
        ...tab.disabled || tab.id === activeTabId ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsSelectMetadata)
    };
    return tab.href ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...commonProps,
        href: tab.href
    }, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...commonProps,
        type: "button",
        disabled: tab.disabled && !isDisabledWithReason
    }, children);
});
function $2bc37773cc3b7003$export$9697735e7c51a21({ namespace: namespace, tabId: tabId }) {
    return namespace + '-' + tabId;
}




'use client';
function $e9b1a89cfa249459$var$firstEnabledTab(tabs) {
    const enabledTabs = tabs.filter((tab)=>!tab.disabled);
    if (enabledTabs.length > 0) return enabledTabs[0];
    return null;
}
function $e9b1a89cfa249459$var$shouldRenderTabContent(tab, viewedTabs) {
    switch(tab.contentRenderStrategy){
        case 'active':
            return false; // rendering active tab is handled directly in component
        case 'eager':
            return true;
        case 'lazy':
            return viewedTabs.has(tab.id);
    }
    return false;
}
function $e9b1a89cfa249459$export$2e2bcd8739ae039({ tabs: tabs, variant: variant = 'default', onChange: onChange, activeTabId: controlledTabId, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, disableContentPaddings: disableContentPaddings = false, i18nStrings: i18nStrings, fitHeight: fitHeight, keyboardActivationMode: keyboardActivationMode = 'automatic', actions: actions, style: style, ...rest }) {
    var _a, _b;
    for (const tab of tabs)(0, $3de0f29144bb4e85$export$6661f6891a200a5f)('Tabs', tab.href);
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Tabs', {
        props: {
            disableContentPaddings: disableContentPaddings,
            variant: variant,
            fitHeight: fitHeight,
            keyboardActivationMode: keyboardActivationMode
        },
        metadata: {
            hasActions: tabs.some((tab)=>!!tab.action),
            hasHeaderActions: !!actions,
            hasDisabledReasons: tabs.some((tab)=>!!tab.disabledReason),
            hasEagerLoadedTabs: tabs.some((tab)=>tab.contentRenderStrategy === 'eager'),
            hasLazyLoadedTabs: tabs.some((tab)=>tab.contentRenderStrategy === 'lazy')
        }
    });
    const idNamespace = (0, $013a2451794a45c0$exports.useUniqueId)('awsui-tabs-');
    const [activeTabId, setActiveTabId] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledTabId, onChange, (_b = (_a = $e9b1a89cfa249459$var$firstEnabledTab(tabs)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '', {
        componentName: 'Tabs',
        controlledProp: 'activeTabId',
        changeHandler: 'onChange'
    });
    const viewedTabs = (0, $acw62.useRef)(new Set());
    if (activeTabId !== undefined) viewedTabs.current.add(activeTabId);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const analyticsComponentMetadata = {
        name: 'awsui.Tabs',
        label: `.${(0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tabs-header-list']}`
    };
    if (activeTabId) analyticsComponentMetadata.properties = {
        activeTabId: activeTabId,
        activeTabLabel: `.${(0, $47efe4393e872e0d$export$2e2bcd8739ae039)['active-tab-header']} .${(0, $47efe4393e872e0d$export$2e2bcd8739ae039)['tab-label']}`,
        activeTabPosition: `${tabs.findIndex((tab)=>tab.id === activeTabId) + 1}`,
        tabsCount: `${tabs.length}`
    };
    const content = ()=>{
        const selectedTab = tabs.filter((tab)=>tab.id === activeTabId)[0];
        const renderContent = (tab)=>{
            const isTabSelected = tab === selectedTab;
            const classes = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
                [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-content']]: true,
                [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-content-active']]: isTabSelected
            });
            const contentAttributes = {
                className: classes,
                role: 'tabpanel',
                id: `${idNamespace}-${tab.id}-panel`,
                key: `${idNamespace}-${tab.id}-panel`,
                tabIndex: 0,
                'aria-labelledby': (0, $2bc37773cc3b7003$export$9697735e7c51a21)({
                    namespace: idNamespace,
                    tabId: tab.id
                })
            };
            const isContentShown = !tab.disabled && (isTabSelected || $e9b1a89cfa249459$var$shouldRenderTabContent(tab, viewedTabs.current));
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                ...contentAttributes
            }, isContentShown && tab.content);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(variant === 'container' || variant === 'stacked' ? (0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-container-content-wrapper'] : (0, $b98c12bd88d60794$export$2e2bcd8739ae039)['tabs-content-wrapper'], {
                [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['with-paddings']]: !disableContentPaddings
            })
        }, tabs.map(renderContent));
    };
    const header = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2bc37773cc3b7003$export$54e7b1d47a1cf43a), {
        activeTabId: activeTabId,
        variant: variant,
        idNamespace: idNamespace,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        tabs: tabs,
        actions: actions,
        onChange: (changeDetail)=>{
            setActiveTabId(changeDetail.activeTabId);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, changeDetail);
        },
        i18nStrings: i18nStrings,
        keyboardActivationMode: keyboardActivationMode,
        style: style
    });
    if (variant === 'container' || variant === 'stacked') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$2e2bcd8739ae039), {
        header: header,
        disableHeaderPaddings: true,
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $b98c12bd88d60794$export$2e2bcd8739ae039).root),
        __internalRootRef: __internalRootRef,
        __contentKey: activeTabId,
        disableContentPaddings: true,
        variant: variant === 'stacked' ? 'stacked' : 'default',
        fitHeight: fitHeight,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: analyticsComponentMetadata
        }),
        style: style === null || style === void 0 ? void 0 : style.container
    }, content());
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $b98c12bd88d60794$export$2e2bcd8739ae039).root, (0, $b98c12bd88d60794$export$2e2bcd8739ae039).tabs, {
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)['fit-height']]: fitHeight
        }),
        ref: __internalRootRef,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: analyticsComponentMetadata
        })
    }, header, content());
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($e9b1a89cfa249459$export$2e2bcd8739ae039, 'Tabs');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $de955624d56c6200$export$781dbfefad5ba4c8(style) {
    return (0, $33e7e05d308de989$export$42752b7c8e044245)(style, true);
}



var $77ecea69e11a09ba$export$2e2bcd8739ae039 = {
    "root": "awsui_root_qk1j1_nfhdp_145",
    "textarea": "awsui_textarea_qk1j1_nfhdp_149",
    "textarea-readonly": "awsui_textarea-readonly_qk1j1_nfhdp_206",
    "textarea-invalid": "awsui_textarea-invalid_qk1j1_nfhdp_247",
    "textarea-warning": "awsui_textarea-warning_qk1j1_nfhdp_256"
};


'use client';
const $def0f31f988660f4$var$Textarea = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, autoComplete: autoComplete = true, disabled: disabled, readOnly: readOnly, disableBrowserAutocorrect: disableBrowserAutocorrect, disableBrowserSpellcheck: disableBrowserSpellcheck, spellcheck: spellcheck, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onChange: onChange, onBlur: onBlur, onFocus: onFocus, ariaRequired: ariaRequired, name: name, rows: rows, placeholder: placeholder, autoFocus: autoFocus, ariaLabel: ariaLabel, nativeTextareaAttributes: nativeTextareaAttributes, style: style, ...rest }, ref)=>{
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Textarea', {
        props: {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            disableBrowserAutocorrect: disableBrowserAutocorrect,
            disableBrowserSpellcheck: disableBrowserSpellcheck,
            readOnly: readOnly,
            spellcheck: spellcheck
        }
    });
    const { ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, controlId: controlId, invalid: invalid, warning: warning } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const textareaRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, textareaRef);
    const attributes = {
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby,
        'aria-describedby': ariaDescribedby,
        'aria-required': ariaRequired ? 'true' : undefined,
        'aria-invalid': invalid ? 'true' : undefined,
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $77ecea69e11a09ba$export$2e2bcd8739ae039).textarea, {
            [(0, $77ecea69e11a09ba$export$2e2bcd8739ae039)['textarea-readonly']]: readOnly,
            [(0, $77ecea69e11a09ba$export$2e2bcd8739ae039)['textarea-invalid']]: invalid,
            [(0, $77ecea69e11a09ba$export$2e2bcd8739ae039)['textarea-warning']]: warning && !invalid
        }),
        autoComplete: (0, $b4592d5eb2ab5ee3$export$d0b21904efc6680a)(autoComplete),
        spellCheck: spellcheck,
        disabled: disabled,
        readOnly: readOnly ? true : undefined,
        rows: rows || 3,
        onKeyDown: onKeyDown && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event)),
        onKeyUp: onKeyUp && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyUp, event)),
        // We set a default value on the component in order to force it into the controlled mode.
        value: value || '',
        onChange: onChange && ((event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: event.target.value
            })),
        onBlur: onBlur && (()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur)),
        onFocus: onFocus && (()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus))
    };
    if (disableBrowserAutocorrect) {
        attributes.autoCorrect = 'off';
        attributes.autoCapitalize = 'off';
    }
    if (disableBrowserSpellcheck) attributes.spellCheck = 'false';
    const componentAnalyticsMetadata = {
        name: 'awsui.Textarea',
        label: 'textarea',
        properties: {
            value: value || ''
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $77ecea69e11a09ba$export$2e2bcd8739ae039).root, baseProps.className),
        ref: __internalRootRef,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticsMetadata
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
        ...attributes,
        tag: "textarea",
        componentName: "Textarea",
        nativeAttributes: nativeTextareaAttributes,
        ref: textareaRef,
        id: controlId,
        style: (0, $de955624d56c6200$export$781dbfefad5ba4c8)(style)
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($def0f31f988660f4$var$Textarea, 'Textarea');
var $def0f31f988660f4$export$2e2bcd8739ae039 = $def0f31f988660f4$var$Textarea;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;


const $c0aa018cd5ecdf0e$export$f51d452c10d5b956 = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8).withTypes();
const $c0aa018cd5ecdf0e$export$a7347740d65f620b = (0, $55388fc2f116d4d7$export$2105062e25df4afe).withTypes();








const $ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS = 5;
const $ef4677a056004d8e$export$eb2799109db70ffd = ()=>{
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const { appVersion: appVersion } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const makeApiCall = async (url, method = "GET", data)=>{
        // Setup
        let cacheControl = `&_=${Date.now()}`; // don't cache stuff
        if (url.includes("html")) cacheControl = "";
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}${url}?v=${appVersion}${cacheControl}`;
        // make API call
        const fetchOptions = {
            method: method,
            headers: {
                Authorization: "Bearer " + auth.getAccessToken()
            }
        };
        if (method == "POST") {
            if (data instanceof FormData) fetchOptions.body = data;
            else fetchOptions.body = JSON.stringify(data);
        }
        return await makeApiCallInternal(urlToCall, fetchOptions);
    };
    const makeApiCallInternal = async (urlToCall, fetchOptions, raiseErrors = true, authRetryCount = 1)=>{
        // make API call
        try {
            const response = await fetch(urlToCall, fetchOptions);
            if (response.ok) {
                // success
                const json = await response.json();
                return Promise.resolve(json);
            } else if (response.status == 401) {
                if (authRetryCount > $ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS) {
                    // only try AUTH_RETRY_ATTEMPTS times
                    console.log(`auth retry count exceeded ${$ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS} attempts`);
                    (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                        type: "error",
                        content: `Unable to authenticate with server, ${$ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS} attempts were made`
                    }));
                    return Promise.reject("Unable to authenticate with server, multiple attempts were made");
                }
                return auth.performTokenRefresh().then((x)=>{
                    // try call again
                    fetchOptions.headers["Authorization"] = "Bearer " + auth.getAccessToken(); // update auth token
                    return makeApiCallInternal(urlToCall, fetchOptions, raiseErrors, authRetryCount + 1).then((x)=>{
                        return Promise.resolve(x);
                    });
                }).catch((err)=>{
                    console.error("error while getting refresh token");
                    console.log(err);
                    // TODO: show login dialog -> which should then essentially restart the application initialization stuff as it will have new tokens
                    // setShowLoginDialog -> or something like that
                    return Promise.resolve(null);
                });
            } else if (response.status == 400) {
                let message = await response.text();
                if (message.includes("invalid_grant")) message = "Incorrect username or password";
                else if (message.startsWith('"')) message = message.substring(1, message.length - 2);
                (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                    type: "error",
                    content: message
                }));
                return Promise.resolve(null);
            }
            const responseText = await response.text();
            const message = `Unhandled response status ${response.status} with content: ${responseText}`;
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: message
            }));
            return Promise.reject(message);
        } catch (err) {
            console.log("error making api call to: " + urlToCall);
            console.log(err);
            if (raiseErrors == true) (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Error making api call to: ${urlToCall}`
            }));
            else return null;
        // alert(
        //   "Error contacting the server. You might not have internet or our server is down"
        // );
        }
    };
    return {
        makeApiCall: makeApiCall
    };
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $5dbc399a9d723999$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)({});
const $5dbc399a9d723999$export$178405afcd8c5eb = ({ children: children })=>{
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const [currentAction, setCurrentAction] = (0, $acw62.useState)("none");
    const [confirmationSettings, setConfirmationSettings] = (0, $acw62.useState)(null);
    const [mainProps, setMainProps] = (0, $acw62.useState)({
        onCloseAction: ()=>{
            return Promise.resolve();
        }
    });
    // TODO: maybe todo. keep stack of modals so that they can be closed incrementally using an internal id etc.
    const getUserConfirmation = (props, data)=>{
        setCurrentAction("user-confirmation");
        setConfirmationSettings(props);
        setIsVisible(true);
        return new Promise((resolve)=>{
            setMainProps({
                ...mainProps,
                onCloseAction: (result)=>{
                    setIsVisible(false);
                    resolve(result);
                }
            });
        });
    };
    const onDismiss = (result)=>{
        mainProps.onCloseAction(result);
    };
    const UserConfirmationDialog = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $104eee66f5fcddce$export$2e2bcd8739ae039), {
            onDismiss: (detail)=>onDismiss(null),
            visible: currentAction != "none" && isVisible,
            footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                float: "right",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                    direction: "horizontal",
                    size: "xs",
                    children: [
                        confirmationSettings?.CancelButtonText?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                            variant: "link",
                            onClick: ()=>onDismiss(false),
                            children: confirmationSettings?.CancelButtonText
                        }) : null,
                        confirmationSettings?.ConfirmationButtonText?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                            variant: "primary",
                            onClick: ()=>onDismiss(true),
                            children: confirmationSettings?.ConfirmationButtonText
                        }) : null
                    ]
                })
            }),
            header: "Confirmation",
            children: confirmationSettings?.ConfirmationMessage
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($5dbc399a9d723999$export$ab57792b9b6974a6.Provider, {
        value: {
            getUserConfirmation: getUserConfirmation
        },
        children: [
            currentAction == "user-confirmation" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UserConfirmationDialog, {}) : null,
            children
        ]
    });
};
const $5dbc399a9d723999$export$33ffd74ebf07f060 = ()=>{
    const context = (0, $acw62.useContext)($5dbc399a9d723999$export$ab57792b9b6974a6);
    if (!context) throw new Error("useModal must be used within an ModalProvider");
    return context;
};








const $ba30691687bb8563$var$ActionContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $ba30691687bb8563$export$9ba8495ab9fb7661 = ({ children: children })=>{
    //const navigate = useNavigate();
    const modal = (0, $5dbc399a9d723999$export$33ffd74ebf07f060)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const encode = (str)=>{
        return btoa(str);
    // const result = btoa(
    //   encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    //     return String.fromCharCode(0 + p1);
    //   })
    // );
    // return result;
    };
    const downloadFile = async (url, requestData)=>{
        (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
            type: "info",
            content: "File download started..."
        }));
        let urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}${url}?v=${mainApp.appVersion}`;
        urlToCall = urlToCall.replaceAll("//", "/");
        // make API call
        const fetchOptions = {
            method: "POST",
            headers: {
                Authorization: "Bearer " + auth.getAccessToken()
            }
        };
        if (requestData && requestData.length > 0) fetchOptions.body = encode(requestData);
        try {
            const fetchUrl = new URL(urlToCall); // fails without this on some domains (it adds extra localhost when https://localhost/Odyssey/ for example)
            const response = await fetch(fetchUrl, fetchOptions);
            if (response.ok) {
                const blob = await response.blob();
                let filename = response.headers.get("filename");
                if (filename == null || filename.length == 0) filename = "unknown file.zip";
                const objUrl = URL.createObjectURL(new Blob([
                    blob
                ]));
                const link = document.createElement("a");
                link.href = objUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(objUrl);
                link.remove();
                (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                    type: "success",
                    content: "File download complete"
                }));
            }
        } catch (err) {
            console.log("error downloading file with url: " + urlToCall);
            console.log(err);
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Error downloading file: ${err}`
            }));
        }
    };
    const handleAction = async (item)=>{
        switch(item.ActionType){
            case 0:
                // show a view
                mainApp.setCurrentContentType("table");
                mainApp.showComponent({
                    menu: item,
                    type: "view"
                });
                break;
            case 1:
                // get inputs
                mainApp.showComponent({
                    menu: item,
                    type: "form"
                });
                break;
            //case 2: // submenu  - // nothing, this is commented out in the old code
            //case 3: // do something - // nothing, this is commented out in the old code
            case 4:
                mainApp.showComponent(-1);
                break;
            case 5:
                // ShowMessage
                modal.getUserConfirmation(item, null).then((result)=>{
                    if (result === true && item.OnConfirmationUIAction > 0) return onMenuClick(item.OnConfirmationUIAction, null);
                    else if (result === false && item.OnCancelUIAction > 0) return onMenuClick(item.OnCancelUIAction, null);
                });
                break;
            case 6:
                await onMenuClick(item.EventNumber, item.ParametersToPass);
                break;
            //case 7: // input data view (ignore in old code)
            case 8:
            case 9:
                // update input view
                if (item.UpdateType == 0) {
                    // add or update
                    const json = JSON.parse(item.JsonDataToUpdate);
                    mainApp.setInputViewUpdateData(json);
                } else if (item.UpdateType == 1) mainApp.setInputViewUpdateData(-1);
                break;
            case 11:
                await downloadFile(item.DataUrl, item.RequestData);
                break;
            case 13:
                const url = new URL(window.location.href);
                url.searchParams.delete("anonAction");
                url.searchParams.delete("params");
                window.history.pushState(null, "", url.toString());
                auth.logout();
                break;
            default:
                console.warn("Unknown action type: " + item.ActionType);
        }
    };
    const onMenuClick = async (event, params = null)=>{
        const url = "executeUIAction/" + event;
        const data = {
            Data: params || ""
        };
        const menuDetails = await api.makeApiCall(url, "POST", data);
        if (menuDetails && menuDetails.length > 0) for(let i = 0; i < menuDetails?.length; i++)await handleAction(menuDetails[i]);
    };
    const value = {
        handleAction: handleAction,
        onMenuClick: onMenuClick
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba30691687bb8563$var$ActionContext.Provider, {
        value: value,
        children: children
    });
};
const $ba30691687bb8563$export$bc923229a7fa61e7 = ()=>{
    const context = (0, $acw62.useContext)($ba30691687bb8563$var$ActionContext);
    if (!context) throw new Error("useActions must be used within an ActionProvider");
    return context;
};



var $45fvw = parcelRequire("45fvw");
// export const useDebounce_old = (callback, params = null, timeout = 250) => {
//   const ref = useRef(callback);
//   ref.current = callback;
//   const debouncedCallback = useMemo(() => {
//     const func = () => {
//       ref.current?.(params);
//     };
//     return debounce(func, timeout);
//   }, []);
//   return debouncedCallback;
// };
const $154d4ea6bbdaf516$var$timers = {};
const $154d4ea6bbdaf516$export$21805fee57372823 = (callback, name, timeout, ...params)=>{
    let timer = $154d4ea6bbdaf516$var$timers[name];
    if (timer) {
        clearTimeout(timer);
        $154d4ea6bbdaf516$var$timers[name] = null;
    }
    timer = setTimeout(()=>{
        callback(...params);
        clearTimeout(timer);
        $154d4ea6bbdaf516$var$timers[name] = null;
    }, timeout);
    $154d4ea6bbdaf516$var$timers[name] = timer;
};
// https://www.geeksforgeeks.org/how-to-get-the-javascript-function-parameter-names-values-dynamically/
// JavaScript program to get the function
// name/values dynamically
function $154d4ea6bbdaf516$var$getParams(func) {
    // String representation of the function code
    let str = func.toString();
    // Remove comments of the form /* ... */
    // Removing comments of the form //
    // Remove body of the function { ... }
    // removing '=>' if func is arrow function
    str = str.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/(.)*/g, "").replace(/{[\s\S]*}/, "").replace(/=>/g, "").trim();
    // Start parameter names after first '('
    let start = str.indexOf("(") + 1;
    // End parameter names is just before last ')'
    let end = str.length - 1;
    let result = str.substring(start, end).split(", ");
    let params = [];
    result.forEach((element)=>{
        // Removing any default value
        element = element.replace(/=[\s\S]*/g, "").trim();
        if (element.length > 0) params.push(element);
    });
    return params;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO [mjawors] _.range
function $eb66e6aa0a7b025e$export$d02631cccf789723(from, to) {
    const result = [];
    for(let i = from; i <= to; i++)result.push(i);
    return result;
}
function $eb66e6aa0a7b025e$export$bc4b74228f8b7ec8(currentPageIndex, totalPagesCount, isOpenEnd) {
    // Total number of elements handled here
    const numberOfControls = 7;
    // Max number of controls that can be displayed on the left and right hand side of the current page.
    // Works only for odd numbers
    const leftDelta = Math.floor(numberOfControls / 2);
    let rightDelta = leftDelta;
    // upper and lower limits for pages range
    const lowerLimit = 2;
    let upperLimit = totalPagesCount - 1;
    if (isOpenEnd) {
        rightDelta++;
        upperLimit = totalPagesCount + 1;
    }
    // Left and right indices based on delta calculation
    let leftIndex = currentPageIndex - leftDelta;
    let rightIndex = currentPageIndex + rightDelta;
    // adjust page indexes if page index is too small
    if (leftIndex < lowerLimit) {
        rightIndex += lowerLimit - leftIndex;
        leftIndex = lowerLimit;
    }
    // adjust page indexes if page index is to big
    if (rightIndex > upperLimit) {
        leftIndex -= rightIndex - upperLimit;
        rightIndex = upperLimit;
    }
    // adjust indexes one more time to avoid out of range errors
    leftIndex = Math.max(leftIndex, 2);
    rightIndex = Math.min(rightIndex, upperLimit);
    // consider adding dots
    const leftDots = leftIndex > 2;
    const rightDots = isOpenEnd || rightIndex < upperLimit;
    if (leftDots) leftIndex++;
    if (rightDots) rightIndex--;
    return {
        leftDots: leftDots,
        rightDots: rightDots,
        leftIndex: leftIndex,
        rightIndex: rightIndex
    };
}



var $279d8c8b10ff543c$export$2e2bcd8739ae039 = {
    "root": "awsui_root_fvjdu_1toqn_145",
    "button": "awsui_button_fvjdu_1toqn_185",
    "dots": "awsui_dots_fvjdu_1toqn_186",
    "button-disabled": "awsui_button-disabled_fvjdu_1toqn_214",
    "arrow": "awsui_arrow_fvjdu_1toqn_219",
    "page-number": "awsui_page-number_fvjdu_1toqn_229",
    "button-current": "awsui_button-current_fvjdu_1toqn_235",
    "page-item": "awsui_page-item_fvjdu_1toqn_252",
    "root-disabled": "awsui_root-disabled_fvjdu_1toqn_270"
};


const $32dda691ea069b7d$var$defaultAriaLabels = {
    nextPageLabel: '',
    paginationLabel: '',
    previousPageLabel: '',
    pageLabel: (pageNumber)=>`${pageNumber}`
};
function $32dda691ea069b7d$var$PageButton({ className: className, ariaLabel: ariaLabel, disabled: disabled, pageIndex: pageIndex, isCurrent: isCurrent = false, children: children, onClick: onClick, ...rest }) {
    function handleClick(event) {
        event.preventDefault();
        onClick(pageIndex);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)['page-item'],
        ...(0, $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute)(rest)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).button, disabled && (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)['button-disabled'], isCurrent && (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)['button-current']),
        type: "button",
        "aria-label": ariaLabel,
        disabled: disabled,
        onClick: handleClick,
        "aria-current": isCurrent,
        ...disabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: 'click',
            detail: {
                label: {
                    root: 'self'
                }
            }
        })
    }, children));
}
function $32dda691ea069b7d$var$PageNumber({ pageIndex: pageIndex, ...rest }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageButton, {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)['page-number'],
        pageIndex: pageIndex,
        ...rest,
        ...rest.disabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            detail: {
                position: `${pageIndex}`
            }
        })
    }, pageIndex);
}
function $32dda691ea069b7d$export$2e2bcd8739ae039({ openEnd: openEnd, currentPageIndex: currentPageIndex, ariaLabels: ariaLabels, pagesCount: pagesCount, disabled: disabled, onChange: onChange, onNextPageClick: onNextPageClick, onPreviousPageClick: onPreviousPageClick, __internalRootRef: __internalRootRef, ...rest }) {
    var _a, _b, _c, _d;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const { leftDots: leftDots, leftIndex: leftIndex, rightIndex: rightIndex, rightDots: rightDots } = (0, $eb66e6aa0a7b025e$export$bc4b74228f8b7ec8)(currentPageIndex, pagesCount, openEnd);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('pagination');
    const paginationLabel = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.paginationLabel;
    const nextPageLabel = (_a = i18n('ariaLabels.nextPageLabel', ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.nextPageLabel)) !== null && _a !== void 0 ? _a : $32dda691ea069b7d$var$defaultAriaLabels.nextPageLabel;
    const previousPageLabel = (_b = i18n('ariaLabels.previousPageLabel', ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.previousPageLabel)) !== null && _b !== void 0 ? _b : $32dda691ea069b7d$var$defaultAriaLabels.previousPageLabel;
    const pageNumberLabelFn = (_c = i18n('ariaLabels.pageLabel', ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.pageLabel, (format)=>(pageNumber)=>format({
                pageNumber: pageNumber
            }))) !== null && _c !== void 0 ? _c : $32dda691ea069b7d$var$defaultAriaLabels.pageLabel;
    function handlePrevPageClick(requestedPageIndex) {
        handlePageClick(requestedPageIndex);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onPreviousPageClick, {
            requestedPageAvailable: true,
            requestedPageIndex: requestedPageIndex
        });
    }
    function handleNextPageClick(requestedPageIndex) {
        handlePageClick(requestedPageIndex);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onNextPageClick, {
            requestedPageAvailable: currentPageIndex < pagesCount,
            requestedPageIndex: requestedPageIndex
        });
    }
    function handlePageClick(requestedPageIndex) {
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            currentPageIndex: requestedPageIndex
        });
    }
    const previousButtonDisabled = disabled || currentPageIndex === 1;
    const nextButtonDisabled = disabled || !openEnd && (pagesCount === 0 || currentPageIndex === pagesCount);
    const tableComponentContext = (0, $83cc797b0d9c18d5$export$b4130bf0cd295245)();
    if ((_d = tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.paginationRef) === null || _d === void 0 ? void 0 : _d.current) {
        tableComponentContext.paginationRef.current.currentPageIndex = currentPageIndex;
        tableComponentContext.paginationRef.current.totalPageCount = pagesCount;
        tableComponentContext.paginationRef.current.openEnd = openEnd;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": paginationLabel,
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).root, disabled && (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)['root-disabled']),
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageButton, {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).arrow,
        pageIndex: currentPageIndex - 1,
        ariaLabel: previousPageLabel !== null && previousPageLabel !== void 0 ? previousPageLabel : $32dda691ea069b7d$var$defaultAriaLabels.nextPageLabel,
        disabled: previousButtonDisabled,
        onClick: handlePrevPageClick,
        ...previousButtonDisabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            detail: {
                position: 'prev'
            }
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-left",
        variant: disabled ? 'disabled' : 'normal'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageNumber, {
        pageIndex: 1,
        isCurrent: currentPageIndex === 1,
        disabled: disabled,
        ariaLabel: pageNumberLabelFn(1),
        onClick: handlePageClick
    }), leftDots && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).dots
    }, "..."), (0, $eb66e6aa0a7b025e$export$d02631cccf789723)(leftIndex, rightIndex).map((pageIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageNumber, {
            key: pageIndex,
            isCurrent: currentPageIndex === pageIndex,
            pageIndex: pageIndex,
            disabled: disabled,
            ariaLabel: pageNumberLabelFn(pageIndex),
            onClick: handlePageClick
        })), rightDots && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).dots
    }, "..."), !openEnd && pagesCount > 1 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageNumber, {
        isCurrent: currentPageIndex === pagesCount,
        pageIndex: pagesCount,
        disabled: disabled,
        ariaLabel: pageNumberLabelFn(pagesCount),
        onClick: handlePageClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageButton, {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).arrow,
        pageIndex: currentPageIndex + 1,
        ariaLabel: nextPageLabel !== null && nextPageLabel !== void 0 ? nextPageLabel : $32dda691ea069b7d$var$defaultAriaLabels.nextPageLabel,
        disabled: nextButtonDisabled,
        onClick: handleNextPageClick,
        ...nextButtonDisabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            detail: {
                position: 'next'
            }
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-right",
        variant: disabled ? 'disabled' : 'normal'
    })));
}


'use client';
function $ede657b6d0ca61ed$export$2e2bcd8739ae039(props) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Pagination', {
        props: {
            openEnd: props.openEnd
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32dda691ea069b7d$export$2e2bcd8739ae039), {
        ...props,
        ...baseComponentProps,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: {
                name: 'awsui.Pagination',
                label: {
                    root: 'self'
                },
                properties: {
                    openEnd: `${!!props.openEnd}`,
                    pagesCount: `${props.pagesCount || ''}`,
                    currentPageIndex: `${props.currentPageIndex}`
                }
            }
        })
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($ede657b6d0ca61ed$export$2e2bcd8739ae039, 'Pagination');

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $5b10d779002c4c5b$export$69e2f3b88d2c5d7 = (0, $acw62.createContext)({});




const $18fb5778d4dc41bf$var$stateToIcon = {
    sortable: 'caret-down',
    ascending: 'caret-up-filled',
    descending: 'caret-down-filled'
};
const $18fb5778d4dc41bf$export$522d1547ed3f4c02 = (sortable, sorted, descending, disabled)=>{
    if (sorted) {
        if (descending) return 'descending';
        return 'ascending';
    }
    if (sortable && !disabled) return 'sortable';
    return undefined;
};
const $18fb5778d4dc41bf$export$f3a117936eca5c61 = (sortingState)=>$18fb5778d4dc41bf$var$stateToIcon[sortingState];
const $18fb5778d4dc41bf$export$efa610630f9e181 = (column, sortingColumn)=>column === sortingColumn || column.sortingField !== undefined && column.sortingField === sortingColumn.sortingField || column.sortingComparator !== undefined && column.sortingComparator === sortingColumn.sortingComparator;
const $18fb5778d4dc41bf$export$5b69c4c6aae8a17d = (columnDefinitions = [], sortingColumn)=>{
    if (!sortingColumn) return null;
    for(let i = 0; i < columnDefinitions.length; i++){
        if ($18fb5778d4dc41bf$export$efa610630f9e181(columnDefinitions[i], sortingColumn)) return columnDefinitions[i].id || null;
    }
    return null;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $796a0d0b43417279$var$useEventListenersSingleton = (0, $013a2451794a45c0$exports.createSingletonHandler)((setTarget)=>{
    function handleMouseDown(event) {
        setTarget(event.target);
    }
    function handleKeyDown() {
        setTarget(null);
    }
    const controller = new AbortController();
    window.addEventListener('mousedown', handleMouseDown, {
        signal: controller.signal
    });
    window.addEventListener('keydown', handleKeyDown, {
        signal: controller.signal
    });
    return ()=>{
        controller.abort();
    };
});
function $796a0d0b43417279$export$2e2bcd8739ae039() {
    const mouseDownTargetRef = (0, $acw62.useRef)(null);
    $796a0d0b43417279$var$useEventListenersSingleton((target)=>{
        mouseDownTargetRef.current = target;
    });
    return ()=>mouseDownTargetRef.current;
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $00ea7b4995e93369$export$5a6f6c506490de72(refs) {
    const activeElement = (0, $acw62.useRef)(null);
    return (event)=>{
        const targetElement = event.currentTarget;
        // remembers the first element that fires onscroll to align with other elements against it
        if (targetElement && (activeElement.current === null || activeElement.current === targetElement)) requestAnimationFrame(()=>{
            activeElement.current = targetElement;
            refs.forEach((ref)=>{
                const element = ref.current;
                if (element && element !== targetElement) element.scrollLeft = targetElement.scrollLeft;
            });
            // unblock the ability to scroll the synced elements
            requestAnimationFrame(()=>{
                activeElement.current = null;
            });
        });
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






/*
If the last user interaction is more than this time ago, it is not considered
to be the cause of the current loading state.
*/ const $d455eb7d4e18ed2a$var$USER_ACTION_TIME_LIMIT = 1000;
function $d455eb7d4e18ed2a$export$4141b24171098aae({ elementRef: elementRef, items: items, itemCount: itemCount, instanceIdentifier: instanceIdentifier, getComponentIdentifier: getComponentIdentifier, getComponentConfiguration: getComponentConfiguration, loading: loading = false, interactionMetadata: interactionMetadata }) {
    const taskInteractionId = (0, $013a2451794a45c0$exports.useRandomId)();
    const tableInteractionAttributes = (0, $9c1836ca8dd61d43$export$69a1650565b41024)(elementRef, 'data-analytics-task-interaction-id', taskInteractionId);
    const { isInFunnel: isInFunnel } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const lastUserAction = (0, $acw62.useRef)(null);
    const capturedUserAction = (0, $acw62.useRef)(null);
    const loadingStartTime = (0, $acw62.useRef)(null);
    const isMountedRef = (0, $acw62.useRef)(true);
    const metadata = (0, $acw62.useRef)({
        itemCount: itemCount,
        getComponentIdentifier: getComponentIdentifier,
        getComponentConfiguration: getComponentConfiguration,
        interactionMetadata: interactionMetadata
    });
    metadata.current = {
        itemCount: itemCount,
        getComponentIdentifier: getComponentIdentifier,
        getComponentConfiguration: getComponentConfiguration,
        interactionMetadata: interactionMetadata
    };
    (0, $acw62.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isInFunnel) return;
        (0, $54d511b0978bc73c$export$ac7489d0d2439141).componentMounted({
            taskInteractionId: taskInteractionId,
            componentName: 'table',
            componentConfiguration: metadata.current.getComponentConfiguration()
        });
    }, [
        taskInteractionId,
        isInFunnel
    ]);
    (0, $acw62.useEffect)(()=>{
        if (loading) {
            loadingStartTime.current = performance.now();
            if (lastUserAction.current && lastUserAction.current.time > performance.now() - $d455eb7d4e18ed2a$var$USER_ACTION_TIME_LIMIT) capturedUserAction.current = lastUserAction.current.name;
            else capturedUserAction.current = null;
        }
    }, [
        loading
    ]);
    (0, $5f60cc888539a35b$export$21dfe79102a9caab)(()=>{
        var _a;
        if (!loading && loadingStartTime.current !== null) {
            const loadingDuration = performance.now() - loadingStartTime.current;
            loadingStartTime.current = null;
            (0, $54d511b0978bc73c$export$68015ba807c17f26).tableInteraction({
                userAction: (_a = capturedUserAction.current) !== null && _a !== void 0 ? _a : '',
                interactionTime: Math.round(loadingDuration),
                interactionMetadata: metadata.current.interactionMetadata(),
                componentIdentifier: metadata.current.getComponentIdentifier(),
                instanceIdentifier: instanceIdentifier,
                noOfResourcesInTable: metadata.current.itemCount
            });
        }
    }, [
        instanceIdentifier,
        loading,
        taskInteractionId,
        isInFunnel
    ]);
    const debouncedUpdated = (0, $2f667510820517ed$export$40ae01be0011c1e6)(()=>{
        var _a, _b;
        if (!isMountedRef.current) return;
        (0, $54d511b0978bc73c$export$ac7489d0d2439141).componentUpdated({
            taskInteractionId: taskInteractionId,
            componentName: 'table',
            actionType: (_b = (_a = lastUserAction.current) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
            componentConfiguration: metadata.current.getComponentConfiguration()
        });
    });
    (0, $5f60cc888539a35b$export$21dfe79102a9caab)(()=>{
        if (isInFunnel || loading) return;
        debouncedUpdated();
    // Note: items used as a dependency here to trigger updates as a side effect
    }, [
        taskInteractionId,
        isInFunnel,
        loading,
        items,
        debouncedUpdated
    ]);
    return {
        tableInteractionAttributes: tableInteractionAttributes,
        setLastUserAction: (name)=>void (lastUserAction.current = {
                name: name,
                time: performance.now()
            })
    };
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $385075666feb9281$export$682608ebc9a33151(onClick) {
    const awayRef = (0, $acw62.useRef)(null);
    const onClickStable = (0, $013a2451794a45c0$exports.useStableCallback)(onClick);
    (0, $acw62.useEffect)(()=>{
        function handleClick(event) {
            if (!(0, $4c778684f125e678$export$57d4cb221e1d1857)(awayRef.current, event.target)) onClickStable();
        }
        // contains returns wrong result if the next render would remove the element
        // but capture phase happens before the render, so returns correct result
        // Ref: https://github.com/facebook/react/issues/20325
        document.addEventListener('click', handleClick, {
            capture: true
        });
        return ()=>document.removeEventListener('click', handleClick, {
                capture: true
            });
    }, [
        onClickStable
    ]);
    return awayRef;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $6684660ee137f3b3$export$2e2bcd8739ae039 = {
    "expand-toggle-icon": "awsui_expand-toggle-icon_1xe88_1hyl4_153",
    "expand-toggle-icon-expanded": "awsui_expand-toggle-icon-expanded_1xe88_1hyl4_174",
    "expand-toggle": "awsui_expand-toggle_1xe88_1hyl4_153",
    "disable-focus-highlight": "awsui_disable-focus-highlight_1xe88_1hyl4_225"
};


function $5781fd2e2c8c126a$export$dee85bbd706fcf78({ isExpanded: isExpanded, onExpandableItemToggle: onExpandableItemToggle, expandButtonLabel: expandButtonLabel, collapseButtonLabel: collapseButtonLabel, customIcon: customIcon, className: className, disableFocusHighlight: disableFocusHighlight }) {
    const buttonRef = (0, $acw62.useRef)(null);
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(buttonRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ref: buttonRef,
        tabIndex: tabIndex,
        "aria-label": isExpanded ? collapseButtonLabel : expandButtonLabel,
        "aria-expanded": isExpanded,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6684660ee137f3b3$export$2e2bcd8739ae039)['expand-toggle'], disableFocusHighlight && (0, $6684660ee137f3b3$export$2e2bcd8739ae039)['disable-focus-highlight'], className),
        onClick: onExpandableItemToggle
    }, customIcon !== null && customIcon !== void 0 ? customIcon : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        size: "small",
        name: "caret-down-filled",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6684660ee137f3b3$export$2e2bcd8739ae039)['expand-toggle-icon'], isExpanded && (0, $6684660ee137f3b3$export$2e2bcd8739ae039)['expand-toggle-icon-expanded'])
    }));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


class $e2d297bc4830b3ed$export$2e2bcd8739ae039 {
    constructor(state){
        this._listeners = [];
        this._state = state;
    }
    get() {
        return this._state;
    }
    set(cb) {
        const prevState = this._state;
        const newState = cb(prevState);
        this._state = newState;
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            for (const [selector, listener] of this._listeners)if (selector(prevState) !== selector(newState)) listener(newState, prevState);
        });
    }
    subscribe(selector, listener) {
        this._listeners.push([
            selector,
            listener
        ]);
        return ()=>this.unsubscribe(listener);
    }
    unsubscribe(listener) {
        for(let index = 0; index < this._listeners.length; index++){
            const [, storedListener] = this._listeners[index];
            if (storedListener === listener) {
                this._listeners.splice(index, 1);
                break;
            }
        }
    }
}
function $e2d297bc4830b3ed$export$bb8178b296baf229(store, selector, effect) {
    (0, $acw62.useLayoutEffect)(()=>{
        const unsubscribe = store.subscribe(selector, (newState, prevState)=>effect(selector(newState), selector(prevState)));
        return unsubscribe;
    }, // ignoring selector and effect as they are expected to stay constant
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        store
    ]);
}
function $e2d297bc4830b3ed$export$2105062e25df4afe(store, selector) {
    const [state, setState] = (0, $acw62.useState)(selector(store.get()));
    $e2d297bc4830b3ed$export$bb8178b296baf229(store, selector, (newState)=>{
        setState(newState);
    });
    // When store changes we need the state to be updated synchronously to avoid inconsistencies.
    const prevStore = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(store);
    if (prevStore !== null && prevStore !== store) return selector(store.get());
    return state;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $706a20e534c5f10e$export$7e25b940db2acfac(s1, s2) {
    if (s1 && s2) return s1.padInlineStart === s2.padInlineStart && s1.lastInsetInlineStart === s2.lastInsetInlineStart && s1.lastInsetInlineEnd === s2.lastInsetInlineEnd && s1.offset.insetInlineStart === s2.offset.insetInlineStart && s1.offset.insetInlineEnd === s2.offset.insetInlineEnd;
    return s1 === s2;
}
function $706a20e534c5f10e$export$dcb87506cb5a76dc(s1, s2) {
    return s1.scrollPaddingInlineStart === s2.scrollPaddingInlineStart && s1.scrollPaddingInlineEnd === s2.scrollPaddingInlineEnd;
}
function $706a20e534c5f10e$export$7ed886faf178267c(cells, props) {
    var _a, _b, _c, _d;
    const totalColumns = props.visibleColumns.length;
    const firstColumnsWidths = [];
    for(let i = 0; i < Math.min(totalColumns, props.stickyColumnsFirst); i++){
        const element = cells.get(props.visibleColumns[i]);
        const cellWidth = element ? (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(element).inlineSize : 0;
        firstColumnsWidths[i] = ((_a = firstColumnsWidths[i - 1]) !== null && _a !== void 0 ? _a : 0) + cellWidth;
    }
    const lastColumnsWidths = [];
    for(let i = 0; i < Math.min(totalColumns, props.stickyColumnsLast); i++){
        const element = cells.get(props.visibleColumns[totalColumns - 1 - i]);
        const cellWidth = element ? (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(element).inlineSize : 0;
        lastColumnsWidths[i] = ((_b = lastColumnsWidths[i - 1]) !== null && _b !== void 0 ? _b : 0) + cellWidth;
    }
    const stickyWidthInlineStart = (_c = firstColumnsWidths[props.stickyColumnsFirst - 1]) !== null && _c !== void 0 ? _c : 0;
    const stickyWidthInlineEnd = (_d = lastColumnsWidths[props.stickyColumnsLast - 1]) !== null && _d !== void 0 ? _d : 0;
    const offsets = props.visibleColumns.reduce((map, columnId, columnIndex)=>{
        var _a, _b;
        return map.set(columnId, {
            first: (_a = firstColumnsWidths[columnIndex - 1]) !== null && _a !== void 0 ? _a : 0,
            last: (_b = lastColumnsWidths[totalColumns - 1 - columnIndex - 1]) !== null && _b !== void 0 ? _b : 0
        });
    }, new Map());
    return {
        offsets: offsets,
        stickyWidthInlineStart: stickyWidthInlineStart,
        stickyWidthInlineEnd: stickyWidthInlineEnd
    };
}


// We allow the table to have a minimum of 148px of available space besides the sum of the widths of the sticky columns
// This value is an UX recommendation and is approximately 1/3 of our smallest breakpoint (465px)
const $b00a9e41f83b2a0f$var$MINIMUM_SCROLLABLE_SPACE = 148;
function $b00a9e41f83b2a0f$export$fa628f01ec57be39({ visibleColumns: visibleColumns, stickyColumnsFirst: stickyColumnsFirst, stickyColumnsLast: stickyColumnsLast }) {
    const store = (0, $acw62.useMemo)(()=>new $b00a9e41f83b2a0f$var$StickyColumnsStore(), []);
    const wrapperRef = (0, $acw62.useRef)(null);
    const tableRef = (0, $acw62.useRef)(null);
    const cellsRef = (0, $acw62.useRef)(new Map());
    const hasStickyColumns = stickyColumnsFirst + stickyColumnsLast > 0;
    const updateStickyStyles = (0, $013a2451794a45c0$exports.useStableCallback)(()=>{
        if (wrapperRef.current && tableRef.current) store.updateCellStyles({
            wrapper: wrapperRef.current,
            table: tableRef.current,
            cells: cellsRef.current,
            visibleColumns: visibleColumns,
            stickyColumnsFirst: stickyColumnsFirst,
            stickyColumnsLast: stickyColumnsLast
        });
    });
    (0, $013a2451794a45c0$exports.useResizeObserver)(wrapperRef, updateStickyStyles);
    (0, $013a2451794a45c0$exports.useResizeObserver)(tableRef, updateStickyStyles);
    (0, $acw62.useEffect)(()=>{
        if (wrapperRef.current && tableRef.current) store.updateCellStyles({
            wrapper: wrapperRef.current,
            table: tableRef.current,
            cells: cellsRef.current,
            visibleColumns: visibleColumns,
            stickyColumnsFirst: stickyColumnsFirst,
            stickyColumnsLast: stickyColumnsLast
        });
    }, [
        store,
        stickyColumnsFirst,
        stickyColumnsLast,
        visibleColumns
    ]);
    // Update wrapper styles imperatively to avoid unnecessary re-renders.
    (0, $acw62.useEffect)(()=>{
        if (!hasStickyColumns) return;
        const selector = (state)=>state.wrapperState;
        const updateWrapperStyles = (state, prev)=>{
            if ((0, $706a20e534c5f10e$export$dcb87506cb5a76dc)(state, prev)) return;
            if (wrapperRef.current) {
                wrapperRef.current.style.scrollPaddingInlineStart = state.scrollPaddingInlineStart + 'px';
                wrapperRef.current.style.scrollPaddingInlineEnd = state.scrollPaddingInlineEnd + 'px';
            }
        };
        const unsubscribe = store.subscribe(selector, (newState, prevState)=>updateWrapperStyles(selector(newState), selector(prevState)));
        return unsubscribe;
    }, [
        store,
        hasStickyColumns
    ]);
    const setWrapper = (0, $acw62.useCallback)((node)=>{
        if (wrapperRef.current) wrapperRef.current.removeEventListener('scroll', updateStickyStyles);
        if (node && hasStickyColumns) node.addEventListener('scroll', updateStickyStyles);
        wrapperRef.current = node;
    }, [
        hasStickyColumns,
        updateStickyStyles
    ]);
    const setTable = (0, $acw62.useCallback)((node)=>{
        tableRef.current = node;
    }, []);
    const setCell = (0, $acw62.useCallback)((columnId, node)=>{
        if (node) cellsRef.current.set(columnId, node);
        else cellsRef.current.delete(columnId);
    }, []);
    return {
        store: store,
        style: {
            // Provide wrapper styles as props so that a re-render won't cause invalidation.
            wrapper: hasStickyColumns ? {
                ...store.get().wrapperState
            } : undefined
        },
        refs: {
            wrapper: setWrapper,
            table: setTable,
            cell: setCell
        }
    };
}
function $b00a9e41f83b2a0f$export$76f0c0a58cdc31f5({ stickyColumns: stickyColumns, columnId: columnId, getClassName: getClassName }) {
    var _a;
    const setCell = stickyColumns.refs.cell;
    // unsubscribeRef to hold the function to unsubscribe from the store's updates
    const unsubscribeRef = (0, $acw62.useRef)(null);
    // refCallback updates the cell ref and sets up the store subscription
    const refCallback = (0, $acw62.useCallback)((cellElement)=>{
        if (unsubscribeRef.current) // Unsubscribe before we do any updates to avoid leaving any subscriptions hanging
        unsubscribeRef.current();
        // Update cellRef and the store's state to point to the new DOM node
        setCell(columnId, cellElement);
        // Update cell styles imperatively to avoid unnecessary re-renders.
        const selector = (state)=>{
            var _a;
            return (_a = state.cellState.get(columnId)) !== null && _a !== void 0 ? _a : null;
        };
        const updateCellStyles = (state, prev)=>{
            if ((0, $706a20e534c5f10e$export$7e25b940db2acfac)(state, prev)) return;
            const className = getClassName(state);
            if (cellElement) {
                Object.keys(className).forEach((key)=>{
                    if (className[key]) cellElement.classList.add(key);
                    else cellElement.classList.remove(key);
                });
                cellElement.style.insetInlineStart = (state === null || state === void 0 ? void 0 : state.offset.insetInlineStart) !== undefined ? `${state.offset.insetInlineStart}px` : '';
                cellElement.style.insetInlineEnd = (state === null || state === void 0 ? void 0 : state.offset.insetInlineEnd) !== undefined ? `${state.offset.insetInlineEnd}px` : '';
            }
        };
        // If the node is not null (i.e., the table cell is being mounted or updated, not unmounted),
        // set up a new subscription to the store's updates
        if (cellElement) unsubscribeRef.current = stickyColumns.store.subscribe(selector, (newState, prevState)=>{
            updateCellStyles(selector(newState), selector(prevState));
        });
    }, // getClassName is expected to be pure
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        columnId,
        setCell,
        stickyColumns.store
    ]);
    // Provide cell styles as props so that a re-render won't cause invalidation.
    const cellStyles = stickyColumns.store.get().cellState.get(columnId);
    return {
        ref: refCallback,
        className: cellStyles ? (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(getClassName(cellStyles)) : undefined,
        style: (_a = cellStyles === null || cellStyles === void 0 ? void 0 : cellStyles.offset) !== null && _a !== void 0 ? _a : undefined
    };
}
class $b00a9e41f83b2a0f$var$StickyColumnsStore extends (0, $e2d297bc4830b3ed$export$2e2bcd8739ae039) {
    constructor(){
        super({
            cellState: new Map(),
            wrapperState: {
                scrollPaddingInlineStart: 0,
                scrollPaddingInlineEnd: 0
            }
        });
        this.cellOffsets = {
            offsets: new Map(),
            stickyWidthInlineStart: 0,
            stickyWidthInlineEnd: 0
        };
        this.isStuckToTheInlineStart = false;
        this.isStuckToTheInlineEnd = false;
        this.padInlineStart = false;
        this.generateCellStyles = (props)=>{
            const isEnabled = this.isEnabled(props);
            const lastLeftStickyColumnIndex = props.stickyColumnsFirst - 1;
            const lastRightStickyColumnIndex = props.visibleColumns.length - props.stickyColumnsLast;
            return props.visibleColumns.reduce((acc, columnId, index)=>{
                var _a, _b, _c, _d;
                let stickySide = 'non-sticky';
                if (index < props.stickyColumnsFirst) stickySide = 'inline-start';
                else if (index >= props.visibleColumns.length - props.stickyColumnsLast) stickySide = 'inline-end';
                if (!isEnabled || stickySide === 'non-sticky') return acc;
                // Determine the offset of the sticky column using the `cellOffsets` state object
                const isFirstColumn = index === 0;
                const stickyColumnOffsetLeft = (_b = (_a = this.cellOffsets.offsets.get(columnId)) === null || _a === void 0 ? void 0 : _a.first) !== null && _b !== void 0 ? _b : 0;
                const stickyColumnOffsetRight = (_d = (_c = this.cellOffsets.offsets.get(columnId)) === null || _c === void 0 ? void 0 : _c.last) !== null && _d !== void 0 ? _d : 0;
                acc.set(columnId, {
                    padInlineStart: isFirstColumn && this.padInlineStart,
                    lastInsetInlineStart: this.isStuckToTheInlineStart && lastLeftStickyColumnIndex === index,
                    lastInsetInlineEnd: this.isStuckToTheInlineEnd && lastRightStickyColumnIndex === index,
                    offset: {
                        insetInlineStart: stickySide === 'inline-start' ? stickyColumnOffsetLeft : undefined,
                        insetInlineEnd: stickySide === 'inline-end' ? stickyColumnOffsetRight : undefined
                    }
                });
                return acc;
            }, new Map());
        };
        this.updateCellOffsets = (props)=>{
            this.cellOffsets = (0, $706a20e534c5f10e$export$7ed886faf178267c)(props.cells, props);
        };
        this.isEnabled = (props)=>{
            const noStickyColumns = props.stickyColumnsFirst + props.stickyColumnsLast === 0;
            if (noStickyColumns) return false;
            const wrapperWidth = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(props.wrapper).inlineSize;
            const tableWidth = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(props.table).inlineSize;
            const isWrapperScrollable = tableWidth > wrapperWidth;
            if (!isWrapperScrollable) return false;
            const totalStickySpace = this.cellOffsets.stickyWidthInlineStart + this.cellOffsets.stickyWidthInlineEnd;
            const tablePaddingLeft = parseFloat(getComputedStyle(props.table).paddingLeft) || 0;
            const tablePaddingRight = parseFloat(getComputedStyle(props.table).paddingRight) || 0;
            const hasEnoughScrollableSpace = totalStickySpace + $b00a9e41f83b2a0f$var$MINIMUM_SCROLLABLE_SPACE + tablePaddingLeft + tablePaddingRight < wrapperWidth;
            if (!hasEnoughScrollableSpace) return false;
            return true;
        };
    }
    updateCellStyles(props) {
        const hasStickyColumns = props.stickyColumnsFirst + props.stickyColumnsLast > 0;
        const hadStickyColumns = this.cellOffsets.offsets.size > 0;
        if (hasStickyColumns || hadStickyColumns) {
            this.updateScroll(props);
            this.updateCellOffsets(props);
            this.set(()=>({
                    cellState: this.generateCellStyles(props),
                    wrapperState: {
                        scrollPaddingInlineStart: this.cellOffsets.stickyWidthInlineStart,
                        scrollPaddingInlineEnd: this.cellOffsets.stickyWidthInlineEnd
                    }
                }));
        }
    }
    updateScroll(props) {
        const wrapperScrollInlineStart = (0, $013a2451794a45c0$exports.getScrollInlineStart)(props.wrapper);
        const wrapperScrollWidth = props.wrapper.scrollWidth;
        const wrapperClientWidth = props.wrapper.clientWidth;
        const tablePaddingInlineStart = parseFloat(getComputedStyle(props.table).paddingInlineStart) || 0;
        const tablePaddingInlineEnd = parseFloat(getComputedStyle(props.table).paddingInlineEnd) || 0;
        this.isStuckToTheInlineStart = wrapperScrollInlineStart > tablePaddingInlineStart;
        // Math.ceil() is used here to address an edge-case in certain browsers, where they return non-integer wrapperScrollInlineStart values
        // which are lower than expected (sub-pixel difference), resulting in the table always being in the "stuck to the right" state
        this.isStuckToTheInlineEnd = Math.ceil(wrapperScrollInlineStart) < wrapperScrollWidth - wrapperClientWidth - tablePaddingInlineEnd;
        this.padInlineStart = tablePaddingInlineStart !== 0 && this.isStuckToTheInlineStart;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4724080100e81846$var$stateToAriaSort = {
    sortable: 'none',
    ascending: 'ascending',
    descending: 'descending'
};
const $4724080100e81846$var$getAriaSort = (sortingState)=>$4724080100e81846$var$stateToAriaSort[sortingState];
function $4724080100e81846$export$2c3bcd6eb50948d4(options) {
    const nativeProps = {};
    // Browsers have weird mechanism to guess whether it's a data table or a layout table.
    // If we state explicitly, they get it always correctly even with low number of rows.
    nativeProps.role = options.tableRole === 'grid-default' ? 'grid' : options.tableRole;
    nativeProps['aria-label'] = options.ariaLabel;
    nativeProps['aria-labelledby'] = options.ariaLabelledby;
    // Incrementing the total count by one to account for the header row.
    if (typeof options.totalItemsCount === 'number' && options.totalItemsCount > 0) nativeProps['aria-rowcount'] = options.totalItemsCount + 1;
    if (options.tableRole === 'grid' || options.tableRole === 'treegrid') nativeProps['aria-colcount'] = options.totalColumnsCount;
    // Make table component programmatically focusable to attach focusin/focusout for keyboard navigation.
    if (options.tableRole === 'grid' || options.tableRole === 'treegrid') nativeProps.tabIndex = -1;
    return nativeProps;
}
function $4724080100e81846$export$9facfa3a9b67cdc8(options) {
    const nativeProps = {};
    // When the table is scrollable, the wrapper is made focusable so that keyboard users can scroll it horizontally with arrow keys.
    if (options.isScrollable) {
        nativeProps.role = 'region';
        nativeProps.tabIndex = 0;
        nativeProps['aria-label'] = options.ariaLabel;
        nativeProps['aria-labelledby'] = options.ariaLabelledby;
    }
    return nativeProps;
}
function $4724080100e81846$export$db8fc6d3575bc25b(options) {
    const nativeProps = {};
    // For grids headers are treated similar to data rows and are indexed accordingly.
    if (options.tableRole === 'grid' || options.tableRole === 'grid-default' || options.tableRole === 'treegrid') nativeProps['aria-rowindex'] = 1;
    return nativeProps;
}
function $4724080100e81846$export$70749aa7430746bc(options) {
    const nativeProps = {};
    // The data cell indices are incremented by 1 to account for the header cells.
    if (options.tableRole === 'grid' || options.tableRole === 'treegrid') nativeProps['aria-rowindex'] = (options.firstIndex || 1) + options.rowIndex + 1;
    else if (options.firstIndex !== undefined) nativeProps['aria-rowindex'] = options.firstIndex + options.rowIndex + 1;
    if (options.tableRole === 'treegrid' && options.level && options.level !== 0) nativeProps['aria-level'] = options.level;
    if (options.tableRole === 'treegrid' && options.setSize) nativeProps['aria-setsize'] = options.setSize;
    if (options.tableRole === 'treegrid' && options.posInSet) nativeProps['aria-posinset'] = options.posInSet;
    return nativeProps;
}
function $4724080100e81846$export$9277a016ea496b61(options) {
    const nativeProps = {};
    nativeProps.scope = 'col';
    if (options.tableRole === 'grid' || options.tableRole === 'treegrid') nativeProps['aria-colindex'] = options.colIndex + 1;
    if (options.sortingStatus) nativeProps['aria-sort'] = $4724080100e81846$var$getAriaSort(options.sortingStatus);
    return nativeProps;
}
function $4724080100e81846$export$df12e6f9829885b(options) {
    const nativeProps = {};
    if (options.tableRole === 'grid' || options.tableRole === 'treegrid') nativeProps['aria-colindex'] = options.colIndex + 1;
    if (options.isRowHeader) nativeProps.scope = 'row';
    return nativeProps;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97 = (trackBy, item)=>{
    if (typeof trackBy === 'function') return trackBy(item);
    return item[trackBy];
};
const $d5e9c22659308d3d$export$424834ba1b0663bc = (trackBy, item, index)=>{
    if (!trackBy) return index;
    return $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97(trackBy, item);
};
const $d5e9c22659308d3d$export$de1681509165dcfe = (trackBy, item)=>{
    if (!trackBy) return item;
    return $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97(trackBy, item);
};
const $d5e9c22659308d3d$export$480219a02f196e72 = (column, index)=>{
    return column.id || index;
};
const $d5e9c22659308d3d$export$9704772993b3cb14 = (variant)=>{
    const isDefaultVariant = !variant || variant === 'container';
    return isDefaultVariant ? 'default' : variant === 'borderless' ? 'embedded' : variant;
};
function $d5e9c22659308d3d$export$8490691ec4e40f0d(columnDefinitions, sortingComparator) {
    const matchedColumn = columnDefinitions.filter((column)=>column.sortingComparator === sortingComparator)[0];
    if (!matchedColumn) (0, $013a2451794a45c0$exports.warnOnce)('Table', 'Currently active sorting comparator was not found in any columns. Make sure to provide the same comparator function instance on each render.');
}
function $d5e9c22659308d3d$export$814232dd3a440b46({ columnDisplay: columnDisplay, visibleColumns: visibleColumns, columnDefinitions: columnDefinitions }) {
    // columnsDisplay has a precedence over visibleColumns.
    if (columnDisplay) return $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromColumnDisplay({
        columnDisplay: columnDisplay,
        columnDefinitions: columnDefinitions
    });
    else if (visibleColumns) return $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromVisibleColumns({
        visibleColumns: visibleColumns,
        columnDefinitions: columnDefinitions
    });
    else return columnDefinitions;
}
function $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromColumnDisplay({ columnDisplay: columnDisplay, columnDefinitions: columnDefinitions }) {
    const columnDefinitionsById = columnDefinitions.reduce((accumulator, item)=>item.id === undefined ? accumulator : {
            ...accumulator,
            [item.id]: item
        }, {});
    return columnDisplay.filter((item)=>item.visible).map((item)=>columnDefinitionsById[item.id]).filter(Boolean);
}
function $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromVisibleColumns({ visibleColumns: visibleColumns, columnDefinitions: columnDefinitions }) {
    const ids = new Set(visibleColumns);
    return columnDefinitions.filter(({ id: id })=>id !== undefined && ids.has(id));
}
function $d5e9c22659308d3d$export$8343e8fa60fc2e2f(styles, props) {
    return {
        [styles['sticky-cell']]: !!props,
        [styles['sticky-cell-pad-inline-start']]: !!(props === null || props === void 0 ? void 0 : props.padInlineStart),
        [styles['sticky-cell-last-inline-start']]: !!(props === null || props === void 0 ? void 0 : props.lastInsetInlineStart),
        [styles['sticky-cell-last-inline-end']]: !!(props === null || props === void 0 ? void 0 : props.lastInsetInlineEnd)
    };
}



var $7ded81c543f72294$export$2e2bcd8739ae039 = {
    "root": "awsui_root_wih1l_zysm5_153",
    "tools": "awsui_tools_wih1l_zysm5_164",
    "tools-filtering": "awsui_tools-filtering_wih1l_zysm5_173",
    "tools-align-right": "awsui_tools-align-right_wih1l_zysm5_186",
    "tools-pagination": "awsui_tools-pagination_wih1l_zysm5_190",
    "tools-preferences": "awsui_tools-preferences_wih1l_zysm5_190",
    "tools-small": "awsui_tools-small_wih1l_zysm5_196",
    "table": "awsui_table_wih1l_zysm5_200",
    "table-layout-fixed": "awsui_table-layout-fixed_wih1l_zysm5_206",
    "wrapper": "awsui_wrapper_wih1l_zysm5_210",
    "variant-stacked": "awsui_variant-stacked_wih1l_zysm5_217",
    "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_zysm5_217",
    "variant-container": "awsui_variant-container_wih1l_zysm5_217",
    "has-footer": "awsui_has-footer_wih1l_zysm5_220",
    "has-header": "awsui_has-header_wih1l_zysm5_223",
    "cell-merged": "awsui_cell-merged_wih1l_zysm5_240",
    "cell-merged-content": "awsui_cell-merged-content_wih1l_zysm5_252",
    "empty": "awsui_empty_wih1l_zysm5_268",
    "loading": "awsui_loading_wih1l_zysm5_272",
    "selection-control": "awsui_selection-control_wih1l_zysm5_281",
    "selection-control-header": "awsui_selection-control-header_wih1l_zysm5_288",
    "header-secondary": "awsui_header-secondary_wih1l_zysm5_294",
    "variant-full-page": "awsui_variant-full-page_wih1l_zysm5_305",
    "table-has-header": "awsui_table-has-header_wih1l_zysm5_311",
    "header-controls": "awsui_header-controls_wih1l_zysm5_322",
    "variant-embedded": "awsui_variant-embedded_wih1l_zysm5_331",
    "variant-borderless": "awsui_variant-borderless_wih1l_zysm5_331",
    "footer-wrapper": "awsui_footer-wrapper_wih1l_zysm5_336",
    "footer": "awsui_footer_wih1l_zysm5_336",
    "footer-with-pagination": "awsui_footer-with-pagination_wih1l_zysm5_344",
    "footer-pagination": "awsui_footer-pagination_wih1l_zysm5_352",
    "thead-active": "awsui_thead-active_wih1l_zysm5_356",
    "row": "awsui_row_wih1l_zysm5_357",
    "row-selected": "awsui_row-selected_wih1l_zysm5_358"
};



var $7a6eb32fec39b4c7$export$2e2bcd8739ae039 = {
    "body-cell-counter": "awsui_body-cell-counter_10jtt_16x1t_5"
};



var $072f869ecd5e8de2$export$2e2bcd8739ae039 = {
    "expandable-toggle-wrapper": "awsui_expandable-toggle-wrapper_c6tup_hvmkg_145",
    "body-cell": "awsui_body-cell_c6tup_hvmkg_152",
    "body-cell-content": "awsui_body-cell-content_c6tup_hvmkg_160",
    "expandable-level-0": "awsui_expandable-level-0_c6tup_hvmkg_166",
    "expandable-level-1": "awsui_expandable-level-1_c6tup_hvmkg_173",
    "expandable-level-2": "awsui_expandable-level-2_c6tup_hvmkg_180",
    "expandable-level-3": "awsui_expandable-level-3_c6tup_hvmkg_187",
    "expandable-level-4": "awsui_expandable-level-4_c6tup_hvmkg_194",
    "expandable-level-5": "awsui_expandable-level-5_c6tup_hvmkg_201",
    "expandable-level-6": "awsui_expandable-level-6_c6tup_hvmkg_208",
    "expandable-level-7": "awsui_expandable-level-7_c6tup_hvmkg_215",
    "expandable-level-8": "awsui_expandable-level-8_c6tup_hvmkg_222",
    "expandable-level-9": "awsui_expandable-level-9_c6tup_hvmkg_229",
    "expandable-level-next": "awsui_expandable-level-next_c6tup_hvmkg_236",
    "body-cell-align-top": "awsui_body-cell-align-top_c6tup_hvmkg_254",
    "body-cell-wrap": "awsui_body-cell-wrap_c6tup_hvmkg_260",
    "body-cell-counter": "awsui_body-cell-counter_c6tup_hvmkg_265",
    "is-visual-refresh": "awsui_is-visual-refresh_c6tup_hvmkg_363",
    "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_hvmkg_453",
    "body-cell-expandable": "awsui_body-cell-expandable_c6tup_hvmkg_453",
    "body-cell-editable": "awsui_body-cell-editable_c6tup_hvmkg_453",
    "has-striped-rows": "awsui_has-striped-rows_c6tup_hvmkg_536",
    "sticky-cell-pad-inline-start": "awsui_sticky-cell-pad-inline-start_c6tup_hvmkg_702",
    "has-selection": "awsui_has-selection_c6tup_hvmkg_868",
    "body-cell-first-row": "awsui_body-cell-first-row_c6tup_hvmkg_1037",
    "body-cell-last-row": "awsui_body-cell-last-row_c6tup_hvmkg_1040",
    "body-cell-selected": "awsui_body-cell-selected_c6tup_hvmkg_1040",
    "has-footer": "awsui_has-footer_c6tup_hvmkg_1040",
    "body-cell-shaded": "awsui_body-cell-shaded_c6tup_hvmkg_1050",
    "sticky-cell": "awsui_sticky-cell_c6tup_hvmkg_702",
    "table-variant-full-page": "awsui_table-variant-full-page_c6tup_hvmkg_1101",
    "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_c6tup_hvmkg_1118",
    "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_c6tup_hvmkg_1127",
    "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_hvmkg_1149",
    "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_hvmkg_1156",
    "body-cell-editor-wrapper": "awsui_body-cell-editor-wrapper_c6tup_hvmkg_1182",
    "body-cell-success": "awsui_body-cell-success_c6tup_hvmkg_1187",
    "body-cell-editor": "awsui_body-cell-editor_c6tup_hvmkg_1182",
    "body-cell-editor-disabled": "awsui_body-cell-editor-disabled_c6tup_hvmkg_1212",
    "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_hvmkg_1221",
    "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_hvmkg_1231",
    "body-cell-editor-row-editor": "awsui_body-cell-editor-row-editor_c6tup_hvmkg_1234",
    "body-cell-editor-focusable": "awsui_body-cell-editor-focusable_c6tup_hvmkg_1237",
    "body-cell-editor-icon": "awsui_body-cell-editor-icon_c6tup_hvmkg_1261",
    "resizable-columns": "awsui_resizable-columns_c6tup_hvmkg_1373",
    "expandable-cell-content": "awsui_expandable-cell-content_c6tup_hvmkg_1376",
    "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_hvmkg_1427",
    "body-cell-has-success": "awsui_body-cell-has-success_c6tup_hvmkg_1430"
};


const $2eb106c16e1c0bab$export$2e9f934a16f4a89a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, wrapLines: wrapLines, isRowHeader: isRowHeader, isFirstRow: isFirstRow, isLastRow: isLastRow, isSelected: isSelected, isNextSelected: isNextSelected, isPrevSelected: isPrevSelected, nativeAttributes: nativeAttributes, onClick: onClick, onFocus: onFocus, onBlur: onBlur, isEvenRow: isEvenRow, stripedRows: stripedRows, isSelection: isSelection, hasSelection: hasSelection, hasFooter: hasFooter, columnId: columnId, colIndex: colIndex, stickyState: stickyState, tableRole: tableRole, level: level, isExpandable: isExpandable, isExpanded: isExpanded, onExpandableItemToggle: onExpandableItemToggle, expandButtonLabel: expandButtonLabel, collapseButtonLabel: collapseButtonLabel, verticalAlign: verticalAlign, resizableColumns: resizableColumns, resizableStyle: resizableStyle, isEditable: isEditable, isEditing: isEditing, isEditingDisabled: isEditingDisabled, hasSuccessIcon: hasSuccessIcon, tableVariant: tableVariant, counter: counter, ...rest }, ref)=>{
    const Element = isRowHeader ? 'th' : 'td';
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    resizableStyle = resizableColumns ? {} : resizableStyle;
    nativeAttributes = {
        ...nativeAttributes,
        ...(0, $4724080100e81846$export$df12e6f9829885b)({
            tableRole: tableRole,
            isRowHeader: isRowHeader,
            colIndex: colIndex
        })
    };
    const stickyStyles = (0, $b00a9e41f83b2a0f$export$76f0c0a58cdc31f5)({
        stickyColumns: stickyState,
        columnId: columnId,
        getClassName: (props)=>(0, $d5e9c22659308d3d$export$8343e8fa60fc2e2f)((0, $072f869ecd5e8de2$export$2e2bcd8739ae039), props)
    });
    const cellRefObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(stickyStyles.ref, ref, cellRefObject);
    const { tabIndex: cellTabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(cellRefObject);
    const isEditingActive = isEditing && !isEditingDisabled;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, {
        style: {
            ...resizableStyle,
            ...stickyStyles.style
        },
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell'], isFirstRow && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-first-row'], isLastRow && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-last-row'], isSelected && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-selected'], isNextSelected && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-next-selected'], isPrevSelected && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-prev-selected'], !isEvenRow && stripedRows && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-shaded'], stripedRows && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['has-striped-rows'], isVisualRefresh && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['is-visual-refresh'], isSelection && (0, $7ded81c543f72294$export$2e2bcd8739ae039)['selection-control'], hasSelection && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['has-selection'], hasFooter && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['has-footer'], resizableColumns && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['resizable-columns'], verticalAlign === 'top' && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-align-top'], isEditable && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editable'], isEditing && !isEditingDisabled && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-edit-active'], isEditing && isEditingDisabled && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-edit-disabled-popover'], hasSuccessIcon && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-has-success'], level !== undefined && !isEditingActive && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-expandable'], level !== undefined && !isEditingActive && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)[`expandable-level-${$2eb106c16e1c0bab$var$getLevelClassSuffix(level)}`], tableVariant && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)[`table-variant-${tableVariant}`], stickyStyles.className),
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: mergedRef,
        ...nativeAttributes,
        tabIndex: cellTabIndex === -1 ? undefined : cellTabIndex,
        ...(0, $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute)(rest)
    }, level !== undefined && isExpandable && !isEditingActive && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['expandable-toggle-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5781fd2e2c8c126a$export$dee85bbd706fcf78), {
        isExpanded: isExpanded,
        onExpandableItemToggle: onExpandableItemToggle,
        expandButtonLabel: expandButtonLabel,
        collapseButtonLabel: collapseButtonLabel
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-content'], wrapLines && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-wrap'])
    }, children, counter ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-counter']
    }, ' ', (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $7a6eb32fec39b4c7$export$2e2bcd8739ae039)['body-cell-counter']
    }, counter)) : null));
});
function $2eb106c16e1c0bab$var$getLevelClassSuffix(level) {
    return 0 <= level && level <= 9 ? level : 'next';
}



function $7623cc36788f036d$export$e6789685317f3993({ item: item, column: column, ariaLabels: ariaLabels, isEditing: isEditing, onEditStart: onEditStart, onEditEnd: onEditEnd, editDisabledReason: editDisabledReason, ...rest }) {
    var _a;
    const isExpandableColumn = rest.level !== undefined;
    const clickAwayRef = (0, $385075666feb9281$export$682608ebc9a33151)(()=>{
        if (isEditing) onEditEnd(true);
    });
    const iconRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const portalRef = (0, $acw62.useRef)(null);
    function handleEscape(event) {
        if (event.key === 'Escape') onEditEnd(true);
    }
    const onClick = ()=>{
        var _a;
        onEditStart();
        (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    };
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(editDisabledReason);
    const portalClasses = (0, $f509ecfba65f3bd6$export$464b090d8a567e1e)(portalRef);
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(buttonRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), {
        ...rest,
        nativeAttributes: {
            'data-inline-editing-active': isEditing.toString()
        },
        isEditing: isEditing,
        isEditingDisabled: true,
        onClick: !isEditing && !isExpandableColumn ? onClick : undefined,
        ref: !isExpandableColumn ? clickAwayRef : undefined
    }, column.cell(item), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: isExpandableColumn ? clickAwayRef : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: buttonRef,
        tabIndex: tabIndex,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor'], (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-disabled'], isExpandableColumn && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-focusable']),
        onClick: !isEditing && isExpandableColumn ? onClick : undefined,
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.activateEditLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, column, item),
        "aria-haspopup": "dialog",
        "aria-disabled": "true",
        onKeyDown: handleEscape,
        ...targetProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-icon']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "lock-private",
        variant: "normal",
        __internalRootRef: iconRef
    })), descriptionEl))), isEditing && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: portalRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: portalClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
        size: "medium",
        fixedWidth: false,
        position: "top",
        trackRef: iconRef,
        arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b971696cf22f0db1$export$2e2bcd8739ae039), {
                position: position
            }),
        renderWithPortal: true,
        zIndex: 7000
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
        dismissButton: false,
        dismissAriaLabel: undefined,
        header: null,
        onDismiss: ()=>{},
        overflowVisible: "both"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span"
    }, editDisabledReason)))))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








// A function that does nothing
const $06bd34375dd8684d$var$noop = ()=>undefined;
function $06bd34375dd8684d$export$daaca9c1047b1596({ ariaLabels: ariaLabels, item: item, column: column, onEditEnd: onEditEnd, submitEdit: submitEdit, __onRender: __onRender }) {
    var _a, _b, _c, _d;
    const [currentEditLoading, setCurrentEditLoading] = (0, $acw62.useState)(false);
    const [currentEditValue, setCurrentEditValue] = (0, $acw62.useState)();
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('table');
    const focusLockRef = (0, $acw62.useRef)(null);
    function finishEdit({ cancelled: cancelled = false, refocusCell: refocusCell = true } = {}) {
        if (!cancelled) setCurrentEditValue(undefined);
        onEditEnd({
            cancelled: cancelled,
            refocusCell: refocusCell
        });
    }
    async function handleSubmit() {
        var _a;
        if (currentEditValue === undefined) {
            finishEdit();
            return;
        }
        setCurrentEditLoading(true);
        try {
            await submitEdit(item, column, currentEditValue);
            setCurrentEditLoading(false);
            finishEdit();
        } catch  {
            setCurrentEditLoading(false);
            (_a = focusLockRef.current) === null || _a === void 0 || _a.focusFirst();
        }
    }
    function onFormSubmit(evt) {
        evt.preventDefault(); // Prevents the form from navigating away
        evt.stopPropagation(); // Prevents any outer form elements from submitting
        handleSubmit();
    }
    function onCancel({ reFocusEditedCell: reFocusEditedCell = true } = {}) {
        if (currentEditLoading) return;
        finishEdit({
            cancelled: true,
            refocusCell: reFocusEditedCell
        });
    }
    function handleEscape(event) {
        if (event.key === 'Escape') onCancel();
    }
    const clickAwayRef = (0, $385075666feb9281$export$682608ebc9a33151)(()=>onCancel({
            reFocusEditedCell: false
        }));
    (0, $acw62.useEffect)(()=>{
        if (__onRender) {
            const timer = setTimeout(__onRender, 1);
            return ()=>clearTimeout(timer);
        }
    }, [
        __onRender
    ]);
    // asserting non-undefined editConfig here because this component is unreachable otherwise
    const { ariaLabel: ariaLabel, validation: validation = $06bd34375dd8684d$var$noop, errorIconAriaLabel: errorIconAriaLabel, constraintText: constraintText, editingCell: editingCell, disableNativeForm: disableNativeForm } = column.editConfig;
    const cellContext = {
        currentValue: currentEditValue,
        setValue: setCurrentEditValue,
        submitValue: handleSubmit
    };
    const FormElement = disableNativeForm ? 'div' : 'form';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        restoreFocus: true,
        ref: focusLockRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        ref: clickAwayRef,
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.activateEditLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, column, item),
        onKeyDown: handleEscape
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FormElement, {
        onSubmit: disableNativeForm ? undefined : onFormSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        stretch: true,
        label: ariaLabel,
        constraintText: constraintText,
        __hideLabel: true,
        __disableGutters: true,
        i18nStrings: {
            errorIconAriaLabel: errorIconAriaLabel
        },
        errorText: validation(item, currentEditValue)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-row']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-row-editor']
    }, editingCell(item, cellContext)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-controls']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        direction: "horizontal",
        size: "xxs"
    }, !currentEditLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        ariaLabel: (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.cancelEditLabel) === null || _b === void 0 ? void 0 : _b.call(ariaLabels, column),
        formAction: "none",
        iconName: "close",
        variant: "inline-icon",
        onClick: ()=>onCancel()
    }) : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        ariaLabel: (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.submitEditLabel) === null || _c === void 0 ? void 0 : _c.call(ariaLabels, column),
        formAction: disableNativeForm ? 'none' : 'submit',
        onClick: disableNativeForm ? handleSubmit : undefined,
        iconName: "check",
        variant: "inline-icon",
        loading: currentEditLoading
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span",
        hidden: true
    }, currentEditLoading ? i18n('ariaLabels.submittingEditText', (_d = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.submittingEditText) === null || _d === void 0 ? void 0 : _d.call(ariaLabels, column)) : '')))))));
}




const $ca56bbf005612a36$var$submitHandlerFallback = ()=>{
    throw new Error('The function `handleSubmit` is required for editable columns');
};
function $ca56bbf005612a36$var$TableCellEditable({ item: item, column: column, isEditing: isEditing, onEditStart: onEditStart, onEditEnd: onEditEnd, submitEdit: submitEdit, ariaLabels: ariaLabels, successfulEdit: successfulEdit = false, ...rest }) {
    var _a, _b, _c;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('table');
    const editActivateRef = (0, $acw62.useRef)(null);
    const tdNativeAttributes = {
        'data-inline-editing-active': isEditing.toString()
    };
    const isFocusMoveNeededRef = (0, $acw62.useRef)(false);
    const isExpandableColumn = rest.level !== undefined;
    (0, $acw62.useEffect)(()=>{
        if (!isEditing && editActivateRef.current && isFocusMoveNeededRef.current) {
            isFocusMoveNeededRef.current = false;
            editActivateRef.current.focus();
        }
    }, [
        isEditing
    ]);
    // To improve the initial page render performance we only show the edit icon when necessary.
    const [hasFocus, setHasFocus] = (0, $acw62.useState)(false);
    const prevSuccessfulEdit = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(successfulEdit);
    const prevHasFocus = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(hasFocus);
    const [showSuccessIcon, setShowSuccessIcon] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        // Hide the success icon after a successful edit, when cell loses focus.
        if (successfulEdit && prevSuccessfulEdit && !hasFocus && prevHasFocus) setShowSuccessIcon(false);
        // Show success icon right after a successful edit, when `successfulEdit` switches to true.
        if (successfulEdit && !prevSuccessfulEdit) setShowSuccessIcon(true);
    }, [
        hasFocus,
        successfulEdit,
        prevHasFocus,
        prevSuccessfulEdit
    ]);
    const { tabIndex: editActivateTabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(editActivateRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), {
        ...rest,
        nativeAttributes: tdNativeAttributes,
        isEditing: isEditing,
        hasSuccessIcon: showSuccessIcon && hasFocus,
        onClick: !isEditing && !isExpandableColumn ? onEditStart : undefined,
        onFocus: ()=>setHasFocus(true),
        onBlur: ()=>setHasFocus(false)
    }, isEditing && column.editConfig ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06bd34375dd8684d$export$daaca9c1047b1596), {
        ariaLabels: ariaLabels,
        column: column,
        item: item,
        onEditEnd: (options)=>{
            setShowSuccessIcon(false);
            isFocusMoveNeededRef.current = options.refocusCell;
            onEditEnd(options.cancelled);
        },
        submitEdit: submitEdit !== null && submitEdit !== void 0 ? submitEdit : $ca56bbf005612a36$var$submitHandlerFallback
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, column.cell(item), showSuccessIcon && hasFocus && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-success'],
        onMouseDown: (e)=>{
            // Prevent the editor's Button blur event to be fired when clicking the success icon.
            // This prevents unfocusing the button and triggers the `TableTdElement` onClick event which initiates the edit mode.
            e.preventDefault();
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "status-positive",
        variant: "success",
        ariaLabel: (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.successfulEditLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, column)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span",
        hidden: true
    }, i18n('ariaLabels.successfulEditLabel', (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.successfulEditLabel) === null || _b === void 0 ? void 0 : _b.call(ariaLabels, column)))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-wrapper']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor'], isExpandableColumn && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-focusable']),
        "aria-label": (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.activateEditLabel) === null || _c === void 0 ? void 0 : _c.call(ariaLabels, column, item),
        ref: editActivateRef,
        onClick: !isEditing && isExpandableColumn ? onEditStart : undefined,
        tabIndex: editActivateTabIndex
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['body-cell-editor-icon']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "edit"
    }))))));
}
function $ca56bbf005612a36$export$948e91fcef170792(props) {
    var _a, _b;
    const editDisabledReason = (_b = (_a = props.column.editConfig) === null || _a === void 0 ? void 0 : _a.disabledReason) === null || _b === void 0 ? void 0 : _b.call(_a, props.item);
    // Inline editing is deactivated for expandable column because editable cells are interactive
    // and cannot include interactive content such as expand toggles.
    if (editDisabledReason) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7623cc36788f036d$export$e6789685317f3993), {
        editDisabledReason: editDisabledReason,
        ...props
    });
    if (props.isEditable || props.isEditing) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca56bbf005612a36$var$TableCellEditable, {
        ...props
    });
    const { column: column, item: item } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), {
        ...props,
        isEditable: false
    }, column.cell(item));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $6208ed25859b543f$export$9ef7e4997c031fc0(columnDefinitions) {
    for (const column of columnDefinitions){
        $6208ed25859b543f$var$checkProperty(column, 'minWidth');
        $6208ed25859b543f$var$checkProperty(column, 'width');
    }
}
function $6208ed25859b543f$export$fc3aed6ced179058(element, styles) {
    function setProperty(property) {
        const value = styles[property];
        let widthCssValue = '';
        if (typeof value === 'number') widthCssValue = value + 'px';
        if (typeof value === 'string') widthCssValue = value;
        if (element.style[property] !== widthCssValue) element.style[property] = widthCssValue;
    }
    setProperty('width');
    setProperty('minWidth');
    setProperty('maxWidth');
}
function $6208ed25859b543f$var$checkProperty(column, name) {
    const value = column[name];
    if (typeof value !== 'number' && typeof value !== 'undefined') (0, $013a2451794a45c0$exports.warnOnce)('Table', `resizableColumns feature requires ${name} property to be a number, got ${value}. The component may work incorrectly.`);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $30c09cf06b060b34$export$988c58523d43232b = 'selection-item';
const $30c09cf06b060b34$var$SELECTION_ROOT = 'selection-root';
class $30c09cf06b060b34$export$685bf180035d2cea {
    constructor(trackBy, items){
        this.map = new Map();
        this.put = (item)=>this.map.set.call(this.map, (0, $d5e9c22659308d3d$export$de1681509165dcfe)(this.trackBy, item), item);
        this.has = (item)=>this.map.has.call(this.map, (0, $d5e9c22659308d3d$export$de1681509165dcfe)(this.trackBy, item));
        this.forEach = this.map.forEach.bind(this.map);
        this.trackBy = trackBy;
        items.forEach(this.put);
    }
}
const $30c09cf06b060b34$export$abdbebe48aa0774a = {
    item: {
        ['data-' + $30c09cf06b060b34$export$988c58523d43232b]: 'item'
    },
    all: {
        ['data-' + $30c09cf06b060b34$export$988c58523d43232b]: 'all'
    },
    root: {
        ['data-' + $30c09cf06b060b34$var$SELECTION_ROOT]: 'true'
    }
};


function $7214aee332d974de$export$fce377726b938a2f({ items: items, expandableRows: expandableRows, trackBy: trackBy, ariaLabels: ariaLabels }) {
    var _a, _b;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('table');
    const isExpandable = !!expandableRows;
    const expandedSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, (_a = expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.expandedItems) !== null && _a !== void 0 ? _a : []);
    let allItems = items;
    const itemToDetail = new Map();
    const getItemLevel = (item)=>{
        var _a, _b;
        return (_b = (_a = itemToDetail.get(item)) === null || _a === void 0 ? void 0 : _a.level) !== null && _b !== void 0 ? _b : 0;
    };
    if (isExpandable) {
        const visibleItems = new Array();
        const traverse = (item, detail, visible)=>{
            const children = expandableRows.getItemChildren(item);
            itemToDetail.set(item, {
                ...detail,
                children: children
            });
            if (visible) {
                visibleItems.push(item);
                children.forEach((child, index)=>traverse(child, {
                        level: detail.level + 1,
                        setSize: children.length,
                        posInSet: index + 1,
                        parent: item
                    }, expandedSet.has(item)));
            }
        };
        items.forEach((item, index)=>traverse(item, {
                level: 1,
                setSize: items.length,
                posInSet: index + 1,
                parent: null
            }, true));
        for(let index = 0; index < visibleItems.length; index++){
            const item = visibleItems[index];
            if (expandedSet.has(item)) {
                let insertionIndex = index + 1;
                for(insertionIndex; insertionIndex < visibleItems.length; insertionIndex++){
                    const insertionItem = visibleItems[insertionIndex];
                    if (getItemLevel(item) >= getItemLevel(insertionItem)) break;
                }
                insertionIndex--;
            }
        }
        allItems = visibleItems;
    }
    const getExpandableItemProps = (item)=>{
        var _a, _b, _c, _d, _e, _f;
        const { level: level = 1, setSize: setSize = 1, posInSet: posInSet = 1, parent: parent = null, children: children = [] } = (_a = itemToDetail.get(item)) !== null && _a !== void 0 ? _a : {};
        return {
            level: level,
            setSize: setSize,
            posInSet: posInSet,
            isExpandable: (_b = expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.isItemExpandable(item)) !== null && _b !== void 0 ? _b : true,
            isExpanded: expandedSet.has(item),
            onExpandableItemToggle: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.onExpandableItemToggle, {
                    item: item,
                    expanded: !expandedSet.has(item)
                }),
            expandButtonLabel: i18n('ariaLabels.expandButtonLabel', (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.expandButtonLabel) === null || _c === void 0 ? void 0 : _c.call(ariaLabels, item)),
            collapseButtonLabel: i18n('ariaLabels.collapseButtonLabel', (_d = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.collapseButtonLabel) === null || _d === void 0 ? void 0 : _d.call(ariaLabels, item)),
            parent: parent,
            children: children,
            itemsCount: (_e = expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.getItemsCount) === null || _e === void 0 ? void 0 : _e.call(expandableRows, item),
            selectedItemsCount: (_f = expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.getSelectedItemsCount) === null || _f === void 0 ? void 0 : _f.call(expandableRows, item)
        };
    };
    return {
        isExpandable: isExpandable,
        allItems: allItems,
        getExpandableItemProps: getExpandableItemProps,
        hasGroupSelection: !!(expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.groupSelection),
        groupSelection: (_b = expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.groupSelection) !== null && _b !== void 0 ? _b : {
            inverted: false,
            toggledItems: []
        },
        onGroupSelectionChange: expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.onGroupSelectionChange,
        totalItemsCount: expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.totalItemsCount,
        totalSelectedItemsCount: expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.totalSelectedItemsCount
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $71cec865b9338494$export$c73ef76fcb96862d({ totalColumnsCount: totalColumnsCount, hasFooter: hasFooter, loading: loading, loadingText: loadingText, empty: empty, tableRef: tableRef, containerRef: containerRef }) {
    const cellContentRef = (0, $acw62.useRef)(null);
    (0, $013a2451794a45c0$exports.useResizeObserver)(containerRef, ({ contentBoxWidth: containerInlineSize })=>{
        if (tableRef.current && cellContentRef.current) {
            const tablePaddingInlineStart = parseFloat(getComputedStyle(tableRef.current).paddingInlineStart) || 0;
            const tablePaddingInlineEnd = parseFloat(getComputedStyle(tableRef.current).paddingInlineEnd) || 0;
            const inlineSize = containerInlineSize + tablePaddingInlineStart + tablePaddingInlineEnd;
            cellContentRef.current.style.inlineSize = Math.floor(inlineSize) + 'px';
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
        colSpan: totalColumnsCount,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)['cell-merged'], hasFooter && (0, $7ded81c543f72294$export$2e2bcd8739ae039)['has-footer'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: cellContentRef,
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['cell-merged-content'],
        "data-awsui-table-suppress-navigation": true
    }, loading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ffdf6cc8746b93a$export$2e2bcd8739ae039), {
        type: "loading",
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039).loading,
        wrapText: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span"
    }, loadingText)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039).empty
    }, empty)));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $d2dc99a12da72318$export$2e2bcd8739ae039 = {
    "items-loader": "awsui_items-loader_115pt_16l07_5"
};


function $85eff45af97fd1d6$export$2e59eb877e0e85de({ item: item, trackBy: trackBy, children: children }) {
    let parentTrackId = item && trackBy ? (0, $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97)(trackBy, item) : undefined;
    parentTrackId = typeof parentTrackId === 'string' ? parentTrackId : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-root": item ? 'false' : 'true',
        "data-parentrow": parentTrackId,
        className: (0, $d2dc99a12da72318$export$2e2bcd8739ae039)['items-loader']
    }, children);
}
function $85eff45af97fd1d6$export$55a59dff87f0f9bd({ item: item, loadingStatus: loadingStatus, renderLoaderPending: renderLoaderPending, renderLoaderLoading: renderLoaderLoading, renderLoaderError: renderLoaderError, renderLoaderEmpty: renderLoaderEmpty }) {
    let content = null;
    if (loadingStatus === 'pending' && renderLoaderPending) content = renderLoaderPending({
        item: item
    });
    else if (loadingStatus === 'loading' && renderLoaderLoading) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span"
    }, renderLoaderLoading({
        item: item
    }));
    else if (loadingStatus === 'error' && renderLoaderError) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span"
    }, renderLoaderError({
        item: item
    }));
    else if (loadingStatus === 'finished' && renderLoaderEmpty && item) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        tagName: "span"
    }, renderLoaderEmpty({
        item: item
    }));
    else (0, $013a2451794a45c0$exports.warnOnce)('Table', 'Must define `renderLoaderPending`, `renderLoaderLoading`, `renderLoaderError`, or `renderLoaderEmpty` when using corresponding loading status.');
    return content;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $e7925bc72d88b5ba$export$c9113e9bb577984b({ item: item, trackBy: trackBy, counter: counter, children: children, ...props }) {
    return props.isRowHeader ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), {
        ...props,
        counter: counter,
        isEditable: false,
        isEditing: false
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $85eff45af97fd1d6$export$2e59eb877e0e85de), {
        item: item,
        trackBy: trackBy
    }, children)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), {
        ...props,
        isEditable: false,
        isEditing: false
    }, null);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $21c8ce7a53dfba27$export$6bc816ed4d0c9912({ getLoadingStatus: getLoadingStatus, expandableRows: expandableRows }) {
    // The rows are either data or loader.
    // A loader row can be added to the root level (level=0) in which case it has no associated item (item=null).
    // Loader rows can be added to expandable rows (level>0) in which case they have an associated item (item!=null).
    // The "from" property of the loader row is the index of the first item to be loaded starting 0. It is used to generate unique React keys.
    const allRows = new Array();
    const items = expandableRows.allItems;
    const getItemParent = (item)=>expandableRows.getExpandableItemProps(item).parent;
    const getItemChildren = (item)=>expandableRows.getExpandableItemProps(item).children;
    const getItemLevel = (item)=>item ? expandableRows.getExpandableItemProps(item).level : 0;
    const isItemExpanded = (item)=>expandableRows.getExpandableItemProps(item).isExpanded;
    for(let i = 0; i < items.length; i++){
        allRows.push({
            type: 'data',
            item: items[i]
        });
        // Insert empty expandable item loader
        if (isItemExpanded(items[i]) && getItemChildren(items[i]).length === 0) {
            const status = getLoadingStatus === null || getLoadingStatus === void 0 ? void 0 : getLoadingStatus(items[i]);
            if (status === 'loading' || status === 'finished' || status === 'error') allRows.push({
                type: 'loader',
                item: items[i],
                level: getItemLevel(items[i]),
                status: status,
                from: 0
            });
            else (0, $013a2451794a45c0$exports.warnOnce)('Table', 'Expanded items without children must have "loading", "finished", or "error" loading status.');
        }
        // Insert expandable items loaders
        let currentParent = getItemParent(items[i]);
        let levelsDiff = getItemLevel(items[i]) - getItemLevel(items[i + 1]);
        while(currentParent && levelsDiff > 0){
            const status = getLoadingStatus === null || getLoadingStatus === void 0 ? void 0 : getLoadingStatus(currentParent);
            if (status && status !== 'finished') {
                const level = currentParent ? getItemLevel(currentParent) : 0;
                const children = currentParent ? getItemChildren(currentParent) : [];
                allRows.push({
                    type: 'loader',
                    item: currentParent,
                    level: level,
                    status: status,
                    from: children.length
                });
            }
            currentParent = currentParent && getItemParent(currentParent);
            levelsDiff--;
        }
        // Insert root loader
        const rootLoadingStatus = getLoadingStatus === null || getLoadingStatus === void 0 ? void 0 : getLoadingStatus(null);
        if (i === items.length - 1 && rootLoadingStatus && rootLoadingStatus !== 'finished') allRows.push({
            type: 'loader',
            item: null,
            level: 0,
            status: rootLoadingStatus,
            from: items.length
        });
    }
    return {
        allRows: allRows
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $52cd48af6d6570d7$export$7c3f559e2ca95fa = 120;
function $52cd48af6d6570d7$var$readWidths(getCell, visibleColumns) {
    const result = new Map();
    for(let index = 0; index < visibleColumns.length; index++){
        const column = visibleColumns[index];
        let width = column.width || 0;
        const minWidth = column.minWidth || width || $52cd48af6d6570d7$export$7c3f559e2ca95fa;
        if (!width && // read width from the DOM if it is missing in the config
        index !== visibleColumns.length - 1 // skip reading for the last column, because it expands to fully fit the container
        ) {
            const colEl = getCell(column.id);
            width = colEl ? (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(colEl).inlineSize : $52cd48af6d6570d7$export$7c3f559e2ca95fa;
        }
        result.set(column.id, Math.max(width, minWidth));
    }
    return result;
}
function $52cd48af6d6570d7$var$updateWidths(visibleColumns, oldWidths, newWidth, columnId) {
    const column = visibleColumns.find((column)=>column.id === columnId);
    let minWidth = $52cd48af6d6570d7$export$7c3f559e2ca95fa;
    if (typeof (column === null || column === void 0 ? void 0 : column.width) === 'number' && column.width < $52cd48af6d6570d7$export$7c3f559e2ca95fa) minWidth = column === null || column === void 0 ? void 0 : column.width;
    if (typeof (column === null || column === void 0 ? void 0 : column.minWidth) === 'number') minWidth = column === null || column === void 0 ? void 0 : column.minWidth;
    newWidth = Math.max(newWidth, minWidth);
    if (oldWidths.get(columnId) === newWidth) return oldWidths;
    const newWidths = new Map(oldWidths);
    newWidths.set(columnId, newWidth);
    return newWidths;
}
const $52cd48af6d6570d7$var$WidthsContext = (0, $acw62.createContext)({
    getColumnStyles: ()=>({}),
    columnWidths: new Map(),
    updateColumn: ()=>{},
    setCell: ()=>{}
});
function $52cd48af6d6570d7$export$9b0658a77dfa159c({ visibleColumns: visibleColumns, resizableColumns: resizableColumns, containerRef: containerRef, children: children }) {
    const visibleColumnsRef = (0, $acw62.useRef)(null);
    const containerWidthRef = (0, $acw62.useRef)(0);
    const [columnWidths, setColumnWidths] = (0, $acw62.useState)(null);
    const cellsRef = (0, $acw62.useRef)(new Map());
    const stickyCellsRef = (0, $acw62.useRef)(new Map());
    const getCell = (columnId)=>{
        var _a;
        return (_a = cellsRef.current.get(columnId)) !== null && _a !== void 0 ? _a : null;
    };
    const setCell = (sticky, columnId, node)=>{
        const ref = sticky ? stickyCellsRef : cellsRef;
        if (node) ref.current.set(columnId, node);
        else ref.current.delete(columnId);
    };
    const getColumnStyles = (sticky, columnId)=>{
        var _a, _b, _c;
        const column = visibleColumns.find((column)=>column.id === columnId);
        if (!column) return {};
        if (sticky) return {
            width: ((_a = cellsRef.current.get(column.id)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || ((_b = columnWidths === null || columnWidths === void 0 ? void 0 : columnWidths.get(column.id)) !== null && _b !== void 0 ? _b : column.width)
        };
        if (resizableColumns && columnWidths) {
            const isLastColumn = column.id === ((_c = visibleColumns[visibleColumns.length - 1]) === null || _c === void 0 ? void 0 : _c.id);
            const totalWidth = visibleColumns.reduce((sum, { id: id })=>sum + (columnWidths.get(id) || $52cd48af6d6570d7$export$7c3f559e2ca95fa), 0);
            if (isLastColumn && containerWidthRef.current > totalWidth) return {
                width: 'auto',
                minWidth: column === null || column === void 0 ? void 0 : column.minWidth
            };
            else return {
                width: columnWidths.get(column.id),
                minWidth: column === null || column === void 0 ? void 0 : column.minWidth
            };
        }
        return {
            width: column.width,
            minWidth: column.minWidth,
            maxWidth: !resizableColumns ? column.maxWidth : undefined
        };
    };
    // Imperatively sets width style for a cell avoiding React state.
    // This allows setting the style as soon container's size change is observed.
    const updateColumnWidths = (0, $013a2451794a45c0$exports.useStableCallback)(()=>{
        for (const { id: id } of visibleColumns){
            const element = cellsRef.current.get(id);
            if (element) (0, $6208ed25859b543f$export$fc3aed6ced179058)(element, getColumnStyles(false, id));
        }
        // Sticky column widths must be synchronized once all real column widths are assigned.
        for (const { id: id } of visibleColumns){
            const element = stickyCellsRef.current.get(id);
            if (element) (0, $6208ed25859b543f$export$fc3aed6ced179058)(element, getColumnStyles(true, id));
        }
    });
    // Observes container size and requests an update to the last cell width as it depends on the container's width.
    (0, $013a2451794a45c0$exports.useResizeObserver)(containerRef, ({ contentBoxWidth: containerWidth })=>{
        containerWidthRef.current = containerWidth;
        requestAnimationFrame(()=>updateColumnWidths());
    });
    // The widths of the dynamically added columns (after the first render) if not set explicitly
    // will default to the DEFAULT_COLUMN_WIDTH.
    (0, $acw62.useEffect)(()=>{
        updateColumnWidths();
        if (!resizableColumns) return;
        let updated = false;
        const newColumnWidths = new Map(columnWidths);
        const lastVisible = visibleColumnsRef.current;
        if (lastVisible) {
            for(let index = 0; index < visibleColumns.length; index++){
                const column = visibleColumns[index];
                if (!(columnWidths === null || columnWidths === void 0 ? void 0 : columnWidths.get(column.id)) && lastVisible.indexOf(column.id) === -1) {
                    updated = true;
                    newColumnWidths.set(column.id, column.width || $52cd48af6d6570d7$export$7c3f559e2ca95fa);
                }
            }
            if (updated) setColumnWidths(newColumnWidths);
        }
        visibleColumnsRef.current = visibleColumns.map((column)=>column.id);
    }, [
        columnWidths,
        resizableColumns,
        visibleColumns,
        updateColumnWidths
    ]);
    // Read the actual column widths after the first render to employ the browser defaults for
    // those columns without explicit width.
    (0, $acw62.useEffect)(()=>{
        if (!resizableColumns) return;
        setColumnWidths(()=>$52cd48af6d6570d7$var$readWidths(getCell, visibleColumns));
    // This code is intended to run only at the first render and should not re-run when table props change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function updateColumn(columnId, newWidth) {
        setColumnWidths((columnWidths)=>$52cd48af6d6570d7$var$updateWidths(visibleColumns, columnWidths !== null && columnWidths !== void 0 ? columnWidths : new Map(), newWidth, columnId));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($52cd48af6d6570d7$var$WidthsContext.Provider, {
        value: {
            getColumnStyles: getColumnStyles,
            columnWidths: columnWidths !== null && columnWidths !== void 0 ? columnWidths : new Map(),
            updateColumn: updateColumn,
            setCell: setCell
        }
    }, children);
}
function $52cd48af6d6570d7$export$d598237875812773() {
    return (0, $acw62.useContext)($52cd48af6d6570d7$var$WidthsContext);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1yiQH = parcelRequire("1yiQH");




var $0ceb98ce36b03157$export$2e2bcd8739ae039 = {
    "resize-active": "awsui_resize-active_x7peu_an1qk_145",
    "resize-active-with-focus": "awsui_resize-active-with-focus_x7peu_an1qk_145",
    "resizer-wrapper": "awsui_resizer-wrapper_x7peu_an1qk_150",
    "divider-interactive": "awsui_divider-interactive_x7peu_an1qk_158",
    "is-borderless": "awsui_is-borderless_x7peu_an1qk_158",
    "resizer-button-wrapper": "awsui_resizer-button-wrapper_x7peu_an1qk_162",
    "divider": "awsui_divider_x7peu_an1qk_158",
    "divider-disabled": "awsui_divider-disabled_x7peu_an1qk_182",
    "visual-refresh": "awsui_visual-refresh_x7peu_an1qk_190",
    "divider-active": "awsui_divider-active_x7peu_an1qk_194",
    "resizer": "awsui_resizer_x7peu_an1qk_150",
    "has-focus": "awsui_has-focus_x7peu_an1qk_246",
    "tracker": "awsui_tracker_x7peu_an1qk_268"
};


function $15e7516183277033$export$357cd0922346413d(resizerElement) {
    if (!resizerElement) return null;
    const header = (0, $1yiQH.findUpUntil)(resizerElement, (element)=>element.tagName === 'TH');
    if (!header) return null;
    const tableRoot = (0, $1yiQH.findUpUntil)(header, (element)=>element.className.indexOf((0, $7ded81c543f72294$export$2e2bcd8739ae039).root) > -1);
    if (!tableRoot) return null;
    const table = tableRoot.querySelector(`table`);
    if (!table) return null;
    const allHeaders = tableRoot.querySelectorAll(`thead th`);
    // tracker is rendered inside table wrapper to align with its size
    const tracker = tableRoot.querySelector(`.${(0, $0ceb98ce36b03157$export$2e2bcd8739ae039).tracker}`);
    if (!tracker) return null;
    const scrollParent = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(header)[0];
    if (!scrollParent) return null;
    return {
        header: header,
        table: table,
        allHeaders: allHeaders,
        tracker: tracker,
        scrollParent: scrollParent
    };
}
function $15e7516183277033$export$134d8f4885c418ba(resizerElement) {
    const header = resizerElement && (0, $1yiQH.findUpUntil)(resizerElement, (element)=>element.tagName.toLowerCase() === 'th');
    return header ? (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(header).inlineSize : 0;
}



const $ba2285bfc0275a61$var$RESIZE_THROTTLE = 25;
const $ba2285bfc0275a61$var$AUTO_GROW_START_TIME = 10;
const $ba2285bfc0275a61$var$AUTO_GROW_INTERVAL = 10;
const $ba2285bfc0275a61$var$AUTO_GROW_INCREMENT = 5;
function $ba2285bfc0275a61$export$2e0a83ec2e27ecbb({ className: className }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0ceb98ce36b03157$export$2e2bcd8739ae039).divider, (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['divider-disabled'], className)
    });
}
function $ba2285bfc0275a61$export$48a76196cafe3b93({ onWidthUpdate: onWidthUpdate, onWidthUpdateCommit: onWidthUpdateCommit, ariaLabelledby: ariaLabelledby, minWidth: minWidth = (0, $52cd48af6d6570d7$export$7c3f559e2ca95fa), tabIndex: tabIndex, showFocusRing: showFocusRing, focusId: focusId, roleDescription: roleDescription, tooltipText: tooltipText, isBorderless: isBorderless }) {
    onWidthUpdate = (0, $013a2451794a45c0$exports.useStableCallback)(onWidthUpdate);
    onWidthUpdateCommit = (0, $013a2451794a45c0$exports.useStableCallback)(onWidthUpdateCommit);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const separatorId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const positioningWrapperRef = (0, $acw62.useRef)(null);
    const resizerToggleRef = (0, $acw62.useRef)(null);
    const resizerSeparatorRef = (0, $acw62.useRef)(null);
    const [isPointerDown, setIsPointerDown] = (0, $acw62.useState)(false);
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const [showUapButtons, setShowUapButtons] = (0, $acw62.useState)(false);
    const [resizerObscured, setResizerObscured] = (0, $acw62.useState)(false);
    const [isKeyboardDragging, setIsKeyboardDragging] = (0, $acw62.useState)(false);
    const autoGrowTimeout = (0, $acw62.useRef)();
    const [resizerHasFocus, setResizerHasFocus] = (0, $acw62.useState)(false);
    const [headerCellWidth, setHeaderCellWidth] = (0, $acw62.useState)(0);
    // Read header width after mounting for it to be available in the element's ARIA label before it gets focused.
    (0, $acw62.useEffect)(()=>{
        setHeaderCellWidth((0, $15e7516183277033$export$134d8f4885c418ba)(resizerToggleRef.current));
    }, []);
    const isObscured = (0, $acw62.useCallback)(()=>{
        const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
        if (!elements || !positioningWrapperRef.current) return false;
        let scrollPaddingInlineStart = 0;
        let scrollPaddingInlineEnd = 0;
        // Calculate size of the headers at the exact moment of the call to deal
        // with auto-width columns and cached sticky column state.
        elements.allHeaders.forEach((header)=>{
            const { inlineSize: inlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(header);
            if (header.style.insetInlineStart) scrollPaddingInlineStart += inlineSize;
            if (header.style.insetInlineEnd) scrollPaddingInlineEnd += inlineSize;
        });
        const { insetInlineStart: scrollParentInsetInlineStart, insetInlineEnd: scrollParentInsetInlineEnd } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.scrollParent);
        const { insetInlineStart: insetInlineStart, insetInlineEnd: insetInlineEnd, inlineSize: inlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header);
        const relativeInsetInlineStart = insetInlineStart - scrollParentInsetInlineStart;
        const relativeInsetInlineEnd = scrollParentInsetInlineEnd - insetInlineEnd;
        const isSticky = !!elements.header.style.insetInlineStart || !!elements.header.style.insetInlineEnd;
        return(// Is positioningWrapper obscured behind the left edge of scrollParent?
        Math.ceil(relativeInsetInlineStart + inlineSize) < (isSticky ? 0 : scrollPaddingInlineStart) || // Is positioningWrapper obscured behind the right edge of scrollParent?
        Math.ceil(relativeInsetInlineEnd) < (isSticky ? 0 : scrollPaddingInlineEnd));
    }, []);
    const scrollIntoViewIfNeeded = (0, $acw62.useCallback)(()=>{
        if (resizerSeparatorRef.current && isObscured()) (0, $24d40242cc6554ee$export$a904af9c1628c179)(resizerSeparatorRef.current);
    }, [
        isObscured
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!showUapButtons) {
            setResizerObscured(false);
            return;
        }
        const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
        if (!elements) return;
        const onScroll = ()=>setResizerObscured(isObscured());
        elements.scrollParent.addEventListener('scroll', onScroll);
        return ()=>elements.scrollParent.removeEventListener('scroll', onScroll);
    }, [
        isObscured,
        showUapButtons
    ]);
    (0, $acw62.useEffect)(()=>{
        if (showUapButtons) setResizerObscured(isObscured());
    }, [
        headerCellWidth,
        isObscured,
        showUapButtons
    ]);
    const updateTrackerPosition = (0, $acw62.useCallback)((newOffset)=>{
        const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
        if (!elements) return;
        const { insetInlineStart: scrollParentInsetInlineStart } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.table);
        elements.tracker.style.insetBlockStart = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).blockSize + 'px';
        // minus one pixel to offset the cell border
        elements.tracker.style.insetInlineStart = newOffset - scrollParentInsetInlineStart - 1 + 'px';
    }, []);
    const updateColumnWidth = (0, $acw62.useCallback)((newWidth)=>{
        const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
        if (!elements) return;
        const { insetInlineEnd: insetInlineEnd, inlineSize: inlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header);
        const updatedWidth = newWidth < minWidth ? minWidth : newWidth;
        updateTrackerPosition(insetInlineEnd + updatedWidth - inlineSize);
        setHeaderCellWidth(updatedWidth);
        // callbacks must be the last calls in the handler, because they may cause an extra update
        onWidthUpdate(newWidth);
    }, [
        minWidth,
        onWidthUpdate,
        updateTrackerPosition
    ]);
    const resizeColumn = (0, $5e5497af6e342378$export$43f0d02427e1c683)((offset)=>{
        const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
        if (!elements) return;
        const { insetInlineStart: inlineStartEdge } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.scrollParent);
        if (offset > inlineStartEdge) {
            const cellLeft = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).insetInlineStart;
            const newWidth = offset - cellLeft;
            // callbacks must be the last calls in the handler, because they may cause an extra update
            updateColumnWidth(newWidth);
        }
    }, $ba2285bfc0275a61$var$RESIZE_THROTTLE, [
        updateColumnWidth
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
        const document = (_b = (_a = resizerToggleRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : window.document;
        if (!isPointerDown && !resizerHasFocus || !elements) return;
        const { insetInlineEnd: inlineEndEdge } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.scrollParent);
        const onAutoGrow = ()=>{
            const inlineSize = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).inlineSize;
            autoGrowTimeout.current = setTimeout(onAutoGrow, $ba2285bfc0275a61$var$AUTO_GROW_INTERVAL);
            // callbacks must be the last calls in the handler, because they may cause an extra update
            updateColumnWidth(inlineSize + $ba2285bfc0275a61$var$AUTO_GROW_INCREMENT);
            elements.scrollParent.scrollLeft += $ba2285bfc0275a61$var$AUTO_GROW_INCREMENT * ((0, $013a2451794a45c0$exports.getIsRtl)(elements.scrollParent) ? -1 : 1);
        };
        const onPointerMove = (event)=>{
            setIsDragging(true);
            clearTimeout(autoGrowTimeout.current);
            const offset = (0, $013a2451794a45c0$exports.getLogicalPageX)(event);
            if (offset > inlineEndEdge) autoGrowTimeout.current = setTimeout(onAutoGrow, $ba2285bfc0275a61$var$AUTO_GROW_START_TIME);
            else resizeColumn(offset);
        };
        const onPointerUp = (event)=>{
            setIsPointerDown(false);
            if (isDragging) {
                setIsDragging(false);
                resizeColumn((0, $013a2451794a45c0$exports.getLogicalPageX)(event));
            } else setShowUapButtons(true);
            onWidthUpdateCommit();
            clearTimeout(autoGrowTimeout.current);
        };
        const onKeyDown = (event)=>{
            if (isKeyboardDragging) {
                const keys = [
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape
                ];
                if (keys.indexOf(event.keyCode) !== -1) {
                    event.preventDefault();
                    if ((0, $d790fc2d8f354fdb$export$f11fd8c04cad088d)(event)) (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
                        onActivate: ()=>{
                            var _a;
                            setIsKeyboardDragging(false);
                            setShowUapButtons(false);
                            (_a = resizerToggleRef.current) === null || _a === void 0 || _a.focus();
                        },
                        onEscape: ()=>{
                            var _a;
                            setIsKeyboardDragging(false);
                            setShowUapButtons(false);
                            (_a = resizerToggleRef.current) === null || _a === void 0 || _a.focus();
                        },
                        onInlineStart: ()=>{
                            updateColumnWidth((0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).inlineSize - 10);
                            scrollIntoViewIfNeeded();
                        },
                        onInlineEnd: ()=>{
                            updateColumnWidth((0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).inlineSize + 10);
                            scrollIntoViewIfNeeded();
                        }
                    });
                }
            } else if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter || event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space) {
                // Enter keyboard dragging mode
                event.preventDefault();
                if ((0, $d790fc2d8f354fdb$export$f11fd8c04cad088d)(event)) (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
                    onActivate: ()=>{
                        var _a;
                        setShowUapButtons(true);
                        setIsKeyboardDragging(true);
                        (_a = resizerSeparatorRef.current) === null || _a === void 0 || _a.focus();
                    }
                });
            } else // Showing the UAP buttons when the button is only focused and not activated
            // gives a false impression that you can resize with the arrow keys.
            setShowUapButtons(false);
        };
        updateTrackerPosition((0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).insetInlineEnd);
        const controller = new AbortController();
        if (isPointerDown) {
            document.body.classList.add((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['resize-active']);
            document.addEventListener('pointermove', onPointerMove, {
                signal: controller.signal
            });
            document.addEventListener('pointerup', onPointerUp, {
                signal: controller.signal
            });
        } else if (resizerHasFocus) {
            document.body.classList.add((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['resize-active-with-focus']);
            elements.header.addEventListener('keydown', onKeyDown, {
                signal: controller.signal
            });
        }
        if (isKeyboardDragging) document.body.classList.add((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['resize-active']);
        return ()=>{
            document.body.classList.remove((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['resize-active']);
            document.body.classList.remove((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['resize-active-with-focus']);
            controller.abort();
        };
    }, [
        isDragging,
        isKeyboardDragging,
        isPointerDown,
        resizerHasFocus,
        scrollIntoViewIfNeeded,
        onWidthUpdateCommit,
        resizeColumn,
        updateColumnWidth,
        updateTrackerPosition
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDragging) return ()=>clearTimeout(autoGrowTimeout.current);
    }, [
        isDragging
    ]);
    const { tabIndex: resizerTabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(resizerToggleRef, {
        tabIndex: tabIndex
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        // When the table is borderless (works in visual refresh tables only), the last resize handle must not
        // exceed table's edges, as it causes an unintended overflow otherwise.
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['resizer-wrapper'], isVisualRefresh && (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['visual-refresh'], (!isVisualRefresh || isBorderless) && (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['is-borderless']),
        ref: positioningWrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $676a06802ce5bea2$export$2e2bcd8739ae039), {
        clickDragThreshold: 3,
        hideButtonsOnDrag: false,
        directions: {
            'inline-start': resizerObscured ? undefined : headerCellWidth > minWidth ? 'active' : 'disabled',
            'inline-end': resizerObscured ? undefined : 'active'
        },
        triggerMode: "controlled",
        controlledShowButtons: showUapButtons && !resizerObscured,
        wrapperClassName: (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['resizer-button-wrapper'],
        tooltipText: tooltipText,
        "data-obscured": resizerObscured,
        onDirectionClick: (direction)=>{
            const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
            if (!elements) return;
            if (direction === 'inline-start') {
                updateColumnWidth((0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).inlineSize - 20);
                requestAnimationFrame(()=>{
                    onWidthUpdateCommit();
                    scrollIntoViewIfNeeded();
                });
            } else if (direction === 'inline-end') {
                updateColumnWidth((0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(elements.header).inlineSize + 20);
                requestAnimationFrame(()=>{
                    onWidthUpdateCommit();
                    scrollIntoViewIfNeeded();
                });
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ref: resizerToggleRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0ceb98ce36b03157$export$2e2bcd8739ae039).resizer, (resizerHasFocus || showFocusRing || isKeyboardDragging) && (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['has-focus']),
        onPointerDown: (event)=>{
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            setIsPointerDown(true);
        },
        onClick: ()=>{
            var _a;
            // Prevent mouse drag activation and activate keyboard dragging for VO+Space click.
            setIsPointerDown(false);
            setIsDragging(false);
            setShowUapButtons(true);
            setResizerHasFocus(true);
            setIsKeyboardDragging(true);
            (_a = resizerSeparatorRef.current) === null || _a === void 0 || _a.focus();
        },
        onFocus: ()=>{
            setHeaderCellWidth((0, $15e7516183277033$export$134d8f4885c418ba)(resizerToggleRef.current));
            setResizerHasFocus(true);
        },
        onBlur: (event)=>{
            // Ignoring blur event when focus moves to the resizer separator element.
            // (This focus transition is done programmatically when the resizer button is clicked).
            if (event.relatedTarget !== resizerSeparatorRef.current) {
                setResizerHasFocus(false);
                setShowUapButtons(false);
                return;
            }
        },
        "aria-roledescription": roleDescription,
        "aria-labelledby": ariaLabelledby,
        tabIndex: resizerTabIndex,
        "data-focus-id": focusId
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['divider-interactive'], (isPointerDown || isDragging) && (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)['divider-active']),
        "data-awsui-table-suppress-navigation": true,
        ref: resizerSeparatorRef,
        id: separatorId,
        role: "slider",
        tabIndex: -1,
        "aria-labelledby": ariaLabelledby,
        "aria-hidden": !isKeyboardDragging,
        "aria-valuemin": minWidth,
        "aria-valuemax": Number.MAX_SAFE_INTEGER,
        "aria-valuenow": headerCellWidth,
        "data-focus-id": focusId,
        onBlur: (event)=>{
            setIsKeyboardDragging(false);
            if (event.relatedTarget !== resizerToggleRef.current) {
                setResizerHasFocus(false);
                setShowUapButtons(false);
            }
            onWidthUpdateCommit();
        }
    })));
}
function $ba2285bfc0275a61$export$1a1c8e5e76867279() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $0ceb98ce36b03157$export$2e2bcd8739ae039).tracker
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $9bc9293ffbf00f4c$export$a97c3cc4bf1da1ca(options) {
    const singleSelectionProps = $9bc9293ffbf00f4c$var$useSingleSelection(options);
    const multiSelectionProps = $9bc9293ffbf00f4c$var$useMultiSelection(options);
    switch(options.selectionType){
        case 'single':
            return singleSelectionProps;
        case 'multi':
            return multiSelectionProps;
        default:
            return {
                isItemSelected: ()=>false
            };
    }
}
function $9bc9293ffbf00f4c$var$useSingleSelection({ ariaLabels: ariaLabels, isItemDisabled: isItemDisabled = ()=>false, onSelectionChange: onSelectionChange, selectedItems: selectedItems = [], selectionType: selectionType, trackBy: trackBy, setLastUserAction: setLastUserAction }) {
    // The name assigned to all controls to combine them in a single group.
    const selectionControlName = (0, $013a2451794a45c0$exports.useUniqueId)();
    if (selectionType !== 'single') return {
        isItemSelected: ()=>false
    };
    // Selection state for individual items.
    const selectedSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, selectedItems.slice(0, 1));
    const isItemSelected = selectedSet.has.bind(selectedSet);
    const handleToggleItem = (item)=>{
        if (!isItemDisabled(item) && !isItemSelected(item)) {
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSelectionChange, {
                selectedItems: [
                    item
                ]
            });
            setLastUserAction === null || setLastUserAction === void 0 || setLastUserAction('selection');
        }
    };
    return {
        isItemSelected: isItemSelected,
        getItemSelectionProps: (item)=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: 'single',
                disabled: isItemDisabled(item),
                checked: isItemSelected(item),
                onChange: ()=>handleToggleItem(item),
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.itemSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems
                }, item))
            };
        }
    };
}
function $9bc9293ffbf00f4c$var$useMultiSelection({ ariaLabels: ariaLabels, isItemDisabled: isItemDisabled = ()=>false, items: items, loading: loading, onSelectionChange: onSelectionChange, selectedItems: selectedItems = [], selectionType: selectionType, trackBy: trackBy, setLastUserAction: setLastUserAction, totalItemsCount: totalItemsCount }) {
    // The name assigned to all controls to combine them in a single group.
    const selectionControlName = (0, $013a2451794a45c0$exports.useUniqueId)();
    const [shiftPressed, setShiftPressed] = (0, $acw62.useState)(false);
    const [lastClickedItem, setLastClickedItem] = (0, $acw62.useState)(null);
    if (selectionType !== 'multi') return {
        isItemSelected: ()=>false
    };
    // Selection state for individual items.
    const selectedSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, selectedItems);
    const isItemSelected = selectedSet.has.bind(selectedSet);
    // Derived selection state for all-items checkbox.
    let allItemsDisabled = true;
    let allEnabledItemsSelected = true;
    for (const item of items){
        allItemsDisabled = allItemsDisabled && isItemDisabled(item);
        allEnabledItemsSelected = allEnabledItemsSelected && (isItemSelected(item) || isItemDisabled(item));
    }
    const allItemsCheckboxSelected = selectedItems.length > 0 && allEnabledItemsSelected;
    const allItemsCheckboxIndeterminate = selectedItems.length > 0 && !allEnabledItemsSelected;
    // Shift-selection helpers.
    const itemIndexesMap = new Map();
    items.forEach((item, i)=>itemIndexesMap.set((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, item), i));
    const getShiftSelectedItems = (item)=>{
        const lastClickedItemIndex = lastClickedItem ? itemIndexesMap.get((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, lastClickedItem)) : undefined;
        // We use lastClickedItemIndex to determine if filtering/sorting/pagination
        // made previously selected item invisible, therefore we reset state for shift-select.
        if (lastClickedItemIndex !== undefined) {
            const currentItemIndex = itemIndexesMap.get((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, item));
            const start = Math.min(currentItemIndex, lastClickedItemIndex);
            const end = Math.max(currentItemIndex, lastClickedItemIndex);
            return items.slice(start, end + 1);
        }
        return [
            item
        ];
    };
    // Select items that are not already selected or disabled.
    const selectItems = (requestedItems)=>{
        const newSelectedItems = [
            ...selectedItems
        ];
        requestedItems.forEach((newItem)=>{
            if (!isItemSelected(newItem) && !isItemDisabled(newItem)) newSelectedItems.push(newItem);
        });
        return newSelectedItems;
    };
    // Unselect items unless they are disabled.
    const deselectItems = (requestedItems)=>{
        const requestedItemsSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, requestedItems);
        const newSelectedItems = [];
        selectedItems.forEach((selectedItem)=>{
            const shouldUnselect = requestedItemsSet.has(selectedItem);
            if (!shouldUnselect || isItemDisabled(selectedItem)) newSelectedItems.push(selectedItem);
        });
        return newSelectedItems;
    };
    const handleToggleAll = ()=>{
        const newSelectedItems = allEnabledItemsSelected ? deselectItems(items) : selectItems(items);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSelectionChange, {
            selectedItems: newSelectedItems
        });
        setLastUserAction === null || setLastUserAction === void 0 || setLastUserAction('selection');
    };
    const handleToggleItem = (item)=>{
        if (!isItemDisabled(item)) {
            const requestedItems = shiftPressed ? getShiftSelectedItems(item) : [
                item
            ];
            const selectedItems = isItemSelected(item) ? deselectItems(requestedItems) : selectItems(requestedItems);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSelectionChange, {
                selectedItems: selectedItems
            });
            setLastClickedItem(item);
            setLastUserAction === null || setLastUserAction === void 0 || setLastUserAction('selection');
        }
    };
    return {
        isItemSelected: isItemSelected,
        getSelectAllProps: ()=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: 'multi',
                disabled: allItemsDisabled || !!loading,
                checked: allItemsCheckboxSelected,
                indeterminate: allItemsCheckboxIndeterminate,
                onChange: handleToggleAll,
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.allItemsSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems,
                    itemsCount: totalItemsCount,
                    selectedItemsCount: selectedItems.length
                })),
                selectionGroupLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel
            };
        },
        getItemSelectionProps: (item)=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: 'multi',
                disabled: isItemDisabled(item),
                checked: isItemSelected(item),
                onChange: ()=>handleToggleItem(item),
                onShiftToggle: (value)=>setShiftPressed(value),
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.itemSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems
                }, item))
            };
        }
    };
}


var $1yiQH = parcelRequire("1yiQH");


var $6c95fef02beb4257$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1s55x_14pps_145",
    "label": "awsui_label_1s55x_14pps_149",
    "label-top": "awsui_label-top_1s55x_14pps_163",
    "stud": "awsui_stud_1s55x_14pps_168"
};


function $021f9e20e3ad3309$export$c8a0aa4990d3b09f(selectionType, totalItems) {
    if (selectionType !== 'multi') return {};
    function moveFocus(sourceElement, fromIndex, direction) {
        let index = fromIndex;
        const rootContainer = $021f9e20e3ad3309$var$findRootContainer(sourceElement);
        while(index >= -1 && index < totalItems){
            index += direction;
            const control = $021f9e20e3ad3309$var$findSelectionControlByIndex(rootContainer, index);
            if (control && !control.disabled) {
                control.focus();
                break;
            }
        }
    }
    const [moveFocusDown, moveFocusUp] = [
        1,
        -1
    ].map((direction)=>{
        return (event)=>{
            const target = event.currentTarget;
            const itemNode = (0, $1yiQH.findUpUntil)(target, (node)=>node.dataset.selectionItem === 'item');
            const fromIndex = Array.prototype.indexOf.call(itemNode.parentElement.children, itemNode);
            moveFocus(target, fromIndex, direction);
        };
    });
    return {
        moveFocusDown: moveFocusDown,
        moveFocusUp: moveFocusUp,
        moveFocus: moveFocus
    };
}
function $021f9e20e3ad3309$var$findSelectionControlByIndex(rootContainer, index) {
    if (index === -1) // find "select all" checkbox
    return rootContainer.querySelector(`[data-${(0, $30c09cf06b060b34$export$988c58523d43232b)}="all"] .${(0, $6c95fef02beb4257$export$2e2bcd8739ae039).root} input`);
    return rootContainer.querySelectorAll(`[data-${(0, $30c09cf06b060b34$export$988c58523d43232b)}="item"] .${(0, $6c95fef02beb4257$export$2e2bcd8739ae039).root} input`)[index];
}
function $021f9e20e3ad3309$var$findRootContainer(element) {
    return (0, $1yiQH.findUpUntil)(element, (node)=>node.dataset.selectionRoot === 'true');
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









var $93211f0fff30af11$export$2e2bcd8739ae039 = {
    "header-cell": "awsui_header-cell_1spae_wii4_149",
    "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_wii4_183",
    "header-cell-sticky": "awsui_header-cell-sticky_1spae_wii4_204",
    "header-cell-stuck": "awsui_header-cell-stuck_1spae_wii4_207",
    "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_wii4_207",
    "header-cell-hidden": "awsui_header-cell-hidden_1spae_wii4_213",
    "header-cell-variant-embedded": "awsui_header-cell-variant-embedded_1spae_wii4_216",
    "is-visual-refresh": "awsui_is-visual-refresh_1spae_wii4_216",
    "sticky-cell": "awsui_sticky-cell_1spae_wii4_216",
    "header-cell-variant-borderless": "awsui_header-cell-variant-borderless_1spae_wii4_216",
    "header-cell-sortable": "awsui_header-cell-sortable_1spae_wii4_219",
    "table-variant-full-page": "awsui_table-variant-full-page_1spae_wii4_240",
    "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_1spae_wii4_243",
    "has-selection": "awsui_has-selection_1spae_wii4_243",
    "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_1spae_wii4_246",
    "resize-divider": "awsui_resize-divider_1spae_wii4_251",
    "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_1spae_wii4_258",
    "sorting-icon": "awsui_sorting-icon_1spae_wii4_268",
    "edit-icon": "awsui_edit-icon_1spae_wii4_276",
    "header-cell-content": "awsui_header-cell-content_1spae_wii4_282",
    "header-cell-content-expandable": "awsui_header-cell-content-expandable_1spae_wii4_288",
    "header-cell-disabled": "awsui_header-cell-disabled_1spae_wii4_340",
    "header-cell-sorted": "awsui_header-cell-sorted_1spae_wii4_340",
    "header-cell-text": "awsui_header-cell-text_1spae_wii4_354",
    "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_wii4_358",
    "header-cell-ascending": "awsui_header-cell-ascending_1spae_wii4_364",
    "header-cell-descending": "awsui_header-cell-descending_1spae_wii4_365",
    "has-striped-rows": "awsui_has-striped-rows_1spae_wii4_479",
    "sticky-cell-pad-inline-start": "awsui_sticky-cell-pad-inline-start_1spae_wii4_479",
    "header-cell-resizable": "awsui_header-cell-resizable_1spae_wii4_491"
};


function $ef31a059f47373a7$export$3d583f8f97f3b3a0({ resizableStyle: resizableStyle, sortingStatus: sortingStatus, sortingDisabled: sortingDisabled, focusedComponent: focusedComponent, stuck: stuck, sticky: sticky, resizable: resizable, hidden: hidden, stripedRows: stripedRows, isSelection: isSelection, colIndex: colIndex, columnId: columnId, stickyState: stickyState, cellRef: cellRef, tableRole: tableRole, children: children, variant: variant, ariaLabel: ariaLabel, tableVariant: tableVariant, ...props }) {
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const stickyStyles = (0, $b00a9e41f83b2a0f$export$76f0c0a58cdc31f5)({
        stickyColumns: stickyState,
        columnId: columnId,
        getClassName: (props)=>(0, $d5e9c22659308d3d$export$8343e8fa60fc2e2f)((0, $93211f0fff30af11$export$2e2bcd8739ae039), props)
    });
    const cellRefObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(stickyStyles.ref, cellRef, cellRefObject);
    const { tabIndex: cellTabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(cellRefObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        "data-focus-id": `header-${String(columnId)}`,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell'], (0, $93211f0fff30af11$export$2e2bcd8739ae039)[`header-cell-variant-${variant}`], sticky && (0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-sticky'], resizable && (0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-resizable'], stuck && (0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-stuck'], stripedRows && (0, $93211f0fff30af11$export$2e2bcd8739ae039)['has-striped-rows'], isVisualRefresh && (0, $93211f0fff30af11$export$2e2bcd8739ae039)['is-visual-refresh'], isSelection && (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)['selection-control'], (0, $7ded81c543f72294$export$2e2bcd8739ae039)['selection-control-header']), tableVariant && (0, $93211f0fff30af11$export$2e2bcd8739ae039)[`table-variant-${tableVariant}`], {
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-fake-focus']]: focusedComponent === `header-${String(columnId)}`,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-sortable']]: sortingStatus,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-sorted']]: sortingStatus === 'ascending' || sortingStatus === 'descending',
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-disabled']]: sortingDisabled,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-ascending']]: sortingStatus === 'ascending',
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-descending']]: sortingStatus === 'descending',
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-hidden']]: hidden
        }, stickyStyles.className),
        style: {
            ...resizableStyle,
            ...stickyStyles.style
        },
        ref: mergedRef,
        ...(0, $4724080100e81846$export$9277a016ea496b61)({
            tableRole: tableRole,
            sortingStatus: sortingStatus,
            colIndex: colIndex
        }),
        tabIndex: cellTabIndex === -1 ? undefined : cellTabIndex,
        ...(0, $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute)(props),
        ...ariaLabel ? {
            'aria-label': ariaLabel
        } : {}
    }, children);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









function $a063fc03a6d3f32f$export$961b2a4b6e0cf70e(style, checked, disabled, readOnly) {
    var _a, _b;
    let properties;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core' && (style === null || style === void 0 ? void 0 : style.input)) {
        const computedState = (0, $a4ca11d6aa7fe07f$export$6444e33011b307a)(checked, disabled, readOnly, undefined);
        properties = {
            fill: ((_a = style.input) === null || _a === void 0 ? void 0 : _a.fill) && style.input.fill[computedState],
            stroke: ((_b = style.input) === null || _b === void 0 ? void 0 : _b.stroke) && style.input.stroke[computedState]
        };
    }
    return properties;
}
function $a063fc03a6d3f32f$export$364effd9687aa2ee(style, checked, disabled, readOnly) {
    var _a, _b, _c;
    let properties;
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core' && (style === null || style === void 0 ? void 0 : style.input)) {
        const computedState = (0, $a4ca11d6aa7fe07f$export$6444e33011b307a)(checked, disabled, readOnly, undefined);
        properties = {
            fill: ((_b = (_a = style.input) === null || _a === void 0 ? void 0 : _a.circle) === null || _b === void 0 ? void 0 : _b.fill) && style.input.circle.fill[computedState],
            stroke: ((_c = style.input) === null || _c === void 0 ? void 0 : _c.fill) && style.input.fill[computedState]
        };
    }
    return properties;
}
function $a063fc03a6d3f32f$export$b401c5cdeddba627(style, checked, disabled, readOnly) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let properties = {};
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core' && ((style === null || style === void 0 ? void 0 : style.label) || (style === null || style === void 0 ? void 0 : style.description) || (style === null || style === void 0 ? void 0 : style.input))) {
        const computedState = (0, $a4ca11d6aa7fe07f$export$6444e33011b307a)(checked, disabled, readOnly, undefined);
        properties = {
            label: {
                color: ((_a = style === null || style === void 0 ? void 0 : style.label) === null || _a === void 0 ? void 0 : _a.color) && style.label.color[computedState]
            },
            description: {
                color: ((_b = style === null || style === void 0 ? void 0 : style.description) === null || _b === void 0 ? void 0 : _b.color) && style.description.color[computedState]
            },
            focusRing: {
                borderColor: (_d = (_c = style === null || style === void 0 ? void 0 : style.input) === null || _c === void 0 ? void 0 : _c.focusRing) === null || _d === void 0 ? void 0 : _d.borderColor,
                borderRadius: (_f = (_e = style === null || style === void 0 ? void 0 : style.input) === null || _e === void 0 ? void 0 : _e.focusRing) === null || _f === void 0 ? void 0 : _f.borderRadius,
                borderWidth: (_h = (_g = style === null || style === void 0 ? void 0 : style.input) === null || _g === void 0 ? void 0 : _g.focusRing) === null || _h === void 0 ? void 0 : _h.borderWidth
            }
        };
    }
    return properties;
}



var $a460a27c545b77d1$export$2e2bcd8739ae039 = {
    "radio-control": "awsui_radio-control_1v1hk_64we6_145",
    "outline": "awsui_outline_1v1hk_64we6_153",
    "styled-circle-border": "awsui_styled-circle-border_1v1hk_64we6_176",
    "styled-circle-disabled": "awsui_styled-circle-disabled_1v1hk_64we6_180",
    "styled-circle-readonly": "awsui_styled-circle-readonly_1v1hk_64we6_180",
    "styled-circle-fill": "awsui_styled-circle-fill_1v1hk_64we6_185",
    "styled-circle-checked": "awsui_styled-circle-checked_1v1hk_64we6_201"
};



var $57170facfbe30cad$export$2e2bcd8739ae039 = {
    "root": "awsui_root_15oj2_1q93l_5"
};


var $4ba5898a3f042c33$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function RadioButton({ name: name, children: children, value: value, checked: checked, description: description, disabled: disabled, controlId: controlId, readOnly: readOnly, className: className, style: style, nativeInputAttributes: nativeInputAttributes, onSelect: onSelect, ...rest }, ref) {
    const radioButtonRef = (0, $acw62.useRef)(null);
    const mergedRefs = (0, $013a2451794a45c0$exports.useMergeRefs)(radioButtonRef, ref);
    const { tabIndex: tabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(radioButtonRef);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9358073d64ebb29$export$2e2bcd8739ae039), {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $57170facfbe30cad$export$2e2bcd8739ae039).root, className),
        controlClassName: (0, $a460a27c545b77d1$export$2e2bcd8739ae039)['radio-control'],
        outlineClassName: (0, $a460a27c545b77d1$export$2e2bcd8739ae039).outline,
        label: children,
        description: description,
        disabled: disabled,
        readOnly: readOnly,
        controlId: controlId,
        style: (0, $a063fc03a6d3f32f$export$b401c5cdeddba627)(style, checked, disabled, readOnly),
        __internalRootRef: rest.__internalRootRef,
        ...(0, $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute)(rest),
        nativeControl: (nativeControlProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
                ...nativeControlProps,
                tag: "input",
                componentName: "RadioButton",
                nativeAttributes: nativeInputAttributes,
                tabIndex: tabIndex,
                type: "radio",
                ref: mergedRefs,
                name: name,
                value: value,
                checked: checked,
                "aria-disabled": readOnly && !disabled ? 'true' : undefined,
                // empty handler to suppress React controllability warning
                onChange: ()=>{}
            }),
        onClick: ()=>{
            var _a;
            (_a = radioButtonRef.current) === null || _a === void 0 || _a.focus();
            if (!checked) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSelect);
        },
        styledControl: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 100 100",
            focusable: "false",
            "aria-hidden": "true"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a460a27c545b77d1$export$2e2bcd8739ae039)['styled-circle-border'], {
                [(0, $a460a27c545b77d1$export$2e2bcd8739ae039)['styled-circle-disabled']]: disabled,
                [(0, $a460a27c545b77d1$export$2e2bcd8739ae039)['styled-circle-readonly']]: readOnly
            }),
            strokeWidth: 6.25,
            cx: 50,
            cy: 50,
            r: 46,
            style: (0, $a063fc03a6d3f32f$export$961b2a4b6e0cf70e)(style, checked, disabled, readOnly)
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a460a27c545b77d1$export$2e2bcd8739ae039)['styled-circle-fill'], {
                [(0, $a460a27c545b77d1$export$2e2bcd8739ae039)['styled-circle-disabled']]: disabled,
                [(0, $a460a27c545b77d1$export$2e2bcd8739ae039)['styled-circle-checked']]: checked,
                [(0, $a460a27c545b77d1$export$2e2bcd8739ae039)['styled-circle-readonly']]: readOnly
            }),
            strokeWidth: 30,
            cx: 50,
            cy: 50,
            r: 35,
            style: (0, $a063fc03a6d3f32f$export$364effd9687aa2ee)(style, checked, disabled, readOnly)
        }))
    });
});




function $51374b608ac485d9$export$c5dcec1959129451({ selectionType: selectionType, indeterminate: indeterminate = false, onShiftToggle: onShiftToggle, onFocusUp: onFocusUp, onFocusDown: onFocusDown, name: name, ariaLabel: ariaLabel, focusedComponent: focusedComponent, rowIndex: rowIndex, itemKey: itemKey, verticalAlign: verticalAlign = 'middle', onChange: onChange, ...sharedProps }) {
    const controlId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const isMultiSelection = selectionType === 'multi';
    const { navigationActive: navigationActive } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(null);
    const setShiftState = (event)=>{
        if (isMultiSelection) onShiftToggle === null || onShiftToggle === void 0 || onShiftToggle(event.shiftKey);
    };
    const onMouseDownHandler = (event)=>{
        setShiftState(event);
        if (isMultiSelection) // To overcome an issue
        // If you shift+click or ctrl+click on a label for a checkbox, checkbox is not checked.
        // https://bugzilla.mozilla.org/show_bug.cgi?id=559506
        event.preventDefault();
    };
    // native checkboxes do not have focus move via keyboard, we implement it here programmatically
    const handleKeyDown = (event)=>{
        setShiftState(event);
        if (isMultiSelection && !navigationActive) {
            if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up) {
                event.preventDefault();
                onFocusUp === null || onFocusUp === void 0 || onFocusUp(event);
            }
            if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down) {
                event.preventDefault();
                onFocusDown === null || onFocusDown === void 0 || onFocusDown(event);
            }
        }
    };
    const handleClick = (event)=>{
        const target = event.currentTarget;
        const nativeInput = target.tagName === 'INPUT' ? target : target.querySelector('input');
        // Clicking on input, does not focus it on Firefox (AWSUI-11345)
        nativeInput === null || nativeInput === void 0 || nativeInput.focus();
    };
    const selector = isMultiSelection ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        ...sharedProps,
        onChange: onChange,
        showOutline: focusedComponent === 'selection-control',
        controlId: controlId,
        "data-focus-id": "selection-control",
        indeterminate: indeterminate
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ba5898a3f042c33$export$2e2bcd8739ae039), {
        ...sharedProps,
        controlId: controlId,
        name: name,
        value: '',
        onSelect: onChange
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        onKeyDown: handleKeyDown,
        onKeyUp: setShiftState,
        onMouseDown: onMouseDownHandler,
        onMouseUp: setShiftState,
        onClick: handleClick,
        htmlFor: controlId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c95fef02beb4257$export$2e2bcd8739ae039).label, (0, $6c95fef02beb4257$export$2e2bcd8739ae039).root, verticalAlign === 'top' && (0, $6c95fef02beb4257$export$2e2bcd8739ae039)['label-top']),
        "aria-label": ariaLabel,
        title: ariaLabel,
        ...rowIndex !== undefined && !sharedProps.disabled ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            detail: {
                position: `${rowIndex + 1}`,
                item: itemKey || ''
            }
        }) : {}
    }, selector), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $6c95fef02beb4257$export$2e2bcd8739ae039).stud,
        "aria-hidden": true
    }, "\u00A0"));
}



function $36873d47a98b41e9$export$e50b671e877efb71({ focusedComponent: focusedComponent, singleSelectionHeaderAriaLabel: singleSelectionHeaderAriaLabel, getSelectAllProps: getSelectAllProps, onFocusMove: onFocusMove, ...props }) {
    const selectAllProps = getSelectAllProps ? getSelectAllProps() : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ef31a059f47373a7$export$3d583f8f97f3b3a0), {
        ...props,
        isSelection: true,
        colIndex: 0,
        focusedComponent: focusedComponent,
        ariaLabel: selectAllProps === null || selectAllProps === void 0 ? void 0 : selectAllProps.selectionGroupLabel,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: (selectAllProps === null || selectAllProps === void 0 ? void 0 : selectAllProps.checked) ? 'deselectAll' : 'selectAll'
        })
    }, selectAllProps ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $51374b608ac485d9$export$c5dcec1959129451), {
        onFocusDown: (event)=>{
            onFocusMove(event.target, -1, 1);
        },
        focusedComponent: focusedComponent,
        ...selectAllProps,
        ...props.sticky ? {
            tabIndex: -1
        } : {}
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), null, singleSelectionHeaderAriaLabel), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$2e0a83ec2e27ecbb), {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['resize-divider']
    }));
}
function $36873d47a98b41e9$export$a0a74e96f9bd7c10({ selectionControlProps: selectionControlProps, ...props }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), {
        ...props,
        isSelection: true,
        wrapLines: false,
        isEditable: false,
        isEditing: false,
        colIndex: 0
    }, selectionControlProps ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $51374b608ac485d9$export$c5dcec1959129451), {
        ...selectionControlProps,
        verticalAlign: props.verticalAlign
    }) : null);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




function $73242b71595f9865$export$c162eb8e13ac6b9({ ariaLabels: ariaLabels, items: items, rootItems: rootItems, selectedItems: selectedItems = [], totalItemsCount: totalItemsCount, trackBy: trackBy, expandableRows: expandableRows, selectionType: selectionType, getLoadingStatus: getLoadingStatus, setLastUserAction: setLastUserAction }) {
    // The name assigned to all controls to combine them in a single group.
    const selectionControlName = (0, $013a2451794a45c0$exports.useUniqueId)();
    const [shiftPressed, setShiftPressed] = (0, $acw62.useState)(false);
    const [lastClickedItem, setLastClickedItem] = (0, $acw62.useState)(null);
    if (selectionType !== 'group') return {
        isItemSelected: ()=>false
    };
    const getParent = (item)=>expandableRows.getExpandableItemProps(item).parent;
    const getChildren = (item)=>expandableRows.getExpandableItemProps(item).children;
    const getSelectionStateProps = (item)=>{
        const { itemsCount: itemsCount, selectedItemsCount: selectedItemsCount } = expandableRows.getExpandableItemProps(item);
        return {
            itemsCount: itemsCount,
            selectedItemsCount: selectedItemsCount
        };
    };
    const isComplete = (item)=>!getLoadingStatus || getLoadingStatus(item) === 'finished';
    const treeProps = {
        rootItems: rootItems,
        trackBy: trackBy,
        getChildren: getChildren,
        isComplete: isComplete
    };
    const selectionTree = new (0, $013a2451794a45c0$exports.SelectionTree)(rootItems, treeProps, expandableRows.groupSelection);
    const onChange = (groupSelection)=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(expandableRows.onGroupSelectionChange, {
            groupSelection: groupSelection
        });
        setLastUserAction === null || setLastUserAction === void 0 || setLastUserAction('selection');
    };
    // Shift-selection helpers.
    const itemIndexesMap = new Map();
    items.forEach((item, i)=>itemIndexesMap.set((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, item), i));
    const getShiftSelectedItems = (item)=>{
        const lastClickedItemIndex = lastClickedItem ? itemIndexesMap.get((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, lastClickedItem)) : undefined;
        // We use lastClickedItemIndex to determine if filtering/sorting/pagination
        // made previously selected item invisible, therefore we reset state for shift-select.
        if (lastClickedItemIndex !== undefined) {
            const currentItemIndex = itemIndexesMap.get((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, item));
            const start = Math.min(currentItemIndex, lastClickedItemIndex);
            const end = Math.max(currentItemIndex, lastClickedItemIndex);
            const requestedItems = items.slice(start, end + 1);
            return lastClickedItemIndex < currentItemIndex ? requestedItems : requestedItems.reverse();
        }
        return [
            item
        ];
    };
    const handleToggleAll = ()=>onChange(selectionTree.toggleAll().getState());
    const handleToggleItem = (item)=>{
        setLastClickedItem(item);
        const requestedItems = shiftPressed ? getShiftSelectedItems(item) : [
            item
        ];
        const requestedItemParents = requestedItems.reduce((set, item)=>set.add(getParent(item)), new Set());
        // Shift-selection is only allowed on items with the same parent.
        if (requestedItemParents.size === 1) onChange(selectionTree.toggleSome(requestedItems).getState());
    };
    const createLoaderToggleHandle = (item)=>()=>onChange(!item ? selectionTree.invertAll().getState() : selectionTree.invertOne(item).getState());
    return {
        isItemSelected: selectionTree.isItemSelected,
        getSelectAllProps: ()=>{
            var _a, _b, _c;
            return {
                name: selectionControlName,
                selectionType: 'multi',
                disabled: false,
                checked: selectionTree.isAllItemsSelected(),
                indeterminate: selectionTree.isAllItemsIndeterminate(),
                onChange: handleToggleAll,
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.allItemsSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems,
                    itemsCount: (_b = expandableRows.totalItemsCount) !== null && _b !== void 0 ? _b : totalItemsCount,
                    selectedItemsCount: (_c = expandableRows.totalSelectedItemsCount) !== null && _c !== void 0 ? _c : selectedItems.length
                }))
            };
        },
        getItemSelectionProps: (item)=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: 'multi',
                disabled: false,
                checked: selectionTree.isItemSelected(item),
                indeterminate: selectionTree.isItemIndeterminate(item),
                onChange: ()=>handleToggleItem(item),
                onShiftToggle: (value)=>setShiftPressed(value),
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.itemSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems,
                    ...getSelectionStateProps(item)
                }, item))
            };
        },
        getLoaderSelectionProps: (item)=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: 'multi',
                disabled: false,
                checked: item ? selectionTree.isItemSelected(item) : selectionTree.getState().inverted,
                indeterminate: false,
                onChange: createLoaderToggleHandle(item),
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.itemLoaderSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems
                }, item))
            };
        }
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $1yiQH = parcelRequire("1yiQH");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");










var $6986397e11c49917$export$2e2bcd8739ae039 = {
    "header-cell-text": "awsui_header-cell-text_dpuyq_1id1o_5"
};



function $09ac39531d24690e$export$9e1517a3035b3e5c({ tabIndex: tabIndex, column: column, activeSortingColumn: activeSortingColumn, sortingDescending: sortingDescending, sortingDisabled: sortingDisabled, wrapLines: wrapLines, focusedComponent: focusedComponent, stuck: stuck, sticky: sticky, hidden: hidden, stripedRows: stripedRows, onClick: onClick, colIndex: colIndex, updateColumn: updateColumn, resizableColumns: resizableColumns, resizableStyle: resizableStyle, onResizeFinish: onResizeFinish, isEditable: isEditable, columnId: columnId, stickyState: stickyState, cellRef: cellRef, tableRole: tableRole, resizerRoleDescription: resizerRoleDescription, resizerTooltipText: resizerTooltipText, isExpandable: isExpandable, hasDynamicContent: hasDynamicContent, variant: variant, tableVariant: tableVariant }) {
    var _a;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('table');
    const sortable = !!column.sortingComparator || !!column.sortingField;
    const sorted = !!activeSortingColumn && (0, $18fb5778d4dc41bf$export$efa610630f9e181)(column, activeSortingColumn);
    const sortingStatus = (0, $18fb5778d4dc41bf$export$522d1547ed3f4c02)(sortable, sorted, !!sortingDescending, !!sortingDisabled);
    const handleClick = ()=>onClick({
            sortingColumn: column,
            isDescending: sorted ? !sortingDescending : false
        });
    // Elements with role="button" do not have the default behavior of <button>, where pressing
    // Enter or Space will trigger a click event. Therefore we need to add this ourselves.
    // The native <button> element cannot be used due to a misaligned implementation in Firefox:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=843003
    const handleKeyPress = ({ nativeEvent: e })=>{
        if (e.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter || e.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space) {
            e.preventDefault();
            handleClick();
        }
    };
    const headerId = (0, $013a2451794a45c0$exports.useUniqueId)('table-header-');
    const clickableHeaderRef = (0, $acw62.useRef)(null);
    const { tabIndex: clickableHeaderTabIndex } = (0, $013a2451794a45c0$exports.useSingleTabStopNavigation)(clickableHeaderRef, {
        tabIndex: tabIndex
    });
    const cellRefObject = (0, $acw62.useRef)(null);
    const cellRefCombined = (0, $013a2451794a45c0$exports.useMergeRefs)(cellRef, cellRefObject);
    // Keep sticky and non-sticky headers in sync for dynamic cell
    // content changes. This is only needed when:
    // - Column has dynamic content
    // - This is the non-sticky version of a sticky header (hidden === true)
    // - Columns are not resizable
    (0, $013a2451794a45c0$exports.useResizeObserver)(hasDynamicContent ? cellRefObject : ()=>null, (entry)=>{
        updateColumn(columnId, entry.borderBoxWidth);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ef31a059f47373a7$export$3d583f8f97f3b3a0), {
        resizableStyle: resizableStyle,
        cellRef: cellRefCombined,
        sortingStatus: sortingStatus,
        sortingDisabled: sortingDisabled,
        focusedComponent: focusedComponent,
        stuck: stuck,
        sticky: sticky,
        resizable: resizableColumns,
        hidden: hidden,
        stripedRows: stripedRows,
        colIndex: colIndex,
        columnId: columnId,
        stickyState: stickyState,
        tableRole: tableRole,
        variant: variant,
        tableVariant: tableVariant,
        ...sortingDisabled ? {} : (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            action: 'sort',
            detail: {
                position: `${colIndex + 1}`,
                columnId: column.id ? `${column.id}` : '',
                label: `.${(0, $6986397e11c49917$export$2e2bcd8739ae039)['header-cell-text']}`,
                sortingDescending: `${!sortingDescending}`
            }
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: clickableHeaderRef,
        "data-focus-id": `sorting-control-${String(columnId)}`,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-content'], {
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-fake-focus']]: focusedComponent === `sorting-control-${String(columnId)}`,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-content-expandable']]: isExpandable
        }),
        "aria-label": column.ariaLabel ? column.ariaLabel({
            sorted: sorted,
            descending: sorted && !!sortingDescending,
            disabled: !!sortingDisabled
        }) : undefined,
        ...sortingStatus && !sortingDisabled ? {
            onKeyPress: handleKeyPress,
            tabIndex: clickableHeaderTabIndex,
            role: 'button',
            onClick: handleClick
        } : {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-text'], (0, $6986397e11c49917$export$2e2bcd8739ae039)['header-cell-text'], wrapLines && (0, $93211f0fff30af11$export$2e2bcd8739ae039)['header-cell-text-wrap']),
        id: headerId
    }, column.header, isEditable ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $93211f0fff30af11$export$2e2bcd8739ae039)['edit-icon']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "edit",
        ariaLabel: i18n('columnDefinitions.editConfig.editIconAriaLabel', (_a = column.editConfig) === null || _a === void 0 ? void 0 : _a.editIconAriaLabel)
    })) : null), sortingStatus && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $93211f0fff30af11$export$2e2bcd8739ae039)['sorting-icon']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: (0, $18fb5778d4dc41bf$export$f3a117936eca5c61)(sortingStatus)
    }))), resizableColumns ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$48a76196cafe3b93), {
        tabIndex: tabIndex,
        focusId: `resize-control-${String(columnId)}`,
        showFocusRing: focusedComponent === `resize-control-${String(columnId)}`,
        onWidthUpdate: (newWidth)=>updateColumn(columnId, newWidth),
        onWidthUpdateCommit: onResizeFinish,
        ariaLabelledby: headerId,
        minWidth: typeof column.minWidth === 'string' ? parseInt(column.minWidth) : column.minWidth,
        roleDescription: i18n('ariaLabels.resizerRoleDescription', resizerRoleDescription),
        // TODO: Replace with this when strings are available
        // tooltipText={i18n('ariaLabels.resizerTooltipText', resizerTooltipText)}
        tooltipText: resizerTooltipText,
        isBorderless: variant === 'full-page' || variant === 'embedded' || variant === 'borderless'
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$2e0a83ec2e27ecbb), {
        className: (0, $93211f0fff30af11$export$2e2bcd8739ae039)['resize-divider']
    }));
}








const $bc555153bc24e36c$var$Thead = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ selectionType: selectionType, getSelectAllProps: getSelectAllProps, columnDefinitions: columnDefinitions, sortingColumn: sortingColumn, sortingDisabled: sortingDisabled, sortingDescending: sortingDescending, resizableColumns: resizableColumns, variant: variant, tableVariant: tableVariant, wrapLines: wrapLines, onFocusMove: onFocusMove, onSortingChange: onSortingChange, onResizeFinish: onResizeFinish, singleSelectionHeaderAriaLabel: singleSelectionHeaderAriaLabel, stripedRows: stripedRows, sticky: sticky = false, hidden: hidden = false, stuck: stuck = false, stickyState: stickyState, selectionColumnId: selectionColumnId, focusedComponent: focusedComponent, onFocusedComponentChange: onFocusedComponentChange, tableRole: tableRole, resizerRoleDescription: resizerRoleDescription, resizerTooltipText: resizerTooltipText, isExpandable: isExpandable, setLastUserAction: setLastUserAction }, outerRef)=>{
    const { getColumnStyles: getColumnStyles, columnWidths: columnWidths, updateColumn: updateColumn, setCell: setCell } = (0, $52cd48af6d6570d7$export$d598237875812773)();
    const commonCellProps = {
        stuck: stuck,
        sticky: sticky,
        hidden: hidden,
        stripedRows: stripedRows,
        tableRole: tableRole,
        variant: variant,
        tableVariant: tableVariant,
        stickyState: stickyState
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(!hidden && (0, $7ded81c543f72294$export$2e2bcd8739ae039)['thead-active'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        ...(0, $30c09cf06b060b34$export$abdbebe48aa0774a).all,
        ref: outerRef,
        "aria-rowindex": 1,
        ...(0, $4724080100e81846$export$db8fc6d3575bc25b)({
            tableRole: tableRole
        }),
        onFocus: (event)=>{
            var _a;
            const focusControlElement = (0, $1yiQH.findUpUntil)(event.target, (element)=>!!element.getAttribute('data-focus-id'));
            const focusId = (_a = focusControlElement === null || focusControlElement === void 0 ? void 0 : focusControlElement.getAttribute('data-focus-id')) !== null && _a !== void 0 ? _a : null;
            onFocusedComponentChange === null || onFocusedComponentChange === void 0 || onFocusedComponentChange(focusId);
        },
        onBlur: ()=>onFocusedComponentChange === null || onFocusedComponentChange === void 0 ? void 0 : onFocusedComponentChange(null)
    }, selectionType ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $36873d47a98b41e9$export$e50b671e877efb71), {
        ...commonCellProps,
        focusedComponent: focusedComponent,
        columnId: selectionColumnId,
        getSelectAllProps: getSelectAllProps,
        onFocusMove: onFocusMove,
        singleSelectionHeaderAriaLabel: singleSelectionHeaderAriaLabel
    }) : null, columnDefinitions.map((column, colIndex)=>{
        const columnId = (0, $d5e9c22659308d3d$export$480219a02f196e72)(column, colIndex);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $09ac39531d24690e$export$9e1517a3035b3e5c), {
            ...commonCellProps,
            key: columnId,
            tabIndex: sticky ? -1 : 0,
            focusedComponent: focusedComponent,
            column: column,
            activeSortingColumn: sortingColumn,
            sortingDescending: sortingDescending,
            sortingDisabled: sortingDisabled,
            wrapLines: wrapLines,
            colIndex: selectionType ? colIndex + 1 : colIndex,
            columnId: columnId,
            updateColumn: updateColumn,
            onResizeFinish: ()=>onResizeFinish(columnWidths),
            resizableColumns: resizableColumns,
            resizableStyle: getColumnStyles(sticky, columnId),
            onClick: (detail)=>{
                setLastUserAction('sorting');
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSortingChange, detail);
            },
            isEditable: !!column.editConfig,
            cellRef: (node)=>setCell(sticky, columnId, node),
            tableRole: tableRole,
            resizerRoleDescription: resizerRoleDescription,
            resizerTooltipText: resizerTooltipText,
            // Expandable option is only applicable to the first data column of the table.
            // When present, the header content receives extra padding to match the first offset in the data cells.
            isExpandable: colIndex === 0 && isExpandable,
            hasDynamicContent: hidden && !resizableColumns && column.hasDynamicContent
        });
    })));
});
var $bc555153bc24e36c$export$2e2bcd8739ae039 = $bc555153bc24e36c$var$Thead;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $1280f926f00da4a8$export$2e2bcd8739ae039(containerRef, stickyRef) {
    const scrollToTop = ()=>{
        if (!containerRef.current || !stickyRef.current) return;
        const scrollingOffset = $1280f926f00da4a8$export$b68f12a4d6ccd788(containerRef.current, stickyRef.current);
        if (scrollingOffset > 0) $1280f926f00da4a8$export$a6850f124f5f264e(scrollingOffset, containerRef.current);
    };
    const scrollToItem = (item)=>{
        if (!item || !containerRef.current || !stickyRef.current) return;
        const stickyBottom = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(stickyRef.current).insetBlockEnd;
        const scrollingOffset = stickyBottom - (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(item).insetBlockStart;
        if (scrollingOffset > 0) $1280f926f00da4a8$export$a6850f124f5f264e(scrollingOffset, containerRef.current);
    };
    return {
        scrollToTop: scrollToTop,
        scrollToItem: scrollToItem
    };
}
function $1280f926f00da4a8$export$b68f12a4d6ccd788(container, sticky) {
    const stickyRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(sticky);
    const containerRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(container);
    return stickyRect.insetBlockStart - containerRect.insetBlockStart;
}
function $1280f926f00da4a8$export$a6850f124f5f264e(amount, container) {
    const parent = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(container);
    if (parent.length) // Take next overflow parent in stack
    parent[0].scrollTop -= amount;
    else window.scrollTo({
        top: window.pageYOffset - amount
    });
}


const $45b5dd6b7dd5660c$export$3a5ae2edeb8648ad = (tableRef, theadRef, secondaryTheadRef, secondaryTableRef, tableWrapperRef)=>{
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    // Sync the sizes of the column header copies in the sticky header with the originals
    const syncColumnHeaderWidths = (0, $acw62.useCallback)(()=>{
        if (tableRef.current && theadRef.current && secondaryTheadRef.current && secondaryTableRef.current && tableWrapperRef.current) tableWrapperRef.current.style.marginBlockStart = `-${theadRef.current.getBoundingClientRect().height}px`;
    }, [
        theadRef,
        secondaryTheadRef,
        secondaryTableRef,
        tableWrapperRef,
        tableRef
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        syncColumnHeaderWidths();
    });
    (0, $013a2451794a45c0$exports.useResizeObserver)(theadRef, syncColumnHeaderWidths);
    const scrollToTop = ()=>{
        if (!isMobile && theadRef.current && secondaryTheadRef.current && tableWrapperRef.current) {
            const scrollDist = (0, $1280f926f00da4a8$export$b68f12a4d6ccd788)(theadRef.current, secondaryTheadRef.current);
            if (scrollDist > 0) (0, $1280f926f00da4a8$export$a6850f124f5f264e)(scrollDist, tableWrapperRef.current);
        }
    };
    const { scrollToItem: scrollToItem } = (0, $1280f926f00da4a8$export$2e2bcd8739ae039)(tableWrapperRef, secondaryTheadRef);
    const scrollToRow = (itemNode)=>{
        if (!isMobile) scrollToItem(itemNode);
    };
    return {
        scrollToRow: scrollToRow,
        scrollToTop: scrollToTop
    };
};



var $9c441436201ecd93$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($9c441436201ecd93$var$StickyHeader);
function $9c441436201ecd93$var$StickyHeader({ variant: variant, theadProps: theadProps, wrapperRef: wrapperRef, theadRef: theadRef, secondaryWrapperRef: secondaryWrapperRef, onScroll: onScroll, tableRef: tableRef, tableHasHeader: tableHasHeader, contentDensity: contentDensity, tableRole: tableRole }, ref) {
    const secondaryTheadRef = (0, $acw62.useRef)(null);
    const secondaryTableRef = (0, $acw62.useRef)(null);
    const { isStuck: isStuck } = (0, $acw62.useContext)((0, $6ffd179a45e998fe$export$277266c55937e104));
    const [focusedComponent, setFocusedComponent] = (0, $acw62.useState)(null);
    const { scrollToRow: scrollToRow, scrollToTop: scrollToTop } = (0, $45b5dd6b7dd5660c$export$3a5ae2edeb8648ad)(tableRef, theadRef, secondaryTheadRef, secondaryTableRef, wrapperRef);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            scrollToTop: scrollToTop,
            scrollToRow: scrollToRow,
            setFocus: setFocusedComponent
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)['header-secondary'], (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $7ded81c543f72294$export$2e2bcd8739ae039)['table-has-header']]: tableHasHeader
        }),
        "aria-hidden": true,
        // Prevents receiving focus in Firefox. Focus on the overflowing table is sufficient
        // to scroll the table horizontally
        tabIndex: -1,
        ref: secondaryWrapperRef,
        onScroll: onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).table, (0, $7ded81c543f72294$export$2e2bcd8739ae039)['table-layout-fixed'], contentDensity === 'compact' && (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)('compact-table')),
        ref: secondaryTableRef,
        ...(0, $4724080100e81846$export$2c3bcd6eb50948d4)({
            tableRole: tableRole
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc555153bc24e36c$export$2e2bcd8739ae039), {
        ref: secondaryTheadRef,
        sticky: true,
        stuck: isStuck,
        focusedComponent: focusedComponent,
        ...theadProps
    })));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $41cfe434a59dd8a5$export$2e2bcd8739ae039 = {
    "sticky-scrollbar": "awsui_sticky-scrollbar_faqt8_105xs_181",
    "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_faqt8_105xs_193",
    "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_faqt8_105xs_196",
    "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_faqt8_105xs_199",
    "sticky-scrollbar-offset": "awsui_sticky-scrollbar-offset_faqt8_105xs_202",
    "is-visual-refresh": "awsui_is-visual-refresh_faqt8_105xs_205"
};


const $460a10c54a45b519$export$96612fa32333e1ce = (tableEl, wrapperEl, scrollbarEl, scrollbarContentEl, inScrollableContainer)=>{
    if (!tableEl || !scrollbarEl || !wrapperEl) return;
    const { inlineSize: tableInlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(tableEl);
    const { inlineSize: wrapperInlineSize } = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(wrapperEl);
    // using 15 px as a height of transparent scrollbar on mac
    const scrollbarHeight = (0, $7b99d3a86137a2e2$export$bbb9ce125c89ccb4)().height;
    const areaIsScrollable = tableInlineSize > wrapperInlineSize;
    if (!areaIsScrollable) scrollbarEl.classList.remove((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['sticky-scrollbar-visible']);
    else {
        // when scrollbar is not displayed scrollLeft property cannot be set by useScrollSync
        // that's why syncing it separately
        if (!scrollbarEl.classList.contains((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['sticky-scrollbar-visible'])) requestAnimationFrame(()=>{
            scrollbarEl.scrollLeft = wrapperEl.scrollLeft;
        });
        scrollbarEl.classList.add((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['sticky-scrollbar-visible']);
        if (!scrollbarHeight) /* istanbul ignore next: covered by screenshot tests */ scrollbarEl.classList.add((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['sticky-scrollbar-native-invisible']);
    }
    if (scrollbarHeight && scrollbarEl && scrollbarContentEl) {
        scrollbarEl.style.blockSize = `${scrollbarHeight}px`;
        scrollbarContentEl.style.blockSize = `${scrollbarHeight}px`;
    }
    if (tableEl && wrapperEl && scrollbarContentEl && scrollbarEl) {
        const wrapperElRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(wrapperEl);
        const tableElRect = (0, $013a2451794a45c0$exports.getLogicalBoundingClientRect)(tableEl);
        scrollbarEl.style.inlineSize = `${wrapperElRect.inlineSize}px`;
        scrollbarContentEl.style.inlineSize = `${tableElRect.inlineSize}px`;
        // when using sticky scrollbars in containers
        // we agreed to ignore dynamic bottom calculations for footer overlap
        scrollbarEl.style.insetBlockEnd = inScrollableContainer ? '0px' : `var(${(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset}, 0px)`;
    }
};
function $460a10c54a45b519$export$43d929acaaebf31b(scrollbarRef, scrollbarContentRef, tableRef, wrapperRef, offsetScrollbar) {
    const [inScrollableContainer, setInScrollableContainer] = (0, $acw62.useState)(false);
    const wrapperEl = wrapperRef.current;
    (0, $acw62.useEffect)(()=>{
        if (wrapperEl) setInScrollableContainer(!!(0, $38f6480185c49d6f$export$940d8225183e1404)(wrapperEl) || !!(0, $24d40242cc6554ee$export$f32edd573b1049e6)(wrapperEl)[0]);
    }, [
        wrapperEl
    ]);
    // Update scrollbar position wrapper or table size change.
    (0, $acw62.useEffect)(()=>{
        if (wrapperRef.current && tableRef.current && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>{
                if (scrollbarContentRef.current) $460a10c54a45b519$export$96612fa32333e1ce(tableRef.current, wrapperRef.current, scrollbarRef.current, scrollbarContentRef.current, inScrollableContainer);
            });
            // Scrollbar width must be in sync with wrapper width.
            observer.observe(wrapperRef.current);
            // Scrollbar content width must be in sync with table width.
            observer.observe(tableRef.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        scrollbarContentRef,
        scrollbarRef,
        tableRef,
        wrapperRef,
        inScrollableContainer,
        offsetScrollbar
    ]);
    // Update scrollbar position when window resizes (vertically).
    (0, $acw62.useEffect)(()=>{
        const resizeHandler = ()=>{
            $460a10c54a45b519$export$96612fa32333e1ce(tableRef.current, wrapperRef.current, scrollbarRef.current, scrollbarContentRef.current, inScrollableContainer);
        };
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        return ()=>{
            window.removeEventListener('resize', resizeHandler);
        };
    }, [
        tableRef,
        wrapperRef,
        scrollbarRef,
        scrollbarContentRef,
        inScrollableContainer
    ]);
}



var $33348950bdbf3017$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($33348950bdbf3017$var$StickyScrollbar);
function $33348950bdbf3017$var$StickyScrollbar({ wrapperRef: wrapperRef, tableRef: tableRef, onScroll: onScroll, hasStickyColumns: hasStickyColumns }, ref) {
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const scrollbarRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollbarContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(ref, scrollbarRef);
    /**
     * If the height of the scrollbar is 0, we're likely on a platform that uses
     * overlay scrollbars (e.g. Mac).
     */ const offsetScrollbar = hasStickyColumns || (0, $7b99d3a86137a2e2$export$bbb9ce125c89ccb4)().height === 0;
    (0, $460a10c54a45b519$export$43d929acaaebf31b)(scrollbarRef, scrollbarContentRef, tableRef, wrapperRef, offsetScrollbar);
    const { ref: stickyDetectionRef, isIntersecting: isStickyDetectionVisible } = (0, $cff975c73fa800c5$export$a7395f9832c00176)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: mergedRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['sticky-scrollbar'], offsetScrollbar && (0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['sticky-scrollbar-offset'], isVisualRefresh && (0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['is-visual-refresh']),
        onScroll: onScroll,
        "data-stuck": !isStickyDetectionVisible
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: scrollbarContentRef,
        className: (0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)['sticky-scrollbar-content']
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: stickyDetectionRef,
        style: {
            position: 'absolute',
            right: 0,
            bottom: 0,
            left: 0,
            height: 1
        }
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f202ce2250b275ba$export$2ec2f91e4944ad3b(element) {
    return element.closest('td,th');
}
function $f202ce2250b275ba$export$a7ebbc3bdaf3b563(element) {
    if (element instanceof HTMLInputElement || element instanceof HTMLButtonElement) return element.disabled;
    return false;
}
function $f202ce2250b275ba$export$4a2080a003dc3d35(target) {
    let current = target;
    while(current){
        // Stop checking for parents upon reaching the cell element as the function only aims at the cell content.
        if ($f202ce2250b275ba$export$3db443afc312b993(current)) return false;
        if (current.getAttribute('role') === 'dialog' || current.getAttribute('data-awsui-table-suppress-navigation') === 'true') return true;
        current = current.parentElement;
    }
    return false;
}
function $f202ce2250b275ba$export$feb0f5cc536d2180(table, targetAriaRowIndex, delta) {
    var _a, _b;
    let targetRow = null;
    const rowElements = Array.from((_a = table === null || table === void 0 ? void 0 : table.querySelectorAll('tr[aria-rowindex]')) !== null && _a !== void 0 ? _a : []);
    if (delta < 0) rowElements.reverse();
    for (const element of rowElements){
        const rowIndex = parseInt((_b = element.getAttribute('aria-rowindex')) !== null && _b !== void 0 ? _b : '');
        targetRow = element;
        if (rowIndex === targetAriaRowIndex) break;
        if (delta >= 0 && rowIndex > targetAriaRowIndex) break;
        if (delta < 0 && rowIndex < targetAriaRowIndex) break;
    }
    return targetRow;
}
function $f202ce2250b275ba$export$cc5f55dc4367642c(tableRow, targetAriaColIndex, delta) {
    var _a;
    let targetCell = null;
    const cellElements = Array.from(tableRow.querySelectorAll('td[aria-colindex],th[aria-colindex]'));
    if (delta < 0) cellElements.reverse();
    for (const element of cellElements){
        const columnIndex = parseInt((_a = element.getAttribute('aria-colindex')) !== null && _a !== void 0 ? _a : '');
        targetCell = element;
        if (columnIndex === targetAriaColIndex) break;
        if (delta >= 0 && columnIndex > targetAriaColIndex) break;
        if (delta < 0 && columnIndex < targetAriaColIndex) break;
    }
    return targetCell;
}
function $f202ce2250b275ba$export$3db443afc312b993(element) {
    return element.tagName === 'TD' || element.tagName === 'TH';
}
function $f202ce2250b275ba$export$3b0237e8566c8d65(element) {
    if (element) {
        // Table cells are not focusable by default (tabIndex=undefined) so cell.focus() is ignored.
        // To force focusing we have to imperatively set tabIndex to -1. This tabIndex is then to be
        // overridden by the single tab stop context to be 0 or undefined.
        // We cannot make cells have tabIndex=-1 by default due to an associated bug with text selection, see: PR 2158.
        if ($f202ce2250b275ba$export$3db443afc312b993(element) && element.tabIndex !== 0) element.tabIndex = -1;
        element.focus();
    }
}


function $4fddcc6aec92a0ef$export$15a0a58a360b70b4({ keyboardNavigation: keyboardNavigation, pageSize: pageSize, getTable: getTable, children: children }) {
    const navigationAPI = (0, $acw62.useRef)(null);
    const gridNavigation = (0, $acw62.useMemo)(()=>new $4fddcc6aec92a0ef$export$a1748a80e2ed0c40(navigationAPI), []);
    const getTableStable = (0, $013a2451794a45c0$exports.useStableCallback)(getTable);
    // Initialize the processor with the table container assuming it is mounted synchronously and only once.
    (0, $acw62.useEffect)(()=>{
        if (keyboardNavigation) {
            const table = getTableStable();
            if (table) {
                gridNavigation.init(table);
                return gridNavigation.cleanup;
            }
        }
    }, [
        keyboardNavigation,
        gridNavigation,
        getTableStable
    ]);
    // Notify the processor of the props change.
    (0, $acw62.useEffect)(()=>{
        gridNavigation.update({
            pageSize: pageSize
        });
    }, [
        gridNavigation,
        pageSize
    ]);
    // Notify the processor of the new render.
    (0, $acw62.useEffect)(()=>{
        if (keyboardNavigation) gridNavigation.refresh();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013a2451794a45c0$exports.SingleTabStopNavigationProvider), {
        ref: navigationAPI,
        navigationActive: keyboardNavigation,
        getNextFocusTarget: gridNavigation.getNextFocusTarget,
        isElementSuppressed: gridNavigation.isElementSuppressed,
        onRegisterFocusable: gridNavigation.onRegisterFocusable,
        onUnregisterActive: gridNavigation.onUnregisterActive
    }, children);
}
class $4fddcc6aec92a0ef$export$a1748a80e2ed0c40 {
    constructor(navigationAPI){
        // Props
        this._pageSize = 0;
        this._table = null;
        // State
        this.focusedCell = null;
        this.focusInside = false;
        this.keepUserIndex = false;
        this.cleanup = ()=>{
        // Do nothing before initialized.
        };
        this.onRegisterFocusable = (focusableElement)=>{
            var _a;
            if (!this.focusInside) return;
            // When newly registered element belongs to the focused cell the focus must transition to it.
            const focusedElement = (_a = this.focusedCell) === null || _a === void 0 ? void 0 : _a.element;
            if (focusedElement && (0, $f202ce2250b275ba$export$3db443afc312b993)(focusedElement) && focusedElement.contains(focusableElement)) // Scroll is unnecessary when moving focus from a cell to element within the cell.
            focusableElement.focus({
                preventScroll: true
            });
        };
        this.onUnregisterActive = ()=>{
            // If the focused cell appears to be no longer attached to the table we need to re-apply
            // focus to a cell with the same or closest position.
            if (this.focusedCell && !(0, $4c778684f125e678$export$57d4cb221e1d1857)(this.table, this.focusedCell.element)) this.moveFocusBy(this.focusedCell, {
                x: 0,
                y: 0
            });
        };
        this.getNextFocusTarget = ()=>{
            var _a;
            if (!this.table) return null;
            const cell = this.focusedCell;
            const firstTableCell = this.table.querySelector('td,th');
            // A single element of the table is made user-focusable.
            // It defaults to the first interactive element of the first cell or the first cell itself otherwise.
            let focusTarget = (_a = firstTableCell && this.getFocusablesFrom(firstTableCell)[0]) !== null && _a !== void 0 ? _a : firstTableCell;
            // When a navigation-focused element is present in the table it is used for user-navigation instead.
            if (cell) focusTarget = this.getNextFocusable(cell, {
                x: 0,
                y: 0
            });
            return focusTarget;
        };
        this.isElementSuppressed = (element)=>{
            // Omit calculation as irrelevant until the table receives focus.
            if (!this.focusedCell) return false;
            return !element || (0, $f202ce2250b275ba$export$4a2080a003dc3d35)(element);
        };
        this.onFocusin = (event)=>{
            var _a;
            this.focusInside = true;
            if (!(event.target instanceof HTMLElement)) return;
            this.updateFocusedCell(event.target);
            if (!this.focusedCell) return;
            (_a = this._navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
            // Focusing on cell is not eligible when it contains focusable elements in the content.
            // If content focusables are available - move the focus to the first one.
            const focusedElement = this.focusedCell.element;
            const nextTarget = (0, $f202ce2250b275ba$export$3db443afc312b993)(focusedElement) ? this.getFocusablesFrom(focusedElement)[0] : null;
            if (nextTarget) // Scroll is unnecessary when moving focus from a cell to element within the cell.
            nextTarget.focus({
                preventScroll: true
            });
            else this.keepUserIndex = false;
        };
        this.onFocusout = ()=>{
            this.focusInside = false;
        };
        this.onKeydown = (event)=>{
            if (!this.focusedCell) return;
            const keys = [
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageUp,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageDown,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end
            ];
            const ctrlKey = event.ctrlKey ? 1 : 0;
            const altKey = event.altKey ? 1 : 0;
            const shiftKey = event.shiftKey ? 1 : 0;
            const metaKey = event.metaKey ? 1 : 0;
            const modifiersPressed = ctrlKey + altKey + shiftKey + metaKey;
            const invalidModifierCombination = modifiersPressed && !event.ctrlKey || event.ctrlKey && event.keyCode !== (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home && event.keyCode !== (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end;
            if (invalidModifierCombination || this.isElementSuppressed(document.activeElement) || !this.isRegistered(document.activeElement) || keys.indexOf(event.keyCode) === -1) return;
            const from = this.focusedCell;
            event.preventDefault();
            if ((0, $d790fc2d8f354fdb$export$f11fd8c04cad088d)(event)) (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
                onBlockStart: ()=>this.moveFocusBy(from, {
                        y: -1,
                        x: 0
                    }),
                onBlockEnd: ()=>this.moveFocusBy(from, {
                        y: 1,
                        x: 0
                    }),
                onInlineStart: ()=>this.moveFocusBy(from, {
                        y: 0,
                        x: -1
                    }),
                onInlineEnd: ()=>this.moveFocusBy(from, {
                        y: 0,
                        x: 1
                    }),
                onPageUp: ()=>this.moveFocusBy(from, {
                        y: -this.pageSize,
                        x: 0
                    }),
                onPageDown: ()=>this.moveFocusBy(from, {
                        y: this.pageSize,
                        x: 0
                    }),
                onHome: ()=>event.ctrlKey ? this.moveFocusBy(from, {
                        y: -Infinity,
                        x: -Infinity
                    }) : this.moveFocusBy(from, {
                        y: 0,
                        x: -Infinity
                    }),
                onEnd: ()=>event.ctrlKey ? this.moveFocusBy(from, {
                        y: Infinity,
                        x: Infinity
                    }) : this.moveFocusBy(from, {
                        y: 0,
                        x: Infinity
                    })
            });
        };
        this._navigationAPI = navigationAPI;
    }
    init(table) {
        this._table = table;
        const controller = new AbortController();
        table.addEventListener('focusin', this.onFocusin, {
            signal: controller.signal
        });
        table.addEventListener('focusout', this.onFocusout, {
            signal: controller.signal
        });
        table.addEventListener('keydown', this.onKeydown, {
            signal: controller.signal
        });
        this.cleanup = ()=>{
            controller.abort();
        };
    }
    update({ pageSize: pageSize }) {
        this._pageSize = pageSize;
    }
    refresh() {
        // Timeout ensures the newly rendered content elements are registered.
        setTimeout(()=>{
            var _a, _b;
            if (this._table) {
                // Update focused cell indices in case table rows, columns, or firstIndex change.
                this.updateFocusedCell((_a = this.focusedCell) === null || _a === void 0 ? void 0 : _a.element);
                (_b = this._navigationAPI.current) === null || _b === void 0 || _b.updateFocusTarget();
            }
        }, 0);
    }
    get pageSize() {
        return this._pageSize;
    }
    get table() {
        return this._table;
    }
    moveFocusBy(cell, delta) {
        // For vertical moves preserve column- and element indices set by user.
        // It allows keeping indices while moving over disabled actions or cells with colspan > 1.
        if (delta.y !== 0 && delta.x === 0) this.keepUserIndex = true;
        (0, $f202ce2250b275ba$export$3b0237e8566c8d65)(this.getNextFocusable(cell, delta));
    }
    isRegistered(element) {
        var _a, _b;
        return !element || ((_b = (_a = this._navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(element)) !== null && _b !== void 0 ? _b : false);
    }
    updateFocusedCell(focusedElement) {
        var _a, _b, _c, _d, _e, _f;
        if (!focusedElement) return;
        const cellElement = (0, $f202ce2250b275ba$export$2ec2f91e4944ad3b)(focusedElement);
        const rowElement = cellElement === null || cellElement === void 0 ? void 0 : cellElement.closest('tr');
        if (!cellElement || !rowElement) return;
        const colIndex = parseInt((_a = cellElement.getAttribute('aria-colindex')) !== null && _a !== void 0 ? _a : '');
        const rowIndex = parseInt((_b = rowElement.getAttribute('aria-rowindex')) !== null && _b !== void 0 ? _b : '');
        if (isNaN(colIndex) || isNaN(rowIndex)) return;
        const cellFocusables = this.getFocusablesFrom(cellElement);
        const elementIndex = cellFocusables.indexOf(focusedElement);
        const prevColIndex = (_d = (_c = this.focusedCell) === null || _c === void 0 ? void 0 : _c.colIndex) !== null && _d !== void 0 ? _d : -1;
        const prevElementIndex = (_f = (_e = this.focusedCell) === null || _e === void 0 ? void 0 : _e.elementIndex) !== null && _f !== void 0 ? _f : -1;
        this.focusedCell = {
            rowIndex: rowIndex,
            colIndex: this.keepUserIndex && prevColIndex !== -1 ? prevColIndex : colIndex,
            elementIndex: this.keepUserIndex && prevElementIndex !== -1 ? prevElementIndex : elementIndex,
            element: focusedElement
        };
    }
    getNextFocusable(from, delta) {
        var _a;
        // Find next row to move focus into (can be null if the top/bottom is reached).
        const targetAriaRowIndex = from.rowIndex + delta.y;
        const targetRow = (0, $f202ce2250b275ba$export$feb0f5cc536d2180)(this.table, targetAriaRowIndex, delta.y);
        if (!targetRow) return null;
        // Return next interactive cell content element if available.
        const cellElement = (0, $f202ce2250b275ba$export$2ec2f91e4944ad3b)(from.element);
        const cellFocusables = cellElement ? this.getFocusablesFrom(cellElement) : [];
        const nextElementIndex = from.elementIndex + delta.x;
        const isValidDirection = !!delta.x;
        const isValidIndex = from.elementIndex !== -1 && 0 <= nextElementIndex && nextElementIndex < cellFocusables.length;
        const isTargetDifferent = from.element !== cellFocusables[nextElementIndex];
        if (isValidDirection && isValidIndex && isTargetDifferent) return cellFocusables[nextElementIndex];
        // Find next cell to focus or move focus into (can be null if the left/right edge is reached).
        const targetAriaColIndex = from.colIndex + delta.x;
        const targetCell = (0, $f202ce2250b275ba$export$cc5f55dc4367642c)(targetRow, targetAriaColIndex, delta.x);
        if (!targetCell) return null;
        // When target cell matches the current cell it means we reached the left or right boundary.
        if (targetCell === cellElement && delta.x !== 0) return null;
        const targetCellFocusables = this.getFocusablesFrom(targetCell);
        // When delta.x = 0 keep element index if possible.
        let focusIndex = from.elementIndex;
        // Use first element index when moving to the right or to extreme left.
        if (isFinite(delta.x) && delta.x > 0 || delta.x === -Infinity) focusIndex = 0;
        // Use last element index when moving to the left or to extreme right.
        if (isFinite(delta.x) && delta.x < 0 || delta.x === Infinity) focusIndex = targetCellFocusables.length - 1;
        return (_a = targetCellFocusables[focusIndex]) !== null && _a !== void 0 ? _a : targetCell;
    }
    getFocusablesFrom(target) {
        const isElementRegistered = (element)=>{
            var _a;
            return (_a = this._navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(element);
        };
        return (0, $eaddf2de854ee801$export$3fcce23e1e72b35b)(target).filter((el)=>isElementRegistered(el) && !(0, $f202ce2250b275ba$export$a7ebbc3bdaf3b563)(el));
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $d7e99db5d46311b5$export$2e2bcd8739ae039({ header: header, filter: filter, pagination: pagination, preferences: preferences, setLastUserAction: setLastUserAction }) {
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        'xs'
    ]);
    const isHeaderString = typeof header === 'string';
    const assignHeaderId = (0, $acw62.useContext)((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314)).assignId;
    const headingId = (0, $013a2451794a45c0$exports.useUniqueId)('heading');
    if (assignHeaderId !== undefined && isHeaderString) assignHeaderId(headingId);
    const isSmall = breakpoint === 'default';
    const hasTools = filter || pagination || preferences;
    const hasRightAlignedTools = !!(pagination || preferences);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isHeaderString ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headingId
    }, header) : header, hasTools && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).tools, isSmall && (0, $7ded81c543f72294$export$2e2bcd8739ae039)['tools-small'])
    }, filter && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['tools-filtering'],
        onClickCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction('filter'),
        onKeyDownCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction('filter')
    }, filter), hasRightAlignedTools && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['tools-align-right']
    }, pagination && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['tools-pagination'],
        onClickCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction('pagination')
    }, pagination), preferences && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['tools-preferences'],
        onClickCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction('preferences')
    }, preferences))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $85269665d4ad8536$export$91b87deb855561fe({ onCancel: onCancel, onSubmit: onSubmit }) {
    const [currentEditCell, setCurrentEditCell] = (0, $acw62.useState)(null);
    const [lastSuccessfulEditCell, setLastSuccessfulEditCell] = (0, $acw62.useState)(null);
    const [currentEditLoading, setCurrentEditLoading] = (0, $acw62.useState)(false);
    const startEdit = (cellId)=>{
        setLastSuccessfulEditCell(null);
        setCurrentEditCell(cellId);
    };
    const cancelEdit = (0, $acw62.useCallback)(()=>setCurrentEditCell(null), []);
    const completeEdit = (cellId, editCancelled)=>{
        const eventCancelled = (0, $fc537b925f715587$export$d7e1721720edbb03)(onCancel, {});
        if (!eventCancelled) {
            setCurrentEditCell(null);
            if (!editCancelled) setLastSuccessfulEditCell(cellId);
        }
    };
    const checkEditing = ({ row: row, col: col })=>row === (currentEditCell === null || currentEditCell === void 0 ? void 0 : currentEditCell.row) && col === currentEditCell.col;
    const checkLastSuccessfulEdit = ({ row: row, col: col })=>row === (lastSuccessfulEditCell === null || lastSuccessfulEditCell === void 0 ? void 0 : lastSuccessfulEditCell.row) && col === lastSuccessfulEditCell.col;
    const submitEdit = onSubmit ? async (...args)=>{
        setCurrentEditLoading(true);
        try {
            await onSubmit(...args);
        } finally{
            setCurrentEditLoading(false);
        }
    } : undefined;
    return {
        isLoading: currentEditLoading,
        startEdit: startEdit,
        cancelEdit: cancelEdit,
        checkEditing: checkEditing,
        checkLastSuccessfulEdit: checkLastSuccessfulEdit,
        completeEdit: completeEdit,
        submitEdit: submitEdit
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $bfb38fe7bcb6a793$var$_ScrollLock_timeoutId, $bfb38fe7bcb6a793$var$_ScrollLock_scrollLeft, $bfb38fe7bcb6a793$var$_ScrollLock_active;
const $bfb38fe7bcb6a793$var$stickyCellSelector = `.${(0, $072f869ecd5e8de2$export$2e2bcd8739ae039)['sticky-cell']}`;
// The scroll lock timeout value was determined empirically.
// It is small enough to not interfere with sequential user events, and long enough
// to ensure the browser-triggered scroll event occurs.
const $bfb38fe7bcb6a793$var$scrollLockTimeout = 50;
function $bfb38fe7bcb6a793$export$39cc7e9b3a376870(wrapperRefObject) {
    (0, $acw62.useEffect)(()=>{
        if (wrapperRefObject.current) {
            const wrapperEl = wrapperRefObject.current;
            const scrollLock = new $bfb38fe7bcb6a793$var$ScrollLock();
            // For click events inside sticky cells we capture the table wrapper scroll offset.
            // This is used to reset the browser-enforced scrolling that is to follow.
            // The scroll lock is automatically cleared after a short delay.
            const onClick = (event)=>{
                if (event.target && event.target instanceof HTMLElement && (event.target.matches($bfb38fe7bcb6a793$var$stickyCellSelector) || event.target.closest($bfb38fe7bcb6a793$var$stickyCellSelector))) scrollLock.set(wrapperEl.scrollLeft);
            };
            wrapperEl.addEventListener('click', onClick);
            // We cannot prevent the browser-issued scroll events from happening, and cannot cancel the default behavior.
            // Instead, if we detect a scroll event that immediately follows a click inside a sticky cell, we negate the
            // effect of it by resetting the wrapper scroll offset to its previous value.
            const onScroll = ()=>{
                if (scrollLock.active) {
                    wrapperEl.scrollLeft = scrollLock.scrollLeft;
                    scrollLock.clear();
                }
            };
            wrapperEl.addEventListener('scroll', onScroll);
            return ()=>{
                wrapperEl.removeEventListener('click', onClick);
                wrapperEl.removeEventListener('scroll', onScroll);
            };
        }
    }, [
        wrapperRefObject
    ]);
}
class $bfb38fe7bcb6a793$var$ScrollLock {
    constructor(){
        $bfb38fe7bcb6a793$var$_ScrollLock_timeoutId.set(this, setTimeout(()=>{}, 0));
        $bfb38fe7bcb6a793$var$_ScrollLock_scrollLeft.set(this, 0);
        $bfb38fe7bcb6a793$var$_ScrollLock_active.set(this, false);
    }
    set(scrollLeft) {
        if (!(0, $7WQrb.__classPrivateFieldGet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_active, "f")) {
            (0, $7WQrb.__classPrivateFieldSet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_active, true, "f");
            (0, $7WQrb.__classPrivateFieldSet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_scrollLeft, scrollLeft, "f");
            (0, $7WQrb.__classPrivateFieldSet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_timeoutId, setTimeout(()=>(0, $7WQrb.__classPrivateFieldSet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_active, false, "f"), $bfb38fe7bcb6a793$var$scrollLockTimeout), "f");
        }
    }
    clear() {
        (0, $7WQrb.__classPrivateFieldSet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_active, false, "f");
        clearTimeout((0, $7WQrb.__classPrivateFieldGet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_timeoutId, "f"));
    }
    get active() {
        return (0, $7WQrb.__classPrivateFieldGet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_active, "f");
    }
    get scrollLeft() {
        return (0, $7WQrb.__classPrivateFieldGet)(this, $bfb38fe7bcb6a793$var$_ScrollLock_scrollLeft, "f");
    }
}
$bfb38fe7bcb6a793$var$_ScrollLock_timeoutId = new WeakMap(), $bfb38fe7bcb6a793$var$_ScrollLock_scrollLeft = new WeakMap(), $bfb38fe7bcb6a793$var$_ScrollLock_active = new WeakMap();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1yiQH = parcelRequire("1yiQH");


function $28a501d6671417e8$export$48c69dbc46986321({ onRowClick: onRowClick, onRowContextMenu: onRowContextMenu }) {
    const onRowClickHandler = (rowIndex, item, event)=>{
        const tableCell = (0, $1yiQH.findUpUntil)(event.target, (element)=>element.tagName.toLowerCase() === 'td');
        if (!tableCell || !tableCell.classList.contains((0, $7ded81c543f72294$export$2e2bcd8739ae039)['selection-control'])) {
            const details = {
                rowIndex: rowIndex,
                item: item
            };
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onRowClick, details);
        }
    };
    const onRowContextMenuHandler = (rowIndex, item, event)=>{
        const details = {
            rowIndex: rowIndex,
            item: item,
            clientX: event.clientX,
            clientY: event.clientY
        };
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onRowContextMenu, details, event);
    };
    return {
        onRowClickHandler: onRowClick && onRowClickHandler,
        onRowContextMenuHandler: onRowContextMenu && onRowContextMenuHandler
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $9c34ca8192fcd717$var$iterateTableCells(table, func) {
    table.querySelectorAll('tr').forEach((row, rowIndex)=>{
        row.querySelectorAll('td').forEach((cell, cellIndex)=>{
            func(cell, rowIndex, cellIndex);
        });
    });
}
/**
 * This hook is used to navigate between table cells using the keyboard arrow keys.
 * All the functionality is implemented in the hook, so the table component does not
 * need to implement any keyboard event handlers.
 * @param enable - Toggle functionality of the hook
 * @param tableRoot - A ref to a table container. Ideally the root element of the table (<table>); tbody is also acceptable.
 * @param columnDefinitions - The column definitions for the table.
 * @param numRows - The number of rows in the table.
 */ function $9c34ca8192fcd717$var$useTableFocusNavigation({ enableKeyboardNavigation: enableKeyboardNavigation, selectionType: selectionType, tableRoot: tableRoot, columnDefinitions: columnDefinitions, numRows: numRows }) {
    const focusableColumns = (0, $acw62.useMemo)(()=>{
        const cols = columnDefinitions.map((column)=>!!column.editConfig);
        if (selectionType) cols.unshift(false);
        return cols;
    }, [
        columnDefinitions,
        selectionType
    ]);
    const maxColumnIndex = focusableColumns.length - 1;
    const minColumnIndex = selectionType ? 1 : 0;
    const focusCell = (0, $acw62.useCallback)((rowIndex, columnIndex)=>{
        if (tableRoot === null || tableRoot === void 0 ? void 0 : tableRoot.current) $9c34ca8192fcd717$var$iterateTableCells(tableRoot.current, (cell, rIndex, cIndex)=>{
            var _a;
            if (rIndex === rowIndex && cIndex === columnIndex) {
                const editButton = cell.querySelector('button:last-child');
                if (editButton) {
                    (_a = editButton.focus) === null || _a === void 0 || _a.call(editButton);
                    (0, $24d40242cc6554ee$export$a904af9c1628c179)(editButton);
                }
            }
        });
    }, [
        tableRoot
    ]);
    const shiftFocus = (0, $acw62.useCallback)((vertical, horizontal)=>{
        var _a;
        const focusedCell = (_a = tableRoot.current) === null || _a === void 0 ? void 0 : _a.querySelector('td:focus-within');
        if (!focusedCell) return;
        const columnIndex = focusedCell.cellIndex;
        const rowIndex = focusedCell.parentElement.rowIndex;
        let newRowIndex = rowIndex;
        let newColumnIndex = columnIndex;
        if (vertical !== 0) newRowIndex = Math.min(numRows, Math.max(rowIndex + vertical, 0));
        if (horizontal !== 0) while(newColumnIndex <= maxColumnIndex && newColumnIndex >= minColumnIndex){
            newColumnIndex += horizontal;
            if (focusableColumns[newColumnIndex]) break;
        }
        if ((rowIndex !== newRowIndex || columnIndex !== newColumnIndex) && tableRoot.current) focusCell(newRowIndex, newColumnIndex);
    }, [
        focusCell,
        focusableColumns,
        maxColumnIndex,
        minColumnIndex,
        numRows,
        tableRoot
    ]);
    const handleArrowKeyEvents = (0, $acw62.useCallback)((event)=>{
        var _a, _b;
        const abort = !!((_a = tableRoot.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-inline-editing-active = "true"]')) || !((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.closest('[data-inline-editing-active]'));
        if (abort) return;
        switch(event.key){
            case 'ArrowUp':
                event.preventDefault();
                shiftFocus(-1, 0);
                break;
            case 'ArrowDown':
                event.preventDefault();
                shiftFocus(1, 0);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                shiftFocus(0, -1);
                break;
            case 'ArrowRight':
                event.preventDefault();
                shiftFocus(0, 1);
                break;
            // istanbul ignore next (default case = do nothing, not testable)
            default:
                return;
        }
    }, [
        shiftFocus,
        tableRoot
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!tableRoot.current || enableKeyboardNavigation) return;
        const tableElement = tableRoot.current;
        tableRoot.current.addEventListener('keydown', handleArrowKeyEvents);
        return ()=>tableElement && tableElement.removeEventListener('keydown', handleArrowKeyEvents);
    }, [
        enableKeyboardNavigation,
        focusableColumns,
        handleArrowKeyEvents,
        tableRoot
    ]);
}
var $9c34ca8192fcd717$export$2e2bcd8739ae039 = $9c34ca8192fcd717$var$useTableFocusNavigation;






const $232ec668ec974363$var$GRID_NAVIGATION_PAGE_SIZE = 10;
const $232ec668ec974363$var$SELECTION_COLUMN_WIDTH = 54;
const $232ec668ec974363$var$selectionColumnId = Symbol('selection-column-id');
const $232ec668ec974363$export$38570466636a45db = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { funnelSubStepProps: funnelSubStepProps } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const tableProps = {
        ...props,
        __funnelSubStepProps: funnelSubStepProps
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($232ec668ec974363$var$InternalTable, {
        ...tableProps,
        ref: ref
    });
});
const $232ec668ec974363$var$InternalTable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ header: header, footer: footer, empty: empty, filter: filter, pagination: pagination, preferences: preferences, items: items, columnDefinitions: columnDefinitions, trackBy: trackBy, loading: loading, loadingText: loadingText, selectionType: externalSelectionType, selectedItems: selectedItems, isItemDisabled: isItemDisabled, ariaLabels: ariaLabels, onSelectionChange: onSelectionChange, onSortingChange: onSortingChange, sortingColumn: sortingColumn, sortingDescending: sortingDescending, sortingDisabled: sortingDisabled, visibleColumns: visibleColumns, stickyHeader: stickyHeader, stickyHeaderVerticalOffset: stickyHeaderVerticalOffset, onRowClick: onRowClick, onRowContextMenu: onRowContextMenu, wrapLines: wrapLines, stripedRows: stripedRows, contentDensity: contentDensity, submitEdit: submitEdit, onEditCancel: onEditCancel, resizableColumns: resizableColumns, onColumnWidthsChange: onColumnWidthsChange, variant: variant, __internalRootRef: __internalRootRef, totalItemsCount: totalItemsCount, firstIndex: firstIndex, renderAriaLive: renderAriaLive, stickyColumns: stickyColumns, columnDisplay: columnDisplay, enableKeyboardNavigation: enableKeyboardNavigation, expandableRows: externalExpandableRows, getLoadingStatus: getLoadingStatus, renderLoaderPending: renderLoaderPending, renderLoaderLoading: renderLoaderLoading, renderLoaderError: renderLoaderError, renderLoaderEmpty: renderLoaderEmpty, renderLoaderCounter: renderLoaderCounter, cellVerticalAlign: cellVerticalAlign, __funnelSubStepProps: __funnelSubStepProps, ...rest }, ref)=>{
    var _a, _b, _c;
    // Keyboard navigation defaults to `true` for tables with expandable rows.
    if (externalExpandableRows && enableKeyboardNavigation === undefined) enableKeyboardNavigation = true;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const prevStickyHeader = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(stickyHeader);
    if (prevStickyHeader !== undefined && !!stickyHeader !== !!prevStickyHeader) (0, $013a2451794a45c0$exports.warnOnce)('Table', `\`stickyHeader\` has changed from "${prevStickyHeader}" to "${stickyHeader}". It is not recommended to change the value of this property during the component lifecycle. Please set it to either "true" or "false" unconditionally.`);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const expandableRows = (0, $7214aee332d974de$export$fce377726b938a2f)({
        items: items,
        expandableRows: externalExpandableRows,
        trackBy: trackBy,
        ariaLabels: ariaLabels
    });
    const { allItems: allItems, isExpandable: isExpandable } = expandableRows;
    const { allRows: allRows } = (0, $21c8ce7a53dfba27$export$6bc816ed4d0c9912)({
        getLoadingStatus: getLoadingStatus,
        expandableRows: expandableRows
    });
    const selectionType = expandableRows.hasGroupSelection ? 'group' : externalSelectionType;
    const [containerWidth, wrapperMeasureRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.borderBoxWidth);
    const wrapperMeasureRefObject = (0, $acw62.useRef)(null);
    const wrapperMeasureMergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(wrapperMeasureRef, wrapperMeasureRefObject);
    const [tableWidth, tableMeasureRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.borderBoxWidth);
    const tableRefObject = (0, $acw62.useRef)(null);
    const secondaryWrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const theadRef = (0, $acw62.useRef)(null);
    const stickyHeaderRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollbarRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { cancelEdit: cancelEdit, ...cellEditing } = (0, $85269665d4ad8536$export$91b87deb855561fe)({
        onCancel: onEditCancel,
        onSubmit: submitEdit
    });
    const paginationRef = (0, $acw62.useRef)({});
    const filterRef = (0, $acw62.useRef)({});
    const preferencesRef = (0, $acw62.useRef)({});
    const headerRef = (0, $acw62.useRef)({});
    /* istanbul ignore next: performance marks do not work in JSDOM */ const getHeaderText = ()=>{
        var _a, _b, _c, _d;
        return (_c = (_b = (_a = toolsHeaderPerformanceMarkRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, $962e3f40ddca05f8$export$2e2bcd8739ae039)['heading-text']}`)) === null || _b === void 0 ? void 0 : _b.innerText) !== null && _c !== void 0 ? _c : (_d = toolsHeaderPerformanceMarkRef.current) === null || _d === void 0 ? void 0 : _d.innerText;
    };
    const getPatternIdentifier = ()=>{
        var _a;
        const hasActions = !!((_a = toolsHeaderPerformanceMarkRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, $962e3f40ddca05f8$export$2e2bcd8739ae039).actions} .${(0, $e49660893c408df4$export$2e2bcd8739ae039).button}`));
        if (hasActions) return 'table-with-actions';
        return '';
    };
    const performanceMarkAttributes = (0, $d1a7bb38399fdadf$export$2ea7ecdb51f088f5)('table', ()=>!loading, tableRefObject, ()=>({
            loading: loading !== null && loading !== void 0 ? loading : false,
            header: getHeaderText()
        }), [
        loading
    ]);
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(rest);
    const interactionMetadata = ()=>{
        const filterData = filterRef.current;
        const paginationData = paginationRef.current;
        return JSON.stringify({
            filterData: filterData,
            paginationData: paginationData,
            sortingColumn: sortingColumn === null || sortingColumn === void 0 ? void 0 : sortingColumn.sortingField,
            sortingOrder: sortingColumn ? sortingDescending ? 'Descending' : 'Ascending' : undefined
        });
    };
    const getComponentConfiguration = ()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const headerData = headerRef.current;
        const filterData = filterRef.current;
        const paginationData = paginationRef.current;
        const preferencesData = preferencesRef.current;
        return {
            variant: variant,
            flowType: (_a = rest.analyticsMetadata) === null || _a === void 0 ? void 0 : _a.flowType,
            resourceType: (_b = rest.analyticsMetadata) === null || _b === void 0 ? void 0 : _b.resourceType,
            instanceIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
            taskName: (_c = analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier) !== null && _c !== void 0 ? _c : getHeaderText(),
            uxTaskName: getHeaderText(),
            patternIdentifier: getPatternIdentifier(),
            sortedBy: {
                columnId: sortingColumn === null || sortingColumn === void 0 ? void 0 : sortingColumn.sortingField,
                sortingOrder: sortingColumn ? sortingDescending ? 'desc' : 'asc' : undefined
            },
            filtered: (_d = filterData === null || filterData === void 0 ? void 0 : filterData.filtered) !== null && _d !== void 0 ? _d : null,
            filteredBy: (_e = filterData === null || filterData === void 0 ? void 0 : filterData.filteredBy) !== null && _e !== void 0 ? _e : [],
            filteredCount: (_f = filterData === null || filterData === void 0 ? void 0 : filterData.filterCount) !== null && _f !== void 0 ? _f : null,
            totalNumberOfResources: (_g = headerData === null || headerData === void 0 ? void 0 : headerData.totalCount) !== null && _g !== void 0 ? _g : null,
            tablePreferences: {
                visibleColumns: (_h = preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.visibleColumns) !== null && _h !== void 0 ? _h : [],
                resourcesPerPage: (_j = preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.pageSize) !== null && _j !== void 0 ? _j : null
            },
            pagination: {
                currentPageIndex: (_k = paginationData === null || paginationData === void 0 ? void 0 : paginationData.currentPageIndex) !== null && _k !== void 0 ? _k : 0,
                totalNumberOfPages: (paginationData === null || paginationData === void 0 ? void 0 : paginationData.openEnd) ? null : (_l = paginationData === null || paginationData === void 0 ? void 0 : paginationData.totalPageCount) !== null && _l !== void 0 ? _l : null,
                openEnd: Boolean(paginationData === null || paginationData === void 0 ? void 0 : paginationData.openEnd)
            },
            resourcesSelected: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0
        };
    };
    const { setLastUserAction: setLastUserAction, tableInteractionAttributes: tableInteractionAttributes } = (0, $d455eb7d4e18ed2a$export$4141b24171098aae)({
        elementRef: tableRefObject,
        loading: loading,
        items: items,
        instanceIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        itemCount: items.length,
        getComponentIdentifier: getHeaderText,
        getComponentConfiguration: getComponentConfiguration,
        interactionMetadata: interactionMetadata
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        var _a;
        return {
            scrollToTop: ((_a = stickyHeaderRef.current) === null || _a === void 0 ? void 0 : _a.scrollToTop) || (()=>undefined),
            cancelEdit: cancelEdit
        };
    }, [
        cancelEdit
    ]);
    const wrapperRefObject = (0, $acw62.useRef)(null);
    const handleScroll = (0, $00ea7b4995e93369$export$5a6f6c506490de72)([
        wrapperRefObject,
        scrollbarRef,
        secondaryWrapperRef
    ]);
    const { moveFocusDown: moveFocusDown, moveFocusUp: moveFocusUp, moveFocus: moveFocus } = (0, $021f9e20e3ad3309$export$c8a0aa4990d3b09f)(selectionType, allItems.length);
    const { onRowClickHandler: onRowClickHandler, onRowContextMenuHandler: onRowContextMenuHandler } = (0, $28a501d6671417e8$export$48c69dbc46986321)({
        onRowClick: onRowClick,
        onRowContextMenu: onRowContextMenu
    });
    const visibleColumnDefinitions = (0, $d5e9c22659308d3d$export$814232dd3a440b46)({
        columnDefinitions: columnDefinitions,
        columnDisplay: columnDisplay,
        visibleColumns: visibleColumns
    });
    const selectionProps = {
        items: allItems,
        rootItems: items,
        trackBy: trackBy,
        selectedItems: selectedItems,
        totalItemsCount: totalItemsCount,
        selectionType: selectionType,
        isItemDisabled: isItemDisabled,
        onSelectionChange: onSelectionChange,
        ariaLabels: {
            ...ariaLabels,
            // `selectionGroupLabel` should not be part of the selection control, it is already part of the selection column header.
            selectionGroupLabel: undefined
        },
        loading: loading,
        expandableRows: expandableRows,
        getLoadingStatus: getLoadingStatus,
        setLastUserAction: setLastUserAction
    };
    const normalSelection = (0, $9bc9293ffbf00f4c$export$a97c3cc4bf1da1ca)(selectionProps);
    const groupSelection = (0, $73242b71595f9865$export$c162eb8e13ac6b9)(selectionProps);
    const selection = selectionType === 'group' ? groupSelection : normalSelection;
    const isRowSelected = (row)=>{
        if (row.type === 'data') return selection.isItemSelected(row.item);
        if (selectionType !== 'group') return false;
        // Group loader is selected when its parent is selected.
        return !row.item ? expandableRows.groupSelection.inverted : selection.isItemSelected(row.item);
    };
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (resizableColumns) (0, $6208ed25859b543f$export$9ef7e4997c031fc0)(columnDefinitions);
        if (sortingColumn === null || sortingColumn === void 0 ? void 0 : sortingColumn.sortingComparator) (0, $d5e9c22659308d3d$export$8490691ec4e40f0d)(columnDefinitions, sortingColumn.sortingComparator);
    }
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const computedVariant = isVisualRefresh ? variant : [
        'embedded',
        'full-page'
    ].indexOf(variant) > -1 ? 'container' : variant;
    const hasHeader = !!(header || filter || pagination || preferences);
    const hasSelection = !!selectionType;
    const hasFooterPagination = isMobile && variant === 'full-page' && !!pagination;
    const hasFooter = !!footer || hasFooterPagination;
    const headerIdRef = (0, $acw62.useRef)(undefined);
    const isLabelledByHeader = !(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tableLabel) && !!header;
    const ariaLabelledby = isLabelledByHeader && headerIdRef.current ? headerIdRef.current : undefined;
    const setHeaderRef = (0, $acw62.useCallback)((id)=>{
        headerIdRef.current = id;
    }, []);
    const visibleColumnWidthsWithSelection = [];
    const visibleColumnIdsWithSelection = [];
    if (hasSelection) {
        visibleColumnWidthsWithSelection.push({
            id: $232ec668ec974363$var$selectionColumnId,
            width: $232ec668ec974363$var$SELECTION_COLUMN_WIDTH
        });
        visibleColumnIdsWithSelection.push($232ec668ec974363$var$selectionColumnId);
    }
    for(let columnIndex = 0; columnIndex < visibleColumnDefinitions.length; columnIndex++){
        const columnId = (0, $d5e9c22659308d3d$export$480219a02f196e72)(visibleColumnDefinitions[columnIndex], columnIndex);
        visibleColumnWidthsWithSelection.push({
            ...visibleColumnDefinitions[columnIndex],
            id: columnId
        });
        visibleColumnIdsWithSelection.push(columnId);
    }
    const stickyState = (0, $b00a9e41f83b2a0f$export$fa628f01ec57be39)({
        visibleColumns: visibleColumnIdsWithSelection,
        stickyColumnsFirst: ((_a = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.first) !== null && _a !== void 0 ? _a : 0) + ((stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.first) && hasSelection ? 1 : 0),
        stickyColumnsLast: (stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.last) || 0
    });
    const hasStickyColumns = !!(((_b = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.first) !== null && _b !== void 0 ? _b : 0) + ((_c = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.last) !== null && _c !== void 0 ? _c : 0) > 0);
    const hasEditableCells = !!columnDefinitions.find((col)=>col.editConfig);
    let tableRole = 'table';
    if (isExpandable) tableRole = 'treegrid';
    else if (enableKeyboardNavigation) tableRole = 'grid';
    else if (hasEditableCells) tableRole = 'grid-default';
    const theadProps = {
        selectionType: selectionType,
        getSelectAllProps: selection.getSelectAllProps,
        columnDefinitions: visibleColumnDefinitions,
        variant: computedVariant,
        tableVariant: computedVariant,
        wrapLines: wrapLines,
        resizableColumns: resizableColumns,
        sortingColumn: sortingColumn,
        sortingDisabled: sortingDisabled,
        sortingDescending: sortingDescending,
        onSortingChange: onSortingChange,
        onFocusMove: moveFocus,
        onResizeFinish (newWidth) {
            const widthsDetail = columnDefinitions.map((column, index)=>newWidth.get((0, $d5e9c22659308d3d$export$480219a02f196e72)(column, index)) || column.width || (0, $52cd48af6d6570d7$export$7c3f559e2ca95fa));
            const widthsChanged = widthsDetail.some((width, index)=>columnDefinitions[index].width !== width);
            if (widthsChanged) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onColumnWidthsChange, {
                widths: widthsDetail
            });
        },
        singleSelectionHeaderAriaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel,
        resizerRoleDescription: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.resizerRoleDescription,
        resizerTooltipText: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.resizerTooltipText,
        stripedRows: stripedRows,
        stickyState: stickyState,
        selectionColumnId: $232ec668ec974363$var$selectionColumnId,
        tableRole: tableRole,
        isExpandable: isExpandable,
        setLastUserAction: setLastUserAction
    };
    (0, $bfb38fe7bcb6a793$export$39cc7e9b3a376870)(wrapperRefObject);
    const wrapperRef = (0, $013a2451794a45c0$exports.useMergeRefs)(wrapperRefObject, stickyState.refs.wrapper);
    const tableRef = (0, $013a2451794a45c0$exports.useMergeRefs)(tableMeasureRef, tableRefObject, stickyState.refs.table);
    const wrapperProps = (0, $4724080100e81846$export$9facfa3a9b67cdc8)({
        tableRole: tableRole,
        isScrollable: !!(tableWidth && containerWidth && tableWidth > containerWidth),
        ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tableLabel,
        ariaLabelledby: ariaLabelledby
    });
    const getMouseDownTarget = (0, $796a0d0b43417279$export$2e2bcd8739ae039)();
    (0, $9c34ca8192fcd717$export$2e2bcd8739ae039)({
        enableKeyboardNavigation: enableKeyboardNavigation,
        selectionType: selectionType,
        tableRoot: tableRefObject,
        columnDefinitions: visibleColumnDefinitions,
        numRows: allRows === null || allRows === void 0 ? void 0 : allRows.length
    });
    const toolsHeaderPerformanceMarkRef = (0, $acw62.useRef)(null);
    // If is mobile, we take into consideration the AppLayout's mobile bar and we subtract the tools wrapper height so only the table header is sticky
    const [toolsHeaderHeight, toolsHeaderWrapperMeasureRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.borderBoxHeight);
    const toolsHeaderWrapper = (0, $013a2451794a45c0$exports.useMergeRefs)(toolsHeaderPerformanceMarkRef, toolsHeaderWrapperMeasureRef);
    const colIndexOffset = selectionType ? 1 : 0;
    const totalColumnsCount = visibleColumnDefinitions.length + colIndexOffset;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9699df5a060a9c12$export$366cdc6257b696ef).Provider, {
        value: {
            defaultVariant: 'primary'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $83cc797b0d9c18d5$export$9822b1dd239f3572), {
        value: {
            paginationRef: paginationRef,
            filterRef: filterRef,
            preferencesRef: preferencesRef,
            headerRef: headerRef
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $52cd48af6d6570d7$export$9b0658a77dfa159c), {
        visibleColumns: visibleColumnWidthsWithSelection,
        resizableColumns: resizableColumns,
        containerRef: wrapperMeasureRefObject
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$2e2bcd8739ae039), {
        ...baseProps,
        ...tableInteractionAttributes,
        __internalRootRef: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $7ded81c543f72294$export$2e2bcd8739ae039).root),
        __funnelSubStepProps: __funnelSubStepProps,
        __fullPage: variant === 'full-page',
        header: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, hasHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: toolsHeaderWrapper,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)['header-controls'], (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${computedVariant}`])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314).Provider, {
            value: {
                assignId: setHeaderRef
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d7e99db5d46311b5$export$2e2bcd8739ae039), {
            header: header,
            filter: filter,
            pagination: pagination,
            preferences: preferences,
            setLastUserAction: setLastUserAction
        })))), stickyHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c441436201ecd93$export$2e2bcd8739ae039), {
            ref: stickyHeaderRef,
            variant: computedVariant,
            theadProps: theadProps,
            wrapperRef: wrapperRefObject,
            theadRef: theadRef,
            secondaryWrapperRef: secondaryWrapperRef,
            tableRef: tableRefObject,
            onScroll: handleScroll,
            tableHasHeader: hasHeader,
            contentDensity: contentDensity,
            tableRole: tableRole
        })),
        disableHeaderPaddings: true,
        disableContentPaddings: true,
        disableFooterPaddings: true,
        variant: (0, $d5e9c22659308d3d$export$9704772993b3cb14)(computedVariant),
        __disableFooterDivider: true,
        __disableStickyMobile: false,
        footer: hasFooter ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)['footer-wrapper'], (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${computedVariant}`])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).footer, hasFooterPagination && (0, $7ded81c543f72294$export$2e2bcd8739ae039)['footer-with-pagination'])
        }, footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, footer), hasFooterPagination && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['footer-pagination']
        }, pagination))) : null,
        __stickyHeader: stickyHeader,
        __mobileStickyOffset: toolsHeaderHeight !== null && toolsHeaderHeight !== void 0 ? toolsHeaderHeight : 0,
        __stickyOffset: stickyHeaderVerticalOffset,
        ...(0, $30c09cf06b060b34$export$abdbebe48aa0774a).root
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: wrapperRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).wrapper, (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${computedVariant}`], {
            [(0, $7ded81c543f72294$export$2e2bcd8739ae039)['has-footer']]: hasFooter,
            [(0, $7ded81c543f72294$export$2e2bcd8739ae039)['has-header']]: hasHeader
        }),
        style: stickyState.style.wrapper,
        onScroll: handleScroll,
        ...wrapperProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)['wrapper-content-measure'],
        ref: wrapperMeasureMergedRef
    }), !!renderAriaLive && !!firstIndex && !loading && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        hidden: true,
        tagName: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, renderAriaLive({
        firstIndex: firstIndex,
        lastIndex: firstIndex + items.length - 1,
        visibleItemsCount: allItems.length,
        totalItemsCount: totalItemsCount
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fddcc6aec92a0ef$export$15a0a58a360b70b4), {
        keyboardNavigation: !!enableKeyboardNavigation,
        pageSize: $232ec668ec974363$var$GRID_NAVIGATION_PAGE_SIZE,
        getTable: ()=>tableRefObject.current
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        ...performanceMarkAttributes,
        ref: tableRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).table, resizableColumns && (0, $7ded81c543f72294$export$2e2bcd8739ae039)['table-layout-fixed'], contentDensity === 'compact' && (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)('compact-table')),
        ...(0, $4724080100e81846$export$2c3bcd6eb50948d4)({
            tableRole: tableRole,
            totalItemsCount: totalItemsCount,
            totalColumnsCount: totalColumnsCount,
            ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tableLabel,
            ariaLabelledby: ariaLabelledby
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc555153bc24e36c$export$2e2bcd8739ae039), {
        ref: theadRef,
        hidden: stickyHeader,
        onFocusedComponentChange: (focusId)=>{
            var _a;
            return (_a = stickyHeaderRef.current) === null || _a === void 0 ? void 0 : _a.setFocus(focusId);
        },
        ...theadProps
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, loading || allItems.length === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $71cec865b9338494$export$c73ef76fcb96862d), {
        totalColumnsCount: totalColumnsCount,
        hasFooter: hasFooter,
        loading: loading,
        loadingText: loadingText,
        empty: empty,
        tableRef: tableRefObject,
        containerRef: wrapperMeasureRefObject
    })) : allRows.map((row, rowIndex)=>{
        const isFirstRow = rowIndex === 0;
        const isLastRow = rowIndex === allRows.length - 1;
        const rowExpandableProps = row.type === 'data' ? expandableRows.getExpandableItemProps(row.item) : undefined;
        const rowRoleProps = (0, $4724080100e81846$export$70749aa7430746bc)({
            tableRole: tableRole,
            firstIndex: firstIndex,
            rowIndex: rowIndex,
            level: row.type === 'loader' ? row.level : undefined,
            ...rowExpandableProps
        });
        const getTableItemKey = (item)=>(0, $d5e9c22659308d3d$export$424834ba1b0663bc)(trackBy, item, rowIndex);
        const sharedCellProps = {
            isFirstRow: isFirstRow,
            isLastRow: isLastRow,
            isSelected: hasSelection && isRowSelected(row),
            isPrevSelected: hasSelection && !isFirstRow && isRowSelected(allRows[rowIndex - 1]),
            isNextSelected: hasSelection && !isLastRow && isRowSelected(allRows[rowIndex + 1]),
            isEvenRow: rowIndex % 2 === 0,
            stripedRows: stripedRows,
            hasSelection: hasSelection,
            hasFooter: hasFooter,
            stickyState: stickyState,
            tableRole: tableRole
        };
        if (row.type === 'data') {
            const rowId = `${getTableItemKey(row.item)}`;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
                key: rowId,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).row, sharedCellProps.isSelected && (0, $7ded81c543f72294$export$2e2bcd8739ae039)['row-selected']),
                onFocus: ({ currentTarget: currentTarget })=>{
                    var _a;
                    // When an element inside table row receives focus we want to adjust the scroll.
                    // However, that behavior is unwanted when the focus is received as result of a click
                    // as it causes the click to never reach the target element.
                    if (!currentTarget.contains(getMouseDownTarget())) (_a = stickyHeaderRef.current) === null || _a === void 0 || _a.scrollToRow(currentTarget);
                },
                ...(0, $30c09cf06b060b34$export$abdbebe48aa0774a).item,
                onClick: onRowClickHandler && onRowClickHandler.bind(null, rowIndex, row.item),
                onContextMenu: onRowContextMenuHandler && onRowContextMenuHandler.bind(null, rowIndex, row.item),
                ...rowRoleProps
            }, selection.getItemSelectionProps && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $36873d47a98b41e9$export$a0a74e96f9bd7c10), {
                ...sharedCellProps,
                columnId: $232ec668ec974363$var$selectionColumnId,
                selectionControlProps: {
                    ...selection.getItemSelectionProps(row.item),
                    onFocusDown: moveFocusDown,
                    onFocusUp: moveFocusUp,
                    rowIndex: rowIndex,
                    itemKey: rowId
                },
                verticalAlign: cellVerticalAlign,
                tableVariant: computedVariant
            }), visibleColumnDefinitions.map((column, colIndex)=>{
                var _a, _b, _c;
                const colId = `${(0, $d5e9c22659308d3d$export$480219a02f196e72)(column, colIndex)}`;
                const cellId = {
                    row: rowId,
                    col: colId
                };
                const isEditing = cellEditing.checkEditing(cellId);
                const successfulEdit = cellEditing.checkLastSuccessfulEdit(cellId);
                const isEditable = !!column.editConfig && !cellEditing.isLoading;
                const cellExpandableProps = isExpandable && colIndex === 0 ? rowExpandableProps : undefined;
                const counter = (_a = column.counter) === null || _a === void 0 ? void 0 : _a.call(column, {
                    item: row.item,
                    itemsCount: rowExpandableProps === null || rowExpandableProps === void 0 ? void 0 : rowExpandableProps.itemsCount,
                    selectedItemsCount: rowExpandableProps === null || rowExpandableProps === void 0 ? void 0 : rowExpandableProps.selectedItemsCount
                });
                const analyticsMetadata = {
                    component: {
                        innerContext: {
                            position: `${rowIndex + 1},${colIndex + 1}`,
                            columnId: column.id ? `${column.id}` : '',
                            columnLabel: {
                                selector: `table thead tr th:nth-child(${colIndex + (selectionType ? 2 : 1)})`,
                                root: 'component'
                            },
                            item: rowId
                        }
                    }
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ca56bbf005612a36$export$948e91fcef170792), {
                    key: colId,
                    ...sharedCellProps,
                    resizableStyle: {
                        width: column.width,
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth
                    },
                    ariaLabels: ariaLabels,
                    column: column,
                    item: row.item,
                    wrapLines: wrapLines,
                    isEditable: isEditable,
                    isEditing: isEditing,
                    isRowHeader: column.isRowHeader,
                    successfulEdit: successfulEdit,
                    resizableColumns: resizableColumns,
                    onEditStart: ()=>cellEditing.startEdit(cellId),
                    onEditEnd: (editCancelled)=>cellEditing.completeEdit(cellId, editCancelled),
                    submitEdit: cellEditing.submitEdit,
                    columnId: (_b = column.id) !== null && _b !== void 0 ? _b : colIndex,
                    colIndex: colIndex + colIndexOffset,
                    verticalAlign: (_c = column.verticalAlign) !== null && _c !== void 0 ? _c : cellVerticalAlign,
                    tableVariant: computedVariant,
                    counter: counter,
                    ...cellExpandableProps,
                    ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
                });
            }));
        }
        const loaderSelectionProps = selection.getLoaderSelectionProps && selection.getLoaderSelectionProps(row.item);
        const rowSelection = selectionType === 'group' ? loaderSelectionProps : undefined;
        const loaderContent = (0, $85eff45af97fd1d6$export$55a59dff87f0f9bd)({
            item: row.item,
            loadingStatus: row.status,
            renderLoaderPending: renderLoaderPending,
            renderLoaderLoading: renderLoaderLoading,
            renderLoaderError: renderLoaderError,
            renderLoaderEmpty: renderLoaderEmpty
        });
        const loaderCounter = renderLoaderCounter === null || renderLoaderCounter === void 0 ? void 0 : renderLoaderCounter({
            item: row.item,
            loadingStatus: row.status,
            selected: !!(rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.checked)
        });
        return loaderContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: (row.item ? getTableItemKey(row.item) : 'root-' + rowIndex) + '-' + row.from,
            className: (0, $7ded81c543f72294$export$2e2bcd8739ae039).row,
            ...rowRoleProps
        }, selectionType ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $36873d47a98b41e9$export$a0a74e96f9bd7c10), {
            ...sharedCellProps,
            columnId: $232ec668ec974363$var$selectionColumnId,
            verticalAlign: cellVerticalAlign,
            tableVariant: computedVariant,
            selectionControlProps: selectionType === 'group' ? loaderSelectionProps : undefined,
            isSelected: selectionType === 'group' && !!(loaderSelectionProps === null || loaderSelectionProps === void 0 ? void 0 : loaderSelectionProps.checked)
        }) : null, visibleColumnDefinitions.map((column, colIndex)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e7925bc72d88b5ba$export$c9113e9bb577984b), {
                key: (0, $d5e9c22659308d3d$export$480219a02f196e72)(column, colIndex),
                ...sharedCellProps,
                wrapLines: false,
                columnId: (_a = column.id) !== null && _a !== void 0 ? _a : colIndex,
                colIndex: colIndex + colIndexOffset,
                isSelected: selectionType === 'group' && !!(loaderSelectionProps === null || loaderSelectionProps === void 0 ? void 0 : loaderSelectionProps.checked),
                isRowHeader: colIndex === 0,
                level: row.level,
                item: row.item,
                trackBy: trackBy,
                counter: loaderCounter
            }, loaderContent);
        }));
    })))), resizableColumns && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$1a1c8e5e76867279), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33348950bdbf3017$export$2e2bcd8739ae039), {
        ref: scrollbarRef,
        wrapperRef: wrapperRefObject,
        tableRef: tableRefObject,
        onScroll: handleScroll,
        hasStickyColumns: hasStickyColumns
    })))));
});
var $232ec668ec974363$export$2e2bcd8739ae039 = $232ec668ec974363$var$InternalTable;


'use client';
const $7f9d0e5ed1593f09$var$Table = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ items: items = [], selectedItems: selectedItems = [], variant: variant = 'container', contentDensity: contentDensity = 'comfortable', cellVerticalAlign: cellVerticalAlign = 'middle', firstIndex: firstIndex = 1, ...props }, ref)=>{
    var _a, _b, _c, _d;
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const hasHiddenColumns = props.visibleColumns && props.visibleColumns.length < props.columnDefinitions.length || ((_a = props.columnDisplay) === null || _a === void 0 ? void 0 : _a.some((col)=>!col.visible));
    const hasStickyColumns = !!((_b = props.stickyColumns) === null || _b === void 0 ? void 0 : _b.first) || !!((_c = props.stickyColumns) === null || _c === void 0 ? void 0 : _c.last);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Table', {
        props: {
            contentDensity: contentDensity,
            resizableColumns: props.resizableColumns,
            selectionType: props.selectionType,
            stickyHeader: props.stickyHeader,
            stripedRows: props.stripedRows,
            variant: variant,
            wrapLines: props.wrapLines,
            enableKeyboardNavigation: props.enableKeyboardNavigation,
            totalItemsCount: props.totalItemsCount,
            flowType: analyticsMetadata.flowType,
            cellVerticalAlign: cellVerticalAlign
        },
        metadata: {
            expandableRows: !!props.expandableRows,
            progressiveLoading: !!props.getLoadingStatus,
            groupSelection: !!((_d = props.expandableRows) === null || _d === void 0 ? void 0 : _d.groupSelection),
            cellCounters: props.columnDefinitions.filter((dev)=>!!dev.counter).length,
            loaderCounters: !!props.renderLoaderCounter,
            inlineEdit: props.columnDefinitions.some((def)=>!!def.editConfig),
            disabledInlineEdit: props.columnDefinitions.some((def)=>{
                var _a;
                return !!((_a = def.editConfig) === null || _a === void 0 ? void 0 : _a.disabledReason);
            }),
            hasSortableColumns: props.columnDefinitions.some((def)=>def.sortingField || def.sortingComparator),
            hasHiddenColumns: hasHiddenColumns,
            hasStickyColumns: hasStickyColumns,
            hasFilterSlot: !!props.filter,
            hasPaginationSlot: !!props.pagination,
            itemsCount: items.length,
            hasInstanceIdentifier: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier),
            hasResourceType: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.resourceType),
            usesVisibleColumns: !!props.visibleColumns,
            usesColumnDisplay: !!props.columnDisplay,
            usesColumnDefinitionsVerticalAlign: props.columnDefinitions.some((def)=>def.verticalAlign !== cellVerticalAlign)
        }
    }, analyticsMetadata);
    const analyticsComponentMetadata = {
        name: 'awsui.Table',
        label: {
            root: 'self'
        },
        properties: {
            selectionType: props.selectionType || 'none',
            itemsCount: `${items.length}`,
            selectedItemsCount: `${selectedItems.length}`,
            variant: variant
        }
    };
    const sortingColumnId = (0, $18fb5778d4dc41bf$export$5b69c4c6aae8a17d)(props.columnDefinitions, props.sortingColumn);
    if (sortingColumnId) {
        analyticsComponentMetadata.properties.sortingColumnId = sortingColumnId;
        analyticsComponentMetadata.properties.sortingDescending = `${props.sortingDescending || false}`;
    }
    const tableProps = {
        items: items,
        selectedItems: selectedItems,
        variant: variant,
        contentDensity: contentDensity,
        firstIndex: firstIndex,
        cellVerticalAlign: cellVerticalAlign,
        ...props,
        ...baseComponentProps,
        ref: ref,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: analyticsComponentMetadata
        })
    };
    const collectionPreferencesMetadata = {
        tableContentDensity: contentDensity,
        tableHasStripedRows: !!props.stripedRows,
        tableHasHiddenColumns: hasHiddenColumns,
        tableHasStickyColumns: hasStickyColumns
    };
    if (variant === 'borderless' || variant === 'embedded') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5b10d779002c4c5b$export$69e2f3b88d2c5d7).Provider, {
        value: collectionPreferencesMetadata
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $232ec668ec974363$export$2e2bcd8739ae039), {
        ...tableProps
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5b10d779002c4c5b$export$69e2f3b88d2c5d7).Provider, {
        value: collectionPreferencesMetadata
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$b1325661caf9fa0), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $232ec668ec974363$export$38570466636a45db), {
        ...tableProps
    })));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($7f9d0e5ed1593f09$var$Table, 'Table');
var $7f9d0e5ed1593f09$export$2e2bcd8739ae039 = $7f9d0e5ed1593f09$var$Table;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $9a3be6e5e2f6c8da$export$1f3015f6bbb3d1be = (filteringText, countText)=>{
    const tableComponentContext = (0, $83cc797b0d9c18d5$export$b4130bf0cd295245)();
    const countValue = (0, $acw62.useMemo)(()=>(0, $fba7efa2f48a8453$export$61352b8152b6fbca)(countText), [
        countText
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if ((_a = tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.filterRef) === null || _a === void 0 ? void 0 : _a.current) {
            tableComponentContext.filterRef.current.filterText = filteringText;
            tableComponentContext.filterRef.current.filterCount = countValue;
            tableComponentContext.filterRef.current.filtered = !!filteringText;
            return ()=>{
                var _a, _b, _c;
                (_a = tableComponentContext.filterRef.current) === null || _a === void 0 || delete _a.filterText;
                (_b = tableComponentContext.filterRef.current) === null || _b === void 0 || delete _b.filterCount;
                (_c = tableComponentContext.filterRef.current) === null || _c === void 0 || delete _c.filtered;
            };
        }
    }, [
        tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.filterRef,
        countValue,
        filteringText
    ]);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $9276a314d364c5b6$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1sdq3_1y1he_145",
    "input": "awsui_input_1sdq3_1y1he_180",
    "results": "awsui_results_1sdq3_1y1he_184"
};


// Debounce delay for live region (based on testing with VoiceOver)
const $46786b905a0ab7fc$var$LIVE_REGION_DELAY = 2000;
const $46786b905a0ab7fc$export$aee53da69e9839be = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ id: id, renderLiveRegion: renderLiveRegion, children: children }, ref)=>{
    const liveRegionRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            reannounce: ()=>{
                var _a;
                (_a = liveRegionRef.current) === null || _a === void 0 || _a.reannounce();
            }
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $9276a314d364c5b6$export$2e2bcd8739ae039).results,
        id: id
    }, children), renderLiveRegion && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7fb7d5e8b2fd49$export$2e2bcd8739ae039), {
        delay: $46786b905a0ab7fc$var$LIVE_REGION_DELAY,
        tagName: "span",
        hidden: true,
        ref: liveRegionRef
    }, children));
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Debounce delay for live region (based on testing with VoiceOver)
const $c4b1eea87226a4a8$var$LIVE_REGION_DELAY = 2000;
function $c4b1eea87226a4a8$export$2e2bcd8739ae039({ searchQuery: searchQuery, countText: countText, loading: loading, announceCallback: announceCallback }) {
    const loadingRef = (0, $acw62.useRef)(loading);
    // announceCallback is called when:
    // - For sync filters: on searchQuery/countText changes.
    // - For async filters: on searchQuery/countText when loading completed and countText exists.
    const debounceLiveAnnouncement = (0, $2f667510820517ed$export$40ae01be0011c1e6)(()=>{
        if (!countText || loadingRef.current) return;
        announceCallback();
    }, $c4b1eea87226a4a8$var$LIVE_REGION_DELAY);
    (0, $acw62.useEffect)(()=>{
        loadingRef.current = loading;
        debounceLiveAnnouncement();
    }, [
        searchQuery,
        countText,
        loading,
        debounceLiveAnnouncement
    ]);
}



const $2b86ff3bde67fdd3$var$InternalTextFilter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ filteringText: filteringText, filteringAriaLabel: filteringAriaLabel, filteringPlaceholder: filteringPlaceholder, filteringClearAriaLabel: filteringClearAriaLabel, controlId: controlId, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, disabled: disabled, countText: countText, disableBrowserAutocorrect: disableBrowserAutocorrect, onChange: onChange, onDelayedChange: onDelayedChange, loading: loading = false, style: style, __internalRootRef: __internalRootRef, ...rest }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const inputRef = (0, $acw62.useRef)(null);
    const searchResultsRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, inputRef);
    (0, $9a3be6e5e2f6c8da$export$1f3015f6bbb3d1be)(filteringText, countText);
    const searchResultsId = (0, $013a2451794a45c0$exports.useUniqueId)('text-filter-search-results');
    const showResults = filteringText && countText && !disabled;
    (0, $c4b1eea87226a4a8$export$2e2bcd8739ae039)({
        searchQuery: filteringText,
        countText: countText,
        loading: loading,
        announceCallback: ()=>{
            var _a;
            (_a = searchResultsRef.current) === null || _a === void 0 || _a.reannounce();
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $9276a314d364c5b6$export$2e2bcd8739ae039).root),
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), {
        __inheritFormFieldProps: true,
        disableBrowserAutocorrect: disableBrowserAutocorrect,
        ref: inputRef,
        className: (0, $9276a314d364c5b6$export$2e2bcd8739ae039).input,
        type: "search",
        ariaLabel: filteringAriaLabel,
        placeholder: filteringPlaceholder,
        value: filteringText,
        disabled: disabled,
        controlId: controlId,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(showResults ? searchResultsId : undefined, ariaDescribedby),
        autoComplete: false,
        clearAriaLabel: filteringClearAriaLabel,
        onChange: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                filteringText: event.detail.value
            }),
        __onDelayedInput: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDelayedChange, {
                filteringText: event.detail.value
            }),
        style: style
    }), showResults ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $46786b905a0ab7fc$export$aee53da69e9839be), {
        renderLiveRegion: !loading,
        id: searchResultsId,
        ref: searchResultsRef
    }, countText) : null);
});
var $2b86ff3bde67fdd3$export$2e2bcd8739ae039 = $2b86ff3bde67fdd3$var$InternalTextFilter;


'use client';
const $f1ad38163d990f1e$var$TextFilter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('TextFilter', {
        props: {
            disabled: props.disabled,
            disableBrowserAutocorrect: props.disableBrowserAutocorrect
        }
    });
    const componentAnalyticsMetadata = {
        name: 'awsui.TextFilter',
        label: 'input',
        properties: {
            disabled: `${!!props.disabled}`,
            filteringText: props.filteringText || ''
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2b86ff3bde67fdd3$export$2e2bcd8739ae039), {
        ...props,
        ...baseComponentProps,
        ref: ref,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: componentAnalyticsMetadata
        })
    });
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($f1ad38163d990f1e$var$TextFilter, 'TextFilter');
var $f1ad38163d990f1e$export$2e2bcd8739ae039 = $f1ad38163d990f1e$var$TextFilter;



var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $2ed802fee1ac7f1b$export$2e2bcd8739ae039 = {
    "trigger-button": "awsui_trigger-button_119fv_11zih_5"
};


const $374ef58330490142$export$1191c14690122a68 = (disabled, preferences = {})=>{
    const metadata = {
        name: 'awsui.CollectionPreferences',
        label: `.${(0, $2ed802fee1ac7f1b$export$2e2bcd8739ae039)['trigger-button']}`,
        properties: {
            disabled: `${!!disabled}`
        }
    };
    if (preferences.pageSize) metadata.properties.pageSize = `${preferences.pageSize}`;
    if (preferences.wrapLines !== undefined) metadata.properties.wrapLines = `${!!preferences.wrapLines}`;
    if (preferences.stripedRows !== undefined) metadata.properties.stripedRows = `${!!preferences.stripedRows}`;
    if (preferences.contentDensity !== undefined) metadata.properties.contentDensity = preferences.contentDensity;
    if (preferences.visibleContent) metadata.properties.visibleContentCount = `${preferences.visibleContent.length}`;
    if (preferences.stickyColumns) {
        if (preferences.stickyColumns.first) metadata.properties.stickyColumnsFirst = `${preferences.stickyColumns.first}`;
        if (preferences.stickyColumns.last) metadata.properties.stickyColumnsLast = `${preferences.stickyColumns.last}`;
    }
    if (preferences.contentDisplay) metadata.properties.contentDisplayVisibleCount = `${preferences.contentDisplay.filter(({ visible: visible })=>!!visible).length}`;
    return metadata;
};
const $374ef58330490142$export$fa742f6408a1b36b = (preference)=>(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
        component: {
            innerContext: {
                preference: preference
            }
        }
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $04cb277e6383bf1f$export$b401c5cdeddba627(style, checked, disabled, readOnly) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let properties = {};
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core' && ((style === null || style === void 0 ? void 0 : style.input) || (style === null || style === void 0 ? void 0 : style.label))) {
        const computedState = (0, $a4ca11d6aa7fe07f$export$6444e33011b307a)(checked, disabled, readOnly, false);
        properties = {
            control: {
                background: ((_a = style === null || style === void 0 ? void 0 : style.input) === null || _a === void 0 ? void 0 : _a.background) && style.input.background[computedState]
            },
            label: {
                color: ((_b = style === null || style === void 0 ? void 0 : style.label) === null || _b === void 0 ? void 0 : _b.color) && style.label.color[computedState]
            },
            focusRing: {
                borderColor: (_d = (_c = style === null || style === void 0 ? void 0 : style.input) === null || _c === void 0 ? void 0 : _c.focusRing) === null || _d === void 0 ? void 0 : _d.borderColor,
                borderRadius: (_f = (_e = style === null || style === void 0 ? void 0 : style.input) === null || _e === void 0 ? void 0 : _e.focusRing) === null || _f === void 0 ? void 0 : _f.borderRadius,
                borderWidth: (_h = (_g = style === null || style === void 0 ? void 0 : style.input) === null || _g === void 0 ? void 0 : _g.focusRing) === null || _h === void 0 ? void 0 : _h.borderWidth
            }
        };
    }
    return properties;
}
function $04cb277e6383bf1f$export$53f8945824a59225(style, checked, disabled, readOnly) {
    var _a, _b;
    let properties = {};
    if ((0, $93d122f201f7d1ff$export$52653a075d3f70dc) === 'core' && ((_b = (_a = style === null || style === void 0 ? void 0 : style.input) === null || _a === void 0 ? void 0 : _a.handle) === null || _b === void 0 ? void 0 : _b.background)) {
        const computedState = (0, $a4ca11d6aa7fe07f$export$6444e33011b307a)(checked, disabled, readOnly, undefined);
        properties = {
            background: style.input.handle.background[computedState]
        };
    }
    return properties;
}



var $31deb4646e53fc33$export$2e2bcd8739ae039 = {
    "root": "awsui_root_4yi2u_1lxzi_145",
    "outline": "awsui_outline_4yi2u_1lxzi_178",
    "toggle-control": "awsui_toggle-control_4yi2u_1lxzi_201",
    "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_1lxzi_214",
    "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_1lxzi_217",
    "toggle-control-readonly": "awsui_toggle-control-readonly_4yi2u_1lxzi_223",
    "toggle-handle": "awsui_toggle-handle_4yi2u_1lxzi_227",
    "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_1lxzi_252",
    "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_1lxzi_259",
    "toggle-handle-readonly": "awsui_toggle-handle-readonly_4yi2u_1lxzi_263"
};


const $9b746e4e3748705e$var$InternalToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ controlId: controlId, checked: checked, name: name, disabled: disabled, readOnly: readOnly, children: children, description: description, ariaLabel: ariaLabel, ariaControls: ariaControls, onFocus: onFocus, onBlur: onBlur, onChange: onChange, nativeInputAttributes: nativeInputAttributes, __internalRootRef: __internalRootRef, style: style, __injectAnalyticsComponentMetadata: __injectAnalyticsComponentMetadata, ...rest }, ref)=>{
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const checkboxRef = (0, $acw62.useRef)(null);
    const analyticsMetadata = {};
    const analyticsComponentMetadata = {
        name: 'awsui.Toggle',
        label: {
            root: 'self'
        },
        properties: {
            checked: `${!!checked}`
        }
    };
    if (__injectAnalyticsComponentMetadata) analyticsMetadata.component = analyticsComponentMetadata;
    if (!disabled && !readOnly) analyticsMetadata.action = !checked ? 'select' : 'deselect';
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, checkboxRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9358073d64ebb29$export$2e2bcd8739ae039), {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $31deb4646e53fc33$export$2e2bcd8739ae039).root, baseProps.className),
        controlClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-control'], {
            [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-control-checked']]: checked,
            [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-control-disabled']]: disabled,
            [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-control-readonly']]: readOnly
        }),
        outlineClassName: (0, $31deb4646e53fc33$export$2e2bcd8739ae039).outline,
        controlId: controlId,
        disabled: disabled,
        readOnly: readOnly,
        label: children,
        description: description,
        descriptionBottomPadding: true,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby,
        ariaControls: ariaControls,
        nativeControl: (nativeControlProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4349d15e19ce67a$export$2e2bcd8739ae039), {
                ...nativeControlProps,
                tag: "input",
                componentName: "Toggle",
                nativeAttributes: nativeInputAttributes,
                ref: checkboxRef,
                type: "checkbox",
                checked: checked,
                name: name,
                "aria-disabled": readOnly && !disabled ? 'true' : undefined,
                onFocus: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus),
                onBlur: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur),
                // empty handler to suppress React controllability warning
                onChange: ()=>{}
            }),
        onClick: ()=>{
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 || _a.focus();
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                checked: !checked
            });
        },
        styledControl: /*Using span, not div for HTML validity*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-handle'], {
                [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-handle-checked']]: checked,
                [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-handle-disabled']]: disabled,
                [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)['toggle-handle-readonly']]: readOnly
            }),
            style: (0, $04cb277e6383bf1f$export$53f8945824a59225)(style, checked, disabled, readOnly)
        }),
        style: (0, $04cb277e6383bf1f$export$b401c5cdeddba627)(style, checked, disabled, readOnly),
        __internalRootRef: __internalRootRef,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(analyticsMetadata)
    });
});
var $9b746e4e3748705e$export$2e2bcd8739ae039 = $9b746e4e3748705e$var$InternalToggle;



var $01b0d7d1e7a80e3a$export$2e2bcd8739ae039 = {
    "visible-content": "awsui_visible-content_tc96w_via2y_153",
    "visible-content-toggle": "awsui_visible-content-toggle_tc96w_via2y_154",
    "visible-content-groups": "awsui_visible-content-groups_tc96w_via2y_155",
    "visible-content-group": "awsui_visible-content-group_tc96w_via2y_155",
    "visible-content-title": "awsui_visible-content-title_tc96w_via2y_160",
    "visible-content-group-label": "awsui_visible-content-group-label_tc96w_via2y_170",
    "visible-content-option": "awsui_visible-content-option_tc96w_via2y_176",
    "visible-content-option-label": "awsui_visible-content-option-label_tc96w_via2y_189",
    "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_via2y_212",
    "content-display-option-content": "awsui_content-display-option-content_tc96w_via2y_216",
    "content-display-option-label": "awsui_content-display-option-label_tc96w_via2y_256",
    "content-display": "awsui_content-display_tc96w_via2y_212",
    "content-display-text-filter": "awsui_content-display-text-filter_tc96w_via2y_264",
    "content-display-no-match": "awsui_content-display-no-match_tc96w_via2y_265",
    "content-display-title": "awsui_content-display-title_tc96w_via2y_269",
    "content-display-description": "awsui_content-display-description_tc96w_via2y_278",
    "content-display-option-list": "awsui_content-display-option-list_tc96w_via2y_286",
    "root": "awsui_root_tc96w_via2y_293",
    "modal-root": "awsui_modal-root_tc96w_via2y_294",
    "trigger-button": "awsui_trigger-button_tc96w_via2y_295",
    "cancel-button": "awsui_cancel-button_tc96w_via2y_296",
    "confirm-button": "awsui_confirm-button_tc96w_via2y_297",
    "custom": "awsui_custom_tc96w_via2y_298",
    "content-before": "awsui_content-before_tc96w_via2y_299",
    "second-column-small": "awsui_second-column-small_tc96w_via2y_303",
    "wrap-lines": "awsui_wrap-lines_tc96w_via2y_307",
    "striped-rows": "awsui_striped-rows_tc96w_via2y_308",
    "content-density": "awsui_content-density_tc96w_via2y_309",
    "page-size": "awsui_page-size_tc96w_via2y_310",
    "page-size-form-field": "awsui_page-size-form-field_tc96w_via2y_311",
    "page-size-radio-group": "awsui_page-size-radio-group_tc96w_via2y_312",
    "sticky-columns": "awsui_sticky-columns_tc96w_via2y_313",
    "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_via2y_314",
    "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_via2y_315",
    "sticky-columns-first": "awsui_sticky-columns-first_tc96w_via2y_316",
    "sticky-columns-last": "awsui_sticky-columns-last_tc96w_via2y_317"
};


const $d5e9a9b18af560cf$var$componentPrefix = 'content-display-option';
const $d5e9a9b18af560cf$export$307b18b61172f7ed = (suffix)=>(0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[[
        $d5e9a9b18af560cf$var$componentPrefix,
        suffix
    ].filter(Boolean).join('-')];
const $d5e9a9b18af560cf$var$ContentDisplayOption = (0, $acw62.forwardRef)(({ onToggle: onToggle, option: option }, ref)=>{
    const idPrefix = (0, $013a2451794a45c0$exports.useUniqueId)($d5e9a9b18af560cf$var$componentPrefix);
    const controlId = `${idPrefix}-control-${option.id}`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: $d5e9a9b18af560cf$export$307b18b61172f7ed('content')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: $d5e9a9b18af560cf$export$307b18b61172f7ed('label'),
        htmlFor: controlId
    }, option.label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $d5e9a9b18af560cf$export$307b18b61172f7ed('toggle')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b746e4e3748705e$export$2e2bcd8739ae039), {
        checked: !!option.visible,
        onChange: ()=>onToggle && onToggle(option),
        disabled: option.alwaysVisible === true,
        controlId: controlId
    })));
});
var $d5e9a9b18af560cf$export$2e2bcd8739ae039 = $d5e9a9b18af560cf$var$ContentDisplayOption;


function $1d5a598a97527b88$export$859eb1ee842452d4({ options: options, contentDisplay: contentDisplay }) {
    // By using a Map, we are guaranteed to preserve insertion order on future iteration.
    const optionsById = new Map();
    // We insert contentDisplay first so we respect the currently selected order
    for (const { id: id, visible: visible } of contentDisplay)// If an option is provided in contentDisplay and not options, we default the label to the id
    optionsById.set(id, {
        id: id,
        label: id,
        visible: visible
    });
    // We merge options data, and insert any that were not in contentDisplay as non-visible
    for (const option of options){
        const existing = optionsById.get(option.id);
        optionsById.set(option.id, {
            ...option,
            visible: !!(existing === null || existing === void 0 ? void 0 : existing.visible)
        });
    }
    return Array.from(optionsById.values());
}
function $1d5a598a97527b88$export$25a7cbafb6ed84cb(options, filterText) {
    filterText = filterText.trim().toLowerCase();
    if (!filterText) return options;
    return options.filter((option)=>option.label.toLowerCase().trim().includes(filterText));
}



const $4a5066266e744f96$var$componentPrefix = 'content-display';
const $4a5066266e744f96$var$getClassName = (suffix)=>(0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[`${$4a5066266e744f96$var$componentPrefix}-${suffix}`];
function $4a5066266e744f96$export$2e2bcd8739ae039({ title: title, description: description, options: options, value: value = options.map(({ id: id })=>({
        id: id,
        visible: true
    })), onChange: onChange, liveAnnouncementDndStarted: liveAnnouncementDndStarted, liveAnnouncementDndItemReordered: liveAnnouncementDndItemReordered, liveAnnouncementDndItemCommitted: liveAnnouncementDndItemCommitted, liveAnnouncementDndDiscarded: liveAnnouncementDndDiscarded, dragHandleAriaDescription: dragHandleAriaDescription, dragHandleAriaLabel: dragHandleAriaLabel, enableColumnFiltering: enableColumnFiltering = false, i18nStrings: i18nStrings }) {
    const idPrefix = (0, $013a2451794a45c0$exports.useUniqueId)($4a5066266e744f96$var$componentPrefix);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('collection-preferences');
    const [columnFilteringText, setColumnFilteringText] = (0, $acw62.useState)('');
    const titleId = `${idPrefix}-title`;
    const descriptionId = `${idPrefix}-description`;
    const [sortedOptions, sortedAndFilteredOptions] = (0, $acw62.useMemo)(()=>{
        const sorted = (0, $1d5a598a97527b88$export$859eb1ee842452d4)({
            options: options,
            contentDisplay: value
        });
        const filtered = (0, $1d5a598a97527b88$export$25a7cbafb6ed84cb)(sorted, columnFilteringText);
        return [
            sorted,
            filtered
        ];
    }, [
        columnFilteringText,
        options,
        value
    ]);
    const onToggle = (option)=>{
        // We use sortedOptions as base and not value because there might be options that
        // are not in the value yet, so they're added as non-visible after the known ones.
        onChange(sortedOptions.map(({ id: id, visible: visible })=>({
                id: id,
                visible: id === option.id ? !option.visible : visible
            })));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[$4a5066266e744f96$var$componentPrefix],
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('contentDisplay')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        className: $4a5066266e744f96$var$getClassName('title'),
        id: titleId
    }, i18n('contentDisplayPreference.title', title)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: $4a5066266e744f96$var$getClassName('description'),
        id: descriptionId
    }, i18n('contentDisplayPreference.description', description)), enableColumnFiltering && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $4a5066266e744f96$var$getClassName('text-filter')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2b86ff3bde67fdd3$export$2e2bcd8739ae039), {
        filteringText: columnFilteringText,
        filteringPlaceholder: i18n('contentDisplayPreference.i18nStrings.columnFilteringPlaceholder', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.columnFilteringPlaceholder),
        filteringAriaLabel: i18n('contentDisplayPreference.i18nStrings.columnFilteringAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.columnFilteringAriaLabel),
        filteringClearAriaLabel: i18n('contentDisplayPreference.i18nStrings.columnFilteringClearFilterText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.columnFilteringClearFilterText),
        onChange: ({ detail: detail })=>setColumnFilteringText(detail.filteringText),
        countText: i18n('contentDisplayPreference.i18nStrings.columnFilteringCountText', (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.columnFilteringCountText) ? i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.columnFilteringCountText(sortedAndFilteredOptions.length) : undefined, (format)=>format({
                count: sortedAndFilteredOptions.length
            }))
    })), sortedAndFilteredOptions.length === 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $4a5066266e744f96$var$getClassName('no-match')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        size: "s",
        alignItems: "center"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        margin: {
            top: 'm'
        }
    }, i18n('contentDisplayPreference.i18nStrings.columnFilteringNoMatchText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.columnFilteringNoMatchText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        onClick: ()=>setColumnFilteringText('')
    }, i18n('contentDisplayPreference.i18nStrings.columnFilteringClearFilterText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.columnFilteringClearFilterText)))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0399fe4d1a89f30e$export$2e2bcd8739ae039), {
        items: sortedAndFilteredOptions,
        renderItem: (item)=>({
                id: item.id,
                content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5e9a9b18af560cf$export$2e2bcd8739ae039), {
                    option: item,
                    onToggle: onToggle
                }),
                announcementLabel: item.label
            }),
        disableItemPaddings: true,
        sortable: true,
        sortDisabled: columnFilteringText.trim().length > 0,
        onSortingChange: ({ detail: { items: items } })=>{
            onChange(items);
        },
        ariaDescribedby: descriptionId,
        ariaLabelledby: titleId,
        i18nStrings: {
            liveAnnouncementDndStarted: i18n('contentDisplayPreference.liveAnnouncementDndStarted', liveAnnouncementDndStarted, (0, $3e8dbcd4f45d884d$export$c6a6b36ab85a3fbc)),
            liveAnnouncementDndItemReordered: i18n('contentDisplayPreference.liveAnnouncementDndItemReordered', liveAnnouncementDndItemReordered, (0, $3e8dbcd4f45d884d$export$1a85e9c4114850f5)),
            liveAnnouncementDndItemCommitted: i18n('contentDisplayPreference.liveAnnouncementDndItemCommitted', liveAnnouncementDndItemCommitted, (0, $3e8dbcd4f45d884d$export$944f43f20f281623)),
            liveAnnouncementDndDiscarded: i18n('contentDisplayPreference.liveAnnouncementDndDiscarded', liveAnnouncementDndDiscarded),
            dragHandleAriaLabel: i18n('contentDisplayPreference.dragHandleAriaLabel', dragHandleAriaLabel),
            dragHandleAriaDescription: i18n('contentDisplayPreference.dragHandleAriaDescription', dragHandleAriaDescription)
        }
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $466bcaccb2168c42$export$2e2bcd8739ae039 = {
    "css-grid": "awsui_css-grid_zqq3x_1t536_181",
    "grid-no-gutters": "awsui_grid-no-gutters_zqq3x_1t536_192",
    "grid-variant-text-grid": "awsui_grid-variant-text-grid_zqq3x_1t536_195",
    "item": "awsui_item_zqq3x_1t536_195",
    "first-column": "awsui_first-column_zqq3x_1t536_212"
};


const $b2e6cf3da3455bca$var$isOdd = (value)=>value % 2 !== 0;
function $b2e6cf3da3455bca$export$cea2a3d259837e9e(columns, minColumnWidth, containerWidth) {
    if (!containerWidth) return columns;
    // First, calculate how many columns we can have based on the current container width and minColumnWidth.
    const targetColumnCount = Math.min(columns, Math.floor(containerWidth / minColumnWidth));
    // When we start wrapping into fewer columns than desired, we want to keep the number of columns even.
    return Math.max(1, targetColumnCount < columns && $b2e6cf3da3455bca$var$isOdd(targetColumnCount) ? targetColumnCount - 1 : targetColumnCount);
}
function $b2e6cf3da3455bca$export$2e2bcd8739ae039({ columns: columns = 1, minColumnWidth: minColumnWidth = 0, disableGutters: disableGutters, variant: variant, children: children, __tagOverride: __tagOverride }) {
    const [containerWidth, containerRef] = (0, $ecd46a6f96034059$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    const columnCount = $b2e6cf3da3455bca$export$cea2a3d259837e9e(columns, minColumnWidth, containerWidth);
    const shouldDisableGutters = variant !== 'text-grid' && disableGutters;
    // Flattening the children allows us to "see through" React Fragments and nested arrays.
    const flattenedChildren = (0, $ba51633932c6dcad$export$ad59fee0807e8d38)(children, 'ColumnLayout');
    const Tag = __tagOverride !== null && __tagOverride !== void 0 ? __tagOverride : 'div';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ref: containerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $466bcaccb2168c42$export$2e2bcd8739ae039)['css-grid'], (0, $466bcaccb2168c42$export$2e2bcd8739ae039)[`grid-variant-${variant}`], shouldDisableGutters && [
            (0, $466bcaccb2168c42$export$2e2bcd8739ae039)['grid-no-gutters']
        ]),
        style: {
            gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`
        }
    }, flattenedChildren.map((child, i)=>{
        // If this react child is a primitive value, the key will be undefined
        const key = child && typeof child === 'object' ? child.key : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ? String(key) : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $466bcaccb2168c42$export$2e2bcd8739ae039).item, {
                [(0, $466bcaccb2168c42$export$2e2bcd8739ae039)['first-column']]: i % columnCount === 0
            })
        }, child);
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $bf49903cd6edd726$export$76d90c956114f2c2(value, times) {
    const array = [];
    for(let i = 0; i < times; i++)array[i] = value;
    return array;
}



var $fdd0ba291139f043$export$2e2bcd8739ae039 = {
    "column-layout": "awsui_column-layout_vvxn7_u5w81_181",
    "grid": "awsui_grid_vvxn7_u5w81_213",
    "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_u5w81_219",
    "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_u5w81_223",
    "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_u5w81_231",
    "grid-columns-1": "awsui_grid-columns-1_vvxn7_u5w81_234",
    "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_u5w81_234",
    "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_u5w81_237",
    "grid-columns-2": "awsui_grid-columns-2_vvxn7_u5w81_240",
    "grid-columns-3": "awsui_grid-columns-3_vvxn7_u5w81_246",
    "grid-columns-4": "awsui_grid-columns-4_vvxn7_u5w81_252",
    "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_u5w81_268",
    "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_u5w81_301"
};


const $c57194b2cd59a4d0$var$COLUMN_DEFS = {
    1: {
        colspan: {
            default: 12,
            xxs: 12,
            xs: 12
        }
    },
    2: {
        colspan: {
            default: 12,
            xxs: 6,
            xs: 6
        }
    },
    3: {
        colspan: {
            default: 12,
            xxs: 6,
            xs: 4
        }
    },
    4: {
        colspan: {
            default: 12,
            xxs: 6,
            xs: 3
        }
    }
};
function $c57194b2cd59a4d0$export$2e2bcd8739ae039({ columns: columns, variant: variant, borders: borders, disableGutters: disableGutters, __breakpoint: __breakpoint, children: children, __tagOverride: __tagOverride }) {
    var _a;
    const isTextGridVariant = variant === 'text-grid';
    const shouldDisableGutters = !isTextGridVariant && disableGutters;
    const shouldHaveHorizontalBorders = !isTextGridVariant && (borders === 'horizontal' || borders === 'all');
    const shouldHaveVerticalBorders = !isTextGridVariant && (borders === 'vertical' || borders === 'all');
    // Flattening the children allows us to "see through" React Fragments and nested arrays.
    const flattenedChildren = (0, $ba51633932c6dcad$export$ad59fee0807e8d38)(children, 'ColumnLayout');
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)((0, $2ae44e537ec7bbb3$export$5b6623e40ba32802));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), {
        ref: ref,
        disableGutters: true,
        gridDefinition: (0, $bf49903cd6edd726$export$76d90c956114f2c2)((_a = $c57194b2cd59a4d0$var$COLUMN_DEFS[columns]) !== null && _a !== void 0 ? _a : {}, flattenedChildren.length),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fdd0ba291139f043$export$2e2bcd8739ae039).grid, (0, $fdd0ba291139f043$export$2e2bcd8739ae039)[`grid-columns-${columns}`], (0, $fdd0ba291139f043$export$2e2bcd8739ae039)[`grid-variant-${variant}`], {
            [(0, $fdd0ba291139f043$export$2e2bcd8739ae039)['grid-horizontal-borders']]: shouldHaveHorizontalBorders,
            [(0, $fdd0ba291139f043$export$2e2bcd8739ae039)['grid-vertical-borders']]: shouldHaveVerticalBorders,
            [(0, $fdd0ba291139f043$export$2e2bcd8739ae039)['grid-no-gutters']]: shouldDisableGutters
        }),
        __breakpoint: __breakpoint || breakpoint,
        __responsiveClassName: (breakpoint)=>breakpoint && (0, $fdd0ba291139f043$export$2e2bcd8739ae039)[`grid-breakpoint-${breakpoint}`],
        __tagOverride: __tagOverride
    }, children);
}



const $2ae44e537ec7bbb3$export$5b6623e40ba32802 = [
    'default',
    'xxs',
    'xs'
];
function $2ae44e537ec7bbb3$export$2e2bcd8739ae039({ columns: columns = 1, variant: variant = 'default', borders: borders = 'none', disableGutters: disableGutters = false, minColumnWidth: minColumnWidth, children: children, __tagOverride: __tagOverride, __breakpoint: __breakpoint, __internalRootRef: __internalRootRef, ...restProps }) {
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $fdd0ba291139f043$export$2e2bcd8739ae039)['column-layout']),
        ref: __internalRootRef
    }, minColumnWidth ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2e6cf3da3455bca$export$2e2bcd8739ae039), {
        columns: columns,
        borders: borders,
        variant: variant,
        minColumnWidth: minColumnWidth,
        disableGutters: disableGutters,
        __tagOverride: __tagOverride
    }, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c57194b2cd59a4d0$export$2e2bcd8739ae039), {
        columns: columns,
        variant: variant,
        borders: borders,
        disableGutters: disableGutters,
        __breakpoint: __breakpoint,
        __tagOverride: __tagOverride
    }, children));
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $3024c0fa705edd01$export$2e2bcd8739ae039(forwardedRef, items, value) {
    const itemRef = (0, $acw62.useRef)(null);
    const itemIndex = items && items.findIndex((item)=>item.value === value);
    (0, $acw62.useImperativeHandle)(forwardedRef, ()=>({
            focus () {
                var _a;
                (_a = itemRef.current) === null || _a === void 0 || _a.focus();
            }
        }));
    return [
        itemRef,
        itemIndex !== undefined && itemIndex !== -1 ? itemIndex : 0
    ];
}



var $c892304626726ab1$export$2e2bcd8739ae039 = {
    "selected": "awsui_selected_1m93f_14fvl_5"
};



var $a5be326d08ef0873$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1mabk_9xklq_145",
    "radio-group": "awsui_radio-group_1mabk_9xklq_149",
    "horizontal-group": "awsui_horizontal-group_1mabk_9xklq_180",
    "radio": "awsui_radio_1mabk_9xklq_149",
    "horizontal": "awsui_horizontal_1mabk_9xklq_180",
    "radio--has-description": "awsui_radio--has-description_1mabk_9xklq_194"
};



var $6a56ebf44d56b795$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1np5w_1q93l_5"
};


const $9fbcc4fc1615c1e4$var$InternalRadioGroup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ name: name, value: value, items: items, ariaLabel: ariaLabel, ariaRequired: ariaRequired, ariaControls: ariaControls, onChange: onChange, readOnly: readOnly, __internalRootRef: __internalRootRef, style: style, direction: direction, ...props }, ref)=>{
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(props);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const generatedName = (0, $013a2451794a45c0$exports.useUniqueId)('awsui-radio-');
    const [radioButtonRef, radioButtonRefIndex] = (0, $3024c0fa705edd01$export$2e2bcd8739ae039)(ref, items, value);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledby,
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired,
        "aria-controls": ariaControls,
        "aria-readonly": readOnly ? 'true' : undefined,
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $6a56ebf44d56b795$export$2e2bcd8739ae039).root, (0, $a5be326d08ef0873$export$2e2bcd8739ae039).root, (0, $a5be326d08ef0873$export$2e2bcd8739ae039)['radio-group'], direction === 'horizontal' && (0, $a5be326d08ef0873$export$2e2bcd8739ae039)['horizontal-group']),
        ref: __internalRootRef
    }, items && items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ba5898a3f042c33$export$2e2bcd8739ae039), {
            key: item.value,
            ref: index === radioButtonRefIndex ? radioButtonRef : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a5be326d08ef0873$export$2e2bcd8739ae039).radio, item.description && (0, $a5be326d08ef0873$export$2e2bcd8739ae039)['radio--has-description'], direction === 'horizontal' && (0, $a5be326d08ef0873$export$2e2bcd8739ae039).horizontal, item.value === value && (0, $c892304626726ab1$export$2e2bcd8739ae039).selected),
            checked: item.value === value,
            name: name || generatedName,
            value: item.value,
            description: item.description,
            disabled: item.disabled,
            onSelect: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                    value: item.value
                }),
            controlId: item.controlId,
            readOnly: readOnly,
            style: style,
            ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)(!item.disabled && !readOnly ? {
                detail: {
                    position: `${index + 1}`,
                    value: item.value
                }
            } : {})
        }, item.label)));
});
var $9fbcc4fc1615c1e4$export$2e2bcd8739ae039 = $9fbcc4fc1615c1e4$var$InternalRadioGroup;





const $5e0c372fb1280cb8$export$9f13f511f7531527 = ({ pageSize: pageSize, wrapLines: wrapLines, stripedRows: stripedRows, contentDensity: contentDensity, visibleContent: visibleContent, contentDisplay: contentDisplay, stickyColumns: stickyColumns, custom: custom })=>({
        pageSize: pageSize,
        wrapLines: wrapLines,
        stripedRows: stripedRows,
        contentDensity: contentDensity,
        visibleContent: visibleContent,
        contentDisplay: contentDisplay,
        stickyColumns: stickyColumns,
        custom: custom
    });
const $5e0c372fb1280cb8$export$76ff241c87799c99 = (newPref, oldPref)=>{
    const newObj = {
        ...oldPref
    };
    const prefNames = [
        'pageSize',
        'wrapLines',
        'stripedRows',
        'contentDensity',
        'visibleContent',
        'custom',
        'contentDisplay',
        'stickyColumns'
    ];
    for (const prefName of prefNames)if (newPref[prefName] !== undefined) newObj[prefName] = newPref[prefName];
    return newObj;
};
const $5e0c372fb1280cb8$export$c84c03f16c0f8752 = ({ left: left, right: right })=>{
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        'xs'
    ]);
    const smallContainer = breakpoint === 'default';
    const columns = left && right ? 2 : 1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2ae44e537ec7bbb3$export$2e2bcd8739ae039), {
        columns: smallContainer ? 1 : columns,
        variant: "text-grid"
    }, left && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, left), right && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(left && smallContainer && (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['second-column-small'])
    }, right)));
};
const $5e0c372fb1280cb8$export$e7b9797caf42ef5e = ({ title: title, options: options, value: value, onChange: onChange })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('collection-preferences');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['page-size'],
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('pageSize')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        label: i18n('pageSizePreference.title', title),
        stretch: true,
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['page-size-form-field']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9fbcc4fc1615c1e4$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['page-size-radio-group'],
        value: `${value}`,
        items: options.map(({ label: label, value: value })=>({
                label: label,
                value: `${value}`
            })),
        onChange: ({ detail: detail })=>onChange(parseInt(detail.value, 10))
    })));
};
const $5e0c372fb1280cb8$export$9c0f52e17055efc3 = ({ label: label, description: description, value: value, onChange: onChange })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('collection-preferences');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('wrapLines')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        checked: !!value,
        description: i18n('wrapLinesPreference.description', description),
        onChange: ({ detail: detail })=>onChange(detail.checked),
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['wrap-lines']
    }, i18n('wrapLinesPreference.label', label)));
};
function $5e0c372fb1280cb8$export$f467017c5d8daff3({ label: label, description: description, value: value, onChange: onChange }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('collection-preferences');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('stripedRows')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        checked: !!value,
        description: i18n('stripedRowsPreference.description', description),
        onChange: ({ detail: detail })=>onChange(detail.checked),
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['striped-rows']
    }, i18n('stripedRowsPreference.label', label)));
}
const $5e0c372fb1280cb8$export$2b48c4c5210809b9 = ({ label: label, description: description, value: value, onChange: onChange })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('collection-preferences');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('contentDensity')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        checked: value === 'compact',
        description: i18n('contentDensityPreference.description', description),
        onChange: ({ detail: detail })=>onChange(detail.checked ? 'compact' : 'comfortable'),
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['content-density']
    }, i18n('contentDensityPreference.label', label)));
};
const $5e0c372fb1280cb8$var$StickyPreference = ({ firstOrLast: firstOrLast, preference: preference, value: value, onChange: onChange })=>{
    const { title: title, description: description, options: options } = preference;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[`sticky-columns-${firstOrLast}`],
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('stickyColumns')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['sticky-columns-form-field'],
        label: title,
        description: description
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9fbcc4fc1615c1e4$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['sticky-columns-radio-group'],
        value: typeof value !== 'undefined' ? `${value}` : null,
        items: options.map(({ label: label, value: value })=>({
                label: label,
                value: `${value}`
            })),
        onChange: ({ detail: detail })=>onChange(Number(detail.value))
    })));
};
const $5e0c372fb1280cb8$export$7110115eecf52680 = ({ firstColumns: firstColumns, lastColumns: lastColumns, onChange: onChange, value: value })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['sticky-columns'],
        size: "l"
    }, firstColumns && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5e0c372fb1280cb8$var$StickyPreference, {
        firstOrLast: "first",
        preference: firstColumns,
        value: value === null || value === void 0 ? void 0 : value.first,
        onChange: (newValue)=>onChange({
                ...value,
                first: newValue
            })
    }), lastColumns && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5e0c372fb1280cb8$var$StickyPreference, {
        firstOrLast: "last",
        preference: lastColumns,
        value: value === null || value === void 0 ? void 0 : value.last,
        onChange: (newValue)=>onChange({
                ...value,
                last: newValue
            })
    }));
};
const $5e0c372fb1280cb8$export$71d19cc08e222f47 = ({ value: value, customPreference: customPreference, onChange: onChange })=>{
    const [customState, setCustomState] = (0, $acw62.useState)(value);
    if (customPreference) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039).custom,
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('custom')
    }, customPreference(customState, (value)=>{
        // prevent value to be treated as a functional callback
        setCustomState(()=>value);
        onChange(value);
    }));
    return null;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





const $1d0e079a04a15fe6$var$isVisible = (id, visibleIds)=>visibleIds.indexOf(id) !== -1;
const $1d0e079a04a15fe6$var$className = (suffix)=>({
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[`visible-content-${suffix}`]
    });
function $1d0e079a04a15fe6$export$2e2bcd8739ae039({ title: title, options: options, value: value = [], onChange: onChange }) {
    const idPrefix = (0, $013a2451794a45c0$exports.useUniqueId)('visible-content');
    const flatOptionsIds = options.flatMap((group)=>group.options.map((option)=>option.id));
    const onToggle = (id)=>{
        if (!$1d0e079a04a15fe6$var$isVisible(id, value)) onChange([
            ...value,
            id
        ].sort((firstId, secondId)=>flatOptionsIds.indexOf(firstId) - flatOptionsIds.indexOf(secondId)));
        else onChange(value.filter((currentId)=>currentId !== id));
    };
    const selectionOption = (option, optionGroupIndex, optionIndex)=>{
        const labelId = `${idPrefix}-${optionGroupIndex}-${optionIndex}`;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: optionIndex,
            ...$1d0e079a04a15fe6$var$className('option')
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            ...$1d0e079a04a15fe6$var$className('option-label'),
            htmlFor: labelId
        }, option.label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...$1d0e079a04a15fe6$var$className('toggle')
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b746e4e3748705e$export$2e2bcd8739ae039), {
            checked: $1d0e079a04a15fe6$var$isVisible(option.id, value),
            onChange: ()=>onToggle(option.id),
            disabled: option.editable === false,
            controlId: labelId
        })));
    };
    const outerGroupLabelId = `${idPrefix}-outer`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['visible-content'],
        ...(0, $374ef58330490142$export$fa742f6408a1b36b)('visibleContent')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        ...$1d0e079a04a15fe6$var$className('title'),
        id: outerGroupLabelId
    }, title), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        ...$1d0e079a04a15fe6$var$className('groups'),
        size: "xs"
    }, options.map((optionGroup, optionGroupIndex)=>{
        const groupLabelId = `${idPrefix}-${optionGroupIndex}`;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: optionGroupIndex,
            ...$1d0e079a04a15fe6$var$className('group'),
            role: "group",
            "aria-labelledby": `${outerGroupLabelId} ${groupLabelId}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...$1d0e079a04a15fe6$var$className('group-label'),
            id: groupLabelId
        }, optionGroup.label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, optionGroup.options.map((option, optionIndex)=>selectionOption(option, optionGroupIndex, optionIndex))));
    })));
}




'use client';
const $5c1f45487ee29a3a$var$componentName = 'CollectionPreferences';
function $5c1f45487ee29a3a$export$2e2bcd8739ae039({ title: title, confirmLabel: confirmLabel, cancelLabel: cancelLabel, closeAriaLabel: closeAriaLabel, disabled: disabled = false, onConfirm: onConfirm, onCancel: onCancel, visibleContentPreference: visibleContentPreference, contentDisplayPreference: contentDisplayPreference, pageSizePreference: pageSizePreference, wrapLinesPreference: wrapLinesPreference, stripedRowsPreference: stripedRowsPreference, contentDensityPreference: contentDensityPreference, stickyColumnsPreference: stickyColumnsPreference, preferences: preferences, customPreference: customPreference, getModalRoot: getModalRoot, removeModalRoot: removeModalRoot, contentBefore: contentBefore, ...rest }) {
    var _a;
    const parentMetadata = (0, $acw62.useContext)((0, $5b10d779002c4c5b$export$69e2f3b88d2c5d7));
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)('CollectionPreferences', {
        props: {},
        metadata: {
            ...parentMetadata,
            hasStripedRowsPreference: !!stripedRowsPreference,
            hasVisibleContentPreference: !!visibleContentPreference,
            hasContentDisplayPreference: !!contentDisplayPreference,
            hasContentDensityPreference: !!contentDensityPreference,
            hasStickyColumnsPreference: !!stickyColumnsPreference,
            hasContentDisplayColumnFiltering: !!(contentDisplayPreference === null || contentDisplayPreference === void 0 ? void 0 : contentDisplayPreference.enableColumnFiltering),
            visibleContentOptionsCount: (_a = visibleContentPreference === null || visibleContentPreference === void 0 ? void 0 : visibleContentPreference.options) === null || _a === void 0 ? void 0 : _a.length
        }
    });
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)('CollectionPreferences', 'preferences', preferences, 'onConfirm', onConfirm);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('collection-preferences');
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const [modalVisible, setModalVisible] = (0, $acw62.useState)(false);
    const [temporaryPreferences, setTemporaryPreferences] = (0, $acw62.useState)((0, $5e0c372fb1280cb8$export$9f13f511f7531527)(preferences || {}));
    const triggerRef = (0, $acw62.useRef)(null);
    const dialogPreviouslyOpen = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (!modalVisible) {
            if (dialogPreviouslyOpen.current) (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
        } else dialogPreviouslyOpen.current = true;
    }, [
        modalVisible
    ]);
    const onConfirmListener = ()=>{
        setModalVisible(false);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onConfirm, temporaryPreferences);
    };
    const onCancelListener = ()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onCancel, {});
        setModalVisible(false);
        setTemporaryPreferences((0, $5e0c372fb1280cb8$export$9f13f511f7531527)(preferences || {}));
    };
    const hasContentOnTheLeft = !!(pageSizePreference || wrapLinesPreference || stripedRowsPreference || contentDensityPreference || stickyColumnsPreference || customPreference);
    const hasContentOnTheRight = !!(visibleContentPreference || contentDisplayPreference);
    const onChange = (changedPreferences)=>setTemporaryPreferences((0, $5e0c372fb1280cb8$export$76ff241c87799c99)(changedPreferences, temporaryPreferences));
    if (visibleContentPreference && contentDisplayPreference) (0, $013a2451794a45c0$exports.warnOnce)($5c1f45487ee29a3a$var$componentName, 'You provided both `visibleContentPreference` and `contentDisplayPreference` props. `visibleContentPreference` will be ignored and only `contentDisplayPreference` will be rendered.');
    const referrerId = (0, $013a2451794a45c0$exports.useUniqueId)();
    const tableComponentContext = (0, $83cc797b0d9c18d5$export$b4130bf0cd295245)();
    (0, $acw62.useEffect)(()=>{
        var _a;
        if ((_a = tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.preferencesRef) === null || _a === void 0 ? void 0 : _a.current) {
            tableComponentContext.preferencesRef.current.pageSize = preferences === null || preferences === void 0 ? void 0 : preferences.pageSize;
            // When both are used contentDisplayPreference takes preference and so we always prefer to use this as our visible columns if available
            if (preferences === null || preferences === void 0 ? void 0 : preferences.contentDisplay) tableComponentContext.preferencesRef.current.visibleColumns = preferences === null || preferences === void 0 ? void 0 : preferences.contentDisplay.filter((column)=>column.visible).map((column)=>column.id);
            else if (preferences === null || preferences === void 0 ? void 0 : preferences.visibleContent) tableComponentContext.preferencesRef.current.visibleColumns = [
                ...preferences.visibleContent
            ];
            return ()=>{
                var _a, _b;
                (_a = tableComponentContext.preferencesRef.current) === null || _a === void 0 || delete _a.pageSize;
                (_b = tableComponentContext.preferencesRef.current) === null || _b === void 0 || delete _b.visibleColumns;
            };
        }
    }, [
        tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.preferencesRef,
        preferences === null || preferences === void 0 ? void 0 : preferences.contentDisplay,
        preferences === null || preferences === void 0 ? void 0 : preferences.visibleContent,
        preferences === null || preferences === void 0 ? void 0 : preferences.pageSize
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039).root),
        ref: __internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: referrerId,
        ...(0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
            component: (0, $374ef58330490142$export$1191c14690122a68)(disabled, preferences)
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: triggerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['trigger-button'], (0, $2ed802fee1ac7f1b$export$2e2bcd8739ae039)['trigger-button']),
        disabled: disabled,
        ariaLabel: i18n('title', title),
        onClick: ()=>{
            setTemporaryPreferences((0, $5e0c372fb1280cb8$export$9f13f511f7531527)(preferences || {}));
            setModalVisible(true);
        },
        variant: "icon",
        iconName: "settings",
        formAction: "none",
        analyticsAction: "open"
    }), !disabled && modalVisible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a5bb8d240e2baab$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['modal-root'],
        visible: true,
        getModalRoot: getModalRoot,
        removeModalRoot: removeModalRoot,
        header: i18n('title', title),
        referrerId: referrerId,
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
            float: "right"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
            direction: "horizontal",
            size: "xs"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['cancel-button'],
            variant: "link",
            formAction: "none",
            onClick: onCancelListener,
            analyticsAction: "cancel"
        }, i18n('cancelLabel', cancelLabel)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['confirm-button'],
            variant: "primary",
            formAction: "none",
            onClick: onConfirmListener,
            analyticsAction: "confirm"
        }, i18n('confirmLabel', confirmLabel)))),
        closeAriaLabel: closeAriaLabel || cancelLabel,
        size: hasContentOnTheLeft && hasContentOnTheRight ? 'large' : 'medium',
        onDismiss: onCancelListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)['content-before']
    }, contentBefore), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$c84c03f16c0f8752), {
        left: hasContentOnTheLeft && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
            size: "l"
        }, pageSizePreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$e7b9797caf42ef5e), {
            value: temporaryPreferences.pageSize,
            ...pageSizePreference,
            onChange: (pageSize)=>onChange({
                    pageSize: pageSize
                })
        }), wrapLinesPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$9c0f52e17055efc3), {
            value: temporaryPreferences.wrapLines,
            ...wrapLinesPreference,
            onChange: (wrapLines)=>onChange({
                    wrapLines: wrapLines
                })
        }), stripedRowsPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$f467017c5d8daff3), {
            value: temporaryPreferences.stripedRows,
            ...stripedRowsPreference,
            onChange: (stripedRows)=>onChange({
                    stripedRows: stripedRows
                })
        }), contentDensityPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$2b48c4c5210809b9), {
            value: temporaryPreferences.contentDensity,
            ...contentDensityPreference,
            onChange: (contentDensity)=>onChange({
                    contentDensity: contentDensity
                })
        }), stickyColumnsPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$7110115eecf52680), {
            value: temporaryPreferences.stickyColumns,
            ...stickyColumnsPreference,
            onChange: (stickyColumns)=>onChange({
                    stickyColumns: stickyColumns
                })
        }), customPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$71d19cc08e222f47), {
            value: temporaryPreferences.custom,
            customPreference: customPreference,
            onChange: (custom)=>onChange({
                    custom: custom
                })
        })),
        right: contentDisplayPreference ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a5066266e744f96$export$2e2bcd8739ae039), {
            ...contentDisplayPreference,
            value: temporaryPreferences.contentDisplay,
            onChange: (contentDisplay)=>onChange({
                    contentDisplay: contentDisplay
                })
        }) : visibleContentPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1d0e079a04a15fe6$export$2e2bcd8739ae039), {
            value: temporaryPreferences.visibleContent,
            ...visibleContentPreference,
            onChange: (visibleItems)=>onChange({
                    visibleContent: visibleItems
                })
        })
    }))));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($5c1f45487ee29a3a$export$2e2bcd8739ae039, $5c1f45487ee29a3a$var$componentName);


function $a89636bbaa439431$export$d5a7fa40d422cbcd({ preferences: preferences, setPreferences: setPreferences, columnDisplayPreferenceOptions: columnDisplayPreferenceOptions }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c1f45487ee29a3a$export$2e2bcd8739ae039), {
        title: "Preferences",
        confirmLabel: "Confirm",
        cancelLabel: "Cancel",
        preferences: preferences,
        onConfirm: ({ detail: detail })=>setPreferences(detail),
        pageSizePreference: {
            title: "Page size",
            options: [
                {
                    value: 10,
                    label: "10 items"
                },
                {
                    value: 20,
                    label: "20 items"
                },
                {
                    value: 50,
                    label: "50 items"
                },
                {
                    value: 100,
                    label: "100 items"
                }
            ]
        },
        wrapLinesPreference: {
            label: "Wrap lines",
            description: "Select to see all the text and wrap the lines"
        },
        stripedRowsPreference: {
            label: "Striped rows",
            description: "Select to add alternating shaded rows"
        },
        contentDensityPreference: {
            label: "Compact mode",
            description: "Select to display content in a denser, more compact mode"
        },
        contentDisplayPreference: {
            title: "Column preferences",
            description: "Customize the columns visibility and order.",
            options: columnDisplayPreferenceOptions
        },
        // customPreference={(customValue, setCustomValue) => (
        //   <Checkbox
        //     checked={customValue}
        //     onChange={({ detail }) => setCustomValue(detail.checked)}
        //   >
        //     Custom field
        //   </Checkbox>
        // )}
        stickyColumnsPreference: {
            firstColumns: {
                title: "Stick first column(s)",
                description: "Keep the first column(s) visible while horizontally scrolling the table content.",
                options: [
                    {
                        label: "None",
                        value: 0
                    },
                    {
                        label: "First column",
                        value: 1
                    },
                    {
                        label: "First two columns",
                        value: 2
                    }
                ]
            },
            lastColumns: {
                title: "Stick last column",
                description: "Keep the last column visible while horizontally scrolling the table content.",
                options: [
                    {
                        label: "None",
                        value: 0
                    },
                    {
                        label: "Last column",
                        value: 1
                    }
                ]
            }
        }
    });
}







var $acw62 = parcelRequire("acw62");






const $93fef701c169bd1e$var$MenuContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $93fef701c169bd1e$export$7ce43d0a8f00d826 = /*#__PURE__*/ function(ColumnType) {
    ColumnType[ColumnType["String"] = 0] = "String";
    ColumnType[ColumnType["Boolean"] = 1] = "Boolean";
    ColumnType[ColumnType["Button"] = 2] = "Button";
    ColumnType[ColumnType["Link"] = 3] = "Link";
    ColumnType[ColumnType["Hidden"] = 4] = "Hidden";
    ColumnType[ColumnType["Date"] = 5] = "Date";
    ColumnType[ColumnType["CheckBox"] = 6] = "CheckBox";
    return ColumnType;
}({});
var $93fef701c169bd1e$var$ColumnDisplay = /*#__PURE__*/ function(ColumnDisplay) {
    ColumnDisplay[ColumnDisplay["Show"] = 0] = "Show";
    ColumnDisplay[ColumnDisplay["Hide"] = 1] = "Hide";
    return ColumnDisplay;
}($93fef701c169bd1e$var$ColumnDisplay || {});
var $93fef701c169bd1e$var$ConditionComparison = /*#__PURE__*/ function(ConditionComparison) {
    ConditionComparison[ConditionComparison["Equals"] = 0] = "Equals";
    ConditionComparison[ConditionComparison["NotEquals"] = 1] = "NotEquals";
    ConditionComparison[ConditionComparison["Contains"] = 2] = "Contains";
    ConditionComparison[ConditionComparison["IsNotNull"] = 3] = "IsNotNull";
    ConditionComparison[ConditionComparison["IsNull"] = 4] = "IsNull";
    ConditionComparison[ConditionComparison["GreaterThan"] = 5] = "GreaterThan";
    ConditionComparison[ConditionComparison["GreaterThanOrEqual"] = 6] = "GreaterThanOrEqual";
    ConditionComparison[ConditionComparison["LessThan"] = 7] = "LessThan";
    ConditionComparison[ConditionComparison["LessThanOrEqual"] = 8] = "LessThanOrEqual";
    return ConditionComparison;
}($93fef701c169bd1e$var$ConditionComparison || {});
const $93fef701c169bd1e$var$MapMenuItemsToSideNavItems = (items, root = true)=>{
    const results = [];
    if (root) results.push({
        text: "Home",
        href: "/",
        type: "link"
    });
    for(let i = 0; i < items?.length; i++){
        const item = items[i];
        if (item.SubMenus && item.SubMenus.length > 0) {
            const sectionItem = {
                text: item.Name,
                type: "section",
                defaultExpanded: false,
                items: $93fef701c169bd1e$var$MapMenuItemsToSideNavItems(item.SubMenus, false)
            };
            results.push(sectionItem);
        } else //href: "#/view" + item.Event, // TODO: Make open in new tab on menu also work
        results.push({
            text: item.Name,
            href: "/" + item.Id,
            type: "link"
        });
    }
    return results;
};
const $93fef701c169bd1e$var$MapMenuItemToAppMenuItem = (items, path = "")=>{
    if (!items) return [];
    return items.map((item)=>({
            path: path + "/" + item.Id,
            href: item.Id,
            id: item.Id,
            name: item.Name,
            parentMenu: null,
            subMenus: [
                {
                    id: "#back",
                    event: null,
                    position: 0,
                    canDelete: false,
                    href: "#back/" + item.Id,
                    name: "<<",
                    parentMenu: null,
                    path: "",
                    subMenus: []
                },
                ...$93fef701c169bd1e$var$MapMenuItemToAppMenuItem(item.SubMenus, path + "/" + item.Id)
            ],
            event: item.Event,
            position: item.Position,
            canDelete: item.CanDelete
        }));
};
const $93fef701c169bd1e$export$62b22d151866115d = ({ children: children })=>{
    const [appMenuItems, setAppMenuItems] = (0, $acw62.useState)([]);
    const [sideNavMenuItems, setSideNavMenuItems] = (0, $acw62.useState)([]);
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const { setCurrentContentType: setCurrentContentType, isReady: mainAppIsReady, showComponent: showComponent } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const loadMenus = async ()=>{
        const menuData = await api.makeApiCall("getUserMenu", "GET");
        const menuItems = $93fef701c169bd1e$var$MapMenuItemToAppMenuItem(menuData, "");
        const sideNavItems = $93fef701c169bd1e$var$MapMenuItemsToSideNavItems(menuData);
        setAppMenuItems(menuItems);
        setSideNavMenuItems(sideNavItems);
    };
    const onHomeClick = async ()=>{
        showComponent({
            menu: null,
            type: "home"
        });
        setCurrentContentType("default");
    };
    (0, $acw62.useEffect)(()=>{
        if (auth.isAuthenticated === true) loadMenus();
        else {
            setAppMenuItems([]);
            setSideNavMenuItems([]);
        }
    }, [
        auth.isAuthenticated
    ]);
    const checkPredefinedActions = async ()=>{
        if (window.location.search.includes("anonAction")) {
            const url = new URL(window.location.href);
            const action = url.searchParams.get("anonAction");
            const params = url.searchParams.get("params");
            await onMenuClick(parseInt(action), params);
            return;
        }
        if (window.location.search.includes("confirmed")) {
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "success",
                content: `"Thank you for confirming you email address. You can now log in using your username and password"`
            }));
            const url = new URL(window.location.href);
            url.searchParams.delete("confirmed");
            window.history.pushState(null, "", url.toString());
        }
    };
    (0, $acw62.useEffect)(()=>{
        checkPredefinedActions();
    }, [
        mainAppIsReady
    ]);
    const value = {
        appMenuItems: appMenuItems,
        sideNavMenuItems: sideNavMenuItems,
        onHomeClick: onHomeClick
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($93fef701c169bd1e$var$MenuContext.Provider, {
        value: value,
        children: children
    });
};
const $93fef701c169bd1e$export$38eaa17faae8f579 = ()=>{
    const context = (0, $acw62.useContext)($93fef701c169bd1e$var$MenuContext);
    if (!context) throw new Error("useMenu must be used within an MenuProvider");
    return context;
};


const $e8a5e1b6e0aac306$var$parseColumnName = (columnName, data)=>{
    let value = "";
    if (columnName != null && columnName.length > 0) {
        value = data;
        var colName = columnName;
        while(colName.indexOf(".") > -1){
            var index = colName.indexOf(".");
            var partName = colName.substring(0, index);
            if (value == null) break;
            value = value[partName];
            colName = colName.substring(index + 1);
        }
        if (value != null) value = value[colName];
    }
    return value;
};
const $e8a5e1b6e0aac306$var$isConditionMet = (condition, actualValue)=>{
    var colName = condition.ColumnName;
    var comparison = condition.Comparison;
    var colVal = condition.ColumnValue;
    var compareResult = true;
    switch(comparison){
        case 0:
            return actualValue == colVal;
        case 1:
            return actualValue != colVal;
        case 2:
            return actualValue.toLowerCase().indexOf(colVal.toLowerCase()) > -1;
        case 3:
            return actualValue != null && actualValue.length > 0;
        case 4:
            return actualValue == null || actualValue.length == 0;
        case 5:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue > colVal;
        case 6:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue >= colVal;
        case 7:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue < colVal;
        case 8:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue <= colVal;
        default:
            //todo: show an error somewhere
            console.error("Unknown condition comparison type: " + comparison);
            break;
    }
    return compareResult;
};
const $e8a5e1b6e0aac306$export$9befa2eca56ffc88 = ({ rowData: rowData, column: column })=>{
    if (column.ColumnSetting != null) {
        if (column.ColumnSetting.ColumnSettingType == 0) {
            /// Show/Hide column
            var show = column.ColumnSetting.Display == 0;
            var compareResult = true;
            for(var p = 0; p < column.ColumnSetting.Conditions.length; p++){
                var condition = column.ColumnSetting.Conditions[p];
                var colName = condition.ColumnName;
                var actualValue = $e8a5e1b6e0aac306$var$parseColumnName(colName, rowData) + "";
                compareResult = compareResult && $e8a5e1b6e0aac306$var$isConditionMet(condition, actualValue);
            }
            if (compareResult == false && show == true || compareResult == true && show == false) return false;
        }
    }
    return true;
};




const $3a99089bf7fdc291$export$1724f667738c6e1d = ()=>{
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const modal = (0, $5dbc399a9d723999$export$33ffd74ebf07f060)();
    const handleViewEvent = async (column, rowData, menu)=>{
        const id = rowData[column.KeyColumn];
        const params = column.ParametersToPass || {};
        params["ViewId"] = menu.Id;
        params["RowId"] = id;
        const formData = {
            Id: id,
            data: rowData,
            viewSettings: "",
            //parameters: theColumn.ParametersToPass,
            parameters: params,
            eventParameters: menu.EventParameters
        };
        if (menu.ActionType == 7) {
            const eventId = column.Event == null ? column.EventNumber : column.Event.EventNumber;
            // execute ui action
            await onMenuClick(eventId, formData);
        } else if (column.Event == null || column.Event.ActionType == 6) {
            const eventId = column.Event == null ? column.EventNumber : column.Event.EventNumber;
            // execute ui action
            await onMenuClick(eventId, formData);
        } else if (column.Event.ActionType == 5) {
            // show message
            const data = formData || {};
            data["parameters"] = params;
            const res = await modal.getUserConfirmation(column.Event, data);
            if (res === true && column.Event.OnConfirmationUIAction > 0) await onMenuClick(column.Event.OnConfirmationUIAction, data);
            else if (res === false && column.Event.OnCancelUIAction > 0) await onMenuClick(column.Event.OnCancelUIAction, data);
        }
    };
    return {
        handleViewEvent: handleViewEvent
    };
};


const $9f358e506d11489c$var$ColButton = ({ rowData: rowData, column: column, onClick: onClick })=>{
    const visible = (0, $e8a5e1b6e0aac306$export$9befa2eca56ffc88)({
        rowData: rowData,
        column: column
    });
    const { handleViewEvent: handleViewEvent } = (0, $3a99089bf7fdc291$export$1724f667738c6e1d)();
    let label = column.ColumnLabel;
    if (column.ColumnType == (0, $93fef701c169bd1e$export$7ce43d0a8f00d826).Button || column.ColumnType == (0, $93fef701c169bd1e$export$7ce43d0a8f00d826).Link) label = column.LinkLabel;
    const buttonClick = async ()=>{
        await onClick(column, rowData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            opacity: visible ? 1 : 0,
            display: "flex",
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
            variant: column.ColumnType == (0, $93fef701c169bd1e$export$7ce43d0a8f00d826).Link ? "inline-link" : "normal",
            onClick: buttonClick,
            wrapText: false,
            disabled: visible ? false : true,
            children: label
        })
    });
};
const $9f358e506d11489c$export$332bbb895017705d = ({ rowData: rowData, columns: columns, onClick: onClick })=>{
    if (!columns || columns.length == 0) return "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
        float: "right",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            direction: "horizontal",
            size: "xl",
            children: columns// .filter((c) => showColumn({ rowData, column: c }))
            .map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f358e506d11489c$var$ColButton, {
                    rowData: rowData,
                    column: c,
                    onClick: onClick
                }, i))
        })
    });
};



const $14c1dd08e5f1280b$var$getNestedValue = (data, path)=>{
    return path.split(".").reduce((partValue, subPath)=>partValue && partValue[subPath], data);
};
const $14c1dd08e5f1280b$export$ff93575ad9700188 = ({ rowData: rowData, column: column })=>{
    let colVal = $14c1dd08e5f1280b$var$getNestedValue(rowData, column.ColumnName);
    if ((0, $e8a5e1b6e0aac306$export$9befa2eca56ffc88)({
        rowData: rowData,
        column: column
    })) {
        if (column.ColumnType == 1) {
            if (colVal == true) colVal = column.TrueValueDisplay;
            else if (colVal == false) colVal = column.FalseValueDisplay;
        }
    } else colVal = "";
    return colVal + ""; // else booleans don't show
};






var $7efd313040cb9ee6$exports = {};
var $e277a64de4eeade6$exports = {};
var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;


var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};

var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, 'create');
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, 'Map');
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8d50e526a9e9b7fa$exports,
        'map': new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        'string': new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype['delete'] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $6b5a5095e0934938$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;




var $f504n = parcelRequire("f504n");
var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};

var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, 'DataView');
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, 'Promise');
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, 'Set');
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, 'WeakMap');
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};

var $d299ac421c05c135$exports = {};

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;



var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == 'object') return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $b613e194c1b157de$exports = {};
var $35fa3296f177aa01$exports = {};
var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $f03eae3721f9ace8$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$ac2c42592aa05543$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f03eae3721f9ace8$exports = $f03eae3721f9ace8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $f03eae3721f9ace8$exports($34edfba366a0cfa1$exports);
$35fa3296f177aa01$exports = $35fa3296f177aa01$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $ac2c42592aa05543$exports(collection) ? Array(collection.length) : [];
    $35fa3296f177aa01$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$b613e194c1b157de$exports = $b613e194c1b157de$var$baseMap;


var $6f370ce7a904568e$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$6f370ce7a904568e$exports = $6f370ce7a904568e$var$baseSortBy;



var $b53b4bd61680c3b6$exports = {};
var $13e53edf809f77b7$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $6b5a5095e0934938$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $6b5a5095e0934938$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$13e53edf809f77b7$exports = $13e53edf809f77b7$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $13e53edf809f77b7$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$b53b4bd61680c3b6$exports = $b53b4bd61680c3b6$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
        if ($0488fde9aa355453$exports(iteratee)) return function(value) {
            return $fd2d90f592c63519$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $37dff9aa04444f9c$exports
    ];
    var index = -1;
    iteratees = $d26d80da1ba3948c$exports(iteratees, $692cb5474f422969$exports($5aba4f6d9f8304a3$exports));
    var result = $b613e194c1b157de$exports(collection, function(value, key, collection) {
        var criteria = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $6f370ce7a904568e$exports(result, function(object, other) {
        return $b53b4bd61680c3b6$exports(object, other, orders);
    });
}
$e277a64de4eeade6$exports = $e277a64de4eeade6$var$baseOrderBy;



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $7efd313040cb9ee6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$0488fde9aa355453$exports(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$0488fde9aa355453$exports(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $e277a64de4eeade6$exports(collection, iteratees, orders);
}
$7efd313040cb9ee6$exports = $7efd313040cb9ee6$var$orderBy;


// Function to create a default column
const $98339aa869f255f6$var$createDefaultColumn = ({ id: id })=>({
        id: id,
        visible: true
    });
const $98339aa869f255f6$var$getDefaultPreference = (columns)=>{
    return {
        stickyColumns: {
            first: 0,
            last: 0
        },
        contentDisplay: columns.map((c)=>$98339aa869f255f6$var$createDefaultColumn(c)),
        pageSize: 20
    };
};
// Function to check if a column exists in the provided definitions
const $98339aa869f255f6$var$isColumnInDefinitions = (column, definitions)=>definitions.some((definition)=>definition.id === column.id);
const $98339aa869f255f6$var$test = {
    Name: "Department 1",
    Id: "03956867-301d-4758-8a49-89b69508752a",
    CanDelete: true
};
const $98339aa869f255f6$export$73903224e3a9e478 = ({ menuItem: menuItem, isEmbedded: isEmbedded = false, defaultData: defaultData = null, handleOnActionColumnClick: handleOnActionColumnClick = ()=>{
    return Promise.resolve();
} })=>{
    const { appName: appName, setSelectedTableRow: setSelectedTableRow, displayStack: displayStack, selectedRow: selectedRow } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const { handleViewEvent: handleViewEvent } = (0, $3a99089bf7fdc291$export$1724f667738c6e1d)();
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [columnDefinitions, setColumnDefinitions] = (0, $acw62.useState)([]);
    const [tableItems, setTableItems] = (0, $acw62.useState)([]);
    const [selectedItems, setSelectedItems] = (0, $acw62.useState)(selectedRow?.rowData ? [
        selectedRow?.rowData
    ] : []);
    //const [selectedRow, setSelectedRow] = useState<any>({});
    const [sortingColumn, setSortingColumn] = (0, $acw62.useState)(null);
    const [sortingDescending, setSortingDescending] = (0, $acw62.useState)(false);
    const onSortingChange = ({ detail: { isDescending: isDescending, sortingColumn: sortingColumn } })=>{
        setSortingDescending(Boolean(isDescending));
        setSortingColumn(sortingColumn);
        if (isEmbedded == false) doReload(filterText, null, sortingColumn.sortingField, !isDescending);
        else {
            const sortedItems = (0, (/*@__PURE__*/$parcel$interopDefault($7efd313040cb9ee6$exports)))([
                ...tableItems
            ], sortingColumn.sortingField, isDescending ? "desc" : "asc");
            setTableItems(sortedItems);
        }
    };
    const [viewSettings, setViewSettings] = (0, $acw62.useState)({
        totalLines: -1,
        currentPage: 1,
        pageCount: 1
    });
    const [filterText, setFilterText] = (0, $acw62.useState)("");
    const [viewMenu, setViewMenu] = (0, $acw62.useState)([]);
    const [preferences, setPreferences] = (0, $acw62.useState)({
        pageSize: 20,
        contentDisplay: [],
        stickyColumns: {
            first: 0,
            last: 0
        }
    });
    const preferenceKey = appName + "_" + menuItem?.Id + "_preference_cache";
    const filterKey = appName + "_" + menuItem?.Id + "_filter_cache";
    const columnPreferenceKey = appName + "_" + menuItem?.Id + "_column_preference_cache";
    const updateFilterValue = (value)=>{
        localStorage.setItem(filterKey, value);
        setFilterText(value);
        if (value == null || value.length == 0) localStorage.removeItem(filterKey);
    };
    const updateColumnPreferences = (value)=>{
        const savedColumnPreferenceString = localStorage.getItem(columnPreferenceKey);
        let newColumnPreferences = {};
        if (savedColumnPreferenceString) newColumnPreferences = JSON.parse(savedColumnPreferenceString);
        for(let i = 0; i < columnDefinitions.length; i++){
            const colDef = columnDefinitions[i];
            newColumnPreferences[colDef.id] = value.widths[i];
        }
        localStorage.setItem(columnPreferenceKey, JSON.stringify(newColumnPreferences));
    };
    const updatePreferences = (value)=>{
        localStorage.setItem(preferenceKey, JSON.stringify(value));
        let currentPage = viewSettings.currentPage;
        if (value.pageSize > preferences.pageSize) currentPage = 1;
        setViewSettings({
            ...viewSettings,
            currentPage: currentPage
        });
        setPreferences(value);
    };
    const doReload = async (filter = "", _viewSettings = null, sortColumn = "", sortAscending = true)=>{
        await retrieveData(filter, _viewSettings || viewSettings, sortColumn, sortAscending);
    };
    const retrieveData = async (filter = "", _viewSettings, sortColumn = "", sortAscending = true)=>{
        setLoading(true);
        try {
            let data = {
                Data: {
                    viewSettings: {
                        currentPage: _viewSettings.currentPage,
                        linesPerPage: preferences.pageSize,
                        totalLines: -1
                    },
                    filter: filter,
                    sortColumn: sortColumn,
                    sortAscending: sortAscending,
                    parameters: menuItem.Parameters,
                    eventParameters: menuItem.EventParameters
                }
            };
            if (isEmbedded) data = {
                Data: defaultData
            };
            const viewData = await api.makeApiCall("updateViewData/" + menuItem.Id, "POST", data);
            if (viewData && viewData.ViewData) updateItems(viewData.ViewData, _viewSettings.currentPage);
        } catch (err) {
            console.log("error loading data");
            console.log(err);
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (defaultData != null) updateItems(defaultData);
    }, [
        defaultData
    ]);
    const updateItems = (data, pageNumber = 1)=>{
        setTableItems(data);
    //updateCounts(data.length, pageNumber);
    };
    const onActionColumnClick = async (column, rowData)=>{
        setLoading(true);
        try {
            await handleOnActionColumnClick(column, rowData);
            await handleViewEvent(column, rowData, column);
            if (isEmbedded) doRefresh();
        } finally{
            setLoading(false);
        }
    };
    const loadConfig = async ()=>{
        const columnsToShow = menuItem?.Columns?.filter((c)=>c.ColumnType == 0 || c.ColumnType == 1);
        const actionColumnsToShow = menuItem?.Columns?.filter((c)=>c.ColumnType == 2 || c.ColumnType == 3);
        const hiddenColumns = menuItem?.Columns?.filter((c)=>c.ColumnType == 4); // not sure if we need to do anything with this
        // 5-date, 6-checkbox // maybe later can format and do other stuff
        if (!columnsToShow) return;
        const savedPreferencesString = localStorage.getItem(preferenceKey);
        const savedColumnPreferenceString = localStorage.getItem(columnPreferenceKey);
        let defaultColumnPreferences = {};
        if (savedColumnPreferenceString) defaultColumnPreferences = JSON.parse(savedColumnPreferenceString);
        const viewColumns = columnsToShow.map((c)=>({
                id: c.ColumnName,
                header: c.ColumnLabel,
                cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14c1dd08e5f1280b$export$ff93575ad9700188), {
                        rowData: row,
                        column: c
                    }),
                width: defaultColumnPreferences[c.ColumnName] || 250,
                sortingField: c.ColumnName.includes(".") ? null : c.ColumnName
            }));
        const cols = [
            ...viewColumns
        ];
        if (actionColumnsToShow.length > 0) cols.push({
            id: "actions",
            header: "Actions",
            cell: (rowData)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f358e506d11489c$export$332bbb895017705d), {
                    rowData: rowData,
                    columns: actionColumnsToShow,
                    onClick: (c, r)=>onActionColumnClick(c, r)
                })
        });
        let updatedPreferences = $98339aa869f255f6$var$getDefaultPreference(cols);
        if (savedPreferencesString) try {
            updatedPreferences = JSON.parse(savedPreferencesString);
        } catch (err) {
            console.log("error parsing saved preferences for menu item: ", menuItem);
            console.log(err);
        }
        // sync saved preferences with any updates made since they were saved
        if (updatedPreferences && updatedPreferences.contentDisplay) {
            // Start with columns from preferences to keep the user order and filter out deprecated columns
            const existingColumns = updatedPreferences.contentDisplay.filter((column)=>$98339aa869f255f6$var$isColumnInDefinitions(column, cols));
            const columnDefinitionIds = cols.filter(({ id: id })=>id).map(({ id: id })=>({
                    id: id
                }));
            let preferencesContentDisplay = [
                ...updatedPreferences.contentDisplay
            ];
            // Add new columns from definitions
            const newColumns = columnDefinitionIds.filter((column)=>!$98339aa869f255f6$var$isColumnInDefinitions(column, preferencesContentDisplay)).map($98339aa869f255f6$var$createDefaultColumn);
            const contentDisplay = [
                ...existingColumns,
                ...newColumns
            ];
            updatedPreferences = {
                ...updatedPreferences,
                contentDisplay: contentDisplay
            };
        }
        setPreferences(updatedPreferences);
        setColumnDefinitions(cols);
    };
    const loadViewMenu = async ()=>{
        const data = {
            data: menuItem.DataForGettingMenu
        };
        const viewMenu = await api.makeApiCall("getViewMenu/" + menuItem.Id, "POST", data);
        setViewMenu(viewMenu);
    };
    const updateCounts = (totalLines, currentPage)=>{
        const pageSize = preferences?.pageSize || 100000;
        let pageCount = Math.floor(totalLines / pageSize);
        if (totalLines % pageSize > 0) pageCount++;
        if (currentPage > pageCount) currentPage = pageCount;
        setViewSettings({
            ...viewSettings,
            currentPage: currentPage,
            totalLines: totalLines,
            pageCount: pageCount
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (preferences && menuItem) {
            // clear page settings
            setSortingDescending(false);
            setSortingColumn(null);
            updateCounts(menuItem.TotalLines, viewSettings.currentPage);
            const storedFilterValue = localStorage.getItem(filterKey);
            updateFilterValue(storedFilterValue || "");
            if (!isEmbedded) doReload(storedFilterValue);
        }
    }, [
        preferences,
        menuItem
    ]);
    (0, $acw62.useEffect)(()=>{
        if (menuItem) {
            loadConfig();
            loadViewMenu(); // this loads even it was previously shown. I think react clears state when a component is re-rendered. Might have to store my own state for this to work in the main app somehow
        }
    }, [
        menuItem
    ]);
    const debouncedFilterChange = ()=>(0, $154d4ea6bbdaf516$export$21805fee57372823)(()=>{
            doReload(filterText, null, sortingColumn?.sortingField, !sortingDescending);
        }, "refresh", 500);
    const viewMenuItemClick = async (item)=>{
        const data = {
            // data: item.ParametersToPass, // i am dissabling this because for adding in detail section, the parameters value should be what was set in parameters
            // parameters: {
            //   ViewId: item.EventNumber,
            // },
            parameters: item.ParametersToPass
        };
        await handleOnActionColumnClick(null, null);
        await onMenuClick(item.EventNumber, data);
    };
    const tableActions = viewMenu?.map((m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
            variant: "normal",
            onClick: ()=>viewMenuItemClick(m),
            children: m.Label
        }, i));
    const doRefresh = ()=>{
        doReload(filterText, null, sortingColumn?.sortingField, !sortingDescending);
    };
    if (!isEmbedded) tableActions.unshift(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
        variant: "icon",
        iconName: "refresh",
        onClick: doRefresh
    }, "refresh"));
    const onSelectionChange = (items)=>{
        setSelectedItems(items);
        const selectedRow = items?.length === 1 ? items[0] : null;
        setSelectedTableRow({
            menuItem: menuItem,
            rowData: selectedRow
        });
    };
    // TODO: E.g. - on Departments to view the expenses.
    //              will have to get/set via mainApp
    // TODO: I wanted to add the details section as something that can be passed from the back-end.
    //       It might have to be a child component or something as the details panel can have multiple tabs.
    //       Maybe a field that returns a list of MenuNumbers of ViewDetail classes.
    //       But maybe there's a way then to use something other than MenuNumbers so that we can prevent users from adding the wrong number by accident.
    //       Maybe ask for the types only?
    //       --> have a method with an object where users can call config.AddDetailView<T>(); // where T is the detail view type. I think this is the best.
    //           or just initialize the class like inputView
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9d0e5ed1593f09$export$2e2bcd8739ae039), {
        items: tableItems,
        loading: loading,
        resizableColumns: true,
        onColumnWidthsChange: (e)=>updateColumnPreferences(e.detail),
        loadingText: "Loading data",
        columnDefinitions: columnDefinitions,
        variant: isEmbedded ? "embedded" : "full-page",
        sortingDisabled: menuItem?.AllowSorting === false,
        sortingColumn: sortingColumn,
        sortingDescending: sortingDescending,
        onSortingChange: onSortingChange,
        onSelectionChange: ({ detail: detail })=>{
            onSelectionChange(detail.selectedItems);
        },
        selectedItems: selectedItems,
        selectionType: isEmbedded || !menuItem.DetailSectionId ? null : "single",
        empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
            margin: {
                vertical: "xs"
            },
            textAlign: "center",
            color: "inherit",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                size: "m",
                children: filterText.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: "No matches found "
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                updateFilterValue("");
                                doReload("", null, sortingColumn.sortingField, !sortingDescending);
                            },
                            children: "Clear filter"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                    children: "No resources"
                })
            })
        }),
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
            variant: "awsui-h1-sticky",
            counter: `(${isEmbedded ? tableItems.length : viewSettings.totalLines})`,
            actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                direction: "horizontal",
                size: "xs",
                children: tableActions
            }),
            children: menuItem?.Title
        }),
        filter: isEmbedded ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1ad38163d990f1e$export$2e2bcd8739ae039), {
            filteringPlaceholder: "Filter items",
            onChange: ({ detail: detail })=>updateFilterValue(detail.filteringText),
            onDelayedChange: (x)=>{
                if (x.detail.filteringText == null || x.detail.filteringText == "") doReload("", null, sortingColumn?.sortingField, !sortingDescending);
                else debouncedFilterChange();
            },
            filteringText: filterText,
            countText: tableItems.length === 1 ? "1 match" : tableItems.length + " matches"
        }),
        columnDisplay: preferences?.contentDisplay,
        contentDensity: preferences?.contentDensity,
        stripedRows: preferences?.stripedRows,
        wrapLines: preferences?.wrapLines,
        stickyColumns: preferences?.stickyColumns,
        pagination: isEmbedded ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ede657b6d0ca61ed$export$2e2bcd8739ae039), {
            currentPageIndex: viewSettings.currentPage,
            pagesCount: viewSettings.pageCount,
            onChange: ({ detail: detail })=>{
                const newViewSettings = {
                    ...viewSettings,
                    currentPage: detail.currentPageIndex
                };
                setViewSettings(newViewSettings);
                doReload(filterText, newViewSettings, sortingColumn?.sortingField || "", !sortingDescending);
            }
        }),
        preferences: isEmbedded ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89636bbaa439431$export$d5a7fa40d422cbcd), {
            preferences: preferences,
            setPreferences: updatePreferences,
            columnDisplayPreferenceOptions: columnDefinitions.map(({ id: id, header: header, isRowHeader: isRowHeader })=>({
                    id: id,
                    label: header,
                    alwaysVisible: isRowHeader
                }))
        })
    });
};


const $a53b2bb5fbfe6059$export$cec7cafc710f5d68 = ({ menuItem: menuItem })=>{
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const dispatch = (0, $c0aa018cd5ecdf0e$export$f51d452c10d5b956)();
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [values, setValues] = (0, $acw62.useState)({});
    const [fieldVisibility, setFieldVisibility] = (0, $acw62.useState)({});
    const [fieldSources, setFieldSources] = (0, $acw62.useState)({});
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const { handleAction: handleAction } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const valuesRef = (0, $acw62.useRef)({});
    const [formCache, setFormCache] = (0, $acw62.useState)(null);
    valuesRef.current = values;
    const getInputValue = async (field, onChangeValue = null)=>{
        let value = null;
        if (onChangeValue != null) value = onChangeValue;
        else if (valuesRef.current[field.InputName] != null) value = valuesRef.current[field.InputName];
        if (field.InputType == 3) {
            // combo box
            const selectedItem = value;
            if (selectedItem) value = selectedItem?.value;
        } else if (field.InputType == 5) {
            // list selection
            const selectedItems = value;
            value = selectedItems?.filter((s)=>s != null).map((s)=>s.value);
        } else if (field.InputType == 6) {
            // date
            if (value) try {
                value = new Date(value).toISOString().split("T")[0]; // example date = 2024-07-21T00:00:00.000Z
            } catch (err) {
                console.log(`error parsing date ${value}: ${err}`);
            }
        } else if (field.InputType == 8) {
            // input view
            value = valuesRef.current[field.InputName];
            return value;
        } else if (field.InputType == 9) // file
        {
            if (value && value.length > 0) {
                value = await readFile(value[0]);
                return value;
            }
        }
        return value;
    };
    const readFile = async (file)=>{
        return new Promise(function(resolve, reject) {
            const reader = new FileReader();
            reader.onload = function(e) {
                const arrayBuffer = e.target.result;
                const byteArray = new Uint8Array(arrayBuffer);
                // Convert Uint8Array to binary string
                let binaryString = "";
                for(let i = 0; i < byteArray.length; i++)binaryString += String.fromCharCode(byteArray[i]);
                const base64String = window.btoa(binaryString);
                const filename = file.name;
                const parts = filename.split(".");
                const extension = parts.length > 1 ? parts[parts.length - 1] : "";
                const nameWithoutExtension = parts[0];
                const result = {
                    Data: base64String,
                    FileName: nameWithoutExtension,
                    MimeType: file.type,
                    FileExtension: extension,
                    Size: file.size
                };
                resolve(result);
            };
            reader.onerror = function(err) {
                reject(err);
            };
            reader.readAsArrayBuffer(file);
        }).catch(function(err) {
            console.error(err);
            dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Error reading file, see logs for details (${err})`
            }));
        });
    };
    const getInputValues = async (includeAll = false)=>{
        const result = {};
        for(let i = 0; i < menuItem.InputFields.length; i++){
            const field = menuItem.InputFields[i];
            if (includeAll != true) {
                const isVisible = fieldVisibility[field.InputName];
                if (!isVisible) continue;
            }
            result[field.InputName] = await getInputValue(field);
        }
        return result;
    };
    const onButtonClick = async (button)=>{
        setLoading(true);
        // TODO: conditional mandatory setting
        // TODO: test that all inputs and features are working
        try {
            if (button.ValidateInput) //todo : validate all input fields -> currentMenu.fields with values
            for(let i = 0; i < menuItem.InputFields.length; i++){
                const field = menuItem.InputFields[i];
                const value = await getInputValue(field);
                const validationResult = validateField(field, value);
                if (validationResult.length > 0) return;
            }
            const params = await getInputValues();
            const data = {
                Data: params || "",
                ActionId: button.ActionNumber
            };
            // call api
            const resp = await api.makeApiCall("processEvent/" + menuItem.Id, "POST", data);
            //await formEvents.handleEvents(resp);
            for(let i = 0; i < resp?.length; i++)handleAction(resp[i]);
        } catch (error) {
            console.log(error);
            let message = "Unexpected error: " + error;
            dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: message
            }));
        } finally{
            setLoading(false);
        }
    };
    const validateField = (field, value, forcedCheck = false)=>{
        if (field.Mandatory === true && (fieldVisibility[field.InputName] !== false || forcedCheck === true)) {
            if (value === null || value === "") return field.InputLabel + " is required";
            if (field.InputType == 3) ;
            else if (field.InputType == 5) {
                if (value == null || value.length == 0) return field.InputLabel + " is required";
            } else if (field.InputType == 9) {
                if (value == null || value.length == 0) return field.InputLabel + " is required";
            }
        }
        return "";
    };
    const buildInputs = ()=>{
        const fields = menuItem.InputFields;
        const defaultVisibility = fields.reduce((prev, f)=>{
            prev[f.InputName] = true;
            return prev;
        }, {});
        const defaultFieldSources = fields.filter((f)=>f.InputType == 5 || f.InputType == 3).reduce((prev, f)=>{
            prev[f.InputName] = f.InputType == 5 ? f.ListSource : f.ListItems;
            return prev;
        }, {});
        setFieldSources(defaultFieldSources);
        setFieldVisibility(defaultVisibility);
        fields.forEach((f)=>{
            let defaultValue = f.DefaultValue;
            switch(f.InputType){
                case 3:
                    // combo box
                    if (f.DefaultValue) defaultValue = {
                        label: f.ListItems.filter((l)=>l.Key == f.DefaultValue)[0]?.Value,
                        value: f.DefaultValue
                    };
                    else defaultValue = null;
                    break;
                case 4:
                    // boolean
                    defaultValue = f.DefaultValue === true ? true : false;
                    break;
                case 5:
                    {
                        // multi select
                        let listDefaultValue = f.DefaultValue || "";
                        if (listDefaultValue.constructor.name != "Array") listDefaultValue = listDefaultValue.split(",");
                        const tmpDefaultValues = listDefaultValue;
                        defaultValue = tmpDefaultValues.map((d)=>{
                            const label = f.ListSource.filter((l)=>l.Key == d)[0]?.Value;
                            return {
                                label: label,
                                value: d
                            };
                        }).filter((x)=>x.label && x.label != "");
                        break;
                    }
                case 6:
                    // date input
                    defaultValue = f.DefaultValue || "";
                    if (defaultValue) // convert from mainApp.dateFormat
                    try {
                        //defaultValue = parse("23-06-2024", "dd-MM-YYYY", new Date());
                        defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(defaultValue, "DD-MMM-YYYY").format("YYYY-MM-DD");
                    } catch (err) {
                        console.log("error parsing date: " + defaultValue);
                        console.log(err);
                    }
                    break;
                case 8:
                    break;
                case 9:
                    // file input
                    defaultValue = [];
                    break;
                default:
                    break;
            }
            onChange(f, defaultValue, true); // to update the visbility
        });
    };
    const [dummy, setDummy] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (menuItem) {
            buildInputs();
            setDummy("reload-done"); // using this because we need various state values set before calling the onChange method (i.e. getting/setting the value state variable)
        }
    }, [
        menuItem
    ]);
    (0, $acw62.useEffect)(()=>{
        if (dummy == "reload-done") {
            const fields = menuItem.InputFields;
            const valuesToUse = formCache?.cacheValue ?? values;
            fields.forEach((f)=>{
                const fieldValue = valuesToUse[f.InputName];
                onChange(f, fieldValue); // raise on property changed now to update visibility conditions etc
            });
            setDummy("");
        }
    }, [
        dummy
    ]);
    (0, $acw62.useEffect)(()=>{
        if (mainApp.inputViewUpdateData != null && formCache != null) {
            const currentValue = values[formCache.fieldName] || [];
            const inputViewUpdateData = mainApp.inputViewUpdateData;
            let newValue = [];
            if (inputViewUpdateData == null) // this was a cancellation
            return;
            if (inputViewUpdateData === -1) {
                // delete item
                newValue = currentValue;
                newValue.splice(formCache.rowId, 1);
            } else if (formCache.rowId == -1) {
                // this is for a new item
                let rowId = -1;
                for(let j = 0; j < currentValue.length; j++)rowId = Math.max(rowId, currentValue[j].rowId);
                rowId++;
                inputViewUpdateData.rowId = rowId;
                newValue = [
                    ...currentValue,
                    inputViewUpdateData
                ];
            } else {
                // this is when an item is modified
                const rowIndex = formCache.rowId;
                newValue = currentValue;
                inputViewUpdateData.rowId = rowIndex;
                newValue[rowIndex] = inputViewUpdateData;
            }
            // update all rowIds
            let index = 0;
            for(let j = 0; j < newValue.length; j++){
                newValue[j].rowId = index;
                index++;
            }
            setValues((prevValues)=>({
                    ...prevValues,
                    [formCache.fieldName]: newValue
                }));
        }
    }, [
        mainApp.inputViewUpdateData
    ]);
    const conditionIsMet = (condition, value)=>{
        if (condition.Comparison == 0) // Equals
        return value === condition.ColumnValue;
        else if (condition.Comparison == 1) // Not-Equals
        return value != condition.ColumnValue;
        else if (condition.Comparison == 2) // Contains
        return value.indexOf(condition.ColumnValue) > -1;
        else if (condition.Comparison == 3) // IsNotNull
        return value != null && (value + "").length > 0;
        else if (condition.Comparison == 4) // IsNull
        return value == null || (value + "").length == 0;
        else {
            console.log("Error", "Unknown comparison: " + condition.Comparison);
            return false;
        }
    };
    const raisePropertyChangedEvent = async (field, fieldValue)=>{
        setLoading(true);
        try {
            const data = {
                Data: {
                    PropertyName: field.InputName,
                    PropertyValue: fieldValue,
                    EventId: menuItem.Id
                }
            };
            const resp = await api.makeApiCall("propertyChanged/" + menuItem.Id, "POST", data);
            if (resp && resp.length > 0) for(let i = 0; i < resp.length; i++){
                let item = resp[i];
                switch(item.ActionType){
                    case 10:
                        {
                            // update combo box
                            setFieldSources((prevValues)=>({
                                    ...prevValues,
                                    [item.InputName]: item.ListItems
                                }));
                            const fld = menuItem.InputFields.filter((f)=>f.InputName == item.InputName)[0];
                            const currentValue = await getInputValue(fld);
                            if (currentValue) {
                                if (fld.InputType == 3) {
                                    const validValues = item.ListItems.map((l)=>l.Key);
                                    if (!validValues.includes(currentValue)) setValues((prevValues)=>({
                                            ...prevValues,
                                            [item.InputName]: null
                                        }));
                                } else if (fld.InputType == 5) {
                                    const validValues = item.ListItems.map((l)=>l.Key);
                                    let newCurrentValue = values[item.InputName];
                                    const updatedValue = newCurrentValue.filter((n)=>validValues.includes(n.value));
                                    if (!validValues.includes(currentValue)) setValues((prevValues)=>({
                                            ...prevValues,
                                            [item.InputName]: updatedValue
                                        }));
                                }
                            }
                            break;
                        }
                    case 17:
                        // UpdateInputVisibility
                        setFieldVisibility((prevValues)=>({
                                ...prevValues,
                                [item.InputName]: item.InputIsVisible
                            }));
                        break;
                    default:
                        console.log("unknown action type: " + item.ActionType);
                        dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                            type: "error",
                            content: "Unknown action type: " + item.ActionType
                        }));
                        break;
                }
            }
        } finally{
            setLoading(false);
        }
    };
    const debouncedPropertyChanged = (propName, timeout, field, ...x)=>(0, $154d4ea6bbdaf516$export$21805fee57372823)(raisePropertyChangedEvent, propName, timeout, ...[
            field,
            ...x
        ]);
    const updateFieldVisibilities = (fieldChanged, valueChanged)=>{
        const otherFields = menuItem.InputFields.filter((f)=>f.VisibilityConditions.filter((v)=>v.ColumnName == fieldChanged.InputName).length > 0);
        for(let i = 0; i < otherFields.length; i++){
            const field = otherFields[i];
            const matchedConditions = field.VisibilityConditions.filter((condition)=>conditionIsMet(condition, valueChanged?.toString()));
            if (matchedConditions.length > 0) {
                const otherValue = values[field.InputName];
                updateFieldErrors(field, otherValue, true);
            }
            setFieldVisibility((prevValues)=>({
                    ...prevValues,
                    [field.InputName]: matchedConditions.length > 0
                }));
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (errors) {
            const keys = Object.keys(errors);
            let thereAreErrors = false;
            for(let i = 0; i < keys.length; i++){
                const error = errors[keys[i]];
                const visibility = fieldVisibility[keys[i]];
                if (error && visibility === true) thereAreErrors = true;
            }
            if (thereAreErrors === true) setErrorMessage("There are invalid inputs. Make sure to check all tabs.");
            else setErrorMessage("");
        }
    }, [
        errors
    ]);
    const updateFieldErrors = async (field, value, forcedValidation = false)=>{
        const actualValue = await getInputValue(field, value);
        const fieldError = validateField(field, actualValue, forcedValidation);
        setErrors((prevErrors)=>({
                ...prevErrors,
                [field.InputName]: fieldError
            }));
    };
    const onChange = async (field, value, isScreenSetup = false)=>{
        setValues((prevValues)=>({
                ...prevValues,
                [field.InputName]: value
            }));
        await updateFieldErrors(field, value);
        if (isScreenSetup === true) return; // don't handle property changed events or check visibility conditions during screen setup
        const fieldValue = await getInputValue(field, value);
        updateFieldVisibilities(field, fieldValue);
        if (field.RaisePropertyChangedEvent === true) {
            let timeoutValue = 0;
            if (field.InputType == 0 || field.InputType == 1 || field.InputType == 10) timeoutValue = 500;
            debouncedPropertyChanged(field.InputName, timeoutValue, field, fieldValue);
        }
    };
    const onInputViewColumnActionClick = async (field, rowData)=>{
        const currentInputs = valuesRef.current;
        mainApp.setInputViewUpdateData(null); // clear any values here
        const cacheItem = {
            fieldName: field.InputName,
            cacheValue: currentInputs,
            rowId: rowData?.rowId ?? -1
        };
        setFormCache(cacheItem);
        return Promise.resolve();
    };
    const getInputField = (field, setAutoFocus)=>{
        switch(field.InputType){
            case 0:
            case 1:
                if (field.MultiLineText == true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $def0f31f988660f4$export$2e2bcd8739ae039), {
                    placeholder: field.InputLabel,
                    autoFocus: setAutoFocus,
                    value: values?.[field.InputName],
                    onChange: ({ detail: { value: value } })=>onChange(field, value)
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                    placeholder: field.InputLabel,
                    autoFocus: setAutoFocus,
                    type: field.InputType == 1 ? "password" : "text",
                    value: values?.[field.InputName],
                    onChange: ({ detail: { value: value } })=>onChange(field, value)
                });
            case 2:
                return null;
            case 3:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a3c01a344cfcaf3$export$2e2bcd8739ae039), {
                    autoFocus: setAutoFocus,
                    selectedOption: values?.[field.InputName],
                    onChange: ({ detail: detail })=>{
                        onChange(field, detail.selectedOption);
                    },
                    options: fieldSources[field.InputName]?.map((x)=>({
                            label: x.Value,
                            value: x.Key
                        }))
                });
            case 4:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f975e47fe9face4d$export$2e2bcd8739ae039), {
                    onChange: ({ detail: detail })=>onChange(field, detail.checked),
                    checked: values?.[field.InputName],
                    children: field.InputLabel
                });
            case 5:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8bb34a8468c146d7$export$2e2bcd8739ae039), {
                    tokenLimit: 10,
                    autoFocus: setAutoFocus,
                    selectedOptions: values?.[field.InputName],
                    onChange: ({ detail: detail })=>{
                        onChange(field, detail.selectedOptions);
                    },
                    enableSelectAll: true,
                    i18nStrings: {
                        selectAllText: "Select All"
                    },
                    options: fieldSources[field.InputName]?.map((x)=>({
                            label: x.Value,
                            value: x.Key
                        }))
                });
            case 6:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fddd550297817b9$export$2e2bcd8739ae039), {
                    //locale="en-CA" // en-CA uses the date format YYYY-MM-DD, which is what we use (i think)
                    value: values?.[field.InputName],
                    autoFocus: setAutoFocus,
                    onChange: ({ detail: { value: value } })=>onChange(field, value),
                    placeholder: field.InputLabel
                });
            case 8:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60822fbe2c08caa5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98339aa869f255f6$export$73903224e3a9e478), {
                        menuItem: field.ViewForInput,
                        isEmbedded: true,
                        defaultData: values?.[field.InputName],
                        handleOnActionColumnClick: (c, data)=>onInputViewColumnActionClick(field, data)
                    })
                });
            case 9:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0caa904d8e7106e8$export$2e2bcd8739ae039), {
                    onChange: ({ detail: { value: value } })=>onChange(field, value),
                    value: values?.[field.InputName],
                    i18nStrings: {
                        uploadButtonText: (e)=>e ? "Choose files" : "Choose file",
                        dropzoneText: (e)=>e ? "Drop files to upload" : "Drop file to upload",
                        removeFileAriaLabel: (e)=>`Remove file ${e + 1}`,
                        limitShowFewer: "Show fewer files",
                        limitShowMore: "Show more files",
                        errorIconAriaLabel: "Error"
                    },
                    showFileLastModified: false,
                    showFileSize: true,
                    showFileThumbnail: true
                });
            case 10:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                    autoFocus: setAutoFocus,
                    type: "number",
                    placeholder: field.InputLabel,
                    value: values?.[field.InputName],
                    onChange: ({ detail: { value: value } })=>onChange(field, value)
                });
            case 11:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: field.DefaultValue
                });
            default:
                console.error("unhandled input type: " + field.InputType);
                console.log(field);
                dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                    type: "error",
                    content: "Unknown input type: " + field.InputType + " for field " + field.InputLabel
                }));
                return null;
        }
    };
    const getTabContent = (tabName)=>{
        const fields = menuItem.InputFields.filter((x)=>x.TabName == tabName || tabName == null && x.TabName == "");
        const formFields = fields.filter((f)=>f.InputType != 2 /* exclude hidden fields */ ).map((f, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: fieldVisibility[f.InputName] != true ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                    label: f.InputLabel,
                    errorText: errors?.[f.InputName],
                    children: getInputField(f, i == 0)
                }, f.InputName)
            }, f.InputName));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            size: "l",
            children: formFields
        });
    };
    const getTabs = ()=>{
        if (menuItem == null) return null;
        // Get unique tab names, ignore hidden inputs
        const uniqueTabs = new Set();
        menuItem.InputFields.forEach((field)=>{
            if (field.InputType != 2) uniqueTabs.add(field.TabName || "");
        });
        const tabNames = Array.from(uniqueTabs?.values()).filter((x)=>x != null && x.length > 0);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                tabNames.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b1a89cfa249459$export$2e2bcd8739ae039), {
                    tabs: tabNames.map((t)=>({
                            label: t,
                            id: t,
                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                                size: "l",
                                children: getTabContent(t)
                            })
                        }))
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                    size: "l",
                    children: getTabContent(null)
                })
            ]
        });
    };
    const onFormSubmit = (e)=>{
        e.preventDefault();
    // button events handle the submit case
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: onFormSubmit,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3128a80b6a88093c$export$2e2bcd8739ae039), {
            variant: "full-page",
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
                variant: "awsui-h1-sticky",
                children: menuItem?.Title
            }),
            // errorText="Some error"
            errorText: errorMessage,
            actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                direction: "horizontal",
                size: "xs",
                alignItems: "end",
                children: menuItem?.InputButtons?.map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                        variant: "primary",
                        loading: loading,
                        onClick: ()=>onButtonClick(b),
                        children: b.Label
                    }, b.Label))
            }),
            children: getTabs()
        })
    });
};




const $d236e265f1464cfc$export$f845437bf1d007fd = ({ menuItem: menuItem })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98339aa869f255f6$export$73903224e3a9e478), {
        menuItem: menuItem
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





'use client';
function $d2db684d56659d26$export$2e2bcd8739ae039({ gridDefinition: gridDefinition = [], disableGutters: disableGutters = false, children: children, ...restProps }) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Grid', {
        props: {
            disableGutters: disableGutters
        }
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)(undefined);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), {
        ...baseProps,
        ...baseComponentProps,
        ref: ref,
        __breakpoint: breakpoint,
        gridDefinition: gridDefinition,
        disableGutters: disableGutters
    }, children);
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($d2db684d56659d26$export$2e2bcd8739ae039, 'Grid');



const $54090c4ee8bb0552$var$ServiceFeatureListItem = ({ title: title, description: description })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                variant: "h3",
                padding: "n",
                fontWeight: "normal",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                variant: "p",
                children: description
            })
        ]
    });
const $54090c4ee8bb0552$export$b94310965bed44e6 = ()=>{
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c3c7a1fd2ca4107$export$2e2bcd8739ae039), {
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2db684d56659d26$export$2e2bcd8739ae039), {
            gridDefinition: [
                {
                    colspan: {
                        default: 12,
                        xs: 8,
                        s: 9
                    }
                },
                {
                    colspan: {
                        default: 12,
                        xs: 4,
                        s: 3
                    }
                }
            ],
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                padding: "s",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                        fontSize: "display-l",
                        fontWeight: "bold",
                        variant: "h1",
                        padding: "n",
                        children: mainApp.appName
                    }),
                    "HOME"
                ]
            })
        })
    });
};


const $e26b8abf7ea53dd6$var$MainAppContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $e26b8abf7ea53dd6$var$homeDisplayItem = {
    menu: null,
    type: "home",
    visible: true,
    id: "home",
    component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54090c4ee8bb0552$export$b94310965bed44e6), {}),
    splitPanelContents: ()=>null
};
let $e26b8abf7ea53dd6$var$clearingStack = false;
const $e26b8abf7ea53dd6$export$e3f0b906e9bc3bad = ({ children: children })=>{
    const [appName, setAppName] = (0, $acw62.useState)("");
    const [appVersion, setAppVersion] = (0, $acw62.useState)("");
    const [dateFormat, setDateFormat] = (0, $acw62.useState)("");
    const [isReady, setIsReady] = (0, $acw62.useState)(false);
    const [authConfig, setAuthConfig] = (0, $acw62.useState)(null);
    const [selectedRow, setRow] = (0, $acw62.useState)(null);
    const [currentContentType, setCurrentContentType] = (0, $acw62.useState)("default");
    const [displayStack, setDisplayStack] = (0, $acw62.useState)([
        $e26b8abf7ea53dd6$var$homeDisplayItem
    ]);
    const makeLastItemVisible = (stack)=>{
        if (stack.length > 0) stack[stack.length - 1].visible = true;
    };
    const hideAllItems = (stack)=>{
        for(let i = 0; i < stack.length; i++)stack[i].visible = false;
    };
    const getComponent = (display)=>{
        switch(display.type){
            case "login":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bed6b8339cc09029$export$21a94553ffa41578), {});
            case "form":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a53b2bb5fbfe6059$export$cec7cafc710f5d68), {
                    menuItem: display.menu
                }); //TODO: not creating a new copy of form - all state values need to be handled somewhere else then
            case "view":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d236e265f1464cfc$export$f845437bf1d007fd), {
                    menuItem: display.menu
                });
            case "home":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54090c4ee8bb0552$export$b94310965bed44e6), {});
        }
    };
    const addDisplayItem = (item, visible, stack)=>{
        const stackItem = {
            id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
            visible: visible,
            menu: item.menu,
            type: item.type,
            component: getComponent(item),
            splitPanelContents: ()=>null
        };
        //TODO: if view, set split panel stuff somehow
        stack.push(stackItem);
    };
    const showComponent = (displayItem)=>{
        let stack = [
            ...displayStack
        ];
        hideAllItems(stack);
        if ($e26b8abf7ea53dd6$var$clearingStack === true) {
            $e26b8abf7ea53dd6$var$clearingStack = false;
            stack = [
                $e26b8abf7ea53dd6$var$homeDisplayItem
            ];
        }
        if (displayItem == -1) {
            // remove current item
            if (stack.length > 0) {
                const index = stack.length - 1;
                const lastItem = stack[index];
                stack = [
                    ...stack.slice(0, index),
                    ...stack.slice(index + 1)
                ];
            }
            if (displayStack.length == 0) addDisplayItem($e26b8abf7ea53dd6$var$homeDisplayItem, true, stack);
        } else addDisplayItem(displayItem, true, stack);
        makeLastItemVisible(stack);
        setDisplayStack(stack);
    };
    const [inputViewUpdateData, setInputViewUpdateData] = (0, $acw62.useState)(null);
    const initializeSystem = async ()=>{
        try {
            const cacheControl = `&_=${Date.now()}`; // don't cache stuff
            const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}initializeSystem?v=${cacheControl}`;
            const resp = await fetch(urlToCall);
            const systemInfo = await resp.json();
            if (systemInfo) {
                if (systemInfo.ConstructionError) {
                    console.log("There was an error in the system initialization code:");
                    console.log(systemInfo.ConstructionError);
                    (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                        type: "error",
                        content: `"There was an error in the system initialization code:" ${systemInfo.ConstructionError}`
                    }));
                } else {
                    setAppName(systemInfo.ApplicationName);
                    setAppVersion(systemInfo.Version);
                    setDateFormat(systemInfo.DateFormat);
                    setAuthConfig(systemInfo.AuthConfig);
                    document.title = `${systemInfo.ApplicationName} ${systemInfo.Version}`;
                    setIsReady(true);
                }
            }
        } catch (err) {
            console.error("Fatal error calling initialize system:");
            // wouldn't really happen because back-end hosts front-end
            console.error(err);
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Fatal error: ${err}`
            }));
        }
    };
    const setSelectedTableRow = (selection)=>{
        setRow(selection);
    };
    (0, $acw62.useEffect)(()=>{
        initializeSystem();
    }, []);
    const clearDisplayStack = ()=>{
        $e26b8abf7ea53dd6$var$clearingStack = true;
        const stack = [];
        addDisplayItem($e26b8abf7ea53dd6$var$homeDisplayItem, true, stack);
        setDisplayStack(stack);
    };
    const value = {
        appName: appName,
        appVersion: appVersion,
        dateFormat: dateFormat,
        isReady: isReady,
        currentContentType: currentContentType,
        setCurrentContentType: setCurrentContentType,
        inputViewUpdateData: inputViewUpdateData,
        setInputViewUpdateData: setInputViewUpdateData,
        showComponent: showComponent,
        displayStack: displayStack,
        clearDisplayStack: clearDisplayStack,
        setSelectedTableRow: setSelectedTableRow,
        selectedRow: selectedRow,
        authConfig: authConfig
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e26b8abf7ea53dd6$var$MainAppContext.Provider, {
        value: value,
        children: children
    });
};
const $e26b8abf7ea53dd6$export$916c34e134c838e3 = ()=>{
    const context = (0, $acw62.useContext)($e26b8abf7ea53dd6$var$MainAppContext);
    if (!context) throw new Error("useMainApp must be used within an MainAppProvider");
    return context;
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









var $8865c966f929fe61$export$2e2bcd8739ae039 = {
    "drawer": "awsui_drawer_1r9lg_492kg_153",
    "drawer-closed": "awsui_drawer-closed_1r9lg_492kg_190",
    "refresh": "awsui_refresh_1r9lg_492kg_190",
    "drawer-content-side": "awsui_drawer-content-side_1r9lg_492kg_194",
    "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_492kg_210",
    "position-bottom": "awsui_position-bottom_1r9lg_492kg_217",
    "hidden": "awsui_hidden_1r9lg_492kg_225",
    "drawer-clickable": "awsui_drawer-clickable_1r9lg_492kg_236",
    "position-side": "awsui_position-side_1r9lg_492kg_247",
    "with-toolbar": "awsui_with-toolbar_1r9lg_492kg_252",
    "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_492kg_256",
    "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_492kg_267",
    "open-button-side": "awsui_open-button-side_1r9lg_492kg_281",
    "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_492kg_290",
    "drawer-mobile": "awsui_drawer-mobile_1r9lg_492kg_300",
    "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_492kg_304",
    "content-bottom": "awsui_content-bottom_1r9lg_492kg_316",
    "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_492kg_335",
    "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_492kg_340",
    "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_492kg_344",
    "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_492kg_348",
    "content-side": "awsui_content-side_1r9lg_492kg_353",
    "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_492kg_365",
    "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_492kg_374",
    "header": "awsui_header_1r9lg_492kg_385",
    "header-main-row": "awsui_header-main-row_1r9lg_492kg_393",
    "header-main-content": "awsui_header-main-content_1r9lg_492kg_393",
    "header-tag-and-info": "awsui_header-tag-and-info_1r9lg_492kg_407",
    "with-description": "awsui_with-description_1r9lg_492kg_412",
    "header-tag": "awsui_header-tag_1r9lg_492kg_407",
    "with-info": "awsui_with-info_1r9lg_492kg_415",
    "header-text": "awsui_header-text_1r9lg_492kg_415",
    "header-before-slot": "awsui_header-before-slot_1r9lg_492kg_421",
    "with-header-text": "awsui_with-header-text_1r9lg_492kg_432",
    "header-actions-slot": "awsui_header-actions-slot_1r9lg_492kg_438",
    "header-description": "awsui_header-description_1r9lg_492kg_444",
    "header-buttons": "awsui_header-buttons_1r9lg_492kg_451",
    "divider": "awsui_divider_1r9lg_492kg_459"
};



function $40f40a5866db94fc$export$acf43145a1f7fbaa({ closeBehavior: closeBehavior, baseProps: baseProps, isOpen: isOpen, splitPanelRef: splitPanelRef, cappedSize: cappedSize, header: header, resizeHandle: resizeHandle, children: children, appLayoutMaxWidth: appLayoutMaxWidth, panelHeaderId: panelHeaderId, ariaLabel: ariaLabel, onToggle: onToggle, hasCustomElements: hasCustomElements }) {
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const isToolbar = (0, $73078c4512771f18$export$d38f11a69207eec8)();
    const { bottomOffset: bottomOffset, leftOffset: leftOffset, rightOffset: rightOffset, disableContentPaddings: disableContentPaddings, contentWrapperPaddings: contentWrapperPaddings, reportHeaderHeight: reportHeaderHeight, headerHeight: headerBlockSize, animationDisabled: animationDisabled } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const headerRef = (0, $acw62.useRef)(null);
    (0, $013a2451794a45c0$exports.useResizeObserver)(headerRef, (entry)=>{
        const visibleHeaderSize = closeBehavior === 'hide' && !isOpen ? 0 : entry.borderBoxHeight;
        reportHeaderHeight(visibleHeaderSize);
    });
    (0, $acw62.useEffect)(()=>{
        // report empty height when unmounting the panel
        return ()=>reportHeaderHeight(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const centeredMaxWidthClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['pane-bottom-center-align']]: isRefresh,
        [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['pane-bottom-content-nav-padding']]: contentWrapperPaddings === null || contentWrapperPaddings === void 0 ? void 0 : contentWrapperPaddings.closedNav,
        [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['pane-bottom-content-tools-padding']]: contentWrapperPaddings === null || contentWrapperPaddings === void 0 ? void 0 : contentWrapperPaddings.closedTools
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8865c966f929fe61$export$2e2bcd8739ae039).drawer, (0, $8865c966f929fe61$export$2e2bcd8739ae039)['position-bottom'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039).root, {
            [(0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-vertical']]: !animationDisabled,
            [(0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['open-position-bottom']]: isOpen,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['drawer-closed']]: !isOpen,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['drawer-clickable']]: !hasCustomElements,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['drawer-mobile']]: isMobile,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['drawer-disable-content-paddings']]: disableContentPaddings,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039).refresh]: isRefresh,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-toolbar']]: isToolbar,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039).hidden]: closeBehavior === 'hide' && !isOpen
        }),
        onClick: ()=>!isOpen && !hasCustomElements && onToggle(),
        style: {
            insetBlockEnd: bottomOffset,
            insetInlineStart: leftOffset,
            insetInlineEnd: rightOffset,
            blockSize: isOpen ? cappedSize : closeBehavior === 'hide' ? 0 : isToolbar && headerBlockSize !== undefined ? `calc(${headerBlockSize}px + ${$17a6dd8285442c36$export$a76a9c28849b8bd4})` : undefined
        },
        ref: splitPanelRef
    }, closeBehavior === 'hide' && !isOpen ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['slider-wrapper-bottom']
    }, resizeHandle), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['drawer-content-bottom'],
        "aria-labelledby": panelHeaderId,
        "aria-label": ariaLabel,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['pane-header-wrapper-bottom'], centeredMaxWidthClasses),
        ref: headerRef
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['content-bottom'], centeredMaxWidthClasses),
        "aria-hidden": !isOpen
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['content-bottom-max-width']]: isRefresh
        }),
        style: appLayoutMaxWidth
    }, children)))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







var $dfe859143f929582$export$2e2bcd8739ae039 = {
    "radio-button": "awsui_radio-button_feeqa_117rp_5",
    "selected": "awsui_selected_feeqa_117rp_9"
};



var $8a00154a77cc4ed8$export$2e2bcd8739ae039 = {
    "column-layout": "awsui_column-layout_vj6p7_1p9yl_189",
    "grid": "awsui_grid_vj6p7_1p9yl_221",
    "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_1p9yl_227",
    "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_1p9yl_231",
    "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_1p9yl_239",
    "grid-columns-1": "awsui_grid-columns-1_vj6p7_1p9yl_242",
    "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_1p9yl_242",
    "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_1p9yl_245",
    "grid-columns-2": "awsui_grid-columns-2_vj6p7_1p9yl_248",
    "grid-columns-3": "awsui_grid-columns-3_vj6p7_1p9yl_254",
    "grid-columns-4": "awsui_grid-columns-4_vj6p7_1p9yl_260",
    "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_1p9yl_276",
    "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_1p9yl_309",
    "root": "awsui_root_vj6p7_1p9yl_359",
    "tile-container": "awsui_tile-container_vj6p7_1p9yl_394",
    "refresh": "awsui_refresh_vj6p7_1p9yl_419",
    "selected": "awsui_selected_vj6p7_1p9yl_423",
    "disabled": "awsui_disabled_vj6p7_1p9yl_423",
    "readonly": "awsui_readonly_vj6p7_1p9yl_423",
    "has-metadata": "awsui_has-metadata_vj6p7_1p9yl_426",
    "columns": "awsui_columns_vj6p7_1p9yl_448",
    "column-1": "awsui_column-1_vj6p7_1p9yl_455",
    "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_1p9yl_462",
    "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_1p9yl_466",
    "column-2": "awsui_column-2_vj6p7_1p9yl_470",
    "column-3": "awsui_column-3_vj6p7_1p9yl_485",
    "column-4": "awsui_column-4_vj6p7_1p9yl_500",
    "control": "awsui_control_vj6p7_1p9yl_516",
    "no-image": "awsui_no-image_vj6p7_1p9yl_520",
    "image": "awsui_image_vj6p7_1p9yl_524"
};


const $66f1afa3a11b864e$export$235cb65c20ad2b7 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ item: item, selected: selected, name: name, breakpoint: breakpoint, onChange: onChange, readOnly: readOnly, ...rest }, forwardedRef)=>{
    const internalRef = (0, $acw62.useRef)(null);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(internalRef, forwardedRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)['tile-container'], {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)['has-metadata']]: item.description || item.image
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).selected]: selected
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).disabled]: !!item.disabled
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).readonly]: readOnly
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).refresh]: isVisualRefresh
        }, (0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)[`breakpoint-${breakpoint}`]),
        "data-value": item.value,
        onClick: ()=>{
            var _a;
            if (item.disabled || readOnly) return;
            (_a = internalRef.current) === null || _a === void 0 || _a.focus();
            if (!selected) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: item.value
            });
        },
        ...(0, $ee5290ed0efb3c57$exports.copyAnalyticsMetadataAttribute)(rest)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).control, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)['no-image']]: !item.image
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ba5898a3f042c33$export$2e2bcd8739ae039), {
        checked: selected,
        ref: mergedRef,
        name: name,
        value: item.value,
        description: item.description,
        disabled: item.disabled,
        controlId: item.controlId,
        readOnly: readOnly,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $dfe859143f929582$export$2e2bcd8739ae039)['radio-button'], selected && (0, $dfe859143f929582$export$2e2bcd8739ae039).selected)
    }, item.label)), item.image && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).image, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).disabled]: !!item.disabled
        })
    }, item.image));
});




const $2f11c66273c15e56$var$COLUMN_TRIGGERS = [
    'default',
    'xxs',
    'xs'
];
const $2f11c66273c15e56$var$InternalTiles = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ name: name, value: value, items: items, ariaLabel: ariaLabel, ariaRequired: ariaRequired, ariaControls: ariaControls, columns: columns, onChange: onChange, readOnly: readOnly, __internalRootRef: __internalRootRef, ...rest }, ref)=>{
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const generatedName = (0, $013a2451794a45c0$exports.useUniqueId)('awsui-tiles-');
    const [tileRef, tileRefIndex] = (0, $3024c0fa705edd01$export$2e2bcd8739ae039)(ref, items, value);
    const [breakpoint, breakpointRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)($2f11c66273c15e56$var$COLUMN_TRIGGERS);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(breakpointRef, __internalRootRef);
    const columnCount = $2f11c66273c15e56$var$getColumnCount(items, columns);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "radiogroup",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired,
        "aria-controls": ariaControls,
        "aria-readonly": readOnly ? 'true' : undefined,
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).root),
        ref: mergedRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).columns, (0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)[`column-${columnCount}`])
    }, items && items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66f1afa3a11b864e$export$235cb65c20ad2b7), {
            ref: index === tileRefIndex ? tileRef : undefined,
            key: item.value,
            item: item,
            selected: item.value === value,
            name: name || generatedName,
            breakpoint: breakpoint,
            onChange: onChange,
            readOnly: readOnly,
            ...!item.disabled && !readOnly ? (0, $ee5290ed0efb3c57$exports.getAnalyticsMetadataAttribute)({
                action: 'select',
                detail: {
                    position: `${index + 1}`,
                    value: item.value,
                    label: `.${(0, $dfe859143f929582$export$2e2bcd8739ae039)['radio-button']}`
                }
            }) : {}
        }))));
});
function $2f11c66273c15e56$var$getColumnCount(items, columns) {
    if (columns) return columns;
    const nItems = items ? items.length : 0;
    const columnsLookup = {
        0: 1,
        1: 1,
        2: 2,
        4: 2,
        8: 2
    };
    return columnsLookup[nItems] || 3;
}
var $2f11c66273c15e56$export$2e2bcd8739ae039 = $2f11c66273c15e56$var$InternalTiles;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $40202e927744a3f5$export$2e2bcd8739ae039 = {
    "preference-icon--svg": "awsui_preference-icon--svg_d4xxm_175gg_145",
    "preference-icon--layout-border": "awsui_preference-icon--layout-border_d4xxm_175gg_151",
    "preference-icon--layout-background": "awsui_preference-icon--layout-background_d4xxm_175gg_155",
    "preference-icon--layout-header": "awsui_preference-icon--layout-header_d4xxm_175gg_158",
    "preference-icon--border": "awsui_preference-icon--border_d4xxm_175gg_161",
    "preference-icon--primary-button": "awsui_preference-icon--primary-button_d4xxm_175gg_165",
    "preference-icon--secondary": "awsui_preference-icon--secondary_d4xxm_175gg_168",
    "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_d4xxm_175gg_171",
    "preference-icon--separator": "awsui_preference-icon--separator_d4xxm_175gg_174",
    "preference-icon--focus-text": "awsui_preference-icon--focus-text_d4xxm_175gg_177",
    "preference-icon-refresh--svg": "awsui_preference-icon-refresh--svg_d4xxm_175gg_181",
    "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_d4xxm_175gg_187",
    "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_d4xxm_175gg_190",
    "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_d4xxm_175gg_193",
    "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_d4xxm_175gg_196",
    "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_d4xxm_175gg_199",
    "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_d4xxm_175gg_202",
    "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_d4xxm_175gg_206",
    "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_d4xxm_175gg_209",
    "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_d4xxm_175gg_212",
    "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_d4xxm_175gg_215",
    "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_d4xxm_175gg_218"
};


const $a4a5e8c22cf2abb7$var$bottomPositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--svg'],
    focusable: "false",
    viewBox: "0 0 240 134",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--layout-border'],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "238",
    height: "125",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--layout-background'],
    x: "12",
    y: "0",
    width: "217",
    height: "126"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--layout-header'],
    d: "M2,0 L238,0 C239.104569,-1.58997828e-14 240,0.8954305 240,2 L240,10 L240,10 L0,10 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(28.000000, 22.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--border'],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "182",
    height: "110",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--primary-button'],
    x: "152",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "122",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "92",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "122",
    y: "29",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "92",
    y: "29",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "19 29 49 29 49 32 19 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "10 10 40 10 40 13 10 13"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "10 29 13 29 13 32 10 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "3",
    y1: "22.7619048",
    x2: "181",
    y2: "22.7619048",
    strokeWidth: "2",
    strokeLinecap: "square"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 37.285714)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(12.000000, 74.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--border'],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "215",
    height: "58",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary'],
    x: "177",
    y: "8",
    width: "30.6630435",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "10 12 45.3804348 12 45.3804348 15 10 15"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary'],
    transform: "translate(9.000000, 40.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "-3.55271368e-15 0 39 0 39 3 -3.55271368e-15 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "53 0 92 0 92 3 53 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "107 0 146 0 146 3 107 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "160 0 199 0 199 3 160 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "-3.55271368e-15 9 39 9 39 12 -3.55271368e-15 12"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "53 9 92 9 92 12 53 12"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "107 9 146 9 146 12 107 12"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "160 9 199 9 199 12 160 12"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "10 23 32 23 32 26 10 26"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary'],
    points: "40 23 62 23 62 26 40 26"
})))));
var $a4a5e8c22cf2abb7$export$2e2bcd8739ae039 = $a4a5e8c22cf2abb7$var$bottomPositionIcon;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $3ca8dc093164aa5b$export$307b18b61172f7ed = (suffix)=>(0, $40202e927744a3f5$export$2e2bcd8739ae039)[`preference-icon-refresh--${suffix}`];
const $3ca8dc093164aa5b$var$TableRow = ({ offset: offset, separator: separator = true, isHeader: isHeader })=>{
    const offsetTop = 0.4482;
    const offsetBottom = 3.4482;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: $3ca8dc093164aa5b$export$307b18b61172f7ed(isHeader ? 'column-header' : 'disabled')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M19 ${offsetTop}2H22V${offsetBottom}H19V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M27 ${offsetTop}H51V${offsetBottom}H27V${offsetTop}Z`,
        className: !isHeader ? $3ca8dc093164aa5b$export$307b18b61172f7ed('secondary') : undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M90 ${offsetTop}H110V${offsetBottom}H90V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M113 ${offsetTop}H157V${offsetBottom}H113V${offsetTop}Z`
    }), separator && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 8H159.387",
        className: $3ca8dc093164aa5b$export$307b18b61172f7ed('separator'),
        strokeLinecap: "square"
    }));
};
const $3ca8dc093164aa5b$var$SidePanelRow = ({ offset: offset })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: $3ca8dc093164aa5b$export$307b18b61172f7ed('secondary')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M177 0H190V3H177V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M195 0H208V3H195V0Z"
    }));
};
const $3ca8dc093164aa5b$var$bottomPositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('svg'),
    focusable: "false",
    viewBox: "0 0 230 128",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 1H214C214.552 1 215 1.44772 215 2V126C215 126.552 214.552 127 214 127H2.00001C1.44772 127 1 126.552 1 126V2C1 1.44772 1.44772 1 2 1Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('window'),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: "awsui-context-top-navigation"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "2",
    y: "2",
    width: "212",
    height: "6",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('layout-top')
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 8H214V23H2V8Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('layout-main')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('default')
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M9 15.5C9 16.8807 7.88071 18 6.5 18C5.11929 18 4 16.8807 4 15.5C4 14.1193 5.11929 13 6.5 13C7.88071 13 9 14.1193 9 15.5Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('disabled')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M16 14H46.1484V17H16V14Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M92 15.5C92 13.567 93.567 12 95.5 12H108.86C110.793 12 112.36 13.567 112.36 15.5C112.36 17.433 110.793 19 108.86 19H95.5C93.567 19 92 17.433 92 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M116 15.5C116 13.567 117.567 12 119.5 12H132.86C134.793 12 136.36 13.567 136.36 15.5C136.36 17.433 134.793 19 132.86 19H119.5C117.567 19 116 17.433 116 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M139 15.5C139 13.567 140.567 12 142.5 12H155.86C157.793 12 159.36 13.567 159.36 15.5C159.36 17.433 157.793 19 155.86 19H142.5C140.567 19 139 17.433 139 15.5Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('primary')
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 27,
    isHeader: true
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 39
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 51
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 63
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 75
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 87
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 99
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 111,
    separator: false
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "166",
    y: "13",
    width: "62",
    height: "108",
    rx: "5",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('window'),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "169",
    y: "62",
    width: "3",
    height: "8",
    rx: "1.5",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('input-default')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M216 14V120",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('separator')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('disabled')
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M224 19.5C224 20.8807 222.881 22 221.5 22C220.119 22 219 20.8807 219 19.5C219 18.1193 220.119 17 221.5 17C222.881 17 224 18.1193 224 19.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M224 27.5C224 28.8807 222.881 30 221.5 30C220.119 30 219 28.8807 219 27.5C219 26.1193 220.119 25 221.5 25C222.881 25 224 26.1193 224 27.5Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M177 23H191V28H177V23Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('heading')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed('secondary')
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M207 23H212V28H207V23Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M199 23H204V28H199V23Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 36
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 48
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 60
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 72
}));
var $3ca8dc093164aa5b$export$2e2bcd8739ae039 = $3ca8dc093164aa5b$var$bottomPositionIcon;


const $5c7830951f90ff27$var$TableRow = ({ offset: offset, isHeader: isHeader })=>{
    const offsetTop = 0.4482;
    const offsetBottom = 3.4482;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)(isHeader ? 'column-header' : 'disabled')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M31 ${offsetTop}H34V${offsetBottom}H31V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M39 ${offsetTop}H63V${offsetBottom}H39V${offsetTop}Z`,
        className: !isHeader ? (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('secondary') : undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M135 ${offsetTop}H155V${offsetBottom}H135V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M158 ${offsetTop}H202V${offsetBottom}H158V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M26 8H204.388",
        className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('separator'),
        strokeLinecap: "square"
    }));
};
const $5c7830951f90ff27$var$SidePanelRow = ({ offset: offset })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('secondary')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M27 0H59V3H27V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M75 0H107V3H75V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M123 0H155V3H123V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M171 0H203V3H171V0Z"
    }));
};
const $5c7830951f90ff27$var$bottomPositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('svg'),
    focusable: "false",
    viewBox: "0 0 230 128",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 1H228C228.552 1 229 1.44772 229 2V117C229 117.552 228.552 118 228 118H2C1.44772 118 1 117.552 1 117V2C1 1.44772 1.44772 1 2 1Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('window'),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: "awsui-context-top-navigation"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "2",
    y: "2",
    width: "226",
    height: "6",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('layout-top')
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 8H228V23H2V8Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('layout-main')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('default')
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M9 15.5C9 16.8807 7.88071 18 6.5 18C5.11929 18 4 16.8807 4 15.5C4 14.1193 5.11929 13 6.5 13C7.88071 13 9 14.1193 9 15.5Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('disabled')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M26 14H56.1484V17H26V14Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M139 15.5C139 13.567 140.567 12 142.5 12H155.86C157.793 12 159.36 13.567 159.36 15.5C159.36 17.433 157.793 19 155.86 19H142.5C140.567 19 139 17.433 139 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M163 15.5C163 13.567 164.567 12 166.5 12H179.86C181.793 12 183.36 13.567 183.36 15.5C183.36 17.433 181.793 19 179.86 19H166.5C164.567 19 163 17.433 163 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M186 15.5C186 13.567 187.567 12 189.5 12H202.86C204.793 12 206.36 13.567 206.36 15.5C206.36 17.433 204.793 19 202.86 19H189.5C187.567 19 186 17.433 186 15.5Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('primary')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    cx: "223.5",
    cy: "15.5",
    r: "2.5",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('disabled')
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 27,
    isHeader: true
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 39
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 51
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 63
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "8",
    y: "75",
    width: "214",
    height: "52",
    rx: "5",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('window'),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "111",
    y: "79",
    width: "8",
    height: "3",
    rx: "1.5",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('input-default')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M27 87H57V92H27V87Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('heading')
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)('secondary')
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M198 87H203V92H198V87Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M190 87H195V92H190V87Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$SidePanelRow, {
    offset: 99
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$SidePanelRow, {
    offset: 106
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$SidePanelRow, {
    offset: 113
}));
var $5c7830951f90ff27$export$2e2bcd8739ae039 = $5c7830951f90ff27$var$bottomPositionIcon;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $de45693ec3978042$var$sidePositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--svg'],
    focusable: "false",
    viewBox: "0 0 239 134",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--layout-border'],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "223",
    height: "125",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--layout-background'],
    x: "11.25",
    y: "0",
    width: "203.4375",
    height: "125"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--layout-header'],
    d: "M2,0 L223,0 C224.104569,-2.02906125e-16 225,0.8954305 225,2 L225,10 L225,10 L0,10 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(20.000000, 22.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--border'],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "182",
    height: "110",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--primary-button'],
    x: "152",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "122",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "92",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "122",
    y: "29",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "92",
    y: "29",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "19 29 49 29 49 32 19 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "10 10 40 10 40 13 10 13"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "10 29 13 29 13 32 10 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "3",
    y1: "22.7619048",
    x2: "181",
    y2: "22.7619048",
    strokeWidth: "2",
    strokeLinecap: "square"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 37.285714)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 51.714286)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 80.571429)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 66.142857)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 95.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--disabled-element'],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--separator'],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(182.000000, 28.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--border'],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "55",
    height: "97",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary'],
    x: "39.5474354",
    y: "5.86666667",
    width: "14",
    height: "6.41666667"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--focus-text'],
    points: "3.62672811 7.88333333 24.6267281 7.88333333 24.6267281 10.6333333 3.62672811 10.6333333"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 22.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary']
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 32.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary']
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 43.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary']
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 51.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)['preference-icon--secondary']
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})))));
var $de45693ec3978042$export$2e2bcd8739ae039 = $de45693ec3978042$var$sidePositionIcon;



var $13d7a8b65fe18c8d$export$2e2bcd8739ae039 = (props)=>{
    const [position, setPosition] = (0, $acw62.useState)(props.preferences.position);
    const onCancel = ()=>{
        setPosition(props.preferences.position);
        props.onDismiss();
    };
    const onConfirm = ()=>{
        props.onConfirm({
            position: position
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a5bb8d240e2baab$export$2e2bcd8739ae039), {
        size: "medium",
        visible: props.visible,
        onDismiss: props.onDismiss,
        header: props.i18nStrings.header,
        closeAriaLabel: props.i18nStrings.close,
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
            float: "right"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
            direction: "horizontal",
            size: "xs"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            onClick: onCancel,
            formAction: "none",
            variant: "link"
        }, props.i18nStrings.cancel), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            onClick: onConfirm,
            variant: "primary"
        }, props.i18nStrings.confirm))),
        __internalRootRef: props.__internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        label: props.i18nStrings.positionLabel,
        description: props.i18nStrings.positionDescription
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f11c66273c15e56$export$2e2bcd8739ae039), {
        onChange: (e)=>setPosition(e.detail.value),
        value: position,
        columns: 2,
        items: [
            {
                label: props.i18nStrings.positionBottom,
                image: props.isRefresh ? (0, $5c7830951f90ff27$export$2e2bcd8739ae039) : (0, $a4a5e8c22cf2abb7$export$2e2bcd8739ae039),
                value: 'bottom'
            },
            {
                label: props.i18nStrings.positionSide,
                image: props.isRefresh ? (0, $3ca8dc093164aa5b$export$2e2bcd8739ae039) : (0, $de45693ec3978042$export$2e2bcd8739ae039),
                value: 'side',
                disabled: props.disabledSidePosition
            }
        ]
    })));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








function $60a72ee6b286b276$export$ab0ba9aff65ad1d3({ style: style, baseProps: baseProps, splitPanelRef: splitPanelRef, toggleRef: toggleRef, header: header, children: children, resizeHandle: resizeHandle, isOpen: isOpen, cappedSize: cappedSize, openButtonAriaLabel: openButtonAriaLabel, panelHeaderId: panelHeaderId, ariaLabel: ariaLabel, onToggle: onToggle, closeBehavior: closeBehavior }) {
    const { topOffset: topOffset, bottomOffset: bottomOffset, animationDisabled: animationDisabled } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const isToolbar = (0, $73078c4512771f18$export$d38f11a69207eec8)();
    const disableAnimation = animationDisabled || closeBehavior === 'hide' && !isOpen;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...baseProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8865c966f929fe61$export$2e2bcd8739ae039).drawer, (0, $8865c966f929fe61$export$2e2bcd8739ae039)['position-side'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039).root, {
            [(0, $4e3b8edb758a09c5$export$2e2bcd8739ae039)['with-motion-horizontal']]: !disableAnimation,
            [(0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['open-position-side']]: isOpen,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['drawer-closed']]: !isOpen,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-toolbar']]: isToolbar,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039).refresh]: isRefresh
        }),
        style: {
            width: isOpen ? cappedSize : isRefresh ? '0px' : undefined,
            maxWidth: isRefresh ? '100%' : undefined,
            ...style
        },
        ref: splitPanelRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['drawer-content-side'],
        style: {
            top: topOffset,
            bottom: bottomOffset
        },
        onClick: ()=>!isOpen && onToggle(),
        "aria-labelledby": panelHeaderId,
        "aria-label": ariaLabel,
        role: "region"
    }, isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['slider-wrapper-side'], isToolbar && (0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-toolbar'])
    }, resizeHandle) : closeBehavior === 'hide' ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['open-button'], (0, $8865c966f929fe61$export$2e2bcd8739ae039)['open-button-side']),
        iconName: "angle-left",
        variant: "icon",
        formAction: "none",
        ariaLabel: openButtonAriaLabel,
        ariaExpanded: isOpen,
        //toggleRef should only be assigned when there is no other trigger-buttons
        ref: isRefresh || isToolbar ? null : toggleRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['content-side'], isToolbar && (0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-toolbar']),
        "aria-hidden": !isOpen,
        style: {
            width: isToolbar ? cappedSize : '0px'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['pane-header-wrapper-side']
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['pane-content-wrapper-side']
    }, children))));
}




function $6af898269f33764d$export$8f213b5bf43ac777({ __internalRootRef: __internalRootRef, header: header, children: children, hidePreferencesButton: hidePreferencesButton, closeBehavior: closeBehavior, i18nStrings: i18nStrings = {}, ariaLabel: ariaLabel, headerActions: headerActions, headerBefore: headerBefore, headerDescription: headerDescription, headerInfo: headerInfo, ...restProps }) {
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const isToolbar = (0, $73078c4512771f18$export$d38f11a69207eec8)();
    if (!header && !headerBefore) (0, $013a2451794a45c0$exports.warnOnce)('SplitPanel', 'You must provide either `header` or `headerBefore`.');
    const { position: position, topOffset: topOffset, bottomOffset: bottomOffset, rightOffset: rightOffset, contentWidthStyles: contentWidthStyles, isOpen: isOpen, isForcedPosition: isForcedPosition, onPreferencesChange: onPreferencesChange, onResize: onResize, onToggle: onToggle, size: size, relativeSize: relativeSize, setSplitPanelToggle: setSplitPanelToggle, refs: refs, animationDisabled: animationDisabled } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const [isPreferencesOpen, setPreferencesOpen] = (0, $acw62.useState)(false);
    const appLayoutMaxWidth = isRefresh && position === 'bottom' ? contentWidthStyles : undefined;
    const openButtonAriaLabel = i18nStrings.openButtonAriaLabel;
    (0, $acw62.useEffect)(()=>{
        setSplitPanelToggle({
            displayed: closeBehavior === 'collapse',
            ariaLabel: openButtonAriaLabel
        });
        return ()=>{
            setSplitPanelToggle({
                displayed: false,
                ariaLabel: undefined
            });
        };
    }, [
        setSplitPanelToggle,
        openButtonAriaLabel,
        closeBehavior
    ]);
    const splitPanelRefObject = (0, $acw62.useRef)(null);
    const sizeControlProps = {
        position: position,
        panelRef: splitPanelRefObject,
        handleRef: refs.slider,
        onResize: onResize
    };
    const onSliderPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const { onKeyDown: onKeyDown, onDirectionClick: onDirectionClick } = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    const contentStyle = {
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset]: topOffset,
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset]: bottomOffset
    };
    const panelHeaderUniqueId = (0, $013a2451794a45c0$exports.useUniqueId)('split-panel-header');
    const panelHeaderId = ariaLabel ? undefined : panelHeaderUniqueId;
    const showActions = headerActions && isOpen;
    const showDescription = headerDescription && isOpen;
    const hasCustomElements = !!headerActions || !!headerBefore || !!headerInfo;
    const wrappedHeader = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039).header, isToolbar && (0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-toolbar']),
        style: appLayoutMaxWidth
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-main-row']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-main-content']
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-tag-and-info'], showDescription && (0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-description'])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-tag'], !!headerInfo && (0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-info']),
        id: panelHeaderId
    }, headerBefore && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-before-slot'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['header-before'], !!header && (0, $8865c966f929fe61$export$2e2bcd8739ae039)['with-header-text'])
    }, headerBefore), !!header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-text'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['header-text'])
    }, header)), headerInfo && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-info-slot'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['header-info'])
    }, headerInfo)), showActions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-actions-slot'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['header-actions'])
    }, headerActions)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-buttons']
    }, !hidePreferencesButton && isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['preferences-button'],
        iconName: "settings",
        variant: "icon",
        onClick: ()=>setPreferencesOpen(true),
        formAction: "none",
        ariaLabel: i18nStrings.preferencesTitle,
        ref: refs.preferences
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039).divider
    })), isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['close-button'],
        iconName: isRefresh && closeBehavior === 'collapse' ? position === 'side' ? 'angle-right' : 'angle-down' : 'close',
        variant: "icon",
        onClick: onToggle,
        formAction: "none",
        ariaLabel: i18nStrings.closeButtonAriaLabel,
        ariaExpanded: isOpen
    }) : position === 'side' || closeBehavior === 'hide' ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['open-button'],
        iconName: "angle-up",
        variant: "icon",
        formAction: "none",
        ariaLabel: i18nStrings.openButtonAriaLabel,
        ref: refs.toggle,
        ariaExpanded: isOpen,
        onClick: hasCustomElements ? onToggle : undefined
    }))), showDescription && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)['header-description'], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)['header-description'])
    }, headerDescription));
    const resizeHandle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
        ref: refs.slider,
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039).slider,
        tooltipText: i18nStrings.resizeHandleTooltipText,
        ariaLabel: i18nStrings.resizeHandleAriaLabel,
        // Allows us to use the logical left/right keys to move the slider left/right,
        // but match aria keyboard behavior of using left/right to decrease/increase
        // the slider value.
        ariaValuenow: position === 'bottom' ? relativeSize : 100 - relativeSize,
        position: position,
        onKeyDown: onKeyDown,
        onPointerDown: onSliderPointerDown,
        onDirectionClick: onDirectionClick
    });
    /*
      This effect forces the browser to recalculate the layout
      whenever the split panel might have moved.
  
      This is needed as a workaround for a bug in Safari, which does
      not automatically calculate the new position of the split panel
      _content_ when the split panel moves.
    */ (0, $acw62.useLayoutEffect)(()=>{
        const root = splitPanelRefObject.current;
        if (root) {
            const property = 'transform';
            const temporaryValue = 'translateZ(0)';
            const valueBefore = root.style[property];
            root.style[property] = temporaryValue;
            // This line forces the browser to recalculate the layout
            root.offsetHeight;
            root.style[property] = valueBefore;
        }
    }, [
        rightOffset,
        __internalRootRef
    ]);
    const mergedRef = (0, $013a2451794a45c0$exports.useMergeRefs)(splitPanelRefObject, __internalRootRef);
    if (closeBehavior === 'hide' && !isOpen && (animationDisabled || !isRefresh)) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    /**
     * The AppLayout factor moved the circular buttons out of the
     * SplitPanel and into the Tools component. This conditional
     * is still needed for the early return to prevent execution
     * of the following code.
     */ if (isRefresh && !isToolbar && !isOpen && position === 'side') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, position === 'side' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $60a72ee6b286b276$export$ab0ba9aff65ad1d3), {
        style: contentStyle,
        resizeHandle: resizeHandle,
        baseProps: baseProps,
        isOpen: isOpen,
        splitPanelRef: mergedRef,
        cappedSize: size,
        onToggle: onToggle,
        openButtonAriaLabel: openButtonAriaLabel,
        toggleRef: refs.toggle,
        header: wrappedHeader,
        panelHeaderId: panelHeaderId,
        ariaLabel: ariaLabel,
        closeBehavior: closeBehavior
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), null, children)), position === 'bottom' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40f40a5866db94fc$export$acf43145a1f7fbaa), {
        style: contentStyle,
        resizeHandle: resizeHandle,
        baseProps: baseProps,
        isOpen: isOpen,
        splitPanelRef: mergedRef,
        cappedSize: size,
        onToggle: onToggle,
        header: wrappedHeader,
        panelHeaderId: panelHeaderId,
        appLayoutMaxWidth: appLayoutMaxWidth,
        ariaLabel: ariaLabel,
        closeBehavior: closeBehavior,
        hasCustomElements: hasCustomElements
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $576a9d659fe56e52$export$757d89c03059dd35), null, children)), isPreferencesOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13d7a8b65fe18c8d$export$2e2bcd8739ae039), {
        visible: true,
        preferences: {
            position: position
        },
        disabledSidePosition: position === 'bottom' && isForcedPosition,
        isRefresh: isRefresh,
        i18nStrings: {
            header: i18nStrings.preferencesTitle,
            confirm: i18nStrings.preferencesConfirm,
            cancel: i18nStrings.preferencesCancel,
            close: i18nStrings.preferencesCloseAriaLabel,
            positionLabel: i18nStrings.preferencesPositionLabel,
            positionDescription: i18nStrings.preferencesPositionDescription,
            positionBottom: i18nStrings.preferencesPositionBottom,
            positionSide: i18nStrings.preferencesPositionSide
        },
        onConfirm: (preferences)=>{
            onPreferencesChange({
                ...preferences
            });
            setPreferencesOpen(false);
        },
        onDismiss: ()=>{
            setPreferencesOpen(false);
        }
    }));
}
const $6af898269f33764d$export$dc1769a3f3539a1e = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($6af898269f33764d$export$8f213b5bf43ac777);


const $814a3471d5eb41d1$export$27aae29291ab1e43 = (0, $6af898269f33764d$export$dc1769a3f3539a1e)();


'use client';
function $e7f721cddf93eaf5$export$2e2bcd8739ae039({ hidePreferencesButton: hidePreferencesButton = false, closeBehavior: closeBehavior = 'collapse', i18nStrings: i18nStrings = {}, ...restProps }) {
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)('SplitPanel', {
        props: {
            closeBehavior: closeBehavior,
            hidePreferencesButton: hidePreferencesButton
        },
        metadata: {
            hasHeaderActions: Boolean(restProps.headerActions),
            hasHeaderDescription: Boolean(restProps.headerDescription),
            hasHeaderInfo: Boolean(restProps.headerInfo),
            hasHeaderBefore: Boolean(restProps.headerBefore)
        }
    });
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('split-panel');
    const i18nModal = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)('modal');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $814a3471d5eb41d1$export$27aae29291ab1e43), {
        ...restProps,
        __internalRootRef: __internalRootRef,
        hidePreferencesButton: hidePreferencesButton,
        closeBehavior: closeBehavior,
        i18nStrings: {
            ...i18nStrings,
            closeButtonAriaLabel: i18n('i18nStrings.closeButtonAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.closeButtonAriaLabel),
            openButtonAriaLabel: i18n('i18nStrings.openButtonAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.openButtonAriaLabel),
            resizeHandleAriaLabel: i18n('i18nStrings.resizeHandleAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.resizeHandleAriaLabel),
            resizeHandleTooltipText: i18n('i18nStrings.resizeHandleTooltipText', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.resizeHandleTooltipText),
            preferencesTitle: i18n('i18nStrings.preferencesTitle', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesTitle),
            preferencesConfirm: i18n('i18nStrings.preferencesConfirm', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesConfirm),
            preferencesCancel: i18n('i18nStrings.preferencesCancel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesCancel),
            preferencesCloseAriaLabel: i18nModal('closeAriaLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesCloseAriaLabel) || (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesCancel),
            preferencesPositionLabel: i18n('i18nStrings.preferencesPositionLabel', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionLabel),
            preferencesPositionDescription: i18n('i18nStrings.preferencesPositionDescription', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionDescription),
            preferencesPositionBottom: i18n('i18nStrings.preferencesPositionBottom', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionBottom),
            preferencesPositionSide: i18n('i18nStrings.preferencesPositionSide', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionSide)
        }
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($e7f721cddf93eaf5$export$2e2bcd8739ae039, 'SplitPanel');




var $acw62 = parcelRequire("acw62");


const $b4ce7ab90b4000a3$var$splitPanelI18nStrings = {
    preferencesTitle: "Split panel preferences",
    preferencesPositionLabel: "Split panel position",
    preferencesPositionDescription: "Choose the default split panel position for the service.",
    preferencesPositionSide: "Side",
    preferencesPositionBottom: "Bottom",
    preferencesConfirm: "Confirm",
    preferencesCancel: "Cancel",
    closeButtonAriaLabel: "Close panel",
    openButtonAriaLabel: "Open panel",
    resizeHandleAriaLabel: "Resize split panel"
};
const $b4ce7ab90b4000a3$export$dbfe7a0a83d60a06 = ({ showContent: showContent })=>{
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const [detailComponents, setDetailComponents] = (0, $acw62.useState)([]);
    const [title, setTitle] = (0, $acw62.useState)("");
    const loadComponentDetails = async ()=>{
        const resp = await api.makeApiCall("getViewDetailSection/" + mainApp.selectedRow.menuItem.DetailSectionId, "POST", mainApp?.selectedRow?.rowData);
        setTitle(resp.Title);
        if (resp.Components) setDetailComponents(resp.Components);
        else setDetailComponents([]);
    //TODO: disable selection if no components are set
    };
    (0, $acw62.useEffect)(()=>{
        if (mainApp.selectedRow?.menuItem?.DetailSectionId) loadComponentDetails();
    }, [
        mainApp.selectedRow
    ]);
    return mainApp.selectedRow == null || detailComponents.length == 0 ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7f721cddf93eaf5$export$2e2bcd8739ae039), {
        header: title || "No item selected",
        hidePreferencesButton: false,
        i18nStrings: $b4ce7ab90b4000a3$var$splitPanelI18nStrings,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b1a89cfa249459$export$2e2bcd8739ae039), {
            tabs: showContent == false ? [] : detailComponents.map((x)=>({
                    id: x.Id.toString(),
                    label: x.Title,
                    content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98339aa869f255f6$export$73903224e3a9e478), {
                        isEmbedded: true,
                        defaultData: x.Data,
                        menuItem: {
                            ViewData: x.Data,
                            DataForGettingMenu: x.DataForGettingMenu,
                            Columns: x.Columns,
                            Id: x.Id,
                            Title: x.Title,
                            TotalLines: -1
                        }
                    })
                }))
        })
    });
};


const $1a74b96f2bb2a4a2$var$findClickedItem = (id, items)=>{
    for (const item of items){
        if (item.id === id) return item;
        if (item.subMenus) {
            const foundItem = $1a74b96f2bb2a4a2$var$findClickedItem(id, item.subMenus);
            if (foundItem) return foundItem;
        }
    }
    return null;
};
const $1a74b96f2bb2a4a2$export$ce4bc3b0184ba3a7 = (_props)=>{
    const [activeHref, setActiveHref] = (0, $acw62.useState)("/");
    const { messages: messages } = (0, $c0aa018cd5ecdf0e$export$a7347740d65f620b)((0, $e94319ab67c021b4$export$31ff3874607c5ef8));
    const dispatch = (0, $c0aa018cd5ecdf0e$export$f51d452c10d5b956)();
    const menus = (0, $93fef701c169bd1e$export$38eaa17faae8f579)();
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const [splitPanelOpen, setSplitPanelOpen] = (0, $acw62.useState)(false);
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)(); // auto injected because it's a context provider
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    // TODO: make these provider things too
    // TODO: - it might be easier to wait for main app to be ready, and call all these things manually
    //       - then I can call them as "startApplication" same as before
    // flow:
    // call 'initialize system' to get system information   -> only happens once ever
    // then (a.k.a. startApplication)
    // then auth initialize
    //    -> get local stored stuff
    //    -> call perform token refresh is needed
    // then main app initialize
    //    -> check anon actions
    //    -> call 'initialize'
    //    -> if web call fails with 401
    //           --> call perform token refresh
    //           --> if this errors show login dialog
    //           --> if login dialog succeeds, start this flow again
    // then load menus
    //    -> if this errors check for anon functions
    const handleMenuClick = (itemRef)=>{
        mainApp.setSelectedTableRow(null);
        if (itemRef == "/") {
            menus.onHomeClick();
            return;
        }
        const itemId = itemRef.substring(1);
        const menuItemClicked = $1a74b96f2bb2a4a2$var$findClickedItem(itemId, menus.appMenuItems);
        mainApp.clearDisplayStack();
        onMenuClick(menuItemClicked.event);
    };
    const clearAllViewFilterCaches = ()=>{
        // Get the number of items in local storage
        const localStorageLength = localStorage.length;
        // Remove keys that match filter cache
        for(let i = 0; i < localStorageLength; i++){
            const key = localStorage.key(i);
            if (key && (key.includes("_filter_cache") || key.includes("_form_values_cache"))) localStorage.removeItem(key);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (mainApp?.selectedRow) setSplitPanelOpen(true);
    }, [
        mainApp.selectedRow
    ]);
    const currentDisplayItem = mainApp.displayStack.filter((d)=>d.visible == true)?.[0]; // this seems to work
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "h",
                style: {
                    position: "sticky",
                    top: 0,
                    zIndex: 1002
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6eb6096d647f226$export$2e2bcd8739ae039), {
                    identity: {
                        href: "/",
                        title: mainApp.appName || "QBic"
                    },
                    utilities: auth.isAuthenticated ? [
                        {
                            type: "button",
                            text: auth?.user?.User
                        },
                        {
                            type: "button",
                            text: "Logout",
                            onClick: auth.logout
                        }
                    ] : []
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12de04d549d06eb2$export$2e2bcd8739ae039), {
                headerSelector: "#h",
                splitPanelOpen: splitPanelOpen,
                onSplitPanelToggle: ()=>setSplitPanelOpen(!splitPanelOpen),
                splitPanel: currentDisplayItem.type == "view" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4ce7ab90b4000a3$export$dbfe7a0a83d60a06), {
                    showContent: currentDisplayItem.type == "view"
                }) : null,
                // we need the <div and id here because without it, components share state and also lose state, etc. It has to do with order of rendering etc.
                // TODO: this might break with a react or cloudscape upgrade at some point.
                //       a possible solution is to just move all form state to a state context provider or something
                content: mainApp.displayStack?.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: d.visible == true ? "block" : "none"
                        },
                        children: d?.component
                    }, d.id)),
                contentType: mainApp.currentContentType,
                toolsHide: true,
                navigationHide: !auth.isAuthenticated,
                navigation: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea79e02d828b2693$export$2e2bcd8739ae039), {
                    activeHref: activeHref,
                    onFollow: (event)=>{
                        event.preventDefault();
                        clearAllViewFilterCaches();
                        setActiveHref(event.detail.href);
                        handleMenuClick(event.detail.href);
                    },
                    items: menus.sideNavMenuItems
                }),
                notifications: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295a537205c57cb7$export$2e2bcd8739ae039), {
                        items: messages.map((message)=>{
                            return {
                                ...message,
                                onDismiss: ()=>{
                                    if (message.id) dispatch((0, $e94319ab67c021b4$export$f9a3c275d8ffdac0)(message.id));
                                }
                            };
                        }),
                        stackItems: true
                    })
                })
            })
        ]
    });
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



'use client';
function $103ea6cd172bad62$export$2e2bcd8739ae039({ size: size = 'normal', variant: variant = 'normal', ...props }) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)('Spinner', {
        props: {
            size: size,
            variant: variant
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), {
        size: size,
        variant: variant,
        ...props,
        ...baseComponentProps
    });
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($103ea6cd172bad62$export$2e2bcd8739ae039, 'Spinner');


const $6f8f8e4dbdc52acc$export$81834d6e76217dcb = ()=>{
    const { authConfig: authConfig, isReady: isReady } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    if (!isReady || !authConfig) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $103ea6cd172bad62$export$2e2bcd8739ae039), {});
    const oidcConfig = {
        authority: authConfig.Config.Authority,
        client_id: authConfig.Config.ClientId,
        redirect_uri: authConfig.Config.RedirectUrl,
        scope: authConfig.Config.Scope,
        response_type: authConfig.Config.ResponseType
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b40c3a08cec6a11c$exports.AuthProvider), {
        ...oidcConfig,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe9e7bfbce151564$export$87091915187a1a85), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dbc399a9d723999$export$178405afcd8c5eb), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba30691687bb8563$export$9ba8495ab9fb7661), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93fef701c169bd1e$export$62b22d151866115d), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a74b96f2bb2a4a2$export$ce4bc3b0184ba3a7), {})
                    })
                })
            })
        })
    });
};





function $cd93687958c8007e$var$App() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: (0, $b38651f901ccdd09$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e26b8abf7ea53dd6$export$e3f0b906e9bc3bad), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f8f8e4dbdc52acc$export$81834d6e76217dcb), {})
        })
    });
}
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;


const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=QBic.FrontEnd.a54ecbed.js.map
